
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefdae"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefdae"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2nzLi", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $1bb9784afa87e369$export$ffb0004e005737fa; }, function (v) { return $1bb9784afa87e369$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $1bb9784afa87e369$export$34b9dba7ce09269b; }, function (v) { return $1bb9784afa87e369$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $1bb9784afa87e369$export$25062201e9e25d76; }, function (v) { return $1bb9784afa87e369$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bb9784afa87e369$export$ffb0004e005737fa;
var $1bb9784afa87e369$export$34b9dba7ce09269b;
var $1bb9784afa87e369$export$25062201e9e25d76;
'use strict';

var $7fPBF = parcelRequire("7fPBF");
var $1bb9784afa87e369$var$k = Symbol.for("react.element"), $1bb9784afa87e369$var$l = Symbol.for("react.fragment"), $1bb9784afa87e369$var$m = Object.prototype.hasOwnProperty, $1bb9784afa87e369$var$n = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $1bb9784afa87e369$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1bb9784afa87e369$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$1bb9784afa87e369$var$m.call(a, b) && !$1bb9784afa87e369$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $1bb9784afa87e369$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $1bb9784afa87e369$var$n.current
    };
}
$1bb9784afa87e369$export$ffb0004e005737fa = $1bb9784afa87e369$var$l;
$1bb9784afa87e369$export$34b9dba7ce09269b = $1bb9784afa87e369$var$q;
$1bb9784afa87e369$export$25062201e9e25d76 = $1bb9784afa87e369$var$q;

});
parcelRegister("7fPBF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fSPLm"));

});
parcelRegister("fSPLm", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $b9040d2deeb360f4$export$dca3b0875bd9a954; }, function (v) { return $b9040d2deeb360f4$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $b9040d2deeb360f4$export$16fa2f45be04daa8; }, function (v) { return $b9040d2deeb360f4$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b9040d2deeb360f4$export$ffb0004e005737fa; }, function (v) { return $b9040d2deeb360f4$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $b9040d2deeb360f4$export$e2c29f18771995cb; }, function (v) { return $b9040d2deeb360f4$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $b9040d2deeb360f4$export$221d75b3f55bb0bd; }, function (v) { return $b9040d2deeb360f4$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b9040d2deeb360f4$export$5f8d39834fd61797; }, function (v) { return $b9040d2deeb360f4$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b9040d2deeb360f4$export$74bf444e3cd11ea5; }, function (v) { return $b9040d2deeb360f4$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b9040d2deeb360f4$export$ae55be85d98224ed; }, function (v) { return $b9040d2deeb360f4$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $b9040d2deeb360f4$export$3ba232387fd5d6dd; }, function (v) { return $b9040d2deeb360f4$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $b9040d2deeb360f4$export$e530037191fcd5d7; }, function (v) { return $b9040d2deeb360f4$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $b9040d2deeb360f4$export$fd42f52fd3ae1109; }, function (v) { return $b9040d2deeb360f4$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $b9040d2deeb360f4$export$c8a8987d4410bf2d; }, function (v) { return $b9040d2deeb360f4$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $b9040d2deeb360f4$export$d38cd72104c1f0e9; }, function (v) { return $b9040d2deeb360f4$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43; }, function (v) { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $b9040d2deeb360f4$export$257a8862b851cb5b; }, function (v) { return $b9040d2deeb360f4$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $b9040d2deeb360f4$export$a8257692ac88316c; }, function (v) { return $b9040d2deeb360f4$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $b9040d2deeb360f4$export$488013bae63b21da; }, function (v) { return $b9040d2deeb360f4$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $b9040d2deeb360f4$export$7c73462e0d25e514; }, function (v) { return $b9040d2deeb360f4$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $b9040d2deeb360f4$export$7568632d0d33d16d; }, function (v) { return $b9040d2deeb360f4$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $b9040d2deeb360f4$export$88948ce120ea2619; }, function (v) { return $b9040d2deeb360f4$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $b9040d2deeb360f4$export$35808ee640e87ca7; }, function (v) { return $b9040d2deeb360f4$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $b9040d2deeb360f4$export$fae74005e78b1a27; }, function (v) { return $b9040d2deeb360f4$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e; }, function (v) { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $b9040d2deeb360f4$export$6a7bc4e911dc01cf; }, function (v) { return $b9040d2deeb360f4$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $b9040d2deeb360f4$export$6d9c69b0de29b591; }, function (v) { return $b9040d2deeb360f4$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $b9040d2deeb360f4$export$f680877a34711e37; }, function (v) { return $b9040d2deeb360f4$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $b9040d2deeb360f4$export$d5a552a76deda3c2; }, function (v) { return $b9040d2deeb360f4$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $b9040d2deeb360f4$export$aaabe4eda9ed9969; }, function (v) { return $b9040d2deeb360f4$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $b9040d2deeb360f4$export$e5c5a5f917a5871c; }, function (v) { return $b9040d2deeb360f4$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $b9040d2deeb360f4$export$1538c33de8887b59; }, function (v) { return $b9040d2deeb360f4$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $b9040d2deeb360f4$export$13e3392192263954; }, function (v) { return $b9040d2deeb360f4$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $b9040d2deeb360f4$export$b8f5890fc79d6aca; }, function (v) { return $b9040d2deeb360f4$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $b9040d2deeb360f4$export$60241385465d0a34; }, function (v) { return $b9040d2deeb360f4$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $b9040d2deeb360f4$export$306c0aa65ff9ec16; }, function (v) { return $b9040d2deeb360f4$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $b9040d2deeb360f4$export$7b286972b8d8ccbf; }, function (v) { return $b9040d2deeb360f4$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $b9040d2deeb360f4$export$83d89fbfd8236492; }, function (v) { return $b9040d2deeb360f4$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b9040d2deeb360f4$export$dca3b0875bd9a954;
var $b9040d2deeb360f4$export$16fa2f45be04daa8;
var $b9040d2deeb360f4$export$ffb0004e005737fa;
var $b9040d2deeb360f4$export$e2c29f18771995cb;
var $b9040d2deeb360f4$export$221d75b3f55bb0bd;
var $b9040d2deeb360f4$export$5f8d39834fd61797;
var $b9040d2deeb360f4$export$74bf444e3cd11ea5;
var $b9040d2deeb360f4$export$ae55be85d98224ed;
var $b9040d2deeb360f4$export$3ba232387fd5d6dd;
var $b9040d2deeb360f4$export$e530037191fcd5d7;
var $b9040d2deeb360f4$export$fd42f52fd3ae1109;
var $b9040d2deeb360f4$export$c8a8987d4410bf2d;
var $b9040d2deeb360f4$export$d38cd72104c1f0e9;
var $b9040d2deeb360f4$export$7d1e3a5e95ceca43;
var $b9040d2deeb360f4$export$257a8862b851cb5b;
var $b9040d2deeb360f4$export$a8257692ac88316c;
var $b9040d2deeb360f4$export$488013bae63b21da;
var $b9040d2deeb360f4$export$7c73462e0d25e514;
var $b9040d2deeb360f4$export$7568632d0d33d16d;
var $b9040d2deeb360f4$export$88948ce120ea2619;
var $b9040d2deeb360f4$export$35808ee640e87ca7;
var $b9040d2deeb360f4$export$fae74005e78b1a27;
var $b9040d2deeb360f4$export$dc8fbce3eb94dc1e;
var $b9040d2deeb360f4$export$6a7bc4e911dc01cf;
var $b9040d2deeb360f4$export$6d9c69b0de29b591;
var $b9040d2deeb360f4$export$f680877a34711e37;
var $b9040d2deeb360f4$export$d5a552a76deda3c2;
var $b9040d2deeb360f4$export$aaabe4eda9ed9969;
var $b9040d2deeb360f4$export$e5c5a5f917a5871c;
var $b9040d2deeb360f4$export$1538c33de8887b59;
var $b9040d2deeb360f4$export$13e3392192263954;
var $b9040d2deeb360f4$export$b8f5890fc79d6aca;
var $b9040d2deeb360f4$export$60241385465d0a34;
var $b9040d2deeb360f4$export$306c0aa65ff9ec16;
var $b9040d2deeb360f4$export$7b286972b8d8ccbf;
var $b9040d2deeb360f4$export$83d89fbfd8236492;
'use strict';
var $b9040d2deeb360f4$var$l = Symbol.for("react.element"), $b9040d2deeb360f4$var$n = Symbol.for("react.portal"), $b9040d2deeb360f4$var$p = Symbol.for("react.fragment"), $b9040d2deeb360f4$var$q = Symbol.for("react.strict_mode"), $b9040d2deeb360f4$var$r = Symbol.for("react.profiler"), $b9040d2deeb360f4$var$t = Symbol.for("react.provider"), $b9040d2deeb360f4$var$u = Symbol.for("react.context"), $b9040d2deeb360f4$var$v = Symbol.for("react.forward_ref"), $b9040d2deeb360f4$var$w = Symbol.for("react.suspense"), $b9040d2deeb360f4$var$x = Symbol.for("react.memo"), $b9040d2deeb360f4$var$y = Symbol.for("react.lazy"), $b9040d2deeb360f4$var$z = Symbol.iterator;
function $b9040d2deeb360f4$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b9040d2deeb360f4$var$z && a[$b9040d2deeb360f4$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b9040d2deeb360f4$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b9040d2deeb360f4$var$C = Object.assign, $b9040d2deeb360f4$var$D = {};
function $b9040d2deeb360f4$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = e || $b9040d2deeb360f4$var$B;
}
$b9040d2deeb360f4$var$E.prototype.isReactComponent = {};
$b9040d2deeb360f4$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$b9040d2deeb360f4$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $b9040d2deeb360f4$var$F() {}
$b9040d2deeb360f4$var$F.prototype = $b9040d2deeb360f4$var$E.prototype;
function $b9040d2deeb360f4$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = e || $b9040d2deeb360f4$var$B;
}
var $b9040d2deeb360f4$var$H = $b9040d2deeb360f4$var$G.prototype = new $b9040d2deeb360f4$var$F;
$b9040d2deeb360f4$var$H.constructor = $b9040d2deeb360f4$var$G;
$b9040d2deeb360f4$var$C($b9040d2deeb360f4$var$H, $b9040d2deeb360f4$var$E.prototype);
$b9040d2deeb360f4$var$H.isPureReactComponent = !0;
var $b9040d2deeb360f4$var$I = Array.isArray, $b9040d2deeb360f4$var$J = Object.prototype.hasOwnProperty, $b9040d2deeb360f4$var$K = {
    current: null
}, $b9040d2deeb360f4$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b9040d2deeb360f4$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$b9040d2deeb360f4$var$J.call(b, d) && !$b9040d2deeb360f4$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $b9040d2deeb360f4$var$K.current
    };
}
function $b9040d2deeb360f4$var$N(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $b9040d2deeb360f4$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b9040d2deeb360f4$var$l;
}
function $b9040d2deeb360f4$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $b9040d2deeb360f4$var$P = /\/+/g;
function $b9040d2deeb360f4$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $b9040d2deeb360f4$var$escape("" + a.key) : b.toString(36);
}
function $b9040d2deeb360f4$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $b9040d2deeb360f4$var$l:
                case $b9040d2deeb360f4$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $b9040d2deeb360f4$var$Q(h, 0) : d, $b9040d2deeb360f4$var$I(c) ? (e = "", null != a && (e = a.replace($b9040d2deeb360f4$var$P, "$&/") + "/"), $b9040d2deeb360f4$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($b9040d2deeb360f4$var$O(c) && (c = $b9040d2deeb360f4$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($b9040d2deeb360f4$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($b9040d2deeb360f4$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $b9040d2deeb360f4$var$Q(k, g);
        h += $b9040d2deeb360f4$var$R(k, b, e, f, c);
    }
    else if (f = $b9040d2deeb360f4$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $b9040d2deeb360f4$var$Q(k, g++), h += $b9040d2deeb360f4$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $b9040d2deeb360f4$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $b9040d2deeb360f4$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $b9040d2deeb360f4$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $b9040d2deeb360f4$var$U = {
    current: null
}, $b9040d2deeb360f4$var$V = {
    transition: null
}, $b9040d2deeb360f4$var$W = {
    ReactCurrentDispatcher: $b9040d2deeb360f4$var$U,
    ReactCurrentBatchConfig: $b9040d2deeb360f4$var$V,
    ReactCurrentOwner: $b9040d2deeb360f4$var$K
};
function $b9040d2deeb360f4$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$b9040d2deeb360f4$export$dca3b0875bd9a954 = {
    map: $b9040d2deeb360f4$var$S,
    forEach: function(a, b, e) {
        $b9040d2deeb360f4$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $b9040d2deeb360f4$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $b9040d2deeb360f4$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$b9040d2deeb360f4$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$b9040d2deeb360f4$export$16fa2f45be04daa8 = $b9040d2deeb360f4$var$E;
$b9040d2deeb360f4$export$ffb0004e005737fa = $b9040d2deeb360f4$var$p;
$b9040d2deeb360f4$export$e2c29f18771995cb = $b9040d2deeb360f4$var$r;
$b9040d2deeb360f4$export$221d75b3f55bb0bd = $b9040d2deeb360f4$var$G;
$b9040d2deeb360f4$export$5f8d39834fd61797 = $b9040d2deeb360f4$var$q;
$b9040d2deeb360f4$export$74bf444e3cd11ea5 = $b9040d2deeb360f4$var$w;
$b9040d2deeb360f4$export$ae55be85d98224ed = $b9040d2deeb360f4$var$W;
$b9040d2deeb360f4$export$3ba232387fd5d6dd = $b9040d2deeb360f4$var$X;
$b9040d2deeb360f4$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $b9040d2deeb360f4$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $b9040d2deeb360f4$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$b9040d2deeb360f4$var$J.call(b, f) && !$b9040d2deeb360f4$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$b9040d2deeb360f4$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $b9040d2deeb360f4$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $b9040d2deeb360f4$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$b9040d2deeb360f4$export$c8a8987d4410bf2d = $b9040d2deeb360f4$var$M;
$b9040d2deeb360f4$export$d38cd72104c1f0e9 = function(a) {
    var b = $b9040d2deeb360f4$var$M.bind(null, a);
    b.type = a;
    return b;
};
$b9040d2deeb360f4$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b9040d2deeb360f4$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$v,
        render: a
    };
};
$b9040d2deeb360f4$export$a8257692ac88316c = $b9040d2deeb360f4$var$O;
$b9040d2deeb360f4$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $b9040d2deeb360f4$var$T
    };
};
$b9040d2deeb360f4$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$b9040d2deeb360f4$export$7568632d0d33d16d = function(a) {
    var b = $b9040d2deeb360f4$var$V.transition;
    $b9040d2deeb360f4$var$V.transition = {};
    try {
        a();
    } finally{
        $b9040d2deeb360f4$var$V.transition = b;
    }
};
$b9040d2deeb360f4$export$88948ce120ea2619 = $b9040d2deeb360f4$var$X;
$b9040d2deeb360f4$export$35808ee640e87ca7 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useCallback(a, b);
};
$b9040d2deeb360f4$export$fae74005e78b1a27 = function(a) {
    return $b9040d2deeb360f4$var$U.current.useContext(a);
};
$b9040d2deeb360f4$export$dc8fbce3eb94dc1e = function() {};
$b9040d2deeb360f4$export$6a7bc4e911dc01cf = function(a) {
    return $b9040d2deeb360f4$var$U.current.useDeferredValue(a);
};
$b9040d2deeb360f4$export$6d9c69b0de29b591 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useEffect(a, b);
};
$b9040d2deeb360f4$export$f680877a34711e37 = function() {
    return $b9040d2deeb360f4$var$U.current.useId();
};
$b9040d2deeb360f4$export$d5a552a76deda3c2 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useImperativeHandle(a, b, e);
};
$b9040d2deeb360f4$export$aaabe4eda9ed9969 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useInsertionEffect(a, b);
};
$b9040d2deeb360f4$export$e5c5a5f917a5871c = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useLayoutEffect(a, b);
};
$b9040d2deeb360f4$export$1538c33de8887b59 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useMemo(a, b);
};
$b9040d2deeb360f4$export$13e3392192263954 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useReducer(a, b, e);
};
$b9040d2deeb360f4$export$b8f5890fc79d6aca = function(a) {
    return $b9040d2deeb360f4$var$U.current.useRef(a);
};
$b9040d2deeb360f4$export$60241385465d0a34 = function(a) {
    return $b9040d2deeb360f4$var$U.current.useState(a);
};
$b9040d2deeb360f4$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useSyncExternalStore(a, b, e);
};
$b9040d2deeb360f4$export$7b286972b8d8ccbf = function() {
    return $b9040d2deeb360f4$var$U.current.useTransition();
};
$b9040d2deeb360f4$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("6EA3T", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $4d82739dd229d539$export$ae55be85d98224ed; }, function (v) { return $4d82739dd229d539$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $4d82739dd229d539$export$d39a5bbd09211389; }, function (v) { return $4d82739dd229d539$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $4d82739dd229d539$export$882461b6382ed46c; }, function (v) { return $4d82739dd229d539$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $4d82739dd229d539$export$466bfc07425424d5; }, function (v) { return $4d82739dd229d539$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $4d82739dd229d539$export$cd75ccfd720a3cd4; }, function (v) { return $4d82739dd229d539$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $4d82739dd229d539$export$fa8d919ba61d84db; }, function (v) { return $4d82739dd229d539$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $4d82739dd229d539$export$757ceba2d55c277e; }, function (v) { return $4d82739dd229d539$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $4d82739dd229d539$export$b3890eb0ae9dca99; }, function (v) { return $4d82739dd229d539$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $4d82739dd229d539$export$502457920280e6be; }, function (v) { return $4d82739dd229d539$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $4d82739dd229d539$export$c78a37762a8d58e1; }, function (v) { return $4d82739dd229d539$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $4d82739dd229d539$export$dc54d992c10e8a18; }, function (v) { return $4d82739dd229d539$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $4d82739dd229d539$export$83d89fbfd8236492; }, function (v) { return $4d82739dd229d539$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $4d82739dd229d539$export$ae55be85d98224ed;
var $4d82739dd229d539$export$d39a5bbd09211389;
var $4d82739dd229d539$export$882461b6382ed46c;
var $4d82739dd229d539$export$466bfc07425424d5;
var $4d82739dd229d539$export$cd75ccfd720a3cd4;
var $4d82739dd229d539$export$fa8d919ba61d84db;
var $4d82739dd229d539$export$757ceba2d55c277e;
var $4d82739dd229d539$export$b3890eb0ae9dca99;
var $4d82739dd229d539$export$502457920280e6be;
var $4d82739dd229d539$export$c78a37762a8d58e1;
var $4d82739dd229d539$export$dc54d992c10e8a18;
var $4d82739dd229d539$export$83d89fbfd8236492;
'use strict';

var $7fPBF = parcelRequire("7fPBF");

var $33s19 = parcelRequire("33s19");
function $4d82739dd229d539$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $4d82739dd229d539$var$da = new Set, $4d82739dd229d539$var$ea = {};
function $4d82739dd229d539$var$fa(a, b) {
    $4d82739dd229d539$var$ha(a, b);
    $4d82739dd229d539$var$ha(a + "Capture", b);
}
function $4d82739dd229d539$var$ha(a, b) {
    $4d82739dd229d539$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$4d82739dd229d539$var$da.add(b[a]);
}
var $4d82739dd229d539$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $4d82739dd229d539$var$ja = Object.prototype.hasOwnProperty, $4d82739dd229d539$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $4d82739dd229d539$var$la = {}, $4d82739dd229d539$var$ma = {};
function $4d82739dd229d539$var$oa(a) {
    if ($4d82739dd229d539$var$ja.call($4d82739dd229d539$var$ma, a)) return !0;
    if ($4d82739dd229d539$var$ja.call($4d82739dd229d539$var$la, a)) return !1;
    if ($4d82739dd229d539$var$ka.test(a)) return $4d82739dd229d539$var$ma[a] = !0;
    $4d82739dd229d539$var$la[a] = !0;
    return !1;
}
function $4d82739dd229d539$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $4d82739dd229d539$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $4d82739dd229d539$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $4d82739dd229d539$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $4d82739dd229d539$var$ra = /[\-:]([a-z])/g;
function $4d82739dd229d539$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$4d82739dd229d539$var$z.xlinkHref = new $4d82739dd229d539$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $4d82739dd229d539$var$ta(a, b, c, d) {
    var e = $4d82739dd229d539$var$z.hasOwnProperty(b) ? $4d82739dd229d539$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $4d82739dd229d539$var$qa(b, c, e, d) && (c = null), d || null === e ? $4d82739dd229d539$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $4d82739dd229d539$var$ua = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $4d82739dd229d539$var$va = Symbol.for("react.element"), $4d82739dd229d539$var$wa = Symbol.for("react.portal"), $4d82739dd229d539$var$ya = Symbol.for("react.fragment"), $4d82739dd229d539$var$za = Symbol.for("react.strict_mode"), $4d82739dd229d539$var$Aa = Symbol.for("react.profiler"), $4d82739dd229d539$var$Ba = Symbol.for("react.provider"), $4d82739dd229d539$var$Ca = Symbol.for("react.context"), $4d82739dd229d539$var$Da = Symbol.for("react.forward_ref"), $4d82739dd229d539$var$Ea = Symbol.for("react.suspense"), $4d82739dd229d539$var$Fa = Symbol.for("react.suspense_list"), $4d82739dd229d539$var$Ga = Symbol.for("react.memo"), $4d82739dd229d539$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $4d82739dd229d539$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $4d82739dd229d539$var$Ja = Symbol.iterator;
function $4d82739dd229d539$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $4d82739dd229d539$var$Ja && a[$4d82739dd229d539$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $4d82739dd229d539$var$A = Object.assign, $4d82739dd229d539$var$La;
function $4d82739dd229d539$var$Ma(a) {
    if (void 0 === $4d82739dd229d539$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $4d82739dd229d539$var$La = b && b[1] || "";
    }
    return "\n" + $4d82739dd229d539$var$La + a;
}
var $4d82739dd229d539$var$Na = !1;
function $4d82739dd229d539$var$Oa(a, b) {
    if (!a || $4d82739dd229d539$var$Na) return "";
    $4d82739dd229d539$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $4d82739dd229d539$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $4d82739dd229d539$var$Ma(a) : "";
}
function $4d82739dd229d539$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $4d82739dd229d539$var$Ma(a.type);
        case 16:
            return $4d82739dd229d539$var$Ma("Lazy");
        case 13:
            return $4d82739dd229d539$var$Ma("Suspense");
        case 19:
            return $4d82739dd229d539$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $4d82739dd229d539$var$Oa(a.type, !1), a;
        case 11:
            return a = $4d82739dd229d539$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $4d82739dd229d539$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $4d82739dd229d539$var$ya:
            return "Fragment";
        case $4d82739dd229d539$var$wa:
            return "Portal";
        case $4d82739dd229d539$var$Aa:
            return "Profiler";
        case $4d82739dd229d539$var$za:
            return "StrictMode";
        case $4d82739dd229d539$var$Ea:
            return "Suspense";
        case $4d82739dd229d539$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $4d82739dd229d539$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $4d82739dd229d539$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $4d82739dd229d539$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $4d82739dd229d539$var$Ga:
            return b = a.displayName || null, null !== b ? b : $4d82739dd229d539$var$Qa(a.type) || "Memo";
        case $4d82739dd229d539$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $4d82739dd229d539$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $4d82739dd229d539$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $4d82739dd229d539$var$Qa(b);
        case 8:
            return b === $4d82739dd229d539$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $4d82739dd229d539$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $4d82739dd229d539$var$Ua(a) {
    var b = $4d82739dd229d539$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $4d82739dd229d539$var$Va(a) {
    a._valueTracker || (a._valueTracker = $4d82739dd229d539$var$Ua(a));
}
function $4d82739dd229d539$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $4d82739dd229d539$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $4d82739dd229d539$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $4d82739dd229d539$var$Ya(a, b) {
    var c = b.checked;
    return $4d82739dd229d539$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $4d82739dd229d539$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $4d82739dd229d539$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $4d82739dd229d539$var$ab(a, b) {
    b = b.checked;
    null != b && $4d82739dd229d539$var$ta(a, "checked", b, !1);
}
function $4d82739dd229d539$var$bb(a, b) {
    $4d82739dd229d539$var$ab(a, b);
    var c = $4d82739dd229d539$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $4d82739dd229d539$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $4d82739dd229d539$var$cb(a, b.type, $4d82739dd229d539$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $4d82739dd229d539$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $4d82739dd229d539$var$cb(a, b, c) {
    if ("number" !== b || $4d82739dd229d539$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $4d82739dd229d539$var$eb = Array.isArray;
function $4d82739dd229d539$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $4d82739dd229d539$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $4d82739dd229d539$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($4d82739dd229d539$var$p(91));
    return $4d82739dd229d539$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $4d82739dd229d539$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($4d82739dd229d539$var$p(92));
            if ($4d82739dd229d539$var$eb(c)) {
                if (1 < c.length) throw Error($4d82739dd229d539$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $4d82739dd229d539$var$Sa(c)
    };
}
function $4d82739dd229d539$var$ib(a, b) {
    var c = $4d82739dd229d539$var$Sa(b.value), d = $4d82739dd229d539$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $4d82739dd229d539$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $4d82739dd229d539$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $4d82739dd229d539$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $4d82739dd229d539$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $4d82739dd229d539$var$mb, $4d82739dd229d539$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $4d82739dd229d539$var$mb = $4d82739dd229d539$var$mb || document.createElement("div");
        $4d82739dd229d539$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $4d82739dd229d539$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $4d82739dd229d539$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $4d82739dd229d539$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $4d82739dd229d539$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($4d82739dd229d539$var$pb).forEach(function(a) {
    $4d82739dd229d539$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $4d82739dd229d539$var$pb[b] = $4d82739dd229d539$var$pb[a];
    });
});
function $4d82739dd229d539$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $4d82739dd229d539$var$pb.hasOwnProperty(a) && $4d82739dd229d539$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $4d82739dd229d539$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $4d82739dd229d539$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $4d82739dd229d539$var$tb = $4d82739dd229d539$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $4d82739dd229d539$var$ub(a, b) {
    if (b) {
        if ($4d82739dd229d539$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($4d82739dd229d539$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($4d82739dd229d539$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($4d82739dd229d539$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($4d82739dd229d539$var$p(62));
    }
}
function $4d82739dd229d539$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $4d82739dd229d539$var$wb = null;
function $4d82739dd229d539$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $4d82739dd229d539$var$yb = null, $4d82739dd229d539$var$zb = null, $4d82739dd229d539$var$Ab = null;
function $4d82739dd229d539$var$Bb(a) {
    if (a = $4d82739dd229d539$var$Cb(a)) {
        if ("function" !== typeof $4d82739dd229d539$var$yb) throw Error($4d82739dd229d539$var$p(280));
        var b = a.stateNode;
        b && (b = $4d82739dd229d539$var$Db(b), $4d82739dd229d539$var$yb(a.stateNode, a.type, b));
    }
}
function $4d82739dd229d539$var$Eb(a) {
    $4d82739dd229d539$var$zb ? $4d82739dd229d539$var$Ab ? $4d82739dd229d539$var$Ab.push(a) : $4d82739dd229d539$var$Ab = [
        a
    ] : $4d82739dd229d539$var$zb = a;
}
function $4d82739dd229d539$var$Fb() {
    if ($4d82739dd229d539$var$zb) {
        var a = $4d82739dd229d539$var$zb, b = $4d82739dd229d539$var$Ab;
        $4d82739dd229d539$var$Ab = $4d82739dd229d539$var$zb = null;
        $4d82739dd229d539$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$4d82739dd229d539$var$Bb(b[a]);
    }
}
function $4d82739dd229d539$var$Gb(a, b) {
    return a(b);
}
function $4d82739dd229d539$var$Hb() {}
var $4d82739dd229d539$var$Ib = !1;
function $4d82739dd229d539$var$Jb(a, b, c) {
    if ($4d82739dd229d539$var$Ib) return a(b, c);
    $4d82739dd229d539$var$Ib = !0;
    try {
        return $4d82739dd229d539$var$Gb(a, b, c);
    } finally{
        if ($4d82739dd229d539$var$Ib = !1, null !== $4d82739dd229d539$var$zb || null !== $4d82739dd229d539$var$Ab) $4d82739dd229d539$var$Hb(), $4d82739dd229d539$var$Fb();
    }
}
function $4d82739dd229d539$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $4d82739dd229d539$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($4d82739dd229d539$var$p(231, b, typeof c));
    return c;
}
var $4d82739dd229d539$var$Lb = !1;
if ($4d82739dd229d539$var$ia) try {
    var $4d82739dd229d539$var$Mb = {};
    Object.defineProperty($4d82739dd229d539$var$Mb, "passive", {
        get: function() {
            $4d82739dd229d539$var$Lb = !0;
        }
    });
    window.addEventListener("test", $4d82739dd229d539$var$Mb, $4d82739dd229d539$var$Mb);
    window.removeEventListener("test", $4d82739dd229d539$var$Mb, $4d82739dd229d539$var$Mb);
} catch (a) {
    $4d82739dd229d539$var$Lb = !1;
}
function $4d82739dd229d539$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $4d82739dd229d539$var$Ob = !1, $4d82739dd229d539$var$Pb = null, $4d82739dd229d539$var$Qb = !1, $4d82739dd229d539$var$Rb = null, $4d82739dd229d539$var$Sb = {
    onError: function(a) {
        $4d82739dd229d539$var$Ob = !0;
        $4d82739dd229d539$var$Pb = a;
    }
};
function $4d82739dd229d539$var$Tb(a, b, c, d, e, f, g, h, k) {
    $4d82739dd229d539$var$Ob = !1;
    $4d82739dd229d539$var$Pb = null;
    $4d82739dd229d539$var$Nb.apply($4d82739dd229d539$var$Sb, arguments);
}
function $4d82739dd229d539$var$Ub(a, b, c, d, e, f, g, h, k) {
    $4d82739dd229d539$var$Tb.apply(this, arguments);
    if ($4d82739dd229d539$var$Ob) {
        if ($4d82739dd229d539$var$Ob) {
            var l = $4d82739dd229d539$var$Pb;
            $4d82739dd229d539$var$Ob = !1;
            $4d82739dd229d539$var$Pb = null;
        } else throw Error($4d82739dd229d539$var$p(198));
        $4d82739dd229d539$var$Qb || ($4d82739dd229d539$var$Qb = !0, $4d82739dd229d539$var$Rb = l);
    }
}
function $4d82739dd229d539$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $4d82739dd229d539$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $4d82739dd229d539$var$Xb(a) {
    if ($4d82739dd229d539$var$Vb(a) !== a) throw Error($4d82739dd229d539$var$p(188));
}
function $4d82739dd229d539$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $4d82739dd229d539$var$Vb(a);
        if (null === b) throw Error($4d82739dd229d539$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $4d82739dd229d539$var$Xb(e), a;
                if (f === d) return $4d82739dd229d539$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($4d82739dd229d539$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($4d82739dd229d539$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($4d82739dd229d539$var$p(190));
    }
    if (3 !== c.tag) throw Error($4d82739dd229d539$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $4d82739dd229d539$var$Zb(a) {
    a = $4d82739dd229d539$var$Yb(a);
    return null !== a ? $4d82739dd229d539$var$$b(a) : null;
}
function $4d82739dd229d539$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $4d82739dd229d539$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $4d82739dd229d539$var$ac = $33s19.unstable_scheduleCallback, $4d82739dd229d539$var$bc = $33s19.unstable_cancelCallback, $4d82739dd229d539$var$cc = $33s19.unstable_shouldYield, $4d82739dd229d539$var$dc = $33s19.unstable_requestPaint, $4d82739dd229d539$var$B = $33s19.unstable_now, $4d82739dd229d539$var$ec = $33s19.unstable_getCurrentPriorityLevel, $4d82739dd229d539$var$fc = $33s19.unstable_ImmediatePriority, $4d82739dd229d539$var$gc = $33s19.unstable_UserBlockingPriority, $4d82739dd229d539$var$hc = $33s19.unstable_NormalPriority, $4d82739dd229d539$var$ic = $33s19.unstable_LowPriority, $4d82739dd229d539$var$jc = $33s19.unstable_IdlePriority, $4d82739dd229d539$var$kc = null, $4d82739dd229d539$var$lc = null;
function $4d82739dd229d539$var$mc(a) {
    if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onCommitFiberRoot) try {
        $4d82739dd229d539$var$lc.onCommitFiberRoot($4d82739dd229d539$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $4d82739dd229d539$var$oc = Math.clz32 ? Math.clz32 : $4d82739dd229d539$var$nc, $4d82739dd229d539$var$pc = Math.log, $4d82739dd229d539$var$qc = Math.LN2;
function $4d82739dd229d539$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($4d82739dd229d539$var$pc(a) / $4d82739dd229d539$var$qc | 0) | 0;
}
var $4d82739dd229d539$var$rc = 64, $4d82739dd229d539$var$sc = 4194304;
function $4d82739dd229d539$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $4d82739dd229d539$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $4d82739dd229d539$var$tc(h) : (f &= g, 0 !== f && (d = $4d82739dd229d539$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $4d82739dd229d539$var$tc(g) : 0 !== f && (d = $4d82739dd229d539$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $4d82739dd229d539$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $4d82739dd229d539$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $4d82739dd229d539$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $4d82739dd229d539$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $4d82739dd229d539$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $4d82739dd229d539$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $4d82739dd229d539$var$yc() {
    var a = $4d82739dd229d539$var$rc;
    $4d82739dd229d539$var$rc <<= 1;
    0 === ($4d82739dd229d539$var$rc & 4194240) && ($4d82739dd229d539$var$rc = 64);
    return a;
}
function $4d82739dd229d539$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $4d82739dd229d539$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $4d82739dd229d539$var$oc(b);
    a[b] = c;
}
function $4d82739dd229d539$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $4d82739dd229d539$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $4d82739dd229d539$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $4d82739dd229d539$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $4d82739dd229d539$var$C = 0;
function $4d82739dd229d539$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $4d82739dd229d539$var$Ec, $4d82739dd229d539$var$Fc, $4d82739dd229d539$var$Gc, $4d82739dd229d539$var$Hc, $4d82739dd229d539$var$Ic, $4d82739dd229d539$var$Jc = !1, $4d82739dd229d539$var$Kc = [], $4d82739dd229d539$var$Lc = null, $4d82739dd229d539$var$Mc = null, $4d82739dd229d539$var$Nc = null, $4d82739dd229d539$var$Oc = new Map, $4d82739dd229d539$var$Pc = new Map, $4d82739dd229d539$var$Qc = [], $4d82739dd229d539$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $4d82739dd229d539$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $4d82739dd229d539$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $4d82739dd229d539$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $4d82739dd229d539$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $4d82739dd229d539$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $4d82739dd229d539$var$Pc.delete(b.pointerId);
    }
}
function $4d82739dd229d539$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $4d82739dd229d539$var$Cb(b), null !== b && $4d82739dd229d539$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $4d82739dd229d539$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $4d82739dd229d539$var$Lc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $4d82739dd229d539$var$Mc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $4d82739dd229d539$var$Nc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $4d82739dd229d539$var$Oc.set(f, $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $4d82739dd229d539$var$Pc.set(f, $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $4d82739dd229d539$var$Vc(a) {
    var b = $4d82739dd229d539$var$Wc(a.target);
    if (null !== b) {
        var c = $4d82739dd229d539$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $4d82739dd229d539$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $4d82739dd229d539$var$Ic(a.priority, function() {
                        $4d82739dd229d539$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $4d82739dd229d539$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $4d82739dd229d539$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $4d82739dd229d539$var$wb = d;
            c.target.dispatchEvent(d);
            $4d82739dd229d539$var$wb = null;
        } else return b = $4d82739dd229d539$var$Cb(c), null !== b && $4d82739dd229d539$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $4d82739dd229d539$var$Zc(a, b, c) {
    $4d82739dd229d539$var$Xc(a) && c.delete(b);
}
function $4d82739dd229d539$var$$c() {
    $4d82739dd229d539$var$Jc = !1;
    null !== $4d82739dd229d539$var$Lc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Lc) && ($4d82739dd229d539$var$Lc = null);
    null !== $4d82739dd229d539$var$Mc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Mc) && ($4d82739dd229d539$var$Mc = null);
    null !== $4d82739dd229d539$var$Nc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Nc) && ($4d82739dd229d539$var$Nc = null);
    $4d82739dd229d539$var$Oc.forEach($4d82739dd229d539$var$Zc);
    $4d82739dd229d539$var$Pc.forEach($4d82739dd229d539$var$Zc);
}
function $4d82739dd229d539$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $4d82739dd229d539$var$Jc || ($4d82739dd229d539$var$Jc = !0, $33s19.unstable_scheduleCallback($33s19.unstable_NormalPriority, $4d82739dd229d539$var$$c)));
}
function $4d82739dd229d539$var$bd(a) {
    function b(b) {
        return $4d82739dd229d539$var$ad(b, a);
    }
    if (0 < $4d82739dd229d539$var$Kc.length) {
        $4d82739dd229d539$var$ad($4d82739dd229d539$var$Kc[0], a);
        for(var c = 1; c < $4d82739dd229d539$var$Kc.length; c++){
            var d = $4d82739dd229d539$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $4d82739dd229d539$var$Lc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Lc, a);
    null !== $4d82739dd229d539$var$Mc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Mc, a);
    null !== $4d82739dd229d539$var$Nc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Nc, a);
    $4d82739dd229d539$var$Oc.forEach(b);
    $4d82739dd229d539$var$Pc.forEach(b);
    for(c = 0; c < $4d82739dd229d539$var$Qc.length; c++)d = $4d82739dd229d539$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $4d82739dd229d539$var$Qc.length && (c = $4d82739dd229d539$var$Qc[0], null === c.blockedOn);)$4d82739dd229d539$var$Vc(c), null === c.blockedOn && $4d82739dd229d539$var$Qc.shift();
}
var $4d82739dd229d539$var$cd = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$dd = !0;
function $4d82739dd229d539$var$ed(a, b, c, d) {
    var e = $4d82739dd229d539$var$C, f = $4d82739dd229d539$var$cd.transition;
    $4d82739dd229d539$var$cd.transition = null;
    try {
        $4d82739dd229d539$var$C = 1, $4d82739dd229d539$var$fd(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$C = e, $4d82739dd229d539$var$cd.transition = f;
    }
}
function $4d82739dd229d539$var$gd(a, b, c, d) {
    var e = $4d82739dd229d539$var$C, f = $4d82739dd229d539$var$cd.transition;
    $4d82739dd229d539$var$cd.transition = null;
    try {
        $4d82739dd229d539$var$C = 4, $4d82739dd229d539$var$fd(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$C = e, $4d82739dd229d539$var$cd.transition = f;
    }
}
function $4d82739dd229d539$var$fd(a, b, c, d) {
    if ($4d82739dd229d539$var$dd) {
        var e = $4d82739dd229d539$var$Yc(a, b, c, d);
        if (null === e) $4d82739dd229d539$var$hd(a, b, d, $4d82739dd229d539$var$id, c), $4d82739dd229d539$var$Sc(a, d);
        else if ($4d82739dd229d539$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($4d82739dd229d539$var$Sc(a, d), b & 4 && -1 < $4d82739dd229d539$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $4d82739dd229d539$var$Cb(e);
                null !== f && $4d82739dd229d539$var$Ec(f);
                f = $4d82739dd229d539$var$Yc(a, b, c, d);
                null === f && $4d82739dd229d539$var$hd(a, b, d, $4d82739dd229d539$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $4d82739dd229d539$var$hd(a, b, d, null, c);
    }
}
var $4d82739dd229d539$var$id = null;
function $4d82739dd229d539$var$Yc(a, b, c, d) {
    $4d82739dd229d539$var$id = null;
    a = $4d82739dd229d539$var$xb(d);
    a = $4d82739dd229d539$var$Wc(a);
    if (null !== a) {
        if (b = $4d82739dd229d539$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $4d82739dd229d539$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $4d82739dd229d539$var$id = a;
    return null;
}
function $4d82739dd229d539$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($4d82739dd229d539$var$ec()){
                case $4d82739dd229d539$var$fc:
                    return 1;
                case $4d82739dd229d539$var$gc:
                    return 4;
                case $4d82739dd229d539$var$hc:
                case $4d82739dd229d539$var$ic:
                    return 16;
                case $4d82739dd229d539$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $4d82739dd229d539$var$kd = null, $4d82739dd229d539$var$ld = null, $4d82739dd229d539$var$md = null;
function $4d82739dd229d539$var$nd() {
    if ($4d82739dd229d539$var$md) return $4d82739dd229d539$var$md;
    var a, b = $4d82739dd229d539$var$ld, c = b.length, d, e = "value" in $4d82739dd229d539$var$kd ? $4d82739dd229d539$var$kd.value : $4d82739dd229d539$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $4d82739dd229d539$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $4d82739dd229d539$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $4d82739dd229d539$var$pd() {
    return !0;
}
function $4d82739dd229d539$var$qd() {
    return !1;
}
function $4d82739dd229d539$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $4d82739dd229d539$var$pd : $4d82739dd229d539$var$qd;
        this.isPropagationStopped = $4d82739dd229d539$var$qd;
        return this;
    }
    $4d82739dd229d539$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $4d82739dd229d539$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $4d82739dd229d539$var$pd);
        },
        persist: function() {},
        isPersistent: $4d82739dd229d539$var$pd
    });
    return b;
}
var $4d82739dd229d539$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $4d82739dd229d539$var$td = $4d82739dd229d539$var$rd($4d82739dd229d539$var$sd), $4d82739dd229d539$var$ud = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    view: 0,
    detail: 0
}), $4d82739dd229d539$var$vd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$ud), $4d82739dd229d539$var$wd, $4d82739dd229d539$var$xd, $4d82739dd229d539$var$yd, $4d82739dd229d539$var$Ad = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $4d82739dd229d539$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $4d82739dd229d539$var$yd && ($4d82739dd229d539$var$yd && "mousemove" === a.type ? ($4d82739dd229d539$var$wd = a.screenX - $4d82739dd229d539$var$yd.screenX, $4d82739dd229d539$var$xd = a.screenY - $4d82739dd229d539$var$yd.screenY) : $4d82739dd229d539$var$xd = $4d82739dd229d539$var$wd = 0, $4d82739dd229d539$var$yd = a);
        return $4d82739dd229d539$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $4d82739dd229d539$var$xd;
    }
}), $4d82739dd229d539$var$Bd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ad), $4d82739dd229d539$var$Cd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    dataTransfer: 0
}), $4d82739dd229d539$var$Dd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Cd), $4d82739dd229d539$var$Ed = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    relatedTarget: 0
}), $4d82739dd229d539$var$Fd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ed), $4d82739dd229d539$var$Gd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4d82739dd229d539$var$Hd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Gd), $4d82739dd229d539$var$Id = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $4d82739dd229d539$var$Jd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Id), $4d82739dd229d539$var$Kd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    data: 0
}), $4d82739dd229d539$var$Ld = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Kd), $4d82739dd229d539$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $4d82739dd229d539$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $4d82739dd229d539$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $4d82739dd229d539$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $4d82739dd229d539$var$Od[a]) ? !!b[a] : !1;
}
function $4d82739dd229d539$var$zd() {
    return $4d82739dd229d539$var$Pd;
}
var $4d82739dd229d539$var$Qd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $4d82739dd229d539$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $4d82739dd229d539$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $4d82739dd229d539$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $4d82739dd229d539$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $4d82739dd229d539$var$Rd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Qd), $4d82739dd229d539$var$Sd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $4d82739dd229d539$var$Td = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Sd), $4d82739dd229d539$var$Ud = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $4d82739dd229d539$var$zd
}), $4d82739dd229d539$var$Vd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ud), $4d82739dd229d539$var$Wd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4d82739dd229d539$var$Xd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Wd), $4d82739dd229d539$var$Yd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $4d82739dd229d539$var$Zd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Yd), $4d82739dd229d539$var$$d = [
    9,
    13,
    27,
    32
], $4d82739dd229d539$var$ae = $4d82739dd229d539$var$ia && "CompositionEvent" in window, $4d82739dd229d539$var$be = null;
$4d82739dd229d539$var$ia && "documentMode" in document && ($4d82739dd229d539$var$be = document.documentMode);
var $4d82739dd229d539$var$ce = $4d82739dd229d539$var$ia && "TextEvent" in window && !$4d82739dd229d539$var$be, $4d82739dd229d539$var$de = $4d82739dd229d539$var$ia && (!$4d82739dd229d539$var$ae || $4d82739dd229d539$var$be && 8 < $4d82739dd229d539$var$be && 11 >= $4d82739dd229d539$var$be), $4d82739dd229d539$var$ee = String.fromCharCode(32), $4d82739dd229d539$var$fe = !1;
function $4d82739dd229d539$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $4d82739dd229d539$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $4d82739dd229d539$var$ie = !1;
function $4d82739dd229d539$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $4d82739dd229d539$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $4d82739dd229d539$var$fe = !0;
            return $4d82739dd229d539$var$ee;
        case "textInput":
            return a = b.data, a === $4d82739dd229d539$var$ee && $4d82739dd229d539$var$fe ? null : a;
        default:
            return null;
    }
}
function $4d82739dd229d539$var$ke(a, b) {
    if ($4d82739dd229d539$var$ie) return "compositionend" === a || !$4d82739dd229d539$var$ae && $4d82739dd229d539$var$ge(a, b) ? (a = $4d82739dd229d539$var$nd(), $4d82739dd229d539$var$md = $4d82739dd229d539$var$ld = $4d82739dd229d539$var$kd = null, $4d82739dd229d539$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $4d82739dd229d539$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $4d82739dd229d539$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$4d82739dd229d539$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $4d82739dd229d539$var$ne(a, b, c, d) {
    $4d82739dd229d539$var$Eb(d);
    b = $4d82739dd229d539$var$oe(b, "onChange");
    0 < b.length && (c = new $4d82739dd229d539$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $4d82739dd229d539$var$pe = null, $4d82739dd229d539$var$qe = null;
function $4d82739dd229d539$var$re(a) {
    $4d82739dd229d539$var$se(a, 0);
}
function $4d82739dd229d539$var$te(a) {
    var b = $4d82739dd229d539$var$ue(a);
    if ($4d82739dd229d539$var$Wa(b)) return a;
}
function $4d82739dd229d539$var$ve(a, b) {
    if ("change" === a) return b;
}
var $4d82739dd229d539$var$we = !1;
if ($4d82739dd229d539$var$ia) {
    var $4d82739dd229d539$var$xe;
    if ($4d82739dd229d539$var$ia) {
        var $4d82739dd229d539$var$ye = "oninput" in document;
        if (!$4d82739dd229d539$var$ye) {
            var $4d82739dd229d539$var$ze = document.createElement("div");
            $4d82739dd229d539$var$ze.setAttribute("oninput", "return;");
            $4d82739dd229d539$var$ye = "function" === typeof $4d82739dd229d539$var$ze.oninput;
        }
        $4d82739dd229d539$var$xe = $4d82739dd229d539$var$ye;
    } else $4d82739dd229d539$var$xe = !1;
    $4d82739dd229d539$var$we = $4d82739dd229d539$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $4d82739dd229d539$var$Ae() {
    $4d82739dd229d539$var$pe && ($4d82739dd229d539$var$pe.detachEvent("onpropertychange", $4d82739dd229d539$var$Be), $4d82739dd229d539$var$qe = $4d82739dd229d539$var$pe = null);
}
function $4d82739dd229d539$var$Be(a) {
    if ("value" === a.propertyName && $4d82739dd229d539$var$te($4d82739dd229d539$var$qe)) {
        var b = [];
        $4d82739dd229d539$var$ne(b, $4d82739dd229d539$var$qe, a, $4d82739dd229d539$var$xb(a));
        $4d82739dd229d539$var$Jb($4d82739dd229d539$var$re, b);
    }
}
function $4d82739dd229d539$var$Ce(a, b, c) {
    "focusin" === a ? ($4d82739dd229d539$var$Ae(), $4d82739dd229d539$var$pe = b, $4d82739dd229d539$var$qe = c, $4d82739dd229d539$var$pe.attachEvent("onpropertychange", $4d82739dd229d539$var$Be)) : "focusout" === a && $4d82739dd229d539$var$Ae();
}
function $4d82739dd229d539$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $4d82739dd229d539$var$te($4d82739dd229d539$var$qe);
}
function $4d82739dd229d539$var$Ee(a, b) {
    if ("click" === a) return $4d82739dd229d539$var$te(b);
}
function $4d82739dd229d539$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $4d82739dd229d539$var$te(b);
}
function $4d82739dd229d539$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $4d82739dd229d539$var$He = "function" === typeof Object.is ? Object.is : $4d82739dd229d539$var$Ge;
function $4d82739dd229d539$var$Ie(a, b) {
    if ($4d82739dd229d539$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$4d82739dd229d539$var$ja.call(b, e) || !$4d82739dd229d539$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $4d82739dd229d539$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $4d82739dd229d539$var$Ke(a, b) {
    var c = $4d82739dd229d539$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $4d82739dd229d539$var$Je(c);
    }
}
function $4d82739dd229d539$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $4d82739dd229d539$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $4d82739dd229d539$var$Me() {
    for(var a = window, b = $4d82739dd229d539$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $4d82739dd229d539$var$Xa(a.document);
    }
    return b;
}
function $4d82739dd229d539$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $4d82739dd229d539$var$Oe(a) {
    var b = $4d82739dd229d539$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $4d82739dd229d539$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $4d82739dd229d539$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $4d82739dd229d539$var$Ke(c, f);
                var g = $4d82739dd229d539$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $4d82739dd229d539$var$Pe = $4d82739dd229d539$var$ia && "documentMode" in document && 11 >= document.documentMode, $4d82739dd229d539$var$Qe = null, $4d82739dd229d539$var$Re = null, $4d82739dd229d539$var$Se = null, $4d82739dd229d539$var$Te = !1;
function $4d82739dd229d539$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $4d82739dd229d539$var$Te || null == $4d82739dd229d539$var$Qe || $4d82739dd229d539$var$Qe !== $4d82739dd229d539$var$Xa(d) || (d = $4d82739dd229d539$var$Qe, "selectionStart" in d && $4d82739dd229d539$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $4d82739dd229d539$var$Se && $4d82739dd229d539$var$Ie($4d82739dd229d539$var$Se, d) || ($4d82739dd229d539$var$Se = d, d = $4d82739dd229d539$var$oe($4d82739dd229d539$var$Re, "onSelect"), 0 < d.length && (b = new $4d82739dd229d539$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $4d82739dd229d539$var$Qe)));
}
function $4d82739dd229d539$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $4d82739dd229d539$var$We = {
    animationend: $4d82739dd229d539$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $4d82739dd229d539$var$Ve("Animation", "AnimationIteration"),
    animationstart: $4d82739dd229d539$var$Ve("Animation", "AnimationStart"),
    transitionend: $4d82739dd229d539$var$Ve("Transition", "TransitionEnd")
}, $4d82739dd229d539$var$Xe = {}, $4d82739dd229d539$var$Ye = {};
$4d82739dd229d539$var$ia && ($4d82739dd229d539$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $4d82739dd229d539$var$We.animationend.animation, delete $4d82739dd229d539$var$We.animationiteration.animation, delete $4d82739dd229d539$var$We.animationstart.animation), "TransitionEvent" in window || delete $4d82739dd229d539$var$We.transitionend.transition);
function $4d82739dd229d539$var$Ze(a) {
    if ($4d82739dd229d539$var$Xe[a]) return $4d82739dd229d539$var$Xe[a];
    if (!$4d82739dd229d539$var$We[a]) return a;
    var b = $4d82739dd229d539$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $4d82739dd229d539$var$Ye) return $4d82739dd229d539$var$Xe[a] = b[c];
    return a;
}
var $4d82739dd229d539$var$$e = $4d82739dd229d539$var$Ze("animationend"), $4d82739dd229d539$var$af = $4d82739dd229d539$var$Ze("animationiteration"), $4d82739dd229d539$var$bf = $4d82739dd229d539$var$Ze("animationstart"), $4d82739dd229d539$var$cf = $4d82739dd229d539$var$Ze("transitionend"), $4d82739dd229d539$var$df = new Map, $4d82739dd229d539$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $4d82739dd229d539$var$ff(a, b) {
    $4d82739dd229d539$var$df.set(a, b);
    $4d82739dd229d539$var$fa(b, [
        a
    ]);
}
for(var $4d82739dd229d539$var$gf = 0; $4d82739dd229d539$var$gf < $4d82739dd229d539$var$ef.length; $4d82739dd229d539$var$gf++){
    var $4d82739dd229d539$var$hf = $4d82739dd229d539$var$ef[$4d82739dd229d539$var$gf], $4d82739dd229d539$var$jf = $4d82739dd229d539$var$hf.toLowerCase(), $4d82739dd229d539$var$kf = $4d82739dd229d539$var$hf[0].toUpperCase() + $4d82739dd229d539$var$hf.slice(1);
    $4d82739dd229d539$var$ff($4d82739dd229d539$var$jf, "on" + $4d82739dd229d539$var$kf);
}
$4d82739dd229d539$var$ff($4d82739dd229d539$var$$e, "onAnimationEnd");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$af, "onAnimationIteration");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$bf, "onAnimationStart");
$4d82739dd229d539$var$ff("dblclick", "onDoubleClick");
$4d82739dd229d539$var$ff("focusin", "onFocus");
$4d82739dd229d539$var$ff("focusout", "onBlur");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$cf, "onTransitionEnd");
$4d82739dd229d539$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$4d82739dd229d539$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$4d82739dd229d539$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$4d82739dd229d539$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$4d82739dd229d539$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$4d82739dd229d539$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$4d82739dd229d539$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$4d82739dd229d539$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$4d82739dd229d539$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$4d82739dd229d539$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $4d82739dd229d539$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $4d82739dd229d539$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($4d82739dd229d539$var$lf));
function $4d82739dd229d539$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $4d82739dd229d539$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $4d82739dd229d539$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4d82739dd229d539$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4d82739dd229d539$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($4d82739dd229d539$var$Qb) throw a = $4d82739dd229d539$var$Rb, $4d82739dd229d539$var$Qb = !1, $4d82739dd229d539$var$Rb = null, a;
}
function $4d82739dd229d539$var$D(a, b) {
    var c = b[$4d82739dd229d539$var$of];
    void 0 === c && (c = b[$4d82739dd229d539$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($4d82739dd229d539$var$pf(b, a, 2, !1), c.add(d));
}
function $4d82739dd229d539$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $4d82739dd229d539$var$pf(c, a, d, b);
}
var $4d82739dd229d539$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $4d82739dd229d539$var$sf(a) {
    if (!a[$4d82739dd229d539$var$rf]) {
        a[$4d82739dd229d539$var$rf] = !0;
        $4d82739dd229d539$var$da.forEach(function(b) {
            "selectionchange" !== b && ($4d82739dd229d539$var$mf.has(b) || $4d82739dd229d539$var$qf(b, !1, a), $4d82739dd229d539$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$4d82739dd229d539$var$rf] || (b[$4d82739dd229d539$var$rf] = !0, $4d82739dd229d539$var$qf("selectionchange", !1, b));
    }
}
function $4d82739dd229d539$var$pf(a, b, c, d) {
    switch($4d82739dd229d539$var$jd(b)){
        case 1:
            var e = $4d82739dd229d539$var$ed;
            break;
        case 4:
            e = $4d82739dd229d539$var$gd;
            break;
        default:
            e = $4d82739dd229d539$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$4d82739dd229d539$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $4d82739dd229d539$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $4d82739dd229d539$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $4d82739dd229d539$var$Jb(function() {
        var d = f, e = $4d82739dd229d539$var$xb(c), g = [];
        a: {
            var h = $4d82739dd229d539$var$df.get(a);
            if (void 0 !== h) {
                var k = $4d82739dd229d539$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $4d82739dd229d539$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $4d82739dd229d539$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $4d82739dd229d539$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $4d82739dd229d539$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $4d82739dd229d539$var$Vd;
                        break;
                    case $4d82739dd229d539$var$$e:
                    case $4d82739dd229d539$var$af:
                    case $4d82739dd229d539$var$bf:
                        k = $4d82739dd229d539$var$Hd;
                        break;
                    case $4d82739dd229d539$var$cf:
                        k = $4d82739dd229d539$var$Xd;
                        break;
                    case "scroll":
                        k = $4d82739dd229d539$var$vd;
                        break;
                    case "wheel":
                        k = $4d82739dd229d539$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $4d82739dd229d539$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $4d82739dd229d539$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $4d82739dd229d539$var$Kb(w, x), null != F && t.push($4d82739dd229d539$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $4d82739dd229d539$var$wb && (n = c.relatedTarget || c.fromElement) && ($4d82739dd229d539$var$Wc(n) || n[$4d82739dd229d539$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $4d82739dd229d539$var$Wc(n) : null, null !== n && (J = $4d82739dd229d539$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $4d82739dd229d539$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $4d82739dd229d539$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $4d82739dd229d539$var$ue(k);
                        u = null == n ? h : $4d82739dd229d539$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $4d82739dd229d539$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $4d82739dd229d539$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $4d82739dd229d539$var$vf(F))u++;
                            for(; 0 < w - u;)t = $4d82739dd229d539$var$vf(t), w--;
                            for(; 0 < u - w;)x = $4d82739dd229d539$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $4d82739dd229d539$var$vf(t);
                                x = $4d82739dd229d539$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $4d82739dd229d539$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $4d82739dd229d539$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $4d82739dd229d539$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $4d82739dd229d539$var$ve;
                else if ($4d82739dd229d539$var$me(h)) {
                    if ($4d82739dd229d539$var$we) na = $4d82739dd229d539$var$Fe;
                    else {
                        na = $4d82739dd229d539$var$De;
                        var xa = $4d82739dd229d539$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $4d82739dd229d539$var$Ee);
                if (na && (na = na(a, d))) {
                    $4d82739dd229d539$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $4d82739dd229d539$var$cb(h, "number", h.value);
            }
            xa = d ? $4d82739dd229d539$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($4d82739dd229d539$var$me(xa) || "true" === xa.contentEditable) $4d82739dd229d539$var$Qe = xa, $4d82739dd229d539$var$Re = d, $4d82739dd229d539$var$Se = null;
                    break;
                case "focusout":
                    $4d82739dd229d539$var$Se = $4d82739dd229d539$var$Re = $4d82739dd229d539$var$Qe = null;
                    break;
                case "mousedown":
                    $4d82739dd229d539$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $4d82739dd229d539$var$Te = !1;
                    $4d82739dd229d539$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($4d82739dd229d539$var$Pe) break;
                case "keydown":
                case "keyup":
                    $4d82739dd229d539$var$Ue(g, c, e);
            }
            var $a;
            if ($4d82739dd229d539$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $4d82739dd229d539$var$ie ? $4d82739dd229d539$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($4d82739dd229d539$var$de && "ko" !== c.locale && ($4d82739dd229d539$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $4d82739dd229d539$var$ie && ($a = $4d82739dd229d539$var$nd()) : ($4d82739dd229d539$var$kd = e, $4d82739dd229d539$var$ld = "value" in $4d82739dd229d539$var$kd ? $4d82739dd229d539$var$kd.value : $4d82739dd229d539$var$kd.textContent, $4d82739dd229d539$var$ie = !0)), xa = $4d82739dd229d539$var$oe(d, ba), 0 < xa.length && (ba = new $4d82739dd229d539$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $4d82739dd229d539$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $4d82739dd229d539$var$ce ? $4d82739dd229d539$var$je(a, c) : $4d82739dd229d539$var$ke(a, c)) d = $4d82739dd229d539$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $4d82739dd229d539$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $4d82739dd229d539$var$se(g, b);
    });
}
function $4d82739dd229d539$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $4d82739dd229d539$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $4d82739dd229d539$var$Kb(a, c), null != f && d.unshift($4d82739dd229d539$var$tf(a, f, e)), f = $4d82739dd229d539$var$Kb(a, b), null != f && d.push($4d82739dd229d539$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $4d82739dd229d539$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $4d82739dd229d539$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $4d82739dd229d539$var$Kb(c, f), null != k && g.unshift($4d82739dd229d539$var$tf(c, k, h))) : e || (k = $4d82739dd229d539$var$Kb(c, f), null != k && g.push($4d82739dd229d539$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $4d82739dd229d539$var$xf = /\r\n?/g, $4d82739dd229d539$var$yf = /\u0000|\uFFFD/g;
function $4d82739dd229d539$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($4d82739dd229d539$var$xf, "\n").replace($4d82739dd229d539$var$yf, "");
}
function $4d82739dd229d539$var$Af(a, b, c) {
    b = $4d82739dd229d539$var$zf(b);
    if ($4d82739dd229d539$var$zf(a) !== b && c) throw Error($4d82739dd229d539$var$p(425));
}
function $4d82739dd229d539$var$Bf() {}
var $4d82739dd229d539$var$Cf = null, $4d82739dd229d539$var$Df = null;
function $4d82739dd229d539$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $4d82739dd229d539$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $4d82739dd229d539$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $4d82739dd229d539$var$Hf = "function" === typeof Promise ? Promise : void 0, $4d82739dd229d539$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $4d82739dd229d539$var$Hf ? function(a) {
    return $4d82739dd229d539$var$Hf.resolve(null).then(a).catch($4d82739dd229d539$var$If);
} : $4d82739dd229d539$var$Ff;
function $4d82739dd229d539$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $4d82739dd229d539$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $4d82739dd229d539$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $4d82739dd229d539$var$bd(b);
}
function $4d82739dd229d539$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $4d82739dd229d539$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $4d82739dd229d539$var$Nf = Math.random().toString(36).slice(2), $4d82739dd229d539$var$Of = "__reactFiber$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Pf = "__reactProps$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$uf = "__reactContainer$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$of = "__reactEvents$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Qf = "__reactListeners$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Rf = "__reactHandles$" + $4d82739dd229d539$var$Nf;
function $4d82739dd229d539$var$Wc(a) {
    var b = a[$4d82739dd229d539$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$4d82739dd229d539$var$uf] || c[$4d82739dd229d539$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $4d82739dd229d539$var$Mf(a); null !== a;){
                if (c = a[$4d82739dd229d539$var$Of]) return c;
                a = $4d82739dd229d539$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $4d82739dd229d539$var$Cb(a) {
    a = a[$4d82739dd229d539$var$Of] || a[$4d82739dd229d539$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $4d82739dd229d539$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($4d82739dd229d539$var$p(33));
}
function $4d82739dd229d539$var$Db(a) {
    return a[$4d82739dd229d539$var$Pf] || null;
}
var $4d82739dd229d539$var$Sf = [], $4d82739dd229d539$var$Tf = -1;
function $4d82739dd229d539$var$Uf(a) {
    return {
        current: a
    };
}
function $4d82739dd229d539$var$E(a) {
    0 > $4d82739dd229d539$var$Tf || (a.current = $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf], $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf] = null, $4d82739dd229d539$var$Tf--);
}
function $4d82739dd229d539$var$G(a, b) {
    $4d82739dd229d539$var$Tf++;
    $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf] = a.current;
    a.current = b;
}
var $4d82739dd229d539$var$Vf = {}, $4d82739dd229d539$var$H = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Vf), $4d82739dd229d539$var$Wf = $4d82739dd229d539$var$Uf(!1), $4d82739dd229d539$var$Xf = $4d82739dd229d539$var$Vf;
function $4d82739dd229d539$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $4d82739dd229d539$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $4d82739dd229d539$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $4d82739dd229d539$var$$f() {
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
}
function $4d82739dd229d539$var$ag(a, b, c) {
    if ($4d82739dd229d539$var$H.current !== $4d82739dd229d539$var$Vf) throw Error($4d82739dd229d539$var$p(168));
    $4d82739dd229d539$var$G($4d82739dd229d539$var$H, b);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, c);
}
function $4d82739dd229d539$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($4d82739dd229d539$var$p(108, $4d82739dd229d539$var$Ra(a) || "Unknown", e));
    return $4d82739dd229d539$var$A({}, c, d);
}
function $4d82739dd229d539$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $4d82739dd229d539$var$Vf;
    $4d82739dd229d539$var$Xf = $4d82739dd229d539$var$H.current;
    $4d82739dd229d539$var$G($4d82739dd229d539$var$H, a);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, $4d82739dd229d539$var$Wf.current);
    return !0;
}
function $4d82739dd229d539$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($4d82739dd229d539$var$p(169));
    c ? (a = $4d82739dd229d539$var$bg(a, b, $4d82739dd229d539$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf), $4d82739dd229d539$var$E($4d82739dd229d539$var$H), $4d82739dd229d539$var$G($4d82739dd229d539$var$H, a)) : $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, c);
}
var $4d82739dd229d539$var$eg = null, $4d82739dd229d539$var$fg = !1, $4d82739dd229d539$var$gg = !1;
function $4d82739dd229d539$var$hg(a) {
    null === $4d82739dd229d539$var$eg ? $4d82739dd229d539$var$eg = [
        a
    ] : $4d82739dd229d539$var$eg.push(a);
}
function $4d82739dd229d539$var$ig(a) {
    $4d82739dd229d539$var$fg = !0;
    $4d82739dd229d539$var$hg(a);
}
function $4d82739dd229d539$var$jg() {
    if (!$4d82739dd229d539$var$gg && null !== $4d82739dd229d539$var$eg) {
        $4d82739dd229d539$var$gg = !0;
        var a = 0, b = $4d82739dd229d539$var$C;
        try {
            var c = $4d82739dd229d539$var$eg;
            for($4d82739dd229d539$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $4d82739dd229d539$var$eg = null;
            $4d82739dd229d539$var$fg = !1;
        } catch (e) {
            throw null !== $4d82739dd229d539$var$eg && ($4d82739dd229d539$var$eg = $4d82739dd229d539$var$eg.slice(a + 1)), $4d82739dd229d539$var$ac($4d82739dd229d539$var$fc, $4d82739dd229d539$var$jg), e;
        } finally{
            $4d82739dd229d539$var$C = b, $4d82739dd229d539$var$gg = !1;
        }
    }
    return null;
}
var $4d82739dd229d539$var$kg = [], $4d82739dd229d539$var$lg = 0, $4d82739dd229d539$var$mg = null, $4d82739dd229d539$var$ng = 0, $4d82739dd229d539$var$og = [], $4d82739dd229d539$var$pg = 0, $4d82739dd229d539$var$qg = null, $4d82739dd229d539$var$rg = 1, $4d82739dd229d539$var$sg = "";
function $4d82739dd229d539$var$tg(a, b) {
    $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg++] = $4d82739dd229d539$var$ng;
    $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg++] = $4d82739dd229d539$var$mg;
    $4d82739dd229d539$var$mg = a;
    $4d82739dd229d539$var$ng = b;
}
function $4d82739dd229d539$var$ug(a, b, c) {
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$rg;
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$sg;
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$qg;
    $4d82739dd229d539$var$qg = a;
    var d = $4d82739dd229d539$var$rg;
    a = $4d82739dd229d539$var$sg;
    var e = 32 - $4d82739dd229d539$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $4d82739dd229d539$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $4d82739dd229d539$var$rg = 1 << 32 - $4d82739dd229d539$var$oc(b) + e | c << e | d;
        $4d82739dd229d539$var$sg = f + a;
    } else $4d82739dd229d539$var$rg = 1 << f | c << e | d, $4d82739dd229d539$var$sg = a;
}
function $4d82739dd229d539$var$vg(a) {
    null !== a.return && ($4d82739dd229d539$var$tg(a, 1), $4d82739dd229d539$var$ug(a, 1, 0));
}
function $4d82739dd229d539$var$wg(a) {
    for(; a === $4d82739dd229d539$var$mg;)$4d82739dd229d539$var$mg = $4d82739dd229d539$var$kg[--$4d82739dd229d539$var$lg], $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg] = null, $4d82739dd229d539$var$ng = $4d82739dd229d539$var$kg[--$4d82739dd229d539$var$lg], $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg] = null;
    for(; a === $4d82739dd229d539$var$qg;)$4d82739dd229d539$var$qg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null, $4d82739dd229d539$var$sg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null, $4d82739dd229d539$var$rg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null;
}
var $4d82739dd229d539$var$xg = null, $4d82739dd229d539$var$yg = null, $4d82739dd229d539$var$I = !1, $4d82739dd229d539$var$zg = null;
function $4d82739dd229d539$var$Ag(a, b) {
    var c = $4d82739dd229d539$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $4d82739dd229d539$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $4d82739dd229d539$var$qg ? {
                id: $4d82739dd229d539$var$rg,
                overflow: $4d82739dd229d539$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $4d82739dd229d539$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $4d82739dd229d539$var$Eg(a) {
    if ($4d82739dd229d539$var$I) {
        var b = $4d82739dd229d539$var$yg;
        if (b) {
            var c = b;
            if (!$4d82739dd229d539$var$Cg(a, b)) {
                if ($4d82739dd229d539$var$Dg(a)) throw Error($4d82739dd229d539$var$p(418));
                b = $4d82739dd229d539$var$Lf(c.nextSibling);
                var d = $4d82739dd229d539$var$xg;
                b && $4d82739dd229d539$var$Cg(a, b) ? $4d82739dd229d539$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $4d82739dd229d539$var$I = !1, $4d82739dd229d539$var$xg = a);
            }
        } else {
            if ($4d82739dd229d539$var$Dg(a)) throw Error($4d82739dd229d539$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $4d82739dd229d539$var$I = !1;
            $4d82739dd229d539$var$xg = a;
        }
    }
}
function $4d82739dd229d539$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $4d82739dd229d539$var$xg = a;
}
function $4d82739dd229d539$var$Gg(a) {
    if (a !== $4d82739dd229d539$var$xg) return !1;
    if (!$4d82739dd229d539$var$I) return $4d82739dd229d539$var$Fg(a), $4d82739dd229d539$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$4d82739dd229d539$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $4d82739dd229d539$var$yg)) {
        if ($4d82739dd229d539$var$Dg(a)) throw $4d82739dd229d539$var$Hg(), Error($4d82739dd229d539$var$p(418));
        for(; b;)$4d82739dd229d539$var$Ag(a, b), b = $4d82739dd229d539$var$Lf(b.nextSibling);
    }
    $4d82739dd229d539$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($4d82739dd229d539$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $4d82739dd229d539$var$yg = null;
        }
    } else $4d82739dd229d539$var$yg = $4d82739dd229d539$var$xg ? $4d82739dd229d539$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $4d82739dd229d539$var$Hg() {
    for(var a = $4d82739dd229d539$var$yg; a;)a = $4d82739dd229d539$var$Lf(a.nextSibling);
}
function $4d82739dd229d539$var$Ig() {
    $4d82739dd229d539$var$yg = $4d82739dd229d539$var$xg = null;
    $4d82739dd229d539$var$I = !1;
}
function $4d82739dd229d539$var$Jg(a) {
    null === $4d82739dd229d539$var$zg ? $4d82739dd229d539$var$zg = [
        a
    ] : $4d82739dd229d539$var$zg.push(a);
}
var $4d82739dd229d539$var$Kg = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig;
function $4d82739dd229d539$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($4d82739dd229d539$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($4d82739dd229d539$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($4d82739dd229d539$var$p(284));
        if (!c._owner) throw Error($4d82739dd229d539$var$p(290, a));
    }
    return a;
}
function $4d82739dd229d539$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($4d82739dd229d539$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $4d82739dd229d539$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $4d82739dd229d539$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $4d82739dd229d539$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $4d82739dd229d539$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $4d82739dd229d539$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $4d82739dd229d539$var$Ha && $4d82739dd229d539$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $4d82739dd229d539$var$Lg(a, b, c), d.return = a, d;
        d = $4d82739dd229d539$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $4d82739dd229d539$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $4d82739dd229d539$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $4d82739dd229d539$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $4d82739dd229d539$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $4d82739dd229d539$var$va:
                    return c = $4d82739dd229d539$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $4d82739dd229d539$var$Lg(a, null, b), c.return = a, c;
                case $4d82739dd229d539$var$wa:
                    return b = $4d82739dd229d539$var$Sg(b, a.mode, c), b.return = a, b;
                case $4d82739dd229d539$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($4d82739dd229d539$var$eb(b) || $4d82739dd229d539$var$Ka(b)) return b = $4d82739dd229d539$var$Tg(b, a.mode, c, null), b.return = a, b;
            $4d82739dd229d539$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $4d82739dd229d539$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $4d82739dd229d539$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $4d82739dd229d539$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($4d82739dd229d539$var$eb(c) || $4d82739dd229d539$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $4d82739dd229d539$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $4d82739dd229d539$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $4d82739dd229d539$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $4d82739dd229d539$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($4d82739dd229d539$var$eb(d) || $4d82739dd229d539$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $4d82739dd229d539$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $4d82739dd229d539$var$Ka(h);
        if ("function" !== typeof l) throw Error($4d82739dd229d539$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($4d82739dd229d539$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $4d82739dd229d539$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $4d82739dd229d539$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $4d82739dd229d539$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $4d82739dd229d539$var$Ha && $4d82739dd229d539$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $4d82739dd229d539$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $4d82739dd229d539$var$ya ? (d = $4d82739dd229d539$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $4d82739dd229d539$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $4d82739dd229d539$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $4d82739dd229d539$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $4d82739dd229d539$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $4d82739dd229d539$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($4d82739dd229d539$var$eb(f)) return n(a, d, f, h);
            if ($4d82739dd229d539$var$Ka(f)) return t(a, d, f, h);
            $4d82739dd229d539$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $4d82739dd229d539$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $4d82739dd229d539$var$Ug = $4d82739dd229d539$var$Og(!0), $4d82739dd229d539$var$Vg = $4d82739dd229d539$var$Og(!1), $4d82739dd229d539$var$Wg = $4d82739dd229d539$var$Uf(null), $4d82739dd229d539$var$Xg = null, $4d82739dd229d539$var$Yg = null, $4d82739dd229d539$var$Zg = null;
function $4d82739dd229d539$var$$g() {
    $4d82739dd229d539$var$Zg = $4d82739dd229d539$var$Yg = $4d82739dd229d539$var$Xg = null;
}
function $4d82739dd229d539$var$ah(a) {
    var b = $4d82739dd229d539$var$Wg.current;
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Wg);
    a._currentValue = b;
}
function $4d82739dd229d539$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $4d82739dd229d539$var$ch(a, b) {
    $4d82739dd229d539$var$Xg = a;
    $4d82739dd229d539$var$Zg = $4d82739dd229d539$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($4d82739dd229d539$var$dh = !0), a.firstContext = null);
}
function $4d82739dd229d539$var$eh(a) {
    var b = a._currentValue;
    if ($4d82739dd229d539$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $4d82739dd229d539$var$Yg) {
            if (null === $4d82739dd229d539$var$Xg) throw Error($4d82739dd229d539$var$p(308));
            $4d82739dd229d539$var$Yg = a;
            $4d82739dd229d539$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $4d82739dd229d539$var$Yg = $4d82739dd229d539$var$Yg.next = a;
    }
    return b;
}
var $4d82739dd229d539$var$fh = null;
function $4d82739dd229d539$var$gh(a) {
    null === $4d82739dd229d539$var$fh ? $4d82739dd229d539$var$fh = [
        a
    ] : $4d82739dd229d539$var$fh.push(a);
}
function $4d82739dd229d539$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $4d82739dd229d539$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $4d82739dd229d539$var$ih(a, d);
}
function $4d82739dd229d539$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $4d82739dd229d539$var$jh = !1;
function $4d82739dd229d539$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $4d82739dd229d539$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $4d82739dd229d539$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $4d82739dd229d539$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($4d82739dd229d539$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $4d82739dd229d539$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $4d82739dd229d539$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $4d82739dd229d539$var$ih(a, c);
}
function $4d82739dd229d539$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4d82739dd229d539$var$Cc(a, c);
    }
}
function $4d82739dd229d539$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $4d82739dd229d539$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $4d82739dd229d539$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $4d82739dd229d539$var$A({}, q, r);
                            break a;
                        case 2:
                            $4d82739dd229d539$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $4d82739dd229d539$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $4d82739dd229d539$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($4d82739dd229d539$var$p(191, e));
            e.call(d);
        }
    }
}
var $4d82739dd229d539$var$th = {}, $4d82739dd229d539$var$uh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$th), $4d82739dd229d539$var$vh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$th), $4d82739dd229d539$var$wh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$th);
function $4d82739dd229d539$var$xh(a) {
    if (a === $4d82739dd229d539$var$th) throw Error($4d82739dd229d539$var$p(174));
    return a;
}
function $4d82739dd229d539$var$yh(a, b) {
    $4d82739dd229d539$var$G($4d82739dd229d539$var$wh, b);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$vh, a);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$uh, $4d82739dd229d539$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $4d82739dd229d539$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $4d82739dd229d539$var$lb(b, a);
    }
    $4d82739dd229d539$var$E($4d82739dd229d539$var$uh);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$uh, b);
}
function $4d82739dd229d539$var$zh() {
    $4d82739dd229d539$var$E($4d82739dd229d539$var$uh);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$vh);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$wh);
}
function $4d82739dd229d539$var$Ah(a) {
    $4d82739dd229d539$var$xh($4d82739dd229d539$var$wh.current);
    var b = $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
    var c = $4d82739dd229d539$var$lb(b, a.type);
    b !== c && ($4d82739dd229d539$var$G($4d82739dd229d539$var$vh, a), $4d82739dd229d539$var$G($4d82739dd229d539$var$uh, c));
}
function $4d82739dd229d539$var$Bh(a) {
    $4d82739dd229d539$var$vh.current === a && ($4d82739dd229d539$var$E($4d82739dd229d539$var$uh), $4d82739dd229d539$var$E($4d82739dd229d539$var$vh));
}
var $4d82739dd229d539$var$L = $4d82739dd229d539$var$Uf(0);
function $4d82739dd229d539$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $4d82739dd229d539$var$Dh = [];
function $4d82739dd229d539$var$Eh() {
    for(var a = 0; a < $4d82739dd229d539$var$Dh.length; a++)$4d82739dd229d539$var$Dh[a]._workInProgressVersionPrimary = null;
    $4d82739dd229d539$var$Dh.length = 0;
}
var $4d82739dd229d539$var$Fh = $4d82739dd229d539$var$ua.ReactCurrentDispatcher, $4d82739dd229d539$var$Gh = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$Hh = 0, $4d82739dd229d539$var$M = null, $4d82739dd229d539$var$N = null, $4d82739dd229d539$var$O = null, $4d82739dd229d539$var$Ih = !1, $4d82739dd229d539$var$Jh = !1, $4d82739dd229d539$var$Kh = 0, $4d82739dd229d539$var$Lh = 0;
function $4d82739dd229d539$var$P() {
    throw Error($4d82739dd229d539$var$p(321));
}
function $4d82739dd229d539$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$4d82739dd229d539$var$He(a[c], b[c])) return !1;
    return !0;
}
function $4d82739dd229d539$var$Nh(a, b, c, d, e, f) {
    $4d82739dd229d539$var$Hh = f;
    $4d82739dd229d539$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $4d82739dd229d539$var$Fh.current = null === a || null === a.memoizedState ? $4d82739dd229d539$var$Oh : $4d82739dd229d539$var$Ph;
    a = c(d, e);
    if ($4d82739dd229d539$var$Jh) {
        f = 0;
        do {
            $4d82739dd229d539$var$Jh = !1;
            $4d82739dd229d539$var$Kh = 0;
            if (25 <= f) throw Error($4d82739dd229d539$var$p(301));
            f += 1;
            $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = null;
            b.updateQueue = null;
            $4d82739dd229d539$var$Fh.current = $4d82739dd229d539$var$Qh;
            a = c(d, e);
        }while ($4d82739dd229d539$var$Jh);
    }
    $4d82739dd229d539$var$Fh.current = $4d82739dd229d539$var$Rh;
    b = null !== $4d82739dd229d539$var$N && null !== $4d82739dd229d539$var$N.next;
    $4d82739dd229d539$var$Hh = 0;
    $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = $4d82739dd229d539$var$M = null;
    $4d82739dd229d539$var$Ih = !1;
    if (b) throw Error($4d82739dd229d539$var$p(300));
    return a;
}
function $4d82739dd229d539$var$Sh() {
    var a = 0 !== $4d82739dd229d539$var$Kh;
    $4d82739dd229d539$var$Kh = 0;
    return a;
}
function $4d82739dd229d539$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $4d82739dd229d539$var$O ? $4d82739dd229d539$var$M.memoizedState = $4d82739dd229d539$var$O = a : $4d82739dd229d539$var$O = $4d82739dd229d539$var$O.next = a;
    return $4d82739dd229d539$var$O;
}
function $4d82739dd229d539$var$Uh() {
    if (null === $4d82739dd229d539$var$N) {
        var a = $4d82739dd229d539$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $4d82739dd229d539$var$N.next;
    var b = null === $4d82739dd229d539$var$O ? $4d82739dd229d539$var$M.memoizedState : $4d82739dd229d539$var$O.next;
    if (null !== b) $4d82739dd229d539$var$O = b, $4d82739dd229d539$var$N = a;
    else {
        if (null === a) throw Error($4d82739dd229d539$var$p(310));
        $4d82739dd229d539$var$N = a;
        a = {
            memoizedState: $4d82739dd229d539$var$N.memoizedState,
            baseState: $4d82739dd229d539$var$N.baseState,
            baseQueue: $4d82739dd229d539$var$N.baseQueue,
            queue: $4d82739dd229d539$var$N.queue,
            next: null
        };
        null === $4d82739dd229d539$var$O ? $4d82739dd229d539$var$M.memoizedState = $4d82739dd229d539$var$O = a : $4d82739dd229d539$var$O = $4d82739dd229d539$var$O.next = a;
    }
    return $4d82739dd229d539$var$O;
}
function $4d82739dd229d539$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $4d82739dd229d539$var$Wh(a) {
    var b = $4d82739dd229d539$var$Uh(), c = b.queue;
    if (null === c) throw Error($4d82739dd229d539$var$p(311));
    c.lastRenderedReducer = a;
    var d = $4d82739dd229d539$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($4d82739dd229d539$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $4d82739dd229d539$var$M.lanes |= m;
                $4d82739dd229d539$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $4d82739dd229d539$var$He(d, b.memoizedState) || ($4d82739dd229d539$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $4d82739dd229d539$var$M.lanes |= f, $4d82739dd229d539$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $4d82739dd229d539$var$Xh(a) {
    var b = $4d82739dd229d539$var$Uh(), c = b.queue;
    if (null === c) throw Error($4d82739dd229d539$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $4d82739dd229d539$var$He(f, b.memoizedState) || ($4d82739dd229d539$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $4d82739dd229d539$var$Yh() {}
function $4d82739dd229d539$var$Zh(a, b) {
    var c = $4d82739dd229d539$var$M, d = $4d82739dd229d539$var$Uh(), e = b(), f = !$4d82739dd229d539$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $4d82739dd229d539$var$dh = !0);
    d = d.queue;
    $4d82739dd229d539$var$$h($4d82739dd229d539$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $4d82739dd229d539$var$O && $4d82739dd229d539$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $4d82739dd229d539$var$bi(9, $4d82739dd229d539$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $4d82739dd229d539$var$Q) throw Error($4d82739dd229d539$var$p(349));
        0 !== ($4d82739dd229d539$var$Hh & 30) || $4d82739dd229d539$var$di(c, b, e);
    }
    return e;
}
function $4d82739dd229d539$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $4d82739dd229d539$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4d82739dd229d539$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $4d82739dd229d539$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $4d82739dd229d539$var$ei(b) && $4d82739dd229d539$var$fi(a);
}
function $4d82739dd229d539$var$ai(a, b, c) {
    return c(function() {
        $4d82739dd229d539$var$ei(b) && $4d82739dd229d539$var$fi(a);
    });
}
function $4d82739dd229d539$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$4d82739dd229d539$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $4d82739dd229d539$var$fi(a) {
    var b = $4d82739dd229d539$var$ih(a, 1);
    null !== b && $4d82739dd229d539$var$gi(b, a, 1, -1);
}
function $4d82739dd229d539$var$hi(a) {
    var b = $4d82739dd229d539$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $4d82739dd229d539$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $4d82739dd229d539$var$ii.bind(null, $4d82739dd229d539$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $4d82739dd229d539$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $4d82739dd229d539$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4d82739dd229d539$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $4d82739dd229d539$var$ji() {
    return $4d82739dd229d539$var$Uh().memoizedState;
}
function $4d82739dd229d539$var$ki(a, b, c, d) {
    var e = $4d82739dd229d539$var$Th();
    $4d82739dd229d539$var$M.flags |= a;
    e.memoizedState = $4d82739dd229d539$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $4d82739dd229d539$var$li(a, b, c, d) {
    var e = $4d82739dd229d539$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $4d82739dd229d539$var$N) {
        var g = $4d82739dd229d539$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $4d82739dd229d539$var$Mh(d, g.deps)) {
            e.memoizedState = $4d82739dd229d539$var$bi(b, c, f, d);
            return;
        }
    }
    $4d82739dd229d539$var$M.flags |= a;
    e.memoizedState = $4d82739dd229d539$var$bi(1 | b, c, f, d);
}
function $4d82739dd229d539$var$mi(a, b) {
    return $4d82739dd229d539$var$ki(8390656, 8, a, b);
}
function $4d82739dd229d539$var$$h(a, b) {
    return $4d82739dd229d539$var$li(2048, 8, a, b);
}
function $4d82739dd229d539$var$ni(a, b) {
    return $4d82739dd229d539$var$li(4, 2, a, b);
}
function $4d82739dd229d539$var$oi(a, b) {
    return $4d82739dd229d539$var$li(4, 4, a, b);
}
function $4d82739dd229d539$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $4d82739dd229d539$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $4d82739dd229d539$var$li(4, 4, $4d82739dd229d539$var$pi.bind(null, b, a), c);
}
function $4d82739dd229d539$var$ri() {}
function $4d82739dd229d539$var$si(a, b) {
    var c = $4d82739dd229d539$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4d82739dd229d539$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4d82739dd229d539$var$ti(a, b) {
    var c = $4d82739dd229d539$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4d82739dd229d539$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4d82739dd229d539$var$ui(a, b, c) {
    if (0 === ($4d82739dd229d539$var$Hh & 21)) return a.baseState && (a.baseState = !1, $4d82739dd229d539$var$dh = !0), a.memoizedState = c;
    $4d82739dd229d539$var$He(c, b) || (c = $4d82739dd229d539$var$yc(), $4d82739dd229d539$var$M.lanes |= c, $4d82739dd229d539$var$rh |= c, a.baseState = !0);
    return b;
}
function $4d82739dd229d539$var$vi(a, b) {
    var c = $4d82739dd229d539$var$C;
    $4d82739dd229d539$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $4d82739dd229d539$var$Gh.transition;
    $4d82739dd229d539$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $4d82739dd229d539$var$C = c, $4d82739dd229d539$var$Gh.transition = d;
    }
}
function $4d82739dd229d539$var$wi() {
    return $4d82739dd229d539$var$Uh().memoizedState;
}
function $4d82739dd229d539$var$xi(a, b, c) {
    var d = $4d82739dd229d539$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4d82739dd229d539$var$zi(a)) $4d82739dd229d539$var$Ai(b, c);
    else if (c = $4d82739dd229d539$var$hh(a, b, c, d), null !== c) {
        var e = $4d82739dd229d539$var$R();
        $4d82739dd229d539$var$gi(c, a, d, e);
        $4d82739dd229d539$var$Bi(c, b, d);
    }
}
function $4d82739dd229d539$var$ii(a, b, c) {
    var d = $4d82739dd229d539$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4d82739dd229d539$var$zi(a)) $4d82739dd229d539$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($4d82739dd229d539$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $4d82739dd229d539$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $4d82739dd229d539$var$hh(a, b, e, d);
        null !== c && (e = $4d82739dd229d539$var$R(), $4d82739dd229d539$var$gi(c, a, d, e), $4d82739dd229d539$var$Bi(c, b, d));
    }
}
function $4d82739dd229d539$var$zi(a) {
    var b = a.alternate;
    return a === $4d82739dd229d539$var$M || null !== b && b === $4d82739dd229d539$var$M;
}
function $4d82739dd229d539$var$Ai(a, b) {
    $4d82739dd229d539$var$Jh = $4d82739dd229d539$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $4d82739dd229d539$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4d82739dd229d539$var$Cc(a, c);
    }
}
var $4d82739dd229d539$var$Rh = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: $4d82739dd229d539$var$P,
    useContext: $4d82739dd229d539$var$P,
    useEffect: $4d82739dd229d539$var$P,
    useImperativeHandle: $4d82739dd229d539$var$P,
    useInsertionEffect: $4d82739dd229d539$var$P,
    useLayoutEffect: $4d82739dd229d539$var$P,
    useMemo: $4d82739dd229d539$var$P,
    useReducer: $4d82739dd229d539$var$P,
    useRef: $4d82739dd229d539$var$P,
    useState: $4d82739dd229d539$var$P,
    useDebugValue: $4d82739dd229d539$var$P,
    useDeferredValue: $4d82739dd229d539$var$P,
    useTransition: $4d82739dd229d539$var$P,
    useMutableSource: $4d82739dd229d539$var$P,
    useSyncExternalStore: $4d82739dd229d539$var$P,
    useId: $4d82739dd229d539$var$P,
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Oh = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: function(a, b) {
        $4d82739dd229d539$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $4d82739dd229d539$var$eh,
    useEffect: $4d82739dd229d539$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $4d82739dd229d539$var$ki(4194308, 4, $4d82739dd229d539$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $4d82739dd229d539$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $4d82739dd229d539$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $4d82739dd229d539$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $4d82739dd229d539$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $4d82739dd229d539$var$xi.bind(null, $4d82739dd229d539$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $4d82739dd229d539$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $4d82739dd229d539$var$hi,
    useDebugValue: $4d82739dd229d539$var$ri,
    useDeferredValue: function(a) {
        return $4d82739dd229d539$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$hi(!1), b = a[0];
        a = $4d82739dd229d539$var$vi.bind(null, a[1]);
        $4d82739dd229d539$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $4d82739dd229d539$var$M, e = $4d82739dd229d539$var$Th();
        if ($4d82739dd229d539$var$I) {
            if (void 0 === c) throw Error($4d82739dd229d539$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $4d82739dd229d539$var$Q) throw Error($4d82739dd229d539$var$p(349));
            0 !== ($4d82739dd229d539$var$Hh & 30) || $4d82739dd229d539$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $4d82739dd229d539$var$mi($4d82739dd229d539$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $4d82739dd229d539$var$bi(9, $4d82739dd229d539$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $4d82739dd229d539$var$Th(), b = $4d82739dd229d539$var$Q.identifierPrefix;
        if ($4d82739dd229d539$var$I) {
            var c = $4d82739dd229d539$var$sg;
            var d = $4d82739dd229d539$var$rg;
            c = (d & ~(1 << 32 - $4d82739dd229d539$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $4d82739dd229d539$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $4d82739dd229d539$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Ph = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: $4d82739dd229d539$var$si,
    useContext: $4d82739dd229d539$var$eh,
    useEffect: $4d82739dd229d539$var$$h,
    useImperativeHandle: $4d82739dd229d539$var$qi,
    useInsertionEffect: $4d82739dd229d539$var$ni,
    useLayoutEffect: $4d82739dd229d539$var$oi,
    useMemo: $4d82739dd229d539$var$ti,
    useReducer: $4d82739dd229d539$var$Wh,
    useRef: $4d82739dd229d539$var$ji,
    useState: function() {
        return $4d82739dd229d539$var$Wh($4d82739dd229d539$var$Vh);
    },
    useDebugValue: $4d82739dd229d539$var$ri,
    useDeferredValue: function(a) {
        var b = $4d82739dd229d539$var$Uh();
        return $4d82739dd229d539$var$ui(b, $4d82739dd229d539$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$Wh($4d82739dd229d539$var$Vh)[0], b = $4d82739dd229d539$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4d82739dd229d539$var$Yh,
    useSyncExternalStore: $4d82739dd229d539$var$Zh,
    useId: $4d82739dd229d539$var$wi,
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Qh = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: $4d82739dd229d539$var$si,
    useContext: $4d82739dd229d539$var$eh,
    useEffect: $4d82739dd229d539$var$$h,
    useImperativeHandle: $4d82739dd229d539$var$qi,
    useInsertionEffect: $4d82739dd229d539$var$ni,
    useLayoutEffect: $4d82739dd229d539$var$oi,
    useMemo: $4d82739dd229d539$var$ti,
    useReducer: $4d82739dd229d539$var$Xh,
    useRef: $4d82739dd229d539$var$ji,
    useState: function() {
        return $4d82739dd229d539$var$Xh($4d82739dd229d539$var$Vh);
    },
    useDebugValue: $4d82739dd229d539$var$ri,
    useDeferredValue: function(a) {
        var b = $4d82739dd229d539$var$Uh();
        return null === $4d82739dd229d539$var$N ? b.memoizedState = a : $4d82739dd229d539$var$ui(b, $4d82739dd229d539$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$Xh($4d82739dd229d539$var$Vh)[0], b = $4d82739dd229d539$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4d82739dd229d539$var$Yh,
    useSyncExternalStore: $4d82739dd229d539$var$Zh,
    useId: $4d82739dd229d539$var$wi,
    unstable_isNewReconciler: !1
};
function $4d82739dd229d539$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $4d82739dd229d539$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $4d82739dd229d539$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $4d82739dd229d539$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $4d82739dd229d539$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $4d82739dd229d539$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4d82739dd229d539$var$R(), e = $4d82739dd229d539$var$yi(a), f = $4d82739dd229d539$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4d82739dd229d539$var$nh(a, f, e);
        null !== b && ($4d82739dd229d539$var$gi(b, a, e, d), $4d82739dd229d539$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4d82739dd229d539$var$R(), e = $4d82739dd229d539$var$yi(a), f = $4d82739dd229d539$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4d82739dd229d539$var$nh(a, f, e);
        null !== b && ($4d82739dd229d539$var$gi(b, a, e, d), $4d82739dd229d539$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $4d82739dd229d539$var$R(), d = $4d82739dd229d539$var$yi(a), e = $4d82739dd229d539$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $4d82739dd229d539$var$nh(a, e, d);
        null !== b && ($4d82739dd229d539$var$gi(b, a, d, c), $4d82739dd229d539$var$oh(b, a, d));
    }
};
function $4d82739dd229d539$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$4d82739dd229d539$var$Ie(c, d) || !$4d82739dd229d539$var$Ie(e, f) : !0;
}
function $4d82739dd229d539$var$Gi(a, b, c) {
    var d = !1, e = $4d82739dd229d539$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $4d82739dd229d539$var$eh(f) : (e = $4d82739dd229d539$var$Zf(b) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $4d82739dd229d539$var$Yf(a, e) : $4d82739dd229d539$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $4d82739dd229d539$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $4d82739dd229d539$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $4d82739dd229d539$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $4d82739dd229d539$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $4d82739dd229d539$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $4d82739dd229d539$var$eh(f) : (f = $4d82739dd229d539$var$Zf(b) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, e.context = $4d82739dd229d539$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($4d82739dd229d539$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $4d82739dd229d539$var$Ei.enqueueReplaceState(e, e.state, null), $4d82739dd229d539$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $4d82739dd229d539$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $4d82739dd229d539$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $4d82739dd229d539$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $4d82739dd229d539$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $4d82739dd229d539$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $4d82739dd229d539$var$Ni(a, b, c) {
    c = $4d82739dd229d539$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $4d82739dd229d539$var$Oi || ($4d82739dd229d539$var$Oi = !0, $4d82739dd229d539$var$Pi = d);
        $4d82739dd229d539$var$Li(a, b);
    };
    return c;
}
function $4d82739dd229d539$var$Qi(a, b, c) {
    c = $4d82739dd229d539$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $4d82739dd229d539$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $4d82739dd229d539$var$Li(a, b);
        "function" !== typeof d && (null === $4d82739dd229d539$var$Ri ? $4d82739dd229d539$var$Ri = new Set([
            this
        ]) : $4d82739dd229d539$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $4d82739dd229d539$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $4d82739dd229d539$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $4d82739dd229d539$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $4d82739dd229d539$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $4d82739dd229d539$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $4d82739dd229d539$var$mh(-1, 1), b.tag = 2, $4d82739dd229d539$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $4d82739dd229d539$var$Wi = $4d82739dd229d539$var$ua.ReactCurrentOwner, $4d82739dd229d539$var$dh = !1;
function $4d82739dd229d539$var$Xi(a, b, c, d) {
    b.child = null === a ? $4d82739dd229d539$var$Vg(b, null, c, d) : $4d82739dd229d539$var$Ug(b, a.child, c, d);
}
function $4d82739dd229d539$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $4d82739dd229d539$var$ch(b, e);
    d = $4d82739dd229d539$var$Nh(a, b, c, d, f, e);
    c = $4d82739dd229d539$var$Sh();
    if (null !== a && !$4d82739dd229d539$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4d82739dd229d539$var$Zi(a, b, e);
    $4d82739dd229d539$var$I && c && $4d82739dd229d539$var$vg(b);
    b.flags |= 1;
    $4d82739dd229d539$var$Xi(a, b, d, e);
    return b.child;
}
function $4d82739dd229d539$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$4d82739dd229d539$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $4d82739dd229d539$var$bj(a, b, f, d, e);
        a = $4d82739dd229d539$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $4d82739dd229d539$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $4d82739dd229d539$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $4d82739dd229d539$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $4d82739dd229d539$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($4d82739dd229d539$var$Ie(f, d) && a.ref === b.ref) {
            if ($4d82739dd229d539$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($4d82739dd229d539$var$dh = !0);
            else return b.lanes = a.lanes, $4d82739dd229d539$var$Zi(a, b, e);
        }
    }
    return $4d82739dd229d539$var$cj(a, b, c, d, e);
}
function $4d82739dd229d539$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj), $4d82739dd229d539$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj), $4d82739dd229d539$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj);
            $4d82739dd229d539$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj), $4d82739dd229d539$var$fj |= d;
    $4d82739dd229d539$var$Xi(a, b, e, c);
    return b.child;
}
function $4d82739dd229d539$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $4d82739dd229d539$var$cj(a, b, c, d, e) {
    var f = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current;
    f = $4d82739dd229d539$var$Yf(b, f);
    $4d82739dd229d539$var$ch(b, e);
    c = $4d82739dd229d539$var$Nh(a, b, c, d, f, e);
    d = $4d82739dd229d539$var$Sh();
    if (null !== a && !$4d82739dd229d539$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4d82739dd229d539$var$Zi(a, b, e);
    $4d82739dd229d539$var$I && d && $4d82739dd229d539$var$vg(b);
    b.flags |= 1;
    $4d82739dd229d539$var$Xi(a, b, c, e);
    return b.child;
}
function $4d82739dd229d539$var$hj(a, b, c, d, e) {
    if ($4d82739dd229d539$var$Zf(c)) {
        var f = !0;
        $4d82739dd229d539$var$cg(b);
    } else f = !1;
    $4d82739dd229d539$var$ch(b, e);
    if (null === b.stateNode) $4d82739dd229d539$var$ij(a, b), $4d82739dd229d539$var$Gi(b, c, d), $4d82739dd229d539$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $4d82739dd229d539$var$eh(l) : (l = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, l = $4d82739dd229d539$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $4d82739dd229d539$var$Hi(b, g, d, l);
        $4d82739dd229d539$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $4d82739dd229d539$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $4d82739dd229d539$var$Wf.current || $4d82739dd229d539$var$jh ? ("function" === typeof m && ($4d82739dd229d539$var$Di(b, c, m, d), k = b.memoizedState), (h = $4d82739dd229d539$var$jh || $4d82739dd229d539$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $4d82739dd229d539$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $4d82739dd229d539$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $4d82739dd229d539$var$eh(k) : (k = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, k = $4d82739dd229d539$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $4d82739dd229d539$var$Hi(b, g, d, k);
        $4d82739dd229d539$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $4d82739dd229d539$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $4d82739dd229d539$var$Wf.current || $4d82739dd229d539$var$jh ? ("function" === typeof y && ($4d82739dd229d539$var$Di(b, c, y, d), n = b.memoizedState), (l = $4d82739dd229d539$var$jh || $4d82739dd229d539$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $4d82739dd229d539$var$jj(a, b, c, d, f, e);
}
function $4d82739dd229d539$var$jj(a, b, c, d, e, f) {
    $4d82739dd229d539$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $4d82739dd229d539$var$dg(b, c, !1), $4d82739dd229d539$var$Zi(a, b, f);
    d = b.stateNode;
    $4d82739dd229d539$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $4d82739dd229d539$var$Ug(b, a.child, null, f), b.child = $4d82739dd229d539$var$Ug(b, null, h, f)) : $4d82739dd229d539$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $4d82739dd229d539$var$dg(b, c, !0);
    return b.child;
}
function $4d82739dd229d539$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $4d82739dd229d539$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $4d82739dd229d539$var$ag(a, b.context, !1);
    $4d82739dd229d539$var$yh(a, b.containerInfo);
}
function $4d82739dd229d539$var$lj(a, b, c, d, e) {
    $4d82739dd229d539$var$Ig();
    $4d82739dd229d539$var$Jg(e);
    b.flags |= 256;
    $4d82739dd229d539$var$Xi(a, b, c, d);
    return b.child;
}
var $4d82739dd229d539$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $4d82739dd229d539$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $4d82739dd229d539$var$oj(a, b, c) {
    var d = b.pendingProps, e = $4d82739dd229d539$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $4d82739dd229d539$var$G($4d82739dd229d539$var$L, e & 1);
    if (null === a) {
        $4d82739dd229d539$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $4d82739dd229d539$var$pj(g, d, 0, null), a = $4d82739dd229d539$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $4d82739dd229d539$var$nj(c), b.memoizedState = $4d82739dd229d539$var$mj, a) : $4d82739dd229d539$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $4d82739dd229d539$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $4d82739dd229d539$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $4d82739dd229d539$var$Pg(h, f) : (f = $4d82739dd229d539$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $4d82739dd229d539$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $4d82739dd229d539$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $4d82739dd229d539$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $4d82739dd229d539$var$qj(a, b) {
    b = $4d82739dd229d539$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $4d82739dd229d539$var$sj(a, b, c, d) {
    null !== d && $4d82739dd229d539$var$Jg(d);
    $4d82739dd229d539$var$Ug(b, a.child, null, c);
    a = $4d82739dd229d539$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $4d82739dd229d539$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $4d82739dd229d539$var$Ki(Error($4d82739dd229d539$var$p(422))), $4d82739dd229d539$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $4d82739dd229d539$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $4d82739dd229d539$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $4d82739dd229d539$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $4d82739dd229d539$var$nj(g);
        b.memoizedState = $4d82739dd229d539$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $4d82739dd229d539$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($4d82739dd229d539$var$p(419));
        d = $4d82739dd229d539$var$Ki(f, d, void 0);
        return $4d82739dd229d539$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($4d82739dd229d539$var$dh || h) {
        d = $4d82739dd229d539$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $4d82739dd229d539$var$ih(a, e), $4d82739dd229d539$var$gi(d, a, e, -1));
        }
        $4d82739dd229d539$var$tj();
        d = $4d82739dd229d539$var$Ki(Error($4d82739dd229d539$var$p(421)));
        return $4d82739dd229d539$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $4d82739dd229d539$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(e.nextSibling);
    $4d82739dd229d539$var$xg = b;
    $4d82739dd229d539$var$I = !0;
    $4d82739dd229d539$var$zg = null;
    null !== a && ($4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$rg, $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$sg, $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$qg, $4d82739dd229d539$var$rg = a.id, $4d82739dd229d539$var$sg = a.overflow, $4d82739dd229d539$var$qg = b);
    b = $4d82739dd229d539$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $4d82739dd229d539$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $4d82739dd229d539$var$bh(a.return, b, c);
}
function $4d82739dd229d539$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $4d82739dd229d539$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $4d82739dd229d539$var$Xi(a, b, d.children, c);
    d = $4d82739dd229d539$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $4d82739dd229d539$var$vj(a, c, b);
            else if (19 === a.tag) $4d82739dd229d539$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $4d82739dd229d539$var$G($4d82739dd229d539$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $4d82739dd229d539$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $4d82739dd229d539$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $4d82739dd229d539$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $4d82739dd229d539$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $4d82739dd229d539$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $4d82739dd229d539$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $4d82739dd229d539$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($4d82739dd229d539$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $4d82739dd229d539$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $4d82739dd229d539$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $4d82739dd229d539$var$kj(b);
            $4d82739dd229d539$var$Ig();
            break;
        case 5:
            $4d82739dd229d539$var$Ah(b);
            break;
        case 1:
            $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$cg(b);
            break;
        case 4:
            $4d82739dd229d539$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $4d82739dd229d539$var$G($4d82739dd229d539$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $4d82739dd229d539$var$oj(a, b, c);
                $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1);
                a = $4d82739dd229d539$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $4d82739dd229d539$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $4d82739dd229d539$var$dj(a, b, c);
    }
    return $4d82739dd229d539$var$Zi(a, b, c);
}
var $4d82739dd229d539$var$zj, $4d82739dd229d539$var$Aj, $4d82739dd229d539$var$Bj, $4d82739dd229d539$var$Cj;
$4d82739dd229d539$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$4d82739dd229d539$var$Aj = function() {};
$4d82739dd229d539$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $4d82739dd229d539$var$Ya(a, e);
                d = $4d82739dd229d539$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $4d82739dd229d539$var$A({}, e, {
                    value: void 0
                });
                d = $4d82739dd229d539$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $4d82739dd229d539$var$gb(a, e);
                d = $4d82739dd229d539$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $4d82739dd229d539$var$Bf);
        }
        $4d82739dd229d539$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($4d82739dd229d539$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($4d82739dd229d539$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $4d82739dd229d539$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$4d82739dd229d539$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $4d82739dd229d539$var$Dj(a, b) {
    if (!$4d82739dd229d539$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $4d82739dd229d539$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $4d82739dd229d539$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $4d82739dd229d539$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $4d82739dd229d539$var$S(b), null;
        case 1:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), $4d82739dd229d539$var$S(b), null;
        case 3:
            d = b.stateNode;
            $4d82739dd229d539$var$zh();
            $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
            $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
            $4d82739dd229d539$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $4d82739dd229d539$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $4d82739dd229d539$var$zg && ($4d82739dd229d539$var$Fj($4d82739dd229d539$var$zg), $4d82739dd229d539$var$zg = null));
            $4d82739dd229d539$var$Aj(a, b);
            $4d82739dd229d539$var$S(b);
            return null;
        case 5:
            $4d82739dd229d539$var$Bh(b);
            var e = $4d82739dd229d539$var$xh($4d82739dd229d539$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $4d82739dd229d539$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($4d82739dd229d539$var$p(166));
                    $4d82739dd229d539$var$S(b);
                    return null;
                }
                a = $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
                if ($4d82739dd229d539$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$4d82739dd229d539$var$Of] = b;
                    d[$4d82739dd229d539$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $4d82739dd229d539$var$D("cancel", d);
                            $4d82739dd229d539$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $4d82739dd229d539$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $4d82739dd229d539$var$lf.length; e++)$4d82739dd229d539$var$D($4d82739dd229d539$var$lf[e], d);
                            break;
                        case "source":
                            $4d82739dd229d539$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $4d82739dd229d539$var$D("error", d);
                            $4d82739dd229d539$var$D("load", d);
                            break;
                        case "details":
                            $4d82739dd229d539$var$D("toggle", d);
                            break;
                        case "input":
                            $4d82739dd229d539$var$Za(d, f);
                            $4d82739dd229d539$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $4d82739dd229d539$var$D("invalid", d);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$hb(d, f), $4d82739dd229d539$var$D("invalid", d);
                    }
                    $4d82739dd229d539$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $4d82739dd229d539$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $4d82739dd229d539$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $4d82739dd229d539$var$Va(d);
                            $4d82739dd229d539$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$Va(d);
                            $4d82739dd229d539$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $4d82739dd229d539$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $4d82739dd229d539$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$4d82739dd229d539$var$Of] = b;
                    a[$4d82739dd229d539$var$Pf] = d;
                    $4d82739dd229d539$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $4d82739dd229d539$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $4d82739dd229d539$var$D("cancel", a);
                                $4d82739dd229d539$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $4d82739dd229d539$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $4d82739dd229d539$var$lf.length; e++)$4d82739dd229d539$var$D($4d82739dd229d539$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $4d82739dd229d539$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $4d82739dd229d539$var$D("error", a);
                                $4d82739dd229d539$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $4d82739dd229d539$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $4d82739dd229d539$var$Za(a, d);
                                e = $4d82739dd229d539$var$Ya(a, d);
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $4d82739dd229d539$var$A({}, d, {
                                    value: void 0
                                });
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            case "textarea":
                                $4d82739dd229d539$var$hb(a, d);
                                e = $4d82739dd229d539$var$gb(a, d);
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $4d82739dd229d539$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $4d82739dd229d539$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $4d82739dd229d539$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $4d82739dd229d539$var$ob(a, k) : "number" === typeof k && $4d82739dd229d539$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($4d82739dd229d539$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $4d82739dd229d539$var$D("scroll", a) : null != k && $4d82739dd229d539$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $4d82739dd229d539$var$Va(a);
                                $4d82739dd229d539$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $4d82739dd229d539$var$Va(a);
                                $4d82739dd229d539$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $4d82739dd229d539$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $4d82739dd229d539$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $4d82739dd229d539$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $4d82739dd229d539$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $4d82739dd229d539$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $4d82739dd229d539$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($4d82739dd229d539$var$p(166));
                c = $4d82739dd229d539$var$xh($4d82739dd229d539$var$wh.current);
                $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
                if ($4d82739dd229d539$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$4d82739dd229d539$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $4d82739dd229d539$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $4d82739dd229d539$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$4d82739dd229d539$var$Of] = b, b.stateNode = d;
            }
            $4d82739dd229d539$var$S(b);
            return null;
        case 13:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($4d82739dd229d539$var$I && null !== $4d82739dd229d539$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $4d82739dd229d539$var$Hg(), $4d82739dd229d539$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $4d82739dd229d539$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($4d82739dd229d539$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($4d82739dd229d539$var$p(317));
                        f[$4d82739dd229d539$var$Of] = b;
                    } else $4d82739dd229d539$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $4d82739dd229d539$var$S(b);
                    f = !1;
                } else null !== $4d82739dd229d539$var$zg && ($4d82739dd229d539$var$Fj($4d82739dd229d539$var$zg), $4d82739dd229d539$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($4d82739dd229d539$var$L.current & 1) ? 0 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 3) : $4d82739dd229d539$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $4d82739dd229d539$var$S(b);
            return null;
        case 4:
            return $4d82739dd229d539$var$zh(), $4d82739dd229d539$var$Aj(a, b), null === a && $4d82739dd229d539$var$sf(b.stateNode.containerInfo), $4d82739dd229d539$var$S(b), null;
        case 10:
            return $4d82739dd229d539$var$ah(b.type._context), $4d82739dd229d539$var$S(b), null;
        case 17:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), $4d82739dd229d539$var$S(b), null;
        case 19:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
            f = b.memoizedState;
            if (null === f) return $4d82739dd229d539$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $4d82739dd229d539$var$Dj(f, !1);
                else {
                    if (0 !== $4d82739dd229d539$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $4d82739dd229d539$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $4d82739dd229d539$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $4d82739dd229d539$var$B() > $4d82739dd229d539$var$Gj && (b.flags |= 128, d = !0, $4d82739dd229d539$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $4d82739dd229d539$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $4d82739dd229d539$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$4d82739dd229d539$var$I) return $4d82739dd229d539$var$S(b), null;
                    } else 2 * $4d82739dd229d539$var$B() - f.renderingStartTime > $4d82739dd229d539$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $4d82739dd229d539$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $4d82739dd229d539$var$B(), b.sibling = null, c = $4d82739dd229d539$var$L.current, $4d82739dd229d539$var$G($4d82739dd229d539$var$L, d ? c & 1 | 2 : c & 1), b;
            $4d82739dd229d539$var$S(b);
            return null;
        case 22:
        case 23:
            return $4d82739dd229d539$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($4d82739dd229d539$var$fj & 1073741824) && ($4d82739dd229d539$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $4d82739dd229d539$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($4d82739dd229d539$var$p(156, b.tag));
}
function $4d82739dd229d539$var$Ij(a, b) {
    $4d82739dd229d539$var$wg(b);
    switch(b.tag){
        case 1:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $4d82739dd229d539$var$zh(), $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf), $4d82739dd229d539$var$E($4d82739dd229d539$var$H), $4d82739dd229d539$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $4d82739dd229d539$var$Bh(b), null;
        case 13:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($4d82739dd229d539$var$p(340));
                $4d82739dd229d539$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $4d82739dd229d539$var$E($4d82739dd229d539$var$L), null;
        case 4:
            return $4d82739dd229d539$var$zh(), null;
        case 10:
            return $4d82739dd229d539$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $4d82739dd229d539$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$Jj = !1, $4d82739dd229d539$var$U = !1, $4d82739dd229d539$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $4d82739dd229d539$var$V = null;
function $4d82739dd229d539$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $4d82739dd229d539$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $4d82739dd229d539$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $4d82739dd229d539$var$W(a, b, d);
    }
}
var $4d82739dd229d539$var$Nj = !1;
function $4d82739dd229d539$var$Oj(a, b) {
    $4d82739dd229d539$var$Cf = $4d82739dd229d539$var$dd;
    a = $4d82739dd229d539$var$Me();
    if ($4d82739dd229d539$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $4d82739dd229d539$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $4d82739dd229d539$var$dd = !1;
    for($4d82739dd229d539$var$V = b; null !== $4d82739dd229d539$var$V;)if (b = $4d82739dd229d539$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $4d82739dd229d539$var$V = a;
    else for(; null !== $4d82739dd229d539$var$V;){
        b = $4d82739dd229d539$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $4d82739dd229d539$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(163));
            }
        } catch (F) {
            $4d82739dd229d539$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $4d82739dd229d539$var$V = a;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
    n = $4d82739dd229d539$var$Nj;
    $4d82739dd229d539$var$Nj = !1;
    return n;
}
function $4d82739dd229d539$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $4d82739dd229d539$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $4d82739dd229d539$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $4d82739dd229d539$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $4d82739dd229d539$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $4d82739dd229d539$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$4d82739dd229d539$var$Of], delete b[$4d82739dd229d539$var$Pf], delete b[$4d82739dd229d539$var$of], delete b[$4d82739dd229d539$var$Qf], delete b[$4d82739dd229d539$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $4d82739dd229d539$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $4d82739dd229d539$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $4d82739dd229d539$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $4d82739dd229d539$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $4d82739dd229d539$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($4d82739dd229d539$var$Vj(a, b, c), a = a.sibling; null !== a;)$4d82739dd229d539$var$Vj(a, b, c), a = a.sibling;
}
function $4d82739dd229d539$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($4d82739dd229d539$var$Wj(a, b, c), a = a.sibling; null !== a;)$4d82739dd229d539$var$Wj(a, b, c), a = a.sibling;
}
var $4d82739dd229d539$var$X = null, $4d82739dd229d539$var$Xj = !1;
function $4d82739dd229d539$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$4d82739dd229d539$var$Zj(a, b, c), c = c.sibling;
}
function $4d82739dd229d539$var$Zj(a, b, c) {
    if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onCommitFiberUnmount) try {
        $4d82739dd229d539$var$lc.onCommitFiberUnmount($4d82739dd229d539$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $4d82739dd229d539$var$U || $4d82739dd229d539$var$Lj(c, b);
        case 6:
            var d = $4d82739dd229d539$var$X, e = $4d82739dd229d539$var$Xj;
            $4d82739dd229d539$var$X = null;
            $4d82739dd229d539$var$Yj(a, b, c);
            $4d82739dd229d539$var$X = d;
            $4d82739dd229d539$var$Xj = e;
            null !== $4d82739dd229d539$var$X && ($4d82739dd229d539$var$Xj ? (a = $4d82739dd229d539$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $4d82739dd229d539$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $4d82739dd229d539$var$X && ($4d82739dd229d539$var$Xj ? (a = $4d82739dd229d539$var$X, c = c.stateNode, 8 === a.nodeType ? $4d82739dd229d539$var$Kf(a.parentNode, c) : 1 === a.nodeType && $4d82739dd229d539$var$Kf(a, c), $4d82739dd229d539$var$bd(a)) : $4d82739dd229d539$var$Kf($4d82739dd229d539$var$X, c.stateNode));
            break;
        case 4:
            d = $4d82739dd229d539$var$X;
            e = $4d82739dd229d539$var$Xj;
            $4d82739dd229d539$var$X = c.stateNode.containerInfo;
            $4d82739dd229d539$var$Xj = !0;
            $4d82739dd229d539$var$Yj(a, b, c);
            $4d82739dd229d539$var$X = d;
            $4d82739dd229d539$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$4d82739dd229d539$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $4d82739dd229d539$var$Mj(c, b, g) : 0 !== (f & 4) && $4d82739dd229d539$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $4d82739dd229d539$var$Yj(a, b, c);
            break;
        case 1:
            if (!$4d82739dd229d539$var$U && ($4d82739dd229d539$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $4d82739dd229d539$var$W(c, b, h);
            }
            $4d82739dd229d539$var$Yj(a, b, c);
            break;
        case 21:
            $4d82739dd229d539$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($4d82739dd229d539$var$U = (d = $4d82739dd229d539$var$U) || null !== c.memoizedState, $4d82739dd229d539$var$Yj(a, b, c), $4d82739dd229d539$var$U = d) : $4d82739dd229d539$var$Yj(a, b, c);
            break;
        default:
            $4d82739dd229d539$var$Yj(a, b, c);
    }
}
function $4d82739dd229d539$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $4d82739dd229d539$var$Kj);
        b.forEach(function(b) {
            var d = $4d82739dd229d539$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $4d82739dd229d539$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $4d82739dd229d539$var$X = h.stateNode;
                        $4d82739dd229d539$var$Xj = !1;
                        break a;
                    case 3:
                        $4d82739dd229d539$var$X = h.stateNode.containerInfo;
                        $4d82739dd229d539$var$Xj = !0;
                        break a;
                    case 4:
                        $4d82739dd229d539$var$X = h.stateNode.containerInfo;
                        $4d82739dd229d539$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $4d82739dd229d539$var$X) throw Error($4d82739dd229d539$var$p(160));
            $4d82739dd229d539$var$Zj(f, g, e);
            $4d82739dd229d539$var$X = null;
            $4d82739dd229d539$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $4d82739dd229d539$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$4d82739dd229d539$var$dk(b, a), b = b.sibling;
}
function $4d82739dd229d539$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 4) {
                try {
                    $4d82739dd229d539$var$Pj(3, a, a.return), $4d82739dd229d539$var$Qj(3, a);
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
                try {
                    $4d82739dd229d539$var$Pj(5, a, a.return);
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            d & 512 && null !== c && $4d82739dd229d539$var$Lj(c, c.return);
            break;
        case 5:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            d & 512 && null !== c && $4d82739dd229d539$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $4d82739dd229d539$var$ob(e, "");
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $4d82739dd229d539$var$ab(e, f);
                    $4d82739dd229d539$var$vb(h, g);
                    var l = $4d82739dd229d539$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $4d82739dd229d539$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $4d82739dd229d539$var$nb(e, q) : "children" === m ? $4d82739dd229d539$var$ob(e, q) : $4d82739dd229d539$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $4d82739dd229d539$var$bb(e, f);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $4d82739dd229d539$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $4d82739dd229d539$var$fb(e, !!f.multiple, f.defaultValue, !0) : $4d82739dd229d539$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$4d82739dd229d539$var$Pf] = f;
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($4d82739dd229d539$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $4d82739dd229d539$var$bd(b.containerInfo);
            } catch (t) {
                $4d82739dd229d539$var$W(a, a.return, t);
            }
            break;
        case 4:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            break;
        case 13:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($4d82739dd229d539$var$fk = $4d82739dd229d539$var$B()));
            d & 4 && $4d82739dd229d539$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($4d82739dd229d539$var$U = (l = $4d82739dd229d539$var$U) || m, $4d82739dd229d539$var$ck(b, a), $4d82739dd229d539$var$U = l) : $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($4d82739dd229d539$var$V = a, m = a.child; null !== m;){
                    for(q = $4d82739dd229d539$var$V = m; null !== $4d82739dd229d539$var$V;){
                        r = $4d82739dd229d539$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $4d82739dd229d539$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $4d82739dd229d539$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $4d82739dd229d539$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $4d82739dd229d539$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $4d82739dd229d539$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $4d82739dd229d539$var$V = y) : $4d82739dd229d539$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $4d82739dd229d539$var$rb("display", g));
                            } catch (t) {
                                $4d82739dd229d539$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $4d82739dd229d539$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            d & 4 && $4d82739dd229d539$var$ak(a);
            break;
        case 21:
            break;
        default:
            $4d82739dd229d539$var$ck(b, a), $4d82739dd229d539$var$ek(a);
    }
}
function $4d82739dd229d539$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($4d82739dd229d539$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($4d82739dd229d539$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($4d82739dd229d539$var$ob(e, ""), d.flags &= -33);
                    var f = $4d82739dd229d539$var$Uj(a);
                    $4d82739dd229d539$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $4d82739dd229d539$var$Uj(a);
                    $4d82739dd229d539$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(161));
            }
        } catch (k) {
            $4d82739dd229d539$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $4d82739dd229d539$var$hk(a, b, c) {
    $4d82739dd229d539$var$V = a;
    $4d82739dd229d539$var$ik(a, b, c);
}
function $4d82739dd229d539$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $4d82739dd229d539$var$V;){
        var e = $4d82739dd229d539$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $4d82739dd229d539$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $4d82739dd229d539$var$U;
                h = $4d82739dd229d539$var$Jj;
                var l = $4d82739dd229d539$var$U;
                $4d82739dd229d539$var$Jj = g;
                if (($4d82739dd229d539$var$U = k) && !l) for($4d82739dd229d539$var$V = e; null !== $4d82739dd229d539$var$V;)g = $4d82739dd229d539$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $4d82739dd229d539$var$jk(e) : null !== k ? (k.return = g, $4d82739dd229d539$var$V = k) : $4d82739dd229d539$var$jk(e);
                for(; null !== f;)$4d82739dd229d539$var$V = f, $4d82739dd229d539$var$ik(f, b, c), f = f.sibling;
                $4d82739dd229d539$var$V = e;
                $4d82739dd229d539$var$Jj = h;
                $4d82739dd229d539$var$U = l;
            }
            $4d82739dd229d539$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $4d82739dd229d539$var$V = f) : $4d82739dd229d539$var$kk(a, b, c);
    }
}
function $4d82739dd229d539$var$kk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $4d82739dd229d539$var$U || $4d82739dd229d539$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$4d82739dd229d539$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $4d82739dd229d539$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $4d82739dd229d539$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $4d82739dd229d539$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $4d82739dd229d539$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($4d82739dd229d539$var$p(163));
                }
                $4d82739dd229d539$var$U || b.flags & 512 && $4d82739dd229d539$var$Rj(b);
            } catch (r) {
                $4d82739dd229d539$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4d82739dd229d539$var$V = c;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
function $4d82739dd229d539$var$gk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4d82739dd229d539$var$V = c;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
function $4d82739dd229d539$var$jk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $4d82739dd229d539$var$Qj(4, b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $4d82739dd229d539$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $4d82739dd229d539$var$Rj(b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $4d82739dd229d539$var$Rj(b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $4d82739dd229d539$var$W(b, b.return, k);
        }
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $4d82739dd229d539$var$V = h;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
var $4d82739dd229d539$var$lk = Math.ceil, $4d82739dd229d539$var$mk = $4d82739dd229d539$var$ua.ReactCurrentDispatcher, $4d82739dd229d539$var$nk = $4d82739dd229d539$var$ua.ReactCurrentOwner, $4d82739dd229d539$var$ok = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$K = 0, $4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$Y = null, $4d82739dd229d539$var$Z = 0, $4d82739dd229d539$var$fj = 0, $4d82739dd229d539$var$ej = $4d82739dd229d539$var$Uf(0), $4d82739dd229d539$var$T = 0, $4d82739dd229d539$var$pk = null, $4d82739dd229d539$var$rh = 0, $4d82739dd229d539$var$qk = 0, $4d82739dd229d539$var$rk = 0, $4d82739dd229d539$var$sk = null, $4d82739dd229d539$var$tk = null, $4d82739dd229d539$var$fk = 0, $4d82739dd229d539$var$Gj = Infinity, $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$Oi = !1, $4d82739dd229d539$var$Pi = null, $4d82739dd229d539$var$Ri = null, $4d82739dd229d539$var$vk = !1, $4d82739dd229d539$var$wk = null, $4d82739dd229d539$var$xk = 0, $4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = null, $4d82739dd229d539$var$Ak = -1, $4d82739dd229d539$var$Bk = 0;
function $4d82739dd229d539$var$R() {
    return 0 !== ($4d82739dd229d539$var$K & 6) ? $4d82739dd229d539$var$B() : -1 !== $4d82739dd229d539$var$Ak ? $4d82739dd229d539$var$Ak : $4d82739dd229d539$var$Ak = $4d82739dd229d539$var$B();
}
function $4d82739dd229d539$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($4d82739dd229d539$var$K & 2) && 0 !== $4d82739dd229d539$var$Z) return $4d82739dd229d539$var$Z & -$4d82739dd229d539$var$Z;
    if (null !== $4d82739dd229d539$var$Kg.transition) return 0 === $4d82739dd229d539$var$Bk && ($4d82739dd229d539$var$Bk = $4d82739dd229d539$var$yc()), $4d82739dd229d539$var$Bk;
    a = $4d82739dd229d539$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $4d82739dd229d539$var$jd(a.type);
    return a;
}
function $4d82739dd229d539$var$gi(a, b, c, d) {
    if (50 < $4d82739dd229d539$var$yk) throw $4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = null, Error($4d82739dd229d539$var$p(185));
    $4d82739dd229d539$var$Ac(a, c, d);
    if (0 === ($4d82739dd229d539$var$K & 2) || a !== $4d82739dd229d539$var$Q) a === $4d82739dd229d539$var$Q && (0 === ($4d82739dd229d539$var$K & 2) && ($4d82739dd229d539$var$qk |= c), 4 === $4d82739dd229d539$var$T && $4d82739dd229d539$var$Ck(a, $4d82739dd229d539$var$Z)), $4d82739dd229d539$var$Dk(a, d), 1 === c && 0 === $4d82739dd229d539$var$K && 0 === (b.mode & 1) && ($4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$fg && $4d82739dd229d539$var$jg());
}
function $4d82739dd229d539$var$Dk(a, b) {
    var c = a.callbackNode;
    $4d82739dd229d539$var$wc(a, b);
    var d = $4d82739dd229d539$var$uc(a, a === $4d82739dd229d539$var$Q ? $4d82739dd229d539$var$Z : 0);
    if (0 === d) null !== c && $4d82739dd229d539$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $4d82739dd229d539$var$bc(c);
        if (1 === b) 0 === a.tag ? $4d82739dd229d539$var$ig($4d82739dd229d539$var$Ek.bind(null, a)) : $4d82739dd229d539$var$hg($4d82739dd229d539$var$Ek.bind(null, a)), $4d82739dd229d539$var$Jf(function() {
            0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$jg();
        }), c = null;
        else {
            switch($4d82739dd229d539$var$Dc(d)){
                case 1:
                    c = $4d82739dd229d539$var$fc;
                    break;
                case 4:
                    c = $4d82739dd229d539$var$gc;
                    break;
                case 16:
                    c = $4d82739dd229d539$var$hc;
                    break;
                case 536870912:
                    c = $4d82739dd229d539$var$jc;
                    break;
                default:
                    c = $4d82739dd229d539$var$hc;
            }
            c = $4d82739dd229d539$var$Fk(c, $4d82739dd229d539$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $4d82739dd229d539$var$Gk(a, b) {
    $4d82739dd229d539$var$Ak = -1;
    $4d82739dd229d539$var$Bk = 0;
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    var c = a.callbackNode;
    if ($4d82739dd229d539$var$Hk() && a.callbackNode !== c) return null;
    var d = $4d82739dd229d539$var$uc(a, a === $4d82739dd229d539$var$Q ? $4d82739dd229d539$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $4d82739dd229d539$var$Ik(a, d);
    else {
        b = d;
        var e = $4d82739dd229d539$var$K;
        $4d82739dd229d539$var$K |= 2;
        var f = $4d82739dd229d539$var$Jk();
        if ($4d82739dd229d539$var$Q !== a || $4d82739dd229d539$var$Z !== b) $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$Kk(a, b);
        for(;;)try {
            $4d82739dd229d539$var$Lk();
            break;
        } catch (h) {
            $4d82739dd229d539$var$Mk(a, h);
        }
        $4d82739dd229d539$var$$g();
        $4d82739dd229d539$var$mk.current = f;
        $4d82739dd229d539$var$K = e;
        null !== $4d82739dd229d539$var$Y ? b = 0 : ($4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$Z = 0, b = $4d82739dd229d539$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $4d82739dd229d539$var$xc(a), 0 !== e && (d = e, b = $4d82739dd229d539$var$Nk(a, e)));
        if (1 === b) throw c = $4d82739dd229d539$var$pk, $4d82739dd229d539$var$Kk(a, 0), $4d82739dd229d539$var$Ck(a, d), $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), c;
        if (6 === b) $4d82739dd229d539$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$4d82739dd229d539$var$Ok(e) && (b = $4d82739dd229d539$var$Ik(a, d), 2 === b && (f = $4d82739dd229d539$var$xc(a), 0 !== f && (d = f, b = $4d82739dd229d539$var$Nk(a, f))), 1 === b)) throw c = $4d82739dd229d539$var$pk, $4d82739dd229d539$var$Kk(a, 0), $4d82739dd229d539$var$Ck(a, d), $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($4d82739dd229d539$var$p(345));
                case 2:
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                case 3:
                    $4d82739dd229d539$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $4d82739dd229d539$var$fk + 500 - $4d82739dd229d539$var$B(), 10 < b)) {
                        if (0 !== $4d82739dd229d539$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $4d82739dd229d539$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $4d82739dd229d539$var$Ff($4d82739dd229d539$var$Pk.bind(null, a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk), b);
                        break;
                    }
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                case 4:
                    $4d82739dd229d539$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $4d82739dd229d539$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $4d82739dd229d539$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $4d82739dd229d539$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $4d82739dd229d539$var$Ff($4d82739dd229d539$var$Pk.bind(null, a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk), d);
                        break;
                    }
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                case 5:
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(329));
            }
        }
    }
    $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B());
    return a.callbackNode === c ? $4d82739dd229d539$var$Gk.bind(null, a) : null;
}
function $4d82739dd229d539$var$Nk(a, b) {
    var c = $4d82739dd229d539$var$sk;
    a.current.memoizedState.isDehydrated && ($4d82739dd229d539$var$Kk(a, b).flags |= 256);
    a = $4d82739dd229d539$var$Ik(a, b);
    2 !== a && (b = $4d82739dd229d539$var$tk, $4d82739dd229d539$var$tk = c, null !== b && $4d82739dd229d539$var$Fj(b));
    return a;
}
function $4d82739dd229d539$var$Fj(a) {
    null === $4d82739dd229d539$var$tk ? $4d82739dd229d539$var$tk = a : $4d82739dd229d539$var$tk.push.apply($4d82739dd229d539$var$tk, a);
}
function $4d82739dd229d539$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$4d82739dd229d539$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $4d82739dd229d539$var$Ck(a, b) {
    b &= ~$4d82739dd229d539$var$rk;
    b &= ~$4d82739dd229d539$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $4d82739dd229d539$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $4d82739dd229d539$var$Ek(a) {
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    $4d82739dd229d539$var$Hk();
    var b = $4d82739dd229d539$var$uc(a, 0);
    if (0 === (b & 1)) return $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), null;
    var c = $4d82739dd229d539$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $4d82739dd229d539$var$xc(a);
        0 !== d && (b = d, c = $4d82739dd229d539$var$Nk(a, d));
    }
    if (1 === c) throw c = $4d82739dd229d539$var$pk, $4d82739dd229d539$var$Kk(a, 0), $4d82739dd229d539$var$Ck(a, b), $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), c;
    if (6 === c) throw Error($4d82739dd229d539$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
    $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B());
    return null;
}
function $4d82739dd229d539$var$Qk(a, b) {
    var c = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 1;
    try {
        return a(b);
    } finally{
        $4d82739dd229d539$var$K = c, 0 === $4d82739dd229d539$var$K && ($4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$fg && $4d82739dd229d539$var$jg());
    }
}
function $4d82739dd229d539$var$Rk(a) {
    null !== $4d82739dd229d539$var$wk && 0 === $4d82739dd229d539$var$wk.tag && 0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$Hk();
    var b = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 1;
    var c = $4d82739dd229d539$var$ok.transition, d = $4d82739dd229d539$var$C;
    try {
        if ($4d82739dd229d539$var$ok.transition = null, $4d82739dd229d539$var$C = 1, a) return a();
    } finally{
        $4d82739dd229d539$var$C = d, $4d82739dd229d539$var$ok.transition = c, $4d82739dd229d539$var$K = b, 0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$jg();
    }
}
function $4d82739dd229d539$var$Hj() {
    $4d82739dd229d539$var$fj = $4d82739dd229d539$var$ej.current;
    $4d82739dd229d539$var$E($4d82739dd229d539$var$ej);
}
function $4d82739dd229d539$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $4d82739dd229d539$var$Gf(c));
    if (null !== $4d82739dd229d539$var$Y) for(c = $4d82739dd229d539$var$Y.return; null !== c;){
        var d = c;
        $4d82739dd229d539$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $4d82739dd229d539$var$$f();
                break;
            case 3:
                $4d82739dd229d539$var$zh();
                $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
                $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
                $4d82739dd229d539$var$Eh();
                break;
            case 5:
                $4d82739dd229d539$var$Bh(d);
                break;
            case 4:
                $4d82739dd229d539$var$zh();
                break;
            case 13:
                $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
                break;
            case 19:
                $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
                break;
            case 10:
                $4d82739dd229d539$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $4d82739dd229d539$var$Hj();
        }
        c = c.return;
    }
    $4d82739dd229d539$var$Q = a;
    $4d82739dd229d539$var$Y = a = $4d82739dd229d539$var$Pg(a.current, null);
    $4d82739dd229d539$var$Z = $4d82739dd229d539$var$fj = b;
    $4d82739dd229d539$var$T = 0;
    $4d82739dd229d539$var$pk = null;
    $4d82739dd229d539$var$rk = $4d82739dd229d539$var$qk = $4d82739dd229d539$var$rh = 0;
    $4d82739dd229d539$var$tk = $4d82739dd229d539$var$sk = null;
    if (null !== $4d82739dd229d539$var$fh) {
        for(b = 0; b < $4d82739dd229d539$var$fh.length; b++)if (c = $4d82739dd229d539$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $4d82739dd229d539$var$fh = null;
    }
    return a;
}
function $4d82739dd229d539$var$Mk(a, b) {
    do {
        var c = $4d82739dd229d539$var$Y;
        try {
            $4d82739dd229d539$var$$g();
            $4d82739dd229d539$var$Fh.current = $4d82739dd229d539$var$Rh;
            if ($4d82739dd229d539$var$Ih) {
                for(var d = $4d82739dd229d539$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $4d82739dd229d539$var$Ih = !1;
            }
            $4d82739dd229d539$var$Hh = 0;
            $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = $4d82739dd229d539$var$M = null;
            $4d82739dd229d539$var$Jh = !1;
            $4d82739dd229d539$var$Kh = 0;
            $4d82739dd229d539$var$nk.current = null;
            if (null === c || null === c.return) {
                $4d82739dd229d539$var$T = 1;
                $4d82739dd229d539$var$pk = b;
                $4d82739dd229d539$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $4d82739dd229d539$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $4d82739dd229d539$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $4d82739dd229d539$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $4d82739dd229d539$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $4d82739dd229d539$var$Si(f, l, b);
                            $4d82739dd229d539$var$tj();
                            break a;
                        }
                        k = Error($4d82739dd229d539$var$p(426));
                    }
                } else if ($4d82739dd229d539$var$I && h.mode & 1) {
                    var J = $4d82739dd229d539$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $4d82739dd229d539$var$Vi(J, g, h, f, b);
                        $4d82739dd229d539$var$Jg($4d82739dd229d539$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $4d82739dd229d539$var$Ji(k, h);
                4 !== $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 2);
                null === $4d82739dd229d539$var$sk ? $4d82739dd229d539$var$sk = [
                    f
                ] : $4d82739dd229d539$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $4d82739dd229d539$var$Ni(f, k, b);
                            $4d82739dd229d539$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $4d82739dd229d539$var$Ri || !$4d82739dd229d539$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $4d82739dd229d539$var$Qi(f, h, b);
                                $4d82739dd229d539$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $4d82739dd229d539$var$Sk(c);
        } catch (na) {
            b = na;
            $4d82739dd229d539$var$Y === c && null !== c && ($4d82739dd229d539$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $4d82739dd229d539$var$Jk() {
    var a = $4d82739dd229d539$var$mk.current;
    $4d82739dd229d539$var$mk.current = $4d82739dd229d539$var$Rh;
    return null === a ? $4d82739dd229d539$var$Rh : a;
}
function $4d82739dd229d539$var$tj() {
    if (0 === $4d82739dd229d539$var$T || 3 === $4d82739dd229d539$var$T || 2 === $4d82739dd229d539$var$T) $4d82739dd229d539$var$T = 4;
    null === $4d82739dd229d539$var$Q || 0 === ($4d82739dd229d539$var$rh & 268435455) && 0 === ($4d82739dd229d539$var$qk & 268435455) || $4d82739dd229d539$var$Ck($4d82739dd229d539$var$Q, $4d82739dd229d539$var$Z);
}
function $4d82739dd229d539$var$Ik(a, b) {
    var c = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 2;
    var d = $4d82739dd229d539$var$Jk();
    if ($4d82739dd229d539$var$Q !== a || $4d82739dd229d539$var$Z !== b) $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$Kk(a, b);
    for(;;)try {
        $4d82739dd229d539$var$Tk();
        break;
    } catch (e) {
        $4d82739dd229d539$var$Mk(a, e);
    }
    $4d82739dd229d539$var$$g();
    $4d82739dd229d539$var$K = c;
    $4d82739dd229d539$var$mk.current = d;
    if (null !== $4d82739dd229d539$var$Y) throw Error($4d82739dd229d539$var$p(261));
    $4d82739dd229d539$var$Q = null;
    $4d82739dd229d539$var$Z = 0;
    return $4d82739dd229d539$var$T;
}
function $4d82739dd229d539$var$Tk() {
    for(; null !== $4d82739dd229d539$var$Y;)$4d82739dd229d539$var$Uk($4d82739dd229d539$var$Y);
}
function $4d82739dd229d539$var$Lk() {
    for(; null !== $4d82739dd229d539$var$Y && !$4d82739dd229d539$var$cc();)$4d82739dd229d539$var$Uk($4d82739dd229d539$var$Y);
}
function $4d82739dd229d539$var$Uk(a) {
    var b = $4d82739dd229d539$var$Vk(a.alternate, a, $4d82739dd229d539$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $4d82739dd229d539$var$Sk(a) : $4d82739dd229d539$var$Y = b;
    $4d82739dd229d539$var$nk.current = null;
}
function $4d82739dd229d539$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $4d82739dd229d539$var$Ej(c, b, $4d82739dd229d539$var$fj), null !== c) {
                $4d82739dd229d539$var$Y = c;
                return;
            }
        } else {
            c = $4d82739dd229d539$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $4d82739dd229d539$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $4d82739dd229d539$var$T = 6;
                $4d82739dd229d539$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $4d82739dd229d539$var$Y = b;
            return;
        }
        $4d82739dd229d539$var$Y = b = a;
    }while (null !== b);
    0 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 5);
}
function $4d82739dd229d539$var$Pk(a, b, c) {
    var d = $4d82739dd229d539$var$C, e = $4d82739dd229d539$var$ok.transition;
    try {
        $4d82739dd229d539$var$ok.transition = null, $4d82739dd229d539$var$C = 1, $4d82739dd229d539$var$Wk(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$ok.transition = e, $4d82739dd229d539$var$C = d;
    }
    return null;
}
function $4d82739dd229d539$var$Wk(a, b, c, d) {
    do $4d82739dd229d539$var$Hk();
    while (null !== $4d82739dd229d539$var$wk);
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($4d82739dd229d539$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $4d82739dd229d539$var$Bc(a, f);
    a === $4d82739dd229d539$var$Q && ($4d82739dd229d539$var$Y = $4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $4d82739dd229d539$var$vk || ($4d82739dd229d539$var$vk = !0, $4d82739dd229d539$var$Fk($4d82739dd229d539$var$hc, function() {
        $4d82739dd229d539$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $4d82739dd229d539$var$ok.transition;
        $4d82739dd229d539$var$ok.transition = null;
        var g = $4d82739dd229d539$var$C;
        $4d82739dd229d539$var$C = 1;
        var h = $4d82739dd229d539$var$K;
        $4d82739dd229d539$var$K |= 4;
        $4d82739dd229d539$var$nk.current = null;
        $4d82739dd229d539$var$Oj(a, c);
        $4d82739dd229d539$var$dk(c, a);
        $4d82739dd229d539$var$Oe($4d82739dd229d539$var$Df);
        $4d82739dd229d539$var$dd = !!$4d82739dd229d539$var$Cf;
        $4d82739dd229d539$var$Df = $4d82739dd229d539$var$Cf = null;
        a.current = c;
        $4d82739dd229d539$var$hk(c, a, e);
        $4d82739dd229d539$var$dc();
        $4d82739dd229d539$var$K = h;
        $4d82739dd229d539$var$C = g;
        $4d82739dd229d539$var$ok.transition = f;
    } else a.current = c;
    $4d82739dd229d539$var$vk && ($4d82739dd229d539$var$vk = !1, $4d82739dd229d539$var$wk = a, $4d82739dd229d539$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($4d82739dd229d539$var$Ri = null);
    $4d82739dd229d539$var$mc(c.stateNode, d);
    $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($4d82739dd229d539$var$Oi) throw $4d82739dd229d539$var$Oi = !1, a = $4d82739dd229d539$var$Pi, $4d82739dd229d539$var$Pi = null, a;
    0 !== ($4d82739dd229d539$var$xk & 1) && 0 !== a.tag && $4d82739dd229d539$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $4d82739dd229d539$var$zk ? $4d82739dd229d539$var$yk++ : ($4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = a) : $4d82739dd229d539$var$yk = 0;
    $4d82739dd229d539$var$jg();
    return null;
}
function $4d82739dd229d539$var$Hk() {
    if (null !== $4d82739dd229d539$var$wk) {
        var a = $4d82739dd229d539$var$Dc($4d82739dd229d539$var$xk), b = $4d82739dd229d539$var$ok.transition, c = $4d82739dd229d539$var$C;
        try {
            $4d82739dd229d539$var$ok.transition = null;
            $4d82739dd229d539$var$C = 16 > a ? 16 : a;
            if (null === $4d82739dd229d539$var$wk) var d = !1;
            else {
                a = $4d82739dd229d539$var$wk;
                $4d82739dd229d539$var$wk = null;
                $4d82739dd229d539$var$xk = 0;
                if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(331));
                var e = $4d82739dd229d539$var$K;
                $4d82739dd229d539$var$K |= 4;
                for($4d82739dd229d539$var$V = a.current; null !== $4d82739dd229d539$var$V;){
                    var f = $4d82739dd229d539$var$V, g = f.child;
                    if (0 !== ($4d82739dd229d539$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($4d82739dd229d539$var$V = l; null !== $4d82739dd229d539$var$V;){
                                    var m = $4d82739dd229d539$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $4d82739dd229d539$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $4d82739dd229d539$var$V = q;
                                    else for(; null !== $4d82739dd229d539$var$V;){
                                        m = $4d82739dd229d539$var$V;
                                        var r = m.sibling, y = m.return;
                                        $4d82739dd229d539$var$Sj(m);
                                        if (m === l) {
                                            $4d82739dd229d539$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $4d82739dd229d539$var$V = r;
                                            break;
                                        }
                                        $4d82739dd229d539$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $4d82739dd229d539$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $4d82739dd229d539$var$V = g;
                    else b: for(; null !== $4d82739dd229d539$var$V;){
                        f = $4d82739dd229d539$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $4d82739dd229d539$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $4d82739dd229d539$var$V = x;
                            break b;
                        }
                        $4d82739dd229d539$var$V = f.return;
                    }
                }
                var w = a.current;
                for($4d82739dd229d539$var$V = w; null !== $4d82739dd229d539$var$V;){
                    g = $4d82739dd229d539$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $4d82739dd229d539$var$V = u;
                    else b: for(g = w; null !== $4d82739dd229d539$var$V;){
                        h = $4d82739dd229d539$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $4d82739dd229d539$var$Qj(9, h);
                            }
                        } catch (na) {
                            $4d82739dd229d539$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $4d82739dd229d539$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $4d82739dd229d539$var$V = F;
                            break b;
                        }
                        $4d82739dd229d539$var$V = h.return;
                    }
                }
                $4d82739dd229d539$var$K = e;
                $4d82739dd229d539$var$jg();
                if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onPostCommitFiberRoot) try {
                    $4d82739dd229d539$var$lc.onPostCommitFiberRoot($4d82739dd229d539$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $4d82739dd229d539$var$C = c, $4d82739dd229d539$var$ok.transition = b;
        }
    }
    return !1;
}
function $4d82739dd229d539$var$Xk(a, b, c) {
    b = $4d82739dd229d539$var$Ji(c, b);
    b = $4d82739dd229d539$var$Ni(a, b, 1);
    a = $4d82739dd229d539$var$nh(a, b, 1);
    b = $4d82739dd229d539$var$R();
    null !== a && ($4d82739dd229d539$var$Ac(a, 1, b), $4d82739dd229d539$var$Dk(a, b));
}
function $4d82739dd229d539$var$W(a, b, c) {
    if (3 === a.tag) $4d82739dd229d539$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $4d82739dd229d539$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $4d82739dd229d539$var$Ri || !$4d82739dd229d539$var$Ri.has(d))) {
                a = $4d82739dd229d539$var$Ji(c, a);
                a = $4d82739dd229d539$var$Qi(b, a, 1);
                b = $4d82739dd229d539$var$nh(b, a, 1);
                a = $4d82739dd229d539$var$R();
                null !== b && ($4d82739dd229d539$var$Ac(b, 1, a), $4d82739dd229d539$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $4d82739dd229d539$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $4d82739dd229d539$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $4d82739dd229d539$var$Q === a && ($4d82739dd229d539$var$Z & c) === c && (4 === $4d82739dd229d539$var$T || 3 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$Z & 130023424) === $4d82739dd229d539$var$Z && 500 > $4d82739dd229d539$var$B() - $4d82739dd229d539$var$fk ? $4d82739dd229d539$var$Kk(a, 0) : $4d82739dd229d539$var$rk |= c);
    $4d82739dd229d539$var$Dk(a, b);
}
function $4d82739dd229d539$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $4d82739dd229d539$var$sc, $4d82739dd229d539$var$sc <<= 1, 0 === ($4d82739dd229d539$var$sc & 130023424) && ($4d82739dd229d539$var$sc = 4194304)));
    var c = $4d82739dd229d539$var$R();
    a = $4d82739dd229d539$var$ih(a, b);
    null !== a && ($4d82739dd229d539$var$Ac(a, b, c), $4d82739dd229d539$var$Dk(a, c));
}
function $4d82739dd229d539$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $4d82739dd229d539$var$Yk(a, c);
}
function $4d82739dd229d539$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($4d82739dd229d539$var$p(314));
    }
    null !== d && d.delete(b);
    $4d82739dd229d539$var$Yk(a, c);
}
var $4d82739dd229d539$var$Vk;
$4d82739dd229d539$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $4d82739dd229d539$var$Wf.current) $4d82739dd229d539$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $4d82739dd229d539$var$dh = !1, $4d82739dd229d539$var$yj(a, b, c);
            $4d82739dd229d539$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $4d82739dd229d539$var$dh = !1, $4d82739dd229d539$var$I && 0 !== (b.flags & 1048576) && $4d82739dd229d539$var$ug(b, $4d82739dd229d539$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $4d82739dd229d539$var$ij(a, b);
            a = b.pendingProps;
            var e = $4d82739dd229d539$var$Yf(b, $4d82739dd229d539$var$H.current);
            $4d82739dd229d539$var$ch(b, c);
            e = $4d82739dd229d539$var$Nh(null, b, d, a, e, c);
            var f = $4d82739dd229d539$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $4d82739dd229d539$var$Zf(d) ? (f = !0, $4d82739dd229d539$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $4d82739dd229d539$var$kh(b), e.updater = $4d82739dd229d539$var$Ei, b.stateNode = e, e._reactInternals = b, $4d82739dd229d539$var$Ii(b, d, a, c), b = $4d82739dd229d539$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $4d82739dd229d539$var$I && f && $4d82739dd229d539$var$vg(b), $4d82739dd229d539$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $4d82739dd229d539$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $4d82739dd229d539$var$Zk(d);
                a = $4d82739dd229d539$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $4d82739dd229d539$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $4d82739dd229d539$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $4d82739dd229d539$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $4d82739dd229d539$var$$i(null, b, d, $4d82739dd229d539$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($4d82739dd229d539$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $4d82739dd229d539$var$kj(b);
                if (null === a) throw Error($4d82739dd229d539$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $4d82739dd229d539$var$lh(a, b);
                $4d82739dd229d539$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $4d82739dd229d539$var$Ji(Error($4d82739dd229d539$var$p(423)), b);
                        b = $4d82739dd229d539$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $4d82739dd229d539$var$Ji(Error($4d82739dd229d539$var$p(424)), b);
                        b = $4d82739dd229d539$var$lj(a, b, d, c, e);
                        break a;
                    } else for($4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(b.stateNode.containerInfo.firstChild), $4d82739dd229d539$var$xg = b, $4d82739dd229d539$var$I = !0, $4d82739dd229d539$var$zg = null, c = $4d82739dd229d539$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $4d82739dd229d539$var$Ig();
                    if (d === e) {
                        b = $4d82739dd229d539$var$Zi(a, b, c);
                        break a;
                    }
                    $4d82739dd229d539$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $4d82739dd229d539$var$Ah(b), null === a && $4d82739dd229d539$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $4d82739dd229d539$var$Ef(d, e) ? g = null : null !== f && $4d82739dd229d539$var$Ef(d, f) && (b.flags |= 32), $4d82739dd229d539$var$gj(a, b), $4d82739dd229d539$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $4d82739dd229d539$var$Eg(b), null;
        case 13:
            return $4d82739dd229d539$var$oj(a, b, c);
        case 4:
            return $4d82739dd229d539$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $4d82739dd229d539$var$Ug(b, null, d, c) : $4d82739dd229d539$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$Yi(a, b, d, e, c);
        case 7:
            return $4d82739dd229d539$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $4d82739dd229d539$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $4d82739dd229d539$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $4d82739dd229d539$var$G($4d82739dd229d539$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($4d82739dd229d539$var$He(f.value, g)) {
                        if (f.children === e.children && !$4d82739dd229d539$var$Wf.current) {
                            b = $4d82739dd229d539$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $4d82739dd229d539$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $4d82739dd229d539$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($4d82739dd229d539$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $4d82739dd229d539$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $4d82739dd229d539$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $4d82739dd229d539$var$ch(b, c), e = $4d82739dd229d539$var$eh(e), d = d(e), b.flags |= 1, $4d82739dd229d539$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $4d82739dd229d539$var$Ci(d, b.pendingProps), e = $4d82739dd229d539$var$Ci(d.type, e), $4d82739dd229d539$var$$i(a, b, d, e, c);
        case 15:
            return $4d82739dd229d539$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$ij(a, b), b.tag = 1, $4d82739dd229d539$var$Zf(d) ? (a = !0, $4d82739dd229d539$var$cg(b)) : a = !1, $4d82739dd229d539$var$ch(b, c), $4d82739dd229d539$var$Gi(b, d, e), $4d82739dd229d539$var$Ii(b, d, e, c), $4d82739dd229d539$var$jj(null, b, d, !0, a, c);
        case 19:
            return $4d82739dd229d539$var$xj(a, b, c);
        case 22:
            return $4d82739dd229d539$var$dj(a, b, c);
    }
    throw Error($4d82739dd229d539$var$p(156, b.tag));
};
function $4d82739dd229d539$var$Fk(a, b) {
    return $4d82739dd229d539$var$ac(a, b);
}
function $4d82739dd229d539$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $4d82739dd229d539$var$Bg(a, b, c, d) {
    return new $4d82739dd229d539$var$$k(a, b, c, d);
}
function $4d82739dd229d539$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $4d82739dd229d539$var$Zk(a) {
    if ("function" === typeof a) return $4d82739dd229d539$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $4d82739dd229d539$var$Da) return 11;
        if (a === $4d82739dd229d539$var$Ga) return 14;
    }
    return 2;
}
function $4d82739dd229d539$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $4d82739dd229d539$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $4d82739dd229d539$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $4d82739dd229d539$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $4d82739dd229d539$var$ya:
            return $4d82739dd229d539$var$Tg(c.children, e, f, b);
        case $4d82739dd229d539$var$za:
            g = 8;
            e |= 8;
            break;
        case $4d82739dd229d539$var$Aa:
            return a = $4d82739dd229d539$var$Bg(12, c, b, e | 2), a.elementType = $4d82739dd229d539$var$Aa, a.lanes = f, a;
        case $4d82739dd229d539$var$Ea:
            return a = $4d82739dd229d539$var$Bg(13, c, b, e), a.elementType = $4d82739dd229d539$var$Ea, a.lanes = f, a;
        case $4d82739dd229d539$var$Fa:
            return a = $4d82739dd229d539$var$Bg(19, c, b, e), a.elementType = $4d82739dd229d539$var$Fa, a.lanes = f, a;
        case $4d82739dd229d539$var$Ia:
            return $4d82739dd229d539$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $4d82739dd229d539$var$Ba:
                    g = 10;
                    break a;
                case $4d82739dd229d539$var$Ca:
                    g = 9;
                    break a;
                case $4d82739dd229d539$var$Da:
                    g = 11;
                    break a;
                case $4d82739dd229d539$var$Ga:
                    g = 14;
                    break a;
                case $4d82739dd229d539$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($4d82739dd229d539$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $4d82739dd229d539$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $4d82739dd229d539$var$Tg(a, b, c, d) {
    a = $4d82739dd229d539$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $4d82739dd229d539$var$pj(a, b, c, d) {
    a = $4d82739dd229d539$var$Bg(22, a, d, b);
    a.elementType = $4d82739dd229d539$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $4d82739dd229d539$var$Qg(a, b, c) {
    a = $4d82739dd229d539$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $4d82739dd229d539$var$Sg(a, b, c) {
    b = $4d82739dd229d539$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $4d82739dd229d539$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $4d82739dd229d539$var$zc(0);
    this.expirationTimes = $4d82739dd229d539$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $4d82739dd229d539$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $4d82739dd229d539$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $4d82739dd229d539$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $4d82739dd229d539$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $4d82739dd229d539$var$kh(f);
    return a;
}
function $4d82739dd229d539$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4d82739dd229d539$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $4d82739dd229d539$var$dl(a) {
    if (!a) return $4d82739dd229d539$var$Vf;
    a = a._reactInternals;
    a: {
        if ($4d82739dd229d539$var$Vb(a) !== a || 1 !== a.tag) throw Error($4d82739dd229d539$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($4d82739dd229d539$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($4d82739dd229d539$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($4d82739dd229d539$var$Zf(c)) return $4d82739dd229d539$var$bg(a, c, b);
    }
    return b;
}
function $4d82739dd229d539$var$el(a, b, c, d, e, f, g, h, k) {
    a = $4d82739dd229d539$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $4d82739dd229d539$var$dl(null);
    c = a.current;
    d = $4d82739dd229d539$var$R();
    e = $4d82739dd229d539$var$yi(c);
    f = $4d82739dd229d539$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $4d82739dd229d539$var$nh(c, f, e);
    a.current.lanes = e;
    $4d82739dd229d539$var$Ac(a, e, d);
    $4d82739dd229d539$var$Dk(a, d);
    return a;
}
function $4d82739dd229d539$var$fl(a, b, c, d) {
    var e = b.current, f = $4d82739dd229d539$var$R(), g = $4d82739dd229d539$var$yi(e);
    c = $4d82739dd229d539$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $4d82739dd229d539$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $4d82739dd229d539$var$nh(e, b, g);
    null !== a && ($4d82739dd229d539$var$gi(a, e, g, f), $4d82739dd229d539$var$oh(a, e, g));
    return g;
}
function $4d82739dd229d539$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $4d82739dd229d539$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $4d82739dd229d539$var$il(a, b) {
    $4d82739dd229d539$var$hl(a, b);
    (a = a.alternate) && $4d82739dd229d539$var$hl(a, b);
}
function $4d82739dd229d539$var$jl() {
    return null;
}
var $4d82739dd229d539$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $4d82739dd229d539$var$ll(a) {
    this._internalRoot = a;
}
$4d82739dd229d539$var$ml.prototype.render = $4d82739dd229d539$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($4d82739dd229d539$var$p(409));
    $4d82739dd229d539$var$fl(a, b, null, null);
};
$4d82739dd229d539$var$ml.prototype.unmount = $4d82739dd229d539$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $4d82739dd229d539$var$Rk(function() {
            $4d82739dd229d539$var$fl(null, a, null, null);
        });
        b[$4d82739dd229d539$var$uf] = null;
    }
};
function $4d82739dd229d539$var$ml(a) {
    this._internalRoot = a;
}
$4d82739dd229d539$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $4d82739dd229d539$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $4d82739dd229d539$var$Qc.length && 0 !== b && b < $4d82739dd229d539$var$Qc[c].priority; c++);
        $4d82739dd229d539$var$Qc.splice(c, 0, a);
        0 === c && $4d82739dd229d539$var$Vc(a);
    }
};
function $4d82739dd229d539$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $4d82739dd229d539$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $4d82739dd229d539$var$pl() {}
function $4d82739dd229d539$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $4d82739dd229d539$var$gl(g);
                f.call(a);
            };
        }
        var g = $4d82739dd229d539$var$el(b, d, a, 0, null, !1, !1, "", $4d82739dd229d539$var$pl);
        a._reactRootContainer = g;
        a[$4d82739dd229d539$var$uf] = g.current;
        $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
        $4d82739dd229d539$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $4d82739dd229d539$var$gl(k);
            h.call(a);
        };
    }
    var k = $4d82739dd229d539$var$bl(a, 0, !1, null, null, !1, !1, "", $4d82739dd229d539$var$pl);
    a._reactRootContainer = k;
    a[$4d82739dd229d539$var$uf] = k.current;
    $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
    $4d82739dd229d539$var$Rk(function() {
        $4d82739dd229d539$var$fl(b, k, c, d);
    });
    return k;
}
function $4d82739dd229d539$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $4d82739dd229d539$var$gl(g);
                h.call(a);
            };
        }
        $4d82739dd229d539$var$fl(b, g, a, e);
    } else g = $4d82739dd229d539$var$ql(c, b, a, e, d);
    return $4d82739dd229d539$var$gl(g);
}
$4d82739dd229d539$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $4d82739dd229d539$var$tc(b.pendingLanes);
                0 !== c && ($4d82739dd229d539$var$Cc(b, c | 1), $4d82739dd229d539$var$Dk(b, $4d82739dd229d539$var$B()), 0 === ($4d82739dd229d539$var$K & 6) && ($4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$jg()));
            }
            break;
        case 13:
            $4d82739dd229d539$var$Rk(function() {
                var b = $4d82739dd229d539$var$ih(a, 1);
                if (null !== b) {
                    var c = $4d82739dd229d539$var$R();
                    $4d82739dd229d539$var$gi(b, a, 1, c);
                }
            }), $4d82739dd229d539$var$il(a, 1);
    }
};
$4d82739dd229d539$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $4d82739dd229d539$var$ih(a, 134217728);
        if (null !== b) {
            var c = $4d82739dd229d539$var$R();
            $4d82739dd229d539$var$gi(b, a, 134217728, c);
        }
        $4d82739dd229d539$var$il(a, 134217728);
    }
};
$4d82739dd229d539$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $4d82739dd229d539$var$yi(a), c = $4d82739dd229d539$var$ih(a, b);
        if (null !== c) {
            var d = $4d82739dd229d539$var$R();
            $4d82739dd229d539$var$gi(c, a, b, d);
        }
        $4d82739dd229d539$var$il(a, b);
    }
};
$4d82739dd229d539$var$Hc = function() {
    return $4d82739dd229d539$var$C;
};
$4d82739dd229d539$var$Ic = function(a, b) {
    var c = $4d82739dd229d539$var$C;
    try {
        return $4d82739dd229d539$var$C = a, b();
    } finally{
        $4d82739dd229d539$var$C = c;
    }
};
$4d82739dd229d539$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $4d82739dd229d539$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $4d82739dd229d539$var$Db(d);
                        if (!e) throw Error($4d82739dd229d539$var$p(90));
                        $4d82739dd229d539$var$Wa(d);
                        $4d82739dd229d539$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $4d82739dd229d539$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $4d82739dd229d539$var$fb(a, !!c.multiple, b, !1);
    }
};
$4d82739dd229d539$var$Gb = $4d82739dd229d539$var$Qk;
$4d82739dd229d539$var$Hb = $4d82739dd229d539$var$Rk;
var $4d82739dd229d539$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $4d82739dd229d539$var$Cb,
        $4d82739dd229d539$var$ue,
        $4d82739dd229d539$var$Db,
        $4d82739dd229d539$var$Eb,
        $4d82739dd229d539$var$Fb,
        $4d82739dd229d539$var$Qk
    ]
}, $4d82739dd229d539$var$tl = {
    findFiberByHostInstance: $4d82739dd229d539$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $4d82739dd229d539$var$ul = {
    bundleType: $4d82739dd229d539$var$tl.bundleType,
    version: $4d82739dd229d539$var$tl.version,
    rendererPackageName: $4d82739dd229d539$var$tl.rendererPackageName,
    rendererConfig: $4d82739dd229d539$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $4d82739dd229d539$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $4d82739dd229d539$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $4d82739dd229d539$var$tl.findFiberByHostInstance || $4d82739dd229d539$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $4d82739dd229d539$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$4d82739dd229d539$var$vl.isDisabled && $4d82739dd229d539$var$vl.supportsFiber) try {
        $4d82739dd229d539$var$kc = $4d82739dd229d539$var$vl.inject($4d82739dd229d539$var$ul), $4d82739dd229d539$var$lc = $4d82739dd229d539$var$vl;
    } catch (a) {}
}
$4d82739dd229d539$export$ae55be85d98224ed = $4d82739dd229d539$var$sl;
$4d82739dd229d539$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$4d82739dd229d539$var$nl(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$cl(a, b, null, c);
};
$4d82739dd229d539$export$882461b6382ed46c = function(a, b) {
    if (!$4d82739dd229d539$var$nl(a)) throw Error($4d82739dd229d539$var$p(299));
    var c = !1, d = "", e = $4d82739dd229d539$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $4d82739dd229d539$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$4d82739dd229d539$var$uf] = b.current;
    $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $4d82739dd229d539$var$ll(b);
};
$4d82739dd229d539$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($4d82739dd229d539$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($4d82739dd229d539$var$p(268, a));
    }
    a = $4d82739dd229d539$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$4d82739dd229d539$export$cd75ccfd720a3cd4 = function(a) {
    return $4d82739dd229d539$var$Rk(a);
};
$4d82739dd229d539$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$4d82739dd229d539$var$ol(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$rl(null, a, b, !0, c);
};
$4d82739dd229d539$export$757ceba2d55c277e = function(a, b, c) {
    if (!$4d82739dd229d539$var$nl(a)) throw Error($4d82739dd229d539$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $4d82739dd229d539$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $4d82739dd229d539$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$4d82739dd229d539$var$uf] = b.current;
    $4d82739dd229d539$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $4d82739dd229d539$var$ml(b);
};
$4d82739dd229d539$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$4d82739dd229d539$var$ol(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$rl(null, a, b, !1, c);
};
$4d82739dd229d539$export$502457920280e6be = function(a) {
    if (!$4d82739dd229d539$var$ol(a)) throw Error($4d82739dd229d539$var$p(40));
    return a._reactRootContainer ? ($4d82739dd229d539$var$Rk(function() {
        $4d82739dd229d539$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$4d82739dd229d539$var$uf] = null;
        });
    }), !0) : !1;
};
$4d82739dd229d539$export$c78a37762a8d58e1 = $4d82739dd229d539$var$Qk;
$4d82739dd229d539$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$4d82739dd229d539$var$ol(c)) throw Error($4d82739dd229d539$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($4d82739dd229d539$var$p(38));
    return $4d82739dd229d539$var$rl(a, b, c, !1, d);
};
$4d82739dd229d539$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("33s19", function(module, exports) {
'use strict';

module.exports = (parcelRequire("a0C75"));

});
parcelRegister("a0C75", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $749777fefd570b40$export$c4744153514ff05d; }, function (v) { return $749777fefd570b40$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $749777fefd570b40$export$3e506c1ccc9cc1a7; }, function (v) { return $749777fefd570b40$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $749777fefd570b40$export$e26fe2ed2fa76875; }, function (v) { return $749777fefd570b40$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $749777fefd570b40$export$502329bbf4b505b1; }, function (v) { return $749777fefd570b40$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $749777fefd570b40$export$6e3807111c4874c4; }, function (v) { return $749777fefd570b40$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $749777fefd570b40$export$c27134553091fb3a; }, function (v) { return $749777fefd570b40$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $749777fefd570b40$export$33ee1acdc04fd2a2; }, function (v) { return $749777fefd570b40$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $749777fefd570b40$export$b00a404bbd5edef2; }, function (v) { return $749777fefd570b40$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $749777fefd570b40$export$8352ce38b91d0c62; }, function (v) { return $749777fefd570b40$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $749777fefd570b40$export$d66a1c1c77bd778b; }, function (v) { return $749777fefd570b40$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $749777fefd570b40$export$d3dfb8e4810cb555; }, function (v) { return $749777fefd570b40$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $749777fefd570b40$export$839f9183b0465a69; }, function (v) { return $749777fefd570b40$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $749777fefd570b40$export$72fdf0e06517287b; }, function (v) { return $749777fefd570b40$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $749777fefd570b40$export$4b844e58a3e414b4; }, function (v) { return $749777fefd570b40$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $749777fefd570b40$export$816d2913ae6b83b1; }, function (v) { return $749777fefd570b40$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $749777fefd570b40$export$61bcfe829111a1d0; }, function (v) { return $749777fefd570b40$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $749777fefd570b40$export$7ee8c9beb337bc3f; }, function (v) { return $749777fefd570b40$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $749777fefd570b40$export$b5836b71941fa3ed; }, function (v) { return $749777fefd570b40$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $749777fefd570b40$export$cf845f2c119da08a; }, function (v) { return $749777fefd570b40$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $749777fefd570b40$export$c4744153514ff05d;
var $749777fefd570b40$export$3e506c1ccc9cc1a7;
var $749777fefd570b40$export$e26fe2ed2fa76875;
var $749777fefd570b40$export$502329bbf4b505b1;
var $749777fefd570b40$export$6e3807111c4874c4;
var $749777fefd570b40$export$c27134553091fb3a;
var $749777fefd570b40$export$33ee1acdc04fd2a2;
var $749777fefd570b40$export$b00a404bbd5edef2;
var $749777fefd570b40$export$8352ce38b91d0c62;
var $749777fefd570b40$export$d66a1c1c77bd778b;
var $749777fefd570b40$export$d3dfb8e4810cb555;
var $749777fefd570b40$export$839f9183b0465a69;
var $749777fefd570b40$export$72fdf0e06517287b;
var $749777fefd570b40$export$4b844e58a3e414b4;
var $749777fefd570b40$export$816d2913ae6b83b1;
var $749777fefd570b40$export$61bcfe829111a1d0;
var $749777fefd570b40$export$7ee8c9beb337bc3f;
var $749777fefd570b40$export$b5836b71941fa3ed;
var $749777fefd570b40$export$cf845f2c119da08a;
'use strict';
function $749777fefd570b40$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $749777fefd570b40$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $749777fefd570b40$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $749777fefd570b40$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $749777fefd570b40$var$g(C, c)) n < e && 0 > $749777fefd570b40$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $749777fefd570b40$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $749777fefd570b40$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $749777fefd570b40$var$l = performance;
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$l.now();
    };
} else {
    var $749777fefd570b40$var$p = Date, $749777fefd570b40$var$q = $749777fefd570b40$var$p.now();
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$p.now() - $749777fefd570b40$var$q;
    };
}
var $749777fefd570b40$var$r = [], $749777fefd570b40$var$t = [], $749777fefd570b40$var$u = 1, $749777fefd570b40$var$v = null, $749777fefd570b40$var$y = 3, $749777fefd570b40$var$z = !1, $749777fefd570b40$var$A = !1, $749777fefd570b40$var$B = !1, $749777fefd570b40$var$D = "function" === typeof setTimeout ? setTimeout : null, $749777fefd570b40$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $749777fefd570b40$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $749777fefd570b40$var$G(a) {
    for(var b = $749777fefd570b40$var$h($749777fefd570b40$var$t); null !== b;){
        if (null === b.callback) $749777fefd570b40$var$k($749777fefd570b40$var$t);
        else if (b.startTime <= a) $749777fefd570b40$var$k($749777fefd570b40$var$t), b.sortIndex = b.expirationTime, $749777fefd570b40$var$f($749777fefd570b40$var$r, b);
        else break;
        b = $749777fefd570b40$var$h($749777fefd570b40$var$t);
    }
}
function $749777fefd570b40$var$H(a) {
    $749777fefd570b40$var$B = !1;
    $749777fefd570b40$var$G(a);
    if (!$749777fefd570b40$var$A) {
        if (null !== $749777fefd570b40$var$h($749777fefd570b40$var$r)) $749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J);
        else {
            var b = $749777fefd570b40$var$h($749777fefd570b40$var$t);
            null !== b && $749777fefd570b40$var$K($749777fefd570b40$var$H, b.startTime - a);
        }
    }
}
function $749777fefd570b40$var$J(a, b) {
    $749777fefd570b40$var$A = !1;
    $749777fefd570b40$var$B && ($749777fefd570b40$var$B = !1, $749777fefd570b40$var$E($749777fefd570b40$var$L), $749777fefd570b40$var$L = -1);
    $749777fefd570b40$var$z = !0;
    var c = $749777fefd570b40$var$y;
    try {
        $749777fefd570b40$var$G(b);
        for($749777fefd570b40$var$v = $749777fefd570b40$var$h($749777fefd570b40$var$r); null !== $749777fefd570b40$var$v && (!($749777fefd570b40$var$v.expirationTime > b) || a && !$749777fefd570b40$var$M());){
            var d = $749777fefd570b40$var$v.callback;
            if ("function" === typeof d) {
                $749777fefd570b40$var$v.callback = null;
                $749777fefd570b40$var$y = $749777fefd570b40$var$v.priorityLevel;
                var e = d($749777fefd570b40$var$v.expirationTime <= b);
                b = $749777fefd570b40$export$c4744153514ff05d();
                "function" === typeof e ? $749777fefd570b40$var$v.callback = e : $749777fefd570b40$var$v === $749777fefd570b40$var$h($749777fefd570b40$var$r) && $749777fefd570b40$var$k($749777fefd570b40$var$r);
                $749777fefd570b40$var$G(b);
            } else $749777fefd570b40$var$k($749777fefd570b40$var$r);
            $749777fefd570b40$var$v = $749777fefd570b40$var$h($749777fefd570b40$var$r);
        }
        if (null !== $749777fefd570b40$var$v) var w = !0;
        else {
            var m = $749777fefd570b40$var$h($749777fefd570b40$var$t);
            null !== m && $749777fefd570b40$var$K($749777fefd570b40$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $749777fefd570b40$var$v = null, $749777fefd570b40$var$y = c, $749777fefd570b40$var$z = !1;
    }
}
var $749777fefd570b40$var$N = !1, $749777fefd570b40$var$O = null, $749777fefd570b40$var$L = -1, $749777fefd570b40$var$P = 5, $749777fefd570b40$var$Q = -1;
function $749777fefd570b40$var$M() {
    return $749777fefd570b40$export$c4744153514ff05d() - $749777fefd570b40$var$Q < $749777fefd570b40$var$P ? !1 : !0;
}
function $749777fefd570b40$var$R() {
    if (null !== $749777fefd570b40$var$O) {
        var a = $749777fefd570b40$export$c4744153514ff05d();
        $749777fefd570b40$var$Q = a;
        var b = !0;
        try {
            b = $749777fefd570b40$var$O(!0, a);
        } finally{
            b ? $749777fefd570b40$var$S() : ($749777fefd570b40$var$N = !1, $749777fefd570b40$var$O = null);
        }
    } else $749777fefd570b40$var$N = !1;
}
var $749777fefd570b40$var$S;
if ("function" === typeof $749777fefd570b40$var$F) $749777fefd570b40$var$S = function() {
    $749777fefd570b40$var$F($749777fefd570b40$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $749777fefd570b40$var$T = new MessageChannel, $749777fefd570b40$var$U = $749777fefd570b40$var$T.port2;
    $749777fefd570b40$var$T.port1.onmessage = $749777fefd570b40$var$R;
    $749777fefd570b40$var$S = function() {
        $749777fefd570b40$var$U.postMessage(null);
    };
} else $749777fefd570b40$var$S = function() {
    $749777fefd570b40$var$D($749777fefd570b40$var$R, 0);
};
function $749777fefd570b40$var$I(a) {
    $749777fefd570b40$var$O = a;
    $749777fefd570b40$var$N || ($749777fefd570b40$var$N = !0, $749777fefd570b40$var$S());
}
function $749777fefd570b40$var$K(a, b) {
    $749777fefd570b40$var$L = $749777fefd570b40$var$D(function() {
        a($749777fefd570b40$export$c4744153514ff05d());
    }, b);
}
$749777fefd570b40$export$3e506c1ccc9cc1a7 = 5;
$749777fefd570b40$export$e26fe2ed2fa76875 = 1;
$749777fefd570b40$export$502329bbf4b505b1 = 4;
$749777fefd570b40$export$6e3807111c4874c4 = 3;
$749777fefd570b40$export$c27134553091fb3a = null;
$749777fefd570b40$export$33ee1acdc04fd2a2 = 2;
$749777fefd570b40$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$749777fefd570b40$export$8352ce38b91d0c62 = function() {
    $749777fefd570b40$var$A || $749777fefd570b40$var$z || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J));
};
$749777fefd570b40$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $749777fefd570b40$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$749777fefd570b40$export$d3dfb8e4810cb555 = function() {
    return $749777fefd570b40$var$y;
};
$749777fefd570b40$export$839f9183b0465a69 = function() {
    return $749777fefd570b40$var$h($749777fefd570b40$var$r);
};
$749777fefd570b40$export$72fdf0e06517287b = function(a) {
    switch($749777fefd570b40$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $749777fefd570b40$var$y;
    }
    var c = $749777fefd570b40$var$y;
    $749777fefd570b40$var$y = b;
    try {
        return a();
    } finally{
        $749777fefd570b40$var$y = c;
    }
};
$749777fefd570b40$export$4b844e58a3e414b4 = function() {};
$749777fefd570b40$export$816d2913ae6b83b1 = function() {};
$749777fefd570b40$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $749777fefd570b40$var$y;
    $749777fefd570b40$var$y = a;
    try {
        return b();
    } finally{
        $749777fefd570b40$var$y = c;
    }
};
$749777fefd570b40$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $749777fefd570b40$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $749777fefd570b40$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $749777fefd570b40$var$f($749777fefd570b40$var$t, a), null === $749777fefd570b40$var$h($749777fefd570b40$var$r) && a === $749777fefd570b40$var$h($749777fefd570b40$var$t) && ($749777fefd570b40$var$B ? ($749777fefd570b40$var$E($749777fefd570b40$var$L), $749777fefd570b40$var$L = -1) : $749777fefd570b40$var$B = !0, $749777fefd570b40$var$K($749777fefd570b40$var$H, c - d))) : (a.sortIndex = e, $749777fefd570b40$var$f($749777fefd570b40$var$r, a), $749777fefd570b40$var$A || $749777fefd570b40$var$z || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J)));
    return a;
};
$749777fefd570b40$export$b5836b71941fa3ed = $749777fefd570b40$var$M;
$749777fefd570b40$export$cf845f2c119da08a = function(a) {
    var b = $749777fefd570b40$var$y;
    return function() {
        var c = $749777fefd570b40$var$y;
        $749777fefd570b40$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $749777fefd570b40$var$y = c;
        }
    };
};

});



parcelRegister("i5uoL", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $d2b0461a7763531f$export$bf730a2d8bf68b42; }, function (v) { return $d2b0461a7763531f$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d2b0461a7763531f$export$bf730a2d8bf68b42;
"use strict";

var $7fPBF = parcelRequire("7fPBF");
function $d2b0461a7763531f$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $d2b0461a7763531f$var$objectIs = "function" === typeof Object.is ? Object.is : $d2b0461a7763531f$var$is, $d2b0461a7763531f$var$useSyncExternalStore = $7fPBF.useSyncExternalStore, $d2b0461a7763531f$var$useRef = $7fPBF.useRef, $d2b0461a7763531f$var$useEffect = $7fPBF.useEffect, $d2b0461a7763531f$var$useMemo = $7fPBF.useMemo, $d2b0461a7763531f$var$useDebugValue = $7fPBF.useDebugValue;
$d2b0461a7763531f$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $d2b0461a7763531f$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $d2b0461a7763531f$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($d2b0461a7763531f$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $d2b0461a7763531f$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $d2b0461a7763531f$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $d2b0461a7763531f$var$useDebugValue(value);
    return value;
};

});

parcelRegister("4qQ7b", function(module, exports) {
'use strict';
var $33a204135f6b8445$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $f2BFz = parcelRequire("f2BFz");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $33a204135f6b8445$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $33a204135f6b8445$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $f2BFz();
};

});
parcelRegister("f2BFz", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("1OCuG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("deVQ2")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("deVQ2")).Icon; });

var $deVQ2 = parcelRequire("deVQ2");

});
parcelRegister("deVQ2", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $9a3972a81521c725$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $9a3972a81521c725$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $gVgMi = parcelRequire("gVgMi");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $9a3972a81521c725$var$svgStyles = null;
var $9a3972a81521c725$var$iconStyles = null;
var $9a3972a81521c725$var$smallIconStyles = null;
var $9a3972a81521c725$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $9a3972a81521c725$var$baseHcmStyles = null;
var $9a3972a81521c725$var$scaleSize = null;
var $9a3972a81521c725$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $9a3972a81521c725$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $9a3972a81521c725$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $9a3972a81521c725$export$f04a61298a47a40f = /*#__PURE__*/ (0, $7fPBF.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $9a3972a81521c725$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $gVgMi.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $gVgMi.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $9a3972a81521c725$var$coreSizeSmall[spacing] : $9a3972a81521c725$var$coreSizeMedium[spacing]
        ])
    }));
});
var $9a3972a81521c725$export$2e2bcd8739ae039 = $9a3972a81521c725$export$f04a61298a47a40f;

});
parcelRegister("gVgMi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c51efbfa35fd135d$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $c51efbfa35fd135d$var$ATOMIC_GROUP_LENGTH = 5;
function $c51efbfa35fd135d$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $c51efbfa35fd135d$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});



parcelRegister("8MJe2", function(module, exports) {

var $jHo6y = parcelRequire("jHo6y");
function $6655e33f0d2c88e7$var$_defineProperty(e, r, t) {
    return (r = $jHo6y(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $6655e33f0d2c88e7$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jHo6y", function(module, exports) {

var $bRUy3 = parcelRequire("bRUy3");
var $e574bb2d4ac0a9b8$var$_typeof = $bRUy3.default;

var $9GPcj = parcelRequire("9GPcj");
function $e574bb2d4ac0a9b8$var$toPropertyKey(t) {
    var i = $9GPcj(t, "string");
    return "symbol" == $e574bb2d4ac0a9b8$var$_typeof(i) ? i : i + "";
}
module.exports = $e574bb2d4ac0a9b8$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("bRUy3", function(module, exports) {
function $8a40824683152bd6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $8a40824683152bd6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $8a40824683152bd6$var$_typeof(o);
}
module.exports = $8a40824683152bd6$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9GPcj", function(module, exports) {

var $bRUy3 = parcelRequire("bRUy3");
var $70dfc0196094649e$var$_typeof = $bRUy3.default;
function $70dfc0196094649e$var$toPrimitive(t, r) {
    if ("object" != $70dfc0196094649e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $70dfc0196094649e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $70dfc0196094649e$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("dxrob", function(module, exports) {
function $9db39a503775575c$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $9db39a503775575c$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6CtYH", function(module, exports) {

var $jHo6y = parcelRequire("jHo6y");
function $4d1d8bace1bc5f55$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $jHo6y(o.key), o);
    }
}
function $4d1d8bace1bc5f55$var$_createClass(e, r, t) {
    return r && $4d1d8bace1bc5f55$var$_defineProperties(e.prototype, r), t && $4d1d8bace1bc5f55$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $4d1d8bace1bc5f55$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("iKdEz", function(module, exports) {

var $hJ0zT = parcelRequire("hJ0zT");

var $2Pbyd = parcelRequire("2Pbyd");

var $5ng8R = parcelRequire("5ng8R");

var $gPUQJ = parcelRequire("gPUQJ");
function $da571d235d718dda$var$_slicedToArray(r, e) {
    return $hJ0zT(r) || $2Pbyd(r, e) || $5ng8R(r, e) || $gPUQJ();
}
module.exports = $da571d235d718dda$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hJ0zT", function(module, exports) {
function $ce77166c8438e964$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $ce77166c8438e964$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2Pbyd", function(module, exports) {
function $20e94df54b7e2c18$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $20e94df54b7e2c18$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5ng8R", function(module, exports) {

var $hOZt4 = parcelRequire("hOZt4");
function $3e9b9f2b208dfc3f$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $hOZt4(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $hOZt4(r, a) : void 0;
    }
}
module.exports = $3e9b9f2b208dfc3f$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hOZt4", function(module, exports) {
function $cf96c9667eae972c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $cf96c9667eae972c$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("gPUQJ", function(module, exports) {
function $c41d81e3d1c59d7f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $c41d81e3d1c59d7f$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("f8tK9", function(module, exports) {

var $bRUy3 = parcelRequire("bRUy3");
var $b04eaccc43f5c61c$var$_typeof = $bRUy3.default;
function $b04eaccc43f5c61c$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ 
    module.exports = $b04eaccc43f5c61c$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return r;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag";
    function c(t, r, e, n) {
        return Object.defineProperty(t, r, {
            value: e,
            enumerable: !n,
            configurable: !n,
            writable: !n
        });
    }
    try {
        c({}, "");
    } catch (t) {
        c = function c(t, r, e) {
            return t[r] = e;
        };
    }
    function h(r, e, n, o) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype);
        return c(a, "_invoke", function(r, e, n) {
            var o = 1;
            return function(i, a) {
                if (3 === o) throw Error("Generator is already running");
                if (4 === o) {
                    if ("throw" === i) throw a;
                    return {
                        value: t,
                        done: !0
                    };
                }
                for(n.method = i, n.arg = a;;){
                    var u = n.delegate;
                    if (u) {
                        var c = d(u, n);
                        if (c) {
                            if (c === f) continue;
                            return c;
                        }
                    }
                    if ("next" === n.method) n.sent = n._sent = n.arg;
                    else if ("throw" === n.method) {
                        if (1 === o) throw o = 4, n.arg;
                        n.dispatchException(n.arg);
                    } else "return" === n.method && n.abrupt("return", n.arg);
                    o = 3;
                    var h = s(r, e, n);
                    if ("normal" === h.type) {
                        if (o = n.done ? 4 : 2, h.arg === f) continue;
                        return {
                            value: h.arg,
                            done: n.done
                        };
                    }
                    "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg);
                }
            };
        }(r, n, new Context(o || [])), !0), a;
    }
    function s(t, r, e) {
        try {
            return {
                type: "normal",
                arg: t.call(r, e)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    r.wrap = h;
    var f = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var l = {};
    c(l, i, function() {
        return this;
    });
    var p = Object.getPrototypeOf, y = p && p(p(x([])));
    y && y !== e && n.call(y, i) && (l = y);
    var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l);
    function g(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(r) {
            c(t, r, function(t) {
                return this._invoke(r, t);
            });
        });
    }
    function AsyncIterator(t, r) {
        function e(o, i, a, u) {
            var c = s(t[o], t, i);
            if ("throw" !== c.type) {
                var h = c.arg, f = h.value;
                return f && "object" == $b04eaccc43f5c61c$var$_typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function(t) {
                    e("next", t, a, u);
                }, function(t) {
                    e("throw", t, a, u);
                }) : r.resolve(f).then(function(t) {
                    h.value = t, a(h);
                }, function(t) {
                    return e("throw", t, a, u);
                });
            }
            u(c.arg);
        }
        var o;
        c(this, "_invoke", function(t, n) {
            function i() {
                return new r(function(r, o) {
                    e(t, n, r, o);
                });
            }
            return o = o ? o.then(i, i) : i();
        }, !0);
    }
    function d(r, e) {
        var n = e.method, o = r.i[n];
        if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f;
        var i = s(o, r.i, e.arg);
        if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f;
        var a = i.arg;
        return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f);
    }
    function w(t) {
        this.tryEntries.push(t);
    }
    function m(r) {
        var e = r[4] || {};
        e.type = "normal", e.arg = t, r[4] = e;
    }
    function Context(t) {
        this.tryEntries = [
            [
                -1
            ]
        ], t.forEach(w, this), this.reset(!0);
    }
    function x(r) {
        if (null != r) {
            var e = r[i];
            if (e) return e.call(r);
            if ("function" == typeof r.next) return r;
            if (!isNaN(r.length)) {
                var o = -1, a = function e() {
                    for(; ++o < r.length;)if (n.call(r, o)) return e.value = r[o], e.done = !1, e;
                    return e.value = t, e.done = !0, e;
                };
                return a.next = a;
            }
        }
        throw new TypeError($b04eaccc43f5c61c$var$_typeof(r) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function(t) {
        var r = "function" == typeof t && t.constructor;
        return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name));
    }, r.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t;
    }, r.awrap = function(t) {
        return {
            __await: t
        };
    }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function() {
        return this;
    }), r.AsyncIterator = AsyncIterator, r.async = function(t, e, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(h(t, e, n, o), i);
        return r.isGeneratorFunction(e) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, g(v), c(v, u, "Generator"), c(v, i, function() {
        return this;
    }), c(v, "toString", function() {
        return "[object Generator]";
    }), r.keys = function(t) {
        var r = Object(t), e = [];
        for(var n in r)e.unshift(n);
        return function t() {
            for(; e.length;)if ((n = e.pop()) in r) return t.value = n, t.done = !1, t;
            return t.done = !0, t;
        };
    }, r.values = x, Context.prototype = {
        constructor: Context,
        reset: function reset(r) {
            if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for(var e in this)"t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0][4];
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(r) {
            if (this.done) throw r;
            var e = this;
            function n(t) {
                a.type = "throw", a.arg = r, e.next = t;
            }
            for(var o = e.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2];
                if (-1 === i[0]) return n("end"), !1;
                if (!c && !h) throw Error("try statement without catch or finally");
                if (null != i[0] && i[0] <= u) {
                    if (u < c) return this.method = "next", this.arg = t, n(c), !0;
                    if (u < h) return n(h), !1;
                }
            }
        },
        abrupt: function abrupt(t, r) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var n = this.tryEntries[e];
                if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) {
                    var o = n;
                    break;
                }
            }
            o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null);
            var i = o ? o[4] : {};
            return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i);
        },
        complete: function complete(t, r) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f;
        },
        finish: function finish(t) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var e = this.tryEntries[r];
                if (e[2] === t) return this.complete(e[4], e[3]), m(e), f;
            }
        },
        "catch": function _catch(t) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var e = this.tryEntries[r];
                if (e[0] === t) {
                    var n = e[4];
                    if ("throw" === n.type) {
                        var o = n.arg;
                        m(e);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(r, e, n) {
            return this.delegate = {
                i: x(r),
                r: e,
                n: n
            }, "next" === this.method && (this.arg = t), f;
        }
    }, r;
}
module.exports = $b04eaccc43f5c61c$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2CTsY", function(module, exports) {
"use strict";
var $1e9a27dc53c779dd$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1e9a27dc53c779dd$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1e9a27dc53c779dd$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("kDWyI")).Diagnostics;
    }
});

var $lo1Ts = parcelRequire("lo1Ts");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $lo1Ts.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("1OvFT")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("hlXcM")).Storage;
    }
});

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("bYNP6")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("bQcYR")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("np6uq")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("FZpp0")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("kDWyI")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("QszgO")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("amoop")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("fPBrb")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("ay03q")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("75X6G")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("dKupR")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("1OvFT")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("3atRr")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("dK79n")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("fieiX")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("3MDN6")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("XhJBy")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("jXGyN")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("7OAfu")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("TtqbT")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("c3GX9")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("gW65n")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("3kqeB")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("hVWUO")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("gh2LQ")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("b2JnU")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("hZDgH")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("esLeu")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("2KqEX")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("kI8Ae")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("dYlmk")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("hlXcM")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("jhVkG")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("7QLuf")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("SiHEi")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("9zTSD")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("cHtSK")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("2PmEk")), module.exports);

$1e9a27dc53c779dd$var$__exportStar((parcelRequire("cKd83")), module.exports);
Object.assign((0, (parcelRequire("bYNP6"))._getStatsigGlobal)(), {
    Log: (parcelRequire("1OvFT")).Log,
    SDK_VERSION: (parcelRequire("b2JnU")).SDK_VERSION
});

});
parcelRegister("bYNP6", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $8b8bf22bae3e1f18$var$_a, $8b8bf22bae3e1f18$var$_b, $8b8bf22bae3e1f18$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $1OvFT = parcelRequire("1OvFT");
const $8b8bf22bae3e1f18$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $8b8bf22bae3e1f18$var$statsigGlobal;
    } catch (e) {
        return $8b8bf22bae3e1f18$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $8b8bf22bae3e1f18$var$_getStatsigGlobal;
const $8b8bf22bae3e1f18$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $8b8bf22bae3e1f18$var$_getStatsigGlobalFlag;
const $8b8bf22bae3e1f18$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $1OvFT.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $8b8bf22bae3e1f18$var$_getInstance;
const $8b8bf22bae3e1f18$var$GLOBAL_KEY = '__STATSIG__';
const $8b8bf22bae3e1f18$var$_window = typeof window !== 'undefined' ? window : {};
const $8b8bf22bae3e1f18$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $8b8bf22bae3e1f18$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $8b8bf22bae3e1f18$var$statsigGlobal = ($8b8bf22bae3e1f18$var$_c = ($8b8bf22bae3e1f18$var$_b = ($8b8bf22bae3e1f18$var$_a = $8b8bf22bae3e1f18$var$_window[$8b8bf22bae3e1f18$var$GLOBAL_KEY]) !== null && $8b8bf22bae3e1f18$var$_a !== void 0 ? $8b8bf22bae3e1f18$var$_a : $8b8bf22bae3e1f18$var$_global[$8b8bf22bae3e1f18$var$GLOBAL_KEY]) !== null && $8b8bf22bae3e1f18$var$_b !== void 0 ? $8b8bf22bae3e1f18$var$_b : $8b8bf22bae3e1f18$var$_globalThis[$8b8bf22bae3e1f18$var$GLOBAL_KEY]) !== null && $8b8bf22bae3e1f18$var$_c !== void 0 ? $8b8bf22bae3e1f18$var$_c : {
    instance: module.exports._getInstance
};
$8b8bf22bae3e1f18$var$_window[$8b8bf22bae3e1f18$var$GLOBAL_KEY] = $8b8bf22bae3e1f18$var$statsigGlobal;
$8b8bf22bae3e1f18$var$_global[$8b8bf22bae3e1f18$var$GLOBAL_KEY] = $8b8bf22bae3e1f18$var$statsigGlobal;
$8b8bf22bae3e1f18$var$_globalThis[$8b8bf22bae3e1f18$var$GLOBAL_KEY] = $8b8bf22bae3e1f18$var$statsigGlobal;

});
parcelRegister("1OvFT", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $152307e8a0269a9a$var$DEBUG = ' DEBUG ';
const $152307e8a0269a9a$var$_INFO = '  INFO ';
const $152307e8a0269a9a$var$_WARN = '  WARN ';
const $152307e8a0269a9a$var$ERROR = ' ERROR ';
function $152307e8a0269a9a$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $152307e8a0269a9a$var$Log {
    static info(...args) {
        if ($152307e8a0269a9a$var$Log.level >= module.exports.LogLevel.Info) console.info($152307e8a0269a9a$var$_INFO, ...$152307e8a0269a9a$var$addTag(args));
    }
    static debug(...args) {
        if ($152307e8a0269a9a$var$Log.level >= module.exports.LogLevel.Debug) console.debug($152307e8a0269a9a$var$DEBUG, ...$152307e8a0269a9a$var$addTag(args));
    }
    static warn(...args) {
        if ($152307e8a0269a9a$var$Log.level >= module.exports.LogLevel.Warn) console.warn($152307e8a0269a9a$var$_WARN, ...$152307e8a0269a9a$var$addTag(args));
    }
    static error(...args) {
        if ($152307e8a0269a9a$var$Log.level >= module.exports.LogLevel.Error) console.error($152307e8a0269a9a$var$ERROR, ...$152307e8a0269a9a$var$addTag(args));
    }
}
module.exports.Log = $152307e8a0269a9a$var$Log;
$152307e8a0269a9a$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("kDWyI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $f074dfbc2a7232ad$var$MARKER_MAP = new Map();
const $f074dfbc2a7232ad$var$ACT_START = 'start';
const $f074dfbc2a7232ad$var$ACT_END = 'end';
const $f074dfbc2a7232ad$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $f074dfbc2a7232ad$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $f074dfbc2a7232ad$var$_addMarker(sdkKey, $f074dfbc2a7232ad$var$_createMarker({}, $f074dfbc2a7232ad$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $f074dfbc2a7232ad$var$_addMarker(sdkKey, $f074dfbc2a7232ad$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $f074dfbc2a7232ad$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $f074dfbc2a7232ad$var$_addMarker(sdkKey, $f074dfbc2a7232ad$var$_createMarker(data, $f074dfbc2a7232ad$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $f074dfbc2a7232ad$var$_addMarker(sdkKey, $f074dfbc2a7232ad$var$_createMarker(data, $f074dfbc2a7232ad$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $f074dfbc2a7232ad$var$_addMarker(sdkKey, $f074dfbc2a7232ad$var$_createMarker({}, $f074dfbc2a7232ad$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $f074dfbc2a7232ad$var$_addMarker(sdkKey, $f074dfbc2a7232ad$var$_createMarker(data, $f074dfbc2a7232ad$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $f074dfbc2a7232ad$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $f074dfbc2a7232ad$var$_safeGetField(e, 'code'),
            name: $f074dfbc2a7232ad$var$_safeGetField(e, 'name'),
            message: $f074dfbc2a7232ad$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $f074dfbc2a7232ad$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $f074dfbc2a7232ad$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $f074dfbc2a7232ad$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $f074dfbc2a7232ad$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $f074dfbc2a7232ad$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $f074dfbc2a7232ad$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $f074dfbc2a7232ad$var$MARKER_MAP.set(sdkKey, markers);
}
function $f074dfbc2a7232ad$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("lo1Ts", function(module, exports) {
"use strict";
var $f91d4ee291257fe0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $bQcYR = parcelRequire("bQcYR");

var $75X6G = parcelRequire("75X6G");

var $1OvFT = parcelRequire("1OvFT");

var $dK79n = parcelRequire("dK79n");

var $jXGyN = parcelRequire("jXGyN");

var $gh2LQ = parcelRequire("gh2LQ");

var $hZDgH = parcelRequire("hZDgH");

var $hlXcM = parcelRequire("hlXcM");

var $SiHEi = parcelRequire("SiHEi");

var $cHtSK = parcelRequire("cHtSK");
const $f91d4ee291257fe0$var$DEFAULT_QUEUE_SIZE = 100;
const $f91d4ee291257fe0$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $f91d4ee291257fe0$var$MAX_DEDUPER_KEYS = 1000;
const $f91d4ee291257fe0$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $f91d4ee291257fe0$var$MAX_FAILED_LOGS = 500;
const $f91d4ee291257fe0$var$QUICK_FLUSH_WINDOW_MS = 200;
const $f91d4ee291257fe0$var$EVENT_LOGGER_MAP = {};
const $f91d4ee291257fe0$var$RetryFailedLogsTrigger = {
    Startup: 'startup',
    GainedFocus: 'gained_focus'
};
class $f91d4ee291257fe0$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $f91d4ee291257fe0$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $f91d4ee291257fe0$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs($f91d4ee291257fe0$var$RetryFailedLogsTrigger.GainedFocus);
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $f91d4ee291257fe0$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $jXGyN._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        $f91d4ee291257fe0$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $cHtSK._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $f91d4ee291257fe0$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') $f91d4ee291257fe0$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs($f91d4ee291257fe0$var$RetryFailedLogsTrigger.Startup);
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $f91d4ee291257fe0$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $f91d4ee291257fe0$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $f91d4ee291257fe0$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $f91d4ee291257fe0$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$f91d4ee291257fe0$var$EventLogger._safeFlushAndForget(this._sdkKey), $f91d4ee291257fe0$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $jXGyN._isServerEnv)()) return false;
        if (!(0, $gh2LQ._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $bQcYR._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $f91d4ee291257fe0$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $f91d4ee291257fe0$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        var _a, _b;
        return $f91d4ee291257fe0$var$__awaiter(this, void 0, void 0, function*() {
            if (this._loggingEnabled === 'disabled') {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $cHtSK._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: events
                });
                const response = shouldUseBeacon ? yield this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: events
                    });
                    return true;
                } else {
                    $1OvFT.Log.warn('Failed to flush events.');
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $1OvFT.Log.warn('Failed to flush events.');
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        var _a;
        return $f91d4ee291257fe0$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return $f91d4ee291257fe0$var$__awaiter(this, void 0, void 0, function*() {
            return {
                success: yield this._network.beacon(this._getRequestData(events))
            };
        });
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$dK79n.NetworkParam.EventCount]: String(events.length)
            },
            credentials: 'same-origin'
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $f91d4ee291257fe0$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            (0, $hlXcM._setObjectInStorage)(storageKey, events);
        } catch (_a) {
            $1OvFT.Log.warn('Unable to save failed logs to storage');
        }
    }
    _retryFailedLogs(trigger) {
        const storageKey = this._getStorageKey();
        (()=>$f91d4ee291257fe0$var$__awaiter(this, void 0, void 0, function*() {
                if (!$hlXcM.Storage.isReady()) yield $hlXcM.Storage.isReadyResolver();
                const events = (0, $hlXcM._getObjectFromStorage)(storageKey);
                if (!events) return;
                if (trigger === $f91d4ee291257fe0$var$RetryFailedLogsTrigger.Startup) $hlXcM.Storage.removeItem(storageKey);
                const isSuccess = yield this._sendEvents(events);
                if (isSuccess && trigger === $f91d4ee291257fe0$var$RetryFailedLogsTrigger.GainedFocus) $hlXcM.Storage.removeItem(storageKey);
            }))().catch(()=>{
            $1OvFT.Log.warn('Failed to flush stored logs');
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $75X6G._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $1OvFT.Log.debug('Enqueued Event:', final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $jXGyN._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $f91d4ee291257fe0$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $f91d4ee291257fe0$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $f91d4ee291257fe0$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $hZDgH.LoggingEnabledOption.disabled : $hZDgH.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $1OvFT.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $f91d4ee291257fe0$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $SiHEi.UrlConfiguration($dK79n.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
}
module.exports.EventLogger = $f91d4ee291257fe0$var$EventLogger;

});
parcelRegister("bQcYR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $75X6G = parcelRequire("75X6G");
function $89ee9eb9961b9bb9$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $75X6G._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $89ee9eb9961b9bb9$var$_getUserStorageKey;
function $89ee9eb9961b9bb9$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $89ee9eb9961b9bb9$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $75X6G._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $89ee9eb9961b9bb9$var$_getStorageKey;

});
parcelRegister("75X6G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $7QLuf = parcelRequire("7QLuf");
const $52a6d96be12757a8$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $52a6d96be12757a8$var$_DJB2;
const $52a6d96be12757a8$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $52a6d96be12757a8$var$_DJB2Object;
const $52a6d96be12757a8$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $7QLuf._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $52a6d96be12757a8$var$_getSortedObject;

});
parcelRegister("7QLuf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $5b7239a209235b83$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $5b7239a209235b83$var$_typeOf;
function $5b7239a209235b83$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $5b7239a209235b83$var$_isTypeMatch;

});



parcelRegister("dK79n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("jXGyN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $e8848a9660c3489a$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $e8848a9660c3489a$var$_getWindowSafe;
const $e8848a9660c3489a$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $e8848a9660c3489a$var$_getDocumentSafe;
const $e8848a9660c3489a$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = false;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $e8848a9660c3489a$var$_isServerEnv;
const $e8848a9660c3489a$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $e8848a9660c3489a$var$_addWindowEventListenerSafe;
const $e8848a9660c3489a$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $e8848a9660c3489a$var$_addDocumentEventListenerSafe;
const $e8848a9660c3489a$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $e8848a9660c3489a$var$_getCurrentPageUrlSafe;
const $e8848a9660c3489a$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $e8848a9660c3489a$var$_getUnloadEvent;

});

parcelRegister("gh2LQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $bd9062167caf580c$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $bd9062167caf580c$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $bd9062167caf580c$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $bd9062167caf580c$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $bd9062167caf580c$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $bd9062167caf580c$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $bd9062167caf580c$var$GATE_EXPOSURE_NAME || eventName === $bd9062167caf580c$var$CONFIG_EXPOSURE_NAME || eventName === $bd9062167caf580c$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $bd9062167caf580c$var$_isExposureEvent;
const $bd9062167caf580c$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $bd9062167caf580c$var$_createExposure($bd9062167caf580c$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $bd9062167caf580c$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $bd9062167caf580c$var$_createGateExposure;
function $bd9062167caf580c$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $bd9062167caf580c$var$_mapExposures;
const $bd9062167caf580c$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $bd9062167caf580c$var$_createExposure($bd9062167caf580c$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $bd9062167caf580c$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $bd9062167caf580c$var$_createConfigExposure;
const $bd9062167caf580c$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = evaluation.secondary_exposures;
    }
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_d = layer.__evaluation) === null || _d === void 0 ? void 0 : _d.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $bd9062167caf580c$var$_createExposure($bd9062167caf580c$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $bd9062167caf580c$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $bd9062167caf580c$var$_createLayerParameterExposure;
const $bd9062167caf580c$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("hZDgH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});

parcelRegister("hlXcM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $1OvFT = parcelRequire("1OvFT");

var $jXGyN = parcelRequire("jXGyN");
const $ca2252bd2bc73b06$var$inMemoryStore = {};
const $ca2252bd2bc73b06$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$ca2252bd2bc73b06$var$inMemoryStore[key] ? $ca2252bd2bc73b06$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $ca2252bd2bc73b06$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $ca2252bd2bc73b06$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($ca2252bd2bc73b06$var$inMemoryStore)
};
let $ca2252bd2bc73b06$var$_localStorageProvider = null;
try {
    const win = (0, $jXGyN._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $ca2252bd2bc73b06$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $1OvFT.Log.warn('Failed to setup localStorageProvider.');
}
let $ca2252bd2bc73b06$var$_main = $ca2252bd2bc73b06$var$_localStorageProvider !== null && $ca2252bd2bc73b06$var$_localStorageProvider !== void 0 ? $ca2252bd2bc73b06$var$_localStorageProvider : $ca2252bd2bc73b06$var$_inMemoryProvider;
let $ca2252bd2bc73b06$var$_current = $ca2252bd2bc73b06$var$_main;
function $ca2252bd2bc73b06$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($ca2252bd2bc73b06$var$_inMemoryProvider);
            return null;
        }
        if (error instanceof Error && error.name === 'QuotaExceededError') {
            const allKeys = module.exports.Storage.getAllKeys();
            const statsigKeys = allKeys.filter((key)=>key.startsWith('statsig.'));
            error.message = `${error.message}. Statsig Keys: ${statsigKeys.length}`;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$ca2252bd2bc73b06$var$_current.isReady(),
    isReadyResolver: ()=>$ca2252bd2bc73b06$var$_current.isReadyResolver(),
    getProviderName: ()=>$ca2252bd2bc73b06$var$_current.getProviderName(),
    getItem: (key)=>$ca2252bd2bc73b06$var$_inMemoryBreaker(()=>$ca2252bd2bc73b06$var$_current.getItem(key)),
    setItem: (key, value)=>$ca2252bd2bc73b06$var$_inMemoryBreaker(()=>$ca2252bd2bc73b06$var$_current.setItem(key, value)),
    removeItem: (key)=>$ca2252bd2bc73b06$var$_current.removeItem(key),
    getAllKeys: ()=>$ca2252bd2bc73b06$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $ca2252bd2bc73b06$var$_main = newProvider;
        $ca2252bd2bc73b06$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $ca2252bd2bc73b06$var$_current = $ca2252bd2bc73b06$var$_inMemoryProvider;
        else $ca2252bd2bc73b06$var$_current = $ca2252bd2bc73b06$var$_main;
    }
};
function $ca2252bd2bc73b06$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    return JSON.parse(value !== null && value !== void 0 ? value : 'null');
}
module.exports._getObjectFromStorage = $ca2252bd2bc73b06$var$_getObjectFromStorage;
function $ca2252bd2bc73b06$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $ca2252bd2bc73b06$var$_setObjectInStorage;

});

parcelRegister("SiHEi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $75X6G = parcelRequire("75X6G");

var $dK79n = parcelRequire("dK79n");
const $0a338d4a154d8f98$var$ENDPOINT_DNS_KEY_MAP = {
    [$dK79n.Endpoint._initialize]: 'i',
    [$dK79n.Endpoint._rgstr]: 'e',
    [$dK79n.Endpoint._download_config_specs]: 'd'
};
class $0a338d4a154d8f98$var$UrlConfiguration {
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $75X6G._DJB2)(this.customUrl + fallbacks);
    }
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $0a338d4a154d8f98$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $dK79n.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
}
module.exports.UrlConfiguration = $0a338d4a154d8f98$var$UrlConfiguration;

});

parcelRegister("cHtSK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $jXGyN = parcelRequire("jXGyN");
const $93f0ae29560cf15c$var$FOREGROUND = 'foreground';
const $93f0ae29560cf15c$var$BACKGROUND = 'background';
const $93f0ae29560cf15c$var$LISTENERS = [];
let $93f0ae29560cf15c$var$current = $93f0ae29560cf15c$var$FOREGROUND;
let $93f0ae29560cf15c$var$isUnloading = false;
const $93f0ae29560cf15c$var$_isCurrentlyVisible = ()=>{
    return $93f0ae29560cf15c$var$current === $93f0ae29560cf15c$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $93f0ae29560cf15c$var$_isCurrentlyVisible;
const $93f0ae29560cf15c$var$_isUnloading = ()=>$93f0ae29560cf15c$var$isUnloading;
module.exports._isUnloading = $93f0ae29560cf15c$var$_isUnloading;
const $93f0ae29560cf15c$var$_subscribeToVisiblityChanged = (listener)=>{
    $93f0ae29560cf15c$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $93f0ae29560cf15c$var$_subscribeToVisiblityChanged;
const $93f0ae29560cf15c$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $93f0ae29560cf15c$var$current) return;
    $93f0ae29560cf15c$var$current = visibility;
    $93f0ae29560cf15c$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $93f0ae29560cf15c$var$_notifyVisibilityChanged;
(0, $jXGyN._addWindowEventListenerSafe)('focus', ()=>{
    $93f0ae29560cf15c$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($93f0ae29560cf15c$var$FOREGROUND);
});
(0, $jXGyN._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($93f0ae29560cf15c$var$BACKGROUND));
(0, $jXGyN._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $93f0ae29560cf15c$var$FOREGROUND : $93f0ae29560cf15c$var$BACKGROUND);
});
(0, $jXGyN._addWindowEventListenerSafe)((0, $jXGyN._getUnloadEvent)(), ()=>{
    $93f0ae29560cf15c$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($93f0ae29560cf15c$var$BACKGROUND);
});

});


parcelRegister("b2JnU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.16.0';
let $80a3160d3002f017$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$80a3160d3002f017$var$metadata,
    add: (additions)=>{
        $80a3160d3002f017$var$metadata = Object.assign(Object.assign({}, $80a3160d3002f017$var$metadata), additions);
    }
};

});

parcelRegister("np6uq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("FZpp0", function(module, exports) {
"use strict";
var $07e376f1092d39cc$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $1OvFT = parcelRequire("1OvFT");

var $c3GX9 = parcelRequire("c3GX9");

var $dYlmk = parcelRequire("dYlmk");

var $hlXcM = parcelRequire("hlXcM");

var $jhVkG = parcelRequire("jhVkG");
const $07e376f1092d39cc$var$CACHE_LIMIT = 10;
class $07e376f1092d39cc$var$DataAdapterCore {
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $dYlmk._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache) {
            this._inMemoryCache.add(cacheKey, cache);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $dYlmk._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $07e376f1092d39cc$var$_makeDataAdapterResult('Bootstrap', data, null, normalized));
    }
    _getDataAsyncImpl(current, user, options) {
        return $07e376f1092d39cc$var$__awaiter(this, void 0, void 0, function*() {
            if (!$hlXcM.Storage.isReady()) yield $hlXcM.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $1OvFT.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $07e376f1092d39cc$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $dYlmk._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }));
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        var _a;
        return $07e376f1092d39cc$var$__awaiter(this, void 0, void 0, function*() {
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $1OvFT.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $jhVkG._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $c3GX9.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $07e376f1092d39cc$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $07e376f1092d39cc$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $1OvFT.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $hlXcM.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($hlXcM.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $jhVkG._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        $hlXcM.Storage.setItem(cacheKey, JSON.stringify(result));
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $hlXcM._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictable = $07e376f1092d39cc$var$_getEvictableKey(lastModifiedTimeMap, $07e376f1092d39cc$var$CACHE_LIMIT);
        if (evictable) {
            delete lastModifiedTimeMap[evictable];
            $hlXcM.Storage.removeItem(evictable);
        }
        (0, $hlXcM._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $07e376f1092d39cc$var$InMemoryCache();
    }
}
module.exports.DataAdapterCore = $07e376f1092d39cc$var$DataAdapterCore;
function $07e376f1092d39cc$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $dYlmk._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $07e376f1092d39cc$var$_makeDataAdapterResult;
class $07e376f1092d39cc$var$InMemoryCache {
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $1OvFT.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value) {
        const oldest = $07e376f1092d39cc$var$_getEvictableKey(this._data, $07e376f1092d39cc$var$CACHE_LIMIT - 1);
        if (oldest) delete this._data[oldest];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
    constructor(){
        this._data = {};
    }
}
function $07e376f1092d39cc$var$_getEvictableKey(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return null;
    return keys.reduce((prevKey, currKey)=>{
        const prev = data[prevKey];
        const current = data[currKey];
        if (typeof prev === 'object' && typeof current === 'object') return current.receivedAt < prev.receivedAt ? currKey : prevKey;
        return current < prev ? currKey : prevKey;
    });
}

});
parcelRegister("c3GX9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StableID = void 0;

var $bQcYR = parcelRequire("bQcYR");

var $1OvFT = parcelRequire("1OvFT");

var $jXGyN = parcelRequire("jXGyN");

var $hlXcM = parcelRequire("hlXcM");

var $9zTSD = parcelRequire("9zTSD");
const $8c7715724816d66f$var$PROMISE_MAP = {};
const $8c7715724816d66f$var$COOKIE_ENABLED_MAP = {};
const $8c7715724816d66f$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($8c7715724816d66f$var$DISABLED_MAP[sdkKey]) return null;
        if ($8c7715724816d66f$var$PROMISE_MAP[sdkKey] != null) return $8c7715724816d66f$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $8c7715724816d66f$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $8c7715724816d66f$var$PROMISE_MAP[sdkKey] = stableID;
            $8c7715724816d66f$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $8c7715724816d66f$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $9zTSD.getUUID)();
        $8c7715724816d66f$var$_persistToStorage(stableID, sdkKey);
        $8c7715724816d66f$var$_persistToCookie(stableID, sdkKey);
        $8c7715724816d66f$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $8c7715724816d66f$var$PROMISE_MAP[sdkKey] = override;
        $8c7715724816d66f$var$_persistToStorage(override, sdkKey);
        $8c7715724816d66f$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $8c7715724816d66f$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $8c7715724816d66f$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $8c7715724816d66f$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $bQcYR._getStorageKey)(sdkKey)}`;
}
function $8c7715724816d66f$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $8c7715724816d66f$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $hlXcM._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $1OvFT.Log.warn('Failed to save StableID to storage');
    }
}
function $8c7715724816d66f$var$_loadFromStorage(sdkKey) {
    const storageKey = $8c7715724816d66f$var$_getStableIDStorageKey(sdkKey);
    return (0, $hlXcM._getObjectFromStorage)(storageKey);
}
function $8c7715724816d66f$var$_loadFromCookie(sdkKey) {
    if (!$8c7715724816d66f$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $jXGyN._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $8c7715724816d66f$var$_getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $8c7715724816d66f$var$_persistToCookie(stableID, sdkKey) {
    if (!$8c7715724816d66f$var$COOKIE_ENABLED_MAP[sdkKey] || !document) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$8c7715724816d66f$var$_getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $8c7715724816d66f$var$_getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $bQcYR._getStorageKey)(sdkKey)}`;
}

});
parcelRegister("9zTSD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $6f92ba9afaef8dd4$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $6f92ba9afaef8dd4$var$getUUID;

});


parcelRegister("dYlmk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $75X6G = parcelRequire("75X6G");

var $1OvFT = parcelRequire("1OvFT");
function $a2c172725b492c22$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $1OvFT.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $a2c172725b492c22$var$_normalizeUser;
function $a2c172725b492c22$var$_getFullUserHash(user) {
    return user ? (0, $75X6G._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $a2c172725b492c22$var$_getFullUserHash;

});

parcelRegister("jhVkG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $1OvFT = parcelRequire("1OvFT");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $e0ac13ee1b2be972$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $1OvFT.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $e0ac13ee1b2be972$var$_typedJsonParse;

});


parcelRegister("QszgO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("amoop", function(module, exports) {
"use strict";
var $78aee154b27f1674$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $1OvFT = parcelRequire("1OvFT");

var $7OAfu = parcelRequire("7OAfu");

var $b2JnU = parcelRequire("b2JnU");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $78aee154b27f1674$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $78aee154b27f1674$var$ErrorBoundary {
    wrap(instance) {
        try {
            const obj = instance;
            $78aee154b27f1674$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $78aee154b27f1674$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $1OvFT.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$78aee154b27f1674$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($78aee154b27f1674$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $78aee154b27f1674$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $7OAfu.SDKType._get(this._sdkKey);
                    const statsigMetadata = $b2JnU.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $78aee154b27f1674$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $78aee154b27f1674$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
}
module.exports.ErrorBoundary = $78aee154b27f1674$var$ErrorBoundary;
function $78aee154b27f1674$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $78aee154b27f1674$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $78aee154b27f1674$var$UNKNOWN_ERROR;
    }
}
function $78aee154b27f1674$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $78aee154b27f1674$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.entries(options).forEach(([option, value])=>{
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});
parcelRegister("7OAfu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $5b09522bea129122$var$SDK_CLIENT = {};
let $5b09522bea129122$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $5b09522bea129122$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($5b09522bea129122$var$suffix !== null && $5b09522bea129122$var$suffix !== void 0 ? $5b09522bea129122$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $5b09522bea129122$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$5b09522bea129122$var$suffix || $5b09522bea129122$var$suffix === '-react') $5b09522bea129122$var$suffix = '-' + binding;
    }
};

});


parcelRegister("fPBrb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("ay03q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("dKupR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3atRr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _layer: 'l',
    _paramStore: 'p'
};
const $24e978092142d83c$var$EXIST_KEYS = new Set([]);
const $24e978092142d83c$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $24e978092142d83c$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($24e978092142d83c$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($24e978092142d83c$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $24e978092142d83c$var$createMemoKey;

});

parcelRegister("fieiX", function(module, exports) {
"use strict";
var $b223a2192225ed06$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $bYNP6 = parcelRequire("bYNP6");

var $bYNP6 = parcelRequire("bYNP6");

var $kDWyI = parcelRequire("kDWyI");

var $1OvFT = parcelRequire("1OvFT");

var $dK79n = parcelRequire("dK79n");

var $17upD = parcelRequire("17upD");

var $cKd83 = parcelRequire("cKd83");

var $7OAfu = parcelRequire("7OAfu");

var $jXGyN = parcelRequire("jXGyN");

var $TtqbT = parcelRequire("TtqbT");

var $c3GX9 = parcelRequire("c3GX9");

var $3kqeB = parcelRequire("3kqeB");

var $b2JnU = parcelRequire("b2JnU");

var $hZDgH = parcelRequire("hZDgH");

var $cHtSK = parcelRequire("cHtSK");
const $b223a2192225ed06$var$DEFAULT_TIMEOUT_MS = 10000;
const $b223a2192225ed06$var$BACKOFF_BASE_MS = 500;
const $b223a2192225ed06$var$BACKOFF_MAX_MS = 30000;
const $b223a2192225ed06$var$RATE_LIMIT_WINDOW_MS = 1000;
const $b223a2192225ed06$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $b223a2192225ed06$var$LEAK_RATE = $b223a2192225ed06$var$RATE_LIMIT_MAX_REQ_COUNT / $b223a2192225ed06$var$RATE_LIMIT_WINDOW_MS;
const $b223a2192225ed06$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $b223a2192225ed06$var$NetworkCore {
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        return $b223a2192225ed06$var$__awaiter(this, void 0, void 0, function*() {
            if (!$b223a2192225ed06$var$_ensureValidSdkKey(args)) return false;
            const argsInternal = this._getInternalRequestArgs('POST', args);
            yield this._tryToCompressBody(argsInternal);
            const url = yield this._getPopulatedURL(argsInternal);
            const nav = navigator;
            return nav.sendBeacon.bind(nav)(url, argsInternal.body);
        });
    }
    post(args) {
        return $b223a2192225ed06$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        var _a, _b, _c, _d;
        return $b223a2192225ed06$var$__awaiter(this, void 0, void 0, function*() {
            if (!$b223a2192225ed06$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $1OvFT.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            const abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
            const timeoutHandle = setTimeout(()=>{
                abortController === null || abortController === void 0 || abortController.abort(`Timeout of ${this._timeout}ms expired.`);
            }, this._timeout);
            const populatedUrl = yield this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $cHtSK._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
                    priority: args.priority,
                    keepalive: keepalive
                };
                $b223a2192225ed06$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                response = yield func(populatedUrl, config);
                clearTimeout(timeoutHandle);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $b223a2192225ed06$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $b223a2192225ed06$var$_getErrorMessage(abortController, error);
                const timedOut = $b223a2192225ed06$var$_didTimeout(abortController);
                $b223a2192225ed06$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$b223a2192225ed06$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $3kqeB.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $1OvFT.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $b223a2192225ed06$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $hZDgH.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $hZDgH.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $b223a2192225ed06$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $b223a2192225ed06$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        return $b223a2192225ed06$var$__awaiter(this, void 0, void 0, function*() {
            const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
            if (args.urlConfig.endpoint === $dK79n.Endpoint._initialize || args.urlConfig.endpoint === $dK79n.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
            const params = Object.assign({
                [$dK79n.NetworkParam.SdkKey]: args.sdkKey,
                [$dK79n.NetworkParam.SdkType]: $7OAfu.SDKType._get(args.sdkKey),
                [$dK79n.NetworkParam.SdkVersion]: $b2JnU.SDK_VERSION,
                [$dK79n.NetworkParam.Time]: String(Date.now()),
                [$dK79n.NetworkParam.SessionID]: $TtqbT.SessionID.get(args.sdkKey)
            }, args.params);
            const query = Object.keys(params).map((key)=>{
                return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
            }).join('&');
            return `${url}${query ? `?${query}` : ''}`;
        });
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $jXGyN._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $bYNP6._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$dK79n.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $1OvFT.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        var _a;
        return $b223a2192225ed06$var$__awaiter(this, void 0, void 0, function*() {
            const body = args.body;
            if (typeof body !== 'string' || !$b223a2192225ed06$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($1OvFT.Log.error);
                writer.close().catch($1OvFT.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$dK79n.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $1OvFT.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $b223a2192225ed06$var$_populateRequestBody(result, args.data);
        return result;
    }
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $b223a2192225ed06$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $17upD.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
}
module.exports.NetworkCore = $b223a2192225ed06$var$NetworkCore;
const $b223a2192225ed06$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $1OvFT.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $b223a2192225ed06$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $c3GX9.StableID.get(sdkKey);
    const sessionID = $TtqbT.SessionID.get(sdkKey);
    const sdkType = $7OAfu.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $b2JnU.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $b223a2192225ed06$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $bYNP6._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $cKd83.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $hZDgH.LogEventCompressionMode.Disabled:
            return false;
        case $hZDgH.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $hZDgH.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $b223a2192225ed06$var$_getErrorMessage(controller, error) {
    if ((controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === 'string') return controller.signal.reason;
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $b223a2192225ed06$var$_didTimeout(controller) {
    const timeout = (controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === 'string' && controller.signal.reason.includes('Timeout');
    return timeout || false;
}
function $b223a2192225ed06$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $dK79n.Endpoint._initialize) return;
    $kDWyI.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $b223a2192225ed06$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $dK79n.Endpoint._initialize) return;
    $kDWyI.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $kDWyI.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $b223a2192225ed06$var$_exponentialBackoff(attempt) {
    return $b223a2192225ed06$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($b223a2192225ed06$var$BACKOFF_BASE_MS * (attempt * attempt), $b223a2192225ed06$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("17upD", function(module, exports) {
"use strict";
var $0d0e09308cd1da6f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $coFmx = parcelRequire("coFmx");

var $75X6G = parcelRequire("75X6G");

var $1OvFT = parcelRequire("1OvFT");

var $hlXcM = parcelRequire("hlXcM");
const $0d0e09308cd1da6f$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $0d0e09308cd1da6f$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $0d0e09308cd1da6f$var$NetworkFallbackResolver {
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $0d0e09308cd1da6f$var$DEFAULT_TTL_MS;
        $0d0e09308cd1da6f$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $0d0e09308cd1da6f$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $0d0e09308cd1da6f$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        var _a, _b;
        return $0d0e09308cd1da6f$var$__awaiter(this, void 0, void 0, function*() {
            try {
                if (!$0d0e09308cd1da6f$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $0d0e09308cd1da6f$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $0d0e09308cd1da6f$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        var _a;
        return $0d0e09308cd1da6f$var$__awaiter(this, void 0, void 0, function*() {
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $0d0e09308cd1da6f$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $coFmx._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $0d0e09308cd1da6f$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
}
module.exports.NetworkFallbackResolver = $0d0e09308cd1da6f$var$NetworkFallbackResolver;
function $0d0e09308cd1da6f$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $0d0e09308cd1da6f$var$_isDomainFailure;
function $0d0e09308cd1da6f$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $75X6G._DJB2)(sdkKey)}`;
}
function $0d0e09308cd1da6f$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $0d0e09308cd1da6f$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $hlXcM.Storage.removeItem(hashKey);
        return;
    }
    $hlXcM.Storage.setItem(hashKey, JSON.stringify(info));
}
function $0d0e09308cd1da6f$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $0d0e09308cd1da6f$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $hlXcM.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $1OvFT.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $0d0e09308cd1da6f$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("coFmx", function(module, exports) {
"use strict";
var $9067cfaa3d092275$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $9067cfaa3d092275$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $9067cfaa3d092275$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $9067cfaa3d092275$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $9067cfaa3d092275$var$MAX_START_LOOKUP = 200;
function $9067cfaa3d092275$var$_fetchTxtRecords(networkFunc) {
    return $9067cfaa3d092275$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($9067cfaa3d092275$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $9067cfaa3d092275$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $9067cfaa3d092275$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $9067cfaa3d092275$var$_fetchTxtRecords;
function $9067cfaa3d092275$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $9067cfaa3d092275$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $9067cfaa3d092275$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});


parcelRegister("cKd83", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $9473f709616eba59$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $9473f709616eba59$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $9473f709616eba59$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("TtqbT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $bYNP6 = parcelRequire("bYNP6");

var $bQcYR = parcelRequire("bQcYR");

var $1OvFT = parcelRequire("1OvFT");

var $hlXcM = parcelRequire("hlXcM");

var $9zTSD = parcelRequire("9zTSD");
const $0a6bf5a700218675$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $0a6bf5a700218675$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $0a6bf5a700218675$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($0a6bf5a700218675$var$PROMISE_MAP[sdkKey] == null) $0a6bf5a700218675$var$PROMISE_MAP[sdkKey] = $0a6bf5a700218675$var$_loadSession(sdkKey);
        const session = $0a6bf5a700218675$var$PROMISE_MAP[sdkKey];
        return $0a6bf5a700218675$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $0a6bf5a700218675$var$PROMISE_MAP[sdkKey] = $0a6bf5a700218675$var$_overrideSessionId(override, sdkKey);
    }
};
function $0a6bf5a700218675$var$_loadSession(sdkKey) {
    let data = $0a6bf5a700218675$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $9zTSD.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $0a6bf5a700218675$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $0a6bf5a700218675$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($0a6bf5a700218675$var$_isIdle(data) || $0a6bf5a700218675$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $9zTSD.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }
    data.lastUpdate = now;
    $0a6bf5a700218675$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $0a6bf5a700218675$var$_createSessionTimeout(sdkKey, $0a6bf5a700218675$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $0a6bf5a700218675$var$_createSessionTimeout(sdkKey, $0a6bf5a700218675$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $0a6bf5a700218675$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $bYNP6._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function $0a6bf5a700218675$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $0a6bf5a700218675$var$MAX_SESSION_IDLE_TIME;
}
function $0a6bf5a700218675$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $0a6bf5a700218675$var$MAX_SESSION_AGE;
}
function $0a6bf5a700218675$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $bQcYR._getStorageKey)(sdkKey)}`;
}
function $0a6bf5a700218675$var$_persistToStorage(session, sdkKey) {
    const storageKey = $0a6bf5a700218675$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $hlXcM._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $1OvFT.Log.warn('Failed to save SessionID');
    }
}
function $0a6bf5a700218675$var$_loadFromStorage(sdkKey) {
    const storageKey = $0a6bf5a700218675$var$_getSessionIDStorageKey(sdkKey);
    return (0, $hlXcM._getObjectFromStorage)(storageKey);
}

});

parcelRegister("3kqeB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});


parcelRegister("3MDN6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("XhJBy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gW65n", function(module, exports) {
"use strict";
var $c546c89f66c5a164$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $bYNP6 = parcelRequire("bYNP6");

var $bYNP6 = parcelRequire("bYNP6");

var $amoop = parcelRequire("amoop");

var $lo1Ts = parcelRequire("lo1Ts");

var $1OvFT = parcelRequire("1OvFT");

var $3atRr = parcelRequire("3atRr");

var $jXGyN = parcelRequire("jXGyN");

var $TtqbT = parcelRequire("TtqbT");

var $c3GX9 = parcelRequire("c3GX9");

var $hZDgH = parcelRequire("hZDgH");

var $hlXcM = parcelRequire("hlXcM");
const $c546c89f66c5a164$var$MAX_MEMO_CACHE_SIZE = 3000;
class $c546c89f66c5a164$var$StatsigClientBase {
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $hlXcM.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $c3GX9.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($hZDgH.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $c546c89f66c5a164$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $1OvFT.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $3atRr.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $c546c89f66c5a164$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($1OvFT.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $hlXcM.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $TtqbT.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $hlXcM.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $c3GX9.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $c3GX9.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $lo1Ts.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $amoop.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $hlXcM.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $c546c89f66c5a164$var$_assignGlobalInstance(sdkKey, this);
    }
}
module.exports.StatsigClientBase = $c546c89f66c5a164$var$StatsigClientBase;
function $c546c89f66c5a164$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $jXGyN._isServerEnv)()) return;
    const statsigGlobal = (0, $bYNP6._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $1OvFT.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("hVWUO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("esLeu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2KqEX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $1OvFT = parcelRequire("1OvFT");

var $7QLuf = parcelRequire("7QLuf");
const $20048eaf2046d967$var$DEFAULT_RULE = 'default';
function $20048eaf2046d967$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : $20048eaf2046d967$var$DEFAULT_RULE,
        __evaluation: evaluation,
        value: value
    };
}
function $20048eaf2046d967$var$_makeFeatureGate(name, details, evaluation) {
    return $20048eaf2046d967$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true);
}
module.exports._makeFeatureGate = $20048eaf2046d967$var$_makeFeatureGate;
function $20048eaf2046d967$var$_makeDynamicConfig(name, details, evaluation) {
    var _a;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $20048eaf2046d967$var$_makeEvaluation(name, details, evaluation, value)), {
        get: $20048eaf2046d967$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $20048eaf2046d967$var$_makeDynamicConfig;
function $20048eaf2046d967$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $20048eaf2046d967$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $20048eaf2046d967$var$_makeExperiment;
function $20048eaf2046d967$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $20048eaf2046d967$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $20048eaf2046d967$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $20048eaf2046d967$var$_makeLayer;
function $20048eaf2046d967$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $20048eaf2046d967$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $20048eaf2046d967$var$_mergeOverride;
function $20048eaf2046d967$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $7QLuf._isTypeMatch)(found, fallback)) {
            $1OvFT.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $20048eaf2046d967$var$_makeTypedGet;

});

parcelRegister("kI8Ae", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2PmEk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $20f1e9e2fea8e3df$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $20f1e9e2fea8e3df$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});


parcelRegister("j9spr", function(module, exports) {

var $jE5aI = parcelRequire("jE5aI");

var $4Qso2 = parcelRequire("4Qso2");

var $5ng8R = parcelRequire("5ng8R");

var $lF2K2 = parcelRequire("lF2K2");
function $df14e51c7c25c788$var$_toConsumableArray(r) {
    return $jE5aI(r) || $4Qso2(r) || $5ng8R(r) || $lF2K2();
}
module.exports = $df14e51c7c25c788$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jE5aI", function(module, exports) {

var $hOZt4 = parcelRequire("hOZt4");
function $e4d5c3c2aaa74da7$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $hOZt4(r);
}
module.exports = $e4d5c3c2aaa74da7$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4Qso2", function(module, exports) {
function $387209bfaa84eb03$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $387209bfaa84eb03$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lF2K2", function(module, exports) {
function $fc4f8dbd031a00db$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $fc4f8dbd031a00db$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("iDep4", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $7KQqJ = parcelRequire("7KQqJ");
function $d9070abd96403449$var$emptyFunction() {}
function $d9070abd96403449$var$emptyFunctionWithReset() {}
$d9070abd96403449$var$emptyFunctionWithReset.resetWarningCache = $d9070abd96403449$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $7KQqJ) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $d9070abd96403449$var$emptyFunctionWithReset,
        resetWarningCache: $d9070abd96403449$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("7KQqJ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $5a557fcd99e4c0a9$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $5a557fcd99e4c0a9$var$ReactPropTypesSecret;

});


parcelRegister("aUDbt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("gCO79")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("gCO79")).Icon; });

var $gCO79 = parcelRequire("gCO79");

});
parcelRegister("gCO79", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $c1a7119776c80d6a$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $c1a7119776c80d6a$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $c1a7119776c80d6a$var$svgStyles = null;
var $c1a7119776c80d6a$var$iconStyles = null;
var $c1a7119776c80d6a$var$smallIconStyles = null;
var $c1a7119776c80d6a$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $c1a7119776c80d6a$var$baseHcmStyles = null;
var $c1a7119776c80d6a$var$scaleSize = null;
var $c1a7119776c80d6a$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $c1a7119776c80d6a$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $c1a7119776c80d6a$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $c1a7119776c80d6a$export$f04a61298a47a40f = /*#__PURE__*/ (0, $7fPBF.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $c1a7119776c80d6a$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $fjFkG.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $fjFkG.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $c1a7119776c80d6a$var$coreSizeSmall[spacing] : $c1a7119776c80d6a$var$coreSizeMedium[spacing]
        ])
    }));
});
var $c1a7119776c80d6a$export$2e2bcd8739ae039 = $c1a7119776c80d6a$export$f04a61298a47a40f;

});
parcelRegister("fjFkG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b268b12df0727654$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $b268b12df0727654$var$ATOMIC_GROUP_LENGTH = 5;
function $b268b12df0727654$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $b268b12df0727654$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});



parcelRegister("8fG9o", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("965si")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("965si")).Icon; });

var $965si = parcelRequire("965si");

});
parcelRegister("965si", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $69f8e7f1fbe987fb$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $69f8e7f1fbe987fb$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $7StG6 = parcelRequire("7StG6");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $69f8e7f1fbe987fb$var$svgStyles = null;
var $69f8e7f1fbe987fb$var$iconStyles = null;
var $69f8e7f1fbe987fb$var$smallIconStyles = null;
var $69f8e7f1fbe987fb$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $69f8e7f1fbe987fb$var$baseHcmStyles = null;
var $69f8e7f1fbe987fb$var$scaleSize = null;
var $69f8e7f1fbe987fb$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $69f8e7f1fbe987fb$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $69f8e7f1fbe987fb$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $69f8e7f1fbe987fb$export$f04a61298a47a40f = /*#__PURE__*/ (0, $7fPBF.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $69f8e7f1fbe987fb$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $7StG6.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $7StG6.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $69f8e7f1fbe987fb$var$coreSizeSmall[spacing] : $69f8e7f1fbe987fb$var$coreSizeMedium[spacing]
        ])
    }));
});
var $69f8e7f1fbe987fb$export$2e2bcd8739ae039 = $69f8e7f1fbe987fb$export$f04a61298a47a40f;

});
parcelRegister("7StG6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bc498fe0979cc94$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $5bc498fe0979cc94$var$ATOMIC_GROUP_LENGTH = 5;
function $5bc498fe0979cc94$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $5bc498fe0979cc94$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});



parcelRegister("45MkT", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $2fad1f91101d4119$export$2b8d127b894957b9; }, function (v) { return $2fad1f91101d4119$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $2fad1f91101d4119$export$cea3a54a6425200c; }, function (v) { return $2fad1f91101d4119$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $2fad1f91101d4119$export$a7c73072b1a182ae; }, function (v) { return $2fad1f91101d4119$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $2fad1f91101d4119$export$9f27bc3417b4524d; }, function (v) { return $2fad1f91101d4119$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $2fad1f91101d4119$export$db77ccec0bb4ccac; }, function (v) { return $2fad1f91101d4119$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $2fad1f91101d4119$export$8392c0c9d3dcbd35; }, function (v) { return $2fad1f91101d4119$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $2fad1f91101d4119$export$ffb0004e005737fa; }, function (v) { return $2fad1f91101d4119$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $2fad1f91101d4119$export$b624eff549462981; }, function (v) { return $2fad1f91101d4119$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $2fad1f91101d4119$export$7897aa7841a5380c; }, function (v) { return $2fad1f91101d4119$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $2fad1f91101d4119$export$602eac185826482c; }, function (v) { return $2fad1f91101d4119$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $2fad1f91101d4119$export$e2c29f18771995cb; }, function (v) { return $2fad1f91101d4119$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $2fad1f91101d4119$export$5f8d39834fd61797; }, function (v) { return $2fad1f91101d4119$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $2fad1f91101d4119$export$74bf444e3cd11ea5; }, function (v) { return $2fad1f91101d4119$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $2fad1f91101d4119$export$92387174baf9b227; }, function (v) { return $2fad1f91101d4119$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $2fad1f91101d4119$export$ec112efeb987d9c6; }, function (v) { return $2fad1f91101d4119$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $2fad1f91101d4119$export$b706b080d889d2c9; }, function (v) { return $2fad1f91101d4119$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $2fad1f91101d4119$export$5be5a87408f70ddc; }, function (v) { return $2fad1f91101d4119$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $2fad1f91101d4119$export$45a5e7f76e0caa8d; }, function (v) { return $2fad1f91101d4119$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $2fad1f91101d4119$export$455c2e768291efa6; }, function (v) { return $2fad1f91101d4119$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $2fad1f91101d4119$export$9522e17588c12572; }, function (v) { return $2fad1f91101d4119$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $2fad1f91101d4119$export$2110ac352bb060b9; }, function (v) { return $2fad1f91101d4119$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $2fad1f91101d4119$export$56885ab8b9c456ab; }, function (v) { return $2fad1f91101d4119$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $2fad1f91101d4119$export$d927fcb6adf8f9de; }, function (v) { return $2fad1f91101d4119$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $2fad1f91101d4119$export$b82d16f27459e05a; }, function (v) { return $2fad1f91101d4119$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $2fad1f91101d4119$export$522c17b4f5e123e8; }, function (v) { return $2fad1f91101d4119$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $2fad1f91101d4119$export$1aabd8a0274ecfd6; }, function (v) { return $2fad1f91101d4119$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $2fad1f91101d4119$export$9b621391a187a31a; }, function (v) { return $2fad1f91101d4119$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $2fad1f91101d4119$export$f5bbd400c2f4426f; }, function (v) { return $2fad1f91101d4119$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2fad1f91101d4119$export$2b8d127b894957b9;
var $2fad1f91101d4119$export$cea3a54a6425200c;
var $2fad1f91101d4119$export$a7c73072b1a182ae;
var $2fad1f91101d4119$export$9f27bc3417b4524d;
var $2fad1f91101d4119$export$db77ccec0bb4ccac;
var $2fad1f91101d4119$export$8392c0c9d3dcbd35;
var $2fad1f91101d4119$export$ffb0004e005737fa;
var $2fad1f91101d4119$export$b624eff549462981;
var $2fad1f91101d4119$export$7897aa7841a5380c;
var $2fad1f91101d4119$export$602eac185826482c;
var $2fad1f91101d4119$export$e2c29f18771995cb;
var $2fad1f91101d4119$export$5f8d39834fd61797;
var $2fad1f91101d4119$export$74bf444e3cd11ea5;
var $2fad1f91101d4119$export$92387174baf9b227;
var $2fad1f91101d4119$export$ec112efeb987d9c6;
var $2fad1f91101d4119$export$b706b080d889d2c9;
var $2fad1f91101d4119$export$5be5a87408f70ddc;
var $2fad1f91101d4119$export$45a5e7f76e0caa8d;
var $2fad1f91101d4119$export$455c2e768291efa6;
var $2fad1f91101d4119$export$9522e17588c12572;
var $2fad1f91101d4119$export$2110ac352bb060b9;
var $2fad1f91101d4119$export$56885ab8b9c456ab;
var $2fad1f91101d4119$export$d927fcb6adf8f9de;
var $2fad1f91101d4119$export$b82d16f27459e05a;
var $2fad1f91101d4119$export$522c17b4f5e123e8;
var $2fad1f91101d4119$export$1aabd8a0274ecfd6;
var $2fad1f91101d4119$export$9b621391a187a31a;
var $2fad1f91101d4119$export$f5bbd400c2f4426f;
'use strict';
var $2fad1f91101d4119$var$b = "function" === typeof Symbol && Symbol.for, $2fad1f91101d4119$var$c = $2fad1f91101d4119$var$b ? Symbol.for("react.element") : 60103, $2fad1f91101d4119$var$d = $2fad1f91101d4119$var$b ? Symbol.for("react.portal") : 60106, $2fad1f91101d4119$var$e = $2fad1f91101d4119$var$b ? Symbol.for("react.fragment") : 60107, $2fad1f91101d4119$var$f = $2fad1f91101d4119$var$b ? Symbol.for("react.strict_mode") : 60108, $2fad1f91101d4119$var$g = $2fad1f91101d4119$var$b ? Symbol.for("react.profiler") : 60114, $2fad1f91101d4119$var$h = $2fad1f91101d4119$var$b ? Symbol.for("react.provider") : 60109, $2fad1f91101d4119$var$k = $2fad1f91101d4119$var$b ? Symbol.for("react.context") : 60110, $2fad1f91101d4119$var$l = $2fad1f91101d4119$var$b ? Symbol.for("react.async_mode") : 60111, $2fad1f91101d4119$var$m = $2fad1f91101d4119$var$b ? Symbol.for("react.concurrent_mode") : 60111, $2fad1f91101d4119$var$n = $2fad1f91101d4119$var$b ? Symbol.for("react.forward_ref") : 60112, $2fad1f91101d4119$var$p = $2fad1f91101d4119$var$b ? Symbol.for("react.suspense") : 60113, $2fad1f91101d4119$var$q = $2fad1f91101d4119$var$b ? Symbol.for("react.suspense_list") : 60120, $2fad1f91101d4119$var$r = $2fad1f91101d4119$var$b ? Symbol.for("react.memo") : 60115, $2fad1f91101d4119$var$t = $2fad1f91101d4119$var$b ? Symbol.for("react.lazy") : 60116, $2fad1f91101d4119$var$v = $2fad1f91101d4119$var$b ? Symbol.for("react.block") : 60121, $2fad1f91101d4119$var$w = $2fad1f91101d4119$var$b ? Symbol.for("react.fundamental") : 60117, $2fad1f91101d4119$var$x = $2fad1f91101d4119$var$b ? Symbol.for("react.responder") : 60118, $2fad1f91101d4119$var$y = $2fad1f91101d4119$var$b ? Symbol.for("react.scope") : 60119;
function $2fad1f91101d4119$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $2fad1f91101d4119$var$c:
                switch(a = a.type, a){
                    case $2fad1f91101d4119$var$l:
                    case $2fad1f91101d4119$var$m:
                    case $2fad1f91101d4119$var$e:
                    case $2fad1f91101d4119$var$g:
                    case $2fad1f91101d4119$var$f:
                    case $2fad1f91101d4119$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $2fad1f91101d4119$var$k:
                            case $2fad1f91101d4119$var$n:
                            case $2fad1f91101d4119$var$t:
                            case $2fad1f91101d4119$var$r:
                            case $2fad1f91101d4119$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $2fad1f91101d4119$var$d:
                return u;
        }
    }
}
function $2fad1f91101d4119$var$A(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$m;
}
$2fad1f91101d4119$export$2b8d127b894957b9 = $2fad1f91101d4119$var$l;
$2fad1f91101d4119$export$cea3a54a6425200c = $2fad1f91101d4119$var$m;
$2fad1f91101d4119$export$a7c73072b1a182ae = $2fad1f91101d4119$var$k;
$2fad1f91101d4119$export$9f27bc3417b4524d = $2fad1f91101d4119$var$h;
$2fad1f91101d4119$export$db77ccec0bb4ccac = $2fad1f91101d4119$var$c;
$2fad1f91101d4119$export$8392c0c9d3dcbd35 = $2fad1f91101d4119$var$n;
$2fad1f91101d4119$export$ffb0004e005737fa = $2fad1f91101d4119$var$e;
$2fad1f91101d4119$export$b624eff549462981 = $2fad1f91101d4119$var$t;
$2fad1f91101d4119$export$7897aa7841a5380c = $2fad1f91101d4119$var$r;
$2fad1f91101d4119$export$602eac185826482c = $2fad1f91101d4119$var$d;
$2fad1f91101d4119$export$e2c29f18771995cb = $2fad1f91101d4119$var$g;
$2fad1f91101d4119$export$5f8d39834fd61797 = $2fad1f91101d4119$var$f;
$2fad1f91101d4119$export$74bf444e3cd11ea5 = $2fad1f91101d4119$var$p;
$2fad1f91101d4119$export$92387174baf9b227 = function(a) {
    return $2fad1f91101d4119$var$A(a) || $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$l;
};
$2fad1f91101d4119$export$ec112efeb987d9c6 = $2fad1f91101d4119$var$A;
$2fad1f91101d4119$export$b706b080d889d2c9 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$k;
};
$2fad1f91101d4119$export$5be5a87408f70ddc = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$h;
};
$2fad1f91101d4119$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2fad1f91101d4119$var$c;
};
$2fad1f91101d4119$export$455c2e768291efa6 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$n;
};
$2fad1f91101d4119$export$9522e17588c12572 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$e;
};
$2fad1f91101d4119$export$2110ac352bb060b9 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$t;
};
$2fad1f91101d4119$export$56885ab8b9c456ab = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$r;
};
$2fad1f91101d4119$export$d927fcb6adf8f9de = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$d;
};
$2fad1f91101d4119$export$b82d16f27459e05a = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$g;
};
$2fad1f91101d4119$export$522c17b4f5e123e8 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$f;
};
$2fad1f91101d4119$export$1aabd8a0274ecfd6 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$p;
};
$2fad1f91101d4119$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $2fad1f91101d4119$var$e || a === $2fad1f91101d4119$var$m || a === $2fad1f91101d4119$var$g || a === $2fad1f91101d4119$var$f || a === $2fad1f91101d4119$var$p || a === $2fad1f91101d4119$var$q || "object" === typeof a && null !== a && (a.$$typeof === $2fad1f91101d4119$var$t || a.$$typeof === $2fad1f91101d4119$var$r || a.$$typeof === $2fad1f91101d4119$var$h || a.$$typeof === $2fad1f91101d4119$var$k || a.$$typeof === $2fad1f91101d4119$var$n || a.$$typeof === $2fad1f91101d4119$var$w || a.$$typeof === $2fad1f91101d4119$var$x || a.$$typeof === $2fad1f91101d4119$var$y || a.$$typeof === $2fad1f91101d4119$var$v);
};
$2fad1f91101d4119$export$f5bbd400c2f4426f = $2fad1f91101d4119$var$z;

});

parcelRegister("2xvCh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("cYpPP")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("cYpPP")).Icon; });

var $cYpPP = parcelRequire("cYpPP");

});
parcelRegister("cYpPP", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $971f20ea9df3fea3$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $971f20ea9df3fea3$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $7StG6 = parcelRequire("7StG6");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $971f20ea9df3fea3$var$svgStyles = null;
var $971f20ea9df3fea3$var$iconStyles = null;
var $971f20ea9df3fea3$var$smallIconStyles = null;
var $971f20ea9df3fea3$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $971f20ea9df3fea3$var$baseHcmStyles = null;
var $971f20ea9df3fea3$var$scaleSize = null;
var $971f20ea9df3fea3$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $971f20ea9df3fea3$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $971f20ea9df3fea3$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $971f20ea9df3fea3$export$f04a61298a47a40f = /*#__PURE__*/ (0, $7fPBF.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $971f20ea9df3fea3$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $7StG6.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $7StG6.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $971f20ea9df3fea3$var$coreSizeSmall[spacing] : $971f20ea9df3fea3$var$coreSizeMedium[spacing]
        ])
    }));
});
var $971f20ea9df3fea3$export$2e2bcd8739ae039 = $971f20ea9df3fea3$export$f04a61298a47a40f;

});


parcelRegister("gQJxI", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $c444d4863d2b604b$export$4ef52930e33717cd; });
$parcel$export(module.exports, "SUBTREE_THEME_ATTRIBUTE", function () { return $c444d4863d2b604b$export$cb374d25ded7f6ab; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $c444d4863d2b604b$export$a00eac3f8684bcd0; });
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", function () { return $c444d4863d2b604b$export$2112803007239c61; });
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", function () { return $c444d4863d2b604b$export$352e418ed5b6193a; });
var $c444d4863d2b604b$export$4ef52930e33717cd = 'data-theme';
var $c444d4863d2b604b$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $c444d4863d2b604b$export$a00eac3f8684bcd0 = 'data-color-mode';
var $c444d4863d2b604b$export$2112803007239c61 = 'data-contrast-mode';
var $c444d4863d2b604b$export$352e418ed5b6193a = 'data-custom-theme';
var $c444d4863d2b604b$export$6f0c6fb8c80fcc92 = 'ds';
var $c444d4863d2b604b$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $c444d4863d2b604b$export$dddac1532e822863 = "--".concat($c444d4863d2b604b$export$6f0c6fb8c80fcc92, "-token-not-found");
var $c444d4863d2b604b$export$9d7b58831ae93caa = "--".concat($c444d4863d2b604b$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("jONa6", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", function () { return $e6d8d25ebbe07ddc$export$83993de8eb66733; });
$parcel$export(module.exports, "themeIds", function () { return $e6d8d25ebbe07ddc$export$7d43e72a58e3283f; });
$parcel$export(module.exports, "themeStateDefaults", function () { return $e6d8d25ebbe07ddc$export$9aedcfa7336a207; });
$parcel$export(module.exports, "default", function () { return $e6d8d25ebbe07ddc$export$2e2bcd8739ae039; });

var $137Lh = parcelRequire("137Lh");
var $e6d8d25ebbe07ddc$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ var $e6d8d25ebbe07ddc$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
var $e6d8d25ebbe07ddc$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $e6d8d25ebbe07ddc$var$themeOverrideIds = [];
var $e6d8d25ebbe07ddc$export$92ba366331403db2 = [].concat($e6d8d25ebbe07ddc$export$7d43e72a58e3283f, $e6d8d25ebbe07ddc$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $e6d8d25ebbe07ddc$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
/**
 * ThemeOptionsSchema: additional configuration options used to customize Atlassian's themes
 */ /**
 * ThemeState: the standard representation of an app's current theme and preferences
 */ /**
 * Can't evaluate typography feature flags at the module level,
 * it will always resolve to false when server side rendered or when flags are loaded async.
 */ function $e6d8d25ebbe07ddc$var$getShapeDefault() {
    if ((0, $137Lh.fg)('platform-dst-shape-theme-default')) return 'shape';
    return undefined;
}
function $e6d8d25ebbe07ddc$var$getMotionDefault() {
    if ((0, $137Lh.fg)('platform-dst-motion-theme-default')) return 'motion';
    return undefined;
}
var $e6d8d25ebbe07ddc$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: $e6d8d25ebbe07ddc$var$getShapeDefault,
    spacing: 'spacing',
    typography: 'typography',
    motion: $e6d8d25ebbe07ddc$var$getMotionDefault,
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $e6d8d25ebbe07ddc$export$2e2bcd8739ae039 = $e6d8d25ebbe07ddc$var$themeConfig;

});
parcelRegister("137Lh", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $0c3c1789006e2563$export$b40ec24ac8275656; });

var $NJYzu = parcelRequire("NJYzu");
function $0c3c1789006e2563$export$ba05d765b8392e5e(flagResolver) {
    (0, $NJYzu.setBooleanResolver)(flagResolver);
}
function $0c3c1789006e2563$export$470e5c2be1411c89(name) {
    return (0, $NJYzu.resolveBooleanFlag)(name);
}
function $0c3c1789006e2563$export$b40ec24ac8275656(name) {
    return (0, $NJYzu.resolveBooleanFlag)(name);
}

});
parcelRegister("NJYzu", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $09583d95e063b91a$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $09583d95e063b91a$export$6333b6aff9fc6275; });

var $6gsEP = parcelRequire("6gsEP");

var $8w2cM = parcelRequire("8w2cM");
var $09583d95e063b91a$var$pkgName = '@atlaskit/platform-feature-flags';
var $09583d95e063b91a$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $09583d95e063b91a$var$hasProcessEnv = false;
// FF global overrides can be configured by test runners or Storybook
var $09583d95e063b91a$var$ENV_ENABLE_PLATFORM_FF = $09583d95e063b91a$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $09583d95e063b91a$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $09583d95e063b91a$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $09583d95e063b91a$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $09583d95e063b91a$var$ENV_ENABLE_PLATFORM_FF || $09583d95e063b91a$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $09583d95e063b91a$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $09583d95e063b91a$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$09583d95e063b91a$var$globalVar[$09583d95e063b91a$export$7e41b1b2bdee3f98] = $09583d95e063b91a$var$globalVar[$09583d95e063b91a$export$7e41b1b2bdee3f98] || $09583d95e063b91a$var$DEFAULT_PFF_GLOBAL;
function $09583d95e063b91a$export$f2b591175b3e424c(resolver) {
    $09583d95e063b91a$var$globalVar[$09583d95e063b91a$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $09583d95e063b91a$export$6333b6aff9fc6275(flagKey) {
    if ($09583d95e063b91a$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $8w2cM.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $09583d95e063b91a$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $09583d95e063b91a$var$globalVar[$09583d95e063b91a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $09583d95e063b91a$var$globalVar[$09583d95e063b91a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $6gsEP.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $09583d95e063b91a$var$globalVar[$09583d95e063b91a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("6gsEP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48fa778320c3ddc4$export$2e2bcd8739ae039; });

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $8MJe2 = parcelRequire("8MJe2");

var $7mn8t = parcelRequire("7mn8t");

var $cS3lQ = parcelRequire("cS3lQ");



var $48fa778320c3ddc4$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $48fa778320c3ddc4$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$48fa778320c3ddc4$var$_FeatureGates = $48fa778320c3ddc4$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "client", new (0, $7mn8t.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$48fa778320c3ddc4$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $48fa778320c3ddc4$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $48fa778320c3ddc4$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$48fa778320c3ddc4$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $48fa778320c3ddc4$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $48fa778320c3ddc4$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "initializeCalled", $48fa778320c3ddc4$var$_FeatureGates.client.initializeCalled.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "initializeCompleted", $48fa778320c3ddc4$var$_FeatureGates.client.initializeCompleted.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "initialize", $48fa778320c3ddc4$var$_FeatureGates.client.initialize.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "initializeWithProvider", $48fa778320c3ddc4$var$_FeatureGates.client.initializeWithProvider.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "initializeFromValues", $48fa778320c3ddc4$var$_FeatureGates.client.initializeFromValues.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "manuallyLogGateExposure", $48fa778320c3ddc4$var$_FeatureGates.client.manuallyLogGateExposure.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "getExperiment", $48fa778320c3ddc4$var$_FeatureGates.client.getExperiment.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "manuallyLogExperimentExposure", $48fa778320c3ddc4$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "manuallyLogLayerExposure", $48fa778320c3ddc4$var$_FeatureGates.client.manuallyLogLayerExposure.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "shutdownStatsig", $48fa778320c3ddc4$var$_FeatureGates.client.shutdownStatsig.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "overrideGate", $48fa778320c3ddc4$var$_FeatureGates.client.overrideGate.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "clearGateOverride", $48fa778320c3ddc4$var$_FeatureGates.client.clearGateOverride.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "overrideConfig", $48fa778320c3ddc4$var$_FeatureGates.client.overrideConfig.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "clearConfigOverride", $48fa778320c3ddc4$var$_FeatureGates.client.clearConfigOverride.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "setOverrides", $48fa778320c3ddc4$var$_FeatureGates.client.setOverrides.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "getOverrides", $48fa778320c3ddc4$var$_FeatureGates.client.getOverrides.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "clearAllOverrides", $48fa778320c3ddc4$var$_FeatureGates.client.clearAllOverrides.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "isCurrentUser", $48fa778320c3ddc4$var$_FeatureGates.client.isCurrentUser.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "onGateUpdated", $48fa778320c3ddc4$var$_FeatureGates.client.onGateUpdated.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "onExperimentValueUpdated", $48fa778320c3ddc4$var$_FeatureGates.client.onExperimentValueUpdated.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "onAnyUpdated", $48fa778320c3ddc4$var$_FeatureGates.client.onAnyUpdated.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "updateUser", $48fa778320c3ddc4$var$_FeatureGates.client.updateUser.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "updateUserWithProvider", $48fa778320c3ddc4$var$_FeatureGates.client.updateUserWithProvider.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "updateUserWithValues", $48fa778320c3ddc4$var$_FeatureGates.client.updateUserWithValues.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "getPackageVersion", $48fa778320c3ddc4$var$_FeatureGates.client.getPackageVersion.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "getLayer", $48fa778320c3ddc4$var$_FeatureGates.client.getLayer.bind($48fa778320c3ddc4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($48fa778320c3ddc4$var$FeatureGates, "getLayerValue", $48fa778320c3ddc4$var$_FeatureGates.client.getLayerValue.bind($48fa778320c3ddc4$var$_FeatureGates.client));
var $48fa778320c3ddc4$var$boundFGJS = $48fa778320c3ddc4$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $48fa778320c3ddc4$var$FeatureGates;
    else {
        var $48fa778320c3ddc4$var$_boundFGJS, $48fa778320c3ddc4$var$_boundFGJS$getPackage;
        $48fa778320c3ddc4$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $48fa778320c3ddc4$var$boundVersion = (($48fa778320c3ddc4$var$_boundFGJS = $48fa778320c3ddc4$var$boundFGJS) === null || $48fa778320c3ddc4$var$_boundFGJS === void 0 || ($48fa778320c3ddc4$var$_boundFGJS$getPackage = $48fa778320c3ddc4$var$_boundFGJS.getPackageVersion) === null || $48fa778320c3ddc4$var$_boundFGJS$getPackage === void 0 ? void 0 : $48fa778320c3ddc4$var$_boundFGJS$getPackage.call($48fa778320c3ddc4$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($48fa778320c3ddc4$var$boundVersion !== (0, $cS3lQ.CLIENT_VERSION)) {
            var $48fa778320c3ddc4$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($48fa778320c3ddc4$var$boundVersion, " when module version ").concat((0, $cS3lQ.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($48fa778320c3ddc4$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $48fa778320c3ddc4$export$2e2bcd8739ae039 = $48fa778320c3ddc4$var$boundFGJS;

});
parcelRegister("7mn8t", function(module, exports) {

$parcel$export(module.exports, "Client", function () { return $55bc88bc5929681a$export$1f2bb630327ac4b6; });

var $emuQy = parcelRequire("emuQy");

var $iKdEz = parcelRequire("iKdEz");

var $1uJLd = parcelRequire("1uJLd");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $8MJe2 = parcelRequire("8MJe2");

var $iQsIh = parcelRequire("iQsIh");

var $79kyO = parcelRequire("79kyO");

var $jiToV = parcelRequire("jiToV");

var $dj9zK = parcelRequire("dj9zK");

var $h6BJU = parcelRequire("h6BJU");

var $cTgM0 = parcelRequire("cTgM0");

var $78a3d = parcelRequire("78a3d");

var $1Jw6w = parcelRequire("1Jw6w");

var $24YjW = parcelRequire("24YjW");

var $brodC = parcelRequire("brodC");

var $dsuun = parcelRequire("dsuun");

var $cS3lQ = parcelRequire("cS3lQ");
var $55bc88bc5929681a$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $55bc88bc5929681a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $55bc88bc5929681a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $55bc88bc5929681a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $55bc88bc5929681a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $55bc88bc5929681a$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $55bc88bc5929681a$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $55bc88bc5929681a$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $24YjW.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "subscriptions", new (0, $jiToV.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "dataAdapter", new (0, $1Jw6w.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $24YjW.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $dsuun.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $dsuun.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $dsuun.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $dsuun.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $cS3lQ.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $55bc88bc5929681a$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $cS3lQ.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $brodC.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $dsuun.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $dsuun.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x10) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $dsuun.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $78a3d.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x11, _x12, _x13) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x14, _x15) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x16, _x17) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $dj9zK.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $dj9zK.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $cTgM0.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $dsuun.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $dsuun.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee7(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                fromValuesClientOptions = $55bc88bc5929681a$var$_objectSpread({}, clientOptions);
                                _context7.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $78a3d.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $78a3d.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context7.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context7.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context7.next = 20;
                                break;
                            case 13:
                                _context7.prev = 13;
                                _context7.t0 = _context7["catch"](1);
                                if (_context7.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context7.t0 === null || _context7.t0 === void 0 ? void 0 : _context7.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context7.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context7.t0;
                            case 20:
                                return _context7.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x18, _x19, _x20) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee8(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $55bc88bc5929681a$var$_objectSpread($55bc88bc5929681a$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context8.prev = 1;
                                _context8.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context8.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context8.next = 22;
                                break;
                            case 15:
                                _context8.prev = 15;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context8.t0;
                            case 22:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x21, _x22, _x23, _x24) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee9(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args9 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                initializeValues = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $dsuun.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $55bc88bc5929681a$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $55bc88bc5929681a$var$_objectSpread($55bc88bc5929681a$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $55bc88bc5929681a$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $brodC.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(newClientOptions, $55bc88bc5929681a$var$_excluded);
                                this.sdkKey = sdkKey;
                                this.user = (0, $dsuun.toStatsigUser)(identifiers, customAttributes, this.sdkKey);
                                statsigOptions = $55bc88bc5929681a$var$_objectSpread($55bc88bc5929681a$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter
                                });
                                _context9.prev = 12;
                                this.statsigClient = new (0, $79kyO.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context9.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context9.next = 29;
                                break;
                            case 19:
                                _context9.prev = 19;
                                _context9.t0 = _context9["catch"](12);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $79kyO.StatsigClient)($55bc88bc5929681a$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context9.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context9.t0;
                            case 29:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x25, _x26, _x27) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee11(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context11.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context11.next = 5;
                                    break;
                                }
                                return _context11.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context11.prev = 6;
                                _context11.next = 9;
                                return this.initPromise;
                            case 9:
                                _context11.next = 13;
                                break;
                            case 11:
                                _context11.prev = 11;
                                _context11.t0 = _context11["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee10() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee10$(_context10) {
                                        while(true)switch(_context10.prev = _context10.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context10.next = 4;
                                                    break;
                                                }
                                                _context10.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context10.stop();
                                        }
                                    }, _callee10);
                                })));
                                return _context11.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x28, _x29, _x30) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee12(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee12$(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context12.prev = 1;
                                _context12.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context12.sent;
                                user = (0, $dsuun.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch, this.sdkKey);
                                _context12.next = 13;
                                break;
                            case 8:
                                _context12.prev = 8;
                                _context12.t0 = _context12["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context12.t0 instanceof Error ? _context12.t0.message : JSON.stringify(_context12.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context12.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context12.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                _context12.next = 20;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 20:
                                _context12.next = 26;
                                break;
                            case 22:
                                _context12.prev = 22;
                                _context12.t1 = _context12["catch"](15);
                                success = false;
                                errorMessage = String(_context12.t1);
                            case 26:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context12.next = 33;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context12.next = 34;
                                break;
                            case 33:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 34:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee12, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            22
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x31, _x32, _x33) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $cS3lQ.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $h6BJU.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $h6BJU.Layer).fromLayer((0, $79kyO._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("emuQy", function(module, exports) {

var $1ifJj = parcelRequire("1ifJj");
function $a74b0c43386c0a1b$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $1ifJj(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $a74b0c43386c0a1b$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1ifJj", function(module, exports) {
function $0f13ac86de1755d2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $0f13ac86de1755d2$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("1uJLd", function(module, exports) {
function $116c16e6836eccc9$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $116c16e6836eccc9$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $116c16e6836eccc9$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $116c16e6836eccc9$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $116c16e6836eccc9$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("iQsIh", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $db835b247d6fea1a$var$runtime = (parcelRequire("f8tK9"))();
module.exports = $db835b247d6fea1a$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $db835b247d6fea1a$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $db835b247d6fea1a$var$runtime;
    else Function("r", "regeneratorRuntime = r")($db835b247d6fea1a$var$runtime);
}

});

parcelRegister("79kyO", function(module, exports) {
"use strict";
var $5349529342b72503$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5349529342b72503$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5349529342b72503$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $keux7 = parcelRequire("keux7");
module.exports.StatsigClient = $keux7.default;

$5349529342b72503$var$__exportStar((parcelRequire("2CTsY")), module.exports);
const $5349529342b72503$var$__STATSIG__ = Object.assign((0, (parcelRequire("2CTsY"))._getStatsigGlobal)(), {
    StatsigClient: $keux7.default
});
module.exports.default = $5349529342b72503$var$__STATSIG__;

});
parcelRegister("keux7", function(module, exports) {
"use strict";
var $ebacccb03eb5d368$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2CTsY = parcelRequire("2CTsY");

var $3Evxa = parcelRequire("3Evxa");

var $i90BU = parcelRequire("i90BU");

var $f5O9f = parcelRequire("f5O9f");

var $5Djoj = parcelRequire("5Djoj");
class $ebacccb03eb5d368$var$StatsigClient extends $2CTsY.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient|undefined} Returns the StatsigClient instance associated with the given SDK key, or undefined if no instance is associated with the key or if no key is provided and no instances exist.
     */ static instance(sdkKey) {
        const instance = (0, $2CTsY._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $ebacccb03eb5d368$var$StatsigClient) return instance;
        $2CTsY.Log.warn((0, $2CTsY._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $ebacccb03eb5d368$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $2CTsY.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $ebacccb03eb5d368$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        var _a;
        const startTime = performance.now();
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $2CTsY.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $2CTsY.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $ebacccb03eb5d368$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $2CTsY.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $2CTsY.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $2CTsY.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $2CTsY.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($2CTsY.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $2CTsY.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $2CTsY.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $2CTsY.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: JSON.parse(JSON.stringify(this._user)),
            errorBoundary: this._errorBoundary,
            session: $2CTsY.StatsigSession.get(this._sdkKey),
            stableID: $2CTsY.StableID.get(this._sdkKey)
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $ebacccb03eb5d368$var$__awaiter(this, void 0, void 0, function*() {
            if (!$2CTsY.Storage.isReady()) yield $2CTsY.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $2CTsY.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a;
        const user = (0, $2CTsY._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) $2CTsY.StableID.setOverride(stableIdOverride, this._sdkKey);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $2CTsY._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $2CTsY._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $2CTsY._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $2CTsY._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $2CTsY._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $2CTsY._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $2CTsY._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $2CTsY._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $2CTsY._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $2CTsY._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $f5O9f._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $f5O9f._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $2CTsY.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $i90BU.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $5Djoj.StatsigEvaluationsDataAdapter(), network, options);
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($2CTsY.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($2CTsY.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($2CTsY.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($2CTsY.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($2CTsY.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $3Evxa.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
}
module.exports.default = $ebacccb03eb5d368$var$StatsigClient;

});
parcelRegister("3Evxa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2CTsY = parcelRequire("2CTsY");
class $2a8d91827c0480f1$var$EvaluationStore {
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        return this._rawValues ? (0, $2CTsY._typedJsonParse)(this._rawValues, 'has_updates', 'EvaluationStoreValues') : null;
    }
    setValues(result, user) {
        var _a;
        if (!result) return false;
        const values = (0, $2CTsY._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        this._values = values;
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $2CTsY.SDKFlags.setFlags(this._sdkKey, (_a = values.sdk_flags) !== null && _a !== void 0 ? _a : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.feature_gates, name);
    }
    getConfig(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.dynamic_configs, name);
    }
    getLayer(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.layer_configs, name);
    }
    getParamStore(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.param_stores, name);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.exposures;
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(lookup, name) {
        let result = null;
        if (lookup) result = lookup[name] ? lookup[name] : lookup[(0, $2CTsY._DJB2)(name)];
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b;
        const stableID = $2CTsY.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            const bootstrapUser = values['user'];
            if ((0, $2CTsY._getFullUserHash)(user) !== (0, $2CTsY._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
}
module.exports.default = $2a8d91827c0480f1$var$EvaluationStore;

});

parcelRegister("i90BU", function(module, exports) {
"use strict";
var $d3598a7d6f7c2d52$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2CTsY = parcelRequire("2CTsY");

var $bklDq = parcelRequire("bklDq");
class $d3598a7d6f7c2d52$var$StatsigNetwork extends $2CTsY.NetworkCore {
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        var _a, _b, _c, _d, _e, _f;
        return $d3598a7d6f7c2d52$var$__awaiter(this, void 0, void 0, function*() {
            const cache = current ? (0, $2CTsY._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        var _a, _b;
        return $d3598a7d6f7c2d52$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $bklDq._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $2CTsY.UrlConfiguration($2CTsY.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
}
module.exports.default = $d3598a7d6f7c2d52$var$StatsigNetwork;

});
parcelRegister("bklDq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $2CTsY = parcelRequire("2CTsY");
const $83f258321079dcd8$var$MAX_DELTAS_SORT_DEPTH = 2;
function $83f258321079dcd8$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $2CTsY._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $83f258321079dcd8$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $83f258321079dcd8$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $2CTsY._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $83f258321079dcd8$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $83f258321079dcd8$var$_resolveDeltasResponse;
function $83f258321079dcd8$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $83f258321079dcd8$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $83f258321079dcd8$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $83f258321079dcd8$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $83f258321079dcd8$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $83f258321079dcd8$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("f5O9f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $2CTsY = parcelRequire("2CTsY");
const $afce39015f83999d$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $afce39015f83999d$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $afce39015f83999d$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $2CTsY._isTypeMatch)(value, fallback);
}
function $afce39015f83999d$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $afce39015f83999d$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $afce39015f83999d$var$_shouldLogExposure(options) ? undefined : $afce39015f83999d$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $afce39015f83999d$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $afce39015f83999d$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($afce39015f83999d$var$_shouldReturnFallback(value, fallback)) return fallback;
    if ($afce39015f83999d$var$_shouldLogExposure(options)) client.getDynamicConfig(param.config_name);
    return value;
}
function $afce39015f83999d$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $afce39015f83999d$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($afce39015f83999d$var$_shouldReturnFallback(value, fallback)) return fallback;
    if ($afce39015f83999d$var$_shouldLogExposure(options)) client.getExperiment(param.experiment_name);
    return value;
}
function $afce39015f83999d$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $afce39015f83999d$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($afce39015f83999d$var$_shouldReturnFallback(value, fallback)) return fallback;
    if ($afce39015f83999d$var$_shouldLogExposure(options)) client.getLayer(param.layer_name).get(param.param_name);
    return value;
}
function $afce39015f83999d$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $2CTsY._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $afce39015f83999d$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $afce39015f83999d$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $afce39015f83999d$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $afce39015f83999d$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $afce39015f83999d$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $afce39015f83999d$var$_makeParamStoreGetter;

});

parcelRegister("5Djoj", function(module, exports) {
"use strict";
var $419fa2f05f424de6$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $2CTsY = parcelRequire("2CTsY");

var $i90BU = parcelRequire("i90BU");
class $419fa2f05f424de6$var$StatsigEvaluationsDataAdapter extends $2CTsY.DataAdapterCore {
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $i90BU.default) this._network = network;
        else this._network = new $i90BU.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $2CTsY._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $2CTsY._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $2CTsY.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        var _a;
        return $419fa2f05f424de6$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $2CTsY._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$2CTsY.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $2CTsY._getFullUserHash)(user);
    }
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
}
module.exports.StatsigEvaluationsDataAdapter = $419fa2f05f424de6$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("jiToV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0daac4091141472$export$2e2bcd8739ae039; });

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $8MJe2 = parcelRequire("8MJe2");

var $5RCmr = parcelRequire("5RCmr");
function $e0daac4091141472$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e0daac4091141472$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e0daac4091141472$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e0daac4091141472$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e0daac4091141472$export$a66cbd9b2289cd78 = '@all-features';
var $e0daac4091141472$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "eventToValue", new Map());
        this.emitter = new (0, $5RCmr.EventEmitter2)();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $e0daac4091141472$var$_objectSpread($e0daac4091141472$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $e0daac4091141472$var$_objectSpread($e0daac4091141472$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $e0daac4091141472$var$_objectSpread($e0daac4091141472$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $e0daac4091141472$var$_objectSpread($e0daac4091141472$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($e0daac4091141472$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($e0daac4091141472$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($e0daac4091141472$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $e0daac4091141472$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});
parcelRegister("5RCmr", function(module, exports) {
/*!
 * EventEmitter2
 * https://github.com/hij1nx/EventEmitter2
 *
 * Copyright (c) 2013 hij1nx
 * Licensed under the MIT license.
 */ !function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.';
        if (this.verboseMemoryLeak) errorMsg += ' Event name: ' + eventName + '.';
        var e;
        console.error(errorMsg);
        if (console.trace) console.trace();
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === 'function') {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === '*' || currentType === '**' || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === '*') {
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === '**') {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === '*';
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                    if (branch === '*' || branch === '**') {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree['*'];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree['**'];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            '**': isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree['*'] && xxTree['*']._listeners) searchListenerTree(handlers, type, xxTree['*'], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === '**' && type[i + 1] === '**') return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === 'function') tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = '.';
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = '';
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== 'function') throw new Error('many only accepts instances of Function');
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === 'function') {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === 'function') {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== 'function') throw new Error('onAny only accepts instances of Function');
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === 'function') {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== 'function') throw new Error('on only accepts instances of Function');
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit('newListener', type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === 'function') // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== 'function') throw new Error('removeListener only takes instances of Function');
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});


parcelRegister("dj9zK", function(module, exports) {

$parcel$export(module.exports, "DynamicConfig", function () { return $9b047a34791fcd89$export$6dc24881a3d96325; });

var $bRUy3 = parcelRequire("bRUy3");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $dsuun = parcelRequire("dsuun");
var $9b047a34791fcd89$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $dsuun.migrateEvaluationDetails)(experiment.details), (_experiment$__evaluat = experiment.__evaluation) === null || _experiment$__evaluat === void 0 ? void 0 : _experiment$__evaluat.secondary_exposures, (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("dsuun", function(module, exports) {

$parcel$export(module.exports, "getOptionsWithDefaults", function () { return $9cc58a5b02dabe28$export$d119b37e5f788b43; });
$parcel$export(module.exports, "shallowEquals", function () { return $9cc58a5b02dabe28$export$fa1c2bbf4100b8bc; });
$parcel$export(module.exports, "toStatsigUser", function () { return $9cc58a5b02dabe28$export$3dad1db244472f32; });
$parcel$export(module.exports, "migrateInitializationOptions", function () { return $9cc58a5b02dabe28$export$202946b690d26d22; });
$parcel$export(module.exports, "migrateEvaluationDetails", function () { return $9cc58a5b02dabe28$export$18ad168d3dbac899; });

var $emuQy = parcelRequire("emuQy");

var $iKdEz = parcelRequire("iKdEz");

var $8MJe2 = parcelRequire("8MJe2");

var $79kyO = parcelRequire("79kyO");

var $3W4Zz = parcelRequire("3W4Zz");

var $cTgM0 = parcelRequire("cTgM0");

var $brodC = parcelRequire("brodC");
var $9cc58a5b02dabe28$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $9cc58a5b02dabe28$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9cc58a5b02dabe28$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9cc58a5b02dabe28$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9cc58a5b02dabe28$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9cc58a5b02dabe28$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $9cc58a5b02dabe28$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $3W4Zz.isFedRamp)() ? (0, $brodC.PerimeterType).FEDRAMP_MODERATE : (0, $brodC.PerimeterType).COMMERCIAL
    }, options);
};
var $9cc58a5b02dabe28$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $9cc58a5b02dabe28$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes, sdkKey) {
    var user = {
        customIDs: !(customAttributes !== null && customAttributes !== void 0 && customAttributes.stableID) && sdkKey ? $9cc58a5b02dabe28$var$_objectSpread({
            stableID: (0, $79kyO.StableID).get(sdkKey)
        }, identifiers) : identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $9cc58a5b02dabe28$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(options, $9cc58a5b02dabe28$var$_excluded);
    return $9cc58a5b02dabe28$var$_objectSpread($9cc58a5b02dabe28$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $9cc58a5b02dabe28$var$evaluationReasonMappings = Object.entries((0, $cTgM0.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $9cc58a5b02dabe28$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $9cc58a5b02dabe28$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $cTgM0.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};

});
parcelRegister("3W4Zz", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", function () { return $2ddaa92e960ad312$export$64d6499adf9b2e51; });

var $iMwX0 = parcelRequire("iMwX0");
function $2ddaa92e960ad312$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $iMwX0.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("iMwX0", function(module, exports) {

$parcel$export(module.exports, "FEDRAMP_MODERATE", function () { return $dac64503d92b351f$export$ce553301d55c2fd8; });
var $dac64503d92b351f$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $dac64503d92b351f$export$f005e2e9f707cb5f = 'commercial';
var $dac64503d92b351f$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $dac64503d92b351f$export$a739cd5aac835909 = 'stg';
var $dac64503d92b351f$export$42dd0cdd351a4a9 = 'prod';
var $dac64503d92b351f$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("cTgM0", function(module, exports) {

$parcel$export(module.exports, "EvaluationReason", function () { return $9627a1edabe8e16f$export$c62558b199e46828; });
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $9627a1edabe8e16f$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("brodC", function(module, exports) {

$parcel$export(module.exports, "FeatureGateEnvironment", function () { return $854500a24eab0ab1$export$479e7351a733299; });
$parcel$export(module.exports, "PerimeterType", function () { return $854500a24eab0ab1$export$c42b7bbc5e7ba555; });
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $854500a24eab0ab1$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $854500a24eab0ab1$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $854500a24eab0ab1$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("h6BJU", function(module, exports) {

$parcel$export(module.exports, "Layer", function () { return $c740457648a6c813$export$936d0764594b6eb3; });

var $bRUy3 = parcelRequire("bRUy3");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $dsuun = parcelRequire("dsuun");
var $c740457648a6c813$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $dsuun.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures, (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures, (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("78a3d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $531113a0d47384e3$export$2e2bcd8739ae039; });

var $8MJe2 = parcelRequire("8MJe2");

var $1uJLd = parcelRequire("1uJLd");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $iQsIh = parcelRequire("iQsIh");

var $brodC = parcelRequire("brodC");

var $cS3lQ = parcelRequire("cS3lQ");

var $6ojtq = parcelRequire("6ojtq");
function $531113a0d47384e3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $531113a0d47384e3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $531113a0d47384e3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $531113a0d47384e3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $531113a0d47384e3$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $531113a0d47384e3$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $531113a0d47384e3$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $531113a0d47384e3$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $531113a0d47384e3$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $531113a0d47384e3$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $531113a0d47384e3$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $531113a0d47384e3$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $6ojtq.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $6ojtq.ResponseError)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                if (useGatewayUrl) return $531113a0d47384e3$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $brodC.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $brodC.FeatureGateEnvironment).Production:
                        return $531113a0d47384e3$export$18c93900db9358a4;
                    case (0, $brodC.FeatureGateEnvironment).Staging:
                        return $531113a0d47384e3$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $brodC.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $brodC.FeatureGateEnvironment).Development:
                        return $531113a0d47384e3$export$f058dbf75c3bc647;
                    case (0, $brodC.FeatureGateEnvironment).Staging:
                        return $531113a0d47384e3$export$942ba04389b0d5a2;
                    default:
                        return $531113a0d47384e3$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $531113a0d47384e3$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $531113a0d47384e3$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $cS3lQ.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x10) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        }
    ]);
}();

});
parcelRegister("cS3lQ", function(module, exports) {

$parcel$export(module.exports, "CLIENT_VERSION", function () { return $95ed20aa5df8b120$export$a59f8d67326bd1cb; });
/// <reference types="node" />
var $95ed20aa5df8b120$export$a59f8d67326bd1cb = "5.2.0";

});

parcelRegister("6ojtq", function(module, exports) {

$parcel$export(module.exports, "ResponseError", function () { return $4a741704c151d266$export$286baf652d0b1206; });

var $6CtYH = parcelRequire("6CtYH");

var $dxrob = parcelRequire("dxrob");

var $eihxX = parcelRequire("eihxX");

var $eaTmW = parcelRequire("eaTmW");

var $l8Sa3 = parcelRequire("l8Sa3");

var $3NMuS = parcelRequire("3NMuS");
function $4a741704c151d266$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eihxX)))(t, $4a741704c151d266$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(t).constructor) : o.apply(t, e));
}
function $4a741704c151d266$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($4a741704c151d266$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $4a741704c151d266$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, ResponseError);
        return $4a741704c151d266$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($l8Sa3)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3NMuS)))(Error));

});
parcelRegister("eihxX", function(module, exports) {

var $bRUy3 = parcelRequire("bRUy3");
var $a6805b89f289256d$var$_typeof = $bRUy3.default;

var $hCCJ0 = parcelRequire("hCCJ0");
function $a6805b89f289256d$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $a6805b89f289256d$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $hCCJ0(t);
}
module.exports = $a6805b89f289256d$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hCCJ0", function(module, exports) {
function $034f8c7ceea7c4ac$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $034f8c7ceea7c4ac$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("eaTmW", function(module, exports) {
function $a51cf303e6548bcf$var$_getPrototypeOf(t) {
    return module.exports = $a51cf303e6548bcf$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $a51cf303e6548bcf$var$_getPrototypeOf(t);
}
module.exports = $a51cf303e6548bcf$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("l8Sa3", function(module, exports) {

var $1BLAE = parcelRequire("1BLAE");
function $f6445b9e0be2a3e5$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $1BLAE(t, e);
}
module.exports = $f6445b9e0be2a3e5$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1BLAE", function(module, exports) {
function $12be2991dd9be400$var$_setPrototypeOf(t, e) {
    return module.exports = $12be2991dd9be400$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $12be2991dd9be400$var$_setPrototypeOf(t, e);
}
module.exports = $12be2991dd9be400$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("3NMuS", function(module, exports) {

var $eaTmW = parcelRequire("eaTmW");

var $1BLAE = parcelRequire("1BLAE");

var $dtSoV = parcelRequire("dtSoV");

var $64jOT = parcelRequire("64jOT");
function $2c4b91374c35f541$var$_wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return module.exports = $2c4b91374c35f541$var$_wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !$dtSoV(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return $64jOT(t, arguments, $eaTmW(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), $1BLAE(Wrapper, t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2c4b91374c35f541$var$_wrapNativeSuper(t);
}
module.exports = $2c4b91374c35f541$var$_wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("dtSoV", function(module, exports) {
function $9d082eb55f744d3a$var$_isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
module.exports = $9d082eb55f744d3a$var$_isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("64jOT", function(module, exports) {

var $baAKx = parcelRequire("baAKx");

var $1BLAE = parcelRequire("1BLAE");
function $46b27d95ae138841$var$_construct(t, e, r) {
    if ($baAKx()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && $1BLAE(p, r.prototype), p;
}
module.exports = $46b27d95ae138841$var$_construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("baAKx", function(module, exports) {
function $821d2291835fd002$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $821d2291835fd002$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $821d2291835fd002$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("1Jw6w", function(module, exports) {

$parcel$export(module.exports, "NoFetchDataAdapter", function () { return $1432e59e8a1d318e$export$55fffef3474104af; });

var $1uJLd = parcelRequire("1uJLd");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $eihxX = parcelRequire("eihxX");

var $eaTmW = parcelRequire("eaTmW");

var $eKeTJ = parcelRequire("eKeTJ");

var $l8Sa3 = parcelRequire("l8Sa3");

var $8MJe2 = parcelRequire("8MJe2");

var $iQsIh = parcelRequire("iQsIh");

var $79kyO = parcelRequire("79kyO");
function $1432e59e8a1d318e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1432e59e8a1d318e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1432e59e8a1d318e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1432e59e8a1d318e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1432e59e8a1d318e$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eihxX)))(t, $1432e59e8a1d318e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(t).constructor) : o.apply(t, e));
}
function $1432e59e8a1d318e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1432e59e8a1d318e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $1432e59e8a1d318e$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($eKeTJ)))((0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $1432e59e8a1d318e$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, NoFetchDataAdapter);
        _this = $1432e59e8a1d318e$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($l8Sa3)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $79kyO.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $1432e59e8a1d318e$var$_objectSpread($1432e59e8a1d318e$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $79kyO._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $1432e59e8a1d318e$var$_objectSpread($1432e59e8a1d318e$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $79kyO._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $79kyO._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $79kyO.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $1432e59e8a1d318e$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $1432e59e8a1d318e$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $79kyO.DataAdapterCore));

});
parcelRegister("eKeTJ", function(module, exports) {

var $fx6ZM = parcelRequire("fx6ZM");
function $abc0eaf9d4faa9e2$var$_get() {
    return module.exports = $abc0eaf9d4faa9e2$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $fx6ZM(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $abc0eaf9d4faa9e2$var$_get.apply(null, arguments);
}
module.exports = $abc0eaf9d4faa9e2$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fx6ZM", function(module, exports) {

var $eaTmW = parcelRequire("eaTmW");
function $b4ef5d3a8759730e$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $eaTmW(t)););
    return t;
}
module.exports = $b4ef5d3a8759730e$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("24YjW", function(module, exports) {

$parcel$export(module.exports, "LOCAL_STORAGE_KEY", function () { return $183abeeb76faa1e2$export$d8474cff104280f3; });
$parcel$export(module.exports, "PersistentOverrideAdapter", function () { return $183abeeb76faa1e2$export$bcb28fbac1def494; });

var $8MJe2 = parcelRequire("8MJe2");

var $iKdEz = parcelRequire("iKdEz");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $2CTsY = parcelRequire("2CTsY");
function $183abeeb76faa1e2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $183abeeb76faa1e2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $183abeeb76faa1e2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $183abeeb76faa1e2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $183abeeb76faa1e2$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $183abeeb76faa1e2$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $183abeeb76faa1e2$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $183abeeb76faa1e2$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $183abeeb76faa1e2$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $183abeeb76faa1e2$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $183abeeb76faa1e2$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $183abeeb76faa1e2$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $183abeeb76faa1e2$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $183abeeb76faa1e2$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $183abeeb76faa1e2$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $183abeeb76faa1e2$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, PersistentOverrideAdapter);
        this._overrides = $183abeeb76faa1e2$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $183abeeb76faa1e2$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $183abeeb76faa1e2$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $183abeeb76faa1e2$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($183abeeb76faa1e2$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($183abeeb76faa1e2$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $183abeeb76faa1e2$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $2CTsY._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $183abeeb76faa1e2$var$_objectSpread($183abeeb76faa1e2$var$_objectSpread({}, $183abeeb76faa1e2$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($183abeeb76faa1e2$var$djb2MapKey((0, $2CTsY._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($183abeeb76faa1e2$var$djb2MapKey((0, $2CTsY._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($183abeeb76faa1e2$var$djb2MapKey((0, $2CTsY._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($183abeeb76faa1e2$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $183abeeb76faa1e2$var$_objectSpread($183abeeb76faa1e2$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $183abeeb76faa1e2$var$_objectSpread($183abeeb76faa1e2$var$_objectSpread({}, current.details), {}, {
                        reason: $183abeeb76faa1e2$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($183abeeb76faa1e2$var$djb2MapKey((0, $2CTsY._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($183abeeb76faa1e2$var$djb2MapKey((0, $2CTsY._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($183abeeb76faa1e2$var$djb2MapKey((0, $2CTsY._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($183abeeb76faa1e2$var$djb2MapKey((0, $2CTsY._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($183abeeb76faa1e2$var$djb2MapKey((0, $2CTsY._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($183abeeb76faa1e2$var$djb2MapKey((0, $2CTsY._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $183abeeb76faa1e2$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($183abeeb76faa1e2$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $183abeeb76faa1e2$var$_objectSpread($183abeeb76faa1e2$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $2CTsY._makeTypedGet)(current.name, overridden),
                    details: $183abeeb76faa1e2$var$_objectSpread($183abeeb76faa1e2$var$_objectSpread({}, current.details), {}, {
                        reason: $183abeeb76faa1e2$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($183abeeb76faa1e2$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $183abeeb76faa1e2$var$_objectSpread($183abeeb76faa1e2$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $2CTsY._makeTypedGet)(current.name, overridden),
                    details: $183abeeb76faa1e2$var$_objectSpread($183abeeb76faa1e2$var$_objectSpread({}, current.details), {}, {
                        reason: $183abeeb76faa1e2$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("8w2cM", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $633305cb5e1737cb$export$1c9f709888824e05; });
var $633305cb5e1737cb$var$_process, $633305cb5e1737cb$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $633305cb5e1737cb$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($633305cb5e1737cb$var$_process = globalThis.process) === null || $633305cb5e1737cb$var$_process === void 0 || ($633305cb5e1737cb$var$_process = $633305cb5e1737cb$var$_process.env) === null || $633305cb5e1737cb$var$_process === void 0 ? void 0 : $633305cb5e1737cb$var$_process.JEST_WORKER_ID) !== undefined;
var $633305cb5e1737cb$var$DEBUG_MODE = !$633305cb5e1737cb$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($633305cb5e1737cb$var$_process2 = globalThis.process) === null || $633305cb5e1737cb$var$_process2 === void 0 || ($633305cb5e1737cb$var$_process2 = $633305cb5e1737cb$var$_process2.env) === null || $633305cb5e1737cb$var$_process2 === void 0 ? void 0 : $633305cb5e1737cb$var$_process2.NODE_ENV) !== 'production';
var $633305cb5e1737cb$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$633305cb5e1737cb$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});




parcelRegister("l4CUT", function(module, exports) {

$parcel$export(module.exports, "isValidBrandHex", function () { return $f57828b404207267$export$53031ac1ecb71f44; });
$parcel$export(module.exports, "rgbToHex", function () { return $f57828b404207267$export$34d09c4a771c46ef; });
$parcel$export(module.exports, "hexToRgbA", function () { return $f57828b404207267$export$b36dbdb4f463f05c; });
$parcel$export(module.exports, "hexToRgb", function () { return $f57828b404207267$export$5a544e13ad4e1fa5; });
$parcel$export(module.exports, "hexToHSL", function () { return $f57828b404207267$export$47ea145a83f50dc0; });
$parcel$export(module.exports, "HSLToRGB", function () { return $f57828b404207267$export$1ff93e992dd58bec; });
$parcel$export(module.exports, "relativeLuminanceW3C", function () { return $f57828b404207267$export$e770b01b744f3745; });
$parcel$export(module.exports, "getContrastRatio", function () { return $f57828b404207267$export$d061e26956a60b0a; });
$parcel$export(module.exports, "deltaE", function () { return $f57828b404207267$export$e8ddad763b4bebf9; });
// valid hex color with 6 digits
var $f57828b404207267$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};
// valid hex color with 4, 6 or 8 digits
var $f57828b404207267$var$isValidHex = function isValidHex(hex) {
    return /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
};
function $f57828b404207267$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $f57828b404207267$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        var int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $f57828b404207267$export$b36dbdb4f463f05c(hex) {
    if (!$f57828b404207267$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $f57828b404207267$export$1212645cf40ebf71(hex)
    ];
}
function $f57828b404207267$export$5a544e13ad4e1fa5(hex) {
    if (!$f57828b404207267$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $f57828b404207267$export$47ea145a83f50dc0(hex) {
    if (!$f57828b404207267$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    var cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $f57828b404207267$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    var k = function k(n) {
        return (n + h / 30) % 12;
    };
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    };
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $f57828b404207267$export$e770b01b744f3745(r, g, b) {
    var RsRGB = r / 255;
    var GsRGB = g / 255;
    var BsRGB = b / 255;
    var R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    var G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    var B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    var L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $f57828b404207267$export$d061e26956a60b0a(foreground, background) {
    if (!$f57828b404207267$var$isValidHex(foreground) || !$f57828b404207267$var$isValidHex(background)) throw new Error('Invalid HEX');
    var foregroundRgb = $f57828b404207267$export$5a544e13ad4e1fa5(foreground);
    var backgroundRgb = $f57828b404207267$export$5a544e13ad4e1fa5(background);
    var foregroundLuminance = $f57828b404207267$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    var backgroundLuminance = $f57828b404207267$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $f57828b404207267$export$e8ddad763b4bebf9(rgbA, rgbB) {
    var labA = $f57828b404207267$var$rgbToLab(rgbA);
    var labB = $f57828b404207267$var$rgbToLab(rgbB);
    var deltaL = labA[0] - labB[0];
    var deltaA = labA[1] - labB[1];
    var deltaB = labA[2] - labB[2];
    var c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    var c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    var deltaC = c1 - c2;
    var deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    var sc = 1.0 + 0.045 * c1;
    var sh = 1.0 + 0.015 * c1;
    var deltaLKlsl = deltaL / 1.0;
    var deltaCkcsc = deltaC / sc;
    var deltaHkhsh = deltaH / sh;
    var i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $f57828b404207267$var$rgbToLab(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("byAUq", function(module, exports) {

$parcel$export(module.exports, "hash", function () { return $869f80149b63834a$export$d6af199866bfb566; });
var $869f80149b63834a$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("iJaKR", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("5OCfF")).then(()=>parcelRequire('clQbn'));

});
parcelRegister("1iyJ7", function(module, exports) {
"use strict";

var $e0V30 = parcelRequire("e0V30");
module.exports = $e0V30(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(('' + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement('script');
        script.async = true;
        script.type = 'module';
        script.charset = 'utf-8';
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("e0V30", function(module, exports) {
"use strict";
var $a33d51355b1da95d$var$cachedBundles = {};
var $a33d51355b1da95d$var$cachedPreloads = {};
var $a33d51355b1da95d$var$cachedPrefetches = {};
function $a33d51355b1da95d$var$getCache(type) {
    switch(type){
        case 'preload':
            return $a33d51355b1da95d$var$cachedPreloads;
        case 'prefetch':
            return $a33d51355b1da95d$var$cachedPrefetches;
        default:
            return $a33d51355b1da95d$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $a33d51355b1da95d$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("ksKsb", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("gPgQ5")).then(()=>parcelRequire('buChp'));

});

parcelRegister("dyp25", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("ao7E2")).then(()=>parcelRequire('ajYWa'));

});

parcelRegister("koCyL", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("lrWJ9")).then(()=>parcelRequire('kFcy6'));

});

parcelRegister("g9djP", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("ivJcg")).then(()=>parcelRequire('6TQD4'));

});

parcelRegister("hXzuD", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("5qSsk")).then(()=>parcelRequire('9hopA'));

});

parcelRegister("canJQ", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("2lU1F")).then(()=>parcelRequire('4sMj2'));

});

parcelRegister("d8a8J", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("5C0Wv")).then(()=>parcelRequire('aBy5s'));

});

parcelRegister("51zGR", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("hBAES")).then(()=>parcelRequire('1JuH1'));

});

parcelRegister("956AA", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("dgi6L")).then(()=>parcelRequire('cD3AV'));

});

parcelRegister("eMCXm", function(module, exports) {

$parcel$export(module.exports, "findMissingCustomStyleElements", function () { return $ac33c44e9fbe6fe9$export$bd1ac9300b0e885a; });
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", function () { return $ac33c44e9fbe6fe9$export$e7ae172320e03461; });
$parcel$export(module.exports, "reduceTokenMap", function () { return $ac33c44e9fbe6fe9$export$e673f367da2ff23e; });

var $iKdEz = parcelRequire("iKdEz");

var $j9spr = parcelRequire("j9spr");

var $hM4mW = parcelRequire("hM4mW");

var $gQJxI = parcelRequire("gQJxI");

var $byAUq = parcelRequire("byAUq");
function $ac33c44e9fbe6fe9$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $byAUq.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $gQJxI.CUSTOM_THEME_ATTRIBUTE), "=\"").concat(uniqueId, "\"][").concat((0, $gQJxI.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $ac33c44e9fbe6fe9$export$e7ae172320e03461(sizeThreshold) {
    var styleTags = (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(Array.from(document.head.querySelectorAll("style[".concat((0, $gQJxI.CUSTOM_THEME_ATTRIBUTE), "][").concat((0, $gQJxI.THEME_DATA_ATTRIBUTE), "]"))));
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach(function(element) {
        return element.remove();
    });
}
function $ac33c44e9fbe6fe9$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce(function(acc, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        var cssVar = (0, $hM4mW.default)[key];
        return cssVar ? "".concat(acc, "\n  ").concat(cssVar, ": ").concat(typeof value === 'string' ? value : themeRamp[value], ";") : acc;
    }, '');
}

});
parcelRegister("hM4mW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf0a4ef328990d12$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::921c184d9a6e3b52bd2ab053939ce9ad>>
 * @codegenCommand yarn build tokens
 */ var $cf0a4ef328990d12$var$tokens = {
    'motion.avatar.enter': '--ds-avatar-enter',
    'motion.avatar.exit': '--ds-avatar-exit',
    'motion.avatar.hovered': '--ds-avatar-hovered',
    'motion.content.enter.long': '--ds-content-enter-long',
    'motion.content.enter.medium': '--ds-content-enter-medium',
    'motion.content.enter.short': '--ds-content-enter-short',
    'motion.content.exit.long': '--ds-content-exit-long',
    'motion.content.exit.medium': '--ds-content-exit-medium',
    'motion.content.exit.short': '--ds-content-exit-short',
    'motion.flag.enter': '--ds-flag-enter',
    'motion.flag.exit': '--ds-flag-exit',
    'motion.flag.reposition': '--ds-flag-reposition',
    'motion.modal.enter': '--ds-modal-enter',
    'motion.modal.exit': '--ds-modal-exit',
    'motion.popup.enter.bottom': '--ds-popup-enter-bottom',
    'motion.popup.enter.left': '--ds-popup-enter-left',
    'motion.popup.enter.right': '--ds-popup-enter-right',
    'motion.popup.enter.top': '--ds-popup-enter-top',
    'motion.popup.exit.bottom': '--ds-popup-exit-bottom',
    'motion.popup.exit.left': '--ds-popup-exit-left',
    'motion.popup.exit.right': '--ds-popup-exit-right',
    'motion.popup.exit.top': '--ds-popup-exit-top',
    'motion.spotlight.enter': '--ds-spotlight-enter',
    'motion.spotlight.exit': '--ds-spotlight-exit',
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.danger.bolder': '--ds-text-danger-bolder',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.warning.bolder': '--ds-text-warning-bolder',
    'color.text.success': '--ds-text-success',
    'color.text.success.bolder': '--ds-text-success-bolder',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.discovery.bolder': '--ds-text-discovery-bolder',
    'color.text.information': '--ds-text-information',
    'color.text.information.bolder': '--ds-text-information-bolder',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.subtler': '--ds-background-danger-subtler',
    'color.background.danger.subtler.hovered': '--ds-background-danger-subtler-hovered',
    'color.background.danger.subtler.pressed': '--ds-background-danger-subtler-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.subtler': '--ds-background-warning-subtler',
    'color.background.warning.subtler.hovered': '--ds-background-warning-subtler-hovered',
    'color.background.warning.subtler.pressed': '--ds-background-warning-subtler-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.subtler': '--ds-background-success-subtler',
    'color.background.success.subtler.hovered': '--ds-background-success-subtler-hovered',
    'color.background.success.subtler.pressed': '--ds-background-success-subtler-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.subtler': '--ds-background-discovery-subtler',
    'color.background.discovery.subtler.hovered': '--ds-background-discovery-subtler-hovered',
    'color.background.discovery.subtler.pressed': '--ds-background-discovery-subtler-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.subtler': '--ds-background-information-subtler',
    'color.background.information.subtler.hovered': '--ds-background-information-subtler-hovered',
    'color.background.information.subtler.pressed': '--ds-background-information-subtler-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.body.UNSAFE_small': '--ds-font-body-UNSAFE_small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.xxlarge': '--ds-radius-xxlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.width': '--ds-border-width',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $cf0a4ef328990d12$export$2e2bcd8739ae039 = $cf0a4ef328990d12$var$tokens;

});


parcelRegister("fTANy", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("eHTN5")).then(()=>parcelRequire('50brd'));

});

parcelRegister("ep5sO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("7GJe1")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("7GJe1")).Icon; });

var $7GJe1 = parcelRequire("7GJe1");

});
parcelRegister("7GJe1", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $598f896800024c3e$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $598f896800024c3e$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $7c0nF = parcelRequire("7c0nF");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $598f896800024c3e$var$svgStyles = null;
var $598f896800024c3e$var$iconStyles = null;
var $598f896800024c3e$var$smallIconStyles = null;
var $598f896800024c3e$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $598f896800024c3e$var$baseHcmStyles = null;
var $598f896800024c3e$var$scaleSize = null;
var $598f896800024c3e$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $598f896800024c3e$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $598f896800024c3e$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $598f896800024c3e$export$f04a61298a47a40f = /*#__PURE__*/ (0, $7fPBF.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $598f896800024c3e$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $7c0nF.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $7c0nF.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $598f896800024c3e$var$coreSizeSmall[spacing] : $598f896800024c3e$var$coreSizeMedium[spacing]
        ])
    }));
});
var $598f896800024c3e$export$2e2bcd8739ae039 = $598f896800024c3e$export$f04a61298a47a40f;

});
parcelRegister("7c0nF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53c9f3002085b935$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $53c9f3002085b935$var$ATOMIC_GROUP_LENGTH = 5;
function $53c9f3002085b935$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $53c9f3002085b935$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});



parcelRegister("gxWof", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("hgZDh")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("hgZDh")).Icon; });

var $hgZDh = parcelRequire("hgZDh");

});
parcelRegister("hgZDh", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $c933bd3fba31e2cc$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $c933bd3fba31e2cc$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $fe91Q = parcelRequire("fe91Q");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $c933bd3fba31e2cc$var$svgStyles = null;
var $c933bd3fba31e2cc$var$iconStyles = null;
var $c933bd3fba31e2cc$var$smallIconStyles = null;
var $c933bd3fba31e2cc$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $c933bd3fba31e2cc$var$baseHcmStyles = null;
var $c933bd3fba31e2cc$var$scaleSize = null;
var $c933bd3fba31e2cc$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $c933bd3fba31e2cc$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $c933bd3fba31e2cc$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $c933bd3fba31e2cc$export$f04a61298a47a40f = /*#__PURE__*/ (0, $7fPBF.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $c933bd3fba31e2cc$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $fe91Q.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $fe91Q.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $c933bd3fba31e2cc$var$coreSizeSmall[spacing] : $c933bd3fba31e2cc$var$coreSizeMedium[spacing]
        ])
    }));
});
var $c933bd3fba31e2cc$export$2e2bcd8739ae039 = $c933bd3fba31e2cc$export$f04a61298a47a40f;

});
parcelRegister("fe91Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b15f2abfdeaba68e$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $b15f2abfdeaba68e$var$ATOMIC_GROUP_LENGTH = 5;
function $b15f2abfdeaba68e$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $b15f2abfdeaba68e$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});



parcelRegister("f6lOK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("fZxDR")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("fZxDR")).Icon; });

var $fZxDR = parcelRequire("fZxDR");

});
parcelRegister("fZxDR", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $ba46a615b0544762$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $ba46a615b0544762$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $heZxp = parcelRequire("heZxp");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $ba46a615b0544762$var$svgStyles = null;
var $ba46a615b0544762$var$iconStyles = null;
var $ba46a615b0544762$var$smallIconStyles = null;
var $ba46a615b0544762$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $ba46a615b0544762$var$baseHcmStyles = null;
var $ba46a615b0544762$var$scaleSize = null;
var $ba46a615b0544762$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $ba46a615b0544762$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $ba46a615b0544762$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $ba46a615b0544762$export$f04a61298a47a40f = /*#__PURE__*/ (0, $7fPBF.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $ba46a615b0544762$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $heZxp.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $heZxp.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $ba46a615b0544762$var$coreSizeSmall[spacing] : $ba46a615b0544762$var$coreSizeMedium[spacing]
        ])
    }));
});
var $ba46a615b0544762$export$2e2bcd8739ae039 = $ba46a615b0544762$export$f04a61298a47a40f;

});
parcelRegister("heZxp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8d37a9a26aaefb0$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $c8d37a9a26aaefb0$var$ATOMIC_GROUP_LENGTH = 5;
function $c8d37a9a26aaefb0$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $c8d37a9a26aaefb0$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});



parcelRegister("b0TAn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("cFKeb")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("cFKeb")).Icon; });

var $cFKeb = parcelRequire("cFKeb");

});
parcelRegister("cFKeb", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $939d2c37ca117576$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $939d2c37ca117576$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $ieXy9 = parcelRequire("ieXy9");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $939d2c37ca117576$var$svgStyles = null;
var $939d2c37ca117576$var$iconStyles = null;
var $939d2c37ca117576$var$smallIconStyles = null;
var $939d2c37ca117576$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $939d2c37ca117576$var$baseHcmStyles = null;
var $939d2c37ca117576$var$scaleSize = null;
var $939d2c37ca117576$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $939d2c37ca117576$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $939d2c37ca117576$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $939d2c37ca117576$export$f04a61298a47a40f = /*#__PURE__*/ (0, $7fPBF.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $939d2c37ca117576$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $ieXy9.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $ieXy9.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $939d2c37ca117576$var$coreSizeSmall[spacing] : $939d2c37ca117576$var$coreSizeMedium[spacing]
        ])
    }));
});
var $939d2c37ca117576$export$2e2bcd8739ae039 = $939d2c37ca117576$export$f04a61298a47a40f;

});
parcelRegister("ieXy9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d477ba26f702ad07$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $d477ba26f702ad07$var$ATOMIC_GROUP_LENGTH = 5;
function $d477ba26f702ad07$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $d477ba26f702ad07$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});



parcelRegister("kR6Cn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("eDVOX")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("eDVOX")).Icon; });

var $eDVOX = parcelRequire("eDVOX");

});
parcelRegister("eDVOX", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $aa918f3af465c9f9$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $aa918f3af465c9f9$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $aFlfF = parcelRequire("aFlfF");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $aa918f3af465c9f9$var$svgStyles = null;
var $aa918f3af465c9f9$var$iconStyles = null;
var $aa918f3af465c9f9$var$smallIconStyles = null;
var $aa918f3af465c9f9$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $aa918f3af465c9f9$var$baseHcmStyles = null;
var $aa918f3af465c9f9$var$scaleSize = null;
var $aa918f3af465c9f9$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $aa918f3af465c9f9$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $aa918f3af465c9f9$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $aa918f3af465c9f9$export$f04a61298a47a40f = /*#__PURE__*/ (0, $7fPBF.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $aa918f3af465c9f9$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $aFlfF.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $aFlfF.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $aa918f3af465c9f9$var$coreSizeSmall[spacing] : $aa918f3af465c9f9$var$coreSizeMedium[spacing]
        ])
    }));
});
var $aa918f3af465c9f9$export$2e2bcd8739ae039 = $aa918f3af465c9f9$export$f04a61298a47a40f;

});
parcelRegister("aFlfF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c3e37df435d76d1$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $7c3e37df435d76d1$var$ATOMIC_GROUP_LENGTH = 5;
function $7c3e37df435d76d1$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $7c3e37df435d76d1$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});



parcelRegister("kHIu0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("2mZcx")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("2mZcx")).Icon; });

var $2mZcx = parcelRequire("2mZcx");

});
parcelRegister("2mZcx", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $1b9d1c1d17fb303b$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $1b9d1c1d17fb303b$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $iRmtv = parcelRequire("iRmtv");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $1b9d1c1d17fb303b$var$svgStyles = null;
var $1b9d1c1d17fb303b$var$iconStyles = null;
var $1b9d1c1d17fb303b$var$smallIconStyles = null;
var $1b9d1c1d17fb303b$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $1b9d1c1d17fb303b$var$baseHcmStyles = null;
var $1b9d1c1d17fb303b$var$scaleSize = null;
var $1b9d1c1d17fb303b$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $1b9d1c1d17fb303b$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $1b9d1c1d17fb303b$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $1b9d1c1d17fb303b$export$f04a61298a47a40f = /*#__PURE__*/ (0, $7fPBF.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $1b9d1c1d17fb303b$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $iRmtv.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $iRmtv.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $1b9d1c1d17fb303b$var$coreSizeSmall[spacing] : $1b9d1c1d17fb303b$var$coreSizeMedium[spacing]
        ])
    }));
});
var $1b9d1c1d17fb303b$export$2e2bcd8739ae039 = $1b9d1c1d17fb303b$export$f04a61298a47a40f;

});
parcelRegister("iRmtv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbae9c46c22067c0$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $dbae9c46c22067c0$var$ATOMIC_GROUP_LENGTH = 5;
function $dbae9c46c22067c0$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $dbae9c46c22067c0$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});



parcelRegister("6jZHp", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hKtzd = parcelRequire("hKtzd");

var $gNZPa = parcelRequire("gNZPa");

var $7QnW4 = parcelRequire("7QnW4");

var $crLpn = parcelRequire("crLpn");

var $2ldD6 = parcelRequire("2ldD6");

var $eqMxV = parcelRequire("eqMxV");

var $gvNu3 = parcelRequire("gvNu3");

var $hxXJ8 = parcelRequire("hxXJ8");

var $lzdUA = parcelRequire("lzdUA");

var $6mP1Z = parcelRequire("6mP1Z");

var $h1Nl2 = parcelRequire("h1Nl2");

var $6lgA1 = parcelRequire("6lgA1");

var $elQdO = parcelRequire("elQdO");

var $faX3S = parcelRequire("faX3S");

var $23pJH = parcelRequire("23pJH");

var $gHOmH = parcelRequire("gHOmH");

var $hSRcd = parcelRequire("hSRcd");

var $bo7a6 = parcelRequire("bo7a6");

var $59Hrx = parcelRequire("59Hrx");

var $gxkrU = parcelRequire("gxkrU");

var $kHUG4 = parcelRequire("kHUG4");

var $4GLB5 = parcelRequire("4GLB5");

var $bdOLT = parcelRequire("bdOLT");

var $jVohA = parcelRequire("jVohA");

var $9n8n8 = parcelRequire("9n8n8");

var $iRTrq = parcelRequire("iRTrq");

var $ksySF = parcelRequire("ksySF");

var $h6P9t = parcelRequire("h6P9t");

var $c44tH = parcelRequire("c44tH");

var $Qi0TL = parcelRequire("Qi0TL");

var $9gzrf = parcelRequire("9gzrf");

var $6vQat = parcelRequire("6vQat");

var $7iyQC = parcelRequire("7iyQC");

var $fm2rf = parcelRequire("fm2rf");

var $jTdz4 = parcelRequire("jTdz4");

var $9K8gk = parcelRequire("9K8gk");

var $d42SF = parcelRequire("d42SF");

var $l9T0r = parcelRequire("l9T0r");

var $6AMlx = parcelRequire("6AMlx");

var $1npIi = parcelRequire("1npIi");

var $65oHg = parcelRequire("65oHg");

var $1fhPD = parcelRequire("1fhPD");

var $LkEbx = parcelRequire("LkEbx");

var $4VNqS = parcelRequire("4VNqS");

var $ebGAH = parcelRequire("ebGAH");

var $dRW3b = parcelRequire("dRW3b");

var $h77y5 = parcelRequire("h77y5");

var $3Wqd7 = parcelRequire("3Wqd7");

var $guP5C = parcelRequire("guP5C");

var $cCABH = parcelRequire("cCABH");

var $ew3kP = parcelRequire("ew3kP");

var $g05x5 = parcelRequire("g05x5");

var $cDbpi = parcelRequire("cDbpi");

var $id64m = parcelRequire("id64m");

var $8mpfg = parcelRequire("8mpfg");

var $71LoA = parcelRequire("71LoA");

var $dxRJQ = parcelRequire("dxRJQ");

var $5gAhR = parcelRequire("5gAhR");

var $haRHv = parcelRequire("haRHv");

var $bDV5D = parcelRequire("bDV5D");

var $7U2Yz = parcelRequire("7U2Yz");

var $jcghP = parcelRequire("jcghP");

var $e5rTZ = parcelRequire("e5rTZ");

var $i2SaP = parcelRequire("i2SaP");

var $hhd4m = parcelRequire("hhd4m");

var $9itui = parcelRequire("9itui");

var $7CctZ = parcelRequire("7CctZ");

var $6Jc2P = parcelRequire("6Jc2P");

var $i0BXE = parcelRequire("i0BXE");

var $63lln = parcelRequire("63lln");

var $gw4Pv = parcelRequire("gw4Pv");

var $guQsY = parcelRequire("guQsY");

var $gXaKs = parcelRequire("gXaKs");

var $cey3X = parcelRequire("cey3X");

var $2vCme = parcelRequire("2vCme");

var $fGpJQ = parcelRequire("fGpJQ");

var $l5JQD = parcelRequire("l5JQD");

var $e78A8 = parcelRequire("e78A8");

var $8H2Be = parcelRequire("8H2Be");

var $3JOYW = parcelRequire("3JOYW");

var $djqGU = parcelRequire("djqGU");

var $2NdDt = parcelRequire("2NdDt");

var $bWdsU = parcelRequire("bWdsU");

var $2pq9U = parcelRequire("2pq9U");

var $cGuuU = parcelRequire("cGuuU");

var $8TMtR = parcelRequire("8TMtR");

var $akoBU = parcelRequire("akoBU");

var $eWHcE = parcelRequire("eWHcE");

var $64Nq7 = parcelRequire("64Nq7");

var $5o3Je = parcelRequire("5o3Je");

var $aP461 = parcelRequire("aP461");

var $jJ8lq = parcelRequire("jJ8lq");

var $6KwFW = parcelRequire("6KwFW");

var $f7TzA = parcelRequire("f7TzA");

var $99JOj = parcelRequire("99JOj");

var $7NTnD = parcelRequire("7NTnD");

var $kjDrv = parcelRequire("kjDrv");

var $cWsYm = parcelRequire("cWsYm");

var $8L7Uc = parcelRequire("8L7Uc");

var $gqKbc = parcelRequire("gqKbc");

var $5Cv1x = parcelRequire("5Cv1x");

var $aSFvs = parcelRequire("aSFvs");

var $1wWAR = parcelRequire("1wWAR");

var $kiJPB = parcelRequire("kiJPB");

var $f2fMw = parcelRequire("f2fMw");

var $8kVQq = parcelRequire("8kVQq");

var $ghmbo = parcelRequire("ghmbo");

var $iv6Ei = parcelRequire("iv6Ei");

var $15YuE = parcelRequire("15YuE");

var $dGNME = parcelRequire("dGNME");

var $XtYlA = parcelRequire("XtYlA");

var $82Rf5 = parcelRequire("82Rf5");

var $2porj = parcelRequire("2porj");

var $jSWkL = parcelRequire("jSWkL");

var $ibzbk = parcelRequire("ibzbk");

var $dhyIj = parcelRequire("dhyIj");

var $hQAU7 = parcelRequire("hQAU7");

var $hppxz = parcelRequire("hppxz");

var $irz1w = parcelRequire("irz1w");

var $a1iNu = parcelRequire("a1iNu");

var $eEQXZ = parcelRequire("eEQXZ");

var $fnuZv = parcelRequire("fnuZv");

var $gx0IS = parcelRequire("gx0IS");

var $fmjoe = parcelRequire("fmjoe");

var $78ha4 = parcelRequire("78ha4");

var $ah1An = parcelRequire("ah1An");

var $8zsqf = parcelRequire("8zsqf");

var $dSbBL = parcelRequire("dSbBL");

var $gCnte = parcelRequire("gCnte");

var $jHcnM = parcelRequire("jHcnM");

var $f0MA0 = parcelRequire("f0MA0");

var $bWJMZ = parcelRequire("bWJMZ");

var $bIVq4 = parcelRequire("bIVq4");

var $96HOz = parcelRequire("96HOz");

var $dxgXQ = parcelRequire("dxgXQ");

var $f0HG2 = parcelRequire("f0HG2");

var $kRTcv = parcelRequire("kRTcv");

var $8chst = parcelRequire("8chst");

var $lqAjj = parcelRequire("lqAjj");

var $6uOi2 = parcelRequire("6uOi2");

var $crjMp = parcelRequire("crjMp");

var $k80Ir = parcelRequire("k80Ir");

var $9cnvM = parcelRequire("9cnvM");

var $jiEbv = parcelRequire("jiEbv");

var $hxJcq = parcelRequire("hxJcq");

var $9a6Na = parcelRequire("9a6Na");

var $hk7pu = parcelRequire("hk7pu");
module.exports.registerSpanErrorInstrumentation = $hKtzd.registerSpanErrorInstrumentation;
module.exports.getCapturedScopesOnSpan = $gNZPa.getCapturedScopesOnSpan;
module.exports.markSpanForOtelSourceInference = $gNZPa.markSpanForOtelSourceInference;
module.exports.setCapturedScopesOnSpan = $gNZPa.setCapturedScopesOnSpan;
module.exports.spanShouldInferOtelSource = $gNZPa.spanShouldInferOtelSource;
module.exports.TRACING_DEFAULTS = $7QnW4.TRACING_DEFAULTS;
module.exports.startIdleSpan = $7QnW4.startIdleSpan;
module.exports.SentrySpan = $crLpn.SentrySpan;
module.exports.SentryNonRecordingSpan = $2ldD6.SentryNonRecordingSpan;
module.exports.SPAN_STATUS_ERROR = $eqMxV.SPAN_STATUS_ERROR;
module.exports.SPAN_STATUS_OK = $eqMxV.SPAN_STATUS_OK;
module.exports.SPAN_STATUS_UNSET = $eqMxV.SPAN_STATUS_UNSET;
module.exports.getSpanStatusFromHttpCode = $eqMxV.getSpanStatusFromHttpCode;
module.exports.setHttpStatus = $eqMxV.setHttpStatus;
module.exports.SUPPRESS_TRACING_KEY = $gvNu3.SUPPRESS_TRACING_KEY;
module.exports.continueTrace = $gvNu3.continueTrace;
module.exports.startInactiveSpan = $gvNu3.startInactiveSpan;
module.exports.startNewTrace = $gvNu3.startNewTrace;
module.exports.startSpan = $gvNu3.startSpan;
module.exports.startSpanManual = $gvNu3.startSpanManual;
module.exports.suppressTracing = $gvNu3.suppressTracing;
module.exports.withActiveSpan = $gvNu3.withActiveSpan;
module.exports.bindScopeToEmitter = $hxXJ8.bindScopeToEmitter;
module.exports.getDynamicSamplingContextFromClient = $lzdUA.getDynamicSamplingContextFromClient;
module.exports.getDynamicSamplingContextFromScope = $lzdUA.getDynamicSamplingContextFromScope;
module.exports.getDynamicSamplingContextFromSpan = $lzdUA.getDynamicSamplingContextFromSpan;
module.exports.spanToBaggageHeader = $lzdUA.spanToBaggageHeader;
module.exports.setMeasurement = $6mP1Z.setMeasurement;
module.exports.timedEventsToMeasurements = $6mP1Z.timedEventsToMeasurements;
module.exports.sampleSpan = $h1Nl2.sampleSpan;
module.exports.logSpanEnd = $6lgA1.logSpanEnd;
module.exports.logSpanStart = $6lgA1.logSpanStart;
module.exports.captureSpan = $elQdO.captureSpan;
module.exports.safeSetSpanJSONAttributes = $elQdO.safeSetSpanJSONAttributes;
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $faX3S.GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_HIT = $faX3S.SEMANTIC_ATTRIBUTE_CACHE_HIT;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = $faX3S.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_KEY = $faX3S.SEMANTIC_ATTRIBUTE_CACHE_KEY;
module.exports.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = $faX3S.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
module.exports.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = $faX3S.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
module.exports.SEMANTIC_ATTRIBUTE_PROFILE_ID = $faX3S.SEMANTIC_ATTRIBUTE_PROFILE_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = $faX3S.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = $faX3S.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = $faX3S.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = $faX3S.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = $faX3S.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_OP = $faX3S.SEMANTIC_ATTRIBUTE_SENTRY_OP;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = $faX3S.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = $faX3S.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = $faX3S.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = $faX3S.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = $faX3S.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = $faX3S.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = $faX3S.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = $faX3S.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = $faX3S.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = $faX3S.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
module.exports.SEMANTIC_ATTRIBUTE_URL_FULL = $faX3S.SEMANTIC_ATTRIBUTE_URL_FULL;
module.exports.SEMANTIC_ATTRIBUTE_USER_EMAIL = $faX3S.SEMANTIC_ATTRIBUTE_USER_EMAIL;
module.exports.SEMANTIC_ATTRIBUTE_USER_ID = $faX3S.SEMANTIC_ATTRIBUTE_USER_ID;
module.exports.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = $faX3S.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS;
module.exports.SEMANTIC_ATTRIBUTE_USER_USERNAME = $faX3S.SEMANTIC_ATTRIBUTE_USER_USERNAME;
module.exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = $faX3S.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;
module.exports.createEventEnvelope = $23pJH.createEventEnvelope;
module.exports.createSessionEnvelope = $23pJH.createSessionEnvelope;
module.exports.createSpanEnvelope = $23pJH.createSpanEnvelope;
module.exports.addEventProcessor = $gHOmH.addEventProcessor;
module.exports.captureCheckIn = $gHOmH.captureCheckIn;
module.exports.captureEvent = $gHOmH.captureEvent;
module.exports.captureException = $gHOmH.captureException;
module.exports.captureMessage = $gHOmH.captureMessage;
module.exports.captureSession = $gHOmH.captureSession;
module.exports.close = $gHOmH.close;
module.exports.endSession = $gHOmH.endSession;
module.exports.flush = $gHOmH.flush;
module.exports.isEnabled = $gHOmH.isEnabled;
module.exports.isInitialized = $gHOmH.isInitialized;
module.exports.lastEventId = $gHOmH.lastEventId;
module.exports.setAttribute = $gHOmH.setAttribute;
module.exports.setAttributes = $gHOmH.setAttributes;
module.exports.setContext = $gHOmH.setContext;
module.exports.setConversationId = $gHOmH.setConversationId;
module.exports.setExtra = $gHOmH.setExtra;
module.exports.setExtras = $gHOmH.setExtras;
module.exports.setTag = $gHOmH.setTag;
module.exports.setTags = $gHOmH.setTags;
module.exports.setUser = $gHOmH.setUser;
module.exports.startSession = $gHOmH.startSession;
module.exports.withMonitor = $gHOmH.withMonitor;
module.exports.getClient = $hSRcd.getClient;
module.exports.getCurrentScope = $hSRcd.getCurrentScope;
module.exports.getExternalPropagationContext = $hSRcd.getExternalPropagationContext;
module.exports.getGlobalScope = $hSRcd.getGlobalScope;
module.exports.getIsolationScope = $hSRcd.getIsolationScope;
module.exports.getTraceContextFromScope = $hSRcd.getTraceContextFromScope;
module.exports.hasExternalPropagationContext = $hSRcd.hasExternalPropagationContext;
module.exports.registerExternalPropagationContext = $hSRcd.registerExternalPropagationContext;
module.exports.withIsolationScope = $hSRcd.withIsolationScope;
module.exports.withScope = $hSRcd.withScope;
module.exports.getDefaultCurrentScope = $bo7a6.getDefaultCurrentScope;
module.exports.getDefaultIsolationScope = $bo7a6.getDefaultIsolationScope;
module.exports._INTERNAL_createTracingChannelBinding = $59Hrx._INTERNAL_createTracingChannelBinding;
module.exports._INTERNAL_getTracingChannelBinding = $59Hrx.getTracingChannelBinding;
module.exports.setAsyncContextStrategy = $59Hrx.setAsyncContextStrategy;
module.exports.getGlobalSingleton = $gxkrU.getGlobalSingleton;
module.exports.getMainCarrier = $gxkrU.getMainCarrier;
module.exports.closeSession = $kHUG4.closeSession;
module.exports.makeSession = $kHUG4.makeSession;
module.exports.updateSession = $kHUG4.updateSession;
module.exports.Scope = $4GLB5.Scope;
module.exports.notifyEventProcessors = $bdOLT.notifyEventProcessors;
module.exports.SENTRY_API_VERSION = $jVohA.SENTRY_API_VERSION;
module.exports.getEnvelopeEndpointWithUrlEncodedAuth = $jVohA.getEnvelopeEndpointWithUrlEncodedAuth;
module.exports.getReportDialogEndpoint = $jVohA.getReportDialogEndpoint;
module.exports.Client = $9n8n8.Client;
module.exports.initAndBind = $iRTrq.initAndBind;
module.exports.setCurrentClient = $iRTrq.setCurrentClient;
module.exports.createTransport = $ksySF.createTransport;
module.exports.makeOfflineTransport = $h6P9t.makeOfflineTransport;
module.exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY = $c44tH.MULTIPLEXED_TRANSPORT_EXTRA_KEY;
module.exports.makeMultiplexedTransport = $c44tH.makeMultiplexedTransport;
module.exports.addIntegration = $Qi0TL.addIntegration;
module.exports.defineIntegration = $Qi0TL.defineIntegration;
module.exports.getIntegrationsToSetup = $Qi0TL.getIntegrationsToSetup;
module.exports.installedIntegrations = $Qi0TL.installedIntegrations;
module.exports._INTERNAL_clearAiProviderSkips = $9gzrf._INTERNAL_clearAiProviderSkips;
module.exports._INTERNAL_shouldSkipAiProviderWrapping = $9gzrf._INTERNAL_shouldSkipAiProviderWrapping;
module.exports._INTERNAL_skipAiProviderWrapping = $9gzrf._INTERNAL_skipAiProviderWrapping;
module.exports._INTERNAL_filterKeyValueData = $6vQat.filterKeyValueData;
module.exports._INTERNAL_filterCookies = $7iyQC.filterCookies;
module.exports._INTERNAL_filterQueryParams = $fm2rf.filterQueryParams;
module.exports.envToBool = $jTdz4.envToBool;
module.exports.applyScopeDataToEvent = $9K8gk.applyScopeDataToEvent;
module.exports.getCombinedScopeData = $9K8gk.getCombinedScopeData;
module.exports.mergeScopeData = $9K8gk.mergeScopeData;
module.exports.prepareEvent = $d42SF.prepareEvent;
module.exports.createCheckInEnvelope = $l9T0r.createCheckInEnvelope;
module.exports.hasSpansEnabled = $6AMlx.hasSpansEnabled;
module.exports.isStreamedBeforeSendSpanCallback = $1npIi.isStreamedBeforeSendSpanCallback;
module.exports.withStreamedSpan = $1npIi.withStreamedSpan;
module.exports.isSentryRequestUrl = $65oHg.isSentryRequestUrl;
module.exports.handleCallbackErrors = $1fhPD.handleCallbackErrors;
module.exports.fmt = $LkEbx.fmt;
module.exports.parameterize = $LkEbx.parameterize;
module.exports.handleTunnelRequest = $4VNqS.handleTunnelRequest;
module.exports.addAutoIpAddressToSession = $ebGAH.addAutoIpAddressToSession;
module.exports.addAutoIpAddressToUser = $ebGAH.addAutoIpAddressToUser;
module.exports.INTERNAL_getSegmentSpan = $dRW3b.INTERNAL_getSegmentSpan;
module.exports.addChildSpanToSpan = $dRW3b.addChildSpanToSpan;
module.exports.convertSpanLinksForEnvelope = $dRW3b.convertSpanLinksForEnvelope;
module.exports.getActiveSpan = $dRW3b.getActiveSpan;
module.exports.getRootSpan = $dRW3b.getRootSpan;
module.exports.getSpanDescendants = $dRW3b.getSpanDescendants;
module.exports.getStatusMessage = $dRW3b.getStatusMessage;
module.exports.spanIsSampled = $dRW3b.spanIsSampled;
module.exports.spanTimeInputToSeconds = $dRW3b.spanTimeInputToSeconds;
module.exports.spanToJSON = $dRW3b.spanToJSON;
module.exports.spanToStreamedSpanJSON = $dRW3b.spanToStreamedSpanJSON;
module.exports.spanToTraceContext = $dRW3b.spanToTraceContext;
module.exports.spanToTraceHeader = $dRW3b.spanToTraceHeader;
module.exports.updateSpanName = $dRW3b.updateSpanName;
module.exports._INTERNAL_setSpanForScope = $h77y5._setSpanForScope;
module.exports.parseSampleRate = $3Wqd7.parseSampleRate;
module.exports.applySdkMetadata = $guP5C.applySdkMetadata;
module.exports.getTraceData = $cCABH.getTraceData;
module.exports.shouldPropagateTraceForUrl = $ew3kP.shouldPropagateTraceForUrl;
module.exports.getTraceMetaTags = $g05x5.getTraceMetaTags;
module.exports.debounce = $cDbpi.debounce;
module.exports.derefWeakRef = $id64m.derefWeakRef;
module.exports.makeWeakRef = $id64m.makeWeakRef;
module.exports.shouldIgnoreSpan = $8mpfg.shouldIgnoreSpan;
module.exports.MAX_BODY_BYTE_LENGTH = $71LoA.MAX_BODY_BYTE_LENGTH;
module.exports.captureBodyFromWinterCGRequest = $71LoA.captureBodyFromWinterCGRequest;
module.exports.extractQueryParamsFromUrl = $71LoA.extractQueryParamsFromUrl;
module.exports.getMaxBodyByteLength = $71LoA.getMaxBodyByteLength;
module.exports.headersToDict = $71LoA.headersToDict;
module.exports.httpHeadersToSpanAttributes = $71LoA.httpHeadersToSpanAttributes;
module.exports.httpRequestToRequestData = $71LoA.httpRequestToRequestData;
module.exports.winterCGHeadersToDict = $71LoA.winterCGHeadersToDict;
module.exports.winterCGRequestToRequestData = $71LoA.winterCGRequestToRequestData;
module.exports.DEFAULT_ENVIRONMENT = $dxRJQ.DEFAULT_ENVIRONMENT;
module.exports.DEV_ENVIRONMENT = $dxRJQ.DEV_ENVIRONMENT;
module.exports.SPAN_KIND = $5gAhR.SPAN_KIND;
module.exports.spanKindToName = $5gAhR.spanKindToName;
module.exports.addBreadcrumb = $haRHv.addBreadcrumb;
module.exports.functionToStringIntegration = $bDV5D.functionToStringIntegration;
module.exports.eventFiltersIntegration = $7U2Yz.eventFiltersIntegration;
module.exports.inboundFiltersIntegration = $7U2Yz.inboundFiltersIntegration;
module.exports.linkedErrorsIntegration = $jcghP.linkedErrorsIntegration;
module.exports.moduleMetadataIntegration = $e5rTZ.moduleMetadataIntegration;
module.exports.requestDataIntegration = $i2SaP.requestDataIntegration;
module.exports.captureConsoleIntegration = $hhd4m.captureConsoleIntegration;
module.exports.dedupeIntegration = $9itui.dedupeIntegration;
module.exports.extraErrorDataIntegration = $7CctZ.extraErrorDataIntegration;
module.exports.rewriteFramesIntegration = $6Jc2P.rewriteFramesIntegration;
module.exports.instrumentSupabaseClient = $i0BXE.instrumentSupabaseClient;
module.exports.supabaseIntegration = $i0BXE.supabaseIntegration;
module.exports.zodErrorsIntegration = $63lln.zodErrorsIntegration;
module.exports.thirdPartyErrorFilterIntegration = $gw4Pv.thirdPartyErrorFilterIntegration;
module.exports.consoleIntegration = $guQsY.consoleIntegration;
module.exports.featureFlagsIntegration = $gXaKs.featureFlagsIntegration;
module.exports.growthbookIntegration = $cey3X.growthbookIntegration;
module.exports.conversationIdIntegration = $2vCme.conversationIdIntegration;
module.exports.profiler = $fGpJQ.profiler;
module.exports._INTERNAL_getTracingHeadersForFetchRequest = $l5JQD._INTERNAL_getTracingHeadersForFetchRequest;
module.exports.instrumentFetchRequest = $l5JQD.instrumentFetchRequest;
module.exports.captureFeedback = $e78A8.captureFeedback;
module.exports._INTERNAL_captureLog = $8H2Be._INTERNAL_captureLog;
module.exports._INTERNAL_captureSerializedLog = $8H2Be._INTERNAL_captureSerializedLog;
module.exports._INTERNAL_flushLogsBuffer = $8H2Be._INTERNAL_flushLogsBuffer;
module.exports.logger = $3JOYW;
module.exports.consoleLoggingIntegration = $djqGU.consoleLoggingIntegration;
module.exports._INTERNAL_captureMetric = $2NdDt._INTERNAL_captureMetric;
module.exports._INTERNAL_captureSerializedMetric = $2NdDt._INTERNAL_captureSerializedMetric;
module.exports._INTERNAL_flushMetricsBuffer = $2NdDt._INTERNAL_flushMetricsBuffer;
module.exports.metrics = $bWdsU;
module.exports.createConsolaReporter = $2pq9U.createConsolaReporter;
module.exports.addVercelAiProcessors = $cGuuU.addVercelAiProcessors;
module.exports.getProviderMetadataAttributes = $cGuuU.getProviderMetadataAttributes;
module.exports.getTruncatedJsonString = $8TMtR.getTruncatedJsonString;
module.exports.shouldEnableTruncation = $8TMtR.shouldEnableTruncation;
module.exports.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = $akoBU.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = $akoBU.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE;
module.exports._INTERNAL_cleanupToolCallSpanContext = $eWHcE._INTERNAL_cleanupToolCallSpanContext;
module.exports._INTERNAL_getSpanContextForToolCallId = $eWHcE._INTERNAL_getSpanContextForToolCallId;
module.exports._INTERNAL_toolCallSpanContextMap = $64Nq7.toolCallSpanContextMap;
module.exports.instrumentOpenAiClient = $5o3Je.instrumentOpenAiClient;
module.exports.OPENAI_INTEGRATION_NAME = $aP461.OPENAI_INTEGRATION_NAME;
module.exports.instrumentAnthropicAiClient = $jJ8lq.instrumentAnthropicAiClient;
module.exports.ANTHROPIC_AI_INTEGRATION_NAME = $6KwFW.ANTHROPIC_AI_INTEGRATION_NAME;
module.exports.instrumentGoogleGenAIClient = $f7TzA.instrumentGoogleGenAIClient;
module.exports.GOOGLE_GENAI_INTEGRATION_NAME = $99JOj.GOOGLE_GENAI_INTEGRATION_NAME;
module.exports.createLangChainCallbackHandler = $7NTnD.createLangChainCallbackHandler;
module.exports._INTERNAL_mergeLangChainCallbackHandler = $kjDrv._INTERNAL_mergeLangChainCallbackHandler;
module.exports.LANGCHAIN_INTEGRATION_NAME = $cWsYm.LANGCHAIN_INTEGRATION_NAME;
module.exports.instrumentCreateReactAgent = $8L7Uc.instrumentCreateReactAgent;
module.exports.instrumentLangGraph = $8L7Uc.instrumentLangGraph;
module.exports.instrumentStateGraphCompile = $8L7Uc.instrumentStateGraphCompile;
module.exports.LANGGRAPH_INTEGRATION_NAME = $gqKbc.LANGGRAPH_INTEGRATION_NAME;
module.exports.SpanBuffer = $5Cv1x.SpanBuffer;
module.exports.hasSpanStreamingEnabled = $aSFvs.hasSpanStreamingEnabled;
module.exports.spanStreamingIntegration = $1wWAR.spanStreamingIntegration;
module.exports._INTERNAL_FLAG_BUFFER_SIZE = $kiJPB._INTERNAL_FLAG_BUFFER_SIZE;
module.exports._INTERNAL_MAX_FLAGS_PER_SPAN = $kiJPB._INTERNAL_MAX_FLAGS_PER_SPAN;
module.exports._INTERNAL_addFeatureFlagToActiveSpan = $kiJPB._INTERNAL_addFeatureFlagToActiveSpan;
module.exports._INTERNAL_copyFlagsFromScopeToEvent = $kiJPB._INTERNAL_copyFlagsFromScopeToEvent;
module.exports._INTERNAL_insertFlagToScope = $kiJPB._INTERNAL_insertFlagToScope;
module.exports.applyAggregateErrorsToEvent = $f2fMw.applyAggregateErrorsToEvent;
module.exports.getBreadcrumbLogLevelFromHttpStatusCode = $8kVQq.getBreadcrumbLogLevelFromHttpStatusCode;
module.exports.dsnFromString = $ghmbo.dsnFromString;
module.exports.dsnToString = $ghmbo.dsnToString;
module.exports.makeDsn = $ghmbo.makeDsn;
module.exports.SentryError = $iv6Ei.SentryError;
module.exports.GLOBAL_OBJ = $15YuE.GLOBAL_OBJ;
module.exports.addConsoleInstrumentationFilter = $dGNME.addConsoleInstrumentationFilter;
module.exports.addConsoleInstrumentationHandler = $dGNME.addConsoleInstrumentationHandler;
module.exports.addFetchEndInstrumentationHandler = $XtYlA.addFetchEndInstrumentationHandler;
module.exports.addFetchInstrumentationHandler = $XtYlA.addFetchInstrumentationHandler;
module.exports.addGlobalErrorInstrumentationHandler = $82Rf5.addGlobalErrorInstrumentationHandler;
module.exports.addGlobalUnhandledRejectionInstrumentationHandler = $2porj.addGlobalUnhandledRejectionInstrumentationHandler;
module.exports.addHandler = $jSWkL.addHandler;
module.exports.maybeInstrument = $jSWkL.maybeInstrument;
module.exports.resetInstrumentationHandlers = $jSWkL.resetInstrumentationHandlers;
module.exports.triggerHandlers = $jSWkL.triggerHandlers;
module.exports.isDOMError = $ibzbk.isDOMError;
module.exports.isDOMException = $ibzbk.isDOMException;
module.exports.isElement = $ibzbk.isElement;
module.exports.isError = $ibzbk.isError;
module.exports.isErrorEvent = $ibzbk.isErrorEvent;
module.exports.isEvent = $ibzbk.isEvent;
module.exports.isInstanceOf = $ibzbk.isInstanceOf;
module.exports.isParameterizedString = $ibzbk.isParameterizedString;
module.exports.isPlainObject = $ibzbk.isPlainObject;
module.exports.isPrimitive = $ibzbk.isPrimitive;
module.exports.isRegExp = $ibzbk.isRegExp;
module.exports.isString = $ibzbk.isString;
module.exports.isSyntheticEvent = $ibzbk.isSyntheticEvent;
module.exports.isThenable = $ibzbk.isThenable;
module.exports.isVueViewModel = $ibzbk.isVueViewModel;
module.exports.isBrowser = $dhyIj.isBrowser;
module.exports.CONSOLE_LEVELS = $hQAU7.CONSOLE_LEVELS;
module.exports.consoleSandbox = $hQAU7.consoleSandbox;
module.exports.debug = $hQAU7.debug;
module.exports.originalConsoleMethods = $hQAU7.originalConsoleMethods;
module.exports.addContextToFrame = $hppxz.addContextToFrame;
module.exports.addExceptionMechanism = $hppxz.addExceptionMechanism;
module.exports.addExceptionTypeValue = $hppxz.addExceptionTypeValue;
module.exports.checkOrSetAlreadyCaught = $hppxz.checkOrSetAlreadyCaught;
module.exports.getEventDescription = $hppxz.getEventDescription;
module.exports.isAlreadyCaptured = $hppxz.isAlreadyCaptured;
module.exports.parseSemver = $hppxz.parseSemver;
module.exports.uuid4 = $hppxz.uuid4;
module.exports.normalize = $irz1w.normalize;
module.exports.normalizeToSize = $irz1w.normalizeToSize;
module.exports.normalizeUrlToBase = $irz1w.normalizeUrlToBase;
module.exports.setNormalizeStringifier = $irz1w.setNormalizeStringifier;
module.exports.setNormalizationDepthOverrideHint = $a1iNu.setNormalizationDepthOverrideHint;
module.exports.setSkipNormalizationHint = $a1iNu.setSkipNormalizationHint;
module.exports.addNonEnumerableProperty = $eEQXZ.addNonEnumerableProperty;
module.exports.convertToPlainObject = $eEQXZ.convertToPlainObject;
module.exports.dropUndefinedKeys = $eEQXZ.dropUndefinedKeys;
module.exports.extractExceptionKeysForMessage = $eEQXZ.extractExceptionKeysForMessage;
module.exports.fill = $eEQXZ.fill;
module.exports.getOriginalFunction = $eEQXZ.getOriginalFunction;
module.exports.markFunctionWrapped = $eEQXZ.markFunctionWrapped;
module.exports.objectify = $eEQXZ.objectify;
module.exports.basename = $fnuZv.basename;
module.exports.dirname = $fnuZv.dirname;
module.exports.isAbsolute = $fnuZv.isAbsolute;
module.exports.join = $fnuZv.join;
module.exports.normalizePath = $fnuZv.normalizePath;
module.exports.relative = $fnuZv.relative;
module.exports.resolve = $fnuZv.resolve;
module.exports.SENTRY_BUFFER_FULL_ERROR = $gx0IS.SENTRY_BUFFER_FULL_ERROR;
module.exports.makePromiseBuffer = $gx0IS.makePromiseBuffer;
module.exports.severityLevelFromString = $fmjoe.severityLevelFromString;
module.exports.replaceExports = $78ha4.replaceExports;
module.exports.UNKNOWN_FUNCTION = $ah1An.UNKNOWN_FUNCTION;
module.exports.createStackParser = $ah1An.createStackParser;
module.exports.getFramesFromEvent = $ah1An.getFramesFromEvent;
module.exports.getFunctionName = $ah1An.getFunctionName;
module.exports.stackParserFromStackParserOptions = $ah1An.stackParserFromStackParserOptions;
module.exports.stripSentryFramesAndReverse = $ah1An.stripSentryFramesAndReverse;
module.exports.isMatchingPattern = $8zsqf.isMatchingPattern;
module.exports.safeJoin = $8zsqf.safeJoin;
module.exports.snipLine = $8zsqf.snipLine;
module.exports.stringMatchesSomePattern = $8zsqf.stringMatchesSomePattern;
module.exports.truncate = $8zsqf.truncate;
module.exports.isNativeFunction = $dSbBL.isNativeFunction;
module.exports.supportsDOMError = $dSbBL.supportsDOMError;
module.exports.supportsDOMException = $dSbBL.supportsDOMException;
module.exports.supportsErrorEvent = $dSbBL.supportsErrorEvent;
module.exports.supportsFetch = $dSbBL.supportsFetch;
module.exports.supportsHistory = $dSbBL.supportsHistory;
module.exports.supportsNativeFetch = $dSbBL.supportsNativeFetch;
module.exports.supportsReferrerPolicy = $dSbBL.supportsReferrerPolicy;
module.exports.supportsReportingObserver = $dSbBL.supportsReportingObserver;
module.exports.SyncPromise = $gCnte.SyncPromise;
module.exports.rejectedSyncPromise = $gCnte.rejectedSyncPromise;
module.exports.resolvedSyncPromise = $gCnte.resolvedSyncPromise;
module.exports.browserPerformanceTimeOrigin = $jHcnM.browserPerformanceTimeOrigin;
module.exports.dateTimestampInSeconds = $jHcnM.dateTimestampInSeconds;
module.exports.timestampInSeconds = $jHcnM.timestampInSeconds;
module.exports.TRACEPARENT_REGEXP = $f0MA0.TRACEPARENT_REGEXP;
module.exports.extractTraceparentData = $f0MA0.extractTraceparentData;
module.exports.generateSentryTraceHeader = $f0MA0.generateSentryTraceHeader;
module.exports.generateTraceparentHeader = $f0MA0.generateTraceparentHeader;
module.exports.propagationContextFromHeaders = $f0MA0.propagationContextFromHeaders;
module.exports.shouldContinueTrace = $f0MA0.shouldContinueTrace;
module.exports.getSDKSource = $bWJMZ.getSDKSource;
module.exports.isBrowserBundle = $bWJMZ.isBrowserBundle;
module.exports.addItemToEnvelope = $bIVq4.addItemToEnvelope;
module.exports.createAttachmentEnvelopeItem = $bIVq4.createAttachmentEnvelopeItem;
module.exports.createEnvelope = $bIVq4.createEnvelope;
module.exports.createEventEnvelopeHeaders = $bIVq4.createEventEnvelopeHeaders;
module.exports.createSpanEnvelopeItem = $bIVq4.createSpanEnvelopeItem;
module.exports.envelopeContainsItemType = $bIVq4.envelopeContainsItemType;
module.exports.envelopeItemTypeToDataCategory = $bIVq4.envelopeItemTypeToDataCategory;
module.exports.forEachEnvelopeItem = $bIVq4.forEachEnvelopeItem;
module.exports.getSdkMetadataForEnvelopeHeader = $bIVq4.getSdkMetadataForEnvelopeHeader;
module.exports.parseEnvelope = $bIVq4.parseEnvelope;
module.exports.serializeEnvelope = $bIVq4.serializeEnvelope;
module.exports.createClientReportEnvelope = $96HOz.createClientReportEnvelope;
module.exports.DEFAULT_RETRY_AFTER = $dxgXQ.DEFAULT_RETRY_AFTER;
module.exports.disabledUntil = $dxgXQ.disabledUntil;
module.exports.isRateLimited = $dxgXQ.isRateLimited;
module.exports.parseRetryAfterHeader = $dxgXQ.parseRetryAfterHeader;
module.exports.updateRateLimits = $dxgXQ.updateRateLimits;
module.exports.MAX_BAGGAGE_STRING_LENGTH = $f0HG2.MAX_BAGGAGE_STRING_LENGTH;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX = $f0HG2.SENTRY_BAGGAGE_KEY_PREFIX;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX_REGEX = $f0HG2.SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
module.exports.baggageHeaderToDynamicSamplingContext = $f0HG2.baggageHeaderToDynamicSamplingContext;
module.exports.dynamicSamplingContextToSentryBaggageHeader = $f0HG2.dynamicSamplingContextToSentryBaggageHeader;
module.exports.mergeBaggageHeaders = $f0HG2.mergeBaggageHeaders;
module.exports.objectToBaggageHeader = $f0HG2.objectToBaggageHeader;
module.exports.parseBaggageHeader = $f0HG2.parseBaggageHeader;
module.exports.getHttpSpanDetailsFromUrlObject = $kRTcv.getHttpSpanDetailsFromUrlObject;
module.exports.getSanitizedUrlString = $kRTcv.getSanitizedUrlString;
module.exports.getSanitizedUrlStringFromUrlObject = $kRTcv.getSanitizedUrlStringFromUrlObject;
module.exports.isURLObjectRelative = $kRTcv.isURLObjectRelative;
module.exports.parseStringToURLObject = $kRTcv.parseStringToURLObject;
module.exports.parseUrl = $kRTcv.parseUrl;
module.exports.stripDataUrlContent = $kRTcv.stripDataUrlContent;
module.exports.stripUrlQueryAndFragment = $kRTcv.stripUrlQueryAndFragment;
module.exports._INTERNAL_enhanceErrorWithSentryInfo = $8chst._enhanceErrorWithSentryInfo;
module.exports.eventFromMessage = $8chst.eventFromMessage;
module.exports.eventFromUnknownInput = $8chst.eventFromUnknownInput;
module.exports.exceptionFromError = $8chst.exceptionFromError;
module.exports.parseStackFrames = $8chst.parseStackFrames;
module.exports.LRUMap = $lqAjj.LRUMap;
module.exports.generateSpanId = $6uOi2.generateSpanId;
module.exports.generateTraceId = $6uOi2.generateTraceId;
module.exports.SDK_VERSION = $crjMp.SDK_VERSION;
module.exports.getDebugImagesForResources = $k80Ir.getDebugImagesForResources;
module.exports.getFilenameToDebugIdMap = $k80Ir.getFilenameToDebugIdMap;
module.exports.getFilenameToMetadataMap = $9cnvM.getFilenameToMetadataMap;
module.exports.escapeStringForRegex = $jiEbv.escapeStringForRegex;
module.exports._INTERNAL_safeDateNow = $hxJcq.safeDateNow;
module.exports._INTERNAL_safeMathRandom = $hxJcq.safeMathRandom;
module.exports._INTERNAL_withRandomSafeContext = $hxJcq.withRandomSafeContext;
module.exports.getComponentName = $9a6Na.getComponentName;
module.exports.getLocationHref = $9a6Na.getLocationHref;
module.exports.htmlTreeAsString = $9a6Na.htmlTreeAsString;
module.exports.instrumentLangChainEmbeddings = $hk7pu.instrumentLangChainEmbeddings;

});
parcelRegister("hKtzd", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $859Bb = parcelRequire("859Bb");

var $82Rf5 = parcelRequire("82Rf5");

var $2porj = parcelRequire("2porj");

var $hQAU7 = parcelRequire("hQAU7");

var $dRW3b = parcelRequire("dRW3b");

var $eqMxV = parcelRequire("eqMxV");
let $cebdaaf2a41fce33$var$errorsInstrumented = false;
function $cebdaaf2a41fce33$var$registerSpanErrorInstrumentation() {
    if ($cebdaaf2a41fce33$var$errorsInstrumented) return;
    function errorCallback() {
        const activeSpan = $dRW3b.getActiveSpan();
        const rootSpan = activeSpan && $dRW3b.getRootSpan(activeSpan);
        if (rootSpan) {
            const message = "internal_error";
            $859Bb.DEBUG_BUILD && $hQAU7.debug.log(`[Tracing] Root span: ${message} -> Global error occurred`);
            rootSpan.setStatus({
                code: $eqMxV.SPAN_STATUS_ERROR,
                message: message
            });
        }
    }
    $cebdaaf2a41fce33$var$errorsInstrumented = true;
    $82Rf5.addGlobalErrorInstrumentationHandler(errorCallback);
    $2porj.addGlobalUnhandledRejectionInstrumentationHandler(errorCallback);
}
module.exports.registerSpanErrorInstrumentation = $cebdaaf2a41fce33$var$registerSpanErrorInstrumentation;

});
parcelRegister("859Bb", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $5e263c73f6e70e3f$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
module.exports.DEBUG_BUILD = $5e263c73f6e70e3f$var$DEBUG_BUILD;

});

parcelRegister("82Rf5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $15YuE = parcelRequire("15YuE");

var $jSWkL = parcelRequire("jSWkL");
let $5db7cf797e848290$var$_oldOnErrorHandler = null;
function $5db7cf797e848290$var$addGlobalErrorInstrumentationHandler(handler) {
    const type = "error";
    $jSWkL.addHandler(type, handler);
    $jSWkL.maybeInstrument(type, $5db7cf797e848290$var$instrumentError);
}
function $5db7cf797e848290$var$instrumentError() {
    $5db7cf797e848290$var$_oldOnErrorHandler = $15YuE.GLOBAL_OBJ.onerror;
    $15YuE.GLOBAL_OBJ.onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        $jSWkL.triggerHandlers("error", handlerData);
        if ($5db7cf797e848290$var$_oldOnErrorHandler) return $5db7cf797e848290$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    $15YuE.GLOBAL_OBJ.onerror.__SENTRY_INSTRUMENTED__ = true;
}
module.exports.addGlobalErrorInstrumentationHandler = $5db7cf797e848290$var$addGlobalErrorInstrumentationHandler;

});
parcelRegister("15YuE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $0cc52ec5ed3c1ac6$var$GLOBAL_OBJ = globalThis;
module.exports.GLOBAL_OBJ = $0cc52ec5ed3c1ac6$var$GLOBAL_OBJ;

});

parcelRegister("jSWkL", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $859Bb = parcelRequire("859Bb");

var $hQAU7 = parcelRequire("hQAU7");

var $ah1An = parcelRequire("ah1An");
const $e7a04f5d28ac26fa$var$handlers = {};
const $e7a04f5d28ac26fa$var$instrumented = {};
function $e7a04f5d28ac26fa$var$addHandler(type, handler) {
    $e7a04f5d28ac26fa$var$handlers[type] = $e7a04f5d28ac26fa$var$handlers[type] || [];
    $e7a04f5d28ac26fa$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $e7a04f5d28ac26fa$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
function $e7a04f5d28ac26fa$var$resetInstrumentationHandlers() {
    Object.keys($e7a04f5d28ac26fa$var$handlers).forEach((key)=>{
        $e7a04f5d28ac26fa$var$handlers[key] = void 0;
    });
}
function $e7a04f5d28ac26fa$var$maybeInstrument(type, instrumentFn) {
    if (!$e7a04f5d28ac26fa$var$instrumented[type]) {
        $e7a04f5d28ac26fa$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            $859Bb.DEBUG_BUILD && $hQAU7.debug.error(`Error while instrumenting ${type}`, e);
        }
    }
}
function $e7a04f5d28ac26fa$var$triggerHandlers(type, data) {
    const typeHandlers = type && $e7a04f5d28ac26fa$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${$ah1An.getFunctionName(handler)}
Error:`, e);
    }
}
module.exports.addHandler = $e7a04f5d28ac26fa$var$addHandler;
module.exports.maybeInstrument = $e7a04f5d28ac26fa$var$maybeInstrument;
module.exports.resetInstrumentationHandlers = $e7a04f5d28ac26fa$var$resetInstrumentationHandlers;
module.exports.triggerHandlers = $e7a04f5d28ac26fa$var$triggerHandlers;

});
parcelRegister("hQAU7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gxkrU = parcelRequire("gxkrU");

var $859Bb = parcelRequire("859Bb");

var $15YuE = parcelRequire("15YuE");
const $cfe3eb60c5c49518$var$CONSOLE_LEVELS = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
const $cfe3eb60c5c49518$var$PREFIX = "Sentry Logger ";
const $cfe3eb60c5c49518$var$originalConsoleMethods = {};
function $cfe3eb60c5c49518$var$consoleSandbox(callback) {
    if (!("console" in $15YuE.GLOBAL_OBJ)) return callback();
    const console = $15YuE.GLOBAL_OBJ.console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($cfe3eb60c5c49518$var$originalConsoleMethods);
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $cfe3eb60c5c49518$var$originalConsoleMethods[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $cfe3eb60c5c49518$var$enable() {
    $cfe3eb60c5c49518$var$_getLoggerSettings().enabled = true;
}
function $cfe3eb60c5c49518$var$disable() {
    $cfe3eb60c5c49518$var$_getLoggerSettings().enabled = false;
}
function $cfe3eb60c5c49518$var$isEnabled() {
    return $cfe3eb60c5c49518$var$_getLoggerSettings().enabled;
}
function $cfe3eb60c5c49518$var$log(...args) {
    $cfe3eb60c5c49518$var$_maybeLog("log", ...args);
}
function $cfe3eb60c5c49518$var$warn(...args) {
    $cfe3eb60c5c49518$var$_maybeLog("warn", ...args);
}
function $cfe3eb60c5c49518$var$error(...args) {
    $cfe3eb60c5c49518$var$_maybeLog("error", ...args);
}
function $cfe3eb60c5c49518$var$_maybeLog(level, ...args) {
    if (!$859Bb.DEBUG_BUILD) return;
    if ($cfe3eb60c5c49518$var$isEnabled()) $cfe3eb60c5c49518$var$consoleSandbox(()=>{
        $15YuE.GLOBAL_OBJ.console[level](`${$cfe3eb60c5c49518$var$PREFIX}[${level}]:`, ...args);
    });
}
function $cfe3eb60c5c49518$var$_getLoggerSettings() {
    if (!$859Bb.DEBUG_BUILD) return {
        enabled: false
    };
    return $gxkrU.getGlobalSingleton("loggerSettings", ()=>({
            enabled: false
        }));
}
const $cfe3eb60c5c49518$var$debug = {
    enable: /** Enable logging. */ $cfe3eb60c5c49518$var$enable,
    disable: /** Disable logging. */ $cfe3eb60c5c49518$var$disable,
    isEnabled: /** Check if logging is enabled. */ $cfe3eb60c5c49518$var$isEnabled,
    log: /** Log a message. */ $cfe3eb60c5c49518$var$log,
    warn: /** Log a warning. */ $cfe3eb60c5c49518$var$warn,
    error: /** Log an error. */ $cfe3eb60c5c49518$var$error
};
module.exports.CONSOLE_LEVELS = $cfe3eb60c5c49518$var$CONSOLE_LEVELS;
module.exports.consoleSandbox = $cfe3eb60c5c49518$var$consoleSandbox;
module.exports.debug = $cfe3eb60c5c49518$var$debug;
module.exports.originalConsoleMethods = $cfe3eb60c5c49518$var$originalConsoleMethods;

});
parcelRegister("gxkrU", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $crjMp = parcelRequire("crjMp");

var $15YuE = parcelRequire("15YuE");
function $c09f9731f63860d9$var$getMainCarrier() {
    $c09f9731f63860d9$var$getSentryCarrier($15YuE.GLOBAL_OBJ);
    return $15YuE.GLOBAL_OBJ;
}
function $c09f9731f63860d9$var$getSentryCarrier(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.version = __SENTRY__.version || $crjMp.SDK_VERSION;
    return __SENTRY__[$crjMp.SDK_VERSION] = __SENTRY__[$crjMp.SDK_VERSION] || {};
}
function $c09f9731f63860d9$var$getGlobalSingleton(name, creator, obj = $15YuE.GLOBAL_OBJ) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[$crjMp.SDK_VERSION] = __SENTRY__[$crjMp.SDK_VERSION] || {};
    return carrier[name] || (carrier[name] = creator());
}
module.exports.getGlobalSingleton = $c09f9731f63860d9$var$getGlobalSingleton;
module.exports.getMainCarrier = $c09f9731f63860d9$var$getMainCarrier;
module.exports.getSentryCarrier = $c09f9731f63860d9$var$getSentryCarrier;

});
parcelRegister("crjMp", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $90e7598825f516b2$var$SDK_VERSION = "10.62.0";
module.exports.SDK_VERSION = $90e7598825f516b2$var$SDK_VERSION;

});



parcelRegister("ah1An", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $77acb8d1e19843bd$var$STACKTRACE_FRAME_LIMIT = 50;
const $77acb8d1e19843bd$var$UNKNOWN_FUNCTION = "?";
const $77acb8d1e19843bd$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $77acb8d1e19843bd$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
function $77acb8d1e19843bd$var$createStackParser(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            if (line.length > 1024) line = line.slice(0, 1024);
            const cleanedLine = $77acb8d1e19843bd$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($77acb8d1e19843bd$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            if (cleanedLine.includes("Error: ")) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $77acb8d1e19843bd$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $77acb8d1e19843bd$var$stripSentryFramesAndReverse(frames.slice(framesToPop));
    };
}
function $77acb8d1e19843bd$var$stackParserFromStackParserOptions(stackParser) {
    if (Array.isArray(stackParser)) return $77acb8d1e19843bd$var$createStackParser(...stackParser);
    return stackParser;
}
function $77acb8d1e19843bd$var$stripSentryFramesAndReverse(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    if (/sentryWrapped/.test($77acb8d1e19843bd$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    localStack.reverse();
    if ($77acb8d1e19843bd$var$STRIP_FRAME_REGEXP.test($77acb8d1e19843bd$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        if ($77acb8d1e19843bd$var$STRIP_FRAME_REGEXP.test($77acb8d1e19843bd$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $77acb8d1e19843bd$var$STACKTRACE_FRAME_LIMIT).map((frame)=>(0, $2qxEV._)((0, $9tqwB._)({}, frame), {
            filename: frame.filename || $77acb8d1e19843bd$var$getLastStackFrame(localStack).filename,
            function: frame.function || $77acb8d1e19843bd$var$UNKNOWN_FUNCTION
        }));
}
function $77acb8d1e19843bd$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $77acb8d1e19843bd$var$defaultFunctionName = "<anonymous>";
function $77acb8d1e19843bd$var$getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== "function") return $77acb8d1e19843bd$var$defaultFunctionName;
        return fn.name || $77acb8d1e19843bd$var$defaultFunctionName;
    } catch (e) {
        return $77acb8d1e19843bd$var$defaultFunctionName;
    }
}
function $77acb8d1e19843bd$var$getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            exception.values.forEach((value)=>{
                if (value.stacktrace.frames) frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (e) {
            return void 0;
        }
    }
    return void 0;
}
function $77acb8d1e19843bd$var$normalizeStackTracePath(path) {
    let filename = (path === null || path === void 0 ? void 0 : path.startsWith("file://")) ? path.slice(7) : path;
    if (filename === null || filename === void 0 ? void 0 : filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}
module.exports.UNKNOWN_FUNCTION = $77acb8d1e19843bd$var$UNKNOWN_FUNCTION;
module.exports.createStackParser = $77acb8d1e19843bd$var$createStackParser;
module.exports.getFramesFromEvent = $77acb8d1e19843bd$var$getFramesFromEvent;
module.exports.getFunctionName = $77acb8d1e19843bd$var$getFunctionName;
module.exports.normalizeStackTracePath = $77acb8d1e19843bd$var$normalizeStackTracePath;
module.exports.stackParserFromStackParserOptions = $77acb8d1e19843bd$var$stackParserFromStackParserOptions;
module.exports.stripSentryFramesAndReverse = $77acb8d1e19843bd$var$stripSentryFramesAndReverse;

});
parcelRegister("9tqwB", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6e5b65c9cbae0db9$export$71511d61b312f219; });

var $cv8cX = parcelRequire("cv8cX");
function $6e5b65c9cbae0db9$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $cv8cX._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("cv8cX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $919ebf39980bf8f3$export$71511d61b312f219; });
function $919ebf39980bf8f3$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("2qxEV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1c481e73824c6361$export$71511d61b312f219; });
function $1c481e73824c6361$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1c481e73824c6361$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $1c481e73824c6361$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});




parcelRegister("2porj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $15YuE = parcelRequire("15YuE");

var $jSWkL = parcelRequire("jSWkL");
let $1c10dfc53b8edbf0$var$_oldOnUnhandledRejectionHandler = null;
function $1c10dfc53b8edbf0$var$addGlobalUnhandledRejectionInstrumentationHandler(handler) {
    const type = "unhandledrejection";
    $jSWkL.addHandler(type, handler);
    $jSWkL.maybeInstrument(type, $1c10dfc53b8edbf0$var$instrumentUnhandledRejection);
}
function $1c10dfc53b8edbf0$var$instrumentUnhandledRejection() {
    $1c10dfc53b8edbf0$var$_oldOnUnhandledRejectionHandler = $15YuE.GLOBAL_OBJ.onunhandledrejection;
    $15YuE.GLOBAL_OBJ.onunhandledrejection = function(e) {
        const handlerData = e;
        $jSWkL.triggerHandlers("unhandledrejection", handlerData);
        if ($1c10dfc53b8edbf0$var$_oldOnUnhandledRejectionHandler) return $1c10dfc53b8edbf0$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    $15YuE.GLOBAL_OBJ.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}
module.exports.addGlobalUnhandledRejectionInstrumentationHandler = $1c10dfc53b8edbf0$var$addGlobalUnhandledRejectionInstrumentationHandler;

});

parcelRegister("dRW3b", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $59Hrx = parcelRequire("59Hrx");

var $i7X1A = parcelRequire("i7X1A");

var $gxkrU = parcelRequire("gxkrU");

var $hSRcd = parcelRequire("hSRcd");

var $faX3S = parcelRequire("faX3S");

var $eqMxV = parcelRequire("eqMxV");

var $gNZPa = parcelRequire("gNZPa");

var $eEQXZ = parcelRequire("eEQXZ");

var $6uOi2 = parcelRequire("6uOi2");

var $jHcnM = parcelRequire("jHcnM");

var $f0MA0 = parcelRequire("f0MA0");

var $hQAU7 = parcelRequire("hQAU7");

var $h77y5 = parcelRequire("h77y5");
const $a18d413551dd81f8$var$TRACE_FLAG_NONE = 0;
const $a18d413551dd81f8$var$TRACE_FLAG_SAMPLED = 1;
let $a18d413551dd81f8$var$hasShownSpanDropWarning = false;
function $a18d413551dd81f8$var$spanToTransactionTraceContext(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $a18d413551dd81f8$var$spanToJSON(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
function $a18d413551dd81f8$var$spanToTraceContext(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    const parent_span_id = isRemote ? spanId : $a18d413551dd81f8$var$spanToJSON(span).parent_span_id;
    const scope = $gNZPa.getCapturedScopesOnSpan(span).scope;
    const span_id = isRemote ? (scope === null || scope === void 0 ? void 0 : scope.getPropagationContext().propagationSpanId) || $6uOi2.generateSpanId() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
function $a18d413551dd81f8$var$spanToTraceHeader(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $a18d413551dd81f8$var$spanIsSampled(span);
    return $f0MA0.generateSentryTraceHeader(traceId, spanId, sampled);
}
function $a18d413551dd81f8$var$spanToTraceparentHeader(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $a18d413551dd81f8$var$spanIsSampled(span);
    return $f0MA0.generateTraceparentHeader(traceId, spanId, sampled);
}
function $a18d413551dd81f8$var$convertSpanLinksForEnvelope(links) {
    if (links && links.length > 0) return links.map((_param)=>{
        var { context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes } = _param, restContext = (0, $bLhVg._)(_param.context, [
            "spanId",
            "traceId",
            "traceFlags"
        ]);
        return (0, $9tqwB._)({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $a18d413551dd81f8$var$TRACE_FLAG_SAMPLED,
            attributes: attributes
        }, restContext);
    });
    else return void 0;
}
function $a18d413551dd81f8$var$getStreamedSpanLinks(links) {
    if (links === null || links === void 0 ? void 0 : links.length) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $a18d413551dd81f8$var$TRACE_FLAG_SAMPLED,
            attributes: attributes
        }));
    else return void 0;
}
function $a18d413551dd81f8$var$spanTimeInputToSeconds(input) {
    if (typeof input === "number") return $a18d413551dd81f8$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $a18d413551dd81f8$var$ensureTimestampInSeconds(input.getTime());
    return $jHcnM.timestampInSeconds();
}
function $a18d413551dd81f8$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1e3 : timestamp;
}
function $a18d413551dd81f8$var$spanToJSON(span) {
    if ($a18d413551dd81f8$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($a18d413551dd81f8$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: $a18d413551dd81f8$var$getOtelParentSpanId(span),
            start_timestamp: $a18d413551dd81f8$var$spanTimeInputToSeconds(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $a18d413551dd81f8$var$spanTimeInputToSeconds(endTime) || void 0,
            status: $a18d413551dd81f8$var$getStatusMessage(status),
            op: attributes[$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            origin: attributes[$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            links: $a18d413551dd81f8$var$convertSpanLinksForEnvelope(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $a18d413551dd81f8$var$spanToStreamedSpanJSON(span) {
    if ($a18d413551dd81f8$var$spanIsSentrySpan(span)) return span.getStreamedSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($a18d413551dd81f8$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            name: name,
            span_id: span_id,
            trace_id: trace_id,
            parent_span_id: $a18d413551dd81f8$var$getOtelParentSpanId(span),
            start_timestamp: $a18d413551dd81f8$var$spanTimeInputToSeconds(startTime),
            end_timestamp: $a18d413551dd81f8$var$spanTimeInputToSeconds(endTime),
            is_segment: span === $a18d413551dd81f8$var$INTERNAL_getSegmentSpan(span),
            status: $a18d413551dd81f8$var$getSimpleStatusMessage(status),
            attributes: attributes,
            links: $a18d413551dd81f8$var$getStreamedSpanLinks(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        name: "",
        end_timestamp: 0,
        status: "ok",
        is_segment: span === $a18d413551dd81f8$var$INTERNAL_getSegmentSpan(span)
    };
}
function $a18d413551dd81f8$var$getOtelParentSpanId(span) {
    var _span_parentSpanContext;
    return "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? (_span_parentSpanContext = span.parentSpanContext) === null || _span_parentSpanContext === void 0 ? void 0 : _span_parentSpanContext.spanId : void 0;
}
function $a18d413551dd81f8$var$streamedSpanJsonToSerializedSpan(spanJson) {
    var _spanJson_links;
    return (0, $2qxEV._)((0, $9tqwB._)({}, spanJson), {
        attributes: $i7X1A.serializeAttributes(spanJson.attributes),
        links: (_spanJson_links = spanJson.links) === null || _spanJson_links === void 0 ? void 0 : _spanJson_links.map((link)=>(0, $2qxEV._)((0, $9tqwB._)({}, link), {
                attributes: $i7X1A.serializeAttributes(link.attributes)
            }))
    });
}
function $a18d413551dd81f8$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
function $a18d413551dd81f8$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
function $a18d413551dd81f8$var$spanIsSampled(span) {
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $a18d413551dd81f8$var$TRACE_FLAG_SAMPLED;
}
function $a18d413551dd81f8$var$getStatusMessage(status) {
    if (!status || status.code === $eqMxV.SPAN_STATUS_UNSET) return void 0;
    if (status.code === $eqMxV.SPAN_STATUS_OK) return "ok";
    return status.message || "internal_error";
}
function $a18d413551dd81f8$var$getSimpleStatusMessage(status) {
    return !status || status.code === $eqMxV.SPAN_STATUS_OK || status.code === $eqMxV.SPAN_STATUS_UNSET || status.message === "cancelled" ? "ok" : "error";
}
const $a18d413551dd81f8$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $a18d413551dd81f8$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
function $a18d413551dd81f8$var$addChildSpanToSpan(span, childSpan) {
    const rootSpan = span[$a18d413551dd81f8$var$ROOT_SPAN_FIELD] || span;
    $eEQXZ.addNonEnumerableProperty(childSpan, $a18d413551dd81f8$var$ROOT_SPAN_FIELD, rootSpan);
    if (span[$a18d413551dd81f8$var$CHILD_SPANS_FIELD]) span[$a18d413551dd81f8$var$CHILD_SPANS_FIELD].add(childSpan);
    else $eEQXZ.addNonEnumerableProperty(span, $a18d413551dd81f8$var$CHILD_SPANS_FIELD, /* @__PURE__ */ new Set([
        childSpan
    ]));
}
function $a18d413551dd81f8$var$removeChildSpanFromSpan(span, childSpan) {
    if (span[$a18d413551dd81f8$var$CHILD_SPANS_FIELD]) span[$a18d413551dd81f8$var$CHILD_SPANS_FIELD].delete(childSpan);
}
function $a18d413551dd81f8$var$getSpanDescendants(span) {
    const resultSet = /* @__PURE__ */ new Set();
    function addSpanChildren(span2) {
        if (resultSet.has(span2)) return;
        else if ($a18d413551dd81f8$var$spanIsSampled(span2)) {
            resultSet.add(span2);
            const childSpans = span2[$a18d413551dd81f8$var$CHILD_SPANS_FIELD] ? Array.from(span2[$a18d413551dd81f8$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
const $a18d413551dd81f8$var$getRootSpan = $a18d413551dd81f8$var$INTERNAL_getSegmentSpan;
function $a18d413551dd81f8$var$INTERNAL_getSegmentSpan(span) {
    return span[$a18d413551dd81f8$var$ROOT_SPAN_FIELD] || span;
}
function $a18d413551dd81f8$var$getActiveSpan() {
    const carrier$1 = $gxkrU.getMainCarrier();
    const acs = $59Hrx.getAsyncContextStrategy(carrier$1);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return $h77y5._getSpanForScope($hSRcd.getCurrentScope());
}
function $a18d413551dd81f8$var$showSpanDropWarning() {
    if (!$a18d413551dd81f8$var$hasShownSpanDropWarning) {
        $hQAU7.consoleSandbox(()=>{
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.");
        });
        $a18d413551dd81f8$var$hasShownSpanDropWarning = true;
    }
}
function $a18d413551dd81f8$var$updateSpanName(span, name) {
    span.updateName(name);
    span.setAttributes({
        [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "custom",
        [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME]: name
    });
}
module.exports.INTERNAL_getSegmentSpan = $a18d413551dd81f8$var$INTERNAL_getSegmentSpan;
module.exports.TRACE_FLAG_NONE = $a18d413551dd81f8$var$TRACE_FLAG_NONE;
module.exports.TRACE_FLAG_SAMPLED = $a18d413551dd81f8$var$TRACE_FLAG_SAMPLED;
module.exports.addChildSpanToSpan = $a18d413551dd81f8$var$addChildSpanToSpan;
module.exports.convertSpanLinksForEnvelope = $a18d413551dd81f8$var$convertSpanLinksForEnvelope;
module.exports.getActiveSpan = $a18d413551dd81f8$var$getActiveSpan;
module.exports.getRootSpan = $a18d413551dd81f8$var$getRootSpan;
module.exports.getSimpleStatusMessage = $a18d413551dd81f8$var$getSimpleStatusMessage;
module.exports.getSpanDescendants = $a18d413551dd81f8$var$getSpanDescendants;
module.exports.getStatusMessage = $a18d413551dd81f8$var$getStatusMessage;
module.exports.getStreamedSpanLinks = $a18d413551dd81f8$var$getStreamedSpanLinks;
module.exports.removeChildSpanFromSpan = $a18d413551dd81f8$var$removeChildSpanFromSpan;
module.exports.showSpanDropWarning = $a18d413551dd81f8$var$showSpanDropWarning;
module.exports.spanIsSampled = $a18d413551dd81f8$var$spanIsSampled;
module.exports.spanTimeInputToSeconds = $a18d413551dd81f8$var$spanTimeInputToSeconds;
module.exports.spanToJSON = $a18d413551dd81f8$var$spanToJSON;
module.exports.spanToStreamedSpanJSON = $a18d413551dd81f8$var$spanToStreamedSpanJSON;
module.exports.spanToTraceContext = $a18d413551dd81f8$var$spanToTraceContext;
module.exports.spanToTraceHeader = $a18d413551dd81f8$var$spanToTraceHeader;
module.exports.spanToTraceparentHeader = $a18d413551dd81f8$var$spanToTraceparentHeader;
module.exports.spanToTransactionTraceContext = $a18d413551dd81f8$var$spanToTransactionTraceContext;
module.exports.streamedSpanJsonToSerializedSpan = $a18d413551dd81f8$var$streamedSpanJsonToSerializedSpan;
module.exports.updateSpanName = $a18d413551dd81f8$var$updateSpanName;

});
parcelRegister("bLhVg", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8901fc92b5563702$export$71511d61b312f219; });

var $a7m7Z = parcelRequire("a7m7Z");
function $8901fc92b5563702$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $a7m7Z._)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("a7m7Z", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $75dbb8f78ee65245$export$71511d61b312f219; });
function $75dbb8f78ee65245$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("59Hrx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gxkrU = parcelRequire("gxkrU");

var $h77y5 = parcelRequire("h77y5");

var $8E8me = parcelRequire("8E8me");
function $3c0f7deb0d3a8f81$var$setAsyncContextStrategy(strategy) {
    const registry = $gxkrU.getMainCarrier();
    const sentry = $gxkrU.getSentryCarrier(registry);
    sentry.acs = strategy;
}
function $3c0f7deb0d3a8f81$var$getAsyncContextStrategy(carrier$1) {
    const sentry = $gxkrU.getSentryCarrier(carrier$1);
    if (sentry.acs) return sentry.acs;
    return $8E8me.getStackAsyncContextStrategy();
}
function $3c0f7deb0d3a8f81$var$getTracingChannelBinding() {
    var _getAsyncContextStrategy_getTracingChannelBinding, _getAsyncContextStrategy;
    return (_getAsyncContextStrategy_getTracingChannelBinding = (_getAsyncContextStrategy = $3c0f7deb0d3a8f81$var$getAsyncContextStrategy($gxkrU.getMainCarrier())).getTracingChannelBinding) === null || _getAsyncContextStrategy_getTracingChannelBinding === void 0 ? void 0 : _getAsyncContextStrategy_getTracingChannelBinding.call(_getAsyncContextStrategy);
}
function $3c0f7deb0d3a8f81$var$_INTERNAL_createTracingChannelBinding(asyncLocalStorage, getScopes) {
    return {
        asyncLocalStorage: asyncLocalStorage,
        getStoreWithActiveSpan: (span)=>{
            const { scope: scope, isolationScope: isolationScope } = getScopes();
            const activeScope = scope.clone();
            $h77y5._setSpanForScope(activeScope, span);
            return {
                scope: activeScope,
                isolationScope: isolationScope
            };
        }
    };
}
module.exports._INTERNAL_createTracingChannelBinding = $3c0f7deb0d3a8f81$var$_INTERNAL_createTracingChannelBinding;
module.exports.getAsyncContextStrategy = $3c0f7deb0d3a8f81$var$getAsyncContextStrategy;
module.exports.getTracingChannelBinding = $3c0f7deb0d3a8f81$var$getTracingChannelBinding;
module.exports.setAsyncContextStrategy = $3c0f7deb0d3a8f81$var$setAsyncContextStrategy;

});
parcelRegister("h77y5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eEQXZ = parcelRequire("eEQXZ");

var $id64m = parcelRequire("id64m");
const $c758f2240d96c6ad$var$SCOPE_SPAN_FIELD = "_sentrySpan";
function $c758f2240d96c6ad$var$_setSpanForScope(scope, span) {
    if (span) $eEQXZ.addNonEnumerableProperty(scope, $c758f2240d96c6ad$var$SCOPE_SPAN_FIELD, $id64m.makeWeakRef(span));
    else delete scope[$c758f2240d96c6ad$var$SCOPE_SPAN_FIELD];
}
function $c758f2240d96c6ad$var$_getSpanForScope(scope) {
    return $id64m.derefWeakRef(scope[$c758f2240d96c6ad$var$SCOPE_SPAN_FIELD]);
}
module.exports._getSpanForScope = $c758f2240d96c6ad$var$_getSpanForScope;
module.exports._setSpanForScope = $c758f2240d96c6ad$var$_setSpanForScope;

});
parcelRegister("eEQXZ", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $859Bb = parcelRequire("859Bb");

var $hQAU7 = parcelRequire("hQAU7");

var $ibzbk = parcelRequire("ibzbk");
function $aabde32ea70db10c$var$fill(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    if (typeof wrapped === "function") $aabde32ea70db10c$var$markFunctionWrapped(wrapped, original);
    try {
        source[name] = wrapped;
    } catch (e) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.log(`Failed to replace method "${name}" in object`, source);
    }
}
function $aabde32ea70db10c$var$addNonEnumerableProperty(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch (e) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
function $aabde32ea70db10c$var$markFunctionWrapped(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $aabde32ea70db10c$var$addNonEnumerableProperty(wrapped, "__sentry_original__", original);
    } catch (e) {}
}
function $aabde32ea70db10c$var$wrapMethod(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== "function") throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($aabde32ea70db10c$var$getOriginalFunction(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $aabde32ea70db10c$var$markFunctionWrapped(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
function $aabde32ea70db10c$var$getOriginalFunction(func) {
    return func.__sentry_original__;
}
function $aabde32ea70db10c$var$convertToPlainObject(value) {
    if ($ibzbk.isError(value)) return (0, $9tqwB._)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $aabde32ea70db10c$var$getOwnProperties(value));
    if ($ibzbk.isEvent(value)) {
        const { type: type, target: target, currentTarget: currentTarget, detail: detail } = value;
        return (0, $9tqwB._)({
            type: type,
            target: target,
            currentTarget: currentTarget
        }, detail ? {
            detail: detail
        } : {}, $aabde32ea70db10c$var$getOwnProperties(value));
    }
    return value;
}
function $aabde32ea70db10c$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) return Object.fromEntries(Object.entries(obj));
    return {};
}
function $aabde32ea70db10c$var$extractExceptionKeysForMessage(exception) {
    const keys = Object.keys($aabde32ea70db10c$var$convertToPlainObject(exception));
    keys.sort();
    return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
function $aabde32ea70db10c$var$dropUndefinedKeys(inputValue) {
    const memoizationMap = /* @__PURE__ */ new Map();
    return $aabde32ea70db10c$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $aabde32ea70db10c$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) return memoVal;
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($aabde32ea70db10c$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($aabde32ea70db10c$var$isPojo(inputValue)) {
        const returnValue = {};
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== void 0) returnValue[key] = $aabde32ea70db10c$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    return inputValue;
}
function $aabde32ea70db10c$var$isPojo(input) {
    const constructor = input.constructor;
    return constructor === Object || constructor === void 0;
}
function $aabde32ea70db10c$var$objectify(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == void 0:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case $ibzbk.isPrimitive(wat):
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
module.exports.addNonEnumerableProperty = $aabde32ea70db10c$var$addNonEnumerableProperty;
module.exports.convertToPlainObject = $aabde32ea70db10c$var$convertToPlainObject;
module.exports.dropUndefinedKeys = $aabde32ea70db10c$var$dropUndefinedKeys;
module.exports.extractExceptionKeysForMessage = $aabde32ea70db10c$var$extractExceptionKeysForMessage;
module.exports.fill = $aabde32ea70db10c$var$fill;
module.exports.getOriginalFunction = $aabde32ea70db10c$var$getOriginalFunction;
module.exports.markFunctionWrapped = $aabde32ea70db10c$var$markFunctionWrapped;
module.exports.objectify = $aabde32ea70db10c$var$objectify;
module.exports.wrapMethod = $aabde32ea70db10c$var$wrapMethod;

});
parcelRegister("ibzbk", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $d3d48b6db0bace35$var$objectToString = Object.prototype.toString;
function $d3d48b6db0bace35$var$isError(wat) {
    switch($d3d48b6db0bace35$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $d3d48b6db0bace35$var$isInstanceOf(wat, Error);
    }
}
function $d3d48b6db0bace35$var$isBuiltin(wat, className) {
    return $d3d48b6db0bace35$var$objectToString.call(wat) === `[object ${className}]`;
}
function $d3d48b6db0bace35$var$isErrorEvent(wat) {
    return $d3d48b6db0bace35$var$isBuiltin(wat, "ErrorEvent");
}
function $d3d48b6db0bace35$var$isDOMError(wat) {
    return $d3d48b6db0bace35$var$isBuiltin(wat, "DOMError");
}
function $d3d48b6db0bace35$var$isDOMException(wat) {
    return $d3d48b6db0bace35$var$isBuiltin(wat, "DOMException");
}
function $d3d48b6db0bace35$var$isString(wat) {
    return $d3d48b6db0bace35$var$isBuiltin(wat, "String");
}
function $d3d48b6db0bace35$var$isParameterizedString(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function $d3d48b6db0bace35$var$isPrimitive(wat) {
    return wat === null || $d3d48b6db0bace35$var$isParameterizedString(wat) || typeof wat !== "object" && typeof wat !== "function";
}
function $d3d48b6db0bace35$var$isPlainObject(wat) {
    return $d3d48b6db0bace35$var$isBuiltin(wat, "Object");
}
function $d3d48b6db0bace35$var$isEvent(wat) {
    return typeof Event !== "undefined" && $d3d48b6db0bace35$var$isInstanceOf(wat, Event);
}
function $d3d48b6db0bace35$var$isElement(wat) {
    return typeof Element !== "undefined" && $d3d48b6db0bace35$var$isInstanceOf(wat, Element);
}
function $d3d48b6db0bace35$var$isRegExp(wat) {
    return $d3d48b6db0bace35$var$isBuiltin(wat, "RegExp");
}
function $d3d48b6db0bace35$var$isThenable(wat) {
    return Boolean((wat === null || wat === void 0 ? void 0 : wat.then) && typeof wat.then === "function");
}
function $d3d48b6db0bace35$var$isSyntheticEvent(wat) {
    return $d3d48b6db0bace35$var$isPlainObject(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $d3d48b6db0bace35$var$isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    } catch (e) {
        return false;
    }
}
function $d3d48b6db0bace35$var$isVueViewModel(wat) {
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
function $d3d48b6db0bace35$var$isRequest(request) {
    return typeof Request !== "undefined" && $d3d48b6db0bace35$var$isInstanceOf(request, Request);
}
module.exports.isDOMError = $d3d48b6db0bace35$var$isDOMError;
module.exports.isDOMException = $d3d48b6db0bace35$var$isDOMException;
module.exports.isElement = $d3d48b6db0bace35$var$isElement;
module.exports.isError = $d3d48b6db0bace35$var$isError;
module.exports.isErrorEvent = $d3d48b6db0bace35$var$isErrorEvent;
module.exports.isEvent = $d3d48b6db0bace35$var$isEvent;
module.exports.isInstanceOf = $d3d48b6db0bace35$var$isInstanceOf;
module.exports.isParameterizedString = $d3d48b6db0bace35$var$isParameterizedString;
module.exports.isPlainObject = $d3d48b6db0bace35$var$isPlainObject;
module.exports.isPrimitive = $d3d48b6db0bace35$var$isPrimitive;
module.exports.isRegExp = $d3d48b6db0bace35$var$isRegExp;
module.exports.isRequest = $d3d48b6db0bace35$var$isRequest;
module.exports.isString = $d3d48b6db0bace35$var$isString;
module.exports.isSyntheticEvent = $d3d48b6db0bace35$var$isSyntheticEvent;
module.exports.isThenable = $d3d48b6db0bace35$var$isThenable;
module.exports.isVueViewModel = $d3d48b6db0bace35$var$isVueViewModel;

});


parcelRegister("id64m", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $15YuE = parcelRequire("15YuE");
function $d41e261d7ca73588$var$makeWeakRef(value) {
    try {
        const WeakRefImpl = $15YuE.GLOBAL_OBJ.WeakRef;
        if (typeof WeakRefImpl === "function") return new WeakRefImpl(value);
    } catch (e) {}
    return value;
}
function $d41e261d7ca73588$var$derefWeakRef(ref) {
    if (!ref) return void 0;
    if (typeof ref === "object" && "deref" in ref && typeof ref.deref === "function") try {
        return ref.deref();
    } catch (e) {
        return void 0;
    }
    return ref;
}
module.exports.derefWeakRef = $d41e261d7ca73588$var$derefWeakRef;
module.exports.makeWeakRef = $d41e261d7ca73588$var$makeWeakRef;

});


parcelRegister("8E8me", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bo7a6 = parcelRequire("bo7a6");

var $4GLB5 = parcelRequire("4GLB5");

var $jgv4K = parcelRequire("jgv4K");

var $ibzbk = parcelRequire("ibzbk");

var $gxkrU = parcelRequire("gxkrU");
class $64b88ad193ee4016$var$AsyncContextStack {
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ($ibzbk.isThenable(maybePromiseResult)) return $jgv4K.chainAndCopyPromiseLike(maybePromiseResult, ()=>this._popScope(), ()=>this._popScope());
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
    constructor(scope$1, isolationScope){
        let assignedScope;
        if (!scope$1) assignedScope = new $4GLB5.Scope();
        else assignedScope = scope$1;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new $4GLB5.Scope();
        else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
}
function $64b88ad193ee4016$var$getAsyncContextStack() {
    const registry = $gxkrU.getMainCarrier();
    const sentry = $gxkrU.getSentryCarrier(registry);
    return sentry.stack = sentry.stack || new $64b88ad193ee4016$var$AsyncContextStack($bo7a6.getDefaultCurrentScope(), $bo7a6.getDefaultIsolationScope());
}
function $64b88ad193ee4016$var$withScope(callback) {
    return $64b88ad193ee4016$var$getAsyncContextStack().withScope(callback);
}
function $64b88ad193ee4016$var$withSetScope(scope, callback) {
    const stack = $64b88ad193ee4016$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $64b88ad193ee4016$var$withIsolationScope(callback) {
    return $64b88ad193ee4016$var$getAsyncContextStack().withScope(()=>{
        return callback($64b88ad193ee4016$var$getAsyncContextStack().getIsolationScope());
    });
}
function $64b88ad193ee4016$var$getStackAsyncContextStrategy() {
    return {
        withIsolationScope: $64b88ad193ee4016$var$withIsolationScope,
        withScope: $64b88ad193ee4016$var$withScope,
        withSetScope: $64b88ad193ee4016$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $64b88ad193ee4016$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$64b88ad193ee4016$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$64b88ad193ee4016$var$getAsyncContextStack().getIsolationScope()
    };
}
module.exports.AsyncContextStack = $64b88ad193ee4016$var$AsyncContextStack;
module.exports.getStackAsyncContextStrategy = $64b88ad193ee4016$var$getStackAsyncContextStrategy;

});
parcelRegister("bo7a6", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gxkrU = parcelRequire("gxkrU");

var $4GLB5 = parcelRequire("4GLB5");
function $84a77dced50b8ff3$var$getDefaultCurrentScope() {
    return $gxkrU.getGlobalSingleton("defaultCurrentScope", ()=>new $4GLB5.Scope());
}
function $84a77dced50b8ff3$var$getDefaultIsolationScope() {
    return $gxkrU.getGlobalSingleton("defaultIsolationScope", ()=>new $4GLB5.Scope());
}
module.exports.getDefaultCurrentScope = $84a77dced50b8ff3$var$getDefaultCurrentScope;
module.exports.getDefaultIsolationScope = $84a77dced50b8ff3$var$getDefaultIsolationScope;

});
parcelRegister("4GLB5", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $859Bb = parcelRequire("859Bb");

var $kHUG4 = parcelRequire("kHUG4");

var $hQAU7 = parcelRequire("hQAU7");

var $ibzbk = parcelRequire("ibzbk");

var $7Ol7I = parcelRequire("7Ol7I");

var $hppxz = parcelRequire("hppxz");

var $6uOi2 = parcelRequire("6uOi2");

var $hxJcq = parcelRequire("hxJcq");

var $h77y5 = parcelRequire("h77y5");

var $8zsqf = parcelRequire("8zsqf");

var $jHcnM = parcelRequire("jHcnM");
const $36a0017cc8c1107f$var$DEFAULT_MAX_BREADCRUMBS = 100;
class $36a0017cc8c1107f$var$Scope {
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $36a0017cc8c1107f$var$Scope();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = (0, $9tqwB._)({}, this._tags);
        newScope._attributes = (0, $9tqwB._)({}, this._attributes);
        newScope._extra = (0, $9tqwB._)({}, this._extra);
        newScope._contexts = (0, $9tqwB._)({}, this._contexts);
        if (this._contexts.flags) newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = (0, $9tqwB._)({}, this._sdkProcessingMetadata);
        newScope._propagationContext = (0, $9tqwB._)({}, this._propagationContext);
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        $h77y5._setSpanForScope(newScope, $h77y5._getSpanForScope(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        this._user = user || {
            email: void 0,
            id: void 0,
            ip_address: void 0,
            username: void 0
        };
        if (this._session) $kHUG4.updateSession(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || void 0;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = (0, $9tqwB._)({}, this._tags, tags);
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param newAttributes - The attributes to set on the scope, as key-value pairs.
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: 150,
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = (0, $9tqwB._)({}, this._attributes, newAttributes);
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param key - The attribute key.
   * @param value - The attribute value.
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', 150);
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = (0, $9tqwB._)({}, this._extra, extras);
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = (0, $2qxEV._)((0, $9tqwB._)({}, this._extra), {
            [key]: extra
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $36a0017cc8c1107f$var$Scope ? scopeToMerge.getScopeData() : $ibzbk.isPlainObject(scopeToMerge) ? captureContext : void 0;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = (0, $9tqwB._)({}, this._tags, tags);
        this._attributes = (0, $9tqwB._)({}, this._attributes, attributes);
        this._extra = (0, $9tqwB._)({}, this._extra, extra);
        this._contexts = (0, $9tqwB._)({}, this._contexts, contexts);
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = void 0;
        this._transactionName = void 0;
        this._fingerprint = void 0;
        this._session = void 0;
        this._conversationId = void 0;
        $h77y5._setSpanForScope(this, void 0);
        this._attachments = [];
        this.setPropagationContext({
            traceId: $6uOi2.generateTraceId(),
            sampleRand: $hxJcq.safeMathRandom()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $36a0017cc8c1107f$var$DEFAULT_MAX_BREADCRUMBS;
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = (0, $2qxEV._)((0, $9tqwB._)({
            timestamp: $jHcnM.dateTimestampInSeconds()
        }, breadcrumb), {
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? $8zsqf.truncate(breadcrumb.message, 2048) : breadcrumb.message
        });
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            var _this__client;
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            (_this__client = this._client) === null || _this__client === void 0 ? void 0 : _this__client.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: $h77y5._getSpanForScope(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = $7Ol7I.merge(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = (hint === null || hint === void 0 ? void 0 : hint.event_id) || $hppxz.uuid4();
        if (!this._client) {
            $859Bb.DEBUG_BUILD && $hQAU7.debug.warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, (0, $2qxEV._)((0, $9tqwB._)({
            originalException: exception,
            syntheticException: syntheticException
        }, hint), {
            event_id: eventId
        }), this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = (hint === null || hint === void 0 ? void 0 : hint.event_id) || $hppxz.uuid4();
        if (!this._client) {
            $859Bb.DEBUG_BUILD && $hQAU7.debug.warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        var _hint_syntheticException;
        const syntheticException = (_hint_syntheticException = hint === null || hint === void 0 ? void 0 : hint.syntheticException) !== null && _hint_syntheticException !== void 0 ? _hint_syntheticException : new Error(message);
        this._client.captureMessage(message, level, (0, $2qxEV._)((0, $9tqwB._)({
            originalException: message,
            syntheticException: syntheticException
        }, hint), {
            event_id: eventId
        }), this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || (hint === null || hint === void 0 ? void 0 : hint.event_id) || $hppxz.uuid4();
        if (!this._client) {
            $859Bb.DEBUG_BUILD && $hQAU7.debug.warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, (0, $2qxEV._)((0, $9tqwB._)({}, hint), {
            event_id: eventId
        }), this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
    // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: $6uOi2.generateTraceId(),
            sampleRand: $hxJcq.safeMathRandom()
        };
    }
}
module.exports.Scope = $36a0017cc8c1107f$var$Scope;

});
parcelRegister("kHUG4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hppxz = parcelRequire("hppxz");

var $jHcnM = parcelRequire("jHcnM");
function $f133c9ca49a9c97f$var$makeSession(context) {
    const startingTime = $jHcnM.timestampInSeconds();
    const session = {
        sid: $hppxz.uuid4(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$f133c9ca49a9c97f$var$sessionToJSON(session)
    };
    if (context) $f133c9ca49a9c97f$var$updateSession(session, context);
    return session;
}
function $f133c9ca49a9c97f$var$updateSession(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || $jHcnM.timestampInSeconds();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) session.sid = context.sid.length === 32 ? context.sid : $hppxz.uuid4();
    if (context.init !== void 0) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = void 0;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
function $f133c9ca49a9c97f$var$closeSession(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $f133c9ca49a9c97f$var$updateSession(session, context);
}
function $f133c9ca49a9c97f$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1e3).toISOString(),
        timestamp: new Date(session.timestamp * 1e3).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : void 0,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}
module.exports.closeSession = $f133c9ca49a9c97f$var$closeSession;
module.exports.makeSession = $f133c9ca49a9c97f$var$makeSession;
module.exports.updateSession = $f133c9ca49a9c97f$var$updateSession;

});
parcelRegister("hppxz", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eEQXZ = parcelRequire("eEQXZ");

var $hxJcq = parcelRequire("hxJcq");

var $8zsqf = parcelRequire("8zsqf");

var $15YuE = parcelRequire("15YuE");
function $cac8954965b626bc$var$getCrypto() {
    const gbl = $15YuE.GLOBAL_OBJ;
    return gbl.crypto || gbl.msCrypto;
}
let $cac8954965b626bc$var$emptyUuid;
function $cac8954965b626bc$var$getRandomByte() {
    return $hxJcq.safeMathRandom() * 16;
}
function $cac8954965b626bc$var$uuid4(crypto = $cac8954965b626bc$var$getCrypto()) {
    try {
        if (crypto === null || crypto === void 0 ? void 0 : crypto.randomUUID) return $hxJcq.withRandomSafeContext(()=>crypto.randomUUID()).replace(/-/g, "");
    } catch (e) {}
    if (!$cac8954965b626bc$var$emptyUuid) $cac8954965b626bc$var$emptyUuid = "10000000100040008000100000000000";
    return $cac8954965b626bc$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($cac8954965b626bc$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $cac8954965b626bc$var$getFirstException(event) {
    var _event_exception_values, _event_exception;
    return (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values[0];
}
function $cac8954965b626bc$var$getEventDescription(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $cac8954965b626bc$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $cac8954965b626bc$var$addExceptionTypeValue(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $cac8954965b626bc$var$addExceptionMechanism(event, newMechanism) {
    const firstException = $cac8954965b626bc$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $9tqwB._)({}, defaultMechanism, currentMechanism, newMechanism);
    if (newMechanism && "data" in newMechanism) {
        const mergedData = (0, $9tqwB._)({}, currentMechanism === null || currentMechanism === void 0 ? void 0 : currentMechanism.data, newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
const $cac8954965b626bc$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $cac8954965b626bc$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
function $cac8954965b626bc$var$parseSemver(input) {
    const match = input.match($cac8954965b626bc$var$SEMVER_REGEXP) || [];
    const major = $cac8954965b626bc$var$_parseInt(match[1]);
    const minor = $cac8954965b626bc$var$_parseInt(match[2]);
    const patch = $cac8954965b626bc$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? void 0 : major,
        minor: isNaN(minor) ? void 0 : minor,
        patch: isNaN(patch) ? void 0 : patch,
        prerelease: match[4]
    };
}
function $cac8954965b626bc$var$addContextToFrame(lines, frame, linesOfContext = 5) {
    if (frame.lineno === void 0) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>$8zsqf.snipLine(line, 0));
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    frame.context_line = $8zsqf.snipLine(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>$8zsqf.snipLine(line, 0));
}
function $cac8954965b626bc$var$checkOrSetAlreadyCaught(exception) {
    if ($cac8954965b626bc$var$isAlreadyCaptured(exception)) return true;
    try {
        $eEQXZ.addNonEnumerableProperty(exception, "__sentry_captured__", true);
    } catch (e) {}
    return false;
}
function $cac8954965b626bc$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch (e) {}
}
module.exports.addContextToFrame = $cac8954965b626bc$var$addContextToFrame;
module.exports.addExceptionMechanism = $cac8954965b626bc$var$addExceptionMechanism;
module.exports.addExceptionTypeValue = $cac8954965b626bc$var$addExceptionTypeValue;
module.exports.checkOrSetAlreadyCaught = $cac8954965b626bc$var$checkOrSetAlreadyCaught;
module.exports.getEventDescription = $cac8954965b626bc$var$getEventDescription;
module.exports.isAlreadyCaptured = $cac8954965b626bc$var$isAlreadyCaptured;
module.exports.parseSemver = $cac8954965b626bc$var$parseSemver;
module.exports.uuid4 = $cac8954965b626bc$var$uuid4;

});
parcelRegister("hxJcq", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $15YuE = parcelRequire("15YuE");
let $cc589462a9317eb1$var$RESOLVED_RUNNER;
function $cc589462a9317eb1$var$withRandomSafeContext(cb) {
    if ($cc589462a9317eb1$var$RESOLVED_RUNNER !== void 0) return $cc589462a9317eb1$var$RESOLVED_RUNNER ? $cc589462a9317eb1$var$RESOLVED_RUNNER(cb) : cb();
    const sym = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
    const globalWithSymbol = $15YuE.GLOBAL_OBJ;
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
        $cc589462a9317eb1$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $cc589462a9317eb1$var$RESOLVED_RUNNER(cb);
    }
    $cc589462a9317eb1$var$RESOLVED_RUNNER = null;
    return cb();
}
function $cc589462a9317eb1$var$safeMathRandom() {
    return $cc589462a9317eb1$var$withRandomSafeContext(()=>Math.random());
}
function $cc589462a9317eb1$var$safeDateNow() {
    return $cc589462a9317eb1$var$withRandomSafeContext(()=>Date.now());
}
module.exports.safeDateNow = $cc589462a9317eb1$var$safeDateNow;
module.exports.safeMathRandom = $cc589462a9317eb1$var$safeMathRandom;
module.exports.withRandomSafeContext = $cc589462a9317eb1$var$withRandomSafeContext;

});

parcelRegister("8zsqf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ibzbk = parcelRequire("ibzbk");

var $irz1w = parcelRequire("irz1w");
function $63d7a3b95be82c7a$var$truncate(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
function $63d7a3b95be82c7a$var$snipLine(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $63d7a3b95be82c7a$var$safeJoin(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        if ($ibzbk.isPrimitive(value)) output.push(String(value));
        else if (value instanceof Error) output.push(value.message ? `${value.name}: ${value.message}` : value.name);
        else output.push($irz1w.stringifyValue(void 0, value));
    }
    return output.join(delimiter);
}
function $63d7a3b95be82c7a$var$isMatchingPattern(value, pattern, requireExactStringMatch = false) {
    if (!$ibzbk.isString(value)) return false;
    if ($ibzbk.isRegExp(pattern)) return pattern.test(value);
    if ($ibzbk.isString(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === "function") return pattern(value);
    return false;
}
function $63d7a3b95be82c7a$var$stringMatchesSomePattern(testString, patterns = [], requireExactStringMatch = false) {
    for (const pattern of patterns){
        if ($63d7a3b95be82c7a$var$isMatchingPattern(testString, pattern, requireExactStringMatch)) return true;
    }
    return false;
}
module.exports.isMatchingPattern = $63d7a3b95be82c7a$var$isMatchingPattern;
module.exports.safeJoin = $63d7a3b95be82c7a$var$safeJoin;
module.exports.snipLine = $63d7a3b95be82c7a$var$snipLine;
module.exports.stringMatchesSomePattern = $63d7a3b95be82c7a$var$stringMatchesSomePattern;
module.exports.truncate = $63d7a3b95be82c7a$var$truncate;

});
parcelRegister("irz1w", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $a1iNu = parcelRequire("a1iNu");

var $eEQXZ = parcelRequire("eEQXZ");

var $ah1An = parcelRequire("ah1An");
let $d6d5ea930fa3e6b6$var$stringifier;
function $d6d5ea930fa3e6b6$var$setNormalizeStringifier(newStringifier) {
    $d6d5ea930fa3e6b6$var$stringifier = newStringifier;
}
function $d6d5ea930fa3e6b6$var$normalize(input, depth = 100, maxProperties = Infinity) {
    try {
        return $d6d5ea930fa3e6b6$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
function $d6d5ea930fa3e6b6$var$normalizeToSize(object, depth = 3, maxSize = 102400) {
    const normalized = $d6d5ea930fa3e6b6$var$normalize(object, depth);
    if ($d6d5ea930fa3e6b6$var$jsonSize(normalized) > maxSize) return $d6d5ea930fa3e6b6$var$normalizeToSize(object, depth - 1, maxSize);
    return normalized;
}
function $d6d5ea930fa3e6b6$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $d6d5ea930fa3e6b6$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $d6d5ea930fa3e6b6$var$stringifyValue(key, value);
    if (!stringified.startsWith("[object ")) return stringified;
    if ($a1iNu.hasSkipNormalizationHint(value)) return value;
    const overrideDepth = $a1iNu.getNormalizationDepthOverrideHint(value);
    const remainingDepth = overrideDepth !== void 0 ? overrideDepth : depth;
    if (remainingDepth === 0) return stringified.replace("object ", "");
    if (memoize(value)) return "[Circular ~]";
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        return $d6d5ea930fa3e6b6$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (e) {}
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    const visitable = $eEQXZ.convertToPlainObject(value);
    for(const visitKey in visitable){
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $d6d5ea930fa3e6b6$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    unmemoize(value);
    return normalized;
}
function $d6d5ea930fa3e6b6$var$stringifyValue(key, value) {
    try {
        if ($d6d5ea930fa3e6b6$var$stringifier) {
            const stringified = $d6d5ea930fa3e6b6$var$stringifier(value);
            if (stringified) return stringified;
        }
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${$ah1An.getFunctionName(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        const objName = $d6d5ea930fa3e6b6$var$getConstructorName(value);
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
function $d6d5ea930fa3e6b6$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === void 0 ? void 0 : prototype.constructor) ? prototype.constructor.name : "null prototype";
}
function $d6d5ea930fa3e6b6$var$utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}
function $d6d5ea930fa3e6b6$var$jsonSize(value) {
    return $d6d5ea930fa3e6b6$var$utf8Length(JSON.stringify(value));
}
function $d6d5ea930fa3e6b6$var$normalizeUrlToBase(url, basePath) {
    const escapedBase = basePath.replace(/\\/g, "/").replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (e) {}
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "").replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
function $d6d5ea930fa3e6b6$var$memoBuilder() {
    const inner = /* @__PURE__ */ new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}
module.exports.normalize = $d6d5ea930fa3e6b6$var$normalize;
module.exports.normalizeToSize = $d6d5ea930fa3e6b6$var$normalizeToSize;
module.exports.normalizeUrlToBase = $d6d5ea930fa3e6b6$var$normalizeUrlToBase;
module.exports.setNormalizeStringifier = $d6d5ea930fa3e6b6$var$setNormalizeStringifier;
module.exports.stringifyValue = $d6d5ea930fa3e6b6$var$stringifyValue;

});
parcelRegister("a1iNu", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eEQXZ = parcelRequire("eEQXZ");
const $01e1f1df798deb0c$var$SENTRY_SKIP_NORMALIZATION = /* @__PURE__ */ Symbol.for("sentry.skipNormalization");
const $01e1f1df798deb0c$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = /* @__PURE__ */ Symbol.for("sentry.overrideNormalizationDepth");
function $01e1f1df798deb0c$var$setSkipNormalizationHint(obj) {
    $eEQXZ.addNonEnumerableProperty(obj, $01e1f1df798deb0c$var$SENTRY_SKIP_NORMALIZATION, true);
}
function $01e1f1df798deb0c$var$setNormalizationDepthOverrideHint(obj, depth) {
    $eEQXZ.addNonEnumerableProperty(obj, $01e1f1df798deb0c$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
function $01e1f1df798deb0c$var$hasSkipNormalizationHint(value) {
    return Boolean(value[$01e1f1df798deb0c$var$SENTRY_SKIP_NORMALIZATION]);
}
function $01e1f1df798deb0c$var$getNormalizationDepthOverrideHint(value) {
    const v = value[$01e1f1df798deb0c$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === "number" ? v : void 0;
}
module.exports.getNormalizationDepthOverrideHint = $01e1f1df798deb0c$var$getNormalizationDepthOverrideHint;
module.exports.hasSkipNormalizationHint = $01e1f1df798deb0c$var$hasSkipNormalizationHint;
module.exports.setNormalizationDepthOverrideHint = $01e1f1df798deb0c$var$setNormalizationDepthOverrideHint;
module.exports.setSkipNormalizationHint = $01e1f1df798deb0c$var$setSkipNormalizationHint;

});




parcelRegister("jHcnM", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hxJcq = parcelRequire("hxJcq");

var $15YuE = parcelRequire("15YuE");
const $e56ba35dc8c17bdf$var$ONE_SECOND_IN_MS = 1e3;
function $e56ba35dc8c17bdf$var$dateTimestampInSeconds() {
    return $hxJcq.safeDateNow() / $e56ba35dc8c17bdf$var$ONE_SECOND_IN_MS;
}
function $e56ba35dc8c17bdf$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = $15YuE.GLOBAL_OBJ;
    if (!(performance === null || performance === void 0 ? void 0 : performance.now) || !performance.timeOrigin) return $e56ba35dc8c17bdf$var$dateTimestampInSeconds;
    const timeOrigin = performance.timeOrigin;
    return ()=>{
        return (timeOrigin + $hxJcq.withRandomSafeContext(()=>performance.now())) / $e56ba35dc8c17bdf$var$ONE_SECOND_IN_MS;
    };
}
let $e56ba35dc8c17bdf$var$_cachedTimestampInSeconds;
function $e56ba35dc8c17bdf$var$timestampInSeconds() {
    const func = $e56ba35dc8c17bdf$var$_cachedTimestampInSeconds !== null && $e56ba35dc8c17bdf$var$_cachedTimestampInSeconds !== void 0 ? $e56ba35dc8c17bdf$var$_cachedTimestampInSeconds : $e56ba35dc8c17bdf$var$_cachedTimestampInSeconds = $e56ba35dc8c17bdf$var$createUnixTimestampInSecondsFunc();
    return func();
}
let $e56ba35dc8c17bdf$var$cachedTimeOrigin = null;
function $e56ba35dc8c17bdf$var$getBrowserTimeOrigin() {
    var _performance_timing;
    const { performance: performance } = $15YuE.GLOBAL_OBJ;
    if (!(performance === null || performance === void 0 ? void 0 : performance.now)) return void 0;
    const threshold = 3e5;
    const performanceNow = $hxJcq.withRandomSafeContext(()=>performance.now());
    const dateNow = $hxJcq.safeDateNow();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === "number") {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    const navigationStart = (_performance_timing = performance.timing) === null || _performance_timing === void 0 ? void 0 : _performance_timing.navigationStart;
    if (typeof navigationStart === "number") {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    return dateNow - performanceNow;
}
function $e56ba35dc8c17bdf$var$browserPerformanceTimeOrigin() {
    if ($e56ba35dc8c17bdf$var$cachedTimeOrigin === null) $e56ba35dc8c17bdf$var$cachedTimeOrigin = $e56ba35dc8c17bdf$var$getBrowserTimeOrigin();
    return $e56ba35dc8c17bdf$var$cachedTimeOrigin;
}
module.exports.browserPerformanceTimeOrigin = $e56ba35dc8c17bdf$var$browserPerformanceTimeOrigin;
module.exports.dateTimestampInSeconds = $e56ba35dc8c17bdf$var$dateTimestampInSeconds;
module.exports.timestampInSeconds = $e56ba35dc8c17bdf$var$timestampInSeconds;

});


parcelRegister("7Ol7I", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $5afd96914278a6bb$var$merge(initialObj, mergeObj, levels = 2) {
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    const output = (0, $9tqwB._)({}, initialObj);
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $5afd96914278a6bb$var$merge(output[key], mergeObj[key], levels - 1);
    return output;
}
module.exports.merge = $5afd96914278a6bb$var$merge;

});

parcelRegister("6uOi2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hppxz = parcelRequire("hppxz");
function $4bac8df25d95e6cd$var$generateTraceId() {
    return $hppxz.uuid4();
}
function $4bac8df25d95e6cd$var$generateSpanId() {
    return $hppxz.uuid4().substring(16);
}
module.exports.generateSpanId = $4bac8df25d95e6cd$var$generateSpanId;
module.exports.generateTraceId = $4bac8df25d95e6cd$var$generateTraceId;

});



parcelRegister("jgv4K", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $e0679de5dfa7ec14$var$isActualPromise = (p)=>p instanceof Promise && !p[$e0679de5dfa7ec14$var$kChainedCopy];
const $e0679de5dfa7ec14$var$kChainedCopy = /* @__PURE__ */ Symbol("chained PromiseLike");
const $e0679de5dfa7ec14$var$chainAndCopyPromiseLike = (original, onSuccess, onError)=>{
    const chained = original.then((value)=>{
        onSuccess(value);
        return value;
    }, (err)=>{
        onError(err);
        throw err;
    });
    return $e0679de5dfa7ec14$var$isActualPromise(chained) && $e0679de5dfa7ec14$var$isActualPromise(original) ? chained : $e0679de5dfa7ec14$var$copyProps(original, chained);
};
const $e0679de5dfa7ec14$var$copyProps = (original, chained)=>{
    if (!chained) return original;
    let mutated = false;
    for(const key in original){
        if (key in chained) continue;
        mutated = true;
        const value = original[key];
        if (typeof value === "function") Object.defineProperty(chained, key, {
            value: (...args)=>value.apply(original, args),
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    }
    if (mutated) Object.assign(chained, {
        [$e0679de5dfa7ec14$var$kChainedCopy]: true
    });
    return chained;
};
module.exports.chainAndCopyPromiseLike = $e0679de5dfa7ec14$var$chainAndCopyPromiseLike;

});



parcelRegister("i7X1A", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ibzbk = parcelRequire("ibzbk");
function $d326aa7f4adf5984$var$isAttributeObject(maybeObj) {
    return typeof maybeObj === "object" && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes("value");
}
function $d326aa7f4adf5984$var$attributeValueToTypedAttributeValue(rawValue, useFallback) {
    const { value: value, unit: unit } = $d326aa7f4adf5984$var$isAttributeObject(rawValue) ? rawValue : {
        value: rawValue,
        unit: void 0
    };
    const attributeValue = $d326aa7f4adf5984$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === "string" ? {
        unit: unit
    } : {};
    if (attributeValue) return (0, $9tqwB._)({}, attributeValue, checkedUnit);
    if (!useFallback || useFallback === "skip-undefined" && value === void 0) return;
    let stringValue = "";
    try {
        var _JSON_stringify;
        stringValue = (_JSON_stringify = JSON.stringify(value)) !== null && _JSON_stringify !== void 0 ? _JSON_stringify : "";
    } catch (e) {}
    return (0, $9tqwB._)({
        value: stringValue,
        type: "string"
    }, checkedUnit);
}
function $d326aa7f4adf5984$var$serializeAttributes(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes !== null && attributes !== void 0 ? attributes : {})){
        const typedValue = $d326aa7f4adf5984$var$attributeValueToTypedAttributeValue(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
function $d326aa7f4adf5984$var$estimateTypedAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    for (const [key, attr] of Object.entries(attributes)){
        var _attr_unit;
        weight += key.length * 2;
        weight += attr.type.length * 2;
        var _attr_unit_length;
        weight += ((_attr_unit_length = (_attr_unit = attr.unit) === null || _attr_unit === void 0 ? void 0 : _attr_unit.length) !== null && _attr_unit_length !== void 0 ? _attr_unit_length : 0) * 2;
        const val = attr.value;
        if (Array.isArray(val)) weight += $d326aa7f4adf5984$var$estimatePrimitiveSizeInBytes(val[0]) * val.length;
        else if ($ibzbk.isPrimitive(val)) weight += $d326aa7f4adf5984$var$estimatePrimitiveSizeInBytes(val);
        else weight += 100;
    }
    return weight;
}
function $d326aa7f4adf5984$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "boolean") return 4;
    else if (typeof value === "number") return 8;
    return 0;
}
function $d326aa7f4adf5984$var$getTypedAttributeValue(value) {
    if (Array.isArray(value)) return {
        value: value,
        type: "array"
    };
    const primitiveType = typeof value === "string" ? "string" : typeof value === "boolean" ? "boolean" : typeof value === "number" && !Number.isNaN(value) ? Number.isInteger(value) ? "integer" : "double" : null;
    if (primitiveType) return {
        value: value,
        type: primitiveType
    };
}
module.exports.attributeValueToTypedAttributeValue = $d326aa7f4adf5984$var$attributeValueToTypedAttributeValue;
module.exports.estimateTypedAttributesSizeInBytes = $d326aa7f4adf5984$var$estimateTypedAttributesSizeInBytes;
module.exports.isAttributeObject = $d326aa7f4adf5984$var$isAttributeObject;
module.exports.serializeAttributes = $d326aa7f4adf5984$var$serializeAttributes;

});

parcelRegister("hSRcd", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $59Hrx = parcelRequire("59Hrx");

var $gxkrU = parcelRequire("gxkrU");

var $4GLB5 = parcelRequire("4GLB5");

var $6uOi2 = parcelRequire("6uOi2");
let $d050be7146d3a82b$var$_externalPropagationContextProvider;
function $d050be7146d3a82b$var$registerExternalPropagationContext(fn) {
    $d050be7146d3a82b$var$_externalPropagationContextProvider = fn;
}
function $d050be7146d3a82b$var$getExternalPropagationContext() {
    return $d050be7146d3a82b$var$_externalPropagationContextProvider === null || $d050be7146d3a82b$var$_externalPropagationContextProvider === void 0 ? void 0 : $d050be7146d3a82b$var$_externalPropagationContextProvider();
}
function $d050be7146d3a82b$var$hasExternalPropagationContext() {
    return $d050be7146d3a82b$var$_externalPropagationContextProvider !== void 0;
}
function $d050be7146d3a82b$var$getCurrentScope() {
    const carrier$1 = $gxkrU.getMainCarrier();
    const acs = $59Hrx.getAsyncContextStrategy(carrier$1);
    return acs.getCurrentScope();
}
function $d050be7146d3a82b$var$getIsolationScope() {
    const carrier$1 = $gxkrU.getMainCarrier();
    const acs = $59Hrx.getAsyncContextStrategy(carrier$1);
    return acs.getIsolationScope();
}
function $d050be7146d3a82b$var$getGlobalScope() {
    return $gxkrU.getGlobalSingleton("globalScope", ()=>new $4GLB5.Scope());
}
function $d050be7146d3a82b$var$withScope(...rest) {
    const carrier$1 = $gxkrU.getMainCarrier();
    const acs = $59Hrx.getAsyncContextStrategy(carrier$1);
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
function $d050be7146d3a82b$var$withIsolationScope(...rest) {
    const carrier$1 = $gxkrU.getMainCarrier();
    const acs = $59Hrx.getAsyncContextStrategy(carrier$1);
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
function $d050be7146d3a82b$var$getClient() {
    return $d050be7146d3a82b$var$getCurrentScope().getClient();
}
function $d050be7146d3a82b$var$getTraceContextFromScope(scope) {
    const externalContext = $d050be7146d3a82b$var$getExternalPropagationContext();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    const propagationContext$1 = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext$1;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || $6uOi2.generateSpanId()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}
module.exports.getClient = $d050be7146d3a82b$var$getClient;
module.exports.getCurrentScope = $d050be7146d3a82b$var$getCurrentScope;
module.exports.getExternalPropagationContext = $d050be7146d3a82b$var$getExternalPropagationContext;
module.exports.getGlobalScope = $d050be7146d3a82b$var$getGlobalScope;
module.exports.getIsolationScope = $d050be7146d3a82b$var$getIsolationScope;
module.exports.getTraceContextFromScope = $d050be7146d3a82b$var$getTraceContextFromScope;
module.exports.hasExternalPropagationContext = $d050be7146d3a82b$var$hasExternalPropagationContext;
module.exports.registerExternalPropagationContext = $d050be7146d3a82b$var$registerExternalPropagationContext;
module.exports.withIsolationScope = $d050be7146d3a82b$var$withIsolationScope;
module.exports.withScope = $d050be7146d3a82b$var$withScope;

});

parcelRegister("faX3S", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = "sentry.source";
const $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = "sentry.sample_rate";
const $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = "sentry.previous_trace_sample_rate";
const $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_OP = "sentry.op";
const $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = "sentry.origin";
const $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = "sentry.idle_span_finish_reason";
const $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = "sentry.measurement_unit";
const $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = "sentry.measurement_value";
const $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = "sentry.release";
const $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = "sentry.environment";
const $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = "sentry.segment.name";
const $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = "sentry.segment.id";
const $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = "sentry.sdk.name";
const $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = "sentry.sdk.version";
const $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = "sentry.sdk.integrations";
const $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_USER_ID = "user.id";
const $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_USER_EMAIL = "user.email";
const $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = "user.ip_address";
const $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_USER_USERNAME = "user.name";
const $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = "sentry.custom_span_name";
const $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_PROFILE_ID = "sentry.profile_id";
const $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = "sentry.exclusive_time";
const $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_CACHE_HIT = "cache.hit";
const $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_CACHE_KEY = "cache.key";
const $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = "cache.item_size";
const $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = "http.request.method";
const $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_URL_FULL = "url.full";
const $b0c59a927bddc4e6$var$SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = "sentry.link.type";
const $b0c59a927bddc4e6$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE = "gen_ai.conversation.id";
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $b0c59a927bddc4e6$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_HIT = $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_CACHE_HIT;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_KEY = $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_CACHE_KEY;
module.exports.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
module.exports.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
module.exports.SEMANTIC_ATTRIBUTE_PROFILE_ID = $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_PROFILE_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_OP = $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_OP;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_RELEASE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
module.exports.SEMANTIC_ATTRIBUTE_URL_FULL = $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_URL_FULL;
module.exports.SEMANTIC_ATTRIBUTE_USER_EMAIL = $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_USER_EMAIL;
module.exports.SEMANTIC_ATTRIBUTE_USER_ID = $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_USER_ID;
module.exports.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS;
module.exports.SEMANTIC_ATTRIBUTE_USER_USERNAME = $b0c59a927bddc4e6$var$SEMANTIC_ATTRIBUTE_USER_USERNAME;
module.exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = $b0c59a927bddc4e6$var$SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;

});

parcelRegister("eqMxV", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $a81926a73dd0f1e8$var$SPAN_STATUS_UNSET = 0;
const $a81926a73dd0f1e8$var$SPAN_STATUS_OK = 1;
const $a81926a73dd0f1e8$var$SPAN_STATUS_ERROR = 2;
function $a81926a73dd0f1e8$var$getSpanStatusFromHttpCode(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $a81926a73dd0f1e8$var$SPAN_STATUS_OK
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $a81926a73dd0f1e8$var$SPAN_STATUS_ERROR,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $a81926a73dd0f1e8$var$SPAN_STATUS_ERROR,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $a81926a73dd0f1e8$var$SPAN_STATUS_ERROR,
                message: "not_found"
            };
        case 409:
            return {
                code: $a81926a73dd0f1e8$var$SPAN_STATUS_ERROR,
                message: "already_exists"
            };
        case 413:
            return {
                code: $a81926a73dd0f1e8$var$SPAN_STATUS_ERROR,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $a81926a73dd0f1e8$var$SPAN_STATUS_ERROR,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $a81926a73dd0f1e8$var$SPAN_STATUS_ERROR,
                message: "cancelled"
            };
        default:
            return {
                code: $a81926a73dd0f1e8$var$SPAN_STATUS_ERROR,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $a81926a73dd0f1e8$var$SPAN_STATUS_ERROR,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $a81926a73dd0f1e8$var$SPAN_STATUS_ERROR,
                message: "unavailable"
            };
        case 504:
            return {
                code: $a81926a73dd0f1e8$var$SPAN_STATUS_ERROR,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $a81926a73dd0f1e8$var$SPAN_STATUS_ERROR,
                message: "internal_error"
            };
    }
    return {
        code: $a81926a73dd0f1e8$var$SPAN_STATUS_ERROR,
        message: "internal_error"
    };
}
function $a81926a73dd0f1e8$var$setHttpStatus(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $a81926a73dd0f1e8$var$getSpanStatusFromHttpCode(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}
module.exports.SPAN_STATUS_ERROR = $a81926a73dd0f1e8$var$SPAN_STATUS_ERROR;
module.exports.SPAN_STATUS_OK = $a81926a73dd0f1e8$var$SPAN_STATUS_OK;
module.exports.SPAN_STATUS_UNSET = $a81926a73dd0f1e8$var$SPAN_STATUS_UNSET;
module.exports.getSpanStatusFromHttpCode = $a81926a73dd0f1e8$var$getSpanStatusFromHttpCode;
module.exports.setHttpStatus = $a81926a73dd0f1e8$var$setHttpStatus;

});

parcelRegister("gNZPa", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eEQXZ = parcelRequire("eEQXZ");

var $id64m = parcelRequire("id64m");
const $c3c12dfa8e75aed2$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $c3c12dfa8e75aed2$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
const $c3c12dfa8e75aed2$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceInference");
function $c3c12dfa8e75aed2$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        $eEQXZ.addNonEnumerableProperty(span, $c3c12dfa8e75aed2$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, $id64m.makeWeakRef(isolationScope));
        $eEQXZ.addNonEnumerableProperty(span, $c3c12dfa8e75aed2$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
function $c3c12dfa8e75aed2$var$getCapturedScopesOnSpan(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$c3c12dfa8e75aed2$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: $id64m.derefWeakRef(spanWithScopes[$c3c12dfa8e75aed2$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}
function $c3c12dfa8e75aed2$var$markSpanForOtelSourceInference(span) {
    $eEQXZ.addNonEnumerableProperty(span, $c3c12dfa8e75aed2$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD, true);
}
function $c3c12dfa8e75aed2$var$spanShouldInferOtelSource(span) {
    return span[$c3c12dfa8e75aed2$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD] === true;
}
module.exports.getCapturedScopesOnSpan = $c3c12dfa8e75aed2$var$getCapturedScopesOnSpan;
module.exports.markSpanForOtelSourceInference = $c3c12dfa8e75aed2$var$markSpanForOtelSourceInference;
module.exports.setCapturedScopesOnSpan = $c3c12dfa8e75aed2$var$setCapturedScopesOnSpan;
module.exports.spanShouldInferOtelSource = $c3c12dfa8e75aed2$var$spanShouldInferOtelSource;

});

parcelRegister("f0MA0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hQAU7 = parcelRequire("hQAU7");

var $f0HG2 = parcelRequire("f0HG2");

var $ghmbo = parcelRequire("ghmbo");

var $3Wqd7 = parcelRequire("3Wqd7");

var $6uOi2 = parcelRequire("6uOi2");

var $hxJcq = parcelRequire("hxJcq");
const $aedc8a036562d553$var$TRACEPARENT_REGEXP = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
function $aedc8a036562d553$var$extractTraceparentData(traceparent) {
    if (!traceparent) return void 0;
    const matches = traceparent.match($aedc8a036562d553$var$TRACEPARENT_REGEXP);
    if (!matches) return void 0;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
function $aedc8a036562d553$var$propagationContextFromHeaders(sentryTrace, baggage$1) {
    const traceparentData = $aedc8a036562d553$var$extractTraceparentData(sentryTrace);
    const dynamicSamplingContext = $f0HG2.baggageHeaderToDynamicSamplingContext(baggage$1);
    if (!(traceparentData === null || traceparentData === void 0 ? void 0 : traceparentData.traceId)) return {
        traceId: $6uOi2.generateTraceId(),
        sampleRand: $hxJcq.safeMathRandom()
    };
    const sampleRand = $aedc8a036562d553$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
        sampleRand
    };
}
function $aedc8a036562d553$var$generateSentryTraceHeader(traceId = $6uOi2.generateTraceId(), spanId = $6uOi2.generateSpanId(), sampled) {
    let sampledString = "";
    if (sampled !== void 0) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
function $aedc8a036562d553$var$generateTraceparentHeader(traceId = $6uOi2.generateTraceId(), spanId = $6uOi2.generateSpanId(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? "01" : "00"}`;
}
function $aedc8a036562d553$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    const parsedSampleRand = $3Wqd7.parseSampleRate(dsc === null || dsc === void 0 ? void 0 : dsc.sample_rand);
    if (parsedSampleRand !== void 0) return parsedSampleRand;
    const parsedSampleRate = $3Wqd7.parseSampleRate(dsc === null || dsc === void 0 ? void 0 : dsc.sample_rate);
    if (parsedSampleRate && (traceparentData === null || traceparentData === void 0 ? void 0 : traceparentData.parentSampled) !== void 0) return traceparentData.parentSampled ? // Returns a sample rand with positive sampling decision [0, sampleRate)
    $hxJcq.safeMathRandom() * parsedSampleRate : // Returns a sample rand with negative sampling decision [sampleRate, 1)
    parsedSampleRate + $hxJcq.safeMathRandom() * (1 - parsedSampleRate);
    else return $hxJcq.safeMathRandom();
}
function $aedc8a036562d553$var$shouldContinueTrace(client, baggageOrgId) {
    const clientOrgId = $ghmbo.extractOrgIdFromClient(client);
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        $hQAU7.debug.log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false;
    if (strictTraceContinuation) {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            $hQAU7.debug.log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}
module.exports.TRACEPARENT_REGEXP = $aedc8a036562d553$var$TRACEPARENT_REGEXP;
module.exports.extractTraceparentData = $aedc8a036562d553$var$extractTraceparentData;
module.exports.generateSentryTraceHeader = $aedc8a036562d553$var$generateSentryTraceHeader;
module.exports.generateTraceparentHeader = $aedc8a036562d553$var$generateTraceparentHeader;
module.exports.propagationContextFromHeaders = $aedc8a036562d553$var$propagationContextFromHeaders;
module.exports.shouldContinueTrace = $aedc8a036562d553$var$shouldContinueTrace;

});
parcelRegister("f0HG2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $859Bb = parcelRequire("859Bb");

var $hQAU7 = parcelRequire("hQAU7");

var $ibzbk = parcelRequire("ibzbk");
const $02d1f2860ac0a684$var$SENTRY_BAGGAGE_KEY_PREFIX = "sentry-";
const $02d1f2860ac0a684$var$SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;
const $02d1f2860ac0a684$var$MAX_BAGGAGE_STRING_LENGTH = 8192;
function $02d1f2860ac0a684$var$baggageHeaderToDynamicSamplingContext(baggageHeader) {
    const baggageObject = $02d1f2860ac0a684$var$parseBaggageHeader(baggageHeader);
    if (!baggageObject) return void 0;
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith($02d1f2860ac0a684$var$SENTRY_BAGGAGE_KEY_PREFIX)) {
            const nonPrefixedKey = key.slice($02d1f2860ac0a684$var$SENTRY_BAGGAGE_KEY_PREFIX.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return void 0;
}
function $02d1f2860ac0a684$var$dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext) {
    if (!dynamicSamplingContext) return void 0;
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$02d1f2860ac0a684$var$SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $02d1f2860ac0a684$var$objectToBaggageHeader(sentryPrefixedDSC);
}
function $02d1f2860ac0a684$var$parseBaggageHeader(baggageHeader) {
    if (!baggageHeader || !$ibzbk.isString(baggageHeader) && !Array.isArray(baggageHeader)) return void 0;
    if (Array.isArray(baggageHeader)) return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $02d1f2860ac0a684$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $02d1f2860ac0a684$var$baggageHeaderToObject(baggageHeader);
}
function $02d1f2860ac0a684$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf("=");
        if (eqIdx === -1) return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch (e) {
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
function $02d1f2860ac0a684$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) return void 0;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $02d1f2860ac0a684$var$MAX_BAGGAGE_STRING_LENGTH) {
            $859Bb.DEBUG_BUILD && $hQAU7.debug.warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}
function $02d1f2860ac0a684$var$mergeBaggageHeaders(existing, incoming) {
    if (!existing) return incoming;
    const existingEntries = $02d1f2860ac0a684$var$parseBaggageHeader(existing);
    const incomingEntries = $02d1f2860ac0a684$var$parseBaggageHeader(incoming);
    if (!incomingEntries) return existing;
    const merged = {};
    let hasNewSentryEntries = false;
    const newSentryEntries = {};
    const newNonSentryEntries = {};
    for (const [key, value] of Object.entries(incomingEntries))if (key.startsWith($02d1f2860ac0a684$var$SENTRY_BAGGAGE_KEY_PREFIX)) {
        newSentryEntries[key] = value;
        hasNewSentryEntries = true;
    } else newNonSentryEntries[key] = value;
    if (existingEntries) {
        for (const [key, value] of Object.entries(existingEntries))if (!hasNewSentryEntries || !key.startsWith($02d1f2860ac0a684$var$SENTRY_BAGGAGE_KEY_PREFIX)) merged[key] = value;
    }
    if (hasNewSentryEntries) Object.assign(merged, newSentryEntries);
    var _merged_key;
    for (const [key, value] of Object.entries(newNonSentryEntries))(_merged_key = merged[key]) !== null && _merged_key !== void 0 ? _merged_key : merged[key] = value;
    return $02d1f2860ac0a684$var$objectToBaggageHeader(merged);
}
module.exports.MAX_BAGGAGE_STRING_LENGTH = $02d1f2860ac0a684$var$MAX_BAGGAGE_STRING_LENGTH;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX = $02d1f2860ac0a684$var$SENTRY_BAGGAGE_KEY_PREFIX;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX_REGEX = $02d1f2860ac0a684$var$SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
module.exports.baggageHeaderToDynamicSamplingContext = $02d1f2860ac0a684$var$baggageHeaderToDynamicSamplingContext;
module.exports.dynamicSamplingContextToSentryBaggageHeader = $02d1f2860ac0a684$var$dynamicSamplingContextToSentryBaggageHeader;
module.exports.mergeBaggageHeaders = $02d1f2860ac0a684$var$mergeBaggageHeaders;
module.exports.objectToBaggageHeader = $02d1f2860ac0a684$var$objectToBaggageHeader;
module.exports.parseBaggageHeader = $02d1f2860ac0a684$var$parseBaggageHeader;

});

parcelRegister("ghmbo", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $859Bb = parcelRequire("859Bb");

var $hQAU7 = parcelRequire("hQAU7");
const $bd9f70ee9d51bbc0$var$ORG_ID_REGEX = /^o(\d+)\./;
const $bd9f70ee9d51bbc0$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $bd9f70ee9d51bbc0$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
function $bd9f70ee9d51bbc0$var$dsnToString(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
function $bd9f70ee9d51bbc0$var$dsnFromString(str) {
    const match = $bd9f70ee9d51bbc0$var$DSN_REGEX.exec(str);
    if (!match) {
        $hQAU7.consoleSandbox(()=>{
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return void 0;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $bd9f70ee9d51bbc0$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $bd9f70ee9d51bbc0$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $bd9f70ee9d51bbc0$var$validateDsn(dsn) {
    if (!$859Bb.DEBUG_BUILD) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            $hQAU7.debug.error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        $hQAU7.debug.error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$bd9f70ee9d51bbc0$var$isValidProtocol(protocol)) {
        $hQAU7.debug.error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        $hQAU7.debug.error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
function $bd9f70ee9d51bbc0$var$extractOrgIdFromDsnHost(host) {
    const match = host.match($bd9f70ee9d51bbc0$var$ORG_ID_REGEX);
    return match === null || match === void 0 ? void 0 : match[1];
}
function $bd9f70ee9d51bbc0$var$extractOrgIdFromClient(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $bd9f70ee9d51bbc0$var$extractOrgIdFromDsnHost(host);
    return org_id;
}
function $bd9f70ee9d51bbc0$var$makeDsn(from) {
    const components = typeof from === "string" ? $bd9f70ee9d51bbc0$var$dsnFromString(from) : $bd9f70ee9d51bbc0$var$dsnFromComponents(from);
    if (!components || !$bd9f70ee9d51bbc0$var$validateDsn(components)) return void 0;
    return components;
}
module.exports.dsnFromString = $bd9f70ee9d51bbc0$var$dsnFromString;
module.exports.dsnToString = $bd9f70ee9d51bbc0$var$dsnToString;
module.exports.extractOrgIdFromClient = $bd9f70ee9d51bbc0$var$extractOrgIdFromClient;
module.exports.extractOrgIdFromDsnHost = $bd9f70ee9d51bbc0$var$extractOrgIdFromDsnHost;
module.exports.makeDsn = $bd9f70ee9d51bbc0$var$makeDsn;

});

parcelRegister("3Wqd7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $2deb1ec3945dbd5a$var$parseSampleRate(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return void 0;
    return rate;
}
module.exports.parseSampleRate = $2deb1ec3945dbd5a$var$parseSampleRate;

});




parcelRegister("7QnW4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hSRcd = parcelRequire("hSRcd");

var $859Bb = parcelRequire("859Bb");

var $faX3S = parcelRequire("faX3S");

var $hQAU7 = parcelRequire("hQAU7");

var $6AMlx = parcelRequire("6AMlx");

var $8mpfg = parcelRequire("8mpfg");

var $h77y5 = parcelRequire("h77y5");

var $dRW3b = parcelRequire("dRW3b");

var $jHcnM = parcelRequire("jHcnM");

var $2ldD6 = parcelRequire("2ldD6");

var $crLpn = parcelRequire("crLpn");

var $eqMxV = parcelRequire("eqMxV");

var $gvNu3 = parcelRequire("gvNu3");

var $gNZPa = parcelRequire("gNZPa");
const $5b5ff4de7051b372$var$TRACING_DEFAULTS = {
    idleTimeout: 1e3,
    finalTimeout: 3e4,
    childSpanTimeout: 15e3
};
const $5b5ff4de7051b372$var$FINISH_REASON_HEARTBEAT_FAILED = "heartbeatFailed";
const $5b5ff4de7051b372$var$FINISH_REASON_IDLE_TIMEOUT = "idleTimeout";
const $5b5ff4de7051b372$var$FINISH_REASON_FINAL_TIMEOUT = "finalTimeout";
const $5b5ff4de7051b372$var$FINISH_REASON_EXTERNAL_FINISH = "externalFinish";
function $5b5ff4de7051b372$var$startIdleSpan(startSpanOptions, options = {}) {
    const activities = /* @__PURE__ */ new Map();
    let _finished = false;
    let _idleTimeoutID;
    let _finishReason = $5b5ff4de7051b372$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout: idleTimeout = $5b5ff4de7051b372$var$TRACING_DEFAULTS.idleTimeout, finalTimeout: finalTimeout = $5b5ff4de7051b372$var$TRACING_DEFAULTS.finalTimeout, childSpanTimeout: childSpanTimeout = $5b5ff4de7051b372$var$TRACING_DEFAULTS.childSpanTimeout, beforeSpanEnd: beforeSpanEnd, trimIdleSpanEndTimestamp: trimIdleSpanEndTimestamp = true } = options;
    const client = $hSRcd.getClient();
    const scope = $hSRcd.getCurrentScope();
    if (!client || !$6AMlx.hasSpansEnabled()) {
        const span2 = new $2ldD6.SentryNonRecordingSpan({
            traceId: scope.getPropagationContext().traceId
        });
        $gNZPa.setCapturedScopesOnSpan(span2, scope, $hSRcd.getIsolationScope());
        return span2;
    }
    const previousActiveSpan = $dRW3b.getActiveSpan();
    const span = $5b5ff4de7051b372$var$_startIdleSpan(startSpanOptions);
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            if ($2ldD6.spanIsNonRecordingSpan(thisArg)) return;
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || $jHcnM.timestampInSeconds();
            const spanEndTimestamp = $dRW3b.spanTimeInputToSeconds(timestamp);
            const spans = $dRW3b.getSpanDescendants(span).filter((child)=>child !== span);
            const spanJson = $dRW3b.spanToJSON(span);
            if (!spans.length || !trimIdleSpanEndTimestamp) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const ignoreSpans = client.getOptions().ignoreSpans;
            const latestSpanEndTimestamp = spans === null || spans === void 0 ? void 0 : spans.reduce((acc, current)=>{
                const currentSpanJson = $dRW3b.spanToJSON(current);
                if (!currentSpanJson.timestamp) return acc;
                if (ignoreSpans && $8mpfg.shouldIgnoreSpan({
                    description: currentSpanJson.description,
                    op: currentSpanJson.op,
                    attributes: currentSpanJson.data
                }, ignoreSpans)) return acc;
                return acc ? Math.max(acc, currentSpanJson.timestamp) : currentSpanJson.timestamp;
            }, void 0);
            const spanStartTimestamp = spanJson.start_timestamp;
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1e3 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = void 0;
        }
    }
    function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $5b5ff4de7051b372$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    function _restartChildSpanTimeout(endTimestamp) {
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $5b5ff4de7051b372$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = $jHcnM.timestampInSeconds();
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1e3);
    }
    function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = $jHcnM.timestampInSeconds();
            _restartIdleTimeout(endTimestamp + idleTimeout / 1e3);
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        $h77y5._setSpanForScope(scope, previousActiveSpan);
        const spanJSON = $dRW3b.spanToJSON(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        if (!startTimestamp) return;
        const attributes = spanJSON.data;
        if (!attributes[$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON]) span.setAttribute($faX3S.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON, _finishReason);
        const currentStatus = spanJSON.status;
        if (!currentStatus || currentStatus === "unknown") span.setStatus({
            code: $eqMxV.SPAN_STATUS_OK
        });
        $hQAU7.debug.log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = $dRW3b.getSpanDescendants(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: $eqMxV.SPAN_STATUS_ERROR,
                    message: "cancelled"
                });
                childSpan.end(endTimestamp);
                $859Bb.DEBUG_BUILD && $hQAU7.debug.log("[Tracing] Cancelling span since span ended early", JSON.stringify(childSpan, void 0, 2));
            }
            const childSpanJSON = $dRW3b.spanToJSON(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1e3;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if ($859Bb.DEBUG_BUILD) {
                const stringifiedSpan = JSON.stringify(childSpan, void 0, 2);
                if (!spanStartedBeforeIdleSpanEnd) $hQAU7.debug.log("[Tracing] Discarding span since it happened after idle span was finished", stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) $hQAU7.debug.log("[Tracing] Discarding span since it finished after idle span final timeout", stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                $dRW3b.removeChildSpanFromSpan(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute("sentry.idle_span_discarded_spans", discardedSpans);
    }
    _cleanupHooks.push(client.on("spanStart", (startedSpan)=>{
        if (_finished || startedSpan === span || !!$dRW3b.spanToJSON(startedSpan).timestamp || startedSpan instanceof $crLpn.SentrySpan && startedSpan.isStandaloneSpan()) return;
        const allSpans = $dRW3b.getSpanDescendants(span);
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("spanEnd", (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("idleSpanEnableAutoFinish", (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: $eqMxV.SPAN_STATUS_ERROR,
                message: "deadline_exceeded"
            });
            _finishReason = $5b5ff4de7051b372$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $5b5ff4de7051b372$var$_startIdleSpan(options) {
    const span = $gvNu3.startInactiveSpan(options);
    $h77y5._setSpanForScope($hSRcd.getCurrentScope(), span);
    $859Bb.DEBUG_BUILD && $hQAU7.debug.log("[Tracing] Started span is an idle span");
    return span;
}
module.exports.TRACING_DEFAULTS = $5b5ff4de7051b372$var$TRACING_DEFAULTS;
module.exports.startIdleSpan = $5b5ff4de7051b372$var$startIdleSpan;

});
parcelRegister("6AMlx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hSRcd = parcelRequire("hSRcd");
function $4ccb9b704ef8a45c$var$hasSpansEnabled(maybeOptions) {
    var _currentScopes_getClient;
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || ((_currentScopes_getClient = $hSRcd.getClient()) === null || _currentScopes_getClient === void 0 ? void 0 : _currentScopes_getClient.getOptions());
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
module.exports.hasSpansEnabled = $4ccb9b704ef8a45c$var$hasSpansEnabled;

});

parcelRegister("8mpfg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $859Bb = parcelRequire("859Bb");

var $hQAU7 = parcelRequire("hQAU7");

var $8zsqf = parcelRequire("8zsqf");
function $6163f5f80e828259$var$logIgnoredSpan(droppedSpan) {
    $hQAU7.debug.log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
function $6163f5f80e828259$var$shouldIgnoreSpan(span, ignoreSpans) {
    if (!(ignoreSpans === null || ignoreSpans === void 0 ? void 0 : ignoreSpans.length)) return false;
    for (const pattern of ignoreSpans){
        if ($6163f5f80e828259$var$isStringOrRegExp(pattern)) {
            if (span.description && $8zsqf.isMatchingPattern(span.description, pattern)) {
                $859Bb.DEBUG_BUILD && $6163f5f80e828259$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
        if (!pattern.name && !pattern.op && !hasAttributes) continue;
        const nameMatches = pattern.name ? span.description && $8zsqf.isMatchingPattern(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && $8zsqf.isMatchingPattern(span.op, pattern.op) : true;
        const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(([key, valuePattern])=>{
            var _span_attributes;
            return $6163f5f80e828259$var$_matchesAttributeValue((_span_attributes = span.attributes) === null || _span_attributes === void 0 ? void 0 : _span_attributes[key], valuePattern);
        }) : true;
        if (nameMatches && opMatches && attrsMatch) {
            $859Bb.DEBUG_BUILD && $6163f5f80e828259$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
function $6163f5f80e828259$var$_matchesAttributeValue(actual, pat) {
    if (typeof actual === "string" && (typeof pat === "string" || pat instanceof RegExp)) return $8zsqf.isMatchingPattern(actual, pat);
    if (Array.isArray(actual) && Array.isArray(pat)) return actual.length === pat.length && actual.every((v, i)=>v === pat[i]);
    return actual === pat;
}
function $6163f5f80e828259$var$reparentChildSpans(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $6163f5f80e828259$var$isStringOrRegExp(value) {
    return typeof value === "string" || value instanceof RegExp;
}
module.exports.reparentChildSpans = $6163f5f80e828259$var$reparentChildSpans;
module.exports.shouldIgnoreSpan = $6163f5f80e828259$var$shouldIgnoreSpan;

});

parcelRegister("2ldD6", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eEQXZ = parcelRequire("eEQXZ");

var $6uOi2 = parcelRequire("6uOi2");

var $dRW3b = parcelRequire("dRW3b");
const $1b481d7bdd9deee2$var$NON_RECORDING_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.nonRecordingSpan");
class $1b481d7bdd9deee2$var$SentryNonRecordingSpan {
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: $dRW3b.TRACE_FLAG_NONE
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || $6uOi2.generateTraceId();
        this._spanId = spanContext.spanId || $6uOi2.generateSpanId();
        this.dropReason = spanContext.dropReason;
        $eEQXZ.addNonEnumerableProperty(this, $1b481d7bdd9deee2$var$NON_RECORDING_SPAN_FIELD, true);
    }
}
function $1b481d7bdd9deee2$var$spanIsNonRecordingSpan(span) {
    return !!span && span[$1b481d7bdd9deee2$var$NON_RECORDING_SPAN_FIELD] === true;
}
module.exports.SentryNonRecordingSpan = $1b481d7bdd9deee2$var$SentryNonRecordingSpan;
module.exports.spanIsNonRecordingSpan = $1b481d7bdd9deee2$var$spanIsNonRecordingSpan;

});

parcelRegister("crLpn", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hSRcd = parcelRequire("hSRcd");

var $859Bb = parcelRequire("859Bb");

var $23pJH = parcelRequire("23pJH");

var $faX3S = parcelRequire("faX3S");

var $hQAU7 = parcelRequire("hQAU7");

var $6uOi2 = parcelRequire("6uOi2");

var $dRW3b = parcelRequire("dRW3b");

var $jHcnM = parcelRequire("jHcnM");

var $lzdUA = parcelRequire("lzdUA");

var $6lgA1 = parcelRequire("6lgA1");

var $6mP1Z = parcelRequire("6mP1Z");

var $aSFvs = parcelRequire("aSFvs");

var $gNZPa = parcelRequire("gNZPa");
const $90fcc7f1d4a82156$var$MAX_SPAN_COUNT = 1e3;
class $90fcc7f1d4a82156$var$SentrySpan {
    /** @inheritDoc */ addLink(link) {
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? $dRW3b.TRACE_FLAG_SAMPLED : $dRW3b.TRACE_FLAG_NONE
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === void 0) delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = $dRW3b.spanTimeInputToSeconds(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        if (!$gNZPa.spanShouldInferOtelSource(this)) this.setAttribute($faX3S.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, "custom");
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        if (this._endTime) return;
        this._endTime = $dRW3b.spanTimeInputToSeconds(endTimestamp);
        $6lgA1.logSpanEnd(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: $dRW3b.getStatusMessage(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            profile_id: this._attributes[$faX3S.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._attributes[$faX3S.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
            measurements: $6mP1Z.timedEventsToMeasurements(this._events),
            is_segment: this._isStandaloneSpan && $dRW3b.getRootSpan(this) === this || void 0,
            segment_id: this._isStandaloneSpan ? $dRW3b.getRootSpan(this).spanContext().spanId : void 0,
            links: $dRW3b.convertSpanLinksForEnvelope(this._links)
        };
    }
    /**
   * Get {@link StreamedSpanJSON} representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToStreamedSpanJSON(span)` instead.
   */ getStreamedSpanJSON() {
        var _this__name, _this__endTime;
        return {
            name: (_this__name = this._name) !== null && _this__name !== void 0 ? _this__name : "",
            span_id: this._spanId,
            trace_id: this._traceId,
            parent_span_id: this._parentSpanId,
            start_timestamp: this._startTime,
            // just in case _endTime is not set, we use the start time (i.e. duration 0)
            end_timestamp: (_this__endTime = this._endTime) !== null && _this__endTime !== void 0 ? _this__endTime : this._startTime,
            is_segment: this._isStandaloneSpan || this === $dRW3b.getRootSpan(this),
            status: $dRW3b.getSimpleStatusMessage(this._status),
            attributes: this._attributes,
            links: $dRW3b.getStreamedSpanLinks(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.log("[Tracing] Adding an event to span:", name);
        const time$1 = $90fcc7f1d4a82156$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || $jHcnM.timestampInSeconds();
        const attributes = $90fcc7f1d4a82156$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: $dRW3b.spanTimeInputToSeconds(time$1),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = $hSRcd.getClient();
        if (client) {
            client.emit("spanEnd", this);
            if (!this._isStandaloneSpan) client.emit("afterSpanEnd", this);
        }
        const isSegmentSpan = this._isStandaloneSpan || this === $dRW3b.getRootSpan(this);
        if (!isSegmentSpan) return;
        if (this._isStandaloneSpan) {
            if (this._sampled) $90fcc7f1d4a82156$var$sendSpanEnvelope($23pJH.createSpanEnvelope([
                this
            ], client));
            else {
                $859Bb.DEBUG_BUILD && $hQAU7.debug.log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        } else if (client && $aSFvs.hasSpanStreamingEnabled(client)) {
            client.emit("afterSegmentSpanEnd", this);
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = $gNZPa.getCapturedScopesOnSpan(this).scope || $hSRcd.getCurrentScope();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        var _capturedSpanScope_getScopeData_sdkProcessingMetadata;
        if (!$90fcc7f1d4a82156$var$isFullFinishedSpan($dRW3b.spanToJSON(this))) return void 0;
        if (!this._name) {
            $859Bb.DEBUG_BUILD && $hQAU7.debug.warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = $gNZPa.getCapturedScopesOnSpan(this);
        const normalizedRequest = capturedSpanScope === null || capturedSpanScope === void 0 ? void 0 : (_capturedSpanScope_getScopeData_sdkProcessingMetadata = capturedSpanScope.getScopeData().sdkProcessingMetadata) === null || _capturedSpanScope_getScopeData_sdkProcessingMetadata === void 0 ? void 0 : _capturedSpanScope_getScopeData_sdkProcessingMetadata.normalizedRequest;
        if (this._sampled !== true) return void 0;
        const finishedSpans = $dRW3b.getSpanDescendants(this).filter((span)=>span !== this && !$90fcc7f1d4a82156$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>$dRW3b.spanToJSON(span)).filter($90fcc7f1d4a82156$var$isFullFinishedSpan);
        const source = this._attributes[$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        delete this._attributes[$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
        let hasGenAiSpans = false;
        spans.forEach((span)=>{
            var _span_op;
            delete span.data[$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
            if ((_span_op = span.op) === null || _span_op === void 0 ? void 0 : _span_op.startsWith("gen_ai.")) hasGenAiSpans = true;
        });
        const transaction = (0, $9tqwB._)({
            contexts: {
                trace: $dRW3b.spanToTransactionTraceContext(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $90fcc7f1d4a82156$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $90fcc7f1d4a82156$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: $lzdUA.getDynamicSamplingContextFromSpan(this),
                hasGenAiSpans: hasGenAiSpans
            },
            request: normalizedRequest
        }, source && {
            transaction_info: {
                source: source
            }
        });
        const measurements = $6mP1Z.timedEventsToMeasurements(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            $859Bb.DEBUG_BUILD && $hQAU7.debug.log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, void 0, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
    /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || $6uOi2.generateTraceId();
        this._spanId = spanContext.spanId || $6uOi2.generateSpanId();
        this._startTime = spanContext.startTimestamp || $jHcnM.timestampInSeconds();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes((0, $9tqwB._)({
            [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "manual",
            [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_OP]: spanContext.op
        }, spanContext.attributes));
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        if (this._endTime) this._onSpanEnded();
    }
}
function $90fcc7f1d4a82156$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
function $90fcc7f1d4a82156$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
function $90fcc7f1d4a82156$var$isStandaloneSpan(span) {
    return span instanceof $90fcc7f1d4a82156$var$SentrySpan && span.isStandaloneSpan();
}
function $90fcc7f1d4a82156$var$sendSpanEnvelope(envelope) {
    const client = $hSRcd.getClient();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    client.sendEnvelope(envelope);
}
module.exports.SentrySpan = $90fcc7f1d4a82156$var$SentrySpan;

});
parcelRegister("23pJH", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lzdUA = parcelRequire("lzdUA");

var $1npIi = parcelRequire("1npIi");

var $ghmbo = parcelRequire("ghmbo");

var $bIVq4 = parcelRequire("bIVq4");

var $hxJcq = parcelRequire("hxJcq");

var $8mpfg = parcelRequire("8mpfg");

var $dRW3b = parcelRequire("dRW3b");
function $17efd33acf6597d5$var$_enhanceEventWithSdkInfo(event, newSdkInfo) {
    var _event_sdk, _event_sdk1, _event_sdk2, _event_sdk3;
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = (0, $2qxEV._)((0, $9tqwB._)({}, eventSdkInfo), {
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...((_event_sdk = event.sdk) === null || _event_sdk === void 0 ? void 0 : _event_sdk.integrations) || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...((_event_sdk1 = event.sdk) === null || _event_sdk1 === void 0 ? void 0 : _event_sdk1.packages) || [],
            ...newSdkInfo.packages || []
        ],
        settings: ((_event_sdk2 = event.sdk) === null || _event_sdk2 === void 0 ? void 0 : _event_sdk2.settings) || newSdkInfo.settings ? (0, $9tqwB._)({}, (_event_sdk3 = event.sdk) === null || _event_sdk3 === void 0 ? void 0 : _event_sdk3.settings, newSdkInfo.settings) : void 0
    });
    return event;
}
function $17efd33acf6597d5$var$createSessionEnvelope(session, dsn$1, metadata, tunnel) {
    const sdkInfo = $bIVq4.getSdkMetadataForEnvelopeHeader(metadata);
    const envelopeHeaders = (0, $9tqwB._)({
        sent_at: new Date($hxJcq.safeDateNow()).toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn$1 && {
        dsn: $ghmbo.dsnToString(dsn$1)
    });
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return $bIVq4.createEnvelope(envelopeHeaders, [
        envelopeItem
    ]);
}
function $17efd33acf6597d5$var$createEventEnvelope(event, dsn, metadata, tunnel) {
    const sdkInfo = $bIVq4.getSdkMetadataForEnvelopeHeader(metadata);
    const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $17efd33acf6597d5$var$_enhanceEventWithSdkInfo(event, metadata === null || metadata === void 0 ? void 0 : metadata.sdk);
    const envelopeHeaders = $bIVq4.createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return $bIVq4.createEnvelope(envelopeHeaders, [
        eventItem
    ]);
}
function $17efd33acf6597d5$var$createSpanEnvelope(spans, client) {
    function dscHasRequiredProps(dsc2) {
        return !!dsc2.trace_id && !!dsc2.public_key;
    }
    const dsc = $lzdUA.getDynamicSamplingContextFromSpan(spans[0]);
    const dsn$1 = client === null || client === void 0 ? void 0 : client.getDsn();
    const tunnel = client === null || client === void 0 ? void 0 : client.getOptions().tunnel;
    const headers = (0, $9tqwB._)({
        sent_at: new Date($hxJcq.safeDateNow()).toISOString()
    }, dscHasRequiredProps(dsc) && {
        trace: dsc
    }, !!tunnel && dsn$1 && {
        dsn: $ghmbo.dsnToString(dsn$1)
    });
    const { beforeSendSpan: beforeSendSpan$1, ignoreSpans: ignoreSpans } = (client === null || client === void 0 ? void 0 : client.getOptions()) || {};
    const filteredSpans = (ignoreSpans === null || ignoreSpans === void 0 ? void 0 : ignoreSpans.length) ? spans.filter((span)=>{
        const json = $dRW3b.spanToJSON(span);
        return !$8mpfg.shouldIgnoreSpan({
            description: json.description,
            op: json.op,
            attributes: json.data
        }, ignoreSpans);
    }) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client === null || client === void 0 ? void 0 : client.recordDroppedEvent("before_send", "span", droppedSpans);
    const convertToSpanJSON = beforeSendSpan$1 ? (span)=>{
        const spanJson = $dRW3b.spanToJSON(span);
        const processedSpan = !$1npIi.isStreamedBeforeSendSpanCallback(beforeSendSpan$1) ? beforeSendSpan$1(spanJson) : spanJson;
        if (!processedSpan) {
            $dRW3b.showSpanDropWarning();
            return spanJson;
        }
        return processedSpan;
    } : $dRW3b.spanToJSON;
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push($bIVq4.createSpanEnvelopeItem(spanJson));
    }
    return $bIVq4.createEnvelope(headers, items);
}
module.exports._enhanceEventWithSdkInfo = $17efd33acf6597d5$var$_enhanceEventWithSdkInfo;
module.exports.createEventEnvelope = $17efd33acf6597d5$var$createEventEnvelope;
module.exports.createSessionEnvelope = $17efd33acf6597d5$var$createSessionEnvelope;
module.exports.createSpanEnvelope = $17efd33acf6597d5$var$createSpanEnvelope;

});
parcelRegister("lzdUA", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dxRJQ = parcelRequire("dxRJQ");

var $hSRcd = parcelRequire("hSRcd");

var $faX3S = parcelRequire("faX3S");

var $f0HG2 = parcelRequire("f0HG2");

var $ghmbo = parcelRequire("ghmbo");

var $6AMlx = parcelRequire("6AMlx");

var $eEQXZ = parcelRequire("eEQXZ");

var $dRW3b = parcelRequire("dRW3b");

var $2ldD6 = parcelRequire("2ldD6");

var $gNZPa = parcelRequire("gNZPa");
const $fb37a86844319263$var$FROZEN_DSC_FIELD = "_frozenDsc";
function $fb37a86844319263$var$freezeDscOnSpan(span, dsc) {
    const spanWithMaybeDsc = span;
    $eEQXZ.addNonEnumerableProperty(spanWithMaybeDsc, $fb37a86844319263$var$FROZEN_DSC_FIELD, dsc);
}
function $fb37a86844319263$var$getDynamicSamplingContextFromClient(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = {
        environment: options.environment || $dxRJQ.DEFAULT_ENVIRONMENT,
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: $ghmbo.extractOrgIdFromClient(client)
    };
    client.emit("createDsc", dsc);
    return dsc;
}
function $fb37a86844319263$var$getDynamicSamplingContextFromScope(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $fb37a86844319263$var$getDynamicSamplingContextFromClient(propagationContext.traceId, client);
}
function $fb37a86844319263$var$getDynamicSamplingContextFromSpan(span) {
    const client = $hSRcd.getClient();
    if (!client) return {};
    const rootSpan = $dRW3b.getRootSpan(span);
    const rootSpanJson = $dRW3b.spanToJSON(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    var _traceState_get, _ref;
    const rootSpanSampleRate = (_ref = (_traceState_get = traceState === null || traceState === void 0 ? void 0 : traceState.get("sentry.sample_rate")) !== null && _traceState_get !== void 0 ? _traceState_get : rootSpanAttributes[$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]) !== null && _ref !== void 0 ? _ref : rootSpanAttributes[$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE];
    function applyLocalSampleRateToDsc(dsc2) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc2.sample_rate = `${rootSpanSampleRate}`;
        return dsc2;
    }
    const frozenDsc = rootSpan[$fb37a86844319263$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    if ($2ldD6.spanIsNonRecordingSpan(rootSpan) && !$6AMlx.hasSpansEnabled(client.getOptions())) {
        const capturedScope = $gNZPa.getCapturedScopesOnSpan(rootSpan).scope;
        if (capturedScope) return applyLocalSampleRateToDsc((0, $9tqwB._)({}, $fb37a86844319263$var$getDynamicSamplingContextFromScope(client, capturedScope)));
    }
    const traceStateDsc = traceState === null || traceState === void 0 ? void 0 : traceState.get("sentry.dsc");
    const dscOnTraceState = traceStateDsc && $f0HG2.baggageHeaderToDynamicSamplingContext(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    const dsc = $fb37a86844319263$var$getDynamicSamplingContextFromClient(span.spanContext().traceId, client);
    var _rootSpanAttributes_semanticAttributes_SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
    const source = (_rootSpanAttributes_semanticAttributes_SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = rootSpanAttributes[$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]) !== null && _rootSpanAttributes_semanticAttributes_SEMANTIC_ATTRIBUTE_SENTRY_SOURCE !== void 0 ? _rootSpanAttributes_semanticAttributes_SEMANTIC_ATTRIBUTE_SENTRY_SOURCE : rootSpanAttributes["sentry.span.source"];
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    if ($6AMlx.hasSpansEnabled()) {
        var // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        _utils_getCapturedScopesOnSpan_scope;
        dsc.sampled = String($dRW3b.spanIsSampled(rootSpan));
        var // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        _traceState_get1;
        dsc.sample_rand = (_traceState_get1 = traceState === null || traceState === void 0 ? void 0 : traceState.get("sentry.sample_rand")) !== null && _traceState_get1 !== void 0 ? _traceState_get1 : (_utils_getCapturedScopesOnSpan_scope = $gNZPa.getCapturedScopesOnSpan(rootSpan).scope) === null || _utils_getCapturedScopesOnSpan_scope === void 0 ? void 0 : _utils_getCapturedScopesOnSpan_scope.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
function $fb37a86844319263$var$spanToBaggageHeader(span) {
    const dsc = $fb37a86844319263$var$getDynamicSamplingContextFromSpan(span);
    return $f0HG2.dynamicSamplingContextToSentryBaggageHeader(dsc);
}
module.exports.freezeDscOnSpan = $fb37a86844319263$var$freezeDscOnSpan;
module.exports.getDynamicSamplingContextFromClient = $fb37a86844319263$var$getDynamicSamplingContextFromClient;
module.exports.getDynamicSamplingContextFromScope = $fb37a86844319263$var$getDynamicSamplingContextFromScope;
module.exports.getDynamicSamplingContextFromSpan = $fb37a86844319263$var$getDynamicSamplingContextFromSpan;
module.exports.spanToBaggageHeader = $fb37a86844319263$var$spanToBaggageHeader;

});
parcelRegister("dxRJQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $9dc80ac19e7b9a53$var$DEFAULT_ENVIRONMENT = "production";
const $9dc80ac19e7b9a53$var$DEV_ENVIRONMENT = "development";
module.exports.DEFAULT_ENVIRONMENT = $9dc80ac19e7b9a53$var$DEFAULT_ENVIRONMENT;
module.exports.DEV_ENVIRONMENT = $9dc80ac19e7b9a53$var$DEV_ENVIRONMENT;

});


parcelRegister("1npIi", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eEQXZ = parcelRequire("eEQXZ");
function $100be2970e0a8bec$var$withStreamedSpan(callback) {
    $eEQXZ.addNonEnumerableProperty(callback, "_streamed", true);
    return callback;
}
function $100be2970e0a8bec$var$isStreamedBeforeSendSpanCallback(callback) {
    return !!callback && typeof callback === "function" && "_streamed" in callback && !!callback._streamed;
}
module.exports.isStreamedBeforeSendSpanCallback = $100be2970e0a8bec$var$isStreamedBeforeSendSpanCallback;
module.exports.withStreamedSpan = $100be2970e0a8bec$var$withStreamedSpan;

});

parcelRegister("bIVq4", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gxkrU = parcelRequire("gxkrU");

var $ghmbo = parcelRequire("ghmbo");

var $irz1w = parcelRequire("irz1w");

var $hxJcq = parcelRequire("hxJcq");

var $15YuE = parcelRequire("15YuE");
function $88905813b69df520$var$createEnvelope(headers, items = []) {
    return [
        headers,
        items
    ];
}
function $88905813b69df520$var$addItemToEnvelope(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
function $88905813b69df520$var$forEachEnvelopeItem(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
function $88905813b69df520$var$envelopeContainsItemType(envelope, types) {
    return $88905813b69df520$var$forEachEnvelopeItem(envelope, (_, type)=>types.includes(type));
}
function $88905813b69df520$var$encodeUTF8(input) {
    const carrier$1 = $gxkrU.getSentryCarrier($15YuE.GLOBAL_OBJ);
    return carrier$1.encodePolyfill ? carrier$1.encodePolyfill(input) : new TextEncoder().encode(input);
}
function $88905813b69df520$var$decodeUTF8(input) {
    const carrier$1 = $gxkrU.getSentryCarrier($15YuE.GLOBAL_OBJ);
    return carrier$1.decodePolyfill ? carrier$1.decodePolyfill(input) : new TextDecoder().decode(input);
}
function $88905813b69df520$var$serializeEnvelope(envelope) {
    const [envHeaders, items] = envelope;
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $88905813b69df520$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $88905813b69df520$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`
${JSON.stringify(itemHeaders)}
`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                stringifiedPayload = JSON.stringify($irz1w.normalize(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $88905813b69df520$var$concatBuffers(parts);
}
function $88905813b69df520$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
function $88905813b69df520$var$parseEnvelope(env) {
    let buffer = typeof env === "string" ? $88905813b69df520$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(10);
        if (i < 0) i = buffer.length;
        return JSON.parse($88905813b69df520$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : void 0;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
function $88905813b69df520$var$createSpanEnvelopeItem(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
function $88905813b69df520$var$createAttachmentEnvelopeItem(attachment) {
    const buffer = typeof attachment.data === "string" ? $88905813b69df520$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $88905813b69df520$var$DATA_CATEGORY_OVERRIDES = {
    sessions: "session",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    raw_security: "security",
    log: "log_item",
    trace_metric: "metric"
};
function $88905813b69df520$var$_isOverriddenType(type) {
    return type in $88905813b69df520$var$DATA_CATEGORY_OVERRIDES;
}
function $88905813b69df520$var$envelopeItemTypeToDataCategory(type) {
    return $88905813b69df520$var$_isOverriddenType(type) ? $88905813b69df520$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
function $88905813b69df520$var$getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
    if (!(metadataOrEvent === null || metadataOrEvent === void 0 ? void 0 : metadataOrEvent.sdk)) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
function $88905813b69df520$var$createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn$1) {
    var _event_sdkProcessingMetadata;
    const dynamicSamplingContext = (_event_sdkProcessingMetadata = event.sdkProcessingMetadata) === null || _event_sdkProcessingMetadata === void 0 ? void 0 : _event_sdkProcessingMetadata.dynamicSamplingContext;
    return (0, $9tqwB._)({
        event_id: event.event_id,
        sent_at: new Date($hxJcq.safeDateNow()).toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn$1 && {
        dsn: $ghmbo.dsnToString(dsn$1)
    }, dynamicSamplingContext && {
        trace: dynamicSamplingContext
    });
}
module.exports.addItemToEnvelope = $88905813b69df520$var$addItemToEnvelope;
module.exports.createAttachmentEnvelopeItem = $88905813b69df520$var$createAttachmentEnvelopeItem;
module.exports.createEnvelope = $88905813b69df520$var$createEnvelope;
module.exports.createEventEnvelopeHeaders = $88905813b69df520$var$createEventEnvelopeHeaders;
module.exports.createSpanEnvelopeItem = $88905813b69df520$var$createSpanEnvelopeItem;
module.exports.envelopeContainsItemType = $88905813b69df520$var$envelopeContainsItemType;
module.exports.envelopeItemTypeToDataCategory = $88905813b69df520$var$envelopeItemTypeToDataCategory;
module.exports.forEachEnvelopeItem = $88905813b69df520$var$forEachEnvelopeItem;
module.exports.getSdkMetadataForEnvelopeHeader = $88905813b69df520$var$getSdkMetadataForEnvelopeHeader;
module.exports.parseEnvelope = $88905813b69df520$var$parseEnvelope;
module.exports.serializeEnvelope = $88905813b69df520$var$serializeEnvelope;

});


parcelRegister("6lgA1", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $859Bb = parcelRequire("859Bb");

var $hQAU7 = parcelRequire("hQAU7");

var $dRW3b = parcelRequire("dRW3b");
function $49e190aca7cb4db8$var$logSpanStart(span) {
    if (!$859Bb.DEBUG_BUILD) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = $dRW3b.spanToJSON(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = $dRW3b.spanIsSampled(span);
    const rootSpan = $dRW3b.getRootSpan(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op2, description: description2 } = $dRW3b.spanToJSON(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op2) infoParts.push(`root op: ${op2}`);
        if (description2) infoParts.push(`root description: ${description2}`);
    }
    $hQAU7.debug.log(`${header}
  ${infoParts.join("\n  ")}`);
}
function $49e190aca7cb4db8$var$logSpanEnd(span) {
    if (!$859Bb.DEBUG_BUILD) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = $dRW3b.spanToJSON(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = $dRW3b.getRootSpan(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    $hQAU7.debug.log(msg);
}
module.exports.logSpanEnd = $49e190aca7cb4db8$var$logSpanEnd;
module.exports.logSpanStart = $49e190aca7cb4db8$var$logSpanStart;

});

parcelRegister("6mP1Z", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $859Bb = parcelRequire("859Bb");

var $faX3S = parcelRequire("faX3S");

var $hQAU7 = parcelRequire("hQAU7");

var $dRW3b = parcelRequire("dRW3b");
function $4a2c61da44c38d45$var$setMeasurement(name, value, unit, activeSpan = $dRW3b.getActiveSpan()) {
    const rootSpan = activeSpan && $dRW3b.getRootSpan(activeSpan);
    if (rootSpan) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE]: value,
            [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT]: unit
        });
    }
}
function $4a2c61da44c38d45$var$timedEventsToMeasurements(events) {
    if (!events || events.length === 0) return void 0;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT];
        const value = attributes[$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}
module.exports.setMeasurement = $4a2c61da44c38d45$var$setMeasurement;
module.exports.timedEventsToMeasurements = $4a2c61da44c38d45$var$timedEventsToMeasurements;

});

parcelRegister("aSFvs", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $7ebf24d0f0ad93d6$var$hasSpanStreamingEnabled(client) {
    return client.getOptions().traceLifecycle === "stream";
}
module.exports.hasSpanStreamingEnabled = $7ebf24d0f0ad93d6$var$hasSpanStreamingEnabled;

});


parcelRegister("gvNu3", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $59Hrx = parcelRequire("59Hrx");

var $gxkrU = parcelRequire("gxkrU");

var $hSRcd = parcelRequire("hSRcd");

var $859Bb = parcelRequire("859Bb");

var $faX3S = parcelRequire("faX3S");

var $f0HG2 = parcelRequire("f0HG2");

var $hQAU7 = parcelRequire("hQAU7");

var $1fhPD = parcelRequire("1fhPD");

var $6AMlx = parcelRequire("6AMlx");

var $8mpfg = parcelRequire("8mpfg");

var $aSFvs = parcelRequire("aSFvs");

var $3Wqd7 = parcelRequire("3Wqd7");

var $6uOi2 = parcelRequire("6uOi2");

var $hxJcq = parcelRequire("hxJcq");

var $h77y5 = parcelRequire("h77y5");

var $dRW3b = parcelRequire("dRW3b");

var $f0MA0 = parcelRequire("f0MA0");

var $lzdUA = parcelRequire("lzdUA");

var $6lgA1 = parcelRequire("6lgA1");

var $h1Nl2 = parcelRequire("h1Nl2");

var $2ldD6 = parcelRequire("2ldD6");

var $crLpn = parcelRequire("crLpn");

var $eqMxV = parcelRequire("eqMxV");

var $gNZPa = parcelRequire("gNZPa");
const $c055ed032085a155$var$SUPPRESS_TRACING_KEY = "__SENTRY_SUPPRESS_TRACING__";
function $c055ed032085a155$var$startSpan(options, callback) {
    const acs = $c055ed032085a155$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $c055ed032085a155$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope === null || customScope === void 0 ? void 0 : customScope.clone();
    return $hSRcd.withScope(customForkedScope, ()=>{
        const wrapper = $c055ed032085a155$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = $hSRcd.getCurrentScope();
            const parentSpan = $c055ed032085a155$var$getParentSpan(scope, customParentSpan);
            const client = $hSRcd.getClient();
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? $c055ed032085a155$var$startMissingRequiredParentSpan(scope, client) : $c055ed032085a155$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$c055ed032085a155$var$_isIgnoredSpan(activeSpan) || !parentSpan) $h77y5._setSpanForScope(scope, activeSpan);
            return $1fhPD.handleCallbackErrors(()=>callback(activeSpan), ()=>{
                const { status: status } = $dRW3b.spanToJSON(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: $eqMxV.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
function $c055ed032085a155$var$startSpanManual(options, callback) {
    const acs = $c055ed032085a155$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $c055ed032085a155$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope === null || customScope === void 0 ? void 0 : customScope.clone();
    return $hSRcd.withScope(customForkedScope, ()=>{
        const wrapper = $c055ed032085a155$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = $hSRcd.getCurrentScope();
            const parentSpan = $c055ed032085a155$var$getParentSpan(scope, customParentSpan);
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? $c055ed032085a155$var$startMissingRequiredParentSpan(scope, $hSRcd.getClient()) : $c055ed032085a155$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$c055ed032085a155$var$_isIgnoredSpan(activeSpan) || !parentSpan) $h77y5._setSpanForScope(scope, activeSpan);
            return $1fhPD.handleCallbackErrors(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                const { status: status } = $dRW3b.spanToJSON(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: $eqMxV.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
            });
        });
    });
}
function $c055ed032085a155$var$startInactiveSpan(options) {
    const acs = $c055ed032085a155$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $c055ed032085a155$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    const wrapper = options.scope ? (callback)=>$hSRcd.withScope(options.scope, callback) : customParentSpan !== void 0 ? (callback)=>$c055ed032085a155$var$withActiveSpan(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = $hSRcd.getCurrentScope();
        const parentSpan = $c055ed032085a155$var$getParentSpan(scope, customParentSpan);
        const client = $hSRcd.getClient();
        const missingRequiredParent = options.onlyIfParent && !parentSpan;
        if (missingRequiredParent) return $c055ed032085a155$var$startMissingRequiredParentSpan(scope, client);
        return $c055ed032085a155$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
const $c055ed032085a155$var$continueTrace = (options, callback)=>{
    const carrier$1 = $gxkrU.getMainCarrier();
    const acs = $59Hrx.getAsyncContextStrategy(carrier$1);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage$1 } = options;
    const client = $hSRcd.getClient();
    const incomingDsc = $f0HG2.baggageHeaderToDynamicSamplingContext(baggage$1);
    if (client && !$f0MA0.shouldContinueTrace(client, incomingDsc === null || incomingDsc === void 0 ? void 0 : incomingDsc.org_id)) return $c055ed032085a155$var$startNewTrace(callback);
    return $hSRcd.withScope((scope)=>{
        const propagationContext = $f0MA0.propagationContextFromHeaders(sentryTrace, baggage$1);
        scope.setPropagationContext(propagationContext);
        $h77y5._setSpanForScope(scope, void 0);
        return callback();
    });
};
function $c055ed032085a155$var$withActiveSpan(span, callback) {
    const acs = $c055ed032085a155$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return $hSRcd.withScope((scope)=>{
        $h77y5._setSpanForScope(scope, span || void 0);
        return callback(scope);
    });
}
function $c055ed032085a155$var$suppressTracing(callback) {
    const acs = $c055ed032085a155$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return $hSRcd.withScope((scope)=>{
        scope.setSDKProcessingMetadata({
            [$c055ed032085a155$var$SUPPRESS_TRACING_KEY]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$c055ed032085a155$var$SUPPRESS_TRACING_KEY]: void 0
        });
        return res;
    });
}
function $c055ed032085a155$var$startNewTrace(callback) {
    const acs = $c055ed032085a155$var$getAcs();
    if (acs.startNewTrace) return acs.startNewTrace(callback);
    return $hSRcd.withScope((scope)=>{
        scope.setPropagationContext({
            traceId: $6uOi2.generateTraceId(),
            sampleRand: $hxJcq.safeMathRandom()
        });
        $859Bb.DEBUG_BUILD && $hQAU7.debug.log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $c055ed032085a155$var$withActiveSpan(null, callback);
    });
}
function $c055ed032085a155$var$startMissingRequiredParentSpan(scope, client) {
    client === null || client === void 0 ? void 0 : client.recordDroppedEvent("no_parent_span", "span");
    const span = new $2ldD6.SentryNonRecordingSpan({
        traceId: scope.getPropagationContext().traceId
    });
    $gNZPa.setCapturedScopesOnSpan(span, scope, $hSRcd.getIsolationScope());
    return span;
}
function $c055ed032085a155$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    const isolationScope = $hSRcd.getIsolationScope();
    if (!$6AMlx.hasSpansEnabled()) {
        const scopePropagationContext = (0, $9tqwB._)({}, isolationScope.getPropagationContext(), scope.getPropagationContext());
        const traceId = parentSpan ? parentSpan.spanContext().traceId : scopePropagationContext.traceId;
        const span2 = new $2ldD6.SentryNonRecordingSpan({
            traceId: traceId
        });
        if (parentSpan && !forceTransaction) $dRW3b.addChildSpanToSpan(parentSpan, span2);
        $gNZPa.setCapturedScopesOnSpan(span2, scope, isolationScope);
        return span2;
    }
    const client = $hSRcd.getClient();
    if ($c055ed032085a155$var$_shouldIgnoreStreamedSpan(client, spanArguments)) {
        if (!$c055ed032085a155$var$_isTracingSuppressed(scope)) client === null || client === void 0 ? void 0 : client.recordDroppedEvent("ignored", "span");
        var _parentSpan_spanContext_traceId;
        const ignoredSpan = new $2ldD6.SentryNonRecordingSpan({
            dropReason: "ignored",
            traceId: (_parentSpan_spanContext_traceId = parentSpan === null || parentSpan === void 0 ? void 0 : parentSpan.spanContext().traceId) !== null && _parentSpan_spanContext_traceId !== void 0 ? _parentSpan_spanContext_traceId : scope.getPropagationContext().traceId
        });
        $gNZPa.setCapturedScopesOnSpan(ignoredSpan, scope, isolationScope);
        return ignoredSpan;
    }
    let span;
    if (parentSpan && !forceTransaction) {
        span = $c055ed032085a155$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope);
        $dRW3b.addChildSpanToSpan(parentSpan, span);
    } else if (parentSpan) {
        const dsc = $lzdUA.getDynamicSamplingContextFromSpan(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = $dRW3b.spanIsSampled(parentSpan);
        span = $c055ed032085a155$var$_startRootSpan((0, $9tqwB._)({
            traceId: traceId,
            parentSpanId: parentSpanId
        }, spanArguments), scope, isolationScope, parentSampled);
        $lzdUA.freezeDscOnSpan(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = (0, $9tqwB._)({}, isolationScope.getPropagationContext(), scope.getPropagationContext());
        span = $c055ed032085a155$var$_startRootSpan((0, $9tqwB._)({
            traceId: traceId,
            parentSpanId: parentSpanId
        }, spanArguments), scope, isolationScope, parentSampled);
        if (dsc) $lzdUA.freezeDscOnSpan(span, dsc);
    }
    $6lgA1.logSpanStart(span);
    return span;
}
function $c055ed032085a155$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = (0, $9tqwB._)({
        isStandalone: exp.standalone
    }, options);
    if (options.startTime) {
        const ctx = (0, $9tqwB._)({}, initialCtx);
        ctx.startTimestamp = $dRW3b.spanTimeInputToSeconds(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $c055ed032085a155$var$getAcs() {
    const carrier$1 = $gxkrU.getMainCarrier();
    return $59Hrx.getAsyncContextStrategy(carrier$1);
}
function $c055ed032085a155$var$_startRootSpan(spanArguments, scope, isolationScope, parentSampled) {
    var _currentPropagationContext_dsc;
    const client = $hSRcd.getClient();
    const options = (client === null || client === void 0 ? void 0 : client.getOptions()) || {};
    const { name: name = "" } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: (0, $9tqwB._)({}, spanArguments.attributes),
        spanName: name,
        parentSampled: parentSampled
    };
    client === null || client === void 0 ? void 0 : client.emit("beforeSampling", mutableSpanSamplingData, {
        decision: false
    });
    var _mutableSpanSamplingData_parentSampled;
    const finalParentSampled = (_mutableSpanSamplingData_parentSampled = mutableSpanSamplingData.parentSampled) !== null && _mutableSpanSamplingData_parentSampled !== void 0 ? _mutableSpanSamplingData_parentSampled : parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const isTracingSuppressed = $c055ed032085a155$var$_isTracingSuppressed(scope);
    const [sampled, sampleRate, localSampleRateWasApplied] = isTracingSuppressed ? [
        false
    ] : $h1Nl2.sampleSpan(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        parentSampleRate: $3Wqd7.parseSampleRate((_currentPropagationContext_dsc = currentPropagationContext.dsc) === null || _currentPropagationContext_dsc === void 0 ? void 0 : _currentPropagationContext_dsc.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new $crLpn.SentrySpan((0, $2qxEV._)((0, $9tqwB._)({}, spanArguments), {
        attributes: (0, $9tqwB._)({
            [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "custom",
            [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]: sampleRate !== void 0 && localSampleRateWasApplied ? sampleRate : void 0
        }, finalAttributes),
        sampled: sampled
    }));
    if (!sampled && client && !isTracingSuppressed) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.log("[Tracing] Discarding root span because its trace was not chosen to be sampled.");
        client.recordDroppedEvent("sample_rate", $aSFvs.hasSpanStreamingEnabled(client) ? "span" : "transaction");
    }
    $gNZPa.setCapturedScopesOnSpan(rootSpan, scope, isolationScope);
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
function $c055ed032085a155$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const isTracingSuppressed = $c055ed032085a155$var$_isTracingSuppressed(scope);
    const sampled = isTracingSuppressed ? false : $dRW3b.spanIsSampled(parentSpan);
    const childSpan = sampled ? new $crLpn.SentrySpan((0, $2qxEV._)((0, $9tqwB._)({}, spanArguments), {
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    })) : new $2ldD6.SentryNonRecordingSpan({
        traceId: traceId
    });
    $dRW3b.addChildSpanToSpan(parentSpan, childSpan);
    $gNZPa.setCapturedScopesOnSpan(childSpan, scope, isolationScope);
    const client = $hSRcd.getClient();
    if (!client) return childSpan;
    if ($aSFvs.hasSpanStreamingEnabled(client) && $2ldD6.spanIsNonRecordingSpan(childSpan)) {
        if ($2ldD6.spanIsNonRecordingSpan(parentSpan) && parentSpan.dropReason) {
            childSpan.dropReason = parentSpan.dropReason;
            client.recordDroppedEvent(parentSpan.dropReason, "span");
        } else if (!isTracingSuppressed) {
            childSpan.dropReason = "sample_rate";
            client.recordDroppedEvent("sample_rate", "span");
        }
    }
    client.emit("spanStart", childSpan);
    if (spanArguments.endTimestamp) {
        client.emit("spanEnd", childSpan);
        client.emit("afterSpanEnd", childSpan);
    }
    return childSpan;
}
function $c055ed032085a155$var$getParentSpan(scope, customParentSpan) {
    if (customParentSpan) return customParentSpan;
    if (customParentSpan === null) return void 0;
    const span = $h77y5._getSpanForScope(scope);
    if (!span) return void 0;
    const client = $hSRcd.getClient();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return $dRW3b.getRootSpan(span);
    return span;
}
function $c055ed032085a155$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== void 0 ? (callback)=>{
        return $c055ed032085a155$var$withActiveSpan(parentSpan, callback);
    } : (callback)=>callback();
}
function $c055ed032085a155$var$_shouldIgnoreStreamedSpan(client, spanArguments) {
    var _spanArguments_attributes;
    const ignoreSpans = client === null || client === void 0 ? void 0 : client.getOptions().ignoreSpans;
    if (!client || !$aSFvs.hasSpanStreamingEnabled(client) || !(ignoreSpans === null || ignoreSpans === void 0 ? void 0 : ignoreSpans.length)) return false;
    return $8mpfg.shouldIgnoreSpan({
        description: spanArguments.name || "",
        op: ((_spanArguments_attributes = spanArguments.attributes) === null || _spanArguments_attributes === void 0 ? void 0 : _spanArguments_attributes[$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_OP]) || spanArguments.op,
        attributes: spanArguments.attributes
    }, ignoreSpans);
}
function $c055ed032085a155$var$_isIgnoredSpan(span) {
    return $2ldD6.spanIsNonRecordingSpan(span) && span.dropReason === "ignored";
}
function $c055ed032085a155$var$_isTracingSuppressed(scope) {
    return scope.getScopeData().sdkProcessingMetadata[$c055ed032085a155$var$SUPPRESS_TRACING_KEY] === true;
}
module.exports.SUPPRESS_TRACING_KEY = $c055ed032085a155$var$SUPPRESS_TRACING_KEY;
module.exports.continueTrace = $c055ed032085a155$var$continueTrace;
module.exports.startInactiveSpan = $c055ed032085a155$var$startInactiveSpan;
module.exports.startNewTrace = $c055ed032085a155$var$startNewTrace;
module.exports.startSpan = $c055ed032085a155$var$startSpan;
module.exports.startSpanManual = $c055ed032085a155$var$startSpanManual;
module.exports.suppressTracing = $c055ed032085a155$var$suppressTracing;
module.exports.withActiveSpan = $c055ed032085a155$var$withActiveSpan;

});
parcelRegister("1fhPD", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jgv4K = parcelRequire("jgv4K");

var $ibzbk = parcelRequire("ibzbk");
function $0e850632a6afb88c$var$handleCallbackErrors(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $0e850632a6afb88c$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
function $0e850632a6afb88c$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ($ibzbk.isThenable(value)) return $jgv4K.chainAndCopyPromiseLike(value, (result)=>{
        onFinally();
        onSuccess(result);
    }, (err)=>{
        onError(err);
        onFinally();
    });
    onFinally();
    onSuccess(value);
    return value;
}
module.exports.handleCallbackErrors = $0e850632a6afb88c$var$handleCallbackErrors;

});

parcelRegister("h1Nl2", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $859Bb = parcelRequire("859Bb");

var $hQAU7 = parcelRequire("hQAU7");

var $6AMlx = parcelRequire("6AMlx");

var $3Wqd7 = parcelRequire("3Wqd7");
function $c658cd3fb4ea6375$var$sampleSpan(options, samplingContext, sampleRand) {
    if (!$6AMlx.hasSpansEnabled(options)) return [
        false
    ];
    let localSampleRateWasApplied = void 0;
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler((0, $2qxEV._)((0, $9tqwB._)({}, samplingContext), {
            inheritOrSampleWith: (fallbackSampleRate)=>{
                if (typeof samplingContext.parentSampleRate === "number") return samplingContext.parentSampleRate;
                if (typeof samplingContext.parentSampled === "boolean") return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        }));
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== void 0) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    const parsedSampleRate = $3Wqd7.parseSampleRate(sampleRate);
    if (parsedSampleRate === void 0) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    if (!parsedSampleRate) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    const shouldSample = sampleRand < parsedSampleRate;
    if (!shouldSample) $859Bb.DEBUG_BUILD && $hQAU7.debug.log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}
module.exports.sampleSpan = $c658cd3fb4ea6375$var$sampleSpan;

});



parcelRegister("hxXJ8", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hSRcd = parcelRequire("hSRcd");
const $cc63d93f2f122c16$var$ADD_LISTENER_METHODS = [
    "addListener",
    "on",
    "once",
    "prependListener",
    "prependOnceListener",
    "addEventListener"
];
const $cc63d93f2f122c16$var$REMOVE_LISTENER_METHODS = [
    "removeListener",
    "off",
    "removeEventListener"
];
const $cc63d93f2f122c16$var$SCOPE_BOUND_LISTENERS = /* @__PURE__ */ Symbol("SentryScopeBoundListeners");
let $cc63d93f2f122c16$var$registeringWrapper;
function $cc63d93f2f122c16$var$isReentrantWrapperRegistration(listener) {
    return $cc63d93f2f122c16$var$registeringWrapper !== void 0 && (listener === $cc63d93f2f122c16$var$registeringWrapper || listener.listener === $cc63d93f2f122c16$var$registeringWrapper);
}
function $cc63d93f2f122c16$var$bindScopeToEmitter(emitter, scope = $hSRcd.getCurrentScope()) {
    const ee = emitter;
    if ($cc63d93f2f122c16$var$getPatchMap(ee)) return emitter;
    $cc63d93f2f122c16$var$createPatchMap(ee);
    for (const methodName of $cc63d93f2f122c16$var$ADD_LISTENER_METHODS){
        if (typeof ee[methodName] !== "function") continue;
        ee[methodName] = $cc63d93f2f122c16$var$patchAddListener(ee, ee[methodName], scope);
    }
    for (const methodName of $cc63d93f2f122c16$var$REMOVE_LISTENER_METHODS){
        if (typeof ee[methodName] !== "function") continue;
        ee[methodName] = $cc63d93f2f122c16$var$patchRemoveListener(ee, ee[methodName]);
    }
    if (typeof ee.removeAllListeners === "function") ee.removeAllListeners = $cc63d93f2f122c16$var$patchRemoveAllListeners(ee, ee.removeAllListeners);
    return emitter;
}
function $cc63d93f2f122c16$var$bindListenerToScope(listener, scope) {
    return function(...args) {
        return $hSRcd.withScope(scope, ()=>listener.apply(this, args));
    };
}
function $cc63d93f2f122c16$var$isBoundListener(listener) {
    return typeof listener === "function";
}
function $cc63d93f2f122c16$var$patchAddListener(ee, original, scope) {
    return function(...args) {
        const event = args[0];
        const listener = args[1];
        const rest = args.slice(2);
        if (!$cc63d93f2f122c16$var$isBoundListener(listener) || $cc63d93f2f122c16$var$isReentrantWrapperRegistration(listener)) return original.apply(this, args);
        const map = $cc63d93f2f122c16$var$getPatchMap(ee) || $cc63d93f2f122c16$var$createPatchMap(ee);
        let listeners = map.get(event);
        if (!listeners) {
            listeners = /* @__PURE__ */ new WeakMap();
            map.set(event, listeners);
        }
        let boundListener = listeners.get(listener);
        if (!boundListener) {
            boundListener = $cc63d93f2f122c16$var$bindListenerToScope(listener, scope);
            listeners.set(listener, boundListener);
        }
        const previous = $cc63d93f2f122c16$var$registeringWrapper;
        $cc63d93f2f122c16$var$registeringWrapper = boundListener;
        try {
            return original.call(this, event, boundListener, ...rest);
        } finally{
            $cc63d93f2f122c16$var$registeringWrapper = previous;
        }
    };
}
function $cc63d93f2f122c16$var$patchRemoveListener(ee, original) {
    return function(...args) {
        var _getPatchMap_get, _getPatchMap;
        const event = args[0];
        const listener = args[1];
        const rest = args.slice(2);
        const boundListener = $cc63d93f2f122c16$var$isBoundListener(listener) ? (_getPatchMap = $cc63d93f2f122c16$var$getPatchMap(ee)) === null || _getPatchMap === void 0 ? void 0 : (_getPatchMap_get = _getPatchMap.get(event)) === null || _getPatchMap_get === void 0 ? void 0 : _getPatchMap_get.get(listener) : void 0;
        if (!boundListener) return original.apply(this, args);
        return original.call(this, event, boundListener, ...rest);
    };
}
function $cc63d93f2f122c16$var$patchRemoveAllListeners(ee, original) {
    return function(...args) {
        const map = $cc63d93f2f122c16$var$getPatchMap(ee);
        if (map) {
            if (args.length === 0) $cc63d93f2f122c16$var$createPatchMap(ee);
            else {
                const event = args[0];
                map.delete(event);
            }
        }
        return original.apply(this, args);
    };
}
function $cc63d93f2f122c16$var$createPatchMap(ee) {
    const map = /* @__PURE__ */ new Map();
    ee[$cc63d93f2f122c16$var$SCOPE_BOUND_LISTENERS] = map;
    return map;
}
function $cc63d93f2f122c16$var$getPatchMap(ee) {
    return ee[$cc63d93f2f122c16$var$SCOPE_BOUND_LISTENERS];
}
module.exports.bindScopeToEmitter = $cc63d93f2f122c16$var$bindScopeToEmitter;

});

parcelRegister("elQdO", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $faX3S = parcelRequire("faX3S");

var $9K8gk = parcelRequire("9K8gk");

var $dRW3b = parcelRequire("dRW3b");

var $gNZPa = parcelRequire("gNZPa");

var $1npIi = parcelRequire("1npIi");

var $98QIC = parcelRequire("98QIC");

var $dxRJQ = parcelRequire("dxRJQ");
function $a72b89033f3319cb$var$captureSpan(span, client) {
    var _processedSpan_attributes;
    const spanJSON = $dRW3b.spanToStreamedSpanJSON(span);
    const segmentSpan = $dRW3b.INTERNAL_getSegmentSpan(span);
    const serializedSegmentSpan = $dRW3b.spanToStreamedSpanJSON(segmentSpan);
    const { isolationScope: spanIsolationScope, scope: spanScope } = $gNZPa.getCapturedScopesOnSpan(span);
    const finalScopeData = $9K8gk.getCombinedScopeData(spanIsolationScope, spanScope);
    $a72b89033f3319cb$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, finalScopeData);
    const spanKind = span.kind;
    client.emit("preprocessSpan", spanJSON, {
        spanKind: spanKind
    });
    if (spanJSON.is_segment) {
        $a72b89033f3319cb$var$applyScopeToSegmentSpan(spanJSON, finalScopeData);
        $a72b89033f3319cb$var$applySdkMetadataToSegmentSpan(spanJSON, client);
        client.emit("processSegmentSpan", spanJSON);
    }
    client.emit("processSpan", spanJSON);
    const { beforeSendSpan: beforeSendSpan$1 } = client.getOptions();
    const processedSpan = beforeSendSpan$1 && $1npIi.isStreamedBeforeSendSpanCallback(beforeSendSpan$1) ? $a72b89033f3319cb$var$applyBeforeSendSpanCallback(spanJSON, beforeSendSpan$1) : spanJSON;
    const spanNameSource = (_processedSpan_attributes = processedSpan.attributes) === null || _processedSpan_attributes === void 0 ? void 0 : _processedSpan_attributes[$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    if (spanNameSource) $a72b89033f3319cb$var$safeSetSpanJSONAttributes(processedSpan, {
        // Purposefully not using a constant defined here like in other attributes:
        // This will be the name for SEMANTIC_ATTRIBUTE_SENTRY_SOURCE in v11
        "sentry.span.source": spanNameSource
    });
    return (0, $2qxEV._)((0, $9tqwB._)({}, $dRW3b.streamedSpanJsonToSerializedSpan(processedSpan)), {
        _segmentSpan: segmentSpan
    });
}
function $a72b89033f3319cb$var$applyScopeToSegmentSpan(segmentSpanJSON, scopeData) {
    const contextAttributes = $98QIC.scopeContextsToSpanAttributes(scopeData.contexts);
    $a72b89033f3319cb$var$safeSetSpanJSONAttributes(segmentSpanJSON, contextAttributes);
}
function $a72b89033f3319cb$var$safeSetSpanJSONAttributes(spanJSON, newAttributes) {
    var _spanJSON_attributes;
    const originalAttributes = (_spanJSON_attributes = spanJSON.attributes) !== null && _spanJSON_attributes !== void 0 ? _spanJSON_attributes : spanJSON.attributes = {};
    Object.entries(newAttributes).forEach(([key, value])=>{
        if (value != null && !(key in originalAttributes)) originalAttributes[key] = value;
    });
}
function $a72b89033f3319cb$var$applySdkMetadataToSegmentSpan(segmentSpanJSON, client) {
    const integrationNames = client.getIntegrationNames();
    if (!integrationNames.length) return;
    $a72b89033f3319cb$var$safeSetSpanJSONAttributes(segmentSpanJSON, {
        [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS]: integrationNames
    });
}
function $a72b89033f3319cb$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, scopeData) {
    var _sdk_sdk, _sdk_sdk1, _scopeData_user, _scopeData_user1, _scopeData_user2, _scopeData_user3;
    const sdk = client.getSdkMetadata();
    const { release: release, environment: environment } = client.getOptions();
    $a72b89033f3319cb$var$safeSetSpanJSONAttributes(spanJSON, (0, $9tqwB._)({
        [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE]: release,
        [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT]: environment || $dxRJQ.DEFAULT_ENVIRONMENT,
        [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME]: serializedSegmentSpan.name,
        [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID]: serializedSegmentSpan.span_id,
        [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME]: sdk === null || sdk === void 0 ? void 0 : (_sdk_sdk = sdk.sdk) === null || _sdk_sdk === void 0 ? void 0 : _sdk_sdk.name,
        [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION]: sdk === null || sdk === void 0 ? void 0 : (_sdk_sdk1 = sdk.sdk) === null || _sdk_sdk1 === void 0 ? void 0 : _sdk_sdk1.version,
        [$faX3S.SEMANTIC_ATTRIBUTE_USER_ID]: (_scopeData_user = scopeData.user) === null || _scopeData_user === void 0 ? void 0 : _scopeData_user.id,
        [$faX3S.SEMANTIC_ATTRIBUTE_USER_EMAIL]: (_scopeData_user1 = scopeData.user) === null || _scopeData_user1 === void 0 ? void 0 : _scopeData_user1.email,
        [$faX3S.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS]: (_scopeData_user2 = scopeData.user) === null || _scopeData_user2 === void 0 ? void 0 : _scopeData_user2.ip_address,
        [$faX3S.SEMANTIC_ATTRIBUTE_USER_USERNAME]: (_scopeData_user3 = scopeData.user) === null || _scopeData_user3 === void 0 ? void 0 : _scopeData_user3.username
    }, scopeData.attributes));
}
function $a72b89033f3319cb$var$applyBeforeSendSpanCallback(span, beforeSendSpan) {
    const modifedSpan = beforeSendSpan(span);
    if (!modifedSpan) {
        $dRW3b.showSpanDropWarning();
        return span;
    }
    return modifedSpan;
}
module.exports.applyBeforeSendSpanCallback = $a72b89033f3319cb$var$applyBeforeSendSpanCallback;
module.exports.captureSpan = $a72b89033f3319cb$var$captureSpan;
module.exports.safeSetSpanJSONAttributes = $a72b89033f3319cb$var$safeSetSpanJSONAttributes;

});
parcelRegister("9K8gk", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hSRcd = parcelRequire("hSRcd");

var $lzdUA = parcelRequire("lzdUA");

var $7Ol7I = parcelRequire("7Ol7I");

var $dRW3b = parcelRequire("dRW3b");
function $717ed1b0c3c8a1bd$var$applyScopeDataToEvent(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    $717ed1b0c3c8a1bd$var$applyDataToEvent(event, data);
    if (span) $717ed1b0c3c8a1bd$var$applySpanToEvent(event, span);
    $717ed1b0c3c8a1bd$var$applyFingerprintToEvent(event, fingerprint);
    $717ed1b0c3c8a1bd$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $717ed1b0c3c8a1bd$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
function $717ed1b0c3c8a1bd$var$mergeScopeData(data, mergeData) {
    const { extra: extra, tags: tags, attributes: attributes, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $717ed1b0c3c8a1bd$var$mergeAndOverwriteScopeData(data, "extra", extra);
    $717ed1b0c3c8a1bd$var$mergeAndOverwriteScopeData(data, "tags", tags);
    $717ed1b0c3c8a1bd$var$mergeAndOverwriteScopeData(data, "attributes", attributes);
    $717ed1b0c3c8a1bd$var$mergeAndOverwriteScopeData(data, "user", user);
    $717ed1b0c3c8a1bd$var$mergeAndOverwriteScopeData(data, "contexts", contexts);
    data.sdkProcessingMetadata = $7Ol7I.merge(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = (0, $9tqwB._)({}, data.propagationContext, propagationContext);
}
function $717ed1b0c3c8a1bd$var$mergeAndOverwriteScopeData(data, prop, mergeVal) {
    data[prop] = $7Ol7I.merge(data[prop], mergeVal, 1);
}
function $717ed1b0c3c8a1bd$var$getCombinedScopeData(isolationScope, currentScope) {
    const scopeData = $hSRcd.getGlobalScope().getScopeData();
    isolationScope && $717ed1b0c3c8a1bd$var$mergeScopeData(scopeData, isolationScope.getScopeData());
    currentScope && $717ed1b0c3c8a1bd$var$mergeScopeData(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $717ed1b0c3c8a1bd$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = (0, $9tqwB._)({}, extra, event.extra);
    if (Object.keys(tags).length) event.tags = (0, $9tqwB._)({}, tags, event.tags);
    if (Object.keys(user).length) event.user = (0, $9tqwB._)({}, user, event.user);
    if (Object.keys(contexts).length) event.contexts = (0, $9tqwB._)({}, contexts, event.contexts);
    if (level) event.level = level;
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $717ed1b0c3c8a1bd$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : void 0;
}
function $717ed1b0c3c8a1bd$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = (0, $9tqwB._)({}, event.sdkProcessingMetadata, sdkProcessingMetadata);
}
function $717ed1b0c3c8a1bd$var$applySpanToEvent(event, span) {
    event.contexts = (0, $9tqwB._)({
        trace: $dRW3b.spanToTraceContext(span)
    }, event.contexts);
    event.sdkProcessingMetadata = (0, $9tqwB._)({
        dynamicSamplingContext: $lzdUA.getDynamicSamplingContextFromSpan(span)
    }, event.sdkProcessingMetadata);
    const rootSpan = $dRW3b.getRootSpan(span);
    const transactionName = $dRW3b.spanToJSON(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
function $717ed1b0c3c8a1bd$var$applyFingerprintToEvent(event, fingerprint) {
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    if (!event.fingerprint.length) delete event.fingerprint;
}
module.exports.applyScopeDataToEvent = $717ed1b0c3c8a1bd$var$applyScopeDataToEvent;
module.exports.getCombinedScopeData = $717ed1b0c3c8a1bd$var$getCombinedScopeData;
module.exports.mergeAndOverwriteScopeData = $717ed1b0c3c8a1bd$var$mergeAndOverwriteScopeData;
module.exports.mergeScopeData = $717ed1b0c3c8a1bd$var$mergeScopeData;

});

parcelRegister("98QIC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $6a7dc13d05cc7ce2$var$scopeContextsToSpanAttributes(contexts) {
    const attrs = {};
    const { response: response, profile: profile, cloud_resource: cloud_resource, culture: culture, state: state } = contexts;
    if (response) {
        if (response.status_code != null) attrs["http.response.status_code"] = response.status_code;
        if (response.body_size != null) attrs["http.response.body.size"] = response.body_size;
    }
    if (profile) {
        if (profile.profile_id) attrs["sentry.profile_id"] = profile.profile_id;
        if (profile.profiler_id) attrs["sentry.profiler_id"] = profile.profiler_id;
    }
    if (cloud_resource) {
        for (const [key, value] of Object.entries(cloud_resource))if (value != null) attrs[key] = value;
    }
    if (culture) {
        if (culture.locale) attrs["culture.locale"] = culture.locale;
        if (culture.timezone) attrs["culture.timezone"] = culture.timezone;
    }
    if ((state === null || state === void 0 ? void 0 : state.state) && typeof state.state.type === "string") attrs["state.type"] = state.state.type;
    const angular = contexts["angular"];
    if (angular) {
        const version = angular["version"];
        if (typeof version === "string" || typeof version === "number") attrs["angular.version"] = version;
    }
    const react = contexts["react"];
    if (react) {
        const version = react["version"];
        if (typeof version === "string" || typeof version === "number") attrs["react.version"] = version;
    }
    return attrs;
}
module.exports.scopeContextsToSpanAttributes = $6a7dc13d05cc7ce2$var$scopeContextsToSpanAttributes;

});


parcelRegister("gHOmH", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hSRcd = parcelRequire("hSRcd");

var $859Bb = parcelRequire("859Bb");

var $kHUG4 = parcelRequire("kHUG4");

var $gvNu3 = parcelRequire("gvNu3");

var $hQAU7 = parcelRequire("hQAU7");

var $ibzbk = parcelRequire("ibzbk");

var $hppxz = parcelRequire("hppxz");

var $d42SF = parcelRequire("d42SF");

var $9K8gk = parcelRequire("9K8gk");

var $jHcnM = parcelRequire("jHcnM");

var $15YuE = parcelRequire("15YuE");
function $c297baef31856764$var$captureException(exception, hint) {
    return $hSRcd.getCurrentScope().captureException(exception, $d42SF.parseEventHintOrCaptureContext(hint));
}
function $c297baef31856764$var$captureMessage(message, captureContext) {
    const level = typeof captureContext === "string" ? captureContext : void 0;
    const hint = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : void 0;
    return $hSRcd.getCurrentScope().captureMessage(message, level, hint);
}
function $c297baef31856764$var$captureEvent(event, hint) {
    return $hSRcd.getCurrentScope().captureEvent(event, hint);
}
function $c297baef31856764$var$setContext(name, context) {
    $hSRcd.getIsolationScope().setContext(name, context);
}
function $c297baef31856764$var$setExtras(extras) {
    $hSRcd.getIsolationScope().setExtras(extras);
}
function $c297baef31856764$var$setExtra(key, extra) {
    $hSRcd.getIsolationScope().setExtra(key, extra);
}
function $c297baef31856764$var$setTags(tags) {
    $hSRcd.getIsolationScope().setTags(tags);
}
function $c297baef31856764$var$setTag(key, value) {
    $hSRcd.getIsolationScope().setTag(key, value);
}
function $c297baef31856764$var$setAttributes(attributes) {
    $hSRcd.getIsolationScope().setAttributes(attributes);
}
function $c297baef31856764$var$setAttribute(key, value) {
    $hSRcd.getIsolationScope().setAttribute(key, value);
}
function $c297baef31856764$var$setUser(user) {
    $hSRcd.getIsolationScope().setUser(user);
}
function $c297baef31856764$var$setConversationId(conversationId) {
    $hSRcd.getIsolationScope().setConversationId(conversationId);
}
function $c297baef31856764$var$lastEventId() {
    return $hSRcd.getIsolationScope().lastEventId();
}
function $c297baef31856764$var$captureCheckIn(checkIn, upsertMonitorConfig) {
    const scope = $hSRcd.getCurrentScope();
    const client = $hSRcd.getClient();
    if (!client) $859Bb.DEBUG_BUILD && $hQAU7.debug.warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) $859Bb.DEBUG_BUILD && $hQAU7.debug.warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return $hppxz.uuid4();
}
function $c297baef31856764$var$withMonitor(monitorSlug, callback, upsertMonitorConfig) {
    function runCallback() {
        const checkInId = $c297baef31856764$var$captureCheckIn({
            monitorSlug: monitorSlug,
            status: "in_progress"
        }, upsertMonitorConfig);
        const now = $jHcnM.timestampInSeconds();
        function finishCheckIn(status) {
            $c297baef31856764$var$captureCheckIn({
                monitorSlug: monitorSlug,
                status: status,
                checkInId: checkInId,
                duration: $jHcnM.timestampInSeconds() - now
            });
        }
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn("error");
            throw e;
        }
        if ($ibzbk.isThenable(maybePromiseResult)) return maybePromiseResult.then((r)=>{
            finishCheckIn("ok");
            return r;
        }, (e)=>{
            finishCheckIn("error");
            throw e;
        });
        finishCheckIn("ok");
        return maybePromiseResult;
    }
    return $hSRcd.withIsolationScope(()=>(upsertMonitorConfig === null || upsertMonitorConfig === void 0 ? void 0 : upsertMonitorConfig.isolateTrace) ? $gvNu3.startNewTrace(runCallback) : runCallback());
}
async function $c297baef31856764$var$flush(timeout) {
    const client = $hSRcd.getClient();
    if (client) return client.flush(timeout);
    $859Bb.DEBUG_BUILD && $hQAU7.debug.warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
async function $c297baef31856764$var$close(timeout) {
    const client = $hSRcd.getClient();
    if (client) return client.close(timeout);
    $859Bb.DEBUG_BUILD && $hQAU7.debug.warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
function $c297baef31856764$var$isInitialized() {
    return !!$hSRcd.getClient();
}
function $c297baef31856764$var$isEnabled() {
    const client = $hSRcd.getClient();
    return (client === null || client === void 0 ? void 0 : client.getOptions().enabled) !== false && !!(client === null || client === void 0 ? void 0 : client.getTransport());
}
function $c297baef31856764$var$addEventProcessor(callback) {
    $hSRcd.getIsolationScope().addEventProcessor(callback);
}
function $c297baef31856764$var$startSession(context) {
    const isolationScope = $hSRcd.getIsolationScope();
    const { user: user } = $9K8gk.getCombinedScopeData(isolationScope, $hSRcd.getCurrentScope());
    const { userAgent: userAgent } = $15YuE.GLOBAL_OBJ.navigator || {};
    const session$1 = $kHUG4.makeSession((0, $9tqwB._)({
        user: user
    }, userAgent && {
        userAgent: userAgent
    }, context));
    const currentSession = isolationScope.getSession();
    if ((currentSession === null || currentSession === void 0 ? void 0 : currentSession.status) === "ok") $kHUG4.updateSession(currentSession, {
        status: "exited"
    });
    $c297baef31856764$var$endSession();
    isolationScope.setSession(session$1);
    return session$1;
}
function $c297baef31856764$var$endSession() {
    const isolationScope = $hSRcd.getIsolationScope();
    const currentScope = $hSRcd.getCurrentScope();
    const session$1 = currentScope.getSession() || isolationScope.getSession();
    if (session$1) $kHUG4.closeSession(session$1);
    $c297baef31856764$var$_sendSessionUpdate();
    isolationScope.setSession();
}
function $c297baef31856764$var$_sendSessionUpdate() {
    const isolationScope = $hSRcd.getIsolationScope();
    const client = $hSRcd.getClient();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
function $c297baef31856764$var$captureSession(end = false) {
    if (end) {
        $c297baef31856764$var$endSession();
        return;
    }
    $c297baef31856764$var$_sendSessionUpdate();
}
module.exports.addEventProcessor = $c297baef31856764$var$addEventProcessor;
module.exports.captureCheckIn = $c297baef31856764$var$captureCheckIn;
module.exports.captureEvent = $c297baef31856764$var$captureEvent;
module.exports.captureException = $c297baef31856764$var$captureException;
module.exports.captureMessage = $c297baef31856764$var$captureMessage;
module.exports.captureSession = $c297baef31856764$var$captureSession;
module.exports.close = $c297baef31856764$var$close;
module.exports.endSession = $c297baef31856764$var$endSession;
module.exports.flush = $c297baef31856764$var$flush;
module.exports.isEnabled = $c297baef31856764$var$isEnabled;
module.exports.isInitialized = $c297baef31856764$var$isInitialized;
module.exports.lastEventId = $c297baef31856764$var$lastEventId;
module.exports.setAttribute = $c297baef31856764$var$setAttribute;
module.exports.setAttributes = $c297baef31856764$var$setAttributes;
module.exports.setContext = $c297baef31856764$var$setContext;
module.exports.setConversationId = $c297baef31856764$var$setConversationId;
module.exports.setExtra = $c297baef31856764$var$setExtra;
module.exports.setExtras = $c297baef31856764$var$setExtras;
module.exports.setTag = $c297baef31856764$var$setTag;
module.exports.setTags = $c297baef31856764$var$setTags;
module.exports.setUser = $c297baef31856764$var$setUser;
module.exports.startSession = $c297baef31856764$var$startSession;
module.exports.withMonitor = $c297baef31856764$var$withMonitor;

});
parcelRegister("d42SF", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dxRJQ = parcelRequire("dxRJQ");

var $bdOLT = parcelRequire("bdOLT");

var $4GLB5 = parcelRequire("4GLB5");

var $k80Ir = parcelRequire("k80Ir");

var $hppxz = parcelRequire("hppxz");

var $irz1w = parcelRequire("irz1w");

var $9K8gk = parcelRequire("9K8gk");

var $8zsqf = parcelRequire("8zsqf");

var $gCnte = parcelRequire("gCnte");

var $jHcnM = parcelRequire("jHcnM");
function $982de22935b870e1$var$prepareEvent(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = options;
    const prepared = (0, $2qxEV._)((0, $9tqwB._)({}, event), {
        event_id: event.event_id || hint.event_id || $hppxz.uuid4(),
        timestamp: event.timestamp || $jHcnM.dateTimestampInSeconds()
    });
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $982de22935b870e1$var$applyClientOptions(prepared, options);
    $982de22935b870e1$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    if (event.type === void 0) $982de22935b870e1$var$applyDebugIds(prepared, options.stackParser);
    const finalScope = $982de22935b870e1$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) $hppxz.addExceptionMechanism(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    const data = $9K8gk.getCombinedScopeData(isolationScope, finalScope);
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    $9K8gk.applyScopeDataToEvent(prepared, data);
    const eventProcessors$1 = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const isInternalException = hint.data && hint.data.__sentry__ === true;
    const result = isInternalException ? $gCnte.resolvedSyncPromise(prepared) : $bdOLT.notifyEventProcessors(eventProcessors$1, prepared, hint);
    return result.then((evt)=>{
        if (evt) $982de22935b870e1$var$applyDebugMeta(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $982de22935b870e1$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
function $982de22935b870e1$var$applyClientOptions(event, options) {
    var _event_exception_values, _event_exception;
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength } = options;
    event.environment = event.environment || environment || $dxRJQ.DEFAULT_ENVIRONMENT;
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if ((request === null || request === void 0 ? void 0 : request.url) && maxValueLength) request.url = $8zsqf.truncate(request.url, maxValueLength);
    if (maxValueLength) (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.forEach((exception)=>{
        if (exception.value) exception.value = $8zsqf.truncate(exception.value, maxValueLength);
    });
}
function $982de22935b870e1$var$applyDebugIds(event, stackParser) {
    var _event_exception_values, _event_exception;
    const filenameDebugIdMap = $k80Ir.getFilenameToDebugIdMap(stackParser);
    (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.forEach((exception)=>{
        var _exception_stacktrace_frames, _exception_stacktrace;
        (_exception_stacktrace = exception.stacktrace) === null || _exception_stacktrace === void 0 ? void 0 : (_exception_stacktrace_frames = _exception_stacktrace.frames) === null || _exception_stacktrace_frames === void 0 ? void 0 : _exception_stacktrace_frames.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
function $982de22935b870e1$var$applyDebugMeta(event) {
    var _event_exception_values, _event_exception;
    const filenameDebugIdMap = {};
    (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.forEach((exception)=>{
        var _exception_stacktrace_frames, _exception_stacktrace;
        (_exception_stacktrace = exception.stacktrace) === null || _exception_stacktrace === void 0 ? void 0 : (_exception_stacktrace_frames = _exception_stacktrace.frames) === null || _exception_stacktrace_frames === void 0 ? void 0 : _exception_stacktrace_frames.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: debug_id
        });
    });
}
function $982de22935b870e1$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
function $982de22935b870e1$var$normalizeEvent(event, depth, maxBreadth) {
    var _event_contexts, _event_contexts1;
    if (!event) return null;
    const normalized = (0, $9tqwB._)({}, event, event.breadcrumbs && {
        breadcrumbs: event.breadcrumbs.map((b)=>(0, $9tqwB._)({}, b, b.data && {
                data: $irz1w.normalize(b.data, depth, maxBreadth)
            }))
    }, event.user && {
        user: $irz1w.normalize(event.user, depth, maxBreadth)
    }, event.contexts && {
        contexts: $irz1w.normalize(event.contexts, depth, maxBreadth)
    }, event.extra && {
        extra: $irz1w.normalize(event.extra, depth, maxBreadth)
    });
    if (((_event_contexts = event.contexts) === null || _event_contexts === void 0 ? void 0 : _event_contexts.trace) && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        if (event.contexts.trace.data) normalized.contexts.trace.data = $irz1w.normalize(event.contexts.trace.data, depth, maxBreadth);
    }
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return (0, $9tqwB._)({}, span, span.data && {
            data: $irz1w.normalize(span.data, depth, maxBreadth)
        });
    });
    if (((_event_contexts1 = event.contexts) === null || _event_contexts1 === void 0 ? void 0 : _event_contexts1.flags) && normalized.contexts) normalized.contexts.flags = $irz1w.normalize(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $982de22935b870e1$var$getFinalScope(scope$1, captureContext) {
    if (!captureContext) return scope$1;
    const finalScope = scope$1 ? scope$1.clone() : new $4GLB5.Scope();
    finalScope.update(captureContext);
    return finalScope;
}
function $982de22935b870e1$var$parseEventHintOrCaptureContext(hint) {
    if (!hint) return void 0;
    if ($982de22935b870e1$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($982de22935b870e1$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $982de22935b870e1$var$hintIsScopeOrFunction(hint) {
    return hint instanceof $4GLB5.Scope || typeof hint === "function";
}
const $982de22935b870e1$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "propagationContext"
];
function $982de22935b870e1$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$982de22935b870e1$var$captureContextKeys.includes(key));
}
module.exports.applyClientOptions = $982de22935b870e1$var$applyClientOptions;
module.exports.applyDebugIds = $982de22935b870e1$var$applyDebugIds;
module.exports.applyDebugMeta = $982de22935b870e1$var$applyDebugMeta;
module.exports.parseEventHintOrCaptureContext = $982de22935b870e1$var$parseEventHintOrCaptureContext;
module.exports.prepareEvent = $982de22935b870e1$var$prepareEvent;

});
parcelRegister("bdOLT", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $859Bb = parcelRequire("859Bb");

var $hQAU7 = parcelRequire("hQAU7");

var $ibzbk = parcelRequire("ibzbk");

var $gCnte = parcelRequire("gCnte");
function $82b84ac6fb9b3d45$var$notifyEventProcessors(processors, event, hint, index = 0) {
    try {
        const result = $82b84ac6fb9b3d45$var$_notifyEventProcessors(event, hint, processors, index);
        return $ibzbk.isThenable(result) ? result : $gCnte.resolvedSyncPromise(result);
    } catch (error) {
        return $gCnte.rejectedSyncPromise(error);
    }
}
function $82b84ac6fb9b3d45$var$_notifyEventProcessors(event, hint, processors, index) {
    const processor = processors[index];
    if (!event || !processor) return event;
    const result = processor((0, $9tqwB._)({}, event), hint);
    $859Bb.DEBUG_BUILD && result === null && $hQAU7.debug.log(`Event processor "${processor.id || "?"}" dropped event`);
    if ($ibzbk.isThenable(result)) return result.then((final)=>$82b84ac6fb9b3d45$var$_notifyEventProcessors(final, hint, processors, index + 1));
    return $82b84ac6fb9b3d45$var$_notifyEventProcessors(result, hint, processors, index + 1);
}
module.exports.notifyEventProcessors = $82b84ac6fb9b3d45$var$notifyEventProcessors;

});
parcelRegister("gCnte", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ibzbk = parcelRequire("ibzbk");
const $c19266b146419670$var$STATE_PENDING = 0;
const $c19266b146419670$var$STATE_RESOLVED = 1;
const $c19266b146419670$var$STATE_REJECTED = 2;
function $c19266b146419670$var$resolvedSyncPromise(value) {
    return new $c19266b146419670$var$SyncPromise((resolve)=>{
        resolve(value);
    });
}
function $c19266b146419670$var$rejectedSyncPromise(reason) {
    return new $c19266b146419670$var$SyncPromise((_, reject)=>{
        reject(reason);
    });
}
class $c19266b146419670$var$SyncPromise {
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $c19266b146419670$var$SyncPromise((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $c19266b146419670$var$SyncPromise((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $c19266b146419670$var$STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $c19266b146419670$var$STATE_RESOLVED) handler[1](this._value);
            if (this._state === $c19266b146419670$var$STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $c19266b146419670$var$STATE_PENDING) return;
            if ($ibzbk.isThenable(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($c19266b146419670$var$STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($c19266b146419670$var$STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
    constructor(executor){
        this._state = $c19266b146419670$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
}
module.exports.SyncPromise = $c19266b146419670$var$SyncPromise;
module.exports.rejectedSyncPromise = $c19266b146419670$var$rejectedSyncPromise;
module.exports.resolvedSyncPromise = $c19266b146419670$var$resolvedSyncPromise;

});


parcelRegister("k80Ir", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ah1An = parcelRequire("ah1An");

var $15YuE = parcelRequire("15YuE");
let $ea751c21d8b9487a$var$parsedStackResults;
let $ea751c21d8b9487a$var$lastSentryKeysCount;
let $ea751c21d8b9487a$var$lastNativeKeysCount;
let $ea751c21d8b9487a$var$cachedFilenameDebugIds;
function $ea751c21d8b9487a$var$getFilenameToDebugIdMap(stackParser) {
    const sentryDebugIdMap = $15YuE.GLOBAL_OBJ._sentryDebugIds;
    const nativeDebugIdMap = $15YuE.GLOBAL_OBJ._debugIds;
    if (!sentryDebugIdMap && !nativeDebugIdMap) return {};
    const sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
    const nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
    if ($ea751c21d8b9487a$var$cachedFilenameDebugIds && sentryDebugIdKeys.length === $ea751c21d8b9487a$var$lastSentryKeysCount && nativeDebugIdKeys.length === $ea751c21d8b9487a$var$lastNativeKeysCount) return $ea751c21d8b9487a$var$cachedFilenameDebugIds;
    $ea751c21d8b9487a$var$lastSentryKeysCount = sentryDebugIdKeys.length;
    $ea751c21d8b9487a$var$lastNativeKeysCount = nativeDebugIdKeys.length;
    $ea751c21d8b9487a$var$cachedFilenameDebugIds = {};
    if (!$ea751c21d8b9487a$var$parsedStackResults) $ea751c21d8b9487a$var$parsedStackResults = {};
    const processDebugIds = (debugIdKeys, debugIdMap)=>{
        for (const key of debugIdKeys){
            const debugId = debugIdMap[key];
            const result = $ea751c21d8b9487a$var$parsedStackResults === null || $ea751c21d8b9487a$var$parsedStackResults === void 0 ? void 0 : $ea751c21d8b9487a$var$parsedStackResults[key];
            if (result && $ea751c21d8b9487a$var$cachedFilenameDebugIds && debugId) {
                $ea751c21d8b9487a$var$cachedFilenameDebugIds[result[0]] = debugId;
                if ($ea751c21d8b9487a$var$parsedStackResults) $ea751c21d8b9487a$var$parsedStackResults[key] = [
                    result[0],
                    debugId
                ];
            } else if (debugId) {
                const parsedStack = stackParser(key);
                for(let i = parsedStack.length - 1; i >= 0; i--){
                    const stackFrame = parsedStack[i];
                    const filename = stackFrame === null || stackFrame === void 0 ? void 0 : stackFrame.filename;
                    if (filename && $ea751c21d8b9487a$var$cachedFilenameDebugIds && $ea751c21d8b9487a$var$parsedStackResults) {
                        $ea751c21d8b9487a$var$cachedFilenameDebugIds[filename] = debugId;
                        $ea751c21d8b9487a$var$parsedStackResults[key] = [
                            filename,
                            debugId
                        ];
                        break;
                    }
                }
            }
        }
    };
    if (sentryDebugIdMap) processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
    if (nativeDebugIdMap) processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
    return $ea751c21d8b9487a$var$cachedFilenameDebugIds;
}
function $ea751c21d8b9487a$var$getDebugImagesForResources(stackParser, resource_paths) {
    const filenameDebugIdMap = $ea751c21d8b9487a$var$getFilenameToDebugIdMap(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths){
        const normalizedPath = $ah1An.normalizeStackTracePath(path);
        if (normalizedPath && filenameDebugIdMap[normalizedPath]) images.push({
            type: "sourcemap",
            code_file: path,
            debug_id: filenameDebugIdMap[normalizedPath]
        });
    }
    return images;
}
module.exports.getDebugImagesForResources = $ea751c21d8b9487a$var$getDebugImagesForResources;
module.exports.getFilenameToDebugIdMap = $ea751c21d8b9487a$var$getFilenameToDebugIdMap;

});



parcelRegister("jVohA", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ghmbo = parcelRequire("ghmbo");
const $e8162d33842a0c6a$var$SENTRY_API_VERSION = "7";
function $e8162d33842a0c6a$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
function $e8162d33842a0c6a$var$_getIngestEndpoint(dsn) {
    return `${$e8162d33842a0c6a$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
function $e8162d33842a0c6a$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $e8162d33842a0c6a$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
function $e8162d33842a0c6a$var$getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$e8162d33842a0c6a$var$_getIngestEndpoint(dsn)}?${$e8162d33842a0c6a$var$_encodedAuth(dsn, sdkInfo)}`;
}
function $e8162d33842a0c6a$var$getReportDialogEndpoint(dsnLike, dialogOptions) {
    const dsn$1 = $ghmbo.makeDsn(dsnLike);
    if (!dsn$1) return "";
    const endpoint = `${$e8162d33842a0c6a$var$getBaseApiEndpoint(dsn$1)}embed/error-page/`;
    let encodedOptions = `dsn=${$ghmbo.dsnToString(dsn$1)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}
module.exports.SENTRY_API_VERSION = $e8162d33842a0c6a$var$SENTRY_API_VERSION;
module.exports.getEnvelopeEndpointWithUrlEncodedAuth = $e8162d33842a0c6a$var$getEnvelopeEndpointWithUrlEncodedAuth;
module.exports.getReportDialogEndpoint = $e8162d33842a0c6a$var$getReportDialogEndpoint;

});

parcelRegister("9n8n8", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jVohA = parcelRequire("jVohA");

var $dxRJQ = parcelRequire("dxRJQ");

var $hSRcd = parcelRequire("hSRcd");

var $859Bb = parcelRequire("859Bb");

var $23pJH = parcelRequire("23pJH");

var $Qi0TL = parcelRequire("Qi0TL");

var $8H2Be = parcelRequire("8H2Be");

var $2NdDt = parcelRequire("2NdDt");

var $kHUG4 = parcelRequire("kHUG4");

var $lzdUA = parcelRequire("lzdUA");

var $1npIi = parcelRequire("1npIi");

var $gduMM = parcelRequire("gduMM");

var $ksySF = parcelRequire("ksySF");

var $96HOz = parcelRequire("96HOz");

var $hQAU7 = parcelRequire("hQAU7");

var $ghmbo = parcelRequire("ghmbo");

var $bIVq4 = parcelRequire("bIVq4");

var $03KcP = parcelRequire("03KcP");

var $ibzbk = parcelRequire("ibzbk");

var $7Ol7I = parcelRequire("7Ol7I");

var $hppxz = parcelRequire("hppxz");

var $3Wqd7 = parcelRequire("3Wqd7");

var $d42SF = parcelRequire("d42SF");

var $gx0IS = parcelRequire("gx0IS");

var $hxJcq = parcelRequire("hxJcq");

var $8mpfg = parcelRequire("8mpfg");

var $dRW3b = parcelRequire("dRW3b");

var $gCnte = parcelRequire("gCnte");

var $8z1zH = parcelRequire("8z1zH");

var $kmFmm = parcelRequire("kmFmm");

var $dHU94 = parcelRequire("dHU94");
const $6d2cc19589cc732a$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $6d2cc19589cc732a$var$MISSING_RELEASE_FOR_SESSION_ERROR = "Discarded session because of missing or non-string release";
const $6d2cc19589cc732a$var$INTERNAL_ERROR_SYMBOL = /* @__PURE__ */ Symbol.for("SentryInternalError");
const $6d2cc19589cc732a$var$DO_NOT_SEND_EVENT_SYMBOL = /* @__PURE__ */ Symbol.for("SentryDoNotSendEventError");
const $6d2cc19589cc732a$var$DEFAULT_FLUSH_INTERVAL = 5e3;
function $6d2cc19589cc732a$var$_makeInternalError(message) {
    return {
        message: message,
        [$6d2cc19589cc732a$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $6d2cc19589cc732a$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$6d2cc19589cc732a$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $6d2cc19589cc732a$var$_isInternalError(error) {
    return !!error && typeof error === "object" && $6d2cc19589cc732a$var$INTERNAL_ERROR_SYMBOL in error;
}
function $6d2cc19589cc732a$var$_isDoNotSendEventError(error) {
    return !!error && typeof error === "object" && $6d2cc19589cc732a$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
function $6d2cc19589cc732a$var$setupWeightBasedFlushing(client, afterCaptureHook, flushHook, estimateSizeFn, flushFn) {
    let weight = 0;
    let flushTimeout;
    let isTimerActive = false;
    client.on(flushHook, ()=>{
        weight = 0;
        clearTimeout(flushTimeout);
        isTimerActive = false;
    });
    client.on(afterCaptureHook, (item)=>{
        weight += estimateSizeFn(item);
        if (weight >= 8e5) flushFn(client);
        else if (!isTimerActive) {
            var _client_getOptions__flushInterval;
            const flushInterval = (_client_getOptions__flushInterval = client.getOptions()._flushInterval) !== null && _client_getOptions__flushInterval !== void 0 ? _client_getOptions__flushInterval : $6d2cc19589cc732a$var$DEFAULT_FLUSH_INTERVAL;
            if (flushInterval > 0) {
                isTimerActive = true;
                flushTimeout = $8z1zH.safeUnref(setTimeout(()=>{
                    flushFn(client);
                }, flushInterval));
            }
        }
    });
    client.on("flush", ()=>{
        flushFn(client);
    });
}
class $6d2cc19589cc732a$var$Client {
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = $hppxz.uuid4();
        if ($hppxz.checkOrSetAlreadyCaught(exception)) {
            $859Bb.DEBUG_BUILD && $hQAU7.debug.log($6d2cc19589cc732a$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = (0, $9tqwB._)({
            event_id: eventId
        }, hint);
        this._process(()=>this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)).then((res)=>res), "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = (0, $9tqwB._)({
            event_id: $hppxz.uuid4()
        }, hint);
        const eventMessage = $ibzbk.isParameterizedString(message) ? message : String(message);
        const isMessage = $ibzbk.isPrimitive(message);
        const promisedEvent = isMessage ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(()=>promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)), isMessage ? "unknown" : "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = $hppxz.uuid4();
        if ((hint === null || hint === void 0 ? void 0 : hint.originalException) && $hppxz.checkOrSetAlreadyCaught(hint.originalException)) {
            $859Bb.DEBUG_BUILD && $hQAU7.debug.log($6d2cc19589cc732a$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = (0, $9tqwB._)({
            event_id: eventId
        }, hint);
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        const dataCategory = $6d2cc19589cc732a$var$getDataCategoryByType(event.type);
        this._process(()=>this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope), dataCategory);
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session$1) {
        this.sendSession(session$1);
        $kHUG4.updateSession(session$1, {
            init: false
        });
    }
    /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the resolved data collection configuration.
   */ getDataCollectionOptions() {
        return this._dataCollection;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async flush(timeout) {
        const transport = this._transport;
        this.emit("flush");
        if (!transport) return true;
        const clientFinished = await this._isClientDoneProcessing(timeout);
        const transportFlushed = await transport.flush(timeout);
        return clientFinished && transportFlushed;
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async close(timeout) {
        $8H2Be._INTERNAL_flushLogsBuffer(this);
        const result = await this.flush(timeout);
        this.getOptions().enabled = false;
        this.emit("close");
        return result;
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith("Spotlight"))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the names of all installed integrations.
   */ getIntegrationNames() {
        return Object.keys(this._integrations);
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration$1) {
        const isAlreadyInstalled = this._integrations[integration$1.name];
        if (!isAlreadyInstalled && integration$1.beforeSetup) integration$1.beforeSetup(this);
        $Qi0TL.setupIntegration(this, integration$1, this._integrations);
        if (!isAlreadyInstalled) $Qi0TL.afterSetupIntegrations(this, [
            integration$1
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        const genAiSpanItem = $gduMM.extractGenAiSpansFromEvent(event, this);
        let env = $23pJH.createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = $bIVq4.addItemToEnvelope(env, $bIVq4.createAttachmentEnvelopeItem(attachment));
        if (genAiSpanItem) env = $bIVq4.addItemToEnvelope(env, genAiSpanItem);
        this.sendEnvelope(env).then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse));
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        const { release: clientReleaseOption, environment: clientEnvironmentOption = $dxRJQ.DEFAULT_ENVIRONMENT } = this._options;
        if ("aggregates" in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                $859Bb.DEBUG_BUILD && $hQAU7.debug.warn($6d2cc19589cc732a$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                $859Bb.DEBUG_BUILD && $hQAU7.debug.warn($6d2cc19589cc732a$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit("beforeSendSession", session);
        const env = $23pJH.createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            const key = `${reason}:${category}`;
            $859Bb.DEBUG_BUILD && $hQAU7.debug.log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hookCallbacks = this._hooks[hook] = this._hooks[hook] || /* @__PURE__ */ new Set();
        const uniqueCallback = (...args)=>callback(...args);
        hookCallbacks.add(uniqueCallback);
        return ()=>{
            hookCallbacks.delete(uniqueCallback);
        };
    }
    /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) try {
            return await this._transport.send(envelope);
        } catch (reason) {
            $859Bb.DEBUG_BUILD && $hQAU7.debug.error("Error while sending envelope:", reason);
            return {};
        }
        $859Bb.DEBUG_BUILD && $hQAU7.debug.error("Transport disabled");
        return {};
    }
    /**
   * Register a cleanup function to be called when the client is disposed.
   * This is useful for integrations that need to clean up global state.
   *
   * NOTE: This is a no-op in the base `Client` class. Subclasses like `ServerRuntimeClient`
   * override this method to actually register and execute cleanup callbacks.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    registerCleanup(callback) {}
    /**
   * Disposes of the client and releases all resources.
   *
   * Subclasses should override this method to clean up their own resources, including invoking
   * any callbacks registered via {@link Client.registerCleanup}. The base implementation is a
   * no-op and does NOT execute registered cleanup callbacks.
   *
   * After calling dispose(), the client should not be used anymore.
   */ dispose() {}
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = $Qi0TL.setupIntegrations(this, integrations);
        $Qi0TL.afterSetupIntegrations(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session$1, event) {
        var _event_exception;
        let crashed = event.level === "fatal";
        let errored = false;
        const exceptions = (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : _event_exception.values;
        if (exceptions) {
            var _ex_mechanism;
            errored = true;
            crashed = false;
            for (const ex of exceptions)if (((_ex_mechanism = ex.mechanism) === null || _ex_mechanism === void 0 ? void 0 : _ex_mechanism.handled) === false) {
                crashed = true;
                break;
            }
        }
        const sessionNonTerminal = session$1.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session$1.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            $kHUG4.updateSession(session$1, (0, $2qxEV._)((0, $9tqwB._)({}, crashed && {
                status: "crashed"
            }), {
                errors: session$1.errors || Number(errored || crashed)
            }));
            this.captureSession(session$1);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ async _isClientDoneProcessing(timeout) {
        let ticked = 0;
        while(!timeout || ticked < timeout){
            await new Promise((resolve)=>setTimeout(resolve, 1));
            if (!this._numProcessing) return true;
            ticked++;
        }
        return false;
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== void 0;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = this.getIntegrationNames();
        if (!hint.integrations && integrations.length) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return $d42SF.prepareEvent(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            var _evt_contexts;
            if (evt === null) return evt;
            this.emit("postprocessEvent", evt, hint);
            evt.contexts = (0, $9tqwB._)({
                trace: (0, $9tqwB._)({}, (_evt_contexts = evt.contexts) === null || _evt_contexts === void 0 ? void 0 : _evt_contexts.trace, $hSRcd.getTraceContextFromScope(currentScope))
            }, evt.contexts);
            const dynamicSamplingContext$1 = $lzdUA.getDynamicSamplingContextFromScope(this, currentScope);
            evt.sdkProcessingMetadata = (0, $9tqwB._)({
                dynamicSamplingContext: dynamicSamplingContext$1
            }, evt.sdkProcessingMetadata);
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = $hSRcd.getCurrentScope(), isolationScope = $hSRcd.getIsolationScope()) {
        if ($859Bb.DEBUG_BUILD && $6d2cc19589cc732a$var$isErrorEvent(event)) $hQAU7.debug.log(`Captured error event \`${$03KcP.getPossibleEventMessages(event)[0] || "<unknown>"}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if ($859Bb.DEBUG_BUILD) {
                if ($6d2cc19589cc732a$var$_isDoNotSendEventError(reason)) $hQAU7.debug.log(reason.message);
                else if ($6d2cc19589cc732a$var$_isInternalError(reason)) $hQAU7.debug.warn(reason.message);
                else $hQAU7.debug.warn(reason);
            }
            return void 0;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $6d2cc19589cc732a$var$isTransactionEvent(event);
        const isError = $6d2cc19589cc732a$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        const parsedSampleRate = typeof sampleRate === "undefined" ? void 0 : $3Wqd7.parseSampleRate(sampleRate);
        if (isError && typeof parsedSampleRate === "number" && $hxJcq.safeMathRandom() > parsedSampleRate) {
            this.recordDroppedEvent("sample_rate", "error");
            return $gCnte.rejectedSyncPromise($6d2cc19589cc732a$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = $6d2cc19589cc732a$var$getDataCategoryByType(event.type);
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            var _hint_data;
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory);
                throw $6d2cc19589cc732a$var$_makeDoNotSendEventError("An event processor returned `null`, will not send event.");
            }
            const isInternalException = ((_hint_data = hint.data) === null || _hint_data === void 0 ? void 0 : _hint_data.__sentry__) === true;
            if (isInternalException) return prepared;
            const result = $6d2cc19589cc732a$var$processBeforeSend(this, options, prepared, hint);
            return $6d2cc19589cc732a$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw $6d2cc19589cc732a$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                var _processedEvent_sdkProcessingMetadata;
                const spanCountBefore = ((_processedEvent_sdkProcessingMetadata = processedEvent.sdkProcessingMetadata) === null || _processedEvent_sdkProcessingMetadata === void 0 ? void 0 : _processedEvent_sdkProcessingMetadata.spanCountBeforeProcessing) || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = (0, $2qxEV._)((0, $9tqwB._)({}, transactionInfo), {
                    source: source
                });
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($6d2cc19589cc732a$var$_isDoNotSendEventError(reason) || $6d2cc19589cc732a$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                mechanism: {
                    handled: false,
                    type: "internal"
                },
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $6d2cc19589cc732a$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(taskProducer, dataCategory) {
        this._numProcessing++;
        this._promiseBuffer.add(taskProducer).then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            if (reason === $gx0IS.SENTRY_BUFFER_FULL_ERROR) this.recordDroppedEvent("queue_overflow", dataCategory);
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.log("Flushing outcomes...");
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            $859Bb.DEBUG_BUILD && $hQAU7.debug.log("No outcomes to send");
            return;
        }
        if (!this._dsn) {
            $859Bb.DEBUG_BUILD && $hQAU7.debug.log("No dsn provided, will not send outcomes");
            return;
        }
        $859Bb.DEBUG_BUILD && $hQAU7.debug.log("Sending outcomes:", outcomes);
        const envelope = $96HOz.createClientReportEnvelope(outcomes, this._options.tunnel && $ghmbo.dsnToString(this._dsn));
        this.sendEnvelope(envelope);
    }
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        var _options_transportOptions, _this__options__experiments, _this__options__experiments1;
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        var _options_transportOptions_bufferSize;
        this._promiseBuffer = $gx0IS.makePromiseBuffer((_options_transportOptions_bufferSize = (_options_transportOptions = options.transportOptions) === null || _options_transportOptions === void 0 ? void 0 : _options_transportOptions.bufferSize) !== null && _options_transportOptions_bufferSize !== void 0 ? _options_transportOptions_bufferSize : $ksySF.DEFAULT_TRANSPORT_BUFFER_SIZE);
        this._dataCollection = $dHU94.resolveDataCollectionOptions(options);
        if (options.dsn) this._dsn = $ghmbo.makeDsn(options.dsn);
        else $859Bb.DEBUG_BUILD && $hQAU7.debug.warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = $jVohA.getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : void 0);
            this._transport = options.transport((0, $2qxEV._)((0, $9tqwB._)({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this)
            }, options.transportOptions), {
                url: url
            }));
        }
        var _this__options_enableLogs;
        this._options.enableLogs = (_this__options_enableLogs = this._options.enableLogs) !== null && _this__options_enableLogs !== void 0 ? _this__options_enableLogs : (_this__options__experiments = this._options._experiments) === null || _this__options__experiments === void 0 ? void 0 : _this__options__experiments.enableLogs;
        if (this._options.enableLogs) $6d2cc19589cc732a$var$setupWeightBasedFlushing(this, "afterCaptureLog", "flushLogs", $6d2cc19589cc732a$var$estimateLogSizeInBytes, $8H2Be._INTERNAL_flushLogsBuffer);
        var _this__options_enableMetrics, _ref;
        const enableMetrics = (_ref = (_this__options_enableMetrics = this._options.enableMetrics) !== null && _this__options_enableMetrics !== void 0 ? _this__options_enableMetrics : (_this__options__experiments1 = this._options._experiments) === null || _this__options__experiments1 === void 0 ? void 0 : _this__options__experiments1.enableMetrics) !== null && _ref !== void 0 ? _ref : true;
        if (enableMetrics) $6d2cc19589cc732a$var$setupWeightBasedFlushing(this, "afterCaptureMetric", "flushMetrics", $6d2cc19589cc732a$var$estimateMetricSizeInBytes, $2NdDt._INTERNAL_flushMetricsBuffer);
    }
}
function $6d2cc19589cc732a$var$getDataCategoryByType(type) {
    return type === "replay_event" ? "replay" : type || "error";
}
function $6d2cc19589cc732a$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ($ibzbk.isThenable(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!$ibzbk.isPlainObject(event) && event !== null) throw $6d2cc19589cc732a$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $6d2cc19589cc732a$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!$ibzbk.isPlainObject(beforeSendResult) && beforeSendResult !== null) throw $6d2cc19589cc732a$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
function $6d2cc19589cc732a$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, ignoreSpans: ignoreSpans } = options;
    const beforeSendSpan$1 = !$1npIi.isStreamedBeforeSendSpanCallback(options.beforeSendSpan) && options.beforeSendSpan;
    let processedEvent = event;
    if ($6d2cc19589cc732a$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($6d2cc19589cc732a$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan$1 || ignoreSpans) {
            const rootSpanJson = $kmFmm.convertTransactionEventToSpanJson(processedEvent);
            if ((ignoreSpans === null || ignoreSpans === void 0 ? void 0 : ignoreSpans.length) && $8mpfg.shouldIgnoreSpan({
                description: rootSpanJson.description,
                op: rootSpanJson.op,
                attributes: rootSpanJson.data
            }, ignoreSpans)) return null;
            if (beforeSendSpan$1) {
                const processedRootSpanJson = beforeSendSpan$1(rootSpanJson);
                if (!processedRootSpanJson) $dRW3b.showSpanDropWarning();
                else processedEvent = $7Ol7I.merge(event, $kmFmm.convertSpanJsonToTransactionEvent(processedRootSpanJson));
            }
            if (processedEvent.spans) {
                const processedSpans = [];
                const initialSpans = processedEvent.spans;
                for (const span of initialSpans){
                    if ((ignoreSpans === null || ignoreSpans === void 0 ? void 0 : ignoreSpans.length) && $8mpfg.shouldIgnoreSpan({
                        description: span.description,
                        op: span.op,
                        attributes: span.data
                    }, ignoreSpans)) {
                        $8mpfg.reparentChildSpans(initialSpans, span);
                        continue;
                    }
                    if (beforeSendSpan$1) {
                        const processedSpan = beforeSendSpan$1(span);
                        if (!processedSpan) {
                            $dRW3b.showSpanDropWarning();
                            processedSpans.push(span);
                        } else processedSpans.push(processedSpan);
                    } else processedSpans.push(span);
                }
                const droppedSpans = processedEvent.spans.length - processedSpans.length;
                if (droppedSpans) client.recordDroppedEvent("before_send", "span", droppedSpans);
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = (0, $2qxEV._)((0, $9tqwB._)({}, event.sdkProcessingMetadata), {
                    spanCountBeforeProcessing: spanCountBefore
                });
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $6d2cc19589cc732a$var$isErrorEvent(event) {
    return event.type === void 0;
}
function $6d2cc19589cc732a$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
function $6d2cc19589cc732a$var$estimateMetricSizeInBytes(metric) {
    let weight = 0;
    if (metric.name) weight += metric.name.length * 2;
    weight += 8;
    return weight + $6d2cc19589cc732a$var$estimateAttributesSizeInBytes(metric.attributes);
}
function $6d2cc19589cc732a$var$estimateLogSizeInBytes(log) {
    let weight = 0;
    if (log.message) weight += log.message.length * 2;
    return weight + $6d2cc19589cc732a$var$estimateAttributesSizeInBytes(log.attributes);
}
function $6d2cc19589cc732a$var$estimateAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    Object.values(attributes).forEach((value)=>{
        if (Array.isArray(value)) weight += value.length * $6d2cc19589cc732a$var$estimatePrimitiveSizeInBytes(value[0]);
        else if ($ibzbk.isPrimitive(value)) weight += $6d2cc19589cc732a$var$estimatePrimitiveSizeInBytes(value);
        else weight += 100;
    });
    return weight;
}
function $6d2cc19589cc732a$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "number") return 8;
    else if (typeof value === "boolean") return 4;
    return 0;
}
module.exports.Client = $6d2cc19589cc732a$var$Client;

});
parcelRegister("Qi0TL", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hSRcd = parcelRequire("hSRcd");

var $859Bb = parcelRequire("859Bb");

var $hQAU7 = parcelRequire("hQAU7");
const $09d2d48c0ce4571d$var$installedIntegrations = [];
function $09d2d48c0ce4571d$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
function $09d2d48c0ce4571d$var$getIntegrationsToSetup(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $09d2d48c0ce4571d$var$filterDuplicates(integrations);
}
function $09d2d48c0ce4571d$var$setupIntegrations(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        if (integration === null || integration === void 0 ? void 0 : integration.beforeSetup) integration.beforeSetup(client);
    });
    integrations.forEach((integration)=>{
        if (integration) $09d2d48c0ce4571d$var$setupIntegration(client, integration, integrationIndex);
    });
    return integrationIndex;
}
function $09d2d48c0ce4571d$var$afterSetupIntegrations(client, integrations) {
    for (const integration of integrations)if (integration === null || integration === void 0 ? void 0 : integration.afterAllSetup) integration.afterAllSetup(client);
}
function $09d2d48c0ce4571d$var$setupIntegration(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    if (!$09d2d48c0ce4571d$var$installedIntegrations.includes(integration.name) && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $09d2d48c0ce4571d$var$installedIntegrations.push(integration.name);
    }
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    [
        "processSpan",
        "processSegmentSpan"
    ].forEach((hook)=>{
        const callback = integration[hook];
        if (typeof callback === "function") client.on(hook, (span)=>callback.call(integration, span, client));
    });
    $859Bb.DEBUG_BUILD && $hQAU7.debug.log(`Integration installed: ${integration.name}`);
}
function $09d2d48c0ce4571d$var$addIntegration(integration) {
    const client = $hSRcd.getClient();
    if (!client) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
function $09d2d48c0ce4571d$var$defineIntegration(fn) {
    return fn;
}
module.exports.addIntegration = $09d2d48c0ce4571d$var$addIntegration;
module.exports.afterSetupIntegrations = $09d2d48c0ce4571d$var$afterSetupIntegrations;
module.exports.defineIntegration = $09d2d48c0ce4571d$var$defineIntegration;
module.exports.getIntegrationsToSetup = $09d2d48c0ce4571d$var$getIntegrationsToSetup;
module.exports.installedIntegrations = $09d2d48c0ce4571d$var$installedIntegrations;
module.exports.setupIntegration = $09d2d48c0ce4571d$var$setupIntegration;
module.exports.setupIntegrations = $09d2d48c0ce4571d$var$setupIntegrations;

});

parcelRegister("8H2Be", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $i7X1A = parcelRequire("i7X1A");

var $gxkrU = parcelRequire("gxkrU");

var $hSRcd = parcelRequire("hSRcd");

var $859Bb = parcelRequire("859Bb");

var $hQAU7 = parcelRequire("hQAU7");

var $ibzbk = parcelRequire("ibzbk");

var $9K8gk = parcelRequire("9K8gk");

var $h77y5 = parcelRequire("h77y5");

var $jHcnM = parcelRequire("jHcnM");

var $6AvFG = parcelRequire("6AvFG");

var $gXVOQ = parcelRequire("gXVOQ");

var $1vOxL = parcelRequire("1vOxL");

var $6HZcK = parcelRequire("6HZcK");
const $65445b13d24dec98$var$MAX_LOG_BUFFER_SIZE = 100;
function $65445b13d24dec98$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
function $65445b13d24dec98$var$_INTERNAL_captureSerializedLog(client, serializedLog) {
    const bufferMap = $65445b13d24dec98$var$_getBufferMap();
    const logBuffer = $65445b13d24dec98$var$_INTERNAL_getLogBuffer(client);
    if (logBuffer === void 0) bufferMap.set(client, [
        serializedLog
    ]);
    else if (logBuffer.length >= $65445b13d24dec98$var$MAX_LOG_BUFFER_SIZE) {
        $65445b13d24dec98$var$_INTERNAL_flushLogsBuffer(client, logBuffer);
        bufferMap.set(client, [
            serializedLog
        ]);
    } else bufferMap.set(client, [
        ...logBuffer,
        serializedLog
    ]);
}
function $65445b13d24dec98$var$_INTERNAL_captureLog(beforeLog, currentScope = $hSRcd.getCurrentScope(), captureSerializedLog = $65445b13d24dec98$var$_INTERNAL_captureSerializedLog) {
    var _client_getSdkMetadata;
    var _currentScope_getClient;
    const client = (_currentScope_getClient = currentScope === null || currentScope === void 0 ? void 0 : currentScope.getClient()) !== null && _currentScope_getClient !== void 0 ? _currentScope_getClient : $hSRcd.getClient();
    if (!client) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.warn("No client available to capture log.");
        return;
    }
    const { release: release, environment: environment, enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = client.getOptions();
    if (!enableLogs) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.warn("logging option not enabled, log will not be captured.");
        return;
    }
    const [, traceContext] = $gXVOQ._getTraceInfoFromScope(client, currentScope);
    const processedLogAttributes = (0, $9tqwB._)({}, beforeLog.attributes);
    const { user: { id: id, email: email, username: username }, attributes: scopeAttributes = {} } = $9K8gk.getCombinedScopeData($hSRcd.getIsolationScope(), currentScope);
    $65445b13d24dec98$var$setLogAttribute(processedLogAttributes, "user.id", id, false);
    $65445b13d24dec98$var$setLogAttribute(processedLogAttributes, "user.email", email, false);
    $65445b13d24dec98$var$setLogAttribute(processedLogAttributes, "user.name", username, false);
    $65445b13d24dec98$var$setLogAttribute(processedLogAttributes, "sentry.release", release);
    $65445b13d24dec98$var$setLogAttribute(processedLogAttributes, "sentry.environment", environment);
    var _client_getSdkMetadata_sdk;
    const { name: name, version: version } = (_client_getSdkMetadata_sdk = (_client_getSdkMetadata = client.getSdkMetadata()) === null || _client_getSdkMetadata === void 0 ? void 0 : _client_getSdkMetadata.sdk) !== null && _client_getSdkMetadata_sdk !== void 0 ? _client_getSdkMetadata_sdk : {};
    $65445b13d24dec98$var$setLogAttribute(processedLogAttributes, "sentry.sdk.name", name);
    $65445b13d24dec98$var$setLogAttribute(processedLogAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay === null || replay === void 0 ? void 0 : replay.getReplayId(true);
    $65445b13d24dec98$var$setLogAttribute(processedLogAttributes, "sentry.replay_id", replayId);
    if (replayId && (replay === null || replay === void 0 ? void 0 : replay.getRecordingMode()) === "buffer") $65445b13d24dec98$var$setLogAttribute(processedLogAttributes, "sentry._internal.replay_is_buffering", true);
    const beforeLogMessage = beforeLog.message;
    if ($ibzbk.isParameterizedString(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        if (__sentry_template_values__ === null || __sentry_template_values__ === void 0 ? void 0 : __sentry_template_values__.length) processedLogAttributes["sentry.message.template"] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = $h77y5._getSpanForScope(currentScope);
    $65445b13d24dec98$var$setLogAttribute(processedLogAttributes, "sentry.trace.parent_span_id", span === null || span === void 0 ? void 0 : span.spanContext().spanId);
    const processedLog = (0, $2qxEV._)((0, $9tqwB._)({}, beforeLog), {
        attributes: processedLogAttributes
    });
    client.emit("beforeCaptureLog", processedLog);
    const log = beforeSendLog ? $hQAU7.consoleSandbox(()=>beforeSendLog(processedLog)) : processedLog;
    if (!log) {
        client.recordDroppedEvent("before_send", "log_item", 1);
        $859Bb.DEBUG_BUILD && $hQAU7.debug.warn("beforeSendLog returned null, log will not be captured.");
        return;
    }
    const { level: level, message: message, attributes: logAttributes = {}, severityNumber: severityNumber } = log;
    const timestamp = $jHcnM.timestampInSeconds();
    const sequenceAttr = $6AvFG.getSequenceAttribute(timestamp);
    const serializedLog = {
        timestamp: timestamp,
        level: level,
        body: $65445b13d24dec98$var$_removeLoneSurrogates(String(message)),
        trace_id: traceContext === null || traceContext === void 0 ? void 0 : traceContext.trace_id,
        severity_number: severityNumber !== null && severityNumber !== void 0 ? severityNumber : $1vOxL.SEVERITY_TEXT_TO_SEVERITY_NUMBER[level],
        attributes: $65445b13d24dec98$var$sanitizeLogAttributes((0, $2qxEV._)((0, $9tqwB._)({}, $i7X1A.serializeAttributes(scopeAttributes), $i7X1A.serializeAttributes(logAttributes, true)), {
            [sequenceAttr.key]: sequenceAttr.value
        }))
    };
    captureSerializedLog(client, serializedLog);
    client.emit("afterCaptureLog", log);
}
function $65445b13d24dec98$var$_INTERNAL_flushLogsBuffer(client, maybeLogBuffer) {
    var _ref;
    const logBuffer = (_ref = maybeLogBuffer !== null && maybeLogBuffer !== void 0 ? maybeLogBuffer : $65445b13d24dec98$var$_INTERNAL_getLogBuffer(client)) !== null && _ref !== void 0 ? _ref : [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope$1 = $6HZcK.createLogEnvelope(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $65445b13d24dec98$var$_getBufferMap().set(client, []);
    client.emit("flushLogs");
    client.sendEnvelope(envelope$1);
}
function $65445b13d24dec98$var$_INTERNAL_getLogBuffer(client) {
    return $65445b13d24dec98$var$_getBufferMap().get(client);
}
function $65445b13d24dec98$var$_getBufferMap() {
    return $gxkrU.getGlobalSingleton("clientToLogBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}
function $65445b13d24dec98$var$sanitizeLogAttributes(attributes) {
    const sanitized = {};
    for (const [key, attr] of Object.entries(attributes)){
        const sanitizedKey = $65445b13d24dec98$var$_removeLoneSurrogates(key);
        if (attr.type === "string") sanitized[sanitizedKey] = (0, $2qxEV._)((0, $9tqwB._)({}, attr), {
            value: $65445b13d24dec98$var$_removeLoneSurrogates(attr.value)
        });
        else sanitized[sanitizedKey] = attr;
    }
    return sanitized;
}
function $65445b13d24dec98$var$_removeLoneSurrogates(str) {
    const strObj = Object(str);
    const isWellFormed = strObj["isWellFormed"];
    const toWellFormed = strObj["toWellFormed"];
    if (typeof isWellFormed === "function" && typeof toWellFormed === "function") return isWellFormed.call(str) ? str : toWellFormed.call(str);
    return str;
}
module.exports._INTERNAL_captureLog = $65445b13d24dec98$var$_INTERNAL_captureLog;
module.exports._INTERNAL_captureSerializedLog = $65445b13d24dec98$var$_INTERNAL_captureSerializedLog;
module.exports._INTERNAL_flushLogsBuffer = $65445b13d24dec98$var$_INTERNAL_flushLogsBuffer;
module.exports._INTERNAL_getLogBuffer = $65445b13d24dec98$var$_INTERNAL_getLogBuffer;
module.exports._removeLoneSurrogates = $65445b13d24dec98$var$_removeLoneSurrogates;

});
parcelRegister("6AvFG", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $4cbeac1db9e7e3cb$var$SEQUENCE_ATTR_KEY = "sentry.timestamp.sequence";
let $4cbeac1db9e7e3cb$var$_sequenceNumber = 0;
let $4cbeac1db9e7e3cb$var$_previousTimestampMs;
function $4cbeac1db9e7e3cb$var$getSequenceAttribute(timestampInSeconds) {
    const nowMs = Math.floor(timestampInSeconds * 1e3);
    if ($4cbeac1db9e7e3cb$var$_previousTimestampMs !== void 0 && nowMs !== $4cbeac1db9e7e3cb$var$_previousTimestampMs) $4cbeac1db9e7e3cb$var$_sequenceNumber = 0;
    const value = $4cbeac1db9e7e3cb$var$_sequenceNumber;
    $4cbeac1db9e7e3cb$var$_sequenceNumber++;
    $4cbeac1db9e7e3cb$var$_previousTimestampMs = nowMs;
    return {
        key: $4cbeac1db9e7e3cb$var$SEQUENCE_ATTR_KEY,
        value: {
            value: value,
            type: "integer"
        }
    };
}
module.exports.getSequenceAttribute = $4cbeac1db9e7e3cb$var$getSequenceAttribute;

});

parcelRegister("gXVOQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hSRcd = parcelRequire("hSRcd");

var $lzdUA = parcelRequire("lzdUA");

var $dRW3b = parcelRequire("dRW3b");
function $c59f01ac3a0f87ef$var$_getTraceInfoFromScope(client, scope) {
    if (!scope) return [
        void 0,
        void 0
    ];
    return $hSRcd.withScope(scope, ()=>{
        const span = $dRW3b.getActiveSpan();
        const traceContext = span ? $dRW3b.spanToTraceContext(span) : $hSRcd.getTraceContextFromScope(scope);
        const dynamicSamplingContext$1 = span ? $lzdUA.getDynamicSamplingContextFromSpan(span) : $lzdUA.getDynamicSamplingContextFromScope(client, scope);
        return [
            dynamicSamplingContext$1,
            traceContext
        ];
    });
}
module.exports._getTraceInfoFromScope = $c59f01ac3a0f87ef$var$_getTraceInfoFromScope;

});

parcelRegister("1vOxL", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $119fe493f1e9e28c$var$SEVERITY_TEXT_TO_SEVERITY_NUMBER = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};
module.exports.SEVERITY_TEXT_TO_SEVERITY_NUMBER = $119fe493f1e9e28c$var$SEVERITY_TEXT_TO_SEVERITY_NUMBER;

});

parcelRegister("6HZcK", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ghmbo = parcelRequire("ghmbo");

var $bIVq4 = parcelRequire("bIVq4");

var $dhyIj = parcelRequire("dhyIj");
function $4e263c358150f4f1$var$createLogContainerEnvelopeItem(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "log",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.log+json"
        },
        (0, $2qxEV._)((0, $9tqwB._)({
            version: 2
        }, $dhyIj.isBrowser() && {
            ingest_settings: {
                infer_ip: inferSetting,
                infer_user_agent: inferSetting
            }
        }), {
            items: items
        })
    ];
}
function $4e263c358150f4f1$var$createLogEnvelope(logs, metadata, tunnel, dsn$1, inferUserData) {
    const headers = {};
    if (metadata === null || metadata === void 0 ? void 0 : metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $ghmbo.dsnToString(dsn$1);
    return $bIVq4.createEnvelope(headers, [
        $4e263c358150f4f1$var$createLogContainerEnvelopeItem(logs, inferUserData)
    ]);
}
module.exports.createLogContainerEnvelopeItem = $4e263c358150f4f1$var$createLogContainerEnvelopeItem;
module.exports.createLogEnvelope = $4e263c358150f4f1$var$createLogEnvelope;

});
parcelRegister("dhyIj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hLFaN = parcelRequire("hLFaN");

var $15YuE = parcelRequire("15YuE");
function $9ab7ca4df9dd8a78$var$isBrowser() {
    return typeof window !== "undefined" && (!$hLFaN.isNodeEnv() || $9ab7ca4df9dd8a78$var$isElectronNodeRenderer());
}
function $9ab7ca4df9dd8a78$var$isElectronNodeRenderer() {
    const process = $15YuE.GLOBAL_OBJ.process;
    return (process === null || process === void 0 ? void 0 : process.type) === "renderer";
}
module.exports.isBrowser = $9ab7ca4df9dd8a78$var$isBrowser;

});
parcelRegister("hLFaN", function(module, exports) {
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bWJMZ = parcelRequire("bWJMZ");
function isNodeEnv() {
    return !$bWJMZ.isBrowserBundle() && Object.prototype.toString.call(0) === "[object process]";
}
function dynamicRequire(mod, request) {
    return mod.require(request);
}
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch (e) {}
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, "process");
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {}
    return mod;
}
exports.isNodeEnv = isNodeEnv;
exports.loadModule = loadModule;

});
parcelRegister("bWJMZ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $8b28a1446e66ffb4$var$isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
function $8b28a1446e66ffb4$var$getSDKSource() {
    /*! __SENTRY_SDK_SOURCE__ */ return "npm";
}
module.exports.getSDKSource = $8b28a1446e66ffb4$var$getSDKSource;
module.exports.isBrowserBundle = $8b28a1446e66ffb4$var$isBrowserBundle;

});





parcelRegister("2NdDt", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $i7X1A = parcelRequire("i7X1A");

var $gxkrU = parcelRequire("gxkrU");

var $hSRcd = parcelRequire("hSRcd");

var $859Bb = parcelRequire("859Bb");

var $hQAU7 = parcelRequire("hQAU7");

var $9K8gk = parcelRequire("9K8gk");

var $h77y5 = parcelRequire("h77y5");

var $jHcnM = parcelRequire("jHcnM");

var $6AvFG = parcelRequire("6AvFG");

var $gXVOQ = parcelRequire("gXVOQ");

var $jCUYd = parcelRequire("jCUYd");
const $208abc220da51745$var$MAX_METRIC_BUFFER_SIZE = 1e3;
function $208abc220da51745$var$setMetricAttribute(metricAttributes, key, value, setEvenIfPresent = true) {
    if (value && (setEvenIfPresent || !(key in metricAttributes))) metricAttributes[key] = value;
}
function $208abc220da51745$var$_INTERNAL_captureSerializedMetric(client, serializedMetric) {
    const bufferMap = $208abc220da51745$var$_getBufferMap();
    const metricBuffer = $208abc220da51745$var$_INTERNAL_getMetricBuffer(client);
    if (metricBuffer === void 0) bufferMap.set(client, [
        serializedMetric
    ]);
    else if (metricBuffer.length >= $208abc220da51745$var$MAX_METRIC_BUFFER_SIZE) {
        $208abc220da51745$var$_INTERNAL_flushMetricsBuffer(client, metricBuffer);
        bufferMap.set(client, [
            serializedMetric
        ]);
    } else bufferMap.set(client, [
        ...metricBuffer,
        serializedMetric
    ]);
}
function $208abc220da51745$var$_enrichMetricAttributes(beforeMetric, client, user) {
    var _client_getSdkMetadata;
    const { release: release, environment: environment } = client.getOptions();
    const processedMetricAttributes = (0, $9tqwB._)({}, beforeMetric.attributes);
    $208abc220da51745$var$setMetricAttribute(processedMetricAttributes, "user.id", user.id, false);
    $208abc220da51745$var$setMetricAttribute(processedMetricAttributes, "user.email", user.email, false);
    $208abc220da51745$var$setMetricAttribute(processedMetricAttributes, "user.name", user.username, false);
    $208abc220da51745$var$setMetricAttribute(processedMetricAttributes, "sentry.release", release);
    $208abc220da51745$var$setMetricAttribute(processedMetricAttributes, "sentry.environment", environment);
    var _client_getSdkMetadata_sdk;
    const { name: name, version: version } = (_client_getSdkMetadata_sdk = (_client_getSdkMetadata = client.getSdkMetadata()) === null || _client_getSdkMetadata === void 0 ? void 0 : _client_getSdkMetadata.sdk) !== null && _client_getSdkMetadata_sdk !== void 0 ? _client_getSdkMetadata_sdk : {};
    $208abc220da51745$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.name", name);
    $208abc220da51745$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay === null || replay === void 0 ? void 0 : replay.getReplayId(true);
    $208abc220da51745$var$setMetricAttribute(processedMetricAttributes, "sentry.replay_id", replayId);
    if (replayId && (replay === null || replay === void 0 ? void 0 : replay.getRecordingMode()) === "buffer") $208abc220da51745$var$setMetricAttribute(processedMetricAttributes, "sentry._internal.replay_is_buffering", true);
    return (0, $2qxEV._)((0, $9tqwB._)({}, beforeMetric), {
        attributes: processedMetricAttributes
    });
}
function $208abc220da51745$var$_buildSerializedMetric(metric, client, currentScope, scopeAttributes) {
    const [, traceContext] = $gXVOQ._getTraceInfoFromScope(client, currentScope);
    const span = $h77y5._getSpanForScope(currentScope);
    const traceId = span ? span.spanContext().traceId : traceContext === null || traceContext === void 0 ? void 0 : traceContext.trace_id;
    const spanId = span ? span.spanContext().spanId : void 0;
    const timestamp = $jHcnM.timestampInSeconds();
    const sequenceAttr = $6AvFG.getSequenceAttribute(timestamp);
    return {
        timestamp: timestamp,
        trace_id: traceId !== null && traceId !== void 0 ? traceId : "",
        span_id: spanId,
        name: metric.name,
        type: metric.type,
        unit: metric.unit,
        value: metric.value,
        attributes: (0, $2qxEV._)((0, $9tqwB._)({}, $i7X1A.serializeAttributes(scopeAttributes), $i7X1A.serializeAttributes(metric.attributes, "skip-undefined")), {
            [sequenceAttr.key]: sequenceAttr.value
        })
    };
}
function $208abc220da51745$var$_INTERNAL_captureMetric(beforeMetric, options) {
    var _options_scope;
    const currentScope = (_options_scope = options === null || options === void 0 ? void 0 : options.scope) !== null && _options_scope !== void 0 ? _options_scope : $hSRcd.getCurrentScope();
    var _options_captureSerializedMetric;
    const captureSerializedMetric = (_options_captureSerializedMetric = options === null || options === void 0 ? void 0 : options.captureSerializedMetric) !== null && _options_captureSerializedMetric !== void 0 ? _options_captureSerializedMetric : $208abc220da51745$var$_INTERNAL_captureSerializedMetric;
    var _currentScope_getClient;
    const client = (_currentScope_getClient = currentScope === null || currentScope === void 0 ? void 0 : currentScope.getClient()) !== null && _currentScope_getClient !== void 0 ? _currentScope_getClient : $hSRcd.getClient();
    if (!client) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.warn("No client available to capture metric.");
        return;
    }
    const { _experiments: _experiments, enableMetrics: enableMetrics, beforeSendMetric: beforeSendMetric } = client.getOptions();
    var _ref;
    const metricsEnabled = (_ref = enableMetrics !== null && enableMetrics !== void 0 ? enableMetrics : _experiments === null || _experiments === void 0 ? void 0 : _experiments.enableMetrics) !== null && _ref !== void 0 ? _ref : true;
    if (!metricsEnabled) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.warn("metrics option not enabled, metric will not be captured.");
        return;
    }
    const { user: user, attributes: scopeAttributes } = $9K8gk.getCombinedScopeData($hSRcd.getIsolationScope(), currentScope);
    const enrichedMetric = $208abc220da51745$var$_enrichMetricAttributes(beforeMetric, client, user);
    client.emit("processMetric", enrichedMetric);
    const beforeSendCallback = beforeSendMetric || (_experiments === null || _experiments === void 0 ? void 0 : _experiments.beforeSendMetric);
    const processedMetric = beforeSendCallback ? beforeSendCallback(enrichedMetric) : enrichedMetric;
    if (!processedMetric) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.log("`beforeSendMetric` returned `null`, will not send metric.");
        return;
    }
    const serializedMetric = $208abc220da51745$var$_buildSerializedMetric(processedMetric, client, currentScope, scopeAttributes);
    $859Bb.DEBUG_BUILD && $hQAU7.debug.log("[Metric]", serializedMetric);
    captureSerializedMetric(client, serializedMetric);
    client.emit("afterCaptureMetric", processedMetric);
}
function $208abc220da51745$var$_INTERNAL_flushMetricsBuffer(client, maybeMetricBuffer) {
    var _ref;
    const metricBuffer = (_ref = maybeMetricBuffer !== null && maybeMetricBuffer !== void 0 ? maybeMetricBuffer : $208abc220da51745$var$_INTERNAL_getMetricBuffer(client)) !== null && _ref !== void 0 ? _ref : [];
    if (metricBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope$1 = $jCUYd.createMetricEnvelope(metricBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $208abc220da51745$var$_getBufferMap().set(client, []);
    client.emit("flushMetrics");
    client.sendEnvelope(envelope$1);
}
function $208abc220da51745$var$_INTERNAL_getMetricBuffer(client) {
    return $208abc220da51745$var$_getBufferMap().get(client);
}
function $208abc220da51745$var$_getBufferMap() {
    return $gxkrU.getGlobalSingleton("clientToMetricBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}
module.exports._INTERNAL_captureMetric = $208abc220da51745$var$_INTERNAL_captureMetric;
module.exports._INTERNAL_captureSerializedMetric = $208abc220da51745$var$_INTERNAL_captureSerializedMetric;
module.exports._INTERNAL_flushMetricsBuffer = $208abc220da51745$var$_INTERNAL_flushMetricsBuffer;
module.exports._INTERNAL_getMetricBuffer = $208abc220da51745$var$_INTERNAL_getMetricBuffer;

});
parcelRegister("jCUYd", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ghmbo = parcelRequire("ghmbo");

var $bIVq4 = parcelRequire("bIVq4");

var $dhyIj = parcelRequire("dhyIj");
function $e49dc2044097be05$var$createMetricContainerEnvelopeItem(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "trace_metric",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.trace-metric+json"
        },
        (0, $2qxEV._)((0, $9tqwB._)({
            version: 2
        }, $dhyIj.isBrowser() && {
            ingest_settings: {
                infer_ip: inferSetting,
                infer_user_agent: inferSetting
            }
        }), {
            items: items
        })
    ];
}
function $e49dc2044097be05$var$createMetricEnvelope(metrics, metadata, tunnel, dsn$1, inferUserData) {
    const headers = {};
    if (metadata === null || metadata === void 0 ? void 0 : metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $ghmbo.dsnToString(dsn$1);
    return $bIVq4.createEnvelope(headers, [
        $e49dc2044097be05$var$createMetricContainerEnvelopeItem(metrics, inferUserData)
    ]);
}
module.exports.createMetricContainerEnvelopeItem = $e49dc2044097be05$var$createMetricContainerEnvelopeItem;
module.exports.createMetricEnvelope = $e49dc2044097be05$var$createMetricEnvelope;

});


parcelRegister("gduMM", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dhyIj = parcelRequire("dhyIj");

var $aSFvs = parcelRequire("aSFvs");

var $22Dfj = parcelRequire("22Dfj");
function $bce5bdaacaff638d$var$extractGenAiSpansFromEvent(event, client) {
    var _event_spans, _event_sdkProcessingMetadata, _span_op;
    if (event.type !== "transaction" || !((_event_spans = event.spans) === null || _event_spans === void 0 ? void 0 : _event_spans.length) || !((_event_sdkProcessingMetadata = event.sdkProcessingMetadata) === null || _event_sdkProcessingMetadata === void 0 ? void 0 : _event_sdkProcessingMetadata.hasGenAiSpans) || client.getOptions().streamGenAiSpans === false || $aSFvs.hasSpanStreamingEnabled(client)) return void 0;
    const genAiSpans = [];
    const remainingSpans = [];
    for (const span of event.spans)if ((_span_op = span.op) === null || _span_op === void 0 ? void 0 : _span_op.startsWith("gen_ai.")) genAiSpans.push($22Dfj.spanJsonToSerializedStreamedSpan(span));
    else remainingSpans.push(span);
    if (genAiSpans.length === 0) return void 0;
    event.spans = remainingSpans;
    const inferSetting = client.getDataCollectionOptions().userInfo ? "auto" : "never";
    return [
        {
            type: "span",
            item_count: genAiSpans.length,
            content_type: "application/vnd.sentry.items.span.v2+json"
        },
        (0, $2qxEV._)((0, $9tqwB._)({
            version: 2
        }, $dhyIj.isBrowser() && {
            ingest_settings: {
                infer_ip: inferSetting,
                infer_user_agent: inferSetting
            }
        }), {
            items: genAiSpans
        })
    ];
}
module.exports.extractGenAiSpansFromEvent = $bce5bdaacaff638d$var$extractGenAiSpansFromEvent;

});
parcelRegister("22Dfj", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dRW3b = parcelRequire("dRW3b");
function $17ca36172f9b8ea9$var$spanJsonToSerializedStreamedSpan(span) {
    const streamedSpan = {
        trace_id: span.trace_id,
        span_id: span.span_id,
        parent_span_id: span.parent_span_id,
        name: span.description || "",
        start_timestamp: span.start_timestamp,
        end_timestamp: span.timestamp || span.start_timestamp,
        status: !span.status || span.status === "ok" || span.status === "cancelled" ? "ok" : "error",
        is_segment: false,
        attributes: (0, $9tqwB._)({}, span.data),
        links: span.links
    };
    return $dRW3b.streamedSpanJsonToSerializedSpan(streamedSpan);
}
module.exports.spanJsonToSerializedStreamedSpan = $17ca36172f9b8ea9$var$spanJsonToSerializedStreamedSpan;

});


parcelRegister("ksySF", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $859Bb = parcelRequire("859Bb");

var $hQAU7 = parcelRequire("hQAU7");

var $bIVq4 = parcelRequire("bIVq4");

var $gx0IS = parcelRequire("gx0IS");

var $dxgXQ = parcelRequire("dxgXQ");
const $ee517ac097b8dbdd$var$DEFAULT_TRANSPORT_BUFFER_SIZE = 64;
function $ee517ac097b8dbdd$var$createTransport(options, makeRequest, buffer = $gx0IS.makePromiseBuffer(options.bufferSize || $ee517ac097b8dbdd$var$DEFAULT_TRANSPORT_BUFFER_SIZE)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope$1) {
        const filteredEnvelopeItems = [];
        $bIVq4.forEachEnvelopeItem(envelope$1, (item, type)=>{
            const dataCategory = $bIVq4.envelopeItemTypeToDataCategory(type);
            if ($dxgXQ.isRateLimited(rateLimits, dataCategory)) options.recordDroppedEvent("ratelimit_backoff", dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        if (filteredEnvelopeItems.length === 0) return Promise.resolve({});
        const filteredEnvelope = $bIVq4.createEnvelope(envelope$1[0], filteredEnvelopeItems);
        const recordEnvelopeLoss = (reason)=>{
            if ($bIVq4.envelopeContainsItemType(filteredEnvelope, [
                "client_report"
            ])) {
                $859Bb.DEBUG_BUILD && $hQAU7.debug.warn(`Dropping client report. Will not send outcomes (reason: ${reason}).`);
                return;
            }
            $bIVq4.forEachEnvelopeItem(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, $bIVq4.envelopeItemTypeToDataCategory(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: $bIVq4.serializeEnvelope(filteredEnvelope)
            }).then((response)=>{
                if (response.statusCode === 413) {
                    $859Bb.DEBUG_BUILD && $hQAU7.debug.error("Sentry responded with status code 413. Envelope was discarded due to exceeding size limits.");
                    recordEnvelopeLoss("send_error");
                    return response;
                }
                if ($859Bb.DEBUG_BUILD && response.statusCode !== void 0 && (response.statusCode < 200 || response.statusCode >= 300)) $hQAU7.debug.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = $dxgXQ.updateRateLimits(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                $859Bb.DEBUG_BUILD && $hQAU7.debug.error("Encountered error running transport request:", error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === $gx0IS.SENTRY_BUFFER_FULL_ERROR) {
                $859Bb.DEBUG_BUILD && $hQAU7.debug.error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return Promise.resolve({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}
module.exports.DEFAULT_TRANSPORT_BUFFER_SIZE = $ee517ac097b8dbdd$var$DEFAULT_TRANSPORT_BUFFER_SIZE;
module.exports.createTransport = $ee517ac097b8dbdd$var$createTransport;

});
parcelRegister("gx0IS", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gCnte = parcelRequire("gCnte");

var $8z1zH = parcelRequire("8z1zH");
const $c09049f496bfc64c$var$SENTRY_BUFFER_FULL_ERROR = /* @__PURE__ */ Symbol.for("SentryBufferFullError");
function $c09049f496bfc64c$var$makePromiseBuffer(limit = 100) {
    const buffer = /* @__PURE__ */ new Set();
    function isReady() {
        return buffer.size < limit;
    }
    function remove(task) {
        buffer.delete(task);
    }
    function add(taskProducer) {
        if (!isReady()) return $gCnte.rejectedSyncPromise($c09049f496bfc64c$var$SENTRY_BUFFER_FULL_ERROR);
        const task = taskProducer();
        buffer.add(task);
        task.then(()=>remove(task), ()=>remove(task));
        return task;
    }
    function drain(timeout) {
        if (!buffer.size) return $gCnte.resolvedSyncPromise(true);
        const drainPromise = Promise.allSettled(Array.from(buffer)).then(()=>true);
        if (!timeout) return drainPromise;
        const promises = [
            drainPromise,
            new Promise((resolve)=>$8z1zH.safeUnref(setTimeout(()=>resolve(false), timeout)))
        ];
        return Promise.race(promises);
    }
    return {
        get $ () {
            return Array.from(buffer);
        },
        add: add,
        drain: drain
    };
}
module.exports.SENTRY_BUFFER_FULL_ERROR = $c09049f496bfc64c$var$SENTRY_BUFFER_FULL_ERROR;
module.exports.makePromiseBuffer = $c09049f496bfc64c$var$makePromiseBuffer;

});
parcelRegister("8z1zH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $63c2d053c8af04aa$var$safeUnref(timer) {
    if (typeof timer === "object" && typeof timer.unref === "function") timer.unref();
    return timer;
}
module.exports.safeUnref = $63c2d053c8af04aa$var$safeUnref;

});


parcelRegister("dxgXQ", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hxJcq = parcelRequire("hxJcq");
const $9dab8430ba47e846$var$DEFAULT_RETRY_AFTER = 60000;
function $9dab8430ba47e846$var$parseRetryAfterHeader(header, now = $hxJcq.safeDateNow()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1e3;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $9dab8430ba47e846$var$DEFAULT_RETRY_AFTER;
}
function $9dab8430ba47e846$var$disabledUntil(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
function $9dab8430ba47e846$var$isRateLimited(limits, dataCategory, now = $hxJcq.safeDateNow()) {
    return $9dab8430ba47e846$var$disabledUntil(limits, dataCategory) > now;
}
function $9dab8430ba47e846$var$updateRateLimits(limits, { statusCode: statusCode, headers: headers }, now = $hxJcq.safeDateNow()) {
    const updatedRateLimits = (0, $9tqwB._)({}, limits);
    const rateLimitHeader = headers === null || headers === void 0 ? void 0 : headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers === null || headers === void 0 ? void 0 : headers["retry-after"];
    if (rateLimitHeader) for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1e3;
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $9dab8430ba47e846$var$parseRetryAfterHeader(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}
module.exports.DEFAULT_RETRY_AFTER = $9dab8430ba47e846$var$DEFAULT_RETRY_AFTER;
module.exports.disabledUntil = $9dab8430ba47e846$var$disabledUntil;
module.exports.isRateLimited = $9dab8430ba47e846$var$isRateLimited;
module.exports.parseRetryAfterHeader = $9dab8430ba47e846$var$parseRetryAfterHeader;
module.exports.updateRateLimits = $9dab8430ba47e846$var$updateRateLimits;

});


parcelRegister("96HOz", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bIVq4 = parcelRequire("bIVq4");

var $jHcnM = parcelRequire("jHcnM");
function $6a16a9419d0d776e$var$createClientReportEnvelope(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || $jHcnM.dateTimestampInSeconds(),
            discarded_events: discarded_events
        }
    ];
    return $bIVq4.createEnvelope(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}
module.exports.createClientReportEnvelope = $6a16a9419d0d776e$var$createClientReportEnvelope;

});

parcelRegister("03KcP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $00b41f7bdcea9f8f$var$getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException === null || lastException === void 0 ? void 0 : lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch (e) {}
    return possibleMessages;
}
module.exports.getPossibleEventMessages = $00b41f7bdcea9f8f$var$getPossibleEventMessages;

});

parcelRegister("kmFmm", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $faX3S = parcelRequire("faX3S");
function $ed35f1e2b260bcda$var$convertTransactionEventToSpanJson(event) {
    var _event_contexts;
    var _event_contexts_trace;
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = (_event_contexts_trace = (_event_contexts = event.contexts) === null || _event_contexts === void 0 ? void 0 : _event_contexts.trace) !== null && _event_contexts_trace !== void 0 ? _event_contexts_trace : {};
    var _event_start_timestamp;
    return {
        data: data !== null && data !== void 0 ? data : {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id !== null && span_id !== void 0 ? span_id : "",
        start_timestamp: (_event_start_timestamp = event.start_timestamp) !== null && _event_start_timestamp !== void 0 ? _event_start_timestamp : 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id !== null && trace_id !== void 0 ? trace_id : "",
        origin: origin,
        profile_id: data === null || data === void 0 ? void 0 : data[$faX3S.SEMANTIC_ATTRIBUTE_PROFILE_ID],
        exclusive_time: data === null || data === void 0 ? void 0 : data[$faX3S.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
        measurements: event.measurements,
        is_segment: true
    };
}
function $ed35f1e2b260bcda$var$convertSpanJsonToTransactionEvent(span) {
    return {
        type: "transaction",
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: (0, $9tqwB._)({}, span.data, span.profile_id && {
                    [$faX3S.SEMANTIC_ATTRIBUTE_PROFILE_ID]: span.profile_id
                }, span.exclusive_time && {
                    [$faX3S.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME]: span.exclusive_time
                })
            }
        },
        measurements: span.measurements
    };
}
module.exports.convertSpanJsonToTransactionEvent = $ed35f1e2b260bcda$var$convertSpanJsonToTransactionEvent;
module.exports.convertTransactionEventToSpanJson = $ed35f1e2b260bcda$var$convertTransactionEventToSpanJson;

});

parcelRegister("dHU94", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7Nwyx = parcelRequire("7Nwyx");
const $9faad7d25ce0e486$var$DEFAULTS = {
    userInfo: true,
    cookies: true,
    httpHeaders: {
        request: true,
        response: true
    },
    httpBodies: [
        "incomingRequest",
        "outgoingRequest",
        "incomingResponse",
        "outgoingResponse"
    ],
    queryParams: true,
    genAI: {
        inputs: true,
        outputs: true
    },
    stackFrameVariables: true,
    frameContextLines: 5
};
function $9faad7d25ce0e486$var$resolveDataCollectionOptions(options) {
    var _dc_httpHeaders, _dc_httpHeaders1, _dc_genAI, _dc_genAI1;
    const base = options.dataCollection != null ? $9faad7d25ce0e486$var$DEFAULTS : $7Nwyx.defaultPiiToCollectionOptions(options.sendDefaultPii);
    var _options_dataCollection;
    const dc = (_options_dataCollection = options.dataCollection) !== null && _options_dataCollection !== void 0 ? _options_dataCollection : {};
    var _dc_userInfo, _dc_cookies, _dc_httpHeaders_request, _dc_httpHeaders_response, _dc_httpBodies, _dc_queryParams, _dc_genAI_inputs, _dc_genAI_outputs, _dc_stackFrameVariables, _dc_frameContextLines;
    return {
        userInfo: (_dc_userInfo = dc.userInfo) !== null && _dc_userInfo !== void 0 ? _dc_userInfo : base.userInfo,
        cookies: (_dc_cookies = dc.cookies) !== null && _dc_cookies !== void 0 ? _dc_cookies : base.cookies,
        httpHeaders: {
            request: (_dc_httpHeaders_request = (_dc_httpHeaders = dc.httpHeaders) === null || _dc_httpHeaders === void 0 ? void 0 : _dc_httpHeaders.request) !== null && _dc_httpHeaders_request !== void 0 ? _dc_httpHeaders_request : base.httpHeaders.request,
            response: (_dc_httpHeaders_response = (_dc_httpHeaders1 = dc.httpHeaders) === null || _dc_httpHeaders1 === void 0 ? void 0 : _dc_httpHeaders1.response) !== null && _dc_httpHeaders_response !== void 0 ? _dc_httpHeaders_response : base.httpHeaders.response
        },
        httpBodies: (_dc_httpBodies = dc.httpBodies) !== null && _dc_httpBodies !== void 0 ? _dc_httpBodies : base.httpBodies,
        queryParams: (_dc_queryParams = dc.queryParams) !== null && _dc_queryParams !== void 0 ? _dc_queryParams : base.queryParams,
        genAI: {
            inputs: (_dc_genAI_inputs = (_dc_genAI = dc.genAI) === null || _dc_genAI === void 0 ? void 0 : _dc_genAI.inputs) !== null && _dc_genAI_inputs !== void 0 ? _dc_genAI_inputs : base.genAI.inputs,
            outputs: (_dc_genAI_outputs = (_dc_genAI1 = dc.genAI) === null || _dc_genAI1 === void 0 ? void 0 : _dc_genAI1.outputs) !== null && _dc_genAI_outputs !== void 0 ? _dc_genAI_outputs : base.genAI.outputs
        },
        stackFrameVariables: (_dc_stackFrameVariables = dc.stackFrameVariables) !== null && _dc_stackFrameVariables !== void 0 ? _dc_stackFrameVariables : base.stackFrameVariables,
        frameContextLines: (_dc_frameContextLines = dc.frameContextLines) !== null && _dc_frameContextLines !== void 0 ? _dc_frameContextLines : base.frameContextLines
    };
}
module.exports.resolveDataCollectionOptions = $9faad7d25ce0e486$var$resolveDataCollectionOptions;

});
parcelRegister("7Nwyx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ePIFU = parcelRequire("ePIFU");
function $5ad65cf8921b3d9c$var$defaultPiiToCollectionOptions(sendDefaultPii) {
    return sendDefaultPii === true ? {
        userInfo: true,
        cookies: true,
        httpHeaders: {
            request: true,
            response: true
        },
        httpBodies: [
            "incomingRequest",
            "outgoingRequest",
            "incomingResponse",
            "outgoingResponse"
        ],
        queryParams: true,
        genAI: {
            inputs: true,
            outputs: true
        },
        stackFrameVariables: true,
        frameContextLines: 7
    } : {
        userInfo: false,
        cookies: {
            deny: $ePIFU.PII_HEADER_SNIPPETS
        },
        httpHeaders: {
            request: {
                deny: $ePIFU.PII_HEADER_SNIPPETS
            },
            response: {
                deny: $ePIFU.PII_HEADER_SNIPPETS
            }
        },
        httpBodies: [],
        queryParams: {
            deny: $ePIFU.PII_HEADER_SNIPPETS
        },
        genAI: {
            inputs: false,
            outputs: false
        },
        stackFrameVariables: true,
        frameContextLines: 7
    };
}
module.exports.defaultPiiToCollectionOptions = $5ad65cf8921b3d9c$var$defaultPiiToCollectionOptions;

});
parcelRegister("ePIFU", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $acc87ba59bf832bf$var$FILTERED_VALUE = "[Filtered]";
const $acc87ba59bf832bf$var$PII_HEADER_SNIPPETS = [
    "forwarded",
    "-ip",
    "remote-",
    "via",
    "-user"
];
const $acc87ba59bf832bf$var$SENSITIVE_KEY_SNIPPETS = [
    "auth",
    "token",
    "secret",
    "session",
    // for the user_session cookie
    "password",
    "passwd",
    "pwd",
    "key",
    "jwt",
    "bearer",
    "sso",
    "saml",
    "csrf",
    "xsrf",
    "credentials",
    "sid",
    "identity",
    // Always treat cookie headers as sensitive in case individual key-value cookie pairs cannot properly be extracted
    "set-cookie",
    "cookie"
];
const $acc87ba59bf832bf$var$SENSITIVE_COOKIE_NAME_SNIPPETS = [
    // Express / Connect default session cookie
    ".sid",
    // Opaque session ids (PHPSESSID, ASPSESSIONID*, BIGipServer*, *sessid*, …)
    "sessid",
    // Laravel etc. "remember me" tokens
    "remember",
    // OIDC / OAuth auxiliary (`oauth*` covered by header snippet `auth`)
    "oidc",
    "pkce",
    "nonce",
    // RFC 6265bis high-security cookie name prefixes
    "__secure-",
    "__host-",
    // Load balancer / CDN sticky-session cookies (opaque routing tokens)
    "awsalb",
    "awselb",
    "akamai",
    // BaaS / IdP session cookies (names often omit "session")
    "__stripe",
    "cognito",
    "firebase",
    "supabase",
    "sb-",
    // Step-up / MFA cookies
    "mfa",
    "2fa"
];
module.exports.FILTERED_VALUE = $acc87ba59bf832bf$var$FILTERED_VALUE;
module.exports.PII_HEADER_SNIPPETS = $acc87ba59bf832bf$var$PII_HEADER_SNIPPETS;
module.exports.SENSITIVE_COOKIE_NAME_SNIPPETS = $acc87ba59bf832bf$var$SENSITIVE_COOKIE_NAME_SNIPPETS;
module.exports.SENSITIVE_KEY_SNIPPETS = $acc87ba59bf832bf$var$SENSITIVE_KEY_SNIPPETS;

});




parcelRegister("iRTrq", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hSRcd = parcelRequire("hSRcd");

var $859Bb = parcelRequire("859Bb");

var $hQAU7 = parcelRequire("hQAU7");
function $dbc82ec07d84d0c2$var$initAndBind(clientClass, options) {
    if (options.debug === true) {
        if ($859Bb.DEBUG_BUILD) $hQAU7.debug.enable();
        else $hQAU7.consoleSandbox(()=>{
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = $hSRcd.getCurrentScope();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $dbc82ec07d84d0c2$var$setCurrentClient(client);
    client.init();
    return client;
}
function $dbc82ec07d84d0c2$var$setCurrentClient(client) {
    $hSRcd.getCurrentScope().setClient(client);
}
module.exports.initAndBind = $dbc82ec07d84d0c2$var$initAndBind;
module.exports.setCurrentClient = $dbc82ec07d84d0c2$var$setCurrentClient;

});

parcelRegister("h6P9t", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $859Bb = parcelRequire("859Bb");

var $hQAU7 = parcelRequire("hQAU7");

var $bIVq4 = parcelRequire("bIVq4");

var $hxJcq = parcelRequire("hxJcq");

var $dxgXQ = parcelRequire("dxgXQ");

var $8z1zH = parcelRequire("8z1zH");
const $c74aacdf0c14b62d$var$MIN_DELAY = 100;
const $c74aacdf0c14b62d$var$START_DELAY = 5e3;
const $c74aacdf0c14b62d$var$MAX_DELAY = 36e5;
function $c74aacdf0c14b62d$var$makeOfflineTransport(createTransport) {
    function log(...args) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.log("[Offline]:", ...args);
    }
    return (options)=>{
        const transport = createTransport(options);
        if (!options.createStore) throw new Error("No `createStore` function was provided");
        const store = options.createStore(options);
        let retryDelay = $c74aacdf0c14b62d$var$START_DELAY;
        let flushTimer;
        function shouldQueue(env, error, retryDelay2) {
            if ($bIVq4.envelopeContainsItemType(env, [
                "client_report"
            ])) return false;
            if (options.shouldStore) return options.shouldStore(env, error, retryDelay2);
            return true;
        }
        function flushIn(delay) {
            if (flushTimer) clearTimeout(flushTimer);
            flushTimer = $8z1zH.safeUnref(setTimeout(async ()=>{
                flushTimer = void 0;
                const found = await store.shift();
                if (found) {
                    log("Attempting to send previously queued event");
                    found[0].sent_at = new Date($hxJcq.safeDateNow()).toISOString();
                    send(found, true).catch((e)=>{
                        log("Failed to retry sending", e);
                    });
                }
            }, delay));
        }
        function flushWithBackOff() {
            if (flushTimer) return;
            flushIn(retryDelay);
            retryDelay = Math.min(retryDelay * 2, $c74aacdf0c14b62d$var$MAX_DELAY);
        }
        async function send(envelope$1, isRetry = false) {
            if (!isRetry && $bIVq4.envelopeContainsItemType(envelope$1, [
                "replay_event",
                "replay_recording"
            ])) {
                await store.push(envelope$1);
                flushIn($c74aacdf0c14b62d$var$MIN_DELAY);
                return {};
            }
            try {
                if (options.shouldSend && await options.shouldSend(envelope$1) === false) throw new Error("Envelope not sent because `shouldSend` callback returned false");
                const result = await transport.send(envelope$1);
                let delay = $c74aacdf0c14b62d$var$MIN_DELAY;
                if (result) {
                    var _result_headers, _result_headers1;
                    if ((_result_headers = result.headers) === null || _result_headers === void 0 ? void 0 : _result_headers["retry-after"]) delay = $dxgXQ.parseRetryAfterHeader(result.headers["retry-after"]);
                    else if ((_result_headers1 = result.headers) === null || _result_headers1 === void 0 ? void 0 : _result_headers1["x-sentry-rate-limits"]) delay = 6e4;
                    else if ((result.statusCode || 0) >= 400) return result;
                }
                flushIn(delay);
                retryDelay = $c74aacdf0c14b62d$var$START_DELAY;
                return result;
            } catch (e) {
                if (await shouldQueue(envelope$1, e, retryDelay)) {
                    if (isRetry) await store.unshift(envelope$1);
                    else await store.push(envelope$1);
                    flushWithBackOff();
                    log("Error sending. Event queued.", e);
                    return {};
                } else throw e;
            }
        }
        if (options.flushAtStartup) flushWithBackOff();
        return {
            send: send,
            flush: (timeout)=>{
                if (timeout === void 0) {
                    retryDelay = $c74aacdf0c14b62d$var$START_DELAY;
                    flushIn($c74aacdf0c14b62d$var$MIN_DELAY);
                }
                return transport.flush(timeout);
            }
        };
    };
}
module.exports.MIN_DELAY = $c74aacdf0c14b62d$var$MIN_DELAY;
module.exports.START_DELAY = $c74aacdf0c14b62d$var$START_DELAY;
module.exports.makeOfflineTransport = $c74aacdf0c14b62d$var$makeOfflineTransport;

});

parcelRegister("c44tH", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jVohA = parcelRequire("jVohA");

var $ghmbo = parcelRequire("ghmbo");

var $bIVq4 = parcelRequire("bIVq4");
const $8c8954fe0bb1c490$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY = "MULTIPLEXED_TRANSPORT_EXTRA_KEY";
function $8c8954fe0bb1c490$var$eventFromEnvelope(env, types) {
    let event;
    $bIVq4.forEachEnvelopeItem(env, (item, type)=>{
        if (types.includes(type)) event = Array.isArray(item) ? item[1] : void 0;
        return !!event;
    });
    return event;
}
function $8c8954fe0bb1c490$var$makeOverrideReleaseTransport(createTransport, release) {
    return (options)=>{
        const transport = createTransport(options);
        return (0, $2qxEV._)((0, $9tqwB._)({}, transport), {
            send: async (envelope)=>{
                const event = $8c8954fe0bb1c490$var$eventFromEnvelope(envelope, [
                    "event",
                    "transaction",
                    "profile",
                    "replay_event"
                ]);
                if (event) event.release = release;
                return transport.send(envelope);
            }
        });
    };
}
function $8c8954fe0bb1c490$var$overrideDsn(envelope$1, dsn) {
    return $bIVq4.createEnvelope(dsn ? (0, $2qxEV._)((0, $9tqwB._)({}, envelope$1[0]), {
        dsn: dsn
    }) : envelope$1[0], envelope$1[1]);
}
function $8c8954fe0bb1c490$var$makeMultiplexedTransport(createTransport, matcher) {
    return (options)=>{
        const fallbackTransport = createTransport(options);
        const otherTransports = /* @__PURE__ */ new Map();
        const actualMatcher = matcher || ((args)=>{
            var _event_extra;
            const event = args.getEvent();
            if ((event === null || event === void 0 ? void 0 : (_event_extra = event.extra) === null || _event_extra === void 0 ? void 0 : _event_extra[$8c8954fe0bb1c490$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY]) && Array.isArray(event.extra[$8c8954fe0bb1c490$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY])) return event.extra[$8c8954fe0bb1c490$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY];
            return [];
        });
        function getTransport(dsn$1, release) {
            const key = release ? `${dsn$1}:${release}` : dsn$1;
            let transport = otherTransports.get(key);
            if (!transport) {
                const validatedDsn = $ghmbo.dsnFromString(dsn$1);
                if (!validatedDsn) return void 0;
                const url = $jVohA.getEnvelopeEndpointWithUrlEncodedAuth(validatedDsn, options.tunnel);
                transport = release ? $8c8954fe0bb1c490$var$makeOverrideReleaseTransport(createTransport, release)((0, $2qxEV._)((0, $9tqwB._)({}, options), {
                    url: url
                })) : createTransport((0, $2qxEV._)((0, $9tqwB._)({}, options), {
                    url: url
                }));
                otherTransports.set(key, transport);
            }
            return [
                dsn$1,
                transport
            ];
        }
        async function send(envelope) {
            function getEvent(types) {
                const eventTypes = (types === null || types === void 0 ? void 0 : types.length) ? types : [
                    "event"
                ];
                return $8c8954fe0bb1c490$var$eventFromEnvelope(envelope, eventTypes);
            }
            const transports = actualMatcher({
                envelope: envelope,
                getEvent: getEvent
            }).map((result)=>{
                if (typeof result === "string") return getTransport(result, void 0);
                else return getTransport(result.dsn, result.release);
            }).filter((t)=>!!t);
            const transportsWithFallback = transports.length ? transports : [
                [
                    "",
                    fallbackTransport
                ]
            ];
            const results = await Promise.all(transportsWithFallback.map(([dsn, transport])=>transport.send($8c8954fe0bb1c490$var$overrideDsn(envelope, dsn))));
            return results[0];
        }
        async function flush(timeout) {
            const allTransports = [
                ...otherTransports.values(),
                fallbackTransport
            ];
            const results = await Promise.all(allTransports.map((transport)=>transport.flush(timeout)));
            return results.every((r)=>r);
        }
        return {
            send: send,
            flush: flush
        };
    };
}
module.exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY = $8c8954fe0bb1c490$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY;
module.exports.eventFromEnvelope = $8c8954fe0bb1c490$var$eventFromEnvelope;
module.exports.makeMultiplexedTransport = $8c8954fe0bb1c490$var$makeMultiplexedTransport;

});

parcelRegister("9gzrf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $859Bb = parcelRequire("859Bb");

var $hQAU7 = parcelRequire("hQAU7");
const $6bf1190b9b928732$var$SKIPPED_AI_PROVIDERS = /* @__PURE__ */ new Set();
function $6bf1190b9b928732$var$_INTERNAL_skipAiProviderWrapping(modules) {
    modules.forEach((module)=>{
        $6bf1190b9b928732$var$SKIPPED_AI_PROVIDERS.add(module);
        $859Bb.DEBUG_BUILD && $hQAU7.debug.log(`AI provider "${module}" wrapping will be skipped`);
    });
}
function $6bf1190b9b928732$var$_INTERNAL_shouldSkipAiProviderWrapping(module) {
    return $6bf1190b9b928732$var$SKIPPED_AI_PROVIDERS.has(module);
}
function $6bf1190b9b928732$var$_INTERNAL_clearAiProviderSkips() {
    $6bf1190b9b928732$var$SKIPPED_AI_PROVIDERS.clear();
    $859Bb.DEBUG_BUILD && $hQAU7.debug.log("Cleared AI provider skip registrations");
}
module.exports._INTERNAL_clearAiProviderSkips = $6bf1190b9b928732$var$_INTERNAL_clearAiProviderSkips;
module.exports._INTERNAL_shouldSkipAiProviderWrapping = $6bf1190b9b928732$var$_INTERNAL_shouldSkipAiProviderWrapping;
module.exports._INTERNAL_skipAiProviderWrapping = $6bf1190b9b928732$var$_INTERNAL_skipAiProviderWrapping;

});

parcelRegister("6vQat", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ePIFU = parcelRequire("ePIFU");
function $4bde1acb97f1ee61$var$isSensitiveKey(lower, denySnippets) {
    return denySnippets.some((snippet)=>lower.includes(snippet));
}
function $4bde1acb97f1ee61$var$filterKeyValueData(data, behavior, additionalDenyTerms) {
    if (behavior === false) return {};
    const denySnippets = additionalDenyTerms != null ? [
        ...$ePIFU.SENSITIVE_KEY_SNIPPETS,
        ...additionalDenyTerms
    ] : $ePIFU.SENSITIVE_KEY_SNIPPETS;
    const result = {};
    if (behavior === true) {
        for (const key of Object.keys(data))result[key] = $4bde1acb97f1ee61$var$isSensitiveKey(key.toLowerCase(), denySnippets) ? $ePIFU.FILTERED_VALUE : data[key];
        return result;
    }
    if ("deny" in behavior) {
        const lowerTerms2 = behavior.deny.map((t)=>t.toLowerCase());
        for (const key of Object.keys(data)){
            const lower = key.toLowerCase();
            const isDenied = $4bde1acb97f1ee61$var$isSensitiveKey(lower, denySnippets) || lowerTerms2.some((term)=>lower.includes(term));
            result[key] = isDenied ? $ePIFU.FILTERED_VALUE : data[key];
        }
        return result;
    }
    const lowerTerms = behavior.allow.map((t)=>t.toLowerCase());
    for (const key of Object.keys(data)){
        const lower = key.toLowerCase();
        if ($4bde1acb97f1ee61$var$isSensitiveKey(lower, denySnippets)) result[key] = $ePIFU.FILTERED_VALUE;
        else {
            const isAllowed = lowerTerms.some((term)=>lower.includes(term));
            result[key] = isAllowed ? data[key] : $ePIFU.FILTERED_VALUE;
        }
    }
    return result;
}
module.exports.filterKeyValueData = $4bde1acb97f1ee61$var$filterKeyValueData;

});

parcelRegister("7iyQC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $96czR = parcelRequire("96czR");

var $ePIFU = parcelRequire("ePIFU");

var $6vQat = parcelRequire("6vQat");
function $55053eddc3d07258$var$filterCookies(cookieString, behavior) {
    if (behavior === false) return {};
    try {
        const parsed = $96czR.parseCookie(cookieString);
        if (Object.keys(parsed).length === 0) return {};
        return $6vQat.filterKeyValueData(parsed, behavior, $ePIFU.SENSITIVE_COOKIE_NAME_SNIPPETS);
    } catch (e) {
        return $ePIFU.FILTERED_VALUE;
    }
}
module.exports.filterCookies = $55053eddc3d07258$var$filterCookies;

});
parcelRegister("96czR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $69fe6e2e75433e28$var$parseCookie(str) {
    const obj = {};
    let index = 0;
    while(index < str.length){
        const eqIdx = str.indexOf("=", index);
        if (eqIdx === -1) break;
        let endIdx = str.indexOf(";", index);
        if (endIdx === -1) endIdx = str.length;
        else if (endIdx < eqIdx) {
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const key = str.slice(index, eqIdx).trim();
        if (void 0 === obj[key]) {
            let val = str.slice(eqIdx + 1, endIdx).trim();
            if (val.charCodeAt(0) === 34) val = val.slice(1, -1);
            try {
                obj[key] = val.indexOf("%") !== -1 ? decodeURIComponent(val) : val;
            } catch (e) {
                obj[key] = val;
            }
        }
        index = endIdx + 1;
    }
    return obj;
}
module.exports.parseCookie = $69fe6e2e75433e28$var$parseCookie;

});


parcelRegister("fm2rf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ePIFU = parcelRequire("ePIFU");

var $6vQat = parcelRequire("6vQat");
function $b2dacd4c73addcde$var$filterQueryParams(queryString, behavior) {
    if (behavior === false) return {};
    try {
        const params = new URLSearchParams(queryString);
        const parsed = {};
        params.forEach((value, key)=>{
            parsed[key] = value;
        });
        if (Object.keys(parsed).length === 0) return {};
        return $6vQat.filterKeyValueData(parsed, behavior);
    } catch (e) {
        return $ePIFU.FILTERED_VALUE;
    }
}
module.exports.filterQueryParams = $b2dacd4c73addcde$var$filterQueryParams;

});

parcelRegister("jTdz4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $e7adad08bc7cf443$var$FALSY_ENV_VALUES = /* @__PURE__ */ new Set([
    "false",
    "f",
    "n",
    "no",
    "off",
    "0"
]);
const $e7adad08bc7cf443$var$TRUTHY_ENV_VALUES = /* @__PURE__ */ new Set([
    "true",
    "t",
    "y",
    "yes",
    "on",
    "1"
]);
function $e7adad08bc7cf443$var$envToBool(value, options) {
    const normalized = String(value).toLowerCase();
    if ($e7adad08bc7cf443$var$FALSY_ENV_VALUES.has(normalized)) return false;
    if ($e7adad08bc7cf443$var$TRUTHY_ENV_VALUES.has(normalized)) return true;
    return (options === null || options === void 0 ? void 0 : options.strict) ? null : Boolean(value);
}
module.exports.FALSY_ENV_VALUES = $e7adad08bc7cf443$var$FALSY_ENV_VALUES;
module.exports.TRUTHY_ENV_VALUES = $e7adad08bc7cf443$var$TRUTHY_ENV_VALUES;
module.exports.envToBool = $e7adad08bc7cf443$var$envToBool;

});

parcelRegister("l9T0r", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ghmbo = parcelRequire("ghmbo");

var $bIVq4 = parcelRequire("bIVq4");

var $hxJcq = parcelRequire("hxJcq");
function $f6751b4d0067c6b9$var$createCheckInEnvelope(checkIn, dynamicSamplingContext, metadata, tunnel, dsn$1) {
    const headers = {
        sent_at: new Date($hxJcq.safeDateNow()).toISOString()
    };
    if (metadata === null || metadata === void 0 ? void 0 : metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $ghmbo.dsnToString(dsn$1);
    if (dynamicSamplingContext) headers.trace = dynamicSamplingContext;
    const item = $f6751b4d0067c6b9$var$createCheckInEnvelopeItem(checkIn);
    return $bIVq4.createEnvelope(headers, [
        item
    ]);
}
function $f6751b4d0067c6b9$var$createCheckInEnvelopeItem(checkIn) {
    const checkInHeaders = {
        type: "check_in"
    };
    return [
        checkInHeaders,
        checkIn
    ];
}
module.exports.createCheckInEnvelope = $f6751b4d0067c6b9$var$createCheckInEnvelope;

});

parcelRegister("65oHg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kRTcv = parcelRequire("kRTcv");
function $0124bf739b1cbcef$var$isSentryRequestUrl(url, client) {
    const dsn = client === null || client === void 0 ? void 0 : client.getDsn();
    const tunnel = client === null || client === void 0 ? void 0 : client.getOptions().tunnel;
    return $0124bf739b1cbcef$var$checkDsn(url, dsn) || $0124bf739b1cbcef$var$checkTunnel(url, tunnel);
}
function $0124bf739b1cbcef$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $0124bf739b1cbcef$var$removeTrailingSlash(url) === $0124bf739b1cbcef$var$removeTrailingSlash(tunnel);
}
function $0124bf739b1cbcef$var$checkDsn(url$1, dsn) {
    const urlParts = $kRTcv.parseStringToURLObject(url$1);
    if (!urlParts || $kRTcv.isURLObjectRelative(urlParts)) return false;
    if (!dsn) return false;
    return $0124bf739b1cbcef$var$hostnameMatchesDsnHost(urlParts.hostname, dsn.host) && /(^|&|\?)sentry_key=/.test(urlParts.search);
}
function $0124bf739b1cbcef$var$hostnameMatchesDsnHost(hostname, dsnHost) {
    return hostname === dsnHost || dsnHost.length > 0 && hostname.endsWith(`.${dsnHost}`);
}
function $0124bf739b1cbcef$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}
module.exports.isSentryRequestUrl = $0124bf739b1cbcef$var$isSentryRequestUrl;

});
parcelRegister("kRTcv", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $faX3S = parcelRequire("faX3S");
const $f313939ebac59a71$var$DEFAULT_BASE_URL = "thismessage:/";
function $f313939ebac59a71$var$isURLObjectRelative(url) {
    return "isRelative" in url;
}
function $f313939ebac59a71$var$parseStringToURLObject(url, urlBase) {
    const isRelative = url.indexOf("://") <= 0 && url.indexOf("//") !== 0;
    const base = urlBase !== null && urlBase !== void 0 ? urlBase : isRelative ? $f313939ebac59a71$var$DEFAULT_BASE_URL : void 0;
    try {
        if ("canParse" in URL && !URL.canParse(url, base)) return void 0;
        const fullUrlObject = new URL(url, base);
        if (isRelative) return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch (e) {}
    return void 0;
}
function $f313939ebac59a71$var$getSanitizedUrlStringFromUrlObject(url) {
    if ($f313939ebac59a71$var$isURLObjectRelative(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = "";
    newUrl.hash = "";
    if ([
        "80",
        "443"
    ].includes(newUrl.port)) newUrl.port = "";
    if (newUrl.password) newUrl.password = "%filtered%";
    if (newUrl.username) newUrl.username = "%filtered%";
    return newUrl.toString();
}
function $f313939ebac59a71$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    var _request_method;
    var _request_method_toUpperCase;
    const method = (_request_method_toUpperCase = request === null || request === void 0 ? void 0 : (_request_method = request.method) === null || _request_method === void 0 ? void 0 : _request_method.toUpperCase()) !== null && _request_method_toUpperCase !== void 0 ? _request_method_toUpperCase : "GET";
    const route = routeName ? routeName : urlObject ? kind === "client" ? $f313939ebac59a71$var$getSanitizedUrlStringFromUrlObject(urlObject) : urlObject.pathname : "/";
    return `${method} ${route}`;
}
function $f313939ebac59a71$var$getHttpSpanDetailsFromUrlObject(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
        [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "url"
    };
    if (routeName) {
        attributes[kind === "server" ? "http.route" : "url.template"] = routeName;
        attributes[$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "route";
    }
    if (request === null || request === void 0 ? void 0 : request.method) attributes[$faX3S.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes["url.query"] = urlObject.search;
        if (urlObject.hash) attributes["url.fragment"] = urlObject.hash;
        if (urlObject.pathname) {
            attributes["url.path"] = urlObject.pathname;
            if (urlObject.pathname === "/") attributes[$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "route";
        }
        if (!$f313939ebac59a71$var$isURLObjectRelative(urlObject)) {
            attributes[$faX3S.SEMANTIC_ATTRIBUTE_URL_FULL] = urlObject.href;
            if (urlObject.port) attributes["url.port"] = urlObject.port;
            if (urlObject.protocol) attributes["url.scheme"] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === "server" ? "server.address" : "url.domain"] = urlObject.hostname;
        }
    }
    return [
        $f313939ebac59a71$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
function $f313939ebac59a71$var$parseUrl(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
function $f313939ebac59a71$var$stripUrlQueryAndFragment(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
function $f313939ebac59a71$var$getSanitizedUrlString(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = (host === null || host === void 0 ? void 0 : host.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "")) || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}
function $f313939ebac59a71$var$stripDataUrlContent(url, includeDataPrefix = true) {
    if (url.startsWith("data:")) {
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : "text/plain";
        const isBase64 = url.includes(";base64,");
        const dataStart = url.indexOf(",");
        let dataPrefix = "";
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ",base64" : ""}${dataPrefix ? `,${dataPrefix}` : ""}`;
    }
    return url;
}
module.exports.getHttpSpanDetailsFromUrlObject = $f313939ebac59a71$var$getHttpSpanDetailsFromUrlObject;
module.exports.getSanitizedUrlString = $f313939ebac59a71$var$getSanitizedUrlString;
module.exports.getSanitizedUrlStringFromUrlObject = $f313939ebac59a71$var$getSanitizedUrlStringFromUrlObject;
module.exports.isURLObjectRelative = $f313939ebac59a71$var$isURLObjectRelative;
module.exports.parseStringToURLObject = $f313939ebac59a71$var$parseStringToURLObject;
module.exports.parseUrl = $f313939ebac59a71$var$parseUrl;
module.exports.stripDataUrlContent = $f313939ebac59a71$var$stripDataUrlContent;
module.exports.stripUrlQueryAndFragment = $f313939ebac59a71$var$stripUrlQueryAndFragment;

});


parcelRegister("LkEbx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $08e467fe7c306654$var$parameterize(strings, ...values) {
    const formatted = new String(String.raw(strings, ...values));
    formatted.__sentry_template_string__ = strings.join("\0").replace(/%/g, "%%").replace(/\0/g, "%s");
    formatted.__sentry_template_values__ = values;
    return formatted;
}
const $08e467fe7c306654$var$fmt = $08e467fe7c306654$var$parameterize;
module.exports.fmt = $08e467fe7c306654$var$fmt;
module.exports.parameterize = $08e467fe7c306654$var$parameterize;

});

parcelRegister("4VNqS", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jVohA = parcelRequire("jVohA");

var $hQAU7 = parcelRequire("hQAU7");

var $ghmbo = parcelRequire("ghmbo");

var $bIVq4 = parcelRequire("bIVq4");
async function $3972d48aeedc4e49$var$handleTunnelRequest(options) {
    const { request: request, allowedDsns: allowedDsns } = options;
    if (allowedDsns.length === 0) return new Response("Tunnel not configured", {
        status: 500
    });
    const body = new Uint8Array(await request.arrayBuffer());
    let envelopeHeader;
    try {
        [envelopeHeader] = $bIVq4.parseEnvelope(body);
    } catch (e) {
        return new Response("Invalid envelope", {
            status: 400
        });
    }
    if (!envelopeHeader) return new Response("Invalid envelope: missing header", {
        status: 400
    });
    const dsn$1 = envelopeHeader.dsn;
    if (!dsn$1) return new Response("Invalid envelope: missing DSN", {
        status: 400
    });
    const isAllowed = allowedDsns.some((allowed)=>allowed === dsn$1);
    if (!isAllowed) {
        $hQAU7.debug.warn(`Sentry tunnel: rejected request with unauthorized DSN (${dsn$1})`);
        return new Response("DSN not allowed", {
            status: 403
        });
    }
    const dsnComponents = $ghmbo.makeDsn(dsn$1);
    if (!dsnComponents) {
        $hQAU7.debug.warn(`Could not extract DSN Components from: ${dsn$1}`);
        return new Response("Invalid DSN", {
            status: 403
        });
    }
    const sentryIngestUrl = $jVohA.getEnvelopeEndpointWithUrlEncodedAuth(dsnComponents);
    try {
        return await fetch(sentryIngestUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-sentry-envelope"
            },
            body: body
        });
    } catch (error) {
        $hQAU7.debug.error("Sentry tunnel: failed to forward envelope", error);
        return new Response("Failed to forward envelope to Sentry", {
            status: 500
        });
    }
}
module.exports.handleTunnelRequest = $3972d48aeedc4e49$var$handleTunnelRequest;

});

parcelRegister("ebGAH", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $a5432174df55da00$var$addAutoIpAddressToUser(objWithMaybeUser) {
    var _objWithMaybeUser_user;
    if (((_objWithMaybeUser_user = objWithMaybeUser.user) === null || _objWithMaybeUser_user === void 0 ? void 0 : _objWithMaybeUser_user.ip_address) === void 0) objWithMaybeUser.user = (0, $2qxEV._)((0, $9tqwB._)({}, objWithMaybeUser.user), {
        ip_address: "{{auto}}"
    });
}
function $a5432174df55da00$var$addAutoIpAddressToSession(session) {
    var _session_attrs;
    if ("aggregates" in session) {
        if (((_session_attrs = session.attrs) === null || _session_attrs === void 0 ? void 0 : _session_attrs["ip_address"]) === void 0) session.attrs = (0, $2qxEV._)((0, $9tqwB._)({}, session.attrs), {
            ip_address: "{{auto}}"
        });
    } else if (session.ipAddress === void 0) session.ipAddress = "{{auto}}";
}
module.exports.addAutoIpAddressToSession = $a5432174df55da00$var$addAutoIpAddressToSession;
module.exports.addAutoIpAddressToUser = $a5432174df55da00$var$addAutoIpAddressToUser;

});

parcelRegister("guP5C", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $crjMp = parcelRequire("crjMp");
function $c02713fe440e71c3$var$applySdkMetadata(options, name, names = [
    name
], source = "npm") {
    const sdk = (options._metadata = options._metadata || {}).sdk = options._metadata.sdk || {};
    if (!sdk.name) {
        sdk.name = `sentry.javascript.${name}`;
        sdk.packages = names.map((name2)=>({
                name: `${source}:@sentry/${name2}`,
                version: $crjMp.SDK_VERSION
            }));
        sdk.version = $crjMp.SDK_VERSION;
    }
}
module.exports.applySdkMetadata = $c02713fe440e71c3$var$applySdkMetadata;

});

parcelRegister("cCABH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $59Hrx = parcelRequire("59Hrx");

var $gxkrU = parcelRequire("gxkrU");

var $hSRcd = parcelRequire("hSRcd");

var $gHOmH = parcelRequire("gHOmH");

var $hQAU7 = parcelRequire("hQAU7");

var $dRW3b = parcelRequire("dRW3b");

var $6AMlx = parcelRequire("6AMlx");

var $2ldD6 = parcelRequire("2ldD6");

var $lzdUA = parcelRequire("lzdUA");

var $f0HG2 = parcelRequire("f0HG2");

var $f0MA0 = parcelRequire("f0MA0");
function $93056e087c766b5d$var$getTraceData(options = {}) {
    const client = options.client || $hSRcd.getClient();
    if (!$gHOmH.isEnabled() || !client) return {};
    const carrier$1 = $gxkrU.getMainCarrier();
    const acs = $59Hrx.getAsyncContextStrategy(carrier$1);
    if (acs.getTraceData) return acs.getTraceData(options);
    const scope = options.scope || $hSRcd.getCurrentScope();
    const span = options.span || $dRW3b.getActiveSpan();
    const isTwpPlaceholder = $2ldD6.spanIsNonRecordingSpan(span) && !$6AMlx.hasSpansEnabled(client.getOptions());
    if (!span && $hSRcd.hasExternalPropagationContext()) return {};
    const sentryTrace = span && !isTwpPlaceholder ? $dRW3b.spanToTraceHeader(span) : $93056e087c766b5d$var$scopeToTraceHeader(scope);
    const dsc = span ? $lzdUA.getDynamicSamplingContextFromSpan(span) : $lzdUA.getDynamicSamplingContextFromScope(client, scope);
    const baggage$1 = $f0HG2.dynamicSamplingContextToSentryBaggageHeader(dsc);
    const isValidSentryTraceHeader = $f0MA0.TRACEPARENT_REGEXP.test(sentryTrace);
    if (!isValidSentryTraceHeader) {
        $hQAU7.debug.warn("Invalid sentry-trace data. Cannot generate trace data");
        return {};
    }
    const traceData = {
        "sentry-trace": sentryTrace,
        baggage: baggage$1
    };
    if (options.propagateTraceparent) traceData.traceparent = span && !isTwpPlaceholder ? $dRW3b.spanToTraceparentHeader(span) : $93056e087c766b5d$var$scopeToTraceparentHeader(scope);
    return traceData;
}
function $93056e087c766b5d$var$scopeToTraceHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return $f0MA0.generateSentryTraceHeader(traceId, propagationSpanId, sampled);
}
function $93056e087c766b5d$var$scopeToTraceparentHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return $f0MA0.generateTraceparentHeader(traceId, propagationSpanId, sampled);
}
module.exports.getTraceData = $93056e087c766b5d$var$getTraceData;

});

parcelRegister("ew3kP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $859Bb = parcelRequire("859Bb");

var $hQAU7 = parcelRequire("hQAU7");

var $8zsqf = parcelRequire("8zsqf");
const $a916a41c7730d35f$var$NOT_PROPAGATED_MESSAGE = "[Tracing] Not injecting trace data for url because it does not match tracePropagationTargets:";
function $a916a41c7730d35f$var$shouldPropagateTraceForUrl(url, tracePropagationTargets, decisionMap) {
    if (typeof url !== "string" || !tracePropagationTargets) return true;
    const cachedDecision = decisionMap === null || decisionMap === void 0 ? void 0 : decisionMap.get(url);
    if (cachedDecision !== void 0) {
        $859Bb.DEBUG_BUILD && !cachedDecision && $hQAU7.debug.log($a916a41c7730d35f$var$NOT_PROPAGATED_MESSAGE, url);
        return cachedDecision;
    }
    const decision = $8zsqf.stringMatchesSomePattern(url, tracePropagationTargets);
    decisionMap === null || decisionMap === void 0 ? void 0 : decisionMap.set(url, decision);
    $859Bb.DEBUG_BUILD && !decision && $hQAU7.debug.log($a916a41c7730d35f$var$NOT_PROPAGATED_MESSAGE, url);
    return decision;
}
module.exports.shouldPropagateTraceForUrl = $a916a41c7730d35f$var$shouldPropagateTraceForUrl;

});

parcelRegister("g05x5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cCABH = parcelRequire("cCABH");
function $ba60f01e2e94fc15$var$getTraceMetaTags(traceData$1) {
    return Object.entries(traceData$1 || $cCABH.getTraceData()).map(([key, value])=>`<meta name="${key}" content="${value}"/>`).join("\n");
}
module.exports.getTraceMetaTags = $ba60f01e2e94fc15$var$getTraceMetaTags;

});

parcelRegister("cDbpi", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $9321f9c5502491d0$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = (options === null || options === void 0 ? void 0 : options.maxWait) ? Math.max(options.maxWait, wait) : 0;
    const setTimeoutImpl = (options === null || options === void 0 ? void 0 : options.setTimeoutImpl) || setTimeout;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== void 0 && clearTimeout(timerId);
        maxTimerId !== void 0 && clearTimeout(maxTimerId);
        timerId = maxTimerId = void 0;
    }
    function flush() {
        if (timerId !== void 0 || maxTimerId !== void 0) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeoutImpl(invokeFunc, wait);
        if (maxWait && maxTimerId === void 0) maxTimerId = setTimeoutImpl(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
module.exports.debounce = $9321f9c5502491d0$var$debounce;

});

parcelRegister("71LoA", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $859Bb = parcelRequire("859Bb");

var $hQAU7 = parcelRequire("hQAU7");

var $7Nwyx = parcelRequire("7Nwyx");

var $ePIFU = parcelRequire("ePIFU");

var $6vQat = parcelRequire("6vQat");

var $8z1zH = parcelRequire("8z1zH");
const $51dd6426dd88e961$var$MAX_BODY_BYTE_LENGTH = 1048576;
const $51dd6426dd88e961$var$TEXT_CONTENT_TYPES = [
    "text/",
    "application/json",
    "application/x-www-form-urlencoded",
    "application/xml",
    "application/graphql"
];
function $51dd6426dd88e961$var$getMaxBodyByteLength(maxRequestBodySize) {
    if (maxRequestBodySize === "small") return 1e3;
    if (maxRequestBodySize === "medium") return 1e4;
    return $51dd6426dd88e961$var$MAX_BODY_BYTE_LENGTH;
}
function $51dd6426dd88e961$var$winterCGHeadersToDict(winterCGHeaders) {
    const headers = {};
    try {
        winterCGHeaders.forEach((value, key)=>{
            if (typeof value === "string") headers[key] = value;
        });
    } catch (e) {}
    return headers;
}
function $51dd6426dd88e961$var$headersToDict(reqHeaders) {
    const headers = /* @__PURE__ */ Object.create(null);
    try {
        Object.entries(reqHeaders).forEach(([key, value])=>{
            if (typeof value === "string") headers[key] = value;
            else if (typeof value === "number") headers[key] = String(value);
        });
    } catch (e) {}
    return headers;
}
function $51dd6426dd88e961$var$winterCGRequestToRequestData(req) {
    const headers = $51dd6426dd88e961$var$winterCGHeadersToDict(req.headers);
    return {
        method: req.method,
        url: req.url,
        query_string: $51dd6426dd88e961$var$extractQueryParamsFromUrl(req.url),
        headers: headers
    };
}
function $51dd6426dd88e961$var$isTextualContentType(contentType) {
    if (!contentType) return false;
    const lowerContentType = contentType.toLowerCase();
    return $51dd6426dd88e961$var$TEXT_CONTENT_TYPES.some((type)=>lowerContentType.includes(type));
}
async function $51dd6426dd88e961$var$captureBodyFromWinterCGRequest(request, isolationScope, maxRequestBodySize) {
    try {
        const contentType = request.headers.get("content-type");
        if (!$51dd6426dd88e961$var$isTextualContentType(contentType)) {
            $859Bb.DEBUG_BUILD && $hQAU7.debug.log("Skipping body capture for non-textual content type:", contentType);
            return;
        }
        if (!request.body) return;
        const contentLength = request.headers.get("content-length");
        const maxBodySize = $51dd6426dd88e961$var$getMaxBodyByteLength(maxRequestBodySize);
        if (contentLength) {
            const length = parseInt(contentLength, 10);
            if (!isNaN(length) && length > $51dd6426dd88e961$var$MAX_BODY_BYTE_LENGTH) {
                $859Bb.DEBUG_BUILD && $hQAU7.debug.log("Skipping body capture: body too large", length);
                return;
            }
        }
        const clonedRequest = request.clone();
        const bodyPromise = clonedRequest.text();
        const timeoutPromise = new Promise((resolve)=>{
            $8z1zH.safeUnref(setTimeout(()=>resolve(null), 2e3));
        });
        const body = await Promise.race([
            bodyPromise,
            timeoutPromise
        ]);
        if (body === null) {
            $859Bb.DEBUG_BUILD && $hQAU7.debug.log("Timeout reading request body");
            return;
        }
        if (!body) return;
        const encoder = new TextEncoder();
        const bytes = encoder.encode(body);
        const bodyByteLength = bytes.length;
        let truncatedBody;
        if (bodyByteLength > maxBodySize) {
            const decoder = new TextDecoder();
            truncatedBody = `${decoder.decode(bytes.slice(0, maxBodySize - 3))}...`;
        } else truncatedBody = body;
        isolationScope.setSDKProcessingMetadata({
            normalizedRequest: {
                data: truncatedBody
            }
        });
        $859Bb.DEBUG_BUILD && $hQAU7.debug.log("Captured request body:", bodyByteLength, "bytes");
    } catch (error) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.error("Error capturing request body:", error);
    }
}
function $51dd6426dd88e961$var$httpRequestToRequestData(request) {
    var _request_socket;
    const headers = request.headers || {};
    const forwardedHost = typeof headers["x-forwarded-host"] === "string" ? headers["x-forwarded-host"] : void 0;
    const host = forwardedHost || (typeof headers.host === "string" ? headers.host : void 0);
    const forwardedProto = typeof headers["x-forwarded-proto"] === "string" ? headers["x-forwarded-proto"] : void 0;
    const protocol = forwardedProto || request.protocol || (((_request_socket = request.socket) === null || _request_socket === void 0 ? void 0 : _request_socket.encrypted) ? "https" : "http");
    const url = request.url || "";
    const absoluteUrl = $51dd6426dd88e961$var$getAbsoluteUrl({
        url: url,
        host: host,
        protocol: protocol
    });
    const data = request.body || void 0;
    const cookies = request.cookies;
    return {
        url: absoluteUrl,
        method: request.method,
        query_string: $51dd6426dd88e961$var$extractQueryParamsFromUrl(url),
        headers: $51dd6426dd88e961$var$headersToDict(headers),
        cookies: cookies,
        data: data
    };
}
function $51dd6426dd88e961$var$getAbsoluteUrl({ url: url, protocol: protocol, host: host }) {
    if (url === null || url === void 0 ? void 0 : url.startsWith("http")) return url;
    if (url && host) return `${protocol}://${host}${url}`;
    return void 0;
}
function $51dd6426dd88e961$var$httpHeadersToSpanAttributes(headers, dataCollection = false, lifecycle = "request") {
    const resolvedDataCollection = typeof dataCollection === "boolean" ? $7Nwyx.defaultPiiToCollectionOptions(dataCollection) : dataCollection;
    const headerBehavior = lifecycle === "request" ? resolvedDataCollection.httpHeaders.request : resolvedDataCollection.httpHeaders.response;
    const cookieBehavior = resolvedDataCollection.cookies;
    const prefix = `http.${lifecycle}.header.`;
    const spanAttributes = {};
    try {
        const regularHeaders = {};
        for (const [key, value] of Object.entries(headers)){
            if (value == null) continue;
            const lowerKey = key.toLowerCase();
            const isCookieHeader = lowerKey === "cookie" || lowerKey === "set-cookie";
            if (isCookieHeader) {
                if (cookieBehavior === false) continue;
                if (typeof value === "string" && value !== "") {
                    const parsed = $51dd6426dd88e961$var$parseCookieHeader(value, lowerKey === "set-cookie");
                    const filtered = $6vQat.filterKeyValueData(parsed, cookieBehavior, $ePIFU.SENSITIVE_COOKIE_NAME_SNIPPETS);
                    for (const [cookieKey, cookieValue] of Object.entries(filtered))spanAttributes[`${prefix}${$51dd6426dd88e961$var$normalizeAttributeKey(lowerKey)}.${$51dd6426dd88e961$var$normalizeAttributeKey(cookieKey)}`] = cookieValue;
                } else spanAttributes[`${prefix}${$51dd6426dd88e961$var$normalizeAttributeKey(lowerKey)}`] = $ePIFU.FILTERED_VALUE;
            } else {
                if (headerBehavior === false) continue;
                if (Array.isArray(value)) regularHeaders[lowerKey] = value.map((v)=>v != null ? String(v) : v).join(";");
                else if (typeof value === "string") regularHeaders[lowerKey] = value;
            }
        }
        if (headerBehavior !== false) {
            const filtered = $6vQat.filterKeyValueData(regularHeaders, headerBehavior);
            for (const [headerKey, headerValue] of Object.entries(filtered))spanAttributes[`${prefix}${$51dd6426dd88e961$var$normalizeAttributeKey(headerKey)}`] = headerValue;
        }
    } catch (e) {}
    return spanAttributes;
}
function $51dd6426dd88e961$var$normalizeAttributeKey(key) {
    return key.replace(/-/g, "_");
}
function $51dd6426dd88e961$var$parseCookieHeader(value, isSetCookie) {
    const semicolonIndex = value.indexOf(";");
    const cookieString = isSetCookie && semicolonIndex !== -1 ? value.substring(0, semicolonIndex) : value;
    const cookies = isSetCookie ? [
        cookieString
    ] : cookieString.split("; ");
    const result = {};
    for (const cookie of cookies){
        const equalSignIndex = cookie.indexOf("=");
        const cookieKey = (equalSignIndex !== -1 ? cookie.substring(0, equalSignIndex) : cookie).toLowerCase();
        const cookieValue = equalSignIndex !== -1 ? cookie.substring(equalSignIndex + 1) : "";
        result[cookieKey] = cookieValue;
    }
    return result;
}
function $51dd6426dd88e961$var$extractQueryParamsFromUrl(url) {
    if (!url) return;
    try {
        const queryParams = new URL(url, "http://s.io").search.slice(1);
        return queryParams.length ? queryParams : void 0;
    } catch (e) {
        return void 0;
    }
}
module.exports.MAX_BODY_BYTE_LENGTH = $51dd6426dd88e961$var$MAX_BODY_BYTE_LENGTH;
module.exports.captureBodyFromWinterCGRequest = $51dd6426dd88e961$var$captureBodyFromWinterCGRequest;
module.exports.extractQueryParamsFromUrl = $51dd6426dd88e961$var$extractQueryParamsFromUrl;
module.exports.getMaxBodyByteLength = $51dd6426dd88e961$var$getMaxBodyByteLength;
module.exports.headersToDict = $51dd6426dd88e961$var$headersToDict;
module.exports.httpHeadersToSpanAttributes = $51dd6426dd88e961$var$httpHeadersToSpanAttributes;
module.exports.httpRequestToRequestData = $51dd6426dd88e961$var$httpRequestToRequestData;
module.exports.winterCGHeadersToDict = $51dd6426dd88e961$var$winterCGHeadersToDict;
module.exports.winterCGRequestToRequestData = $51dd6426dd88e961$var$winterCGRequestToRequestData;

});

parcelRegister("5gAhR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $3d5a98418946e40d$var$SPAN_KIND = {
    INTERNAL: 0,
    SERVER: 1,
    CLIENT: 2,
    PRODUCER: 3,
    CONSUMER: 4
};
const $3d5a98418946e40d$var$SPAN_KIND_NAME = {
    [$3d5a98418946e40d$var$SPAN_KIND.INTERNAL]: "INTERNAL",
    [$3d5a98418946e40d$var$SPAN_KIND.SERVER]: "SERVER",
    [$3d5a98418946e40d$var$SPAN_KIND.CLIENT]: "CLIENT",
    [$3d5a98418946e40d$var$SPAN_KIND.PRODUCER]: "PRODUCER",
    [$3d5a98418946e40d$var$SPAN_KIND.CONSUMER]: "CONSUMER"
};
function $3d5a98418946e40d$var$spanKindToName(kind) {
    return $3d5a98418946e40d$var$SPAN_KIND_NAME[kind];
}
module.exports.SPAN_KIND = $3d5a98418946e40d$var$SPAN_KIND;
module.exports.spanKindToName = $3d5a98418946e40d$var$spanKindToName;

});

parcelRegister("haRHv", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hSRcd = parcelRequire("hSRcd");

var $hQAU7 = parcelRequire("hQAU7");

var $jHcnM = parcelRequire("jHcnM");
const $c80d06a9f3e678f9$var$DEFAULT_BREADCRUMBS = 100;
function $c80d06a9f3e678f9$var$addBreadcrumb(breadcrumb, hint) {
    const client = $hSRcd.getClient();
    const isolationScope = $hSRcd.getIsolationScope();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $c80d06a9f3e678f9$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = $jHcnM.dateTimestampInSeconds();
    const mergedBreadcrumb = (0, $9tqwB._)({
        timestamp: timestamp
    }, breadcrumb);
    const finalBreadcrumb = beforeBreadcrumb ? $hQAU7.consoleSandbox(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}
module.exports.addBreadcrumb = $c80d06a9f3e678f9$var$addBreadcrumb;

});

parcelRegister("bDV5D", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hSRcd = parcelRequire("hSRcd");

var $Qi0TL = parcelRequire("Qi0TL");

var $eEQXZ = parcelRequire("eEQXZ");
let $879f9f111eeea5ca$var$originalFunctionToString;
const $879f9f111eeea5ca$var$INTEGRATION_NAME = "FunctionToString";
const $879f9f111eeea5ca$var$SETUP_CLIENTS = /* @__PURE__ */ new WeakMap();
const $879f9f111eeea5ca$var$_functionToStringIntegration = ()=>{
    return {
        name: $879f9f111eeea5ca$var$INTEGRATION_NAME,
        setupOnce () {
            $879f9f111eeea5ca$var$originalFunctionToString = Function.prototype.toString;
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = $eEQXZ.getOriginalFunction(this);
                    const context = $879f9f111eeea5ca$var$SETUP_CLIENTS.has($hSRcd.getClient()) && originalFunction !== void 0 ? originalFunction : this;
                    return $879f9f111eeea5ca$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {}
        },
        setup (client) {
            $879f9f111eeea5ca$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
const $879f9f111eeea5ca$var$functionToStringIntegration = $Qi0TL.defineIntegration($879f9f111eeea5ca$var$_functionToStringIntegration);
module.exports.functionToStringIntegration = $879f9f111eeea5ca$var$functionToStringIntegration;

});

parcelRegister("7U2Yz", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $859Bb = parcelRequire("859Bb");

var $Qi0TL = parcelRequire("Qi0TL");

var $hQAU7 = parcelRequire("hQAU7");

var $03KcP = parcelRequire("03KcP");

var $hppxz = parcelRequire("hppxz");

var $8zsqf = parcelRequire("8zsqf");
const $5c1012569f0609c6$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    // The browser logs this when a ResizeObserver handler takes a bit longer. Usually this is not an actual issue though. It indicates slowness.
    /^Cannot redefine property: googletag$/,
    // This is thrown when google tag manager is used in combination with an ad blocker
    /^Can't find variable: gmo$/,
    // Error from Google Search App https://issuetracker.google.com/issues/396043331
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    // Random error that happens but not actionable or noticeable to end-users.
    /can't redefine non-configurable property "solana"/,
    // Probably a browser extension or custom browser (Brave) throwing this error
    /vv\(\)\.getRestrictions is not a function/,
    // Error thrown by GTM, seemingly not affecting end-users
    /Can't find variable: _AutofillCallbackHandler/,
    // Unactionable error in instagram webview https://developers.facebook.com/community/threads/320013549791141/
    /Object Not Found Matching Id:\d+, MethodName:simulateEvent/,
    // unactionable error from CEFSharp, a .NET library that embeds chromium in .NET apps
    /^Java exception was raised during method invocation$/
];
const $5c1012569f0609c6$var$INTEGRATION_NAME = "EventFilters";
const $5c1012569f0609c6$var$eventFiltersIntegration = $Qi0TL.defineIntegration((options = {})=>{
    let mergedOptions;
    return {
        name: $5c1012569f0609c6$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $5c1012569f0609c6$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $5c1012569f0609c6$var$_mergeOptions(options, clientOptions);
            }
            return $5c1012569f0609c6$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
const $5c1012569f0609c6$var$inboundFiltersIntegration = $Qi0TL.defineIntegration((options = {})=>{
    return (0, $2qxEV._)((0, $9tqwB._)({}, $5c1012569f0609c6$var$eventFiltersIntegration(options)), {
        name: "InboundFilters"
    });
});
function $5c1012569f0609c6$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $5c1012569f0609c6$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $5c1012569f0609c6$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        if ($5c1012569f0609c6$var$_isIgnoredError(event, options.ignoreErrors)) {
            $859Bb.DEBUG_BUILD && $hQAU7.debug.warn(`Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${$hppxz.getEventDescription(event)}`);
            return true;
        }
        if ($5c1012569f0609c6$var$_isUselessError(event)) {
            $859Bb.DEBUG_BUILD && $hQAU7.debug.warn(`Event dropped due to not having an error message, error type or stacktrace.
Event: ${$hppxz.getEventDescription(event)}`);
            return true;
        }
        if ($5c1012569f0609c6$var$_isDeniedUrl(event, options.denyUrls)) {
            $859Bb.DEBUG_BUILD && $hQAU7.debug.warn(`Event dropped due to being matched by \`denyUrls\` option.
Event: ${$hppxz.getEventDescription(event)}.
Url: ${$5c1012569f0609c6$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$5c1012569f0609c6$var$_isAllowedUrl(event, options.allowUrls)) {
            $859Bb.DEBUG_BUILD && $hQAU7.debug.warn(`Event dropped due to not being matched by \`allowUrls\` option.
Event: ${$hppxz.getEventDescription(event)}.
Url: ${$5c1012569f0609c6$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === "transaction") {
        if ($5c1012569f0609c6$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            $859Bb.DEBUG_BUILD && $hQAU7.debug.warn(`Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${$hppxz.getEventDescription(event)}`);
            return true;
        }
    }
    return false;
}
function $5c1012569f0609c6$var$_isIgnoredError(event, ignoreErrors) {
    if (!(ignoreErrors === null || ignoreErrors === void 0 ? void 0 : ignoreErrors.length)) return false;
    return $03KcP.getPossibleEventMessages(event).some((message)=>$8zsqf.stringMatchesSomePattern(message, ignoreErrors));
}
function $5c1012569f0609c6$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!(ignoreTransactions === null || ignoreTransactions === void 0 ? void 0 : ignoreTransactions.length)) return false;
    const name = event.transaction;
    return name ? $8zsqf.stringMatchesSomePattern(name, ignoreTransactions) : false;
}
function $5c1012569f0609c6$var$_isDeniedUrl(event, denyUrls) {
    if (!(denyUrls === null || denyUrls === void 0 ? void 0 : denyUrls.length)) return false;
    const url = $5c1012569f0609c6$var$_getEventFilterUrl(event);
    return !url ? false : $8zsqf.stringMatchesSomePattern(url, denyUrls);
}
function $5c1012569f0609c6$var$_isAllowedUrl(event, allowUrls) {
    if (!(allowUrls === null || allowUrls === void 0 ? void 0 : allowUrls.length)) return true;
    const url = $5c1012569f0609c6$var$_getEventFilterUrl(event);
    return !url ? true : $8zsqf.stringMatchesSomePattern(url, allowUrls);
}
function $5c1012569f0609c6$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $5c1012569f0609c6$var$_getEventFilterUrl(event) {
    try {
        var _event_exception, _rootException_stacktrace;
        var _event_exception_values;
        const rootException = [
            ...(_event_exception_values = (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : _event_exception.values) !== null && _event_exception_values !== void 0 ? _event_exception_values : []
        ].reverse().find((value)=>{
            var _value_mechanism, _value_stacktrace_frames, _value_stacktrace;
            return ((_value_mechanism = value.mechanism) === null || _value_mechanism === void 0 ? void 0 : _value_mechanism.parent_id) === void 0 && ((_value_stacktrace = value.stacktrace) === null || _value_stacktrace === void 0 ? void 0 : (_value_stacktrace_frames = _value_stacktrace.frames) === null || _value_stacktrace_frames === void 0 ? void 0 : _value_stacktrace_frames.length);
        });
        const frames = rootException === null || rootException === void 0 ? void 0 : (_rootException_stacktrace = rootException.stacktrace) === null || _rootException_stacktrace === void 0 ? void 0 : _rootException_stacktrace.frames;
        return frames ? $5c1012569f0609c6$var$_getLastValidUrl(frames) : null;
    } catch (e) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.error(`Cannot extract url for event ${$hppxz.getEventDescription(event)}`);
        return null;
    }
}
function $5c1012569f0609c6$var$_isUselessError(event) {
    var _event_exception_values, _event_exception;
    if (!((_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.length)) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== "Error" || value.value));
}
module.exports.eventFiltersIntegration = $5c1012569f0609c6$var$eventFiltersIntegration;
module.exports.inboundFiltersIntegration = $5c1012569f0609c6$var$inboundFiltersIntegration;

});

parcelRegister("jcghP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $Qi0TL = parcelRequire("Qi0TL");

var $f2fMw = parcelRequire("f2fMw");

var $8chst = parcelRequire("8chst");
const $df9bc57571c1fb74$var$DEFAULT_KEY = "cause";
const $df9bc57571c1fb74$var$DEFAULT_LIMIT = 5;
const $df9bc57571c1fb74$var$INTEGRATION_NAME = "LinkedErrors";
const $df9bc57571c1fb74$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $df9bc57571c1fb74$var$DEFAULT_LIMIT;
    const key = options.key || $df9bc57571c1fb74$var$DEFAULT_KEY;
    return {
        name: $df9bc57571c1fb74$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options2 = client.getOptions();
            $f2fMw.applyAggregateErrorsToEvent($8chst.exceptionFromError, options2.stackParser, key, limit, event, hint);
        }
    };
};
const $df9bc57571c1fb74$var$linkedErrorsIntegration = $Qi0TL.defineIntegration($df9bc57571c1fb74$var$_linkedErrorsIntegration);
module.exports.linkedErrorsIntegration = $df9bc57571c1fb74$var$linkedErrorsIntegration;

});
parcelRegister("f2fMw", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ibzbk = parcelRequire("ibzbk");
function $af2348d53660776d$var$applyAggregateErrorsToEvent(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    var _event_exception;
    if (!((_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : _event_exception.values) || !hint || !$ibzbk.isInstanceOf(hint.originalException, Error)) return;
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : void 0;
    if (originalException) event.exception.values = $af2348d53660776d$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $af2348d53660776d$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    if ($ibzbk.isInstanceOf(error[key], Error)) {
        $af2348d53660776d$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $af2348d53660776d$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $af2348d53660776d$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    if ($af2348d53660776d$var$isExceptionGroup(error)) error.errors.forEach((childError, i)=>{
        if ($ibzbk.isInstanceOf(childError, Error)) {
            $af2348d53660776d$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $af2348d53660776d$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $af2348d53660776d$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $af2348d53660776d$var$isExceptionGroup(error) {
    return Array.isArray(error.errors);
}
function $af2348d53660776d$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error) {
    exception.mechanism = (0, $2qxEV._)((0, $9tqwB._)({
        handled: true,
        type: "auto.core.linked_errors"
    }, $af2348d53660776d$var$isExceptionGroup(error) && {
        is_exception_group: true
    }, exception.mechanism), {
        exception_id: exceptionId
    });
}
function $af2348d53660776d$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    exception.mechanism = (0, $2qxEV._)((0, $9tqwB._)({
        handled: true
    }, exception.mechanism), {
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    });
}
module.exports.applyAggregateErrorsToEvent = $af2348d53660776d$var$applyAggregateErrorsToEvent;

});

parcelRegister("8chst", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ibzbk = parcelRequire("ibzbk");

var $hppxz = parcelRequire("hppxz");

var $irz1w = parcelRequire("irz1w");

var $eEQXZ = parcelRequire("eEQXZ");
function $5f7cfc8d4b313e3b$var$parseStackFrames(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
function $5f7cfc8d4b313e3b$var$hasSentryFetchUrlHost(error) {
    return $ibzbk.isError(error) && "__sentry_fetch_url_host__" in error && typeof error.__sentry_fetch_url_host__ === "string";
}
function $5f7cfc8d4b313e3b$var$_enhanceErrorWithSentryInfo(error) {
    if ($5f7cfc8d4b313e3b$var$hasSentryFetchUrlHost(error)) return `${error.message} (${error.__sentry_fetch_url_host__})`;
    return error.message;
}
function $5f7cfc8d4b313e3b$var$exceptionFromError(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: $5f7cfc8d4b313e3b$var$_enhanceErrorWithSentryInfo(error)
    };
    const frames = $5f7cfc8d4b313e3b$var$parseStackFrames(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $5f7cfc8d4b313e3b$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return void 0;
}
function $5f7cfc8d4b313e3b$var$getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        let message = `'${exception.name}' captured as exception`;
        if ("message" in exception && typeof exception.message === "string") message += ` with message '${exception.message}'`;
        return message;
    } else if ("message" in exception && typeof exception.message === "string") return exception.message;
    const keys = $eEQXZ.extractExceptionKeysForMessage(exception);
    if ($ibzbk.isErrorEvent(exception)) return `Event \`ErrorEvent\` captured as exception with message \`${exception.message}\``;
    const className = $5f7cfc8d4b313e3b$var$getObjectClassName(exception);
    return `${className && className !== "Object" ? `'${className}'` : "Object"} captured as exception with keys: ${keys}`;
}
function $5f7cfc8d4b313e3b$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch (e) {}
}
function $5f7cfc8d4b313e3b$var$getException(client, mechanism, exception, hint) {
    if ($ibzbk.isError(exception)) return [
        exception,
        void 0
    ];
    mechanism.synthetic = true;
    if ($ibzbk.isPlainObject(exception)) {
        const normalizeDepth = client === null || client === void 0 ? void 0 : client.getOptions().normalizeDepth;
        const extras = {
            ["__serialized__"]: $irz1w.normalizeToSize(exception, normalizeDepth)
        };
        const errorFromProp = $5f7cfc8d4b313e3b$var$getErrorPropertyFromObject(exception);
        if (errorFromProp) return [
            errorFromProp,
            extras
        ];
        const message = $5f7cfc8d4b313e3b$var$getMessageForObject(exception);
        const ex2 = (hint === null || hint === void 0 ? void 0 : hint.syntheticException) || new Error(message);
        ex2.message = message;
        return [
            ex2,
            extras
        ];
    }
    const ex = (hint === null || hint === void 0 ? void 0 : hint.syntheticException) || new Error(exception);
    ex.message = `${exception}`;
    return [
        ex,
        void 0
    ];
}
function $5f7cfc8d4b313e3b$var$eventFromUnknownInput(client, stackParser, exception, hint) {
    const providedMechanism = (hint === null || hint === void 0 ? void 0 : hint.data) && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    const [ex, extras] = $5f7cfc8d4b313e3b$var$getException(client, mechanism, exception, hint);
    const event = {
        exception: {
            values: [
                $5f7cfc8d4b313e3b$var$exceptionFromError(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    $hppxz.addExceptionTypeValue(event, void 0, void 0);
    $hppxz.addExceptionMechanism(event, mechanism);
    return (0, $2qxEV._)((0, $9tqwB._)({}, event), {
        event_id: hint === null || hint === void 0 ? void 0 : hint.event_id
    });
}
function $5f7cfc8d4b313e3b$var$eventFromMessage(stackParser, message, level = "info", hint, attachStacktrace) {
    const event = {
        event_id: hint === null || hint === void 0 ? void 0 : hint.event_id,
        level: level
    };
    if (attachStacktrace && (hint === null || hint === void 0 ? void 0 : hint.syntheticException)) {
        const frames = $5f7cfc8d4b313e3b$var$parseStackFrames(stackParser, hint.syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames: frames
                        }
                    }
                ]
            };
            $hppxz.addExceptionMechanism(event, {
                synthetic: true
            });
        }
    }
    if ($ibzbk.isParameterizedString(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
module.exports._enhanceErrorWithSentryInfo = $5f7cfc8d4b313e3b$var$_enhanceErrorWithSentryInfo;
module.exports.eventFromMessage = $5f7cfc8d4b313e3b$var$eventFromMessage;
module.exports.eventFromUnknownInput = $5f7cfc8d4b313e3b$var$eventFromUnknownInput;
module.exports.exceptionFromError = $5f7cfc8d4b313e3b$var$exceptionFromError;
module.exports.parseStackFrames = $5f7cfc8d4b313e3b$var$parseStackFrames;

});


parcelRegister("e5rTZ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $Qi0TL = parcelRequire("Qi0TL");

var $9cnvM = parcelRequire("9cnvM");

var $bIVq4 = parcelRequire("bIVq4");
const $a4172d1b69115d7f$var$moduleMetadataIntegration = $Qi0TL.defineIntegration(()=>{
    return {
        name: "ModuleMetadata",
        setup (client) {
            client.on("beforeEnvelope", (envelope$1)=>{
                $bIVq4.forEachEnvelopeItem(envelope$1, (item, type)=>{
                    if (type === "event") {
                        const event = Array.isArray(item) ? item[1] : void 0;
                        if (event) {
                            $9cnvM.stripMetadataFromStackFrames(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on("applyFrameMetadata", (event)=>{
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                $9cnvM.addMetadataToStackFrames(stackParser, event);
            });
        }
    };
});
module.exports.moduleMetadataIntegration = $a4172d1b69115d7f$var$moduleMetadataIntegration;

});
parcelRegister("9cnvM", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $15YuE = parcelRequire("15YuE");
const $6b2778f6e9ce5acf$var$filenameMetadataMap = /* @__PURE__ */ new Map();
const $6b2778f6e9ce5acf$var$parsedStacks = /* @__PURE__ */ new Set();
function $6b2778f6e9ce5acf$var$getFilenameToMetadataMap(parser) {
    if (!$15YuE.GLOBAL_OBJ._sentryModuleMetadata) return {};
    const filenameMap = {};
    for (const stack of Object.keys($15YuE.GLOBAL_OBJ._sentryModuleMetadata)){
        const metadata = $15YuE.GLOBAL_OBJ._sentryModuleMetadata[stack];
        const frames = parser(stack);
        for (const frame of frames.reverse())if (frame.filename) {
            filenameMap[frame.filename] = metadata;
            break;
        }
    }
    return filenameMap;
}
function $6b2778f6e9ce5acf$var$ensureMetadataStacksAreParsed(parser) {
    if (!$15YuE.GLOBAL_OBJ._sentryModuleMetadata) return;
    for (const stack of Object.keys($15YuE.GLOBAL_OBJ._sentryModuleMetadata)){
        const metadata = $15YuE.GLOBAL_OBJ._sentryModuleMetadata[stack];
        if ($6b2778f6e9ce5acf$var$parsedStacks.has(stack)) continue;
        $6b2778f6e9ce5acf$var$parsedStacks.add(stack);
        const frames = parser(stack);
        for (const frame of frames.reverse())if (frame.filename) {
            $6b2778f6e9ce5acf$var$filenameMetadataMap.set(frame.filename, metadata);
            break;
        }
    }
}
function $6b2778f6e9ce5acf$var$getMetadataForUrl(parser, filename) {
    $6b2778f6e9ce5acf$var$ensureMetadataStacksAreParsed(parser);
    return $6b2778f6e9ce5acf$var$filenameMetadataMap.get(filename);
}
function $6b2778f6e9ce5acf$var$addMetadataToStackFrames(parser, event) {
    var _event_exception_values, _event_exception;
    (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.forEach((exception)=>{
        var _exception_stacktrace_frames, _exception_stacktrace;
        (_exception_stacktrace = exception.stacktrace) === null || _exception_stacktrace === void 0 ? void 0 : (_exception_stacktrace_frames = _exception_stacktrace.frames) === null || _exception_stacktrace_frames === void 0 ? void 0 : _exception_stacktrace_frames.forEach((frame)=>{
            if (!frame.filename || frame.module_metadata) return;
            const metadata = $6b2778f6e9ce5acf$var$getMetadataForUrl(parser, frame.filename);
            if (metadata) frame.module_metadata = metadata;
        });
    });
}
function $6b2778f6e9ce5acf$var$stripMetadataFromStackFrames(event) {
    var _event_exception_values, _event_exception;
    (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.forEach((exception)=>{
        var _exception_stacktrace_frames, _exception_stacktrace;
        (_exception_stacktrace = exception.stacktrace) === null || _exception_stacktrace === void 0 ? void 0 : (_exception_stacktrace_frames = _exception_stacktrace.frames) === null || _exception_stacktrace_frames === void 0 ? void 0 : _exception_stacktrace_frames.forEach((frame)=>{
            delete frame.module_metadata;
        });
    });
}
module.exports.addMetadataToStackFrames = $6b2778f6e9ce5acf$var$addMetadataToStackFrames;
module.exports.getFilenameToMetadataMap = $6b2778f6e9ce5acf$var$getFilenameToMetadataMap;
module.exports.getMetadataForUrl = $6b2778f6e9ce5acf$var$getMetadataForUrl;
module.exports.stripMetadataFromStackFrames = $6b2778f6e9ce5acf$var$stripMetadataFromStackFrames;

});


parcelRegister("i2SaP", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hSRcd = parcelRequire("hSRcd");

var $Qi0TL = parcelRequire("Qi0TL");

var $faX3S = parcelRequire("faX3S");

var $96czR = parcelRequire("96czR");

var $71LoA = parcelRequire("71LoA");

var $j6wTC = parcelRequire("j6wTC");

var $elQdO = parcelRequire("elQdO");
const $d2326facac3766d6$var$INTEGRATION_NAME = "RequestData";
const $d2326facac3766d6$var$_requestDataIntegration = (options = {})=>{
    function resolveIncludeAndDataCollection(client) {
        var _options_include, _options_include1;
        const dc = client.getDataCollectionOptions();
        const dataCollection = (0, $9tqwB._)({}, dc, ((_options_include = options.include) === null || _options_include === void 0 ? void 0 : _options_include.cookies) === true && dc.cookies === false && {
            cookies: true
        }, ((_options_include1 = options.include) === null || _options_include1 === void 0 ? void 0 : _options_include1.headers) === true && dc.httpHeaders.request === false && {
            httpHeaders: (0, $2qxEV._)((0, $9tqwB._)({}, dc.httpHeaders), {
                request: true
            })
        });
        return {
            dataCollection: dataCollection,
            include: (0, $9tqwB._)({
                cookies: dataCollection.cookies !== false,
                // Always attach body data that's already on the scope — dataCollection.httpBodies gates write-time, not read-time
                data: true,
                headers: dataCollection.httpHeaders.request !== false,
                ip: dataCollection.userInfo,
                query_string: dataCollection.queryParams !== false,
                // No dataCollection equivalent — URL is always included
                url: true
            }, options.include)
        };
    }
    return {
        name: $d2326facac3766d6$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const { sdkProcessingMetadata: sdkProcessingMetadata = {} } = event;
            const { normalizedRequest: normalizedRequest, ipAddress: ipAddress } = sdkProcessingMetadata;
            const { include: include } = resolveIncludeAndDataCollection(client);
            if (normalizedRequest) $d2326facac3766d6$var$addNormalizedRequestDataToEvent(event, normalizedRequest, {
                ipAddress: ipAddress
            }, include);
            return event;
        },
        processSegmentSpan (span, client) {
            const { sdkProcessingMetadata: sdkProcessingMetadata = {} } = $hSRcd.getIsolationScope().getScopeData();
            const { normalizedRequest: normalizedRequest, ipAddress: ipAddress } = sdkProcessingMetadata;
            if (!normalizedRequest) return;
            const { include: include, dataCollection: dataCollection } = resolveIncludeAndDataCollection(client);
            $d2326facac3766d6$var$addNormalizedRequestDataToSpan(span, normalizedRequest, ipAddress, include, dataCollection);
        }
    };
};
const $d2326facac3766d6$var$requestDataIntegration = $Qi0TL.defineIntegration($d2326facac3766d6$var$_requestDataIntegration);
function $d2326facac3766d6$var$addNormalizedRequestDataToEvent(event, req, additionalData, include) {
    event.request = (0, $9tqwB._)({}, event.request, $d2326facac3766d6$var$extractNormalizedRequestData(req, include));
    if (include.ip) {
        const ip = req.headers && $j6wTC.getClientIPAddress(req.headers) || additionalData.ipAddress;
        if (ip) event.user = (0, $2qxEV._)((0, $9tqwB._)({}, event.user), {
            ip_address: ip
        });
    }
}
function $d2326facac3766d6$var$addNormalizedRequestDataToSpan(span, normalizedRequest, ipAddress, include, dataCollection) {
    const requestData = $d2326facac3766d6$var$extractNormalizedRequestData(normalizedRequest, include);
    const attributes = {};
    if (requestData.url) attributes["url.full"] = requestData.url;
    if (requestData.method) attributes["http.request.method"] = requestData.method;
    if (requestData.query_string) attributes["url.query"] = $d2326facac3766d6$var$normalizeQueryString(requestData.query_string);
    $elQdO.safeSetSpanJSONAttributes(span, attributes);
    if (requestData.cookies && Object.keys(requestData.cookies).length > 0) {
        const cookieString = Object.entries(requestData.cookies).map(([name, value])=>`${name}=${value}`).join("; ");
        const cookieAttributes = $71LoA.httpHeadersToSpanAttributes({
            cookie: cookieString
        }, dataCollection, "request");
        $elQdO.safeSetSpanJSONAttributes(span, cookieAttributes);
    }
    if (requestData.headers) {
        const headerAttributes = $71LoA.httpHeadersToSpanAttributes(requestData.headers, dataCollection, "request");
        $elQdO.safeSetSpanJSONAttributes(span, headerAttributes);
    }
    if (requestData.data != null) {
        const serialized = typeof requestData.data === "string" ? requestData.data : JSON.stringify(requestData.data);
        if (serialized) $elQdO.safeSetSpanJSONAttributes(span, {
            "http.request.body.data": serialized
        });
    }
    if (include.ip) {
        const ip = normalizedRequest.headers && $j6wTC.getClientIPAddress(normalizedRequest.headers) || ipAddress || void 0;
        if (ip) $elQdO.safeSetSpanJSONAttributes(span, {
            [$faX3S.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS]: ip
        });
    }
}
function $d2326facac3766d6$var$extractNormalizedRequestData(normalizedRequest, include) {
    const requestData = {};
    const headers = (0, $9tqwB._)({}, normalizedRequest.headers);
    if (include.headers) {
        requestData.headers = headers;
        if (!include.cookies) delete headers.cookie;
        if (!include.ip) {
            const ipHeaderNamesLower = new Set($j6wTC.ipHeaderNames.map((name)=>name.toLowerCase()));
            for (const key of Object.keys(headers))if (ipHeaderNamesLower.has(key.toLowerCase())) delete headers[key];
        }
    }
    requestData.method = normalizedRequest.method;
    if (include.url) requestData.url = normalizedRequest.url;
    if (include.cookies) {
        const cookies = normalizedRequest.cookies || ((headers === null || headers === void 0 ? void 0 : headers.cookie) ? $96czR.parseCookie(headers.cookie) : void 0);
        requestData.cookies = cookies || {};
    }
    if (include.query_string) requestData.query_string = normalizedRequest.query_string;
    if (include.data) requestData.data = normalizedRequest.data;
    return requestData;
}
function $d2326facac3766d6$var$normalizeQueryString(queryString) {
    if (typeof queryString === "string") return queryString || void 0;
    const pairs = Array.isArray(queryString) ? queryString : Object.entries(queryString);
    const result = pairs.map(([key, value])=>`${key}=${value}`).join("&");
    return result || void 0;
}
module.exports.requestDataIntegration = $d2326facac3766d6$var$requestDataIntegration;

});
parcelRegister("j6wTC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $de8818546d73122a$var$ipHeaderNames = [
    "X-Client-IP",
    "X-Forwarded-For",
    "Fly-Client-IP",
    "CF-Connecting-IP",
    "Fastly-Client-Ip",
    "True-Client-Ip",
    "X-Real-IP",
    "X-Cluster-Client-IP",
    "X-Forwarded",
    "Forwarded-For",
    "Forwarded",
    "X-Vercel-Forwarded-For"
];
function $de8818546d73122a$var$getClientIPAddress(headers) {
    const lowerCaseHeaders = {};
    for (const key of Object.keys(headers))lowerCaseHeaders[key.toLowerCase()] = headers[key];
    const headerValues = $de8818546d73122a$var$ipHeaderNames.map((headerName)=>{
        const rawValue = lowerCaseHeaders[headerName.toLowerCase()];
        const value = Array.isArray(rawValue) ? rawValue.join(";") : rawValue;
        if (headerName === "Forwarded") return $de8818546d73122a$var$parseForwardedHeader(value);
        return value === null || value === void 0 ? void 0 : value.split(",").map((v)=>v.trim());
    });
    const flattenedHeaderValues = headerValues.reduce((acc, val)=>{
        if (!val) return acc;
        return acc.concat(val);
    }, []);
    const ipAddress = flattenedHeaderValues.find((ip)=>ip !== null && $de8818546d73122a$var$isIP(ip));
    return ipAddress || null;
}
function $de8818546d73122a$var$parseForwardedHeader(value) {
    if (!value) return null;
    for (const part of value.split(";")){
        if (part.startsWith("for=")) return part.slice(4);
    }
    return null;
}
function $de8818546d73122a$var$isIP(str) {
    const regex = /(?:^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$)|(?:^(?:(?:[a-fA-F\d]{1,4}:){7}(?:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,2}|:)|(?:[a-fA-F\d]{1,4}:){4}(?:(?::[a-fA-F\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,3}|:)|(?:[a-fA-F\d]{1,4}:){3}(?:(?::[a-fA-F\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,4}|:)|(?:[a-fA-F\d]{1,4}:){2}(?:(?::[a-fA-F\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,5}|:)|(?:[a-fA-F\d]{1,4}:){1}(?:(?::[a-fA-F\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,6}|:)|(?::(?:(?::[a-fA-F\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,7}|:)))(?:%[0-9a-zA-Z]{1,})?$)/;
    return regex.test(str);
}
module.exports.getClientIPAddress = $de8818546d73122a$var$getClientIPAddress;
module.exports.ipHeaderNames = $de8818546d73122a$var$ipHeaderNames;

});


parcelRegister("hhd4m", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hSRcd = parcelRequire("hSRcd");

var $gHOmH = parcelRequire("gHOmH");

var $dGNME = parcelRequire("dGNME");

var $Qi0TL = parcelRequire("Qi0TL");

var $hQAU7 = parcelRequire("hQAU7");

var $hppxz = parcelRequire("hppxz");

var $fmjoe = parcelRequire("fmjoe");

var $8zsqf = parcelRequire("8zsqf");

var $15YuE = parcelRequire("15YuE");
const $c93e297c36d7ce4f$var$INTEGRATION_NAME = "CaptureConsole";
const $c93e297c36d7ce4f$var$_captureConsoleIntegration = (options = {})=>{
    const levels = options.levels || $hQAU7.CONSOLE_LEVELS;
    var _options_handled;
    const handled = (_options_handled = options.handled) !== null && _options_handled !== void 0 ? _options_handled : true;
    return {
        name: $c93e297c36d7ce4f$var$INTEGRATION_NAME,
        setup (client) {
            if (!("console" in $15YuE.GLOBAL_OBJ)) return;
            $dGNME.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($hSRcd.getClient() !== client || !levels.includes(level)) return;
                $c93e297c36d7ce4f$var$consoleHandler(args, level, handled);
            });
        }
    };
};
const $c93e297c36d7ce4f$var$captureConsoleIntegration = $Qi0TL.defineIntegration($c93e297c36d7ce4f$var$_captureConsoleIntegration);
function $c93e297c36d7ce4f$var$consoleHandler(args, level, handled) {
    const severityLevel = $fmjoe.severityLevelFromString(level);
    const syntheticException = new Error();
    const captureContext = {
        level: $fmjoe.severityLevelFromString(level),
        extra: {
            arguments: args
        }
    };
    $hSRcd.withScope((scope)=>{
        scope.addEventProcessor((event)=>{
            event.logger = "console";
            $hppxz.addExceptionMechanism(event, {
                handled: handled,
                type: "auto.core.capture_console"
            });
            return event;
        });
        if (level === "assert") {
            if (!args[0]) {
                const message2 = `Assertion failed: ${$8zsqf.safeJoin(args.slice(1), " ") || "console.assert"}`;
                scope.setExtra("arguments", args.slice(1));
                scope.captureMessage(message2, severityLevel, {
                    captureContext: captureContext,
                    syntheticException: syntheticException
                });
            }
            return;
        }
        const error = args.find((arg)=>arg instanceof Error);
        if (error) {
            $gHOmH.captureException(error, captureContext);
            return;
        }
        const message = $8zsqf.safeJoin(args, " ");
        scope.captureMessage(message, severityLevel, {
            captureContext: captureContext,
            syntheticException: syntheticException
        });
    });
}
module.exports.captureConsoleIntegration = $c93e297c36d7ce4f$var$captureConsoleIntegration;

});
parcelRegister("dGNME", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $859Bb = parcelRequire("859Bb");

var $hQAU7 = parcelRequire("hQAU7");

var $eEQXZ = parcelRequire("eEQXZ");

var $8zsqf = parcelRequire("8zsqf");

var $15YuE = parcelRequire("15YuE");

var $jSWkL = parcelRequire("jSWkL");
const $9f75d09e32d73663$var$_filter = /* @__PURE__ */ new Set([]);
function $9f75d09e32d73663$var$addConsoleInstrumentationHandler(handler) {
    const type = "console";
    const removeHandler = $jSWkL.addHandler(type, handler);
    $jSWkL.maybeInstrument(type, $9f75d09e32d73663$var$instrumentConsole);
    return removeHandler;
}
function $9f75d09e32d73663$var$addConsoleInstrumentationFilter(filter) {
    for (const f of filter)$9f75d09e32d73663$var$_filter.add(f);
    return ()=>{
        for (const f of filter)$9f75d09e32d73663$var$_filter.delete(f);
    };
}
function $9f75d09e32d73663$var$instrumentConsole() {
    if (!("console" in $15YuE.GLOBAL_OBJ)) return;
    $hQAU7.CONSOLE_LEVELS.forEach(function(level) {
        if (!(level in $15YuE.GLOBAL_OBJ.console)) return;
        $eEQXZ.fill($15YuE.GLOBAL_OBJ.console, level, function(originalConsoleMethod) {
            $hQAU7.originalConsoleMethods[level] = originalConsoleMethod;
            return function(...args) {
                const firstArg = args[0];
                const log = $hQAU7.originalConsoleMethods[level];
                const isFiltered = $9f75d09e32d73663$var$_filter.size && typeof firstArg === "string" && $8zsqf.stringMatchesSomePattern(firstArg, $9f75d09e32d73663$var$_filter);
                if (!isFiltered) $jSWkL.triggerHandlers("console", {
                    args: args,
                    level: level
                });
                if (!isFiltered || $859Bb.DEBUG_BUILD && $hQAU7.debug.isEnabled()) log === null || log === void 0 ? void 0 : log.apply($15YuE.GLOBAL_OBJ.console, args);
            };
        });
    });
}
module.exports.addConsoleInstrumentationFilter = $9f75d09e32d73663$var$addConsoleInstrumentationFilter;
module.exports.addConsoleInstrumentationHandler = $9f75d09e32d73663$var$addConsoleInstrumentationHandler;

});

parcelRegister("fmjoe", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $b2e7f3801fe9ecbf$var$severityLevelFromString(level) {
    return level === "warn" ? "warning" : [
        "fatal",
        "error",
        "warning",
        "log",
        "info",
        "debug"
    ].includes(level) ? level : "log";
}
module.exports.severityLevelFromString = $b2e7f3801fe9ecbf$var$severityLevelFromString;

});


parcelRegister("9itui", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $859Bb = parcelRequire("859Bb");

var $Qi0TL = parcelRequire("Qi0TL");

var $hQAU7 = parcelRequire("hQAU7");

var $ah1An = parcelRequire("ah1An");
const $6c4cab20de337d32$var$INTEGRATION_NAME = "Dedupe";
const $6c4cab20de337d32$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $6c4cab20de337d32$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            if (currentEvent.type) return currentEvent;
            try {
                if ($6c4cab20de337d32$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    $859Bb.DEBUG_BUILD && $hQAU7.debug.warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (e) {}
            return previousEvent = currentEvent;
        }
    };
};
const $6c4cab20de337d32$var$dedupeIntegration = $Qi0TL.defineIntegration($6c4cab20de337d32$var$_dedupeIntegration);
function $6c4cab20de337d32$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($6c4cab20de337d32$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($6c4cab20de337d32$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $6c4cab20de337d32$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    if (!currentMessage && !previousMessage) return false;
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$6c4cab20de337d32$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$6c4cab20de337d32$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $6c4cab20de337d32$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $6c4cab20de337d32$var$_getExceptionFromEvent(previousEvent);
    const currentException = $6c4cab20de337d32$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$6c4cab20de337d32$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$6c4cab20de337d32$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $6c4cab20de337d32$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $ah1An.getFramesFromEvent(currentEvent);
    let previousFrames = $ah1An.getFramesFromEvent(previousEvent);
    if (!currentFrames && !previousFrames) return true;
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    if (previousFrames.length !== currentFrames.length) return false;
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $6c4cab20de337d32$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    if (!currentFingerprint && !previousFingerprint) return true;
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (e) {
        return false;
    }
}
function $6c4cab20de337d32$var$_getExceptionFromEvent(event) {
    var _event_exception_values, _event_exception;
    return (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values[0];
}
module.exports._shouldDropEvent = $6c4cab20de337d32$var$_shouldDropEvent;
module.exports.dedupeIntegration = $6c4cab20de337d32$var$dedupeIntegration;

});

parcelRegister("7CctZ", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $859Bb = parcelRequire("859Bb");

var $Qi0TL = parcelRequire("Qi0TL");

var $hQAU7 = parcelRequire("hQAU7");

var $ibzbk = parcelRequire("ibzbk");

var $irz1w = parcelRequire("irz1w");

var $a1iNu = parcelRequire("a1iNu");

var $8zsqf = parcelRequire("8zsqf");
const $58b5c3cb84e2fe04$var$INTEGRATION_NAME = "ExtraErrorData";
const $58b5c3cb84e2fe04$var$_extraErrorDataIntegration = (options = {})=>{
    const { depth: depth = 3, captureErrorCause: captureErrorCause = true } = options;
    return {
        name: $58b5c3cb84e2fe04$var$INTEGRATION_NAME,
        processEvent (event, hint, client) {
            const { maxValueLength: maxValueLength } = client.getOptions();
            return $58b5c3cb84e2fe04$var$_enhanceEventWithErrorData(event, hint, depth, captureErrorCause, maxValueLength);
        }
    };
};
const $58b5c3cb84e2fe04$var$extraErrorDataIntegration = $Qi0TL.defineIntegration($58b5c3cb84e2fe04$var$_extraErrorDataIntegration);
function $58b5c3cb84e2fe04$var$_enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause, maxValueLength) {
    if (!hint.originalException || !$ibzbk.isError(hint.originalException)) return event;
    const exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    const errorData = $58b5c3cb84e2fe04$var$_extractErrorData(hint.originalException, captureErrorCause, maxValueLength);
    if (errorData) {
        const contexts = (0, $9tqwB._)({}, event.contexts);
        const normalizedErrorData = $irz1w.normalize(errorData, depth);
        if ($ibzbk.isPlainObject(normalizedErrorData)) {
            $a1iNu.setSkipNormalizationHint(normalizedErrorData);
            contexts[exceptionName] = normalizedErrorData;
        }
        return (0, $2qxEV._)((0, $9tqwB._)({}, event), {
            contexts: contexts
        });
    }
    return event;
}
function $58b5c3cb84e2fe04$var$_extractErrorData(error, captureErrorCause, maxValueLength) {
    try {
        const nativeKeys = [
            "name",
            "message",
            "stack",
            "line",
            "column",
            "fileName",
            "lineNumber",
            "columnNumber",
            "toJSON"
        ];
        const extraErrorInfo = {};
        for (const key of Object.keys(error)){
            if (nativeKeys.indexOf(key) !== -1) continue;
            const value = error[key];
            extraErrorInfo[key] = $ibzbk.isError(value) || typeof value === "string" ? maxValueLength ? $8zsqf.truncate(`${value}`, maxValueLength) : `${value}` : value;
        }
        if (captureErrorCause && error.cause !== void 0) {
            if ($ibzbk.isError(error.cause)) {
                const errorName = error.cause.name || error.cause.constructor.name;
                extraErrorInfo.cause = {
                    [errorName]: $58b5c3cb84e2fe04$var$_extractErrorData(error.cause, false, maxValueLength)
                };
            } else extraErrorInfo.cause = error.cause;
        }
        if (typeof error.toJSON === "function") {
            const serializedError = error.toJSON();
            for (const key of Object.keys(serializedError)){
                const value = serializedError[key];
                extraErrorInfo[key] = $ibzbk.isError(value) ? value.toString() : value;
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.error("Unable to extract extra data from the Error object:", oO);
    }
    return null;
}
module.exports.extraErrorDataIntegration = $58b5c3cb84e2fe04$var$extraErrorDataIntegration;

});

parcelRegister("6Jc2P", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $Qi0TL = parcelRequire("Qi0TL");

var $fnuZv = parcelRequire("fnuZv");

var $15YuE = parcelRequire("15YuE");
const $4e6049e0c598e760$var$INTEGRATION_NAME = "RewriteFrames";
const $4e6049e0c598e760$var$rewriteFramesIntegration = $Qi0TL.defineIntegration((options = {})=>{
    const root = options.root;
    const prefix = options.prefix || "app:///";
    const isBrowser = "window" in $15YuE.GLOBAL_OBJ && !!$15YuE.GLOBAL_OBJ.window;
    const iteratee = options.iteratee || $4e6049e0c598e760$var$generateIteratee({
        isBrowser: isBrowser,
        root: root,
        prefix: prefix
    });
    function _processExceptionsEvent(event) {
        try {
            return (0, $2qxEV._)((0, $9tqwB._)({}, event), {
                exception: (0, $2qxEV._)((0, $9tqwB._)({}, event.exception), {
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map((value)=>(0, $9tqwB._)({}, value, value.stacktrace && {
                            stacktrace: _processStacktrace(value.stacktrace)
                        }))
                })
            });
        } catch (e) {
            return event;
        }
    }
    function _processStacktrace(stacktrace) {
        var _stacktrace_frames;
        return (0, $2qxEV._)((0, $9tqwB._)({}, stacktrace), {
            frames: stacktrace === null || stacktrace === void 0 ? void 0 : (_stacktrace_frames = stacktrace.frames) === null || _stacktrace_frames === void 0 ? void 0 : _stacktrace_frames.map((f)=>iteratee(f))
        });
    }
    return {
        name: $4e6049e0c598e760$var$INTEGRATION_NAME,
        processEvent (originalEvent) {
            let processedEvent = originalEvent;
            if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = _processExceptionsEvent(processedEvent);
            return processedEvent;
        }
    };
});
function $4e6049e0c598e760$var$generateIteratee({ isBrowser: isBrowser, root: root, prefix: prefix }) {
    return (frame)=>{
        if (!frame.filename) return frame;
        const isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) || // or the presence of a backslash without a forward slash (which are not allowed on Windows)
        frame.filename.includes("\\") && !frame.filename.includes("/");
        const startsWithSlash = /^\//.test(frame.filename);
        if (isBrowser) {
            if (root) {
                const oldFilename = frame.filename;
                if (oldFilename.indexOf(root) === 0) frame.filename = oldFilename.replace(root, prefix);
            }
        } else if (isWindowsFrame || startsWithSlash) {
            const filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, "").replace(/\\/g, "/") : frame.filename;
            const base = root ? $fnuZv.relative(root, filename) : $fnuZv.basename(filename);
            frame.filename = `${prefix}${base}`;
        }
        return frame;
    };
}
module.exports.generateIteratee = $4e6049e0c598e760$var$generateIteratee;
module.exports.rewriteFramesIntegration = $4e6049e0c598e760$var$rewriteFramesIntegration;

});
parcelRegister("fnuZv", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $b3210b280e9b00bb$var$normalizeArray(parts, allowAboveRoot) {
    let up = 0;
    for(let i = parts.length - 1; i >= 0; i--){
        const last = parts[i];
        if (last === ".") parts.splice(i, 1);
        else if (last === "..") {
            parts.splice(i, 1);
            up++;
        } else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    if (allowAboveRoot) for(; up--; up)parts.unshift("..");
    return parts;
}
const $b3210b280e9b00bb$var$splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
function $b3210b280e9b00bb$var$splitPath(filename) {
    const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
    const parts = $b3210b280e9b00bb$var$splitPathRe.exec(truncated);
    return parts ? parts.slice(1) : [];
}
function $b3210b280e9b00bb$var$resolve(...args) {
    let resolvedPath = "";
    let resolvedAbsolute = false;
    for(let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        const path = i >= 0 ? args[i] : "/";
        if (!path) continue;
        resolvedPath = `${path}/${resolvedPath}`;
        resolvedAbsolute = path.charAt(0) === "/";
    }
    resolvedPath = $b3210b280e9b00bb$var$normalizeArray(resolvedPath.split("/").filter((p)=>!!p), !resolvedAbsolute).join("/");
    return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
}
function $b3210b280e9b00bb$var$trim(arr) {
    let start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== "") break;
    }
    let end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== "") break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
function $b3210b280e9b00bb$var$relative(from, to) {
    from = $b3210b280e9b00bb$var$resolve(from).slice(1);
    to = $b3210b280e9b00bb$var$resolve(to).slice(1);
    const fromParts = $b3210b280e9b00bb$var$trim(from.split("/"));
    const toParts = $b3210b280e9b00bb$var$trim(to.split("/"));
    const length = Math.min(fromParts.length, toParts.length);
    let samePartsLength = length;
    for(let i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    let outputParts = [];
    for(let i = samePartsLength; i < fromParts.length; i++)outputParts.push("..");
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join("/");
}
function $b3210b280e9b00bb$var$normalizePath(path) {
    const isPathAbsolute = $b3210b280e9b00bb$var$isAbsolute(path);
    const trailingSlash = path.slice(-1) === "/";
    let normalizedPath = $b3210b280e9b00bb$var$normalizeArray(path.split("/").filter((p)=>!!p), !isPathAbsolute).join("/");
    if (!normalizedPath && !isPathAbsolute) normalizedPath = ".";
    if (normalizedPath && trailingSlash) normalizedPath += "/";
    return (isPathAbsolute ? "/" : "") + normalizedPath;
}
function $b3210b280e9b00bb$var$isAbsolute(path) {
    return path.charAt(0) === "/";
}
function $b3210b280e9b00bb$var$join(...args) {
    return $b3210b280e9b00bb$var$normalizePath(args.join("/"));
}
function $b3210b280e9b00bb$var$dirname(path) {
    const result = $b3210b280e9b00bb$var$splitPath(path);
    const root = result[0] || "";
    let dir = result[1];
    if (!root && !dir) return ".";
    if (dir) dir = dir.slice(0, dir.length - 1);
    return root + dir;
}
function $b3210b280e9b00bb$var$basename(path, ext) {
    let f = $b3210b280e9b00bb$var$splitPath(path)[2] || "";
    if (ext && f.slice(ext.length * -1) === ext) f = f.slice(0, f.length - ext.length);
    return f;
}
module.exports.basename = $b3210b280e9b00bb$var$basename;
module.exports.dirname = $b3210b280e9b00bb$var$dirname;
module.exports.isAbsolute = $b3210b280e9b00bb$var$isAbsolute;
module.exports.join = $b3210b280e9b00bb$var$join;
module.exports.normalizePath = $b3210b280e9b00bb$var$normalizePath;
module.exports.relative = $b3210b280e9b00bb$var$relative;
module.exports.resolve = $b3210b280e9b00bb$var$resolve;

});


parcelRegister("i0BXE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $haRHv = parcelRequire("haRHv");

var $hSRcd = parcelRequire("hSRcd");

var $859Bb = parcelRequire("859Bb");

var $gHOmH = parcelRequire("gHOmH");

var $Qi0TL = parcelRequire("Qi0TL");

var $faX3S = parcelRequire("faX3S");

var $hQAU7 = parcelRequire("hQAU7");

var $ibzbk = parcelRequire("ibzbk");

var $hppxz = parcelRequire("hppxz");

var $eqMxV = parcelRequire("eqMxV");

var $gvNu3 = parcelRequire("gvNu3");
const $d1c5ac6274174482$var$AUTH_OPERATIONS_TO_INSTRUMENT = [
    "reauthenticate",
    "signInAnonymously",
    "signInWithOAuth",
    "signInWithIdToken",
    "signInWithOtp",
    "signInWithPassword",
    "signInWithSSO",
    "signOut",
    "signUp",
    "verifyOtp"
];
const $d1c5ac6274174482$var$AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT = [
    "createUser",
    "deleteUser",
    "listUsers",
    "getUserById",
    "updateUserById",
    "inviteUserByEmail"
];
const $d1c5ac6274174482$var$FILTER_MAPPINGS = {
    eq: "eq",
    neq: "neq",
    gt: "gt",
    gte: "gte",
    lt: "lt",
    lte: "lte",
    like: "like",
    "like(all)": "likeAllOf",
    "like(any)": "likeAnyOf",
    ilike: "ilike",
    "ilike(all)": "ilikeAllOf",
    "ilike(any)": "ilikeAnyOf",
    is: "is",
    in: "in",
    cs: "contains",
    cd: "containedBy",
    sr: "rangeGt",
    nxl: "rangeGte",
    sl: "rangeLt",
    nxr: "rangeLte",
    adj: "rangeAdjacent",
    ov: "overlaps",
    fts: "",
    plfts: "plain",
    phfts: "phrase",
    wfts: "websearch",
    not: "not"
};
const $d1c5ac6274174482$var$DB_OPERATIONS_TO_INSTRUMENT = [
    "select",
    "insert",
    "upsert",
    "update",
    "delete"
];
function $d1c5ac6274174482$var$markAsInstrumented(fn) {
    try {
        fn.__SENTRY_INSTRUMENTED__ = true;
    } catch (e) {}
}
function $d1c5ac6274174482$var$isInstrumented(fn) {
    try {
        return fn.__SENTRY_INSTRUMENTED__;
    } catch (e) {
        return false;
    }
}
function $d1c5ac6274174482$var$getMutationBodyPayloadForTelemetry(rawBody, plainBody) {
    if (Object.keys(plainBody).length > 0) return plainBody;
    if (Array.isArray(rawBody) && rawBody.length > 0) return rawBody;
    return void 0;
}
function $d1c5ac6274174482$var$hasMutationBodyForDescription(rawBody, plainBody) {
    return $d1c5ac6274174482$var$getMutationBodyPayloadForTelemetry(rawBody, plainBody) !== void 0;
}
function $d1c5ac6274174482$var$extractOperation(method, headers = {}) {
    switch(method){
        case "GET":
            return "select";
        case "POST":
            var _headers_Prefer;
            if ((_headers_Prefer = headers["Prefer"]) === null || _headers_Prefer === void 0 ? void 0 : _headers_Prefer.includes("resolution=")) return "upsert";
            else return "insert";
        case "PATCH":
            return "update";
        case "DELETE":
            return "delete";
        default:
            return "<unknown-op>";
    }
}
function $d1c5ac6274174482$var$translateFiltersIntoMethods(key, query) {
    if (query === "" || query === "*") return "select(*)";
    if (key === "select") return `select(${query})`;
    if (key === "or" || key.endsWith(".or")) return `${key}${query}`;
    const [filter, ...value] = query.split(".");
    let method;
    if (filter === null || filter === void 0 ? void 0 : filter.startsWith("fts")) method = "textSearch";
    else if (filter === null || filter === void 0 ? void 0 : filter.startsWith("plfts")) method = "textSearch[plain]";
    else if (filter === null || filter === void 0 ? void 0 : filter.startsWith("phfts")) method = "textSearch[phrase]";
    else if (filter === null || filter === void 0 ? void 0 : filter.startsWith("wfts")) method = "textSearch[websearch]";
    else method = filter && $d1c5ac6274174482$var$FILTER_MAPPINGS[filter] || "filter";
    return `${method}(${key}, ${value.join(".")})`;
}
function $d1c5ac6274174482$var$instrumentAuthOperation(operation, isAdmin = false) {
    return new Proxy(operation, {
        apply (target, thisArg, argumentsList) {
            return $gvNu3.startSpan({
                name: `auth ${isAdmin ? "(admin) " : ""}${operation.name}`,
                attributes: {
                    [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.db.supabase",
                    [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "db",
                    "db.system": "postgresql",
                    "db.operation": `auth.${isAdmin ? "admin." : ""}${operation.name}`
                }
            }, (span)=>{
                return Reflect.apply(target, thisArg, argumentsList).then((res)=>{
                    if (res && typeof res === "object" && "error" in res && res.error) {
                        span.setStatus({
                            code: $eqMxV.SPAN_STATUS_ERROR
                        });
                        $gHOmH.captureException(res.error, {
                            mechanism: {
                                handled: false,
                                type: "auto.db.supabase.auth"
                            }
                        });
                    } else span.setStatus({
                        code: $eqMxV.SPAN_STATUS_OK
                    });
                    span.end();
                    return res;
                }).catch((err)=>{
                    span.setStatus({
                        code: $eqMxV.SPAN_STATUS_ERROR
                    });
                    span.end();
                    $gHOmH.captureException(err, {
                        mechanism: {
                            handled: false,
                            type: "auto.db.supabase.auth"
                        }
                    });
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
}
function $d1c5ac6274174482$var$instrumentSupabaseAuthClient(supabaseClientInstance) {
    const auth = supabaseClientInstance.auth;
    if (!auth || $d1c5ac6274174482$var$isInstrumented(supabaseClientInstance.auth)) return;
    for (const operation of $d1c5ac6274174482$var$AUTH_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth[operation] === "function") supabaseClientInstance.auth[operation] = $d1c5ac6274174482$var$instrumentAuthOperation(authOperation);
    }
    for (const operation of $d1c5ac6274174482$var$AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth.admin[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth.admin[operation] === "function") supabaseClientInstance.auth.admin[operation] = $d1c5ac6274174482$var$instrumentAuthOperation(authOperation, true);
    }
    $d1c5ac6274174482$var$markAsInstrumented(supabaseClientInstance.auth);
}
function $d1c5ac6274174482$var$instrumentSupabaseClientConstructor(SupabaseClient, _options) {
    if ($d1c5ac6274174482$var$isInstrumented(SupabaseClient.prototype.from)) return;
    SupabaseClient.prototype.from = new Proxy(SupabaseClient.prototype.from, {
        apply (target, thisArg, argumentsList) {
            const rv = Reflect.apply(target, thisArg, argumentsList);
            const PostgRESTQueryBuilder = rv.constructor;
            $d1c5ac6274174482$var$instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder, _options);
            return rv;
        }
    });
    $d1c5ac6274174482$var$markAsInstrumented(SupabaseClient.prototype.from);
}
function $d1c5ac6274174482$var$instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder, _options) {
    if ($d1c5ac6274174482$var$isInstrumented(PostgRESTFilterBuilder.prototype.then)) return;
    PostgRESTFilterBuilder.prototype.then = new Proxy(PostgRESTFilterBuilder.prototype.then, {
        apply (target, thisArg, argumentsList) {
            var _typedThis_url;
            const operations = $d1c5ac6274174482$var$DB_OPERATIONS_TO_INSTRUMENT;
            const typedThis = thisArg;
            const operation = $d1c5ac6274174482$var$extractOperation(typedThis.method, typedThis.headers);
            if (!operations.includes(operation)) return Reflect.apply(target, thisArg, argumentsList);
            if (!(typedThis === null || typedThis === void 0 ? void 0 : (_typedThis_url = typedThis.url) === null || _typedThis_url === void 0 ? void 0 : _typedThis_url.pathname) || typeof typedThis.url.pathname !== "string") return Reflect.apply(target, thisArg, argumentsList);
            const pathParts = typedThis.url.pathname.split("/");
            const table = pathParts.length > 0 ? pathParts[pathParts.length - 1] : "";
            const queryItems = [];
            for (const [key, value] of typedThis.url.searchParams.entries())queryItems.push($d1c5ac6274174482$var$translateFiltersIntoMethods(key, value));
            const body = /* @__PURE__ */ Object.create(null);
            if ($ibzbk.isPlainObject(typedThis.body)) for (const [key, value] of Object.entries(typedThis.body))body[key] = value;
            const client = $hSRcd.getClient();
            var _options_sendOperationData;
            const shouldSendData = (_options_sendOperationData = _options.sendOperationData) !== null && _options_sendOperationData !== void 0 ? _options_sendOperationData : (client === null || client === void 0 ? void 0 : client.getDataCollectionOptions().userInfo) === true;
            const bodyPayload = $d1c5ac6274174482$var$getMutationBodyPayloadForTelemetry(typedThis.body, body);
            const mutationPart = operation === "select" ? "" : `${operation}${$d1c5ac6274174482$var$hasMutationBodyForDescription(typedThis.body, body) ? "(...) " : ""}`;
            const queryPart = shouldSendData ? queryItems.join(" ") : queryItems.length > 0 ? "[redacted]" : "";
            const descriptionMiddle = [
                mutationPart.trimEnd(),
                queryPart
            ].filter(Boolean).join(" ");
            const description = descriptionMiddle ? `${descriptionMiddle} from(${table})` : `from(${table})`;
            const attributes = {
                "db.table": table,
                "db.schema": typedThis.schema,
                "db.url": typedThis.url.origin,
                "db.sdk": typedThis.headers["X-Client-Info"],
                "db.system": "postgresql",
                "db.operation": operation,
                [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.db.supabase",
                [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "db"
            };
            if (queryItems.length && shouldSendData) attributes["db.query"] = queryItems;
            if (bodyPayload !== void 0 && shouldSendData) attributes["db.body"] = bodyPayload;
            return $gvNu3.startSpan({
                name: description,
                attributes: attributes
            }, (span)=>{
                return Reflect.apply(target, thisArg, []).then((res)=>{
                    if (span) {
                        if (res && typeof res === "object" && "status" in res) $eqMxV.setHttpStatus(span, res.status || 500);
                        span.end();
                    }
                    if (res === null || res === void 0 ? void 0 : res.error) {
                        const err = new Error(res.error.message);
                        if (res.error.code) err.code = res.error.code;
                        if (res.error.details) err.details = res.error.details;
                        const supabaseContext = {};
                        if (queryItems.length && shouldSendData) supabaseContext.query = queryItems;
                        if (bodyPayload !== void 0 && shouldSendData) supabaseContext.body = bodyPayload;
                        $gHOmH.captureException(err, (scope)=>{
                            scope.addEventProcessor((e)=>{
                                $hppxz.addExceptionMechanism(e, {
                                    handled: false,
                                    type: "auto.db.supabase.postgres"
                                });
                                return e;
                            });
                            scope.setContext("supabase", supabaseContext);
                            return scope;
                        });
                    }
                    const breadcrumb = {
                        type: "supabase",
                        category: `db.${operation}`,
                        message: description
                    };
                    const data = {};
                    if (queryItems.length && shouldSendData) data.query = queryItems;
                    if (bodyPayload !== void 0 && shouldSendData) data.body = bodyPayload;
                    if (Object.keys(data).length) breadcrumb.data = data;
                    $haRHv.addBreadcrumb(breadcrumb);
                    return res;
                }, (err)=>{
                    if (span) {
                        $eqMxV.setHttpStatus(span, 500);
                        span.end();
                    }
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
    $d1c5ac6274174482$var$markAsInstrumented(PostgRESTFilterBuilder.prototype.then);
}
function $d1c5ac6274174482$var$instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder, _options) {
    for (const operation of $d1c5ac6274174482$var$DB_OPERATIONS_TO_INSTRUMENT){
        if ($d1c5ac6274174482$var$isInstrumented(PostgRESTQueryBuilder.prototype[operation])) continue;
        PostgRESTQueryBuilder.prototype[operation] = new Proxy(PostgRESTQueryBuilder.prototype[operation], {
            apply (target, thisArg, argumentsList) {
                const rv = Reflect.apply(target, thisArg, argumentsList);
                const PostgRESTFilterBuilder = rv.constructor;
                $859Bb.DEBUG_BUILD && $hQAU7.debug.log(`Instrumenting ${operation} operation's PostgRESTFilterBuilder`);
                $d1c5ac6274174482$var$instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder, _options);
                return rv;
            }
        });
        $d1c5ac6274174482$var$markAsInstrumented(PostgRESTQueryBuilder.prototype[operation]);
    }
}
const $d1c5ac6274174482$var$instrumentSupabaseClient = (supabaseClient, options = {})=>{
    if (!supabaseClient) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.warn("Supabase integration was not installed because no Supabase client was provided.");
        return;
    }
    const SupabaseClientConstructor = supabaseClient.constructor === Function ? supabaseClient : supabaseClient.constructor;
    $d1c5ac6274174482$var$instrumentSupabaseClientConstructor(SupabaseClientConstructor, options);
    $d1c5ac6274174482$var$instrumentSupabaseAuthClient(supabaseClient);
};
const $d1c5ac6274174482$var$INTEGRATION_NAME = "Supabase";
const $d1c5ac6274174482$var$_supabaseIntegration = (supabaseClient, options)=>{
    return {
        setupOnce () {
            $d1c5ac6274174482$var$instrumentSupabaseClient(supabaseClient, options);
        },
        name: $d1c5ac6274174482$var$INTEGRATION_NAME
    };
};
const $d1c5ac6274174482$var$supabaseIntegration = $Qi0TL.defineIntegration((options)=>{
    return $d1c5ac6274174482$var$_supabaseIntegration(options.supabaseClient, {
        sendOperationData: options.sendOperationData
    });
});
module.exports.DB_OPERATIONS_TO_INSTRUMENT = $d1c5ac6274174482$var$DB_OPERATIONS_TO_INSTRUMENT;
module.exports.FILTER_MAPPINGS = $d1c5ac6274174482$var$FILTER_MAPPINGS;
module.exports.extractOperation = $d1c5ac6274174482$var$extractOperation;
module.exports.instrumentSupabaseClient = $d1c5ac6274174482$var$instrumentSupabaseClient;
module.exports.supabaseIntegration = $d1c5ac6274174482$var$supabaseIntegration;
module.exports.translateFiltersIntoMethods = $d1c5ac6274174482$var$translateFiltersIntoMethods;

});

parcelRegister("63lln", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $Qi0TL = parcelRequire("Qi0TL");

var $ibzbk = parcelRequire("ibzbk");

var $8zsqf = parcelRequire("8zsqf");
const $46839453de42367a$var$DEFAULT_LIMIT = 10;
const $46839453de42367a$var$INTEGRATION_NAME = "ZodErrors";
function $46839453de42367a$var$originalExceptionIsZodError(originalException) {
    return $ibzbk.isError(originalException) && originalException.name === "ZodError" && Array.isArray(originalException.issues);
}
function $46839453de42367a$var$flattenIssue(issue) {
    return (0, $2qxEV._)((0, $9tqwB._)({}, issue), {
        path: "path" in issue && Array.isArray(issue.path) ? issue.path.join(".") : void 0,
        keys: "keys" in issue ? JSON.stringify(issue.keys) : void 0,
        unionErrors: "unionErrors" in issue ? JSON.stringify(issue.unionErrors) : void 0
    });
}
function $46839453de42367a$var$flattenIssuePath(path) {
    return path.map((p)=>{
        if (typeof p === "number") return "<array>";
        else return p;
    }).join(".");
}
function $46839453de42367a$var$formatIssueMessage(zodError) {
    const errorKeyMap = /* @__PURE__ */ new Set();
    for (const iss of zodError.issues){
        const issuePath = $46839453de42367a$var$flattenIssuePath(iss.path);
        if (issuePath.length > 0) errorKeyMap.add(issuePath);
    }
    const errorKeys = Array.from(errorKeyMap);
    if (errorKeys.length === 0) {
        let rootExpectedType = "variable";
        if (zodError.issues.length > 0) {
            const iss = zodError.issues[0];
            if (iss !== void 0 && "expected" in iss && typeof iss.expected === "string") rootExpectedType = iss.expected;
        }
        return `Failed to validate ${rootExpectedType}`;
    }
    return `Failed to validate keys: ${$8zsqf.truncate(errorKeys.join(", "), 100)}`;
}
function $46839453de42367a$var$applyZodErrorsToEvent(limit, saveZodIssuesAsAttachment = false, event, hint) {
    var _event_exception;
    if (!((_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : _event_exception.values) || !hint.originalException || !$46839453de42367a$var$originalExceptionIsZodError(hint.originalException) || hint.originalException.issues.length === 0) return event;
    try {
        const issuesToFlatten = saveZodIssuesAsAttachment ? hint.originalException.issues : hint.originalException.issues.slice(0, limit);
        const flattenedIssues = issuesToFlatten.map($46839453de42367a$var$flattenIssue);
        if (saveZodIssuesAsAttachment) {
            if (!Array.isArray(hint.attachments)) hint.attachments = [];
            hint.attachments.push({
                filename: "zod_issues.json",
                data: JSON.stringify({
                    issues: flattenedIssues
                })
            });
        }
        return (0, $2qxEV._)((0, $9tqwB._)({}, event), {
            exception: (0, $2qxEV._)((0, $9tqwB._)({}, event.exception), {
                values: [
                    (0, $2qxEV._)((0, $9tqwB._)({}, event.exception.values[0]), {
                        value: $46839453de42367a$var$formatIssueMessage(hint.originalException)
                    }),
                    ...event.exception.values.slice(1)
                ]
            }),
            extra: (0, $2qxEV._)((0, $9tqwB._)({}, event.extra), {
                "zoderror.issues": flattenedIssues.slice(0, limit)
            })
        });
    } catch (e) {
        return (0, $2qxEV._)((0, $9tqwB._)({}, event), {
            extra: (0, $2qxEV._)((0, $9tqwB._)({}, event.extra), {
                "zoderrors sentry integration parse error": {
                    message: "an exception was thrown while processing ZodError within applyZodErrorsToEvent()",
                    error: e instanceof Error ? `${e.name}: ${e.message}
${e.stack}` : "unknown"
                }
            })
        });
    }
}
const $46839453de42367a$var$_zodErrorsIntegration = (options = {})=>{
    var _options_limit;
    const limit = (_options_limit = options.limit) !== null && _options_limit !== void 0 ? _options_limit : $46839453de42367a$var$DEFAULT_LIMIT;
    return {
        name: $46839453de42367a$var$INTEGRATION_NAME,
        processEvent (originalEvent, hint) {
            const processedEvent = $46839453de42367a$var$applyZodErrorsToEvent(limit, options.saveZodIssuesAsAttachment, originalEvent, hint);
            return processedEvent;
        }
    };
};
const $46839453de42367a$var$zodErrorsIntegration = $Qi0TL.defineIntegration($46839453de42367a$var$_zodErrorsIntegration);
module.exports.applyZodErrorsToEvent = $46839453de42367a$var$applyZodErrorsToEvent;
module.exports.flattenIssue = $46839453de42367a$var$flattenIssue;
module.exports.flattenIssuePath = $46839453de42367a$var$flattenIssuePath;
module.exports.formatIssueMessage = $46839453de42367a$var$formatIssueMessage;
module.exports.zodErrorsIntegration = $46839453de42367a$var$zodErrorsIntegration;

});

parcelRegister("gw4Pv", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $Qi0TL = parcelRequire("Qi0TL");

var $9cnvM = parcelRequire("9cnvM");

var $bIVq4 = parcelRequire("bIVq4");

var $ah1An = parcelRequire("ah1An");

var $15YuE = parcelRequire("15YuE");
const $c063619aae4a5083$var$thirdPartyErrorFilterIntegration = $Qi0TL.defineIntegration((options)=>{
    return {
        name: "ThirdPartyErrorsFilter",
        setup (client) {
            client.on("beforeEnvelope", (envelope$1)=>{
                $bIVq4.forEachEnvelopeItem(envelope$1, (item, type)=>{
                    if (type === "event") {
                        const event = Array.isArray(item) ? item[1] : void 0;
                        if (event) {
                            $9cnvM.stripMetadataFromStackFrames(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on("applyFrameMetadata", (event)=>{
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                $9cnvM.addMetadataToStackFrames(stackParser, event);
            });
        },
        preprocessEvent (event) {
            var _worldwide_GLOBAL_OBJ__sentryWrappedDepth;
            if (options.ignoreSentryInternalFrames && ((_worldwide_GLOBAL_OBJ__sentryWrappedDepth = $15YuE.GLOBAL_OBJ._sentryWrappedDepth) !== null && _worldwide_GLOBAL_OBJ__sentryWrappedDepth !== void 0 ? _worldwide_GLOBAL_OBJ__sentryWrappedDepth : 0) > 0) event.sdkProcessingMetadata = (0, $2qxEV._)((0, $9tqwB._)({}, event.sdkProcessingMetadata), {
                insideSentryWrapped: true
            });
        },
        processEvent (event) {
            var _event_sdkProcessingMetadata, _event_exception_values, _event_exception;
            const insideSentryWrapped = options.ignoreSentryInternalFrames ? ((_event_sdkProcessingMetadata = event.sdkProcessingMetadata) === null || _event_sdkProcessingMetadata === void 0 ? void 0 : _event_sdkProcessingMetadata.insideSentryWrapped) === true && ((_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.length) === 1 : false;
            const frameKeys = $c063619aae4a5083$var$getBundleKeysForAllFramesWithFilenames(event, options.ignoreSentryInternalFrames, insideSentryWrapped);
            if (frameKeys) {
                const arrayMethod = options.behaviour === "drop-error-if-contains-third-party-frames" || options.behaviour === "apply-tag-if-contains-third-party-frames" ? "some" : "every";
                const behaviourApplies = frameKeys[arrayMethod]((keys)=>!keys.some((key)=>options.filterKeys.includes(key)));
                if (behaviourApplies) {
                    const shouldDrop = options.behaviour === "drop-error-if-contains-third-party-frames" || options.behaviour === "drop-error-if-exclusively-contains-third-party-frames";
                    if (shouldDrop) return null;
                    else event.tags = (0, $2qxEV._)((0, $9tqwB._)({}, event.tags), {
                        third_party_code: true
                    });
                }
            }
            return event;
        }
    };
});
function $c063619aae4a5083$var$isSentryInternalFrame(frame, frameIndex, insideSentryWrapped) {
    if (frameIndex !== 0) return false;
    if (insideSentryWrapped && $c063619aae4a5083$var$isLikelyMinifiedSentryWrappedFrame(frame)) return true;
    if (frame.function === "sentryWrapped") return true;
    if (!frame.context_line || !frame.filename) return false;
    if (!frame.filename.includes("sentry") || !frame.filename.includes("helpers") || // Filename would look something like this: 'node_modules/@sentry/browser/build/npm/esm/helpers.js'
    !frame.context_line.includes($c063619aae4a5083$var$SENTRY_INTERNAL_FN_APPLY)) return false;
    if (frame.pre_context) {
        const len = frame.pre_context.length;
        for(let i = 0; i < len; i++){
            var _frame_pre_context_i;
            if ((_frame_pre_context_i = frame.pre_context[i]) === null || _frame_pre_context_i === void 0 ? void 0 : _frame_pre_context_i.includes($c063619aae4a5083$var$SENTRY_INTERNAL_COMMENT)) return true;
        }
    }
    return false;
}
function $c063619aae4a5083$var$getBundleKeysForAllFramesWithFilenames(event, ignoreSentryInternalFrames, insideSentryWrapped) {
    const frames = $ah1An.getFramesFromEvent(event);
    if (!frames) return void 0;
    return frames.filter((frame, index)=>{
        if (!frame.filename) return false;
        if (frame.lineno == null && frame.colno == null && frame.instruction_addr == null) return false;
        return !ignoreSentryInternalFrames || !$c063619aae4a5083$var$isSentryInternalFrame(frame, index, !!insideSentryWrapped);
    }).map((frame)=>{
        if (!frame.module_metadata) return [];
        return Object.keys(frame.module_metadata).filter((key)=>key.startsWith($c063619aae4a5083$var$BUNDLER_PLUGIN_APP_KEY_PREFIX)).map((key)=>key.slice($c063619aae4a5083$var$BUNDLER_PLUGIN_APP_KEY_PREFIX.length));
    });
}
function $c063619aae4a5083$var$isLikelyMinifiedSentryWrappedFrame(frame) {
    return !frame.context_line && !frame.pre_context && !!frame.function && frame.function.length <= 2;
}
const $c063619aae4a5083$var$BUNDLER_PLUGIN_APP_KEY_PREFIX = "_sentryBundlerPluginAppKey:";
const $c063619aae4a5083$var$SENTRY_INTERNAL_COMMENT = "Attempt to invoke user-land function";
const $c063619aae4a5083$var$SENTRY_INTERNAL_FN_APPLY = "fn.apply(this, wrappedArguments)";
module.exports.thirdPartyErrorFilterIntegration = $c063619aae4a5083$var$thirdPartyErrorFilterIntegration;

});

parcelRegister("guQsY", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $haRHv = parcelRequire("haRHv");

var $hSRcd = parcelRequire("hSRcd");

var $dGNME = parcelRequire("dGNME");

var $Qi0TL = parcelRequire("Qi0TL");

var $hQAU7 = parcelRequire("hQAU7");

var $fmjoe = parcelRequire("fmjoe");

var $8zsqf = parcelRequire("8zsqf");

var $15YuE = parcelRequire("15YuE");
const $c0282560df0789aa$var$INTEGRATION_NAME = "Console";
const $c0282560df0789aa$var$consoleIntegration = $Qi0TL.defineIntegration((options = {})=>{
    const levels = new Set(options.levels || $hQAU7.CONSOLE_LEVELS);
    return {
        name: $c0282560df0789aa$var$INTEGRATION_NAME,
        setup (client) {
            const unsubscribe = $dGNME.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($hSRcd.getClient() !== client || !levels.has(level)) return;
                $c0282560df0789aa$var$addConsoleBreadcrumb(level, args);
            });
            client.registerCleanup(unsubscribe);
            if (options.filter) {
                const unsubscribe2 = $dGNME.addConsoleInstrumentationFilter(options.filter);
                client.registerCleanup(unsubscribe2);
            }
        }
    };
});
function $c0282560df0789aa$var$addConsoleBreadcrumb(level, args) {
    const breadcrumb = {
        category: "console",
        data: {
            arguments: args,
            logger: "console"
        },
        level: $fmjoe.severityLevelFromString(level),
        message: $c0282560df0789aa$var$formatConsoleArgs(args)
    };
    if (level === "assert") {
        if (args[0] === false) {
            const assertionArgs = args.slice(1);
            breadcrumb.message = assertionArgs.length > 0 ? `Assertion failed: ${$c0282560df0789aa$var$formatConsoleArgs(assertionArgs)}` : "Assertion failed";
            breadcrumb.data.arguments = assertionArgs;
        } else return;
    }
    $haRHv.addBreadcrumb(breadcrumb, {
        input: args,
        level: level
    });
}
function $c0282560df0789aa$var$formatConsoleArgs(values) {
    return "util" in $15YuE.GLOBAL_OBJ && typeof $15YuE.GLOBAL_OBJ.util.format === "function" ? $15YuE.GLOBAL_OBJ.util.format(...values) : $8zsqf.safeJoin(values, " ");
}
module.exports.addConsoleBreadcrumb = $c0282560df0789aa$var$addConsoleBreadcrumb;
module.exports.consoleIntegration = $c0282560df0789aa$var$consoleIntegration;

});

parcelRegister("gXaKs", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $Qi0TL = parcelRequire("Qi0TL");

var $kiJPB = parcelRequire("kiJPB");
const $c57a7e6de318f336$var$featureFlagsIntegration = $Qi0TL.defineIntegration(()=>{
    return {
        name: "FeatureFlags",
        processEvent (event, _hint, _client) {
            return $kiJPB._INTERNAL_copyFlagsFromScopeToEvent(event);
        },
        addFeatureFlag (name, value) {
            $kiJPB._INTERNAL_insertFlagToScope(name, value);
            $kiJPB._INTERNAL_addFeatureFlagToActiveSpan(name, value);
        }
    };
});
module.exports.featureFlagsIntegration = $c57a7e6de318f336$var$featureFlagsIntegration;

});
parcelRegister("kiJPB", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hSRcd = parcelRequire("hSRcd");

var $859Bb = parcelRequire("859Bb");

var $hQAU7 = parcelRequire("hQAU7");

var $dRW3b = parcelRequire("dRW3b");
const $ec790a3b4c59d8d3$var$_INTERNAL_FLAG_BUFFER_SIZE = 100;
const $ec790a3b4c59d8d3$var$_INTERNAL_MAX_FLAGS_PER_SPAN = 10;
const $ec790a3b4c59d8d3$var$SPAN_FLAG_ATTRIBUTE_PREFIX = "flag.evaluation.";
function $ec790a3b4c59d8d3$var$_INTERNAL_copyFlagsFromScopeToEvent(event) {
    if (event.type) return event;
    const scope = $hSRcd.getCurrentScope();
    const flagContext = scope.getScopeData().contexts.flags;
    const flagBuffer = flagContext ? flagContext.values : [];
    if (!flagBuffer.length) return event;
    if (event.contexts === void 0) event.contexts = {};
    event.contexts.flags = {
        values: [
            ...flagBuffer
        ]
    };
    return event;
}
function $ec790a3b4c59d8d3$var$_INTERNAL_insertFlagToScope(name, value, maxSize = $ec790a3b4c59d8d3$var$_INTERNAL_FLAG_BUFFER_SIZE) {
    const scopeContexts = $hSRcd.getCurrentScope().getScopeData().contexts;
    if (!scopeContexts.flags) scopeContexts.flags = {
        values: []
    };
    const flags = scopeContexts.flags.values;
    $ec790a3b4c59d8d3$var$_INTERNAL_insertToFlagBuffer(flags, name, value, maxSize);
}
function $ec790a3b4c59d8d3$var$_INTERNAL_insertToFlagBuffer(flags, name, value, maxSize) {
    if (typeof value !== "boolean") return;
    if (flags.length > maxSize) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.error(`[Feature Flags] insertToFlagBuffer called on a buffer larger than maxSize=${maxSize}`);
        return;
    }
    const index = flags.findIndex((f)=>f.flag === name);
    if (index !== -1) flags.splice(index, 1);
    if (flags.length === maxSize) flags.shift();
    flags.push({
        flag: name,
        result: value
    });
}
function $ec790a3b4c59d8d3$var$_INTERNAL_addFeatureFlagToActiveSpan(name, value, maxFlagsPerSpan = $ec790a3b4c59d8d3$var$_INTERNAL_MAX_FLAGS_PER_SPAN) {
    if (typeof value !== "boolean") return;
    const span = $dRW3b.getActiveSpan();
    if (!span) return;
    const attributes = $dRW3b.spanToJSON(span).data;
    if (`${$ec790a3b4c59d8d3$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}` in attributes) {
        span.setAttribute(`${$ec790a3b4c59d8d3$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
        return;
    }
    const numOfAddedFlags = Object.keys(attributes).filter((key)=>key.startsWith($ec790a3b4c59d8d3$var$SPAN_FLAG_ATTRIBUTE_PREFIX)).length;
    if (numOfAddedFlags < maxFlagsPerSpan) span.setAttribute(`${$ec790a3b4c59d8d3$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
}
module.exports._INTERNAL_FLAG_BUFFER_SIZE = $ec790a3b4c59d8d3$var$_INTERNAL_FLAG_BUFFER_SIZE;
module.exports._INTERNAL_MAX_FLAGS_PER_SPAN = $ec790a3b4c59d8d3$var$_INTERNAL_MAX_FLAGS_PER_SPAN;
module.exports._INTERNAL_addFeatureFlagToActiveSpan = $ec790a3b4c59d8d3$var$_INTERNAL_addFeatureFlagToActiveSpan;
module.exports._INTERNAL_copyFlagsFromScopeToEvent = $ec790a3b4c59d8d3$var$_INTERNAL_copyFlagsFromScopeToEvent;
module.exports._INTERNAL_insertFlagToScope = $ec790a3b4c59d8d3$var$_INTERNAL_insertFlagToScope;
module.exports._INTERNAL_insertToFlagBuffer = $ec790a3b4c59d8d3$var$_INTERNAL_insertToFlagBuffer;

});


parcelRegister("cey3X", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $Qi0TL = parcelRequire("Qi0TL");

var $kiJPB = parcelRequire("kiJPB");

var $eEQXZ = parcelRequire("eEQXZ");
const $8e8137067f42747c$var$growthbookIntegration = $Qi0TL.defineIntegration(({ growthbookClass: growthbookClass })=>{
    return {
        name: "GrowthBook",
        setupOnce () {
            const proto = growthbookClass.prototype;
            if (typeof proto.isOn === "function") $eEQXZ.fill(proto, "isOn", $8e8137067f42747c$var$_wrapAndCaptureBooleanResult);
            if (typeof proto.getFeatureValue === "function") $eEQXZ.fill(proto, "getFeatureValue", $8e8137067f42747c$var$_wrapAndCaptureBooleanResult);
        },
        processEvent (event, _hint, _client) {
            return $kiJPB._INTERNAL_copyFlagsFromScopeToEvent(event);
        }
    };
});
function $8e8137067f42747c$var$_wrapAndCaptureBooleanResult(original) {
    return function(...args) {
        const flagName = args[0];
        const result = original.apply(this, args);
        if (typeof flagName === "string" && typeof result === "boolean") {
            $kiJPB._INTERNAL_insertFlagToScope(flagName, result);
            $kiJPB._INTERNAL_addFeatureFlagToActiveSpan(flagName, result);
        }
        return result;
    };
}
module.exports.growthbookIntegration = $8e8137067f42747c$var$growthbookIntegration;

});

parcelRegister("2vCme", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hSRcd = parcelRequire("hSRcd");

var $Qi0TL = parcelRequire("Qi0TL");

var $faX3S = parcelRequire("faX3S");

var $dRW3b = parcelRequire("dRW3b");
const $1d3c3b0928bac306$var$INTEGRATION_NAME = "ConversationId";
const $1d3c3b0928bac306$var$_conversationIdIntegration = ()=>{
    return {
        name: $1d3c3b0928bac306$var$INTEGRATION_NAME,
        setup (client) {
            client.on("spanStart", (span)=>{
                const scopeData = $hSRcd.getCurrentScope().getScopeData();
                const isolationScopeData = $hSRcd.getIsolationScope().getScopeData();
                const conversationId = scopeData.conversationId || isolationScopeData.conversationId;
                if (conversationId) {
                    const { op: op, data: attributes, description: name } = $dRW3b.spanToJSON(span);
                    if (!(op === null || op === void 0 ? void 0 : op.startsWith("gen_ai.")) && !attributes["ai.operationId"] && !(name === null || name === void 0 ? void 0 : name.startsWith("ai."))) return;
                    span.setAttribute($faX3S.GEN_AI_CONVERSATION_ID_ATTRIBUTE, conversationId);
                }
            });
        }
    };
};
const $1d3c3b0928bac306$var$conversationIdIntegration = $Qi0TL.defineIntegration($1d3c3b0928bac306$var$_conversationIdIntegration);
module.exports.conversationIdIntegration = $1d3c3b0928bac306$var$conversationIdIntegration;

});

parcelRegister("fGpJQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hSRcd = parcelRequire("hSRcd");

var $859Bb = parcelRequire("859Bb");

var $hQAU7 = parcelRequire("hQAU7");
function $b6aebe6639c25eb0$var$isProfilingIntegrationWithProfiler(integration) {
    return !!integration && typeof integration["_profiler"] !== "undefined" && typeof integration["_profiler"]["start"] === "function" && typeof integration["_profiler"]["stop"] === "function";
}
function $b6aebe6639c25eb0$var$startProfiler() {
    const client = $hSRcd.getClient();
    if (!client) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.warn("No Sentry client available, profiling is not started");
        return;
    }
    const integration = client.getIntegrationByName("ProfilingIntegration");
    if (!integration) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.warn("ProfilingIntegration is not available");
        return;
    }
    if (!$b6aebe6639c25eb0$var$isProfilingIntegrationWithProfiler(integration)) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.warn("Profiler is not available on profiling integration.");
        return;
    }
    integration._profiler.start();
}
function $b6aebe6639c25eb0$var$stopProfiler() {
    const client = $hSRcd.getClient();
    if (!client) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.warn("No Sentry client available, profiling is not started");
        return;
    }
    const integration = client.getIntegrationByName("ProfilingIntegration");
    if (!integration) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.warn("ProfilingIntegration is not available");
        return;
    }
    if (!$b6aebe6639c25eb0$var$isProfilingIntegrationWithProfiler(integration)) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.warn("Profiler is not available on profiling integration.");
        return;
    }
    integration._profiler.stop();
}
const $b6aebe6639c25eb0$var$profiler = {
    startProfiler: $b6aebe6639c25eb0$var$startProfiler,
    stopProfiler: $b6aebe6639c25eb0$var$stopProfiler
};
module.exports.profiler = $b6aebe6639c25eb0$var$profiler;

});

parcelRegister("l5JQD", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hSRcd = parcelRequire("hSRcd");

var $faX3S = parcelRequire("faX3S");

var $dRW3b = parcelRequire("dRW3b");

var $eqMxV = parcelRequire("eqMxV");

var $ibzbk = parcelRequire("ibzbk");

var $6AMlx = parcelRequire("6AMlx");

var $2ldD6 = parcelRequire("2ldD6");

var $f0HG2 = parcelRequire("f0HG2");

var $aSFvs = parcelRequire("aSFvs");

var $gvNu3 = parcelRequire("gvNu3");

var $cCABH = parcelRequire("cCABH");

var $kRTcv = parcelRequire("kRTcv");
function $f5ada111ef6c9779$var$instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOriginOrOptions) {
    if (!handlerData.fetchData) return void 0;
    const { method: method, url: url } = handlerData.fetchData;
    const shouldCreateSpanResult = $6AMlx.hasSpansEnabled() && shouldCreateSpan(url);
    if (handlerData.endTimestamp) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span2 = spans[spanId];
        if (span2) {
            if (shouldCreateSpanResult) {
                $f5ada111ef6c9779$var$endSpan(span2, handlerData);
                $f5ada111ef6c9779$var$_callOnRequestSpanEnd(span2, handlerData, spanOriginOrOptions);
            }
            delete spans[spanId];
        }
        return void 0;
    }
    const { spanOrigin: spanOrigin = "auto.http.browser", propagateTraceparent: propagateTraceparent = false } = typeof spanOriginOrOptions === "object" ? spanOriginOrOptions : {
        spanOrigin: spanOriginOrOptions
    };
    const client = $hSRcd.getClient();
    const hasParent = !!$dRW3b.getActiveSpan();
    const shouldEmitSpan = hasParent || !!client && $aSFvs.hasSpanStreamingEnabled(client);
    const span = shouldCreateSpanResult && shouldEmitSpan ? $gvNu3.startInactiveSpan($f5ada111ef6c9779$var$getSpanStartOptions(url, method, spanOrigin)) : new $2ldD6.SentryNonRecordingSpan();
    if (shouldCreateSpanResult && !shouldEmitSpan) client === null || client === void 0 ? void 0 : client.recordDroppedEvent("no_parent_span", "span");
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url)) {
        const request = handlerData.args[0];
        const options = (0, $9tqwB._)({}, handlerData.args[1] || {});
        const headers = $f5ada111ef6c9779$var$_INTERNAL_getTracingHeadersForFetchRequest(request, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        $6AMlx.hasSpansEnabled() && shouldEmitSpan ? span : void 0, propagateTraceparent);
        if (headers) {
            handlerData.args[1] = options;
            options.headers = headers;
        }
    }
    if (client) {
        const fetchHint = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: handlerData.startTimestamp,
            endTimestamp: handlerData.endTimestamp
        };
        client.emit("beforeOutgoingRequestSpan", span, fetchHint);
    }
    return span;
}
function $f5ada111ef6c9779$var$_callOnRequestSpanEnd(span, handlerData, spanOriginOrOptions) {
    var _handlerData_response;
    const onRequestSpanEnd = typeof spanOriginOrOptions === "object" && spanOriginOrOptions !== null ? spanOriginOrOptions.onRequestSpanEnd : void 0;
    onRequestSpanEnd === null || onRequestSpanEnd === void 0 ? void 0 : onRequestSpanEnd(span, {
        headers: (_handlerData_response = handlerData.response) === null || _handlerData_response === void 0 ? void 0 : _handlerData_response.headers,
        error: handlerData.error
    });
}
function $f5ada111ef6c9779$var$_INTERNAL_getTracingHeadersForFetchRequest(request, fetchOptionsObj, span, propagateTraceparent) {
    const traceHeaders = $cCABH.getTraceData({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    const sentryTrace = traceHeaders["sentry-trace"];
    const baggage = traceHeaders.baggage;
    const traceparent = traceHeaders.traceparent;
    if (!sentryTrace) return void 0;
    const originalHeaders = fetchOptionsObj.headers || ($ibzbk.isRequest(request) ? request.headers : void 0);
    if (!originalHeaders) return (0, $9tqwB._)({}, traceHeaders);
    else if ($f5ada111ef6c9779$var$isHeaders(originalHeaders)) {
        const newHeaders = new Headers(originalHeaders);
        if (!newHeaders.get("sentry-trace")) newHeaders.set("sentry-trace", sentryTrace);
        if (propagateTraceparent && traceparent && !newHeaders.get("traceparent")) newHeaders.set("traceparent", traceparent);
        if (baggage) {
            const prevBaggageHeader = newHeaders.get("baggage");
            if (!prevBaggageHeader) newHeaders.set("baggage", baggage);
            else if (!$f5ada111ef6c9779$var$baggageHeaderHasSentryBaggageValues(prevBaggageHeader)) newHeaders.set("baggage", `${prevBaggageHeader},${baggage}`);
        }
        return newHeaders;
    } else if ($f5ada111ef6c9779$var$isHeadersInitTupleArray(originalHeaders)) {
        const newHeaders = [
            ...originalHeaders
        ];
        if (!newHeaders.find((header)=>header[0] === "sentry-trace")) newHeaders.push([
            "sentry-trace",
            sentryTrace
        ]);
        if (propagateTraceparent && traceparent && !newHeaders.find((header)=>header[0] === "traceparent")) newHeaders.push([
            "traceparent",
            traceparent
        ]);
        const prevBaggageHeaderWithSentryValues = originalHeaders.find((header)=>header[0] === "baggage" && typeof header[1] === "string" && $f5ada111ef6c9779$var$baggageHeaderHasSentryBaggageValues(header[1]));
        if (baggage && !prevBaggageHeaderWithSentryValues) newHeaders.push([
            "baggage",
            baggage
        ]);
        return newHeaders;
    } else {
        const existingSentryTraceHeader = "sentry-trace" in originalHeaders ? originalHeaders["sentry-trace"] : void 0;
        const existingTraceparentHeader = "traceparent" in originalHeaders ? originalHeaders.traceparent : void 0;
        const existingBaggageHeader = "baggage" in originalHeaders ? originalHeaders.baggage : void 0;
        const newBaggageHeaders = existingBaggageHeader ? Array.isArray(existingBaggageHeader) ? [
            ...existingBaggageHeader
        ] : [
            existingBaggageHeader
        ] : [];
        const prevBaggageHeaderWithSentryValues = existingBaggageHeader && (Array.isArray(existingBaggageHeader) ? existingBaggageHeader.find((headerItem)=>$f5ada111ef6c9779$var$baggageHeaderHasSentryBaggageValues(headerItem)) : $f5ada111ef6c9779$var$baggageHeaderHasSentryBaggageValues(existingBaggageHeader));
        if (baggage && !prevBaggageHeaderWithSentryValues) newBaggageHeaders.push(baggage);
        const newHeaders = Object.assign({}, originalHeaders, {
            "sentry-trace": existingSentryTraceHeader !== null && existingSentryTraceHeader !== void 0 ? existingSentryTraceHeader : sentryTrace,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : void 0
        });
        if (propagateTraceparent && traceparent && !existingTraceparentHeader) newHeaders.traceparent = traceparent;
        return newHeaders;
    }
}
function $f5ada111ef6c9779$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        var _handlerData_response_headers, _handlerData_response;
        $eqMxV.setHttpStatus(span, handlerData.response.status);
        const contentLength = (_handlerData_response = handlerData.response) === null || _handlerData_response === void 0 ? void 0 : (_handlerData_response_headers = _handlerData_response.headers) === null || _handlerData_response_headers === void 0 ? void 0 : _handlerData_response_headers.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: $eqMxV.SPAN_STATUS_ERROR,
        message: "internal_error"
    });
    span.end();
}
function $f5ada111ef6c9779$var$baggageHeaderHasSentryBaggageValues(baggageHeader) {
    if (typeof baggageHeader !== "string") return false;
    return baggageHeader.split(",").some((baggageEntry)=>baggageEntry.trim().startsWith($f0HG2.SENTRY_BAGGAGE_KEY_PREFIX));
}
function $f5ada111ef6c9779$var$isHeaders(headers) {
    return typeof Headers !== "undefined" && $ibzbk.isInstanceOf(headers, Headers);
}
function $f5ada111ef6c9779$var$isHeadersInitTupleArray(headers) {
    if (!Array.isArray(headers)) return false;
    return headers.every((item)=>Array.isArray(item) && item.length === 2 && typeof item[0] === "string");
}
function $f5ada111ef6c9779$var$getSpanStartOptions(url$1, method, spanOrigin) {
    if (url$1.startsWith("data:")) {
        const sanitizedUrl2 = $kRTcv.stripDataUrlContent(url$1);
        return {
            name: `${method} ${sanitizedUrl2}`,
            attributes: $f5ada111ef6c9779$var$getFetchSpanAttributes(url$1, void 0, method, spanOrigin)
        };
    }
    const parsedUrl = $kRTcv.parseStringToURLObject(url$1);
    const sanitizedUrl = parsedUrl ? $kRTcv.getSanitizedUrlStringFromUrlObject(parsedUrl) : url$1;
    return {
        name: `${method} ${sanitizedUrl}`,
        attributes: $f5ada111ef6c9779$var$getFetchSpanAttributes(url$1, parsedUrl, method, spanOrigin)
    };
}
function $f5ada111ef6c9779$var$getFetchSpanAttributes(url$1, parsedUrl, method, spanOrigin) {
    const attributes = {
        url: $kRTcv.stripDataUrlContent(url$1),
        type: "fetch",
        "http.method": method,
        [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
        [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "http.client"
    };
    if (parsedUrl) {
        if (!$kRTcv.isURLObjectRelative(parsedUrl)) {
            attributes["http.url"] = $kRTcv.stripDataUrlContent(parsedUrl.href);
            attributes["server.address"] = parsedUrl.host;
        }
        if (parsedUrl.search) attributes["http.query"] = parsedUrl.search;
        if (parsedUrl.hash) attributes["http.fragment"] = parsedUrl.hash;
    }
    return attributes;
}
module.exports._INTERNAL_getTracingHeadersForFetchRequest = $f5ada111ef6c9779$var$_INTERNAL_getTracingHeadersForFetchRequest;
module.exports._callOnRequestSpanEnd = $f5ada111ef6c9779$var$_callOnRequestSpanEnd;
module.exports.instrumentFetchRequest = $f5ada111ef6c9779$var$instrumentFetchRequest;

});

parcelRegister("e78A8", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hSRcd = parcelRequire("hSRcd");
function $a4686051f2e0f804$var$captureFeedback(params, hint = {}, scope = $hSRcd.getCurrentScope()) {
    const { message: message, name: name, email: email, url: url, source: source, associatedEventId: associatedEventId, tags: tags } = params;
    const feedbackEvent = {
        contexts: {
            feedback: {
                contact_email: email,
                name: name,
                message: message,
                url: url,
                source: source,
                associated_event_id: associatedEventId
            }
        },
        type: "feedback",
        level: "info",
        tags: tags
    };
    const client = (scope === null || scope === void 0 ? void 0 : scope.getClient()) || $hSRcd.getClient();
    if (client) client.emit("beforeSendFeedback", feedbackEvent, hint);
    const eventId = scope.captureEvent(feedbackEvent, hint);
    return eventId;
}
module.exports.captureFeedback = $a4686051f2e0f804$var$captureFeedback;

});

parcelRegister("3JOYW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8H2Be = parcelRequire("8H2Be");

var $LkEbx = parcelRequire("LkEbx");
function $2b8d1efea858ab42$var$captureLog(level, message, attributes, scope, severityNumber) {
    $8H2Be._INTERNAL_captureLog({
        level: level,
        message: message,
        attributes: attributes,
        severityNumber: severityNumber
    }, scope);
}
function $2b8d1efea858ab42$var$trace(message, attributes, { scope: scope } = {}) {
    $2b8d1efea858ab42$var$captureLog("trace", message, attributes, scope);
}
function $2b8d1efea858ab42$var$debug(message, attributes, { scope: scope } = {}) {
    $2b8d1efea858ab42$var$captureLog("debug", message, attributes, scope);
}
function $2b8d1efea858ab42$var$info(message, attributes, { scope: scope } = {}) {
    $2b8d1efea858ab42$var$captureLog("info", message, attributes, scope);
}
function $2b8d1efea858ab42$var$warn(message, attributes, { scope: scope } = {}) {
    $2b8d1efea858ab42$var$captureLog("warn", message, attributes, scope);
}
function $2b8d1efea858ab42$var$error(message, attributes, { scope: scope } = {}) {
    $2b8d1efea858ab42$var$captureLog("error", message, attributes, scope);
}
function $2b8d1efea858ab42$var$fatal(message, attributes, { scope: scope } = {}) {
    $2b8d1efea858ab42$var$captureLog("fatal", message, attributes, scope);
}
module.exports.fmt = $LkEbx.fmt;
module.exports.debug = $2b8d1efea858ab42$var$debug;
module.exports.error = $2b8d1efea858ab42$var$error;
module.exports.fatal = $2b8d1efea858ab42$var$fatal;
module.exports.info = $2b8d1efea858ab42$var$info;
module.exports.trace = $2b8d1efea858ab42$var$trace;
module.exports.warn = $2b8d1efea858ab42$var$warn;

});

parcelRegister("djqGU", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hSRcd = parcelRequire("hSRcd");

var $859Bb = parcelRequire("859Bb");

var $dGNME = parcelRequire("dGNME");

var $Qi0TL = parcelRequire("Qi0TL");

var $faX3S = parcelRequire("faX3S");

var $hQAU7 = parcelRequire("hQAU7");

var $ibzbk = parcelRequire("ibzbk");

var $irz1w = parcelRequire("irz1w");

var $8H2Be = parcelRequire("8H2Be");

var $lw1SR = parcelRequire("lw1SR");
const $9b11c0fb8358d6ea$var$INTEGRATION_NAME = "ConsoleLogs";
const $9b11c0fb8358d6ea$var$DEFAULT_ATTRIBUTES = {
    [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.log.console"
};
const $9b11c0fb8358d6ea$var$_consoleLoggingIntegration = (options = {})=>{
    const levels = options.levels || $hQAU7.CONSOLE_LEVELS;
    return {
        name: $9b11c0fb8358d6ea$var$INTEGRATION_NAME,
        setup (client) {
            const { enableLogs: enableLogs, normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = client.getOptions();
            if (!enableLogs) {
                $859Bb.DEBUG_BUILD && $hQAU7.debug.warn("`enableLogs` is not enabled, ConsoleLogs integration disabled");
                return;
            }
            const unsubscribe = $dGNME.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($hSRcd.getClient() !== client || !levels.includes(level)) return;
                const firstArg = args[0];
                const followingArgs = args.slice(1);
                if (level === "assert") {
                    if (!firstArg) {
                        const assertionMessage = followingArgs.length > 0 ? `Assertion failed: ${$lw1SR.formatConsoleArgs(followingArgs, normalizeDepth, normalizeMaxBreadth)}` : "Assertion failed";
                        $8H2Be._INTERNAL_captureLog({
                            level: "error",
                            message: assertionMessage,
                            attributes: $9b11c0fb8358d6ea$var$DEFAULT_ATTRIBUTES
                        });
                    }
                    return;
                }
                const isLevelLog = level === "log";
                const attributes = (0, $9tqwB._)({}, $9b11c0fb8358d6ea$var$DEFAULT_ATTRIBUTES);
                if ($ibzbk.isPlainObject(firstArg)) {
                    Object.assign(attributes, $irz1w.normalize(firstArg, normalizeDepth, normalizeMaxBreadth));
                    const remainingArgsStartIndex = typeof args[1] === "string" ? 2 : 1;
                    const remainingArgs = args.slice(remainingArgsStartIndex);
                    remainingArgs.forEach((arg, index)=>{
                        attributes[`sentry.message.parameter.${index}`] = $irz1w.normalize(arg, normalizeDepth, normalizeMaxBreadth);
                    });
                } else {
                    const shouldGenerateTemplate = followingArgs.length > 0 && typeof firstArg === "string" && !$lw1SR.hasConsoleSubstitutions(firstArg);
                    if (shouldGenerateTemplate) {
                        const templateAttrs = $lw1SR.createConsoleTemplateAttributes(firstArg, followingArgs);
                        for (const [key, value] of Object.entries(templateAttrs))attributes[key] = key.startsWith("sentry.message.parameter.") ? $irz1w.normalize(value, normalizeDepth, normalizeMaxBreadth) : value;
                    }
                }
                $8H2Be._INTERNAL_captureLog({
                    level: isLevelLog ? "info" : level,
                    message: $lw1SR.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth),
                    severityNumber: isLevelLog ? 10 : void 0,
                    attributes: attributes
                });
            });
            client.registerCleanup(unsubscribe);
        }
    };
};
const $9b11c0fb8358d6ea$var$consoleLoggingIntegration = $Qi0TL.defineIntegration($9b11c0fb8358d6ea$var$_consoleLoggingIntegration);
module.exports.consoleLoggingIntegration = $9b11c0fb8358d6ea$var$consoleLoggingIntegration;

});
parcelRegister("lw1SR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ibzbk = parcelRequire("ibzbk");

var $irz1w = parcelRequire("irz1w");

var $15YuE = parcelRequire("15YuE");
function $fa9e0c3fee0c62b2$var$formatConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return "util" in $15YuE.GLOBAL_OBJ && typeof $15YuE.GLOBAL_OBJ.util.format === "function" ? $15YuE.GLOBAL_OBJ.util.format(...values) : $fa9e0c3fee0c62b2$var$safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth);
}
function $fa9e0c3fee0c62b2$var$safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return values.map((value)=>$ibzbk.isPrimitive(value) ? String(value) : JSON.stringify($irz1w.normalize(value, normalizeDepth, normalizeMaxBreadth))).join(" ");
}
function $fa9e0c3fee0c62b2$var$hasConsoleSubstitutions(str) {
    return /%[sdifocO]/.test(str);
}
function $fa9e0c3fee0c62b2$var$createConsoleTemplateAttributes(firstArg, followingArgs) {
    const attributes = {};
    const template = new Array(followingArgs.length).fill("{}").join(" ");
    attributes["sentry.message.template"] = `${firstArg} ${template}`;
    followingArgs.forEach((arg, index)=>{
        attributes[`sentry.message.parameter.${index}`] = arg;
    });
    return attributes;
}
module.exports.createConsoleTemplateAttributes = $fa9e0c3fee0c62b2$var$createConsoleTemplateAttributes;
module.exports.formatConsoleArgs = $fa9e0c3fee0c62b2$var$formatConsoleArgs;
module.exports.hasConsoleSubstitutions = $fa9e0c3fee0c62b2$var$hasConsoleSubstitutions;
module.exports.safeJoinConsoleArgs = $fa9e0c3fee0c62b2$var$safeJoinConsoleArgs;

});


parcelRegister("bWdsU", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2NdDt = parcelRequire("2NdDt");
function $8b0f8e6a7ee464ad$var$captureMetric(type, name, value, options) {
    $2NdDt._INTERNAL_captureMetric({
        type: type,
        name: name,
        value: value,
        unit: options === null || options === void 0 ? void 0 : options.unit,
        attributes: options === null || options === void 0 ? void 0 : options.attributes
    }, {
        scope: options === null || options === void 0 ? void 0 : options.scope
    });
}
function $8b0f8e6a7ee464ad$var$count(name, value = 1, options) {
    $8b0f8e6a7ee464ad$var$captureMetric("counter", name, value, options);
}
function $8b0f8e6a7ee464ad$var$gauge(name, value, options) {
    $8b0f8e6a7ee464ad$var$captureMetric("gauge", name, value, options);
}
function $8b0f8e6a7ee464ad$var$distribution(name, value, options) {
    $8b0f8e6a7ee464ad$var$captureMetric("distribution", name, value, options);
}
module.exports.count = $8b0f8e6a7ee464ad$var$count;
module.exports.distribution = $8b0f8e6a7ee464ad$var$distribution;
module.exports.gauge = $8b0f8e6a7ee464ad$var$gauge;

});

parcelRegister("2pq9U", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $bLhVg = parcelRequire("bLhVg");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hSRcd = parcelRequire("hSRcd");

var $8H2Be = parcelRequire("8H2Be");

var $lw1SR = parcelRequire("lw1SR");

var $ibzbk = parcelRequire("ibzbk");

var $irz1w = parcelRequire("irz1w");
const $1c1235311911ac4b$var$DEFAULT_CAPTURED_LEVELS = [
    "trace",
    "debug",
    "info",
    "warn",
    "error",
    "fatal"
];
function $1c1235311911ac4b$var$createConsolaReporter(options = {}) {
    var _options_levels;
    const levels = new Set((_options_levels = options.levels) !== null && _options_levels !== void 0 ? _options_levels : $1c1235311911ac4b$var$DEFAULT_CAPTURED_LEVELS);
    const providedClient = options.client;
    return {
        log (logObj) {
            const { type: type, level: level, message: consolaMessage, args: args, tag: tag, date: _date } = logObj, rest = (0, $bLhVg._)(logObj, [
                "type",
                "level",
                "message",
                "args",
                "tag",
                "date"
            ]);
            const client = providedClient || $hSRcd.getClient();
            if (!client) return;
            const logSeverityLevel = $1c1235311911ac4b$var$getLogSeverityLevel(type, level);
            if (!levels.has(logSeverityLevel)) return;
            const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = client.getOptions();
            const attributes = {};
            for (const [key, value] of Object.entries(rest))attributes[key] = $irz1w.normalize(value, normalizeDepth, normalizeMaxBreadth);
            attributes["sentry.origin"] = "auto.log.consola";
            if (tag) attributes["consola.tag"] = tag;
            if (type) attributes["consola.type"] = type;
            if (level != null && typeof level === "number") attributes["consola.level"] = level;
            const extractionResult = $1c1235311911ac4b$var$processExtractedAttributes($1c1235311911ac4b$var$defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth), normalizeDepth, normalizeMaxBreadth);
            if (extractionResult === null || extractionResult === void 0 ? void 0 : extractionResult.attributes) Object.assign(attributes, extractionResult.attributes);
            $8H2Be._INTERNAL_captureLog({
                level: logSeverityLevel,
                message: (extractionResult === null || extractionResult === void 0 ? void 0 : extractionResult.message) || consolaMessage || args && $lw1SR.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth) || "",
                attributes: attributes
            });
        }
    };
}
const $1c1235311911ac4b$var$CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP = {
    // Consola built-in types
    silent: "trace",
    fatal: "fatal",
    error: "error",
    warn: "warn",
    log: "info",
    info: "info",
    success: "info",
    fail: "error",
    ready: "info",
    start: "info",
    box: "info",
    debug: "debug",
    trace: "trace",
    verbose: "debug",
    // Custom types that might exist
    critical: "fatal",
    notice: "info"
};
const $1c1235311911ac4b$var$CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP = {
    0: "fatal",
    // Fatal and Error
    1: "warn",
    // Warnings
    2: "info",
    // Normal logs
    3: "info",
    // Informational logs, success, fail, ready, start, ...
    4: "debug",
    // Debug logs
    5: "trace"
};
function $1c1235311911ac4b$var$getLogSeverityLevel(type, level) {
    if (type === "verbose") return "debug";
    if (type === "silent") return "trace";
    if (type) {
        const mappedLevel = $1c1235311911ac4b$var$CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP[type];
        if (mappedLevel) return mappedLevel;
    }
    if (typeof level === "number") {
        const mappedLevel = $1c1235311911ac4b$var$CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP[level];
        if (mappedLevel) return mappedLevel;
    }
    return "info";
}
function $1c1235311911ac4b$var$defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth) {
    if (!(args === null || args === void 0 ? void 0 : args.length)) return {
        message: ""
    };
    const message = $lw1SR.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth);
    const firstArg = args[0];
    if ($ibzbk.isPlainObject(firstArg)) {
        const remainingArgsStartIndex = typeof args[1] === "string" ? 2 : 1;
        const remainingArgs = args.slice(remainingArgsStartIndex);
        return {
            message: message,
            // Object content from first arg is added as attributes
            attributes: firstArg,
            // Add remaining args as message parameters
            messageParameters: remainingArgs
        };
    } else {
        const followingArgs = args.slice(1);
        const shouldAddTemplateAttr = followingArgs.length > 0 && typeof firstArg === "string" && !$lw1SR.hasConsoleSubstitutions(firstArg);
        return {
            message: message,
            messageTemplate: shouldAddTemplateAttr ? firstArg : void 0,
            messageParameters: shouldAddTemplateAttr ? followingArgs : void 0
        };
    }
}
function $1c1235311911ac4b$var$processExtractedAttributes(extractionResult, normalizeDepth, normalizeMaxBreadth) {
    const { message: message, attributes: attributes, messageTemplate: messageTemplate, messageParameters: messageParameters } = extractionResult;
    const messageParamAttributes = {};
    if (messageTemplate && messageParameters) {
        const templateAttrs = $lw1SR.createConsoleTemplateAttributes(messageTemplate, messageParameters);
        for (const [key, value] of Object.entries(templateAttrs))messageParamAttributes[key] = key.startsWith("sentry.message.parameter.") ? $irz1w.normalize(value, normalizeDepth, normalizeMaxBreadth) : value;
    } else if (messageParameters && messageParameters.length > 0) messageParameters.forEach((arg, index)=>{
        messageParamAttributes[`sentry.message.parameter.${index}`] = $irz1w.normalize(arg, normalizeDepth, normalizeMaxBreadth);
    });
    return {
        message: message,
        attributes: (0, $9tqwB._)({}, $irz1w.normalize(attributes, normalizeDepth, normalizeMaxBreadth), messageParamAttributes)
    };
}
module.exports.createConsolaReporter = $1c1235311911ac4b$var$createConsolaReporter;

});

parcelRegister("cGuuU", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hSRcd = parcelRequire("hSRcd");

var $faX3S = parcelRequire("faX3S");

var $8TMtR = parcelRequire("8TMtR");

var $dRW3b = parcelRequire("dRW3b");

var $akoBU = parcelRequire("akoBU");

var $64Nq7 = parcelRequire("64Nq7");

var $aSFvs = parcelRequire("aSFvs");

var $eWHcE = parcelRequire("eWHcE");

var $1dj8F = parcelRequire("1dj8F");
function $93c11071e4084bf1$var$onVercelAiSpanStart(span) {
    var _integration_options;
    const { data: attributes, description: name } = $dRW3b.spanToJSON(span);
    if (!name) return;
    if (attributes[$1dj8F.AI_TOOL_CALL_NAME_ATTRIBUTE] && attributes[$1dj8F.AI_TOOL_CALL_ID_ATTRIBUTE] && name === "ai.toolCall") {
        $93c11071e4084bf1$var$processToolCallSpan(span, attributes);
        return;
    }
    if (!attributes[$1dj8F.AI_OPERATION_ID_ATTRIBUTE] && !name.startsWith("ai.")) return;
    const client = $hSRcd.getClient();
    const integration = client === null || client === void 0 ? void 0 : client.getIntegrationByName("VercelAI");
    const enableTruncation = $8TMtR.shouldEnableTruncation(integration === null || integration === void 0 ? void 0 : (_integration_options = integration.options) === null || _integration_options === void 0 ? void 0 : _integration_options.enableTruncation);
    $93c11071e4084bf1$var$processGenerateSpan(span, name, attributes, enableTruncation);
}
function $93c11071e4084bf1$var$vercelAiEventProcessor(event) {
    if (event.type === "transaction" && event.spans) {
        var _event_contexts;
        const tokenAccumulator = /* @__PURE__ */ new Map();
        for (const span of event.spans){
            $93c11071e4084bf1$var$processEndedVercelAiSpan(span);
            $eWHcE.accumulateTokensForParent(span, tokenAccumulator);
        }
        $eWHcE.applyToolDescriptionsAndTokens(event.spans, tokenAccumulator);
        const trace = (_event_contexts = event.contexts) === null || _event_contexts === void 0 ? void 0 : _event_contexts.trace;
        if ((trace === null || trace === void 0 ? void 0 : trace.op) === "gen_ai.invoke_agent") $eWHcE.applyAccumulatedTokens(trace, tokenAccumulator);
    }
    return event;
}
function $93c11071e4084bf1$var$normalizeFinishReason(finishReason) {
    if (typeof finishReason !== "string") return "stop";
    switch(finishReason){
        case "tool-calls":
            return "tool_call";
        case "stop":
        case "length":
        case "content_filter":
        case "error":
            return finishReason;
        default:
            return finishReason;
    }
}
function $93c11071e4084bf1$var$buildOutputMessages(attributes) {
    const responseText = attributes[$1dj8F.AI_RESPONSE_TEXT_ATTRIBUTE];
    const responseToolCalls = attributes[$1dj8F.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE];
    const finishReason = attributes[$1dj8F.AI_RESPONSE_FINISH_REASON_ATTRIBUTE];
    if (responseText == null && responseToolCalls == null) return;
    const parts = [];
    if (typeof responseText === "string" && responseText.length > 0) parts.push({
        type: "text",
        content: responseText
    });
    if (responseToolCalls != null) try {
        const toolCalls = typeof responseToolCalls === "string" ? JSON.parse(responseToolCalls) : responseToolCalls;
        if (Array.isArray(toolCalls)) {
            for (const toolCall of toolCalls){
                var _toolCall_input;
                const args = (_toolCall_input = toolCall.input) !== null && _toolCall_input !== void 0 ? _toolCall_input : toolCall.args;
                parts.push({
                    type: "tool_call",
                    id: toolCall.toolCallId,
                    name: toolCall.toolName,
                    // Handle undefined args: JSON.stringify(undefined) returns undefined, not a string,
                    // which would cause the property to be omitted from the final JSON output
                    arguments: typeof args === "string" ? args : JSON.stringify(args !== null && args !== void 0 ? args : {})
                });
            }
            delete attributes[$1dj8F.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE];
        }
    } catch (e) {}
    if (parts.length > 0) {
        const outputMessage = {
            role: "assistant",
            parts: parts,
            finish_reason: $93c11071e4084bf1$var$normalizeFinishReason(finishReason)
        };
        attributes[$akoBU.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE] = JSON.stringify([
            outputMessage
        ]);
        delete attributes[$1dj8F.AI_RESPONSE_TEXT_ATTRIBUTE];
    }
}
function $93c11071e4084bf1$var$processVercelAiSpanAttributes(attributes) {
    $93c11071e4084bf1$var$renameAttributeKey(attributes, $1dj8F.AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE, $akoBU.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE);
    $93c11071e4084bf1$var$renameAttributeKey(attributes, $1dj8F.AI_USAGE_PROMPT_TOKENS_ATTRIBUTE, $akoBU.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $93c11071e4084bf1$var$renameAttributeKey(attributes, $1dj8F.AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE, $akoBU.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE);
    $93c11071e4084bf1$var$renameAttributeKey(attributes, "ai.usage.inputTokens", $akoBU.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $93c11071e4084bf1$var$renameAttributeKey(attributes, "ai.usage.outputTokens", $akoBU.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE);
    $93c11071e4084bf1$var$renameAttributeKey(attributes, $1dj8F.AI_USAGE_TOKENS_ATTRIBUTE, $akoBU.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $93c11071e4084bf1$var$renameAttributeKey(attributes, "ai.response.avgOutputTokensPerSecond", "ai.response.avgCompletionTokensPerSecond");
    const inputTokensAreCacheInclusive = Object.keys(attributes).some((key)=>key.startsWith($1dj8F.AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX));
    if (!inputTokensAreCacheInclusive && typeof attributes[$akoBU.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] === "number" && typeof attributes[$akoBU.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE] === "number") attributes[$akoBU.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = attributes[$akoBU.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] + attributes[$akoBU.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE];
    if (typeof attributes[$akoBU.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] === "number") {
        const outputTokens = typeof attributes[$akoBU.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] === "number" ? attributes[$akoBU.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] : 0;
        attributes[$akoBU.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = outputTokens + attributes[$akoBU.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE];
    }
    if (attributes[$1dj8F.AI_PROMPT_TOOLS_ATTRIBUTE] && Array.isArray(attributes[$1dj8F.AI_PROMPT_TOOLS_ATTRIBUTE])) attributes[$1dj8F.AI_PROMPT_TOOLS_ATTRIBUTE] = $eWHcE.convertAvailableToolsToJsonString(attributes[$1dj8F.AI_PROMPT_TOOLS_ATTRIBUTE]);
    if (attributes[$1dj8F.OPERATION_NAME_ATTRIBUTE]) {
        const rawOperationName = attributes[$1dj8F.AI_OPERATION_ID_ATTRIBUTE] ? attributes[$1dj8F.AI_OPERATION_ID_ATTRIBUTE] : attributes[$1dj8F.OPERATION_NAME_ATTRIBUTE];
        var _constants_SPAN_TO_OPERATION_NAME_get;
        const operationName = (_constants_SPAN_TO_OPERATION_NAME_get = $64Nq7.SPAN_TO_OPERATION_NAME.get(rawOperationName)) !== null && _constants_SPAN_TO_OPERATION_NAME_get !== void 0 ? _constants_SPAN_TO_OPERATION_NAME_get : rawOperationName;
        attributes[$akoBU.GEN_AI_OPERATION_NAME_ATTRIBUTE] = operationName;
        delete attributes[$1dj8F.OPERATION_NAME_ATTRIBUTE];
    }
    $93c11071e4084bf1$var$renameAttributeKey(attributes, $1dj8F.AI_PROMPT_MESSAGES_ATTRIBUTE, $akoBU.GEN_AI_INPUT_MESSAGES_ATTRIBUTE);
    $93c11071e4084bf1$var$buildOutputMessages(attributes);
    $93c11071e4084bf1$var$renameAttributeKey(attributes, $1dj8F.AI_RESPONSE_OBJECT_ATTRIBUTE, "gen_ai.response.object");
    $93c11071e4084bf1$var$renameAttributeKey(attributes, $1dj8F.AI_PROMPT_TOOLS_ATTRIBUTE, "gen_ai.request.available_tools");
    $93c11071e4084bf1$var$renameAttributeKey(attributes, $1dj8F.AI_TOOL_CALL_ARGS_ATTRIBUTE, $akoBU.GEN_AI_TOOL_INPUT_ATTRIBUTE);
    $93c11071e4084bf1$var$renameAttributeKey(attributes, $1dj8F.AI_TOOL_CALL_RESULT_ATTRIBUTE, $akoBU.GEN_AI_TOOL_OUTPUT_ATTRIBUTE);
    $93c11071e4084bf1$var$renameAttributeKey(attributes, $1dj8F.AI_SCHEMA_ATTRIBUTE, "gen_ai.request.schema");
    $93c11071e4084bf1$var$renameAttributeKey(attributes, $1dj8F.AI_MODEL_ID_ATTRIBUTE, $akoBU.GEN_AI_REQUEST_MODEL_ATTRIBUTE);
    if (Array.isArray(attributes[$1dj8F.AI_VALUES_ATTRIBUTE])) {
        const parsed = attributes[$1dj8F.AI_VALUES_ATTRIBUTE].map((v)=>{
            try {
                return JSON.parse(v);
            } catch (e) {
                return v;
            }
        });
        attributes[$akoBU.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE] = parsed.length === 1 ? parsed[0] : JSON.stringify(parsed);
    }
    $93c11071e4084bf1$var$addProviderMetadataToAttributes(attributes);
    for (const key of Object.keys(attributes)){
        if (Array.isArray(attributes[key])) attributes[key] = JSON.stringify(attributes[key]);
        if (key.startsWith("ai.")) $93c11071e4084bf1$var$renameAttributeKey(attributes, key, `vercel.${key}`);
    }
}
function $93c11071e4084bf1$var$processEndedVercelAiSpan(span) {
    const { data: attributes, origin: origin } = span;
    if (origin !== "auto.vercelai.otel") return;
    if (span.status && span.status !== "ok") span.status = "internal_error";
    $93c11071e4084bf1$var$processVercelAiSpanAttributes(attributes);
}
function $93c11071e4084bf1$var$processVercelAiStreamedSpan(span) {
    const attributes = span.attributes;
    if ((attributes === null || attributes === void 0 ? void 0 : attributes[$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]) !== "auto.vercelai.otel") return;
    $93c11071e4084bf1$var$processVercelAiSpanAttributes(attributes);
    if (attributes[$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_OP] === "gen_ai.execute_tool" && span.parent_span_id) {
        const descriptions = $64Nq7.toolDescriptionMap.get(span.parent_span_id);
        if (descriptions) {
            const toolName = attributes[$akoBU.GEN_AI_TOOL_NAME_ATTRIBUTE];
            if (typeof toolName === "string") {
                const desc = descriptions.get(toolName);
                if (desc) attributes[$akoBU.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = desc;
            }
        }
    }
    $64Nq7.toolDescriptionMap.delete(span.span_id);
}
function $93c11071e4084bf1$var$renameAttributeKey(attributes, oldKey, newKey) {
    if (attributes[oldKey] != null) {
        attributes[newKey] = attributes[oldKey];
        delete attributes[oldKey];
    }
}
function $93c11071e4084bf1$var$processToolCallSpan(span, attributes) {
    span.setAttribute($faX3S.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, "auto.vercelai.otel");
    span.setAttribute($faX3S.SEMANTIC_ATTRIBUTE_SENTRY_OP, "gen_ai.execute_tool");
    span.setAttribute($akoBU.GEN_AI_OPERATION_NAME_ATTRIBUTE, "execute_tool");
    $93c11071e4084bf1$var$renameAttributeKey(attributes, $1dj8F.AI_TOOL_CALL_NAME_ATTRIBUTE, $akoBU.GEN_AI_TOOL_NAME_ATTRIBUTE);
    $93c11071e4084bf1$var$renameAttributeKey(attributes, $1dj8F.AI_TOOL_CALL_ID_ATTRIBUTE, $akoBU.GEN_AI_TOOL_CALL_ID_ATTRIBUTE);
    const toolCallId = attributes[$akoBU.GEN_AI_TOOL_CALL_ID_ATTRIBUTE];
    if (typeof toolCallId === "string") $64Nq7.toolCallSpanContextMap.set(toolCallId, span.spanContext());
    if (!attributes[$akoBU.GEN_AI_TOOL_TYPE_ATTRIBUTE]) span.setAttribute($akoBU.GEN_AI_TOOL_TYPE_ATTRIBUTE, "function");
    const toolName = attributes[$akoBU.GEN_AI_TOOL_NAME_ATTRIBUTE];
    if (toolName) span.updateName(`execute_tool ${toolName}`);
}
function $93c11071e4084bf1$var$processGenerateSpan(span, name, attributes, enableTruncation) {
    span.setAttribute($faX3S.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, "auto.vercelai.otel");
    const nameWthoutAi = name.replace("ai.", "");
    span.setAttribute("ai.pipeline.name", nameWthoutAi);
    span.updateName(nameWthoutAi);
    const functionId = attributes[$1dj8F.AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE];
    if (functionId && typeof functionId === "string") span.setAttribute("gen_ai.function_id", functionId);
    $eWHcE.requestMessagesFromPrompt(span, attributes, enableTruncation);
    if (attributes[$1dj8F.AI_MODEL_ID_ATTRIBUTE] && !attributes[$akoBU.GEN_AI_RESPONSE_MODEL_ATTRIBUTE]) span.setAttribute($akoBU.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, attributes[$1dj8F.AI_MODEL_ID_ATTRIBUTE]);
    span.setAttribute("ai.streaming", name.includes("stream"));
    const operationName = $64Nq7.SPAN_TO_OPERATION_NAME.get(name);
    if (operationName) span.setAttribute($faX3S.SEMANTIC_ATTRIBUTE_SENTRY_OP, `gen_ai.${operationName}`);
    else if (name.startsWith("ai.stream")) span.setAttribute($faX3S.SEMANTIC_ATTRIBUTE_SENTRY_OP, "ai.run");
    if (operationName === "invoke_agent") {
        if (functionId && typeof functionId === "string") span.updateName(`invoke_agent ${functionId}`);
        else span.updateName("invoke_agent");
        return;
    }
    const modelId = attributes[$1dj8F.AI_MODEL_ID_ATTRIBUTE];
    if (modelId && operationName) span.updateName(`${operationName} ${modelId}`);
    const client = $hSRcd.getClient();
    if (client && $aSFvs.hasSpanStreamingEnabled(client) && attributes[$1dj8F.AI_PROMPT_TOOLS_ATTRIBUTE] && Array.isArray(attributes[$1dj8F.AI_PROMPT_TOOLS_ATTRIBUTE])) {
        const descriptions = /* @__PURE__ */ new Map();
        for (const toolStr of attributes[$1dj8F.AI_PROMPT_TOOLS_ATTRIBUTE])try {
            const parsed = typeof toolStr === "string" ? JSON.parse(toolStr) : toolStr;
            if ((parsed === null || parsed === void 0 ? void 0 : parsed.name) && (parsed === null || parsed === void 0 ? void 0 : parsed.description)) descriptions.set(parsed.name, parsed.description);
        } catch (e) {}
        if (descriptions.size > 0) {
            const parentSpanId = $dRW3b.spanToJSON(span).parent_span_id;
            if (parentSpanId) $64Nq7.toolDescriptionMap.set(parentSpanId, descriptions);
        }
    }
}
function $93c11071e4084bf1$var$addVercelAiProcessors(client) {
    client.on("spanStart", $93c11071e4084bf1$var$onVercelAiSpanStart);
    client.addEventProcessor(Object.assign($93c11071e4084bf1$var$vercelAiEventProcessor, {
        id: "VercelAiEventProcessor"
    }));
    client.on("processSpan", (span)=>{
        $93c11071e4084bf1$var$processVercelAiStreamedSpan(span);
    });
}
function $93c11071e4084bf1$var$getProviderMetadataAttributes(providerMetadata) {
    var _metadata_bedrock;
    const attributes = {};
    if (!providerMetadata || typeof providerMetadata !== "object") return attributes;
    const metadata = providerMetadata;
    var _metadata_openai;
    const openaiMetadata = (_metadata_openai = metadata.openai) !== null && _metadata_openai !== void 0 ? _metadata_openai : metadata.azure;
    if (openaiMetadata) {
        $93c11071e4084bf1$var$setAttributeIfDefined(attributes, $akoBU.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, openaiMetadata.cachedPromptTokens);
        $93c11071e4084bf1$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.reasoning", openaiMetadata.reasoningTokens);
        $93c11071e4084bf1$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.prediction_accepted", openaiMetadata.acceptedPredictionTokens);
        $93c11071e4084bf1$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.prediction_rejected", openaiMetadata.rejectedPredictionTokens);
        $93c11071e4084bf1$var$setAttributeIfDefined(attributes, $akoBU.GEN_AI_CONVERSATION_ID_ATTRIBUTE, openaiMetadata.responseId);
    }
    if (metadata.anthropic) {
        var _metadata_anthropic_usage, _metadata_anthropic_usage1;
        var _metadata_anthropic_usage_cache_read_input_tokens;
        const cachedInputTokens = (_metadata_anthropic_usage_cache_read_input_tokens = (_metadata_anthropic_usage = metadata.anthropic.usage) === null || _metadata_anthropic_usage === void 0 ? void 0 : _metadata_anthropic_usage.cache_read_input_tokens) !== null && _metadata_anthropic_usage_cache_read_input_tokens !== void 0 ? _metadata_anthropic_usage_cache_read_input_tokens : metadata.anthropic.cacheReadInputTokens;
        $93c11071e4084bf1$var$setAttributeIfDefined(attributes, $akoBU.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, cachedInputTokens);
        var _metadata_anthropic_usage_cache_creation_input_tokens;
        const cacheWriteInputTokens = (_metadata_anthropic_usage_cache_creation_input_tokens = (_metadata_anthropic_usage1 = metadata.anthropic.usage) === null || _metadata_anthropic_usage1 === void 0 ? void 0 : _metadata_anthropic_usage1.cache_creation_input_tokens) !== null && _metadata_anthropic_usage_cache_creation_input_tokens !== void 0 ? _metadata_anthropic_usage_cache_creation_input_tokens : metadata.anthropic.cacheCreationInputTokens;
        $93c11071e4084bf1$var$setAttributeIfDefined(attributes, $akoBU.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE, cacheWriteInputTokens);
    }
    if ((_metadata_bedrock = metadata.bedrock) === null || _metadata_bedrock === void 0 ? void 0 : _metadata_bedrock.usage) {
        $93c11071e4084bf1$var$setAttributeIfDefined(attributes, $akoBU.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, metadata.bedrock.usage.cacheReadInputTokens);
        $93c11071e4084bf1$var$setAttributeIfDefined(attributes, $akoBU.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE, metadata.bedrock.usage.cacheWriteInputTokens);
    }
    if (metadata.deepseek) {
        $93c11071e4084bf1$var$setAttributeIfDefined(attributes, $akoBU.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, metadata.deepseek.promptCacheHitTokens);
        $93c11071e4084bf1$var$setAttributeIfDefined(attributes, "gen_ai.usage.input_tokens.cache_miss", metadata.deepseek.promptCacheMissTokens);
    }
    return attributes;
}
function $93c11071e4084bf1$var$addProviderMetadataToAttributes(attributes) {
    const providerMetadata = attributes[$1dj8F.AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE];
    if (!providerMetadata) return;
    try {
        const derived = $93c11071e4084bf1$var$getProviderMetadataAttributes(JSON.parse(providerMetadata));
        for (const [key, value] of Object.entries(derived)){
            if (key === $akoBU.GEN_AI_CONVERSATION_ID_ATTRIBUTE && attributes[key]) continue;
            attributes[key] = value;
        }
    } catch (e) {}
}
function $93c11071e4084bf1$var$setAttributeIfDefined(attributes, key, value) {
    if (value != null) attributes[key] = value;
}
module.exports.addVercelAiProcessors = $93c11071e4084bf1$var$addVercelAiProcessors;
module.exports.getProviderMetadataAttributes = $93c11071e4084bf1$var$getProviderMetadataAttributes;
module.exports.processVercelAiSpanAttributes = $93c11071e4084bf1$var$processVercelAiSpanAttributes;

});
parcelRegister("8TMtR", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gHOmH = parcelRequire("gHOmH");

var $hSRcd = parcelRequire("hSRcd");

var $aSFvs = parcelRequire("aSFvs");

var $ibzbk = parcelRequire("ibzbk");

var $akoBU = parcelRequire("akoBU");

var $fE4qR = parcelRequire("fE4qR");
function $67a91106979a1bde$var$resolveAIRecordingOptions(options) {
    var _currentScopes_getClient;
    const genAI = (_currentScopes_getClient = $hSRcd.getClient()) === null || _currentScopes_getClient === void 0 ? void 0 : _currentScopes_getClient.getDataCollectionOptions().genAI;
    var _options_recordInputs, _ref, _options_recordOutputs, _ref1;
    return (0, $2qxEV._)((0, $9tqwB._)({}, options), {
        recordInputs: (_ref = (_options_recordInputs = options === null || options === void 0 ? void 0 : options.recordInputs) !== null && _options_recordInputs !== void 0 ? _options_recordInputs : genAI === null || genAI === void 0 ? void 0 : genAI.inputs) !== null && _ref !== void 0 ? _ref : false,
        recordOutputs: (_ref1 = (_options_recordOutputs = options === null || options === void 0 ? void 0 : options.recordOutputs) !== null && _options_recordOutputs !== void 0 ? _options_recordOutputs : genAI === null || genAI === void 0 ? void 0 : genAI.outputs) !== null && _ref1 !== void 0 ? _ref1 : false
    });
}
function $67a91106979a1bde$var$shouldEnableTruncation(enableTruncation) {
    if (enableTruncation !== void 0) return enableTruncation;
    const client = $hSRcd.getClient();
    if (!client) return true;
    return !$aSFvs.hasSpanStreamingEnabled(client) && client.getOptions().streamGenAiSpans === false;
}
function $67a91106979a1bde$var$buildMethodPath(currentPath, prop) {
    return currentPath ? `${currentPath}.${prop}` : prop;
}
function $67a91106979a1bde$var$setTokenUsageAttributes(span, promptTokens, completionTokens, cachedInputTokens, cachedOutputTokens) {
    if (promptTokens !== void 0) span.setAttributes({
        [$akoBU.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE]: promptTokens
    });
    if (completionTokens !== void 0) span.setAttributes({
        [$akoBU.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE]: completionTokens
    });
    if (promptTokens !== void 0 || completionTokens !== void 0 || cachedInputTokens !== void 0 || cachedOutputTokens !== void 0) {
        const totalTokens = (promptTokens !== null && promptTokens !== void 0 ? promptTokens : 0) + (completionTokens !== null && completionTokens !== void 0 ? completionTokens : 0) + (cachedInputTokens !== null && cachedInputTokens !== void 0 ? cachedInputTokens : 0) + (cachedOutputTokens !== null && cachedOutputTokens !== void 0 ? cachedOutputTokens : 0);
        span.setAttributes({
            [$akoBU.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE]: totalTokens
        });
    }
}
function $67a91106979a1bde$var$endStreamSpan(span, state, recordOutputs) {
    if (!span.isRecording()) return;
    const attrs = {
        [$akoBU.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE]: true
    };
    if (state.responseId) attrs[$akoBU.GEN_AI_RESPONSE_ID_ATTRIBUTE] = state.responseId;
    if (state.responseModel) attrs[$akoBU.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = state.responseModel;
    if (state.promptTokens !== void 0) attrs[$akoBU.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = state.promptTokens;
    if (state.completionTokens !== void 0) attrs[$akoBU.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = state.completionTokens;
    var _state_promptTokens, _state_completionTokens, _state_cacheCreationInputTokens, _state_cacheReadInputTokens;
    if (state.totalTokens !== void 0) attrs[$akoBU.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = state.totalTokens;
    else if (state.promptTokens !== void 0 || state.completionTokens !== void 0 || state.cacheCreationInputTokens !== void 0 || state.cacheReadInputTokens !== void 0) attrs[$akoBU.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = ((_state_promptTokens = state.promptTokens) !== null && _state_promptTokens !== void 0 ? _state_promptTokens : 0) + ((_state_completionTokens = state.completionTokens) !== null && _state_completionTokens !== void 0 ? _state_completionTokens : 0) + ((_state_cacheCreationInputTokens = state.cacheCreationInputTokens) !== null && _state_cacheCreationInputTokens !== void 0 ? _state_cacheCreationInputTokens : 0) + ((_state_cacheReadInputTokens = state.cacheReadInputTokens) !== null && _state_cacheReadInputTokens !== void 0 ? _state_cacheReadInputTokens : 0);
    if (state.finishReasons.length) attrs[$akoBU.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(state.finishReasons);
    if (recordOutputs && state.responseTexts.length) attrs[$akoBU.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = state.responseTexts.join("");
    if (recordOutputs && state.toolCalls.length) attrs[$akoBU.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(state.toolCalls);
    span.setAttributes(attrs);
    span.end();
}
function $67a91106979a1bde$var$getJsonString(value) {
    if (typeof value === "string") return value;
    return JSON.stringify(value);
}
function $67a91106979a1bde$var$getTruncatedJsonString(value) {
    if (typeof value === "string") return $fE4qR.truncateGenAiStringInput(value);
    if (Array.isArray(value)) {
        const truncatedMessages = $fE4qR.truncateGenAiMessages(value);
        return JSON.stringify(truncatedMessages);
    }
    return JSON.stringify(value);
}
function $67a91106979a1bde$var$extractSystemInstructions(messages) {
    if (!Array.isArray(messages)) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemMessageIndex = messages.findIndex((msg)=>msg && typeof msg === "object" && "role" in msg && msg.role === "system");
    if (systemMessageIndex === -1) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemMessage = messages[systemMessageIndex];
    const systemContent = typeof systemMessage.content === "string" ? systemMessage.content : systemMessage.content !== void 0 ? JSON.stringify(systemMessage.content) : void 0;
    if (!systemContent) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemInstructions = JSON.stringify([
        {
            type: "text",
            content: systemContent
        }
    ]);
    const filteredMessages = [
        ...messages.slice(0, systemMessageIndex),
        ...messages.slice(systemMessageIndex + 1)
    ];
    return {
        systemInstructions: systemInstructions,
        filteredMessages: filteredMessages
    };
}
async function $67a91106979a1bde$var$createWithResponseWrapper(originalWithResponse, instrumentedPromise, mechanismType) {
    const safeOriginalWithResponse = originalWithResponse.catch((error)=>{
        $gHOmH.captureException(error, {
            mechanism: {
                handled: false,
                type: mechanismType
            }
        });
        throw error;
    });
    const instrumentedResult = await instrumentedPromise;
    const originalWrapper = await safeOriginalWithResponse;
    if (originalWrapper && typeof originalWrapper === "object" && "data" in originalWrapper) return (0, $2qxEV._)((0, $9tqwB._)({}, originalWrapper), {
        data: instrumentedResult
    });
    return instrumentedResult;
}
function $67a91106979a1bde$var$wrapPromiseWithMethods(originalPromiseLike, instrumentedPromise, mechanismType) {
    if (!$ibzbk.isThenable(originalPromiseLike)) return instrumentedPromise;
    return new Proxy(originalPromiseLike, {
        get (target, prop) {
            const useInstrumentedPromise = prop in Promise.prototype || prop === Symbol.toStringTag;
            const source = useInstrumentedPromise ? instrumentedPromise : target;
            const value = Reflect.get(source, prop);
            if (prop === "withResponse" && typeof value === "function") return function wrappedWithResponse() {
                const originalWithResponse = value.call(target);
                return $67a91106979a1bde$var$createWithResponseWrapper(originalWithResponse, instrumentedPromise, mechanismType);
            };
            return typeof value === "function" ? value.bind(source) : value;
        }
    });
}
module.exports.buildMethodPath = $67a91106979a1bde$var$buildMethodPath;
module.exports.endStreamSpan = $67a91106979a1bde$var$endStreamSpan;
module.exports.extractSystemInstructions = $67a91106979a1bde$var$extractSystemInstructions;
module.exports.getJsonString = $67a91106979a1bde$var$getJsonString;
module.exports.getTruncatedJsonString = $67a91106979a1bde$var$getTruncatedJsonString;
module.exports.resolveAIRecordingOptions = $67a91106979a1bde$var$resolveAIRecordingOptions;
module.exports.setTokenUsageAttributes = $67a91106979a1bde$var$setTokenUsageAttributes;
module.exports.shouldEnableTruncation = $67a91106979a1bde$var$shouldEnableTruncation;
module.exports.wrapPromiseWithMethods = $67a91106979a1bde$var$wrapPromiseWithMethods;

});
parcelRegister("akoBU", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $784edcc4b1c41486$var$GEN_AI_PROMPT_ATTRIBUTE = "gen_ai.prompt";
const $784edcc4b1c41486$var$GEN_AI_SYSTEM_ATTRIBUTE = "gen_ai.system";
const $784edcc4b1c41486$var$GEN_AI_REQUEST_MODEL_ATTRIBUTE = "gen_ai.request.model";
const $784edcc4b1c41486$var$GEN_AI_REQUEST_STREAM_ATTRIBUTE = "gen_ai.request.stream";
const $784edcc4b1c41486$var$GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE = "gen_ai.request.temperature";
const $784edcc4b1c41486$var$GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE = "gen_ai.request.max_tokens";
const $784edcc4b1c41486$var$GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE = "gen_ai.request.frequency_penalty";
const $784edcc4b1c41486$var$GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE = "gen_ai.request.presence_penalty";
const $784edcc4b1c41486$var$GEN_AI_REQUEST_TOP_P_ATTRIBUTE = "gen_ai.request.top_p";
const $784edcc4b1c41486$var$GEN_AI_REQUEST_TOP_K_ATTRIBUTE = "gen_ai.request.top_k";
const $784edcc4b1c41486$var$GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE = "gen_ai.request.encoding_format";
const $784edcc4b1c41486$var$GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE = "gen_ai.request.dimensions";
const $784edcc4b1c41486$var$GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE = "gen_ai.response.finish_reasons";
const $784edcc4b1c41486$var$GEN_AI_RESPONSE_MODEL_ATTRIBUTE = "gen_ai.response.model";
const $784edcc4b1c41486$var$GEN_AI_RESPONSE_ID_ATTRIBUTE = "gen_ai.response.id";
const $784edcc4b1c41486$var$GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE = "gen_ai.response.stop_reason";
const $784edcc4b1c41486$var$GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.input_tokens";
const $784edcc4b1c41486$var$GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.output_tokens";
const $784edcc4b1c41486$var$GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE = "gen_ai.usage.total_tokens";
const $784edcc4b1c41486$var$GEN_AI_OPERATION_NAME_ATTRIBUTE = "gen_ai.operation.name";
const $784edcc4b1c41486$var$GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = "sentry.sdk_meta.gen_ai.input.messages.original_length";
const $784edcc4b1c41486$var$GEN_AI_INPUT_MESSAGES_ATTRIBUTE = "gen_ai.input.messages";
const $784edcc4b1c41486$var$GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE = "gen_ai.output.messages";
const $784edcc4b1c41486$var$GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = "gen_ai.system_instructions";
const $784edcc4b1c41486$var$GEN_AI_RESPONSE_TEXT_ATTRIBUTE = "gen_ai.response.text";
const $784edcc4b1c41486$var$GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE = "gen_ai.request.available_tools";
const $784edcc4b1c41486$var$GEN_AI_RESPONSE_STREAMING_ATTRIBUTE = "gen_ai.response.streaming";
const $784edcc4b1c41486$var$GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = "gen_ai.response.tool_calls";
const $784edcc4b1c41486$var$GEN_AI_AGENT_NAME_ATTRIBUTE = "gen_ai.agent.name";
const $784edcc4b1c41486$var$GEN_AI_PIPELINE_NAME_ATTRIBUTE = "gen_ai.pipeline.name";
const $784edcc4b1c41486$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE = "gen_ai.conversation.id";
const $784edcc4b1c41486$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.cache_creation_input_tokens";
const $784edcc4b1c41486$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.cache_read_input_tokens";
const $784edcc4b1c41486$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE = "gen_ai.usage.input_tokens.cache_write";
const $784edcc4b1c41486$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE = "gen_ai.usage.input_tokens.cached";
const $784edcc4b1c41486$var$GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE = "gen_ai.invoke_agent";
const $784edcc4b1c41486$var$GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE = "gen_ai.embeddings.input";
const $784edcc4b1c41486$var$GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE = "gen_ai.embeddings";
const $784edcc4b1c41486$var$GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE = "gen_ai.execute_tool";
const $784edcc4b1c41486$var$GEN_AI_TOOL_NAME_ATTRIBUTE = "gen_ai.tool.name";
const $784edcc4b1c41486$var$GEN_AI_TOOL_CALL_ID_ATTRIBUTE = "gen_ai.tool.call.id";
const $784edcc4b1c41486$var$GEN_AI_TOOL_TYPE_ATTRIBUTE = "gen_ai.tool.type";
const $784edcc4b1c41486$var$GEN_AI_TOOL_INPUT_ATTRIBUTE = "gen_ai.tool.input";
const $784edcc4b1c41486$var$GEN_AI_TOOL_OUTPUT_ATTRIBUTE = "gen_ai.tool.output";
const $784edcc4b1c41486$var$GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE = "gen_ai.tool.description";
module.exports.GEN_AI_AGENT_NAME_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_AGENT_NAME_ATTRIBUTE;
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE;
module.exports.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_INPUT_MESSAGES_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_INPUT_MESSAGES_ATTRIBUTE;
module.exports.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE;
module.exports.GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_OPERATION_NAME_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_OPERATION_NAME_ATTRIBUTE;
module.exports.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE;
module.exports.GEN_AI_PIPELINE_NAME_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_PIPELINE_NAME_ATTRIBUTE;
module.exports.GEN_AI_PROMPT_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_PROMPT_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MODEL_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_REQUEST_MODEL_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_STREAM_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_REQUEST_STREAM_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TOP_K_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_REQUEST_TOP_K_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TOP_P_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_REQUEST_TOP_P_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_ID_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_RESPONSE_ID_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_MODEL_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_RESPONSE_MODEL_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_RESPONSE_STREAMING_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_TEXT_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_RESPONSE_TEXT_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_SYSTEM_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE;
module.exports.GEN_AI_TOOL_CALL_ID_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_TOOL_CALL_ID_ATTRIBUTE;
module.exports.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE;
module.exports.GEN_AI_TOOL_INPUT_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_TOOL_INPUT_ATTRIBUTE;
module.exports.GEN_AI_TOOL_NAME_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_TOOL_NAME_ATTRIBUTE;
module.exports.GEN_AI_TOOL_OUTPUT_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_TOOL_OUTPUT_ATTRIBUTE;
module.exports.GEN_AI_TOOL_TYPE_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_TOOL_TYPE_ATTRIBUTE;
module.exports.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE;
module.exports.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE = $784edcc4b1c41486$var$GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE;

});

parcelRegister("fE4qR", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $fPzlZ = parcelRequire("fPzlZ");
const $b63e079883d0633b$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT = 2e4;
const $b63e079883d0633b$var$utf8Bytes = (text)=>{
    return new TextEncoder().encode(text).length;
};
const $b63e079883d0633b$var$jsonBytes = (value)=>{
    return $b63e079883d0633b$var$utf8Bytes(JSON.stringify(value));
};
function $b63e079883d0633b$var$truncateTextByBytes(text, maxBytes) {
    if ($b63e079883d0633b$var$utf8Bytes(text) <= maxBytes) return text;
    let low = 0;
    let high = text.length;
    let bestFit = "";
    while(low <= high){
        const mid = Math.floor((low + high) / 2);
        const candidate = text.slice(0, mid);
        const byteSize = $b63e079883d0633b$var$utf8Bytes(candidate);
        if (byteSize <= maxBytes) {
            bestFit = candidate;
            low = mid + 1;
        } else high = mid - 1;
    }
    return bestFit;
}
function $b63e079883d0633b$var$getItemText(item) {
    if (typeof item === "string") return item;
    if ("text" in item && typeof item.text === "string") return item.text;
    return "";
}
function $b63e079883d0633b$var$withItemText(item, text) {
    if (typeof item === "string") return text;
    return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
        text: text
    });
}
function $b63e079883d0633b$var$isContentMessage(message) {
    return message !== null && typeof message === "object" && "content" in message && typeof message.content === "string";
}
function $b63e079883d0633b$var$isContentArrayMessage(message) {
    return message !== null && typeof message === "object" && "content" in message && Array.isArray(message.content);
}
function $b63e079883d0633b$var$isPartsMessage(message) {
    return message !== null && typeof message === "object" && "parts" in message && Array.isArray(message.parts) && message.parts.length > 0;
}
function $b63e079883d0633b$var$truncateContentMessage(message, maxBytes) {
    const emptyMessage = (0, $2qxEV._)((0, $9tqwB._)({}, message), {
        content: ""
    });
    const overhead = $b63e079883d0633b$var$jsonBytes(emptyMessage);
    const availableForContent = maxBytes - overhead;
    if (availableForContent <= 0) return [];
    const truncatedContent = $b63e079883d0633b$var$truncateTextByBytes(message.content, availableForContent);
    return [
        (0, $2qxEV._)((0, $9tqwB._)({}, message), {
            content: truncatedContent
        })
    ];
}
function $b63e079883d0633b$var$getArrayItems(message) {
    if ("parts" in message && Array.isArray(message.parts)) return {
        key: "parts",
        items: message.parts
    };
    if ("content" in message && Array.isArray(message.content)) return {
        key: "content",
        items: message.content
    };
    return {
        key: null,
        items: []
    };
}
function $b63e079883d0633b$var$truncateArrayMessage(message, maxBytes) {
    const { key: key, items: items } = $b63e079883d0633b$var$getArrayItems(message);
    if (key === null || items.length === 0) return [];
    const emptyItems = items.map((item)=>$b63e079883d0633b$var$withItemText(item, ""));
    const overhead = $b63e079883d0633b$var$jsonBytes((0, $2qxEV._)((0, $9tqwB._)({}, message), {
        [key]: emptyItems
    }));
    let remainingBytes = maxBytes - overhead;
    if (remainingBytes <= 0) return [];
    const includedItems = [];
    for (const item of items){
        const text = $b63e079883d0633b$var$getItemText(item);
        const textSize = $b63e079883d0633b$var$utf8Bytes(text);
        if (textSize <= remainingBytes) {
            includedItems.push(item);
            remainingBytes -= textSize;
        } else if (includedItems.length === 0) {
            const truncated = $b63e079883d0633b$var$truncateTextByBytes(text, remainingBytes);
            if (truncated) includedItems.push($b63e079883d0633b$var$withItemText(item, truncated));
            break;
        } else break;
    }
    if (includedItems.length <= 0) return [];
    else return [
        (0, $2qxEV._)((0, $9tqwB._)({}, message), {
            [key]: includedItems
        })
    ];
}
function $b63e079883d0633b$var$truncateSingleMessage(message, maxBytes) {
    if (!message) return [];
    if (typeof message === "string") {
        const truncated = $b63e079883d0633b$var$truncateTextByBytes(message, maxBytes);
        return truncated ? [
            truncated
        ] : [];
    }
    if (typeof message !== "object") return [];
    if ($b63e079883d0633b$var$isContentMessage(message)) return $b63e079883d0633b$var$truncateContentMessage(message, maxBytes);
    if ($b63e079883d0633b$var$isContentArrayMessage(message) || $b63e079883d0633b$var$isPartsMessage(message)) return $b63e079883d0633b$var$truncateArrayMessage(message, maxBytes);
    return [];
}
function $b63e079883d0633b$var$stripInlineMediaFromMessages(messages) {
    const stripped = messages.map((message)=>{
        let newMessage = void 0;
        if (!!message && typeof message === "object") {
            if ($b63e079883d0633b$var$isContentArrayMessage(message)) newMessage = (0, $2qxEV._)((0, $9tqwB._)({}, message), {
                content: $b63e079883d0633b$var$stripInlineMediaFromMessages(message.content)
            });
            else if ("content" in message && $fPzlZ.isContentMedia(message.content)) newMessage = (0, $2qxEV._)((0, $9tqwB._)({}, message), {
                content: $fPzlZ.stripInlineMediaFromSingleMessage(message.content)
            });
            if ($b63e079883d0633b$var$isPartsMessage(message)) newMessage = (0, $2qxEV._)((0, $9tqwB._)({}, newMessage !== null && newMessage !== void 0 ? newMessage : message), {
                parts: $b63e079883d0633b$var$stripInlineMediaFromMessages(message.parts)
            });
            if ($fPzlZ.isContentMedia(newMessage)) newMessage = $fPzlZ.stripInlineMediaFromSingleMessage(newMessage);
            else if ($fPzlZ.isContentMedia(message)) newMessage = $fPzlZ.stripInlineMediaFromSingleMessage(message);
        }
        return newMessage !== null && newMessage !== void 0 ? newMessage : message;
    });
    return stripped;
}
function $b63e079883d0633b$var$truncateMessagesByBytes(messages, maxBytes) {
    if (!Array.isArray(messages) || messages.length === 0) return messages;
    const effectiveMaxBytes = maxBytes - 2;
    const lastMessage = messages[messages.length - 1];
    const stripped = $b63e079883d0633b$var$stripInlineMediaFromMessages([
        lastMessage
    ]);
    const strippedMessage = stripped[0];
    const messageBytes = $b63e079883d0633b$var$jsonBytes(strippedMessage);
    if (messageBytes <= effectiveMaxBytes) return stripped;
    return $b63e079883d0633b$var$truncateSingleMessage(strippedMessage, effectiveMaxBytes);
}
function $b63e079883d0633b$var$truncateGenAiMessages(messages) {
    return $b63e079883d0633b$var$truncateMessagesByBytes(messages, $b63e079883d0633b$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
}
function $b63e079883d0633b$var$truncateGenAiStringInput(input) {
    return $b63e079883d0633b$var$truncateTextByBytes(input, $b63e079883d0633b$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
}
module.exports.DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT = $b63e079883d0633b$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT;
module.exports.truncateGenAiMessages = $b63e079883d0633b$var$truncateGenAiMessages;
module.exports.truncateGenAiStringInput = $b63e079883d0633b$var$truncateGenAiStringInput;

});
parcelRegister("fPzlZ", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $b8670af5608740f5$var$isContentMedia(part) {
    if (!part || typeof part !== "object") return false;
    return $b8670af5608740f5$var$isContentMediaSource(part) || $b8670af5608740f5$var$hasInlineData(part) || $b8670af5608740f5$var$hasImageUrl(part) || $b8670af5608740f5$var$hasInputAudio(part) || $b8670af5608740f5$var$hasFileData(part) || $b8670af5608740f5$var$hasMediaTypeData(part) || $b8670af5608740f5$var$hasVercelFileData(part) || $b8670af5608740f5$var$hasVercelImageData(part) || $b8670af5608740f5$var$hasBlobOrBase64Type(part) || $b8670af5608740f5$var$hasB64Json(part) || $b8670af5608740f5$var$hasImageGenerationResult(part) || $b8670af5608740f5$var$hasDataUri(part);
}
function $b8670af5608740f5$var$hasImageUrl(part) {
    if (!("image_url" in part)) return false;
    if (typeof part.image_url === "string") return part.image_url.startsWith("data:");
    return $b8670af5608740f5$var$hasNestedImageUrl(part);
}
function $b8670af5608740f5$var$hasNestedImageUrl(part) {
    return "image_url" in part && !!part.image_url && typeof part.image_url === "object" && "url" in part.image_url && typeof part.image_url.url === "string" && part.image_url.url.startsWith("data:");
}
function $b8670af5608740f5$var$isContentMediaSource(part) {
    return "type" in part && typeof part.type === "string" && "source" in part && $b8670af5608740f5$var$isContentMedia(part.source);
}
function $b8670af5608740f5$var$hasInlineData(part) {
    return "inlineData" in part && !!part.inlineData && typeof part.inlineData === "object" && "data" in part.inlineData && typeof part.inlineData.data === "string";
}
function $b8670af5608740f5$var$hasInputAudio(part) {
    return "type" in part && part.type === "input_audio" && "input_audio" in part && !!part.input_audio && typeof part.input_audio === "object" && "data" in part.input_audio && typeof part.input_audio.data === "string";
}
function $b8670af5608740f5$var$hasFileData(part) {
    return "type" in part && part.type === "file" && "file" in part && !!part.file && typeof part.file === "object" && "file_data" in part.file && typeof part.file.file_data === "string";
}
function $b8670af5608740f5$var$hasMediaTypeData(part) {
    return "media_type" in part && typeof part.media_type === "string" && "data" in part;
}
function $b8670af5608740f5$var$hasVercelFileData(part) {
    return "type" in part && part.type === "file" && "mediaType" in part && typeof part.mediaType === "string" && "data" in part && typeof part.data === "string" && // Only strip base64/binary data, not HTTP/HTTPS URLs which should be preserved as references
    !part.data.startsWith("http://") && !part.data.startsWith("https://");
}
function $b8670af5608740f5$var$hasVercelImageData(part) {
    return "type" in part && part.type === "image" && "image" in part && typeof part.image === "string" && // Only strip base64/data URIs, not HTTP/HTTPS URLs which should be preserved as references
    !part.image.startsWith("http://") && !part.image.startsWith("https://");
}
function $b8670af5608740f5$var$hasBlobOrBase64Type(part) {
    return "type" in part && (part.type === "blob" || part.type === "base64");
}
function $b8670af5608740f5$var$hasB64Json(part) {
    return "b64_json" in part;
}
function $b8670af5608740f5$var$hasImageGenerationResult(part) {
    return "type" in part && "result" in part && part.type === "image_generation";
}
function $b8670af5608740f5$var$hasDataUri(part) {
    return "uri" in part && typeof part.uri === "string" && part.uri.startsWith("data:");
}
const $b8670af5608740f5$var$REMOVED_STRING = "[Blob substitute]";
const $b8670af5608740f5$var$MEDIA_FIELDS = [
    "image_url",
    "data",
    "content",
    "b64_json",
    "result",
    "uri",
    "image"
];
function $b8670af5608740f5$var$stripInlineMediaFromSingleMessage(part) {
    const strip = (0, $9tqwB._)({}, part);
    if ($b8670af5608740f5$var$isContentMedia(strip.source)) strip.source = $b8670af5608740f5$var$stripInlineMediaFromSingleMessage(strip.source);
    if ($b8670af5608740f5$var$hasInlineData(part)) strip.inlineData = (0, $2qxEV._)((0, $9tqwB._)({}, part.inlineData), {
        data: $b8670af5608740f5$var$REMOVED_STRING
    });
    if ($b8670af5608740f5$var$hasNestedImageUrl(part)) strip.image_url = (0, $2qxEV._)((0, $9tqwB._)({}, part.image_url), {
        url: $b8670af5608740f5$var$REMOVED_STRING
    });
    if ($b8670af5608740f5$var$hasInputAudio(part)) strip.input_audio = (0, $2qxEV._)((0, $9tqwB._)({}, part.input_audio), {
        data: $b8670af5608740f5$var$REMOVED_STRING
    });
    if ($b8670af5608740f5$var$hasFileData(part)) strip.file = (0, $2qxEV._)((0, $9tqwB._)({}, part.file), {
        file_data: $b8670af5608740f5$var$REMOVED_STRING
    });
    for (const field of $b8670af5608740f5$var$MEDIA_FIELDS)if (typeof strip[field] === "string") strip[field] = $b8670af5608740f5$var$REMOVED_STRING;
    return strip;
}
module.exports.isContentMedia = $b8670af5608740f5$var$isContentMedia;
module.exports.stripInlineMediaFromSingleMessage = $b8670af5608740f5$var$stripInlineMediaFromSingleMessage;

});



parcelRegister("64Nq7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $46c973a07df14cfa$var$toolCallSpanContextMap = /* @__PURE__ */ new Map();
const $46c973a07df14cfa$var$toolDescriptionMap = /* @__PURE__ */ new Map();
const $46c973a07df14cfa$var$SPAN_TO_OPERATION_NAME = /* @__PURE__ */ new Map([
    [
        "ai.generateText",
        "invoke_agent"
    ],
    [
        "ai.streamText",
        "invoke_agent"
    ],
    [
        "ai.generateObject",
        "invoke_agent"
    ],
    [
        "ai.streamObject",
        "invoke_agent"
    ],
    [
        "ai.generateText.doGenerate",
        "generate_content"
    ],
    [
        "ai.streamText.doStream",
        "generate_content"
    ],
    [
        "ai.generateObject.doGenerate",
        "generate_content"
    ],
    [
        "ai.streamObject.doStream",
        "generate_content"
    ],
    [
        "ai.embed.doEmbed",
        "embeddings"
    ],
    [
        "ai.embedMany.doEmbed",
        "embeddings"
    ],
    [
        "ai.rerank.doRerank",
        "rerank"
    ],
    [
        "ai.toolCall",
        "execute_tool"
    ]
]);
module.exports.SPAN_TO_OPERATION_NAME = $46c973a07df14cfa$var$SPAN_TO_OPERATION_NAME;
module.exports.toolCallSpanContextMap = $46c973a07df14cfa$var$toolCallSpanContextMap;
module.exports.toolDescriptionMap = $46c973a07df14cfa$var$toolDescriptionMap;

});

parcelRegister("eWHcE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $akoBU = parcelRequire("akoBU");

var $8TMtR = parcelRequire("8TMtR");

var $64Nq7 = parcelRequire("64Nq7");

var $1dj8F = parcelRequire("1dj8F");
function $ae17feb0668a7b47$var$accumulateTokensForParent(span, tokenAccumulator) {
    const parentSpanId = span.parent_span_id;
    if (!parentSpanId) return;
    const inputTokens = span.data[$akoBU.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE];
    const outputTokens = span.data[$akoBU.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE];
    if (typeof inputTokens === "number" || typeof outputTokens === "number") {
        const existing = tokenAccumulator.get(parentSpanId) || {
            inputTokens: 0,
            outputTokens: 0
        };
        if (typeof inputTokens === "number") existing.inputTokens += inputTokens;
        if (typeof outputTokens === "number") existing.outputTokens += outputTokens;
        tokenAccumulator.set(parentSpanId, existing);
    }
}
function $ae17feb0668a7b47$var$applyAccumulatedTokens(spanOrTrace, tokenAccumulator) {
    const accumulated = tokenAccumulator.get(spanOrTrace.span_id);
    if (!accumulated || !spanOrTrace.data) return;
    if (accumulated.inputTokens > 0) spanOrTrace.data[$akoBU.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = accumulated.inputTokens;
    if (accumulated.outputTokens > 0) spanOrTrace.data[$akoBU.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = accumulated.outputTokens;
    if (accumulated.inputTokens > 0 || accumulated.outputTokens > 0) spanOrTrace.data["gen_ai.usage.total_tokens"] = accumulated.inputTokens + accumulated.outputTokens;
}
function $ae17feb0668a7b47$var$buildToolDescriptionMap(spans) {
    const toolDescriptions = /* @__PURE__ */ new Map();
    for (const span of spans){
        const availableTools = span.data[$akoBU.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE];
        if (typeof availableTools !== "string") continue;
        try {
            const tools = JSON.parse(availableTools);
            for (const tool of tools)if (tool.name && tool.description && !toolDescriptions.has(tool.name)) toolDescriptions.set(tool.name, tool.description);
        } catch (e) {}
    }
    return toolDescriptions;
}
function $ae17feb0668a7b47$var$applyToolDescriptionsAndTokens(spans, tokenAccumulator) {
    const toolDescriptions = $ae17feb0668a7b47$var$buildToolDescriptionMap(spans);
    for (const span of spans){
        if (span.op === "gen_ai.execute_tool") {
            const toolName = span.data[$akoBU.GEN_AI_TOOL_NAME_ATTRIBUTE];
            if (typeof toolName === "string") {
                const description = toolDescriptions.get(toolName);
                if (description) span.data[$akoBU.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = description;
            }
        }
        if (span.op === "gen_ai.invoke_agent") $ae17feb0668a7b47$var$applyAccumulatedTokens(span, tokenAccumulator);
    }
}
function $ae17feb0668a7b47$var$_INTERNAL_getSpanContextForToolCallId(toolCallId) {
    return $64Nq7.toolCallSpanContextMap.get(toolCallId);
}
function $ae17feb0668a7b47$var$_INTERNAL_cleanupToolCallSpanContext(toolCallId) {
    $64Nq7.toolCallSpanContextMap.delete(toolCallId);
}
function $ae17feb0668a7b47$var$convertAvailableToolsToJsonString(tools) {
    const toolObjects = tools.map((tool)=>{
        if (typeof tool === "string") try {
            return JSON.parse(tool);
        } catch (e) {
            return tool;
        }
        return tool;
    });
    return JSON.stringify(toolObjects);
}
function $ae17feb0668a7b47$var$filterMessagesArray(input) {
    return input.filter((m)=>!!m && typeof m === "object" && "role" in m && "content" in m);
}
function $ae17feb0668a7b47$var$convertUserInputToMessagesFormat(userInput) {
    try {
        const p = JSON.parse(userInput);
        if (!!p && typeof p === "object") {
            let { messages: messages } = p;
            const { prompt: prompt, system: system } = p;
            const result = [];
            if (typeof system === "string") result.push({
                role: "system",
                content: system
            });
            if (typeof messages === "string") try {
                messages = JSON.parse(messages);
            } catch (e) {}
            if (Array.isArray(messages)) {
                result.push(...$ae17feb0668a7b47$var$filterMessagesArray(messages));
                return result;
            }
            if (Array.isArray(prompt)) {
                result.push(...$ae17feb0668a7b47$var$filterMessagesArray(prompt));
                return result;
            }
            if (typeof prompt === "string") result.push({
                role: "user",
                content: prompt
            });
            if (result.length > 0) return result;
        }
    } catch (e) {}
    return [];
}
function $ae17feb0668a7b47$var$requestMessagesFromPrompt(span, attributes, enableTruncation) {
    if (typeof attributes[$1dj8F.AI_PROMPT_ATTRIBUTE] === "string" && !attributes[$akoBU.GEN_AI_INPUT_MESSAGES_ATTRIBUTE] && !attributes[$1dj8F.AI_PROMPT_MESSAGES_ATTRIBUTE]) {
        const userInput = attributes[$1dj8F.AI_PROMPT_ATTRIBUTE];
        const messages = $ae17feb0668a7b47$var$convertUserInputToMessagesFormat(userInput);
        if (messages.length) {
            const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $8TMtR.extractSystemInstructions(messages);
            if (systemInstructions) span.setAttribute($akoBU.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
            const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
            const messagesJson = enableTruncation ? $8TMtR.getTruncatedJsonString(filteredMessages) : $8TMtR.getJsonString(filteredMessages);
            span.setAttributes({
                [$1dj8F.AI_PROMPT_ATTRIBUTE]: messagesJson,
                [$akoBU.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: messagesJson,
                [$akoBU.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
            });
        }
    } else if (typeof attributes[$1dj8F.AI_PROMPT_MESSAGES_ATTRIBUTE] === "string") {
        const originalMessagesJson = attributes[$1dj8F.AI_PROMPT_MESSAGES_ATTRIBUTE];
        try {
            const messages = JSON.parse(originalMessagesJson);
            if (Array.isArray(messages)) {
                const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $8TMtR.extractSystemInstructions(messages);
                if (systemInstructions) span.setAttribute($akoBU.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
                const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
                const messagesJson = !enableTruncation && filteredMessages === messages ? originalMessagesJson : enableTruncation ? $8TMtR.getTruncatedJsonString(filteredMessages) : $8TMtR.getJsonString(filteredMessages);
                span.setAttributes({
                    [$1dj8F.AI_PROMPT_MESSAGES_ATTRIBUTE]: messagesJson,
                    [$akoBU.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: messagesJson,
                    [$akoBU.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
                });
            }
        } catch (e) {}
    }
}
module.exports._INTERNAL_cleanupToolCallSpanContext = $ae17feb0668a7b47$var$_INTERNAL_cleanupToolCallSpanContext;
module.exports._INTERNAL_getSpanContextForToolCallId = $ae17feb0668a7b47$var$_INTERNAL_getSpanContextForToolCallId;
module.exports.accumulateTokensForParent = $ae17feb0668a7b47$var$accumulateTokensForParent;
module.exports.applyAccumulatedTokens = $ae17feb0668a7b47$var$applyAccumulatedTokens;
module.exports.applyToolDescriptionsAndTokens = $ae17feb0668a7b47$var$applyToolDescriptionsAndTokens;
module.exports.convertAvailableToolsToJsonString = $ae17feb0668a7b47$var$convertAvailableToolsToJsonString;
module.exports.convertUserInputToMessagesFormat = $ae17feb0668a7b47$var$convertUserInputToMessagesFormat;
module.exports.requestMessagesFromPrompt = $ae17feb0668a7b47$var$requestMessagesFromPrompt;

});
parcelRegister("1dj8F", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $0e25d9e64af59000$var$OPERATION_NAME_ATTRIBUTE = "operation.name";
const $0e25d9e64af59000$var$AI_OPERATION_ID_ATTRIBUTE = "ai.operationId";
const $0e25d9e64af59000$var$AI_PROMPT_ATTRIBUTE = "ai.prompt";
const $0e25d9e64af59000$var$AI_SCHEMA_ATTRIBUTE = "ai.schema";
const $0e25d9e64af59000$var$AI_RESPONSE_OBJECT_ATTRIBUTE = "ai.response.object";
const $0e25d9e64af59000$var$AI_VALUES_ATTRIBUTE = "ai.values";
const $0e25d9e64af59000$var$AI_RESPONSE_TEXT_ATTRIBUTE = "ai.response.text";
const $0e25d9e64af59000$var$AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = "ai.response.toolCalls";
const $0e25d9e64af59000$var$AI_RESPONSE_FINISH_REASON_ATTRIBUTE = "ai.response.finishReason";
const $0e25d9e64af59000$var$AI_PROMPT_MESSAGES_ATTRIBUTE = "ai.prompt.messages";
const $0e25d9e64af59000$var$AI_PROMPT_TOOLS_ATTRIBUTE = "ai.prompt.tools";
const $0e25d9e64af59000$var$AI_MODEL_ID_ATTRIBUTE = "ai.model.id";
const $0e25d9e64af59000$var$AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE = "ai.response.providerMetadata";
const $0e25d9e64af59000$var$AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE = "ai.usage.cachedInputTokens";
const $0e25d9e64af59000$var$AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX = "ai.usage.inputTokenDetails.";
const $0e25d9e64af59000$var$AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE = "ai.telemetry.functionId";
const $0e25d9e64af59000$var$AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE = "ai.usage.completionTokens";
const $0e25d9e64af59000$var$AI_USAGE_PROMPT_TOKENS_ATTRIBUTE = "ai.usage.promptTokens";
const $0e25d9e64af59000$var$AI_USAGE_TOKENS_ATTRIBUTE = "ai.usage.tokens";
const $0e25d9e64af59000$var$AI_TOOL_CALL_NAME_ATTRIBUTE = "ai.toolCall.name";
const $0e25d9e64af59000$var$AI_TOOL_CALL_ID_ATTRIBUTE = "ai.toolCall.id";
const $0e25d9e64af59000$var$AI_TOOL_CALL_ARGS_ATTRIBUTE = "ai.toolCall.args";
const $0e25d9e64af59000$var$AI_TOOL_CALL_RESULT_ATTRIBUTE = "ai.toolCall.result";
module.exports.AI_MODEL_ID_ATTRIBUTE = $0e25d9e64af59000$var$AI_MODEL_ID_ATTRIBUTE;
module.exports.AI_OPERATION_ID_ATTRIBUTE = $0e25d9e64af59000$var$AI_OPERATION_ID_ATTRIBUTE;
module.exports.AI_PROMPT_ATTRIBUTE = $0e25d9e64af59000$var$AI_PROMPT_ATTRIBUTE;
module.exports.AI_PROMPT_MESSAGES_ATTRIBUTE = $0e25d9e64af59000$var$AI_PROMPT_MESSAGES_ATTRIBUTE;
module.exports.AI_PROMPT_TOOLS_ATTRIBUTE = $0e25d9e64af59000$var$AI_PROMPT_TOOLS_ATTRIBUTE;
module.exports.AI_RESPONSE_FINISH_REASON_ATTRIBUTE = $0e25d9e64af59000$var$AI_RESPONSE_FINISH_REASON_ATTRIBUTE;
module.exports.AI_RESPONSE_OBJECT_ATTRIBUTE = $0e25d9e64af59000$var$AI_RESPONSE_OBJECT_ATTRIBUTE;
module.exports.AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE = $0e25d9e64af59000$var$AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE;
module.exports.AI_RESPONSE_TEXT_ATTRIBUTE = $0e25d9e64af59000$var$AI_RESPONSE_TEXT_ATTRIBUTE;
module.exports.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = $0e25d9e64af59000$var$AI_RESPONSE_TOOL_CALLS_ATTRIBUTE;
module.exports.AI_SCHEMA_ATTRIBUTE = $0e25d9e64af59000$var$AI_SCHEMA_ATTRIBUTE;
module.exports.AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE = $0e25d9e64af59000$var$AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE;
module.exports.AI_TOOL_CALL_ARGS_ATTRIBUTE = $0e25d9e64af59000$var$AI_TOOL_CALL_ARGS_ATTRIBUTE;
module.exports.AI_TOOL_CALL_ID_ATTRIBUTE = $0e25d9e64af59000$var$AI_TOOL_CALL_ID_ATTRIBUTE;
module.exports.AI_TOOL_CALL_NAME_ATTRIBUTE = $0e25d9e64af59000$var$AI_TOOL_CALL_NAME_ATTRIBUTE;
module.exports.AI_TOOL_CALL_RESULT_ATTRIBUTE = $0e25d9e64af59000$var$AI_TOOL_CALL_RESULT_ATTRIBUTE;
module.exports.AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE = $0e25d9e64af59000$var$AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE = $0e25d9e64af59000$var$AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX = $0e25d9e64af59000$var$AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX;
module.exports.AI_USAGE_PROMPT_TOKENS_ATTRIBUTE = $0e25d9e64af59000$var$AI_USAGE_PROMPT_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_TOKENS_ATTRIBUTE = $0e25d9e64af59000$var$AI_USAGE_TOKENS_ATTRIBUTE;
module.exports.AI_VALUES_ATTRIBUTE = $0e25d9e64af59000$var$AI_VALUES_ATTRIBUTE;
module.exports.OPERATION_NAME_ATTRIBUTE = $0e25d9e64af59000$var$OPERATION_NAME_ATTRIBUTE;

});



parcelRegister("5o3Je", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $859Bb = parcelRequire("859Bb");

var $gHOmH = parcelRequire("gHOmH");

var $faX3S = parcelRequire("faX3S");

var $hQAU7 = parcelRequire("hQAU7");

var $eqMxV = parcelRequire("eqMxV");

var $gvNu3 = parcelRequire("gvNu3");

var $akoBU = parcelRequire("akoBU");

var $8TMtR = parcelRequire("8TMtR");

var $aP461 = parcelRequire("aP461");

var $jgJlt = parcelRequire("jgJlt");

var $bynJN = parcelRequire("bynJN");
function $3ec2160c204f467c$var$extractAvailableTools(params) {
    const tools = Array.isArray(params.tools) ? params.tools : [];
    const hasWebSearchOptions = params.web_search_options && typeof params.web_search_options === "object";
    const webSearchOptions = hasWebSearchOptions ? [
        (0, $9tqwB._)({
            type: "web_search_options"
        }, params.web_search_options)
    ] : [];
    const availableTools = [
        ...tools,
        ...webSearchOptions
    ];
    if (availableTools.length === 0) return void 0;
    try {
        return JSON.stringify(availableTools);
    } catch (error) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.error("Failed to serialize OpenAI tools:", error);
        return void 0;
    }
}
function $3ec2160c204f467c$var$extractRequestAttributes(args, operationName) {
    const attributes = {
        [$akoBU.GEN_AI_SYSTEM_ATTRIBUTE]: "openai",
        [$akoBU.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.openai"
    };
    if (args.length > 0 && typeof args[0] === "object" && args[0] !== null) {
        const params = args[0];
        const availableTools = $3ec2160c204f467c$var$extractAvailableTools(params);
        if (availableTools) attributes[$akoBU.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = availableTools;
        Object.assign(attributes, $bynJN.extractRequestParameters(params));
    } else attributes[$akoBU.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = "unknown";
    return attributes;
}
function $3ec2160c204f467c$var$addRequestAttributes(span, params, operationName, enableTruncation) {
    if (operationName === "embeddings" && "input" in params) {
        const input = params.input;
        if (input == null) return;
        if (typeof input === "string" && input.length === 0) return;
        if (Array.isArray(input) && input.length === 0) return;
        span.setAttribute($akoBU.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE, typeof input === "string" ? input : JSON.stringify(input));
        return;
    }
    const src = "input" in params ? params.input : "messages" in params ? params.messages : void 0;
    if (!src) return;
    if (Array.isArray(src) && src.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $8TMtR.extractSystemInstructions(src);
    if (systemInstructions) span.setAttribute($akoBU.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
    span.setAttribute($akoBU.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $8TMtR.getTruncatedJsonString(filteredMessages) : $8TMtR.getJsonString(filteredMessages));
    if (Array.isArray(filteredMessages)) span.setAttribute($akoBU.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, filteredMessages.length);
    else span.setAttribute($akoBU.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, 1);
}
function $3ec2160c204f467c$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    return function instrumentedCall(...args) {
        const operationName = instrumentedMethod.operation || "unknown";
        const requestAttributes = $3ec2160c204f467c$var$extractRequestAttributes(args, operationName);
        const model = requestAttributes[$akoBU.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || "unknown";
        const params = args[0];
        const isStreamRequested = params && typeof params === "object" && params.stream === true;
        const spanConfig = {
            name: `${operationName} ${model}`,
            op: `gen_ai.${operationName}`,
            attributes: requestAttributes
        };
        if (isStreamRequested) {
            let originalResult2;
            const instrumentedPromise2 = $gvNu3.startSpanManual(spanConfig, (span)=>{
                originalResult2 = originalMethod.apply(context, args);
                if (options.recordInputs && params) $3ec2160c204f467c$var$addRequestAttributes(span, params, operationName, $8TMtR.shouldEnableTruncation(options.enableTruncation));
                return (async ()=>{
                    try {
                        const result = await originalResult2;
                        var _options_recordOutputs;
                        return $jgJlt.instrumentStream(result, span, (_options_recordOutputs = options.recordOutputs) !== null && _options_recordOutputs !== void 0 ? _options_recordOutputs : false);
                    } catch (error) {
                        span.setStatus({
                            code: $eqMxV.SPAN_STATUS_ERROR,
                            message: "internal_error"
                        });
                        $gHOmH.captureException(error, {
                            mechanism: {
                                handled: false,
                                type: "auto.ai.openai.stream",
                                data: {
                                    function: methodPath
                                }
                            }
                        });
                        span.end();
                        throw error;
                    }
                })();
            });
            return $8TMtR.wrapPromiseWithMethods(originalResult2, instrumentedPromise2, "auto.ai.openai");
        }
        let originalResult;
        const instrumentedPromise = $gvNu3.startSpan(spanConfig, (span)=>{
            originalResult = originalMethod.apply(context, args);
            if (options.recordInputs && params) $3ec2160c204f467c$var$addRequestAttributes(span, params, operationName, $8TMtR.shouldEnableTruncation(options.enableTruncation));
            return originalResult.then((result)=>{
                $bynJN.addResponseAttributes(span, result, options.recordOutputs);
                return result;
            }, (error)=>{
                $gHOmH.captureException(error, {
                    mechanism: {
                        handled: false,
                        type: "auto.ai.openai",
                        data: {
                            function: methodPath
                        }
                    }
                });
                throw error;
            });
        });
        return $8TMtR.wrapPromiseWithMethods(originalResult, instrumentedPromise, "auto.ai.openai");
    };
}
function $3ec2160c204f467c$var$createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get (obj, prop) {
            const value = obj[prop];
            const methodPath = $8TMtR.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $aP461.OPENAI_METHOD_REGISTRY[methodPath];
            if (typeof value === "function" && instrumentedMethod) return $3ec2160c204f467c$var$instrumentMethod(value, methodPath, instrumentedMethod, obj, options);
            if (typeof value === "function") return value.bind(obj);
            if (value && typeof value === "object") return $3ec2160c204f467c$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
function $3ec2160c204f467c$var$instrumentOpenAiClient(client, options) {
    return $3ec2160c204f467c$var$createDeepProxy(client, "", $8TMtR.resolveAIRecordingOptions(options));
}
module.exports.instrumentOpenAiClient = $3ec2160c204f467c$var$instrumentOpenAiClient;

});
parcelRegister("aP461", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $7e11d8361f53de55$var$OPENAI_INTEGRATION_NAME = "OpenAI";
const $7e11d8361f53de55$var$OPENAI_METHOD_REGISTRY = {
    "responses.create": {
        operation: "chat"
    },
    "chat.completions.create": {
        operation: "chat"
    },
    "embeddings.create": {
        operation: "embeddings"
    },
    // Conversations API - for conversation state management
    // https://platform.openai.com/docs/guides/conversation-state
    "conversations.create": {
        operation: "chat"
    }
};
const $7e11d8361f53de55$var$RESPONSES_TOOL_CALL_EVENT_TYPES = [
    "response.output_item.added",
    "response.function_call_arguments.delta",
    "response.function_call_arguments.done",
    "response.output_item.done"
];
const $7e11d8361f53de55$var$RESPONSE_EVENT_TYPES = [
    "response.created",
    "response.in_progress",
    "response.failed",
    "response.completed",
    "response.incomplete",
    "response.queued",
    "response.output_text.delta",
    ...$7e11d8361f53de55$var$RESPONSES_TOOL_CALL_EVENT_TYPES
];
module.exports.OPENAI_INTEGRATION_NAME = $7e11d8361f53de55$var$OPENAI_INTEGRATION_NAME;
module.exports.OPENAI_METHOD_REGISTRY = $7e11d8361f53de55$var$OPENAI_METHOD_REGISTRY;
module.exports.RESPONSES_TOOL_CALL_EVENT_TYPES = $7e11d8361f53de55$var$RESPONSES_TOOL_CALL_EVENT_TYPES;
module.exports.RESPONSE_EVENT_TYPES = $7e11d8361f53de55$var$RESPONSE_EVENT_TYPES;

});

parcelRegister("jgJlt", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gHOmH = parcelRequire("gHOmH");

var $eqMxV = parcelRequire("eqMxV");

var $8TMtR = parcelRequire("8TMtR");

var $aP461 = parcelRequire("aP461");

var $bynJN = parcelRequire("bynJN");
function $e072af978a104311$var$processChatCompletionToolCalls(toolCalls, state) {
    for (const toolCall of toolCalls){
        const index = toolCall.index;
        if (index === void 0 || !toolCall.function) continue;
        if (!(index in state.chatCompletionToolCalls)) state.chatCompletionToolCalls[index] = (0, $2qxEV._)((0, $9tqwB._)({}, toolCall), {
            function: {
                name: toolCall.function.name,
                arguments: toolCall.function.arguments || ""
            }
        });
        else {
            const existingToolCall = state.chatCompletionToolCalls[index];
            if (toolCall.function.arguments && (existingToolCall === null || existingToolCall === void 0 ? void 0 : existingToolCall.function)) existingToolCall.function.arguments += toolCall.function.arguments;
        }
    }
}
function $e072af978a104311$var$processChatCompletionChunk(chunk, state, recordOutputs) {
    var _chunk_id;
    state.responseId = (_chunk_id = chunk.id) !== null && _chunk_id !== void 0 ? _chunk_id : state.responseId;
    var _chunk_model;
    state.responseModel = (_chunk_model = chunk.model) !== null && _chunk_model !== void 0 ? _chunk_model : state.responseModel;
    if (chunk.usage) {
        state.promptTokens = chunk.usage.prompt_tokens;
        state.completionTokens = chunk.usage.completion_tokens;
        state.totalTokens = chunk.usage.total_tokens;
    }
    var _chunk_choices;
    for (const choice of (_chunk_choices = chunk.choices) !== null && _chunk_choices !== void 0 ? _chunk_choices : []){
        if (recordOutputs) {
            var _choice_delta, _choice_delta1;
            if ((_choice_delta = choice.delta) === null || _choice_delta === void 0 ? void 0 : _choice_delta.content) state.responseTexts.push(choice.delta.content);
            if ((_choice_delta1 = choice.delta) === null || _choice_delta1 === void 0 ? void 0 : _choice_delta1.tool_calls) $e072af978a104311$var$processChatCompletionToolCalls(choice.delta.tool_calls, state);
        }
        if (choice.finish_reason) state.finishReasons.push(choice.finish_reason);
    }
}
function $e072af978a104311$var$processResponsesApiEvent(streamEvent, state, recordOutputs, span) {
    if (!(streamEvent && typeof streamEvent === "object")) {
        state.eventTypes.push("unknown:non-object");
        return;
    }
    if (streamEvent instanceof Error) {
        span.setStatus({
            code: $eqMxV.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        $gHOmH.captureException(streamEvent, {
            mechanism: {
                handled: false,
                type: "auto.ai.openai.stream-response"
            }
        });
        return;
    }
    if (!("type" in streamEvent)) return;
    const event = streamEvent;
    if (!$aP461.RESPONSE_EVENT_TYPES.includes(event.type)) {
        state.eventTypes.push(event.type);
        return;
    }
    if (recordOutputs) {
        if (event.type === "response.output_item.done" && "item" in event) state.responsesApiToolCalls.push(event.item);
        if (event.type === "response.output_text.delta" && "delta" in event && event.delta) {
            state.responseTexts.push(event.delta);
            return;
        }
    }
    if ("response" in event) {
        const { response: response } = event;
        var _response_id;
        state.responseId = (_response_id = response.id) !== null && _response_id !== void 0 ? _response_id : state.responseId;
        var _response_model;
        state.responseModel = (_response_model = response.model) !== null && _response_model !== void 0 ? _response_model : state.responseModel;
        if (response.usage) {
            state.promptTokens = response.usage.input_tokens;
            state.completionTokens = response.usage.output_tokens;
            state.totalTokens = response.usage.total_tokens;
        }
        if (response.status) state.finishReasons.push(response.status);
        if (recordOutputs && response.output_text) state.responseTexts.push(response.output_text);
    }
}
async function* $e072af978a104311$var$instrumentStream(stream, span, recordOutputs) {
    const state = {
        eventTypes: [],
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        totalTokens: void 0,
        chatCompletionToolCalls: {},
        responsesApiToolCalls: []
    };
    try {
        for await (const event of stream){
            if ($bynJN.isChatCompletionChunk(event)) $e072af978a104311$var$processChatCompletionChunk(event, state, recordOutputs);
            else if ($bynJN.isResponsesApiStreamEvent(event)) $e072af978a104311$var$processResponsesApiEvent(event, state, recordOutputs, span);
            yield event;
        }
    } finally{
        const allToolCalls = [
            ...Object.values(state.chatCompletionToolCalls),
            ...state.responsesApiToolCalls
        ];
        $8TMtR.endStreamSpan(span, (0, $2qxEV._)((0, $9tqwB._)({}, state), {
            toolCalls: allToolCalls
        }), recordOutputs);
    }
}
module.exports.instrumentStream = $e072af978a104311$var$instrumentStream;

});
parcelRegister("bynJN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $akoBU = parcelRequire("akoBU");
function $869548790bb0d291$var$isResponsesApiStreamEvent(event) {
    return event !== null && typeof event === "object" && "type" in event && typeof event.type === "string" && event.type.startsWith("response.");
}
function $869548790bb0d291$var$isChatCompletionChunk(event) {
    return event !== null && typeof event === "object" && "object" in event && event.object === "chat.completion.chunk";
}
function $869548790bb0d291$var$addResponseAttributes(span, result, recordOutputs) {
    if (!result || typeof result !== "object") return;
    const response = result;
    const attrs = {};
    if (typeof response.id === "string") attrs[$akoBU.GEN_AI_RESPONSE_ID_ATTRIBUTE] = response.id;
    if (typeof response.model === "string") attrs[$akoBU.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = response.model;
    if (response.object === "conversation" && typeof response.id === "string") attrs[$akoBU.GEN_AI_CONVERSATION_ID_ATTRIBUTE] = response.id;
    if (response.usage && typeof response.usage === "object") {
        const usage = response.usage;
        var _usage_prompt_tokens;
        const inputTokens = (_usage_prompt_tokens = usage.prompt_tokens) !== null && _usage_prompt_tokens !== void 0 ? _usage_prompt_tokens : usage.input_tokens;
        if (typeof inputTokens === "number") attrs[$akoBU.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = inputTokens;
        var _usage_completion_tokens;
        const outputTokens = (_usage_completion_tokens = usage.completion_tokens) !== null && _usage_completion_tokens !== void 0 ? _usage_completion_tokens : usage.output_tokens;
        if (typeof outputTokens === "number") attrs[$akoBU.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = outputTokens;
        if (typeof usage.total_tokens === "number") attrs[$akoBU.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = usage.total_tokens;
    }
    if (Array.isArray(response.choices)) {
        const choices = response.choices;
        const finishReasons = choices.map((choice)=>choice.finish_reason).filter((reason)=>typeof reason === "string");
        if (finishReasons.length > 0) attrs[$akoBU.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(finishReasons);
        if (recordOutputs) {
            const responseTexts = choices.map((choice)=>{
                const message = choice.message;
                return (message === null || message === void 0 ? void 0 : message.content) || "";
            });
            attrs[$akoBU.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = JSON.stringify(responseTexts);
            const toolCalls = choices.map((choice)=>{
                const message = choice.message;
                return message === null || message === void 0 ? void 0 : message.tool_calls;
            }).filter((calls)=>Array.isArray(calls) && calls.length > 0).flat();
            if (toolCalls.length > 0) attrs[$akoBU.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(toolCalls);
        }
    }
    if (typeof response.status === "string") {
        if (!attrs[$akoBU.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE]) attrs[$akoBU.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify([
            response.status
        ]);
    }
    if (recordOutputs) {
        if (typeof response.output_text === "string" && !attrs[$akoBU.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]) attrs[$akoBU.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = response.output_text;
        if (Array.isArray(response.output) && response.output.length > 0 && !attrs[$akoBU.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]) {
            const functionCalls = response.output.filter((item)=>(item === null || item === void 0 ? void 0 : item.type) === "function_call");
            if (functionCalls.length > 0) attrs[$akoBU.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(functionCalls);
        }
    }
    span.setAttributes(attrs);
}
function $869548790bb0d291$var$extractConversationId(params) {
    if ("conversation" in params && typeof params.conversation === "string") return params.conversation;
    if ("previous_response_id" in params && typeof params.previous_response_id === "string") return params.previous_response_id;
    return void 0;
}
function $869548790bb0d291$var$extractRequestParameters(params) {
    var _params_model;
    const attributes = {
        [$akoBU.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: (_params_model = params.model) !== null && _params_model !== void 0 ? _params_model : "unknown"
    };
    if ("temperature" in params) attributes[$akoBU.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
    if ("top_p" in params) attributes[$akoBU.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
    if ("frequency_penalty" in params) attributes[$akoBU.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
    if ("presence_penalty" in params) attributes[$akoBU.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = params.presence_penalty;
    if ("stream" in params) attributes[$akoBU.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
    if ("encoding_format" in params) attributes[$akoBU.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = params.encoding_format;
    if ("dimensions" in params) attributes[$akoBU.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = params.dimensions;
    const conversationId = $869548790bb0d291$var$extractConversationId(params);
    if (conversationId) attributes[$akoBU.GEN_AI_CONVERSATION_ID_ATTRIBUTE] = conversationId;
    return attributes;
}
module.exports.addResponseAttributes = $869548790bb0d291$var$addResponseAttributes;
module.exports.extractRequestParameters = $869548790bb0d291$var$extractRequestParameters;
module.exports.isChatCompletionChunk = $869548790bb0d291$var$isChatCompletionChunk;
module.exports.isResponsesApiStreamEvent = $869548790bb0d291$var$isResponsesApiStreamEvent;

});



parcelRegister("jJ8lq", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gHOmH = parcelRequire("gHOmH");

var $faX3S = parcelRequire("faX3S");

var $eqMxV = parcelRequire("eqMxV");

var $gvNu3 = parcelRequire("gvNu3");

var $akoBU = parcelRequire("akoBU");

var $8TMtR = parcelRequire("8TMtR");

var $6KwFW = parcelRequire("6KwFW");

var $kKEFR = parcelRequire("kKEFR");

var $fO1m6 = parcelRequire("fO1m6");
function $e5c8b15f64a47a3e$var$extractRequestAttributes(args, methodPath, operationName) {
    const attributes = {
        [$akoBU.GEN_AI_SYSTEM_ATTRIBUTE]: "anthropic",
        [$akoBU.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.anthropic"
    };
    if (args.length > 0 && typeof args[0] === "object" && args[0] !== null) {
        const params = args[0];
        if (params.tools && Array.isArray(params.tools)) attributes[$akoBU.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(params.tools);
        var _params_model;
        attributes[$akoBU.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = (_params_model = params.model) !== null && _params_model !== void 0 ? _params_model : "unknown";
        if ("temperature" in params) attributes[$akoBU.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
        if ("top_p" in params) attributes[$akoBU.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
        if ("stream" in params) attributes[$akoBU.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
        if ("top_k" in params) attributes[$akoBU.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = params.top_k;
        if ("frequency_penalty" in params) attributes[$akoBU.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
        if ("max_tokens" in params) attributes[$akoBU.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = params.max_tokens;
    } else if (methodPath === "models.retrieve" || methodPath === "models.get") attributes[$akoBU.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = args[0];
    else attributes[$akoBU.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = "unknown";
    return attributes;
}
function $e5c8b15f64a47a3e$var$addPrivateRequestAttributes(span, params, enableTruncation) {
    const messages = $fO1m6.messagesFromParams(params);
    $fO1m6.setMessagesAttribute(span, messages, enableTruncation);
    if ("prompt" in params) span.setAttributes({
        [$akoBU.GEN_AI_PROMPT_ATTRIBUTE]: JSON.stringify(params.prompt)
    });
}
function $e5c8b15f64a47a3e$var$addContentAttributes(span, response) {
    if ("content" in response) {
        if (Array.isArray(response.content)) {
            span.setAttributes({
                [$akoBU.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: response.content.map((item)=>item.text).filter((text)=>!!text).join("")
            });
            const toolCalls = [];
            for (const item of response.content)if (item.type === "tool_use" || item.type === "server_tool_use") toolCalls.push(item);
            if (toolCalls.length > 0) span.setAttributes({
                [$akoBU.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]: JSON.stringify(toolCalls)
            });
        }
    }
    if ("completion" in response) span.setAttributes({
        [$akoBU.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: response.completion
    });
    if ("input_tokens" in response) span.setAttributes({
        [$akoBU.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: JSON.stringify(response.input_tokens)
    });
}
function $e5c8b15f64a47a3e$var$addMetadataAttributes(span, response) {
    if ("id" in response && "model" in response) {
        span.setAttributes({
            [$akoBU.GEN_AI_RESPONSE_ID_ATTRIBUTE]: response.id,
            [$akoBU.GEN_AI_RESPONSE_MODEL_ATTRIBUTE]: response.model
        });
        if ("usage" in response && response.usage) $8TMtR.setTokenUsageAttributes(span, response.usage.input_tokens, response.usage.output_tokens, response.usage.cache_creation_input_tokens, response.usage.cache_read_input_tokens);
    }
}
function $e5c8b15f64a47a3e$var$addResponseAttributes(span, response, recordOutputs) {
    if (!response || typeof response !== "object") return;
    if ("type" in response && response.type === "error") {
        $fO1m6.handleResponseError(span, response);
        return;
    }
    if (recordOutputs) $e5c8b15f64a47a3e$var$addContentAttributes(span, response);
    $e5c8b15f64a47a3e$var$addMetadataAttributes(span, response);
}
function $e5c8b15f64a47a3e$var$handleStreamingError(error, span, methodPath) {
    $gHOmH.captureException(error, {
        mechanism: {
            handled: false,
            type: "auto.ai.anthropic",
            data: {
                function: methodPath
            }
        }
    });
    if (span.isRecording()) {
        span.setStatus({
            code: $eqMxV.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        span.end();
    }
    throw error;
}
function $e5c8b15f64a47a3e$var$handleStreamingRequest(originalMethod, target, context, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod) {
    var _requestAttributes_genAiAttributes_GEN_AI_REQUEST_MODEL_ATTRIBUTE;
    const model = (_requestAttributes_genAiAttributes_GEN_AI_REQUEST_MODEL_ATTRIBUTE = requestAttributes[$akoBU.GEN_AI_REQUEST_MODEL_ATTRIBUTE]) !== null && _requestAttributes_genAiAttributes_GEN_AI_REQUEST_MODEL_ATTRIBUTE !== void 0 ? _requestAttributes_genAiAttributes_GEN_AI_REQUEST_MODEL_ATTRIBUTE : "unknown";
    const spanConfig = {
        name: `${operationName} ${model}`,
        op: `gen_ai.${operationName}`,
        attributes: requestAttributes
    };
    if (isStreamRequested && !isStreamingMethod) {
        let originalResult;
        const instrumentedPromise = $gvNu3.startSpanManual(spanConfig, (span)=>{
            originalResult = originalMethod.apply(context, args);
            if (options.recordInputs && params) $e5c8b15f64a47a3e$var$addPrivateRequestAttributes(span, params, $8TMtR.shouldEnableTruncation(options.enableTruncation));
            return (async ()=>{
                try {
                    const result = await originalResult;
                    var _options_recordOutputs;
                    return $kKEFR.instrumentAsyncIterableStream(result, span, (_options_recordOutputs = options.recordOutputs) !== null && _options_recordOutputs !== void 0 ? _options_recordOutputs : false);
                } catch (error) {
                    return $e5c8b15f64a47a3e$var$handleStreamingError(error, span, methodPath);
                }
            })();
        });
        return $8TMtR.wrapPromiseWithMethods(originalResult, instrumentedPromise, "auto.ai.anthropic");
    } else return $gvNu3.startSpanManual(spanConfig, (span)=>{
        try {
            if (options.recordInputs && params) $e5c8b15f64a47a3e$var$addPrivateRequestAttributes(span, params, $8TMtR.shouldEnableTruncation(options.enableTruncation));
            const messageStream = target.apply(context, args);
            var _options_recordOutputs;
            return $kKEFR.instrumentMessageStream(messageStream, span, (_options_recordOutputs = options.recordOutputs) !== null && _options_recordOutputs !== void 0 ? _options_recordOutputs : false);
        } catch (error) {
            return $e5c8b15f64a47a3e$var$handleStreamingError(error, span, methodPath);
        }
    });
}
function $e5c8b15f64a47a3e$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    return new Proxy(originalMethod, {
        apply (target, thisArg, args) {
            const operationName = instrumentedMethod.operation || "unknown";
            const requestAttributes = $e5c8b15f64a47a3e$var$extractRequestAttributes(args, methodPath, operationName);
            var _requestAttributes_genAiAttributes_GEN_AI_REQUEST_MODEL_ATTRIBUTE;
            const model = (_requestAttributes_genAiAttributes_GEN_AI_REQUEST_MODEL_ATTRIBUTE = requestAttributes[$akoBU.GEN_AI_REQUEST_MODEL_ATTRIBUTE]) !== null && _requestAttributes_genAiAttributes_GEN_AI_REQUEST_MODEL_ATTRIBUTE !== void 0 ? _requestAttributes_genAiAttributes_GEN_AI_REQUEST_MODEL_ATTRIBUTE : "unknown";
            const params = typeof args[0] === "object" ? args[0] : void 0;
            const isStreamRequested = Boolean(params === null || params === void 0 ? void 0 : params.stream);
            const isStreamingMethod = instrumentedMethod.streaming === true;
            if (isStreamRequested || isStreamingMethod) return $e5c8b15f64a47a3e$var$handleStreamingRequest(originalMethod, target, context, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod);
            let originalResult;
            const instrumentedPromise = $gvNu3.startSpan({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, (span)=>{
                originalResult = target.apply(context, args);
                if (options.recordInputs && params) $e5c8b15f64a47a3e$var$addPrivateRequestAttributes(span, params, $8TMtR.shouldEnableTruncation(options.enableTruncation));
                return originalResult.then((result)=>{
                    $e5c8b15f64a47a3e$var$addResponseAttributes(span, result, options.recordOutputs);
                    return result;
                }, (error)=>{
                    $gHOmH.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.anthropic",
                            data: {
                                function: methodPath
                            }
                        }
                    });
                    throw error;
                });
            });
            return $8TMtR.wrapPromiseWithMethods(originalResult, instrumentedPromise, "auto.ai.anthropic");
        }
    });
}
function $e5c8b15f64a47a3e$var$createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get (obj, prop) {
            const value = obj[prop];
            const methodPath = $8TMtR.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $6KwFW.ANTHROPIC_METHOD_REGISTRY[methodPath];
            if (typeof value === "function" && instrumentedMethod) return $e5c8b15f64a47a3e$var$instrumentMethod(value, methodPath, instrumentedMethod, obj, options);
            if (typeof value === "function") return value.bind(obj);
            if (value && typeof value === "object") return $e5c8b15f64a47a3e$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
function $e5c8b15f64a47a3e$var$instrumentAnthropicAiClient(anthropicAiClient, options) {
    return $e5c8b15f64a47a3e$var$createDeepProxy(anthropicAiClient, "", $8TMtR.resolveAIRecordingOptions(options));
}
module.exports.instrumentAnthropicAiClient = $e5c8b15f64a47a3e$var$instrumentAnthropicAiClient;

});
parcelRegister("6KwFW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $0144a6c07fb61542$var$ANTHROPIC_AI_INTEGRATION_NAME = "Anthropic_AI";
const $0144a6c07fb61542$var$ANTHROPIC_METHOD_REGISTRY = {
    "messages.create": {
        operation: "chat"
    },
    "messages.stream": {
        operation: "chat",
        streaming: true
    },
    "messages.countTokens": {
        operation: "chat"
    },
    "models.get": {
        operation: "models"
    },
    "completions.create": {
        operation: "chat"
    },
    "models.retrieve": {
        operation: "models"
    },
    "beta.messages.create": {
        operation: "chat"
    }
};
module.exports.ANTHROPIC_AI_INTEGRATION_NAME = $0144a6c07fb61542$var$ANTHROPIC_AI_INTEGRATION_NAME;
module.exports.ANTHROPIC_METHOD_REGISTRY = $0144a6c07fb61542$var$ANTHROPIC_METHOD_REGISTRY;

});

parcelRegister("kKEFR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gHOmH = parcelRequire("gHOmH");

var $eqMxV = parcelRequire("eqMxV");

var $8TMtR = parcelRequire("8TMtR");

var $fO1m6 = parcelRequire("fO1m6");
function $f1b7a7923c59700d$var$isErrorEvent(event, span) {
    if ("type" in event && typeof event.type === "string") {
        if (event.type === "error") {
            var _event_error;
            span.setStatus({
                code: $eqMxV.SPAN_STATUS_ERROR,
                message: $fO1m6.mapAnthropicErrorToStatusMessage((_event_error = event.error) === null || _event_error === void 0 ? void 0 : _event_error.type)
            });
            $gHOmH.captureException(event.error, {
                mechanism: {
                    handled: false,
                    type: "auto.ai.anthropic.anthropic_error"
                }
            });
            return true;
        }
    }
    return false;
}
function $f1b7a7923c59700d$var$handleMessageMetadata(event, state) {
    if (event.type === "message_delta" && event.usage) {
        if ("output_tokens" in event.usage && typeof event.usage.output_tokens === "number") state.completionTokens = event.usage.output_tokens;
    }
    if (event.message) {
        const message = event.message;
        if (message.id) state.responseId = message.id;
        if (message.model) state.responseModel = message.model;
        if (message.stop_reason) state.finishReasons.push(message.stop_reason);
        if (message.usage) {
            if (typeof message.usage.input_tokens === "number") state.promptTokens = message.usage.input_tokens;
            if (typeof message.usage.cache_creation_input_tokens === "number") state.cacheCreationInputTokens = message.usage.cache_creation_input_tokens;
            if (typeof message.usage.cache_read_input_tokens === "number") state.cacheReadInputTokens = message.usage.cache_read_input_tokens;
        }
    }
}
function $f1b7a7923c59700d$var$handleContentBlockStart(event, state) {
    if (event.type !== "content_block_start" || typeof event.index !== "number" || !event.content_block) return;
    if (event.content_block.type === "tool_use" || event.content_block.type === "server_tool_use") state.activeToolBlocks[event.index] = {
        id: event.content_block.id,
        name: event.content_block.name,
        inputJsonParts: []
    };
}
function $f1b7a7923c59700d$var$handleContentBlockDelta(event, state, recordOutputs) {
    if (event.type !== "content_block_delta" || !event.delta) return;
    if (typeof event.index === "number" && "partial_json" in event.delta && typeof event.delta.partial_json === "string") {
        const active = state.activeToolBlocks[event.index];
        if (active) active.inputJsonParts.push(event.delta.partial_json);
    }
    if (recordOutputs && typeof event.delta.text === "string") state.responseTexts.push(event.delta.text);
}
function $f1b7a7923c59700d$var$handleContentBlockStop(event, state) {
    if (event.type !== "content_block_stop" || typeof event.index !== "number") return;
    const active = state.activeToolBlocks[event.index];
    if (!active) return;
    const raw = active.inputJsonParts.join("");
    let parsedInput;
    try {
        parsedInput = raw ? JSON.parse(raw) : {};
    } catch (e) {
        parsedInput = {
            __unparsed: raw
        };
    }
    state.toolCalls.push({
        type: "tool_use",
        id: active.id,
        name: active.name,
        input: parsedInput
    });
    delete state.activeToolBlocks[event.index];
}
function $f1b7a7923c59700d$var$processEvent(event, state, recordOutputs, span) {
    if (!(event && typeof event === "object")) return;
    const isError = $f1b7a7923c59700d$var$isErrorEvent(event, span);
    if (isError) return;
    $f1b7a7923c59700d$var$handleMessageMetadata(event, state);
    $f1b7a7923c59700d$var$handleContentBlockStart(event, state);
    $f1b7a7923c59700d$var$handleContentBlockDelta(event, state, recordOutputs);
    $f1b7a7923c59700d$var$handleContentBlockStop(event, state);
}
async function* $f1b7a7923c59700d$var$instrumentAsyncIterableStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        cacheCreationInputTokens: void 0,
        cacheReadInputTokens: void 0,
        toolCalls: [],
        activeToolBlocks: {}
    };
    try {
        for await (const event of stream){
            $f1b7a7923c59700d$var$processEvent(event, state, recordOutputs, span);
            yield event;
        }
    } finally{
        $8TMtR.endStreamSpan(span, state, recordOutputs);
    }
}
function $f1b7a7923c59700d$var$instrumentMessageStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        cacheCreationInputTokens: void 0,
        cacheReadInputTokens: void 0,
        toolCalls: [],
        activeToolBlocks: {}
    };
    stream.on("streamEvent", (event)=>{
        $f1b7a7923c59700d$var$processEvent(event, state, recordOutputs, span);
    });
    stream.on("message", ()=>{
        $8TMtR.endStreamSpan(span, state, recordOutputs);
    });
    stream.on("error", (error)=>{
        $gHOmH.captureException(error, {
            mechanism: {
                handled: false,
                type: "auto.ai.anthropic.stream_error"
            }
        });
        if (span.isRecording()) {
            span.setStatus({
                code: $eqMxV.SPAN_STATUS_ERROR,
                message: "internal_error"
            });
            span.end();
        }
    });
    return stream;
}
module.exports.instrumentAsyncIterableStream = $f1b7a7923c59700d$var$instrumentAsyncIterableStream;
module.exports.instrumentMessageStream = $f1b7a7923c59700d$var$instrumentMessageStream;

});
parcelRegister("fO1m6", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gHOmH = parcelRequire("gHOmH");

var $eqMxV = parcelRequire("eqMxV");

var $akoBU = parcelRequire("akoBU");

var $8TMtR = parcelRequire("8TMtR");
function $b81c93b7523a5ca1$var$setMessagesAttribute(span, messages, enableTruncation) {
    if (Array.isArray(messages) && messages.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $8TMtR.extractSystemInstructions(messages);
    if (systemInstructions) span.setAttributes({
        [$akoBU.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE]: systemInstructions
    });
    const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 1;
    span.setAttributes({
        [$akoBU.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $8TMtR.getTruncatedJsonString(filteredMessages) : $8TMtR.getJsonString(filteredMessages),
        [$akoBU.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
    });
}
const $b81c93b7523a5ca1$var$ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS = {
    invalid_request_error: "invalid_argument",
    authentication_error: "unauthenticated",
    permission_error: "permission_denied",
    not_found_error: "not_found",
    request_too_large: "failed_precondition",
    rate_limit_error: "resource_exhausted",
    api_error: "internal_error",
    overloaded_error: "unavailable"
};
function $b81c93b7523a5ca1$var$mapAnthropicErrorToStatusMessage(errorType) {
    if (!errorType) return "internal_error";
    return $b81c93b7523a5ca1$var$ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS[errorType] || "internal_error";
}
function $b81c93b7523a5ca1$var$handleResponseError(span, response) {
    if (response.error) {
        span.setStatus({
            code: $eqMxV.SPAN_STATUS_ERROR,
            message: $b81c93b7523a5ca1$var$mapAnthropicErrorToStatusMessage(response.error.type)
        });
        $gHOmH.captureException(response.error, {
            mechanism: {
                handled: false,
                type: "auto.ai.anthropic.anthropic_error"
            }
        });
    }
}
function $b81c93b7523a5ca1$var$messagesFromParams(params) {
    const { system: system, messages: messages, input: input } = params;
    const systemMessages = typeof system === "string" ? [
        {
            role: "system",
            content: params.system
        }
    ] : [];
    const inputParamMessages = Array.isArray(input) ? input : input != null ? [
        input
    ] : void 0;
    const messagesParamMessages = Array.isArray(messages) ? messages : messages != null ? [
        messages
    ] : [];
    const userMessages = inputParamMessages !== null && inputParamMessages !== void 0 ? inputParamMessages : messagesParamMessages;
    return [
        ...systemMessages,
        ...userMessages
    ];
}
module.exports.handleResponseError = $b81c93b7523a5ca1$var$handleResponseError;
module.exports.mapAnthropicErrorToStatusMessage = $b81c93b7523a5ca1$var$mapAnthropicErrorToStatusMessage;
module.exports.messagesFromParams = $b81c93b7523a5ca1$var$messagesFromParams;
module.exports.setMessagesAttribute = $b81c93b7523a5ca1$var$setMessagesAttribute;

});



parcelRegister("f7TzA", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gHOmH = parcelRequire("gHOmH");

var $faX3S = parcelRequire("faX3S");

var $eqMxV = parcelRequire("eqMxV");

var $gvNu3 = parcelRequire("gvNu3");

var $1fhPD = parcelRequire("1fhPD");

var $akoBU = parcelRequire("akoBU");

var $8TMtR = parcelRequire("8TMtR");

var $99JOj = parcelRequire("99JOj");

var $kNMz2 = parcelRequire("kNMz2");

var $7IBEr = parcelRequire("7IBEr");
function $b0329e1db81b37e7$var$extractModel(params, context) {
    if ("model" in params && typeof params.model === "string") return params.model;
    if (context && typeof context === "object") {
        const contextObj = context;
        if ("model" in contextObj && typeof contextObj.model === "string") return contextObj.model;
        if ("modelVersion" in contextObj && typeof contextObj.modelVersion === "string") return contextObj.modelVersion;
    }
    return "unknown";
}
function $b0329e1db81b37e7$var$extractConfigAttributes(config) {
    const attributes = {};
    if ("temperature" in config && typeof config.temperature === "number") attributes[$akoBU.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = config.temperature;
    if ("topP" in config && typeof config.topP === "number") attributes[$akoBU.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = config.topP;
    if ("topK" in config && typeof config.topK === "number") attributes[$akoBU.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = config.topK;
    if ("maxOutputTokens" in config && typeof config.maxOutputTokens === "number") attributes[$akoBU.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = config.maxOutputTokens;
    if ("frequencyPenalty" in config && typeof config.frequencyPenalty === "number") attributes[$akoBU.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = config.frequencyPenalty;
    if ("presencePenalty" in config && typeof config.presencePenalty === "number") attributes[$akoBU.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = config.presencePenalty;
    return attributes;
}
function $b0329e1db81b37e7$var$extractRequestAttributes(operationName, params, context) {
    const attributes = {
        [$akoBU.GEN_AI_SYSTEM_ATTRIBUTE]: $99JOj.GOOGLE_GENAI_SYSTEM_NAME,
        [$akoBU.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.google_genai"
    };
    if (params) {
        attributes[$akoBU.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = $b0329e1db81b37e7$var$extractModel(params, context);
        if ("config" in params && typeof params.config === "object" && params.config) {
            const config = params.config;
            Object.assign(attributes, $b0329e1db81b37e7$var$extractConfigAttributes(config));
            if ("tools" in config && Array.isArray(config.tools)) {
                const functionDeclarations = config.tools.flatMap((tool)=>tool.functionDeclarations);
                attributes[$akoBU.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(functionDeclarations);
            }
        }
    } else attributes[$akoBU.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = $b0329e1db81b37e7$var$extractModel({}, context);
    return attributes;
}
function $b0329e1db81b37e7$var$addPrivateRequestAttributes(span, params, isEmbeddings, enableTruncation) {
    if (isEmbeddings) {
        const contents = params.contents;
        if (contents != null) span.setAttribute($akoBU.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE, typeof contents === "string" ? contents : JSON.stringify(contents));
        return;
    }
    const messages = [];
    if ("config" in params && params.config && typeof params.config === "object" && "systemInstruction" in params.config && params.config.systemInstruction) messages.push(...$7IBEr.contentUnionToMessages(params.config.systemInstruction, "system"));
    if ("history" in params) messages.push(...$7IBEr.contentUnionToMessages(params.history, "user"));
    if ("contents" in params) messages.push(...$7IBEr.contentUnionToMessages(params.contents, "user"));
    if ("message" in params) messages.push(...$7IBEr.contentUnionToMessages(params.message, "user"));
    if (Array.isArray(messages) && messages.length) {
        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $8TMtR.extractSystemInstructions(messages);
        if (systemInstructions) span.setAttribute($akoBU.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
        span.setAttributes({
            [$akoBU.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength,
            [$akoBU.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $8TMtR.getTruncatedJsonString(filteredMessages) : $8TMtR.getJsonString(filteredMessages)
        });
    }
}
function $b0329e1db81b37e7$var$addResponseAttributes(span, response, recordOutputs) {
    if (!response || typeof response !== "object") return;
    if (response.modelVersion) span.setAttribute($akoBU.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, response.modelVersion);
    if (response.usageMetadata && typeof response.usageMetadata === "object") {
        const usage = response.usageMetadata;
        if (typeof usage.promptTokenCount === "number") span.setAttributes({
            [$akoBU.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE]: usage.promptTokenCount
        });
        if (typeof usage.candidatesTokenCount === "number") span.setAttributes({
            [$akoBU.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE]: usage.candidatesTokenCount
        });
        if (typeof usage.totalTokenCount === "number") span.setAttributes({
            [$akoBU.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE]: usage.totalTokenCount
        });
    }
    if (recordOutputs && Array.isArray(response.candidates) && response.candidates.length > 0) {
        const responseTexts = response.candidates.map((candidate)=>{
            var _candidate_content;
            if (((_candidate_content = candidate.content) === null || _candidate_content === void 0 ? void 0 : _candidate_content.parts) && Array.isArray(candidate.content.parts)) return candidate.content.parts.map((part)=>typeof part.text === "string" ? part.text : "").filter((text)=>text.length > 0).join("");
            return "";
        }).filter((text)=>text.length > 0);
        if (responseTexts.length > 0) span.setAttributes({
            [$akoBU.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: responseTexts.join("")
        });
    }
    if (recordOutputs && response.functionCalls) {
        const functionCalls = response.functionCalls;
        if (Array.isArray(functionCalls) && functionCalls.length > 0) span.setAttributes({
            [$akoBU.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]: JSON.stringify(functionCalls)
        });
    }
}
function $b0329e1db81b37e7$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    const isEmbeddings = instrumentedMethod.operation === "embeddings";
    return new Proxy(originalMethod, {
        apply (target, _, args) {
            const operationName = instrumentedMethod.operation || "unknown";
            const params = args[0];
            const requestAttributes = $b0329e1db81b37e7$var$extractRequestAttributes(operationName, params, context);
            var _requestAttributes_genAiAttributes_GEN_AI_REQUEST_MODEL_ATTRIBUTE;
            const model = (_requestAttributes_genAiAttributes_GEN_AI_REQUEST_MODEL_ATTRIBUTE = requestAttributes[$akoBU.GEN_AI_REQUEST_MODEL_ATTRIBUTE]) !== null && _requestAttributes_genAiAttributes_GEN_AI_REQUEST_MODEL_ATTRIBUTE !== void 0 ? _requestAttributes_genAiAttributes_GEN_AI_REQUEST_MODEL_ATTRIBUTE : "unknown";
            if (instrumentedMethod.streaming) return $gvNu3.startSpanManual({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, async (span)=>{
                try {
                    if (options.recordInputs && params) $b0329e1db81b37e7$var$addPrivateRequestAttributes(span, params, isEmbeddings, $8TMtR.shouldEnableTruncation(options.enableTruncation));
                    const stream = await target.apply(context, args);
                    return $kNMz2.instrumentStream(stream, span, Boolean(options.recordOutputs));
                } catch (error) {
                    span.setStatus({
                        code: $eqMxV.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    $gHOmH.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.google_genai",
                            data: {
                                function: methodPath
                            }
                        }
                    });
                    span.end();
                    throw error;
                }
            });
            return $gvNu3.startSpan({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, (span)=>{
                if (options.recordInputs && params) $b0329e1db81b37e7$var$addPrivateRequestAttributes(span, params, isEmbeddings, $8TMtR.shouldEnableTruncation(options.enableTruncation));
                return $1fhPD.handleCallbackErrors(()=>target.apply(context, args), (error)=>{
                    $gHOmH.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.google_genai",
                            data: {
                                function: methodPath
                            }
                        }
                    });
                }, ()=>{}, (result)=>{
                    if (!isEmbeddings) $b0329e1db81b37e7$var$addResponseAttributes(span, result, options.recordOutputs);
                });
            });
        }
    });
}
function $b0329e1db81b37e7$var$createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get: (t, prop, receiver)=>{
            const value = Reflect.get(t, prop, receiver);
            const methodPath = $8TMtR.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $99JOj.GOOGLE_GENAI_METHOD_REGISTRY[methodPath];
            if (typeof value === "function" && instrumentedMethod) {
                const wrappedMethod = instrumentedMethod.operation ? $b0329e1db81b37e7$var$instrumentMethod(value, methodPath, instrumentedMethod, t, options) : value.bind(t);
                if (!instrumentedMethod.proxyResultPath) return wrappedMethod;
                return function(...args) {
                    const result = wrappedMethod(...args);
                    if (result && typeof result === "object") return $b0329e1db81b37e7$var$createDeepProxy(result, instrumentedMethod.proxyResultPath, options);
                    return result;
                };
            }
            if (typeof value === "function") return value.bind(t);
            if (value && typeof value === "object") return $b0329e1db81b37e7$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
function $b0329e1db81b37e7$var$instrumentGoogleGenAIClient(client, options) {
    return $b0329e1db81b37e7$var$createDeepProxy(client, "", $8TMtR.resolveAIRecordingOptions(options));
}
module.exports.extractModel = $b0329e1db81b37e7$var$extractModel;
module.exports.instrumentGoogleGenAIClient = $b0329e1db81b37e7$var$instrumentGoogleGenAIClient;

});
parcelRegister("99JOj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $6aa87d5902ea7de9$var$GOOGLE_GENAI_INTEGRATION_NAME = "Google_GenAI";
const $6aa87d5902ea7de9$var$GOOGLE_GENAI_METHOD_REGISTRY = {
    "models.generateContent": {
        operation: "generate_content"
    },
    "models.generateContentStream": {
        operation: "generate_content",
        streaming: true
    },
    "models.embedContent": {
        operation: "embeddings"
    },
    "chats.create": {
        proxyResultPath: "chat"
    },
    "chat.sendMessage": {
        operation: "chat"
    },
    "chat.sendMessageStream": {
        operation: "chat",
        streaming: true
    }
};
const $6aa87d5902ea7de9$var$GOOGLE_GENAI_SYSTEM_NAME = "google_genai";
module.exports.GOOGLE_GENAI_INTEGRATION_NAME = $6aa87d5902ea7de9$var$GOOGLE_GENAI_INTEGRATION_NAME;
module.exports.GOOGLE_GENAI_METHOD_REGISTRY = $6aa87d5902ea7de9$var$GOOGLE_GENAI_METHOD_REGISTRY;
module.exports.GOOGLE_GENAI_SYSTEM_NAME = $6aa87d5902ea7de9$var$GOOGLE_GENAI_SYSTEM_NAME;

});

parcelRegister("kNMz2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gHOmH = parcelRequire("gHOmH");

var $eqMxV = parcelRequire("eqMxV");

var $8TMtR = parcelRequire("8TMtR");
function $f24e0e11103139f2$var$isErrorChunk(chunk, span) {
    const feedback = chunk === null || chunk === void 0 ? void 0 : chunk.promptFeedback;
    if (feedback === null || feedback === void 0 ? void 0 : feedback.blockReason) {
        var _feedback_blockReasonMessage;
        const message = (_feedback_blockReasonMessage = feedback.blockReasonMessage) !== null && _feedback_blockReasonMessage !== void 0 ? _feedback_blockReasonMessage : feedback.blockReason;
        span.setStatus({
            code: $eqMxV.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        $gHOmH.captureException(`Content blocked: ${message}`, {
            mechanism: {
                handled: false,
                type: "auto.ai.google_genai"
            }
        });
        return true;
    }
    return false;
}
function $f24e0e11103139f2$var$handleResponseMetadata(chunk, state) {
    if (typeof chunk.responseId === "string") state.responseId = chunk.responseId;
    if (typeof chunk.modelVersion === "string") state.responseModel = chunk.modelVersion;
    const usage = chunk.usageMetadata;
    if (usage) {
        if (typeof usage.promptTokenCount === "number") state.promptTokens = usage.promptTokenCount;
        if (typeof usage.candidatesTokenCount === "number") state.completionTokens = usage.candidatesTokenCount;
        if (typeof usage.totalTokenCount === "number") state.totalTokens = usage.totalTokenCount;
    }
}
function $f24e0e11103139f2$var$handleCandidateContent(chunk, state, recordOutputs) {
    if (Array.isArray(chunk.functionCalls)) state.toolCalls.push(...chunk.functionCalls);
    var _chunk_candidates;
    for (const candidate of (_chunk_candidates = chunk.candidates) !== null && _chunk_candidates !== void 0 ? _chunk_candidates : []){
        var _candidate_content;
        if ((candidate === null || candidate === void 0 ? void 0 : candidate.finishReason) && !state.finishReasons.includes(candidate.finishReason)) state.finishReasons.push(candidate.finishReason);
        var _candidate_content_parts;
        for (const part of (_candidate_content_parts = candidate === null || candidate === void 0 ? void 0 : (_candidate_content = candidate.content) === null || _candidate_content === void 0 ? void 0 : _candidate_content.parts) !== null && _candidate_content_parts !== void 0 ? _candidate_content_parts : []){
            if (recordOutputs && part.text) state.responseTexts.push(part.text);
            if (part.functionCall) state.toolCalls.push({
                type: "function",
                id: part.functionCall.id,
                name: part.functionCall.name,
                arguments: part.functionCall.args
            });
        }
    }
}
function $f24e0e11103139f2$var$processChunk(chunk, state, recordOutputs, span) {
    if (!chunk || $f24e0e11103139f2$var$isErrorChunk(chunk, span)) return;
    $f24e0e11103139f2$var$handleResponseMetadata(chunk, state);
    $f24e0e11103139f2$var$handleCandidateContent(chunk, state, recordOutputs);
}
async function* $f24e0e11103139f2$var$instrumentStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        toolCalls: []
    };
    try {
        for await (const chunk of stream){
            $f24e0e11103139f2$var$processChunk(chunk, state, recordOutputs, span);
            yield chunk;
        }
    } finally{
        $8TMtR.endStreamSpan(span, state, recordOutputs);
    }
}
module.exports.instrumentStream = $f24e0e11103139f2$var$instrumentStream;

});

parcelRegister("7IBEr", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $59e9d93ac36965b8$var$contentUnionToMessages(content, role = "user") {
    if (typeof content === "string") return [
        {
            role: role,
            content: content
        }
    ];
    if (Array.isArray(content)) return content.flatMap((content2)=>$59e9d93ac36965b8$var$contentUnionToMessages(content2, role));
    if (typeof content !== "object" || !content) return [];
    if ("role" in content && typeof content.role === "string") return [
        content
    ];
    if ("parts" in content) return [
        (0, $2qxEV._)((0, $9tqwB._)({}, content), {
            role: role
        })
    ];
    return [
        {
            role: role,
            content: content
        }
    ];
}
module.exports.contentUnionToMessages = $59e9d93ac36965b8$var$contentUnionToMessages;

});


parcelRegister("7NTnD", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gHOmH = parcelRequire("gHOmH");

var $faX3S = parcelRequire("faX3S");

var $eqMxV = parcelRequire("eqMxV");

var $gvNu3 = parcelRequire("gvNu3");

var $akoBU = parcelRequire("akoBU");

var $8TMtR = parcelRequire("8TMtR");

var $cWsYm = parcelRequire("cWsYm");

var $kjDrv = parcelRequire("kjDrv");
function $5ae8115e64e9c1bb$var$createLangChainCallbackHandler(options = {}) {
    const { recordInputs: recordInputs, recordOutputs: recordOutputs } = $8TMtR.resolveAIRecordingOptions(options);
    const enableTruncation = $8TMtR.shouldEnableTruncation(options.enableTruncation);
    const spanMap = /* @__PURE__ */ new Map();
    const exitSpan = (runId)=>{
        const span = spanMap.get(runId);
        if (span === null || span === void 0 ? void 0 : span.isRecording()) {
            span.end();
            spanMap.delete(runId);
        }
    };
    const handler = {
        // Required LangChain BaseCallbackHandler properties
        lc_serializable: false,
        lc_namespace: [
            "langchain_core",
            "callbacks",
            "sentry"
        ],
        lc_secrets: void 0,
        lc_attributes: void 0,
        lc_aliases: void 0,
        lc_serializable_keys: void 0,
        lc_id: [
            "langchain_core",
            "callbacks",
            "sentry"
        ],
        lc_kwargs: {},
        name: "SentryCallbackHandler",
        // BaseCallbackHandlerInput boolean flags
        ignoreLLM: false,
        ignoreChain: false,
        ignoreAgent: false,
        ignoreRetriever: false,
        ignoreCustomEvent: false,
        raiseError: false,
        awaitHandlers: true,
        handleLLMStart (llm, prompts, runId, _parentRunId, _extraParams, tags, metadata, _runName) {
            const invocationParams = $kjDrv.getInvocationParams(tags);
            const attributes = $kjDrv.extractLLMRequestAttributes(llm, prompts, recordInputs, enableTruncation, invocationParams, metadata);
            const modelName = attributes[$akoBU.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
            const operationName = attributes[$akoBU.GEN_AI_OPERATION_NAME_ATTRIBUTE];
            $gvNu3.startSpanManual({
                name: `${operationName} ${modelName}`,
                op: "gen_ai.chat",
                attributes: (0, $2qxEV._)((0, $9tqwB._)({}, $kjDrv.getAgentNameFromMetadata(metadata), attributes), {
                    [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.chat"
                })
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chat Model Start Handler
        handleChatModelStart (llm, messages, runId, _parentRunId, extraParams, tags, metadata, _runName) {
            const invocationParams = $kjDrv.getInvocationParams(tags);
            const attributes = $kjDrv.extractChatModelRequestAttributes(llm, messages, recordInputs, enableTruncation, invocationParams, metadata);
            const toolDefsJson = $kjDrv.extractToolDefinitions(extraParams);
            if (toolDefsJson) attributes[$akoBU.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = toolDefsJson;
            const modelName = attributes[$akoBU.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
            const operationName = attributes[$akoBU.GEN_AI_OPERATION_NAME_ATTRIBUTE];
            $gvNu3.startSpanManual({
                name: `${operationName} ${modelName}`,
                op: "gen_ai.chat",
                attributes: (0, $2qxEV._)((0, $9tqwB._)({}, $kjDrv.getAgentNameFromMetadata(metadata), attributes), {
                    [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.chat"
                })
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // LLM End Handler - note: handleLLMEnd with capital LLM (used by both LLMs and chat models!)
        handleLLMEnd (output, runId, _parentRunId, _tags, _extraParams) {
            const span = spanMap.get(runId);
            if (span === null || span === void 0 ? void 0 : span.isRecording()) {
                const attributes = $kjDrv.extractLlmResponseAttributes(output, recordOutputs);
                if (attributes) span.setAttributes(attributes);
                exitSpan(runId);
            }
        },
        // LLM Error Handler - note: handleLLMError with capital LLM
        handleLLMError (error, runId) {
            const span = spanMap.get(runId);
            if (span === null || span === void 0 ? void 0 : span.isRecording()) {
                span.setStatus({
                    code: $eqMxV.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
            $gHOmH.captureException(error, {
                mechanism: {
                    handled: false,
                    type: `${$cWsYm.LANGCHAIN_ORIGIN}.llm_error_handler`
                }
            });
        },
        // Chain Start Handler
        handleChainStart (chain, inputs, runId, _parentRunId, _tags, metadata, _runType, runName) {
            if (metadata === null || metadata === void 0 ? void 0 : metadata.__sentry_langgraph__) return;
            const chainName = runName || chain.name || "unknown_chain";
            const attributes = {
                [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.langchain",
                "langchain.chain.name": chainName
            };
            if (recordInputs) attributes["langchain.chain.inputs"] = JSON.stringify(inputs);
            $gvNu3.startSpanManual({
                name: `chain ${chainName}`,
                op: "gen_ai.invoke_agent",
                attributes: (0, $2qxEV._)((0, $9tqwB._)({}, attributes), {
                    [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.invoke_agent"
                })
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chain End Handler
        handleChainEnd (outputs, runId) {
            const span = spanMap.get(runId);
            if (span === null || span === void 0 ? void 0 : span.isRecording()) {
                if (recordOutputs) span.setAttributes({
                    "langchain.chain.outputs": JSON.stringify(outputs)
                });
                exitSpan(runId);
            }
        },
        // Chain Error Handler
        handleChainError (error, runId) {
            const span = spanMap.get(runId);
            if (span === null || span === void 0 ? void 0 : span.isRecording()) {
                span.setStatus({
                    code: $eqMxV.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
            $gHOmH.captureException(error, {
                mechanism: {
                    handled: false,
                    type: `${$cWsYm.LANGCHAIN_ORIGIN}.chain_error_handler`
                }
            });
        },
        // Tool Start Handler
        handleToolStart (tool, input, runId, _parentRunId, _tags, metadata, runName) {
            if (metadata === null || metadata === void 0 ? void 0 : metadata.__sentry_langgraph__) return;
            const toolName = runName || tool.name || "unknown_tool";
            const attributes = (0, $2qxEV._)((0, $9tqwB._)({}, $kjDrv.getAgentNameFromMetadata(metadata)), {
                [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $cWsYm.LANGCHAIN_ORIGIN,
                [$akoBU.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "execute_tool",
                [$akoBU.GEN_AI_TOOL_NAME_ATTRIBUTE]: toolName
            });
            if (recordInputs) attributes[$akoBU.GEN_AI_TOOL_INPUT_ATTRIBUTE] = input;
            $gvNu3.startSpanManual({
                name: `execute_tool ${toolName}`,
                op: "gen_ai.execute_tool",
                attributes: (0, $2qxEV._)((0, $9tqwB._)({}, attributes), {
                    [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.execute_tool"
                })
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Tool End Handler
        handleToolEnd (output, runId) {
            const span = spanMap.get(runId);
            if (span === null || span === void 0 ? void 0 : span.isRecording()) {
                if (recordOutputs) {
                    const outputObj = output;
                    const content = outputObj && typeof outputObj === "object" && "content" in outputObj ? outputObj.content : output;
                    span.setAttributes({
                        [$akoBU.GEN_AI_TOOL_OUTPUT_ATTRIBUTE]: typeof content === "string" ? content : JSON.stringify(content)
                    });
                }
                exitSpan(runId);
            }
        },
        // Tool Error Handler
        handleToolError (error, runId) {
            const span = spanMap.get(runId);
            if (span === null || span === void 0 ? void 0 : span.isRecording()) {
                span.setStatus({
                    code: $eqMxV.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
            $gHOmH.captureException(error, {
                mechanism: {
                    handled: false,
                    type: `${$cWsYm.LANGCHAIN_ORIGIN}.tool_error_handler`
                }
            });
        },
        // LangChain BaseCallbackHandler required methods
        copy () {
            return handler;
        },
        toJSON () {
            return {
                lc: 1,
                type: "not_implemented",
                id: handler.lc_id
            };
        },
        toJSONNotImplemented () {
            return {
                lc: 1,
                type: "not_implemented",
                id: handler.lc_id
            };
        }
    };
    return handler;
}
module.exports.createLangChainCallbackHandler = $5ae8115e64e9c1bb$var$createLangChainCallbackHandler;

});
parcelRegister("cWsYm", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $96c16023d6bb0820$var$LANGCHAIN_INTEGRATION_NAME = "LangChain";
const $96c16023d6bb0820$var$LANGCHAIN_ORIGIN = "auto.ai.langchain";
const $96c16023d6bb0820$var$ROLE_MAP = {
    human: "user",
    ai: "assistant",
    assistant: "assistant",
    system: "system",
    function: "function",
    tool: "tool"
};
module.exports.LANGCHAIN_INTEGRATION_NAME = $96c16023d6bb0820$var$LANGCHAIN_INTEGRATION_NAME;
module.exports.LANGCHAIN_ORIGIN = $96c16023d6bb0820$var$LANGCHAIN_ORIGIN;
module.exports.ROLE_MAP = $96c16023d6bb0820$var$ROLE_MAP;

});

parcelRegister("kjDrv", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $faX3S = parcelRequire("faX3S");

var $akoBU = parcelRequire("akoBU");

var $fPzlZ = parcelRequire("fPzlZ");

var $8TMtR = parcelRequire("8TMtR");

var $cWsYm = parcelRequire("cWsYm");
const $eca42d7f79c8fa3f$var$setIfDefined = (target, key, value)=>{
    if (value != null) target[key] = value;
};
const $eca42d7f79c8fa3f$var$setNumberIfDefined = (target, key, value)=>{
    const n = Number(value);
    if (!Number.isNaN(n)) target[key] = n;
};
function $eca42d7f79c8fa3f$var$asString(v) {
    if (typeof v === "string") return v;
    try {
        return JSON.stringify(v);
    } catch (e) {
        return String(v);
    }
}
function $eca42d7f79c8fa3f$var$normalizeContent(v) {
    if (Array.isArray(v)) try {
        const stripped = v.map((part)=>part && typeof part === "object" && $fPzlZ.isContentMedia(part) ? $fPzlZ.stripInlineMediaFromSingleMessage(part) : part);
        return JSON.stringify(stripped);
    } catch (e) {
        return String(v);
    }
    return $eca42d7f79c8fa3f$var$asString(v);
}
function $eca42d7f79c8fa3f$var$normalizeMessageRole(role) {
    const normalized = role.toLowerCase();
    var _constants_ROLE_MAP_normalized;
    return (_constants_ROLE_MAP_normalized = $cWsYm.ROLE_MAP[normalized]) !== null && _constants_ROLE_MAP_normalized !== void 0 ? _constants_ROLE_MAP_normalized : normalized;
}
function $eca42d7f79c8fa3f$var$normalizeRoleNameFromCtor(name) {
    if (name.includes("System")) return "system";
    if (name.includes("Human")) return "user";
    if (name.includes("AI") || name.includes("Assistant")) return "assistant";
    if (name.includes("Function")) return "function";
    if (name.includes("Tool")) return "tool";
    return "user";
}
function $eca42d7f79c8fa3f$var$getInvocationParams(tags) {
    if (!tags || Array.isArray(tags)) return void 0;
    return tags.invocation_params;
}
function $eca42d7f79c8fa3f$var$normalizeLangChainMessages(messages) {
    return messages.map((message)=>{
        var _message_constructor;
        const maybeGetType = message._getType;
        if (typeof maybeGetType === "function") {
            const messageType = maybeGetType.call(message);
            return {
                role: $eca42d7f79c8fa3f$var$normalizeMessageRole(messageType),
                content: $eca42d7f79c8fa3f$var$normalizeContent(message.content)
            };
        }
        if (message.lc === 1 && message.kwargs) {
            var _message_kwargs;
            const id = message.id;
            const messageType = Array.isArray(id) && id.length > 0 ? id[id.length - 1] : "";
            const role = typeof messageType === "string" ? $eca42d7f79c8fa3f$var$normalizeRoleNameFromCtor(messageType) : "user";
            return {
                role: $eca42d7f79c8fa3f$var$normalizeMessageRole(role),
                content: $eca42d7f79c8fa3f$var$normalizeContent((_message_kwargs = message.kwargs) === null || _message_kwargs === void 0 ? void 0 : _message_kwargs.content)
            };
        }
        if (message.type) {
            const role = String(message.type).toLowerCase();
            return {
                role: $eca42d7f79c8fa3f$var$normalizeMessageRole(role),
                content: $eca42d7f79c8fa3f$var$normalizeContent(message.content)
            };
        }
        if (message.role) return {
            role: $eca42d7f79c8fa3f$var$normalizeMessageRole(String(message.role)),
            content: $eca42d7f79c8fa3f$var$normalizeContent(message.content)
        };
        const ctor = (_message_constructor = message.constructor) === null || _message_constructor === void 0 ? void 0 : _message_constructor.name;
        if (ctor && ctor !== "Object") return {
            role: $eca42d7f79c8fa3f$var$normalizeMessageRole($eca42d7f79c8fa3f$var$normalizeRoleNameFromCtor(ctor)),
            content: $eca42d7f79c8fa3f$var$normalizeContent(message.content)
        };
        return {
            role: "user",
            content: $eca42d7f79c8fa3f$var$normalizeContent(message.content)
        };
    });
}
function $eca42d7f79c8fa3f$var$extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata) {
    const attrs = {};
    const kwargs = "kwargs" in serialized ? serialized.kwargs : void 0;
    var _invocationParams_temperature, _ref;
    const temperature = (_ref = (_invocationParams_temperature = invocationParams === null || invocationParams === void 0 ? void 0 : invocationParams.temperature) !== null && _invocationParams_temperature !== void 0 ? _invocationParams_temperature : langSmithMetadata === null || langSmithMetadata === void 0 ? void 0 : langSmithMetadata.ls_temperature) !== null && _ref !== void 0 ? _ref : kwargs === null || kwargs === void 0 ? void 0 : kwargs.temperature;
    $eca42d7f79c8fa3f$var$setNumberIfDefined(attrs, $akoBU.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE, temperature);
    var _invocationParams_max_tokens, _ref1;
    const maxTokens = (_ref1 = (_invocationParams_max_tokens = invocationParams === null || invocationParams === void 0 ? void 0 : invocationParams.max_tokens) !== null && _invocationParams_max_tokens !== void 0 ? _invocationParams_max_tokens : langSmithMetadata === null || langSmithMetadata === void 0 ? void 0 : langSmithMetadata.ls_max_tokens) !== null && _ref1 !== void 0 ? _ref1 : kwargs === null || kwargs === void 0 ? void 0 : kwargs.max_tokens;
    $eca42d7f79c8fa3f$var$setNumberIfDefined(attrs, $akoBU.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE, maxTokens);
    var _invocationParams_top_p;
    const topP = (_invocationParams_top_p = invocationParams === null || invocationParams === void 0 ? void 0 : invocationParams.top_p) !== null && _invocationParams_top_p !== void 0 ? _invocationParams_top_p : kwargs === null || kwargs === void 0 ? void 0 : kwargs.top_p;
    $eca42d7f79c8fa3f$var$setNumberIfDefined(attrs, $akoBU.GEN_AI_REQUEST_TOP_P_ATTRIBUTE, topP);
    const frequencyPenalty = invocationParams === null || invocationParams === void 0 ? void 0 : invocationParams.frequency_penalty;
    $eca42d7f79c8fa3f$var$setNumberIfDefined(attrs, $akoBU.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE, frequencyPenalty);
    const presencePenalty = invocationParams === null || invocationParams === void 0 ? void 0 : invocationParams.presence_penalty;
    $eca42d7f79c8fa3f$var$setNumberIfDefined(attrs, $akoBU.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE, presencePenalty);
    if (invocationParams && "stream" in invocationParams) $eca42d7f79c8fa3f$var$setIfDefined(attrs, $akoBU.GEN_AI_REQUEST_STREAM_ATTRIBUTE, Boolean(invocationParams.stream));
    return attrs;
}
function $eca42d7f79c8fa3f$var$baseRequestAttributes(system, modelName, serialized, invocationParams, langSmithMetadata) {
    return (0, $9tqwB._)({
        [$akoBU.GEN_AI_SYSTEM_ATTRIBUTE]: $eca42d7f79c8fa3f$var$asString(system !== null && system !== void 0 ? system : "langchain"),
        [$akoBU.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "chat",
        [$akoBU.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: $eca42d7f79c8fa3f$var$asString(modelName),
        [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $cWsYm.LANGCHAIN_ORIGIN
    }, $eca42d7f79c8fa3f$var$extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata));
}
function $eca42d7f79c8fa3f$var$extractLLMRequestAttributes(llm, prompts, recordInputs, enableTruncation, invocationParams, langSmithMetadata) {
    const system = langSmithMetadata === null || langSmithMetadata === void 0 ? void 0 : langSmithMetadata.ls_provider;
    var _invocationParams_model, _ref;
    const modelName = (_ref = (_invocationParams_model = invocationParams === null || invocationParams === void 0 ? void 0 : invocationParams.model) !== null && _invocationParams_model !== void 0 ? _invocationParams_model : langSmithMetadata === null || langSmithMetadata === void 0 ? void 0 : langSmithMetadata.ls_model_name) !== null && _ref !== void 0 ? _ref : "unknown";
    const attrs = $eca42d7f79c8fa3f$var$baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(prompts) && prompts.length > 0) {
        $eca42d7f79c8fa3f$var$setIfDefined(attrs, $akoBU.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, prompts.length);
        const messages = prompts.map((p)=>({
                role: "user",
                content: p
            }));
        $eca42d7f79c8fa3f$var$setIfDefined(attrs, $akoBU.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $8TMtR.getTruncatedJsonString(messages) : $8TMtR.getJsonString(messages));
    }
    return attrs;
}
function $eca42d7f79c8fa3f$var$extractChatModelRequestAttributes(llm, langChainMessages, recordInputs, enableTruncation, invocationParams, langSmithMetadata) {
    var _llm_id;
    var _langSmithMetadata_ls_provider;
    const system = (_langSmithMetadata_ls_provider = langSmithMetadata === null || langSmithMetadata === void 0 ? void 0 : langSmithMetadata.ls_provider) !== null && _langSmithMetadata_ls_provider !== void 0 ? _langSmithMetadata_ls_provider : (_llm_id = llm.id) === null || _llm_id === void 0 ? void 0 : _llm_id[2];
    var _invocationParams_model, _ref;
    const modelName = (_ref = (_invocationParams_model = invocationParams === null || invocationParams === void 0 ? void 0 : invocationParams.model) !== null && _invocationParams_model !== void 0 ? _invocationParams_model : langSmithMetadata === null || langSmithMetadata === void 0 ? void 0 : langSmithMetadata.ls_model_name) !== null && _ref !== void 0 ? _ref : "unknown";
    const attrs = $eca42d7f79c8fa3f$var$baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(langChainMessages) && langChainMessages.length > 0) {
        const normalized = $eca42d7f79c8fa3f$var$normalizeLangChainMessages(langChainMessages.flat());
        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $8TMtR.extractSystemInstructions(normalized);
        if (systemInstructions) $eca42d7f79c8fa3f$var$setIfDefined(attrs, $akoBU.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
        $eca42d7f79c8fa3f$var$setIfDefined(attrs, $akoBU.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, filteredLength);
        $eca42d7f79c8fa3f$var$setIfDefined(attrs, $akoBU.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $8TMtR.getTruncatedJsonString(filteredMessages) : $8TMtR.getJsonString(filteredMessages));
    }
    return attrs;
}
function $eca42d7f79c8fa3f$var$addToolCallsAttributes(generations, attrs) {
    const toolCalls = [];
    const flatGenerations = generations.flat();
    for (const gen of flatGenerations){
        const msg = gen.message;
        const msgToolCalls = msg === null || msg === void 0 ? void 0 : msg.tool_calls;
        if (Array.isArray(msgToolCalls) && msgToolCalls.length > 0) toolCalls.push(...msgToolCalls);
        else {
            var _gen_message;
            const content = (_gen_message = gen.message) === null || _gen_message === void 0 ? void 0 : _gen_message.content;
            if (Array.isArray(content)) for (const item of content){
                const t = item;
                if (t.type === "tool_use") toolCalls.push(t);
            }
        }
    }
    if (toolCalls.length > 0) $eca42d7f79c8fa3f$var$setIfDefined(attrs, $akoBU.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, $eca42d7f79c8fa3f$var$asString(toolCalls));
}
function $eca42d7f79c8fa3f$var$addTokenUsageAttributes(llmOutput, attrs) {
    if (!llmOutput) return;
    const tokenUsage = llmOutput.tokenUsage;
    const anthropicUsage = llmOutput.usage;
    if (tokenUsage) {
        $eca42d7f79c8fa3f$var$setNumberIfDefined(attrs, $akoBU.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, tokenUsage.promptTokens);
        $eca42d7f79c8fa3f$var$setNumberIfDefined(attrs, $akoBU.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, tokenUsage.completionTokens);
        $eca42d7f79c8fa3f$var$setNumberIfDefined(attrs, $akoBU.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, tokenUsage.totalTokens);
    } else if (anthropicUsage) {
        $eca42d7f79c8fa3f$var$setNumberIfDefined(attrs, $akoBU.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.input_tokens);
        $eca42d7f79c8fa3f$var$setNumberIfDefined(attrs, $akoBU.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, anthropicUsage.output_tokens);
        const input = Number(anthropicUsage.input_tokens);
        const output = Number(anthropicUsage.output_tokens);
        const total = (Number.isNaN(input) ? 0 : input) + (Number.isNaN(output) ? 0 : output);
        if (total > 0) $eca42d7f79c8fa3f$var$setNumberIfDefined(attrs, $akoBU.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, total);
        if (anthropicUsage.cache_creation_input_tokens !== void 0) $eca42d7f79c8fa3f$var$setNumberIfDefined(attrs, $akoBU.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.cache_creation_input_tokens);
        if (anthropicUsage.cache_read_input_tokens !== void 0) $eca42d7f79c8fa3f$var$setNumberIfDefined(attrs, $akoBU.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.cache_read_input_tokens);
    }
}
function $eca42d7f79c8fa3f$var$extractLlmResponseAttributes(llmResult, recordOutputs) {
    var _llmResult_generations_, _llmResult_generations, _v1Message_response_metadata, _v1Message_response_metadata1;
    if (!llmResult) return;
    const attrs = {};
    if (Array.isArray(llmResult.generations)) {
        const finishReasons = llmResult.generations.flat().map((g)=>{
            var _g_generationInfo, _g_generation_info;
            if ((_g_generationInfo = g.generationInfo) === null || _g_generationInfo === void 0 ? void 0 : _g_generationInfo.finish_reason) return g.generationInfo.finish_reason;
            if ((_g_generation_info = g.generation_info) === null || _g_generation_info === void 0 ? void 0 : _g_generation_info.finish_reason) return g.generation_info.finish_reason;
            return null;
        }).filter((r)=>typeof r === "string");
        if (finishReasons.length > 0) $eca42d7f79c8fa3f$var$setIfDefined(attrs, $akoBU.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE, $eca42d7f79c8fa3f$var$asString(finishReasons));
        $eca42d7f79c8fa3f$var$addToolCallsAttributes(llmResult.generations, attrs);
        if (recordOutputs) {
            const texts = llmResult.generations.flat().map((gen)=>{
                var _gen_message;
                var _gen_text;
                return (_gen_text = gen.text) !== null && _gen_text !== void 0 ? _gen_text : (_gen_message = gen.message) === null || _gen_message === void 0 ? void 0 : _gen_message.content;
            }).filter((t)=>typeof t === "string");
            if (texts.length > 0) $eca42d7f79c8fa3f$var$setIfDefined(attrs, $akoBU.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, $eca42d7f79c8fa3f$var$asString(texts));
        }
    }
    $eca42d7f79c8fa3f$var$addTokenUsageAttributes(llmResult.llmOutput, attrs);
    const llmOutput = llmResult.llmOutput;
    const firstGeneration = (_llmResult_generations = llmResult.generations) === null || _llmResult_generations === void 0 ? void 0 : (_llmResult_generations_ = _llmResult_generations[0]) === null || _llmResult_generations_ === void 0 ? void 0 : _llmResult_generations_[0];
    const v1Message = firstGeneration === null || firstGeneration === void 0 ? void 0 : firstGeneration.message;
    var _llmOutput_model_name, _ref;
    const modelName = (_ref = (_llmOutput_model_name = llmOutput === null || llmOutput === void 0 ? void 0 : llmOutput.model_name) !== null && _llmOutput_model_name !== void 0 ? _llmOutput_model_name : llmOutput === null || llmOutput === void 0 ? void 0 : llmOutput.model) !== null && _ref !== void 0 ? _ref : v1Message === null || v1Message === void 0 ? void 0 : (_v1Message_response_metadata = v1Message.response_metadata) === null || _v1Message_response_metadata === void 0 ? void 0 : _v1Message_response_metadata.model_name;
    if (modelName) $eca42d7f79c8fa3f$var$setIfDefined(attrs, $akoBU.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, modelName);
    var _llmOutput_id;
    const responseId = (_llmOutput_id = llmOutput === null || llmOutput === void 0 ? void 0 : llmOutput.id) !== null && _llmOutput_id !== void 0 ? _llmOutput_id : v1Message === null || v1Message === void 0 ? void 0 : v1Message.id;
    if (responseId) $eca42d7f79c8fa3f$var$setIfDefined(attrs, $akoBU.GEN_AI_RESPONSE_ID_ATTRIBUTE, responseId);
    var _llmOutput_stop_reason;
    const stopReason = (_llmOutput_stop_reason = llmOutput === null || llmOutput === void 0 ? void 0 : llmOutput.stop_reason) !== null && _llmOutput_stop_reason !== void 0 ? _llmOutput_stop_reason : v1Message === null || v1Message === void 0 ? void 0 : (_v1Message_response_metadata1 = v1Message.response_metadata) === null || _v1Message_response_metadata1 === void 0 ? void 0 : _v1Message_response_metadata1.finish_reason;
    if (stopReason) $eca42d7f79c8fa3f$var$setIfDefined(attrs, $akoBU.GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE, $eca42d7f79c8fa3f$var$asString(stopReason));
    return attrs;
}
function $eca42d7f79c8fa3f$var$getAgentNameFromMetadata(metadata) {
    const attrs = {};
    const agentName = metadata === null || metadata === void 0 ? void 0 : metadata.lc_agent_name;
    if (typeof agentName === "string") attrs[$akoBU.GEN_AI_AGENT_NAME_ATTRIBUTE] = agentName;
    return attrs;
}
function $eca42d7f79c8fa3f$var$extractToolDefinitions(extraParams) {
    var _extraParams_invocation_params, _extraParams_options;
    var _extraParams_invocation_params_tools;
    const tools = (_extraParams_invocation_params_tools = extraParams === null || extraParams === void 0 ? void 0 : (_extraParams_invocation_params = extraParams.invocation_params) === null || _extraParams_invocation_params === void 0 ? void 0 : _extraParams_invocation_params.tools) !== null && _extraParams_invocation_params_tools !== void 0 ? _extraParams_invocation_params_tools : extraParams === null || extraParams === void 0 ? void 0 : (_extraParams_options = extraParams.options) === null || _extraParams_options === void 0 ? void 0 : _extraParams_options.tools;
    if (!Array.isArray(tools) || tools.length === 0) return void 0;
    const toolDefs = tools.map((tool)=>{
        const fn = tool.function;
        var _tool_name, _ref, _tool_description;
        return {
            type: "function",
            name: (_ref = (_tool_name = tool.name) !== null && _tool_name !== void 0 ? _tool_name : fn === null || fn === void 0 ? void 0 : fn.name) !== null && _ref !== void 0 ? _ref : "",
            description: (_tool_description = tool.description) !== null && _tool_description !== void 0 ? _tool_description : fn === null || fn === void 0 ? void 0 : fn.description
        };
    });
    return JSON.stringify(toolDefs);
}
function $eca42d7f79c8fa3f$var$isCallbackManager(value) {
    if (!value || typeof value !== "object") return false;
    const candidate = value;
    return typeof candidate.addHandler === "function" && typeof candidate.copy === "function";
}
function $eca42d7f79c8fa3f$var$isSentryHandler(handler) {
    return typeof handler === "object" && (handler === null || handler === void 0 ? void 0 : handler.name) === "SentryCallbackHandler";
}
function $eca42d7f79c8fa3f$var$containsSentryHandler(handlers) {
    return handlers.some($eca42d7f79c8fa3f$var$isSentryHandler);
}
function $eca42d7f79c8fa3f$var$_INTERNAL_mergeLangChainCallbackHandler(existing, sentryHandler) {
    if (!existing) return [
        sentryHandler
    ];
    if ($eca42d7f79c8fa3f$var$isCallbackManager(existing)) {
        var _existing_handlers;
        if ($eca42d7f79c8fa3f$var$containsSentryHandler((_existing_handlers = existing.handlers) !== null && _existing_handlers !== void 0 ? _existing_handlers : [])) return existing;
        const copied = existing.copy();
        copied.addHandler(sentryHandler, true);
        return copied;
    }
    const handlers = Array.isArray(existing) ? existing : [
        existing
    ];
    if ($eca42d7f79c8fa3f$var$containsSentryHandler(handlers)) return existing;
    return [
        ...handlers,
        sentryHandler
    ];
}
module.exports._INTERNAL_mergeLangChainCallbackHandler = $eca42d7f79c8fa3f$var$_INTERNAL_mergeLangChainCallbackHandler;
module.exports.extractChatModelRequestAttributes = $eca42d7f79c8fa3f$var$extractChatModelRequestAttributes;
module.exports.extractLLMRequestAttributes = $eca42d7f79c8fa3f$var$extractLLMRequestAttributes;
module.exports.extractLlmResponseAttributes = $eca42d7f79c8fa3f$var$extractLlmResponseAttributes;
module.exports.extractToolDefinitions = $eca42d7f79c8fa3f$var$extractToolDefinitions;
module.exports.getAgentNameFromMetadata = $eca42d7f79c8fa3f$var$getAgentNameFromMetadata;
module.exports.getInvocationParams = $eca42d7f79c8fa3f$var$getInvocationParams;
module.exports.normalizeLangChainMessages = $eca42d7f79c8fa3f$var$normalizeLangChainMessages;

});


parcelRegister("8L7Uc", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gHOmH = parcelRequire("gHOmH");

var $faX3S = parcelRequire("faX3S");

var $eqMxV = parcelRequire("eqMxV");

var $gvNu3 = parcelRequire("gvNu3");

var $akoBU = parcelRequire("akoBU");

var $8TMtR = parcelRequire("8TMtR");

var $7NTnD = parcelRequire("7NTnD");

var $kjDrv = parcelRequire("kjDrv");

var $gqKbc = parcelRequire("gqKbc");

var $1Mkyx = parcelRequire("1Mkyx");
let $6608d85cf03dfffa$var$_insideCreateReactAgent = false;
const $6608d85cf03dfffa$var$SENTRY_PATCHED = "__sentry_patched__";
function $6608d85cf03dfffa$var$instrumentStateGraphCompile(originalCompile, options) {
    if (Object.prototype.hasOwnProperty.call(originalCompile, $6608d85cf03dfffa$var$SENTRY_PATCHED)) return originalCompile;
    const sentryHandler = $7NTnD.createLangChainCallbackHandler(options);
    const wrapped = new Proxy(originalCompile, {
        apply (target, thisArg, args) {
            if ($6608d85cf03dfffa$var$_insideCreateReactAgent) return Reflect.apply(target, thisArg, args);
            return $gvNu3.startSpan({
                op: "gen_ai.create_agent",
                name: "create_agent",
                attributes: {
                    [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $gqKbc.LANGGRAPH_ORIGIN,
                    [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.create_agent",
                    [$akoBU.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "create_agent"
                }
            }, (span)=>{
                try {
                    const compiledGraph = Reflect.apply(target, thisArg, args);
                    const compileOptions = args.length > 0 ? args[0] : {};
                    if ((compileOptions === null || compileOptions === void 0 ? void 0 : compileOptions.name) && typeof compileOptions.name === "string") {
                        span.setAttribute($akoBU.GEN_AI_AGENT_NAME_ATTRIBUTE, compileOptions.name);
                        span.updateName(`create_agent ${compileOptions.name}`);
                    }
                    const originalInvoke = compiledGraph.invoke;
                    if (originalInvoke && typeof originalInvoke === "function") compiledGraph.invoke = $6608d85cf03dfffa$var$instrumentCompiledGraphInvoke(originalInvoke.bind(compiledGraph), compiledGraph, compileOptions, options, void 0, sentryHandler);
                    return compiledGraph;
                } catch (error) {
                    span.setStatus({
                        code: $eqMxV.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    $gHOmH.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.langgraph.error"
                        }
                    });
                    throw error;
                }
            });
        }
    });
    Object.defineProperty(wrapped, $6608d85cf03dfffa$var$SENTRY_PATCHED, {
        value: true,
        enumerable: false
    });
    return wrapped;
}
function $6608d85cf03dfffa$var$instrumentCompiledGraphInvoke(originalInvoke, graphInstance, compileOptions, options, llm, sentryCallbackHandler) {
    return new Proxy(originalInvoke, {
        apply (target, thisArg, args) {
            var _llm_modelName;
            const modelName = (_llm_modelName = llm === null || llm === void 0 ? void 0 : llm.modelName) !== null && _llm_modelName !== void 0 ? _llm_modelName : llm === null || llm === void 0 ? void 0 : llm.model;
            return $gvNu3.startSpan({
                op: "gen_ai.invoke_agent",
                name: "invoke_agent",
                attributes: {
                    [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $gqKbc.LANGGRAPH_ORIGIN,
                    [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $akoBU.GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE,
                    [$akoBU.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "invoke_agent"
                }
            }, async (span)=>{
                try {
                    var _args_;
                    const graphName = compileOptions === null || compileOptions === void 0 ? void 0 : compileOptions.name;
                    if (graphName && typeof graphName === "string") {
                        span.setAttribute($akoBU.GEN_AI_PIPELINE_NAME_ATTRIBUTE, graphName);
                        span.setAttribute($akoBU.GEN_AI_AGENT_NAME_ATTRIBUTE, graphName);
                        span.updateName(`invoke_agent ${graphName}`);
                    }
                    if (modelName) span.setAttribute($akoBU.GEN_AI_REQUEST_MODEL_ATTRIBUTE, modelName);
                    const config = args.length > 1 ? args[1] : void 0;
                    const configurable = config === null || config === void 0 ? void 0 : config.configurable;
                    const threadId = configurable === null || configurable === void 0 ? void 0 : configurable.thread_id;
                    if (threadId && typeof threadId === "string") span.setAttribute($akoBU.GEN_AI_CONVERSATION_ID_ATTRIBUTE, threadId);
                    if (sentryCallbackHandler) {
                        var _args_1;
                        const invokeConfig = (_args_1 = args[1]) !== null && _args_1 !== void 0 ? _args_1 : {};
                        args[1] = invokeConfig;
                        var _invokeConfig_metadata;
                        const existingMetadata = (_invokeConfig_metadata = invokeConfig.metadata) !== null && _invokeConfig_metadata !== void 0 ? _invokeConfig_metadata : {};
                        invokeConfig.metadata = (0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({}, existingMetadata), {
                            __sentry_langgraph__: true
                        }), typeof graphName === "string" ? {
                            lc_agent_name: graphName
                        } : {});
                        invokeConfig.callbacks = $kjDrv._INTERNAL_mergeLangChainCallbackHandler(invokeConfig.callbacks, sentryCallbackHandler);
                    }
                    const tools = $1Mkyx.extractToolsFromCompiledGraph(graphInstance);
                    if (tools) span.setAttribute($akoBU.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE, JSON.stringify(tools));
                    const recordInputs = options.recordInputs;
                    const recordOutputs = options.recordOutputs;
                    var _args__messages;
                    const inputMessages = args.length > 0 ? (_args__messages = (_args_ = args[0]) === null || _args_ === void 0 ? void 0 : _args_.messages) !== null && _args__messages !== void 0 ? _args__messages : [] : [];
                    if (inputMessages && recordInputs) {
                        const normalizedMessages = $kjDrv.normalizeLangChainMessages(inputMessages);
                        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $8TMtR.extractSystemInstructions(normalizedMessages);
                        if (systemInstructions) span.setAttribute($akoBU.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
                        const enableTruncation = $8TMtR.shouldEnableTruncation(options.enableTruncation);
                        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
                        span.setAttributes({
                            [$akoBU.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $8TMtR.getTruncatedJsonString(filteredMessages) : $8TMtR.getJsonString(filteredMessages),
                            [$akoBU.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
                        });
                    }
                    const result = await Reflect.apply(target, thisArg, args);
                    if (recordOutputs) $1Mkyx.setResponseAttributes(span, inputMessages !== null && inputMessages !== void 0 ? inputMessages : null, result);
                    return result;
                } catch (error) {
                    span.setStatus({
                        code: $eqMxV.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    $gHOmH.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.langgraph.error"
                        }
                    });
                    throw error;
                }
            });
        }
    });
}
function $6608d85cf03dfffa$var$instrumentCreateReactAgent(originalCreateReactAgent, options) {
    if (Object.prototype.hasOwnProperty.call(originalCreateReactAgent, $6608d85cf03dfffa$var$SENTRY_PATCHED)) return originalCreateReactAgent;
    const resolvedOptions = $8TMtR.resolveAIRecordingOptions(options);
    const sentryHandler = $7NTnD.createLangChainCallbackHandler(resolvedOptions);
    const wrapped = new Proxy(originalCreateReactAgent, {
        apply (target, thisArg, args) {
            const llm = $1Mkyx.extractLLMFromParams(args);
            const agentName = $1Mkyx.extractAgentNameFromParams(args);
            const params = args[0];
            if (params && Array.isArray(params.tools) && params.tools.length > 0) $1Mkyx.wrapToolsWithSpans(params.tools, resolvedOptions, agentName !== null && agentName !== void 0 ? agentName : void 0);
            $6608d85cf03dfffa$var$_insideCreateReactAgent = true;
            let compiledGraph;
            try {
                compiledGraph = Reflect.apply(target, thisArg, args);
            } finally{
                $6608d85cf03dfffa$var$_insideCreateReactAgent = false;
            }
            const originalInvoke = compiledGraph.invoke;
            if (originalInvoke && typeof originalInvoke === "function") {
                const compileOptions = {};
                if (agentName) compileOptions.name = agentName;
                compiledGraph.invoke = $6608d85cf03dfffa$var$instrumentCompiledGraphInvoke(originalInvoke.bind(compiledGraph), compiledGraph, compileOptions, resolvedOptions, llm, sentryHandler);
            }
            return compiledGraph;
        }
    });
    Object.defineProperty(wrapped, $6608d85cf03dfffa$var$SENTRY_PATCHED, {
        value: true,
        enumerable: false
    });
    return wrapped;
}
function $6608d85cf03dfffa$var$instrumentLangGraph(stateGraph, options) {
    stateGraph.compile = $6608d85cf03dfffa$var$instrumentStateGraphCompile(stateGraph.compile, $8TMtR.resolveAIRecordingOptions(options));
    return stateGraph;
}
module.exports.instrumentCreateReactAgent = $6608d85cf03dfffa$var$instrumentCreateReactAgent;
module.exports.instrumentLangGraph = $6608d85cf03dfffa$var$instrumentLangGraph;
module.exports.instrumentStateGraphCompile = $6608d85cf03dfffa$var$instrumentStateGraphCompile;

});
parcelRegister("gqKbc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $bf62e55cb54b6781$var$LANGGRAPH_INTEGRATION_NAME = "LangGraph";
const $bf62e55cb54b6781$var$LANGGRAPH_ORIGIN = "auto.ai.langgraph";
module.exports.LANGGRAPH_INTEGRATION_NAME = $bf62e55cb54b6781$var$LANGGRAPH_INTEGRATION_NAME;
module.exports.LANGGRAPH_ORIGIN = $bf62e55cb54b6781$var$LANGGRAPH_ORIGIN;

});

parcelRegister("1Mkyx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gHOmH = parcelRequire("gHOmH");

var $faX3S = parcelRequire("faX3S");

var $eqMxV = parcelRequire("eqMxV");

var $gvNu3 = parcelRequire("gvNu3");

var $akoBU = parcelRequire("akoBU");

var $kjDrv = parcelRequire("kjDrv");

var $gqKbc = parcelRequire("gqKbc");
function $14ba38241b4f98bb$var$extractLLMFromParams(args) {
    const arg = args[0];
    if (typeof arg !== "object" || !arg || !("llm" in arg) || !arg.llm || typeof arg.llm !== "object") return null;
    const llm = arg.llm;
    if (typeof llm.modelName !== "string" && typeof llm.model !== "string") return null;
    return llm;
}
function $14ba38241b4f98bb$var$extractAgentNameFromParams(args) {
    const arg = args[0];
    if (typeof arg === "object" && !!arg && "name" in arg && typeof arg.name === "string") return arg.name;
    return null;
}
function $14ba38241b4f98bb$var$wrapToolsWithSpans(tools, options, agentName) {
    const SENTRY_WRAPPED = "__sentry_tool_wrapped__";
    for (const tool of tools){
        if (!tool || typeof tool !== "object") continue;
        const t = tool;
        const originalInvoke = t.invoke;
        if (typeof originalInvoke !== "function" || Object.prototype.hasOwnProperty.call(t, SENTRY_WRAPPED)) continue;
        const toolName = typeof t.name === "string" ? t.name : "unknown_tool";
        const toolDescription = typeof t.description === "string" ? t.description : void 0;
        const wrappedInvoke = new Proxy(originalInvoke, {
            apply (target, thisArg, args) {
                var _callConfig_metadata;
                const spanAttributes = {
                    [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $gqKbc.LANGGRAPH_ORIGIN,
                    [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $akoBU.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE,
                    [$akoBU.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "execute_tool",
                    [$akoBU.GEN_AI_TOOL_NAME_ATTRIBUTE]: toolName,
                    [$akoBU.GEN_AI_TOOL_TYPE_ATTRIBUTE]: "function"
                };
                const callConfig = args[1];
                var _callConfig_metadata_lc_agent_name;
                const callAgentName = (_callConfig_metadata_lc_agent_name = callConfig === null || callConfig === void 0 ? void 0 : (_callConfig_metadata = callConfig.metadata) === null || _callConfig_metadata === void 0 ? void 0 : _callConfig_metadata.lc_agent_name) !== null && _callConfig_metadata_lc_agent_name !== void 0 ? _callConfig_metadata_lc_agent_name : agentName;
                if (typeof callAgentName === "string") spanAttributes[$akoBU.GEN_AI_AGENT_NAME_ATTRIBUTE] = callAgentName;
                if (toolDescription) spanAttributes[$akoBU.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = toolDescription;
                const input = args[0];
                if (typeof input === "object" && !!input) {
                    if ("id" in input && typeof input.id === "string") spanAttributes[$akoBU.GEN_AI_TOOL_CALL_ID_ATTRIBUTE] = input.id;
                    if (options.recordInputs) {
                        const toolArgs = "args" in input && typeof input.args === "object" ? input.args : input;
                        try {
                            spanAttributes[$akoBU.GEN_AI_TOOL_INPUT_ATTRIBUTE] = JSON.stringify(toolArgs);
                        } catch (e) {}
                    }
                }
                return $gvNu3.startSpan({
                    op: $akoBU.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE,
                    name: `execute_tool ${toolName}`,
                    attributes: spanAttributes
                }, async (span)=>{
                    try {
                        const result = await Reflect.apply(target, thisArg, args);
                        if (options.recordOutputs) try {
                            const resultObj = result;
                            const content = resultObj && typeof resultObj === "object" && "content" in resultObj ? resultObj.content : result;
                            span.setAttribute($akoBU.GEN_AI_TOOL_OUTPUT_ATTRIBUTE, typeof content === "string" ? content : JSON.stringify(content));
                        } catch (e) {}
                        return result;
                    } catch (error) {
                        span.setStatus({
                            code: $eqMxV.SPAN_STATUS_ERROR,
                            message: "internal_error"
                        });
                        $gHOmH.captureException(error, {
                            mechanism: {
                                handled: false,
                                type: "auto.ai.langgraph.error"
                            }
                        });
                        throw error;
                    }
                });
            }
        });
        t.invoke = wrappedInvoke;
        Object.defineProperty(t, SENTRY_WRAPPED, {
            value: true,
            enumerable: false
        });
    }
    return tools;
}
function $14ba38241b4f98bb$var$extractToolCalls(messages) {
    if (!messages || messages.length === 0) return null;
    const toolCalls = [];
    for (const message of messages)if (message && typeof message === "object") {
        const msgToolCalls = message.tool_calls;
        if (msgToolCalls && Array.isArray(msgToolCalls)) toolCalls.push(...msgToolCalls);
    }
    return toolCalls.length > 0 ? toolCalls : null;
}
function $14ba38241b4f98bb$var$extractTokenUsageFromMessage(message) {
    const msg = message;
    let inputTokens = 0;
    let outputTokens = 0;
    let totalTokens = 0;
    if (msg.usage_metadata && typeof msg.usage_metadata === "object") {
        const usage = msg.usage_metadata;
        if (typeof usage.input_tokens === "number") inputTokens = usage.input_tokens;
        if (typeof usage.output_tokens === "number") outputTokens = usage.output_tokens;
        if (typeof usage.total_tokens === "number") totalTokens = usage.total_tokens;
        return {
            inputTokens: inputTokens,
            outputTokens: outputTokens,
            totalTokens: totalTokens
        };
    }
    if (msg.response_metadata && typeof msg.response_metadata === "object") {
        const metadata = msg.response_metadata;
        if (metadata.tokenUsage && typeof metadata.tokenUsage === "object") {
            const tokenUsage = metadata.tokenUsage;
            if (typeof tokenUsage.promptTokens === "number") inputTokens = tokenUsage.promptTokens;
            if (typeof tokenUsage.completionTokens === "number") outputTokens = tokenUsage.completionTokens;
            if (typeof tokenUsage.totalTokens === "number") totalTokens = tokenUsage.totalTokens;
        }
    }
    return {
        inputTokens: inputTokens,
        outputTokens: outputTokens,
        totalTokens: totalTokens
    };
}
function $14ba38241b4f98bb$var$extractModelMetadata(span, message) {
    const msg = message;
    if (msg.response_metadata && typeof msg.response_metadata === "object") {
        const metadata = msg.response_metadata;
        if (metadata.model_name && typeof metadata.model_name === "string") span.setAttribute($akoBU.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, metadata.model_name);
        if (metadata.finish_reason && typeof metadata.finish_reason === "string") span.setAttribute($akoBU.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE, [
            metadata.finish_reason
        ]);
    }
}
function $14ba38241b4f98bb$var$extractToolsFromCompiledGraph(compiledGraph) {
    var _compiledGraph_builder_nodes_tools_runnable, _compiledGraph_builder_nodes_tools, _compiledGraph_builder_nodes, _compiledGraph_builder, _compiledGraph_builder_nodes_tools_runnable1, _compiledGraph_builder_nodes_tools1, _compiledGraph_builder_nodes1, _compiledGraph_builder1;
    if (!((_compiledGraph_builder = compiledGraph.builder) === null || _compiledGraph_builder === void 0 ? void 0 : (_compiledGraph_builder_nodes = _compiledGraph_builder.nodes) === null || _compiledGraph_builder_nodes === void 0 ? void 0 : (_compiledGraph_builder_nodes_tools = _compiledGraph_builder_nodes.tools) === null || _compiledGraph_builder_nodes_tools === void 0 ? void 0 : (_compiledGraph_builder_nodes_tools_runnable = _compiledGraph_builder_nodes_tools.runnable) === null || _compiledGraph_builder_nodes_tools_runnable === void 0 ? void 0 : _compiledGraph_builder_nodes_tools_runnable.tools)) return null;
    const tools = (_compiledGraph_builder1 = compiledGraph.builder) === null || _compiledGraph_builder1 === void 0 ? void 0 : (_compiledGraph_builder_nodes1 = _compiledGraph_builder1.nodes) === null || _compiledGraph_builder_nodes1 === void 0 ? void 0 : (_compiledGraph_builder_nodes_tools1 = _compiledGraph_builder_nodes1.tools) === null || _compiledGraph_builder_nodes_tools1 === void 0 ? void 0 : (_compiledGraph_builder_nodes_tools_runnable1 = _compiledGraph_builder_nodes_tools1.runnable) === null || _compiledGraph_builder_nodes_tools_runnable1 === void 0 ? void 0 : _compiledGraph_builder_nodes_tools_runnable1.tools;
    if (!tools || !Array.isArray(tools) || tools.length === 0) return null;
    return tools.map((tool)=>{
        var _tool_lc_kwargs, _tool_lc_kwargs1, _tool_lc_kwargs2;
        return {
            name: (_tool_lc_kwargs = tool.lc_kwargs) === null || _tool_lc_kwargs === void 0 ? void 0 : _tool_lc_kwargs.name,
            description: (_tool_lc_kwargs1 = tool.lc_kwargs) === null || _tool_lc_kwargs1 === void 0 ? void 0 : _tool_lc_kwargs1.description,
            schema: (_tool_lc_kwargs2 = tool.lc_kwargs) === null || _tool_lc_kwargs2 === void 0 ? void 0 : _tool_lc_kwargs2.schema
        };
    });
}
function $14ba38241b4f98bb$var$setResponseAttributes(span, inputMessages, result) {
    const resultObj = result;
    const outputMessages = resultObj === null || resultObj === void 0 ? void 0 : resultObj.messages;
    if (!outputMessages || !Array.isArray(outputMessages)) return;
    var _inputMessages_length;
    const inputCount = (_inputMessages_length = inputMessages === null || inputMessages === void 0 ? void 0 : inputMessages.length) !== null && _inputMessages_length !== void 0 ? _inputMessages_length : 0;
    const newMessages = outputMessages.length > inputCount ? outputMessages.slice(inputCount) : [];
    if (newMessages.length === 0) return;
    const toolCalls = $14ba38241b4f98bb$var$extractToolCalls(newMessages);
    if (toolCalls) span.setAttribute($akoBU.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, JSON.stringify(toolCalls));
    const normalizedNewMessages = $kjDrv.normalizeLangChainMessages(newMessages);
    span.setAttribute($akoBU.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, JSON.stringify(normalizedNewMessages));
    let totalInputTokens = 0;
    let totalOutputTokens = 0;
    let totalTokens = 0;
    for (const message of newMessages){
        const tokens = $14ba38241b4f98bb$var$extractTokenUsageFromMessage(message);
        totalInputTokens += tokens.inputTokens;
        totalOutputTokens += tokens.outputTokens;
        totalTokens += tokens.totalTokens;
        $14ba38241b4f98bb$var$extractModelMetadata(span, message);
    }
    if (totalInputTokens > 0) span.setAttribute($akoBU.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, totalInputTokens);
    if (totalOutputTokens > 0) span.setAttribute($akoBU.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, totalOutputTokens);
    if (totalTokens > 0) span.setAttribute($akoBU.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, totalTokens);
}
module.exports.extractAgentNameFromParams = $14ba38241b4f98bb$var$extractAgentNameFromParams;
module.exports.extractLLMFromParams = $14ba38241b4f98bb$var$extractLLMFromParams;
module.exports.extractModelMetadata = $14ba38241b4f98bb$var$extractModelMetadata;
module.exports.extractTokenUsageFromMessage = $14ba38241b4f98bb$var$extractTokenUsageFromMessage;
module.exports.extractToolCalls = $14ba38241b4f98bb$var$extractToolCalls;
module.exports.extractToolsFromCompiledGraph = $14ba38241b4f98bb$var$extractToolsFromCompiledGraph;
module.exports.setResponseAttributes = $14ba38241b4f98bb$var$setResponseAttributes;
module.exports.wrapToolsWithSpans = $14ba38241b4f98bb$var$wrapToolsWithSpans;

});


parcelRegister("5Cv1x", function(module, exports) {

var $bLhVg = parcelRequire("bLhVg");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $859Bb = parcelRequire("859Bb");

var $hQAU7 = parcelRequire("hQAU7");

var $8z1zH = parcelRequire("8z1zH");

var $lzdUA = parcelRequire("lzdUA");

var $cF4MM = parcelRequire("cF4MM");

var $he8mw = parcelRequire("he8mw");
const $4178910f0d495c03$var$MAX_SPANS_PER_ENVELOPE = 1e3;
const $4178910f0d495c03$var$MAX_TRACE_WEIGHT_IN_BYTES = 5e6;
class $4178910f0d495c03$var$SpanBuffer {
    /**
   * Add a span to the buffer.
   */ add(spanJSON) {
        const traceId = spanJSON.trace_id;
        let bucket = this._traceBuckets.get(traceId);
        if (!bucket) {
            bucket = {
                spans: /* @__PURE__ */ new Set(),
                size: 0,
                timeout: $8z1zH.safeUnref(setTimeout(()=>{
                    this.flush(traceId);
                }, this._flushInterval))
            };
            this._traceBuckets.set(traceId, bucket);
        }
        bucket.spans.add(spanJSON);
        bucket.size += $he8mw.estimateSerializedSpanSizeInBytes(spanJSON);
        if (bucket.spans.size >= this._maxSpanLimit || bucket.size >= this._maxTraceWeight) this.flush(traceId);
    }
    /**
   * Drain and flush all buffered traces.
   */ drain() {
        if (!this._traceBuckets.size) return;
        $859Bb.DEBUG_BUILD && $hQAU7.debug.log(`Flushing span tree map with ${this._traceBuckets.size} traces`);
        this._traceBuckets.forEach((_, traceId)=>{
            this.flush(traceId);
        });
    }
    /**
   * Flush spans of a specific trace.
   * In contrast to {@link SpanBuffer.drain}, this method does not flush all traces, but only the one with the given traceId.
   */ flush(traceId) {
        var _spans_;
        const bucket = this._traceBuckets.get(traceId);
        if (!bucket) return;
        if (!bucket.spans.size) {
            this._removeTrace(traceId);
            return;
        }
        const spans = Array.from(bucket.spans);
        const segmentSpan = (_spans_ = spans[0]) === null || _spans_ === void 0 ? void 0 : _spans_._segmentSpan;
        if (!segmentSpan) {
            $859Bb.DEBUG_BUILD && $hQAU7.debug.warn("No segment span reference found on span JSON, cannot compute DSC");
            this._removeTrace(traceId);
            return;
        }
        const dsc = $lzdUA.getDynamicSamplingContextFromSpan(segmentSpan);
        const cleanedSpans = spans.map((spanJSON)=>{
            const { _segmentSpan: _segmentSpan } = spanJSON, cleanSpanJSON = (0, $bLhVg._)(spanJSON, [
                "_segmentSpan"
            ]);
            return cleanSpanJSON;
        });
        const envelope$1 = $cF4MM.createStreamedSpanEnvelope(cleanedSpans, dsc, this._client);
        $859Bb.DEBUG_BUILD && $hQAU7.debug.log(`Sending span envelope for trace ${traceId} with ${cleanedSpans.length} spans`);
        this._client.sendEnvelope(envelope$1).then(null, (reason)=>{
            $859Bb.DEBUG_BUILD && $hQAU7.debug.error("Error while sending streamed span envelope:", reason);
        });
        this._removeTrace(traceId);
    }
    _removeTrace(traceId) {
        const bucket = this._traceBuckets.get(traceId);
        if (bucket) clearTimeout(bucket.timeout);
        this._traceBuckets.delete(traceId);
    }
    constructor(client, options){
        this._traceBuckets = /* @__PURE__ */ new Map();
        this._client = client;
        const { maxSpanLimit: maxSpanLimit, flushInterval: flushInterval, maxTraceWeightInBytes: maxTraceWeightInBytes } = options !== null && options !== void 0 ? options : {};
        this._maxSpanLimit = maxSpanLimit && maxSpanLimit > 0 && maxSpanLimit <= $4178910f0d495c03$var$MAX_SPANS_PER_ENVELOPE ? maxSpanLimit : $4178910f0d495c03$var$MAX_SPANS_PER_ENVELOPE;
        this._flushInterval = flushInterval && flushInterval > 0 ? flushInterval : 5e3;
        this._maxTraceWeight = maxTraceWeightInBytes && maxTraceWeightInBytes > 0 ? maxTraceWeightInBytes : $4178910f0d495c03$var$MAX_TRACE_WEIGHT_IN_BYTES;
        this._client.on("flush", ()=>{
            this.drain();
        });
        this._client.on("close", ()=>{
            this._traceBuckets.forEach((bucket)=>{
                clearTimeout(bucket.timeout);
            });
            this._traceBuckets.clear();
        });
    }
}
module.exports.SpanBuffer = $4178910f0d495c03$var$SpanBuffer;

});
parcelRegister("cF4MM", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ghmbo = parcelRequire("ghmbo");

var $bIVq4 = parcelRequire("bIVq4");

var $dhyIj = parcelRequire("dhyIj");

var $hxJcq = parcelRequire("hxJcq");
function $937d06bf07c1184b$var$createStreamedSpanEnvelope(serializedSpans, dsc, client) {
    const options = client.getOptions();
    const dsn$1 = client.getDsn();
    const tunnel = options.tunnel;
    const sdk = $bIVq4.getSdkMetadataForEnvelopeHeader(options._metadata);
    const headers = (0, $9tqwB._)({
        sent_at: new Date($hxJcq.safeDateNow()).toISOString()
    }, $937d06bf07c1184b$var$dscHasRequiredProps(dsc) && {
        trace: dsc
    }, sdk && {
        sdk: sdk
    }, !!tunnel && dsn$1 && {
        dsn: $ghmbo.dsnToString(dsn$1)
    });
    const inferSetting = client.getDataCollectionOptions().userInfo ? "auto" : "never";
    const spanContainer = [
        {
            type: "span",
            item_count: serializedSpans.length,
            content_type: "application/vnd.sentry.items.span.v2+json"
        },
        (0, $2qxEV._)((0, $9tqwB._)({
            version: 2
        }, $dhyIj.isBrowser() && {
            ingest_settings: {
                infer_ip: inferSetting,
                infer_user_agent: inferSetting
            }
        }), {
            items: serializedSpans
        })
    ];
    return $bIVq4.createEnvelope(headers, [
        spanContainer
    ]);
}
function $937d06bf07c1184b$var$dscHasRequiredProps(dsc) {
    return !!dsc.trace_id && !!dsc.public_key;
}
module.exports.createStreamedSpanEnvelope = $937d06bf07c1184b$var$createStreamedSpanEnvelope;

});

parcelRegister("he8mw", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $i7X1A = parcelRequire("i7X1A");
function $c8aa3b07f0c4a467$var$estimateSerializedSpanSizeInBytes(span) {
    let weight = 156;
    weight += span.name.length * 2;
    weight += $i7X1A.estimateTypedAttributesSizeInBytes(span.attributes);
    if (span.links && span.links.length > 0) {
        const firstLink = span.links[0];
        const attributes$1 = firstLink === null || firstLink === void 0 ? void 0 : firstLink.attributes;
        const linkWeight = 100 + (attributes$1 ? $i7X1A.estimateTypedAttributesSizeInBytes(attributes$1) : 0);
        weight += linkWeight * span.links.length;
    }
    return weight;
}
module.exports.estimateSerializedSpanSizeInBytes = $c8aa3b07f0c4a467$var$estimateSerializedSpanSizeInBytes;

});


parcelRegister("1wWAR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $859Bb = parcelRequire("859Bb");

var $Qi0TL = parcelRequire("Qi0TL");

var $1npIi = parcelRequire("1npIi");

var $elQdO = parcelRequire("elQdO");

var $aSFvs = parcelRequire("aSFvs");

var $5Cv1x = parcelRequire("5Cv1x");

var $hQAU7 = parcelRequire("hQAU7");

var $dRW3b = parcelRequire("dRW3b");
const $11d63b0ebf7d5a3b$var$spanStreamingIntegration = $Qi0TL.defineIntegration(()=>{
    return {
        name: "SpanStreaming",
        setup (client) {
            const initialMessage = "SpanStreaming integration requires";
            const fallbackMsg = "Falling back to static trace lifecycle.";
            const clientOptions = client.getOptions();
            if (!$aSFvs.hasSpanStreamingEnabled(client)) {
                clientOptions.traceLifecycle = "static";
                $859Bb.DEBUG_BUILD && $hQAU7.debug.warn(`${initialMessage} \`traceLifecycle\` to be set to "stream"! ${fallbackMsg}`);
                return;
            }
            const beforeSendSpan$1 = clientOptions.beforeSendSpan;
            if (beforeSendSpan$1 && !$1npIi.isStreamedBeforeSendSpanCallback(beforeSendSpan$1)) {
                clientOptions.traceLifecycle = "static";
                $859Bb.DEBUG_BUILD && $hQAU7.debug.warn(`${initialMessage} a beforeSendSpan callback using \`withStreamedSpan\`! ${fallbackMsg}`);
                return;
            }
            const buffer = new $5Cv1x.SpanBuffer(client);
            client.on("afterSpanEnd", (span)=>{
                if (!$dRW3b.spanIsSampled(span)) return;
                buffer.add($elQdO.captureSpan(span, client));
            });
        }
    };
});
module.exports.spanStreamingIntegration = $11d63b0ebf7d5a3b$var$spanStreamingIntegration;

});

parcelRegister("8kVQq", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $611d0fbb2e5e384c$var$getBreadcrumbLogLevelFromHttpStatusCode(statusCode) {
    if (statusCode === void 0) return void 0;
    else if (statusCode >= 400 && statusCode < 500) return "warning";
    else if (statusCode >= 500) return "error";
    else return void 0;
}
module.exports.getBreadcrumbLogLevelFromHttpStatusCode = $611d0fbb2e5e384c$var$getBreadcrumbLogLevelFromHttpStatusCode;

});

parcelRegister("iv6Ei", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
class $d7804792dc91f858$var$SentryError extends Error {
    constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.logLevel = logLevel;
    }
}
module.exports.SentryError = $d7804792dc91f858$var$SentryError;

});

parcelRegister("XtYlA", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hSRcd = parcelRequire("hSRcd");

var $ibzbk = parcelRequire("ibzbk");

var $eEQXZ = parcelRequire("eEQXZ");

var $dSbBL = parcelRequire("dSbBL");

var $jHcnM = parcelRequire("jHcnM");

var $15YuE = parcelRequire("15YuE");

var $jSWkL = parcelRequire("jSWkL");
function $0b2cc2af74e95a6a$var$addFetchInstrumentationHandler(handler, skipNativeFetchCheck) {
    const type = "fetch";
    const removeHandler = $jSWkL.addHandler(type, handler);
    $jSWkL.maybeInstrument(type, ()=>$0b2cc2af74e95a6a$var$instrumentFetch(void 0, skipNativeFetchCheck));
    return removeHandler;
}
function $0b2cc2af74e95a6a$var$addFetchEndInstrumentationHandler(handler) {
    const type = "fetch-body-resolved";
    const removeHandler = $jSWkL.addHandler(type, handler);
    $jSWkL.maybeInstrument(type, ()=>$0b2cc2af74e95a6a$var$instrumentFetch($0b2cc2af74e95a6a$var$streamHandler));
    return removeHandler;
}
function $0b2cc2af74e95a6a$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !$dSbBL.supportsNativeFetch()) return;
    $eEQXZ.fill($15YuE.GLOBAL_OBJ, "fetch", function(originalFetch) {
        return function(...args) {
            const virtualError = new Error();
            const { method: method, url: url } = $0b2cc2af74e95a6a$var$parseFetchArgs(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: $jHcnM.timestampInSeconds() * 1e3,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $0b2cc2af74e95a6a$var$getHeadersFromFetchArgs(args)
            };
            if (!onFetchResolved) $jSWkL.triggerHandlers("fetch", (0, $9tqwB._)({}, handlerData));
            return originalFetch.apply($15YuE.GLOBAL_OBJ, args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else $jSWkL.triggerHandlers("fetch", (0, $2qxEV._)((0, $9tqwB._)({}, handlerData), {
                    endTimestamp: $jHcnM.timestampInSeconds() * 1e3,
                    response: response
                }));
                return response;
            }, (error)=>{
                $jSWkL.triggerHandlers("fetch", (0, $2qxEV._)((0, $9tqwB._)({}, handlerData), {
                    endTimestamp: $jHcnM.timestampInSeconds() * 1e3,
                    error: error
                }));
                if ($ibzbk.isError(error) && error.stack === void 0) {
                    error.stack = virtualError.stack;
                    $eEQXZ.addNonEnumerableProperty(error, "framesToPop", 1);
                }
                const client = $hSRcd.getClient();
                var _client_getOptions_enhanceFetchErrorMessages;
                const enhanceOption = (_client_getOptions_enhanceFetchErrorMessages = client === null || client === void 0 ? void 0 : client.getOptions().enhanceFetchErrorMessages) !== null && _client_getOptions_enhanceFetchErrorMessages !== void 0 ? _client_getOptions_enhanceFetchErrorMessages : "always";
                const shouldEnhance = enhanceOption !== false;
                if (shouldEnhance && error instanceof TypeError && (error.message === "Failed to fetch" || error.message === "Load failed" || error.message === "NetworkError when attempting to fetch resource.")) try {
                    const url2 = new URL(handlerData.fetchData.url);
                    const hostname = url2.host;
                    if (enhanceOption === "always") error.message = `${error.message} (${hostname})`;
                    else $eEQXZ.addNonEnumerableProperty(error, "__sentry_fetch_url_host__", hostname);
                } catch (e) {}
                throw error;
            });
        };
    });
}
async function $0b2cc2af74e95a6a$var$resolveResponse(res, onFinishedResolving) {
    if (res === null || res === void 0 ? void 0 : res.body) {
        const body = res.body;
        const responseReader = body.getReader();
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{});
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{});
                }, 5e3);
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch (e) {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{});
    }
}
function $0b2cc2af74e95a6a$var$streamHandler(response) {
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch (e) {
        return;
    }
    $0b2cc2af74e95a6a$var$resolveResponse(clonedResponseForResolving, ()=>{
        $jSWkL.triggerHandlers("fetch-body-resolved", {
            endTimestamp: $jHcnM.timestampInSeconds() * 1e3,
            response: response
        });
    });
}
function $0b2cc2af74e95a6a$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $0b2cc2af74e95a6a$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($0b2cc2af74e95a6a$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
function $0b2cc2af74e95a6a$var$parseFetchArgs(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [resource, options] = fetchArgs;
        return {
            url: $0b2cc2af74e95a6a$var$getUrlFromResource(resource),
            method: $0b2cc2af74e95a6a$var$hasProp(options, "method") ? String(options.method).toUpperCase() : // Request object as first argument
            $ibzbk.isRequest(resource) && $0b2cc2af74e95a6a$var$hasProp(resource, "method") ? String(resource.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $0b2cc2af74e95a6a$var$getUrlFromResource(arg),
        method: $0b2cc2af74e95a6a$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
function $0b2cc2af74e95a6a$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === "object" && optionsArgument !== null && "headers" in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ($ibzbk.isRequest(requestArgument)) return new Headers(requestArgument.headers);
    } catch (e) {}
    return;
}
module.exports.addFetchEndInstrumentationHandler = $0b2cc2af74e95a6a$var$addFetchEndInstrumentationHandler;
module.exports.addFetchInstrumentationHandler = $0b2cc2af74e95a6a$var$addFetchInstrumentationHandler;
module.exports.parseFetchArgs = $0b2cc2af74e95a6a$var$parseFetchArgs;

});
parcelRegister("dSbBL", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $859Bb = parcelRequire("859Bb");

var $hQAU7 = parcelRequire("hQAU7");

var $15YuE = parcelRequire("15YuE");
const $a199529f1614cbe1$var$WINDOW = $15YuE.GLOBAL_OBJ;
function $a199529f1614cbe1$var$supportsErrorEvent() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
function $a199529f1614cbe1$var$supportsDOMError() {
    try {
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
function $a199529f1614cbe1$var$supportsDOMException() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
function $a199529f1614cbe1$var$supportsHistory() {
    return "history" in $a199529f1614cbe1$var$WINDOW && !!$a199529f1614cbe1$var$WINDOW.history;
}
const $a199529f1614cbe1$var$supportsFetch = $a199529f1614cbe1$var$_isFetchSupported;
function $a199529f1614cbe1$var$_isFetchSupported() {
    if (!("fetch" in $a199529f1614cbe1$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("data:,");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
function $a199529f1614cbe1$var$isNativeFunction(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $a199529f1614cbe1$var$supportsNativeFetch() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$a199529f1614cbe1$var$_isFetchSupported()) return false;
    if ($a199529f1614cbe1$var$isNativeFunction($a199529f1614cbe1$var$WINDOW.fetch)) return true;
    let result = false;
    const doc = $a199529f1614cbe1$var$WINDOW.document;
    if (doc && typeof doc.createElement === "function") try {
        var _sandbox_contentWindow;
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if ((_sandbox_contentWindow = sandbox.contentWindow) === null || _sandbox_contentWindow === void 0 ? void 0 : _sandbox_contentWindow.fetch) result = $a199529f1614cbe1$var$isNativeFunction(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        $859Bb.DEBUG_BUILD && $hQAU7.debug.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $a199529f1614cbe1$var$supportsReportingObserver() {
    return "ReportingObserver" in $a199529f1614cbe1$var$WINDOW;
}
function $a199529f1614cbe1$var$supportsReferrerPolicy() {
    if (!$a199529f1614cbe1$var$_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isNativeFunction = $a199529f1614cbe1$var$isNativeFunction;
module.exports.supportsDOMError = $a199529f1614cbe1$var$supportsDOMError;
module.exports.supportsDOMException = $a199529f1614cbe1$var$supportsDOMException;
module.exports.supportsErrorEvent = $a199529f1614cbe1$var$supportsErrorEvent;
module.exports.supportsFetch = $a199529f1614cbe1$var$supportsFetch;
module.exports.supportsHistory = $a199529f1614cbe1$var$supportsHistory;
module.exports.supportsNativeFetch = $a199529f1614cbe1$var$supportsNativeFetch;
module.exports.supportsReferrerPolicy = $a199529f1614cbe1$var$supportsReferrerPolicy;
module.exports.supportsReportingObserver = $a199529f1614cbe1$var$supportsReportingObserver;

});


parcelRegister("78ha4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $531697a9a8f89db2$var$replaceExports(exports1, exportName, wrappedConstructor) {
    const original = exports1[exportName];
    if (typeof original !== "function") return;
    try {
        exports1[exportName] = wrappedConstructor;
    } catch (e) {
        Object.defineProperty(exports1, exportName, {
            value: wrappedConstructor,
            writable: true,
            configurable: true,
            enumerable: true
        });
    }
    if (exports1.default === original) try {
        exports1.default = wrappedConstructor;
    } catch (e) {
        Object.defineProperty(exports1, "default", {
            value: wrappedConstructor,
            writable: true,
            configurable: true,
            enumerable: true
        });
    }
}
module.exports.replaceExports = $531697a9a8f89db2$var$replaceExports;

});

parcelRegister("lqAjj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
class $f998312dca624c75$var$LRUMap {
    /** Get the current size of the cache */ get size() {
        return this._cache.size;
    }
    /** Get an entry or undefined if it was not in the cache. Re-inserts to update the recently used order */ get(key) {
        const value = this._cache.get(key);
        if (value === void 0) return void 0;
        this._cache.delete(key);
        this._cache.set(key, value);
        return value;
    }
    /** Insert an entry and evict an older entry if we've reached maxSize */ set(key, value) {
        if (this._cache.size >= this._maxSize) {
            const nextKey = this._cache.keys().next().value;
            this._cache.delete(nextKey);
        }
        this._cache.set(key, value);
    }
    /** Remove an entry and return the entry if it was in the cache */ remove(key) {
        const value = this._cache.get(key);
        if (value) this._cache.delete(key);
        return value;
    }
    /** Clear all entries */ clear() {
        this._cache.clear();
    }
    /** Get all the keys */ keys() {
        return Array.from(this._cache.keys());
    }
    /** Get all the values */ values() {
        const values = [];
        this._cache.forEach((value)=>values.push(value));
        return values;
    }
    constructor(_maxSize){
        this._maxSize = _maxSize;
        this._cache = /* @__PURE__ */ new Map();
    }
}
module.exports.LRUMap = $f998312dca624c75$var$LRUMap;

});

parcelRegister("jiEbv", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $e0cede8e7c52491f$var$escapeStringForRegex(regexString) {
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
module.exports.escapeStringForRegex = $e0cede8e7c52491f$var$escapeStringForRegex;

});

parcelRegister("9a6Na", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ibzbk = parcelRequire("ibzbk");

var $15YuE = parcelRequire("15YuE");
const $6aba50fb9e159faf$var$WINDOW = $15YuE.GLOBAL_OBJ;
const $6aba50fb9e159faf$var$DEFAULT_MAX_STRING_LENGTH = 80;
function $6aba50fb9e159faf$var$htmlTreeAsString(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $6aba50fb9e159faf$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $6aba50fb9e159faf$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (e) {
        return "<unknown>";
    }
}
function $6aba50fb9e159faf$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!(elem === null || elem === void 0 ? void 0 : elem.tagName)) return "";
    if ($6aba50fb9e159faf$var$WINDOW.HTMLElement) {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    const keyAttrPairs = (keyAttrs === null || keyAttrs === void 0 ? void 0 : keyAttrs.length) ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs === null || keyAttrPairs === void 0 ? void 0 : keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && $ibzbk.isString(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
function $6aba50fb9e159faf$var$getLocationHref() {
    try {
        return $6aba50fb9e159faf$var$WINDOW.document.location.href;
    } catch (e) {
        return "";
    }
}
function $6aba50fb9e159faf$var$getComponentName(elem, maxTraverseHeight = 5) {
    if (!$6aba50fb9e159faf$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    for(let i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}
module.exports.getComponentName = $6aba50fb9e159faf$var$getComponentName;
module.exports.getLocationHref = $6aba50fb9e159faf$var$getLocationHref;
module.exports.htmlTreeAsString = $6aba50fb9e159faf$var$htmlTreeAsString;

});

parcelRegister("hk7pu", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gHOmH = parcelRequire("gHOmH");

var $faX3S = parcelRequire("faX3S");

var $gvNu3 = parcelRequire("gvNu3");

var $akoBU = parcelRequire("akoBU");

var $8TMtR = parcelRequire("8TMtR");

var $cWsYm = parcelRequire("cWsYm");
function $c9ca0d6800f93a15$var$inferSystemFromInstance(instance) {
    var _instance_constructor;
    var _instance_constructor_name;
    const name = (_instance_constructor_name = (_instance_constructor = instance.constructor) === null || _instance_constructor === void 0 ? void 0 : _instance_constructor.name) !== null && _instance_constructor_name !== void 0 ? _instance_constructor_name : "";
    if (name.includes("OpenAI")) return "openai";
    if (name.includes("Google")) return "google_genai";
    if (name.includes("Mistral")) return "mistralai";
    if (name.includes("Vertex")) return "google_vertexai";
    if (name.includes("Bedrock")) return "aws_bedrock";
    if (name.includes("Ollama")) return "ollama";
    if (name.includes("Cloudflare")) return "cloudflare";
    if (name.includes("Cohere")) return "cohere";
    return "langchain";
}
function $c9ca0d6800f93a15$var$extractEmbeddingAttributes(instance) {
    const embeddingsInstance = instance !== null && instance !== void 0 ? instance : {};
    var _embeddingsInstance_model;
    const attributes = {
        [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $cWsYm.LANGCHAIN_ORIGIN,
        [$faX3S.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $akoBU.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE,
        [$akoBU.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "embeddings",
        [$akoBU.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: (_embeddingsInstance_model = embeddingsInstance.model) !== null && _embeddingsInstance_model !== void 0 ? _embeddingsInstance_model : "unknown"
    };
    attributes[$akoBU.GEN_AI_SYSTEM_ATTRIBUTE] = $c9ca0d6800f93a15$var$inferSystemFromInstance(embeddingsInstance);
    if ("dimensions" in embeddingsInstance) attributes[$akoBU.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = embeddingsInstance.dimensions;
    if ("encodingFormat" in embeddingsInstance) attributes[$akoBU.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = embeddingsInstance.encodingFormat;
    return attributes;
}
function $c9ca0d6800f93a15$var$instrumentEmbeddingMethod(originalMethod, options = {}) {
    const { recordInputs: recordInputs } = $8TMtR.resolveAIRecordingOptions(options);
    return new Proxy(originalMethod, {
        apply (target, thisArg, args) {
            const attributes = $c9ca0d6800f93a15$var$extractEmbeddingAttributes(thisArg);
            const modelName = attributes[$akoBU.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || "unknown";
            if (recordInputs) {
                const input = args[0];
                if (input != null) attributes[$akoBU.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE] = typeof input === "string" ? input : JSON.stringify(input);
            }
            return $gvNu3.startSpan({
                name: `embeddings ${modelName}`,
                op: $akoBU.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE,
                attributes: attributes
            }, ()=>{
                return Reflect.apply(target, thisArg, args).then(void 0, (error)=>{
                    $gHOmH.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.langchain"
                        }
                    });
                    throw error;
                });
            });
        }
    });
}
function $c9ca0d6800f93a15$var$instrumentLangChainEmbeddings(instance, options) {
    const embeddingsInstance = instance;
    if (typeof embeddingsInstance.embedQuery === "function") embeddingsInstance.embedQuery = $c9ca0d6800f93a15$var$instrumentEmbeddingMethod(embeddingsInstance.embedQuery, options);
    if (typeof embeddingsInstance.embedDocuments === "function") embeddingsInstance.embedDocuments = $c9ca0d6800f93a15$var$instrumentEmbeddingMethod(embeddingsInstance.embedDocuments, options);
    return instance;
}
module.exports.instrumentEmbeddingMethod = $c9ca0d6800f93a15$var$instrumentEmbeddingMethod;
module.exports.instrumentLangChainEmbeddings = $c9ca0d6800f93a15$var$instrumentLangChainEmbeddings;

});


parcelRegister("3MsYN", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });

var $iPRIv = parcelRequire("iPRIv");
function isNodeEnv() {
    return !(0, $iPRIv.isBrowserBundle)() && Object.prototype.toString.call(0) === "[object process]";
}
function dynamicRequire(mod, request) {
    return mod.require(request);
}
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch (e) {}
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, "process");
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {}
    return mod;
}

});
parcelRegister("iPRIv", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $db66a870e5b08f0d$export$2928c40372e623c0; });
function $db66a870e5b08f0d$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
function $db66a870e5b08f0d$export$8ad33f488b1ab046() {
    /*! __SENTRY_SDK_SOURCE__ */ return "npm";
}

});


parcelRegister("gh26H", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $bd8fde4dd988ccb0$export$4ef52930e33717cd; });
$parcel$export(module.exports, "SUBTREE_THEME_ATTRIBUTE", function () { return $bd8fde4dd988ccb0$export$cb374d25ded7f6ab; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $bd8fde4dd988ccb0$export$a00eac3f8684bcd0; });
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", function () { return $bd8fde4dd988ccb0$export$2112803007239c61; });
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", function () { return $bd8fde4dd988ccb0$export$352e418ed5b6193a; });
var $bd8fde4dd988ccb0$export$4ef52930e33717cd = 'data-theme';
var $bd8fde4dd988ccb0$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $bd8fde4dd988ccb0$export$a00eac3f8684bcd0 = 'data-color-mode';
var $bd8fde4dd988ccb0$export$2112803007239c61 = 'data-contrast-mode';
var $bd8fde4dd988ccb0$export$352e418ed5b6193a = 'data-custom-theme';
var $bd8fde4dd988ccb0$export$6f0c6fb8c80fcc92 = 'ds';
var $bd8fde4dd988ccb0$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $bd8fde4dd988ccb0$export$dddac1532e822863 = "--".concat($bd8fde4dd988ccb0$export$6f0c6fb8c80fcc92, "-token-not-found");
var $bd8fde4dd988ccb0$export$9d7b58831ae93caa = "--".concat($bd8fde4dd988ccb0$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("kvmJj", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", function () { return $eed85597a99edb6d$export$83993de8eb66733; });
$parcel$export(module.exports, "themeIds", function () { return $eed85597a99edb6d$export$7d43e72a58e3283f; });
$parcel$export(module.exports, "themeStateDefaults", function () { return $eed85597a99edb6d$export$9aedcfa7336a207; });
$parcel$export(module.exports, "default", function () { return $eed85597a99edb6d$export$2e2bcd8739ae039; });

var $137Lh = parcelRequire("137Lh");
var $eed85597a99edb6d$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ var $eed85597a99edb6d$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
var $eed85597a99edb6d$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $eed85597a99edb6d$var$themeOverrideIds = [];
var $eed85597a99edb6d$export$92ba366331403db2 = [].concat($eed85597a99edb6d$export$7d43e72a58e3283f, $eed85597a99edb6d$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $eed85597a99edb6d$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
/**
 * ThemeOptionsSchema: additional configuration options used to customize Atlassian's themes
 */ /**
 * ThemeState: the standard representation of an app's current theme and preferences
 */ /**
 * Can't evaluate typography feature flags at the module level,
 * it will always resolve to false when server side rendered or when flags are loaded async.
 */ function $eed85597a99edb6d$var$getShapeDefault() {
    if ((0, $137Lh.fg)('platform-dst-shape-theme-default')) return 'shape';
    return undefined;
}
function $eed85597a99edb6d$var$getMotionDefault() {
    if ((0, $137Lh.fg)('platform-dst-motion-theme-default')) return 'motion';
    return undefined;
}
var $eed85597a99edb6d$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: $eed85597a99edb6d$var$getShapeDefault,
    spacing: 'spacing',
    typography: 'typography',
    motion: $eed85597a99edb6d$var$getMotionDefault,
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $eed85597a99edb6d$export$2e2bcd8739ae039 = $eed85597a99edb6d$var$themeConfig;

});

parcelRegister("8vOqQ", function(module, exports) {

$parcel$export(module.exports, "isValidBrandHex", function () { return $632856bc6a4a3ba3$export$53031ac1ecb71f44; });
$parcel$export(module.exports, "rgbToHex", function () { return $632856bc6a4a3ba3$export$34d09c4a771c46ef; });
$parcel$export(module.exports, "hexToRgbA", function () { return $632856bc6a4a3ba3$export$b36dbdb4f463f05c; });
$parcel$export(module.exports, "hexToRgb", function () { return $632856bc6a4a3ba3$export$5a544e13ad4e1fa5; });
$parcel$export(module.exports, "hexToHSL", function () { return $632856bc6a4a3ba3$export$47ea145a83f50dc0; });
$parcel$export(module.exports, "HSLToRGB", function () { return $632856bc6a4a3ba3$export$1ff93e992dd58bec; });
$parcel$export(module.exports, "relativeLuminanceW3C", function () { return $632856bc6a4a3ba3$export$e770b01b744f3745; });
$parcel$export(module.exports, "getContrastRatio", function () { return $632856bc6a4a3ba3$export$d061e26956a60b0a; });
$parcel$export(module.exports, "deltaE", function () { return $632856bc6a4a3ba3$export$e8ddad763b4bebf9; });
// valid hex color with 6 digits
var $632856bc6a4a3ba3$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};
// valid hex color with 4, 6 or 8 digits
var $632856bc6a4a3ba3$var$isValidHex = function isValidHex(hex) {
    return /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
};
function $632856bc6a4a3ba3$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $632856bc6a4a3ba3$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        var int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $632856bc6a4a3ba3$export$b36dbdb4f463f05c(hex) {
    if (!$632856bc6a4a3ba3$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $632856bc6a4a3ba3$export$1212645cf40ebf71(hex)
    ];
}
function $632856bc6a4a3ba3$export$5a544e13ad4e1fa5(hex) {
    if (!$632856bc6a4a3ba3$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $632856bc6a4a3ba3$export$47ea145a83f50dc0(hex) {
    if (!$632856bc6a4a3ba3$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    var cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $632856bc6a4a3ba3$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    var k = function k(n) {
        return (n + h / 30) % 12;
    };
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    };
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $632856bc6a4a3ba3$export$e770b01b744f3745(r, g, b) {
    var RsRGB = r / 255;
    var GsRGB = g / 255;
    var BsRGB = b / 255;
    var R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    var G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    var B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    var L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $632856bc6a4a3ba3$export$d061e26956a60b0a(foreground, background) {
    if (!$632856bc6a4a3ba3$var$isValidHex(foreground) || !$632856bc6a4a3ba3$var$isValidHex(background)) throw new Error('Invalid HEX');
    var foregroundRgb = $632856bc6a4a3ba3$export$5a544e13ad4e1fa5(foreground);
    var backgroundRgb = $632856bc6a4a3ba3$export$5a544e13ad4e1fa5(background);
    var foregroundLuminance = $632856bc6a4a3ba3$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    var backgroundLuminance = $632856bc6a4a3ba3$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $632856bc6a4a3ba3$export$e8ddad763b4bebf9(rgbA, rgbB) {
    var labA = $632856bc6a4a3ba3$var$rgbToLab(rgbA);
    var labB = $632856bc6a4a3ba3$var$rgbToLab(rgbB);
    var deltaL = labA[0] - labB[0];
    var deltaA = labA[1] - labB[1];
    var deltaB = labA[2] - labB[2];
    var c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    var c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    var deltaC = c1 - c2;
    var deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    var sc = 1.0 + 0.045 * c1;
    var sh = 1.0 + 0.015 * c1;
    var deltaLKlsl = deltaL / 1.0;
    var deltaCkcsc = deltaC / sc;
    var deltaHkhsh = deltaH / sh;
    var i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $632856bc6a4a3ba3$var$rgbToLab(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("gZESL", function(module, exports) {

$parcel$export(module.exports, "hash", function () { return $c5f20e37d006d9ef$export$d6af199866bfb566; });
var $c5f20e37d006d9ef$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("TvNHr", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("i4PG5")).then(()=>parcelRequire('a2j9C'));

});

parcelRegister("hw7El", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("2gqHy")).then(()=>parcelRequire('6AMb2'));

});

parcelRegister("h3yc9", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("8iXnd")).then(()=>parcelRequire('34fcI'));

});

parcelRegister("7GhKa", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("irFYW")).then(()=>parcelRequire('19DXK'));

});

parcelRegister("6CfhU", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("9XlNa")).then(()=>parcelRequire('3iBI7'));

});

parcelRegister("1I0LA", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("4SGdC")).then(()=>parcelRequire('c0183'));

});

parcelRegister("9mdpk", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("3uMY8")).then(()=>parcelRequire('cSYPB'));

});

parcelRegister("j33XD", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("43UjT")).then(()=>parcelRequire('2eYSg'));

});

parcelRegister("2kVm9", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("5M52Y")).then(()=>parcelRequire('lFj70'));

});

parcelRegister("36Qfp", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("3fw2c")).then(()=>parcelRequire('itFxJ'));

});

parcelRegister("guYHo", function(module, exports) {

$parcel$export(module.exports, "findMissingCustomStyleElements", function () { return $c02e8835a995a4e3$export$bd1ac9300b0e885a; });
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", function () { return $c02e8835a995a4e3$export$e7ae172320e03461; });
$parcel$export(module.exports, "reduceTokenMap", function () { return $c02e8835a995a4e3$export$e673f367da2ff23e; });

var $iKdEz = parcelRequire("iKdEz");

var $j9spr = parcelRequire("j9spr");

var $gDQpH = parcelRequire("gDQpH");

var $gh26H = parcelRequire("gh26H");

var $gZESL = parcelRequire("gZESL");
function $c02e8835a995a4e3$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $gZESL.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $gh26H.CUSTOM_THEME_ATTRIBUTE), "=\"").concat(uniqueId, "\"][").concat((0, $gh26H.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $c02e8835a995a4e3$export$e7ae172320e03461(sizeThreshold) {
    var styleTags = (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(Array.from(document.head.querySelectorAll("style[".concat((0, $gh26H.CUSTOM_THEME_ATTRIBUTE), "][").concat((0, $gh26H.THEME_DATA_ATTRIBUTE), "]"))));
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach(function(element) {
        return element.remove();
    });
}
function $c02e8835a995a4e3$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce(function(acc, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        var cssVar = (0, $gDQpH.default)[key];
        return cssVar ? "".concat(acc, "\n  ").concat(cssVar, ": ").concat(typeof value === 'string' ? value : themeRamp[value], ";") : acc;
    }, '');
}

});
parcelRegister("gDQpH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1d8f2173dc4003a$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1de8a9439d40392e3e4945ecf9d9214>>
 * @codegenCommand yarn build tokens
 */ var $c1d8f2173dc4003a$var$tokens = {
    'motion.avatar.enter': '--ds-avatar-enter',
    'motion.avatar.exit': '--ds-avatar-exit',
    'motion.avatar.hovered': '--ds-avatar-hovered',
    'motion.blanket.enter': '--ds-blanket-enter',
    'motion.blanket.exit': '--ds-blanket-exit',
    'motion.duration.instant': '--ds-duration-instant',
    'motion.duration.long': '--ds-duration-long',
    'motion.duration.medium': '--ds-duration-medium',
    'motion.duration.short': '--ds-duration-short',
    'motion.duration.xlong': '--ds-duration-xlong',
    'motion.duration.xshort': '--ds-duration-xshort',
    'motion.duration.xxlong': '--ds-duration-xxlong',
    'motion.duration.xxshort': '--ds-duration-xxshort',
    'motion.easing.in.practical': '--ds-easing-in-practical',
    'motion.easing.inout.bold': '--ds-easing-inout-bold',
    'motion.easing.out.practical': '--ds-easing-out-practical',
    'motion.easing.out.bold': '--ds-easing-out-bold',
    'motion.easing.spring': '--ds-easing-spring',
    'motion.flag.enter': '--ds-flag-enter',
    'motion.flag.exit': '--ds-flag-exit',
    'motion.flag.reposition': '--ds-flag-reposition',
    'motion.keyframe.fade.in': '--ds-keyframe-fade-in',
    'motion.keyframe.fade.out': '--ds-keyframe-fade-out',
    'motion.keyframe.scale.in.medium': '--ds-keyframe-scale-in-medium',
    'motion.keyframe.scale.in.small': '--ds-keyframe-scale-in-small',
    'motion.keyframe.scale.out.medium': '--ds-keyframe-scale-out-medium',
    'motion.keyframe.scale.out.small': '--ds-keyframe-scale-out-small',
    'motion.keyframe.slide.in.bottom.short': '--ds-keyframe-slide-in-bottom-short',
    'motion.keyframe.slide.in.left.half': '--ds-keyframe-slide-in-left-half',
    'motion.keyframe.slide.in.left.short': '--ds-keyframe-slide-in-left-short',
    'motion.keyframe.slide.in.right.short': '--ds-keyframe-slide-in-right-short',
    'motion.keyframe.slide.in.top.short': '--ds-keyframe-slide-in-top-short',
    'motion.keyframe.slide.out.bottom.short': '--ds-keyframe-slide-out-bottom-short',
    'motion.keyframe.slide.out.left.half': '--ds-keyframe-slide-out-left-half',
    'motion.keyframe.slide.out.left.short': '--ds-keyframe-slide-out-left-short',
    'motion.keyframe.slide.out.right.short': '--ds-keyframe-slide-out-right-short',
    'motion.keyframe.slide.out.top.short': '--ds-keyframe-slide-out-top-short',
    'motion.modal.enter': '--ds-modal-enter',
    'motion.modal.exit': '--ds-modal-exit',
    'motion.popup.enter.bottom': '--ds-popup-enter-bottom',
    'motion.popup.enter.left': '--ds-popup-enter-left',
    'motion.popup.enter.right': '--ds-popup-enter-right',
    'motion.popup.enter.top': '--ds-popup-enter-top',
    'motion.popup.exit.bottom': '--ds-popup-exit-bottom',
    'motion.popup.exit.left': '--ds-popup-exit-left',
    'motion.popup.exit.right': '--ds-popup-exit-right',
    'motion.popup.exit.top': '--ds-popup-exit-top',
    'motion.spotlight.enter': '--ds-spotlight-enter',
    'motion.spotlight.exit': '--ds-spotlight-exit',
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.danger.bolder': '--ds-text-danger-bolder',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.warning.bolder': '--ds-text-warning-bolder',
    'color.text.success': '--ds-text-success',
    'color.text.success.bolder': '--ds-text-success-bolder',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.discovery.bolder': '--ds-text-discovery-bolder',
    'color.text.information': '--ds-text-information',
    'color.text.information.bolder': '--ds-text-information-bolder',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.subtler': '--ds-background-danger-subtler',
    'color.background.danger.subtler.hovered': '--ds-background-danger-subtler-hovered',
    'color.background.danger.subtler.pressed': '--ds-background-danger-subtler-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.subtler': '--ds-background-warning-subtler',
    'color.background.warning.subtler.hovered': '--ds-background-warning-subtler-hovered',
    'color.background.warning.subtler.pressed': '--ds-background-warning-subtler-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.subtler': '--ds-background-success-subtler',
    'color.background.success.subtler.hovered': '--ds-background-success-subtler-hovered',
    'color.background.success.subtler.pressed': '--ds-background-success-subtler-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.subtler': '--ds-background-discovery-subtler',
    'color.background.discovery.subtler.hovered': '--ds-background-discovery-subtler-hovered',
    'color.background.discovery.subtler.pressed': '--ds-background-discovery-subtler-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.subtler': '--ds-background-information-subtler',
    'color.background.information.subtler.hovered': '--ds-background-information-subtler-hovered',
    'color.background.information.subtler.pressed': '--ds-background-information-subtler-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.xxlarge': '--ds-radius-xxlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.width': '--ds-border-width',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $c1d8f2173dc4003a$export$2e2bcd8739ae039 = $c1d8f2173dc4003a$var$tokens;

});


parcelRegister("j3q2g", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("4yKqX")).then(()=>parcelRequire('CBB9s'));

});

var $bbc4af36a44d7b9b$exports = {};
$parcel$extendImportMap({
    "5OCfF": "atlassian-light.2363d172.js",
    "gPgQ5": "atlassian-light-future.df49dd18.js",
    "ao7E2": "atlassian-light-increased-contrast.da65f10a.js",
    "lrWJ9": "atlassian-dark.d9a3ea28.js",
    "ivJcg": "atlassian-dark-future.ccc16840.js",
    "5qSsk": "atlassian-dark-increased-contrast.77b19265.js",
    "2lU1F": "atlassian-spacing.ad590ffc.js",
    "5C0Wv": "atlassian-typography.021526e3.js",
    "hBAES": "atlassian-shape.3e31e97a.js",
    "dgi6L": "atlassian-motion.307a8d93.js",
    "eHTN5": "custom-theme.1847a2ab.js",
    "i4PG5": "atlassian-light.062094b9.js",
    "2gqHy": "atlassian-light-future.f8218cae.js",
    "8iXnd": "atlassian-light-increased-contrast.c4205554.js",
    "irFYW": "atlassian-dark.0a009095.js",
    "9XlNa": "atlassian-dark-future.0a2b8068.js",
    "4SGdC": "atlassian-dark-increased-contrast.e53e923b.js",
    "3uMY8": "atlassian-spacing.7398006b.js",
    "43UjT": "atlassian-typography.023c63f1.js",
    "5M52Y": "atlassian-shape.75e8bb9c.js",
    "3fw2c": "atlassian-motion.2a92fa4f.js",
    "4yKqX": "custom-theme.43e9ac63.js"
});

var $824c049f32d4395d$exports = {};
'use strict';

$824c049f32d4395d$exports = (parcelRequire("2nzLi"));


const $c69938f751e7a026$export$ffb0004e005737fa = $824c049f32d4395d$exports.Fragment;
const $c69938f751e7a026$export$34b9dba7ce09269b = $824c049f32d4395d$exports.jsx;
const $c69938f751e7a026$export$25062201e9e25d76 = $824c049f32d4395d$exports.jsxs;


parcelRequire("7fPBF");
var $f11ec298ebcca059$export$882461b6382ed46c;
var $f11ec298ebcca059$export$757ceba2d55c277e;
'use strict';
var $b4ba1c853f6e1116$exports = {};
'use strict';
function $b4ba1c853f6e1116$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b4ba1c853f6e1116$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b4ba1c853f6e1116$var$checkDCE();

$b4ba1c853f6e1116$exports = (parcelRequire("6EA3T"));


var $f11ec298ebcca059$var$i;
$f11ec298ebcca059$export$882461b6382ed46c = $b4ba1c853f6e1116$exports.createRoot;
$f11ec298ebcca059$export$757ceba2d55c277e = $b4ba1c853f6e1116$exports.hydrateRoot;



var $7fPBF = parcelRequire("7fPBF");
var $c1c6d595ff42d79c$exports = {};
'use strict';

$c1c6d595ff42d79c$exports = (parcelRequire("i5uoL"));


var $f30b917334351296$var$__defProp = Object.defineProperty;
var $f30b917334351296$var$__defProps = Object.defineProperties;
var $f30b917334351296$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $f30b917334351296$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $f30b917334351296$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $f30b917334351296$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $f30b917334351296$var$__defNormalProp = (obj, key, value)=>key in obj ? $f30b917334351296$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $f30b917334351296$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($f30b917334351296$var$__hasOwnProp.call(b, prop)) $f30b917334351296$var$__defNormalProp(a, prop, b[prop]);
    if ($f30b917334351296$var$__getOwnPropSymbols) {
        for (var prop of $f30b917334351296$var$__getOwnPropSymbols(b))if ($f30b917334351296$var$__propIsEnum.call(b, prop)) $f30b917334351296$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $f30b917334351296$var$__spreadProps = (a, b)=>$f30b917334351296$var$__defProps(a, $f30b917334351296$var$__getOwnPropDescs(b));
var $f30b917334351296$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($f30b917334351296$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $f30b917334351296$var$__getOwnPropSymbols) {
        for (var prop of $f30b917334351296$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $f30b917334351296$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var $f30b917334351296$var$IS_REACT_19 = /* @__PURE__ */ $7fPBF.version.startsWith("19");
var $f30b917334351296$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($f30b917334351296$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $f30b917334351296$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $f30b917334351296$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $f30b917334351296$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $f30b917334351296$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $f30b917334351296$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $f30b917334351296$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $f30b917334351296$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $f30b917334351296$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $f30b917334351296$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $f30b917334351296$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $f30b917334351296$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $f30b917334351296$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $f30b917334351296$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $f30b917334351296$var$ForwardRef = $f30b917334351296$var$REACT_FORWARD_REF_TYPE;
var $f30b917334351296$var$Memo = $f30b917334351296$var$REACT_MEMO_TYPE;
function $f30b917334351296$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $f30b917334351296$var$REACT_FRAGMENT_TYPE || type === $f30b917334351296$var$REACT_PROFILER_TYPE || type === $f30b917334351296$var$REACT_STRICT_MODE_TYPE || type === $f30b917334351296$var$REACT_SUSPENSE_TYPE || type === $f30b917334351296$var$REACT_SUSPENSE_LIST_TYPE || type === $f30b917334351296$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $f30b917334351296$var$REACT_LAZY_TYPE || type.$$typeof === $f30b917334351296$var$REACT_MEMO_TYPE || type.$$typeof === $f30b917334351296$var$REACT_CONTEXT_TYPE || type.$$typeof === $f30b917334351296$var$REACT_CONSUMER_TYPE || type.$$typeof === $f30b917334351296$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $f30b917334351296$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $f30b917334351296$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $f30b917334351296$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $f30b917334351296$var$REACT_FRAGMENT_TYPE:
                    case $f30b917334351296$var$REACT_PROFILER_TYPE:
                    case $f30b917334351296$var$REACT_STRICT_MODE_TYPE:
                    case $f30b917334351296$var$REACT_SUSPENSE_TYPE:
                    case $f30b917334351296$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $f30b917334351296$var$REACT_CONTEXT_TYPE:
                            case $f30b917334351296$var$REACT_FORWARD_REF_TYPE:
                            case $f30b917334351296$var$REACT_LAZY_TYPE:
                            case $f30b917334351296$var$REACT_MEMO_TYPE:
                                return object;
                            case $f30b917334351296$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $f30b917334351296$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $f30b917334351296$var$isContextConsumer(object) {
    return $f30b917334351296$var$IS_REACT_19 ? $f30b917334351296$var$typeOf(object) === $f30b917334351296$var$REACT_CONSUMER_TYPE : $f30b917334351296$var$typeOf(object) === $f30b917334351296$var$REACT_CONTEXT_TYPE;
}
function $f30b917334351296$var$isMemo(object) {
    return $f30b917334351296$var$typeOf(object) === $f30b917334351296$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $f30b917334351296$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $f30b917334351296$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $f30b917334351296$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $f30b917334351296$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $f30b917334351296$var$verify(mapStateToProps, "mapStateToProps");
    $f30b917334351296$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $f30b917334351296$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $f30b917334351296$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $f30b917334351296$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $f30b917334351296$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $f30b917334351296$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $f30b917334351296$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $f30b917334351296$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $f30b917334351296$var$verifyPlainObject(value, displayName, methodName) {
    if (!$f30b917334351296$var$isPlainObject(value)) $f30b917334351296$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $f30b917334351296$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $f30b917334351296$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $f30b917334351296$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $f30b917334351296$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $f30b917334351296$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $f30b917334351296$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $f30b917334351296$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $f30b917334351296$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $f30b917334351296$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $f30b917334351296$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $f30b917334351296$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $f30b917334351296$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $f30b917334351296$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $f30b917334351296$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $f30b917334351296$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $f30b917334351296$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $f30b917334351296$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $f30b917334351296$var$__spreadValues($f30b917334351296$var$__spreadValues($f30b917334351296$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $f30b917334351296$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $f30b917334351296$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$f30b917334351296$var$defaultMergeProps : typeof mergeProps === "function" ? $f30b917334351296$var$wrapMergePropsFunc(mergeProps) : $f30b917334351296$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $f30b917334351296$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $f30b917334351296$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $f30b917334351296$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $f30b917334351296$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $f30b917334351296$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $f30b917334351296$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $f30b917334351296$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $f30b917334351296$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $f30b917334351296$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $f30b917334351296$var$isDOM = /* @__PURE__ */ $f30b917334351296$var$canUseDOM();
var $f30b917334351296$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $f30b917334351296$var$isReactNative = /* @__PURE__ */ $f30b917334351296$var$isRunningInReactNative();
var $f30b917334351296$var$getUseIsomorphicLayoutEffect = ()=>$f30b917334351296$var$isDOM || $f30b917334351296$var$isReactNative ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
var $f30b917334351296$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $f30b917334351296$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $f30b917334351296$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $f30b917334351296$export$d36bdfa510afb180(objA, objB) {
    if ($f30b917334351296$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$f30b917334351296$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $f30b917334351296$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $f30b917334351296$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $f30b917334351296$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $f30b917334351296$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $f30b917334351296$var$TYPE_STATICS = {
    [$f30b917334351296$var$ForwardRef]: $f30b917334351296$var$FORWARD_REF_STATICS,
    [$f30b917334351296$var$Memo]: $f30b917334351296$var$MEMO_STATICS
};
function $f30b917334351296$var$getStatics(component) {
    if ($f30b917334351296$var$isMemo(component)) return $f30b917334351296$var$MEMO_STATICS;
    return $f30b917334351296$var$TYPE_STATICS[component["$$typeof"]] || $f30b917334351296$var$REACT_STATICS;
}
var $f30b917334351296$var$defineProperty = Object.defineProperty;
var $f30b917334351296$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $f30b917334351296$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $f30b917334351296$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $f30b917334351296$var$getPrototypeOf = Object.getPrototypeOf;
var $f30b917334351296$var$objectPrototype = Object.prototype;
function $f30b917334351296$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($f30b917334351296$var$objectPrototype) {
            const inheritedComponent = $f30b917334351296$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $f30b917334351296$var$objectPrototype) $f30b917334351296$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $f30b917334351296$var$getOwnPropertyNames(sourceComponent);
        if ($f30b917334351296$var$getOwnPropertySymbols) keys = keys.concat($f30b917334351296$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $f30b917334351296$var$getStatics(targetComponent);
        const sourceStatics = $f30b917334351296$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$f30b917334351296$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $f30b917334351296$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $f30b917334351296$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $f30b917334351296$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $f30b917334351296$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $f30b917334351296$var$getContext() {
    var _a;
    if (!$7fPBF.createContext) return {};
    const contextMap = (_a = $f30b917334351296$var$gT[$f30b917334351296$var$ContextKey]) != null ? _a : $f30b917334351296$var$gT[$f30b917334351296$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($7fPBF.createContext);
    if (!realContext) {
        realContext = $7fPBF.createContext(null);
        contextMap.set($7fPBF.createContext, realContext);
    }
    return realContext;
}
var $f30b917334351296$export$cc80c08dc91f1c00 = /* @__PURE__ */ $f30b917334351296$var$getContext();
// src/components/connect.tsx
var $f30b917334351296$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $f30b917334351296$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $f30b917334351296$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $f30b917334351296$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $f30b917334351296$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $f30b917334351296$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $f30b917334351296$var$strictEqual(a, b) {
    return a === b;
}
var $f30b917334351296$var$hasWarnedAboutDeprecatedPureOption = false;
function $f30b917334351296$var$_connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $f30b917334351296$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $f30b917334351296$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $f30b917334351296$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $f30b917334351296$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $f30b917334351296$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $f30b917334351296$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $f30b917334351296$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $f30b917334351296$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $7fPBF.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $f30b917334351296$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $7fPBF.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $7fPBF.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $7fPBF.useMemo(()=>{
                return $f30b917334351296$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $7fPBF.useMemo(()=>{
                if (!shouldHandleStateChanges) return $f30b917334351296$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $f30b917334351296$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $7fPBF.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $f30b917334351296$var$__spreadProps($f30b917334351296$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $7fPBF.useRef(void 0);
            const lastWrapperProps = $7fPBF.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $7fPBF.useRef(void 0);
            const renderIsScheduled = $7fPBF.useRef(false);
            const isMounted = $7fPBF.useRef(false);
            const latestSubscriptionCallbackError = $7fPBF.useRef(void 0);
            $f30b917334351296$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $7fPBF.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $7fPBF.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $f30b917334351296$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $f30b917334351296$var$useIsomorphicLayoutEffectWithArgs($f30b917334351296$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $7fPBF.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $f30b917334351296$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $7fPBF.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $7fPBF.createElement(WrappedComponent, $f30b917334351296$var$__spreadProps($f30b917334351296$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $7fPBF.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $7fPBF.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $7fPBF.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $7fPBF.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $7fPBF.createElement(Connect, $f30b917334351296$var$__spreadProps($f30b917334351296$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $f30b917334351296$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $f30b917334351296$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $f30b917334351296$export$64605811ab45167f = $f30b917334351296$var$_connect;
var $f30b917334351296$export$8807b5ba46f9d0b7 = $f30b917334351296$var$_connect;
// src/components/Provider.tsx
function $f30b917334351296$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $7fPBF.useMemo(()=>{
        const subscription = $f30b917334351296$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $7fPBF.useMemo(()=>store.getState(), [
        store
    ]);
    $f30b917334351296$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $f30b917334351296$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $7fPBF.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $f30b917334351296$export$2881499e37b75b9a = $f30b917334351296$var$Provider;
// src/hooks/useReduxContext.ts
function $f30b917334351296$var$createReduxContextHook(context = $f30b917334351296$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $7fPBF.useContext(context);
        return contextValue;
    };
}
var $f30b917334351296$var$useReduxContext = /* @__PURE__ */ $f30b917334351296$var$createReduxContextHook();
// src/hooks/useStore.ts
function $f30b917334351296$export$671dba69185d0304(context = $f30b917334351296$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $f30b917334351296$export$cc80c08dc91f1c00 ? $f30b917334351296$var$useReduxContext : // @ts-ignore
    $f30b917334351296$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $f30b917334351296$export$6ccbb43953eebf8 = /* @__PURE__ */ $f30b917334351296$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $f30b917334351296$export$bc9b55530897c558(context = $f30b917334351296$export$cc80c08dc91f1c00) {
    const useStore2 = context === $f30b917334351296$export$cc80c08dc91f1c00 ? $f30b917334351296$export$6ccbb43953eebf8 : $f30b917334351296$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $f30b917334351296$export$8ad76b76a4c905f8 = /* @__PURE__ */ $f30b917334351296$export$bc9b55530897c558();
var $f30b917334351296$var$refEquality = (a, b)=>a === b;
function $f30b917334351296$export$2b53f90d2bd1cbfb(context = $f30b917334351296$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $f30b917334351296$export$cc80c08dc91f1c00 ? $f30b917334351296$var$useReduxContext : $f30b917334351296$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $f30b917334351296$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $7fPBF.useRef(true);
        const wrappedSelector = $7fPBF.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $c1c6d595ff42d79c$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $7fPBF.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $f30b917334351296$export$2105062e25df4afe = /* @__PURE__ */ $f30b917334351296$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $f30b917334351296$export$712ea50be43a7858 = $f30b917334351296$var$defaultNoopBatch;


/**
 * React Router DOM v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");

/**
 * @remix-run/router v1.23.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $55100129ab36ed65$var$_extends() {
    $55100129ab36ed65$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $55100129ab36ed65$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $55100129ab36ed65$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($55100129ab36ed65$export$e19cd5f9376f8cee || ($55100129ab36ed65$export$e19cd5f9376f8cee = {}));
const $55100129ab36ed65$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $55100129ab36ed65$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $55100129ab36ed65$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $55100129ab36ed65$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $55100129ab36ed65$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $55100129ab36ed65$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
    }
    return $55100129ab36ed65$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $55100129ab36ed65$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $55100129ab36ed65$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $55100129ab36ed65$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $55100129ab36ed65$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $55100129ab36ed65$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $55100129ab36ed65$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $55100129ab36ed65$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $55100129ab36ed65$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $55100129ab36ed65$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $55100129ab36ed65$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $55100129ab36ed65$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $55100129ab36ed65$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $55100129ab36ed65$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $55100129ab36ed65$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $55100129ab36ed65$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($55100129ab36ed65$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        let location = $55100129ab36ed65$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $55100129ab36ed65$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        let location = $55100129ab36ed65$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $55100129ab36ed65$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $55100129ab36ed65$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($55100129ab36ed65$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($55100129ab36ed65$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $55100129ab36ed65$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($55100129ab36ed65$var$ResultType || ($55100129ab36ed65$var$ResultType = {}));
const $55100129ab36ed65$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $55100129ab36ed65$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $55100129ab36ed65$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $55100129ab36ed65$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $55100129ab36ed65$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($55100129ab36ed65$var$isIndexRoute(route)) {
            let indexRoute = $55100129ab36ed65$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $55100129ab36ed65$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $55100129ab36ed65$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $55100129ab36ed65$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $55100129ab36ed65$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $55100129ab36ed65$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $55100129ab36ed65$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $55100129ab36ed65$var$flattenRoutes(routes);
    $55100129ab36ed65$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $55100129ab36ed65$export$30d21fd6d7295f52(pathname);
        matches = $55100129ab36ed65$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $55100129ab36ed65$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $55100129ab36ed65$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $55100129ab36ed65$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $55100129ab36ed65$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $55100129ab36ed65$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $55100129ab36ed65$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $55100129ab36ed65$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $55100129ab36ed65$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $55100129ab36ed65$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $55100129ab36ed65$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $55100129ab36ed65$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $55100129ab36ed65$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $55100129ab36ed65$var$paramRe = /^:[\w-]+$/;
const $55100129ab36ed65$var$dynamicSegmentValue = 3;
const $55100129ab36ed65$var$indexRouteValue = 2;
const $55100129ab36ed65$var$emptySegmentValue = 1;
const $55100129ab36ed65$var$staticSegmentValue = 10;
const $55100129ab36ed65$var$splatPenalty = -2;
const $55100129ab36ed65$var$isSplat = (s)=>s === "*";
function $55100129ab36ed65$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($55100129ab36ed65$var$isSplat)) initialScore += $55100129ab36ed65$var$splatPenalty;
    if (index) initialScore += $55100129ab36ed65$var$indexRouteValue;
    return segments.filter((s)=>!$55100129ab36ed65$var$isSplat(s)).reduce((score, segment)=>score + ($55100129ab36ed65$var$paramRe.test(segment) ? $55100129ab36ed65$var$dynamicSegmentValue : segment === "" ? $55100129ab36ed65$var$emptySegmentValue : $55100129ab36ed65$var$staticSegmentValue), initialScore);
}
function $55100129ab36ed65$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $55100129ab36ed65$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $55100129ab36ed65$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $55100129ab36ed65$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $55100129ab36ed65$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $55100129ab36ed65$export$a5c6d149b50c1d86($55100129ab36ed65$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $55100129ab36ed65$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $55100129ab36ed65$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $55100129ab36ed65$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $55100129ab36ed65$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $55100129ab36ed65$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $55100129ab36ed65$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $55100129ab36ed65$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $55100129ab36ed65$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $55100129ab36ed65$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $55100129ab36ed65$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $55100129ab36ed65$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $55100129ab36ed65$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $55100129ab36ed65$var$isAbsoluteUrl = (url)=>$55100129ab36ed65$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $55100129ab36ed65$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($55100129ab36ed65$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $55100129ab36ed65$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $55100129ab36ed65$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $55100129ab36ed65$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $55100129ab36ed65$var$normalizeSearch(search),
        hash: $55100129ab36ed65$var$normalizeHash(hash)
    };
}
function $55100129ab36ed65$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $55100129ab36ed65$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $55100129ab36ed65$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $55100129ab36ed65$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $55100129ab36ed65$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $55100129ab36ed65$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $55100129ab36ed65$export$8ccf933b0513f8d0(toArg);
    else {
        to = $55100129ab36ed65$var$_extends({}, toArg);
        $55100129ab36ed65$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $55100129ab36ed65$var$getInvalidPathError("?", "pathname", "search", to));
        $55100129ab36ed65$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $55100129ab36ed65$var$getInvalidPathError("#", "pathname", "hash", to));
        $55100129ab36ed65$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $55100129ab36ed65$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $55100129ab36ed65$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $55100129ab36ed65$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $55100129ab36ed65$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $55100129ab36ed65$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $55100129ab36ed65$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $55100129ab36ed65$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $55100129ab36ed65$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $55100129ab36ed65$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $55100129ab36ed65$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $55100129ab36ed65$export$4051a07651545597(data, init) {
    return new $55100129ab36ed65$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $55100129ab36ed65$export$42a99a7a4bc0e76a extends Error {
}
class $55100129ab36ed65$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $55100129ab36ed65$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $55100129ab36ed65$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $55100129ab36ed65$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $55100129ab36ed65$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $55100129ab36ed65$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $55100129ab36ed65$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $55100129ab36ed65$var$unwrapTrackedPromise(value) {
    if (!$55100129ab36ed65$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $55100129ab36ed65$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $55100129ab36ed65$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $55100129ab36ed65$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $55100129ab36ed65$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $55100129ab36ed65$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $55100129ab36ed65$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $55100129ab36ed65$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $55100129ab36ed65$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $55100129ab36ed65$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $55100129ab36ed65$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $55100129ab36ed65$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $55100129ab36ed65$var$validMutationMethods = new Set($55100129ab36ed65$var$validMutationMethodsArr);
const $55100129ab36ed65$var$validRequestMethodsArr = [
    "get",
    ...$55100129ab36ed65$var$validMutationMethodsArr
];
const $55100129ab36ed65$var$validRequestMethods = new Set($55100129ab36ed65$var$validRequestMethodsArr);
const $55100129ab36ed65$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $55100129ab36ed65$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $55100129ab36ed65$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $55100129ab36ed65$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $55100129ab36ed65$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $55100129ab36ed65$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $55100129ab36ed65$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $55100129ab36ed65$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $55100129ab36ed65$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $55100129ab36ed65$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $55100129ab36ed65$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $55100129ab36ed65$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $55100129ab36ed65$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$55100129ab36ed65$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$55100129ab36ed65$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $55100129ab36ed65$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $55100129ab36ed65$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $55100129ab36ed65$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $55100129ab36ed65$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$55100129ab36ed65$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($55100129ab36ed65$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $55100129ab36ed65$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $55100129ab36ed65$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $55100129ab36ed65$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $55100129ab36ed65$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $55100129ab36ed65$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($55100129ab36ed65$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $55100129ab36ed65$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $55100129ab36ed65$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $55100129ab36ed65$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $55100129ab36ed65$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $55100129ab36ed65$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $55100129ab36ed65$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $55100129ab36ed65$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $55100129ab36ed65$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $55100129ab36ed65$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $55100129ab36ed65$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $55100129ab36ed65$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $55100129ab36ed65$var$findNearestBoundary(matches).route.id,
            {
                type: $55100129ab36ed65$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $55100129ab36ed65$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($55100129ab36ed65$var$isErrorResult(result) && $55100129ab36ed65$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $55100129ab36ed65$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $55100129ab36ed65$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $55100129ab36ed65$var$_extends({
            matches: updatedMatches || matches
        }, $55100129ab36ed65$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $55100129ab36ed65$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $55100129ab36ed65$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $55100129ab36ed65$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $55100129ab36ed65$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $55100129ab36ed65$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $55100129ab36ed65$var$ResultType.error,
            error: $55100129ab36ed65$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($55100129ab36ed65$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $55100129ab36ed65$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($55100129ab36ed65$var$isDeferredResult(result)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $55100129ab36ed65$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $55100129ab36ed65$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($55100129ab36ed65$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $55100129ab36ed65$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $55100129ab36ed65$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $55100129ab36ed65$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $55100129ab36ed65$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $55100129ab36ed65$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $55100129ab36ed65$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $55100129ab36ed65$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $55100129ab36ed65$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$55100129ab36ed65$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $55100129ab36ed65$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $55100129ab36ed65$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $55100129ab36ed65$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $55100129ab36ed65$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $55100129ab36ed65$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $55100129ab36ed65$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $55100129ab36ed65$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $55100129ab36ed65$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($55100129ab36ed65$var$isRedirectResult(actionResult) || $55100129ab36ed65$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($55100129ab36ed65$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $55100129ab36ed65$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($55100129ab36ed65$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($55100129ab36ed65$var$isDeferredResult(actionResult)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $55100129ab36ed65$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $55100129ab36ed65$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $55100129ab36ed65$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $55100129ab36ed65$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $55100129ab36ed65$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $55100129ab36ed65$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $55100129ab36ed65$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $55100129ab36ed65$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $55100129ab36ed65$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $55100129ab36ed65$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $55100129ab36ed65$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $55100129ab36ed65$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($55100129ab36ed65$var$isDeferredResult(result)) result = await $55100129ab36ed65$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($55100129ab36ed65$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $55100129ab36ed65$export$3e9cee6b33872309(!$55100129ab36ed65$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $55100129ab36ed65$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $55100129ab36ed65$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $55100129ab36ed65$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $55100129ab36ed65$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $55100129ab36ed65$export$e19cd5f9376f8cee.Replace : $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $55100129ab36ed65$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($55100129ab36ed65$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $55100129ab36ed65$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $55100129ab36ed65$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $55100129ab36ed65$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $55100129ab36ed65$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $55100129ab36ed65$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($55100129ab36ed65$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $55100129ab36ed65$var$ResultType.redirect,
                response: $55100129ab36ed65$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $55100129ab36ed65$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $55100129ab36ed65$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $55100129ab36ed65$var$ResultType.error,
                    error: $55100129ab36ed65$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $55100129ab36ed65$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $55100129ab36ed65$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $55100129ab36ed65$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $55100129ab36ed65$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $55100129ab36ed65$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $55100129ab36ed65$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $55100129ab36ed65$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $55100129ab36ed65$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $55100129ab36ed65$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $55100129ab36ed65$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$55100129ab36ed65$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $55100129ab36ed65$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $55100129ab36ed65$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $55100129ab36ed65$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $55100129ab36ed65$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $55100129ab36ed65$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $55100129ab36ed65$export$4d0306f8f6a4585b = Symbol("deferred");
function $55100129ab36ed65$export$3336b097a6fbc59a(routes, opts) {
    $55100129ab36ed65$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $55100129ab36ed65$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $55100129ab36ed65$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $55100129ab36ed65$var$createLocation("", $55100129ab36ed65$export$fe53371bee54353d(url), null, "default");
        let matches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$55100129ab36ed65$var$isValidMethod(method) && method !== "HEAD") {
            let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($55100129ab36ed65$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $55100129ab36ed65$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $55100129ab36ed65$var$createLocation("", $55100129ab36ed65$export$fe53371bee54353d(url), null, "default");
        let matches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$55100129ab36ed65$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $55100129ab36ed65$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $55100129ab36ed65$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $55100129ab36ed65$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($55100129ab36ed65$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$55100129ab36ed65$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $55100129ab36ed65$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($55100129ab36ed65$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $55100129ab36ed65$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $55100129ab36ed65$var$isResponse(result) ? result : $55100129ab36ed65$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($55100129ab36ed65$var$isDataStrategyResult(e) && $55100129ab36ed65$var$isResponse(e.result)) {
                if (e.type === $55100129ab36ed65$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($55100129ab36ed65$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $55100129ab36ed65$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $55100129ab36ed65$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($55100129ab36ed65$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($55100129ab36ed65$var$isDeferredResult(result)) {
            let error = $55100129ab36ed65$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $55100129ab36ed65$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($55100129ab36ed65$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $55100129ab36ed65$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $55100129ab36ed65$var$_extends({}, context, {
                statusCode: $55100129ab36ed65$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $55100129ab36ed65$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $55100129ab36ed65$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $55100129ab36ed65$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $55100129ab36ed65$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $55100129ab36ed65$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $55100129ab36ed65$var$callDataStrategyImpl(dataStrategy || $55100129ab36ed65$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($55100129ab36ed65$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $55100129ab36ed65$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($55100129ab36ed65$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $55100129ab36ed65$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $55100129ab36ed65$export$fec11da027c70692(routes, context, error) {
    let newContext = $55100129ab36ed65$var$_extends({}, context, {
        statusCode: $55100129ab36ed65$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $55100129ab36ed65$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $55100129ab36ed65$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $55100129ab36ed65$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $55100129ab36ed65$export$cae722b0cc860f13(to ? to : ".", $55100129ab36ed65$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $55100129ab36ed65$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $55100129ab36ed65$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $55100129ab36ed65$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $55100129ab36ed65$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $55100129ab36ed65$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$55100129ab36ed65$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$55100129ab36ed65$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $55100129ab36ed65$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $55100129ab36ed65$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $55100129ab36ed65$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$55100129ab36ed65$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$55100129ab36ed65$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $55100129ab36ed65$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $55100129ab36ed65$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $55100129ab36ed65$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($55100129ab36ed65$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $55100129ab36ed65$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $55100129ab36ed65$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $55100129ab36ed65$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $55100129ab36ed65$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $55100129ab36ed65$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($55100129ab36ed65$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $55100129ab36ed65$var$shouldRevalidateLoader(match, $55100129ab36ed65$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $55100129ab36ed65$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $55100129ab36ed65$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $55100129ab36ed65$var$shouldRevalidateLoader(fetcherMatch, $55100129ab36ed65$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $55100129ab36ed65$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $55100129ab36ed65$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $55100129ab36ed65$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $55100129ab36ed65$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $55100129ab36ed65$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $55100129ab36ed65$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$55100129ab36ed65$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $55100129ab36ed65$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$55100129ab36ed65$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $55100129ab36ed65$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $55100129ab36ed65$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $55100129ab36ed65$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$55100129ab36ed65$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $55100129ab36ed65$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $55100129ab36ed65$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $55100129ab36ed65$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $55100129ab36ed65$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $55100129ab36ed65$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $55100129ab36ed65$var$ResultType.data,
                result: undefined
            });
        };
        return $55100129ab36ed65$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $55100129ab36ed65$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $55100129ab36ed65$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $55100129ab36ed65$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $55100129ab36ed65$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $55100129ab36ed65$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $55100129ab36ed65$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($55100129ab36ed65$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $55100129ab36ed65$var$ResultType.error,
                error: e
            };
        }
        if (type === $55100129ab36ed65$var$ResultType.error) return {
            type: $55100129ab36ed65$var$ResultType.error,
            error: new $55100129ab36ed65$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $55100129ab36ed65$var$ResultType.error) {
        if ($55100129ab36ed65$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $55100129ab36ed65$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $55100129ab36ed65$var$ResultType.error,
                error: new $55100129ab36ed65$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $55100129ab36ed65$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $55100129ab36ed65$var$ResultType.error,
            error: result,
            statusCode: $55100129ab36ed65$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($55100129ab36ed65$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $55100129ab36ed65$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($55100129ab36ed65$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $55100129ab36ed65$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $55100129ab36ed65$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $55100129ab36ed65$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $55100129ab36ed65$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $55100129ab36ed65$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $55100129ab36ed65$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $55100129ab36ed65$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($55100129ab36ed65$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $55100129ab36ed65$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $55100129ab36ed65$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $55100129ab36ed65$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $55100129ab36ed65$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $55100129ab36ed65$export$3e9cee6b33872309(!$55100129ab36ed65$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $55100129ab36ed65$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($55100129ab36ed65$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $55100129ab36ed65$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $55100129ab36ed65$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($55100129ab36ed65$var$isErrorResult(result)) {
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $55100129ab36ed65$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($55100129ab36ed65$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $55100129ab36ed65$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($55100129ab36ed65$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $55100129ab36ed65$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $55100129ab36ed65$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $55100129ab36ed65$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $55100129ab36ed65$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $55100129ab36ed65$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $55100129ab36ed65$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $55100129ab36ed65$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $55100129ab36ed65$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $55100129ab36ed65$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($55100129ab36ed65$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $55100129ab36ed65$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(path) : path;
    return $55100129ab36ed65$export$fe53371bee54353d($55100129ab36ed65$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $55100129ab36ed65$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $55100129ab36ed65$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $55100129ab36ed65$var$ResultType.data || result.type === $55100129ab36ed65$var$ResultType.error);
}
function $55100129ab36ed65$var$isRedirectDataStrategyResultResult(result) {
    return $55100129ab36ed65$var$isResponse(result.result) && $55100129ab36ed65$var$redirectStatusCodes.has(result.result.status);
}
function $55100129ab36ed65$var$isDeferredResult(result) {
    return result.type === $55100129ab36ed65$var$ResultType.deferred;
}
function $55100129ab36ed65$var$isErrorResult(result) {
    return result.type === $55100129ab36ed65$var$ResultType.error;
}
function $55100129ab36ed65$var$isRedirectResult(result) {
    return (result && result.type) === $55100129ab36ed65$var$ResultType.redirect;
}
function $55100129ab36ed65$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $55100129ab36ed65$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $55100129ab36ed65$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $55100129ab36ed65$var$isRedirectResponse(result) {
    if (!$55100129ab36ed65$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $55100129ab36ed65$var$isValidMethod(method) {
    return $55100129ab36ed65$var$validRequestMethods.has(method.toLowerCase());
}
function $55100129ab36ed65$var$isMutationMethod(method) {
    return $55100129ab36ed65$var$validMutationMethods.has(method.toLowerCase());
}
async function $55100129ab36ed65$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$55100129ab36ed65$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($55100129ab36ed65$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $55100129ab36ed65$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $55100129ab36ed65$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($55100129ab36ed65$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $55100129ab36ed65$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $55100129ab36ed65$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $55100129ab36ed65$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $55100129ab36ed65$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $55100129ab36ed65$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $55100129ab36ed65$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $55100129ab36ed65$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $55100129ab36ed65$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $55100129ab36ed65$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $55100129ab36ed65$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $55100129ab36ed65$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $55100129ab36ed65$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $55100129ab36ed65$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $55100129ab36ed65$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $55100129ab36ed65$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $55100129ab36ed65$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($55100129ab36ed65$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $55100129ab36ed65$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($55100129ab36ed65$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $55100129ab36ed65$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");

function $d9fd026bfea79ab9$var$_extends() {
    $d9fd026bfea79ab9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d9fd026bfea79ab9$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $d9fd026bfea79ab9$export$3add0d5dce533e2e = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$145dfa71566a64dc = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$var$AwaitContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $d9fd026bfea79ab9$export$26749e8557646306 = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$c7914228fb69b0f5 = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$9072aa6dd1f93057 = /*#__PURE__*/ $7fPBF.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $d9fd026bfea79ab9$var$RouteErrorContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $d9fd026bfea79ab9$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $d9fd026bfea79ab9$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $d9fd026bfea79ab9$export$9c954a9d03d32f4a() {
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $d9fd026bfea79ab9$export$45d76561a5302f2b() {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $d9fd026bfea79ab9$export$1b3f31771c5d07c() {
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $d9fd026bfea79ab9$export$6c330e8992e8a295(pattern) {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    return $7fPBF.useMemo(()=>(0, $55100129ab36ed65$export$81336c211d5ff295)(pattern, (0, $55100129ab36ed65$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $d9fd026bfea79ab9$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $7fPBF.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $d9fd026bfea79ab9$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $d9fd026bfea79ab9$var$useNavigateStable() : $d9fd026bfea79ab9$var$useNavigateUnstable();
}
function $d9fd026bfea79ab9$var$useNavigateUnstable() {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let dataRouterContext = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $55100129ab36ed65$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $7fPBF.useRef(false);
    $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $55100129ab36ed65$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $d9fd026bfea79ab9$var$OutletContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $d9fd026bfea79ab9$export$4138103a3ae699cc() {
    return $7fPBF.useContext($d9fd026bfea79ab9$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $d9fd026bfea79ab9$export$a3be3530d8e40d0b(context) {
    let outlet = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $d9fd026bfea79ab9$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $d9fd026bfea79ab9$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $55100129ab36ed65$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $7fPBF.useMemo(()=>(0, $55100129ab36ed65$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $d9fd026bfea79ab9$export$5d3fca4a98652595(routes, locationArg) {
    return $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: parentMatches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $55100129ab36ed65$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $55100129ab36ed65$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $d9fd026bfea79ab9$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $55100129ab36ed65$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $d9fd026bfea79ab9$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $55100129ab36ed65$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $d9fd026bfea79ab9$var$DefaultErrorComponent() {
    let error = $d9fd026bfea79ab9$export$ed527bf60f6e05f2();
    let message = (0, $55100129ab36ed65$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $7fPBF.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $7fPBF.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $d9fd026bfea79ab9$var$defaultErrorElement = /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$DefaultErrorComponent, null);
class $d9fd026bfea79ab9$var$RenderErrorBoundary extends $7fPBF.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function $d9fd026bfea79ab9$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $d9fd026bfea79ab9$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $d9fd026bfea79ab9$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $d9fd026bfea79ab9$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $7fPBF.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $d9fd026bfea79ab9$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($d9fd026bfea79ab9$var$DataRouterHook || {});
var $d9fd026bfea79ab9$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($d9fd026bfea79ab9$var$DataRouterStateHook || {});
function $d9fd026bfea79ab9$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $d9fd026bfea79ab9$var$useDataRouterContext(hookName) {
    let ctx = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    !ctx && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return ctx;
}
function $d9fd026bfea79ab9$var$useDataRouterState(hookName) {
    let state = $7fPBF.useContext($d9fd026bfea79ab9$export$145dfa71566a64dc);
    !state && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return state;
}
function $d9fd026bfea79ab9$var$useRouteContext(hookName) {
    let route = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    !route && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $d9fd026bfea79ab9$var$useCurrentRouteId(hookName) {
    let route = $d9fd026bfea79ab9$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $d9fd026bfea79ab9$export$5fc8298006ad9e58() {
    return $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $d9fd026bfea79ab9$export$d0fd4b7106de2769() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $d9fd026bfea79ab9$export$600dc272ed516c15() {
    let dataRouterContext = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseRevalidator);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRevalidator);
    return $7fPBF.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $d9fd026bfea79ab9$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseMatches);
    return $7fPBF.useMemo(()=>matches.map((m)=>(0, $55100129ab36ed65$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $d9fd026bfea79ab9$export$1448a5050d252c4d() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $d9fd026bfea79ab9$export$fd5d37484eab868d(routeId) {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $d9fd026bfea79ab9$export$fdc00f3f26066d5e() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseActionData);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $d9fd026bfea79ab9$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $7fPBF.useContext($d9fd026bfea79ab9$var$RouteErrorContext);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteError);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $d9fd026bfea79ab9$export$78a72ddb39bdd145() {
    let value = $7fPBF.useContext($d9fd026bfea79ab9$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $d9fd026bfea79ab9$export$17f53340677d5831() {
    let value = $7fPBF.useContext($d9fd026bfea79ab9$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $d9fd026bfea79ab9$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $d9fd026bfea79ab9$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseBlocker);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $7fPBF.useState("");
    let blockerFunction = $7fPBF.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $d9fd026bfea79ab9$var$_extends({}, currentLocation, {
                pathname: (0, $55100129ab36ed65$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $d9fd026bfea79ab9$var$_extends({}, nextLocation, {
                pathname: (0, $55100129ab36ed65$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $7fPBF.useEffect(()=>{
        let key = String(++$d9fd026bfea79ab9$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $7fPBF.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $55100129ab36ed65$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $d9fd026bfea79ab9$var$useNavigateStable() {
    let { router: router } = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseNavigateStable);
    let id = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $7fPBF.useRef(false);
    $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $d9fd026bfea79ab9$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $d9fd026bfea79ab9$var$alreadyWarned$1 = {};
function $d9fd026bfea79ab9$var$warningOnce(key, cond, message) {
    if (!cond && !$d9fd026bfea79ab9$var$alreadyWarned$1[key]) $d9fd026bfea79ab9$var$alreadyWarned$1[key] = true;
}
const $d9fd026bfea79ab9$var$alreadyWarned = {};
function $d9fd026bfea79ab9$var$warnOnce(key, message) {}
const $d9fd026bfea79ab9$var$logDeprecation = (flag, msg, link)=>$d9fd026bfea79ab9$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $d9fd026bfea79ab9$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $d9fd026bfea79ab9$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $d9fd026bfea79ab9$var$START_TRANSITION = "startTransition";
const $d9fd026bfea79ab9$var$startTransitionImpl = $7fPBF[$d9fd026bfea79ab9$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $d9fd026bfea79ab9$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $7fPBF.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        if (v7_startTransition && $d9fd026bfea79ab9$var$startTransitionImpl) $d9fd026bfea79ab9$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $7fPBF.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $7fPBF.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $7fPBF.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7fPBF.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $7fPBF.useEffect(()=>$d9fd026bfea79ab9$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $d9fd026bfea79ab9$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $d9fd026bfea79ab9$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $d9fd026bfea79ab9$var$startTransitionImpl ? $d9fd026bfea79ab9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7fPBF.useEffect(()=>$d9fd026bfea79ab9$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $d9fd026bfea79ab9$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let navigate = $d9fd026bfea79ab9$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $55100129ab36ed65$export$cae722b0cc860f13)(to, (0, $55100129ab36ed65$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $7fPBF.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $d9fd026bfea79ab9$export$910ae8079b2c2852(props) {
    return $d9fd026bfea79ab9$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $d9fd026bfea79ab9$export$e7b0ac011bb776c6(_props) {
    (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $d9fd026bfea79ab9$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $55100129ab36ed65$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $7fPBF.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $d9fd026bfea79ab9$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $55100129ab36ed65$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $7fPBF.useMemo(()=>{
        let trailingPathname = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $d9fd026bfea79ab9$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $d9fd026bfea79ab9$export$5d3fca4a98652595($d9fd026bfea79ab9$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $d9fd026bfea79ab9$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$ResolveAwait, null, children));
}
var $d9fd026bfea79ab9$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($d9fd026bfea79ab9$var$AwaitRenderStatus || {});
const $d9fd026bfea79ab9$var$neverSettledPromise = new Promise(()=>{});
class $d9fd026bfea79ab9$var$AwaitErrorBoundary extends $7fPBF.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $d9fd026bfea79ab9$var$AwaitRenderStatus.error : "_data" in promise ? $d9fd026bfea79ab9$var$AwaitRenderStatus.success : $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error && promise._error instanceof (0, $55100129ab36ed65$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $d9fd026bfea79ab9$var$neverSettledPromise;
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $d9fd026bfea79ab9$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $d9fd026bfea79ab9$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $d9fd026bfea79ab9$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $7fPBF.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $7fPBF.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $d9fd026bfea79ab9$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $d9fd026bfea79ab9$export$e7b0ac011bb776c6) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $d9fd026bfea79ab9$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $d9fd026bfea79ab9$export$daf73786167a7f72(matches) {
    return $d9fd026bfea79ab9$var$_renderMatches(matches);
}
function $d9fd026bfea79ab9$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $7fPBF.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $7fPBF.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $7fPBF.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $d9fd026bfea79ab9$export$f30f7e456d254e83(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $d9fd026bfea79ab9$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55100129ab36ed65$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $d9fd026bfea79ab9$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $a0cf24fd73ae067c$var$_extends() {
    $a0cf24fd73ae067c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a0cf24fd73ae067c$var$_extends.apply(this, arguments);
}
function $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $a0cf24fd73ae067c$var$defaultMethod = "get";
const $a0cf24fd73ae067c$var$defaultEncType = "application/x-www-form-urlencoded";
function $a0cf24fd73ae067c$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $a0cf24fd73ae067c$var$isButtonElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $a0cf24fd73ae067c$var$isFormElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $a0cf24fd73ae067c$var$isInputElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $a0cf24fd73ae067c$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $a0cf24fd73ae067c$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$a0cf24fd73ae067c$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $a0cf24fd73ae067c$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = null;
function $a0cf24fd73ae067c$var$isFormDataSubmitterSupported() {
    if ($a0cf24fd73ae067c$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = true;
    }
    return $a0cf24fd73ae067c$var$_formDataSupportsSubmitter;
}
const $a0cf24fd73ae067c$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $a0cf24fd73ae067c$var$getFormEncType(encType) {
    if (encType != null && !$a0cf24fd73ae067c$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $a0cf24fd73ae067c$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($a0cf24fd73ae067c$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $55100129ab36ed65$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $a0cf24fd73ae067c$var$defaultMethod;
        encType = $a0cf24fd73ae067c$var$getFormEncType(target.getAttribute("enctype")) || $a0cf24fd73ae067c$var$defaultEncType;
        formData = new FormData(target);
    } else if ($a0cf24fd73ae067c$var$isButtonElement(target) || $a0cf24fd73ae067c$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $55100129ab36ed65$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $a0cf24fd73ae067c$var$defaultMethod;
        encType = $a0cf24fd73ae067c$var$getFormEncType(target.getAttribute("formenctype")) || $a0cf24fd73ae067c$var$getFormEncType(form.getAttribute("enctype")) || $a0cf24fd73ae067c$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$a0cf24fd73ae067c$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($a0cf24fd73ae067c$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $a0cf24fd73ae067c$var$defaultMethod;
        action = null;
        encType = $a0cf24fd73ae067c$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $a0cf24fd73ae067c$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $a0cf24fd73ae067c$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $a0cf24fd73ae067c$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $a0cf24fd73ae067c$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $a0cf24fd73ae067c$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $a0cf24fd73ae067c$export$1f3f55432a00e06d(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a0cf24fd73ae067c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55100129ab36ed65$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a0cf24fd73ae067c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $d9fd026bfea79ab9$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $a0cf24fd73ae067c$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a0cf24fd73ae067c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55100129ab36ed65$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a0cf24fd73ae067c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $d9fd026bfea79ab9$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $a0cf24fd73ae067c$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $a0cf24fd73ae067c$var$_extends({}, state, {
        errors: $a0cf24fd73ae067c$var$deserializeErrors(state.errors)
    });
    return state;
}
function $a0cf24fd73ae067c$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $55100129ab36ed65$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $a0cf24fd73ae067c$export$7ad602f0e94e62d1 = /*#__PURE__*/ $7fPBF.createContext({
    isTransitioning: false
});
const $a0cf24fd73ae067c$export$148fd98d095596d4 = /*#__PURE__*/ $7fPBF.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $a0cf24fd73ae067c$var$START_TRANSITION = "startTransition";
const $a0cf24fd73ae067c$var$startTransitionImpl = $7fPBF[$a0cf24fd73ae067c$var$START_TRANSITION];
const $a0cf24fd73ae067c$var$FLUSH_SYNC = "flushSync";
const $a0cf24fd73ae067c$var$flushSyncImpl = $b4ba1c853f6e1116$exports[$a0cf24fd73ae067c$var$FLUSH_SYNC];
const $a0cf24fd73ae067c$var$USE_ID = "useId";
const $a0cf24fd73ae067c$var$useIdImpl = $7fPBF[$a0cf24fd73ae067c$var$USE_ID];
function $a0cf24fd73ae067c$var$startTransitionSafe(cb) {
    if ($a0cf24fd73ae067c$var$startTransitionImpl) $a0cf24fd73ae067c$var$startTransitionImpl(cb);
    else cb();
}
function $a0cf24fd73ae067c$var$flushSyncSafe(cb) {
    if ($a0cf24fd73ae067c$var$flushSyncImpl) $a0cf24fd73ae067c$var$flushSyncImpl(cb);
    else cb();
}
class $a0cf24fd73ae067c$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $a0cf24fd73ae067c$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $7fPBF.useState(router.state);
    let [pendingState, setPendingState] = $7fPBF.useState();
    let [vtContext, setVtContext] = $7fPBF.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $7fPBF.useState();
    let [transition, setTransition] = $7fPBF.useState();
    let [interruption, setInterruption] = $7fPBF.useState();
    let fetcherData = $7fPBF.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $7fPBF.useCallback((cb)=>{
        if (v7_startTransition) $a0cf24fd73ae067c$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $7fPBF.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $a0cf24fd73ae067c$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $a0cf24fd73ae067c$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $a0cf24fd73ae067c$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $a0cf24fd73ae067c$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $a0cf24fd73ae067c$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $7fPBF.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $7fPBF.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $a0cf24fd73ae067c$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $7fPBF.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $7fPBF.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $7fPBF.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $7fPBF.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $7fPBF.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7fPBF.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $7fPBF.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $7fPBF.useEffect(()=>(0, $d9fd026bfea79ab9$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $a0cf24fd73ae067c$var$MemoizedDataRoutes = /*#__PURE__*/ $7fPBF.memo($a0cf24fd73ae067c$var$DataRoutes);
function $a0cf24fd73ae067c$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $d9fd026bfea79ab9$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $a0cf24fd73ae067c$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7fPBF.useEffect(()=>(0, $d9fd026bfea79ab9$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $a0cf24fd73ae067c$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7fPBF.useEffect(()=>(0, $d9fd026bfea79ab9$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $a0cf24fd73ae067c$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7fPBF.useEffect(()=>(0, $d9fd026bfea79ab9$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $a0cf24fd73ae067c$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $a0cf24fd73ae067c$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $a0cf24fd73ae067c$export$a6c7ac8248d6e38a = /*#__PURE__*/ $7fPBF.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref7, $a0cf24fd73ae067c$var$_excluded);
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $a0cf24fd73ae067c$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($a0cf24fd73ae067c$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $d9fd026bfea79ab9$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $a0cf24fd73ae067c$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $7fPBF.createElement("a", $a0cf24fd73ae067c$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $a0cf24fd73ae067c$export$b0d92dbee9b5b60d = /*#__PURE__*/ $7fPBF.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref8, $a0cf24fd73ae067c$var$_excluded2);
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let routerState = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $a0cf24fd73ae067c$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$a6c7ac8248d6e38a, $a0cf24fd73ae067c$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $a0cf24fd73ae067c$export$a7fed597f4b8afd8 = /*#__PURE__*/ $7fPBF.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $a0cf24fd73ae067c$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref9, $a0cf24fd73ae067c$var$_excluded3);
    let submit = $a0cf24fd73ae067c$export$47c85c6e3a081d3();
    let formAction = $a0cf24fd73ae067c$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $7fPBF.createElement("form", $a0cf24fd73ae067c$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $a0cf24fd73ae067c$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $a0cf24fd73ae067c$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $a0cf24fd73ae067c$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($a0cf24fd73ae067c$var$DataRouterHook || ($a0cf24fd73ae067c$var$DataRouterHook = {}));
var $a0cf24fd73ae067c$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($a0cf24fd73ae067c$var$DataRouterStateHook || ($a0cf24fd73ae067c$var$DataRouterStateHook = {}));
// Internal hooks
function $a0cf24fd73ae067c$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $a0cf24fd73ae067c$var$useDataRouterContext(hookName) {
    let ctx = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$3add0d5dce533e2e));
    !ctx && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return ctx;
}
function $a0cf24fd73ae067c$var$useDataRouterState(hookName) {
    let state = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$145dfa71566a64dc));
    !state && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $a0cf24fd73ae067c$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $7fPBF.useCallback((event)=>{
        if ($a0cf24fd73ae067c$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $55100129ab36ed65$export$fe53371bee54353d)(location) === (0, $55100129ab36ed65$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $a0cf24fd73ae067c$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $7fPBF.useRef($a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $7fPBF.useRef(false);
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let searchParams = $7fPBF.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $a0cf24fd73ae067c$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    let setSearchParams = $7fPBF.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $a0cf24fd73ae067c$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $a0cf24fd73ae067c$var$fetcherId = 0;
let $a0cf24fd73ae067c$var$getUniqueFetcherId = ()=>"__" + String(++$a0cf24fd73ae067c$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $a0cf24fd73ae067c$export$47c85c6e3a081d3() {
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let currentRouteId = (0, $d9fd026bfea79ab9$export$5fc8298006ad9e58)();
    return $7fPBF.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $a0cf24fd73ae067c$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $a0cf24fd73ae067c$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $a0cf24fd73ae067c$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $a0cf24fd73ae067c$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let routeContext = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$9072aa6dd1f93057));
    !routeContext && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $a0cf24fd73ae067c$var$_extends({}, (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $55100129ab36ed65$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $a0cf24fd73ae067c$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseFetcher);
    let state = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $7fPBF.useContext($a0cf24fd73ae067c$export$148fd98d095596d4);
    let route = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    !route && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $a0cf24fd73ae067c$var$useIdImpl ? $a0cf24fd73ae067c$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $7fPBF.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($a0cf24fd73ae067c$var$getUniqueFetcherId());
    // Registration/cleanup
    $7fPBF.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $7fPBF.useCallback((href, opts)=>{
        !routeId && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $a0cf24fd73ae067c$export$47c85c6e3a081d3();
    let submit = $7fPBF.useCallback((target, opts)=>{
        submitImpl(target, $a0cf24fd73ae067c$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $7fPBF.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $7fPBF.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$a7fed597f4b8afd8, $a0cf24fd73ae067c$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $55100129ab36ed65$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $7fPBF.useMemo(()=>$a0cf24fd73ae067c$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $a0cf24fd73ae067c$export$fa996778a3a31087() {
    let state = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $a0cf24fd73ae067c$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $a0cf24fd73ae067c$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $a0cf24fd73ae067c$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let matches = (0, $d9fd026bfea79ab9$export$2378eb7f5ff86053)();
    let navigation = (0, $d9fd026bfea79ab9$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $7fPBF.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $a0cf24fd73ae067c$var$usePageHide($7fPBF.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $a0cf24fd73ae067c$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($a0cf24fd73ae067c$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $a0cf24fd73ae067c$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($a0cf24fd73ae067c$var$_extends({}, location, {
                    pathname: (0, $55100129ab36ed65$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($a0cf24fd73ae067c$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a0cf24fd73ae067c$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a0cf24fd73ae067c$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $a0cf24fd73ae067c$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $d9fd026bfea79ab9$export$b273b3273281a049)(when);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $a0cf24fd73ae067c$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $7fPBF.useContext($a0cf24fd73ae067c$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { basename: basename } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.useViewTransitionState);
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $55100129ab36ed65$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $55100129ab36ed65$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




var $7fPBF = parcelRequire("7fPBF");

/* Consent.tsx generated by @compiled/babel-plugin v2.0.0 */ 
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $bfde69414e76f2a7$var$ATOMIC_GROUP_LENGTH = 5;
function $bfde69414e76f2a7$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $bfde69414e76f2a7$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

parcelRequire("7fPBF");
/**
 * Returns `true` when caching should be disabled, else `false`.
 *
 * Any code within this check will be removed in the output bundles:
 *
 * ```js
 * if (isCacheDisabled()) {
 *   // This code will be removed from the output bundles
 * }
 * ```
 */ const $a13499268a19582a$export$3afd524f1aee0f44 = ()=>{
    return false;
};



/**
 * Cache to hold already used styles.
 * React Context on the server - singleton object on the client.
 */ const $e954cdbfe522d5cb$var$Cache = {};
if (typeof document !== 'undefined') {
    /**
     * Iterates through all found style elements generated when server side rendering.
     *
     * @param cb
     */ const ssrStyles = document.querySelectorAll('style[data-cmpld]');
    for(let i = 0; i < ssrStyles.length; i++)// Move all found server-side rendered style elements to the head before React hydration happens.
    document.head.appendChild(ssrStyles[i]);
}
const $e954cdbfe522d5cb$export$c6e89b6bb9436bc0 = ()=>{
    if ((0, $a13499268a19582a$export$3afd524f1aee0f44)()) return {};
    // On the client we use the object singleton.
    return $e954cdbfe522d5cb$var$Cache;
};
/**
 * On the server this ensures the minimal amount of styles will be rendered
 * safely using React Context.
 *
 * On the browser this turns into a fragment with no React Context.
 */ const $e954cdbfe522d5cb$var$StyleCacheProvider = (props)=>{
    return props.children;
};
var $e954cdbfe522d5cb$export$2e2bcd8739ae039 = $e954cdbfe522d5cb$var$StyleCacheProvider;

parcelRequire("7fPBF");



// Copied from packages/utils/src/shorthand.ts so that we avoid
// inflating the bundle size of @compiled/react/runtime with the contents
// of @compiled/utils
//
// Keep this `shorthandBuckets` in sync with the `shorthandBuckets` defined in
// packages/utils/src/shorthand.ts
const $f7031165668ab2fb$var$shorthandBuckets = {
    all: 0,
    animation: 1,
    'animation-range': 1,
    background: 1,
    border: 1,
    'border-color': 2,
    'border-style': 2,
    'border-width': 2,
    'border-block': 3,
    'border-inline': 3,
    'border-top': 4,
    'border-right': 4,
    'border-bottom': 4,
    'border-left': 4,
    'border-block-start': 5,
    'border-block-end': 5,
    'border-inline-start': 5,
    'border-inline-end': 5,
    'border-image': 1,
    'border-radius': 1,
    'column-rule': 1,
    columns: 1,
    'contain-intrinsic-size': 1,
    container: 1,
    flex: 1,
    'flex-flow': 1,
    font: 1,
    'font-synthesis': 1,
    'font-variant': 2,
    gap: 1,
    grid: 1,
    'grid-area': 1,
    'grid-column': 2,
    'grid-row': 2,
    'grid-template': 2,
    inset: 1,
    'inset-block': 2,
    'inset-inline': 2,
    'list-style': 1,
    margin: 1,
    'margin-block': 2,
    'margin-inline': 2,
    mask: 1,
    'mask-border': 1,
    offset: 1,
    outline: 1,
    overflow: 1,
    'overscroll-behavior': 1,
    padding: 1,
    'padding-block': 2,
    'padding-inline': 2,
    'place-content': 1,
    'place-items': 1,
    'place-self': 1,
    'position-try': 1,
    'scroll-margin': 1,
    'scroll-margin-block': 2,
    'scroll-margin-inline': 2,
    'scroll-padding': 1,
    'scroll-padding-block': 2,
    'scroll-padding-inline': 2,
    'scroll-timeline': 1,
    'text-decoration': 1,
    'text-emphasis': 1,
    'text-wrap': 1,
    transition: 1,
    'view-timeline': 1
};
const $f7031165668ab2fb$export$b08836c779543dbf = (shorthand)=>{
    var _a;
    return (_a = $f7031165668ab2fb$var$shorthandBuckets[shorthand]) !== null && _a !== void 0 ? _a : null;
};


const $189a6334ccf0e9ac$export$8394bdfbee416ca4 = [
    // shorthand properties
    's-0',
    's-1',
    's-2',
    's-3',
    's-4',
    's-5',
    // catch-all
    '',
    // link
    'l',
    // visited
    'v',
    // focus-within
    'w',
    // focus
    'f',
    // focus-visible
    'i',
    // hover
    'h',
    // active
    'a',
    // at-rules
    'm'
];
/**
 * Holds all style buckets in memory that have been added to the head.
 */ const $189a6334ccf0e9ac$var$styleBucketsInHead = {};
/**
 * Maps the long pseudo name to the short pseudo name.
 * Pseudos that match here will be ordered,
 * everything else will make their way to the catch all style bucket.
 * We reduce the pseudo name to save bundlesize.
 * Thankfully there aren't any overlaps, see: https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-classes.
 */ const $189a6334ccf0e9ac$var$pseudosMap = {
    // link
    k: 'l',
    // visited
    ited: 'v',
    // focus-within
    'us-within': 'w',
    // focus
    us: 'f',
    // focus-visible
    'us-visible': 'i',
    // hover
    er: 'h',
    // active
    ive: 'a'
};
/**
 * Holds style buckets per custom container (e.g. a ShadowRoot), keyed by the
 * container DOM node. Uses WeakMap so entries are garbage collected when the
 * container is removed from the page.
 */ const $189a6334ccf0e9ac$var$styleBucketsByContainer = new WeakMap();
/**
 * Lazily adds a `<style>` bucket to a container, defaulting to `the `<head>`
 * when no container is provided in opts. Ensures style buckets are inserted in
 * the correct order regardless of the target container.
 *
 * Each custom container (e.g. a ShadowRoot) gets its own independent set of
 * buckets via the WeakMap — the main document singleton is unaffected.
 *
 * @param bucketName Bucket to insert into the container.
 * @param opts StyleSheetOpts optionally including a custom container.
 */ function $189a6334ccf0e9ac$var$lazyAddStyleBucketToContainer(bucketName, opts) {
    var _a;
    const target = (_a = opts.container) !== null && _a !== void 0 ? _a : document.head;
    let buckets;
    if (opts.container) {
        if (!$189a6334ccf0e9ac$var$styleBucketsByContainer.has(opts.container)) $189a6334ccf0e9ac$var$styleBucketsByContainer.set(opts.container, {});
        buckets = $189a6334ccf0e9ac$var$styleBucketsByContainer.get(opts.container);
    } else buckets = $189a6334ccf0e9ac$var$styleBucketsInHead;
    if (!buckets[bucketName]) {
        let currentBucketIndex = $189a6334ccf0e9ac$export$8394bdfbee416ca4.indexOf(bucketName) + 1;
        let nextBucketFromCache = null;
        // Find the next bucket which we will add our new style bucket before.
        for(; currentBucketIndex < $189a6334ccf0e9ac$export$8394bdfbee416ca4.length; currentBucketIndex++){
            const nextBucket = buckets[$189a6334ccf0e9ac$export$8394bdfbee416ca4[currentBucketIndex]];
            if (nextBucket) {
                nextBucketFromCache = nextBucket;
                break;
            }
        }
        const tag = document.createElement('style');
        opts.nonce && tag.setAttribute('nonce', opts.nonce);
        tag.appendChild(document.createTextNode(''));
        target.insertBefore(tag, nextBucketFromCache);
        if ((0, $a13499268a19582a$export$3afd524f1aee0f44)()) return tag;
        buckets[bucketName] = tag;
    }
    return buckets[bucketName];
}
const $189a6334ccf0e9ac$export$d90f6836ea1aee93 = (sheet)=>{
    // We are grouping all the at-rules like @media, @supports etc under `m` bucket.
    if (sheet.charCodeAt(0) === 64 /* "@" */ ) return 'm';
    const firstBracket = sheet.indexOf('{');
    /**
     * We assume that classname will always be 9 character long,
     * using this the 10th characters could be a pseudo declaration.
     */ if (sheet.charCodeAt(10) === 58 /* ":" */ ) {
        // We send through a subset of the string instead of the full pseudo name.
        // For example `"focus-visible"` name would instead of `"us-visible"`.
        // Return a mapped pseudo else the default catch all bucket.
        const mapped = $189a6334ccf0e9ac$var$pseudosMap[sheet.slice(14, firstBracket)];
        if (mapped) return mapped;
    }
    const property = sheet.slice(firstBracket + 1, sheet.indexOf(':', firstBracket)).trim();
    const shorthandDepth = (0, $f7031165668ab2fb$export$b08836c779543dbf)(property);
    if (typeof shorthandDepth === 'number') return `s-${shorthandDepth}`;
    // Return default catch all bucket
    return '';
};
function $189a6334ccf0e9ac$export$2e2bcd8739ae039(css, opts) {
    const bucketName = $189a6334ccf0e9ac$export$d90f6836ea1aee93(css);
    const style = $189a6334ccf0e9ac$var$lazyAddStyleBucketToContainer(bucketName, opts);
    {
        const sheet = style.sheet;
        // Used to avoid unhandled exceptions across browsers with prefixed selectors such as -moz-placeholder.
        try {
            sheet.insertRule(css, sheet.cssRules.length);
        } catch (_a) {}
    }
}
function $189a6334ccf0e9ac$export$2f01f8749482f7ab(css, opts) {
    // Always use the catch-all '' bucket to preserve source-order cascade.
    // The css string may contain multiple CSS rules concatenated (cssMapScoped variants
    // with nested selectors). `insertRule` only accepts a single rule per call, so we
    // use `Text.appendData` instead — it appends to an existing text node in a single
    // DOM mutation (no new text node creation, no parsing limits, accepts multi-rule).
    const style = $189a6334ccf0e9ac$var$lazyAddStyleBucketToContainer('', opts);
    const text = style.firstChild;
    if (text) text.appendData(css);
    else style.appendChild(document.createTextNode(css));
}




var $7fPBF = parcelRequire("7fPBF");

let $8b1b394310d694ed$export$1c617ef0fac4c274 = null;
const $8b1b394310d694ed$export$27c28af7c58fc6b4 = ()=>{
    return $8b1b394310d694ed$export$1c617ef0fac4c274;
};
function $8b1b394310d694ed$export$c2e7cf7518b34f16({ container: container, cacheKey: cacheKey, children: children }) {
    // On the client, set the singleton synchronously during the render phase via
    // useMemo so CS children pick it up immediately.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>{
        $8b1b394310d694ed$export$1c617ef0fac4c274 = {
            container: container,
            cacheKey: cacheKey
        };
    }, [
        container,
        cacheKey
    ]);
    // Clear the singleton when this provider unmounts.
    // Note: nested StyleContainerProviders are not supported. If an inner provider
    // unmounts, this will clear clientStyleContainer to null rather than restoring
    // the outer provider's value. This is an acceptable limitation for the intended
    // use case of a single provider wrapping a shadow DOM subtree.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        return ()=>{
            $8b1b394310d694ed$export$1c617ef0fac4c274 = null;
        };
    }, []);
    return children;
}


/**
 * Returns true if the CSS sheet string is a non-atomic rule generated by
 * `cssMapScoped`. Non-atomic rules use the `cc-` class prefix
 * (i.e. the sheet starts with `.cc-`).
 */ const $45806fc118e88e4e$var$isNonAtomicSheet = (sheet)=>sheet.startsWith('.cc-');
function $45806fc118e88e4e$export$2e2bcd8739ae039(props) {
    const inserted = (0, $e954cdbfe522d5cb$export$c6e89b6bb9436bc0)();
    const styleContainer = (0, $8b1b394310d694ed$export$27c28af7c58fc6b4)();
    if (props.children.length) {
        var bucket;
        {
            const opts = styleContainer ? Object.assign(Object.assign({}, props), {
                container: styleContainer.container,
                cacheKey: styleContainer.cacheKey
            }) : props;
            for(let i = 0; i < props.children.length; i++){
                const sheet = props.children[i];
                // When a container is active, namespace the cache key so this container's
                // inserted records are tracked independently from the main document cache.
                const cacheKey = styleContainer ? `${styleContainer.cacheKey}:${sheet}` : sheet;
                if (inserted[cacheKey]) continue;
                inserted[cacheKey] = true;
                // Non-atomic rules (cc- prefix from cssMapScoped) must bypass the
                // shorthand bucket sorting logic — they contain multiple declarations per rule
                // and must preserve source-order cascade within the catch-all bucket.
                if ($45806fc118e88e4e$var$isNonAtomicSheet(sheet)) (0, $189a6334ccf0e9ac$export$2f01f8749482f7ab)(sheet, opts);
                else (0, $189a6334ccf0e9ac$export$2e2bcd8739ae039)(sheet, opts);
            }
        }
    }
    return null;
}



var $7fPBF = parcelRequire("7fPBF");

parcelRequire("7fPBF");
/* Footer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $151b1d922dd4b2cf$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}



var $7fPBF = parcelRequire("7fPBF");
var $447ba15143f7eed7$exports = {};

$parcel$export($447ba15143f7eed7$exports, "GOTO_PREFERENCES_CENTER_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$397c69071c7b1ce2; });
$parcel$export($447ba15143f7eed7$exports, "GOTO_ATLASSIAN_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$a032c0358daca74b; });
$parcel$export($447ba15143f7eed7$exports, "PRIVACY_POLICY_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$bd3a35dde4ef175c; });
$parcel$export($447ba15143f7eed7$exports, "TERM_OF_USE_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$5ec2f4d972df7fd3; });
$parcel$export($447ba15143f7eed7$exports, "TRADEMARK_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$5c56b9e715e65435; });
$parcel$export($447ba15143f7eed7$exports, "USER_NOT_FOUND_MESSAGE", function () { return $447ba15143f7eed7$export$45923b899016cb93; });
$parcel$export($447ba15143f7eed7$exports, "EMPTY_USER_SUBSCRIPTIONS_MESSAGE", function () { return $447ba15143f7eed7$export$91435b4781e5f50d; });
$parcel$export($447ba15143f7eed7$exports, "ALL_LANGUAGES_MESSAGE", function () { return $447ba15143f7eed7$export$d3cd07d395a9ed0a; });
$parcel$export($447ba15143f7eed7$exports, "PROPOSED_LANGUAGE_MESSAGE", function () { return $447ba15143f7eed7$export$188c68aa312fbf1c; });
$parcel$export($447ba15143f7eed7$exports, "UNSUBSCRIBE_ALL_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$3d386fa5ce2bb50f; });
$parcel$export($447ba15143f7eed7$exports, "UNSUBSCRIBE_ALL_TOOLTIP_LABEL", function () { return $447ba15143f7eed7$export$e76fe16bca5a05f; });
$parcel$export($447ba15143f7eed7$exports, "UPDATE_SUBSCRIPTIONS_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$bb457a99f02ee8df; });
$parcel$export($447ba15143f7eed7$exports, "GMOI_REQUEST_ERROR_MESSAGE", function () { return $447ba15143f7eed7$export$1042bd74142919d3; });
$parcel$export($447ba15143f7eed7$exports, "SELECT_LABEL", function () { return $447ba15143f7eed7$export$8282e8208b45c51a; });
$parcel$export($447ba15143f7eed7$exports, "SELECT_ALL_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$986068f8bec214ca; });
$parcel$export($447ba15143f7eed7$exports, "SELECT_NONE_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$b79e4a941028ca1f; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_ERROR_MESSAGE_TITLE", function () { return $447ba15143f7eed7$export$ddb748859563ce79; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_ERROR_MESSAGE_DESCRIPTION", function () { return $447ba15143f7eed7$export$c79abf3d845a1fdd; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_NOTE_MESSAGE", function () { return $447ba15143f7eed7$export$866e88663611df05; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_GLOBAL_UNSUBSCRIBE_MESSAGE_TITLE", function () { return $447ba15143f7eed7$export$5093956da3c8db1c; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_PRODUCT_INVITATIONS_WARNING_TITLE", function () { return $447ba15143f7eed7$export$781d5fa1055ae86a; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_PRODUCT_INVITATIONS_WARNING_BODY_PRIMARY", function () { return $447ba15143f7eed7$export$956f2ec48e0de951; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_PRODUCT_INVITATIONS_WARNING_BODY_SECONDARY", function () { return $447ba15143f7eed7$export$e3a826721228e8e2; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_SUBSCRIBE_MESSAGE_TITLE", function () { return $447ba15143f7eed7$export$54dcd5dee646311c; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_SUBSCRIBE_MESSAGE_BODY_PRIMARY", function () { return $447ba15143f7eed7$export$455b805d86ac6cee; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_SUBSCRIBE_MESSAGE_BODY_SECONDARY", function () { return $447ba15143f7eed7$export$803298324e8194ae; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_SUBSCRIBE_MESSAGE_BODY_TERTIARY", function () { return $447ba15143f7eed7$export$f4911f869cc01000; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_UNSUBSCRIBE_MESSAGE_TITLE", function () { return $447ba15143f7eed7$export$70371af9f5fd8981; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_UNSUBSCRIBE_MESSAGE_BODY_PRIMARY", function () { return $447ba15143f7eed7$export$e95889acedebb0b; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_UNSUBSCRIBE_MESSAGE_BODY_SECONDARY", function () { return $447ba15143f7eed7$export$e52a7b9718929cd4; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_UNSUBSCRIBE_MESSAGE_BODY_TERTIARY", function () { return $447ba15143f7eed7$export$ac6196eb73ad054e; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_UPDATE_SUCCESS_MESSAGE_TITLE", function () { return $447ba15143f7eed7$export$6710290bec50a2d9; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_UPDATE_SUCCESS_MESSAGE_DESCRIPTION", function () { return $447ba15143f7eed7$export$6c795c0503e7a19a; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_UPDATE_CONSENT_DOUBLE_OPT_IN_MESSAGE", function () { return $447ba15143f7eed7$export$298d0327b5b79594; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_LEARN_MORE_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$cef752f911adf0f9; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_DISMISS_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$7bdbef670c907c38; });
$parcel$export($447ba15143f7eed7$exports, "NOTIFICATION_SUBSCRIBE_TO_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$54a1be12708d2f5; });
$parcel$export($447ba15143f7eed7$exports, "CONSENT_DIALOG_LABEL", function () { return $447ba15143f7eed7$export$6cdfffd461a59281; });
$parcel$export($447ba15143f7eed7$exports, "CONSENT_DIALOG_ACCEPT_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$d1eeb2bc07f4f58b; });
$parcel$export($447ba15143f7eed7$exports, "CONSENT_DIALOG_DECLINE_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$fd792269277ee593; });
$parcel$export($447ba15143f7eed7$exports, "CONSENT_DIALOG_GMOI_MESSAGE", function () { return $447ba15143f7eed7$export$4aeb433178e4246b; });
$parcel$export($447ba15143f7eed7$exports, "CONSENT_DECLINE_PR_DIALOG_LABEL", function () { return $447ba15143f7eed7$export$1d83912f2291ee3c; });
$parcel$export($447ba15143f7eed7$exports, "CONSENT_DECLINE_PR_DIALOG_MESSAGE", function () { return $447ba15143f7eed7$export$f871df89b6210c46; });
$parcel$export($447ba15143f7eed7$exports, "CONSENT_DECLINE_PR_ACCEPT_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$6fa38d28a45687c1; });
$parcel$export($447ba15143f7eed7$exports, "CONSENT_DECLINE_PR_CANCEL_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$1840364bf6f6fbfe; });
$parcel$export($447ba15143f7eed7$exports, "GLOBAL_UNSUBSCRIBE_DIALOG_LABEL", function () { return $447ba15143f7eed7$export$edd3a3232f802b5f; });
$parcel$export($447ba15143f7eed7$exports, "GLOBAL_UNSUBSCRIBE_DIALOG_MESSAGE", function () { return $447ba15143f7eed7$export$995b366aaf4ad5bf; });
$parcel$export($447ba15143f7eed7$exports, "GLOBAL_UNSUBSCRIBE_DIALOG_ACCEPT_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$6b585b2c49802e53; });
$parcel$export($447ba15143f7eed7$exports, "GLOBAL_UNSUBSCRIBE_DIALOG_DECLINE_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$42d9402f99ba57a; });
$parcel$export($447ba15143f7eed7$exports, "DOUBLE_OPT_IN_DIALOG_LABEL", function () { return $447ba15143f7eed7$export$5005c05e9a6da27b; });
$parcel$export($447ba15143f7eed7$exports, "DOUBLE_OPT_IN_DIALOG_MESSAGE", function () { return $447ba15143f7eed7$export$e5a61277c372c8c4; });
$parcel$export($447ba15143f7eed7$exports, "DOUBLE_OPT_IN_DIALOG_ACCEPT_BUTTON_LABEL", function () { return $447ba15143f7eed7$export$8496d3c16cb9aaae; });
const $447ba15143f7eed7$export$397c69071c7b1ce2 = 'goto_preferences_center.button.label';
const $447ba15143f7eed7$export$a032c0358daca74b = 'goto_atlassian.button.label';
const $447ba15143f7eed7$export$bd3a35dde4ef175c = 'privacy_policy.button.label';
const $447ba15143f7eed7$export$5ec2f4d972df7fd3 = 'term_of_use.button.label';
const $447ba15143f7eed7$export$5c56b9e715e65435 = 'trademark.button.label';
const $447ba15143f7eed7$export$45923b899016cb93 = 'user_not_found.message';
const $447ba15143f7eed7$export$91435b4781e5f50d = 'empty_user_subscriptions.message';
const $447ba15143f7eed7$export$d3cd07d395a9ed0a = 'all_languages.message';
const $447ba15143f7eed7$export$188c68aa312fbf1c = 'proposed_language.message';
const $447ba15143f7eed7$export$3d386fa5ce2bb50f = 'unsubscribe_all.button.label';
const $447ba15143f7eed7$export$e76fe16bca5a05f = 'unsubscribe_all.tooltip.label';
const $447ba15143f7eed7$export$bb457a99f02ee8df = 'update_subscriptions.button.label';
const $447ba15143f7eed7$export$1042bd74142919d3 = 'gmoi_request.error.message';
const $447ba15143f7eed7$export$8282e8208b45c51a = 'select.label';
const $447ba15143f7eed7$export$986068f8bec214ca = 'select_all.button.label';
const $447ba15143f7eed7$export$b79e4a941028ca1f = 'select_none.button.label';
const $447ba15143f7eed7$export$ddb748859563ce79 = 'notification.error.message.title';
const $447ba15143f7eed7$export$c79abf3d845a1fdd = 'notification.error.message.description';
const $447ba15143f7eed7$export$866e88663611df05 = 'notification.note.message';
const $447ba15143f7eed7$export$5093956da3c8db1c = 'notification.global_unsubscribe.message.title';
const $447ba15143f7eed7$export$781d5fa1055ae86a = 'notification.product_invitations.warning.title';
const $447ba15143f7eed7$export$956f2ec48e0de951 = 'notification.product_invitations.warning.body.primary';
const $447ba15143f7eed7$export$e3a826721228e8e2 = 'notification.product_invitations.warning.body.secondary';
const $447ba15143f7eed7$export$54dcd5dee646311c = 'notification.subscribe.message.title';
const $447ba15143f7eed7$export$455b805d86ac6cee = 'notification.subscribe.message.body.primary';
const $447ba15143f7eed7$export$803298324e8194ae = 'notification.subscribe.message.body.secondary';
const $447ba15143f7eed7$export$f4911f869cc01000 = 'notification.subscribe.message.body.tertiary';
const $447ba15143f7eed7$export$70371af9f5fd8981 = 'notification.unsubscribe.message.title';
const $447ba15143f7eed7$export$e95889acedebb0b = 'notification.unsubscribe.message.body.primary';
const $447ba15143f7eed7$export$e52a7b9718929cd4 = 'notification.unsubscribe.message.body.secondary';
const $447ba15143f7eed7$export$ac6196eb73ad054e = 'notification.unsubscribe.message.body.tertiary';
const $447ba15143f7eed7$export$6710290bec50a2d9 = 'notification.update_subscriptions.message.title';
const $447ba15143f7eed7$export$6c795c0503e7a19a = 'notification.update_subscriptions.message.description';
const $447ba15143f7eed7$export$298d0327b5b79594 = 'notification.update_consent.double_opt_in.message';
const $447ba15143f7eed7$export$cef752f911adf0f9 = 'notification.learn_more.button.label';
const $447ba15143f7eed7$export$7bdbef670c907c38 = 'notification.dismiss.button.label';
const $447ba15143f7eed7$export$54a1be12708d2f5 = 'notification.subscribe_to.button.label';
const $447ba15143f7eed7$export$6cdfffd461a59281 = 'consent_dialog.label';
const $447ba15143f7eed7$export$d1eeb2bc07f4f58b = 'consent_dialog.accept.button.label';
const $447ba15143f7eed7$export$fd792269277ee593 = 'consent_dialog.decline.button.label';
const $447ba15143f7eed7$export$4aeb433178e4246b = 'consent_dialog.gmoi.message';
const $447ba15143f7eed7$export$1d83912f2291ee3c = 'consent_decline_pr.dialog.label';
const $447ba15143f7eed7$export$f871df89b6210c46 = 'consent_decline_pr.dialog.message';
const $447ba15143f7eed7$export$6fa38d28a45687c1 = 'consent_decline_pr.accept.button.label';
const $447ba15143f7eed7$export$1840364bf6f6fbfe = 'consent_decline_pr.decline.button.label';
const $447ba15143f7eed7$export$edd3a3232f802b5f = 'global_unsubscribe_dialog.label';
const $447ba15143f7eed7$export$995b366aaf4ad5bf = 'global_unsubscribe_dialog.message';
const $447ba15143f7eed7$export$6b585b2c49802e53 = 'global_unsubscribe_dialog.accept.button.label';
const $447ba15143f7eed7$export$42d9402f99ba57a = 'global_unsubscribe_dialog.decline.button.label';
const $447ba15143f7eed7$export$5005c05e9a6da27b = 'double_opt_in_dialog.label';
const $447ba15143f7eed7$export$e5a61277c372c8c4 = 'double_opt_in_dialog.message';
const $447ba15143f7eed7$export$8496d3c16cb9aaae = 'double_opt_in_dialog.accept.button.label';



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
// src/utils/formatProdErrorMessage.ts

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
function $78916fc80cd27125$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $78916fc80cd27125$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $78916fc80cd27125$var$symbol_observable_default = $78916fc80cd27125$var$$$observable;
// src/utils/actionTypes.ts
var $78916fc80cd27125$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $78916fc80cd27125$var$ActionTypes = {
    INIT: `@@redux/INIT${$78916fc80cd27125$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$78916fc80cd27125$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$78916fc80cd27125$var$randomString()}`
};
var $78916fc80cd27125$export$4219e499db7ca678 = $78916fc80cd27125$var$ActionTypes;
// src/utils/isPlainObject.ts
function $78916fc80cd27125$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $78916fc80cd27125$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($78916fc80cd27125$var$isDate(val)) return "date";
    if ($78916fc80cd27125$var$isError(val)) return "error";
    const constructorName = $78916fc80cd27125$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $78916fc80cd27125$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $78916fc80cd27125$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $78916fc80cd27125$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $78916fc80cd27125$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $78916fc80cd27125$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(1));
        return enhancer($78916fc80cd27125$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$78916fc80cd27125$export$53b83ca8eaab0383(action)) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $78916fc80cd27125$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$78916fc80cd27125$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $78916fc80cd27125$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$78916fc80cd27125$var$symbol_observable_default]: observable
    };
    return store;
}
function $78916fc80cd27125$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $78916fc80cd27125$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $78916fc80cd27125$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $78916fc80cd27125$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $78916fc80cd27125$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$78916fc80cd27125$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$78916fc80cd27125$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $78916fc80cd27125$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $78916fc80cd27125$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $78916fc80cd27125$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $78916fc80cd27125$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(13));
    });
}
function $78916fc80cd27125$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $78916fc80cd27125$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($78916fc80cd27125$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $78916fc80cd27125$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $78916fc80cd27125$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $78916fc80cd27125$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $78916fc80cd27125$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $78916fc80cd27125$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $78916fc80cd27125$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($78916fc80cd27125$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $78916fc80cd27125$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return (0, $2qxEV._)((0, $9tqwB._)({}, store), {
                dispatch: dispatch
            });
        };
}
// src/utils/isAction.ts
function $78916fc80cd27125$export$b956e38827fca970(action) {
    return $78916fc80cd27125$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


var $7d97e02cb028d0b8$var$__defProp = Object.defineProperty;
var $7d97e02cb028d0b8$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $7d97e02cb028d0b8$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7d97e02cb028d0b8$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $7d97e02cb028d0b8$var$__defNormalProp = (obj, key, value)=>key in obj ? $7d97e02cb028d0b8$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7d97e02cb028d0b8$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($7d97e02cb028d0b8$var$__hasOwnProp.call(b, prop)) $7d97e02cb028d0b8$var$__defNormalProp(a, prop, b[prop]);
    if ($7d97e02cb028d0b8$var$__getOwnPropSymbols) {
        for (var prop of $7d97e02cb028d0b8$var$__getOwnPropSymbols(b))if ($7d97e02cb028d0b8$var$__propIsEnum.call(b, prop)) $7d97e02cb028d0b8$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $7d97e02cb028d0b8$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $7d97e02cb028d0b8$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $7d97e02cb028d0b8$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $7d97e02cb028d0b8$var$errors = [];
function $7d97e02cb028d0b8$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $7d97e02cb028d0b8$var$O = Object;
var $7d97e02cb028d0b8$var$getPrototypeOf = $7d97e02cb028d0b8$var$O.getPrototypeOf;
var $7d97e02cb028d0b8$var$CONSTRUCTOR = "constructor";
var $7d97e02cb028d0b8$var$PROTOTYPE = "prototype";
var $7d97e02cb028d0b8$var$CONFIGURABLE = "configurable";
var $7d97e02cb028d0b8$var$ENUMERABLE = "enumerable";
var $7d97e02cb028d0b8$var$WRITABLE = "writable";
var $7d97e02cb028d0b8$var$VALUE = "value";
var $7d97e02cb028d0b8$export$541ac630993a4c84 = (value)=>!!value && !!value[$7d97e02cb028d0b8$var$DRAFT_STATE];
function $7d97e02cb028d0b8$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $7d97e02cb028d0b8$var$isPlainObject(value) || $7d97e02cb028d0b8$var$isArray(value) || !!value[$7d97e02cb028d0b8$export$6ee2082928bcb0ee] || !!((_a = value[$7d97e02cb028d0b8$var$CONSTRUCTOR]) == null ? void 0 : _a[$7d97e02cb028d0b8$export$6ee2082928bcb0ee]) || $7d97e02cb028d0b8$var$isMap(value) || $7d97e02cb028d0b8$var$isSet(value);
}
var $7d97e02cb028d0b8$var$objectCtorString = $7d97e02cb028d0b8$var$O[$7d97e02cb028d0b8$var$PROTOTYPE][$7d97e02cb028d0b8$var$CONSTRUCTOR].toString();
var $7d97e02cb028d0b8$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $7d97e02cb028d0b8$var$isPlainObject(value) {
    if (!value || !$7d97e02cb028d0b8$var$isObjectish(value)) return false;
    const proto = $7d97e02cb028d0b8$var$getPrototypeOf(value);
    if (proto === null || proto === $7d97e02cb028d0b8$var$O[$7d97e02cb028d0b8$var$PROTOTYPE]) return true;
    const Ctor = $7d97e02cb028d0b8$var$O.hasOwnProperty.call(proto, $7d97e02cb028d0b8$var$CONSTRUCTOR) && proto[$7d97e02cb028d0b8$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$7d97e02cb028d0b8$var$isFunction(Ctor)) return false;
    let ctorString = $7d97e02cb028d0b8$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $7d97e02cb028d0b8$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $7d97e02cb028d0b8$var$objectCtorString;
}
function $7d97e02cb028d0b8$export$22e8af3f75a010e3(value) {
    if (!$7d97e02cb028d0b8$export$541ac630993a4c84(value)) $7d97e02cb028d0b8$var$die(15, value);
    return value[$7d97e02cb028d0b8$var$DRAFT_STATE].base_;
}
function $7d97e02cb028d0b8$var$each(obj, iter, strict = true) {
    if ($7d97e02cb028d0b8$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $7d97e02cb028d0b8$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $7d97e02cb028d0b8$var$getArchtype(thing) {
    const state = thing[$7d97e02cb028d0b8$var$DRAFT_STATE];
    return state ? state.type_ : $7d97e02cb028d0b8$var$isArray(thing) ? 1 /* Array */  : $7d97e02cb028d0b8$var$isMap(thing) ? 2 /* Map */  : $7d97e02cb028d0b8$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $7d97e02cb028d0b8$var$has = (thing, prop, type = $7d97e02cb028d0b8$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $7d97e02cb028d0b8$var$O[$7d97e02cb028d0b8$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $7d97e02cb028d0b8$var$get = (thing, prop, type = $7d97e02cb028d0b8$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $7d97e02cb028d0b8$var$set = (thing, propOrOldValue, value, type = $7d97e02cb028d0b8$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $7d97e02cb028d0b8$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $7d97e02cb028d0b8$var$isArray = Array.isArray;
var $7d97e02cb028d0b8$var$isMap = (target)=>target instanceof Map;
var $7d97e02cb028d0b8$var$isSet = (target)=>target instanceof Set;
var $7d97e02cb028d0b8$var$isObjectish = (target)=>typeof target === "object";
var $7d97e02cb028d0b8$var$isFunction = (target)=>typeof target === "function";
var $7d97e02cb028d0b8$var$isBoolean = (target)=>typeof target === "boolean";
var $7d97e02cb028d0b8$var$getProxyDraft = (value)=>{
    if (!$7d97e02cb028d0b8$var$isObjectish(value)) return null;
    return value == null ? void 0 : value[$7d97e02cb028d0b8$var$DRAFT_STATE];
};
var $7d97e02cb028d0b8$var$latest = (state)=>state.copy_ || state.base_;
var $7d97e02cb028d0b8$var$getValue = (value)=>{
    var _a;
    const proxyDraft = $7d97e02cb028d0b8$var$getProxyDraft(value);
    return proxyDraft ? (_a = proxyDraft.copy_) != null ? _a : proxyDraft.base_ : value;
};
var $7d97e02cb028d0b8$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $7d97e02cb028d0b8$var$shallowCopy(base, strict) {
    if ($7d97e02cb028d0b8$var$isMap(base)) return new Map(base);
    if ($7d97e02cb028d0b8$var$isSet(base)) return new Set(base);
    if ($7d97e02cb028d0b8$var$isArray(base)) return Array[$7d97e02cb028d0b8$var$PROTOTYPE].slice.call(base);
    const isPlain = $7d97e02cb028d0b8$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $7d97e02cb028d0b8$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$7d97e02cb028d0b8$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$7d97e02cb028d0b8$var$WRITABLE] === false) {
                desc[$7d97e02cb028d0b8$var$WRITABLE] = true;
                desc[$7d97e02cb028d0b8$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$7d97e02cb028d0b8$var$CONFIGURABLE]: true,
                [$7d97e02cb028d0b8$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$7d97e02cb028d0b8$var$ENUMERABLE]: desc[$7d97e02cb028d0b8$var$ENUMERABLE],
                [$7d97e02cb028d0b8$var$VALUE]: base[key]
            };
        }
        return $7d97e02cb028d0b8$var$O.create($7d97e02cb028d0b8$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $7d97e02cb028d0b8$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $7d97e02cb028d0b8$var$__spreadValues({}, base);
        const obj = $7d97e02cb028d0b8$var$O.create(proto);
        return $7d97e02cb028d0b8$var$O.assign(obj, base);
    }
}
function $7d97e02cb028d0b8$export$792f3d81ea979f55(obj, deep = false) {
    if ($7d97e02cb028d0b8$var$isFrozen(obj) || $7d97e02cb028d0b8$export$541ac630993a4c84(obj)) return obj;
    if ($7d97e02cb028d0b8$var$getArchtype(obj) > 1) $7d97e02cb028d0b8$var$O.defineProperties(obj, {
        set: $7d97e02cb028d0b8$var$dontMutateMethodOverride,
        add: $7d97e02cb028d0b8$var$dontMutateMethodOverride,
        clear: $7d97e02cb028d0b8$var$dontMutateMethodOverride,
        delete: $7d97e02cb028d0b8$var$dontMutateMethodOverride
    });
    $7d97e02cb028d0b8$var$O.freeze(obj);
    if (deep) $7d97e02cb028d0b8$var$each(obj, (_key, value)=>{
        $7d97e02cb028d0b8$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $7d97e02cb028d0b8$var$dontMutateFrozenCollections() {
    $7d97e02cb028d0b8$var$die(2);
}
var $7d97e02cb028d0b8$var$dontMutateMethodOverride = {
    [$7d97e02cb028d0b8$var$VALUE]: $7d97e02cb028d0b8$var$dontMutateFrozenCollections
};
function $7d97e02cb028d0b8$var$isFrozen(obj) {
    if (obj === null || !$7d97e02cb028d0b8$var$isObjectish(obj)) return true;
    return $7d97e02cb028d0b8$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $7d97e02cb028d0b8$var$PluginMapSet = "MapSet";
var $7d97e02cb028d0b8$var$PluginPatches = "Patches";
var $7d97e02cb028d0b8$var$plugins = {};
function $7d97e02cb028d0b8$var$getPlugin(pluginKey) {
    const plugin = $7d97e02cb028d0b8$var$plugins[pluginKey];
    if (!plugin) $7d97e02cb028d0b8$var$die(0, pluginKey);
    return plugin;
}
var $7d97e02cb028d0b8$var$isPluginLoaded = (pluginKey)=>!!$7d97e02cb028d0b8$var$plugins[pluginKey];
function $7d97e02cb028d0b8$var$loadPlugin(pluginKey, implementation) {
    if (!$7d97e02cb028d0b8$var$plugins[pluginKey]) $7d97e02cb028d0b8$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $7d97e02cb028d0b8$var$currentScope;
var $7d97e02cb028d0b8$var$getCurrentScope = ()=>$7d97e02cb028d0b8$var$currentScope;
var $7d97e02cb028d0b8$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $7d97e02cb028d0b8$var$isPluginLoaded($7d97e02cb028d0b8$var$PluginMapSet) ? $7d97e02cb028d0b8$var$getPlugin($7d97e02cb028d0b8$var$PluginMapSet) : void 0
    });
function $7d97e02cb028d0b8$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $7d97e02cb028d0b8$var$getPlugin($7d97e02cb028d0b8$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $7d97e02cb028d0b8$var$revokeScope(scope) {
    $7d97e02cb028d0b8$var$leaveScope(scope);
    scope.drafts_.forEach($7d97e02cb028d0b8$var$revokeDraft);
    scope.drafts_ = null;
}
function $7d97e02cb028d0b8$var$leaveScope(scope) {
    if (scope === $7d97e02cb028d0b8$var$currentScope) $7d97e02cb028d0b8$var$currentScope = scope.parent_;
}
var $7d97e02cb028d0b8$var$enterScope = (immer2)=>$7d97e02cb028d0b8$var$currentScope = $7d97e02cb028d0b8$var$createScope($7d97e02cb028d0b8$var$currentScope, immer2);
function $7d97e02cb028d0b8$var$revokeDraft(draft) {
    const state = draft[$7d97e02cb028d0b8$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $7d97e02cb028d0b8$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$7d97e02cb028d0b8$var$DRAFT_STATE].modified_) {
            $7d97e02cb028d0b8$var$revokeScope(scope);
            $7d97e02cb028d0b8$var$die(4);
        }
        if ($7d97e02cb028d0b8$export$16e3aed3edb85946(result)) result = $7d97e02cb028d0b8$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$7d97e02cb028d0b8$var$DRAFT_STATE].base_, result, scope);
    } else result = $7d97e02cb028d0b8$var$finalize(scope, baseDraft);
    $7d97e02cb028d0b8$var$maybeFreeze(scope, result, true);
    $7d97e02cb028d0b8$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $7d97e02cb028d0b8$export$45b790e32b2810ee ? result : void 0;
}
function $7d97e02cb028d0b8$var$finalize(rootScope, value) {
    if ($7d97e02cb028d0b8$var$isFrozen(value)) return value;
    const state = value[$7d97e02cb028d0b8$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $7d97e02cb028d0b8$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$7d97e02cb028d0b8$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $7d97e02cb028d0b8$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $7d97e02cb028d0b8$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $7d97e02cb028d0b8$export$792f3d81ea979f55(value, deep);
}
function $7d97e02cb028d0b8$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $7d97e02cb028d0b8$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $7d97e02cb028d0b8$var$EMPTY_LOCATIONS_RESULT = [];
function $7d97e02cb028d0b8$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    var _a;
    const parentCopy = $7d97e02cb028d0b8$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $7d97e02cb028d0b8$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $7d97e02cb028d0b8$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $7d97e02cb028d0b8$var$each(parentCopy, (key, value)=>{
            if ($7d97e02cb028d0b8$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = (_a = parent.draftLocations_.get(draftValue)) != null ? _a : $7d97e02cb028d0b8$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$7d97e02cb028d0b8$var$set(parentCopy, location, finalizedValue, parentType);
}
function $7d97e02cb028d0b8$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        var _a, _b;
        const state = child;
        if (!state || !$7d97e02cb028d0b8$var$isSameScope(state, rootScope)) return;
        (_a = rootScope.mapSetPlugin_) == null || _a.fixSetContents(state);
        const finalizedValue = $7d97e02cb028d0b8$var$getFinalValue(state);
        $7d97e02cb028d0b8$var$updateDraftInParent(parent, (_b = state.draft_) != null ? _b : state, finalizedValue, key);
        $7d97e02cb028d0b8$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $7d97e02cb028d0b8$var$generatePatchesAndFinalize(state, rootScope) {
    var _a, _b;
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || ((_b = (_a = state.assigned_) == null ? void 0 : _a.size) != null ? _b : 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $7d97e02cb028d0b8$var$markStateFinalized(state);
    }
}
function $7d97e02cb028d0b8$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($7d97e02cb028d0b8$export$541ac630993a4c84(value)) {
        const state = value[$7d97e02cb028d0b8$var$DRAFT_STATE];
        if ($7d97e02cb028d0b8$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $7d97e02cb028d0b8$var$prepareCopy(target);
            const finalizedValue = $7d97e02cb028d0b8$var$getFinalValue(state);
            $7d97e02cb028d0b8$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($7d97e02cb028d0b8$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        var _a;
        const targetCopy = $7d97e02cb028d0b8$var$latest(target);
        if ($7d97e02cb028d0b8$var$get(targetCopy, key, target.type_) === value) {
            if (scope_.drafts_.length > 1 && ((_a = target.assigned_.get(key)) != null ? _a : false) === true && target.copy_) $7d97e02cb028d0b8$var$handleValue($7d97e02cb028d0b8$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
        }
    });
}
function $7d97e02cb028d0b8$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($7d97e02cb028d0b8$export$541ac630993a4c84(target) || handledSet.has(target) || !$7d97e02cb028d0b8$export$16e3aed3edb85946(target) || $7d97e02cb028d0b8$var$isFrozen(target)) return target;
    handledSet.add(target);
    $7d97e02cb028d0b8$var$each(target, (key, value)=>{
        if ($7d97e02cb028d0b8$export$541ac630993a4c84(value)) {
            const state = value[$7d97e02cb028d0b8$var$DRAFT_STATE];
            if ($7d97e02cb028d0b8$var$isSameScope(state, rootScope)) {
                const updatedValue = $7d97e02cb028d0b8$var$getFinalValue(state);
                $7d97e02cb028d0b8$var$set(target, key, updatedValue, target.type_);
                $7d97e02cb028d0b8$var$markStateFinalized(state);
            }
        } else if ($7d97e02cb028d0b8$export$16e3aed3edb85946(value)) $7d97e02cb028d0b8$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $7d97e02cb028d0b8$var$createProxyProxy(base, parent) {
    const baseIsArray = $7d97e02cb028d0b8$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $7d97e02cb028d0b8$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $7d97e02cb028d0b8$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $7d97e02cb028d0b8$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $7d97e02cb028d0b8$var$objectTraps = {
    get (state, prop) {
        if (prop === $7d97e02cb028d0b8$var$DRAFT_STATE) return state;
        const source = $7d97e02cb028d0b8$var$latest(state);
        if (!$7d97e02cb028d0b8$var$has(source, prop, state.type_)) return $7d97e02cb028d0b8$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$7d97e02cb028d0b8$export$16e3aed3edb85946(value)) return value;
        if (value === $7d97e02cb028d0b8$var$peek(state.base_, prop)) {
            $7d97e02cb028d0b8$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $7d97e02cb028d0b8$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $7d97e02cb028d0b8$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($7d97e02cb028d0b8$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $7d97e02cb028d0b8$var$getDescriptorFromProto($7d97e02cb028d0b8$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $7d97e02cb028d0b8$var$peek($7d97e02cb028d0b8$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$7d97e02cb028d0b8$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.set(prop, false);
                return true;
            }
            if ($7d97e02cb028d0b8$var$is(value, current2) && (value !== void 0 || $7d97e02cb028d0b8$var$has(state.base_, prop, state.type_))) return true;
            $7d97e02cb028d0b8$var$prepareCopy(state);
            $7d97e02cb028d0b8$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $7d97e02cb028d0b8$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $7d97e02cb028d0b8$var$prepareCopy(state);
        if ($7d97e02cb028d0b8$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $7d97e02cb028d0b8$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $7d97e02cb028d0b8$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$7d97e02cb028d0b8$var$WRITABLE]: true,
            [$7d97e02cb028d0b8$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$7d97e02cb028d0b8$var$ENUMERABLE]: desc[$7d97e02cb028d0b8$var$ENUMERABLE],
            [$7d97e02cb028d0b8$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $7d97e02cb028d0b8$var$die(11);
    },
    getPrototypeOf (state) {
        return $7d97e02cb028d0b8$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $7d97e02cb028d0b8$var$die(12);
    }
};
var $7d97e02cb028d0b8$var$arrayTraps = {};
$7d97e02cb028d0b8$var$each($7d97e02cb028d0b8$var$objectTraps, (key, fn)=>{
    $7d97e02cb028d0b8$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
});
$7d97e02cb028d0b8$var$arrayTraps.deleteProperty = function(state, prop) {
    return $7d97e02cb028d0b8$var$arrayTraps.set.call(this, state, prop, void 0);
};
$7d97e02cb028d0b8$var$arrayTraps.set = function(state, prop, value) {
    return $7d97e02cb028d0b8$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $7d97e02cb028d0b8$var$peek(draft, prop) {
    const state = draft[$7d97e02cb028d0b8$var$DRAFT_STATE];
    const source = state ? $7d97e02cb028d0b8$var$latest(state) : draft;
    return source[prop];
}
function $7d97e02cb028d0b8$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $7d97e02cb028d0b8$var$getDescriptorFromProto(source, prop);
    return desc ? $7d97e02cb028d0b8$var$VALUE in desc ? desc[$7d97e02cb028d0b8$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $7d97e02cb028d0b8$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $7d97e02cb028d0b8$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $7d97e02cb028d0b8$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $7d97e02cb028d0b8$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $7d97e02cb028d0b8$var$markChanged(state.parent_);
    }
}
function $7d97e02cb028d0b8$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $7d97e02cb028d0b8$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $7d97e02cb028d0b8$export$aaadc6ff0f822719 = class {
    createDraft(base) {
        if (!$7d97e02cb028d0b8$export$16e3aed3edb85946(base)) $7d97e02cb028d0b8$var$die(8);
        if ($7d97e02cb028d0b8$export$541ac630993a4c84(base)) base = $7d97e02cb028d0b8$export$97aac956da55dae9(base);
        const scope = $7d97e02cb028d0b8$var$enterScope(this);
        const proxy = $7d97e02cb028d0b8$var$createProxy(scope, base, void 0);
        proxy[$7d97e02cb028d0b8$var$DRAFT_STATE].isManual_ = true;
        $7d97e02cb028d0b8$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$7d97e02cb028d0b8$var$DRAFT_STATE];
        if (!state || !state.isManual_) $7d97e02cb028d0b8$var$die(9);
        const { scope_: scope } = state;
        $7d97e02cb028d0b8$var$usePatchesInScope(scope, patchListener);
        return $7d97e02cb028d0b8$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $7d97e02cb028d0b8$var$getPlugin($7d97e02cb028d0b8$var$PluginPatches).applyPatches_;
        if ($7d97e02cb028d0b8$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($7d97e02cb028d0b8$var$isFunction(base) && !$7d97e02cb028d0b8$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$7d97e02cb028d0b8$var$isFunction(recipe)) $7d97e02cb028d0b8$var$die(6);
            if (patchListener !== void 0 && !$7d97e02cb028d0b8$var$isFunction(patchListener)) $7d97e02cb028d0b8$var$die(7);
            let result;
            if ($7d97e02cb028d0b8$export$16e3aed3edb85946(base)) {
                const scope = $7d97e02cb028d0b8$var$enterScope(this);
                const proxy = $7d97e02cb028d0b8$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $7d97e02cb028d0b8$var$revokeScope(scope);
                    else $7d97e02cb028d0b8$var$leaveScope(scope);
                }
                $7d97e02cb028d0b8$var$usePatchesInScope(scope, patchListener);
                return $7d97e02cb028d0b8$var$processResult(result, scope);
            } else if (!base || !$7d97e02cb028d0b8$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $7d97e02cb028d0b8$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $7d97e02cb028d0b8$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $7d97e02cb028d0b8$var$getPlugin($7d97e02cb028d0b8$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $7d97e02cb028d0b8$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($7d97e02cb028d0b8$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($7d97e02cb028d0b8$var$isBoolean(config == null ? void 0 : config.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($7d97e02cb028d0b8$var$isBoolean(config == null ? void 0 : config.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($7d97e02cb028d0b8$var$isBoolean(config == null ? void 0 : config.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
};
function $7d97e02cb028d0b8$var$createProxy(rootScope, value, parent, key) {
    var _a, _b;
    const [draft, state] = $7d97e02cb028d0b8$var$isMap(value) ? $7d97e02cb028d0b8$var$getPlugin($7d97e02cb028d0b8$var$PluginMapSet).proxyMap_(value, parent) : $7d97e02cb028d0b8$var$isSet(value) ? $7d97e02cb028d0b8$var$getPlugin($7d97e02cb028d0b8$var$PluginMapSet).proxySet_(value, parent) : $7d97e02cb028d0b8$var$createProxyProxy(value, parent);
    const scope = (_a = parent == null ? void 0 : parent.scope_) != null ? _a : $7d97e02cb028d0b8$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = (_b = parent == null ? void 0 : parent.callbacks_) != null ? _b : [];
    state.key_ = key;
    if (parent && key !== void 0) $7d97e02cb028d0b8$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        var _a2;
        (_a2 = rootScope2.mapSetPlugin_) == null || _a2.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $7d97e02cb028d0b8$export$97aac956da55dae9(value) {
    if (!$7d97e02cb028d0b8$export$541ac630993a4c84(value)) $7d97e02cb028d0b8$var$die(10, value);
    return $7d97e02cb028d0b8$var$currentImpl(value);
}
function $7d97e02cb028d0b8$var$currentImpl(value) {
    if (!$7d97e02cb028d0b8$export$16e3aed3edb85946(value) || $7d97e02cb028d0b8$var$isFrozen(value)) return value;
    const state = value[$7d97e02cb028d0b8$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $7d97e02cb028d0b8$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $7d97e02cb028d0b8$var$shallowCopy(value, true);
    $7d97e02cb028d0b8$var$each(copy, (key, childValue)=>{
        $7d97e02cb028d0b8$var$set(copy, key, $7d97e02cb028d0b8$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $7d97e02cb028d0b8$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        var _a;
        if ("key_" in state && state.key_ !== void 0) {
            const parentCopy = (_a = state.parent_.copy_) != null ? _a : state.parent_.base_;
            const proxyDraft = $7d97e02cb028d0b8$var$getProxyDraft($7d97e02cb028d0b8$var$get(parentCopy, state.key_));
            const valueAtKey = $7d97e02cb028d0b8$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $7d97e02cb028d0b8$var$has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $7d97e02cb028d0b8$var$get(current2, key);
            if (!$7d97e02cb028d0b8$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            if ((assigned_ == null ? void 0 : assigned_.get(i.toString())) && copiedItem !== baseItem) {
                const childState = copiedItem == null ? void 0 : copiedItem[$7d97e02cb028d0b8$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $7d97e02cb028d0b8$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $7d97e02cb028d0b8$var$get(base_, key, type_);
            const value = $7d97e02cb028d0b8$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $7d97e02cb028d0b8$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $7d97e02cb028d0b8$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $7d97e02cb028d0b8$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $7d97e02cb028d0b8$var$CONSTRUCTOR)) $7d97e02cb028d0b8$var$die(errorOffset + 3);
                if ($7d97e02cb028d0b8$var$isFunction(base) && p === $7d97e02cb028d0b8$var$PROTOTYPE) $7d97e02cb028d0b8$var$die(errorOffset + 3);
                base = $7d97e02cb028d0b8$var$get(base, p);
                if (!$7d97e02cb028d0b8$var$isObjectish(base)) $7d97e02cb028d0b8$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $7d97e02cb028d0b8$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $7d97e02cb028d0b8$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $7d97e02cb028d0b8$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$7d97e02cb028d0b8$export$16e3aed3edb85946(obj)) return obj;
        if ($7d97e02cb028d0b8$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($7d97e02cb028d0b8$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($7d97e02cb028d0b8$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($7d97e02cb028d0b8$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($7d97e02cb028d0b8$var$has(obj, $7d97e02cb028d0b8$export$6ee2082928bcb0ee)) cloned[$7d97e02cb028d0b8$export$6ee2082928bcb0ee] = obj[$7d97e02cb028d0b8$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($7d97e02cb028d0b8$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $7d97e02cb028d0b8$var$loadPlugin($7d97e02cb028d0b8$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
function $7d97e02cb028d0b8$export$7d9f65390203b435() {
    class DraftMap extends Map {
        get size() {
            return $7d97e02cb028d0b8$var$latest(this[$7d97e02cb028d0b8$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $7d97e02cb028d0b8$var$latest(this[$7d97e02cb028d0b8$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$7d97e02cb028d0b8$var$latest(state).has(key) || $7d97e02cb028d0b8$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $7d97e02cb028d0b8$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $7d97e02cb028d0b8$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($7d97e02cb028d0b8$var$latest(state).size) {
                prepareMapCopy(state);
                $7d97e02cb028d0b8$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $7d97e02cb028d0b8$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            $7d97e02cb028d0b8$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $7d97e02cb028d0b8$var$latest(state).get(key);
            if (state.finalized_ || !$7d97e02cb028d0b8$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $7d97e02cb028d0b8$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $7d97e02cb028d0b8$var$latest(this[$7d97e02cb028d0b8$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($7d97e02cb028d0b8$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
        constructor(target, parent){
            super();
            this[$7d97e02cb028d0b8$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $7d97e02cb028d0b8$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$7d97e02cb028d0b8$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        get size() {
            return $7d97e02cb028d0b8$var$latest(this[$7d97e02cb028d0b8$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $7d97e02cb028d0b8$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $7d97e02cb028d0b8$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($7d97e02cb028d0b8$var$latest(state).size) {
                prepareSetCopy(state);
                $7d97e02cb028d0b8$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($7d97e02cb028d0b8$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
        constructor(target, parent){
            super();
            this[$7d97e02cb028d0b8$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $7d97e02cb028d0b8$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$7d97e02cb028d0b8$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($7d97e02cb028d0b8$export$16e3aed3edb85946(value)) {
                    const draft = $7d97e02cb028d0b8$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $7d97e02cb028d0b8$var$die(3, JSON.stringify($7d97e02cb028d0b8$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($7d97e02cb028d0b8$var$getValue(value));
            });
        }
    }
    $7d97e02cb028d0b8$var$loadPlugin($7d97e02cb028d0b8$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/immer.ts
var $7d97e02cb028d0b8$var$immer = new $7d97e02cb028d0b8$export$aaadc6ff0f822719();
var $7d97e02cb028d0b8$export$b46cabe22e78bc00 = $7d97e02cb028d0b8$var$immer.produce;
var $7d97e02cb028d0b8$export$4da66d41c9492c78 = /* @__PURE__ */ $7d97e02cb028d0b8$var$immer.produceWithPatches.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$573f26f60825c493 = /* @__PURE__ */ $7d97e02cb028d0b8$var$immer.setAutoFreeze.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$333ce65961cbe047 = /* @__PURE__ */ $7d97e02cb028d0b8$var$immer.setUseStrictShallowCopy.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$1045b3be3904c489 = /* @__PURE__ */ $7d97e02cb028d0b8$var$immer.setUseStrictIteration.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $7d97e02cb028d0b8$var$immer.applyPatches.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$3c3214997190395f = /* @__PURE__ */ $7d97e02cb028d0b8$var$immer.createDraft.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$c60f5e69c521b528 = /* @__PURE__ */ $7d97e02cb028d0b8$var$immer.finishDraft.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$c05b21e3257751e5 = (value)=>value;
var $7d97e02cb028d0b8$export$20f911b3f8cf0b74 = (value)=>value;


var $8098b29b64296697$var$__defProp = Object.defineProperty;
var $8098b29b64296697$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $8098b29b64296697$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8098b29b64296697$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $8098b29b64296697$var$__defNormalProp = (obj, key, value)=>key in obj ? $8098b29b64296697$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8098b29b64296697$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($8098b29b64296697$var$__hasOwnProp.call(b, prop)) $8098b29b64296697$var$__defNormalProp(a, prop, b[prop]);
    if ($8098b29b64296697$var$__getOwnPropSymbols) {
        for (var prop of $8098b29b64296697$var$__getOwnPropSymbols(b))if ($8098b29b64296697$var$__propIsEnum.call(b, prop)) $8098b29b64296697$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $8098b29b64296697$var$__publicField = (obj, key, value)=>{
    $8098b29b64296697$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $8098b29b64296697$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $8098b29b64296697$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $8098b29b64296697$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $8098b29b64296697$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($8098b29b64296697$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $8098b29b64296697$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $8098b29b64296697$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $8098b29b64296697$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $8098b29b64296697$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $8098b29b64296697$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $8098b29b64296697$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $8098b29b64296697$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $8098b29b64296697$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $8098b29b64296697$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $8098b29b64296697$var$__spreadValues($8098b29b64296697$var$__spreadValues({}, $8098b29b64296697$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $8098b29b64296697$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $8098b29b64296697$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $8098b29b64296697$var$$REVISION = 0;
var $8098b29b64296697$var$CURRENT_TRACKER = null;
var $8098b29b64296697$var$Cell = class {
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $8098b29b64296697$var$CURRENT_TRACKER == null || $8098b29b64296697$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$8098b29b64296697$var$$REVISION;
    }
    constructor(initialValue, isEqual = $8098b29b64296697$var$tripleEq){
        $8098b29b64296697$var$__publicField(this, "revision", $8098b29b64296697$var$$REVISION);
        $8098b29b64296697$var$__publicField(this, "_value");
        $8098b29b64296697$var$__publicField(this, "_lastValue");
        $8098b29b64296697$var$__publicField(this, "_isEqual", $8098b29b64296697$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
};
function $8098b29b64296697$var$tripleEq(a, b) {
    return a === b;
}
var $8098b29b64296697$var$TrackingCache = class {
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $8098b29b64296697$var$CURRENT_TRACKER;
            $8098b29b64296697$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $8098b29b64296697$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $8098b29b64296697$var$CURRENT_TRACKER == null || $8098b29b64296697$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
    constructor(fn){
        $8098b29b64296697$var$__publicField(this, "_cachedValue");
        $8098b29b64296697$var$__publicField(this, "_cachedRevision", -1);
        $8098b29b64296697$var$__publicField(this, "_deps", []);
        $8098b29b64296697$var$__publicField(this, "hits", 0);
        $8098b29b64296697$var$__publicField(this, "fn");
        this.fn = fn;
    }
};
function $8098b29b64296697$var$getValue(cell) {
    if (!(cell instanceof $8098b29b64296697$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $8098b29b64296697$var$setValue(storage, value) {
    if (!(storage instanceof $8098b29b64296697$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $8098b29b64296697$var$createCell(initialValue, isEqual = $8098b29b64296697$var$tripleEq) {
    return new $8098b29b64296697$var$Cell(initialValue, isEqual);
}
function $8098b29b64296697$var$createCache(fn) {
    $8098b29b64296697$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $8098b29b64296697$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $8098b29b64296697$var$neverEq = (a, b)=>false;
function $8098b29b64296697$var$createTag() {
    return $8098b29b64296697$var$createCell(null, $8098b29b64296697$var$neverEq);
}
function $8098b29b64296697$var$dirtyTag(tag, value) {
    $8098b29b64296697$var$setValue(tag, value);
}
var $8098b29b64296697$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $8098b29b64296697$var$createTag();
    $8098b29b64296697$var$getValue(tag);
};
var $8098b29b64296697$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $8098b29b64296697$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $8098b29b64296697$var$REDUX_PROXY_LABEL = Symbol();
var $8098b29b64296697$var$nextId = 0;
var $8098b29b64296697$var$proto = Object.getPrototypeOf({});
var $8098b29b64296697$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $8098b29b64296697$var$__publicField(this, "proxy", new Proxy(this, $8098b29b64296697$var$objectProxyHandler));
        $8098b29b64296697$var$__publicField(this, "tag", $8098b29b64296697$var$createTag());
        $8098b29b64296697$var$__publicField(this, "tags", {});
        $8098b29b64296697$var$__publicField(this, "children", {});
        $8098b29b64296697$var$__publicField(this, "collectionTag", null);
        $8098b29b64296697$var$__publicField(this, "id", $8098b29b64296697$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $8098b29b64296697$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $8098b29b64296697$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $8098b29b64296697$var$createNode(childValue);
                if (childNode.tag) $8098b29b64296697$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $8098b29b64296697$var$createTag();
                    tag.value = childValue;
                }
                $8098b29b64296697$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $8098b29b64296697$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $8098b29b64296697$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $8098b29b64296697$var$__publicField(this, "proxy", new Proxy([
            this
        ], $8098b29b64296697$var$arrayProxyHandler));
        $8098b29b64296697$var$__publicField(this, "tag", $8098b29b64296697$var$createTag());
        $8098b29b64296697$var$__publicField(this, "tags", {});
        $8098b29b64296697$var$__publicField(this, "children", {});
        $8098b29b64296697$var$__publicField(this, "collectionTag", null);
        $8098b29b64296697$var$__publicField(this, "id", $8098b29b64296697$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $8098b29b64296697$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $8098b29b64296697$var$consumeCollection(node);
        return $8098b29b64296697$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $8098b29b64296697$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $8098b29b64296697$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $8098b29b64296697$var$objectProxyHandler.has(node, prop);
    }
};
function $8098b29b64296697$var$createNode(value) {
    if (Array.isArray(value)) return new $8098b29b64296697$var$ArrayTreeNode(value);
    return new $8098b29b64296697$var$ObjectTreeNode(value);
}
function $8098b29b64296697$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $8098b29b64296697$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $8098b29b64296697$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $8098b29b64296697$var$dirtyCollection(node);
            $8098b29b64296697$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $8098b29b64296697$var$updateNode(childNode, newChildValue);
        else {
            $8098b29b64296697$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $8098b29b64296697$var$deleteNode(node) {
    if (node.tag) $8098b29b64296697$var$dirtyTag(node.tag, null);
    $8098b29b64296697$var$dirtyCollection(node);
    for(const key in node.tags)$8098b29b64296697$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$8098b29b64296697$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $8098b29b64296697$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $8098b29b64296697$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $8098b29b64296697$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $8098b29b64296697$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $8098b29b64296697$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $8098b29b64296697$export$3f025202a230c6dd = (a, b)=>a === b;
function $8098b29b64296697$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $8098b29b64296697$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $8098b29b64296697$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $8098b29b64296697$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $8098b29b64296697$var$createSingletonCache(comparator) : $8098b29b64296697$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $8098b29b64296697$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $8098b29b64296697$export$c8f9cf88d9fdee55(func) {
    const node = $8098b29b64296697$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $8098b29b64296697$var$createCacheKeyComparator($8098b29b64296697$export$3f025202a230c6dd);
    const cache = $8098b29b64296697$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $8098b29b64296697$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $8098b29b64296697$var$StrongRef = class {
    deref() {
        return this.value;
    }
    constructor(value){
        this.value = value;
    }
};
var $8098b29b64296697$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $8098b29b64296697$var$StrongRef;
var $8098b29b64296697$var$UNTERMINATED = 0;
var $8098b29b64296697$var$TERMINATED = 1;
function $8098b29b64296697$var$createCacheNode() {
    return {
        s: $8098b29b64296697$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $8098b29b64296697$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $8098b29b64296697$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $8098b29b64296697$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $8098b29b64296697$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $8098b29b64296697$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $8098b29b64296697$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $8098b29b64296697$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $8098b29b64296697$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $8098b29b64296697$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $8098b29b64296697$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $8098b29b64296697$var$__spreadValues($8098b29b64296697$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $8098b29b64296697$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $8098b29b64296697$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $8098b29b64296697$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $8098b29b64296697$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $8098b29b64296697$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $8098b29b64296697$export$595d22ed68ca2841 = /* @__PURE__ */ $8098b29b64296697$export$5943f4447f6ef248($8098b29b64296697$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $8098b29b64296697$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $8098b29b64296697$export$595d22ed68ca2841)=>{
    $8098b29b64296697$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$8098b29b64296697$export$75979cfcd91bf38f
});


// src/index.ts
function $a08349f8b4900e5d$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $a08349f8b4900e5d$export$dd164f5517779f15 = $a08349f8b4900e5d$var$createThunkMiddleware();
var $a08349f8b4900e5d$export$16d06542a1949d9e = $a08349f8b4900e5d$var$createThunkMiddleware;


var $15d924278321bdfd$var$__defProp = Object.defineProperty;
var $15d924278321bdfd$var$__defProps = Object.defineProperties;
var $15d924278321bdfd$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $15d924278321bdfd$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $15d924278321bdfd$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $15d924278321bdfd$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $15d924278321bdfd$var$__defNormalProp = (obj, key, value)=>key in obj ? $15d924278321bdfd$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $15d924278321bdfd$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($15d924278321bdfd$var$__hasOwnProp.call(b, prop)) $15d924278321bdfd$var$__defNormalProp(a, prop, b[prop]);
    if ($15d924278321bdfd$var$__getOwnPropSymbols) {
        for (var prop of $15d924278321bdfd$var$__getOwnPropSymbols(b))if ($15d924278321bdfd$var$__propIsEnum.call(b, prop)) $15d924278321bdfd$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $15d924278321bdfd$var$__spreadProps = (a, b)=>$15d924278321bdfd$var$__defProps(a, $15d924278321bdfd$var$__getOwnPropDescs(b));
var $15d924278321bdfd$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($15d924278321bdfd$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $15d924278321bdfd$var$__getOwnPropSymbols) {
        for (var prop of $15d924278321bdfd$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $15d924278321bdfd$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $15d924278321bdfd$var$__publicField = (obj, key, value)=>$15d924278321bdfd$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/createDraftSafeSelector.ts
var $15d924278321bdfd$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $8098b29b64296697$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $7d97e02cb028d0b8$export$541ac630993a4c84)(value) ? (0, $7d97e02cb028d0b8$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $15d924278321bdfd$export$a5d3c27355e35910 = /* @__PURE__ */ $15d924278321bdfd$export$aab6de9e3dbb1473((0, $8098b29b64296697$export$8402dc26d96f6902));
// src/devtoolsExtension.ts
var $15d924278321bdfd$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $78916fc80cd27125$export$f672e0b6f7222cd7;
    return (0, $78916fc80cd27125$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $15d924278321bdfd$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $15d924278321bdfd$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $15d924278321bdfd$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($15d924278321bdfd$export$378fa86b259c0280(0));
            return $15d924278321bdfd$var$__spreadValues($15d924278321bdfd$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $78916fc80cd27125$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $15d924278321bdfd$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $15d924278321bdfd$var$hasMatchFunction(action);
}
function $15d924278321bdfd$export$ebd532f9034651f3(action) {
    return (0, $78916fc80cd27125$export$b956e38827fca970)(action) && Object.keys(action).every($15d924278321bdfd$var$isValidKey);
}
function $15d924278321bdfd$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $15d924278321bdfd$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched.
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $15d924278321bdfd$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/utils.ts
function $15d924278321bdfd$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $15d924278321bdfd$export$1908877435b1d5e9 = class _Tuple extends Array {
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
};
function $15d924278321bdfd$var$freezeDraftable(val) {
    return (0, $7d97e02cb028d0b8$export$16e3aed3edb85946)(val) ? (0, $7d97e02cb028d0b8$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $15d924278321bdfd$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $15d924278321bdfd$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $15d924278321bdfd$var$trackForMutations(isImmutable, ignoredPaths, obj) {
    const trackedProperties = $15d924278321bdfd$var$trackProperties(isImmutable, ignoredPaths, obj);
    return {
        detectMutations () {
            return $15d924278321bdfd$var$detectMutations(isImmutable, ignoredPaths, trackedProperties, obj);
        }
    };
}
function $15d924278321bdfd$var$trackProperties(isImmutable, ignoredPaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        const hasIgnoredPaths = ignoredPaths.length > 0;
        for(const key in obj){
            const nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                const hasMatches = ignoredPaths.some((ignored)=>{
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) continue;
            }
            tracked.children[key] = $15d924278321bdfd$var$trackProperties(isImmutable, ignoredPaths, obj[key], nestedPath);
        }
    }
    return tracked;
}
function $15d924278321bdfd$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $15d924278321bdfd$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $15d924278321bdfd$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/serializableStateInvariantMiddleware.ts
function $15d924278321bdfd$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $78916fc80cd27125$export$53b83ca8eaab0383)(val);
}
function $15d924278321bdfd$export$ada5dca0b571bc7(value, path = "", isSerializable = $15d924278321bdfd$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $15d924278321bdfd$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $15d924278321bdfd$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $15d924278321bdfd$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$15d924278321bdfd$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $15d924278321bdfd$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $15d924278321bdfd$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $15d924278321bdfd$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $15d924278321bdfd$export$1908877435b1d5e9();
        if (thunk) {
            if ($15d924278321bdfd$var$isBoolean(thunk)) middlewareArray.push((0, $a08349f8b4900e5d$export$dd164f5517779f15));
            else middlewareArray.push((0, $a08349f8b4900e5d$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $15d924278321bdfd$export$8fb31c0f05df007b = "RTK_autoBatch";
var $15d924278321bdfd$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$15d924278321bdfd$export$8fb31c0f05df007b]: true
            }
        });
var $15d924278321bdfd$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $15d924278321bdfd$var$createRafWithFallbackTimer = (raf, timeout)=>{
    return (notify)=>{
        let called = false;
        const callback = ()=>{
            if (called) return;
            called = true;
            cancelAnimationFrame(rafId);
            clearTimeout(timerId);
            notify();
        };
        const rafId = raf(callback);
        const timerId = setTimeout(callback, timeout);
    };
};
var $15d924278321bdfd$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? $15d924278321bdfd$var$createRafWithFallbackTimer(window.requestAnimationFrame, 100) : $15d924278321bdfd$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $15d924278321bdfd$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$15d924278321bdfd$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $15d924278321bdfd$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $15d924278321bdfd$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($15d924278321bdfd$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $15d924278321bdfd$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $15d924278321bdfd$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, duplicateMiddlewareCheck: duplicateMiddlewareCheck = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $78916fc80cd27125$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $78916fc80cd27125$export$66e4520cdb265d18)(reducer);
    else throw new Error($15d924278321bdfd$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware2;
    let finalCompose = (0, $78916fc80cd27125$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $15d924278321bdfd$var$composeWithDevTools($15d924278321bdfd$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $78916fc80cd27125$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $15d924278321bdfd$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $78916fc80cd27125$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $15d924278321bdfd$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($15d924278321bdfd$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($15d924278321bdfd$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addAsyncThunk (asyncThunk, reducers) {
            if (reducers.pending) actionsMap[asyncThunk.pending.type] = reducers.pending;
            if (reducers.rejected) actionsMap[asyncThunk.rejected.type] = reducers.rejected;
            if (reducers.fulfilled) actionsMap[asyncThunk.fulfilled.type] = reducers.fulfilled;
            if (reducers.settled) actionMatchers.push({
                matcher: asyncThunk.settled,
                reducer: reducers.settled
            });
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $15d924278321bdfd$var$isStateFunction(x) {
    return typeof x === "function";
}
function $15d924278321bdfd$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $15d924278321bdfd$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($15d924278321bdfd$var$isStateFunction(initialState)) getInitialState = ()=>$15d924278321bdfd$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $15d924278321bdfd$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $7d97e02cb028d0b8$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $7d97e02cb028d0b8$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $7d97e02cb028d0b8$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $15d924278321bdfd$var$matches = (matcher, action)=>{
    if ($15d924278321bdfd$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $15d924278321bdfd$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$15d924278321bdfd$var$matches(matcher, action));
    };
}
function $15d924278321bdfd$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$15d924278321bdfd$var$matches(matcher, action));
    };
}
function $15d924278321bdfd$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $15d924278321bdfd$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $15d924278321bdfd$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$15d924278321bdfd$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$15d924278321bdfd$var$isAsyncThunkArray(asyncThunks)) return $15d924278321bdfd$export$872dec21e9a69476()(asyncThunks[0]);
    return $15d924278321bdfd$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $15d924278321bdfd$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$15d924278321bdfd$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$15d924278321bdfd$var$isAsyncThunkArray(asyncThunks)) return $15d924278321bdfd$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $15d924278321bdfd$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $15d924278321bdfd$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $15d924278321bdfd$export$9dd1fb32974da385($15d924278321bdfd$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$15d924278321bdfd$var$isAsyncThunkArray(asyncThunks)) return $15d924278321bdfd$export$fcc3388fb56de601()(asyncThunks[0]);
    return $15d924278321bdfd$export$9dd1fb32974da385($15d924278321bdfd$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $15d924278321bdfd$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$15d924278321bdfd$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$15d924278321bdfd$var$isAsyncThunkArray(asyncThunks)) return $15d924278321bdfd$export$1da80a6ef1307441()(asyncThunks[0]);
    return $15d924278321bdfd$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $15d924278321bdfd$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$15d924278321bdfd$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$15d924278321bdfd$var$isAsyncThunkArray(asyncThunks)) return $15d924278321bdfd$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $15d924278321bdfd$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $15d924278321bdfd$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $15d924278321bdfd$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $15d924278321bdfd$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $15d924278321bdfd$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $15d924278321bdfd$var$RejectWithValue = class {
    constructor(payload, meta){
        $15d924278321bdfd$var$__publicField(this, "payload", payload);
        $15d924278321bdfd$var$__publicField(this, "meta", meta);
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $15d924278321bdfd$var$__publicField(this, "_type");
    }
};
var $15d924278321bdfd$var$FulfillWithMeta = class {
    constructor(payload, meta){
        $15d924278321bdfd$var$__publicField(this, "payload", payload);
        $15d924278321bdfd$var$__publicField(this, "meta", meta);
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $15d924278321bdfd$var$__publicField(this, "_type");
    }
};
var $15d924278321bdfd$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $15d924278321bdfd$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $15d924278321bdfd$var$externalAbortMessage = "External signal was aborted";
var $15d924278321bdfd$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $15d924278321bdfd$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $15d924278321bdfd$var$__spreadProps($15d924278321bdfd$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $15d924278321bdfd$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $15d924278321bdfd$var$__spreadProps($15d924278321bdfd$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $15d924278321bdfd$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $15d924278321bdfd$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $15d924278321bdfd$var$__spreadProps($15d924278321bdfd$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg, { signal: signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $15d924278321bdfd$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort($15d924278321bdfd$var$externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort($15d924278321bdfd$var$externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($15d924278321bdfd$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler, {
                                once: true
                            });
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $15d924278321bdfd$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $15d924278321bdfd$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $15d924278321bdfd$var$RejectWithValue) throw result;
                                if (result instanceof $15d924278321bdfd$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $15d924278321bdfd$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($15d924278321bdfd$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $15d924278321bdfd$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $15d924278321bdfd$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $15d924278321bdfd$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $15d924278321bdfd$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $15d924278321bdfd$export$343355ed40c51c46 = {
    [$15d924278321bdfd$var$asyncThunkSymbol]: $15d924278321bdfd$export$6abd22dc03e5063f
};
var $15d924278321bdfd$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($15d924278321bdfd$export$23a094319a4b586 || {});
function $15d924278321bdfd$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $15d924278321bdfd$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$15d924278321bdfd$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($15d924278321bdfd$export$378fa86b259c0280(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers($15d924278321bdfd$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($15d924278321bdfd$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($15d924278321bdfd$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $15d924278321bdfd$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($15d924278321bdfd$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $15d924278321bdfd$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $15d924278321bdfd$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $15d924278321bdfd$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $15d924278321bdfd$var$__spreadValues($15d924278321bdfd$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $15d924278321bdfd$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = $15d924278321bdfd$var$getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $15d924278321bdfd$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return $15d924278321bdfd$var$getOrInsertComputed(selectorCache, selectState, ()=>{
                    var _a2;
                    const map = {};
                    for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $15d924278321bdfd$var$wrapSelector(selector, selectState, ()=>$15d924278321bdfd$var$getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $15d924278321bdfd$var$__spreadProps($15d924278321bdfd$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $15d924278321bdfd$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $15d924278321bdfd$var$__spreadValues($15d924278321bdfd$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $15d924278321bdfd$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $15d924278321bdfd$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $15d924278321bdfd$export$affdea4146de9cf5();
function $15d924278321bdfd$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $15d924278321bdfd$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $15d924278321bdfd$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$15d924278321bdfd$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($15d924278321bdfd$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $15d924278321bdfd$export$309c7a02b0b0bc62(type, prepareCallback) : $15d924278321bdfd$export$309c7a02b0b0bc62(type));
}
function $15d924278321bdfd$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $15d924278321bdfd$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $15d924278321bdfd$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($15d924278321bdfd$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $15d924278321bdfd$var$noop,
        pending: pending || $15d924278321bdfd$var$noop,
        rejected: rejected || $15d924278321bdfd$var$noop,
        settled: settled || $15d924278321bdfd$var$noop
    });
}
function $15d924278321bdfd$var$noop() {}
// src/entities/entity_state.ts
function $15d924278321bdfd$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $15d924278321bdfd$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($15d924278321bdfd$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $15d924278321bdfd$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $15d924278321bdfd$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
// src/entities/state_adapter.ts
var $15d924278321bdfd$var$isDraftTyped = (0, $7d97e02cb028d0b8$export$541ac630993a4c84);
function $15d924278321bdfd$var$createSingleArgumentStateOperator(mutator) {
    const operator = $15d924278321bdfd$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $15d924278321bdfd$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $15d924278321bdfd$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($15d924278321bdfd$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $7d97e02cb028d0b8$export$b46cabe22e78bc00)(state, runMutator);
    };
}
// src/entities/utils.ts
function $15d924278321bdfd$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $15d924278321bdfd$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $15d924278321bdfd$var$getCurrent(value) {
    return (0, $7d97e02cb028d0b8$export$541ac630993a4c84)(value) ? (0, $7d97e02cb028d0b8$export$97aac956da55dae9)(value) : value;
}
function $15d924278321bdfd$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $15d924278321bdfd$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $15d924278321bdfd$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = $15d924278321bdfd$var$selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $15d924278321bdfd$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $15d924278321bdfd$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $15d924278321bdfd$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $15d924278321bdfd$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $15d924278321bdfd$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $15d924278321bdfd$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $15d924278321bdfd$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $15d924278321bdfd$var$__spreadValues($15d924278321bdfd$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$15d924278321bdfd$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $15d924278321bdfd$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: $15d924278321bdfd$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $15d924278321bdfd$var$createStateOperator(addOneMutably),
        addMany: $15d924278321bdfd$var$createStateOperator(addManyMutably),
        setOne: $15d924278321bdfd$var$createStateOperator(setOneMutably),
        setMany: $15d924278321bdfd$var$createStateOperator(setManyMutably),
        setAll: $15d924278321bdfd$var$createStateOperator(setAllMutably),
        updateOne: $15d924278321bdfd$var$createStateOperator(updateOneMutably),
        updateMany: $15d924278321bdfd$var$createStateOperator(updateManyMutably),
        upsertOne: $15d924278321bdfd$var$createStateOperator(upsertOneMutably),
        upsertMany: $15d924278321bdfd$var$createStateOperator(upsertManyMutably),
        removeOne: $15d924278321bdfd$var$createStateOperator(removeOneMutably),
        removeMany: $15d924278321bdfd$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $15d924278321bdfd$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $15d924278321bdfd$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $15d924278321bdfd$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $15d924278321bdfd$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $15d924278321bdfd$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $15d924278321bdfd$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : $15d924278321bdfd$var$getCurrent(state.ids));
        const addedKeys = /* @__PURE__ */ new Set();
        const models = newEntities.filter((model)=>{
            const modelId = $15d924278321bdfd$var$selectIdValue(model, selectId);
            const notAdded = !addedKeys.has(modelId);
            if (notAdded) addedKeys.add(modelId);
            return !existingKeys.has(modelId) && notAdded;
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        let deduplicatedEntities = {};
        newEntities = $15d924278321bdfd$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities){
                const entityId = selectId(item);
                deduplicatedEntities[entityId] = item;
                delete state.entities[entityId];
            }
            newEntities = $15d924278321bdfd$var$ensureEntitiesArray(deduplicatedEntities);
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $15d924278321bdfd$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $15d924278321bdfd$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $15d924278321bdfd$var$getCurrent(state.entities);
        const currentIds = $15d924278321bdfd$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $15d924278321bdfd$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $15d924278321bdfd$var$createStateOperator(addOneMutably),
        updateOne: $15d924278321bdfd$var$createStateOperator(updateOneMutably),
        upsertOne: $15d924278321bdfd$var$createStateOperator(upsertOneMutably),
        setOne: $15d924278321bdfd$var$createStateOperator(setOneMutably),
        setMany: $15d924278321bdfd$var$createStateOperator(setManyMutably),
        setAll: $15d924278321bdfd$var$createStateOperator(setAllMutably),
        addMany: $15d924278321bdfd$var$createStateOperator(addManyMutably),
        updateMany: $15d924278321bdfd$var$createStateOperator(updateManyMutably),
        upsertMany: $15d924278321bdfd$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $15d924278321bdfd$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $15d924278321bdfd$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $15d924278321bdfd$var$createSortedStateAdapter(selectId, sortComparer) : $15d924278321bdfd$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $15d924278321bdfd$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $15d924278321bdfd$var$createSelectorsFactory();
    return $15d924278321bdfd$var$__spreadValues($15d924278321bdfd$var$__spreadValues($15d924278321bdfd$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $15d924278321bdfd$var$task = "task";
var $15d924278321bdfd$var$listener = "listener";
var $15d924278321bdfd$var$completed = "completed";
var $15d924278321bdfd$var$cancelled = "cancelled";
var $15d924278321bdfd$var$taskCancelled = `task-${$15d924278321bdfd$var$cancelled}`;
var $15d924278321bdfd$var$taskCompleted = `task-${$15d924278321bdfd$var$completed}`;
var $15d924278321bdfd$var$listenerCancelled = `${$15d924278321bdfd$var$listener}-${$15d924278321bdfd$var$cancelled}`;
var $15d924278321bdfd$var$listenerCompleted = `${$15d924278321bdfd$var$listener}-${$15d924278321bdfd$var$completed}`;
var $15d924278321bdfd$export$cb1bdac908fed7f = class {
    constructor(code){
        $15d924278321bdfd$var$__publicField(this, "code", code);
        $15d924278321bdfd$var$__publicField(this, "name", "TaskAbortError");
        $15d924278321bdfd$var$__publicField(this, "message");
        this.message = `${$15d924278321bdfd$var$task} ${$15d924278321bdfd$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $15d924278321bdfd$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($15d924278321bdfd$export$378fa86b259c0280(32));
};
var $15d924278321bdfd$var$noop2 = ()=>{};
var $15d924278321bdfd$var$catchRejection = (promise, onError = $15d924278321bdfd$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $15d924278321bdfd$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
// src/listenerMiddleware/task.ts
var $15d924278321bdfd$var$validateActive = (signal)=>{
    if (signal.aborted) throw new $15d924278321bdfd$export$cb1bdac908fed7f(signal.reason);
};
function $15d924278321bdfd$var$raceWithSignal(signal, promise) {
    let cleanup = $15d924278321bdfd$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $15d924278321bdfd$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $15d924278321bdfd$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $15d924278321bdfd$var$noop2;
    });
}
var $15d924278321bdfd$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $15d924278321bdfd$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $15d924278321bdfd$var$createPause = (signal)=>{
    return (promise)=>{
        return $15d924278321bdfd$var$catchRejection($15d924278321bdfd$var$raceWithSignal(signal, promise).then((output)=>{
            $15d924278321bdfd$var$validateActive(signal);
            return output;
        }));
    };
};
var $15d924278321bdfd$var$createDelay = (signal)=>{
    const pause = $15d924278321bdfd$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $15d924278321bdfd$var$assign } = Object;
var $15d924278321bdfd$var$INTERNAL_NIL_TOKEN = {};
var $15d924278321bdfd$var$alm = "listenerMiddleware";
var $15d924278321bdfd$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$15d924278321bdfd$var$addAbortSignalListener(parentAbortSignal, ()=>controller.abort(parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $15d924278321bdfd$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $15d924278321bdfd$var$runTask(async ()=>{
            $15d924278321bdfd$var$validateActive(parentAbortSignal);
            $15d924278321bdfd$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $15d924278321bdfd$var$createPause(childAbortController.signal),
                delay: $15d924278321bdfd$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $15d924278321bdfd$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>childAbortController.abort($15d924278321bdfd$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($15d924278321bdfd$var$noop2));
        return {
            result: $15d924278321bdfd$var$createPause(parentAbortSignal)(result),
            cancel () {
                childAbortController.abort($15d924278321bdfd$var$taskCancelled);
            }
        };
    };
};
var $15d924278321bdfd$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $15d924278321bdfd$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $15d924278321bdfd$var$raceWithSignal(signal, Promise.race(promises));
            $15d924278321bdfd$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$15d924278321bdfd$var$catchRejection(take(predicate, timeout));
};
var $15d924278321bdfd$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $15d924278321bdfd$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($15d924278321bdfd$export$378fa86b259c0280(21));
    $15d924278321bdfd$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $15d924278321bdfd$var$createListenerEntry = /* @__PURE__ */ $15d924278321bdfd$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $15d924278321bdfd$var$getListenerEntryPropsFrom(options);
    const entry = {
        id: $15d924278321bdfd$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($15d924278321bdfd$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$15d924278321bdfd$var$createListenerEntry
});
var $15d924278321bdfd$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $15d924278321bdfd$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $15d924278321bdfd$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        controller.abort($15d924278321bdfd$var$listenerCancelled);
    });
};
var $15d924278321bdfd$var$createClearListenerMiddleware = (listenerMap, executingListeners)=>{
    return ()=>{
        for (const listener2 of executingListeners.keys())$15d924278321bdfd$var$cancelActiveListeners(listener2);
        listenerMap.clear();
    };
};
var $15d924278321bdfd$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $15d924278321bdfd$export$f03a6b845d3fb58b = /* @__PURE__ */ $15d924278321bdfd$var$assign(/* @__PURE__ */ $15d924278321bdfd$export$309c7a02b0b0bc62(`${$15d924278321bdfd$var$alm}/add`), {
    withTypes: ()=>$15d924278321bdfd$export$f03a6b845d3fb58b
});
var $15d924278321bdfd$export$b1b8022855fb2b71 = /* @__PURE__ */ $15d924278321bdfd$export$309c7a02b0b0bc62(`${$15d924278321bdfd$var$alm}/removeAll`);
var $15d924278321bdfd$export$b03e9483f936dccb = /* @__PURE__ */ $15d924278321bdfd$var$assign(/* @__PURE__ */ $15d924278321bdfd$export$309c7a02b0b0bc62(`${$15d924278321bdfd$var$alm}/remove`), {
    withTypes: ()=>$15d924278321bdfd$export$b03e9483f936dccb
});
var $15d924278321bdfd$var$defaultErrorHandler = (...args)=>{
    console.error(`${$15d924278321bdfd$var$alm}/error`, ...args);
};
var $15d924278321bdfd$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const executingListeners = /* @__PURE__ */ new Map();
    const trackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 0;
        executingListeners.set(entry, count + 1);
    };
    const untrackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 1;
        if (count === 1) executingListeners.delete(entry);
        else executingListeners.set(entry, count - 1);
    };
    const { extra: extra, onError: onError = $15d924278321bdfd$var$defaultErrorHandler } = middlewareOptions;
    $15d924278321bdfd$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $15d924278321bdfd$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _a;
        const entry = (_a = $15d924278321bdfd$var$findListenerEntry(listenerMap, options)) != null ? _a : $15d924278321bdfd$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $15d924278321bdfd$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $15d924278321bdfd$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $15d924278321bdfd$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $15d924278321bdfd$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $15d924278321bdfd$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            trackExecutingListener(entry);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $15d924278321bdfd$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $15d924278321bdfd$var$createDelay(internalTaskController.signal),
                pause: $15d924278321bdfd$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $15d924278321bdfd$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            controller.abort($15d924278321bdfd$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    internalTaskController.abort($15d924278321bdfd$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $15d924278321bdfd$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $15d924278321bdfd$export$cb1bdac908fed7f)) $15d924278321bdfd$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            internalTaskController.abort($15d924278321bdfd$var$listenerCompleted);
            untrackExecutingListener(entry);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $15d924278321bdfd$var$createClearListenerMiddleware(listenerMap, executingListeners);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $78916fc80cd27125$export$b956e38827fca970)(action)) return next(action);
                if ($15d924278321bdfd$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($15d924278321bdfd$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($15d924278321bdfd$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $15d924278321bdfd$var$INTERNAL_NIL_TOKEN) throw new Error($15d924278321bdfd$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $15d924278321bdfd$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $15d924278321bdfd$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
// src/dynamicMiddleware/index.ts
var $15d924278321bdfd$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $15d924278321bdfd$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $15d924278321bdfd$export$4bb1606a79445586 = ()=>{
    const instanceId = $15d924278321bdfd$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($15d924278321bdfd$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            $15d924278321bdfd$var$getOrInsertComputed(middlewareMap, middleware2, $15d924278321bdfd$var$createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$15d924278321bdfd$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $78916fc80cd27125$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $15d924278321bdfd$export$9dd1fb32974da385(withMiddleware, $15d924278321bdfd$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $15d924278321bdfd$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $15d924278321bdfd$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$15d924278321bdfd$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $15d924278321bdfd$var$ORIGINAL_STATE = /* @__PURE__ */ Symbol.for("rtk-state-proxy-original");
var $15d924278321bdfd$var$isStateProxy = (value)=>!!value && !!value[$15d924278321bdfd$var$ORIGINAL_STATE];
var $15d924278321bdfd$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $15d924278321bdfd$var$createStateProxy = (state, reducerMap, initialStateCache)=>$15d924278321bdfd$var$getOrInsertComputed($15d924278321bdfd$var$stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $15d924278321bdfd$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $15d924278321bdfd$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($15d924278321bdfd$export$378fa86b259c0280(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var $15d924278321bdfd$var$original = (state)=>{
    if (!$15d924278321bdfd$var$isStateProxy(state)) throw new Error($15d924278321bdfd$export$378fa86b259c0280(25));
    return state[$15d924278321bdfd$var$ORIGINAL_STATE];
};
var $15d924278321bdfd$var$emptyObject = {};
var $15d924278321bdfd$var$noopReducer = (state = $15d924278321bdfd$var$emptyObject)=>state;
function $15d924278321bdfd$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($15d924278321bdfd$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $78916fc80cd27125$export$66e4520cdb265d18)(reducerMap) : $15d924278321bdfd$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($15d924278321bdfd$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original: $15d924278321bdfd$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $15d924278321bdfd$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


'use strict';
function $4c852d2f6a5a0387$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $77146a31cb578292$var$toString } = Object.prototype;
const { getPrototypeOf: $77146a31cb578292$var$getPrototypeOf } = Object;
const { iterator: $77146a31cb578292$var$iterator, toStringTag: $77146a31cb578292$var$toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const $77146a31cb578292$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Walk the prototype chain (excluding the shared Object.prototype) looking for
 * an own `prop`. This distinguishes genuine own/inherited members — including
 * class accessors and template prototypes — from members injected via
 * Object.prototype pollution (e.g. `Object.prototype.username = '...'`), which
 * live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const $77146a31cb578292$var$hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null && obj !== Object.prototype){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        if ($77146a31cb578292$var$hasOwnProperty(obj, prop)) return true;
        obj = $77146a31cb578292$var$getPrototypeOf(obj);
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const $77146a31cb578292$var$getSafeProp = (obj, prop)=>obj != null && $77146a31cb578292$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
const $77146a31cb578292$var$kindOf = ((cache)=>(thing)=>{
        const str = $77146a31cb578292$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $77146a31cb578292$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$77146a31cb578292$var$kindOf(thing) === type;
};
const $77146a31cb578292$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $77146a31cb578292$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $77146a31cb578292$var$isUndefined = $77146a31cb578292$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $77146a31cb578292$var$isBuffer(val) {
    return val !== null && !$77146a31cb578292$var$isUndefined(val) && val.constructor !== null && !$77146a31cb578292$var$isUndefined(val.constructor) && $77146a31cb578292$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $77146a31cb578292$var$isArrayBuffer = $77146a31cb578292$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $77146a31cb578292$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $77146a31cb578292$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $77146a31cb578292$var$isString = $77146a31cb578292$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $77146a31cb578292$var$isFunction = $77146a31cb578292$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $77146a31cb578292$var$isNumber = $77146a31cb578292$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $77146a31cb578292$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $77146a31cb578292$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $77146a31cb578292$var$isPlainObject = (val)=>{
    if (!$77146a31cb578292$var$isObject(val)) return false;
    const prototype = $77146a31cb578292$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $77146a31cb578292$var$getPrototypeOf(prototype) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
    // Symbol.iterator as evidence the value is a tagged/iterable type rather
    // than a plain object, while ignoring keys injected onto Object.prototype.
    !$77146a31cb578292$var$hasOwnInPrototypeChain(val, $77146a31cb578292$var$toStringTag) && !$77146a31cb578292$var$hasOwnInPrototypeChain(val, $77146a31cb578292$var$iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $77146a31cb578292$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$77146a31cb578292$var$isObject(val) || $77146a31cb578292$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $77146a31cb578292$var$isDate = $77146a31cb578292$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $77146a31cb578292$var$isFile = $77146a31cb578292$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $77146a31cb578292$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $77146a31cb578292$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $77146a31cb578292$var$isBlob = $77146a31cb578292$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $77146a31cb578292$var$isFileList = $77146a31cb578292$var$kindOfTest('FileList');
const $77146a31cb578292$var$isSet = $77146a31cb578292$var$kindOfTest('Set');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $77146a31cb578292$var$isStream = (val)=>$77146a31cb578292$var$isObject(val) && $77146a31cb578292$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $77146a31cb578292$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $77146a31cb578292$var$G = $77146a31cb578292$var$getGlobal();
const $77146a31cb578292$var$FormDataCtor = typeof $77146a31cb578292$var$G.FormData !== 'undefined' ? $77146a31cb578292$var$G.FormData : undefined;
const $77146a31cb578292$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($77146a31cb578292$var$FormDataCtor && thing instanceof $77146a31cb578292$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $77146a31cb578292$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$77146a31cb578292$var$isFunction(thing.append)) return false;
    const kind = $77146a31cb578292$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $77146a31cb578292$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $77146a31cb578292$var$isURLSearchParams = $77146a31cb578292$var$kindOfTest('URLSearchParams');
const [$77146a31cb578292$var$isReadableStream, $77146a31cb578292$var$isRequest, $77146a31cb578292$var$isResponse, $77146a31cb578292$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($77146a31cb578292$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $77146a31cb578292$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $77146a31cb578292$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($77146a31cb578292$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($77146a31cb578292$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $77146a31cb578292$var$findKey(obj, key) {
    if ($77146a31cb578292$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $77146a31cb578292$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $77146a31cb578292$var$isContextDefined = (context)=>!$77146a31cb578292$var$isUndefined(context) && context !== $77146a31cb578292$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $77146a31cb578292$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $77146a31cb578292$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && $77146a31cb578292$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $77146a31cb578292$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($77146a31cb578292$var$isPlainObject(existing) && $77146a31cb578292$var$isPlainObject(val)) result[targetKey] = $77146a31cb578292$var$merge(existing, val);
        else if ($77146a31cb578292$var$isPlainObject(val)) result[targetKey] = $77146a31cb578292$var$merge({}, val);
        else if ($77146a31cb578292$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$77146a31cb578292$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $77146a31cb578292$var$isBuffer(source)) continue;
        $77146a31cb578292$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $77146a31cb578292$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($77146a31cb578292$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $77146a31cb578292$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $77146a31cb578292$var$forEach(b, (val, key)=>{
        if (thisArg && $77146a31cb578292$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $4c852d2f6a5a0387$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $77146a31cb578292$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $77146a31cb578292$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $77146a31cb578292$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $77146a31cb578292$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $77146a31cb578292$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $77146a31cb578292$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($77146a31cb578292$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$77146a31cb578292$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $77146a31cb578292$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $77146a31cb578292$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $77146a31cb578292$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$77146a31cb578292$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $77146a31cb578292$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $77146a31cb578292$var$isHTMLForm = $77146a31cb578292$var$kindOfTest('HTMLFormElement');
const $77146a31cb578292$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable: $77146a31cb578292$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $77146a31cb578292$var$isRegExp = $77146a31cb578292$var$kindOfTest('RegExp');
const $77146a31cb578292$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $77146a31cb578292$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $77146a31cb578292$var$freezeMethods = (obj)=>{
    $77146a31cb578292$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($77146a31cb578292$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$77146a31cb578292$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $77146a31cb578292$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $77146a31cb578292$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $77146a31cb578292$var$noop = ()=>{};
const $77146a31cb578292$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $77146a31cb578292$var$isSpecCompliantForm(thing) {
    return !!(thing && $77146a31cb578292$var$isFunction(thing.append) && thing[$77146a31cb578292$var$toStringTag] === 'FormData' && thing[$77146a31cb578292$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $77146a31cb578292$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($77146a31cb578292$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($77146a31cb578292$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                let target;
                if ($77146a31cb578292$var$isSet(source)) {
                    target = [];
                    for (const value of source){
                        const reducedValue = visit(value);
                        !$77146a31cb578292$var$isUndefined(reducedValue) && target.push(reducedValue);
                    }
                } else {
                    target = $77146a31cb578292$var$isArray(source) ? [] : {};
                    $77146a31cb578292$var$forEach(source, (value, key)=>{
                        const reducedValue = visit(value);
                        !$77146a31cb578292$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                    });
                }
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $77146a31cb578292$var$isAsyncFn = $77146a31cb578292$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $77146a31cb578292$var$isThenable = (thing)=>thing && ($77146a31cb578292$var$isObject(thing) || $77146a31cb578292$var$isFunction(thing)) && $77146a31cb578292$var$isFunction(thing.then) && $77146a31cb578292$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $77146a31cb578292$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $77146a31cb578292$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $77146a31cb578292$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $77146a31cb578292$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $77146a31cb578292$var$isFunction($77146a31cb578292$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $77146a31cb578292$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($77146a31cb578292$var$_global) : $77146a31cb578292$var$_setImmediate;
// *********************
const $77146a31cb578292$var$isIterable = (thing)=>thing != null && $77146a31cb578292$var$isFunction(thing[$77146a31cb578292$var$iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const $77146a31cb578292$var$isSafeIterable = (thing)=>thing != null && $77146a31cb578292$var$hasOwnInPrototypeChain(thing, $77146a31cb578292$var$iterator) && $77146a31cb578292$var$isIterable(thing);
var $77146a31cb578292$export$2e2bcd8739ae039 = {
    isArray: $77146a31cb578292$var$isArray,
    isArrayBuffer: $77146a31cb578292$var$isArrayBuffer,
    isBuffer: $77146a31cb578292$var$isBuffer,
    isFormData: $77146a31cb578292$var$isFormData,
    isArrayBufferView: $77146a31cb578292$var$isArrayBufferView,
    isString: $77146a31cb578292$var$isString,
    isNumber: $77146a31cb578292$var$isNumber,
    isBoolean: $77146a31cb578292$var$isBoolean,
    isObject: $77146a31cb578292$var$isObject,
    isPlainObject: $77146a31cb578292$var$isPlainObject,
    isEmptyObject: $77146a31cb578292$var$isEmptyObject,
    isReadableStream: $77146a31cb578292$var$isReadableStream,
    isRequest: $77146a31cb578292$var$isRequest,
    isResponse: $77146a31cb578292$var$isResponse,
    isHeaders: $77146a31cb578292$var$isHeaders,
    isUndefined: $77146a31cb578292$var$isUndefined,
    isDate: $77146a31cb578292$var$isDate,
    isFile: $77146a31cb578292$var$isFile,
    isReactNativeBlob: $77146a31cb578292$var$isReactNativeBlob,
    isReactNative: $77146a31cb578292$var$isReactNative,
    isBlob: $77146a31cb578292$var$isBlob,
    isRegExp: $77146a31cb578292$var$isRegExp,
    isFunction: $77146a31cb578292$var$isFunction,
    isStream: $77146a31cb578292$var$isStream,
    isURLSearchParams: $77146a31cb578292$var$isURLSearchParams,
    isTypedArray: $77146a31cb578292$var$isTypedArray,
    isFileList: $77146a31cb578292$var$isFileList,
    forEach: $77146a31cb578292$var$forEach,
    merge: $77146a31cb578292$var$merge,
    extend: $77146a31cb578292$var$extend,
    trim: $77146a31cb578292$var$trim,
    stripBOM: $77146a31cb578292$var$stripBOM,
    inherits: $77146a31cb578292$var$inherits,
    toFlatObject: $77146a31cb578292$var$toFlatObject,
    kindOf: $77146a31cb578292$var$kindOf,
    kindOfTest: $77146a31cb578292$var$kindOfTest,
    endsWith: $77146a31cb578292$var$endsWith,
    toArray: $77146a31cb578292$var$toArray,
    forEachEntry: $77146a31cb578292$var$forEachEntry,
    matchAll: $77146a31cb578292$var$matchAll,
    isHTMLForm: $77146a31cb578292$var$isHTMLForm,
    hasOwnProperty: $77146a31cb578292$var$hasOwnProperty,
    hasOwnProp: $77146a31cb578292$var$hasOwnProperty,
    hasOwnInPrototypeChain: $77146a31cb578292$var$hasOwnInPrototypeChain,
    getSafeProp: $77146a31cb578292$var$getSafeProp,
    reduceDescriptors: $77146a31cb578292$var$reduceDescriptors,
    freezeMethods: $77146a31cb578292$var$freezeMethods,
    toObjectSet: $77146a31cb578292$var$toObjectSet,
    toCamelCase: $77146a31cb578292$var$toCamelCase,
    noop: $77146a31cb578292$var$noop,
    toFiniteNumber: $77146a31cb578292$var$toFiniteNumber,
    findKey: $77146a31cb578292$var$findKey,
    global: $77146a31cb578292$var$_global,
    isContextDefined: $77146a31cb578292$var$isContextDefined,
    isSpecCompliantForm: $77146a31cb578292$var$isSpecCompliantForm,
    toJSONObject: $77146a31cb578292$var$toJSONObject,
    isAsyncFn: $77146a31cb578292$var$isAsyncFn,
    isThenable: $77146a31cb578292$var$isThenable,
    setImmediate: $77146a31cb578292$var$_setImmediate,
    asap: $77146a31cb578292$var$asap,
    isIterable: $77146a31cb578292$var$isIterable,
    isSafeIterable: $77146a31cb578292$var$isSafeIterable
};









'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $cf2275aca40d6d88$var$ignoreDuplicateOf = (0, $77146a31cb578292$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $cf2275aca40d6d88$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        const hasKey = (0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(parsed, key);
        if (!key || hasKey && (0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp($cf2275aca40d6d88$var$ignoreDuplicateOf, key)) return;
        if (key === 'set-cookie') {
            if (hasKey) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = hasKey ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};



'use strict';
function $f0ca37af3d81c31b$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $f0ca37af3d81c31b$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $f0ca37af3d81c31b$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $f0ca37af3d81c31b$var$sanitizeValue(value, invalidChars) {
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(value)) return value.map((item)=>$f0ca37af3d81c31b$var$sanitizeValue(item, invalidChars));
    return $f0ca37af3d81c31b$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $f0ca37af3d81c31b$export$9e344cffce061a22 = (value)=>$f0ca37af3d81c31b$var$sanitizeValue(value, $f0ca37af3d81c31b$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $f0ca37af3d81c31b$export$59dd66c2a12d8f62 = (value)=>$f0ca37af3d81c31b$var$sanitizeValue(value, $f0ca37af3d81c31b$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $f0ca37af3d81c31b$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $f0ca37af3d81c31b$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}


'use strict';
const $c7e8ef3e2bb241a6$var$$internals = Symbol('internals');
function $c7e8ef3e2bb241a6$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $c7e8ef3e2bb241a6$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(value) ? value.map($c7e8ef3e2bb241a6$var$normalizeValue) : (0, $f0ca37af3d81c31b$export$9e344cffce061a22)(String(value));
}
function $c7e8ef3e2bb241a6$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $c7e8ef3e2bb241a6$var$parameterNameRE = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function $c7e8ef3e2bb241a6$var$trimOWS(value) {
    let start = 0;
    let end = value.length;
    while(start < end){
        const code = value.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = value.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === value.length ? value : value.slice(start, end);
}
function $c7e8ef3e2bb241a6$var$decodeQuotedString(value) {
    const last = value.length - 1;
    if (last < 1 || value.charCodeAt(0) !== 0x22 || value.charCodeAt(last) !== 0x22) return value;
    let decoded = '';
    for(let i = 1; i < last; i++){
        const code = value.charCodeAt(i);
        if (code === 0x22) return value;
        if (code === 0x5c) {
            i += 1;
            if (i >= last) return value;
        }
        decoded += value[i];
    }
    return decoded;
}
function $c7e8ef3e2bb241a6$var$parseParameters(value) {
    const parameters = Object.create(null);
    const str = String(value);
    let start = 0;
    let quoted = false;
    let escaped = false;
    function parseParameter(end) {
        const part = $c7e8ef3e2bb241a6$var$trimOWS(str.slice(start, end));
        const equals = part.indexOf('=');
        if (equals < 1) return;
        const name = $c7e8ef3e2bb241a6$var$trimOWS(part.slice(0, equals));
        if (!$c7e8ef3e2bb241a6$var$parameterNameRE.test(name)) return;
        const normalizedName = name.toLowerCase();
        if (normalizedName === '__proto__' || normalizedName === 'constructor' || normalizedName === 'prototype') return;
        const parameterValue = $c7e8ef3e2bb241a6$var$trimOWS(part.slice(equals + 1));
        parameters[normalizedName] = $c7e8ef3e2bb241a6$var$decodeQuotedString(parameterValue);
    }
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        if (quoted) {
            if (escaped) escaped = false;
            else if (code === 0x5c) escaped = true;
            else if (code === 0x22) quoted = false;
        } else if (code === 0x22) quoted = true;
        else if (code === 0x2c || code === 0x3b) {
            parseParameter(i);
            start = i + 1;
        }
    }
    parseParameter(str.length);
    return parameters;
}
const $c7e8ef3e2bb241a6$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $c7e8ef3e2bb241a6$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $c7e8ef3e2bb241a6$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $c7e8ef3e2bb241a6$var$buildAccessors(obj, header) {
    const accessorName = (0, $77146a31cb578292$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $c7e8ef3e2bb241a6$var$AxiosHeaders {
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $c7e8ef3e2bb241a6$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $c7e8ef3e2bb241a6$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$c7e8ef3e2bb241a6$var$isValidHeaderName(header)) setHeaders((0, $cf2275aca40d6d88$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(header) && (0, $77146a31cb578292$export$2e2bcd8739ae039).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                key = entry[0];
                if ((0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $c7e8ef3e2bb241a6$var$normalizeHeader(header);
        if (header) {
            const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $c7e8ef3e2bb241a6$var$parseTokens(value);
                if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $c7e8ef3e2bb241a6$var$normalizeHeader(header);
        if (header) {
            const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $c7e8ef3e2bb241a6$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $c7e8ef3e2bb241a6$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $c7e8ef3e2bb241a6$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $c7e8ef3e2bb241a6$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $c7e8ef3e2bb241a6$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $c7e8ef3e2bb241a6$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $c7e8ef3e2bb241a6$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        const value = this.get('set-cookie');
        return (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(value) ? value : value == null || value === false ? [] : [
            value
        ];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static parseParameters(value) {
        return $c7e8ef3e2bb241a6$var$parseParameters(value);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$c7e8ef3e2bb241a6$var$$internals] = this[$c7e8ef3e2bb241a6$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $c7e8ef3e2bb241a6$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $c7e8ef3e2bb241a6$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
    constructor(headers){
        headers && this.set(headers);
    }
}
$c7e8ef3e2bb241a6$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $77146a31cb578292$export$2e2bcd8739ae039).reduceDescriptors($c7e8ef3e2bb241a6$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $77146a31cb578292$export$2e2bcd8739ae039).freezeMethods($c7e8ef3e2bb241a6$var$AxiosHeaders);
var $c7e8ef3e2bb241a6$export$2e2bcd8739ae039 = $c7e8ef3e2bb241a6$var$AxiosHeaders;


'use strict';
const $b9cc6960093b095e$export$6acd2efa8ac62a1b = '[REDACTED ****]';
function $b9cc6960093b095e$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $b9cc6960093b095e$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(source) && $b9cc6960093b095e$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $b9cc6960093b095e$export$6acd2efa8ac62a1b : visit(value);
                if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
function $b9cc6960093b095e$var$stringifySafely(value) {
    try {
        return String(value);
    } catch (err) {
        return '';
    }
}
function $b9cc6960093b095e$var$aggregateErrorMessage(error) {
    const message = error.errors.map((entry)=>{
        try {
            return entry && entry.message ? $b9cc6960093b095e$var$stringifySafely(entry.message) : $b9cc6960093b095e$var$stringifySafely(entry);
        } catch (err) {
            return '';
        }
    }).filter(Boolean).join('; ');
    return message || error.name || 'AggregateError';
}
class $b9cc6960093b095e$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        // `AggregateError` (thrown by Node on dual-stack/Happy-Eyeballs connection
        // failures) has an empty `message`; its detail lives in `errors[]`. Without
        // this, the wrapped error surfaces with a blank message (see #6721).
        let message = error.message;
        if (!message && (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(error.errors) && error.errors.length) message = $b9cc6960093b095e$var$aggregateErrorMessage(error);
        const axiosError = new $b9cc6960093b095e$var$AxiosError(message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, 'cause', {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
        });
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(redactKeys) && redactKeys.length > 0 ? $b9cc6960093b095e$var$redactConfig(config, redactKeys) : (0, $77146a31cb578292$export$2e2bcd8739ae039).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$b9cc6960093b095e$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$b9cc6960093b095e$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$b9cc6960093b095e$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$b9cc6960093b095e$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$b9cc6960093b095e$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$b9cc6960093b095e$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$b9cc6960093b095e$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$b9cc6960093b095e$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$b9cc6960093b095e$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$b9cc6960093b095e$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$b9cc6960093b095e$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$b9cc6960093b095e$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$b9cc6960093b095e$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$b9cc6960093b095e$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $b9cc6960093b095e$export$2e2bcd8739ae039 = $b9cc6960093b095e$var$AxiosError;


// eslint-disable-next-line strict
var $31df7fcb8acaa73a$export$2e2bcd8739ae039 = null;



'use strict';
const $19044a9fa7281693$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $19044a9fa7281693$var$isVisitable(thing) {
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $19044a9fa7281693$var$removeBrackets(key) {
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $19044a9fa7281693$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $19044a9fa7281693$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $19044a9fa7281693$var$isFlatArray(arr) {
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(arr) && !arr.some($19044a9fa7281693$var$isVisitable);
}
const $19044a9fa7281693$var$predicates = (0, $77146a31cb578292$export$2e2bcd8739ae039).toFlatObject((0, $77146a31cb578292$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $19044a9fa7281693$var$toFormData(obj, formData, options) {
    if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $31df7fcb8acaa73a$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $77146a31cb578292$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const maxDepth = options.maxDepth === undefined ? $19044a9fa7281693$export$659081b45d03227d : options.maxDepth;
    const useBlob = _Blob && (0, $77146a31cb578292$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $77146a31cb578292$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isTypedArray(value)) {
            if (useBlob && typeof _Blob === 'function') return new _Blob([
                value
            ]);
            if ((0, $31df7fcb8acaa73a$export$2e2bcd8739ae039) && (0, $31df7fcb8acaa73a$export$2e2bcd8739ae039).isBufferAvailable()) return (0, $31df7fcb8acaa73a$export$2e2bcd8739ae039).from(value);
            throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isReactNative(formData) && (0, $77146a31cb578292$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($19044a9fa7281693$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(value) && $19044a9fa7281693$var$isFlatArray(value) || ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFileList(value) || (0, $77146a31cb578292$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $77146a31cb578292$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $19044a9fa7281693$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $19044a9fa7281693$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($19044a9fa7281693$var$isVisitable(value)) return true;
        formData.append($19044a9fa7281693$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign($19044a9fa7281693$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $19044a9fa7281693$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $77146a31cb578292$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $19044a9fa7281693$export$2e2bcd8739ae039 = $19044a9fa7281693$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $a2774d1dd3bec636$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $a2774d1dd3bec636$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $19044a9fa7281693$export$2e2bcd8739ae039)(params, this, options);
}
const $a2774d1dd3bec636$var$prototype = $a2774d1dd3bec636$var$AxiosURLSearchParams.prototype;
$a2774d1dd3bec636$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$a2774d1dd3bec636$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? (value)=>encoder.call(this, value, $a2774d1dd3bec636$var$encode) : $a2774d1dd3bec636$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $a2774d1dd3bec636$export$2e2bcd8739ae039 = $a2774d1dd3bec636$var$AxiosURLSearchParams;


'use strict';
function $4a4d655613ae826e$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $4a4d655613ae826e$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    url = url || '';
    const _options = (0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, $77146a31cb578292$export$2e2bcd8739ae039).getSafeProp(_options, 'encode') || $4a4d655613ae826e$export$c564cdbbe6da493;
    const serializeFn = (0, $77146a31cb578292$export$2e2bcd8739ae039).getSafeProp(_options, 'serialize');
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $77146a31cb578292$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $a2774d1dd3bec636$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $ec4d8e24b0699790$var$InterceptorManager {
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
    constructor(){
        this.handlers = [];
    }
}
var $ec4d8e24b0699790$export$2e2bcd8739ae039 = $ec4d8e24b0699790$var$InterceptorManager;





'use strict';
var $7e146da7bba06216$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};




var $9tqwB = parcelRequire("9tqwB");



var $9tqwB = parcelRequire("9tqwB");

'use strict';
var $9a13f762833a66d0$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $a2774d1dd3bec636$export$2e2bcd8739ae039);


'use strict';
var $16325b87e107b4bc$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $650c3d387ae3fbd4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $e4489594588108ef$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $9a13f762833a66d0$export$2e2bcd8739ae039,
        FormData: $16325b87e107b4bc$export$2e2bcd8739ae039,
        Blob: $650c3d387ae3fbd4$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $1bbd8fa0325c4f9a$exports = {};

$parcel$export($1bbd8fa0325c4f9a$exports, "hasBrowserEnv", function () { return $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf; });
$parcel$export($1bbd8fa0325c4f9a$exports, "navigator", function () { return $1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae; });
$parcel$export($1bbd8fa0325c4f9a$exports, "hasStandardBrowserEnv", function () { return $1bbd8fa0325c4f9a$export$c0bcc9250309d66; });
$parcel$export($1bbd8fa0325c4f9a$exports, "hasStandardBrowserWebWorkerEnv", function () { return $1bbd8fa0325c4f9a$export$c81692cf5af97dac; });
$parcel$export($1bbd8fa0325c4f9a$exports, "origin", function () { return $1bbd8fa0325c4f9a$export$f710a83a91838a36; });
const $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $1bbd8fa0325c4f9a$export$c0bcc9250309d66 = $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf && (!$1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $1bbd8fa0325c4f9a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $1bbd8fa0325c4f9a$export$f710a83a91838a36 = $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $f9f874191f496b63$export$2e2bcd8739ae039 = (0, $9tqwB._)({}, $1bbd8fa0325c4f9a$exports, (0, $e4489594588108ef$export$2e2bcd8739ae039));


'use strict';
function $f1a69cd24a140b61$export$2e2bcd8739ae039(data, options) {
    return (0, $19044a9fa7281693$export$2e2bcd8739ae039)(data, new (0, $f9f874191f496b63$export$2e2bcd8739ae039).classes.URLSearchParams(), (0, $9tqwB._)({
        visitor: function(value, key, path, helpers) {
            if ((0, $f9f874191f496b63$export$2e2bcd8739ae039).isNode && (0, $77146a31cb578292$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}






'use strict';
const $24febbb5d340c733$var$MAX_DEPTH = (0, $19044a9fa7281693$export$659081b45d03227d);
function $24febbb5d340c733$var$throwIfDepthExceeded(index) {
    if (index > $24febbb5d340c733$var$MAX_DEPTH) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + $24febbb5d340c733$var$MAX_DEPTH, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $24febbb5d340c733$var$parsePropPath(name) {
    // foo[x][y][z] -> ['foo', 'x', 'y', 'z']
    // foo.x.y.z    -> ['foo', 'x', 'y', 'z']
    // A path is split on `.` and on `[...]` groups. A segment — whether written
    // in dot notation or captured inside brackets — may contain any character
    // except `.`, `[` and `]`, so a key like `user-name` or `user name` is kept
    // literal instead of being split (#5402). `.`, `[` and `]` keep their existing
    // meaning, e.g. `foo[bar.baz]` -> ['foo', 'bar', 'baz'] and `[]` is an array push.
    // Excluding `[` from the bracket group also makes the match fail fast at the
    // next `[`, so a malformed name cannot rescan to the end of the string from
    // every unmatched `[` — parsing stays linear in the length of the name.
    const path = [];
    const pattern = /[^.[\]]+|\[([^.[\]]*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        $24febbb5d340c733$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $24febbb5d340c733$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $24febbb5d340c733$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $24febbb5d340c733$var$throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(target, name) || !(0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $24febbb5d340c733$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFormData(formData) && (0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($24febbb5d340c733$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $24febbb5d340c733$export$2e2bcd8739ae039 = $24febbb5d340c733$var$formDataToJSON;


'use strict';
const $a5e696f232d0dc12$var$own = (obj, key)=>obj != null && (0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $a5e696f232d0dc12$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $77146a31cb578292$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $a5e696f232d0dc12$var$defaults = {
    transitional: (0, $7e146da7bba06216$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $77146a31cb578292$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $77146a31cb578292$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $24febbb5d340c733$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isBuffer(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isStream(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isFile(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isBlob(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $a5e696f232d0dc12$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $f1a69cd24a140b61$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $77146a31cb578292$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $a5e696f232d0dc12$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $19044a9fa7281693$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $a5e696f232d0dc12$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $a5e696f232d0dc12$var$own(this, 'transitional') || $a5e696f232d0dc12$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $a5e696f232d0dc12$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isResponse(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $77146a31cb578292$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $a5e696f232d0dc12$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $b9cc6960093b095e$export$2e2bcd8739ae039).from(e, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $a5e696f232d0dc12$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $f9f874191f496b63$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $f9f874191f496b63$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch',
    'query'
], (method)=>{
    $a5e696f232d0dc12$var$defaults.headers[method] = {};
});
var $a5e696f232d0dc12$export$2e2bcd8739ae039 = $a5e696f232d0dc12$var$defaults;



'use strict';
function $0cb2ce7608ace114$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $a5e696f232d0dc12$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $36f1aa490c1da053$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $f6ac833a4b31e3dc$var$CanceledError extends (0, $b9cc6960093b095e$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $f6ac833a4b31e3dc$export$2e2bcd8739ae039 = $f6ac833a4b31e3dc$var$CanceledError;







'use strict';
function $2c92173995cdc070$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_REQUEST : (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, response.config, response.request, response));
}





'use strict';
function $2ecf5cf4c0202afd$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $d592abf0a04957f1$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $d592abf0a04957f1$export$2e2bcd8739ae039 = $d592abf0a04957f1$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $5603d643a9d93c92$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $5603d643a9d93c92$export$2e2bcd8739ae039 = $5603d643a9d93c92$var$throttle;



const $de65761df8a598af$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $d592abf0a04957f1$export$2e2bcd8739ae039)(50, 250);
    return (0, $5603d643a9d93c92$export$2e2bcd8739ae039)((e)=>{
        if (!e || typeof e.loaded !== 'number') return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = Math.max(0, total != null ? Math.min(rawLoaded, total) : rawLoaded);
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $de65761df8a598af$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $de65761df8a598af$export$5d35863c355a22a9 = (fn, scheduler = (0, $77146a31cb578292$export$2e2bcd8739ae039).asap)=>(...args)=>scheduler(()=>fn(...args));






var $82d74b1a5a0a01da$export$2e2bcd8739ae039 = (0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $f9f874191f496b63$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $f9f874191f496b63$export$2e2bcd8739ae039).origin), (0, $f9f874191f496b63$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $f9f874191f496b63$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $534b3794da5c002d$export$2e2bcd8739ae039 = (0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) try {
                return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
                return cookie.slice(eq + 1);
            }
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};



'use strict';
function $12188e34b7070552$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $f55e71b6c54c4376$export$2e2bcd8739ae039(baseURL, relativeURL) {
    if (!relativeURL) return baseURL;
    let end = baseURL.length;
    while(end > 0 && baseURL.charCodeAt(end - 1) === 47)end--;
    return baseURL.slice(0, end) + '/' + relativeURL.replace(/^\/+/, '');
}


'use strict';
const $2ec1d7b86495f966$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
const $2ec1d7b86495f966$var$httpProtocolControlCharacters = /[\t\n\r]/g;
function $2ec1d7b86495f966$var$stripLeadingC0ControlOrSpace(url) {
    let i = 0;
    while(i < url.length && url.charCodeAt(i) <= 0x20)i++;
    return url.slice(i);
}
function $2ec1d7b86495f966$var$normalizeURLForProtocolCheck(url) {
    return $2ec1d7b86495f966$var$stripLeadingC0ControlOrSpace(url).replace($2ec1d7b86495f966$var$httpProtocolControlCharacters, '');
}
// Redact the parts of a URL that can carry secrets before it is embedded in an
// error message. AxiosError.toJSON() serializes `message` verbatim and errors
// are commonly logged, while the opt-in `config.redact` model only cleans
// config keys — it cannot reach the message. Redact only the genuinely
// sensitive substrings — userinfo (credentials), query parameter values and
// fragment contents — with the same REDACTED marker the config redaction uses,
// while keeping the scheme, host, path and parameter names so the offending
// request stays accurately identifiable.
function $2ec1d7b86495f966$var$redactFragment(fragment) {
    if (!fragment) return fragment;
    return fragment.replace(/(^|&)([^=&]*=)?[^&]+/g, (match, separator, parameterName = '')=>{
        return `${separator}${parameterName}${0, $b9cc6960093b095e$export$6acd2efa8ac62a1b}`;
    });
}
function $2ec1d7b86495f966$var$redactSensitiveURLParts(url) {
    const redactedURL = url.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${(0, $b9cc6960093b095e$export$6acd2efa8ac62a1b)}@`);
    const fragmentIndex = redactedURL.indexOf('#');
    const urlWithoutFragment = fragmentIndex === -1 ? redactedURL : redactedURL.slice(0, fragmentIndex);
    const redactedURLWithoutFragment = urlWithoutFragment.replace(/([?&][^=&#]*=)[^&#]*/g, `$1${(0, $b9cc6960093b095e$export$6acd2efa8ac62a1b)}`);
    if (fragmentIndex === -1) return redactedURLWithoutFragment;
    return `${redactedURLWithoutFragment}#${$2ec1d7b86495f966$var$redactFragment(redactedURL.slice(fragmentIndex + 1))}`;
}
function $2ec1d7b86495f966$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string') {
        const normalizedURL = $2ec1d7b86495f966$var$normalizeURLForProtocolCheck(url);
        if ($2ec1d7b86495f966$var$malformedHttpProtocol.test(normalizedURL)) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(`Invalid URL ${JSON.stringify($2ec1d7b86495f966$var$redactSensitiveURLParts(normalizedURL))}: missing "//" after protocol`, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_INVALID_URL, config);
    }
}
function $2ec1d7b86495f966$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $2ec1d7b86495f966$var$assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, $12188e34b7070552$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $2ec1d7b86495f966$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $f55e71b6c54c4376$export$2e2bcd8739ae039)(baseURL, requestedURL);
    }
    return requestedURL;
}



var $9tqwB = parcelRequire("9tqwB");


'use strict';
const $3d132bbf7812485b$var$headersToObject = (thing)=>thing instanceof (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039) ? (0, $9tqwB._)({}, thing) : thing;
const $3d132bbf7812485b$var$ownEnumerableKeys = (thing)=>{
    if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) return Object.keys(thing).concat(Object.getOwnPropertySymbols(thing).filter((symbol)=>Object.getOwnPropertyDescriptor(thing, symbol).enumerable));
    return Object.keys(thing);
};
function $3d132bbf7812485b$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(target) && (0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $77146a31cb578292$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $77146a31cb578292$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        const transitional2 = (0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(transitional2)) {
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(transitional2)) {
                if ((0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        const transitional1 = (0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(transitional1) && (0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($3d132bbf7812485b$var$headersToObject(a), $3d132bbf7812485b$var$headersToObject(b), prop, true)
    };
    (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach($3d132bbf7812485b$var$ownEnumerableKeys((0, $9tqwB._)({}, config1, config2)), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(config2, 'validateStatus') && (0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(config2.validateStatus) && getMergedTransitionalOption('validateStatusUndefinedResolves') === false) {
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(config1, 'validateStatus')) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}



'use strict';
const $2db7806979b02fe9$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $2db7806979b02fe9$export$2e2bcd8739ae039(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val])=>{
        if ($2db7806979b02fe9$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}



/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $b00a7ead3edff84a$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $b00a7ead3edff84a$var$resolveConfig(config) {
    const newConfig = (0, $3d132bbf7812485b$export$2e2bcd8739ae039)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $4a4d655613ae826e$export$2e2bcd8739ae039)((0, $2ec1d7b86495f966$export$2e2bcd8739ae039)(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        const username = (0, $77146a31cb578292$export$2e2bcd8739ae039).getSafeProp(auth, 'username') || '';
        const password = (0, $77146a31cb578292$export$2e2bcd8739ae039).getSafeProp(auth, 'password') || '';
        try {
            headers.set('Authorization', 'Basic ' + btoa(username + ':' + (password ? $b00a7ead3edff84a$var$encodeUTF8(password) : '')));
        } catch (e) {
            throw (0, $b9cc6960093b095e$export$2e2bcd8739ae039).from(e, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv || (0, $77146a31cb578292$export$2e2bcd8739ae039).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(data.getHeaders)) // Node.js FormData (like form-data package)
        (0, $2db7806979b02fe9$export$2e2bcd8739ae039)(headers, data.getHeaders(), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $82d74b1a5a0a01da$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $534b3794da5c002d$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $b00a7ead3edff84a$export$2e2bcd8739ae039 = $b00a7ead3edff84a$var$resolveConfig;



const $2cabe869ce51dbf6$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $2cabe869ce51dbf6$export$2e2bcd8739ae039 = $2cabe869ce51dbf6$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $b00a7ead3edff84a$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $2c92173995cdc070$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Request aborted', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(msg, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $7e146da7bba06216$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ETIMEDOUT : (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach((0, $f0ca37af3d81c31b$export$c30c72bb7e677d54)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $de65761df8a598af$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $de65761df8a598af$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $2ecf5cf4c0202afd$export$2e2bcd8739ae039)(_config.url);
        if (protocol && !(0, $f9f874191f496b63$export$2e2bcd8739ae039).protocols.includes(protocol)) {
            reject(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");






const $62bdf0498e608a4a$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $b9cc6960093b095e$export$2e2bcd8739ae039) ? err : new (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>{
        if (aborted) return;
        if (signal.aborted) {
            onabort.call(signal);
            return;
        }
        signal.addEventListener('abort', onabort, {
            once: true
        });
    });
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $77146a31cb578292$export$2e2bcd8739ae039).asap(unsubscribe);
    return signal;
};
var $62bdf0498e608a4a$export$2e2bcd8739ae039 = $62bdf0498e608a4a$var$composeSignals;


const $c626b6acbc30fe14$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c626b6acbc30fe14$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c626b6acbc30fe14$var$readStream(iterable))yield* $c626b6acbc30fe14$export$71b051935044bd5d(chunk, chunkSize);
};
const $c626b6acbc30fe14$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c626b6acbc30fe14$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c626b6acbc30fe14$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






/**
 * Estimate data: URL byte lengths *without* allocating large buffers.
 * - Fetch percent-decodes a base64 body before decoding it.
 * - Node's Buffer.from(body, 'base64') sizes its backing allocation from the
 *   raw body, including ignored characters and content after padding.
 * - Non-base64 data is percent-decoded and then encoded as UTF-8.
 */ const $ca979531ea712187$var$isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const $ca979531ea712187$var$isPercentEncodedByte = (str, i, len)=>i + 2 < len && $ca979531ea712187$var$isHexDigit(str.charCodeAt(i + 1)) && $ca979531ea712187$var$isHexDigit(str.charCodeAt(i + 2));
const $ca979531ea712187$var$hexValue = (charCode)=>charCode <= 57 ? charCode - 48 : (charCode & 0xdf) - 55;
const $ca979531ea712187$var$isBase64Char = (charCode)=>charCode >= 65 && charCode <= 90 || // A-Z
    charCode >= 97 && charCode <= 122 || // a-z
    charCode >= 48 && charCode <= 57 || // 0-9
    charCode === 43 || // +
    charCode === 47 || // /
    charCode === 45 || // - (base64url)
    charCode === 95; // _ (base64url)
const $ca979531ea712187$var$isBase64Whitespace = (charCode)=>charCode === 9 || charCode === 10 || charCode === 12 || charCode === 13 || charCode === 32;
const $ca979531ea712187$var$base64Bytes = (significant)=>{
    const groups = Math.floor(significant / 4);
    const remainder = significant % 4;
    return groups * 3 + (remainder === 2 ? 1 : remainder === 3 ? 2 : 0);
};
// Buffer.byteLength(body, 'base64') uses the raw string length as an allocation
// upper bound even when Buffer.from later ignores characters or stops at '='.
const $ca979531ea712187$var$estimateBase64BufferAllocation = (body)=>{
    const len = body.length;
    let padding = 0;
    if (len > 0 && body.charCodeAt(len - 1) === 61 /* '=' */ ) {
        padding++;
        if (len > 1 && body.charCodeAt(len - 2) === 61 /* '=' */ ) padding++;
    }
    return Math.floor((len - padding) * 3 / 4);
};
const $ca979531ea712187$var$estimatePercentDecodedBase64Bytes = (body)=>{
    const len = body.length;
    let significant = 0;
    let padding = 0;
    let invalid = false;
    for(let i = 0; i < len; i++){
        let code = body.charCodeAt(i);
        if (code === 37 /* '%' */  && $ca979531ea712187$var$isPercentEncodedByte(body, i, len)) {
            code = $ca979531ea712187$var$hexValue(body.charCodeAt(i + 1)) * 16 + $ca979531ea712187$var$hexValue(body.charCodeAt(i + 2));
            i += 2;
        }
        if ($ca979531ea712187$var$isBase64Whitespace(code)) continue;
        if (code === 61 /* '=' */ ) {
            padding++;
            continue;
        }
        if (!$ca979531ea712187$var$isBase64Char(code) || padding > 0) {
            invalid = true;
            continue;
        }
        significant++;
    }
    // Fetch rejects malformed forgiving-base64 input. Returning the raw-size
    // allocation bound keeps that invalid input from becoming a pre-check bypass.
    if (invalid || padding > 2 || padding > 0 && (significant + padding) % 4 !== 0 || significant % 4 === 1) return $ca979531ea712187$var$estimateBase64BufferAllocation(body);
    return $ca979531ea712187$var$base64Bytes(significant);
};
const $ca979531ea712187$var$estimateDataURLBytes = (url, estimateBase64)=>{
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) return estimateBase64(body);
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $ca979531ea712187$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
};
function $ca979531ea712187$export$2e2bcd8739ae039(url) {
    // Fetch removes URL fragments before processing a data: URL.
    const fragmentIndex = typeof url === 'string' ? url.indexOf('#') : -1;
    return $ca979531ea712187$var$estimateDataURLBytes(fragmentIndex === -1 ? url : url.slice(0, fragmentIndex), $ca979531ea712187$var$estimatePercentDecodedBase64Bytes);
}
function $ca979531ea712187$export$1f39e64b554a246f(url) {
    return $ca979531ea712187$var$estimateDataURLBytes(url, $ca979531ea712187$var$estimateBase64BufferAllocation);
}


const $95be4ecd446de127$export$a4ad2735b021c132 = "1.19.0";



const $c2191f87f9ef3849$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $c2191f87f9ef3849$var$isFunction } = (0, $77146a31cb578292$export$2e2bcd8739ae039);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $c2191f87f9ef3849$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $c2191f87f9ef3849$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $c2191f87f9ef3849$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $c2191f87f9ef3849$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $c2191f87f9ef3849$var$factory = (env)=>{
    const globalObject = (0, $77146a31cb578292$export$2e2bcd8739ae039).global !== undefined && (0, $77146a31cb578292$export$2e2bcd8739ae039).global !== null ? (0, $77146a31cb578292$export$2e2bcd8739ae039).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $77146a31cb578292$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $c2191f87f9ef3849$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $c2191f87f9ef3849$var$isFunction(Request);
    const isResponseSupported = $c2191f87f9ef3849$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $c2191f87f9ef3849$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $c2191f87f9ef3849$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $f9f874191f496b63$export$2e2bcd8739ae039).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $c2191f87f9ef3849$var$test(()=>(0, $77146a31cb578292$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $f9f874191f496b63$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $77146a31cb578292$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength } = (0, $b00a7ead3edff84a$export$2e2bcd8739ae039)(config);
        const hasMaxContentLength = (0, $77146a31cb578292$export$2e2bcd8739ae039).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $77146a31cb578292$export$2e2bcd8739ae039).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $62bdf0498e608a4a$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosError we raise while the request body is being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        const maxBodyLengthError = ()=>new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Request body larger than maxBodyLength limit', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = (0, $77146a31cb578292$export$2e2bcd8739ae039).getSafeProp(configAuth, 'username') || '';
                const password = (0, $77146a31cb578292$export$2e2bcd8739ae039).getSafeProp(configAuth, 'password') || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($c2191f87f9ef3849$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $f9f874191f496b63$export$2e2bcd8739ae039).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $c2191f87f9ef3849$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $c2191f87f9ef3849$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($c2191f87f9ef3849$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $ca979531ea712187$export$2e2bcd8739ae039)(url);
                if (estimated > maxContentLength) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, $77146a31cb578292$export$2e2bcd8739ae039).isReadableStream(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, $c626b6acbc30fe14$export$b0119225647bd83)(stream, $c2191f87f9ef3849$var$DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: 'POST',
                        body: data,
                        duplex: 'half'
                    });
                    let contentTypeHeader;
                    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, $de65761df8a598af$export$d9fadd12586c18d6)(requestContentLength, (0, $de65761df8a598af$export$c1b28109d46c3592)((0, $de65761df8a598af$export$5d35863c355a22a9)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Stream request bodies are not supported by the current fetch implementation', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config, request);
            if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $95be4ecd446de127$export$a4ad2735b021c132), false);
            const resolvedOptions = (0, $2qxEV._)((0, $9tqwB._)({}, fetchOptions), {
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $f0ca37af3d81c31b$export$c30c72bb7e677d54)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            });
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $77146a31cb578292$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $77146a31cb578292$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, $de65761df8a598af$export$d9fadd12586c18d6)(responseContentLength, (0, $de65761df8a598af$export$c1b28109d46c3592)((0, $de65761df8a598af$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $c626b6acbc30fe14$export$b0119225647bd83)(response.body, $c2191f87f9ef3849$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $2c92173995cdc070$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $b9cc6960093b095e$export$2e2bcd8739ae039)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, 'cause', {
                    __proto__: null,
                    value: err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Matching by identity (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, $b9cc6960093b095e$export$2e2bcd8739ae039)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
                const networkError = new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Network Error', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response);
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(networkError, 'cause', {
                    __proto__: null,
                    value: err.cause || err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw networkError;
            }
            throw (0, $b9cc6960093b095e$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $c2191f87f9ef3849$var$seedCache = new Map();
const $c2191f87f9ef3849$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $c2191f87f9ef3849$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $c2191f87f9ef3849$var$factory(env));
        map = target;
    }
    return target;
};
const $c2191f87f9ef3849$var$adapter = $c2191f87f9ef3849$export$3105c6651375d4fa();
var $c2191f87f9ef3849$export$2e2bcd8739ae039 = $c2191f87f9ef3849$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $c036c406f3928265$var$knownAdapters = {
    http: (0, $31df7fcb8acaa73a$export$2e2bcd8739ae039),
    xhr: (0, $2cabe869ce51dbf6$export$2e2bcd8739ae039),
    fetch: {
        get: $c2191f87f9ef3849$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach($c036c406f3928265$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $c036c406f3928265$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $c036c406f3928265$var$isResolvedHandle = (adapter)=>(0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $c036c406f3928265$var$getAdapter(adapters, config) {
    adapters = (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$c036c406f3928265$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $c036c406f3928265$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($c036c406f3928265$var$renderReason).join('\n') : ' ' + $c036c406f3928265$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $c036c406f3928265$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $c036c406f3928265$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $c036c406f3928265$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $a98a53c8a75f9db0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039)(null, config);
}
function $a98a53c8a75f9db0$export$2e2bcd8739ae039(config) {
    $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
    config.headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $0cb2ce7608ace114$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $c036c406f3928265$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $a5e696f232d0dc12$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $0cb2ce7608ace114$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $36f1aa490c1da053$export$2e2bcd8739ae039)(reason)) {
            $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $0cb2ce7608ace114$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}






'use strict';
const $1ad671c27810423e$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $1ad671c27810423e$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $1ad671c27810423e$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $1ad671c27810423e$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $95be4ecd446de127$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$1ad671c27810423e$var$deprecatedWarnings[opt]) {
            $1ad671c27810423e$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$1ad671c27810423e$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $1ad671c27810423e$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object' || options === null) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('options must be an object', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $1ad671c27810423e$export$2e2bcd8739ae039 = {
    assertOptions: $1ad671c27810423e$var$assertOptions,
    validators: $1ad671c27810423e$var$validators
};




'use strict';
const $66f2b8a41463d1e8$var$validators = (0, $1ad671c27810423e$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $66f2b8a41463d1e8$var$Axios {
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = (()=>{
                    if (!dummy.stack) return '';
                    const firstNewlineIndex = dummy.stack.indexOf('\n');
                    return firstNewlineIndex === -1 ? '' : dummy.stack.slice(firstNewlineIndex + 1);
                })();
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack) {
                        const firstNewlineIndex = stack.indexOf('\n');
                        const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                        const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                    }
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $3d132bbf7812485b$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $1ad671c27810423e$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            forcedJSONParsing: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            clarifyTimeoutError: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            legacyInterceptorReqResOrdering: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            advertiseZstdAcceptEncoding: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            validateStatusUndefinedResolves: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $1ad671c27810423e$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $66f2b8a41463d1e8$var$validators.function,
                serialize: $66f2b8a41463d1e8$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $1ad671c27810423e$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $66f2b8a41463d1e8$var$validators.spelling('baseURL'),
            withXsrfToken: $66f2b8a41463d1e8$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $77146a31cb578292$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'query',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $7e146da7bba06216$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $a98a53c8a75f9db0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled ? onFulfilled(newConfig) : newConfig;
            } catch (error) {
                if (!onRejected) {
                    promise = Promise.reject(error);
                    break;
                }
                try {
                    const rejectedResult = onRejected.call(this, error);
                    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isThenable(rejectedResult)) promise = Promise.resolve(rejectedResult).then(()=>(0, $a98a53c8a75f9db0$export$2e2bcd8739ae039).call(this, newConfig));
                } catch (rejectedError) {
                    promise = Promise.reject(rejectedError);
                }
                break;
            }
        }
        if (!promise) try {
            promise = (0, $a98a53c8a75f9db0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            promise = Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $3d132bbf7812485b$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $2ec1d7b86495f966$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, $4a4d655613ae826e$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $ec4d8e24b0699790$export$2e2bcd8739ae039)(),
            response: new (0, $ec4d8e24b0699790$export$2e2bcd8739ae039)()
        };
    }
}
// Provide aliases for supported request methods
(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $66f2b8a41463d1e8$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $3d132bbf7812485b$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $3d132bbf7812485b$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $66f2b8a41463d1e8$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $66f2b8a41463d1e8$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $66f2b8a41463d1e8$export$2e2bcd8739ae039 = $66f2b8a41463d1e8$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $f4994f37c883aea2$var$CancelToken {
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $f4994f37c883aea2$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
}
var $f4994f37c883aea2$export$2e2bcd8739ae039 = $f4994f37c883aea2$var$CancelToken;






'use strict';
function $8145c4b68bfee186$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $ec03acb464b74212$export$2e2bcd8739ae039(payload) {
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $a9353565c2e0947e$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerReturnsAnUnknownError: 520,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($a9353565c2e0947e$var$HttpStatusCode).forEach(([key, value])=>{
    $a9353565c2e0947e$var$HttpStatusCode[value] = key;
});
var $a9353565c2e0947e$export$2e2bcd8739ae039 = $a9353565c2e0947e$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $747d656b899e6115$var$createInstance(defaultConfig) {
    const context = new (0, $66f2b8a41463d1e8$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $4c852d2f6a5a0387$export$2e2bcd8739ae039)((0, $66f2b8a41463d1e8$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $77146a31cb578292$export$2e2bcd8739ae039).extend(instance, (0, $66f2b8a41463d1e8$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $77146a31cb578292$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $747d656b899e6115$var$createInstance((0, $3d132bbf7812485b$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $747d656b899e6115$var$axios = $747d656b899e6115$var$createInstance((0, $a5e696f232d0dc12$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$747d656b899e6115$var$axios.Axios = (0, $66f2b8a41463d1e8$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$747d656b899e6115$var$axios.CanceledError = (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.CancelToken = (0, $f4994f37c883aea2$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.isCancel = (0, $36f1aa490c1da053$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.VERSION = (0, $95be4ecd446de127$export$a4ad2735b021c132);
$747d656b899e6115$var$axios.toFormData = (0, $19044a9fa7281693$export$2e2bcd8739ae039);
// Expose AxiosError class
$747d656b899e6115$var$axios.AxiosError = (0, $b9cc6960093b095e$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$747d656b899e6115$var$axios.Cancel = $747d656b899e6115$var$axios.CanceledError;
// Expose all/spread
$747d656b899e6115$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$747d656b899e6115$var$axios.spread = (0, $8145c4b68bfee186$export$2e2bcd8739ae039);
// Expose isAxiosError
$747d656b899e6115$var$axios.isAxiosError = (0, $ec03acb464b74212$export$2e2bcd8739ae039);
// Expose mergeConfig
$747d656b899e6115$var$axios.mergeConfig = (0, $3d132bbf7812485b$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.AxiosHeaders = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.formToJSON = (thing)=>(0, $24febbb5d340c733$export$2e2bcd8739ae039)((0, $77146a31cb578292$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$747d656b899e6115$var$axios.getAdapter = (0, $c036c406f3928265$export$2e2bcd8739ae039).getAdapter;
$747d656b899e6115$var$axios.HttpStatusCode = (0, $a9353565c2e0947e$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.default = $747d656b899e6115$var$axios;
var // this module should only have a default export
$747d656b899e6115$export$2e2bcd8739ae039 = $747d656b899e6115$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $c6ba0193c6fadd6f$export$1c00760e9e5a4e95, AxiosError: $c6ba0193c6fadd6f$export$c1fbed17c2f6a328, CanceledError: $c6ba0193c6fadd6f$export$1ab0c6b20d94fa14, isCancel: $c6ba0193c6fadd6f$export$3b22524397b493c6, CancelToken: $c6ba0193c6fadd6f$export$fd08e3cb425f0d61, VERSION: $c6ba0193c6fadd6f$export$a4ad2735b021c132, all: $c6ba0193c6fadd6f$export$84bf76cd7afc7469, Cancel: $c6ba0193c6fadd6f$export$848c9b7ead0df967, isAxiosError: $c6ba0193c6fadd6f$export$fbafdbe06a5b5a9a, spread: $c6ba0193c6fadd6f$export$3ae0fd4797ed47c8, toFormData: $c6ba0193c6fadd6f$export$10ae0d317ea97f8b, AxiosHeaders: $c6ba0193c6fadd6f$export$4e7d6ff0f3e6520, HttpStatusCode: $c6ba0193c6fadd6f$export$a972f69c851492b3, formToJSON: $c6ba0193c6fadd6f$export$86d7c59254d6a2c9, getAdapter: $c6ba0193c6fadd6f$export$17ddc20a97d669e2, mergeConfig: $c6ba0193c6fadd6f$export$7ec1ebcfa9d8bd6a, create: $c6ba0193c6fadd6f$export$185802fd694ee1f5 } = (0, $747d656b899e6115$export$2e2bcd8739ae039);


var $3cc271bb186f0140$exports = {};
'use strict';
var $fdae59e8868608a5$exports = {};
'use strict';
var $591015a6910ac79e$exports = {};
'use strict';
var $456db8ea475d5b38$exports = {};
'use strict';
/** @type {import('./type')} */ $456db8ea475d5b38$exports = TypeError;


var $4c38295599b865d4$exports = {};
var $4c38295599b865d4$var$hasMap = typeof Map === 'function' && Map.prototype;
var $4c38295599b865d4$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $4c38295599b865d4$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $4c38295599b865d4$var$mapSize = $4c38295599b865d4$var$hasMap && $4c38295599b865d4$var$mapSizeDescriptor && typeof $4c38295599b865d4$var$mapSizeDescriptor.get === 'function' ? $4c38295599b865d4$var$mapSizeDescriptor.get : null;
var $4c38295599b865d4$var$mapForEach = $4c38295599b865d4$var$hasMap && Map.prototype.forEach;
var $4c38295599b865d4$var$hasSet = typeof Set === 'function' && Set.prototype;
var $4c38295599b865d4$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $4c38295599b865d4$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $4c38295599b865d4$var$setSize = $4c38295599b865d4$var$hasSet && $4c38295599b865d4$var$setSizeDescriptor && typeof $4c38295599b865d4$var$setSizeDescriptor.get === 'function' ? $4c38295599b865d4$var$setSizeDescriptor.get : null;
var $4c38295599b865d4$var$setForEach = $4c38295599b865d4$var$hasSet && Set.prototype.forEach;
var $4c38295599b865d4$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $4c38295599b865d4$var$weakMapHas = $4c38295599b865d4$var$hasWeakMap ? WeakMap.prototype.has : null;
var $4c38295599b865d4$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $4c38295599b865d4$var$weakSetHas = $4c38295599b865d4$var$hasWeakSet ? WeakSet.prototype.has : null;
var $4c38295599b865d4$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $4c38295599b865d4$var$weakRefDeref = $4c38295599b865d4$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $4c38295599b865d4$var$booleanValueOf = Boolean.prototype.valueOf;
var $4c38295599b865d4$var$objectToString = Object.prototype.toString;
var $4c38295599b865d4$var$functionToString = Function.prototype.toString;
var $4c38295599b865d4$var$$match = String.prototype.match;
var $4c38295599b865d4$var$$slice = String.prototype.slice;
var $4c38295599b865d4$var$$replace = String.prototype.replace;
var $4c38295599b865d4$var$$toUpperCase = String.prototype.toUpperCase;
var $4c38295599b865d4$var$$toLowerCase = String.prototype.toLowerCase;
var $4c38295599b865d4$var$$test = RegExp.prototype.test;
var $4c38295599b865d4$var$$concat = Array.prototype.concat;
var $4c38295599b865d4$var$$join = Array.prototype.join;
var $4c38295599b865d4$var$$arrSlice = Array.prototype.slice;
var $4c38295599b865d4$var$$floor = Math.floor;
var $4c38295599b865d4$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $4c38295599b865d4$var$gOPS = Object.getOwnPropertySymbols;
var $4c38295599b865d4$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $4c38295599b865d4$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $4c38295599b865d4$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $4c38295599b865d4$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $4c38295599b865d4$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $4c38295599b865d4$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $4c38295599b865d4$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $4c38295599b865d4$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$4c38295599b865d4$var$$floor(-num) : $4c38295599b865d4$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $4c38295599b865d4$var$$slice.call(str, intStr.length + 1);
            return $4c38295599b865d4$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $4c38295599b865d4$var$$replace.call($4c38295599b865d4$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $4c38295599b865d4$var$$replace.call(str, sepRegex, '$&_');
}
var $d482898a2941eea9$exports = {};
"use strict";


var $4c38295599b865d4$var$inspectCustom = $d482898a2941eea9$exports.custom;
var $4c38295599b865d4$var$inspectSymbol = $4c38295599b865d4$var$isSymbol($4c38295599b865d4$var$inspectCustom) ? $4c38295599b865d4$var$inspectCustom : null;
var $4c38295599b865d4$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $4c38295599b865d4$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
$4c38295599b865d4$exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($4c38295599b865d4$var$has(opts, 'quoteStyle') && !$4c38295599b865d4$var$has($4c38295599b865d4$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($4c38295599b865d4$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $4c38295599b865d4$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($4c38295599b865d4$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($4c38295599b865d4$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $4c38295599b865d4$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $4c38295599b865d4$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $4c38295599b865d4$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $4c38295599b865d4$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $4c38295599b865d4$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($4c38295599b865d4$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $4c38295599b865d4$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($4c38295599b865d4$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$4c38295599b865d4$var$isRegExp(obj)) {
        var name = $4c38295599b865d4$var$nameOf(obj);
        var keys = $4c38295599b865d4$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $4c38295599b865d4$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($4c38295599b865d4$var$isSymbol(obj)) {
        var symString = $4c38295599b865d4$var$hasShammedSymbols ? $4c38295599b865d4$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $4c38295599b865d4$var$symToString.call(obj);
        return typeof obj === 'object' && !$4c38295599b865d4$var$hasShammedSymbols ? $4c38295599b865d4$var$markBoxed(symString) : symString;
    }
    if ($4c38295599b865d4$var$isElement(obj)) {
        var s = '<' + $4c38295599b865d4$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $4c38295599b865d4$var$wrapQuotes($4c38295599b865d4$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $4c38295599b865d4$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($4c38295599b865d4$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $4c38295599b865d4$var$arrObjKeys(obj, inspect);
        if (indent && !$4c38295599b865d4$var$singleLineValues(xs)) return '[' + $4c38295599b865d4$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $4c38295599b865d4$var$$join.call(xs, ', ') + ' ]';
    }
    if ($4c38295599b865d4$var$isError(obj)) {
        var parts = $4c38295599b865d4$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$4c38295599b865d4$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $4c38295599b865d4$var$$join.call($4c38295599b865d4$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $4c38295599b865d4$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($4c38295599b865d4$var$inspectSymbol && typeof obj[$4c38295599b865d4$var$inspectSymbol] === 'function' && $d482898a2941eea9$exports) return $d482898a2941eea9$exports(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($4c38295599b865d4$var$isMap(obj)) {
        var mapParts = [];
        if ($4c38295599b865d4$var$mapForEach) $4c38295599b865d4$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $4c38295599b865d4$var$collectionOf('Map', $4c38295599b865d4$var$mapSize.call(obj), mapParts, indent);
    }
    if ($4c38295599b865d4$var$isSet(obj)) {
        var setParts = [];
        if ($4c38295599b865d4$var$setForEach) $4c38295599b865d4$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $4c38295599b865d4$var$collectionOf('Set', $4c38295599b865d4$var$setSize.call(obj), setParts, indent);
    }
    if ($4c38295599b865d4$var$isWeakMap(obj)) return $4c38295599b865d4$var$weakCollectionOf('WeakMap');
    if ($4c38295599b865d4$var$isWeakSet(obj)) return $4c38295599b865d4$var$weakCollectionOf('WeakSet');
    if ($4c38295599b865d4$var$isWeakRef(obj)) return $4c38295599b865d4$var$weakCollectionOf('WeakRef');
    if ($4c38295599b865d4$var$isNumber(obj)) return $4c38295599b865d4$var$markBoxed(inspect(Number(obj)));
    if ($4c38295599b865d4$var$isBigInt(obj)) return $4c38295599b865d4$var$markBoxed(inspect($4c38295599b865d4$var$bigIntValueOf.call(obj)));
    if ($4c38295599b865d4$var$isBoolean(obj)) return $4c38295599b865d4$var$markBoxed($4c38295599b865d4$var$booleanValueOf.call(obj));
    if ($4c38295599b865d4$var$isString(obj)) return $4c38295599b865d4$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$4c38295599b865d4$var$isDate(obj) && !$4c38295599b865d4$var$isRegExp(obj)) {
        var ys = $4c38295599b865d4$var$arrObjKeys(obj, inspect);
        var isPlainObject = $4c38295599b865d4$var$gPO ? $4c38295599b865d4$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $4c38295599b865d4$var$toStringTag && Object(obj) === obj && $4c38295599b865d4$var$toStringTag in obj ? $4c38295599b865d4$var$$slice.call($4c38295599b865d4$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $4c38295599b865d4$var$$join.call($4c38295599b865d4$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $4c38295599b865d4$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $4c38295599b865d4$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $4c38295599b865d4$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $4c38295599b865d4$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $4c38295599b865d4$var$quote(s) {
    return $4c38295599b865d4$var$$replace.call(String(s), /"/g, '&quot;');
}
function $4c38295599b865d4$var$canTrustToString(obj) {
    return !$4c38295599b865d4$var$toStringTag || !(typeof obj === 'object' && ($4c38295599b865d4$var$toStringTag in obj || typeof obj[$4c38295599b865d4$var$toStringTag] !== 'undefined'));
}
function $4c38295599b865d4$var$isArray(obj) {
    return $4c38295599b865d4$var$toStr(obj) === '[object Array]' && $4c38295599b865d4$var$canTrustToString(obj);
}
function $4c38295599b865d4$var$isDate(obj) {
    return $4c38295599b865d4$var$toStr(obj) === '[object Date]' && $4c38295599b865d4$var$canTrustToString(obj);
}
function $4c38295599b865d4$var$isRegExp(obj) {
    return $4c38295599b865d4$var$toStr(obj) === '[object RegExp]' && $4c38295599b865d4$var$canTrustToString(obj);
}
function $4c38295599b865d4$var$isError(obj) {
    return $4c38295599b865d4$var$toStr(obj) === '[object Error]' && $4c38295599b865d4$var$canTrustToString(obj);
}
function $4c38295599b865d4$var$isString(obj) {
    return $4c38295599b865d4$var$toStr(obj) === '[object String]' && $4c38295599b865d4$var$canTrustToString(obj);
}
function $4c38295599b865d4$var$isNumber(obj) {
    return $4c38295599b865d4$var$toStr(obj) === '[object Number]' && $4c38295599b865d4$var$canTrustToString(obj);
}
function $4c38295599b865d4$var$isBoolean(obj) {
    return $4c38295599b865d4$var$toStr(obj) === '[object Boolean]' && $4c38295599b865d4$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $4c38295599b865d4$var$isSymbol(obj) {
    if ($4c38295599b865d4$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$4c38295599b865d4$var$symToString) return false;
    try {
        $4c38295599b865d4$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $4c38295599b865d4$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$4c38295599b865d4$var$bigIntValueOf) return false;
    try {
        $4c38295599b865d4$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $4c38295599b865d4$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $4c38295599b865d4$var$has(obj, key) {
    return $4c38295599b865d4$var$hasOwn.call(obj, key);
}
function $4c38295599b865d4$var$toStr(obj) {
    return $4c38295599b865d4$var$objectToString.call(obj);
}
function $4c38295599b865d4$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $4c38295599b865d4$var$$match.call($4c38295599b865d4$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $4c38295599b865d4$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $4c38295599b865d4$var$isMap(x) {
    if (!$4c38295599b865d4$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $4c38295599b865d4$var$mapSize.call(x);
        try {
            $4c38295599b865d4$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $4c38295599b865d4$var$isWeakMap(x) {
    if (!$4c38295599b865d4$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $4c38295599b865d4$var$weakMapHas.call(x, $4c38295599b865d4$var$weakMapHas);
        try {
            $4c38295599b865d4$var$weakSetHas.call(x, $4c38295599b865d4$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $4c38295599b865d4$var$isWeakRef(x) {
    if (!$4c38295599b865d4$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $4c38295599b865d4$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $4c38295599b865d4$var$isSet(x) {
    if (!$4c38295599b865d4$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $4c38295599b865d4$var$setSize.call(x);
        try {
            $4c38295599b865d4$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $4c38295599b865d4$var$isWeakSet(x) {
    if (!$4c38295599b865d4$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $4c38295599b865d4$var$weakSetHas.call(x, $4c38295599b865d4$var$weakSetHas);
        try {
            $4c38295599b865d4$var$weakMapHas.call(x, $4c38295599b865d4$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $4c38295599b865d4$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $4c38295599b865d4$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $4c38295599b865d4$var$inspectString($4c38295599b865d4$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $4c38295599b865d4$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $4c38295599b865d4$var$$replace.call($4c38295599b865d4$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $4c38295599b865d4$var$lowbyte);
    return $4c38295599b865d4$var$wrapQuotes(s, 'single', opts);
}
function $4c38295599b865d4$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $4c38295599b865d4$var$$toUpperCase.call(n.toString(16));
}
function $4c38295599b865d4$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $4c38295599b865d4$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $4c38295599b865d4$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $4c38295599b865d4$var$indentedJoin(entries, indent) : $4c38295599b865d4$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $4c38295599b865d4$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($4c38295599b865d4$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $4c38295599b865d4$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $4c38295599b865d4$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $4c38295599b865d4$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $4c38295599b865d4$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $4c38295599b865d4$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $4c38295599b865d4$var$arrObjKeys(obj, inspect) {
    var isArr = $4c38295599b865d4$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $4c38295599b865d4$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $4c38295599b865d4$var$gOPS === 'function' ? $4c38295599b865d4$var$gOPS(obj) : [];
    var symMap;
    if ($4c38295599b865d4$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$4c38295599b865d4$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($4c38295599b865d4$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($4c38295599b865d4$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $4c38295599b865d4$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($4c38295599b865d4$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}


var $d843fc9a8940edc7$exports = {};
'use strict';


/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $d843fc9a8940edc7$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $d843fc9a8940edc7$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $d843fc9a8940edc7$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $d843fc9a8940edc7$var$listSet = function(objects, key, value) {
    var node = $d843fc9a8940edc7$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $d843fc9a8940edc7$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$d843fc9a8940edc7$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $d843fc9a8940edc7$var$listDelete = function(objects, key) {
    if (objects) return $d843fc9a8940edc7$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ $d843fc9a8940edc7$exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $456db8ea475d5b38$exports('Side channel does not contain ' + $4c38295599b865d4$exports(key));
        },
        'delete': function(key) {
            var deletedNode = $d843fc9a8940edc7$var$listDelete($o, key);
            if (deletedNode && $o && !$o.next) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $d843fc9a8940edc7$var$listGet($o, key);
        },
        has: function(key) {
            return $d843fc9a8940edc7$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $d843fc9a8940edc7$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    return channel;
};


var $7a4b2f671249ac2e$exports = {};
'use strict';
var $c9eac16840c8f75d$exports = {};
'use strict';
var $c9eac16840c8f75d$var$undefined1;
var $7c1951c4b2f3c17d$exports = {};
'use strict';
/** @type {import('.')} */ $7c1951c4b2f3c17d$exports = Object;


var $4c289fff3dbfe702$exports = {};
'use strict';
/** @type {import('.')} */ $4c289fff3dbfe702$exports = Error;


var $0a4964b05b1da8ca$exports = {};
'use strict';
/** @type {import('./eval')} */ $0a4964b05b1da8ca$exports = EvalError;


var $4964a75e50e99def$exports = {};
'use strict';
/** @type {import('./range')} */ $4964a75e50e99def$exports = RangeError;


var $dd6d636093909a48$exports = {};
'use strict';
/** @type {import('./ref')} */ $dd6d636093909a48$exports = ReferenceError;


var $8629a6899cc471af$exports = {};
'use strict';
/** @type {import('./syntax')} */ $8629a6899cc471af$exports = SyntaxError;



var $4665c77f41985b28$exports = {};
'use strict';
/** @type {import('./uri')} */ $4665c77f41985b28$exports = URIError;


var $d77946e494e1a15b$exports = {};
'use strict';
/** @type {import('./abs')} */ $d77946e494e1a15b$exports = Math.abs;


var $3ba51078a8473c97$exports = {};
'use strict';
/** @type {import('./floor')} */ $3ba51078a8473c97$exports = Math.floor;


var $65f5c63815a4ddf6$exports = {};
'use strict';
/** @type {import('./max')} */ $65f5c63815a4ddf6$exports = Math.max;


var $8ffac5907fd8a96b$exports = {};
'use strict';
/** @type {import('./min')} */ $8ffac5907fd8a96b$exports = Math.min;


var $a515e4e1bc435e87$exports = {};
'use strict';
/** @type {import('./pow')} */ $a515e4e1bc435e87$exports = Math.pow;


var $0c63b5a7ad425301$exports = {};
'use strict';
/** @type {import('./round')} */ $0c63b5a7ad425301$exports = Math.round;


var $bac1fb4df5a4e010$exports = {};
'use strict';
var $6069165344808e6b$exports = {};
'use strict';
/** @type {import('./isNaN')} */ $6069165344808e6b$exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};


/** @type {import('./sign')} */ $bac1fb4df5a4e010$exports = function sign(number) {
    if ($6069165344808e6b$exports(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};


var $c9eac16840c8f75d$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $c9eac16840c8f75d$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $c9eac16840c8f75d$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};
var $c3b59e512f612c17$exports = {};
'use strict';
var $5e95c0005cc82bbe$exports = {};
'use strict';
/** @type {import('./gOPD')} */ $5e95c0005cc82bbe$exports = Object.getOwnPropertyDescriptor;


var $c3b59e512f612c17$require$$gOPD = $5e95c0005cc82bbe$exports;
if ($c3b59e512f612c17$require$$gOPD) try {
    $c3b59e512f612c17$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $c3b59e512f612c17$require$$gOPD = null;
}
$c3b59e512f612c17$exports = $c3b59e512f612c17$require$$gOPD;


var $88f2749ea03868eb$exports = {};
'use strict';
/** @type {import('.')} */ var $88f2749ea03868eb$var$$defineProperty = Object.defineProperty || false;
if ($88f2749ea03868eb$var$$defineProperty) try {
    $88f2749ea03868eb$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $88f2749ea03868eb$var$$defineProperty = false;
}
$88f2749ea03868eb$exports = $88f2749ea03868eb$var$$defineProperty;


var $c9eac16840c8f75d$var$throwTypeError = function() {
    throw new $456db8ea475d5b38$exports();
};
var $c9eac16840c8f75d$var$ThrowTypeError = $c3b59e512f612c17$exports ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $c9eac16840c8f75d$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $c3b59e512f612c17$exports(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $c9eac16840c8f75d$var$throwTypeError;
        }
    }
}() : $c9eac16840c8f75d$var$throwTypeError;

var $c9eac16840c8f75d$var$hasSymbols = (parcelRequire("4qQ7b"))();
var $8187c11d1adeed98$exports = {};
'use strict';
var $139c9bd688b984c3$exports = {};
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ $139c9bd688b984c3$exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;


var $32842c400960be12$exports = {};
'use strict';

/** @type {import('./Object.getPrototypeOf')} */ $32842c400960be12$exports = $7c1951c4b2f3c17d$exports.getPrototypeOf || null;


var $1b87f3939656d8ea$exports = {};
'use strict';
var $3bf04cffe190ee6b$exports = {};
'use strict';
var $acdbd3c294de9ddc$exports = {};
'use strict';
var $bd52800b6fae4c57$exports = {};
'use strict';
/* eslint no-invalid-this: 1 */ var $bd52800b6fae4c57$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $bd52800b6fae4c57$var$toStr = Object.prototype.toString;
var $bd52800b6fae4c57$var$max = Math.max;
var $bd52800b6fae4c57$var$funcType = '[object Function]';
var $bd52800b6fae4c57$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $bd52800b6fae4c57$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $bd52800b6fae4c57$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
$bd52800b6fae4c57$exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $bd52800b6fae4c57$var$toStr.apply(target) !== $bd52800b6fae4c57$var$funcType) throw new TypeError($bd52800b6fae4c57$var$ERROR_MESSAGE + target);
    var args = $bd52800b6fae4c57$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $bd52800b6fae4c57$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $bd52800b6fae4c57$var$concatty(args, arguments));
    };
    var boundLength = $bd52800b6fae4c57$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $bd52800b6fae4c57$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};


$acdbd3c294de9ddc$exports = Function.prototype.bind || $bd52800b6fae4c57$exports;



var $8a642d9521ce95b0$exports = {};
'use strict';
/** @type {import('./functionCall')} */ $8a642d9521ce95b0$exports = Function.prototype.call;


var $00d73abda794e5f4$exports = {};
'use strict';

var $7fdad5d228268c18$exports = {};
'use strict';
/** @type {import('./functionApply')} */ $7fdad5d228268c18$exports = Function.prototype.apply;



var $ba0bd9e0f090f4ee$exports = {};
'use strict';
/** @type {import('./reflectApply')} */ $ba0bd9e0f090f4ee$exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/** @type {import('./actualApply')} */ $00d73abda794e5f4$exports = $ba0bd9e0f090f4ee$exports || $acdbd3c294de9ddc$exports.call($8a642d9521ce95b0$exports, $7fdad5d228268c18$exports);


/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ $3bf04cffe190ee6b$exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $456db8ea475d5b38$exports('a function is required');
    return $00d73abda794e5f4$exports($acdbd3c294de9ddc$exports, $8a642d9521ce95b0$exports, args);
};



var $1b87f3939656d8ea$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $1b87f3939656d8ea$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $1b87f3939656d8ea$var$desc = !!$1b87f3939656d8ea$var$hasProtoAccessor && $c3b59e512f612c17$exports && $c3b59e512f612c17$exports(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $1b87f3939656d8ea$var$$Object = Object;
var $1b87f3939656d8ea$var$$getPrototypeOf = $1b87f3939656d8ea$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ $1b87f3939656d8ea$exports = $1b87f3939656d8ea$var$desc && typeof $1b87f3939656d8ea$var$desc.get === 'function' ? $3bf04cffe190ee6b$exports([
    $1b87f3939656d8ea$var$desc.get
]) : typeof $1b87f3939656d8ea$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $1b87f3939656d8ea$var$$getPrototypeOf(value == null ? value : $1b87f3939656d8ea$var$$Object(value));
} : false;


/** @type {import('.')} */ $8187c11d1adeed98$exports = $139c9bd688b984c3$exports ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $139c9bd688b984c3$exports(O);
} : $32842c400960be12$exports ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $32842c400960be12$exports(O);
} : $1b87f3939656d8ea$exports ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $1b87f3939656d8ea$exports(O);
} : null;






var $c9eac16840c8f75d$var$needsEval = {};
var $c9eac16840c8f75d$var$TypedArray = typeof Uint8Array === 'undefined' || !$8187c11d1adeed98$exports ? undefined : $8187c11d1adeed98$exports(Uint8Array);
var $c9eac16840c8f75d$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $c9eac16840c8f75d$var$hasSymbols && $8187c11d1adeed98$exports ? $8187c11d1adeed98$exports([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $c9eac16840c8f75d$var$needsEval,
    '%AsyncGenerator%': $c9eac16840c8f75d$var$needsEval,
    '%AsyncGeneratorFunction%': $c9eac16840c8f75d$var$needsEval,
    '%AsyncIteratorPrototype%': $c9eac16840c8f75d$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $4c289fff3dbfe702$exports,
    '%eval%': eval,
    '%EvalError%': $0a4964b05b1da8ca$exports,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $c9eac16840c8f75d$var$$Function,
    '%GeneratorFunction%': $c9eac16840c8f75d$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $c9eac16840c8f75d$var$hasSymbols && $8187c11d1adeed98$exports ? $8187c11d1adeed98$exports($8187c11d1adeed98$exports([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$c9eac16840c8f75d$var$hasSymbols || !$8187c11d1adeed98$exports ? undefined : $8187c11d1adeed98$exports(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $7c1951c4b2f3c17d$exports,
    '%Object.getOwnPropertyDescriptor%': $c3b59e512f612c17$exports,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $4964a75e50e99def$exports,
    '%ReferenceError%': $dd6d636093909a48$exports,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$c9eac16840c8f75d$var$hasSymbols || !$8187c11d1adeed98$exports ? undefined : $8187c11d1adeed98$exports(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $c9eac16840c8f75d$var$hasSymbols && $8187c11d1adeed98$exports ? $8187c11d1adeed98$exports(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $c9eac16840c8f75d$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $8629a6899cc471af$exports,
    '%ThrowTypeError%': $c9eac16840c8f75d$var$ThrowTypeError,
    '%TypedArray%': $c9eac16840c8f75d$var$TypedArray,
    '%TypeError%': $456db8ea475d5b38$exports,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $4665c77f41985b28$exports,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $8a642d9521ce95b0$exports,
    '%Function.prototype.apply%': $7fdad5d228268c18$exports,
    '%Object.defineProperty%': $88f2749ea03868eb$exports,
    '%Object.getPrototypeOf%': $32842c400960be12$exports,
    '%Math.abs%': $d77946e494e1a15b$exports,
    '%Math.floor%': $3ba51078a8473c97$exports,
    '%Math.max%': $65f5c63815a4ddf6$exports,
    '%Math.min%': $8ffac5907fd8a96b$exports,
    '%Math.pow%': $a515e4e1bc435e87$exports,
    '%Math.round%': $0c63b5a7ad425301$exports,
    '%Math.sign%': $bac1fb4df5a4e010$exports,
    '%Reflect.getPrototypeOf%': $139c9bd688b984c3$exports
};
if ($8187c11d1adeed98$exports) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $c9eac16840c8f75d$var$errorProto = $8187c11d1adeed98$exports($8187c11d1adeed98$exports(e));
    $c9eac16840c8f75d$var$INTRINSICS['%Error.prototype%'] = $c9eac16840c8f75d$var$errorProto;
}
var $c9eac16840c8f75d$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $c9eac16840c8f75d$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $c9eac16840c8f75d$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $c9eac16840c8f75d$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $8187c11d1adeed98$exports) value = $8187c11d1adeed98$exports(gen.prototype);
    }
    $c9eac16840c8f75d$var$INTRINSICS[name] = value;
    return value;
};
var $c9eac16840c8f75d$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $5f5a0fe320c1ef2a$exports = {};
'use strict';
var $5f5a0fe320c1ef2a$var$call = Function.prototype.call;
var $5f5a0fe320c1ef2a$var$$hasOwn = Object.prototype.hasOwnProperty;

/** @type {import('.')} */ $5f5a0fe320c1ef2a$exports = $acdbd3c294de9ddc$exports.call($5f5a0fe320c1ef2a$var$call, $5f5a0fe320c1ef2a$var$$hasOwn);


var $c9eac16840c8f75d$var$$concat = $acdbd3c294de9ddc$exports.call($8a642d9521ce95b0$exports, Array.prototype.concat);
var $c9eac16840c8f75d$var$$spliceApply = $acdbd3c294de9ddc$exports.call($7fdad5d228268c18$exports, Array.prototype.splice);
var $c9eac16840c8f75d$var$$replace = $acdbd3c294de9ddc$exports.call($8a642d9521ce95b0$exports, String.prototype.replace);
var $c9eac16840c8f75d$var$$strSlice = $acdbd3c294de9ddc$exports.call($8a642d9521ce95b0$exports, String.prototype.slice);
var $c9eac16840c8f75d$var$$exec = $acdbd3c294de9ddc$exports.call($8a642d9521ce95b0$exports, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $c9eac16840c8f75d$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $c9eac16840c8f75d$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $c9eac16840c8f75d$var$stringToPath = function stringToPath(string) {
    var first = $c9eac16840c8f75d$var$$strSlice(string, 0, 1);
    var last = $c9eac16840c8f75d$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $8629a6899cc471af$exports('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $8629a6899cc471af$exports('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $c9eac16840c8f75d$var$$replace(string, $c9eac16840c8f75d$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $c9eac16840c8f75d$var$$replace(subString, $c9eac16840c8f75d$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $c9eac16840c8f75d$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($5f5a0fe320c1ef2a$exports($c9eac16840c8f75d$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $c9eac16840c8f75d$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($5f5a0fe320c1ef2a$exports($c9eac16840c8f75d$var$INTRINSICS, intrinsicName)) {
        var value = $c9eac16840c8f75d$var$INTRINSICS[intrinsicName];
        if (value === $c9eac16840c8f75d$var$needsEval) value = $c9eac16840c8f75d$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $456db8ea475d5b38$exports('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $8629a6899cc471af$exports('intrinsic ' + name + ' does not exist!');
};
$c9eac16840c8f75d$exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $456db8ea475d5b38$exports('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $456db8ea475d5b38$exports('"allowMissing" argument must be a boolean');
    if ($c9eac16840c8f75d$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $8629a6899cc471af$exports('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $c9eac16840c8f75d$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $c9eac16840c8f75d$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $c9eac16840c8f75d$var$$spliceApply(parts, $c9eac16840c8f75d$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $c9eac16840c8f75d$var$$strSlice(part, 0, 1);
        var last = $c9eac16840c8f75d$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $8629a6899cc471af$exports('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($5f5a0fe320c1ef2a$exports($c9eac16840c8f75d$var$INTRINSICS, intrinsicRealName)) value = $c9eac16840c8f75d$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $456db8ea475d5b38$exports('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($c3b59e512f612c17$exports && i + 1 >= parts.length) {
                var desc = $c3b59e512f612c17$exports(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $5f5a0fe320c1ef2a$exports(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $c9eac16840c8f75d$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};


var $aa3764525413497a$exports = {};
'use strict';


/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $aa3764525413497a$var$$indexOf = $3bf04cffe190ee6b$exports([
    $c9eac16840c8f75d$exports('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ $aa3764525413497a$exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $c9eac16840c8f75d$exports(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $aa3764525413497a$var$$indexOf(name, '.prototype.') > -1) return $3bf04cffe190ee6b$exports(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};




var $7a4b2f671249ac2e$var$$Map = $c9eac16840c8f75d$exports('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $7a4b2f671249ac2e$var$$mapGet = $aa3764525413497a$exports('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $7a4b2f671249ac2e$var$$mapSet = $aa3764525413497a$exports('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $7a4b2f671249ac2e$var$$mapHas = $aa3764525413497a$exports('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $7a4b2f671249ac2e$var$$mapDelete = $aa3764525413497a$exports('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $7a4b2f671249ac2e$var$$mapSize = $aa3764525413497a$exports('Map.prototype.size', true);
/** @type {import('.')} */ $7a4b2f671249ac2e$exports = !!$7a4b2f671249ac2e$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $456db8ea475d5b38$exports('Side channel does not contain ' + $4c38295599b865d4$exports(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $7a4b2f671249ac2e$var$$mapDelete($m, key);
                if ($7a4b2f671249ac2e$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $7a4b2f671249ac2e$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $7a4b2f671249ac2e$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $7a4b2f671249ac2e$var$$Map();
            $7a4b2f671249ac2e$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};


var $1bb87b485acc2d8c$exports = {};
'use strict';





var $1bb87b485acc2d8c$var$$WeakMap = $c9eac16840c8f75d$exports('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $1bb87b485acc2d8c$var$$weakMapGet = $aa3764525413497a$exports('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $1bb87b485acc2d8c$var$$weakMapSet = $aa3764525413497a$exports('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $1bb87b485acc2d8c$var$$weakMapHas = $aa3764525413497a$exports('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $1bb87b485acc2d8c$var$$weakMapDelete = $aa3764525413497a$exports('WeakMap.prototype.delete', true);
/** @type {import('.')} */ $1bb87b485acc2d8c$exports = $1bb87b485acc2d8c$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $456db8ea475d5b38$exports('Side channel does not contain ' + $4c38295599b865d4$exports(key));
        },
        'delete': function(key) {
            if ($1bb87b485acc2d8c$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $1bb87b485acc2d8c$var$$weakMapDelete($wm, key);
            } else if ($7a4b2f671249ac2e$exports) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($1bb87b485acc2d8c$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $1bb87b485acc2d8c$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($1bb87b485acc2d8c$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $1bb87b485acc2d8c$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($1bb87b485acc2d8c$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $1bb87b485acc2d8c$var$$WeakMap();
                $1bb87b485acc2d8c$var$$weakMapSet($wm, key, value);
            } else if ($7a4b2f671249ac2e$exports) {
                if (!$m) $m = $7a4b2f671249ac2e$exports();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $7a4b2f671249ac2e$exports;


var $591015a6910ac79e$var$makeChannel = $1bb87b485acc2d8c$exports || $7a4b2f671249ac2e$exports || $d843fc9a8940edc7$exports;
/** @type {import('.')} */ $591015a6910ac79e$exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) {
                var keyDesc = key && Object(key) === key ? 'the given object key' : $4c38295599b865d4$exports(key);
                throw new $456db8ea475d5b38$exports('Side channel does not contain ' + keyDesc);
            }
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $591015a6910ac79e$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    return channel;
};


var $1b97d0b055bc5f8c$exports = {};
'use strict';
var $8534d4a11448cf7e$exports = {};
'use strict';
var $8534d4a11448cf7e$var$replace = String.prototype.replace;
var $8534d4a11448cf7e$var$percentTwenties = /%20/g;
var $8534d4a11448cf7e$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
$8534d4a11448cf7e$exports = {
    'default': $8534d4a11448cf7e$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $8534d4a11448cf7e$var$replace.call(value, $8534d4a11448cf7e$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $8534d4a11448cf7e$var$Format.RFC1738,
    RFC3986: $8534d4a11448cf7e$var$Format.RFC3986
};




var $1b97d0b055bc5f8c$var$has = Object.prototype.hasOwnProperty;
var $1b97d0b055bc5f8c$var$isArray = Array.isArray;
// Track objects created from arrayLimit overflow using side-channel
// Stores the current max numeric index for O(1) lookup
var $1b97d0b055bc5f8c$var$overflowChannel = $591015a6910ac79e$exports();
var $1b97d0b055bc5f8c$var$markOverflow = function markOverflow(obj, maxIndex) {
    $1b97d0b055bc5f8c$var$overflowChannel.set(obj, maxIndex);
    return obj;
};
var $1b97d0b055bc5f8c$var$isOverflow = function isOverflow(obj) {
    return $1b97d0b055bc5f8c$var$overflowChannel.has(obj);
};
var $1b97d0b055bc5f8c$var$getMaxIndex = function getMaxIndex(obj) {
    return $1b97d0b055bc5f8c$var$overflowChannel.get(obj);
};
var $1b97d0b055bc5f8c$var$setMaxIndex = function setMaxIndex(obj, maxIndex) {
    $1b97d0b055bc5f8c$var$overflowChannel.set(obj, maxIndex);
};
var $1b97d0b055bc5f8c$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array[array.length] = '%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase();
    return array;
}();
var $1b97d0b055bc5f8c$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($1b97d0b055bc5f8c$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted[compacted.length] = obj[j];
            item.obj[item.prop] = compacted;
        }
    }
};
var $1b97d0b055bc5f8c$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $1b97d0b055bc5f8c$var$setProperty = function setProperty(obj, key, value) {
    if (key === '__proto__' && $88f2749ea03868eb$exports) $88f2749ea03868eb$exports(obj, key, {
        configurable: true,
        enumerable: true,
        value: value,
        writable: true
    });
    else obj[key] = value;
};
var $1b97d0b055bc5f8c$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($1b97d0b055bc5f8c$var$isArray(target)) {
            var nextIndex = target.length;
            if (options && typeof options.arrayLimit === 'number' && nextIndex >= options.arrayLimit) {
                if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
                return $1b97d0b055bc5f8c$var$markOverflow($1b97d0b055bc5f8c$var$arrayToObject(target.concat(source), options), nextIndex);
            }
            target[nextIndex] = source;
        } else if (target && typeof target === 'object') {
            if ($1b97d0b055bc5f8c$var$isOverflow(target)) {
                // Add at next numeric index for overflow objects
                var newIndex = $1b97d0b055bc5f8c$var$getMaxIndex(target) + 1;
                target[newIndex] = source;
                $1b97d0b055bc5f8c$var$setMaxIndex(target, newIndex);
            } else if (options && options.strictMerge) return [
                target,
                source
            ];
            else if (options && (options.plainObjects || options.allowPrototypes) || !$1b97d0b055bc5f8c$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') {
        if ($1b97d0b055bc5f8c$var$isOverflow(source)) {
            // Create new object with target at 0, source values shifted by 1
            var sourceKeys = Object.keys(source);
            var result = options && options.plainObjects ? {
                __proto__: null,
                0: target
            } : {
                0: target
            };
            for(var m = 0; m < sourceKeys.length; m++){
                var oldKey = parseInt(sourceKeys[m], 10);
                result[oldKey + 1] = source[sourceKeys[m]];
            }
            return $1b97d0b055bc5f8c$var$markOverflow(result, $1b97d0b055bc5f8c$var$getMaxIndex(source) + 1);
        }
        var combined = [
            target
        ].concat(source);
        if (options && typeof options.arrayLimit === 'number' && combined.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            return $1b97d0b055bc5f8c$var$markOverflow($1b97d0b055bc5f8c$var$arrayToObject(combined, options), combined.length - 1);
        }
        return combined;
    }
    var mergeTarget = target;
    if ($1b97d0b055bc5f8c$var$isArray(target) && !$1b97d0b055bc5f8c$var$isArray(source)) mergeTarget = $1b97d0b055bc5f8c$var$arrayToObject(target, options);
    if ($1b97d0b055bc5f8c$var$isArray(target) && $1b97d0b055bc5f8c$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($1b97d0b055bc5f8c$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target[target.length] = item;
            } else target[i] = item;
        });
        if (options && typeof options.arrayLimit === 'number' && target.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            return $1b97d0b055bc5f8c$var$markOverflow($1b97d0b055bc5f8c$var$arrayToObject(target, options), target.length - 1);
        }
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($1b97d0b055bc5f8c$var$has.call(acc, key)) $1b97d0b055bc5f8c$var$setProperty(acc, key, merge(acc[key], value, options));
        else $1b97d0b055bc5f8c$var$setProperty(acc, key, value);
        if ($1b97d0b055bc5f8c$var$isOverflow(source) && !$1b97d0b055bc5f8c$var$isOverflow(acc)) $1b97d0b055bc5f8c$var$markOverflow(acc, $1b97d0b055bc5f8c$var$getMaxIndex(source));
        if ($1b97d0b055bc5f8c$var$isOverflow(acc)) {
            var keyNum = parseInt(key, 10);
            if (String(keyNum) === key && keyNum >= 0 && keyNum > $1b97d0b055bc5f8c$var$getMaxIndex(acc)) $1b97d0b055bc5f8c$var$setMaxIndex(acc, keyNum);
        }
        return acc;
    }, mergeTarget);
};
var $1b97d0b055bc5f8c$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        $1b97d0b055bc5f8c$var$setProperty(acc, key, source[key]);
        return acc;
    }, target);
};
var $1b97d0b055bc5f8c$var$decode = function(str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $1b97d0b055bc5f8c$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $1b97d0b055bc5f8c$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var j = 0; j < string.length; j += $1b97d0b055bc5f8c$var$limit){
        var segment = string.length >= $1b97d0b055bc5f8c$var$limit ? string.slice(j, j + $1b97d0b055bc5f8c$var$limit) : string;
        if (j + $1b97d0b055bc5f8c$var$limit < string.length) {
            var last = segment.charCodeAt(segment.length - 1);
            if (last >= 0xD800 && last <= 0xDBFF) {
                segment = segment.slice(0, -1);
                j -= 1;
            }
        }
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $8534d4a11448cf7e$exports.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $1b97d0b055bc5f8c$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $1b97d0b055bc5f8c$var$hexTable[0xC0 | c >> 6] + $1b97d0b055bc5f8c$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $1b97d0b055bc5f8c$var$hexTable[0xE0 | c >> 12] + $1b97d0b055bc5f8c$var$hexTable[0x80 | c >> 6 & 0x3F] + $1b97d0b055bc5f8c$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $1b97d0b055bc5f8c$var$hexTable[0xF0 | c >> 18] + $1b97d0b055bc5f8c$var$hexTable[0x80 | c >> 12 & 0x3F] + $1b97d0b055bc5f8c$var$hexTable[0x80 | c >> 6 & 0x3F] + $1b97d0b055bc5f8c$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $1b97d0b055bc5f8c$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = $591015a6910ac79e$exports();
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && !refs.has(val)) {
                queue[queue.length] = {
                    obj: obj,
                    prop: key
                };
                refs.set(val, true);
            }
        }
    }
    $1b97d0b055bc5f8c$var$compactQueue(queue);
    return value;
};
var $1b97d0b055bc5f8c$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $1b97d0b055bc5f8c$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj));
};
var $1b97d0b055bc5f8c$var$combine = function combine(a, b, arrayLimit, plainObjects, throwOnLimitExceeded) {
    // If 'a' is already an overflow object, add to it
    if ($1b97d0b055bc5f8c$var$isOverflow(a)) {
        if (throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + arrayLimit + ' element' + (arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
        // spread `b` one level, matching the `[].concat(a, b)` used below, so a
        // collection appended to an already-overflowed object is flattened
        // rather than nested under a single index
        var bValues = $1b97d0b055bc5f8c$var$isArray(b) ? b : [
            b
        ];
        var newIndex = $1b97d0b055bc5f8c$var$getMaxIndex(a);
        for(var i = 0; i < bValues.length; ++i){
            newIndex += 1;
            a[newIndex] = bValues[i];
        }
        $1b97d0b055bc5f8c$var$setMaxIndex(a, newIndex);
        return a;
    }
    var result = [].concat(a, b);
    if (result.length > arrayLimit) {
        if (throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + arrayLimit + ' element' + (arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
        return $1b97d0b055bc5f8c$var$markOverflow($1b97d0b055bc5f8c$var$arrayToObject(result, {
            plainObjects: plainObjects
        }), result.length - 1);
    }
    return result;
};
var $1b97d0b055bc5f8c$var$maybeMap = function maybeMap(val, fn) {
    if ($1b97d0b055bc5f8c$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped[mapped.length] = fn(val[i]);
        return mapped;
    }
    return fn(val);
};
$1b97d0b055bc5f8c$exports = {
    arrayToObject: $1b97d0b055bc5f8c$var$arrayToObject,
    assign: $1b97d0b055bc5f8c$var$assign,
    combine: $1b97d0b055bc5f8c$var$combine,
    compact: $1b97d0b055bc5f8c$var$compact,
    decode: $1b97d0b055bc5f8c$var$decode,
    encode: $1b97d0b055bc5f8c$var$encode,
    isBuffer: $1b97d0b055bc5f8c$var$isBuffer,
    isOverflow: $1b97d0b055bc5f8c$var$isOverflow,
    isRegExp: $1b97d0b055bc5f8c$var$isRegExp,
    markOverflow: $1b97d0b055bc5f8c$var$markOverflow,
    maybeMap: $1b97d0b055bc5f8c$var$maybeMap,
    merge: $1b97d0b055bc5f8c$var$merge
};



var $fdae59e8868608a5$var$has = Object.prototype.hasOwnProperty;
var $fdae59e8868608a5$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $fdae59e8868608a5$var$isArray = Array.isArray;
var $fdae59e8868608a5$var$push = Array.prototype.push;
var $fdae59e8868608a5$var$pushToArray = function(arr, valueOrArray) {
    $fdae59e8868608a5$var$push.apply(arr, $fdae59e8868608a5$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $fdae59e8868608a5$var$toISO = Date.prototype.toISOString;
var $fdae59e8868608a5$var$defaultFormat = $8534d4a11448cf7e$exports.default;
var $fdae59e8868608a5$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    depth: Infinity,
    encode: true,
    encodeDotInKeys: false,
    encoder: $1b97d0b055bc5f8c$exports.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $fdae59e8868608a5$var$defaultFormat,
    formatter: $8534d4a11448cf7e$exports.formatters[$fdae59e8868608a5$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $fdae59e8868608a5$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $fdae59e8868608a5$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $fdae59e8868608a5$var$sentinel = {};
var $fdae59e8868608a5$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel, depth, currentDepth) {
    var obj = object;
    if (currentDepth > depth) throw new RangeError('Input depth exceeded depth option of ' + depth);
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($fdae59e8868608a5$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($fdae59e8868608a5$var$sentinel) === 'undefined') step = 0;
    }
    obj = typeof filter === 'function' ? filter(prefix, obj) : obj;
    if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $fdae59e8868608a5$var$isArray(obj)) obj = $1b97d0b055bc5f8c$exports.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return formatter(encoder && !encodeValuesOnly ? encoder(prefix, $fdae59e8868608a5$var$defaults.encoder, charset, 'key', format) : prefix);
        obj = '';
    }
    if ($fdae59e8868608a5$var$isNonNullishPrimitive(obj) || $1b97d0b055bc5f8c$exports.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $fdae59e8868608a5$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $fdae59e8868608a5$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $fdae59e8868608a5$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $1b97d0b055bc5f8c$exports.maybeMap(obj, function(v) {
            return v == null ? v : encoder(v);
        });
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($fdae59e8868608a5$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    var adjustedPrefix = commaRoundTrip && $fdae59e8868608a5$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $fdae59e8868608a5$var$isArray(obj) && obj.length === 0 && Object.keys(obj).length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $fdae59e8868608a5$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $591015a6910ac79e$exports();
        valueSideChannel.set($fdae59e8868608a5$var$sentinel, sideChannel);
        $fdae59e8868608a5$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $fdae59e8868608a5$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel, depth, currentDepth + 1));
    }
    return values;
};
var $fdae59e8868608a5$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $fdae59e8868608a5$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $fdae59e8868608a5$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $8534d4a11448cf7e$exports.default;
    if (typeof opts.format !== 'undefined') {
        if (!$fdae59e8868608a5$var$has.call($8534d4a11448cf7e$exports.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $8534d4a11448cf7e$exports.formatters[format];
    var filter = $fdae59e8868608a5$var$defaults.filter;
    if (typeof opts.filter === 'function' || $fdae59e8868608a5$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $fdae59e8868608a5$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $fdae59e8868608a5$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $fdae59e8868608a5$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $fdae59e8868608a5$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $fdae59e8868608a5$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $fdae59e8868608a5$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $fdae59e8868608a5$var$defaults.delimiter : opts.delimiter,
        depth: typeof opts.depth === 'number' ? opts.depth : $fdae59e8868608a5$var$defaults.depth,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $fdae59e8868608a5$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $fdae59e8868608a5$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $fdae59e8868608a5$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $fdae59e8868608a5$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $fdae59e8868608a5$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $fdae59e8868608a5$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $fdae59e8868608a5$var$defaults.strictNullHandling
    };
};
$fdae59e8868608a5$exports = function(object, opts) {
    var obj = object;
    var options = $fdae59e8868608a5$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($fdae59e8868608a5$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $fdae59e8868608a5$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $591015a6910ac79e$exports();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (typeof key === 'undefined' || key === null) continue;
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        var encodedKey = options.encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        $fdae59e8868608a5$var$pushToArray(keys, $fdae59e8868608a5$var$stringify(value, encodedKey, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel, options.depth, 0));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B' + options.delimiter;
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93' + options.delimiter;
    }
    return joined.length > 0 ? prefix + joined : '';
};


var $3225be4cdfe13ac3$exports = {};
'use strict';

var $3225be4cdfe13ac3$var$has = Object.prototype.hasOwnProperty;
var $3225be4cdfe13ac3$var$isArray = Array.isArray;
var $3225be4cdfe13ac3$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $1b97d0b055bc5f8c$exports.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictMerge: true,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $3225be4cdfe13ac3$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $3225be4cdfe13ac3$var$parseArrayValue = function(val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        if (options.throwOnLimitExceeded) {
            var commaCount = 0;
            var commaIndex = val.indexOf(',');
            while(commaIndex > -1){
                commaCount += 1;
                if (commaCount >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
                commaIndex = val.indexOf(',', commaIndex + 1);
            }
        }
        return val.split(',');
    }
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $3225be4cdfe13ac3$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $3225be4cdfe13ac3$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $3225be4cdfe13ac3$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? void 0 : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded && typeof limit !== 'undefined' ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && typeof limit !== 'undefined' && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $3225be4cdfe13ac3$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $3225be4cdfe13ac3$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $3225be4cdfe13ac3$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $3225be4cdfe13ac3$var$defaults.decoder, charset, 'key');
            if (key !== null) val = $1b97d0b055bc5f8c$exports.maybeMap($3225be4cdfe13ac3$var$parseArrayValue(part.slice(pos + 1), options, $3225be4cdfe13ac3$var$isArray(obj[key]) ? obj[key].length : 0), function(encodedVal) {
                return options.decoder(encodedVal, $3225be4cdfe13ac3$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $3225be4cdfe13ac3$var$interpretNumericEntities(String(val));
        if (part.indexOf('[]=') > -1) val = $3225be4cdfe13ac3$var$isArray(val) ? [
            val
        ] : val;
        if (options.comma && $3225be4cdfe13ac3$var$isArray(val) && val.length > options.arrayLimit) val = $1b97d0b055bc5f8c$exports.combine([], val, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
        if (key !== null) {
            var existing = $3225be4cdfe13ac3$var$has.call(obj, key);
            if (existing && (options.duplicates === 'combine' || part.indexOf('[]=') > -1)) obj[key] = $1b97d0b055bc5f8c$exports.combine(obj[key], val, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
            else if (!existing || options.duplicates === 'last') obj[key] = val;
        }
    }
    return obj;
};
var $3225be4cdfe13ac3$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $3225be4cdfe13ac3$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) {
            if ($1b97d0b055bc5f8c$exports.isOverflow(leaf)) // leaf is already an overflow object, preserve it
            obj = leaf;
            else obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $1b97d0b055bc5f8c$exports.combine([], leaf, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
        } else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            var isValidArrayIndex = !isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays;
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (isValidArrayIndex && index < options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (isValidArrayIndex && options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            else if (isValidArrayIndex) {
                obj[index] = leaf;
                $1b97d0b055bc5f8c$exports.markOverflow(obj, index);
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
// Split a key like "a[b][c[]]" into ['a', '[b]', '[c[]]'] while preserving
// qs parse semantics for depth/prototype guards.
var $3225be4cdfe13ac3$var$splitKeyIntoSegments = function splitKeyIntoSegments(originalKey, options) {
    var key = options.allowDots ? originalKey.replace(/\.([^.[]+)/g, '[$1]') : originalKey;
    // depth <= 0 keeps the whole key as one segment
    if (options.depth <= 0) {
        if (!options.plainObjects && $3225be4cdfe13ac3$var$has.call(Object.prototype, key)) {
            if (!options.allowPrototypes) return;
        }
        return [
            key
        ];
    }
    var segments = [];
    // parent before the first '[' (may be empty if key starts with '[')
    var first = key.indexOf('[');
    var parent = first >= 0 ? key.slice(0, first) : key;
    if (parent) {
        if (!options.plainObjects && $3225be4cdfe13ac3$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        segments[segments.length] = parent;
    }
    var n = key.length;
    var open = first;
    var collected = 0;
    while(open >= 0 && collected < options.depth){
        var level = 1;
        var i = open + 1;
        var close = -1;
        // balance nested '[' and ']' inside this bracket group using a nesting level counter
        while(i < n && close < 0){
            var cu = key.charCodeAt(i);
            if (cu === 0x5B) level += 1;
            else if (cu === 0x5D) {
                level -= 1;
                if (level === 0) close = i; // found matching close; loop will exit by condition
            }
            i += 1;
        }
        if (close < 0) {
            // Unterminated group: wrap the raw remainder in one bracket pair so it stays
            // a single literal segment (e.g. "[[]b" -> "[[]b]"); we do not infer missing ']'.
            segments[segments.length] = '[' + key.slice(open) + ']';
            return segments;
        }
        var seg = key.slice(open, close + 1);
        // prototype guard for the content of this group
        var content = seg.slice(1, -1);
        if (!options.plainObjects && $3225be4cdfe13ac3$var$has.call(Object.prototype, content) && !options.allowPrototypes) return;
        segments[segments.length] = seg;
        collected += 1;
        // find the next '[' after this balanced group
        open = key.indexOf('[', close + 1);
    }
    if (open >= 0) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        segments[segments.length] = '[' + key.slice(open) + ']';
    }
    return segments;
};
var $3225be4cdfe13ac3$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    var keys = $3225be4cdfe13ac3$var$splitKeyIntoSegments(givenKey, options);
    if (!keys) return;
    return $3225be4cdfe13ac3$var$parseObject(keys, val, options, valuesParsed);
};
var $3225be4cdfe13ac3$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $3225be4cdfe13ac3$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $3225be4cdfe13ac3$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $3225be4cdfe13ac3$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $3225be4cdfe13ac3$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $3225be4cdfe13ac3$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $3225be4cdfe13ac3$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $3225be4cdfe13ac3$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $3225be4cdfe13ac3$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $3225be4cdfe13ac3$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $3225be4cdfe13ac3$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $3225be4cdfe13ac3$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $3225be4cdfe13ac3$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $1b97d0b055bc5f8c$exports.isRegExp(opts.delimiter) ? opts.delimiter : $3225be4cdfe13ac3$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $3225be4cdfe13ac3$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $3225be4cdfe13ac3$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $3225be4cdfe13ac3$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $3225be4cdfe13ac3$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $3225be4cdfe13ac3$var$defaults.strictDepth,
        strictMerge: typeof opts.strictMerge === 'boolean' ? !!opts.strictMerge : $3225be4cdfe13ac3$var$defaults.strictMerge,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $3225be4cdfe13ac3$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
$3225be4cdfe13ac3$exports = function(str, opts) {
    var options = $3225be4cdfe13ac3$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $3225be4cdfe13ac3$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $3225be4cdfe13ac3$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $1b97d0b055bc5f8c$exports.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $1b97d0b055bc5f8c$exports.compact(obj);
};



$3cc271bb186f0140$exports = {
    formats: $8534d4a11448cf7e$exports,
    parse: $3225be4cdfe13ac3$exports,
    stringify: $fdae59e8868608a5$exports
};


var $c1e4a1336f2cb96e$exports = {};

$parcel$export($c1e4a1336f2cb96e$exports, "LOCAL", function () { return $c1e4a1336f2cb96e$export$2670cb7d5d4f7184; });
$parcel$export($c1e4a1336f2cb96e$exports, "DEV", function () { return $c1e4a1336f2cb96e$export$404582bc18fe4d9e; });
$parcel$export($c1e4a1336f2cb96e$exports, "STAGE", function () { return $c1e4a1336f2cb96e$export$f9865a0a7f208c15; });
$parcel$export($c1e4a1336f2cb96e$exports, "PROD", function () { return $c1e4a1336f2cb96e$export$e51cdc15d0c6bee2; });
const $c1e4a1336f2cb96e$export$2670cb7d5d4f7184 = 'local';
const $c1e4a1336f2cb96e$export$404582bc18fe4d9e = 'dev';
const $c1e4a1336f2cb96e$export$f9865a0a7f208c15 = 'stg';
const $c1e4a1336f2cb96e$export$e51cdc15d0c6bee2 = 'prod';


// Tech doc can be found here
// https://hello.atlassian.net/wiki/spaces/MARTECH/pages/159733334/ConsentHub+Application+Technical+Design

const $35a545355f14a0c7$var$localEnvironment = {
    name: $c1e4a1336f2cb96e$export$2670cb7d5d4f7184,
    url: 'http://localhost:8080'
};
const $35a545355f14a0c7$var$devEnvironment = {
    name: $c1e4a1336f2cb96e$export$404582bc18fe4d9e,
    url: 'https://preferences.dev.atlassian.com'
};
const $35a545355f14a0c7$var$stageEnvironment = {
    name: $c1e4a1336f2cb96e$export$f9865a0a7f208c15,
    url: 'https://preferences.stg.atlassian.com'
};
const $35a545355f14a0c7$var$prodEnvironment = {
    name: $c1e4a1336f2cb96e$export$e51cdc15d0c6bee2,
    url: 'https://preferences.atlassian.com'
};
const $35a545355f14a0c7$export$6bc7b24d4e862158 = ()=>{
    const { hostname: hostname } = window.location;
    if ([
        /\.prod\./,
        /preferences\.atlassian\.com/
    ].some((r)=>r.test(hostname))) return $35a545355f14a0c7$var$prodEnvironment;
    else if ([
        /\.staging\./,
        /\.stg\./
    ].some((r)=>r.test(hostname))) return $35a545355f14a0c7$var$stageEnvironment;
    else if ([
        /\.dev\./
    ].some((r)=>r.test(hostname))) return $35a545355f14a0c7$var$devEnvironment;
    else if ([
        /localhost/
    ].some((r)=>r.test(hostname))) return $35a545355f14a0c7$var$localEnvironment;
    else throw Error('Unable to determine environment');
};




const $1632e46edaa58de9$var$apiClient = (0, $747d656b899e6115$export$2e2bcd8739ae039).create({
    baseURL: `${(0, $35a545355f14a0c7$export$6bc7b24d4e862158)().url}/rest/preferences`,
    responseType: 'json',
    headers: {
        'Content-Type': 'application/json'
    },
    paramsSerializer: (params)=>(0, (/*@__PURE__*/$parcel$interopDefault($3cc271bb186f0140$exports))).stringify(params)
});
$1632e46edaa58de9$var$apiClient.interceptors.response.use((response)=>response.data, (error)=>{
    var _error_response;
    return Promise.reject(((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.data) || error.message);
});
var $1632e46edaa58de9$export$2e2bcd8739ae039 = $1632e46edaa58de9$var$apiClient;
const $1632e46edaa58de9$export$1addd41d999692aa = (0, $747d656b899e6115$export$2e2bcd8739ae039).create({
    baseURL: `${(0, $35a545355f14a0c7$export$6bc7b24d4e862158)().url}/rest/preferences`,
    responseType: 'json',
    headers: {
        'Content-Type': 'application/json'
    },
    paramsSerializer: (params)=>(0, (/*@__PURE__*/$parcel$interopDefault($3cc271bb186f0140$exports))).stringify(params)
});



const $71fbb9240bd0b42c$export$fa5a5f9acf0b4757 = (hid)=>(0, $1632e46edaa58de9$export$2e2bcd8739ae039).get('/consentsAndSubscriptions', {
        params: {
            hid: hid
        }
    });
const $71fbb9240bd0b42c$export$c1cf1b7b7ca0c54c = async ()=>(0, $1632e46edaa58de9$export$1addd41d999692aa).get('/session/consentsAndSubscriptions');
const $71fbb9240bd0b42c$export$d12a00019f220cc1 = (hid, subscriptions)=>(0, $1632e46edaa58de9$export$2e2bcd8739ae039).put('/subscriptions', {
        subscriptions: subscriptions
    }, {
        params: {
            hid: hid,
            source: 'PREFERENCES_CENTER',
            action: 'UPDATE_PREFERENCES'
        }
    });
const $71fbb9240bd0b42c$export$e2a4d9289365ff88 = (hid)=>(0, $1632e46edaa58de9$export$2e2bcd8739ae039).delete('/subscriptions/all', {
        params: {
            hid: hid,
            source: 'PREFERENCES_CENTER',
            action: 'GLOBAL_UNSUBSCRIBE'
        }
    });
const $71fbb9240bd0b42c$export$a1e4533914e154bd = (hid, keys, jobId)=>{
    return (0, $1632e46edaa58de9$export$2e2bcd8739ae039).delete('/subscriptions', {
        params: {
            keys: keys,
            hid: hid,
            action: 'EMAIL_UNSUBSCRIBE_LINK',
            jobId: jobId,
            source: jobId != null ? 'SFMC_EMAIL' : undefined
        }
    });
};
const $71fbb9240bd0b42c$export$3ab4aed8562cb58d = (request)=>(0, $1632e46edaa58de9$export$2e2bcd8739ae039).post('/consent', request);


var $91cadcf42f447377$export$d460f747b73abb10 = /*#__PURE__*/ function(GroupType) {
    GroupType["SUBSCRIPTIONS"] = "SUBSCRIPTIONS";
    GroupType["CONSENTS"] = "CONSENTS";
    return GroupType;
}({});
var $91cadcf42f447377$export$3d4da522aa66ad7 = /*#__PURE__*/ function(ItemStatus) {
    ItemStatus["ON"] = "ON";
    ItemStatus["OFF"] = "OFF";
    ItemStatus["PENDING"] = "PENDING";
    return ItemStatus;
}({});




const $d5dda7b7f034addc$export$fcc75ec143a0a864 = (language)=>(0, $1632e46edaa58de9$export$2e2bcd8739ae039).get(`/translations/${language}`);
const $d5dda7b7f034addc$export$3ba5e2c74659a212 = ()=>(0, $1632e46edaa58de9$export$2e2bcd8739ae039).get(`/translations`);




var $8b55bd10a455ef8c$exports = {};

$parcel$export($8b55bd10a455ef8c$exports, "BUTTON_CLICK", function () { return $8b55bd10a455ef8c$export$965dbcaf9eaff519; });
$parcel$export($8b55bd10a455ef8c$exports, "LINK_CLICK", function () { return $8b55bd10a455ef8c$export$fcfaa09cc4161077; });
$parcel$export($8b55bd10a455ef8c$exports, "MESSAGE_TEXT", function () { return $8b55bd10a455ef8c$export$1a4b85c6feafd267; });
$parcel$export($8b55bd10a455ef8c$exports, "BANNER", function () { return $8b55bd10a455ef8c$export$238d30785c4bca84; });
$parcel$export($8b55bd10a455ef8c$exports, "ERROR_BANNER", function () { return $8b55bd10a455ef8c$export$73f887cc88cd3d43; });
$parcel$export($8b55bd10a455ef8c$exports, "CHECKBOX_CLICK", function () { return $8b55bd10a455ef8c$export$c8f6c7aa8a3372de; });
$parcel$export($8b55bd10a455ef8c$exports, "TOOGLE", function () { return $8b55bd10a455ef8c$export$feafb7048ba17092; });
const $8b55bd10a455ef8c$export$965dbcaf9eaff519 = 'button_click';
const $8b55bd10a455ef8c$export$fcfaa09cc4161077 = 'link_click';
const $8b55bd10a455ef8c$export$1a4b85c6feafd267 = 'message_text';
const $8b55bd10a455ef8c$export$238d30785c4bca84 = 'banner';
const $8b55bd10a455ef8c$export$73f887cc88cd3d43 = 'error_banner';
const $8b55bd10a455ef8c$export$c8f6c7aa8a3372de = 'checkbox_click';
const $8b55bd10a455ef8c$export$feafb7048ba17092 = 'toogle';


var $744732e0bd9719d8$exports = {};

$parcel$export($744732e0bd9719d8$exports, "UNSUBSCRIBE_ALL", function () { return $744732e0bd9719d8$export$199127a4a2058410; });
$parcel$export($744732e0bd9719d8$exports, "DECLINE_UNSUBSCRIBE_ALL", function () { return $744732e0bd9719d8$export$a4d07698a8bb1a95; });
$parcel$export($744732e0bd9719d8$exports, "DOWN_FOR_MAINTENANCE", function () { return $744732e0bd9719d8$export$95367dd33f34a448; });
$parcel$export($744732e0bd9719d8$exports, "EMPTY_SUB_LIST", function () { return $744732e0bd9719d8$export$dc3e3a7146a7071c; });
$parcel$export($744732e0bd9719d8$exports, "USER_NOT_FOUND", function () { return $744732e0bd9719d8$export$a8a3d6e2f6eeee03; });
$parcel$export($744732e0bd9719d8$exports, "FAILED_TO_UPDATE_PREFERENCES", function () { return $744732e0bd9719d8$export$3ba33fbdafc5be66; });
$parcel$export($744732e0bd9719d8$exports, "UPDATE_PREFERENCES", function () { return $744732e0bd9719d8$export$946e18e3873235d0; });
$parcel$export($744732e0bd9719d8$exports, "UNSUBSCRIBE", function () { return $744732e0bd9719d8$export$881b71df7abed909; });
$parcel$export($744732e0bd9719d8$exports, "SUBSCRIBE", function () { return $744732e0bd9719d8$export$f8db20b65b2d4fc4; });
$parcel$export($744732e0bd9719d8$exports, "PREFERENCES_CENTER_NAVIGATION", function () { return $744732e0bd9719d8$export$f7a90df9002e60a8; });
$parcel$export($744732e0bd9719d8$exports, "ACCEPT_CONSENT", function () { return $744732e0bd9719d8$export$cd0a3902626d26aa; });
$parcel$export($744732e0bd9719d8$exports, "DECLINE_CONSENT", function () { return $744732e0bd9719d8$export$4f67ce9f48d4cc97; });
$parcel$export($744732e0bd9719d8$exports, "CONFIRM_CONSENT_PR_UNSUB_CONSENT", function () { return $744732e0bd9719d8$export$e012f5121294da10; });
$parcel$export($744732e0bd9719d8$exports, "DECLINE_CONSENT_PR_UNSUB_CONSENT", function () { return $744732e0bd9719d8$export$681c07eab7dfb6f2; });
$parcel$export($744732e0bd9719d8$exports, "REVOKE_ALL_CONSENT", function () { return $744732e0bd9719d8$export$2a591ef5a2734d84; });
$parcel$export($744732e0bd9719d8$exports, "SUBSCRIBE_GROUP", function () { return $744732e0bd9719d8$export$e0dcfd31675866ee; });
$parcel$export($744732e0bd9719d8$exports, "UNSUBSCRIBE_GROUP", function () { return $744732e0bd9719d8$export$845502d739550ac8; });
$parcel$export($744732e0bd9719d8$exports, "SELECT_LANGUAGE", function () { return $744732e0bd9719d8$export$7648dfe09aa97505; });
$parcel$export($744732e0bd9719d8$exports, "REVOKE_CONSENT", function () { return $744732e0bd9719d8$export$805cd9f249ca61ad; });
$parcel$export($744732e0bd9719d8$exports, "SWITCH_TAB", function () { return $744732e0bd9719d8$export$59e75124cccac80d; });
$parcel$export($744732e0bd9719d8$exports, "CONFIRM_DOUBLE_OPT_IN", function () { return $744732e0bd9719d8$export$5bea899ee9b8b29f; });
$parcel$export($744732e0bd9719d8$exports, "SUBSCRIBE_PRODUCT_INVITATIONS_WARNING", function () { return $744732e0bd9719d8$export$b3df1c5423e656a2; });
const $744732e0bd9719d8$export$199127a4a2058410 = 'unsubscribe_all';
const $744732e0bd9719d8$export$a4d07698a8bb1a95 = 'decline_unsubscribe_all';
const $744732e0bd9719d8$export$95367dd33f34a448 = 'down_for_maintenance';
const $744732e0bd9719d8$export$dc3e3a7146a7071c = 'empty_sub_list';
const $744732e0bd9719d8$export$a8a3d6e2f6eeee03 = 'user_not_found';
const $744732e0bd9719d8$export$3ba33fbdafc5be66 = 'failed_to_update_preferences';
const $744732e0bd9719d8$export$946e18e3873235d0 = 'update_preferences';
const $744732e0bd9719d8$export$881b71df7abed909 = 'unsubscribe';
const $744732e0bd9719d8$export$f8db20b65b2d4fc4 = 'subscribe';
const $744732e0bd9719d8$export$f7a90df9002e60a8 = 'preferences_center_navigation';
const $744732e0bd9719d8$export$cd0a3902626d26aa = 'accept_consent';
const $744732e0bd9719d8$export$4f67ce9f48d4cc97 = 'decline_consent';
const $744732e0bd9719d8$export$e012f5121294da10 = 'confirm_consent_pr_unsub';
const $744732e0bd9719d8$export$681c07eab7dfb6f2 = 'decline_consent_pr_unsub';
const $744732e0bd9719d8$export$2a591ef5a2734d84 = 'revoke_all_consent';
const $744732e0bd9719d8$export$e0dcfd31675866ee = 'subscribe_group';
const $744732e0bd9719d8$export$845502d739550ac8 = 'unsubscribe_group';
const $744732e0bd9719d8$export$7648dfe09aa97505 = 'select_language';
const $744732e0bd9719d8$export$805cd9f249ca61ad = 'revoke_consent';
const $744732e0bd9719d8$export$59e75124cccac80d = 'switch_tab';
const $744732e0bd9719d8$export$5bea899ee9b8b29f = 'confirm_double_opt_in';
const $744732e0bd9719d8$export$b3df1c5423e656a2 = 'subscribe_product_invitations_warning';



var $9tqwB = parcelRequire("9tqwB");

const $275512fd46801a1e$var$PROD_SEGMENT_SOURCE_ID = '8tEfgRCivSBv7oqseie70PwBF8dEE0F7';
const $275512fd46801a1e$var$STAGE_SEGMENT_SOURCE_ID = 'tFFPMQDrOUOBmDWwOJrsZOO4epCn28ie';
const $275512fd46801a1e$var$ANALYTICS_WRAPPER = 'https://atl-global.atlassian.com/js/atl-global.min.js';
const $275512fd46801a1e$export$f2a39aaa42ea357a = ()=>{
    const { name: name } = (0, $35a545355f14a0c7$export$6bc7b24d4e862158)();
    const writeKey = name === (0, $c1e4a1336f2cb96e$exports).PROD ? $275512fd46801a1e$var$PROD_SEGMENT_SOURCE_ID : $275512fd46801a1e$var$STAGE_SEGMENT_SOURCE_ID;
    if (window.ace) window.ace.analytics.Initializer.initAnalytics(writeKey);
    else console.warn('Did not load analytics library');
};
const $275512fd46801a1e$export$d22535dc59b4c5d0 = ()=>{
    const script = document.createElement('script');
    script.src = $275512fd46801a1e$var$ANALYTICS_WRAPPER;
    script.type = 'text/javascript';
    script.id = 'atl-global';
    script.onload = $275512fd46801a1e$export$f2a39aaa42ea357a;
    document.body.appendChild(script);
};
const $275512fd46801a1e$export$bd13a0a8c0977b2f = (pageName, data)=>{
    if (window.ace) window.ace.analytics.Tracking.pageView(null, pageName, data);
    else console.warn('Did not load analytics library');
};
const $275512fd46801a1e$export$73d0a139caca1fee = (action, actionDesc, params)=>{
    const data = params ? (0, $9tqwB._)({
        actionDesc: actionDesc
    }, params) : {
        actionDesc: actionDesc
    };
    if (window.ace) window.ace.analytics.Tracking.trackEvent(action, data);
    else console.warn('Did not load analytics library');
};





const $0e08eda71bb24540$export$e2ad6fafbc50701c = (hid, source, unsubscribe_keys, subscribe_keys)=>{
    (0, $275512fd46801a1e$export$bd13a0a8c0977b2f)('Preferences Center', {
        hid: hid,
        source: source,
        unsubscribe_keys: unsubscribe_keys,
        subscribe_keys: subscribe_keys
    });
};
const $0e08eda71bb24540$export$2661a9b7d6c9d40 = ()=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BUTTON_CLICK, (0, $744732e0bd9719d8$exports).UNSUBSCRIBE_ALL);
};
const $0e08eda71bb24540$export$11887f10ee02c881 = ()=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BUTTON_CLICK, (0, $744732e0bd9719d8$exports).DECLINE_UNSUBSCRIBE_ALL);
};
const $0e08eda71bb24540$export$b2d5c41c71279068 = (subscribed, params)=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).CHECKBOX_CLICK, subscribed ? (0, $744732e0bd9719d8$exports).SUBSCRIBE : (0, $744732e0bd9719d8$exports).UNSUBSCRIBE, params);
};
const $0e08eda71bb24540$export$6f7cca16e34ea87f = ()=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).MESSAGE_TEXT, (0, $744732e0bd9719d8$exports).DOWN_FOR_MAINTENANCE);
};
const $0e08eda71bb24540$export$f1239e0c91a8acb6 = ()=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).MESSAGE_TEXT, (0, $744732e0bd9719d8$exports).EMPTY_SUB_LIST);
};
const $0e08eda71bb24540$export$df7ac42928b20388 = ()=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).MESSAGE_TEXT, (0, $744732e0bd9719d8$exports).USER_NOT_FOUND);
};
const $0e08eda71bb24540$export$24a9508d2a444047 = ()=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BANNER, (0, $744732e0bd9719d8$exports).UNSUBSCRIBE_ALL);
};
const $0e08eda71bb24540$export$a5babd368b9bd0a8 = ()=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BANNER, (0, $744732e0bd9719d8$exports).UPDATE_PREFERENCES);
};
const $0e08eda71bb24540$export$f508667310aad4a2 = (params)=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BANNER, (0, $744732e0bd9719d8$exports).UNSUBSCRIBE, params);
};
const $0e08eda71bb24540$export$3830a8576e3e4291 = ()=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BANNER, (0, $744732e0bd9719d8$exports).SUBSCRIBE);
};
const $0e08eda71bb24540$export$d6067dcb8ad24019 = ()=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).ERROR_BANNER, (0, $744732e0bd9719d8$exports).FAILED_TO_UPDATE_PREFERENCES);
};
const $0e08eda71bb24540$export$ac0c4a766e9f767e = ()=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BUTTON_CLICK, (0, $744732e0bd9719d8$exports).PREFERENCES_CENTER_NAVIGATION);
};
const $0e08eda71bb24540$export$1ee474b7e28ef3c0 = (params)=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BUTTON_CLICK, (0, $744732e0bd9719d8$exports).ACCEPT_CONSENT, params);
};
const $0e08eda71bb24540$export$f9f36241b679fafe = (params)=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BUTTON_CLICK, (0, $744732e0bd9719d8$exports).DECLINE_CONSENT, params);
};
const $0e08eda71bb24540$export$46324d0949923406 = ()=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).ERROR_BANNER, (0, $744732e0bd9719d8$exports).DECLINE_CONSENT);
};
const $0e08eda71bb24540$export$ee3c89fcd945a704 = (params)=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BUTTON_CLICK, (0, $744732e0bd9719d8$exports).CONFIRM_CONSENT_PR_UNSUB_CONSENT, params);
};
const $0e08eda71bb24540$export$76b1ce7baa042b11 = (params)=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BUTTON_CLICK, (0, $744732e0bd9719d8$exports).DECLINE_CONSENT_PR_UNSUB_CONSENT, params);
};
const $0e08eda71bb24540$export$36e114c0305b5ce5 = (params)=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).TOOGLE, (0, $744732e0bd9719d8$exports).SELECT_LANGUAGE, params);
};
const $0e08eda71bb24540$export$c369c41080a75c3d = (params)=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).CHECKBOX_CLICK, (0, $744732e0bd9719d8$exports).REVOKE_CONSENT, params);
};
const $0e08eda71bb24540$export$1e7f31c83a73d717 = (params)=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).TOOGLE, (0, $744732e0bd9719d8$exports).SWITCH_TAB, params);
};
const $0e08eda71bb24540$export$19e5a6bca6f03118 = (subscribed, params)=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BUTTON_CLICK, subscribed ? (0, $744732e0bd9719d8$exports).SUBSCRIBE_GROUP : (0, $744732e0bd9719d8$exports).UNSUBSCRIBE_GROUP, params);
};
const $0e08eda71bb24540$export$f1757086d8a8d8f4 = ()=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BUTTON_CLICK, (0, $744732e0bd9719d8$exports).REVOKE_ALL_CONSENT);
};
const $0e08eda71bb24540$export$203cbc4ee16257d7 = ()=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BUTTON_CLICK, (0, $744732e0bd9719d8$exports).CONFIRM_DOUBLE_OPT_IN);
};
const $0e08eda71bb24540$export$e40784e30c403486 = ()=>{
    (0, $275512fd46801a1e$export$73d0a139caca1fee)((0, $8b55bd10a455ef8c$exports).BUTTON_CLICK, (0, $744732e0bd9719d8$exports).SUBSCRIBE_PRODUCT_INVITATIONS_WARNING);
};




const $6b30d0cc5ae6fbf1$export$e3f5ffe9a12f28f6 = 'localization';
const $6b30d0cc5ae6fbf1$export$d8883c30992bd0c2 = `${$6b30d0cc5ae6fbf1$export$e3f5ffe9a12f28f6}/loadTranslation`;
const $6b30d0cc5ae6fbf1$export$ed8c90bb5caf747 = `${$6b30d0cc5ae6fbf1$export$e3f5ffe9a12f28f6}/loadLanguages`;
const $6b30d0cc5ae6fbf1$export$30095ee86a883fad = `${$6b30d0cc5ae6fbf1$export$e3f5ffe9a12f28f6}/initialization`;
const $6b30d0cc5ae6fbf1$export$495eb7fb1401acaa = `${$6b30d0cc5ae6fbf1$export$e3f5ffe9a12f28f6}/switchLanguage`;


const $cc45bcc51bf95f36$var$extractSystemLanguage = ()=>window.navigator.languages[0].split('-')[0];
const $cc45bcc51bf95f36$var$FALLBACK_LANGUAGE = 'en';
const $cc45bcc51bf95f36$var$initialState = {
    language: $cc45bcc51bf95f36$var$FALLBACK_LANGUAGE,
    fallbackLanguage: $cc45bcc51bf95f36$var$FALLBACK_LANGUAGE,
    systemLanguage: $cc45bcc51bf95f36$var$extractSystemLanguage(),
    userLanguage: undefined,
    supportedLanguages: {
        en: 'English'
    },
    translations: {}
};
const $cc45bcc51bf95f36$export$85e084dbe857046b = (0, $15d924278321bdfd$export$6abd22dc03e5063f)((0, $6b30d0cc5ae6fbf1$export$d8883c30992bd0c2), async (language)=>{
    return await (0, $d5dda7b7f034addc$export$fcc75ec143a0a864)(language);
}, {
    condition: (language, { getState: getState })=>getState().localization.translations[language] == null
});
const $cc45bcc51bf95f36$export$8cd7e7a54fa865bc = (0, $15d924278321bdfd$export$6abd22dc03e5063f)((0, $6b30d0cc5ae6fbf1$export$ed8c90bb5caf747), async ()=>{
    return await (0, $d5dda7b7f034addc$export$3ba5e2c74659a212)();
}, {
});
const $cc45bcc51bf95f36$export$d1f0f8da0682c531 = (0, $15d924278321bdfd$export$6abd22dc03e5063f)((0, $6b30d0cc5ae6fbf1$export$30095ee86a883fad), async (_, { dispatch: dispatch })=>{
    await dispatch($cc45bcc51bf95f36$export$85e084dbe857046b($cc45bcc51bf95f36$var$FALLBACK_LANGUAGE));
    await dispatch($cc45bcc51bf95f36$export$8cd7e7a54fa865bc(null));
});
const $cc45bcc51bf95f36$export$fa43c961ec463ef0 = (0, $15d924278321bdfd$export$6abd22dc03e5063f)((0, $6b30d0cc5ae6fbf1$export$495eb7fb1401acaa), async (language, { dispatch: dispatch })=>{
    await dispatch($cc45bcc51bf95f36$export$85e084dbe857046b(language));
    (0, $0e08eda71bb24540$export$36e114c0305b5ce5)({
        lang: language
    });
    return language;
});
const $cc45bcc51bf95f36$var$localizationSlice = (0, $15d924278321bdfd$export$4d8d9bd83c24ae8b)({
    name: (0, $6b30d0cc5ae6fbf1$export$e3f5ffe9a12f28f6),
    initialState: $cc45bcc51bf95f36$var$initialState,
    reducers: {
        changeUserLanguage: (state, action)=>{
            state.userLanguage = action.payload;
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($cc45bcc51bf95f36$export$85e084dbe857046b.fulfilled, (state, { payload: payload, meta: meta })=>{
            state.translations = (0, $2qxEV._)((0, $9tqwB._)({}, state.translations), {
                [meta.arg]: payload
            });
        });
        builder.addCase($cc45bcc51bf95f36$export$8cd7e7a54fa865bc.fulfilled, (state, { payload: payload })=>{
            state.supportedLanguages = payload;
        });
        builder.addCase($cc45bcc51bf95f36$export$fa43c961ec463ef0.fulfilled, (state, { payload: payload })=>{
            state.language = payload;
        });
    }
});
const { changeUserLanguage: $cc45bcc51bf95f36$export$b403247a4bf8b780 } = $cc45bcc51bf95f36$var$localizationSlice.actions;
var $cc45bcc51bf95f36$export$2e2bcd8739ae039 = $cc45bcc51bf95f36$var$localizationSlice.reducer;





var $7fPBF = parcelRequire("7fPBF");

const $0ce633403190319b$export$20b36ebcfeb0a091 = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.localization.language, (language)=>language);
const $0ce633403190319b$export$66e9475a9fd6dfbe = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.localization.language, (state)=>state.localization.userLanguage, (state)=>state.localization.systemLanguage, (state)=>state.localization.fallbackLanguage, (state)=>state.localization.supportedLanguages, (currentLanguage, userLanguage, systemLanguage, fallbackLanguage, supportedLanguages)=>{
    let proposedLanguage = fallbackLanguage;
    if (userLanguage && supportedLanguages[userLanguage] != null) proposedLanguage = userLanguage;
    else if (supportedLanguages[systemLanguage] != null) proposedLanguage = systemLanguage;
    return currentLanguage !== proposedLanguage ? proposedLanguage : undefined;
});
const $0ce633403190319b$export$2a9f106f311b16ff = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.localization.translations, (translations)=>Object.keys(translations).length !== 0);
const $0ce633403190319b$export$454c8e352dec47e6 = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.localization.supportedLanguages, (supportedLanguages)=>supportedLanguages);
const $0ce633403190319b$export$77bdeabf29c9729a = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.localization.translations, (state)=>state.localization.language, (state)=>state.localization.fallbackLanguage, (translations, language, fallbackLanguage)=>{
    let languageTranslation = translations[language];
    if (languageTranslation == null) languageTranslation = translations[fallbackLanguage];
    return languageTranslation;
});
const $0ce633403190319b$export$9db941f9dac66123 = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.localization.translations, (state)=>state.localization.fallbackLanguage, (translations, fallbackLanguage)=>translations[fallbackLanguage]);


const $c9cb1bee0dfb8876$export$f3b57b803065ff8a = (source, holder)=>{
    if (source == null) return source;
    const replacer = (substring, args)=>holder[args] || substring;
    return source.replace(/{([^{}]*)}/g, replacer);
};





const $7ef2374eddee6a70$export$f51d452c10d5b956 = (0, $f30b917334351296$export$8ad76b76a4c905f8).withTypes();
const $7ef2374eddee6a70$export$a7347740d65f620b = (0, $f30b917334351296$export$2105062e25df4afe).withTypes();


const $a69d01c0ea406f35$export$9fc83ad70ead8663 = ()=>{
    const translations = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $0ce633403190319b$export$77bdeabf29c9729a));
    const fallbackTranslations = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $0ce633403190319b$export$9db941f9dac66123));
    const keyWithTitle = (0, $7fPBF.useCallback)((key)=>`${key}.title`, []);
    const keyWithDescription = (0, $7fPBF.useCallback)((key)=>`${key}.description`, []);
    const keyWithCallout = (0, $7fPBF.useCallback)((key)=>`${key}.callout`, []);
    const translate = (0, $7fPBF.useCallback)((key, values)=>{
        let translation = translations[key];
        if (!translation) translation = fallbackTranslations[key];
        if (values != null) return (0, $c9cb1bee0dfb8876$export$f3b57b803065ff8a)(translation, values) || key;
        else return translation || key;
    }, [
        translations,
        fallbackTranslations
    ]);
    return {
        translate: translate,
        keyWithTitle: keyWithTitle,
        keyWithDescription: keyWithDescription,
        keyWithCallout: keyWithCallout
    };
};








var $49831beffa50c42c$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e4a75f30383a815136b76433b9d7ec6c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($49831beffa50c42c$exports, "__esModule", {
    value: true
});
$49831beffa50c42c$exports.default = void 0;

var $49831beffa50c42c$var$_react = $49831beffa50c42c$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $49831beffa50c42c$var$_baseNew = $49831beffa50c42c$var$_interopRequireDefault((parcelRequire("1OCuG")));
function $49831beffa50c42c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Globe".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: public link in Confluence share dialog, global rules in Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $49831beffa50c42c$var$GlobeIcon = (props)=>/*#__PURE__*/ $49831beffa50c42c$var$_react.default.createElement($49831beffa50c42c$var$_baseNew.default, Object.assign({
        name: "GlobeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.543 7.25h2.722c.073-1.784.403-3.413.92-4.663q.123-.294.26-.566A6.5 6.5 0 0 0 1.544 7.25M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 1.5c-.151 0-.364.07-.632.344-.27.276-.547.714-.796 1.316-.432 1.043-.733 2.47-.805 4.09h4.466c-.072-1.62-.373-3.047-.805-4.09-.249-.602-.526-1.04-.796-1.316C8.364 1.571 8.15 1.5 8 1.5m3.735 5.75c-.073-1.784-.403-3.413-.92-4.663a8 8 0 0 0-.26-.566 6.5 6.5 0 0 1 3.902 5.229zm-1.502 1.5H5.767c.072 1.62.373 3.047.805 4.09.249.602.526 1.04.796 1.316.268.273.481.344.632.344s.364-.07.632-.344c.27-.276.547-.714.796-1.316.432-1.043.733-2.47.805-4.09m.321 5.229q.14-.272.26-.566c.518-1.25.848-2.879.92-4.663h2.723a6.5 6.5 0 0 1-3.903 5.229m-5.108 0q-.14-.272-.26-.566c-.518-1.25-.848-2.879-.92-4.663H1.542a6.5 6.5 0 0 0 3.903 5.229" clip-rule="evenodd"/>`
    }, props));
$49831beffa50c42c$var$GlobeIcon.displayName = 'GlobeIcon';
var $49831beffa50c42c$var$_default = $49831beffa50c42c$exports.default = $49831beffa50c42c$var$GlobeIcon;


/* eslint-disable @repo/internal/react/require-jsdoc */ var $5819e7133c450b79$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};

var $91b5651481cc9d5c$exports = {};
function $91b5651481cc9d5c$var$_extends() {
    return $91b5651481cc9d5c$exports = $91b5651481cc9d5c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $91b5651481cc9d5c$exports.__esModule = true, $91b5651481cc9d5c$exports["default"] = $91b5651481cc9d5c$exports, $91b5651481cc9d5c$var$_extends.apply(null, arguments);
}
$91b5651481cc9d5c$exports = $91b5651481cc9d5c$var$_extends, $91b5651481cc9d5c$exports.__esModule = true, $91b5651481cc9d5c$exports["default"] = $91b5651481cc9d5c$exports;



var $8MJe2 = parcelRequire("8MJe2");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");
var $e476a2e3142aad46$var$_process$env;
/// <reference types="node" />
var $e476a2e3142aad46$var$_default_1 = false;
var $e476a2e3142aad46$export$2e2bcd8739ae039 = $e476a2e3142aad46$var$_default_1;



var $j9spr = parcelRequire("j9spr");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $eihxX = parcelRequire("eihxX");

var $eaTmW = parcelRequire("eaTmW");

var $l8Sa3 = parcelRequire("l8Sa3");

var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");
var $1bfc5778dcd4841a$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bfc5778dcd4841a$var$ReactIs, $1bfc5778dcd4841a$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$1bfc5778dcd4841a$exports = (parcelRequire("iDep4"))();



var $7fPBF = parcelRequire("7fPBF");
var $b7b652b4080c1da6$var$AnalyticsNextContext = (0, $7fPBF.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $b7b652b4080c1da6$export$2e2bcd8739ae039 = $b7b652b4080c1da6$var$AnalyticsNextContext;


var $e420dde09fb890a4$export$2e2bcd8739ae039 = (0, $b7b652b4080c1da6$export$2e2bcd8739ae039);


function $2925ce99e929899b$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eihxX)))(t, $2925ce99e929899b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(t).constructor) : o.apply(t, e));
}
function $2925ce99e929899b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($2925ce99e929899b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $2925ce99e929899b$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func
};
var $2925ce99e929899b$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $2925ce99e929899b$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, AnalyticsContext);
        _this = $2925ce99e929899b$var$_callSuper(this, AnalyticsContext, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $2925ce99e929899b$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $2925ce99e929899b$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($l8Sa3)))(AnalyticsContext, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e420dde09fb890a4$export$2e2bcd8739ae039).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
}((0, $7fPBF.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($2925ce99e929899b$var$AnalyticsContext, "contextTypes", $2925ce99e929899b$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($2925ce99e929899b$var$AnalyticsContext, "childContextTypes", $2925ce99e929899b$var$ContextTypes);
var $2925ce99e929899b$export$2e2bcd8739ae039 = $2925ce99e929899b$var$AnalyticsContext;



var $j9spr = parcelRequire("j9spr");

var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");

var $afe2f1cfd0fadbcf$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $7fPBF.useContext)((0, $e420dde09fb890a4$export$2e2bcd8739ae039));
};



var $7fPBF = parcelRequire("7fPBF");
var $8606d3c77a5913a9$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $7fPBF.useRef)(value);
    ref.current = value;
    return ref;
};


var $f751e275ea128696$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $8606d3c77a5913a9$export$1d27a74659855e44)(data);
    var _useAnalyticsContext = (0, $afe2f1cfd0fadbcf$export$d1f587f82ad51c4)(), getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getOriginalAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var getAtlaskitAnalyticsContext = (0, $7fPBF.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(getOriginalAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    var value = (0, $7fPBF.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e420dde09fb890a4$export$2e2bcd8739ae039).Provider, {
        value: value
    }, children);
};
var $f751e275ea128696$export$2e2bcd8739ae039 = $f751e275ea128696$var$AnalyticsContext;


var $3f9e6ff285b84928$var$AnalyticsContext = function AnalyticsContext(props) {
    var isModernContext = (0, $e476a2e3142aad46$export$2e2bcd8739ae039) || (0, $137Lh.fg)('analytics-next-use-legacy-context') === false;
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $f751e275ea128696$export$2e2bcd8739ae039), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2925ce99e929899b$export$2e2bcd8739ae039), props);
};
var $3f9e6ff285b84928$export$2e2bcd8739ae039 = $3f9e6ff285b84928$var$AnalyticsContext;


var $4d25ac76de88d196$var$_excluded = [
    "analyticsContext"
];
function $4d25ac76de88d196$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4d25ac76de88d196$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4d25ac76de88d196$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4d25ac76de88d196$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4d25ac76de88d196$var$withAnalyticsContext = function withAnalyticsContext(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
            var analyticsContext = _ref.analyticsContext, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $4d25ac76de88d196$var$_excluded);
            var analyticsData = (0, $7fPBF.useMemo)(function() {
                return $4d25ac76de88d196$var$_objectSpread($4d25ac76de88d196$var$_objectSpread({}, defaultData), analyticsContext);
            }, [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $3f9e6ff285b84928$export$2e2bcd8739ae039), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, rest, {
                ref: ref
            })));
        });
        WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsContext;
    };
};
var $4d25ac76de88d196$export$2e2bcd8739ae039 = $4d25ac76de88d196$var$withAnalyticsContext;



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
function $6ff1114199100bef$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $6ff1114199100bef$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $7fPBF.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $7fPBF.useRef)(true);
    var committed = (0, $7fPBF.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $6ff1114199100bef$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $7fPBF.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $6ff1114199100bef$export$33752cf3ee811995(callback, inputs) {
    return $6ff1114199100bef$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $6ff1114199100bef$export$1538c33de8887b59 = $6ff1114199100bef$export$b6feb8998cd9b342;
var $6ff1114199100bef$export$35808ee640e87ca7 = $6ff1114199100bef$export$33752cf3ee811995;



var $j9spr = parcelRequire("j9spr");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $eihxX = parcelRequire("eihxX");

var $eaTmW = parcelRequire("eaTmW");

var $eKeTJ = parcelRequire("eKeTJ");

var $l8Sa3 = parcelRequire("l8Sa3");

var $8MJe2 = parcelRequire("8MJe2");

var $bRUy3 = parcelRequire("bRUy3");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $8MJe2 = parcelRequire("8MJe2");
function $d666a3ae7fbfd72e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d666a3ae7fbfd72e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d666a3ae7fbfd72e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d666a3ae7fbfd72e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d666a3ae7fbfd72e$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $d666a3ae7fbfd72e$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $d666a3ae7fbfd72e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $d666a3ae7fbfd72e$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(updater) === 'object') this.payload = $d666a3ae7fbfd72e$var$_objectSpread($d666a3ae7fbfd72e$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $1732f5d94ae24641$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eihxX)))(t, $1732f5d94ae24641$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(t).constructor) : o.apply(t, e));
}
function $1732f5d94ae24641$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1732f5d94ae24641$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $1732f5d94ae24641$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($eKeTJ)))((0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $1732f5d94ae24641$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $1732f5d94ae24641$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $1732f5d94ae24641$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, UIAnalyticsEvent);
        _this = $1732f5d94ae24641$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($l8Sa3)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $1732f5d94ae24641$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $d666a3ae7fbfd72e$export$2e2bcd8739ae039));



function $8618b7ff1a86c099$export$5bf35293e545f20c() {
    var analyticsContext = (0, $afe2f1cfd0fadbcf$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $6ff1114199100bef$export$33752cf3ee811995)(function(payload) {
        return new (0, $1732f5d94ae24641$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $8MJe2 = parcelRequire("8MJe2");

var $bRUy3 = parcelRequire("bRUy3");

var $7fPBF = parcelRequire("7fPBF");

function $abb2b2a73fb99cad$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $abb2b2a73fb99cad$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $abb2b2a73fb99cad$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $abb2b2a73fb99cad$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $abb2b2a73fb99cad$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $8618b7ff1a86c099$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $7fPBF.useRef)({});
    var patchedProps = (0, $7fPBF.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $abb2b2a73fb99cad$var$_objectSpread($abb2b2a73fb99cad$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $abb2b2a73fb99cad$var$_objectSpread($abb2b2a73fb99cad$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}


var $f8e03d3ef4b3dc3d$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
            var _usePatchedProps = (0, $abb2b2a73fb99cad$export$9ebb5a84d17e5d18)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $8618b7ff1a86c099$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $f8e03d3ef4b3dc3d$export$2e2bcd8739ae039 = $f8e03d3ef4b3dc3d$var$withAnalyticsEvents;




var $7fPBF = parcelRequire("7fPBF");
/* select.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $2d4796af5a44921e$exports = {};
function $2d4796af5a44921e$var$_readOnlyError(r) {
    throw new TypeError('"' + r + '" is read-only');
}
$2d4796af5a44921e$exports = $2d4796af5a44921e$var$_readOnlyError, $2d4796af5a44921e$exports.__esModule = true, $2d4796af5a44921e$exports["default"] = $2d4796af5a44921e$exports;



var $bRUy3 = parcelRequire("bRUy3");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $eihxX = parcelRequire("eihxX");

var $eaTmW = parcelRequire("eaTmW");

var $l8Sa3 = parcelRequire("l8Sa3");

var $8MJe2 = parcelRequire("8MJe2");

var $j9spr = parcelRequire("j9spr");

var $fjFkG = parcelRequire("fjFkG");

var $7fPBF = parcelRequire("7fPBF");
function $40c181de46002bdb$var$testPlatform(re) {
    var _userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_userAgentData = window.navigator['userAgentData']) === null || _userAgentData === void 0 ? void 0 : _userAgentData.platform) || window.navigator.platform) : false;
}
function $40c181de46002bdb$var$isIPhone() {
    return $40c181de46002bdb$var$testPlatform(/^iPhone/i);
}
function $40c181de46002bdb$var$isIPad() {
    return $40c181de46002bdb$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $40c181de46002bdb$var$isMac() && navigator.maxTouchPoints > 1;
}
function $40c181de46002bdb$var$isMac() {
    return $40c181de46002bdb$var$testPlatform(/^Mac/i);
}
function $40c181de46002bdb$var$isIOS() {
    return $40c181de46002bdb$var$isIPhone() || $40c181de46002bdb$var$isIPad();
}
function $40c181de46002bdb$export$e1865c3bedcd822b() {
    return $40c181de46002bdb$var$isMac() || $40c181de46002bdb$var$isIOS();
}


function $bf96b6408e362ed6$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use;
        var ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}


/**
 * An empty function which does nothing.
 */ function $f48d740006cf3f7d$export$2e2bcd8739ae039() {}



var $137Lh = parcelRequire("137Lh");
/* eslint-disable @repo/internal/fs/filename-pattern-match */ var $678ac190e9b31be7$export$f4da216a6ca54656 = function formatGroupLabel(group) {
    return group.label;
};

/* eslint-disable @repo/internal/fs/filename-pattern-match */ var $e793d8dc95029c13$export$dac6ace3020563ca = function getOptionLabel(option) {
    return option.label;
};

/* eslint-disable @repo/internal/fs/filename-pattern-match */ var $175922ddf6c67fc6$export$40be908210c5a79c = function getOptionValue(option) {
    return option.value;
};

/* eslint-disable @repo/internal/fs/filename-pattern-match */ var $2beb7490e14357df$export$56bd0c8d90db075 = function isOptionDisabled(option) {
    return !!option.isDisabled;
};



var $8MJe2 = parcelRequire("8MJe2");
/* indicators-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");

var $fjFkG = parcelRequire("fjFkG");
const $1f114d76bc1ab81d$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $fjFkG.default)(actualStyles);
};


var $f8c6de32f1b21b77$export$26417cabd806a658 = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};


var $c4e256eac7ef5e44$var$indicatorContainerStyles = null;
var $c4e256eac7ef5e44$export$d0ffd7e649cab6f = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $f8c6de32f1b21b77$export$26417cabd806a658)(props, 'indicatorsContainer', {
        indicators: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $fjFkG.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-IndicatorsContainer')
        ])
    }, innerProps), children);
};


/* multi-value-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");

var $1ca43377be0bfbff$var$multiValueStyles = {
    root: "_2rko12b0 _1h6d14je _1dqonqa1 _189ee4h9 _1e0c1txw _1ul9ze3t _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _bfhk1j9a _p12f1osq _syazi7uo _3yq3glyw",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk15s3 _16qs1xv8 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
var $1ca43377be0bfbff$export$cf9cf2a30a59265c = function MultiValueContainer(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, isFocused = _ref.isFocused, isDisabled = _ref.isDisabled, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $fjFkG.default)([
            $1ca43377be0bfbff$var$multiValueStyles.root,
            isDisabled && $1ca43377be0bfbff$var$multiValueStyles.disabled,
            isFocused && $1ca43377be0bfbff$var$multiValueStyles.focused,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-multiValue')
        ])
    }), children);
};


/* select-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");


var $cab10268ea777c5a$var$containerStyles = {
    default: "_11c81d4k _kqswh2mm _lcxv1rj4 _1tn2fhey",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf"
};
var $cab10268ea777c5a$export$446eebadefe1123b = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl, xcss = props.xcss;
    var _getStyleProps = (0, $f8c6de32f1b21b77$export$26417cabd806a658)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), className = _getStyleProps.className, css = _getStyleProps.css;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $fjFkG.default)([
            $cab10268ea777c5a$var$containerStyles.default,
            isRtl && $cab10268ea777c5a$var$containerStyles.rtl,
            isDisabled && $cab10268ea777c5a$var$containerStyles.disabled,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-container')
        ]),
        style: css
    }, innerProps), children);
};


/* value-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");


var $137Lh = parcelRequire("137Lh");

var $9775291eefb18560$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _y4ti12x7 _bozg12x7",
    verticalPaddingStandard: "_1q51v77o _85i5v77o",
    verticalPaddingTagUpliftMulti: "_1q511b66 _85i51b66",
    verticalPaddingTagUpliftCompactMulti: "_1q51v77o _85i5v77o",
    verticalPaddingCompactNonUplift: "_1q51ze3t _85i5ze3t",
    flex: "_1e0c1txw",
    flexWithGap: "_zulp1b66 _1e0c1txw _1n261g80"
};
var $9775291eefb18560$export$4dc9f58ad9a1a000 = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue, isCompact = props.isCompact, xcss = props.xcss, controlShouldRenderValue = props.selectProps.controlShouldRenderValue;
    var _getStyleProps = (0, $f8c6de32f1b21b77$export$26417cabd806a658)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    var ffTagUplifts = (0, $137Lh.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    var tagUpliftMultiVertical = ffTagUplifts && isMulti;
    var tagUpliftChipRow = ffTagUplifts && isMulti && hasValue && controlShouldRenderValue;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $fjFkG.default)([
            $9775291eefb18560$var$valueContainerStyles.default,
            tagUpliftMultiVertical && isCompact && $9775291eefb18560$var$valueContainerStyles.verticalPaddingTagUpliftCompactMulti,
            tagUpliftMultiVertical && !isCompact && $9775291eefb18560$var$valueContainerStyles.verticalPaddingTagUpliftMulti,
            !tagUpliftMultiVertical && !isCompact && $9775291eefb18560$var$valueContainerStyles.verticalPaddingStandard,
            !tagUpliftMultiVertical && isCompact && $9775291eefb18560$var$valueContainerStyles.verticalPaddingCompactNonUplift,
            isMulti && hasValue && controlShouldRenderValue && $9775291eefb18560$var$valueContainerStyles.flex,
            tagUpliftChipRow && $9775291eefb18560$var$valueContainerStyles.flexWithGap,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-ValueContainer')
        ]),
        style: css
    }, innerProps), children);
};


/* control.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");


var $137Lh = parcelRequire("137Lh");

var $8665919ac4a0fd0c$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkofajl _v564r5cv _1h6drsbi _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _15peftgi _1ke8ftgi _jaboglyw _1u6luvb6 _4cvxrsbi _123byq51 _d0altlke _irr3l4ek _1ogl1caj",
    defaultT26Shape: "_2rko1qi0",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsvyy1",
    disabled: "_1h6dby5v _lcxvglyw _bfhkby5v _1u6l1s3b",
    focused: "_1h6d1v1w _bfhkr01l _16qsvyy1 _1u6lvyy1 _4cvx1v1w _irr3r01l",
    subtle: "_1h6d1j28 _bfhk1j28 _1u6l3sij",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d1j28 _bfhk1j28 _1u6l3sij _4cvx1j28 _irr31j28"
};
var $8665919ac4a0fd0c$var$Control = function Control(props) {
    var children = props.children, appearance = props.appearance, isCompact = props.isCompact, isDisabled = props.isDisabled, isFocused = props.isFocused, isInvalid = props.isInvalid, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen, xcss = props.xcss;
    var _getStyleProps = (0, $f8c6de32f1b21b77$export$26417cabd806a658)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        ref: innerRef,
        className: (0, $fjFkG.default)([
            $8665919ac4a0fd0c$var$styles.default,
            (0, $137Lh.fg)('platform-dst-shape-theme-default') && $8665919ac4a0fd0c$var$styles.defaultT26Shape,
            isDisabled && $8665919ac4a0fd0c$var$styles.disabled,
            isInvalid && $8665919ac4a0fd0c$var$styles.invalid,
            isCompact && $8665919ac4a0fd0c$var$styles.compact,
            appearance === 'subtle' && $8665919ac4a0fd0c$var$styles.subtle,
            appearance === 'subtle' && isFocused && $8665919ac4a0fd0c$var$styles.subtleFocused,
            isFocused && $8665919ac4a0fd0c$var$styles.focused,
            appearance === 'none' && $8665919ac4a0fd0c$var$styles.none,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-control')
        ]),
        style: css
    }, innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8665919ac4a0fd0c$export$2e2bcd8739ae039 = $8665919ac4a0fd0c$var$Control;


/* group.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");


var $d83249d96f66c520$var$styles = {
    root: "_85i5u2gc _1q51u2gc"
};
var $d83249d96f66c520$var$Group = function Group(props) {
    var children = props.children, builtinCX = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, selectProps = props.selectProps, xcss = props.xcss;
    var _getStyleProps = (0, $f8c6de32f1b21b77$export$26417cabd806a658)(props, 'group', {
        group: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $fjFkG.default)([
            $d83249d96f66c520$var$styles.root,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, innerProps === null || innerProps === void 0 ? void 0 : innerProps.className, '-Group')
        ])
    }), label && /*#__PURE__*/ $7fPBF.createElement(Heading, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, headingProps, {
        selectProps: selectProps,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: builtinCX
    }), label), /*#__PURE__*/ $7fPBF.createElement("div", null, children));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d83249d96f66c520$export$2e2bcd8739ae039 = $d83249d96f66c520$var$Group;


/* group-heading.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");



var $8MJe2 = parcelRequire("8MJe2");

var $emuQy = parcelRequire("emuQy");
var $f4126422cf850daa$var$_excluded = [
    "className",
    "clearValue",
    "cx",
    "xcss",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue"
];
function $f4126422cf850daa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f4126422cf850daa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f4126422cf850daa$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f4126422cf850daa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f4126422cf850daa$export$8e9fd4287627890c = function cleanCommonProps(props) {
    //className
    var className = props.className, clearValue = props.clearValue, cx = props.cx, xcss = props.xcss, getStyles = props.getStyles, getClassNames = props.getClassNames, getValue = props.getValue, hasValue = props.hasValue, isMulti = props.isMulti, isRtl = props.isRtl, options = props.options, selectOption = props.selectOption, selectProps = props.selectProps, setValue = props.setValue, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(props, $f4126422cf850daa$var$_excluded);
    return $f4126422cf850daa$var$_objectSpread({}, innerProps);
};


var $cd92b3927bdd3805$var$_excluded = [
    "data"
];
var $cd92b3927bdd3805$var$headingStyles = null;
var $cd92b3927bdd3805$export$85c8b41a3cd87edc = function GroupHeading(props) {
    var xcss = props.xcss;
    var _cleanCommonProps = (0, $f4126422cf850daa$export$8e9fd4287627890c)(props), data = _cleanCommonProps.data, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_cleanCommonProps, $cd92b3927bdd3805$var$_excluded);
    var _getStyleProps = (0, $f8c6de32f1b21b77$export$26417cabd806a658)(props, 'groupHeading', {
        'group-heading': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $fjFkG.default)([
            "_11c8wadc _1e0c1ule _syazazsu _80om73ad _k48pwu06 _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-group')
        ]),
        style: css
    }, innerProps));
};


/* clear-indicator.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");

var $8b18ffa52acfaefc$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3eb90e0e095210547df6d71f04e27a56>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($8b18ffa52acfaefc$exports, "__esModule", {
    value: true
});
$8b18ffa52acfaefc$exports.default = void 0;

var $8b18ffa52acfaefc$var$_react = $8b18ffa52acfaefc$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $8b18ffa52acfaefc$var$_baseNew = $8b18ffa52acfaefc$var$_interopRequireDefault((parcelRequire("aUDbt")));
function $8b18ffa52acfaefc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8b18ffa52acfaefc$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $8b18ffa52acfaefc$var$_react.default.createElement($8b18ffa52acfaefc$var$_baseNew.default, Object.assign({
        name: "CrossCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$8b18ffa52acfaefc$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $8b18ffa52acfaefc$var$_default = $8b18ffa52acfaefc$exports.default = $8b18ffa52acfaefc$var$CrossCircleIcon;


/* pressable.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");



var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");


function $593ac790924c31ca$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $593ac790924c31ca$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $593ac790924c31ca$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $593ac790924c31ca$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $593ac790924c31ca$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $8618b7ff1a86c099$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $8606d3c77a5913a9$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $8606d3c77a5913a9$export$1d27a74659855e44)(fn);
    var handler = (0, $7fPBF.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $593ac790924c31ca$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}





var $7fPBF = parcelRequire("7fPBF");
var $48ec410b84640600$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);


/* focusable.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");
var $d6ec448880724f9a$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $d6ec448880724f9a$var$_excluded2 = [
    "className"
];
var $d6ec448880724f9a$var$focusRingStyles = null;
var $d6ec448880724f9a$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $d6ec448880724f9a$var$Focusable = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $d6ec448880724f9a$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $d6ec448880724f9a$var$_excluded2);
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $fjFkG.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $d6ec448880724f9a$export$2e2bcd8739ae039 = $d6ec448880724f9a$var$Focusable;


var $41fecbc91843540e$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $41fecbc91843540e$var$_excluded2 = [
    "className"
];
var $41fecbc91843540e$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $41fecbc91843540e$var$Pressable = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $f48d740006cf3f7d$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $41fecbc91843540e$var$_excluded);
    var interactionContext = (0, $7fPBF.useContext)((0, $48ec410b84640600$export$2e2bcd8739ae039));
    var handleClick = (0, $7fPBF.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $593ac790924c31ca$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "19.0.0",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $41fecbc91843540e$var$_excluded2);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d6ec448880724f9a$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $bf96b6408e362ed6$export$95df08bae54cb4df)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)($41fecbc91843540e$var$styles.root, isDisabled && $41fecbc91843540e$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $41fecbc91843540e$export$2e2bcd8739ae039 = $41fecbc91843540e$var$Pressable;



var $d92eac18651b3eb6$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _1q51v77o _y4tiv77o _85i5v77o _bozgv77o"
};
var $d92eac18651b3eb6$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1rpy _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf"
};
var $d92eac18651b3eb6$export$ecf9cf59142dd54a = function ClearIndicator(props) {
    var innerProps = props.innerProps, _props$clearControlLa = props.clearControlLabel, clearControlLabel = _props$clearControlLa === void 0 ? 'clear' : _props$clearControlLa, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps = (0, $f8c6de32f1b21b77$export$26417cabd806a658)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $fjFkG.default)([
            $d92eac18651b3eb6$var$clearIndicatorStyles.default,
            isCompact && $d92eac18651b3eb6$var$clearIndicatorStyles.compact,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-indicatorContainer')
        ])
    }, innerProps), /*#__PURE__*/ $7fPBF.createElement((0, $41fecbc91843540e$export$2e2bcd8739ae039), {
        xcss: $d92eac18651b3eb6$var$iconContainerStyles.root,
        tabIndex: -1,
        "aria-label": clearControlLabel
    }, /*#__PURE__*/ $7fPBF.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8b18ffa52acfaefc$exports))), {
        label: "",
        color: "currentColor",
        size: "small"
    })));
};


/* dropdown-indicator.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");

var $58eddbfe7ba123a9$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($58eddbfe7ba123a9$exports, "__esModule", {
    value: true
});
$58eddbfe7ba123a9$exports.default = void 0;

var $58eddbfe7ba123a9$var$_react = $58eddbfe7ba123a9$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $58eddbfe7ba123a9$var$_baseNew = $58eddbfe7ba123a9$var$_interopRequireDefault((parcelRequire("aUDbt")));
function $58eddbfe7ba123a9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $58eddbfe7ba123a9$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $58eddbfe7ba123a9$var$_react.default.createElement($58eddbfe7ba123a9$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$58eddbfe7ba123a9$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $58eddbfe7ba123a9$var$_default = $58eddbfe7ba123a9$exports.default = $58eddbfe7ba123a9$var$ChevronDownIcon;


/* inline.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ parcelRequire("7fPBF");

const $b9d1c131a6494052$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $b9d1c131a6494052$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};


/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $89b549ac0d00b763$var$ATOMIC_GROUP_LENGTH = 5;
function $89b549ac0d00b763$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $89b549ac0d00b763$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


const $c16c43e7995db31e$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $89b549ac0d00b763$export$2e2bcd8739ae039)(actualStyles);
};


function $5f17e3270868ebf8$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $b9d1c131a6494052$export$c4df1cb0c2b4d77c)();
        },
        cssMap () {
            throw (0, $b9d1c131a6494052$export$c4df1cb0c2b4d77c)();
        },
        cx: $c16c43e7995db31e$export$a274e22fb40f762e,
        XCSSProp () {
            throw (0, $b9d1c131a6494052$export$c4df1cb0c2b4d77c)();
        }
    };
}


var $e636b2257db42c06$var$strictApi = (0, $5f17e3270868ebf8$export$39716b4af53f4ad)();
var $e636b2257db42c06$export$dbf350e5966cf602 = $e636b2257db42c06$var$strictApi.css;
var $e636b2257db42c06$export$eb1ecd84a24ee424 = $e636b2257db42c06$var$strictApi.cssMap;
$e636b2257db42c06$var$strictApi.cssMap;
var $e636b2257db42c06$export$a274e22fb40f762e = $e636b2257db42c06$var$strictApi.cx;
var $e636b2257db42c06$var$XCSSProp = $e636b2257db42c06$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 


/* flex.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");
var $721e0ddba2b4eb5e$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $721e0ddba2b4eb5e$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $721e0ddba2b4eb5e$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $721e0ddba2b4eb5e$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $721e0ddba2b4eb5e$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $721e0ddba2b4eb5e$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $721e0ddba2b4eb5e$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $721e0ddba2b4eb5e$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $721e0ddba2b4eb5e$var$Flex = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $721e0ddba2b4eb5e$var$_excluded);
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, ariaAttributes, {
        role: role,
        className: (0, $fjFkG.default)([
            $721e0ddba2b4eb5e$var$styles.root,
            gap && $721e0ddba2b4eb5e$var$columnGapMap[gap],
            columnGap && $721e0ddba2b4eb5e$var$columnGapMap[columnGap],
            gap && $721e0ddba2b4eb5e$var$rowGapMap[gap],
            rowGap && $721e0ddba2b4eb5e$var$rowGapMap[rowGap],
            alignItems && $721e0ddba2b4eb5e$var$alignItemsMap[alignItems],
            direction && $721e0ddba2b4eb5e$var$flexDirectionMap[direction],
            justifyContent && $721e0ddba2b4eb5e$var$justifyContentMap[justifyContent],
            wrap && $721e0ddba2b4eb5e$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$721e0ddba2b4eb5e$var$Flex.displayName = 'Flex';
var $721e0ddba2b4eb5e$export$2e2bcd8739ae039 = $721e0ddba2b4eb5e$var$Flex;


var $d332230dce261b1e$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $d332230dce261b1e$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $d332230dce261b1e$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, $fjFkG.default)([
            $d332230dce261b1e$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $d332230dce261b1e$var$Inline = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref2, $d332230dce261b1e$var$_excluded);
    var separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $7fPBF.createElement($d332230dce261b1e$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $7fPBF.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $7fPBF.createElement((0, $7fPBF.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $7fPBF.createElement((0, $721e0ddba2b4eb5e$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $e636b2257db42c06$export$a274e22fb40f762e)(grow === 'hug' && $d332230dce261b1e$var$styles.hug, grow === 'fill' && $d332230dce261b1e$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$d332230dce261b1e$var$Inline.displayName = 'Inline';
var $d332230dce261b1e$export$2e2bcd8739ae039 = $d332230dce261b1e$var$Inline;



var $ea3507cc624b5bca$var$dropdownWrapperStyles = {
    root: "_1q5112x7 _y4ti12x7 _85i512x7 _bozg12x7"
};
var $ea3507cc624b5bca$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syazazsu _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf",
    disabled: "_syaz1gmx"
};
var $ea3507cc624b5bca$export$ec98719d3db7f2e4 = function DropdownIndicator(props) {
    var innerProps = props.innerProps, children = props.children, isDisabled = props.isDisabled, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps = (0, $f8c6de32f1b21b77$export$26417cabd806a658)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $fjFkG.default)([
            $ea3507cc624b5bca$var$dropdownStyles.default,
            isDisabled && $ea3507cc624b5bca$var$dropdownStyles.disabled,
            isCompact && $ea3507cc624b5bca$var$dropdownStyles.compact,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-indicatorContainer')
        ])
    }, innerProps), children ? children : /*#__PURE__*/ $7fPBF.createElement((0, $d332230dce261b1e$export$2e2bcd8739ae039), {
        as: "span",
        xcss: $ea3507cc624b5bca$var$dropdownWrapperStyles.root
    }, /*#__PURE__*/ $7fPBF.createElement((0, (/*@__PURE__*/$parcel$interopDefault($58eddbfe7ba123a9$exports))), {
        color: "currentColor",
        label: "open",
        size: "small"
    })));
};


/* loading-indicator.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $8MJe2 = parcelRequire("8MJe2");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");

/* spinner.tsx generated by @compiled/babel-plugin v0.39.1 */ /**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $79a41e9b219be9af$var$ATOMIC_GROUP_LENGTH = 5;
function $79a41e9b219be9af$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $79a41e9b219be9af$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $7fPBF = parcelRequire("7fPBF");

var $43f46bcc377fb1f0$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $aacfdd39b28e059d$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
var $aacfdd39b28e059d$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $aacfdd39b28e059d$var$loadIn = null;
var $aacfdd39b28e059d$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $aacfdd39b28e059d$var$useLayoutEffect = typeof window === 'undefined' ? (0, $7fPBF.useEffect) : (0, $7fPBF.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $aacfdd39b28e059d$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $43f46bcc377fb1f0$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $aacfdd39b28e059d$var$getStrokeColor(appearance);
    var context = (0, $7fPBF.useContext)((0, $48ec410b84640600$export$2e2bcd8739ae039));
    $aacfdd39b28e059d$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $79a41e9b219be9af$export$2e2bcd8739ae039)([
            $aacfdd39b28e059d$var$styles.wrapperStyles,
            $aacfdd39b28e059d$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $79a41e9b219be9af$export$2e2bcd8739ae039)([
            $aacfdd39b28e059d$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $79a41e9b219be9af$export$2e2bcd8739ae039)([
            $aacfdd39b28e059d$var$styles.circleStyles
        ])
    })));
}));
var $aacfdd39b28e059d$export$2e2bcd8739ae039 = $aacfdd39b28e059d$var$Spinner;



var $9b5194014897b16f$var$_excluded = [
    "innerProps",
    "isRtl",
    "size",
    "isCompact",
    "xcss"
];
function $9b5194014897b16f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9b5194014897b16f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9b5194014897b16f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9b5194014897b16f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9b5194014897b16f$var$loadingIndicatorStyles = {
    default: "_1q5112x7 _y4tiu2gc _85i512x7 _bozgu2gc",
    compact: "_1q51idpf _85i5idpf"
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
var $9b5194014897b16f$export$7c20be4c1d342248 = function LoadingIndicator(_ref) {
    var innerProps = _ref.innerProps, isRtl = _ref.isRtl, _ref$size = _ref.size, size = _ref$size === void 0 ? 4 : _ref$size, isCompact = _ref.isCompact, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $9b5194014897b16f$var$_excluded);
    var _getStyleProps = (0, $f8c6de32f1b21b77$export$26417cabd806a658)($9b5194014897b16f$var$_objectSpread($9b5194014897b16f$var$_objectSpread({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $fjFkG.default)([
            $9b5194014897b16f$var$loadingIndicatorStyles.default,
            isCompact && $9b5194014897b16f$var$loadingIndicatorStyles.compact,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-loadingIndicator')
        ])
    }, innerProps), /*#__PURE__*/ $7fPBF.createElement((0, $aacfdd39b28e059d$export$2e2bcd8739ae039), {
        size: "small"
    }));
};


/* input.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");


var $137Lh = parcelRequire("137Lh");


var $af3cd8bd77342c6a$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName",
    "testId"
];
var $af3cd8bd77342c6a$var$inputStylesOld = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
var $af3cd8bd77342c6a$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _kqswh2mm _1e0c1txw _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
var $af3cd8bd77342c6a$var$nativeInputStylesOld = null;
var $af3cd8bd77342c6a$var$nativeInputStyles = null;
var $af3cd8bd77342c6a$var$hidden = null;
var $af3cd8bd77342c6a$var$Input = function Input(props) {
    var builtinCX = props.cx, value = props.value, xcss = props.xcss, isMulti = props.isMulti;
    var _cleanCommonProps = (0, $f4126422cf850daa$export$8e9fd4287627890c)(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, testId = _cleanCommonProps.testId, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_cleanCommonProps, $af3cd8bd77342c6a$var$_excluded);
    var dataId = testId ? "".concat(testId, "-select--input") : null;
    var _getStyleProps = (0, $f8c6de32f1b21b77$export$26417cabd806a658)(props, 'input', {
        'input-container': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    var ffTagUplifts = (0, $137Lh.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    if ((0, $137Lh.fg)('platform_fix_input_component_styling')) return /*#__PURE__*/ $7fPBF.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $fjFkG.default)([
            $af3cd8bd77342c6a$var$inputStyles.root,
            isMulti && ffTagUplifts && $af3cd8bd77342c6a$var$inputStyles.labellingFFStyles,
            isDisabled && $af3cd8bd77342c6a$var$inputStyles.disabled,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $7fPBF.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $fjFkG.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1r04idpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _kqswstnw _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $fjFkG.default)([
            $af3cd8bd77342c6a$var$inputStylesOld.root,
            isMulti && ffTagUplifts && $af3cd8bd77342c6a$var$inputStylesOld.labellingFFStyles,
            isDisabled && $af3cd8bd77342c6a$var$inputStylesOld.disabled,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $7fPBF.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $fjFkG.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$af3cd8bd77342c6a$export$2e2bcd8739ae039 = $af3cd8bd77342c6a$var$Input;


/* menu.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");


var $137Lh = parcelRequire("137Lh");

var $701943b1660eb776$var$menuStyles = {
    root: "_2rko12b0 _kqswstnw _1bsb1osq _1pbykb7n _6rthu2gc _1pfhu2gc _bfhk1bhr _16qs130s",
    rootT26Shape: "_2rko1mok",
    bottom: "_152t1osq",
    top: "_u7co1osq"
};
var $701943b1660eb776$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps, _props$placement = props.placement, placement = _props$placement === void 0 ? 'bottom' : _props$placement, xcss = props.xcss;
    var _getStyleProps = (0, $f8c6de32f1b21b77$export$26417cabd806a658)(props, 'menu', {
        menu: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $fjFkG.default)([
            $701943b1660eb776$var$menuStyles.root,
            $701943b1660eb776$var$menuStyles[placement],
            (0, $137Lh.fg)('platform-dst-shape-theme-default') && $701943b1660eb776$var$menuStyles.rootT26Shape,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(xcss, className, '-menu')
        ]),
        style: css,
        ref: innerRef
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$701943b1660eb776$export$2e2bcd8739ae039 = $701943b1660eb776$var$Menu;


/* menu-list.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");


function $0f1f5577b85c7b6b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0f1f5577b85c7b6b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0f1f5577b85c7b6b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0f1f5577b85c7b6b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0f1f5577b85c7b6b$var$menuListStyles = null;
var $0f1f5577b85c7b6b$export$d4c4e98c5044dc8 = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti, maxHeight = props.maxHeight, xcss = props.xcss;
    var _getStyleProps = (0, $f8c6de32f1b21b77$export$26417cabd806a658)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $fjFkG.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-MenuList')
        ]),
        style: $0f1f5577b85c7b6b$var$_objectSpread($0f1f5577b85c7b6b$var$_objectSpread({}, css), {}, {
            maxHeight: maxHeight
        }),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};


/* menu-loading-message.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $8MJe2 = parcelRequire("8MJe2");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");

/* text.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");
var $80ee8fc99f5202eb$var$isProduction = true;
var $80ee8fc99f5202eb$var$prefix = 'Invariant failed';
function $80ee8fc99f5202eb$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($80ee8fc99f5202eb$var$isProduction) throw new Error($80ee8fc99f5202eb$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($80ee8fc99f5202eb$var$prefix, ": ").concat(provided) : $80ee8fc99f5202eb$var$prefix;
    throw new Error(value);
}



var $7fPBF = parcelRequire("7fPBF");
var $791b73d3b20348cb$var$HasTextAncestorContext = /*#__PURE__*/ (0, $7fPBF.createContext)(false);
var $791b73d3b20348cb$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $7fPBF.useContext)($791b73d3b20348cb$var$HasTextAncestorContext);
};
var $791b73d3b20348cb$export$ae933c6cbe5643ad = $791b73d3b20348cb$var$HasTextAncestorContext.Provider;



var $7fPBF = parcelRequire("7fPBF");
var $d7468988b092818c$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $7fPBF.createContext)('elevation.surface');
var $d7468988b092818c$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $7fPBF.useContext)($d7468988b092818c$export$1ca2a26fecb070ae);
};
$d7468988b092818c$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


var $b492c7d69ebc2798$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $b492c7d69ebc2798$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $d7468988b092818c$export$1aeb4f6b93c4540d)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($b492c7d69ebc2798$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $b492c7d69ebc2798$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
var $b492c7d69ebc2798$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $b492c7d69ebc2798$var$fontSizeMap = {
    medium: "_11c8fhey",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
var $b492c7d69ebc2798$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $b492c7d69ebc2798$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
var $b492c7d69ebc2798$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $b492c7d69ebc2798$var$Text = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)($b492c7d69ebc2798$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $791b73d3b20348cb$export$9322276ec105d055)();
    var color = $b492c7d69ebc2798$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $7fPBF.createElement(Component, {
        id: id,
        className: (0, $fjFkG.default)([
            $b492c7d69ebc2798$var$styles.root,
            size && $b492c7d69ebc2798$var$fontSizeMap[size],
            color && $b492c7d69ebc2798$var$textColorMap[color],
            maxLines && $b492c7d69ebc2798$var$styles.truncation,
            maxLines === 1 && $b492c7d69ebc2798$var$styles.breakAll,
            align && $b492c7d69ebc2798$var$styles["textAlign.".concat(align)],
            weight && $b492c7d69ebc2798$var$fontWeightMap[weight],
            Component === 'em' && $b492c7d69ebc2798$var$styles['as.em'],
            Component === 'strong' && $b492c7d69ebc2798$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $7fPBF.createElement((0, $791b73d3b20348cb$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var $b492c7d69ebc2798$export$2e2bcd8739ae039 = $b492c7d69ebc2798$var$Text;



var $b9b4fb752d208a2b$var$_excluded = [
    "children",
    "innerProps",
    "xcss"
];
function $b9b4fb752d208a2b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b9b4fb752d208a2b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b9b4fb752d208a2b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b9b4fb752d208a2b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b9b4fb752d208a2b$var$noticeStyles = null;
// eslint-disable-next-line @repo/internal/react/require-jsdoc
var $b9b4fb752d208a2b$export$e928a71d039d3102 = function LoadingMessage(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? 'Loading...' : _ref$children, innerProps = _ref.innerProps, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $b9b4fb752d208a2b$var$_excluded);
    var _getStyleProps = (0, $f8c6de32f1b21b77$export$26417cabd806a658)($b9b4fb752d208a2b$var$_objectSpread($b9b4fb752d208a2b$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $fjFkG.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-LoadingMessage')
        ]),
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option"
    }), /*#__PURE__*/ $7fPBF.createElement((0, $b492c7d69ebc2798$export$2e2bcd8739ae039), {
        color: "color.text.subtle"
    }, children));
};


/* menu-no-options-message.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $8MJe2 = parcelRequire("8MJe2");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");



var $8b96d597a244eb84$var$_excluded = [
    "children",
    "innerProps",
    "xcss"
];
function $8b96d597a244eb84$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8b96d597a244eb84$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8b96d597a244eb84$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8b96d597a244eb84$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8b96d597a244eb84$var$noticeStyles = null;
// eslint-disable-next-line @repo/internal/react/require-jsdoc
var $8b96d597a244eb84$export$d58b72b7d3c4072c = function NoOptionsMessage(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? 'No options' : _ref$children, innerProps = _ref.innerProps, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $8b96d597a244eb84$var$_excluded);
    var _getStyleProps = (0, $f8c6de32f1b21b77$export$26417cabd806a658)($8b96d597a244eb84$var$_objectSpread($8b96d597a244eb84$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $fjFkG.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-NoOptionsMessage')
        ]),
        style: css,
        role: "option"
    }, innerProps), /*#__PURE__*/ $7fPBF.createElement((0, $b492c7d69ebc2798$export$2e2bcd8739ae039), {
        color: "color.text.subtle"
    }, children));
};


/* menu-portal.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $8MJe2 = parcelRequire("8MJe2");

var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");


var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ 
var $9tqwB = parcelRequire("9tqwB");
const $f56410848bcbe11b$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $f56410848bcbe11b$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $f56410848bcbe11b$export$803cd8101b6c182b = /*#__PURE__*/ $f56410848bcbe11b$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $f56410848bcbe11b$export$27b07d8a310ed8b5[0], side + "-" + $f56410848bcbe11b$export$27b07d8a310ed8b5[1]), []);
const $f56410848bcbe11b$export$96ec731ed4dcb222 = Math.min;
const $f56410848bcbe11b$export$8960430cfd85939f = Math.max;
const $f56410848bcbe11b$export$2077e0241d6afd3c = Math.round;
const $f56410848bcbe11b$export$a3fe094919f356fd = Math.floor;
const $f56410848bcbe11b$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $f56410848bcbe11b$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $f56410848bcbe11b$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $f56410848bcbe11b$export$7d15b64cf5a3a4c4(start, value, end) {
    return $f56410848bcbe11b$export$8960430cfd85939f(start, $f56410848bcbe11b$export$96ec731ed4dcb222(value, end));
}
function $f56410848bcbe11b$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $f56410848bcbe11b$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $f56410848bcbe11b$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $f56410848bcbe11b$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $f56410848bcbe11b$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $f56410848bcbe11b$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($f56410848bcbe11b$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $f56410848bcbe11b$export$2b57e0052a6d6d4c(placement) {
    return $f56410848bcbe11b$export$8a000a963141ac32($f56410848bcbe11b$export$f28e8f882010718a(placement));
}
function $f56410848bcbe11b$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $f56410848bcbe11b$export$f0989780f32bfcda(placement);
    const alignmentAxis = $f56410848bcbe11b$export$2b57e0052a6d6d4c(placement);
    const length = $f56410848bcbe11b$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $f56410848bcbe11b$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $f56410848bcbe11b$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $f56410848bcbe11b$export$496432a3699e50b1(placement) {
    const oppositePlacement = $f56410848bcbe11b$export$9c5e28bad23365fa(placement);
    return [
        $f56410848bcbe11b$export$2b182c584985588b(placement),
        oppositePlacement,
        $f56410848bcbe11b$export$2b182c584985588b(oppositePlacement)
    ];
}
function $f56410848bcbe11b$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$f56410848bcbe11b$var$oppositeAlignmentMap[alignment]);
}
function $f56410848bcbe11b$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $f56410848bcbe11b$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $f56410848bcbe11b$export$f0989780f32bfcda(placement);
    let list = $f56410848bcbe11b$var$getSideList($f56410848bcbe11b$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($f56410848bcbe11b$export$2b182c584985588b));
    }
    return list;
}
function $f56410848bcbe11b$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$f56410848bcbe11b$var$oppositeSideMap[side]);
}
function $f56410848bcbe11b$export$1c66dbf1a9e34223(padding) {
    return (0, $9tqwB._)({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }, padding);
}
function $f56410848bcbe11b$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $f56410848bcbe11b$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $f56410848bcbe11b$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $b8d321edac7a7d95$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $f56410848bcbe11b$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $f56410848bcbe11b$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $f56410848bcbe11b$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $f56410848bcbe11b$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $b8d321edac7a7d95$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $b8d321edac7a7d95$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = (0, $2qxEV._)((0, $9tqwB._)({}, middlewareData), {
            [name]: (0, $9tqwB._)({}, middlewareData[name], data)
        });
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $b8d321edac7a7d95$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $b8d321edac7a7d95$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $f56410848bcbe11b$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $f56410848bcbe11b$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $f56410848bcbe11b$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $b8d321edac7a7d95$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $f56410848bcbe11b$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $f56410848bcbe11b$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $f56410848bcbe11b$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $f56410848bcbe11b$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $f56410848bcbe11b$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: (0, $9tqwB._)({
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset
                }, shouldAddOffset && {
                    alignmentOffset: alignmentOffset
                }),
                reset: shouldAddOffset
            };
        }
    });
function $b8d321edac7a7d95$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $f56410848bcbe11b$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $f56410848bcbe11b$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $f56410848bcbe11b$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $f56410848bcbe11b$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $b8d321edac7a7d95$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const _evaluate = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state), { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $f56410848bcbe11b$export$803cd8101b6c182b), autoAlignment: autoAlignment = true } = _evaluate, detectOverflowOptions = (0, $bLhVg._)(_evaluate, [
                "crossAxis",
                "alignment",
                "allowedPlacements",
                "autoAlignment"
            ]);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $f56410848bcbe11b$export$803cd8101b6c182b) ? $b8d321edac7a7d95$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $b8d321edac7a7d95$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $f56410848bcbe11b$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $f56410848bcbe11b$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $f56410848bcbe11b$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $f56410848bcbe11b$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $b8d321edac7a7d95$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const _evaluate = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true } = _evaluate, detectOverflowOptions = (0, $bLhVg._)(_evaluate, [
                "mainAxis",
                "crossAxis",
                "fallbackPlacements",
                "fallbackStrategy",
                "fallbackAxisSideDirection",
                "flipAlignment"
            ]);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $f56410848bcbe11b$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $f56410848bcbe11b$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $f56410848bcbe11b$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $f56410848bcbe11b$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $f56410848bcbe11b$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $b8d321edac7a7d95$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $f56410848bcbe11b$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $f56410848bcbe11b$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $b8d321edac7a7d95$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $b8d321edac7a7d95$var$isAnySideFullyClipped(overflow) {
    return (0, $f56410848bcbe11b$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $b8d321edac7a7d95$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const _evaluate = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state), { strategy: strategy = 'referenceHidden' } = _evaluate, detectOverflowOptions = (0, $bLhVg._)(_evaluate, [
                "strategy"
            ]);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $b8d321edac7a7d95$export$37b6bde19b108ecc(state, (0, $2qxEV._)((0, $9tqwB._)({}, detectOverflowOptions), {
                            elementContext: 'reference'
                        }));
                        const offsets = $b8d321edac7a7d95$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $b8d321edac7a7d95$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $b8d321edac7a7d95$export$37b6bde19b108ecc(state, (0, $2qxEV._)((0, $9tqwB._)({}, detectOverflowOptions), {
                            altBoundary: true
                        }));
                        const offsets = $b8d321edac7a7d95$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $b8d321edac7a7d95$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $b8d321edac7a7d95$var$getBoundingRect(rects) {
    const minX = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $f56410848bcbe11b$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $f56410848bcbe11b$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $b8d321edac7a7d95$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $f56410848bcbe11b$export$ee05aea0aeecbad4)($b8d321edac7a7d95$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $b8d321edac7a7d95$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $b8d321edac7a7d95$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $f56410848bcbe11b$export$ee05aea0aeecbad4)($b8d321edac7a7d95$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $f56410848bcbe11b$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $f56410848bcbe11b$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $f56410848bcbe11b$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $b8d321edac7a7d95$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $f56410848bcbe11b$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $f56410848bcbe11b$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $b8d321edac7a7d95$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $b8d321edac7a7d95$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: (0, $2qxEV._)((0, $9tqwB._)({}, diffCoords), {
                    placement: placement
                })
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $b8d321edac7a7d95$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const _evaluate = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            } } = _evaluate, detectOverflowOptions = (0, $bLhVg._)(_evaluate, [
                "mainAxis",
                "crossAxis",
                "limiter"
            ]);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $b8d321edac7a7d95$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $f56410848bcbe11b$export$f28e8f882010718a)((0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $f56410848bcbe11b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $f56410848bcbe11b$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $f56410848bcbe11b$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn((0, $2qxEV._)((0, $9tqwB._)({}, state), {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            }));
            return (0, $2qxEV._)((0, $9tqwB._)({}, limitedCoords), {
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            });
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $b8d321edac7a7d95$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $f56410848bcbe11b$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $f56410848bcbe11b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : (0, $9tqwB._)({
                mainAxis: 0,
                crossAxis: 0
            }, rawOffset);
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $b8d321edac7a7d95$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const _evaluate = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state), { apply: apply = ()=>{} } = _evaluate, detectOverflowOptions = (0, $bLhVg._)(_evaluate, [
                "apply"
            ]);
            const overflow = await $b8d321edac7a7d95$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $f56410848bcbe11b$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $f56410848bcbe11b$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $f56410848bcbe11b$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $f56410848bcbe11b$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $f56410848bcbe11b$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $f56410848bcbe11b$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $f56410848bcbe11b$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $f56410848bcbe11b$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply((0, $2qxEV._)((0, $9tqwB._)({}, state), {
                availableWidth: availableWidth,
                availableHeight: availableHeight
            }));
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $d0eb1ce7e5ffa070$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $d0eb1ce7e5ffa070$export$651544f548703224(node) {
    if ($d0eb1ce7e5ffa070$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $d0eb1ce7e5ffa070$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $d0eb1ce7e5ffa070$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($d0eb1ce7e5ffa070$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $d0eb1ce7e5ffa070$export$8ee0fc9ee280b4ee(value) {
    if (!$d0eb1ce7e5ffa070$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $d0eb1ce7e5ffa070$export$38b2d434cce3ea22(value).Node;
}
function $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d(value) {
    if (!$d0eb1ce7e5ffa070$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $d0eb1ce7e5ffa070$export$38b2d434cce3ea22(value).Element;
}
function $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa(value) {
    if (!$d0eb1ce7e5ffa070$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $d0eb1ce7e5ffa070$export$38b2d434cce3ea22(value).HTMLElement;
}
function $d0eb1ce7e5ffa070$export$af51f0f06c0f328a(value) {
    if (!$d0eb1ce7e5ffa070$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $d0eb1ce7e5ffa070$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $d0eb1ce7e5ffa070$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $d0eb1ce7e5ffa070$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $d0eb1ce7e5ffa070$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($d0eb1ce7e5ffa070$export$651544f548703224(element));
}
function $d0eb1ce7e5ffa070$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $d0eb1ce7e5ffa070$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $d0eb1ce7e5ffa070$export$78551043582a6a98();
    const css = $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d(elementOrCss) ? $d0eb1ce7e5ffa070$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective'
    ].some((value)=>css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $d0eb1ce7e5ffa070$export$940d8225183e1404(element) {
    let currentNode = $d0eb1ce7e5ffa070$export$4e12058fc4d51d56(element);
    while($d0eb1ce7e5ffa070$export$1b3bfaa9684536aa(currentNode) && !$d0eb1ce7e5ffa070$export$d1162fb0b6d4cd51(currentNode)){
        if ($d0eb1ce7e5ffa070$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($d0eb1ce7e5ffa070$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $d0eb1ce7e5ffa070$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $d0eb1ce7e5ffa070$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $d0eb1ce7e5ffa070$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($d0eb1ce7e5ffa070$export$651544f548703224(node));
}
function $d0eb1ce7e5ffa070$export$3735103072e4a80(element) {
    return $d0eb1ce7e5ffa070$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $d0eb1ce7e5ffa070$export$dc8fc79fa2800137(element) {
    if ($d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $d0eb1ce7e5ffa070$export$4e12058fc4d51d56(node) {
    if ($d0eb1ce7e5ffa070$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $d0eb1ce7e5ffa070$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $d0eb1ce7e5ffa070$export$e495491855dc5418(node);
    return $d0eb1ce7e5ffa070$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $d0eb1ce7e5ffa070$export$7cd01a57c8ca906c(node) {
    const parentNode = $d0eb1ce7e5ffa070$export$4e12058fc4d51d56(node);
    if ($d0eb1ce7e5ffa070$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($d0eb1ce7e5ffa070$export$1b3bfaa9684536aa(parentNode) && $d0eb1ce7e5ffa070$export$989e911fa9af580a(parentNode)) return parentNode;
    return $d0eb1ce7e5ffa070$export$7cd01a57c8ca906c(parentNode);
}
function $d0eb1ce7e5ffa070$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $d0eb1ce7e5ffa070$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $d0eb1ce7e5ffa070$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $d0eb1ce7e5ffa070$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $d0eb1ce7e5ffa070$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $d0eb1ce7e5ffa070$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $d0eb1ce7e5ffa070$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $d0eb1ce7e5ffa070$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $28b5c677ea6a5d8a$var$getCssDimensions(element) {
    const css = (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $f56410848bcbe11b$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $f56410848bcbe11b$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $28b5c677ea6a5d8a$var$unwrapElement(element) {
    return !(0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $28b5c677ea6a5d8a$var$getScale(element) {
    const domElement = $28b5c677ea6a5d8a$var$unwrapElement(element);
    if (!(0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(domElement)) return (0, $f56410848bcbe11b$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $28b5c677ea6a5d8a$var$getCssDimensions(domElement);
    let x = ($ ? (0, $f56410848bcbe11b$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $f56410848bcbe11b$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $28b5c677ea6a5d8a$var$noOffsets = /*#__PURE__*/ (0, $f56410848bcbe11b$export$a397704b5e280835)(0);
function $28b5c677ea6a5d8a$var$getVisualOffsets(element) {
    const win = (0, $d0eb1ce7e5ffa070$export$38b2d434cce3ea22)(element);
    if (!(0, $d0eb1ce7e5ffa070$export$78551043582a6a98)() || !win.visualViewport) return $28b5c677ea6a5d8a$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $28b5c677ea6a5d8a$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $d0eb1ce7e5ffa070$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $28b5c677ea6a5d8a$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $28b5c677ea6a5d8a$var$unwrapElement(element);
    let scale = (0, $f56410848bcbe11b$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(offsetParent)) scale = $28b5c677ea6a5d8a$var$getScale(offsetParent);
        } else scale = $28b5c677ea6a5d8a$var$getScale(element);
    }
    const visualOffsets = $28b5c677ea6a5d8a$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $28b5c677ea6a5d8a$var$getVisualOffsets(domElement) : (0, $f56410848bcbe11b$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $d0eb1ce7e5ffa070$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $d0eb1ce7e5ffa070$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $d0eb1ce7e5ffa070$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $28b5c677ea6a5d8a$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $d0eb1ce7e5ffa070$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $d0eb1ce7e5ffa070$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $f56410848bcbe11b$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $28b5c677ea6a5d8a$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $d0eb1ce7e5ffa070$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $28b5c677ea6a5d8a$var$getBoundingClientRect((0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $28b5c677ea6a5d8a$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $28b5c677ea6a5d8a$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $28b5c677ea6a5d8a$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $d0eb1ce7e5ffa070$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $f56410848bcbe11b$export$a397704b5e280835)(1);
    const offsets = (0, $f56410848bcbe11b$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $d0eb1ce7e5ffa070$export$651544f548703224)(offsetParent) !== 'body' || (0, $d0eb1ce7e5ffa070$export$989e911fa9af580a)(documentElement)) scroll = (0, $d0eb1ce7e5ffa070$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $28b5c677ea6a5d8a$var$getBoundingClientRect(offsetParent);
            scale = $28b5c677ea6a5d8a$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $28b5c677ea6a5d8a$var$getHTMLOffset(documentElement, scroll, true) : (0, $f56410848bcbe11b$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $28b5c677ea6a5d8a$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $28b5c677ea6a5d8a$var$getDocumentRect(element) {
    const html = (0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(element);
    const scroll = (0, $d0eb1ce7e5ffa070$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $f56410848bcbe11b$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $f56410848bcbe11b$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $28b5c677ea6a5d8a$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $f56410848bcbe11b$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $28b5c677ea6a5d8a$var$getViewportRect(element, strategy) {
    const win = (0, $d0eb1ce7e5ffa070$export$38b2d434cce3ea22)(element);
    const html = (0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $d0eb1ce7e5ffa070$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $28b5c677ea6a5d8a$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $28b5c677ea6a5d8a$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(element) ? $28b5c677ea6a5d8a$var$getScale(element) : (0, $f56410848bcbe11b$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $28b5c677ea6a5d8a$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $28b5c677ea6a5d8a$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $28b5c677ea6a5d8a$var$getDocumentRect((0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(element));
    else if ((0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $28b5c677ea6a5d8a$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $28b5c677ea6a5d8a$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $f56410848bcbe11b$export$ee05aea0aeecbad4)(rect);
}
function $28b5c677ea6a5d8a$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $d0eb1ce7e5ffa070$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(parentNode) || (0, $d0eb1ce7e5ffa070$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(parentNode).position === 'fixed' || $28b5c677ea6a5d8a$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $28b5c677ea6a5d8a$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $d0eb1ce7e5ffa070$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(el) && (0, $d0eb1ce7e5ffa070$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $d0eb1ce7e5ffa070$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(currentNode) && !(0, $d0eb1ce7e5ffa070$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $d0eb1ce7e5ffa070$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $d0eb1ce7e5ffa070$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $28b5c677ea6a5d8a$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $d0eb1ce7e5ffa070$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $28b5c677ea6a5d8a$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $d0eb1ce7e5ffa070$export$89e651af02346cd4)(element) ? [] : $28b5c677ea6a5d8a$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $28b5c677ea6a5d8a$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $f56410848bcbe11b$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $f56410848bcbe11b$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $28b5c677ea6a5d8a$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $28b5c677ea6a5d8a$var$getDimensions(element) {
    const { width: width, height: height } = $28b5c677ea6a5d8a$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $28b5c677ea6a5d8a$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $28b5c677ea6a5d8a$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $f56410848bcbe11b$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $d0eb1ce7e5ffa070$export$651544f548703224)(offsetParent) !== 'body' || (0, $d0eb1ce7e5ffa070$export$989e911fa9af580a)(documentElement)) scroll = (0, $d0eb1ce7e5ffa070$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $28b5c677ea6a5d8a$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $28b5c677ea6a5d8a$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $28b5c677ea6a5d8a$var$getHTMLOffset(documentElement, scroll) : (0, $f56410848bcbe11b$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $28b5c677ea6a5d8a$var$isStaticPositioned(element) {
    return (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(element).position === 'static';
}
function $28b5c677ea6a5d8a$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(element) || (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $28b5c677ea6a5d8a$var$getOffsetParent(element, polyfill) {
    const win = (0, $d0eb1ce7e5ffa070$export$38b2d434cce3ea22)(element);
    if ((0, $d0eb1ce7e5ffa070$export$89e651af02346cd4)(element)) return win;
    if (!(0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $d0eb1ce7e5ffa070$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $d0eb1ce7e5ffa070$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$28b5c677ea6a5d8a$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $d0eb1ce7e5ffa070$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $28b5c677ea6a5d8a$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $d0eb1ce7e5ffa070$export$71535ffaa902797f)(offsetParent) && $28b5c677ea6a5d8a$var$isStaticPositioned(offsetParent))offsetParent = $28b5c677ea6a5d8a$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $d0eb1ce7e5ffa070$export$d1162fb0b6d4cd51)(offsetParent) && $28b5c677ea6a5d8a$var$isStaticPositioned(offsetParent) && !(0, $d0eb1ce7e5ffa070$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $d0eb1ce7e5ffa070$export$940d8225183e1404)(element) || win;
}
const $28b5c677ea6a5d8a$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $28b5c677ea6a5d8a$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $28b5c677ea6a5d8a$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $28b5c677ea6a5d8a$var$isRTL(element) {
    return (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(element).direction === 'rtl';
}
const $28b5c677ea6a5d8a$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $28b5c677ea6a5d8a$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $d0eb1ce7e5ffa070$export$e495491855dc5418,
    getClippingRect: $28b5c677ea6a5d8a$var$getClippingRect,
    getOffsetParent: $28b5c677ea6a5d8a$var$getOffsetParent,
    getElementRects: $28b5c677ea6a5d8a$var$getElementRects,
    getClientRects: $28b5c677ea6a5d8a$var$getClientRects,
    getDimensions: $28b5c677ea6a5d8a$var$getDimensions,
    getScale: $28b5c677ea6a5d8a$var$getScale,
    isElement: $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d,
    isRTL: $28b5c677ea6a5d8a$var$isRTL
};
function $28b5c677ea6a5d8a$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $28b5c677ea6a5d8a$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $f56410848bcbe11b$export$a3fe094919f356fd)(top);
        const insetRight = (0, $f56410848bcbe11b$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $f56410848bcbe11b$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $f56410848bcbe11b$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $f56410848bcbe11b$export$8960430cfd85939f)(0, (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$28b5c677ea6a5d8a$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, (0, $2qxEV._)((0, $9tqwB._)({}, options), {
                // Handle <iframe>s
                root: root.ownerDocument
            }));
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $28b5c677ea6a5d8a$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $28b5c677ea6a5d8a$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $d0eb1ce7e5ffa070$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $d0eb1ce7e5ffa070$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $28b5c677ea6a5d8a$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $28b5c677ea6a5d8a$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $28b5c677ea6a5d8a$var$getBoundingClientRect(reference);
        if (prevRefRect && !$28b5c677ea6a5d8a$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $28b5c677ea6a5d8a$export$37b6bde19b108ecc = (0, $b8d321edac7a7d95$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $28b5c677ea6a5d8a$export$cc800923e997bb8 = (0, $b8d321edac7a7d95$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $28b5c677ea6a5d8a$export$91fb6ecbd551914 = (0, $b8d321edac7a7d95$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $28b5c677ea6a5d8a$export$fba63a578e423eb = (0, $b8d321edac7a7d95$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $28b5c677ea6a5d8a$export$8a83211c878a3f1f = (0, $b8d321edac7a7d95$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $28b5c677ea6a5d8a$export$346677f925de839c = (0, $b8d321edac7a7d95$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $28b5c677ea6a5d8a$export$fe8985bb6374093c = (0, $b8d321edac7a7d95$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $28b5c677ea6a5d8a$export$f2120bbfa5450bd2 = (0, $b8d321edac7a7d95$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $28b5c677ea6a5d8a$export$18c8ad048e32c7d5 = (0, $b8d321edac7a7d95$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $28b5c677ea6a5d8a$export$7bf07e38f3dc4b69 = (0, $b8d321edac7a7d95$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $28b5c677ea6a5d8a$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = (0, $9tqwB._)({
        platform: $28b5c677ea6a5d8a$export$722a64dea1b767dc
    }, options);
    const platformWithCache = (0, $2qxEV._)((0, $9tqwB._)({}, mergedOptions.platform), {
        _c: cache
    });
    return (0, $b8d321edac7a7d95$export$48a53dcb22e581d0)(reference, floating, (0, $2qxEV._)((0, $9tqwB._)({}, mergedOptions), {
        platform: platformWithCache
    }));
};





var $7fPBF = parcelRequire("7fPBF");
var $54dee0294add7ccc$export$e001f626511a0ead = /*#__PURE__*/ (0, $7fPBF.createContext)(null);


function $1a0fbf90781368a3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1a0fbf90781368a3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1a0fbf90781368a3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1a0fbf90781368a3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1a0fbf90781368a3$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
var $1a0fbf90781368a3$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $1a0fbf90781368a3$var$menuPortalStyles = {
    root: "_1pbykb7n _1e02a1vk _kqswcp1v _152t1nmo _1bsb1qxj"
};
var $1a0fbf90781368a3$export$793392f970497feb = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, xcss = props.xcss;
    var menuPortalRef = (0, $7fPBF.useRef)(null);
    var cleanupRef = (0, $7fPBF.useRef)(null);
    var _useState = (0, $7fPBF.useState)($1a0fbf90781368a3$var$coercePlacement(menuPlacement)), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), placement = _useState2[0], setPortalPlacement = _useState2[1];
    var portalPlacementContext = (0, $7fPBF.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState3 = (0, $7fPBF.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 2), computedPosition = _useState4[0], setComputedPosition = _useState4[1];
    var updateComputedPosition = (0, $7fPBF.useCallback)(function() {
        if (!controlElement) return;
        var rect = $1a0fbf90781368a3$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $7fPBF.useLayoutEffect)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $7fPBF.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $28b5c677ea6a5d8a$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $7fPBF.useLayoutEffect)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $7fPBF.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    var _getStyleProps = (0, $f8c6de32f1b21b77$export$26417cabd806a658)($1a0fbf90781368a3$var$_objectSpread($1a0fbf90781368a3$var$_objectSpread({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    // same wrapper element whether fixed or portalled
    var menuWrapper = /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $fjFkG.default)([
            $1a0fbf90781368a3$var$menuPortalStyles.root,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: $1a0fbf90781368a3$var$_objectSpread({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': "".concat(computedPosition.rect.left, "px"),
            '--menu-position': menuPosition,
            '--menu-top': "".concat(computedPosition.offset, "px"),
            '--menu-width': "".concat(computedPosition.rect.width, "px")
        }, css)
    }, innerProps), children);
    return /*#__PURE__*/ $7fPBF.createElement((0, $54dee0294add7ccc$export$e001f626511a0ead).Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $b4ba1c853f6e1116$exports.createPortal)(menuWrapper, appendTo) : menuWrapper);
};


/* multi-value.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $8MJe2 = parcelRequire("8MJe2");


var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");


var $137Lh = parcelRequire("137Lh");
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $8MJe2 = parcelRequire("8MJe2");


var $iKdEz = parcelRequire("iKdEz");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $7StG6 = parcelRequire("7StG6");

var $7fPBF = parcelRequire("7fPBF");


var $0d09177678401696$export$53c2b9c37c40e0d8 = function useCallbackWithAnalytics(method, payload, channel) {
    var _useAnalyticsEvents = (0, $8618b7ff1a86c099$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var methodRef = (0, $8606d3c77a5913a9$export$1d27a74659855e44)(method);
    var payloadRef = (0, $8606d3c77a5913a9$export$1d27a74659855e44)(payload);
    return (0, $7fPBF.useCallback)(function() {
        var pload = typeof payloadRef.current === 'function' ? payloadRef.current.apply(payloadRef, arguments) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current.apply(methodRef, arguments);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};



var $bRUy3 = parcelRequire("bRUy3");
function $9ec85dcfc6117313$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null && (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref) === 'object') ref.current = value;
        });
    };
}



/* lozenge.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $7StG6 = parcelRequire("7StG6");

var $137Lh = parcelRequire("137Lh");
/* lozenge.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

/* lozenge-base.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $8MJe2 = parcelRequire("8MJe2");


var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $7StG6 = parcelRequire("7StG6");
/* badge.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $76665f67c62366ce$var$ATOMIC_GROUP_LENGTH = 5;
function $76665f67c62366ce$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $76665f67c62366ce$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $137Lh = parcelRequire("137Lh");
/* text.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");
var $a13a23de933a58b6$var$HasTextAncestorContext = /*#__PURE__*/ (0, $7fPBF.createContext)(false);
var $a13a23de933a58b6$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $7fPBF.useContext)($a13a23de933a58b6$var$HasTextAncestorContext);
};
var $a13a23de933a58b6$export$ae933c6cbe5643ad = $a13a23de933a58b6$var$HasTextAncestorContext.Provider;



var $7fPBF = parcelRequire("7fPBF");
var $6ea5ae6990a3818f$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $7fPBF.createContext)('elevation.surface');
var $6ea5ae6990a3818f$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $7fPBF.useContext)($6ea5ae6990a3818f$export$1ca2a26fecb070ae);
};
$6ea5ae6990a3818f$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


var $684e8971632ae50d$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $684e8971632ae50d$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $6ea5ae6990a3818f$export$1aeb4f6b93c4540d)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($684e8971632ae50d$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $684e8971632ae50d$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
var $684e8971632ae50d$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $684e8971632ae50d$var$fontSizeMap = {
    medium: "_11c8fhey",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
var $684e8971632ae50d$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $684e8971632ae50d$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
var $684e8971632ae50d$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $684e8971632ae50d$var$Text = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)($684e8971632ae50d$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $a13a23de933a58b6$export$9322276ec105d055)();
    var color = $684e8971632ae50d$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $7fPBF.createElement(Component, {
        id: id,
        className: (0, $76665f67c62366ce$export$2e2bcd8739ae039)([
            $684e8971632ae50d$var$styles.root,
            size && $684e8971632ae50d$var$fontSizeMap[size],
            color && $684e8971632ae50d$var$textColorMap[color],
            maxLines && $684e8971632ae50d$var$styles.truncation,
            maxLines === 1 && $684e8971632ae50d$var$styles.breakAll,
            align && $684e8971632ae50d$var$styles["textAlign.".concat(align)],
            weight && $684e8971632ae50d$var$fontWeightMap[weight],
            Component === 'em' && $684e8971632ae50d$var$styles['as.em'],
            Component === 'strong' && $684e8971632ae50d$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $7fPBF.createElement((0, $a13a23de933a58b6$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var $684e8971632ae50d$export$2e2bcd8739ae039 = $684e8971632ae50d$var$Text;


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ var $da63713475011c71$export$d21bba0569254935 = {
    added: 'success',
    removed: 'danger',
    default: 'neutral',
    primary: 'information',
    primaryInverted: 'inverse',
    important: 'danger',
    warning: 'warning',
    discovery: 'discovery',
    danger: 'danger',
    success: 'success',
    information: 'information',
    inverse: 'inverse',
    neutral: 'neutral'
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ var $5569b3d269e3747c$export$16f8cc7ac3541e83 = {
    added: 'added',
    removed: 'removed',
    default: 'default',
    primary: 'primary',
    primaryInverted: 'primaryInverted',
    important: 'important',
    danger: 'removed',
    success: 'added',
    information: 'primary',
    inverse: 'primaryInverted',
    neutral: 'default',
    warning: 'default',
    discovery: 'default'
};


/* badge-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");


function $eedd507ab63a9990$var$getSafeValue() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $eedd507ab63a9990$export$7c4d25c0c3217d8c(value, max) {
    var safeValue = $eedd507ab63a9990$var$getSafeValue(value);
    var safeMax = $eedd507ab63a9990$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}


/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ // Nested selectors with data attributes are required for theme switching
var $29708b40e881727e$var$stylesNew = {
    root: "_2rkolb4i _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    success: "_syaz1p1e _bfhk14j0",
    danger: "_syaz1blx _bfhk18wg",
    warning: "_syazmgs1 _bfhk10f4",
    information: "_syaz1qd9 _bfhk8lbg",
    discovery: "_syaz1g72 _bfhke670",
    neutral: "_syazi7uo _bfhk7qp0",
    inverse: "_bfhkvuon _syazi7uo"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ var $29708b40e881727e$var$badgeValueWithNegativeNumberSupported = function badgeValueWithNegativeNumberSupported(children, max) {
    return typeof children === 'number' && max ? (0, $eedd507ab63a9990$export$7c4d25c0c3217d8c)(children, max) : children;
};
/**
 * __BadgeNew__
 *
 * New visual refresh implementation of Badge component for the labelling system.
 * This component is used when the 'platform-dst-lozenge-tag-badge-visual-uplifts' feature flag is enabled.
 *
 * Uses new appearance naming convention:
 * - success (green)
 * - danger (red)
 * - neutral (gray)
 * - information (blue)
 * - inverse (inverted colors)
 * - warning (orange/yellow)
 * - discovery (purple)
 */ var $29708b40e881727e$var$BadgeNew = /*#__PURE__*/ (0, $7fPBF.memo)(function BadgeNew(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $76665f67c62366ce$export$2e2bcd8739ae039)([
            $29708b40e881727e$var$stylesNew.root,
            $29708b40e881727e$var$stylesNew[appearance]
        ])
    }, /*#__PURE__*/ $7fPBF.createElement((0, $684e8971632ae50d$export$2e2bcd8739ae039), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $29708b40e881727e$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $29708b40e881727e$export$2e2bcd8739ae039 = $29708b40e881727e$var$BadgeNew;


function $4ed3dfa64388f2aa$var$getSafeValueWithNegativeSupport() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $4ed3dfa64388f2aa$export$4b844743568d5983(value, max) {
    var safeValue = $4ed3dfa64388f2aa$var$getSafeValueWithNegativeSupport(value);
    var safeMax = $4ed3dfa64388f2aa$var$getSafeValueWithNegativeSupport(max);
    var hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}


/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they will be updated in the labelling system work and we want to avoid frequent UI changes.\
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ var $35fbf3ba688956a9$var$neutral300 = '#DDDEE1';
var $35fbf3ba688956a9$var$red300 = '#FD9891';
var $35fbf3ba688956a9$var$blue300 = '#8FB8F6';
var $35fbf3ba688956a9$var$neutral1000 = '#292A2E';
var $35fbf3ba688956a9$var$styles = {
    root: "_2rkolb4i _18zr1b66 _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    added: "_bfhk1y9u _syazi7uo",
    default: "_bfhk1fkg _syazwwip",
    important: "_bfhk1366 _syazwwip",
    primary: "_bfhk1ymo _syazwwip",
    primaryInverted: "_bfhkvuon _syaz1oa5",
    removed: "_bfhk1gly _syazi7uo"
};
var $35fbf3ba688956a9$var$badgeValueWithNegativeNumberSupported = function badgeValueWithNegativeNumberSupported(children, max) {
    return typeof children === 'number' && typeof max === 'number' ? (0, $4ed3dfa64388f2aa$export$4b844743568d5983)(children, max) : children;
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ var $35fbf3ba688956a9$var$Badge = /*#__PURE__*/ (0, $7fPBF.memo)(function Badge(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    if ((0, $137Lh.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        // Map old appearance names to new ones
        var newAppearance = (0, $da63713475011c71$export$d21bba0569254935)[appearance];
        return /*#__PURE__*/ $7fPBF.createElement((0, $29708b40e881727e$export$2e2bcd8739ae039), {
            appearance: newAppearance,
            max: max,
            style: style,
            testId: testId
        }, children);
    }
    var oldAppearance = (0, $5569b3d269e3747c$export$16f8cc7ac3541e83)[appearance];
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $76665f67c62366ce$export$2e2bcd8739ae039)([
            $35fbf3ba688956a9$var$styles.root,
            $35fbf3ba688956a9$var$styles[oldAppearance]
        ])
    }, /*#__PURE__*/ $7fPBF.createElement((0, $684e8971632ae50d$export$2e2bcd8739ae039), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $35fbf3ba688956a9$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $35fbf3ba688956a9$export$2e2bcd8739ae039 = $35fbf3ba688956a9$var$Badge;



var $53b5033184a33c84$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($53b5033184a33c84$exports, "__esModule", {
    value: true
});
$53b5033184a33c84$exports.default = void 0;

var $53b5033184a33c84$var$_react = $53b5033184a33c84$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $53b5033184a33c84$var$_baseNew = $53b5033184a33c84$var$_interopRequireDefault((parcelRequire("8fG9o")));
function $53b5033184a33c84$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $53b5033184a33c84$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $53b5033184a33c84$var$_react.default.createElement($53b5033184a33c84$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$53b5033184a33c84$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $53b5033184a33c84$var$_default = $53b5033184a33c84$exports.default = $53b5033184a33c84$var$ChevronDownIcon;



var $emuQy = parcelRequire("emuQy");

var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");
var $a091c25729a976b1$exports = {};
"use strict";
Object.defineProperty($a091c25729a976b1$exports, "__esModule", {
    value: true
});
$a091c25729a976b1$exports.bindAll = $a091c25729a976b1$exports.bind = void 0;
var $f0ddb24ec1b772be$exports = {};
"use strict";
Object.defineProperty($f0ddb24ec1b772be$exports, "__esModule", {
    value: true
});
$f0ddb24ec1b772be$exports.bind = void 0;
function $f0ddb24ec1b772be$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
$f0ddb24ec1b772be$exports.bind = $f0ddb24ec1b772be$var$bind;


Object.defineProperty($a091c25729a976b1$exports, "bind", {
    enumerable: true,
    get: function() {
        return $f0ddb24ec1b772be$exports.bind;
    }
});
var $1057e213ed66a122$exports = {};
"use strict";
var $1057e213ed66a122$var$__assign = $1057e213ed66a122$exports && $1057e213ed66a122$exports.__assign || function() {
    $1057e213ed66a122$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1057e213ed66a122$var$__assign.apply(this, arguments);
};
Object.defineProperty($1057e213ed66a122$exports, "__esModule", {
    value: true
});
$1057e213ed66a122$exports.bindAll = void 0;

function $1057e213ed66a122$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $1057e213ed66a122$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $1057e213ed66a122$var$__assign($1057e213ed66a122$var$__assign({}, original), {
        options: $1057e213ed66a122$var$__assign($1057e213ed66a122$var$__assign({}, $1057e213ed66a122$var$toOptions(sharedOptions)), $1057e213ed66a122$var$toOptions(original.options))
    });
    return binding;
}
function $1057e213ed66a122$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $1057e213ed66a122$var$getBinding(original, sharedOptions);
        return (0, $f0ddb24ec1b772be$exports.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
$1057e213ed66a122$exports.bindAll = $1057e213ed66a122$var$bindAll;


Object.defineProperty($a091c25729a976b1$exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $1057e213ed66a122$exports.bindAll;
    }
});


/**
 * Use for any CSS based motion (animation or transition).
 * Always put at the end of your declaration for correct use of the cascade.
 * Reduced motion preference is generally set through OS preferences/settings.
 *
 * @deprecated This is not fully compatible with Compiled CSS and will be removed in the future.
 * You should hardcode the `prefers-reduced-motion` media query in your file instead.
 */ var $08412a6538a36b65$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};


var $d4daef9147c5842c$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $d4daef9147c5842c$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$d4daef9147c5842c$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $d4daef9147c5842c$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $7fPBF.useState)($d4daef9147c5842c$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $7fPBF.useEffect)(function() {
        if (!$d4daef9147c5842c$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $a091c25729a976b1$exports.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $d4daef9147c5842c$export$ff7706047246b98b = function prefersReducedMotion() {
    return 0, $08412a6538a36b65$export$f0f789643ba5a83c;
};



var $7fPBF = parcelRequire("7fPBF");
// Handle both browser and Node.js environments
var $fec12d368d681fb0$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $fec12d368d681fb0$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $7fPBF.useRef)([]);
    (0, $7fPBF.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $fec12d368d681fb0$var$getHookDeps(opts));
    return (0, $7fPBF.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $fec12d368d681fb0$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $7fPBF.useRef)([]);
    (0, $7fPBF.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $fec12d368d681fb0$var$getHookDeps(opts));
    return (0, $7fPBF.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};



var $7fPBF = parcelRequire("7fPBF");
var $d428d4ee5fc7f73a$export$ff879f35a69d56b7 = function useElementRef() {
    var elementRef = (0, $7fPBF.useRef)(null);
    var setRef = (0, $7fPBF.useCallback)(function(ref) {
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};



var $7fPBF = parcelRequire("7fPBF");
var $4e1fe18a5f43db0e$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $7fPBF.useEffect) : (0, $7fPBF.useLayoutEffect);



var $7fPBF = parcelRequire("7fPBF");

var $3092032d92807753$export$9e95200239cd148b = function useSnapshotBeforeUpdate(cb) {
    var isFirstRender = (0, $7fPBF.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $4e1fe18a5f43db0e$export$e5c5a5f917a5871c)(function() {
        isFirstRender.current = false;
    }, []);
};


var $18b7944ba172ba81$var$_excluded = [
    "children"
];
/**
 * Which dimension(s) of the element to animate.
 *
 * - `'width'` animates only width changes.
 * - `'height'` animates only height changes.
 * - `'both'` animates width and height changes simultaneously.
 */ /**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $18b7944ba172ba81$var$parseCSSTimeToMs(value) {
    var parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $18b7944ba172ba81$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $18b7944ba172ba81$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
var $18b7944ba172ba81$export$a300664a1a230956 = function useResizing(_ref) {
    var dimension = _ref.dimension, duration = _ref.duration, easing = _ref.easing, onFinishMotion = _ref.onFinishMotion;
    var prevDimensions = (0, $7fPBF.useRef)();
    var _useElementRef = (0, $d428d4ee5fc7f73a$export$ff879f35a69d56b7)(), _useElementRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useElementRef, 2), element = _useElementRef2[0], setElementRef = _useElementRef2[1];
    var setTimeout = (0, $fec12d368d681fb0$export$4f34107a2b00f39c)({
        cleanup: 'next-effect'
    });
    var requestAnimationFrame = (0, $fec12d368d681fb0$export$1775f27e7c8051ca)();
    (0, $3092032d92807753$export$9e95200239cd148b)(function() {
        if ((0, $d4daef9147c5842c$export$b7baf7667a68d87c)() || !element) return;
        var rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $4e1fe18a5f43db0e$export$e5c5a5f917a5871c)(function() {
        if ((0, $d4daef9147c5842c$export$b7baf7667a68d87c)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        var rect = element.getBoundingClientRect();
        var nextDimensions = {
            width: rect.width,
            height: rect.height
        };
        if (!$18b7944ba172ba81$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
            return;
        }
        var propertyList = $18b7944ba172ba81$var$getDimensionPropertyList(dimension);
        var newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = "".concat(prevDimensions.current.width, "px");
        if (dimension === 'height' || dimension === 'both') newStyles.height = "".concat(prevDimensions.current.height, "px");
        Object.assign(element.style, newStyles);
        var resolvedDuration = $18b7944ba172ba81$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = "".concat(nextDimensions.width, "px");
                if (dimension === 'height' || dimension === 'both') element.style.height = "".concat(nextDimensions.height, "px");
                setTimeout(function() {
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
var $18b7944ba172ba81$export$9942248a1ae255c2 = function Resizing(_ref2) {
    var children = _ref2.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref2, $18b7944ba172ba81$var$_excluded);
    var resizing = $18b7944ba172ba81$export$a300664a1a230956(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, children(resizing));
};



var $137Lh = parcelRequire("137Lh");


var $j9spr = parcelRequire("j9spr");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $3104ec53a35158ff$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $3104ec53a35158ff$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $3104ec53a35158ff$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $3104ec53a35158ff$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$3104ec53a35158ff$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($3104ec53a35158ff$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $3104ec53a35158ff$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 = "-ms-";
var $83f8df0fc4bef2f6$export$2c0f367103c8d01c = "-moz-";
var $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 = "-webkit-";
var $83f8df0fc4bef2f6$export$a29989082612d0d9 = "comm";
var $83f8df0fc4bef2f6$export$aa3a2e812ca8570d = "rule";
var $83f8df0fc4bef2f6$export$527d108ccf083c2b = "decl";
var $83f8df0fc4bef2f6$export$d3d35020fa5b54f0 = "@page";
var $83f8df0fc4bef2f6$export$500415a86c544f73 = "@media";
var $83f8df0fc4bef2f6$export$a763edbf796b780a = "@import";
var $83f8df0fc4bef2f6$export$2790aeb8b4e5c826 = "@charset";
var $83f8df0fc4bef2f6$export$1cc683e23b84b133 = "@viewport";
var $83f8df0fc4bef2f6$export$9447a5efea57e862 = "@supports";
var $83f8df0fc4bef2f6$export$ef011b4e114b1fba = "@document";
var $83f8df0fc4bef2f6$export$6aad947bda0f3f46 = "@namespace";
var $83f8df0fc4bef2f6$export$b44a8529a35fcb60 = "@keyframes";
var $83f8df0fc4bef2f6$export$2c16de31893252e6 = "@font-face";
var $83f8df0fc4bef2f6$export$3d846dd52e150c6f = "@counter-style";
var $83f8df0fc4bef2f6$export$22314bfbb57653fe = "@font-feature-values";
var $83f8df0fc4bef2f6$export$d773506282b3cfe6 = "@layer";
var $83f8df0fc4bef2f6$export$2335f513bbd82c6d = Math.abs;
var $83f8df0fc4bef2f6$export$6788812c4e6611e6 = String.fromCharCode;
var $83f8df0fc4bef2f6$export$e6e34fd1f2686227 = Object.assign;
function $83f8df0fc4bef2f6$export$d6af199866bfb566(e, r) {
    return $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 0)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 1)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 2)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 3) : 0;
}
function $83f8df0fc4bef2f6$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $83f8df0fc4bef2f6$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $83f8df0fc4bef2f6$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $83f8df0fc4bef2f6$export$36776f635604f274(e) {
    return e.length;
}
function $83f8df0fc4bef2f6$export$f9084667e487ed46(e) {
    return e.length;
}
function $83f8df0fc4bef2f6$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $83f8df0fc4bef2f6$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c = 1;
var $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1;
var $83f8df0fc4bef2f6$export$f24224f1c91d8156 = 0;
var $83f8df0fc4bef2f6$export$5880b8b5730aff45 = 0;
var $83f8df0fc4bef2f6$export$c0306caf338ac095 = 0;
var $83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = "";
function $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c,
        column: $83f8df0fc4bef2f6$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $83f8df0fc4bef2f6$export$784d13d8ee351f07(e, r) {
    return $83f8df0fc4bef2f6$export$e6e34fd1f2686227($83f8df0fc4bef2f6$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $83f8df0fc4bef2f6$export$eba6f6f03b0a92e7() {
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$232faf9add678146() {
    $83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$5880b8b5730aff45 > 0 ? $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, --$83f8df0fc4bef2f6$export$5880b8b5730aff45) : 0;
    if ($83f8df0fc4bef2f6$export$4e0c71f277ca26b3--, $83f8df0fc4bef2f6$export$c0306caf338ac095 === 10) $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c--;
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$48cfd1e771a65c4f() {
    $83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$5880b8b5730aff45 < $83f8df0fc4bef2f6$export$f24224f1c91d8156 ? $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, $83f8df0fc4bef2f6$export$5880b8b5730aff45++) : 0;
    if ($83f8df0fc4bef2f6$export$4e0c71f277ca26b3++, $83f8df0fc4bef2f6$export$c0306caf338ac095 === 10) $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c++;
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() {
    return $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, $83f8df0fc4bef2f6$export$5880b8b5730aff45);
}
function $83f8df0fc4bef2f6$export$e88cb2efb12ae807() {
    return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
}
function $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, r) {
    return $83f8df0fc4bef2f6$export$2f35ab04d2335697($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, e, r);
}
function $83f8df0fc4bef2f6$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $83f8df0fc4bef2f6$export$2de70f21292aac9e(e) {
    return $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c = $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$f24224f1c91d8156 = $83f8df0fc4bef2f6$export$36776f635604f274($83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = e), $83f8df0fc4bef2f6$export$5880b8b5730aff45 = 0, [];
}
function $83f8df0fc4bef2f6$export$45918ac1574455b1(e) {
    return $83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = "", e;
}
function $83f8df0fc4bef2f6$export$410ac95b9ec204b8(e) {
    return $83f8df0fc4bef2f6$export$87c2784dc9fc4ab($83f8df0fc4bef2f6$export$58adb3bec8346d0f($83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1, $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $83f8df0fc4bef2f6$export$660b2ee2d4fb4eff(e) {
    return $83f8df0fc4bef2f6$export$45918ac1574455b1($83f8df0fc4bef2f6$export$5f8c09e3ae6f64e1($83f8df0fc4bef2f6$export$2de70f21292aac9e(e)));
}
function $83f8df0fc4bef2f6$export$7af1228ff777d175(e) {
    while($83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$4d3fb11e950abb9e())if ($83f8df0fc4bef2f6$export$c0306caf338ac095 < 33) $83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
    else break;
    return $83f8df0fc4bef2f6$export$9e1725a4cfeada27(e) > 2 || $83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $83f8df0fc4bef2f6$export$5f8c09e3ae6f64e1(e) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())switch($83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$c0306caf338ac095)){
        case 0:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$c2ab62c7bf24634($83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$410ac95b9ec204b8($83f8df0fc4bef2f6$export$c0306caf338ac095), e);
            break;
        default:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$6788812c4e6611e6($83f8df0fc4bef2f6$export$c0306caf338ac095), e);
    }
    return e;
}
function $83f8df0fc4bef2f6$export$955ba06d119e085e(e, r) {
    while(--r && $83f8df0fc4bef2f6$export$48cfd1e771a65c4f())if ($83f8df0fc4bef2f6$export$c0306caf338ac095 < 48 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 102 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 57 && $83f8df0fc4bef2f6$export$c0306caf338ac095 < 65 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 70 && $83f8df0fc4bef2f6$export$c0306caf338ac095 < 97) break;
    return $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, $83f8df0fc4bef2f6$export$e88cb2efb12ae807() + (r < 6 && $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() == 32 && $83f8df0fc4bef2f6$export$48cfd1e771a65c4f() == 32));
}
function $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())switch($83f8df0fc4bef2f6$export$c0306caf338ac095){
        case e:
            return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $83f8df0fc4bef2f6$export$c889f2fcc19dbf12($83f8df0fc4bef2f6$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
            break;
    }
    return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
}
function $83f8df0fc4bef2f6$export$4254d4e2b3745c4c(e, r) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())if (e + $83f8df0fc4bef2f6$export$c0306caf338ac095 === 57) break;
    else if (e + $83f8df0fc4bef2f6$export$c0306caf338ac095 === 84 && $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $83f8df0fc4bef2f6$export$58adb3bec8346d0f(r, $83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1) + "*" + $83f8df0fc4bef2f6$export$6788812c4e6611e6(e === 47 ? e : $83f8df0fc4bef2f6$export$48cfd1e771a65c4f());
}
function $83f8df0fc4bef2f6$export$c2ab62c7bf24634(e) {
    while(!$83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$4d3fb11e950abb9e()))$83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
    return $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, $83f8df0fc4bef2f6$export$5880b8b5730aff45);
}
function $83f8df0fc4bef2f6$export$ef7acd7185315e22(e) {
    return $83f8df0fc4bef2f6$export$45918ac1574455b1($83f8df0fc4bef2f6$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $83f8df0fc4bef2f6$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $83f8df0fc4bef2f6$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $83f8df0fc4bef2f6$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $83f8df0fc4bef2f6$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($83f8df0fc4bef2f6$export$f8e21b1e77979a08(j += $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $83f8df0fc4bef2f6$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $83f8df0fc4bef2f6$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $83f8df0fc4bef2f6$export$955ba06d119e085e($83f8df0fc4bef2f6$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($83f8df0fc4bef2f6$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$4a34f930e789283c($83f8df0fc4bef2f6$export$4254d4e2b3745c4c($83f8df0fc4bef2f6$export$48cfd1e771a65c4f(), $83f8df0fc4bef2f6$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $83f8df0fc4bef2f6$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $83f8df0fc4bef2f6$export$36776f635604f274(j) - l) $83f8df0fc4bef2f6$export$10d8903dec122b9d(p > 32 ? $83f8df0fc4bef2f6$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $83f8df0fc4bef2f6$export$f8483753829ec8f3($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $83f8df0fc4bef2f6$export$10d8903dec122b9d(y = $83f8df0fc4bef2f6$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $83f8df0fc4bef2f6$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $83f8df0fc4bef2f6$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $83f8df0fc4bef2f6$export$98e6a39c04603d36(e, y, y, n && $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $83f8df0fc4bef2f6$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $83f8df0fc4bef2f6$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $83f8df0fc4bef2f6$export$232faf9add678146() == 125) continue;
            }
            switch(j += $83f8df0fc4bef2f6$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($83f8df0fc4bef2f6$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($83f8df0fc4bef2f6$export$4d3fb11e950abb9e() === 45) j += $83f8df0fc4bef2f6$export$410ac95b9ec204b8($83f8df0fc4bef2f6$export$48cfd1e771a65c4f());
                    v = $83f8df0fc4bef2f6$export$4d3fb11e950abb9e(), o = l = $83f8df0fc4bef2f6$export$36776f635604f274(g = j += $83f8df0fc4bef2f6$export$c2ab62c7bf24634($83f8df0fc4bef2f6$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $83f8df0fc4bef2f6$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $83f8df0fc4bef2f6$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $83f8df0fc4bef2f6$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, v + 1, v = $83f8df0fc4bef2f6$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $83f8df0fc4bef2f6$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, s === 0 ? $83f8df0fc4bef2f6$export$aa3a2e812ca8570d : i, f, o, l);
}
function $83f8df0fc4bef2f6$export$4a34f930e789283c(e, r, a) {
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, $83f8df0fc4bef2f6$export$a29989082612d0d9, $83f8df0fc4bef2f6$export$6788812c4e6611e6($83f8df0fc4bef2f6$export$eba6f6f03b0a92e7()), $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $83f8df0fc4bef2f6$export$f8483753829ec8f3(e, r, a, n) {
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, $83f8df0fc4bef2f6$export$527d108ccf083c2b, $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, 0, n), $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $83f8df0fc4bef2f6$export$82e9f45cca5ba907(n, c, s) {
    switch($83f8df0fc4bef2f6$export$d6af199866bfb566(n, c)){
        case 5103:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $83f8df0fc4bef2f6$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-$1$2" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-item-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-row-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-line-pack" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-grow", "") + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-pack:$3" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-column-align" + $83f8df0fc4bef2f6$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(s, "span") ? $83f8df0fc4bef2f6$export$4659b591c19bdf3d(s, /\d+/) : +$83f8df0fc4bef2f6$export$4659b591c19bdf3d(s, /\d+/) - +$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($83f8df0fc4bef2f6$export$36776f635604f274(n) - 1 - c > 6) switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(n, "stretch") ? $83f8df0fc4bef2f6$export$82e9f45cca5ba907($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 6) === 121) return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, ":", ":" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, $83f8df0fc4bef2f6$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, ":", ":" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $83f8df0fc4bef2f6$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $83f8df0fc4bef2f6$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $83f8df0fc4bef2f6$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $83f8df0fc4bef2f6$export$a763edbf796b780a:
        case $83f8df0fc4bef2f6$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $83f8df0fc4bef2f6$export$a29989082612d0d9:
            return "";
        case $83f8df0fc4bef2f6$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $83f8df0fc4bef2f6$export$36776f635604f274(a = $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $83f8df0fc4bef2f6$export$5a7767152ae0305f(e) {
    var r = $83f8df0fc4bef2f6$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $83f8df0fc4bef2f6$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $83f8df0fc4bef2f6$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $83f8df0fc4bef2f6$export$527d108ccf083c2b:
                n.return = $83f8df0fc4bef2f6$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $83f8df0fc4bef2f6$export$b44a8529a35fcb60:
                return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                    $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                        value: $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
                if (n.length) return $83f8df0fc4bef2f6$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($83f8df0fc4bef2f6$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $83f8df0fc4bef2f6$export$76a88f7de6507443(e) {
    switch(e.type){
        case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $83f8df0fc4bef2f6$export$1be1fc439b849fdf($83f8df0fc4bef2f6$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($83f8df0fc4bef2f6$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $83f8df0fc4bef2f6$export$2f35ab04d2335697(r, 1, $83f8df0fc4bef2f6$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $83f8df0fc4bef2f6$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $83f8df0fc4bef2f6$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $83f8df0fc4bef2f6$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $fef3d59b736200bc$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $3587f7e2ed7416b3$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $273321b94be832ab$var$isBrowser = typeof document !== 'undefined';
var $273321b94be832ab$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $83f8df0fc4bef2f6$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $83f8df0fc4bef2f6$export$9e1725a4cfeada27)(character)) break;
        (0, $83f8df0fc4bef2f6$export$48cfd1e771a65c4f)();
    }
    return (0, $83f8df0fc4bef2f6$export$58adb3bec8346d0f)(begin, (0, $83f8df0fc4bef2f6$export$5880b8b5730aff45));
};
var $273321b94be832ab$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $83f8df0fc4bef2f6$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $83f8df0fc4bef2f6$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $273321b94be832ab$var$identifierWithPointTracking((0, $83f8df0fc4bef2f6$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $83f8df0fc4bef2f6$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $83f8df0fc4bef2f6$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $83f8df0fc4bef2f6$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $83f8df0fc4bef2f6$export$48cfd1e771a65c4f)());
    return parsed;
};
var $273321b94be832ab$var$getRules = function getRules(value, points) {
    return (0, $83f8df0fc4bef2f6$export$45918ac1574455b1)($273321b94be832ab$var$toRules((0, $83f8df0fc4bef2f6$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $273321b94be832ab$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $273321b94be832ab$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$273321b94be832ab$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $273321b94be832ab$var$fixedElements.set(element, true);
    var points = [];
    var rules = $273321b94be832ab$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $273321b94be832ab$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $273321b94be832ab$var$prefix(value, length) {
    switch((0, $83f8df0fc4bef2f6$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$2c0f367103c8d01c) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + 'box-' + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)((0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)((0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)((0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $83f8df0fc4bef2f6$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $83f8df0fc4bef2f6$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $83f8df0fc4bef2f6$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $83f8df0fc4bef2f6$export$2c0f367103c8d01c) + ((0, $83f8df0fc4bef2f6$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $83f8df0fc4bef2f6$export$f8e21b1e77979a08)(value, 'stretch') ? $273321b94be832ab$var$prefix((0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $83f8df0fc4bef2f6$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $83f8df0fc4bef2f6$export$a9db5e087081082d)(value, (0, $83f8df0fc4bef2f6$export$36776f635604f274)(value) - 3 - (~(0, $83f8df0fc4bef2f6$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + ((0, $83f8df0fc4bef2f6$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $83f8df0fc4bef2f6$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + value + (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $273321b94be832ab$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $83f8df0fc4bef2f6$export$527d108ccf083c2b:
                element["return"] = $273321b94be832ab$var$prefix(element.value, element.length);
                break;
            case 0, $83f8df0fc4bef2f6$export$b44a8529a35fcb60:
                return (0, $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb)([
                    (0, $83f8df0fc4bef2f6$export$784d13d8ee351f07)(element, {
                        value: (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
                if (element.length) return (0, $83f8df0fc4bef2f6$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $83f8df0fc4bef2f6$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb)([
                                (0, $83f8df0fc4bef2f6$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $83f8df0fc4bef2f6$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb)([
                                (0, $83f8df0fc4bef2f6$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $83f8df0fc4bef2f6$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $83f8df0fc4bef2f6$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $83f8df0fc4bef2f6$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $273321b94be832ab$var$getServerStylisCache = $273321b94be832ab$var$isBrowser ? undefined : (0, $fef3d59b736200bc$export$2e2bcd8739ae039)(function() {
    return (0, $3587f7e2ed7416b3$export$2e2bcd8739ae039)(function() {
        return {};
    });
});
var $273321b94be832ab$var$defaultStylisPlugins = [
    $273321b94be832ab$var$prefixer
];
var $273321b94be832ab$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($273321b94be832ab$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $273321b94be832ab$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($273321b94be832ab$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $273321b94be832ab$var$compat,
        $273321b94be832ab$var$removeLabel
    ];
    if (!$273321b94be832ab$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $83f8df0fc4bef2f6$export$fac44ee5b035f737),
            (0, $83f8df0fc4bef2f6$export$38bcb760f1d4871c)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $83f8df0fc4bef2f6$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb)((0, $83f8df0fc4bef2f6$export$ef7acd7185315e22)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $83f8df0fc4bef2f6$export$fac44ee5b035f737)
        ];
        var _serializer = (0, $83f8df0fc4bef2f6$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb)((0, $83f8df0fc4bef2f6$export$ef7acd7185315e22)(styles), _serializer);
        };
        var serverStylisCache = $273321b94be832ab$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $3104ec53a35158ff$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};


function $f43c50d92a19d876$export$2e2bcd8739ae039() {
    return $f43c50d92a19d876$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f43c50d92a19d876$export$2e2bcd8739ae039.apply(null, arguments);
}



var $63fc9407ef8fcdfe$exports = {};
'use strict';
var $dddaf6f84c717660$exports = {};
'use strict';

$dddaf6f84c717660$exports = (parcelRequire("45MkT"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $63fc9407ef8fcdfe$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $63fc9407ef8fcdfe$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$TYPE_STATICS = {};
$63fc9407ef8fcdfe$var$TYPE_STATICS[$dddaf6f84c717660$exports.ForwardRef] = $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS;
$63fc9407ef8fcdfe$var$TYPE_STATICS[$dddaf6f84c717660$exports.Memo] = $63fc9407ef8fcdfe$var$MEMO_STATICS;
function $63fc9407ef8fcdfe$var$getStatics(component) {
    // React v16.11 and below
    if ($dddaf6f84c717660$exports.isMemo(component)) return $63fc9407ef8fcdfe$var$MEMO_STATICS;
     // React v16.12 and above
    return $63fc9407ef8fcdfe$var$TYPE_STATICS[component['$$typeof']] || $63fc9407ef8fcdfe$var$REACT_STATICS;
}
var $63fc9407ef8fcdfe$var$defineProperty = Object.defineProperty;
var $63fc9407ef8fcdfe$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $63fc9407ef8fcdfe$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $63fc9407ef8fcdfe$var$getPrototypeOf = Object.getPrototypeOf;
var $63fc9407ef8fcdfe$var$objectPrototype = Object.prototype;
function $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($63fc9407ef8fcdfe$var$objectPrototype) {
            var inheritedComponent = $63fc9407ef8fcdfe$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $63fc9407ef8fcdfe$var$objectPrototype) $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $63fc9407ef8fcdfe$var$getOwnPropertyNames(sourceComponent);
        if ($63fc9407ef8fcdfe$var$getOwnPropertySymbols) keys = keys.concat($63fc9407ef8fcdfe$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $63fc9407ef8fcdfe$var$getStatics(targetComponent);
        var sourceStatics = $63fc9407ef8fcdfe$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$63fc9407ef8fcdfe$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $63fc9407ef8fcdfe$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$63fc9407ef8fcdfe$exports = $63fc9407ef8fcdfe$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $0bc6489980e08e1c$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($63fc9407ef8fcdfe$exports)))(targetComponent, sourceComponent);
};


var $5d390c582efd47c3$var$isBrowser = typeof document !== 'undefined';
function $5d390c582efd47c3$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $5d390c582efd47c3$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5d390c582efd47c3$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5d390c582efd47c3$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5d390c582efd47c3$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$5d390c582efd47c3$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$5d390c582efd47c3$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $1529d79d9aa6f066$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $8ec00e8a3ecbe6f7$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $49fc6b0b9a1bf345$var$isDevelopment = false;
var $49fc6b0b9a1bf345$var$hyphenateRegex = /[A-Z]|^ms/g;
var $49fc6b0b9a1bf345$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $49fc6b0b9a1bf345$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $49fc6b0b9a1bf345$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $49fc6b0b9a1bf345$var$processStyleName = /* #__PURE__ */ (0, $3587f7e2ed7416b3$export$2e2bcd8739ae039)(function(styleName) {
    return $49fc6b0b9a1bf345$var$isCustomProperty(styleName) ? styleName : styleName.replace($49fc6b0b9a1bf345$var$hyphenateRegex, '-$&').toLowerCase();
});
var $49fc6b0b9a1bf345$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($49fc6b0b9a1bf345$var$animationRegex, function(match, p1, p2) {
                $49fc6b0b9a1bf345$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $49fc6b0b9a1bf345$var$cursor
                };
                return p1;
            });
    }
    if ((0, $8ec00e8a3ecbe6f7$export$2e2bcd8739ae039)[key] !== 1 && !$49fc6b0b9a1bf345$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $49fc6b0b9a1bf345$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $49fc6b0b9a1bf345$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $49fc6b0b9a1bf345$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $49fc6b0b9a1bf345$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $49fc6b0b9a1bf345$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $49fc6b0b9a1bf345$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $49fc6b0b9a1bf345$var$cursor;
                var result = interpolation(mergedProps);
                $49fc6b0b9a1bf345$var$cursor = previousCursor;
                return $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $49fc6b0b9a1bf345$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($49fc6b0b9a1bf345$var$isProcessableValue(asString)) string += $49fc6b0b9a1bf345$var$processStyleName(key) + ":" + $49fc6b0b9a1bf345$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $49fc6b0b9a1bf345$var$isDevelopment) throw new Error($49fc6b0b9a1bf345$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($49fc6b0b9a1bf345$var$isProcessableValue(value[_i])) string += $49fc6b0b9a1bf345$var$processStyleName(key) + ":" + $49fc6b0b9a1bf345$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $49fc6b0b9a1bf345$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $49fc6b0b9a1bf345$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $49fc6b0b9a1bf345$var$cursor;
function $49fc6b0b9a1bf345$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $49fc6b0b9a1bf345$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $49fc6b0b9a1bf345$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $49fc6b0b9a1bf345$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $1529d79d9aa6f066$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $49fc6b0b9a1bf345$var$cursor
    };
}



var $7fPBF = parcelRequire("7fPBF");
var $6ea4cfa701df259a$var$isBrowser = typeof document !== 'undefined';
var $6ea4cfa701df259a$var$syncFallback = function syncFallback(create) {
    return create();
};
var $6ea4cfa701df259a$var$useInsertionEffect = $7fPBF.useInsertionEffect ? $7fPBF.useInsertionEffect : false;
var $6ea4cfa701df259a$export$db21c7ffa21794e7 = !$6ea4cfa701df259a$var$isBrowser ? $6ea4cfa701df259a$var$syncFallback : $6ea4cfa701df259a$var$useInsertionEffect || $6ea4cfa701df259a$var$syncFallback;
var $6ea4cfa701df259a$export$811a713a7276cb9d = $6ea4cfa701df259a$var$useInsertionEffect || $7fPBF.useLayoutEffect;


var $4b604f9ff2f6f5b8$export$407448d2b89b1813 = false;
var $4b604f9ff2f6f5b8$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $4b604f9ff2f6f5b8$var$EmotionCacheContext = /* #__PURE__ */ $7fPBF.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $273321b94be832ab$export$2e2bcd8739ae039)({
    key: 'css'
}) : null);
var $4b604f9ff2f6f5b8$export$e7094788287c5e9b = $4b604f9ff2f6f5b8$var$EmotionCacheContext.Provider;
var $4b604f9ff2f6f5b8$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $7fPBF.useContext)($4b604f9ff2f6f5b8$var$EmotionCacheContext);
};
var $4b604f9ff2f6f5b8$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $7fPBF.useContext)($4b604f9ff2f6f5b8$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$4b604f9ff2f6f5b8$export$23f2a1d2818174ef) $4b604f9ff2f6f5b8$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $7fPBF.useContext)($4b604f9ff2f6f5b8$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $273321b94be832ab$export$2e2bcd8739ae039)({
                key: 'css'
            });
            return /*#__PURE__*/ $7fPBF.createElement($4b604f9ff2f6f5b8$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $4b604f9ff2f6f5b8$export$971d5caa766a69d7 = /* #__PURE__ */ $7fPBF.createContext({});
var $4b604f9ff2f6f5b8$export$3b14a55fb2447963 = function useTheme() {
    return $7fPBF.useContext($4b604f9ff2f6f5b8$export$971d5caa766a69d7);
};
var $4b604f9ff2f6f5b8$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $4b604f9ff2f6f5b8$var$createCacheWithTheme = /* #__PURE__ */ (0, $fef3d59b736200bc$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $fef3d59b736200bc$export$2e2bcd8739ae039)(function(theme) {
        return $4b604f9ff2f6f5b8$var$getTheme(outerTheme, theme);
    });
});
var $4b604f9ff2f6f5b8$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $7fPBF.useContext($4b604f9ff2f6f5b8$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $4b604f9ff2f6f5b8$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $7fPBF.createElement($4b604f9ff2f6f5b8$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $4b604f9ff2f6f5b8$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $7fPBF.forwardRef(function render(props, ref) {
        var theme = $7fPBF.useContext($4b604f9ff2f6f5b8$export$971d5caa766a69d7);
        return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $0bc6489980e08e1c$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $4b604f9ff2f6f5b8$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $4b604f9ff2f6f5b8$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $4b604f9ff2f6f5b8$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($4b604f9ff2f6f5b8$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$4b604f9ff2f6f5b8$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $4b604f9ff2f6f5b8$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $5d390c582efd47c3$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    var rules = (0, $6ea4cfa701df259a$export$db21c7ffa21794e7)(function() {
        return (0, $5d390c582efd47c3$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    if (!$4b604f9ff2f6f5b8$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $7fPBF.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $4b604f9ff2f6f5b8$var$Emotion = /* #__PURE__ */ $4b604f9ff2f6f5b8$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$4b604f9ff2f6f5b8$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $5d390c582efd47c3$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $49fc6b0b9a1bf345$export$6321afa313b251b5)(registeredStyles, undefined, $7fPBF.useContext($4b604f9ff2f6f5b8$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($4b604f9ff2f6f5b8$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $4b604f9ff2f6f5b8$var$typePropName && !$4b604f9ff2f6f5b8$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($4b604f9ff2f6f5b8$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $7fPBF.createElement(WrappedComponent, newProps));
});
var $4b604f9ff2f6f5b8$export$a9c23c6ac3fc3eca = $4b604f9ff2f6f5b8$var$Emotion;



var $7fPBF = parcelRequire("7fPBF");








var $3ebaaabf76fb5db5$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $4b604f9ff2f6f5b8$export$dda1d9f60106f0e9).call(props, 'css')) return $7fPBF.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $4b604f9ff2f6f5b8$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $4b604f9ff2f6f5b8$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $7fPBF.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($3ebaaabf76fb5db5$export$c8a8987d4410bf2d || ($3ebaaabf76fb5db5$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $3ebaaabf76fb5db5$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $4b604f9ff2f6f5b8$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $49fc6b0b9a1bf345$export$6321afa313b251b5)([
        styles
    ], undefined, $7fPBF.useContext((0, $4b604f9ff2f6f5b8$export$971d5caa766a69d7)));
    if (!(0, $4b604f9ff2f6f5b8$export$23f2a1d2818174ef)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $7fPBF.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $7fPBF.useRef();
    (0, $6ea4cfa701df259a$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $6ea4cfa701df259a$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $5d390c582efd47c3$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $3ebaaabf76fb5db5$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $49fc6b0b9a1bf345$export$6321afa313b251b5)(args);
}
function $3ebaaabf76fb5db5$export$d25ddfdf17c3ad3e() {
    var insertable = $3ebaaabf76fb5db5$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $3ebaaabf76fb5db5$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $3ebaaabf76fb5db5$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $5d390c582efd47c3$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $3ebaaabf76fb5db5$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $6ea4cfa701df259a$export$db21c7ffa21794e7)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $5d390c582efd47c3$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
            if (!(0, $4b604f9ff2f6f5b8$export$23f2a1d2818174ef) && res !== undefined) rules += res;
        }
        if (!(0, $4b604f9ff2f6f5b8$export$23f2a1d2818174ef)) return rules;
    });
    if (!(0, $4b604f9ff2f6f5b8$export$23f2a1d2818174ef) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $7fPBF.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $3ebaaabf76fb5db5$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $4b604f9ff2f6f5b8$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $4b604f9ff2f6f5b8$export$407448d2b89b1813)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $49fc6b0b9a1bf345$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $5d390c582efd47c3$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $4b604f9ff2f6f5b8$export$407448d2b89b1813)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $3ebaaabf76fb5db5$var$merge(cache.registered, css, $3ebaaabf76fb5db5$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $7fPBF.useContext((0, $4b604f9ff2f6f5b8$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($3ebaaabf76fb5db5$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});






var $8MJe2 = parcelRequire("8MJe2");

var $47b92f8c0923a233$export$4ef52930e33717cd = 'data-theme';
var $47b92f8c0923a233$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $47b92f8c0923a233$export$a00eac3f8684bcd0 = 'data-color-mode';
var $47b92f8c0923a233$export$2112803007239c61 = 'data-contrast-mode';
var $47b92f8c0923a233$export$352e418ed5b6193a = 'data-custom-theme';
var $47b92f8c0923a233$export$6f0c6fb8c80fcc92 = 'ds';
var $47b92f8c0923a233$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $47b92f8c0923a233$export$dddac1532e822863 = "--".concat($47b92f8c0923a233$export$6f0c6fb8c80fcc92, "-token-not-found");
var $47b92f8c0923a233$export$9d7b58831ae93caa = "--".concat($47b92f8c0923a233$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $e79a069e92b65996$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e79a069e92b65996$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e79a069e92b65996$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e79a069e92b65996$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e79a069e92b65996$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $e79a069e92b65996$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $e79a069e92b65996$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $e79a069e92b65996$export$632685d741f3dbbf = $e79a069e92b65996$var$_objectSpread($e79a069e92b65996$var$_objectSpread({}, $e79a069e92b65996$export$958d0ae7f2977ae4), $e79a069e92b65996$export$d2dc61f58390201c);
var $e79a069e92b65996$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $e79a069e92b65996$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $e79a069e92b65996$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};
var $e79a069e92b65996$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};
var $e79a069e92b65996$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};
var $e79a069e92b65996$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.disabled': "var(--ds-background-disabled, #17171708)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $e79a069e92b65996$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};
var $e79a069e92b65996$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #292A2E)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #C9372C)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #E06C00)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #B38600)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #22A06B)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #2898BD)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #357DE8)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #AF59E1)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #7D818A)",
    'color.icon.disabled': "var(--ds-icon-disabled, #080F214A)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #1868DB)",
    'color.icon.brand': "var(--ds-icon-brand, #1868DB)",
    'color.icon.danger': "var(--ds-icon-danger, #C9372C)",
    'color.icon.warning': "var(--ds-icon-warning, #E06C00)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #292A2E)",
    'color.icon.success': "var(--ds-icon-success, #6A9A23)",
    'color.icon.discovery': "var(--ds-icon-discovery, #AF59E1)",
    'color.icon.information': "var(--ds-icon-information, #357DE8)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B6E76)",
    'color.icon.subtle': "var(--ds-icon-subtle, #505258)"
};
var $e79a069e92b65996$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $e79a069e92b65996$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
var $e79a069e92b65996$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
var $e79a069e92b65996$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $e79a069e92b65996$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $e79a069e92b65996$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $e79a069e92b65996$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $e79a069e92b65996$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $e79a069e92b65996$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
/**
 * Token functions are currently allowed for borderRadius in xcss to ease migration.
 * Because 'radius.small' defaults to 3px, we need a mechanism to allow for 4px values to be provided:
 * This is done by calling the token function - token('radius.small')
 *
 * TODO: Remove once shape them is rolled out and fg platform-dst-shape-theme-default removed
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $e79a069e92b65996$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $e79a069e92b65996$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $e79a069e92b65996$export$e615f061ca585a6c = $e79a069e92b65996$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $e79a069e92b65996$export$ca0f9c2de39ffed7(spacingProperty, $e79a069e92b65996$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $e79a069e92b65996$export$bf46c3f9eeafc71f = $e79a069e92b65996$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $e79a069e92b65996$export$ca0f9c2de39ffed7(spacingProperty, $e79a069e92b65996$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $e79a069e92b65996$export$e7af83bafe7f9e63 = $e79a069e92b65996$export$ca0f9c2de39ffed7('backgroundColor', $e79a069e92b65996$export$d1d79bf68ac056bd);
var $e79a069e92b65996$export$3a1bcba60b23d7f0 = $e79a069e92b65996$export$ca0f9c2de39ffed7('color', $e79a069e92b65996$export$8473307aa00d6ea1);
var $e79a069e92b65996$export$45f3f4fe16f9f7d5 = $e79a069e92b65996$export$ca0f9c2de39ffed7('fontWeight', $e79a069e92b65996$export$303e322c6b1ed114);
var $e79a069e92b65996$export$68cc305da27dbaa4 = $e79a069e92b65996$export$ca0f9c2de39ffed7('fontFamily', $e79a069e92b65996$export$3c7e9587132614b4);
var $e79a069e92b65996$export$128f10c238242f83 = $e79a069e92b65996$export$ca0f9c2de39ffed7('font', $e79a069e92b65996$export$6ffa317d5e70375);
var $e79a069e92b65996$export$219d364c0da35ae4 = $e79a069e92b65996$export$ca0f9c2de39ffed7('font', $e79a069e92b65996$export$236bfe3a33ef1292);
var $e79a069e92b65996$export$38845ca010b93505 = $e79a069e92b65996$export$ca0f9c2de39ffed7('fontWeight', $e79a069e92b65996$export$855cfd311192d666);
var $e79a069e92b65996$export$ff257d957d48c421 = $e79a069e92b65996$export$ca0f9c2de39ffed7((0, $47b92f8c0923a233$export$9d7b58831ae93caa), $e79a069e92b65996$export$41a358c9c2356760);
var $e79a069e92b65996$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $e79a069e92b65996$export$41a358c9c2356760[color] !== undefined;
};
var $e79a069e92b65996$export$7001ce64d9ff7c7f = $e79a069e92b65996$export$ca0f9c2de39ffed7('font', $e79a069e92b65996$export$b805719bc8cb376);



var $j9spr = parcelRequire("j9spr");

var $8MJe2 = parcelRequire("8MJe2");

var $iKdEz = parcelRequire("iKdEz");

var $bRUy3 = parcelRequire("bRUy3");


function $52bcc3230359a5cf$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $52bcc3230359a5cf$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $52bcc3230359a5cf$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $52bcc3230359a5cf$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $52bcc3230359a5cf$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $52bcc3230359a5cf$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $52bcc3230359a5cf$export$9a199fbafee0014e = {
    backgroundColor: (0, $e79a069e92b65996$export$d1d79bf68ac056bd),
    blockSize: (0, $e79a069e92b65996$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $e79a069e92b65996$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $e79a069e92b65996$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $e79a069e92b65996$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $e79a069e92b65996$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $e79a069e92b65996$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $e79a069e92b65996$export$e1b83c5210c471b8),
    borderBottomColor: (0, $e79a069e92b65996$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $e79a069e92b65996$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $e79a069e92b65996$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $e79a069e92b65996$export$e1b83c5210c471b8),
    borderColor: (0, $e79a069e92b65996$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $e79a069e92b65996$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $e79a069e92b65996$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $e79a069e92b65996$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $e79a069e92b65996$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $e79a069e92b65996$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $e79a069e92b65996$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $e79a069e92b65996$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $e79a069e92b65996$export$e1b83c5210c471b8),
    borderLeftColor: (0, $e79a069e92b65996$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $e79a069e92b65996$export$e1b83c5210c471b8),
    borderRadius: (0, $e79a069e92b65996$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $e79a069e92b65996$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $e79a069e92b65996$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $e79a069e92b65996$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $e79a069e92b65996$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $e79a069e92b65996$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $e79a069e92b65996$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $e79a069e92b65996$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $e79a069e92b65996$export$e1b83c5210c471b8),
    borderWidth: (0, $e79a069e92b65996$export$e1b83c5210c471b8),
    bottom: (0, $e79a069e92b65996$export$632685d741f3dbbf),
    boxShadow: (0, $e79a069e92b65996$export$7aff6e7ba39bb774),
    color: (0, $e79a069e92b65996$export$8473307aa00d6ea1),
    columnGap: (0, $e79a069e92b65996$export$958d0ae7f2977ae4),
    font: (0, $e79a069e92b65996$export$6ffa317d5e70375),
    fontFamily: (0, $e79a069e92b65996$export$3c7e9587132614b4),
    fontWeight: (0, $e79a069e92b65996$export$303e322c6b1ed114),
    gap: (0, $e79a069e92b65996$export$958d0ae7f2977ae4),
    height: (0, $e79a069e92b65996$export$6ccdbebca2ee545f),
    inlineSize: (0, $e79a069e92b65996$export$6ccdbebca2ee545f),
    inset: (0, $e79a069e92b65996$export$632685d741f3dbbf),
    insetBlock: (0, $e79a069e92b65996$export$632685d741f3dbbf),
    insetBlockEnd: (0, $e79a069e92b65996$export$632685d741f3dbbf),
    insetBlockStart: (0, $e79a069e92b65996$export$632685d741f3dbbf),
    insetInline: (0, $e79a069e92b65996$export$632685d741f3dbbf),
    insetInlineEnd: (0, $e79a069e92b65996$export$632685d741f3dbbf),
    insetInlineStart: (0, $e79a069e92b65996$export$632685d741f3dbbf),
    left: (0, $e79a069e92b65996$export$632685d741f3dbbf),
    margin: (0, $e79a069e92b65996$export$632685d741f3dbbf),
    marginBlock: (0, $e79a069e92b65996$export$632685d741f3dbbf),
    marginBlockEnd: (0, $e79a069e92b65996$export$632685d741f3dbbf),
    marginBlockStart: (0, $e79a069e92b65996$export$632685d741f3dbbf),
    marginBottom: (0, $e79a069e92b65996$export$632685d741f3dbbf),
    marginInline: (0, $e79a069e92b65996$export$632685d741f3dbbf),
    marginInlineEnd: (0, $e79a069e92b65996$export$632685d741f3dbbf),
    marginInlineStart: (0, $e79a069e92b65996$export$632685d741f3dbbf),
    marginLeft: (0, $e79a069e92b65996$export$632685d741f3dbbf),
    marginRight: (0, $e79a069e92b65996$export$632685d741f3dbbf),
    marginTop: (0, $e79a069e92b65996$export$632685d741f3dbbf),
    maxBlockSize: (0, $e79a069e92b65996$export$6ccdbebca2ee545f),
    maxHeight: (0, $e79a069e92b65996$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $e79a069e92b65996$export$6ccdbebca2ee545f),
    maxWidth: (0, $e79a069e92b65996$export$6ccdbebca2ee545f),
    minBlockSize: (0, $e79a069e92b65996$export$6ccdbebca2ee545f),
    minHeight: (0, $e79a069e92b65996$export$6ccdbebca2ee545f),
    minInlineSize: (0, $e79a069e92b65996$export$6ccdbebca2ee545f),
    minWidth: (0, $e79a069e92b65996$export$6ccdbebca2ee545f),
    opacity: (0, $e79a069e92b65996$export$daf94a976c798b4f),
    outlineColor: (0, $e79a069e92b65996$export$1531ad5bb3fbedac),
    outlineOffset: (0, $e79a069e92b65996$export$632685d741f3dbbf),
    outlineWidth: (0, $e79a069e92b65996$export$e1b83c5210c471b8),
    padding: (0, $e79a069e92b65996$export$958d0ae7f2977ae4),
    paddingBlock: (0, $e79a069e92b65996$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $e79a069e92b65996$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $e79a069e92b65996$export$958d0ae7f2977ae4),
    paddingBottom: (0, $e79a069e92b65996$export$958d0ae7f2977ae4),
    paddingInline: (0, $e79a069e92b65996$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $e79a069e92b65996$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $e79a069e92b65996$export$958d0ae7f2977ae4),
    paddingLeft: (0, $e79a069e92b65996$export$958d0ae7f2977ae4),
    paddingRight: (0, $e79a069e92b65996$export$958d0ae7f2977ae4),
    paddingTop: (0, $e79a069e92b65996$export$958d0ae7f2977ae4),
    right: (0, $e79a069e92b65996$export$632685d741f3dbbf),
    rowGap: (0, $e79a069e92b65996$export$958d0ae7f2977ae4),
    top: (0, $e79a069e92b65996$export$632685d741f3dbbf),
    width: (0, $e79a069e92b65996$export$6ccdbebca2ee545f),
    zIndex: (0, $e79a069e92b65996$export$b5f31a7e431d2eab)
};
var $52bcc3230359a5cf$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $52bcc3230359a5cf$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return false;
};
var $52bcc3230359a5cf$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $52bcc3230359a5cf$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $52bcc3230359a5cf$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($52bcc3230359a5cf$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(value) === 'object' && $52bcc3230359a5cf$var$safeSelectors.test(key)) {
            styleObj[key] = $52bcc3230359a5cf$var$_transformStyles(value);
            return;
        }
        if ($52bcc3230359a5cf$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($52bcc3230359a5cf$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $52bcc3230359a5cf$export$9a199fbafee0014e)) return;
        var tokenValue = $52bcc3230359a5cf$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $52bcc3230359a5cf$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $52bcc3230359a5cf$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, $52bcc3230359a5cf$var$uniqueSymbol, (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $52bcc3230359a5cf$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $52bcc3230359a5cf$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $52bcc3230359a5cf$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$52bcc3230359a5cf$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $52bcc3230359a5cf$export$f6c783d06584602c(style) {
    return $52bcc3230359a5cf$var$baseXcss(style);
}


var $054f878f9c5e6732$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $054f878f9c5e6732$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $054f878f9c5e6732$var$focusRingStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $e79a069e92b65996$export$1531ad5bb3fbedac)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $e79a069e92b65996$export$958d0ae7f2977ae4)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $e79a069e92b65996$export$e1b83c5210c471b8)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: "".concat((0, $e79a069e92b65996$export$e1b83c5210c471b8)['border.width'], " solid")
        }
    }
});
var $054f878f9c5e6732$var$baseStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});
var $054f878f9c5e6732$var$enabledStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    cursor: 'pointer'
});
var $054f878f9c5e6732$var$disabledStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    cursor: 'not-allowed'
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $054f878f9c5e6732$var$Pressable = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $f48d740006cf3f7d$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $054f878f9c5e6732$var$_excluded);
    var interactionContext = (0, $7fPBF.useContext)((0, $48ec410b84640600$export$2e2bcd8739ae039));
    var handleClick = (0, $7fPBF.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $593ac790924c31ca$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "19.0.0",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $054f878f9c5e6732$var$_excluded2);
    var resolvedStyles = (0, $52bcc3230359a5cf$export$a9c84988c8f81f2d)(xcss);
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("button", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $054f878f9c5e6732$var$baseStyles,
            $054f878f9c5e6732$var$focusRingStyles,
            isDisabled ? $054f878f9c5e6732$var$disabledStyles : $054f878f9c5e6732$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $e79a069e92b65996$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $e79a069e92b65996$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $e79a069e92b65996$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $e79a069e92b65996$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $e79a069e92b65996$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $e79a069e92b65996$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $e79a069e92b65996$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $e79a069e92b65996$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(resolvedStyles.emotion || [])),
        "data-testid": testId
    }), children);
});
var $054f878f9c5e6732$export$2e2bcd8739ae039 = $054f878f9c5e6732$var$Pressable;



// extract the category and key from the resolved color
var $70131c979f865eba$export$a3fc04b8551e006a = function getThemeStyles(resolvedColor) {
    var isAccent = resolvedColor.startsWith('accent-');
    var category = isAccent ? 'accent' : 'semantic';
    var key = isAccent ? resolvedColor.replace('accent-', '') : resolvedColor;
    return {
        category: category,
        key: key
    };
};


/* icon-renderer.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");
/* box.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $7StG6 = parcelRequire("7StG6");

var $7fPBF = parcelRequire("7fPBF");
var $f87b17e82bda78c5$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $7fPBF.createContext)('elevation.surface');
var $f87b17e82bda78c5$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $7fPBF.useContext)($f87b17e82bda78c5$export$1ca2a26fecb070ae);
};
$f87b17e82bda78c5$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


var $55829f56df0bc88f$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $55829f56df0bc88f$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $55829f56df0bc88f$var$baseStyles = null;
var $55829f56df0bc88f$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhkby5v",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $55829f56df0bc88f$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $55829f56df0bc88f$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $55829f56df0bc88f$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $55829f56df0bc88f$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $55829f56df0bc88f$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $55829f56df0bc88f$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $55829f56df0bc88f$var$Box = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $55829f56df0bc88f$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $55829f56df0bc88f$var$_excluded2);
    var node = /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        style: style,
        ref: ref,
        className: (0, $7StG6.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $55829f56df0bc88f$var$backgroundColorMap[backgroundColor],
            backgroundColor && $55829f56df0bc88f$var$isSurfaceToken(backgroundColor) && $55829f56df0bc88f$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $55829f56df0bc88f$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $55829f56df0bc88f$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $55829f56df0bc88f$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $55829f56df0bc88f$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $7fPBF.createElement((0, $f87b17e82bda78c5$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $55829f56df0bc88f$export$2e2bcd8739ae039 = $55829f56df0bc88f$var$Box;
function $55829f56df0bc88f$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $55829f56df0bc88f$var$setSurfaceTokenMap;
}


// Map lozenge colors to appropriate icon colors
var $8435eb3b3b79f3b6$var$getIconColor = function getIconColor(color) {
    // For semantic colors, use corresponding semantic icon colors
    switch(color){
        case 'success':
            return "var(--ds-icon-success, #6A9A23)";
        case 'warning':
            return "var(--ds-icon-warning, #E06C00)";
        case 'danger':
            return "var(--ds-icon-danger, #C9372C)";
        case 'information':
            return "var(--ds-icon-information, #357DE8)";
        case 'neutral':
            return "var(--ds-icon-subtlest, #6B6E76)";
        case 'discovery':
            return "var(--ds-icon-discovery, #AF59E1)";
        // For accent colors, use corresponding accent icon colors
        case 'accent-red':
            return "var(--ds-icon-accent-red, #C9372C)";
        case 'accent-orange':
            return "var(--ds-icon-accent-orange, #E06C00)";
        case 'accent-yellow':
            return "var(--ds-icon-accent-yellow, #B38600)";
        case 'accent-lime':
            return "var(--ds-icon-accent-lime, #6A9A23)";
        case 'accent-green':
            return "var(--ds-icon-accent-green, #22A06B)";
        case 'accent-teal':
            return "var(--ds-icon-accent-teal, #2898BD)";
        case 'accent-blue':
            return "var(--ds-icon-accent-blue, #357DE8)";
        case 'accent-purple':
            return "var(--ds-icon-accent-purple, #AF59E1)";
        case 'accent-magenta':
            return "var(--ds-icon-accent-magenta, #CD519D)";
        case 'accent-gray':
            return "var(--ds-icon-accent-gray, #7D818A)";
        default:
            return "var(--ds-icon-subtlest, #6B6E76)";
    }
};
var $8435eb3b3b79f3b6$var$styles = {
    motion: "_k8m01ylx _1oeci9qs _6fl41d08"
};
var $8435eb3b3b79f3b6$export$32ff197eed95e568 = function IconRenderer(_ref) {
    var Icon = _ref.icon, color = _ref.color, testId = _ref.testId, size = _ref.size;
    var iconColor = $8435eb3b3b79f3b6$var$getIconColor(color);
    return (0, $137Lh.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $55829f56df0bc88f$export$2e2bcd8739ae039), {
        xcss: $8435eb3b3b79f3b6$var$styles.motion,
        style: {
            color: iconColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Icon, {
        label: "",
        size: size,
        testId: testId
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Icon, {
        color: iconColor,
        label: "",
        size: size,
        testId: testId
    });
};
var $8435eb3b3b79f3b6$export$2e2bcd8739ae039 = $8435eb3b3b79f3b6$export$32ff197eed95e568;


// Map legacy appearance to new color values

var $1de803ef420837c2$var$legacyAppearanceMap = {
    default: 'neutral',
    removed: 'danger',
    inprogress: 'information',
    new: 'discovery',
    moved: 'warning'
};
var $1de803ef420837c2$export$acf5d2b7dc999bda = function resolveLozengeColor() {
    var _legacyAppearanceMap$;
    var appearance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'neutral';
    if (appearance.startsWith('accent-')) return appearance;
    return (_legacyAppearanceMap$ = $1de803ef420837c2$var$legacyAppearanceMap[appearance]) !== null && _legacyAppearanceMap$ !== void 0 ? _legacyAppearanceMap$ : appearance;
};


function $88b098ff68dfabd5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $88b098ff68dfabd5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $88b098ff68dfabd5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $88b098ff68dfabd5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Get the pressed background color for the selected lozenge dropdown trigger
var $88b098ff68dfabd5$var$pressedBackgroundMapping = {
    success: "var(--ds-background-success-subtler-pressed, #B3DF72)",
    warning: "var(--ds-background-warning-subtler-pressed, #FBC828)",
    danger: "var(--ds-background-danger-subtler-pressed, #FD9891)",
    information: "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    neutral: "var(--ds-background-neutral-pressed, #080F214A)",
    discovery: "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'accent-red': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'accent-orange': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'accent-yellow': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'accent-lime': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'accent-green': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'accent-teal': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'accent-blue': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'accent-purple': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'accent-magenta': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'accent-gray': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
};
var $88b098ff68dfabd5$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1j28 _kqswh2mm _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k92 _1q51v77o _85i5v77o _bozg1b66 _y4ti1b66",
    motionContainer: "_k8m01rje _1oeci9qs _6fl41d08",
    containerSpacious: "_2rko1qi0 _1tkeviql _1q511b66 _85i51b66 _bozgutpp _y4tiutpp",
    containerBadgePadding: "_y4ti303w",
    text: "_11c8wadc _1reo15vq _18m915vq _o5721q9c",
    textEllipsis: "_1bto1l2s",
    textClip: "_1btozryt",
    textSpacious: "_11c8fhey _k48p1wq8",
    textSelected: "_syaz6x5g",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw",
    metricBadgeWrapper: "_1e0c1txw",
    'metric.semantic.success': "_1bn8d6jc _4ayg1wl5",
    'metric.semantic.warning': "_1bn8bkku _4aygzr32",
    'metric.semantic.danger': "_1bn8jkmi _4ayg1r4b",
    'metric.semantic.information': "_1bn8ar1y _4ayg1c1j",
    'metric.semantic.neutral': "_1bn814je _4ayg1fkg _iymy8hz0 _16burnys",
    'metric.semantic.discovery': "_1bn85usi _4ayg18vq",
    'metric.inverse': "_1bn8vuon _4aygvuon",
    'semantic.success': "_1b3i4pcx _3wu01mps _bfhk14j0 _syaz1p1e",
    'semantic.warning': "_1b3iervl _3wu01xiv _bfhk10f4 _syazmgs1",
    'semantic.danger': "_1b3is4qr _3wu01bqt _bfhk18wg _syaz1blx",
    'semantic.information': "_1b3iyhbg _3wu0vbh5 _bfhk8lbg _syaz1qd9",
    'semantic.neutral': "_1b3i1cv2 _3wu01ihb _bfhki8nm _syazi7uo",
    'semantic.discovery': "_1b3iqm1h _3wu0v30g _bfhke670 _syaz1g72",
    'accent.red': "_1b3inbxb _3wu016y8 _bfhk1rtt _syazhwvp",
    'accent.orange': "_1b3i1j6y _3wu01b2s _bfhk165s _syaz7i1p",
    'accent.yellow': "_1b3i1oqg _3wu0feiv _bfhk1773 _syazekll",
    'accent.lime': "_1b3i8645 _3wu0nf89 _bfhkz2ec _syaz1ik3",
    'accent.green': "_1b3i17hp _3wu01crs _bfhk1wnw _syaz1y78",
    'accent.teal': "_1b3i8uof _3wu01h3o _bfhk1a17 _syaz12v7",
    'accent.blue': "_1b3i6txe _3wu01w55 _bfhk1dy8 _syaz1kyx",
    'accent.purple': "_1b3iuq3u _3wu01hqq _bfhk1nm4 _syaz1mn1",
    'accent.magenta': "_1b3iv8hk _3wu0uwd0 _bfhkv9ra _syaz1qur",
    'accent.gray': "_1b3i1diz _3wu08yml _bfhkysee _syaz1tmo",
    'interactive.semantic.success': "_irr31r82 _1di6d6jc",
    'interactive.semantic.warning': "_irr31yx4 _1di6bkku",
    'interactive.semantic.danger': "_irr370oi _1di6jkmi",
    'interactive.semantic.information': "_irr315aw _1di6ar1y",
    'interactive.semantic.neutral': "_irr3plhp _1di61gdz",
    'interactive.semantic.discovery': "_irr3rumk _1di65usi",
    'interactive.accent.red': "_irr3affd _1di61j5a",
    'interactive.accent.orange': "_irr31ei0 _1di6dpo3",
    'interactive.accent.yellow': "_irr31uw7 _1di61r9w",
    'interactive.accent.lime': "_irr31gf0 _1di62kxc",
    'interactive.accent.green': "_irr31e2h _1di6ybhx",
    'interactive.accent.teal': "_irr3kwwr _1di61jb0",
    'interactive.accent.blue': "_irr3815t _1di6rwxf",
    'interactive.accent.purple': "_irr3attl _1di63nfk",
    'interactive.accent.magenta': "_irr31axx _1di642ri",
    'interactive.accent.gray': "_irr3wejn _1di618ut",
    iconBorderFilter: "_1h6dzs9d _4uq11yqs _1k671038 _m71tr3uz _13muu67f _168qx19p _oe6mmko7 _189qkb7n _u8p61h4e _1t75u67f _hg5mr3uz _1f28f1ug _1xe213rw _1easxmrh _1r9r1ss3",
    iconBorderInteractiveFilter: "_1iel6xdd _111i1h4e _18dicjiy _hyog26zw _fdt01r5k _46v5hwvj _ylgq1r5k _bg3q9by0 _196p1btq _18mn783i _l0666xdd _pclnn8xv _ockq1r5k _aewt1n8h _4cvx7ddx _1cp21w66 _q4zt1csi _1gqs1mvc _75gv2l9f _1lh71sfd _ui3h1ct7 _11o31cha",
    containerSelected: "_1xe213kw",
    content: "_zulp1b66 _1e0c116y _4cvr1h6o",
    contentSpacious: "_zulp12x7",
    loadingContent: "_tzy4idpf",
    containerBadge: "_1ftrbpke",
    containerBadgeInteractive: "_1axm1bqy"
};
/**
 * __New Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 * This is the updated version with the new North Star visual language.
 */ var $88b098ff68dfabd5$var$LozengeBase = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, appearance = _ref.appearance, iconBefore = _ref.iconBefore, trailingMetric = _ref.trailingMetric, trailingMetricAppearance = _ref.trailingMetricAppearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, isSelected = _ref.isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, onClick = _ref.onClick, style = _ref.style, analyticsContext = _ref.analyticsContext, interactionName = _ref.interactionName, ariaControls = _ref['aria-controls'], ariaExpanded = _ref['aria-expanded'], ariaHaspopup = _ref['aria-haspopup'], ariaLabel = _ref['aria-label'];
    var _useState = (0, $7fPBF.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), resizing = _useState2[0], setResizing = _useState2[1];
    var onFinishMotion = function onFinishMotion() {
        return setResizing(false);
    };
    var resizingWidth = (0, $18b7944ba172ba81$export$a300664a1a230956)({
        dimension: 'width',
        duration: "var(--ds-duration-medium, 200ms)",
        easing: "var(--ds-easing-inout-bold, cubic-bezier(0.4, 0, 0, 1))",
        onFinishMotion: onFinishMotion
    });
    var isInitialRender = (0, $7fPBF.useRef)(true);
    var isInteractive = typeof onClick === 'function';
    // Determine the effective color, with fallback logic for legacy appearances
    var resolvedColor = (0, $1de803ef420837c2$export$acf5d2b7dc999bda)(appearance) || 'neutral';
    var _getThemeStyles = (0, $70131c979f865eba$export$a3fc04b8551e006a)(resolvedColor), category = _getThemeStyles.category, key = _getThemeStyles.key;
    var colorStyleKey = "".concat(category, ".").concat(key);
    var interactiveStyleKey = "interactive.".concat(category, ".").concat(key);
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && maxWidth.endsWith('%');
    var resolvedTrailingMetricAppearance = trailingMetricAppearance ? trailingMetricAppearance === 'inverse' ? 'inverse' : (0, $1de803ef420837c2$export$acf5d2b7dc999bda)(trailingMetricAppearance) : resolvedColor;
    var metricBadgeAppearance = resolvedTrailingMetricAppearance === 'inverse' ? 'inverse' : resolvedTrailingMetricAppearance != null && resolvedTrailingMetricAppearance.startsWith('accent-') ? 'neutral' : resolvedTrailingMetricAppearance !== null && resolvedTrailingMetricAppearance !== void 0 ? resolvedTrailingMetricAppearance : 'neutral';
    var metricStyleKey = resolvedTrailingMetricAppearance === 'inverse' ? 'metric.inverse' : resolvedTrailingMetricAppearance != null && !resolvedTrailingMetricAppearance.startsWith('accent-') ? "metric.semantic.".concat((0, $70131c979f865eba$export$a3fc04b8551e006a)(resolvedTrailingMetricAppearance).key) : 'metric.semantic.neutral';
    var commonStyleOverrides = {
        backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
        maxWidth: maxWidthIsPc ? maxWidth : '100%'
    };
    var hasTrailingMetric = trailingMetric != null && trailingMetric !== '';
    var childrenKey = typeof children === 'string' ? children : undefined;
    (0, $7fPBF.useLayoutEffect)(function() {
        // Ignore initial render
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        setResizing(true);
    }, [
        childrenKey
    ]);
    var enableMotionFG = (0, $137Lh.fg)('platform-dst-motion-uplift');
    var innerContent = /*#__PURE__*/ $7fPBF.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        style: {
            // When maxWidth is a percentage, constrain the content wrapper
            // so text truncation works correctly within the flex layout
            maxWidth: maxWidthIsPc ? '100%' : undefined
        }
    }, enableMotionFG ? resizingWidth : undefined, {
        className: (0, $7StG6.default)([
            $88b098ff68dfabd5$var$styles.content,
            spacing === 'spacious' && $88b098ff68dfabd5$var$styles.contentSpacious,
            isLoading && $88b098ff68dfabd5$var$styles.loadingContent
        ])
    }), iconBefore && /*#__PURE__*/ $7fPBF.createElement((0, $8435eb3b3b79f3b6$export$2e2bcd8739ae039), {
        size: spacing === 'spacious' ? 'medium' : 'small',
        icon: iconBefore,
        color: resolvedColor,
        testId: testId && "".concat(testId, "--icon")
    }), /*#__PURE__*/ $7fPBF.createElement("span", {
        style: {
            maxWidth: maxWidthIsPc ? undefined : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")"),
            color: style === null || style === void 0 ? void 0 : style.color
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $7StG6.default)([
            $88b098ff68dfabd5$var$styles.text,
            enableMotionFG && resizing ? $88b098ff68dfabd5$var$styles.textClip : $88b098ff68dfabd5$var$styles.textEllipsis,
            spacing === 'spacious' && $88b098ff68dfabd5$var$styles.textSpacious
        ])
    }, children), hasTrailingMetric && !resolvedColor.startsWith('accent-') && /*#__PURE__*/ $7fPBF.createElement("span", {
        "data-lozenge-metric-wrapper": true,
        "data-testid": testId && "".concat(testId, "--metric"),
        className: (0, $7StG6.default)([
            $88b098ff68dfabd5$var$styles.metricBadgeWrapper
        ])
    }, /*#__PURE__*/ $7fPBF.createElement((0, $35fbf3ba688956a9$export$2e2bcd8739ae039), {
        appearance: metricBadgeAppearance
    }, trailingMetric)), isInteractive && /*#__PURE__*/ $7fPBF.createElement((0, (/*@__PURE__*/$parcel$interopDefault($53b5033184a33c84$exports))), {
        label: "",
        size: "small",
        color: 'currentColor',
        testId: testId && "".concat(testId, "--chevron")
    }));
    if (isInteractive) return /*#__PURE__*/ $7fPBF.createElement((0, $054f878f9c5e6732$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        ref: ref,
        xcss: (0, $e636b2257db42c06$export$a274e22fb40f762e)($88b098ff68dfabd5$var$styles.container, (0, $137Lh.fg)('platform-dst-motion-uplift') && $88b098ff68dfabd5$var$styles.motionContainer, spacing === 'spacious' && $88b098ff68dfabd5$var$styles.containerSpacious, !isSelected && $88b098ff68dfabd5$var$styles.iconBorderFilter, !isLoading && $88b098ff68dfabd5$var$styles.iconBorderInteractiveFilter, $88b098ff68dfabd5$var$styles[colorStyleKey], !isLoading && $88b098ff68dfabd5$var$styles[interactiveStyleKey], isSelected && $88b098ff68dfabd5$var$styles.containerSelected, hasTrailingMetric && $88b098ff68dfabd5$var$styles.containerBadge, hasTrailingMetric && $88b098ff68dfabd5$var$styles.containerBadgeInteractive, hasTrailingMetric && $88b098ff68dfabd5$var$styles[metricStyleKey])
    }, isLoading && {
        'aria-busy': true,
        'aria-disabled': true,
        isDisabled: true
    }, {
        "aria-label": isLoading ? 'Loading' : ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        onClick: isLoading ? undefined : onClick,
        style: $88b098ff68dfabd5$var$_objectSpread($88b098ff68dfabd5$var$_objectSpread({}, commonStyleOverrides), {}, {
            // Specified because Pressable has a default border:none which overrides the border specified on the container
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            border: "solid ".concat("var(--ds-border-width, 1px)", " ", isSelected ? 'oklch(from var(--border-color) calc(l * var(--border-pressed-l-factor)) c h) !important' : 'transparent'),
            backgroundColor: isSelected ? $88b098ff68dfabd5$var$pressedBackgroundMapping[resolvedColor] : undefined,
            cursor: isLoading ? 'progress' : 'pointer'
        }),
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LozengeDropdownTrigger"
    }), innerContent, isLoading && /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, $7StG6.default)([
            $88b098ff68dfabd5$var$styles.loadingOverlay
        ])
    }, /*#__PURE__*/ $7fPBF.createElement((0, $aacfdd39b28e059d$export$2e2bcd8739ae039), {
        size: spacing === 'spacious' ? 'small' : 'xsmall',
        label: ", Loading",
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    })));
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        ref: ref,
        style: commonStyleOverrides,
        "data-testid": testId,
        className: (0, $7StG6.default)([
            $88b098ff68dfabd5$var$styles.container,
            spacing === 'spacious' && $88b098ff68dfabd5$var$styles.containerSpacious,
            spacing !== 'spacious' && hasTrailingMetric && $88b098ff68dfabd5$var$styles.containerBadgePadding,
            $88b098ff68dfabd5$var$styles[colorStyleKey],
            hasTrailingMetric && $88b098ff68dfabd5$var$styles[metricStyleKey],
            $88b098ff68dfabd5$var$styles.iconBorderFilter,
            $88b098ff68dfabd5$var$styles.containerBadge
        ])
    }, innerContent);
}));
var $88b098ff68dfabd5$export$2e2bcd8739ae039 = $88b098ff68dfabd5$var$LozengeBase;


/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $fabb9f023e86f68e$var$Lozenge = function Lozenge(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style, testId = _ref.testId, children = _ref.children, iconBefore = _ref.iconBefore, trailingMetric = _ref.trailingMetric, trailingMetricAppearance = _ref.trailingMetricAppearance;
    var baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        children: children
    };
    return /*#__PURE__*/ $7fPBF.createElement((0, $88b098ff68dfabd5$export$2e2bcd8739ae039), baseProps, children);
};
$fabb9f023e86f68e$var$Lozenge.displayName = 'Lozenge';
var $fabb9f023e86f68e$export$2e2bcd8739ae039 = $fabb9f023e86f68e$var$Lozenge;


/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ var $c1dee19b2c866aaf$var$styles = {
    container: "_2rkofajl _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect4ttxp _1wyb1skh _zg8l4jg8 _k48pwu06 _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhksm61",
    'bg.subtle.inprogress': "_bfhksm61",
    'bg.subtle.moved': "_bfhksm61",
    'bg.subtle.new': "_bfhksm61",
    'bg.subtle.removed': "_bfhksm61",
    'bg.subtle.success': "_bfhksm61",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syazi7uo",
    'text.bold': "_syazwwip"
};
var $c1dee19b2c866aaf$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed'
];
var $c1dee19b2c866aaf$var$newSemanticColors = [
    'success',
    'discovery',
    'warning',
    'danger',
    'information',
    'neutral'
];
var $c1dee19b2c866aaf$var$appearanceMapping = {
    neutral: 'default',
    default: 'default',
    information: 'inprogress',
    inprogress: 'inprogress',
    warning: 'moved',
    moved: 'moved',
    removed: 'removed',
    danger: 'removed',
    success: 'success',
    discovery: 'new',
    new: 'new'
};
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $c1dee19b2c866aaf$var$LegacyLozenge = /*#__PURE__*/ (0, $7fPBF.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$isBold = _ref.isBold, isBold = _ref$isBold === void 0 ? false : _ref$isBold, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style;
    var appearanceStyle = isBold ? 'bold' : 'subtle';
    var appearanceType = (0, $7fPBF.useMemo)(function() {
        return $c1dee19b2c866aaf$var$appearanceTypes.includes(appearance) || $c1dee19b2c866aaf$var$newSemanticColors.includes(appearance) ? $c1dee19b2c866aaf$var$appearanceMapping[appearance] : 'default';
    }, [
        appearance
    ]);
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $7StG6.default)([
            $c1dee19b2c866aaf$var$styles.container,
            $c1dee19b2c866aaf$var$styles["bg.".concat(appearanceStyle, ".").concat(appearanceType)],
            appearanceStyle === 'subtle' && $c1dee19b2c866aaf$var$styles["outline.subtle.".concat(appearanceType)],
            appearanceStyle === 'subtle' && $c1dee19b2c866aaf$var$styles.containerSubtle
        ])
    }, /*#__PURE__*/ $7fPBF.createElement("span", {
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $7StG6.default)([
            $c1dee19b2c866aaf$var$styles.text,
            (0, $137Lh.fg)('platform-lozenge-custom-letterspacing') && $c1dee19b2c866aaf$var$styles.customLetterspacing,
            $c1dee19b2c866aaf$var$styles["text.".concat(appearanceStyle)]
        ])
    }, children));
});
$c1dee19b2c866aaf$var$LegacyLozenge.displayName = 'Lozenge';
/**
 * Wrapper component that switches between old and new Lozenge based on feature flag
 */ var $c1dee19b2c866aaf$var$LozengeWrapper = /*#__PURE__*/ (0, $7fPBF.memo)(function(props) {
    if ((0, $137Lh.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) return /*#__PURE__*/ $7fPBF.createElement((0, $fabb9f023e86f68e$export$2e2bcd8739ae039), props);
    return /*#__PURE__*/ $7fPBF.createElement($c1dee19b2c866aaf$var$LegacyLozenge, props);
});
$c1dee19b2c866aaf$var$LozengeWrapper.displayName = 'Lozenge';
var $c1dee19b2c866aaf$export$2e2bcd8739ae039 = $c1dee19b2c866aaf$var$LozengeWrapper;



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $226a6189eb11e913$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $226a6189eb11e913$var$ExitingContext = /*#__PURE__*/ (0, $7fPBF.createContext)($226a6189eb11e913$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $226a6189eb11e913$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $226a6189eb11e913$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($226a6189eb11e913$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $226a6189eb11e913$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $7fPBF.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $226a6189eb11e913$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $226a6189eb11e913$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $226a6189eb11e913$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $226a6189eb11e913$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $226a6189eb11e913$var$ExitingPersistence = /*#__PURE__*/ (0, $7fPBF.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $7fPBF.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $7fPBF.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $7fPBF.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $226a6189eb11e913$var$childrenToArray(previousChildren);
    var current = $226a6189eb11e913$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $226a6189eb11e913$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $226a6189eb11e913$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $137Lh.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $226a6189eb11e913$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $226a6189eb11e913$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $226a6189eb11e913$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $7fPBF.useContext)($226a6189eb11e913$var$ExitingContext);
};
$226a6189eb11e913$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $226a6189eb11e913$export$2e2bcd8739ae039 = $226a6189eb11e913$var$ExitingPersistence;


var $iKdEz = parcelRequire("iKdEz");

/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $c16c25b6810bc9b7$export$368bacef0dacbe05 = 25;
var $c16c25b6810bc9b7$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $c16c25b6810bc9b7$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $c16c25b6810bc9b7$export$30fa1a2e62ae150c = {
    none: $c16c25b6810bc9b7$export$38b928a7167ce124.none,
    small: $c16c25b6810bc9b7$export$38b928a7167ce124.small * $c16c25b6810bc9b7$var$EXITING_MOTION_MULTIPLIER,
    medium: $c16c25b6810bc9b7$export$38b928a7167ce124.medium * $c16c25b6810bc9b7$var$EXITING_MOTION_MULTIPLIER,
    large: $c16c25b6810bc9b7$export$38b928a7167ce124.large * $c16c25b6810bc9b7$var$EXITING_MOTION_MULTIPLIER
};






/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $11bc122b553512b1$var$ShrinkOut = function ShrinkOut(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'small' : _ref$duration, onFinish = _ref.onFinish;
    var _useElementRef = (0, $d428d4ee5fc7f73a$export$ff879f35a69d56b7)(), _useElementRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useElementRef, 2), element = _useElementRef2[0], setElementRef = _useElementRef2[1];
    var exiting = (0, $226a6189eb11e913$export$3b6f38abbdcbd000)();
    var requestAnimationFrame = (0, $fec12d368d681fb0$export$1775f27e7c8051ca)();
    var setTimeout = (0, $fec12d368d681fb0$export$4f34107a2b00f39c)();
    var direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $4e1fe18a5f43db0e$export$e5c5a5f917a5871c)(function() {
        if (exiting.isExiting && element) {
            if ((0, $d4daef9147c5842c$export$b7baf7667a68d87c)()) {
                exiting.onFinish && exiting.onFinish();
                onFinish && onFinish('exiting');
                return;
            }
            var newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: "".concat(element.offsetWidth, "px"),
                height: "".concat(element.offsetHeight, "px"),
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    var newStyles = {
                        width: '0px',
                        margin: '0px',
                        // We animate margin down to zero so it doesn't take any space.
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $c16c25b6810bc9b7$export$38b928a7167ce124)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(function() {
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $c16c25b6810bc9b7$export$38b928a7167ce124)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $11bc122b553512b1$export$2e2bcd8739ae039 = $11bc122b553512b1$var$ShrinkOut;



var $137Lh = parcelRequire("137Lh");
/* tag-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $7StG6 = parcelRequire("7StG6");

var $7StG6 = parcelRequire("7StG6");
const $8ded14bfed5398d3$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $7StG6.default)(actualStyles);
};


var $bdcfa9ca2b21d8d2$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($bdcfa9ca2b21d8d2$exports, "__esModule", {
    value: true
});
$bdcfa9ca2b21d8d2$exports.default = void 0;

var $bdcfa9ca2b21d8d2$var$_react = $bdcfa9ca2b21d8d2$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $bdcfa9ca2b21d8d2$var$_baseNew = $bdcfa9ca2b21d8d2$var$_interopRequireDefault((parcelRequire("2xvCh")));
function $bdcfa9ca2b21d8d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bdcfa9ca2b21d8d2$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $bdcfa9ca2b21d8d2$var$_react.default.createElement($bdcfa9ca2b21d8d2$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$bdcfa9ca2b21d8d2$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $bdcfa9ca2b21d8d2$var$_default = $bdcfa9ca2b21d8d2$exports.default = $bdcfa9ca2b21d8d2$var$ChevronDownIcon;


/* pressable.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");






/* focusable.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $7StG6 = parcelRequire("7StG6");
var $727f26fc3c423dc0$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $727f26fc3c423dc0$var$_excluded2 = [
    "className"
];
var $727f26fc3c423dc0$var$focusRingStyles = null;
var $727f26fc3c423dc0$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $727f26fc3c423dc0$var$Focusable = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $727f26fc3c423dc0$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $727f26fc3c423dc0$var$_excluded2);
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $7StG6.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $727f26fc3c423dc0$export$2e2bcd8739ae039 = $727f26fc3c423dc0$var$Focusable;


var $f58b83bb5060acdc$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $f58b83bb5060acdc$var$_excluded2 = [
    "className"
];
var $f58b83bb5060acdc$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $f58b83bb5060acdc$var$Pressable = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $f48d740006cf3f7d$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $f58b83bb5060acdc$var$_excluded);
    var interactionContext = (0, $7fPBF.useContext)((0, $48ec410b84640600$export$2e2bcd8739ae039));
    var handleClick = (0, $7fPBF.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $593ac790924c31ca$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "19.0.0",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $f58b83bb5060acdc$var$_excluded2);
    return /*#__PURE__*/ $7fPBF.createElement((0, $727f26fc3c423dc0$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $bf96b6408e362ed6$export$95df08bae54cb4df)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $8ded14bfed5398d3$export$a274e22fb40f762e)($f58b83bb5060acdc$var$styles.root, isDisabled && $f58b83bb5060acdc$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $f58b83bb5060acdc$export$2e2bcd8739ae039 = $f58b83bb5060acdc$var$Pressable;



/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // Color mapping from old color names to new color names
var $15a66b1d36e434f4$export$3351a8d90bcc13aa = {
    standard: 'gray',
    grey: 'gray',
    blue: 'blue',
    green: 'green',
    red: 'red',
    yellow: 'yellow',
    purple: 'purple',
    lime: 'lime',
    magenta: 'magenta',
    orange: 'orange',
    teal: 'teal',
    // Light variants map to same as their non-light counterparts
    greyLight: 'gray',
    blueLight: 'blue',
    greenLight: 'green',
    redLight: 'red',
    yellowLight: 'yellow',
    purpleLight: 'purple',
    limeLight: 'lime',
    magentaLight: 'magenta',
    orangeLight: 'orange',
    tealLight: 'teal'
};


/* shared.tsx generated by @compiled/babel-plugin v0.39.1 */ /**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $7fPBF = parcelRequire("7fPBF");

var $7StG6 = parcelRequire("7StG6");

/* remove-button.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");


var $b366abb07d6635b7$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($b366abb07d6635b7$exports, "__esModule", {
    value: true
});
$b366abb07d6635b7$exports.default = void 0;

var $b366abb07d6635b7$var$_react = $b366abb07d6635b7$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $b366abb07d6635b7$var$_baseNew = $b366abb07d6635b7$var$_interopRequireDefault((parcelRequire("2xvCh")));
function $b366abb07d6635b7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b366abb07d6635b7$var$CrossIcon = (props)=>/*#__PURE__*/ $b366abb07d6635b7$var$_react.default.createElement($b366abb07d6635b7$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$b366abb07d6635b7$var$CrossIcon.displayName = 'CrossIcon';
var $b366abb07d6635b7$var$_default = $b366abb07d6635b7$exports.default = $b366abb07d6635b7$var$CrossIcon;



var $3003e2c4e689ceea$var$removeButtonStyles = {
    root: "_19itglyw _2rkolb4i _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i1j6v _1bsb1j6v _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah3idpf _irr31dpa _1di6fcek",
    circle: "_2rko1rr0 _1ah3idpf"
};
var $3003e2c4e689ceea$var$removeButtonStylesNewIcon = {
    root: "_rjxpv77o"
};
var $3003e2c4e689ceea$var$RemoveButton = function RemoveButton(_ref) {
    var ariaLabel = _ref['aria-label'], onClick = _ref.onClick, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onKeyPress = _ref.onKeyPress, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onMouseDown = _ref.onMouseDown, onMouseUp = _ref.onMouseUp, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, testId = _ref.testId, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? 'default' : _ref$shape;
    return /*#__PURE__*/ $7fPBF.createElement((0, $f58b83bb5060acdc$export$2e2bcd8739ae039), {
        xcss: (0, $e636b2257db42c06$export$a274e22fb40f762e)($3003e2c4e689ceea$var$removeButtonStyles.root, shape === 'circle' && $3003e2c4e689ceea$var$removeButtonStyles.circle, $3003e2c4e689ceea$var$removeButtonStylesNewIcon.root),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        testId: testId
    }, /*#__PURE__*/ $7fPBF.createElement((0, (/*@__PURE__*/$parcel$interopDefault($b366abb07d6635b7$exports))), {
        color: "currentColor",
        label: "",
        size: "small"
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3003e2c4e689ceea$export$2e2bcd8739ae039 = $3003e2c4e689ceea$var$RemoveButton;


// Tag status enum
var $a2300eb8a99c4c95$export$74452314b63acabc = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}({});







var $03da918212986ee5$export$203775b632e10448 = '--ds-tag-icon';
var $03da918212986ee5$export$7d6deb4aa4b5840e = '--tag-border-token';
var $03da918212986ee5$export$df7ff9c2f76bffcd = '--tag-icon-token';
/**
 * Stable key so ExitingPersistence can match this child across the remove transition
 * (see ShrinkOut + ExitingPersistence docs in @atlaskit/motion).
 */ var $03da918212986ee5$var$removableShrinkOutChildKey = 'atlaskit-tag-removable-shrink-out';
var $03da918212986ee5$var$motionWrapperStyles = null;
function $03da918212986ee5$export$97d8be09cd53869b(_ref) {
    var isRemovable = _ref.isRemovable, tagText = _ref.tagText, removeButtonLabel = _ref.removeButtonLabel, testId = _ref.testId, handleRemoveRequest = _ref.handleRemoveRequest, removingTag = _ref.removingTag, showingTag = _ref.showingTag, onKeyPress = _ref.onKeyPress, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? 'default' : _ref$shape, buttonHandlers = _ref.buttonHandlers;
    var handleFocus = (0, $7fPBF.useCallback)(function() {
        removingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onFocus();
    }, [
        removingTag,
        buttonHandlers
    ]);
    var handleBlur = (0, $7fPBF.useCallback)(function() {
        showingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onBlur();
    }, [
        showingTag,
        buttonHandlers
    ]);
    return (0, $7fPBF.useMemo)(function() {
        if (!isRemovable) return undefined;
        return /*#__PURE__*/ $7fPBF.createElement((0, $3003e2c4e689ceea$export$2e2bcd8739ae039), {
            "aria-label": "".concat(removeButtonLabel || 'Remove', " ").concat(tagText),
            onClick: handleRemoveRequest,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyPress: onKeyPress,
            onMouseEnter: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseEnter,
            onMouseLeave: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseLeave,
            onMouseDown: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseDown,
            testId: testId ? "close-button-".concat(testId) : undefined,
            shape: shape
        });
    }, [
        isRemovable,
        removeButtonLabel,
        tagText,
        handleRemoveRequest,
        handleFocus,
        handleBlur,
        onKeyPress,
        buttonHandlers,
        testId,
        shape
    ]);
}
function $03da918212986ee5$export$898a500849bb5cf4(_ref2) {
    var isRemovable = _ref2.isRemovable, status = _ref2.status, onShrinkOutExitComplete = _ref2.onShrinkOutExitComplete, children = _ref2.children;
    if (isRemovable) return /*#__PURE__*/ $7fPBF.createElement((0, $226a6189eb11e913$export$2e2bcd8739ae039), null, !(status === (0, $a2300eb8a99c4c95$export$74452314b63acabc).Removed) && /*#__PURE__*/ $7fPBF.createElement((0, $11bc122b553512b1$export$2e2bcd8739ae039), {
        key: $03da918212986ee5$var$removableShrinkOutChildKey,
        onFinish: onShrinkOutExitComplete ? function(phase) {
            if (phase === 'exiting') onShrinkOutExitComplete();
        } : undefined
    }, function(motion) {
        return /*#__PURE__*/ $7fPBF.createElement("span", {
            ref: motion.ref,
            className: (0, $7StG6.default)([
                "_1e0c116y"
            ])
        }, children);
    }));
    return children;
}
function $03da918212986ee5$export$ce4b6a469c26f53f(_ref3) {
    var isLink = _ref3.isLink, href = _ref3.href, LinkComponent = _ref3.LinkComponent, testId = _ref3.testId, children = _ref3.children, onClick = _ref3.onClick, linkHandlers = _ref3.linkHandlers;
    if (isLink && href) return /*#__PURE__*/ $7fPBF.createElement(LinkComponent, {
        href: href,
        testId: testId ? "".concat(testId, "--link") : undefined,
        onClick: onClick,
        onMouseEnter: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseEnter,
        onMouseLeave: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseLeave,
        onMouseDown: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseDown,
        onFocus: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onFocus,
        onBlur: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onBlur
    }, children);
    return /*#__PURE__*/ $7fPBF.createElement((0, $7fPBF.Fragment), null, children);
}


/* swatch-before.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $7StG6 = parcelRequire("7StG6");
var $ede16a8706ef5c45$var$tagSwatchBeforeStyles = {
    swatch: "_2rkolb4i _1bsboqnp _4t3ioqnp _1o9zidpf"
};
var $ede16a8706ef5c45$var$tagSwatchBeforeColorStyles = {
    gray: "_bfhk18j9",
    blue: "_bfhk115i",
    green: "_bfhk1rsu",
    red: "_bfhkkrt9",
    yellow: "_bfhk8y3s",
    purple: "_bfhk18ah",
    lime: "_bfhkbq5w",
    magenta: "_bfhk1mi6",
    orange: "_bfhk1kkj",
    teal: "_bfhktdv8"
};
function $ede16a8706ef5c45$export$2e2bcd8739ae039(_ref) {
    var colorKey = _ref.colorKey, swatchBefore = _ref.swatchBefore;
    if (swatchBefore === undefined || swatchBefore === false) return null;
    if (swatchBefore === true) return /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, $7StG6.default)([
            $ede16a8706ef5c45$var$tagSwatchBeforeStyles.swatch,
            $ede16a8706ef5c45$var$tagSwatchBeforeColorStyles[colorKey]
        ])
    });
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            backgroundColor: swatchBefore
        },
        className: (0, $7StG6.default)([
            $ede16a8706ef5c45$var$tagSwatchBeforeStyles.swatch
        ])
    });
}



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");
function $85547070a50baa10$export$84acd183858d8235() {
    var _useState = (0, $7fPBF.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), isLinkHovered = _useState2[0], setIsLinkHovered = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 2), isOverButton = _useState4[0], setIsOverButton = _useState4[1];
    var _useState5 = (0, $7fPBF.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState5, 2), isButtonFocused = _useState6[0], setIsButtonFocused = _useState6[1];
    var _useState7 = (0, $7fPBF.useState)(false), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState7, 2), isLinkFocused = _useState8[0], setIsLinkFocused = _useState8[1];
    // Track if last interaction was via mouse (to determine keyboard vs mouse focus)
    var hadMouseDownRef = (0, $7fPBF.useRef)(false);
    // Button handlers
    var buttonHandlers = (0, $7fPBF.useMemo)(function() {
        return {
            onMouseEnter: function onMouseEnter() {
                return setIsOverButton(true);
            },
            onMouseLeave: function onMouseLeave() {
                return setIsOverButton(false);
            },
            onMouseDown: function onMouseDown(e) {
                // Prevent the browser from moving focus to the remove button on mousedown.
                // Without this, parent composite widgets (e.g. Select) lose input focus when
                // the user clicks remove, triggering unwanted blur side-effects.
                e === null || e === void 0 || e.preventDefault();
                hadMouseDownRef.current = true;
            },
            onFocus: function onFocus() {
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsButtonFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: function onBlur() {
                return setIsButtonFocused(false);
            }
        };
    }, []);
    // Link handlers - includes hover tracking
    var linkHandlers = (0, $7fPBF.useMemo)(function() {
        return {
            onMouseEnter: function onMouseEnter() {
                return setIsLinkHovered(true);
            },
            onMouseLeave: function onMouseLeave() {
                return setIsLinkHovered(false);
            },
            onMouseDown: function onMouseDown() {
                hadMouseDownRef.current = true;
            },
            onFocus: function onFocus() {
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsLinkFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: function onBlur() {
                return setIsLinkFocused(false);
            }
        };
    }, []);
    return {
        isLinkHovered: isLinkHovered,
        isOverButton: isOverButton,
        isButtonFocused: isButtonFocused,
        isLinkFocused: isLinkFocused,
        buttonHandlers: buttonHandlers,
        linkHandlers: linkHandlers
    };
}


/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $756eaadbe5c8c5b6$var$ATOMIC_GROUP_LENGTH = 5;
function $756eaadbe5c8c5b6$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $756eaadbe5c8c5b6$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}




var $137Lh = parcelRequire("137Lh");
/* anchor.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $bRUy3 = parcelRequire("bRUy3");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");


const $a715c670806f090b$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $756eaadbe5c8c5b6$export$2e2bcd8739ae039)(actualStyles);
};





var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $278b06282f8962b1$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $7fPBF.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $278b06282f8962b1$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($278b06282f8962b1$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $278b06282f8962b1$export$2e2bcd8739ae039 = $278b06282f8962b1$var$RouterLinkProvider;


/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $d4047c55a9de058e$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $7fPBF.useContext)((0, $278b06282f8962b1$export$2931e0ee690eee88)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $d4047c55a9de058e$export$2e2bcd8739ae039 = $d4047c55a9de058e$var$useRouterLink;




var $7fPBF = parcelRequire("7fPBF");
function $d4d502868e612e1e$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useId().replace(/[:«»]/g, '_');
}



/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $468e1031dfd834df$var$ATOMIC_GROUP_LENGTH = 5;
function $468e1031dfd834df$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $468e1031dfd834df$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


var $d1b9d01570e45f55$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $d1b9d01570e45f55$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $468e1031dfd834df$export$2e2bcd8739ae039)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
var $d1b9d01570e45f55$export$2e2bcd8739ae039 = $d1b9d01570e45f55$var$VisuallyHidden;


/* focusable.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $170003928167b932$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $170003928167b932$var$_excluded2 = [
    "className"
];
var $170003928167b932$var$focusRingStyles = null;
var $170003928167b932$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $170003928167b932$var$Focusable = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $170003928167b932$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $170003928167b932$var$_excluded2);
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $756eaadbe5c8c5b6$export$2e2bcd8739ae039)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $170003928167b932$export$2e2bcd8739ae039 = $170003928167b932$var$Focusable;


var $2ef640405325383a$var$_excluded = [
    "href",
    "children",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss",
    "newWindowLabel"
], $2ef640405325383a$var$_excluded2 = [
    "className"
];
var $2ef640405325383a$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
var $2ef640405325383a$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $2ef640405325383a$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $2ef640405325383a$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $f48d740006cf3f7d$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, _ref$newWindowLabel = _ref.newWindowLabel, newWindowLabel = _ref$newWindowLabel === void 0 ? '(opens new window)' : _ref$newWindowLabel, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $2ef640405325383a$var$_excluded);
    var interactionContext = (0, $7fPBF.useContext)((0, $48ec410b84640600$export$2e2bcd8739ae039));
    var handleClick = (0, $7fPBF.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $d4d502868e612e1e$export$f680877a34711e37)();
    var onClick = (0, $593ac790924c31ca$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "@atlaskit/primitives",
        packageVersion: "19.0.0",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $2ef640405325383a$var$_excluded2);
    var RouterLink = (0, $d4047c55a9de058e$export$2e2bcd8739ae039)();
    var isExternal = typeof href === 'string' && $2ef640405325383a$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $2ef640405325383a$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(href) === 'object';
    (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $7fPBF.createElement((0, $170003928167b932$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        xcss: (0, $a715c670806f090b$export$a274e22fb40f762e)($2ef640405325383a$var$styles.root, $2ef640405325383a$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }), children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ $7fPBF.createElement((0, $d1b9d01570e45f55$export$2e2bcd8739ae039), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $2ef640405325383a$var$Anchor = /*#__PURE__*/ (0, $7fPBF.forwardRef)($2ef640405325383a$var$AnchorNoRef);
var $2ef640405325383a$export$2e2bcd8739ae039 = $2ef640405325383a$var$Anchor;

/* box.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
var $1a1e19d151d51d68$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $7fPBF.createContext)('elevation.surface');
var $1a1e19d151d51d68$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $7fPBF.useContext)($1a1e19d151d51d68$export$1ca2a26fecb070ae);
};
$1a1e19d151d51d68$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


var $4df8c425f26ffe90$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $4df8c425f26ffe90$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $4df8c425f26ffe90$var$baseStyles = null;
var $4df8c425f26ffe90$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhkby5v",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $4df8c425f26ffe90$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $4df8c425f26ffe90$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $4df8c425f26ffe90$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $4df8c425f26ffe90$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $4df8c425f26ffe90$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $4df8c425f26ffe90$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $4df8c425f26ffe90$var$Box = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $4df8c425f26ffe90$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $4df8c425f26ffe90$var$_excluded2);
    var node = /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        style: style,
        ref: ref,
        className: (0, $756eaadbe5c8c5b6$export$2e2bcd8739ae039)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $4df8c425f26ffe90$var$backgroundColorMap[backgroundColor],
            backgroundColor && $4df8c425f26ffe90$var$isSurfaceToken(backgroundColor) && $4df8c425f26ffe90$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $4df8c425f26ffe90$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $4df8c425f26ffe90$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $4df8c425f26ffe90$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $4df8c425f26ffe90$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $7fPBF.createElement((0, $1a1e19d151d51d68$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $4df8c425f26ffe90$export$2e2bcd8739ae039 = $4df8c425f26ffe90$var$Box;
function $4df8c425f26ffe90$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $4df8c425f26ffe90$var$setSurfaceTokenMap;
}


var $705b4fb71b2918ff$var$_excluded = [
    "children",
    "testId",
    "appearance",
    "newWindowLabel",
    "target",
    "className",
    "style"
];
var $705b4fb71b2918ff$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
var $705b4fb71b2918ff$var$iconStyles = null;
var $705b4fb71b2918ff$var$LinkWithoutRef = function LinkWithoutRef(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, newWindowLabel = _ref.newWindowLabel, target = _ref.target, _preventedClassName = _ref.className, _preventedStyle = _ref.style, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $705b4fb71b2918ff$var$_excluded);
    return /*#__PURE__*/ $7fPBF.createElement((0, $2ef640405325383a$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, htmlAttributes, {
        target: target,
        ref: ref,
        xcss: (0, $e636b2257db42c06$export$a274e22fb40f762e)($705b4fb71b2918ff$var$styles.base, (0, $137Lh.fg)('platform-dst-shape-theme-default') && $705b4fb71b2918ff$var$styles.baseT26Shape, appearance === 'default' && $705b4fb71b2918ff$var$styles.defaultAppearance, appearance === 'subtle' && $705b4fb71b2918ff$var$styles.subtleAppearance, appearance === 'inverse' && $705b4fb71b2918ff$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $705b4fb71b2918ff$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }), children, target === '_blank' && /*#__PURE__*/ $7fPBF.createElement((0, $4df8c425f26ffe90$export$2e2bcd8739ae039), {
        as: "span",
        xcss: $705b4fb71b2918ff$var$styles.iconWrapper,
        testId: testId && "".concat(testId, "__icon")
    }, "\uFEFF", /*#__PURE__*/ $7fPBF.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $756eaadbe5c8c5b6$export$2e2bcd8739ae039)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ var $705b4fb71b2918ff$var$Link = /*#__PURE__*/ (0, $7fPBF.forwardRef)($705b4fb71b2918ff$var$LinkWithoutRef);
var $705b4fb71b2918ff$export$2e2bcd8739ae039 = $705b4fb71b2918ff$var$Link;


function $5508f81116ef8f0f$export$dcf14c9974fe2767(href, linkComponent) {
    var isLink = Boolean(href);
    var LinkComponent = linkComponent !== null && linkComponent !== void 0 ? linkComponent : (0, $705b4fb71b2918ff$export$2e2bcd8739ae039);
    return {
        isLink: isLink,
        LinkComponent: LinkComponent
    };
}



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");
var $fdaefd3bc83c9046$export$279e7025ed114474 = function defaultBeforeRemoveAction() {
    return true;
};



function $5c301342b182546a$export$f26019543e9f862f(onBeforeRemoveAction) {
    var _useState = (0, $7fPBF.useState)((0, $a2300eb8a99c4c95$export$74452314b63acabc).Showing), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), status = _useState2[0], setStatus = _useState2[1];
    var handleRemoveRequest = (0, $7fPBF.useCallback)(function() {
        var beforeAction = onBeforeRemoveAction !== null && onBeforeRemoveAction !== void 0 ? onBeforeRemoveAction : (0, $fdaefd3bc83c9046$export$279e7025ed114474);
        if (beforeAction()) // Defer onAfterRemoveAction until ShrinkOut's onFinish so ExitingPersistence can run
        // the exit animation (e.g. in multi-select and user pickers).
        setStatus((0, $a2300eb8a99c4c95$export$74452314b63acabc).Removed);
    }, [
        onBeforeRemoveAction
    ]);
    var onKeyPress = (0, $7fPBF.useCallback)(function(e) {
        var spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    var removingTag = (0, $7fPBF.useCallback)(function() {
        return setStatus((0, $a2300eb8a99c4c95$export$74452314b63acabc).Removing);
    }, []);
    var showingTag = (0, $7fPBF.useCallback)(function() {
        return setStatus((0, $a2300eb8a99c4c95$export$74452314b63acabc).Showing);
    }, []);
    return {
        status: status,
        handleRemoveRequest: handleRemoveRequest,
        onKeyPress: onKeyPress,
        removingTag: removingTag,
        showingTag: showingTag
    };
}


var $d3cd7da87451b24e$var$_excluded = [
    "color",
    "text",
    "elemBefore",
    "href",
    "linkComponent",
    "isRemovable",
    "removeButtonLabel",
    "onBeforeRemoveAction",
    "onAfterRemoveAction",
    "testId",
    "maxWidth",
    "hasMargin",
    "onClick",
    "swatchBefore"
], $d3cd7da87451b24e$var$_excluded2 = [
    "color",
    "text",
    "elemBefore",
    "testId",
    "maxWidth",
    "hasMargin",
    "onClick",
    "isSelected",
    "isLoading",
    "analyticsContext",
    "hasChevron",
    "swatchBefore"
];
// CSS variable name for icon color - must be used as literal string in cssMap due to Compiled CSS static analysis
var $d3cd7da87451b24e$var$iconColorVar = '--ds-tag-icon';
var $d3cd7da87451b24e$var$styles = {
    baseStyles: "_zulp1b66 _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1rjcv77o _18zr1mie _1mou1b66 _195g1b66 _1e0c116y _vchhusvi _1ul9idpf _p12ff6dh _4t3i1k92 _kqswh2mm _4cvr1h6o _80om73ad _bfhksm61",
    noMarginStyles: "_1mouze3t _195gze3t",
    removableStyles: "_zulp1b66",
    beforeStyles: "_4bfu1snc _1hmsagmp _ajmmvv82 _1e0c116y _4cvr1h6o _1o9zidpf _syaz125o",
    beforeStylesSelected: "_syazxl6c",
    textStyles: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n _1ul9idpf _syazi7uo",
    textStylesSelected: "_syaz6x5g",
    afterStyles: "_1e0c1txw _4cvr1h6o _1o9zidpf _lcxv1wug _kqswh2mm",
    focusRingStyles: "_1ygbdfik _1ah3v77o",
    childFocusRingStyles: "_1a37dfik _1cwgv77o",
    interactiveBaseStyles: "_80omtlke _1all1b66 _qsdj1r31 _17ncglyw _15hpnqa1 _1rg815vq _1yoo15vq _j8j91snc _1afaagmp _gdbt10yn _h5vp116y _1qxz1h6o _8zx0idpf _1km4jdj5 _wc1fagmp _9408jdj5 _usew1snc _ebtnagmp _uvk910yn _10nj1r31 _1xq0glyw _18x1nqa1 _2mpsagmp",
    interactiveHoverStyles: "_17501r31 _qrsc8stv _1wodnqa1 _irr31dpa _rlyhjdj5 _1di6fcek"
};
// Border and icon color styles - each color sets CSS variables for its token values
var $d3cd7da87451b24e$var$colorStyles = {
    gray: "_119b8yml _1ib21diz",
    blue: "_119b1w55 _1ib26txe",
    green: "_119b1crs _1ib217hp",
    red: "_119b16y8 _1ib2nbxb",
    yellow: "_119bfeiv _1ib21oqg",
    purple: "_119b1hqq _1ib2uq3u",
    lime: "_119bnf89 _1ib28645",
    magenta: "_119buwd0 _1ib2v8hk",
    orange: "_119b1b2s _1ib21j6y",
    teal: "_119b1h3o _1ib28uof"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values */ // Border + icon filter styles - base state
var $d3cd7da87451b24e$var$borderIconFilterStyles = {
    root: "_1h6dpryq _1k671038 _13muu67f _oe6mmko7 _m71tr3uz _168qx19p _wi6h1o1e _4uq11yqs _u8p61h4e _hg5mr3uz _1t75u67f _1f28f1ug _189qkb7n _1easrqqc _1knhjbtf"
};
// Border + icon filter styles - interactive states (hover/pressed)
var $d3cd7da87451b24e$var$borderIconInteractiveFilterStyles = {
    root: "_18dicjiy _hyog26zw _ylgq1r5k _bg3q9by0 _fdt01r5k _46v5hwvj _1iel6xdd _111i1h4e _l0666xdd _pclnn8xv _ockq1r5k _aewt1n8h _196p1btq _18mn783i _4cvxpc7y _zqoikzix _q4zt1ij0 _ba351r2o _75gvn2k3 _kgu3swso _ui3h1vs5 _1r84p7hp"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values */ var $d3cd7da87451b24e$var$dropdownStyles = {
    interactive: "_irr31dpa _1di6fcek",
    selected: "_1h6dq98m _syaz6x5g _bfhk15s3 _irr3ufnl _1di6nozp",
    content: "_zulp1b66 _1reo15vq _18m915vq _1e0c116y _4cvr1h6o _16jlkb7n _1o9zkb7n _1ul9idpf",
    loadingContent: "_tzy4idpf",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values */ /**
 * __TagNew__
 *
 * TagNew is the visual uplift implementation of Tag
 */ var $d3cd7da87451b24e$var$TagNewComponent = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function TagNew(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'gray' : _ref$color, text = _ref.text, elemBefore = _ref.elemBefore, href = _ref.href, linkComponent = _ref.linkComponent, _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, removeButtonLabel = _ref.removeButtonLabel, onBeforeRemoveAction = _ref.onBeforeRemoveAction, onAfterRemoveAction = _ref.onAfterRemoveAction, testId = _ref.testId, maxWidth = _ref.maxWidth, _ref$hasMargin = _ref.hasMargin, hasMargin = _ref$hasMargin === void 0 ? true : _ref$hasMargin, onClick = _ref.onClick, swatchBefore = _ref.swatchBefore, other = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $d3cd7da87451b24e$var$_excluded);
    var _useTagRemoval = (0, $5c301342b182546a$export$f26019543e9f862f)(onBeforeRemoveAction), status = _useTagRemoval.status, handleRemoveRequest = _useTagRemoval.handleRemoveRequest, onKeyPress = _useTagRemoval.onKeyPress, removingTag = _useTagRemoval.removingTag, showingTag = _useTagRemoval.showingTag;
    var onShrinkOutExitComplete = (0, $7fPBF.useCallback)(function() {
        onAfterRemoveAction === null || onAfterRemoveAction === void 0 || onAfterRemoveAction(text);
    }, [
        onAfterRemoveAction,
        text
    ]);
    var _useLink = (0, $5508f81116ef8f0f$export$dcf14c9974fe2767)(href, linkComponent), isLink = _useLink.isLink, LinkComponent = _useLink.LinkComponent;
    var _useButtonInteraction = (0, $85547070a50baa10$export$84acd183858d8235)(), isLinkHovered = _useButtonInteraction.isLinkHovered, isOverButton = _useButtonInteraction.isOverButton, isButtonFocused = _useButtonInteraction.isButtonFocused, isLinkFocused = _useButtonInteraction.isLinkFocused, buttonHandlers = _useButtonInteraction.buttonHandlers, linkHandlers = _useButtonInteraction.linkHandlers;
    var removeButton = (0, $03da918212986ee5$export$97d8be09cd53869b)({
        isRemovable: isRemovable,
        tagText: text,
        removeButtonLabel: removeButtonLabel,
        testId: testId,
        handleRemoveRequest: handleRemoveRequest,
        removingTag: removingTag,
        showingTag: showingTag,
        onKeyPress: onKeyPress,
        buttonHandlers: buttonHandlers
    });
    var tagContent = /*#__PURE__*/ $7fPBF.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, other, {
        ref: ref,
        "data-testid": testId,
        style: maxWidth !== undefined ? {
            maxWidth: maxWidth
        } : undefined,
        className: (0, $7StG6.default)([
            $d3cd7da87451b24e$var$styles.baseStyles,
            !hasMargin && $d3cd7da87451b24e$var$styles.noMarginStyles,
            $d3cd7da87451b24e$var$colorStyles[color],
            $d3cd7da87451b24e$var$borderIconFilterStyles.root,
            isLink && $d3cd7da87451b24e$var$styles.interactiveBaseStyles,
            isLink && $d3cd7da87451b24e$var$styles.focusRingStyles,
            isLink && isLinkHovered && !isOverButton && $d3cd7da87451b24e$var$borderIconInteractiveFilterStyles.root,
            isLink && isLinkHovered && !isOverButton && $d3cd7da87451b24e$var$styles.interactiveHoverStyles,
            isRemovable && $d3cd7da87451b24e$var$styles.removableStyles,
            isLinkFocused && !isButtonFocused && $d3cd7da87451b24e$var$styles.childFocusRingStyles
        ])
    }), /*#__PURE__*/ $7fPBF.createElement((0, $03da918212986ee5$export$ce4b6a469c26f53f), {
        isLink: isLink,
        href: href,
        LinkComponent: LinkComponent,
        testId: testId,
        linkHandlers: linkHandlers,
        onClick: onClick
    }, /*#__PURE__*/ $7fPBF.createElement((0, $ede16a8706ef5c45$export$2e2bcd8739ae039), {
        colorKey: color,
        swatchBefore: swatchBefore
    }), elemBefore && /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, $7StG6.default)([
            $d3cd7da87451b24e$var$styles.beforeStyles
        ])
    }, elemBefore), /*#__PURE__*/ $7fPBF.createElement("span", {
        "data-tag-text": true,
        className: (0, $7StG6.default)([
            $d3cd7da87451b24e$var$styles.textStyles
        ])
    }, text)), removeButton && /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, $7StG6.default)([
            $d3cd7da87451b24e$var$styles.afterStyles
        ])
    }, removeButton));
    return /*#__PURE__*/ $7fPBF.createElement((0, $03da918212986ee5$export$898a500849bb5cf4), {
        isRemovable: isRemovable,
        status: status,
        onShrinkOutExitComplete: isRemovable ? onShrinkOutExitComplete : undefined
    }, tagContent);
});
var $d3cd7da87451b24e$export$aba6bd1190e79361 = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function TagDropdownTrigger(_ref2, ref) {
    var _ref2$color = _ref2.color, color = _ref2$color === void 0 ? 'gray' : _ref2$color, text = _ref2.text, elemBefore = _ref2.elemBefore, testId = _ref2.testId, maxWidth = _ref2.maxWidth, _ref2$hasMargin = _ref2.hasMargin, hasMargin = _ref2$hasMargin === void 0 ? true : _ref2$hasMargin, onClick = _ref2.onClick, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, _analyticsContext = _ref2.analyticsContext, _ref2$hasChevron = _ref2.hasChevron, hasChevron = _ref2$hasChevron === void 0 ? true : _ref2$hasChevron, swatchBefore = _ref2.swatchBefore, other = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref2, $d3cd7da87451b24e$var$_excluded2);
    var resolvedColor = (0, $15a66b1d36e434f4$export$3351a8d90bcc13aa)[color] || 'gray';
    return /*#__PURE__*/ $7fPBF.createElement((0, $f58b83bb5060acdc$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        ref: ref,
        xcss: (0, $8ded14bfed5398d3$export$a274e22fb40f762e)($d3cd7da87451b24e$var$styles.baseStyles, !hasMargin && $d3cd7da87451b24e$var$styles.noMarginStyles, $d3cd7da87451b24e$var$colorStyles[resolvedColor], $d3cd7da87451b24e$var$borderIconFilterStyles.root, $d3cd7da87451b24e$var$borderIconInteractiveFilterStyles.root, isSelected && $d3cd7da87451b24e$var$dropdownStyles.selected),
        onClick: isLoading ? undefined : onClick,
        style: {
            borderColor: isSelected ? "var(--ds-border-selected, #1868DB)" : undefined,
            cursor: isLoading ? 'progress' : 'pointer',
            maxWidth: maxWidth !== undefined ? maxWidth : undefined
        }
    }, isLoading && {
        'aria-busy': true,
        'aria-disabled': true,
        isDisabled: true
    }, {
        testId: testId
    }, other), /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, $7StG6.default)([
            $d3cd7da87451b24e$var$dropdownStyles.content,
            isLoading && $d3cd7da87451b24e$var$dropdownStyles.loadingContent
        ])
    }, /*#__PURE__*/ $7fPBF.createElement((0, $ede16a8706ef5c45$export$2e2bcd8739ae039), {
        colorKey: resolvedColor,
        swatchBefore: swatchBefore
    }), elemBefore && /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, $7StG6.default)([
            $d3cd7da87451b24e$var$styles.beforeStyles,
            isSelected && $d3cd7da87451b24e$var$styles.beforeStylesSelected
        ])
    }, elemBefore), /*#__PURE__*/ $7fPBF.createElement("span", {
        "data-tag-text": true,
        className: (0, $7StG6.default)([
            $d3cd7da87451b24e$var$styles.textStyles,
            isSelected && $d3cd7da87451b24e$var$styles.textStylesSelected
        ])
    }, text), hasChevron && /*#__PURE__*/ $7fPBF.createElement((0, (/*@__PURE__*/$parcel$interopDefault($bdcfa9ca2b21d8d2$exports))), {
        label: "",
        size: "small",
        color: 'currentColor',
        testId: testId && "".concat(testId, "--chevron")
    })), isLoading && /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, $7StG6.default)([
            $d3cd7da87451b24e$var$dropdownStyles.loadingOverlay
        ])
    }, /*#__PURE__*/ $7fPBF.createElement((0, $aacfdd39b28e059d$export$2e2bcd8739ae039), {
        size: 'xsmall',
        label: ", Loading",
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    })));
});
/**
 * __Tag new__
 */ var $d3cd7da87451b24e$var$TagNew = /*#__PURE__*/ (0, $7fPBF.memo)($d3cd7da87451b24e$var$TagNewComponent);
var $d3cd7da87451b24e$export$2e2bcd8739ae039 = $d3cd7da87451b24e$var$TagNew;


/* base.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $8MJe2 = parcelRequire("8MJe2");

var $emuQy = parcelRequire("emuQy");

var $7StG6 = parcelRequire("7StG6");

var $7fPBF = parcelRequire("7fPBF");
var $95faf4cfa776d344$var$_excluded = [
    "before",
    "contentElement",
    "after",
    "testId",
    "style",
    "color",
    "href",
    "className"
];
function $95faf4cfa776d344$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $95faf4cfa776d344$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $95faf4cfa776d344$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $95faf4cfa776d344$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Border colors - Hardcoded for Visual Refresh - to be removed with labelling system work
var $95faf4cfa776d344$var$borderColors = {
    standard: "_1h6d14je",
    blue: "_1h6duisw",
    red: "_1h6da2c0",
    yellow: "_1h6deh2r",
    green: "_1h6d18uw",
    teal: "_1h6d1ug6",
    purple: "_1h6d157s",
    lime: "_1h6dn0nx",
    magenta: "_1h6d1lf6",
    orange: "_1h6dh727",
    grey: "_1h6d14je",
    standardLink: "_1h6d14je",
    blueLight: "_1h6duisw",
    redLight: "_1h6da2c0",
    yellowLight: "_1h6deh2r",
    greenLight: "_1h6d18uw",
    tealLight: "_1h6d1ug6",
    purpleLight: "_1h6d157s",
    limeLight: "_1h6dn0nx",
    magentaLight: "_1h6d1lf6",
    orangeLight: "_1h6dh727",
    greyLight: "_1h6d14je"
};
var $95faf4cfa776d344$var$baseStyles = null;
var $95faf4cfa776d344$var$interactiveStyles = null;
var $95faf4cfa776d344$var$focusRingStyles = null;
var $95faf4cfa776d344$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function BaseTag(_ref, ref) {
    var before = _ref.before, contentElement = _ref.contentElement, after = _ref.after, testId = _ref.testId, style = _ref.style, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, className = _ref.className, other = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $95faf4cfa776d344$var$_excluded);
    var isLink = Boolean(href);
    var isRemovable = Boolean(after);
    var isInteractive = isLink || isRemovable;
    if (color === 'gray') // internally we use 'grey' for gray color so that we can make migration easier behind the ff (gray will work with and without ff now)
    color = 'grey';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, other, {
        ref: ref,
        style: $95faf4cfa776d344$var$_objectSpread({}, style),
        className: (0, $7StG6.default)([
            "_zulp1b66 _2rko12b0 _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3i1k92 _kqswh2mm _4cvr1h6o _bfhksm61 _syazi7uo _80om73ad",
            isInteractive && "_1e38dfik _7glxv77o",
            isLink && "_irr31dpa _1di6fcek",
            $95faf4cfa776d344$var$borderColors[color],
            className
        ]),
        "data-testid": testId
    }), before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$95faf4cfa776d344$export$2e2bcd8739ae039 = $95faf4cfa776d344$var$BaseTag;


/* before.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $7StG6 = parcelRequire("7StG6");
var $cf42053a9ac8aa5c$var$beforeElementStyles = null;
var $cf42053a9ac8aa5c$var$Before = function Before(_ref) {
    var elemBefore = _ref.elemBefore;
    return elemBefore ? /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, $7StG6.default)([
            "_1e0c1txw _4t3i1j6v _4cvr1h6o _1bah1h6o _152tze3t"
        ])
    }, elemBefore) : null;
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cf42053a9ac8aa5c$export$2e2bcd8739ae039 = $cf42053a9ac8aa5c$var$Before;


/**
 * Maps Tag color values to Lozenge appearance values.
 * Used for migration_fallback rendering when feature flag is off.
 */ var $14b76c5d9292f119$var$colorToLozengeAppearanceMap = {
    gray: 'default',
    grey: 'default',
    lime: 'success',
    green: 'success',
    blue: 'inprogress',
    red: 'removed',
    purple: 'new',
    yellow: 'moved',
    orange: 'moved',
    magenta: 'new',
    teal: 'inprogress',
    grayLight: 'default',
    greyLight: 'default',
    limeLight: 'success',
    greenLight: 'success',
    blueLight: 'inprogress',
    redLight: 'removed',
    purpleLight: 'new',
    yellowLight: 'moved',
    orangeLight: 'moved',
    magentaLight: 'new',
    tealLight: 'inprogress'
};
function $14b76c5d9292f119$export$4d9e331cafeacb9d(color) {
    return $14b76c5d9292f119$var$colorToLozengeAppearanceMap[color || 'gray'] || 'default';
}


/* content.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $7StG6 = parcelRequire("7StG6");
var $af00a73df4cb1556$var$baseStyles = null;
var $af00a73df4cb1556$var$linkStyles = null;
var $af00a73df4cb1556$var$hasAfterStyles = null;
var $af00a73df4cb1556$var$Content = function Content(_ref) {
    var _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, _ref$text = _ref.text, text = _ref$text === void 0 ? '' : _ref$text, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, linkComponent = _ref.linkComponent, testId = _ref.testId;
    var Link = linkComponent !== null && linkComponent !== void 0 ? linkComponent : 'a';
    if (href) return /*#__PURE__*/ $7fPBF.createElement(Link, {
        href: href,
        "data-color": color,
        "data-testid": testId ? "".concat(testId, "--link") : undefined,
        className: (0, $7StG6.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazi7uo _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3i7uo _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
            isRemovable && "_p12f1lit"
        ])
    }, text);
    else return /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, $7StG6.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            isRemovable && "_p12f1lit"
        ])
    }, text);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$af00a73df4cb1556$export$2e2bcd8739ae039 = $af00a73df4cb1556$var$Content;



var $f6eb1f9b50246d00$var$_excluded = [
    "appearance",
    "elemBefore",
    "isRemovable",
    "text",
    "color",
    "href",
    "removeButtonLabel",
    "testId",
    "onBeforeRemoveAction",
    "onAfterRemoveAction",
    "linkComponent",
    "migration_fallback",
    "maxWidth",
    "hasMargin",
    "swatchBefore"
];
var $f6eb1f9b50246d00$var$textLinkCssVar = '--ds-ctl';
var $f6eb1f9b50246d00$var$textDefaultCssVar = '--ds-ct';
var $f6eb1f9b50246d00$var$textActiveCssVar = '--ds-ctp';
var $f6eb1f9b50246d00$var$backgroundHoverCssVar = '--ds-cbh';
var $f6eb1f9b50246d00$var$backgroundActiveCssVar = '--ds-cba';
var $f6eb1f9b50246d00$var$TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}($f6eb1f9b50246d00$var$TagStatus || {});
var $f6eb1f9b50246d00$var$packageName = "@atlaskit/tag";
var $f6eb1f9b50246d00$var$packageVersion = "0.0.0-development";
var $f6eb1f9b50246d00$var$defaultBeforeRemoveAction = function defaultBeforeRemoveAction() {
    return true;
};
/**
 * These hide the focus ring for the tag when its remove button is focused,
 * preventing a double focus ring.
 */ var $f6eb1f9b50246d00$var$removingStyles = null;
var $f6eb1f9b50246d00$var$RemovableTagComponent = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var appearance = _ref.appearance, _ref$elemBefore = _ref.elemBefore, elemBefore = _ref$elemBefore === void 0 ? null : _ref$elemBefore, _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, _ref$text = _ref.text, text = _ref$text === void 0 ? '' : _ref$text, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, removeButtonLabel = _ref.removeButtonLabel, testId = _ref.testId, _ref$onBeforeRemoveAc = _ref.onBeforeRemoveAction, onBeforeRemoveAction = _ref$onBeforeRemoveAc === void 0 ? $f6eb1f9b50246d00$var$defaultBeforeRemoveAction : _ref$onBeforeRemoveAc, _ref$onAfterRemoveAct = _ref.onAfterRemoveAction, onAfterRemoveAction = _ref$onAfterRemoveAct === void 0 ? (0, $f48d740006cf3f7d$export$2e2bcd8739ae039) : _ref$onAfterRemoveAct, linkComponent = _ref.linkComponent, migration_fallback = _ref.migration_fallback, maxWidth = _ref.maxWidth, _ref$hasMargin = _ref.hasMargin, hasMargin = _ref$hasMargin === void 0 ? true : _ref$hasMargin, swatchBefore = _ref.swatchBefore, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $f6eb1f9b50246d00$var$_excluded);
    var _useState = (0, $7fPBF.useState)($f6eb1f9b50246d00$var$TagStatus.Showing), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), status = _useState2[0], setStatus = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 2), isHoverCloseButton = _useState4[0], setIsHoverCloseButton = _useState4[1];
    var onAfterRemoveActionWithAnalytics = (0, $0d09177678401696$export$53c2b9c37c40e0d8)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $f6eb1f9b50246d00$var$packageName,
            packageVersion: $f6eb1f9b50246d00$var$packageVersion
        }
    }, 'atlaskit');
    var handleRemoveComplete = (0, $7fPBF.useCallback)(function() {
        setStatus($f6eb1f9b50246d00$var$TagStatus.Removed);
    }, []);
    var handleRemoveRequest = (0, $7fPBF.useCallback)(function() {
        if (onBeforeRemoveAction && onBeforeRemoveAction()) {
            onAfterRemoveActionWithAnalytics(text);
            handleRemoveComplete();
        }
    }, [
        handleRemoveComplete,
        onBeforeRemoveAction,
        onAfterRemoveActionWithAnalytics,
        text
    ]);
    var onKeyPress = (0, $7fPBF.useCallback)(function(e) {
        var spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    var removingTag = (0, $7fPBF.useCallback)(function() {
        return setStatus($f6eb1f9b50246d00$var$TagStatus.Removing);
    }, []);
    var showingTag = (0, $7fPBF.useCallback)(function() {
        return setStatus($f6eb1f9b50246d00$var$TagStatus.Showing);
    }, []);
    var handleMouseOver = (0, $7fPBF.useCallback)(function() {
        return setIsHoverCloseButton(true);
    }, []);
    var handleMouseOut = (0, $7fPBF.useCallback)(function() {
        return setIsHoverCloseButton(false);
    }, []);
    var removeButton = isRemovable ? /*#__PURE__*/ $7fPBF.createElement((0, $3003e2c4e689ceea$export$2e2bcd8739ae039), {
        "aria-label": "".concat(removeButtonLabel || 'Remove', " ").concat(text),
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: "close-button-".concat(testId)
    }) : undefined;
    // Handle migration_fallback: render Lozenge when flag is off and migration_fallback is 'lozenge'
    if (migration_fallback === 'lozenge' && !(0, $137Lh.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        var lozengeAppearance = (0, $14b76c5d9292f119$export$4d9e331cafeacb9d)(color);
        return /*#__PURE__*/ $7fPBF.createElement((0, $c1dee19b2c866aaf$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
            appearance: lozengeAppearance,
            isBold: false,
            testId: testId
        }, rest), text);
    }
    // Use new TagNew component behind feature flag
    // TagNew handles its own animation internally via RemovableWrapper
    if ((0, $137Lh.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        var newColor = (0, $15a66b1d36e434f4$export$3351a8d90bcc13aa)[color || 'standard'];
        return /*#__PURE__*/ $7fPBF.createElement((0, $d3cd7da87451b24e$export$2e2bcd8739ae039), {
            ref: ref,
            color: newColor,
            text: text,
            elemBefore: elemBefore,
            href: href,
            testId: testId,
            isRemovable: isRemovable,
            removeButtonLabel: removeButtonLabel,
            onBeforeRemoveAction: onBeforeRemoveAction,
            onAfterRemoveAction: onAfterRemoveActionWithAnalytics,
            maxWidth: maxWidth,
            hasMargin: hasMargin,
            swatchBefore: swatchBefore
        });
    }
    // Original implementation
    var content = /*#__PURE__*/ $7fPBF.createElement((0, $af00a73df4cb1556$export$2e2bcd8739ae039), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    var hoverCloseButtonColors = (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
    }, $f6eb1f9b50246d00$var$backgroundHoverCssVar, undefined), $f6eb1f9b50246d00$var$backgroundActiveCssVar, undefined), $f6eb1f9b50246d00$var$textDefaultCssVar, undefined), $f6eb1f9b50246d00$var$textActiveCssVar, undefined), $f6eb1f9b50246d00$var$textLinkCssVar, undefined);
    return /*#__PURE__*/ $7fPBF.createElement((0, $226a6189eb11e913$export$2e2bcd8739ae039), null, !(status === $f6eb1f9b50246d00$var$TagStatus.Removed) && /*#__PURE__*/ $7fPBF.createElement((0, $11bc122b553512b1$export$2e2bcd8739ae039), {
        key: "atlaskit-removable-tag-legacy-shrink-out",
        onFinish: handleRemoveComplete
    }, function(motion) {
        return /*#__PURE__*/ $7fPBF.createElement((0, $95faf4cfa776d344$export$2e2bcd8739ae039), {
            ref: (0, $9ec85dcfc6117313$export$2e2bcd8739ae039)([
                motion.ref,
                ref
            ]),
            appearance: appearance,
            color: color,
            testId: testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
            "data-removable": true,
            "data-removing": status === $f6eb1f9b50246d00$var$TagStatus.Removing,
            "data-ishoverclosebutton": isHoverCloseButton,
            href: href,
            before: /*#__PURE__*/ $7fPBF.createElement((0, $cf42053a9ac8aa5c$export$2e2bcd8739ae039), {
                elemBefore: elemBefore
            }),
            contentElement: content,
            after: removeButton,
            className: (0, $7StG6.default)([
                status === $f6eb1f9b50246d00$var$TagStatus.Removing && "_z30c1r31 _twwiglyw _1pka1o36 _bqhtfiwo"
            ])
        });
    }));
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ var $f6eb1f9b50246d00$var$RemovableTag = /*#__PURE__*/ (0, $7fPBF.memo)($f6eb1f9b50246d00$var$RemovableTagComponent);
var $f6eb1f9b50246d00$export$2e2bcd8739ae039 = $f6eb1f9b50246d00$var$RemovableTag;



/* multi-value-label.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");

var $a820f177b45dbbb4$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkolb4i _11c8fhey _o5721q9c _y4tiv77o _bozg1b66 _syaz1kw7",
    disabled: "_syaz1gmx",
    ellipsis: "_1bto1l2s"
};
var $a820f177b45dbbb4$export$544aeea2a5ce08ee = function MultiValueLabel(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, isDisabled = _ref.isDisabled, hasEllipsis = _ref.hasEllipsis, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $fjFkG.default)([
            $a820f177b45dbbb4$var$multiValueLabelStyles.root,
            isDisabled && $a820f177b45dbbb4$var$multiValueLabelStyles.disabled,
            hasEllipsis && $a820f177b45dbbb4$var$multiValueLabelStyles.ellipsis,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-MultiValueLabel')
        ])
    }), children);
};


function $e7fd529649ea4ccc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e7fd529649ea4ccc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e7fd529649ea4ccc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e7fd529649ea4ccc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e7fd529649ea4ccc$var$multiValueTagWrapperStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1mouze3t _195gze3t _4cvr1h6o _1e0c1txw _1ul9ze3t _zdxokb7n _v5ynkb7n _13lsf1ug _3pxh1h6o _d0dz1txw _1ouwze3t"
};
// Tag-like color styles
var $e7fd529649ea4ccc$var$tagLikeColorStyles = {
    gray: "_119b8yml",
    blue: "_119b1w55",
    green: "_119b1crs",
    red: "_119b16y8",
    yellow: "_119bfeiv",
    purple: "_119b1hqq",
    lime: "_119bnf89",
    magenta: "_119buwd0",
    orange: "_119b1b2s",
    teal: "_119b1h3o"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- match TagNew border color logic
var $e7fd529649ea4ccc$var$tagLikeBorderFilterStyles = null;
// Tag-like styles for custom content values (not plain text) when FF is on.
// Mirrors the TagNew component's visual appearance (padding, margins, sizing, colors).
// The container uses tag-like styling while Label/Remove sub-components are preserved
// so custom overrides (e.g. custom aria-labels, rendering objects as data) continue to work.
var $e7fd529649ea4ccc$var$multiValueTagLikeStyles = {
    root: "_1reo15vq _18m915vq _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1mouze3t _195gze3t _1e0c116y _vchhusvi _kqswh2mm _4cvr1h6o _1wpz1h6o _1ul9ze3t _1o9zkb7n _p12ff6dh _4t3i1k92 _bfhksm61 _syazi7uo _80om73ad _3yq3glyw",
    labelWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _11c8wadc _1e0c1txw _4cvr1h6o _1ul9ze3t _1tkeidpf _2a9v1kw7",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk1dpa _16qs1xv8 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
var $e7fd529649ea4ccc$var$getMultiValueLabelText = function getMultiValueLabelText(children, data) {
    if (typeof children === 'string') return children;
    var label = data === null || data === void 0 ? void 0 : data.label;
    return typeof label === 'string' ? label : '';
};
var $e7fd529649ea4ccc$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, isFocused = props.isFocused, removeProps = props.removeProps, selectProps = props.selectProps, cropWithEllipsis = props.cropWithEllipsis;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    var labelText = $e7fd529649ea4ccc$var$getMultiValueLabelText(children, data);
    var isPlainLabel = typeof children === 'string';
    var ffTagUplifts = (0, $137Lh.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    var _getStyleProps = (0, $f8c6de32f1b21b77$export$26417cabd806a658)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    }), containerCss = _getStyleProps.css, containerClassName = _getStyleProps.className;
    var _getStyleProps2 = (0, $f8c6de32f1b21b77$export$26417cabd806a658)(props, 'multiValueLabel', {
        'multi-value__label': true
    }), labelCss = _getStyleProps2.css, labelClassName = _getStyleProps2.className;
    var _getStyleProps3 = (0, $f8c6de32f1b21b77$export$26417cabd806a658)(props, 'multiValueRemove', {
        'multi-value__remove': true
    }), removeCss = _getStyleProps3.css, removeClassName = _getStyleProps3.className;
    var hasCustomLabel = Label !== (0, $a820f177b45dbbb4$export$544aeea2a5ce08ee);
    // Plain labels: use Tag with fillContainer so it truncates like tag-like structure.
    if (ffTagUplifts && isPlainLabel && !hasCustomLabel) {
        var _ref = data !== null && data !== void 0 ? data : {}, elemBefore = _ref.elemBefore, tagColor = _ref.color;
        return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, innerProps, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
            className: (0, $fjFkG.default)([
                $e7fd529649ea4ccc$var$multiValueTagWrapperStyles.root,
                (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(props.className, containerClassName, props.xcss, '-multiValue')
            ])
        }), /*#__PURE__*/ $7fPBF.createElement((0, $f6eb1f9b50246d00$export$2e2bcd8739ae039), {
            text: labelText,
            isRemovable: !isDisabled,
            removeButtonLabel: "".concat(labelText, ", remove"),
            onBeforeRemoveAction: function onBeforeRemoveAction() {
                var _removeProps$onClick;
                (_removeProps$onClick = removeProps.onClick) === null || _removeProps$onClick === void 0 || _removeProps$onClick.call(removeProps, {});
                return false;
            },
            color: tagColor !== null && tagColor !== void 0 ? tagColor : 'gray',
            elemBefore: elemBefore,
            hasMargin: false
        }));
    }
    // FF on + custom content → tag-like path
    if (ffTagUplifts) {
        var colorKey = data === null || data === void 0 ? void 0 : data.color;
        return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
            "data-multi-value-tag-like": "true"
        }, innerProps, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- custom styles.multiValue overrides (e.g. colored borders) must be preserved
            style: containerCss,
            className: (0, $fjFkG.default)([
                $e7fd529649ea4ccc$var$multiValueTagLikeStyles.root,
                $e7fd529649ea4ccc$var$tagLikeColorStyles.gray,
                colorKey === 'blue' && $e7fd529649ea4ccc$var$tagLikeColorStyles.blue,
                colorKey === 'green' && $e7fd529649ea4ccc$var$tagLikeColorStyles.green,
                colorKey === 'red' && $e7fd529649ea4ccc$var$tagLikeColorStyles.red,
                colorKey === 'yellow' && $e7fd529649ea4ccc$var$tagLikeColorStyles.yellow,
                colorKey === 'purple' && $e7fd529649ea4ccc$var$tagLikeColorStyles.purple,
                colorKey === 'lime' && $e7fd529649ea4ccc$var$tagLikeColorStyles.lime,
                colorKey === 'magenta' && $e7fd529649ea4ccc$var$tagLikeColorStyles.magenta,
                colorKey === 'orange' && $e7fd529649ea4ccc$var$tagLikeColorStyles.orange,
                colorKey === 'teal' && $e7fd529649ea4ccc$var$tagLikeColorStyles.teal,
                "_1h6dpryq _1k671038 _13muu67f _oe6mmko7 _u8p61h4e _hg5mr3uz _1easrqqc",
                isDisabled && $e7fd529649ea4ccc$var$multiValueTagLikeStyles.disabled,
                isFocused && $e7fd529649ea4ccc$var$multiValueTagLikeStyles.focused,
                (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(props.className, containerClassName, props.xcss, '-multiValue')
            ])
        }), /*#__PURE__*/ $7fPBF.createElement("div", {
            className: (0, $fjFkG.default)([
                $e7fd529649ea4ccc$var$multiValueTagLikeStyles.labelWrapper
            ])
        }, /*#__PURE__*/ $7fPBF.createElement(Label, {
            data: data,
            innerProps: {
                style: labelCss,
                className: labelClassName
            },
            className: labelClassName,
            hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
            selectProps: selectProps
        }, children)), /*#__PURE__*/ $7fPBF.createElement(Remove, {
            data: data,
            innerProps: $e7fd529649ea4ccc$var$_objectSpread({
                style: removeCss,
                className: removeClassName,
                role: 'button',
                tabIndex: -1,
                'aria-label': "".concat(labelText || 'option', ", remove")
            }, removeProps),
            className: removeClassName,
            isDisabled: isDisabled,
            selectProps: selectProps
        }));
    }
    // FF off → default styles
    return /*#__PURE__*/ $7fPBF.createElement(Container, {
        data: data,
        innerProps: $e7fd529649ea4ccc$var$_objectSpread({
            style: containerCss,
            className: containerClassName
        }, innerProps),
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps
    }, /*#__PURE__*/ $7fPBF.createElement(Label, {
        data: data,
        innerProps: {
            style: labelCss,
            className: labelClassName
        },
        className: labelClassName,
        hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
        selectProps: selectProps
    }, children), /*#__PURE__*/ $7fPBF.createElement(Remove, {
        data: data,
        innerProps: $e7fd529649ea4ccc$var$_objectSpread({
            style: removeCss,
            className: removeClassName,
            role: 'button',
            tabIndex: -1,
            'aria-label': "".concat(labelText || 'option', ", remove")
        }, removeProps),
        className: removeClassName,
        isDisabled: isDisabled,
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e7fd529649ea4ccc$export$2e2bcd8739ae039 = $e7fd529649ea4ccc$var$MultiValue;



/* multi-value-remove.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");

var $0fb0264f42f6755f$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($0fb0264f42f6755f$exports, "__esModule", {
    value: true
});
$0fb0264f42f6755f$exports.default = void 0;

var $0fb0264f42f6755f$var$_react = $0fb0264f42f6755f$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $0fb0264f42f6755f$var$_baseNew = $0fb0264f42f6755f$var$_interopRequireDefault((parcelRequire("aUDbt")));
function $0fb0264f42f6755f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0fb0264f42f6755f$var$CrossIcon = (props)=>/*#__PURE__*/ $0fb0264f42f6755f$var$_react.default.createElement($0fb0264f42f6755f$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$0fb0264f42f6755f$var$CrossIcon.displayName = 'CrossIcon';
var $0fb0264f42f6755f$var$_default = $0fb0264f42f6755f$exports.default = $0fb0264f42f6755f$var$CrossIcon;


var $3330e5c6cc4a5082$var$disabledStyles = null;
var $3330e5c6cc4a5082$var$enabledStyles = null;
var $3330e5c6cc4a5082$var$multiValueRemoveStyles = {
    focused: "_bfhkb1q9 _lswu6x5g",
    root: "_19itglyw _2rko12b0 _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _1e0c1txw _lswui7uo _1q51v77o _y4tiv77o _85i5v77o _bozgv77o _12l2v77o _1ah312gs _irr31dpa _13br1tmw _1di6fcek _i5f81tmw"
};
function $3330e5c6cc4a5082$export$8e1fd1a40e7a2f4a(_ref) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, innerProps = _ref.innerProps, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $fjFkG.default)([
            $3330e5c6cc4a5082$var$multiValueRemoveStyles.root,
            isFocused && $3330e5c6cc4a5082$var$multiValueRemoveStyles.focused,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-MultiValueRemove')
        ])
    }), /*#__PURE__*/ $7fPBF.createElement("div", {
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
        className: (0, $fjFkG.default)([
            isDisabled && "_1e0cglyw",
            !isDisabled && "_1e0c1kw7"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement((0, (/*@__PURE__*/$parcel$interopDefault($0fb0264f42f6755f$exports))), {
        label: "",
        color: "currentColor",
        size: "small"
    })));
}


/* option.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");


var $6966aa68e6cc290a$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syazi7uo _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di6fcek",
    disabled: "_syaz1gmx _80om13gf _bfhk1j28 _16qsglyw _1di61j28 _112eglyw",
    focused: "_bfhk1dpa _16qs1x9r _112e5u6v",
    selected: "_syaz6x5g _bfhk15s3 _16qs1x9r _1di6nozp _112e5u6v",
    focusedSelected: "_bfhkufnl"
};
var $6966aa68e6cc290a$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $f8c6de32f1b21b77$export$26417cabd806a658)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $fjFkG.default)([
            $6966aa68e6cc290a$var$optionStyles.root,
            isFocused && $6966aa68e6cc290a$var$optionStyles.focused,
            isSelected && $6966aa68e6cc290a$var$optionStyles.selected,
            isFocused && isSelected && $6966aa68e6cc290a$var$optionStyles.focusedSelected,
            isDisabled && $6966aa68e6cc290a$var$optionStyles.disabled,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-option')
        ]),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6966aa68e6cc290a$export$2e2bcd8739ae039 = $6966aa68e6cc290a$var$Option;


/* placeholder.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");


var $35c8ae659c390b04$var$placeholderStyles = {
    root: "_nd5l1sux _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syaz1rpy",
    disabled: "_syaz1gmx"
};
var $35c8ae659c390b04$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, xcss = props.xcss;
    var _getStyleProps = (0, $f8c6de32f1b21b77$export$26417cabd806a658)(props, 'placeholder', {
        placeholder: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $fjFkG.default)([
            $35c8ae659c390b04$var$placeholderStyles.root,
            isDisabled && $35c8ae659c390b04$var$placeholderStyles.disabled,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-placeholder')
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$35c8ae659c390b04$export$2e2bcd8739ae039 = $35c8ae659c390b04$var$Placeholder;


/* single-value.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");


var $f84debfada15a9f2$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syazi7uo",
    disalbed: "_syaz1gmx"
};
var $f84debfada15a9f2$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $f8c6de32f1b21b77$export$26417cabd806a658)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $fjFkG.default)([
            $f84debfada15a9f2$var$styles.root,
            isDisabled && $f84debfada15a9f2$var$styles.disalbed,
            (0, $1f114d76bc1ab81d$export$a274e22fb40f762e)(className, xcss, '-singleValue')
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f84debfada15a9f2$export$2e2bcd8739ae039 = $f84debfada15a9f2$var$SingleValue;


function $3b7b7f3751a34714$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3b7b7f3751a34714$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3b7b7f3751a34714$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3b7b7f3751a34714$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3b7b7f3751a34714$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $d92eac18651b3eb6$export$ecf9cf59142dd54a),
    Control: (0, $8665919ac4a0fd0c$export$2e2bcd8739ae039),
    DropdownIndicator: (0, $ea3507cc624b5bca$export$ec98719d3db7f2e4),
    Group: (0, $d83249d96f66c520$export$2e2bcd8739ae039),
    GroupHeading: (0, $cd92b3927bdd3805$export$85c8b41a3cd87edc),
    IndicatorsContainer: (0, $c4e256eac7ef5e44$export$d0ffd7e649cab6f),
    Input: (0, $af3cd8bd77342c6a$export$2e2bcd8739ae039),
    LoadingIndicator: (0, $9b5194014897b16f$export$7c20be4c1d342248),
    Menu: (0, $701943b1660eb776$export$2e2bcd8739ae039),
    MenuList: (0, $0f1f5577b85c7b6b$export$d4c4e98c5044dc8),
    MenuPortal: (0, $1a0fbf90781368a3$export$793392f970497feb),
    LoadingMessage: (0, $b9b4fb752d208a2b$export$e928a71d039d3102),
    NoOptionsMessage: (0, $8b96d597a244eb84$export$d58b72b7d3c4072c),
    MultiValue: (0, $e7fd529649ea4ccc$export$2e2bcd8739ae039),
    MultiValueContainer: (0, $1ca43377be0bfbff$export$cf9cf2a30a59265c),
    MultiValueLabel: (0, $a820f177b45dbbb4$export$544aeea2a5ce08ee),
    MultiValueRemove: (0, $3330e5c6cc4a5082$export$8e1fd1a40e7a2f4a),
    Option: (0, $6966aa68e6cc290a$export$2e2bcd8739ae039),
    Placeholder: (0, $35c8ae659c390b04$export$2e2bcd8739ae039),
    SelectContainer: (0, $cab10268ea777c5a$export$446eebadefe1123b),
    SingleValue: (0, $f84debfada15a9f2$export$2e2bcd8739ae039),
    ValueContainer: (0, $9775291eefb18560$export$4dc9f58ad9a1a000)
};
var $3b7b7f3751a34714$export$71abc632aa29e6fe = function defaultComponents(props) {
    return $3b7b7f3751a34714$var$_objectSpread($3b7b7f3751a34714$var$_objectSpread({}, $3b7b7f3751a34714$export$9b5ac10f59f76296), props.components);
};


/* dummy-input.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");

var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");
var $5d8f82a9c52a2c27$var$_excluded = [
    "innerRef"
];
var $5d8f82a9c52a2c27$var$removeProps = function removeProps(propsObj) {
    for(var _len = arguments.length, properties = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)properties[_key - 1] = arguments[_key];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $5d8f82a9c52a2c27$var$dummyInputStyles = null;
function $5d8f82a9c52a2c27$export$2e2bcd8739ae039(_ref5) {
    var innerRef = _ref5.innerRef, props = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref5, $5d8f82a9c52a2c27$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = $5d8f82a9c52a2c27$var$removeProps(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ $7fPBF.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        ref: innerRef,
        className: (0, $fjFkG.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d1j28 _syaz1j28 _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ])
    }, filteredProps));
}



var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");
var $3e80fd83f3ef2370$export$a7265767c78f9bae = {
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length ? "option ".concat(label, ", deselected") : '';
            case 'clear':
                return 'All selected options have been cleared.';
            case 'select-option':
                return label.length && !isDisabled ? "option ".concat(label, ", selected.") : '';
            default:
                return '';
        }
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return inputValue ? "".concat(resultsMessage, " for search term ").concat(inputValue, ".") : '';
    }
};


/* a11y-text.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");
// Assistive text to describe visual elements. Hidden for sighted users.
var $4300f475199234d8$var$styles = null;
var $4300f475199234d8$var$A11yText = function A11yText(props) {
    return /*#__PURE__*/ $7fPBF.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $fjFkG.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _uiztglyw _o5721q9c",
            "-a11yText"
        ])
    }, props));
};
var $4300f475199234d8$export$2e2bcd8739ae039 = $4300f475199234d8$var$A11yText;


function $f9ec643cf0e70261$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f9ec643cf0e70261$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f9ec643cf0e70261$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f9ec643cf0e70261$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Root Container
// ==============================
var $f9ec643cf0e70261$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isOptionDisabled = selectProps.isOptionDisabled, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, isLoading = selectProps.isLoading;
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $7fPBF.useMemo)(function() {
        return $f9ec643cf0e70261$var$_objectSpread($f9ec643cf0e70261$var$_objectSpread({}, (0, $3e80fd83f3ef2370$export$a7265767c78f9bae)), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $7fPBF.useMemo)(function() {
        var message = '';
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return '';
            var onChangeProps = $f9ec643cf0e70261$var$_objectSpread({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    var ariaResults = (0, $7fPBF.useMemo)(function() {
        var resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ScreenReaderText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fPBF.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
        id: "aria-results"
    }, ariaResults));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fPBF.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $4300f475199234d8$export$2e2bcd8739ae039), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $4300f475199234d8$export$2e2bcd8739ae039), {
        "aria-live": ariaLive // Should be undefined by default unless a specific use case requires it
        ,
        role: "status"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f9ec643cf0e70261$export$2e2bcd8739ae039 = $f9ec643cf0e70261$var$LiveRegion;



var $8MJe2 = parcelRequire("8MJe2");

var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");


function $0ab6539d641d7604$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0ab6539d641d7604$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0ab6539d641d7604$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0ab6539d641d7604$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0ab6539d641d7604$var$noop = (0, $f48d740006cf3f7d$export$2e2bcd8739ae039);
function $0ab6539d641d7604$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
function $0ab6539d641d7604$var$isDocumentElement(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $0ab6539d641d7604$var$normalizedHeight(el) {
    if ($0ab6539d641d7604$var$isDocumentElement(el)) return window.innerHeight;
    return el.clientHeight;
}
function $0ab6539d641d7604$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($0ab6539d641d7604$var$isDocumentElement(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $0ab6539d641d7604$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $0ab6539d641d7604$var$getScrollTop(el) {
    if ($0ab6539d641d7604$var$isDocumentElement(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $0ab6539d641d7604$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $0ab6539d641d7604$var$noop;
    var start = $0ab6539d641d7604$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $0ab6539d641d7604$var$easeOutCubic(currentTime, start, change, duration);
        $0ab6539d641d7604$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $0ab6539d641d7604$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $0ab6539d641d7604$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $0ab6539d641d7604$var$normalizedHeight(scrollParent);
    var scrollTop = $0ab6539d641d7604$var$getScrollTop(scrollParent);
    var menuTopFromParent = menuTop;
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTopFromParent;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $0ab6539d641d7604$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $0ab6539d641d7604$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $0ab6539d641d7604$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $0ab6539d641d7604$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $0ab6539d641d7604$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
var $0ab6539d641d7604$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
// NOTE: internal only
// eslint-disable-next-line @repo/internal/react/require-jsdoc
// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Menu placer__
 *
 * A menu placer {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ var $0ab6539d641d7604$var$MenuPlacer = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView;
    var _ref2 = (0, $7fPBF.useContext)((0, $54dee0294add7ccc$export$e001f626511a0ead)) || {}, setPortalPlacement = _ref2.setPortalPlacement;
    var ref = (0, $7fPBF.useRef)(null);
    var _useState = (0, $7fPBF.useState)(maxMenuHeight), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    // The minimum height of the control
    var controlHeight = 38;
    (0, $7fPBF.useLayoutEffect)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $0ab6539d641d7604$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: $0ab6539d641d7604$var$_objectSpread($0ab6539d641d7604$var$_objectSpread({}, props), {}, {
            placement: placement || $0ab6539d641d7604$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $0ab6539d641d7604$export$2e2bcd8739ae039 = $0ab6539d641d7604$var$MenuPlacer;



var $8MJe2 = parcelRequire("8MJe2");
var $859f0395401445ad$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $859f0395401445ad$var$isEqual(first, second) {
    if (first === second) return true;
    if ($859f0395401445ad$var$safeIsNaN(first) && $859f0395401445ad$var$safeIsNaN(second)) return true;
    return false;
}
function $859f0395401445ad$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$859f0395401445ad$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $859f0395401445ad$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $859f0395401445ad$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}


var $06939dd157d102ec$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $06939dd157d102ec$var$anyDiacritic = new RegExp('[' + $06939dd157d102ec$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $06939dd157d102ec$var$diacriticToBase = {};
for(var $06939dd157d102ec$var$i = 0; $06939dd157d102ec$var$i < $06939dd157d102ec$var$diacritics.length; $06939dd157d102ec$var$i++){
    var $06939dd157d102ec$var$diacritic = $06939dd157d102ec$var$diacritics[$06939dd157d102ec$var$i];
    for(var $06939dd157d102ec$var$j = 0; $06939dd157d102ec$var$j < $06939dd157d102ec$var$diacritic.letters.length; $06939dd157d102ec$var$j++)$06939dd157d102ec$var$diacriticToBase[$06939dd157d102ec$var$diacritic.letters[$06939dd157d102ec$var$j]] = $06939dd157d102ec$var$diacritic.base;
}
var $06939dd157d102ec$export$b5bee4b27048330b = function stripDiacritics(str) {
    return str.replace($06939dd157d102ec$var$anyDiacritic, function(match) {
        return $06939dd157d102ec$var$diacriticToBase[match];
    });
};


function $186eac41796e35cc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $186eac41796e35cc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $186eac41796e35cc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $186eac41796e35cc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $186eac41796e35cc$var$memoizedStripDiacriticsForInput = (0, $859f0395401445ad$export$2e2bcd8739ae039)((0, $06939dd157d102ec$export$b5bee4b27048330b));
var $186eac41796e35cc$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $186eac41796e35cc$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $186eac41796e35cc$export$5d81789ff4aeccdf = function createFilter(config) {
    return function(option, rawInput) {
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = $186eac41796e35cc$var$_objectSpread({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $186eac41796e35cc$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $186eac41796e35cc$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $186eac41796e35cc$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $186eac41796e35cc$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $06939dd157d102ec$export$b5bee4b27048330b)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};


/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $153cefd289b79580$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $153cefd289b79580$export$ce4ab0c55987d1ff(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($153cefd289b79580$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}



var $bRUy3 = parcelRequire("bRUy3");
var $c1ffbe9903ad0d82$export$33f062f47f21a01 = function cleanValue(value) {
    if (Array.isArray(value)) return value.filter(Boolean);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};


function $6d81a067909cc4a0$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}


function $42f32144bedc8c4e$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $a11b2f5cc98a750d$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $d325ee56965454b6$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $7fPBF.createContext)(null);


function $43314d593e5da9cc$export$1d57e79091cc3046() {
    var namespace = (0, $7fPBF.useContext)((0, $d325ee56965454b6$export$644a49f3b8c50fcd));
    return namespace;
}


function $e85233b93e6c09f0$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $7fPBF.useContext)((0, $a11b2f5cc98a750d$export$5fbf4d7fae6cdc00));
    var namespace = (0, $43314d593e5da9cc$export$1d57e79091cc3046)();
    (0, $7fPBF.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}


function $5e2935f663489ac3$export$17baa7c95b6ba1b8(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose;
    // @ts-ignore - hot-116676
    (0, $e85233b93e6c09f0$export$469bb693f11edc7f)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}


/* required-input.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $fjFkG = parcelRequire("fjFkG");

var $738cbf7026ecedd5$var$styles = null;
var $738cbf7026ecedd5$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return /*#__PURE__*/ $7fPBF.createElement("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        className: (0, $fjFkG.default)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $f48d740006cf3f7d$export$2e2bcd8739ae039)
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$738cbf7026ecedd5$export$2e2bcd8739ae039 = $738cbf7026ecedd5$var$RequiredInput;



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
// ==============================
// Passive Event Detector
// ==============================

var $249b8bcc377d18c6$var$noop = (0, $f48d740006cf3f7d$export$2e2bcd8739ae039);
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $249b8bcc377d18c6$var$passiveOptionAccessed = false;
var $249b8bcc377d18c6$var$options = {
    get passive () {
        return $249b8bcc377d18c6$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $249b8bcc377d18c6$var$w = typeof window !== 'undefined' ? window : {};
if ($249b8bcc377d18c6$var$w.addEventListener && $249b8bcc377d18c6$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $249b8bcc377d18c6$var$w.addEventListener('p', $249b8bcc377d18c6$var$noop, $249b8bcc377d18c6$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $249b8bcc377d18c6$var$w.removeEventListener('p', $249b8bcc377d18c6$var$noop, false);
}
var $249b8bcc377d18c6$export$b0622a6911dbeaf5 = $249b8bcc377d18c6$var$passiveOptionAccessed;


var $8319ccb8f4fd6c2c$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $8319ccb8f4fd6c2c$export$2e2bcd8739ae039(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $7fPBF.useRef)(false);
    var isTop = (0, $7fPBF.useRef)(false);
    var touchStart = (0, $7fPBF.useRef)(0);
    var scrollTarget = (0, $7fPBF.useRef)(null);
    var handleEventDelta = (0, $7fPBF.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $8319ccb8f4fd6c2c$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $7fPBF.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $7fPBF.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $7fPBF.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $7fPBF.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $249b8bcc377d18c6$export$b0622a6911dbeaf5) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $7fPBF.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $7fPBF.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}



var $7fPBF = parcelRequire("7fPBF");
var $07925351a60024c3$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $07925351a60024c3$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $07925351a60024c3$var$preventTouchMove(e) {
    e.preventDefault();
}
function $07925351a60024c3$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $07925351a60024c3$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $07925351a60024c3$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $07925351a60024c3$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $07925351a60024c3$var$activeScrollLocks = 0;
var $07925351a60024c3$var$listenerOptions = {
    capture: false,
    passive: false
};
function $07925351a60024c3$export$2e2bcd8739ae039(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $7fPBF.useRef)({});
    var scrollTarget = (0, $7fPBF.useRef)(null);
    var addScrollLock = (0, $7fPBF.useCallback)(function(touchScrollTarget) {
        if (!$07925351a60024c3$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $07925351a60024c3$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $07925351a60024c3$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($07925351a60024c3$var$LOCK_STYLES).forEach(function(key) {
                var val = $07925351a60024c3$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $07925351a60024c3$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $07925351a60024c3$var$preventTouchMove, $07925351a60024c3$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $07925351a60024c3$var$preventInertiaScroll, $07925351a60024c3$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $07925351a60024c3$var$allowTouchMove, $07925351a60024c3$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $07925351a60024c3$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $7fPBF.useCallback)(function(touchScrollTarget) {
        if (!$07925351a60024c3$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $07925351a60024c3$var$activeScrollLocks = Math.max($07925351a60024c3$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $07925351a60024c3$var$activeScrollLocks < 1) $07925351a60024c3$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $07925351a60024c3$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $07925351a60024c3$var$preventTouchMove, $07925351a60024c3$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $07925351a60024c3$var$preventInertiaScroll, $07925351a60024c3$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $07925351a60024c3$var$allowTouchMove, $07925351a60024c3$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $7fPBF.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}


var $d4a7a8f607624fe0$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $d4a7a8f607624fe0$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = (0, $8319ccb8f4fd6c2c$export$2e2bcd8739ae039)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = (0, $07925351a60024c3$export$2e2bcd8739ae039)({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fPBF.Fragment), null, lockEnabled && /*#__PURE__*/ // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        onClick: $d4a7a8f607624fe0$var$blurSelectInput,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            position: 'fixed',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockStart: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineStart: 0
        }
    }), children(targetRef));
}



function $6afd59b4f1368377$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ((0, $6d81a067909cc4a0$export$d8a62a489b442872)(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}


function $8313d98b7904aaaa$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}


function $3207579bc2f8f92e$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}


function $c647738a411ac32c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c647738a411ac32c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c647738a411ac32c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c647738a411ac32c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c647738a411ac32c$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eihxX)))(t, $c647738a411ac32c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(t).constructor) : o.apply(t, e));
}
function $c647738a411ac32c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c647738a411ac32c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $c647738a411ac32c$var$noop = (0, $f48d740006cf3f7d$export$2e2bcd8739ae039);
function $c647738a411ac32c$var$notNullish(item) {
    return item != null;
}
function $c647738a411ac32c$var$scrollIntoView(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) (0, $6afd59b4f1368377$export$3f99968195accfaf)(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) (0, $6afd59b4f1368377$export$3f99968195accfaf)(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $c647738a411ac32c$var$isMobileDevice() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (_unused) {
        return false;
    }
}
function $c647738a411ac32c$var$isTouchCapable() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (_unused2) {
        return false;
    }
}
/**
 * Filters out unsupported selectors (e.g., pseudo-classes, complex selectors) from a styles object.
 * @param styles - The styles object to filter.
 * @returns A new object containing only supported styles.
 */ var $c647738a411ac32c$var$filterUnsupportedSelectors = function filterUnsupportedSelectors(styles) {
    var unsupportedSelectors = [
        ':',
        // pseudo-classes/elements
        '[',
        // attribute selectors
        '>',
        // child combinator
        '+',
        // adjacent sibling combinator
        '~',
        // general sibling combinator
        ' ',
        // descendant combinator
        '*',
        // universal selector
        '#',
        // ID selector
        '.',
        // class selector
        '@',
        // at-rules
        '&',
        // parent selector
        '|',
        // namespace separator
        '^',
        // starts with
        '$',
        // ends with
        '=' // equals
    ];
    return Object.keys(styles).reduce(function(filteredStyles, key) {
        if (!unsupportedSelectors.some(function(selector) {
            return key.includes(selector);
        })) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};
var $c647738a411ac32c$var$elemBeforeCSS = null;
var $c647738a411ac32c$export$9c21a3269931e1e6 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: $c647738a411ac32c$var$isTouchCapable(),
    captureMenuScroll: !$c647738a411ac32c$var$isTouchCapable(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $186eac41796e35cc$export$5d81789ff4aeccdf)(),
    formatGroupLabel: (0, $678ac190e9b31be7$export$f4da216a6ca54656),
    getOptionLabel: (0, $e793d8dc95029c13$export$dac6ace3020563ca),
    getOptionValue: (0, $175922ddf6c67fc6$export$40be908210c5a79c),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $2beb7490e14357df$export$56bd0c8d90db075),
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !$c647738a411ac32c$var$isMobileDevice(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    shouldPreventEscapePropagation: false,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false
};
function $c647738a411ac32c$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $c647738a411ac32c$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $c647738a411ac32c$var$_isOptionSelected(props, option, selectValue);
    var label = $c647738a411ac32c$var$getOptionLabel(props, option);
    var value = $c647738a411ac32c$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $c647738a411ac32c$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        //@ts-ignore
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $c647738a411ac32c$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $c647738a411ac32c$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $c647738a411ac32c$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $c647738a411ac32c$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter($c647738a411ac32c$var$notNullish);
}
function $c647738a411ac32c$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $c647738a411ac32c$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $c647738a411ac32c$var$buildFocusableOptions(props, selectValue) {
    return $c647738a411ac32c$var$buildFocusableOptionsFromCategorizedOptions($c647738a411ac32c$var$buildCategorizedOptions(props, selectValue));
}
function $c647738a411ac32c$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$c647738a411ac32c$var$shouldHideSelectedOptions(props) || !isSelected) && $c647738a411ac32c$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $c647738a411ac32c$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $c647738a411ac32c$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $c647738a411ac32c$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $c647738a411ac32c$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $c647738a411ac32c$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $c647738a411ac32c$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $c647738a411ac32c$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $c647738a411ac32c$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $c647738a411ac32c$var$getOptionValue(props, i) === candidate;
    });
}
function $c647738a411ac32c$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $c647738a411ac32c$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $c647738a411ac32c$var$instanceId = 1;
// eslint-disable-next-line @repo/internal/react/no-class-components
var $c647738a411ac32c$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, Select);
        _this = $c647738a411ac32c$var$_callSuper(this, Select, [
            _props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "state", {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        });
        // Misc. Instance Properties
        // ------------------------------
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "blockOptionHover", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "isComposing", false);
        // TODO
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "initialTouchX", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "initialTouchY", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "openAfterFocus", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "scrollToFocusedOptionOnUpdate", false);
        // Refs
        // ------------------------------
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "controlRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getControlRef", function(ref) {
            _this.controlRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "focusedOptionRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getFocusedOptionRef", function(ref) {
            _this.focusedOptionRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "menuListRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getMenuListRef", function(ref) {
            _this.menuListRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "inputRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getInputRef", function(ref) {
            _this.inputRef = ref;
        });
        // aliased for consumers
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "focus", _this.focusInput);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "blur", _this.blurInput);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onChange", function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "setValue", function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "selectOption", function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $42f32144bedc8c4e$export$d1ca752ec761b95b)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $42f32144bedc8c4e$export$d1ca752ec761b95b)([].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $8313d98b7904aaaa$export$dea4763e29237f4c)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $8313d98b7904aaaa$export$dea4763e29237f4c)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "removeValue", function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $3207579bc2f8f92e$export$40fb9515c784cc3b)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "clearValue", function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $3207579bc2f8f92e$export$40fb9515c784cc3b)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "popValue", function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $3207579bc2f8f92e$export$40fb9515c784cc3b)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        });
        // ==============================
        // Getters
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getFocusedOptionId", function(focusedOption) {
            return $c647738a411ac32c$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getFocusableOptionsWithIds", function() {
            return $c647738a411ac32c$var$buildFocusableOptionsWithIds($c647738a411ac32c$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getValue", function() {
            return _this.state.selectValue;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "cx", function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $153cefd289b79580$export$ce4ab0c55987d1ff).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getOptionLabel", function(data) {
            return $c647738a411ac32c$var$getOptionLabel(_this.props, data);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getOptionValue", function(data) {
            return $c647738a411ac32c$var$getOptionValue(_this.props, data);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getStyles", function(key, props) {
            var base = {
                boxSizing: 'border-box'
            };
            var custom = _this.props.styles[key];
            if (custom) return $c647738a411ac32c$var$filterUnsupportedSelectors(custom(base, props));
            return base;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getClassNames", function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getElementId", function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getComponents", function() {
            return (0, $3b7b7f3751a34714$export$71abc632aa29e6fe)(_this.props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "buildCategorizedOptions", function() {
            return $c647738a411ac32c$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getCategorizedOptions", function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "buildFocusableOptions", function() {
            return $c647738a411ac32c$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getFocusableOptions", function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        });
        // ==============================
        // Helpers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "ariaOnChange", function(value, actionMeta) {
            _this.setState({
                ariaSelection: $c647738a411ac32c$var$_objectSpread({
                    value: value
                }, actionMeta)
            });
        });
        // ==============================
        // Mouse Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onMenuMouseDown", function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onMenuMouseMove", function(_) {
            _this.blockOptionHover = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onControlMouseDown", function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                var _this$controlRef;
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!((_this$controlRef = _this.controlRef) !== null && _this$controlRef !== void 0 && _this$controlRef.closest('[data-rbd-draggable-context-id]'))) return;
            }
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onDropdownIndicatorMouseDown", function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onClearIndicatorMouseDown", function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onScroll", function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $6d81a067909cc4a0$export$d8a62a489b442872)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onCompositionStart", function() {
            _this.isComposing = true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onCompositionEnd", function() {
            _this.isComposing = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onTouchStart", function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onTouchMove", function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onControlTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onClearIndicatorTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onDropdownIndicatorTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        });
        // ==============================
        // Focus Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "handleInputChange", function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onInputFocus", function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onInputBlur", function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            if ((0, $137Lh.fg)('platform_dst_select_menu_close_on_blur')) // when fg is enabled, we only call onMenuClose when this.props.menuIsOpen is true.
            _this.props.menuIsOpen && _this.onMenuClose();
            else _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onOptionHover", function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "shouldHideSelectedOptions", function() {
            return $c647738a411ac32c$var$shouldHideSelectedOptions(_this.props);
        });
        // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onValueInputFocus", function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        });
        // ==============================
        // Keyboard Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "onKeyDown", function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus, shouldPreventEscapePropagation = _this$props5.shouldPreventEscapePropagation;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) _this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                        if (shouldPreventEscapePropagation && event.target instanceof HTMLElement) event.stopPropagation();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "handleOpenLayerObserverCloseSignal", function() {
            _this.onMenuClose();
        });
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$c647738a411ac32c$var$instanceId);
        _this.state.selectValue = (0, $c1ffbe9903ad0d82$export$33f062f47f21a01)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $c647738a411ac32c$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($l8Sa3)))(Select, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) $c647738a411ac32c$var$scrollIntoView(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    $c647738a411ac32c$var$scrollIntoView(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                var focusedOption = focusableOptions[openAtIndex];
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusedOption,
                    focusedOptionId: this.getFocusedOptionId(focusedOption)
                }, function() {
                    return _this2.onMenuOpen();
                });
                (0, $bf96b6408e362ed6$export$95df08bae54cb4df)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
            }
        },
        {
            key: "updateInputLabel",
            value: function updateInputLabel(inputLabel) {
                var _this3 = this;
                if (inputLabel) {
                    var _this$inputRef;
                    (_this$inputRef = this.inputRef) === null || _this$inputRef === void 0 || _this$inputRef.setAttribute('aria-label', inputLabel);
                    setTimeout(function() {
                        var normalizedLabel = _this3.props['aria-label'] || _this3.props.label;
                        if (normalizedLabel) {
                            var _this3$inputRef;
                            (_this3$inputRef = _this3.inputRef) === null || _this3$inputRef === void 0 || _this3$inputRef.setAttribute('aria-label', normalizedLabel);
                        } else {
                            var _this3$inputRef2;
                            (_this3$inputRef2 = _this3.inputRef) === null || _this3$inputRef2 === void 0 || _this3$inputRef2.removeAttribute('aria-label');
                        }
                    }, 500);
                }
            }
        },
        {
            key: "calculateInputLabel",
            value: function calculateInputLabel(focusedOption, optionIndex) {
                var _this4 = this;
                var options = this.props.options;
                var isOptionsGrouped = options === null || options === void 0 ? void 0 : options.every(function(obj) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(obj) === 'object' && obj !== null && 'options' in obj;
                });
                var inputLabel = this.getOptionLabel(focusedOption);
                var isOptionFocused = function isOptionFocused(option) {
                    return _this4.getOptionLabel(option) === inputLabel;
                };
                var groupData = options === null || options === void 0 ? void 0 : options.find(function(option) {
                    var _groupCandidate$optio, _groupCandidate$optio2;
                    var groupCandidate = option;
                    return (_groupCandidate$optio = (_groupCandidate$optio2 = groupCandidate.options) === null || _groupCandidate$optio2 === void 0 ? void 0 : _groupCandidate$optio2.some(isOptionFocused)) !== null && _groupCandidate$optio !== void 0 ? _groupCandidate$optio : false;
                });
                if (isOptionsGrouped) {
                    var _groupData$options$fi;
                    var groupOptionIndex = (_groupData$options$fi = groupData === null || groupData === void 0 ? void 0 : groupData.options.findIndex(isOptionFocused)) !== null && _groupData$options$fi !== void 0 ? _groupData$options$fi : 0;
                    var totalLength = options === null || options === void 0 ? void 0 : options.reduce(function(acc, currentGroup) {
                        var _group$options;
                        var group = currentGroup;
                        acc += group === null || group === void 0 || (_group$options = group.options) === null || _group$options === void 0 ? void 0 : _group$options.length;
                        return acc;
                    }, 0);
                    inputLabel = "".concat(inputLabel, ", ").concat(groupData === null || groupData === void 0 ? void 0 : groupData.label, " (").concat(groupOptionIndex + 1, " of ").concat(totalLength, ")");
                } else inputLabel = "".concat(inputLabel, " (").concat(optionIndex + 1, " of ").concat(options === null || options === void 0 ? void 0 : options.length, ")");
                return inputLabel;
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus],
                    focusedValueId: "".concat(this.getElementId('selected-value'), "-").concat(nextFocus, "-remove"),
                    focusedOption: null,
                    focusedOptionId: null
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedValueId: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $c647738a411ac32c$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $c647738a411ac32c$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $c647738a411ac32c$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                var _this$props$component;
                if (typeof this.props.formatOptionLabel === 'function') {
                    var inputValue = this.props.inputValue;
                    var selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: inputValue,
                        selectValue: selectValue
                    });
                }
                // Auto-render elemBefore in dropdown menu only if formatOptionLabel is not provided
                // and no custom Option component is provided (custom Option components may already
                // render elemBefore themselves, causing it to appear twice)
                if (context === 'menu' && !this.props.formatOptionLabel && !((_this$props$component = this.props.components) !== null && _this$props$component !== void 0 && _this$props$component.Option) && (0, $137Lh.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
                    var elemBefore = data.elemBefore;
                    if (elemBefore) {
                        var label = this.getOptionLabel(data);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                            className: (0, $fjFkG.default)([
                                "_zulpu2gc _1e0c1txw _4cvr1h6o"
                            ])
                        }, elemBefore, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", null, label));
                    }
                }
                return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "calculateDescription",
            value: function calculateDescription() {
                var descriptionProp = this.props['aria-describedby'] || this.props.descriptionId;
                var isMulti = this.props.isMulti;
                var hasValue = this.state.selectValue.length > 0;
                // Determine base description based on selection state
                var baseDescriptionId = hasValue ? isMulti ? '' : this.getElementId('single-value') : this.getElementId('placeholder');
                // Fast path for single select with no description prop
                if (!isMulti && !descriptionProp) return {
                    'aria-describedby': baseDescriptionId
                };
                // Build the describedby string efficiently
                var describedBy = baseDescriptionId;
                // Add description prop if it exists
                if (descriptionProp) describedBy = describedBy ? "".concat(descriptionProp, " ").concat(describedBy) : descriptionProp;
                // For multi-select, always add multi-message ID
                if (isMulti) {
                    var multiMessage = this.getElementId('multi-message');
                    describedBy = describedBy ? "".concat(describedBy, " ").concat(multiMessage) : multiMessage;
                }
                return {
                    'aria-describedby': describedBy
                };
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchstart', this.onTouchStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchmove', this.onTouchMove);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, form = _this$props8.form, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, isDisabled = _this$props8.isDisabled, isInvalid = _this$props8.isInvalid, isRequired = _this$props8.isRequired, isSearchable = _this$props8.isSearchable, label = _this$props8.label, labelId = _this$props8.labelId, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required, _this$props8$tabIndex = _this$props8.tabIndex, tabIndex = _this$props8$tabIndex === void 0 ? 0 : _this$props8$tabIndex, testId = _this$props8.testId;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var inputIsHidden = this.state.inputIsHidden;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = $c647738a411ac32c$var$_objectSpread($c647738a411ac32c$var$_objectSpread($c647738a411ac32c$var$_objectSpread($c647738a411ac32c$var$_objectSpread({}, !this.props.isSearchable && (0, $137Lh.fg)('platform_fix_autocomplete_aria_for_select') ? {} : {
                    'aria-autocomplete': 'both'
                }), {}, {
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-expanded': menuIsOpen,
                    // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
                    'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                    'aria-invalid': this.props['aria-invalid'] || isInvalid,
                    'aria-label': this.props['aria-label'] || label,
                    'aria-labelledby': this.props['aria-labelledby'] || labelId,
                    'aria-required': required || isRequired,
                    role: 'combobox',
                    'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && !(0, $137Lh.fg)('select_issearchable_aria-readonly_fix') && {
                    'aria-readonly': true
                }), this.calculateDescription());
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $5d8f82a9c52a2c27$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: $c647738a411ac32c$var$noop,
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: "",
                    "data-testid": testId && "".concat(testId, "-select--input")
                }, ariaAttributes));
                // NOTE: Don't add the `name` prop to this Input, `name` is already a prop on the hidden input element that has the value of the select.
                // Adding `name` to this Input will cause unexpected behavior.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Input, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    testId: testId,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this5 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder, testId = _this$props9.testId;
                var _this$state4 = this.state, selectValue = _this$state4.selectValue, focusedValue = _this$state4.focusedValue, isFocused = _this$state4.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Placeholder, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: $c647738a411ac32c$var$_objectSpread({
                        id: this.getElementId('placeholder')
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--placeholder")
                    })
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this5.getOptionLabel(opt), "-").concat(_this5.getOptionValue(opt));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(MultiValue, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: $c647738a411ac32c$var$_objectSpread($c647738a411ac32c$var$_objectSpread({
                            onClick: function onClick() {
                                return _this5.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this5.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        }, testId && {
                            'data-testid': "".concat(testId, "-select--multivalue-").concat(index, "-remove")
                        }), {}, {
                            id: "".concat(_this5.getElementId('selected-value'), "-").concat(index, "-remove")
                        }),
                        data: opt,
                        innerProps: $c647738a411ac32c$var$_objectSpread($c647738a411ac32c$var$_objectSpread({}, testId && {
                            'data-testid': "".concat(testId, "-select--multivalue-").concat(index)
                        }), {}, {
                            id: "".concat(_this5.getElementId('selected-value'), "-").concat(index)
                        })
                    }), _this5.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(SingleValue, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled,
                    innerProps: {
                        id: this.getElementId('single-value')
                    }
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props0 = this.props, clearControlLabel = _this$props0.clearControlLabel, isDisabled = _this$props0.isDisabled, isLoading = _this$props0.isLoading, spacing = _this$props0.spacing, testId = _this$props0.testId;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = $c647738a411ac32c$var$_objectSpread({
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd
                }, testId && {
                    'data-testid': "".concat(testId, "-select--clear-indicator")
                });
                var isCompact = spacing === 'compact';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(ClearIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
                    clearControlLabel: clearControlLabel
                }, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props1 = this.props, isDisabled = _this$props1.isDisabled, isLoading = _this$props1.isLoading, spacing = _this$props1.spacing, testId = _this$props1.testId;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var isCompact = spacing === 'compact';
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(LoadingIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
                    "data-testid": testId && "".concat(testId, "-select--loading-indicator")
                }, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, spacing = _this$props10.spacing, testId = _this$props10.testId;
                var isFocused = this.state.isFocused;
                var isCompact = spacing === 'compact';
                var innerProps = $c647738a411ac32c$var$_objectSpread({
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                }, testId && {
                    'data-testid': "".concat(testId, "-select--dropdown-indicator")
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(DropdownIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this6 = this;
                var _this$getComponents6 = this.getComponents(), Group = _this$getComponents6.Group, GroupHeading = _this$getComponents6.GroupHeading, Menu = _this$getComponents6.Menu, MenuList = _this$getComponents6.MenuList, MenuPortal = _this$getComponents6.MenuPortal, LoadingMessage = _this$getComponents6.LoadingMessage, NoOptionsMessage = _this$getComponents6.NoOptionsMessage, Option = _this$getComponents6.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props11 = this.props, captureMenuScroll = _this$props11.captureMenuScroll, inputValue = _this$props11.inputValue, isLoading = _this$props11.isLoading, loadingMessage = _this$props11.loadingMessage, minMenuHeight = _this$props11.minMenuHeight, maxMenuHeight = _this$props11.maxMenuHeight, menuIsOpen = _this$props11.menuIsOpen, menuPlacement = _this$props11.menuPlacement, menuPosition = _this$props11.menuPosition, menuPortalTarget = _this$props11.menuPortalTarget, menuShouldBlockScroll = _this$props11.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props11.menuShouldScrollIntoView, noOptionsMessage = _this$props11.noOptionsMessage, onMenuScrollToTop = _this$props11.onMenuScrollToTop, onMenuScrollToBottom = _this$props11.onMenuScrollToBottom, testId = _this$props11.testId;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id, headingId) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this6.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this6.selectOption(data);
                    };
                    var optionId = "".concat(_this6.getElementId('option'), "-").concat(id);
                    var innerProps = $c647738a411ac32c$var$_objectSpread({
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        role: _this6.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                        'aria-selected': _this6.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                        // We don't want aria-disabled if it's false. It's just noisy.
                        'aria-disabled': !isDisabled ? undefined : isDisabled,
                        'aria-describedby': headingId
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--option-").concat(id)
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Option, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this6.getFocusedOptionRef : undefined
                    }), _this6.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) {
                    var items = this.getCategorizedOptions();
                    menuUI = items.map(function(item) {
                        if (item.type === 'group') {
                            var data = item.data, options = item.options, groupIndex = item.index;
                            var groupId = "".concat(_this6.getElementId('group'), "-").concat(groupIndex);
                            var headingId = "".concat(groupId, "-heading");
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Group, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, commonProps, {
                                key: groupId,
                                data: data,
                                options: options,
                                Heading: GroupHeading,
                                headingProps: $c647738a411ac32c$var$_objectSpread({
                                    id: headingId,
                                    data: item.data
                                }, testId && {
                                    'data-testid': "".concat(testId, "-select--group-").concat(groupIndex, "-heading")
                                }),
                                label: _this6.formatGroupLabel(item.data)
                            }), item.options.map(function(option) {
                                return render(option, "".concat(groupIndex, "-").concat(option.index), headingId);
                            }));
                        } else if (item.type === 'option') return render(item, "".concat(item.index));
                        return undefined;
                    });
                } else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(NoOptionsMessage, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, commonProps, {
                        innerProps: $c647738a411ac32c$var$_objectSpread($c647738a411ac32c$var$_objectSpread({}, this.props['UNSAFE_is_experimental_generic'] && {
                            role: 'listitem'
                        }), testId && {
                            'data-testid': "".concat(testId, "-select--no-options")
                        })
                    }), _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $0ab6539d641d7604$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Menu, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: $c647738a411ac32c$var$_objectSpread({
                            onMouseDown: _this6.onMenuMouseDown,
                            onMouseMove: _this6.onMenuMouseMove,
                            id: _this6.props.components.Menu ? _this6.getElementId('listbox') : undefined
                        }, testId && {
                            'data-testid': "".concat(testId, "-select--listbox-container")
                        }),
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d4a7a8f607624fe0$export$2e2bcd8739ae039), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        var _this6$inputRef, _this6$inputRef2;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(MenuList, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this6.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: $c647738a411ac32c$var$_objectSpread($c647738a411ac32c$var$_objectSpread($c647738a411ac32c$var$_objectSpread({
                                role: _this6.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox'
                            }, _this6.props['UNSAFE_is_experimental_generic'] && {
                                'aria-labelledby': ((_this6$inputRef = _this6.inputRef) === null || _this6$inputRef === void 0 ? void 0 : _this6$inputRef.id) || _this6.getElementId('input')
                            }), {}, {
                                'aria-multiselectable': !commonProps.isMulti || _this6.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                id: _this6.getElementId('listbox')
                            }, testId && {
                                'data-testid': "".concat(testId, "-select--listbox")
                            }), (0, $bf96b6408e362ed6$export$95df08bae54cb4df)() && !_this6.props['UNSAFE_is_experimental_generic'] && {
                                'aria-describedby': ((_this6$inputRef2 = _this6.inputRef) === null || _this6$inputRef2 === void 0 ? void 0 : _this6$inputRef2.id) || _this6.getElementId('input')
                            }),
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), _this6.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                            role: "list"
                        }, menuUI) : menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(MenuPortal, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this7 = this;
                var _this$props12 = this.props, delimiter = _this$props12.delimiter, isDisabled = _this$props12.isDisabled, isMulti = _this$props12.isMulti, required = _this$props12.required, name = _this$props12.name;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $738cbf7026ecedd5$export$2e2bcd8739ae039), {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this7.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this7.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state5 = this.state, ariaSelection = _this$state5.ariaSelection, isFocused = _this$state5.isFocused, selectValue = _this$state5.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $f9ec643cf0e70261$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "renderMultiselectMessage",
            value: function renderMultiselectMessage() {
                // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
                // Also, since this is rendered onscreen, it should be transtlated automatically.
                var msg = ", multiple selections available, ".concat(this.state.selectValue.length ? 'Use left or right arrow keys to navigate selected items' : '');
                return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
                (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                    id: this.getElementId('multi-message'),
                    hidden: true
                }, msg));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents7 = this.getComponents(), Control = _this$getComponents7.Control, IndicatorsContainer = _this$getComponents7.IndicatorsContainer, SelectContainer = _this$getComponents7.SelectContainer, ValueContainer = _this$getComponents7.ValueContainer;
                var _this$props13 = this.props, className = _this$props13.className, id = _this$props13.id, isDisabled = _this$props13.isDisabled, menuIsOpen = _this$props13.menuIsOpen, isInvalid = _this$props13.isInvalid, testId = _this$props13.testId, _this$props13$appeara = _this$props13.appearance, appearance = _this$props13$appeara === void 0 ? 'default' : _this$props13$appeara, _this$props13$spacing = _this$props13.spacing, spacing = _this$props13$spacing === void 0 ? 'default' : _this$props13$spacing;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                var isCompact = spacing === 'compact';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(SelectContainer, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, commonProps, {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                    className: className,
                    innerProps: $c647738a411ac32c$var$_objectSpread({
                        id: id,
                        onKeyDown: this.onKeyDown
                    }, testId && {
                        'data-testid': testId && "".concat(testId, "-select--container")
                    }),
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), commonProps.isMulti && this.renderMultiselectMessage(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Control, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: $c647738a411ac32c$var$_objectSpread({
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--control")
                    }),
                    appearance: appearance,
                    isInvalid: isInvalid,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen,
                    isCompact: isCompact
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(ValueContainer, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, commonProps, {
                    isDisabled: isDisabled,
                    isCompact: isCompact,
                    innerProps: $c647738a411ac32c$var$_objectSpread($c647738a411ac32c$var$_objectSpread({}, testId && {
                        'data-testid': "".concat(testId, "-select--value-container")
                    }), commonProps.isMulti && commonProps.hasValue && !(0, $40c181de46002bdb$export$e1865c3bedcd822b)() && {
                        // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                        // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                        // DST Accessibility.
                        role: 'application'
                    })
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(IndicatorsContainer, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, commonProps, {
                    isDisabled: isDisabled,
                    innerProps: $c647738a411ac32c$var$_objectSpread({}, testId && {
                        'data-testid': "".concat(testId, "-select--indicators-container")
                    })
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $5e2935f663489ac3$export$17baa7c95b6ba1b8), {
                    isOpen: this.props.menuIsOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                }));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $c1ffbe9903ad0d82$export$33f062f47f21a01)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $c647738a411ac32c$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $c647738a411ac32c$var$buildFocusableOptionsWithIds($c647738a411ac32c$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $c647738a411ac32c$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $c647738a411ac32c$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $c647738a411ac32c$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $3207579bc2f8f92e$export$40fb9515c784cc3b)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return $c647738a411ac32c$var$_objectSpread($c647738a411ac32c$var$_objectSpread($c647738a411ac32c$var$_objectSpread({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
}((0, $7fPBF.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($c647738a411ac32c$export$2e2bcd8739ae039, "defaultProps", $c647738a411ac32c$export$9c21a3269931e1e6);



var $8MJe2 = parcelRequire("8MJe2");

var $iKdEz = parcelRequire("iKdEz");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");
var $d3b27b3269bc4670$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $d3b27b3269bc4670$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d3b27b3269bc4670$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d3b27b3269bc4670$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d3b27b3269bc4670$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d3b27b3269bc4670$var$handleInputChange(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $d3b27b3269bc4670$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions, propsOptions = _ref.options, _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $d3b27b3269bc4670$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $7fPBF.useRef)(undefined);
    var mounted = (0, $7fPBF.useRef)(false);
    var _useState = (0, $7fPBF.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : ''), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $7fPBF.useState)(propsDefaultOptions === true), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $7fPBF.useState)(undefined), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $7fPBF.useState)([]), _useState0 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState9, 2), loadedOptions = _useState0[0], setLoadedOptions = _useState0[1];
    var _useState1 = (0, $7fPBF.useState)(false), _useState10 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState1, 2), passEmptyOptions = _useState10[0], setPassEmptyOptions = _useState10[1];
    var _useState11 = (0, $7fPBF.useState)({}), _useState12 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState11, 2), optionsCache = _useState12[0], setOptionsCache = _useState12[1];
    var _useState13 = (0, $7fPBF.useState)(undefined), _useState14 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState13, 2), prevDefaultOptions = _useState14[0], setPrevDefaultOptions = _useState14[1];
    var _useState15 = (0, $7fPBF.useState)(undefined), _useState16 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState15, 2), prevCacheOptions = _useState16[0], setPrevCacheOptions = _useState16[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $7fPBF.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $7fPBF.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $7fPBF.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $7fPBF.useCallback)(function(newValue, actionMeta) {
        var inputValue = $d3b27b3269bc4670$var$handleInputChange(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? $d3b27b3269bc4670$var$_objectSpread($d3b27b3269bc4670$var$_objectSpread({}, optionsCache), {}, (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return $d3b27b3269bc4670$var$_objectSpread($d3b27b3269bc4670$var$_objectSpread({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}



var $8MJe2 = parcelRequire("8MJe2");

var $iKdEz = parcelRequire("iKdEz");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");
var $f8fa064e8c7bf643$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $f8fa064e8c7bf643$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f8fa064e8c7bf643$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f8fa064e8c7bf643$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f8fa064e8c7bf643$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f8fa064e8c7bf643$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $f8fa064e8c7bf643$var$_excluded);
    var _useState = (0, $7fPBF.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $7fPBF.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $7fPBF.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $7fPBF.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $7fPBF.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $7fPBF.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return $f8fa064e8c7bf643$var$_objectSpread($f8fa064e8c7bf643$var$_objectSpread({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}


var $f6919b9119b4aa1b$var$AsyncSelect = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
    // when isAsync is true, options are not provided and async props are used, we will enable async
    var isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    var stateManagedProps = (0, $d3b27b3269bc4670$export$2e2bcd8739ae039)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    var selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    var selectProps = (0, $f8fa064e8c7bf643$export$2e2bcd8739ae039)(selectAsyncProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $c647738a411ac32c$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        ref: ref
    }, selectProps));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f6919b9119b4aa1b$export$2e2bcd8739ae039 = $f6919b9119b4aa1b$var$AsyncSelect;




var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");
var $d09f58e7392bbb8c$var$_excluded = [
    "ariaLiveMessages",
    "isInvalid",
    "onClickPreventDefault",
    "tabSelectsValue",
    "validationState"
];
function $d09f58e7392bbb8c$export$2e2bcd8739ae039(WrappedComponent) {
    var AtlaskitSelect = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        var ariaLiveMessages = props.ariaLiveMessages, isInvalid = props.isInvalid, _props$onClickPrevent = props.onClickPreventDefault, onClickPreventDefault = _props$onClickPrevent === void 0 ? true : _props$onClickPrevent, _props$tabSelectsValu = props.tabSelectsValue, tabSelectsValue = _props$tabSelectsValu === void 0 ? false : _props$tabSelectsValu, _props$validationStat = props.validationState, validationState = _props$validationStat === void 0 ? 'default' : _props$validationStat, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(props, $d09f58e7392bbb8c$var$_excluded);
        var internalSelectRef = (0, $7fPBF.useRef)(null);
        /**
     * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
     * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
     * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
     * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
     * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
     */ (0, $7fPBF.useImperativeHandle)(forwardedRef, function() {
            return {
                select: internalSelectRef.current,
                focus: function focus() {
                    var _internalSelectRef$cu;
                    return (_internalSelectRef$cu = internalSelectRef.current) === null || _internalSelectRef$cu === void 0 ? void 0 : _internalSelectRef$cu.focus();
                },
                blur: function blur() {
                    var _internalSelectRef$cu2;
                    return (_internalSelectRef$cu2 = internalSelectRef.current) === null || _internalSelectRef$cu2 === void 0 ? void 0 : _internalSelectRef$cu2.blur();
                }
            };
        }, []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error'
        }, restProps, {
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        }));
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}


var $55fce3feb1b8d0b5$var$packageName = "@atlaskit/select";
var $55fce3feb1b8d0b5$var$packageVersion = "21.11.0";
var $55fce3feb1b8d0b5$export$d1de3b251ccaa8a3 = (0, $d09f58e7392bbb8c$export$2e2bcd8739ae039)((0, $f6919b9119b4aa1b$export$2e2bcd8739ae039));
var $55fce3feb1b8d0b5$var$createAndFireEventOnAtlaskit = (0, $5819e7133c450b79$export$2e2bcd8739ae039)('atlaskit');
var $55fce3feb1b8d0b5$var$Select = (0, $4d25ac76de88d196$export$2e2bcd8739ae039)({
    componentName: 'select',
    packageName: $55fce3feb1b8d0b5$var$packageName,
    packageVersion: $55fce3feb1b8d0b5$var$packageVersion
})((0, $f8e03d3ef4b3dc3d$export$2e2bcd8739ae039)({
    onChange: $55fce3feb1b8d0b5$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $55fce3feb1b8d0b5$var$packageName,
            packageVersion: $55fce3feb1b8d0b5$var$packageVersion
        }
    })
})($55fce3feb1b8d0b5$export$d1de3b251ccaa8a3));
var $55fce3feb1b8d0b5$export$2e2bcd8739ae039 = $55fce3feb1b8d0b5$var$Select;



var $7fPBF = parcelRequire("7fPBF");



/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::921c184d9a6e3b52bd2ab053939ce9ad>>
 * @codegenCommand yarn build tokens
 */ var $042b66ee07ee2364$var$tokens = {
    'motion.avatar.enter': '--ds-avatar-enter',
    'motion.avatar.exit': '--ds-avatar-exit',
    'motion.avatar.hovered': '--ds-avatar-hovered',
    'motion.content.enter.long': '--ds-content-enter-long',
    'motion.content.enter.medium': '--ds-content-enter-medium',
    'motion.content.enter.short': '--ds-content-enter-short',
    'motion.content.exit.long': '--ds-content-exit-long',
    'motion.content.exit.medium': '--ds-content-exit-medium',
    'motion.content.exit.short': '--ds-content-exit-short',
    'motion.flag.enter': '--ds-flag-enter',
    'motion.flag.exit': '--ds-flag-exit',
    'motion.flag.reposition': '--ds-flag-reposition',
    'motion.modal.enter': '--ds-modal-enter',
    'motion.modal.exit': '--ds-modal-exit',
    'motion.popup.enter.bottom': '--ds-popup-enter-bottom',
    'motion.popup.enter.left': '--ds-popup-enter-left',
    'motion.popup.enter.right': '--ds-popup-enter-right',
    'motion.popup.enter.top': '--ds-popup-enter-top',
    'motion.popup.exit.bottom': '--ds-popup-exit-bottom',
    'motion.popup.exit.left': '--ds-popup-exit-left',
    'motion.popup.exit.right': '--ds-popup-exit-right',
    'motion.popup.exit.top': '--ds-popup-exit-top',
    'motion.spotlight.enter': '--ds-spotlight-enter',
    'motion.spotlight.exit': '--ds-spotlight-exit',
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.danger.bolder': '--ds-text-danger-bolder',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.warning.bolder': '--ds-text-warning-bolder',
    'color.text.success': '--ds-text-success',
    'color.text.success.bolder': '--ds-text-success-bolder',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.discovery.bolder': '--ds-text-discovery-bolder',
    'color.text.information': '--ds-text-information',
    'color.text.information.bolder': '--ds-text-information-bolder',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.subtler': '--ds-background-danger-subtler',
    'color.background.danger.subtler.hovered': '--ds-background-danger-subtler-hovered',
    'color.background.danger.subtler.pressed': '--ds-background-danger-subtler-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.subtler': '--ds-background-warning-subtler',
    'color.background.warning.subtler.hovered': '--ds-background-warning-subtler-hovered',
    'color.background.warning.subtler.pressed': '--ds-background-warning-subtler-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.subtler': '--ds-background-success-subtler',
    'color.background.success.subtler.hovered': '--ds-background-success-subtler-hovered',
    'color.background.success.subtler.pressed': '--ds-background-success-subtler-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.subtler': '--ds-background-discovery-subtler',
    'color.background.discovery.subtler.hovered': '--ds-background-discovery-subtler-hovered',
    'color.background.discovery.subtler.pressed': '--ds-background-discovery-subtler-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.subtler': '--ds-background-information-subtler',
    'color.background.information.subtler.hovered': '--ds-background-information-subtler-hovered',
    'color.background.information.subtler.pressed': '--ds-background-information-subtler-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.body.UNSAFE_small': '--ds-font-body-UNSAFE_small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.xxlarge': '--ds-radius-xxlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.width': '--ds-border-width',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $042b66ee07ee2364$export$2e2bcd8739ae039 = $042b66ee07ee2364$var$tokens;


var $614501a942df47fa$export$4ef52930e33717cd = 'data-theme';
var $614501a942df47fa$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $614501a942df47fa$export$a00eac3f8684bcd0 = 'data-color-mode';
var $614501a942df47fa$export$2112803007239c61 = 'data-contrast-mode';
var $614501a942df47fa$export$352e418ed5b6193a = 'data-custom-theme';
var $614501a942df47fa$export$6f0c6fb8c80fcc92 = 'ds';
var $614501a942df47fa$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $614501a942df47fa$export$dddac1532e822863 = "--".concat($614501a942df47fa$export$6f0c6fb8c80fcc92, "-token-not-found");
var $614501a942df47fa$export$9d7b58831ae93caa = "--".concat($614501a942df47fa$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


/**
 * Takes a dot-separated token name and an optional fallback, and returns the CSS custom property for the corresponding token.
 * This should be used to implement design decisions throughout your application.
 *
 * Note: With `@atlaskit/babel-plugin-tokens`, this function can be pre-compiled and a fallback value automatically inserted.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * <div
 *   css={{
 *     backgroundColor: token('elevation.surface.raised', N0),
 *     boxShadow: token('elevation.shadow.raised', `0 20px 32px -8px ${N50A}, 0 0 1px ${N60A}`),
 *     padding: token('spacing.scale.100', '8px'),
 *     fontWeight: token('font.weight.regular', '400'),
 *   }}
 * />
 * ```
 *
 */ function $727d537db95bcc31$var$token(path, fallback) {
    var token = (0, $042b66ee07ee2364$export$2e2bcd8739ae039)[path];
    // if the token is not found - replacing it with variable name without any value, to avoid it being undefined which would result in invalid css
    if (!token) token = (0, $614501a942df47fa$export$dddac1532e822863);
    var tokenCall = fallback ? "var(".concat(token, ", ").concat(fallback, ")") : "var(".concat(token, ")");
    return tokenCall;
}
var $727d537db95bcc31$export$2e2bcd8739ae039 = $727d537db95bcc31$var$token;




var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
var $bd8fd1a07ee559ec$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $7fPBF.createContext)('elevation.surface');
var $bd8fd1a07ee559ec$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $7fPBF.useContext)($bd8fd1a07ee559ec$export$1ca2a26fecb070ae);
};
$bd8fd1a07ee559ec$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';



var $8MJe2 = parcelRequire("8MJe2");


function $f914dcb93d08bd27$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f914dcb93d08bd27$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f914dcb93d08bd27$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f914dcb93d08bd27$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f914dcb93d08bd27$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $f914dcb93d08bd27$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $f914dcb93d08bd27$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $f914dcb93d08bd27$export$632685d741f3dbbf = $f914dcb93d08bd27$var$_objectSpread($f914dcb93d08bd27$var$_objectSpread({}, $f914dcb93d08bd27$export$958d0ae7f2977ae4), $f914dcb93d08bd27$export$d2dc61f58390201c);
var $f914dcb93d08bd27$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $f914dcb93d08bd27$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $f914dcb93d08bd27$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};
var $f914dcb93d08bd27$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};
var $f914dcb93d08bd27$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};
var $f914dcb93d08bd27$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.disabled': "var(--ds-background-disabled, #17171708)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $f914dcb93d08bd27$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};
var $f914dcb93d08bd27$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #292A2E)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #C9372C)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #E06C00)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #B38600)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #22A06B)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #2898BD)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #357DE8)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #AF59E1)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #7D818A)",
    'color.icon.disabled': "var(--ds-icon-disabled, #080F214A)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #1868DB)",
    'color.icon.brand': "var(--ds-icon-brand, #1868DB)",
    'color.icon.danger': "var(--ds-icon-danger, #C9372C)",
    'color.icon.warning': "var(--ds-icon-warning, #E06C00)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #292A2E)",
    'color.icon.success': "var(--ds-icon-success, #6A9A23)",
    'color.icon.discovery': "var(--ds-icon-discovery, #AF59E1)",
    'color.icon.information': "var(--ds-icon-information, #357DE8)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B6E76)",
    'color.icon.subtle': "var(--ds-icon-subtle, #505258)"
};
var $f914dcb93d08bd27$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $f914dcb93d08bd27$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
var $f914dcb93d08bd27$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
var $f914dcb93d08bd27$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // @deprecated
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $f914dcb93d08bd27$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $f914dcb93d08bd27$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $f914dcb93d08bd27$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $f914dcb93d08bd27$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $f914dcb93d08bd27$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
/**
 * Token functions are currently allowed for borderRadius in xcss to ease migration.
 * Because 'radius.small' defaults to 3px, we need a mechanism to allow for 4px values to be provided:
 * This is done by calling the token function - token('radius.small')
 *
 * TODO: Remove once shape them is rolled out and fg platform-dst-shape-theme-default removed
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $f914dcb93d08bd27$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $f914dcb93d08bd27$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $f914dcb93d08bd27$export$e615f061ca585a6c = $f914dcb93d08bd27$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $f914dcb93d08bd27$export$ca0f9c2de39ffed7(spacingProperty, $f914dcb93d08bd27$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $f914dcb93d08bd27$export$bf46c3f9eeafc71f = $f914dcb93d08bd27$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $f914dcb93d08bd27$export$ca0f9c2de39ffed7(spacingProperty, $f914dcb93d08bd27$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $f914dcb93d08bd27$export$e7af83bafe7f9e63 = $f914dcb93d08bd27$export$ca0f9c2de39ffed7('backgroundColor', $f914dcb93d08bd27$export$d1d79bf68ac056bd);
var $f914dcb93d08bd27$export$3a1bcba60b23d7f0 = $f914dcb93d08bd27$export$ca0f9c2de39ffed7('color', $f914dcb93d08bd27$export$8473307aa00d6ea1);
var $f914dcb93d08bd27$export$45f3f4fe16f9f7d5 = $f914dcb93d08bd27$export$ca0f9c2de39ffed7('fontWeight', $f914dcb93d08bd27$export$303e322c6b1ed114);
var $f914dcb93d08bd27$export$68cc305da27dbaa4 = $f914dcb93d08bd27$export$ca0f9c2de39ffed7('fontFamily', $f914dcb93d08bd27$export$3c7e9587132614b4);
var $f914dcb93d08bd27$export$128f10c238242f83 = $f914dcb93d08bd27$export$ca0f9c2de39ffed7('font', $f914dcb93d08bd27$export$6ffa317d5e70375);
var $f914dcb93d08bd27$export$219d364c0da35ae4 = $f914dcb93d08bd27$export$ca0f9c2de39ffed7('font', $f914dcb93d08bd27$export$236bfe3a33ef1292);
var $f914dcb93d08bd27$export$38845ca010b93505 = $f914dcb93d08bd27$export$ca0f9c2de39ffed7('fontWeight', $f914dcb93d08bd27$export$855cfd311192d666);
var $f914dcb93d08bd27$export$ff257d957d48c421 = $f914dcb93d08bd27$export$ca0f9c2de39ffed7((0, $614501a942df47fa$export$9d7b58831ae93caa), $f914dcb93d08bd27$export$41a358c9c2356760);
var $f914dcb93d08bd27$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $f914dcb93d08bd27$export$41a358c9c2356760[color] !== undefined;
};
var $f914dcb93d08bd27$export$7001ce64d9ff7c7f = $f914dcb93d08bd27$export$ca0f9c2de39ffed7('font', $f914dcb93d08bd27$export$b805719bc8cb376);



var $j9spr = parcelRequire("j9spr");

var $8MJe2 = parcelRequire("8MJe2");

var $iKdEz = parcelRequire("iKdEz");

var $bRUy3 = parcelRequire("bRUy3");


function $3e5203791fd7c7fc$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $3e5203791fd7c7fc$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $3e5203791fd7c7fc$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $3e5203791fd7c7fc$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $3e5203791fd7c7fc$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $3e5203791fd7c7fc$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $3e5203791fd7c7fc$export$9a199fbafee0014e = {
    backgroundColor: (0, $f914dcb93d08bd27$export$d1d79bf68ac056bd),
    blockSize: (0, $f914dcb93d08bd27$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $f914dcb93d08bd27$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $f914dcb93d08bd27$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $f914dcb93d08bd27$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $f914dcb93d08bd27$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $f914dcb93d08bd27$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $f914dcb93d08bd27$export$e1b83c5210c471b8),
    borderBottomColor: (0, $f914dcb93d08bd27$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $f914dcb93d08bd27$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $f914dcb93d08bd27$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $f914dcb93d08bd27$export$e1b83c5210c471b8),
    borderColor: (0, $f914dcb93d08bd27$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $f914dcb93d08bd27$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $f914dcb93d08bd27$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $f914dcb93d08bd27$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $f914dcb93d08bd27$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $f914dcb93d08bd27$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $f914dcb93d08bd27$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $f914dcb93d08bd27$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $f914dcb93d08bd27$export$e1b83c5210c471b8),
    borderLeftColor: (0, $f914dcb93d08bd27$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $f914dcb93d08bd27$export$e1b83c5210c471b8),
    borderRadius: (0, $f914dcb93d08bd27$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $f914dcb93d08bd27$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $f914dcb93d08bd27$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $f914dcb93d08bd27$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $f914dcb93d08bd27$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $f914dcb93d08bd27$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $f914dcb93d08bd27$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $f914dcb93d08bd27$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $f914dcb93d08bd27$export$e1b83c5210c471b8),
    borderWidth: (0, $f914dcb93d08bd27$export$e1b83c5210c471b8),
    bottom: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    boxShadow: (0, $f914dcb93d08bd27$export$7aff6e7ba39bb774),
    color: (0, $f914dcb93d08bd27$export$8473307aa00d6ea1),
    columnGap: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4),
    font: (0, $f914dcb93d08bd27$export$6ffa317d5e70375),
    fontFamily: (0, $f914dcb93d08bd27$export$3c7e9587132614b4),
    fontWeight: (0, $f914dcb93d08bd27$export$303e322c6b1ed114),
    gap: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4),
    height: (0, $f914dcb93d08bd27$export$6ccdbebca2ee545f),
    inlineSize: (0, $f914dcb93d08bd27$export$6ccdbebca2ee545f),
    inset: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    insetBlock: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    insetBlockEnd: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    insetBlockStart: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    insetInline: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    insetInlineEnd: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    insetInlineStart: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    left: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    margin: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    marginBlock: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    marginBlockEnd: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    marginBlockStart: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    marginBottom: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    marginInline: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    marginInlineEnd: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    marginInlineStart: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    marginLeft: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    marginRight: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    marginTop: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    maxBlockSize: (0, $f914dcb93d08bd27$export$6ccdbebca2ee545f),
    maxHeight: (0, $f914dcb93d08bd27$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $f914dcb93d08bd27$export$6ccdbebca2ee545f),
    maxWidth: (0, $f914dcb93d08bd27$export$6ccdbebca2ee545f),
    minBlockSize: (0, $f914dcb93d08bd27$export$6ccdbebca2ee545f),
    minHeight: (0, $f914dcb93d08bd27$export$6ccdbebca2ee545f),
    minInlineSize: (0, $f914dcb93d08bd27$export$6ccdbebca2ee545f),
    minWidth: (0, $f914dcb93d08bd27$export$6ccdbebca2ee545f),
    opacity: (0, $f914dcb93d08bd27$export$daf94a976c798b4f),
    outlineColor: (0, $f914dcb93d08bd27$export$1531ad5bb3fbedac),
    outlineOffset: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    outlineWidth: (0, $f914dcb93d08bd27$export$e1b83c5210c471b8),
    padding: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4),
    paddingBlock: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4),
    paddingBottom: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4),
    paddingInline: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4),
    paddingLeft: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4),
    paddingRight: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4),
    paddingTop: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4),
    right: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    rowGap: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4),
    top: (0, $f914dcb93d08bd27$export$632685d741f3dbbf),
    width: (0, $f914dcb93d08bd27$export$6ccdbebca2ee545f),
    zIndex: (0, $f914dcb93d08bd27$export$b5f31a7e431d2eab)
};
var $3e5203791fd7c7fc$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $3e5203791fd7c7fc$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return false;
};
var $3e5203791fd7c7fc$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $3e5203791fd7c7fc$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $3e5203791fd7c7fc$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($3e5203791fd7c7fc$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(value) === 'object' && $3e5203791fd7c7fc$var$safeSelectors.test(key)) {
            styleObj[key] = $3e5203791fd7c7fc$var$_transformStyles(value);
            return;
        }
        if ($3e5203791fd7c7fc$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($3e5203791fd7c7fc$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $3e5203791fd7c7fc$export$9a199fbafee0014e)) return;
        var tokenValue = $3e5203791fd7c7fc$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $3e5203791fd7c7fc$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $3e5203791fd7c7fc$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, $3e5203791fd7c7fc$var$uniqueSymbol, (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $3e5203791fd7c7fc$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $3e5203791fd7c7fc$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $3e5203791fd7c7fc$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$3e5203791fd7c7fc$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $3e5203791fd7c7fc$export$f6c783d06584602c(style) {
    return $3e5203791fd7c7fc$var$baseXcss(style);
}


var $d245204bc35d9406$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $d245204bc35d9406$var$_excluded2 = [
    "className"
];
var $d245204bc35d9406$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $d245204bc35d9406$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $d245204bc35d9406$var$_excluded2);
    var resolvedStyles = (0, $3e5203791fd7c7fc$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $d245204bc35d9406$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $f914dcb93d08bd27$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $f914dcb93d08bd27$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $f914dcb93d08bd27$export$ff257d957d48c421)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $f914dcb93d08bd27$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $f914dcb93d08bd27$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $f914dcb93d08bd27$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $f914dcb93d08bd27$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $f914dcb93d08bd27$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $f914dcb93d08bd27$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $f914dcb93d08bd27$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $bd8fd1a07ee559ec$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $d245204bc35d9406$export$2e2bcd8739ae039 = $d245204bc35d9406$export$e71c4d32a2263218;
var $d245204bc35d9406$var$baseStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});


const $6718274fb1e241ce$var$languageSelectStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.025'
});
const $6718274fb1e241ce$var$LanguageSelect = ()=>{
    const dispatch = (0, $7ef2374eddee6a70$export$f51d452c10d5b956)();
    const selectLanguageHandler = (0, $7fPBF.useCallback)((option)=>{
        if (option) dispatch((0, $cc45bcc51bf95f36$export$fa43c961ec463ef0)(option.value));
    }, [
        dispatch
    ]);
    const currentLanguage = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $0ce633403190319b$export$20b36ebcfeb0a091));
    const supportedLanguages = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $0ce633403190319b$export$454c8e352dec47e6));
    const languageOptions = (0, $7fPBF.useMemo)(()=>Object.keys(supportedLanguages).map((key)=>({
                value: key,
                label: supportedLanguages[key]
            })), [
        supportedLanguages
    ]);
    const defaultLanguage = (0, $7fPBF.useMemo)(()=>({
            value: currentLanguage,
            label: supportedLanguages[currentLanguage]
        }), [
        currentLanguage,
        supportedLanguages
    ]);
    (0, $7fPBF.useEffect)(()=>{
        document.documentElement.lang = currentLanguage;
    }, [
        currentLanguage
    ]);
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
        xcss: $6718274fb1e241ce$var$languageSelectStyles,
        children: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($49831beffa50c42c$exports))), {
                label: 'Language Select',
                color: (0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.icon.subtle')
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $55fce3feb1b8d0b5$export$2e2bcd8739ae039), {
                appearance: 'subtle',
                classNamePrefix: 'languageSelectWrapper',
                value: defaultLanguage,
                options: languageOptions,
                onChange: selectLanguageHandler,
                menuPlacement: 'top',
                blurInputOnSelect: true
            })
        ]
    });
};
var $6718274fb1e241ce$export$2e2bcd8739ae039 = $6718274fb1e241ce$var$LanguageSelect;







var $j9spr = parcelRequire("j9spr");

var $bRUy3 = parcelRequire("bRUy3");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $3e965e9bfa13f6c2$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $7fPBF.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $3e965e9bfa13f6c2$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($3e965e9bfa13f6c2$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $3e965e9bfa13f6c2$export$2e2bcd8739ae039 = $3e965e9bfa13f6c2$var$RouterLinkProvider;


/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $1e99b1bf831ba46f$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $7fPBF.useContext)((0, $3e965e9bfa13f6c2$export$2931e0ee690eee88)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $1e99b1bf831ba46f$export$2e2bcd8739ae039 = $1e99b1bf831ba46f$var$useRouterLink;


/**
 * An empty function which does nothing.
 */ function $27bc0e79b61c3ca3$export$2e2bcd8739ae039() {}



var $bRUy3 = parcelRequire("bRUy3");

var $7fPBF = parcelRequire("7fPBF");
function $7be67eb736da6c4d$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useId().replace(/[:«»]/g, '_');
}
var $7be67eb736da6c4d$export$6be90bcb437e928f = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($7be67eb736da6c4d$export$f680877a34711e37()).concat(postfix);
    (0, $7fPBF.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $7be67eb736da6c4d$export$6ee17796e3d70de2() {
    var uid = $7be67eb736da6c4d$export$f680877a34711e37();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}






var $d675dd73cffce3dd$var$_excluded = [
    "href",
    "children",
    "backgroundColor",
    "newWindowLabel",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss"
], $d675dd73cffce3dd$var$_excluded2 = [
    "className"
];
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $d675dd73cffce3dd$var$focusRingStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $f914dcb93d08bd27$export$1531ad5bb3fbedac)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $f914dcb93d08bd27$export$958d0ae7f2977ae4)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $f914dcb93d08bd27$export$e1b83c5210c471b8)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: "".concat((0, $f914dcb93d08bd27$export$e1b83c5210c471b8)['border.width'], " solid")
        }
    }
});
var $d675dd73cffce3dd$var$baseStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    boxSizing: 'border-box',
    textDecoration: 'underline'
});
var $d675dd73cffce3dd$var$positionStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    position: 'relative'
});
var $d675dd73cffce3dd$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $d675dd73cffce3dd$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
var $d675dd73cffce3dd$var$OPENS_NEW_WINDOW_LABEL = '(opens new window)';
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $d675dd73cffce3dd$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, backgroundColor = _ref.backgroundColor, newWindowLabel = _ref.newWindowLabel, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $27bc0e79b61c3ca3$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $d675dd73cffce3dd$var$_excluded);
    var interactionContext = (0, $7fPBF.useContext)((0, $48ec410b84640600$export$2e2bcd8739ae039));
    var handleClick = (0, $7fPBF.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $7be67eb736da6c4d$export$f680877a34711e37)();
    var onClick = (0, $593ac790924c31ca$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "@atlaskit/primitives",
        packageVersion: "18.1.1",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $d675dd73cffce3dd$var$_excluded2);
    var resolvedStyles = (0, $3e5203791fd7c7fc$export$a9c84988c8f81f2d)(xcss);
    var RouterLink = (0, $1e99b1bf831ba46f$export$2e2bcd8739ae039)();
    var isExternal = typeof href === 'string' && $d675dd73cffce3dd$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $d675dd73cffce3dd$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(href) === 'object';
    (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : 'a';
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // @ts-expect-error
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel ? newWindowLabel : $d675dd73cffce3dd$var$OPENS_NEW_WINDOW_LABEL) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        css: [
            $d675dd73cffce3dd$var$baseStyles,
            $d675dd73cffce3dd$var$positionStyles,
            $d675dd73cffce3dd$var$focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $f914dcb93d08bd27$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $f914dcb93d08bd27$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $f914dcb93d08bd27$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $f914dcb93d08bd27$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $f914dcb93d08bd27$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $f914dcb93d08bd27$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $f914dcb93d08bd27$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $f914dcb93d08bd27$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(resolvedStyles.emotion || [])),
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }), children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $d1b9d01570e45f55$export$2e2bcd8739ae039), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel ? newWindowLabel : $d675dd73cffce3dd$var$OPENS_NEW_WINDOW_LABEL)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $d675dd73cffce3dd$var$Anchor = /*#__PURE__*/ (0, $7fPBF.forwardRef)($d675dd73cffce3dd$var$AnchorNoRef);
var $d675dd73cffce3dd$export$2e2bcd8739ae039 = $d675dd73cffce3dd$var$Anchor;


var $j9spr = parcelRequire("j9spr");

var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");



var $650de54fef58c216$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
var $650de54fef58c216$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
var $650de54fef58c216$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
var $650de54fef58c216$var$justifyContentMap = {
    start: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyContent: 'start'
    }),
    center: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyContent: 'center'
    }),
    end: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyContent: 'end'
    }),
    'space-between': (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyContent: 'stretch'
    })
};
var $650de54fef58c216$var$justifyItemsMap = {
    start: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyItems: 'start'
    }),
    center: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyItems: 'center'
    }),
    end: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyItems: 'end'
    }),
    stretch: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyItems: 'stretch'
    })
};
var $650de54fef58c216$var$alignContentMap = {
    start: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignContent: 'start'
    }),
    center: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignContent: 'center'
    }),
    end: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignContent: 'end'
    }),
    'space-between': (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignContent: 'space-between'
    }),
    'space-around': (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignContent: 'space-around'
    }),
    'space-evenly': (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignContent: 'space-evenly'
    }),
    stretch: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignContent: 'stretch'
    })
};
var $650de54fef58c216$var$alignItemsMap = {
    start: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignItems: 'start'
    }),
    center: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignItems: 'center'
    }),
    baseline: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignItems: 'baseline'
    }),
    end: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignItems: 'end'
    })
};
var $650de54fef58c216$var$baseStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: "var(".concat($650de54fef58c216$var$gridTemplateAreasVar, ")"),
    gridTemplateColumns: "var(".concat($650de54fef58c216$var$gridTemplateColumnsVar, ")"),
    gridTemplateRows: "var(".concat($650de54fef58c216$var$gridTemplateRowsVar, ")")
});
var $650de54fef58c216$var$gridAutoFlowMap = {
    row: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        gridAutoFlow: 'row'
    }),
    column: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        gridAutoFlow: 'column'
    }),
    dense: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        gridAutoFlow: 'dense'
    }),
    'row dense': (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        gridAutoFlow: 'row dense'
    }),
    'column dense': (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        gridAutoFlow: 'column dense'
    })
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ var $650de54fef58c216$var$Grid = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignItems, alignContent = _ref.alignContent, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, id = _ref.id, role = _ref.role, testId = _ref.testId, autoFlow = _ref.autoFlow, gridTemplateAreas = _ref.templateAreas, gridTemplateRows = _ref.templateRows, gridTemplateColumns = _ref.templateColumns, xcss = _ref.xcss;
    var Component = as || 'div';
    var resolvedStyles = (0, $3e5203791fd7c7fc$export$a9c84988c8f81f2d)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ var style = (0, $7fPBF.useMemo)(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, $650de54fef58c216$var$gridTemplateAreasVar, gridTemplateAreas ? gridTemplateAreas.map(function(str) {
            return "\"".concat(str, "\"");
        }).join('\n') || 'initial' : 'initial'), $650de54fef58c216$var$gridTemplateColumnsVar, gridTemplateColumns || 'initial'), $650de54fef58c216$var$gridTemplateRowsVar, gridTemplateRows || 'initial');
    }, [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(Component, {
        id: id,
        role: role,
        style: style,
        className: resolvedStyles.static,
        css: [
            $650de54fef58c216$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $f914dcb93d08bd27$export$bf46c3f9eeafc71f).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $f914dcb93d08bd27$export$bf46c3f9eeafc71f).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $f914dcb93d08bd27$export$bf46c3f9eeafc71f).rowGap[rowGap],
            alignItems && $650de54fef58c216$var$alignItemsMap[alignItems],
            alignContent && $650de54fef58c216$var$alignContentMap[alignContent],
            justifyContent && $650de54fef58c216$var$justifyContentMap[justifyContent],
            autoFlow && $650de54fef58c216$var$gridAutoFlowMap[autoFlow]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(resolvedStyles.emotion || [])),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$650de54fef58c216$var$Grid.displayName = 'Grid';
var $650de54fef58c216$export$2e2bcd8739ae039 = $650de54fef58c216$var$Grid;

/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $8c23171a376c15ae$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
var $8c23171a376c15ae$export$c881183ca713c214 = $8c23171a376c15ae$export$987d49ffe1b0900f;



const $8bc21533085bc562$var$_6 = "._30l330cd:hover{color:var(--_bp2er6)}";
const $8bc21533085bc562$var$_5 = "._80omtlke{cursor:pointer}";
const $8bc21533085bc562$var$_4 = "._syaz30cd{color:var(--_bp2er6)}";
const $8bc21533085bc562$var$_3 = "._ajmmnqa1{text-decoration-style:solid}";
const $8bc21533085bc562$var$_2 = "._1hmsglyw{text-decoration-line:none}";
const $8bc21533085bc562$var$_ = "._4bfu1r31{text-decoration-color:currentColor}";
const $8bc21533085bc562$var$footerGridStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    [(0, $8c23171a376c15ae$export$987d49ffe1b0900f).above.xxs]: {
        gridTemplateColumns: 'repeat(1, minmax(0, max-content))',
        gap: 'space.200'
    },
    [(0, $8c23171a376c15ae$export$987d49ffe1b0900f).above.md]: {
        gridTemplateColumns: 'repeat(auto-fit, minmax(0, max-content))',
        gap: 'space.600'
    }
});
const $8bc21533085bc562$var$footerLinkStylesCss = null;
const $8bc21533085bc562$var$footerLinkStylesXCss = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    color: 'color.text.subtle',
    textDecoration: 'none',
    cursor: 'pointer',
    ':hover': {
        color: 'color.text.subtle'
    }
});
const $8bc21533085bc562$var$footerTextStyles = null;
const $8bc21533085bc562$var$Footer = ()=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    const currentLanguage = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $0ce633403190319b$export$20b36ebcfeb0a091));
    (0, $7fPBF.useEffect)(()=>{
        var _window_AtlOneTrustWrapper_updatePolicyLinks, _window_AtlOneTrustWrapper;
        (_window_AtlOneTrustWrapper = window.AtlOneTrustWrapper) === null || _window_AtlOneTrustWrapper === void 0 ? void 0 : (_window_AtlOneTrustWrapper_updatePolicyLinks = _window_AtlOneTrustWrapper.updatePolicyLinks) === null || _window_AtlOneTrustWrapper_updatePolicyLinks === void 0 ? void 0 : _window_AtlOneTrustWrapper_updatePolicyLinks.call(_window_AtlOneTrustWrapper);
    }, [
        currentLanguage
    ]);
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
        as: 'footer',
        testId: 'footer-wrapper',
        padding: 'space.150',
        backgroundColor: 'color.background.neutral',
        children: /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $650de54fef58c216$export$2e2bcd8739ae039), {
            xcss: $8bc21533085bc562$var$footerGridStyles,
            alignItems: "center",
            justifyContent: "center",
            children: [
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $6718274fb1e241ce$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d675dd73cffce3dd$export$2e2bcd8739ae039), {
                    xcss: $8bc21533085bc562$var$footerLinkStylesXCss,
                    testId: "footer-privacy-policy",
                    href: "https://www.atlassian.com/legal/privacy-policy",
                    rel: "noreferrer",
                    target: "_blank",
                    children: translate((0, $447ba15143f7eed7$exports).PRIVACY_POLICY_BUTTON_LABEL)
                }),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                            children: [
                                $8bc21533085bc562$var$_,
                                $8bc21533085bc562$var$_2,
                                $8bc21533085bc562$var$_3,
                                $8bc21533085bc562$var$_4,
                                $8bc21533085bc562$var$_5,
                                $8bc21533085bc562$var$_6
                            ]
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("a", {
                            "data-testId": "footer-policy-link",
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                            className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                                "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz30cd _80omtlke _30l330cd",
                                'atl-policy-link atl-policy-link-text'
                            ]),
                            rel: "noreferrer",
                            target: "_blank",
                            style: {
                                "--_bp2er6": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.text.subtle'))
                            },
                            children: "Notice at Collection"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d675dd73cffce3dd$export$2e2bcd8739ae039), {
                    xcss: $8bc21533085bc562$var$footerLinkStylesXCss,
                    testId: "footer-terms-of-use",
                    href: "https://www.atlassian.com/legal/customer-agreement",
                    rel: "noreferrer",
                    target: "_blank",
                    children: translate((0, $447ba15143f7eed7$exports).TERM_OF_USE_BUTTON_LABEL)
                }),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d675dd73cffce3dd$export$2e2bcd8739ae039), {
                    xcss: $8bc21533085bc562$var$footerLinkStylesXCss,
                    testId: "footer-trademark",
                    href: "https://www.atlassian.com/legal/trademark",
                    rel: "noreferrer",
                    target: "_blank",
                    children: translate((0, $447ba15143f7eed7$exports).TRADEMARK_BUTTON_LABEL)
                }),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                            children: [
                                $8bc21533085bc562$var$_4
                            ]
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("span", {
                            className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                                "_syaz30cd"
                            ]),
                            style: {
                                "--_bp2er6": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.text.subtle'))
                            },
                            children: `Atlassian \xa9 ${new Date().getFullYear()}`
                        })
                    ]
                })
            ]
        })
    });
};
var $8bc21533085bc562$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $7fPBF.memo)($8bc21533085bc562$var$Footer);





parcelRequire("7fPBF");

parcelRequire("7fPBF");


var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");
var $06e8fc615885301a$var$_process$env;
var /// <reference types="node" />
$06e8fc615885301a$export$2e2bcd8739ae039 = false;



var $j9spr = parcelRequire("j9spr");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $eihxX = parcelRequire("eihxX");

var $eaTmW = parcelRequire("eaTmW");

var $l8Sa3 = parcelRequire("l8Sa3");

var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");


function $424f1f90d90f725a$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eihxX)))(t, $424f1f90d90f725a$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(t).constructor) : o.apply(t, e));
}
function $424f1f90d90f725a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($424f1f90d90f725a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $424f1f90d90f725a$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($1bfc5778dcd4841a$exports))).func
};
var $424f1f90d90f725a$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $424f1f90d90f725a$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, AnalyticsContext);
        _this = $424f1f90d90f725a$var$_callSuper(this, AnalyticsContext, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $424f1f90d90f725a$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $424f1f90d90f725a$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($l8Sa3)))(AnalyticsContext, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e420dde09fb890a4$export$2e2bcd8739ae039).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
}((0, $7fPBF.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($424f1f90d90f725a$var$AnalyticsContext, "contextTypes", $424f1f90d90f725a$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($424f1f90d90f725a$var$AnalyticsContext, "childContextTypes", $424f1f90d90f725a$var$ContextTypes);
var $424f1f90d90f725a$export$2e2bcd8739ae039 = $424f1f90d90f725a$var$AnalyticsContext;



var $j9spr = parcelRequire("j9spr");

var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");

var $744e9f235aae602f$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $7fPBF.useContext)((0, $e420dde09fb890a4$export$2e2bcd8739ae039));
};



var $7fPBF = parcelRequire("7fPBF");
var $778efa38d8433f71$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $7fPBF.useRef)(value);
    ref.current = value;
    return ref;
};


var $36232c276cc489da$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $778efa38d8433f71$export$1d27a74659855e44)(data);
    var _useAnalyticsContext = (0, $744e9f235aae602f$export$d1f587f82ad51c4)(), getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getOriginalAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var getAtlaskitAnalyticsContext = (0, $7fPBF.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(getOriginalAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    var value = (0, $7fPBF.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e420dde09fb890a4$export$2e2bcd8739ae039).Provider, {
        value: value
    }, children);
};
var $36232c276cc489da$export$2e2bcd8739ae039 = $36232c276cc489da$var$AnalyticsContext;


var $d1b3315ddbeb9ff3$var$ExportedAnalyticsContext = function ExportedAnalyticsContext(props) {
    var isModernContext = (0, $06e8fc615885301a$export$2e2bcd8739ae039) || (0, $137Lh.fg)('analytics-next-use-modern-context_jira');
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $36232c276cc489da$export$2e2bcd8739ae039), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $424f1f90d90f725a$export$2e2bcd8739ae039), props);
};
var $d1b3315ddbeb9ff3$export$2e2bcd8739ae039 = $d1b3315ddbeb9ff3$var$ExportedAnalyticsContext;


var $51b02fe1f88ea77f$var$createNamespaceContext = function createNamespaceContext(namespace) {
    var displayName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'NamespacedContext';
    var Component = function Component(props) {
        var newData = (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, namespace, props.data);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d1b3315ddbeb9ff3$export$2e2bcd8739ae039), {
            data: newData
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.only(props.children));
    };
    Component.displayName = displayName;
    return Component;
};
var $51b02fe1f88ea77f$export$2e2bcd8739ae039 = $51b02fe1f88ea77f$var$createNamespaceContext;


var $92449e234712a663$export$80450e0a84a5ede9 = 'fabricElementsCtx';
var $92449e234712a663$export$3fe25500478a635c = (0, $51b02fe1f88ea77f$export$2e2bcd8739ae039)($92449e234712a663$export$80450e0a84a5ede9, 'FabricElementsAnalyticsContext');



var $75c91c4e13a5796f$export$1fd3aad76a7c6788 = 'navigationCtx';
var $75c91c4e13a5796f$export$d0a82da1a0b94929 = (0, $51b02fe1f88ea77f$export$2e2bcd8739ae039)($75c91c4e13a5796f$export$1fd3aad76a7c6788, 'NavigationAnalyticsContext');



var $dece67ad20480118$export$8c8f6d8f1fa796f0 = 'fabricEditorCtx';
var $dece67ad20480118$export$9eb2b47430ed3f7c = /*#__PURE__*/ function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
    EDITOR_APPEARANCE_CONTEXT["MAX"] = "max";
    return EDITOR_APPEARANCE_CONTEXT;
}({});
var $dece67ad20480118$export$629cada6c5e621e1 = (0, $51b02fe1f88ea77f$export$2e2bcd8739ae039)($dece67ad20480118$export$8c8f6d8f1fa796f0, 'FabricEditorAnalyticsContext');


// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
var $06d3d62c85491d72$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx



var $2fc8b49ff098c068$export$b326383bee6cb993 = 'peopleTeamsCtx';
var $2fc8b49ff098c068$export$4119ddb38ccbfb87 = (0, $51b02fe1f88ea77f$export$2e2bcd8739ae039)($2fc8b49ff098c068$export$b326383bee6cb993, 'PeopleTeamsAnalyticsContext');



var $0cc0ff1d3627d52c$export$da1befb791e93c7e = 'NotificationsCtx';
var $0cc0ff1d3627d52c$export$6f8e7ff1e3feafd7 = (0, $51b02fe1f88ea77f$export$2e2bcd8739ae039)($0cc0ff1d3627d52c$export$da1befb791e93c7e, 'NotificationsAnalyticsContext');



var $ed34bad4a7536512$export$fc7a65795610cb71 = 'RecentWorkCtx';
var $ed34bad4a7536512$export$745926731087ebe2 = (0, $51b02fe1f88ea77f$export$2e2bcd8739ae039)($ed34bad4a7536512$export$fc7a65795610cb71, 'RecentWorkAnalyticsContext');



var $8f85cfeb0afc43d1$export$4906017439f33fc0 = 'atlasCtx';
var $8f85cfeb0afc43d1$export$43ebbe41370d4543 = (0, $51b02fe1f88ea77f$export$2e2bcd8739ae039)($8f85cfeb0afc43d1$export$4906017439f33fc0, 'AtlasAnalyticsContext');



var $9c433a8f7da6738b$export$aa18ab4fff926c9e = 'townsquareHomeCtx';
var $9c433a8f7da6738b$export$d283110f5d85c8f2 = (0, $51b02fe1f88ea77f$export$2e2bcd8739ae039)($9c433a8f7da6738b$export$aa18ab4fff926c9e, 'TownsquareHomeAnalyticsContext');



var $351aeee377de9bdb$export$3240443bf2b83834 = 'linkingPlatformCtx';
var $351aeee377de9bdb$export$6d568da622ce0a08 = (0, $51b02fe1f88ea77f$export$2e2bcd8739ae039)($351aeee377de9bdb$export$3240443bf2b83834, 'LinkingPlatformAnalyticsContext');



var $9b125f9bd5397833$export$ef0c05448f0f8f9 = 'postOfficeCtx';
var $9b125f9bd5397833$export$dcd232f3be312f94 = (0, $51b02fe1f88ea77f$export$2e2bcd8739ae039)($9b125f9bd5397833$export$ef0c05448f0f8f9, 'PostOfficeAnalyticsContext');



var $92180eac3dc28435$export$5c3a6fd8b96e8b66 = 'aiMateCtx';
var $92180eac3dc28435$export$de3826c30468da26 = (0, $51b02fe1f88ea77f$export$2e2bcd8739ae039)($92180eac3dc28435$export$5c3a6fd8b96e8b66, 'AIMateAnalyticsContext');



var $32512ad48756675a$export$c2a811a4e42f4af5 = 'avpCtx';
var $32512ad48756675a$export$da383e8879a25b03 = (0, $51b02fe1f88ea77f$export$2e2bcd8739ae039)($32512ad48756675a$export$c2a811a4e42f4af5, 'AVPAnalyticsContext');



var $599df8b65ae97955$export$82023f2f4bfb06c1 = 'editionAwarenessCtx';
var $599df8b65ae97955$export$84980182680018f = (0, $51b02fe1f88ea77f$export$2e2bcd8739ae039)($599df8b65ae97955$export$82023f2f4bfb06c1, 'GrowthAnalyticsContext');



var $935bd894480a8bc5$export$6d3c48fd1b3e4f3b = 'omniChannelCtx';
var $935bd894480a8bc5$export$e4e6df99270bbbb1 = (0, $51b02fe1f88ea77f$export$2e2bcd8739ae039)($935bd894480a8bc5$export$6d3c48fd1b3e4f3b, 'OmniChannelAnalyticsContext');



var $38aaedb5dc7694be$export$fae437eb1dd9520c = 'rovoExtensionCtx';
var $38aaedb5dc7694be$export$7fcecc25ee38fbef = (0, $51b02fe1f88ea77f$export$2e2bcd8739ae039)($38aaedb5dc7694be$export$fae437eb1dd9520c, 'RovoExtensionAnalyticsContext');




var $09cd32ac24fc7bec$export$30fa7cc5f2690a43 = 56;
var $09cd32ac24fc7bec$export$4033a111ca79977d = 1280;
var $09cd32ac24fc7bec$export$24ec62cee78b7042 = 1130;
var $09cd32ac24fc7bec$export$d8bde68ac946124f = '--ds--ans--fbc';
var $09cd32ac24fc7bec$export$73e44f54603a0964 = '--ds--ans--hbgc';
var $09cd32ac24fc7bec$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
var $09cd32ac24fc7bec$export$d81606c1fc5119bc = '--ds--ans--c';
var $09cd32ac24fc7bec$export$65f656ad520ea71 = '--ds--ans--bc';


var $fb54c92546ddb49f$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-pressed, #144794)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-hovered, #1558BC)",
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: ''
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: "var(--ds-surface, #FFFFFF)",
            color: "var(--ds-text-subtlest, #6B6E76)"
        },
        productHome: {
            backgroundColor: "var(--ds-text-brand, #1868DB)",
            color: "var(--ds-text, #292A2E)",
            borderRight: "var(--ds-border-width, 1px)".concat(" solid ", "var(--ds-border, #0B120E24)"),
            // TODO: replace with token after brand refresh
            iconColor: '#357DE8',
            textColor: "var(--ds-text, #292A2E)"
        },
        primaryButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            }
        },
        search: {
            default: {
                backgroundColor: "var(--ds-background-input, #FFFFFF)",
                color: "var(--ds-text-subtlest, #6B6E76)",
                borderColor: "var(--ds-border-input, #8C8F97)"
            },
            focus: {
                borderColor: "var(--ds-border-focused, #4688EC)"
            },
            hover: {
                backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
            }
        },
        skeleton: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            opacity: 1
        }
    }
};
// Create deep copy of defaultTheme
var $fb54c92546ddb49f$var$defaultThemeCopy = JSON.parse(JSON.stringify($fb54c92546ddb49f$var$defaultTheme));
// Update iconColor and textColor in defaultThemeBrandRefresh
$fb54c92546ddb49f$var$defaultThemeCopy.mode.productHome.iconColor = undefined;
$fb54c92546ddb49f$var$defaultThemeCopy.mode.productHome.textColor = undefined;
var $fb54c92546ddb49f$export$77823bc9863eaa03 = $fb54c92546ddb49f$var$defaultThemeCopy;
var $fb54c92546ddb49f$export$2491e13b198e597d = 'atlassian';
var $fb54c92546ddb49f$export$2e2bcd8739ae039 = $fb54c92546ddb49f$var$defaultTheme;



var $8MJe2 = parcelRequire("8MJe2");


var $j9spr = parcelRequire("j9spr");

var $8MJe2 = parcelRequire("8MJe2");
function $c48d08609c4efffc$var$fromHex(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace("#", "").match(/.{2}/g);
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a], 16);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $c48d08609c4efffc$var$fromRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "hex":
            return 1 == (g = Math.round(n.r).toString(16)).length && (g = "0" + g), 1 == (y = Math.round(n.g).toString(16)).length && (y = "0" + y), 1 == (_ = Math.round(n.b).toString(16)).length && (_ = "0" + _), "#" + g + y + _;
        case "cssrgb":
            return "rgb(" + Math.round(n.r) + "," + Math.round(n.g) + "," + Math.round(n.b) + ")";
        case "hsl":
            var a = [
                g = n.r / 255,
                y = n.g / 255,
                _ = n.b / 255
            ].sort(), i = (a[0] + a[2]) / 2 * 100;
            return a[0] == a[2] ? (b = 0, d = 0) : (b = i >= 50 ? (a[2] - a[0]) / (2 - a[2] - a[0]) * 100 : (a[2] - a[0]) / (a[2] + a[0]) * 100, (d = a[2] == g ? (y - _) / (a[2] - a[0]) * 60 : a[2] == y ? 60 * (2 + (_ - g) / (a[2] - a[0])) : 60 * (4 + (g - y) / (a[2] - a[0]))) < 0 ? d += 360 : d > 360 && (d %= 360)), {
                h: d,
                s: b,
                l: i
            };
        case "csshsl":
            var c = o.convert({
                conversions: t,
                helpers: s
            }, "hsl", n);
            return "hsl(" + Math.round(c.h) + "," + Math.round(c.s) + "%," + Math.round(c.l) + "%)";
        case "cmyk":
            var u = n.r / 255, l = n.g / 255, h = n.b / 255, v = 1 - Math.max(u, l, h);
            if (1 != v) var p = (1 - u - v) / (1 - v), f = (1 - l - v) / (1 - v), m = (1 - h - v) / (1 - v);
            else var p = 0, f = 0, m = 0;
            return {
                c: p,
                m: f,
                y: m,
                k: v
            };
        case "hsv":
            var d, b, g = n.r / 255, y = n.g / 255, _ = n.b / 255, M = Math.min(g, y, _), Y = Math.max(g, y, _), L = Y - M, X = Y;
            if (0 == L) d = 0, b = 0;
            else {
                b = L / Y;
                var Z = ((Y - g) / 6 + L / 2) / L, R = ((Y - y) / 6 + L / 2) / L, w = ((Y - _) / 6 + L / 2) / L;
                g == Y ? d = w - R : y == Y ? d = 1 / 3 + Z - w : _ == Y && (d = 2 / 3 + R - Z), d < 0 && (d += 1), d > 1 && (d -= 1);
            }
            return {
                h: 360 * d,
                s: 100 * b,
                v: 100 * X
            };
        case "yiq":
            var m = n.r / 255 * .299 + n.g / 255 * .587 + n.b / 255 * .114, C = n.r / 255 * .596 + n.g / 255 * -0.274 + n.b / 255 * -0.322, x = n.r / 255 * .211 + n.g / 255 * -0.523 + n.b / 255 * .312;
            return C = s.bounded(C, [
                -0.5957,
                .5957
            ]), x = s.bounded(x, [
                -0.5226,
                .5226
            ]), {
                y: m,
                i: C,
                q: x
            };
        case "XYZ":
            var A = [
                n.r,
                n.g,
                n.b
            ].map(function(r) {
                return r / 255;
            }).map(function(r) {
                return r <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
            }), S = s.getTransform("SRGB_XYZ").map(function(r) {
                return A.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return 100 * r;
            }), O = $c48d08609c4efffc$var$slicedToArray(S, 3);
            return {
                X: O[0],
                Y: O[1],
                Z: O[2]
            };
        case "lms":
        case "cielab":
        case "cieluv":
        case "xyY":
            var I = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, I);
        case "cielch":
            var j = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, j);
        case "hsluv":
            var D = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, D);
    }
}
function $c48d08609c4efffc$var$fromCssRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/((rgb\(|\))|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $c48d08609c4efffc$var$fromHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            if (0 == n.s) {
                var a = n.l / 100 * 255;
                return {
                    r: a,
                    g: a,
                    b: a
                };
            }
            var i, c, u;
            i = n.l >= 50 ? n.l / 100 + n.s / 100 - n.l / 100 * (n.s / 100) : n.l / 100 * (1 + n.s / 100), c = n.l / 100 * 2 - i;
            var l, h, v, p = ((u = n.h / 360) + .333) % 1, f = u, m = s.negMod(u - .333, 1);
            return l = 6 * p < 1 ? c + 6 * (i - c) * p : 2 * p < 1 ? i : 3 * p < 2 ? c + 6 * (.666 - p) * (i - c) : c, h = 6 * f < 1 ? c + 6 * (i - c) * f : 2 * f < 1 ? i : 3 * f < 2 ? c + 6 * (.666 - f) * (i - c) : c, v = 6 * m < 1 ? c + 6 * (i - c) * m : 2 * m < 1 ? i : 3 * m < 2 ? c + 6 * (.666 - m) * (i - c) : c, l < 0 && (l = 0), h < 0 && (h = 0), v < 0 && (v = 0), {
                r: 255 * l,
                g: 255 * h,
                b: 255 * v
            };
        case "csshsl":
            return "hsl(" + Math.round(n.h) + "," + Math.round(n.s) + "%," + Math.round(n.l) + "%)";
        case "hsv":
            n.s = n.s / 100, n.l = n.l / 100;
            var d = n.s * (n.l < .5 ? n.l : 1 - n.l);
            return {
                h: n.h,
                s: 100 * (2 * d / (n.l + d)),
                v: 100 * (n.l + d)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $c48d08609c4efffc$var$fromCssHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/(hsl\(|\)|%|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "hsl":
            return {
                h: n[0],
                s: n[1],
                l: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                h: n[0],
                s: n[1],
                l: n[2]
            });
    }
}
function $c48d08609c4efffc$var$fromHsv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            var a, i, c;
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            var u = 6 * n.h;
            6 == u && (u = 0);
            var l, h, v, p = Math.round(u), f = n.v * (1 - n.s), m = n.v * (1 - n.s * (u - p)), d = n.v * (1 - n.s * (1 - (u - p)));
            return 0 == p ? (l = n.v, h = d, v = f) : 1 == p ? (l = m, h = n.v, v = f) : 2 == p ? (l = f, h = n.v, v = d) : 3 == p ? (l = f, h = m, v = n.v) : 4 == p ? (l = d, h = f, v = n.v) : (l = n.v, h = f, v = m), a = 255 * l, i = 255 * h, c = 255 * v, {
                r: a,
                g: i,
                b: c
            };
        case "hsl":
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            return {
                h: 360 * n.h,
                s: 100 * ((2 - n.s) * n.v < 1 ? n.s * n.v / ((2 - n.s) * n.v) : n.s * n.v / (2 - (2 - n.s) * n.v)),
                l: 100 * ((2 - n.s) * n.v / 2)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $c48d08609c4efffc$var$fromCmyk(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            return {
                r: a = 255 * (1 - n.c) * (1 - n.k),
                g: i = 255 * (1 - n.m) * (1 - n.k),
                b: c = 255 * (1 - n.y) * (1 - n.k)
            };
        case "cssrgb":
            var a = 255 * (1 - n.c) * (1 - n.k), i = 255 * (1 - n.m) * (1 - n.k), c = 255 * (1 - n.y) * (1 - n.k);
            return "rgb(" + Math.round(a) + "," + Math.round(i) + "," + Math.round(c) + ")";
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $c48d08609c4efffc$var$fromYiq(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(n.i = s.bounded(n.i, [
        -0.5957,
        .5957
    ]), n.q = s.bounded(n.q, [
        -0.5226,
        .5226
    ]), e){
        case "rgb":
            var a = 255 * (n.y + .956 * n.i + .621 * n.q), i = 255 * (n.y + -0.272 * n.i + -0.647 * n.q), c = 255 * (n.y + -1.106 * n.i + -1.703 * n.q);
            return a = s.bounded(a, [
                0,
                255
            ]), i = s.bounded(i, [
                0,
                255
            ]), c = s.bounded(c, [
                0,
                255
            ]), {
                r: a,
                g: i,
                b: c
            };
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $c48d08609c4efffc$var$fromXYZ(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers, a = s.getIlluminant("D65");
    switch(e){
        case "rgb":
            var i = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), c = s.getTransform("INVERSE_SRGB_XYZ").map(function(r) {
                return i.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return r <= .0031308 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055;
            }).map(function(r) {
                return 255 * r;
            }), u = $c48d08609c4efffc$var$slicedToArray(c, 3), l = u[0], h = u[1], v = u[2];
            return s.boundedRgb({
                r: l,
                g: h,
                b: v
            });
        case "lms":
            var p = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), f = s.getTransform("BRADFORD").map(function(r) {
                return p.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                rho: f[0],
                gamma: f[1],
                beta: f[2]
            };
        case "cielab":
            var m = n.X / a.X, d = n.Y / a.Y, b = n.Z / a.Z, g = function(r) {
                return r > .008856 ? s.cbrt(r) : (903.3 * r + 16) / 116;
            }, y = g(m), _ = g(d);
            return {
                L: 116 * _ - 16,
                a: 500 * (y - _),
                b: 200 * (_ - g(b))
            };
        case "cieluv":
            var M = n.Y / a.Y, Y = M > .008856 ? 116 * s.cbrt(M) - 16 : 903.3 * M, L = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }, X = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            };
            return {
                L: Y,
                u: 13 * Y * (L(n) - L(a)),
                v: 13 * Y * (X(n) - X(a))
            };
        case "xyY":
            return {
                x: n.X / (n.X + n.Y + n.Z),
                y: n.Y / (n.X + n.Y + n.Z),
                Y: n.Y
            };
        default:
            var Z = s.boundedRgb(o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n));
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, Z);
    }
}
function $c48d08609c4efffc$var$fromxyY(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = n.Y / n.y * n.x, i = n.Y / n.y * (1 - n.x - n.y);
            return {
                X: a,
                Y: n.Y,
                Z: i
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $c48d08609c4efffc$var$fromLms(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = [
                n.rho,
                n.gamma,
                n.beta
            ], i = s.getTransform("INVERSE_BRADFORD").map(function(r) {
                return a.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                X: 100 * i[0],
                Y: 100 * i[1],
                Z: 100 * i[2]
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $c48d08609c4efffc$var$fromCieLab(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = (n.L + 16) / 116, c = n.a / 500 + i, u = i - n.b / 200, l = function(r) {
                return Math.pow(r, 3) > .008856 ? Math.pow(r, 3) : (116 * r - 16) / 903.3;
            }, h = l(c), v = l(u), p = n.L > 903.3 * .008856 ? Math.pow(i, 3) : n.L / 903.3;
            return {
                X: h * a.X,
                Y: p * a.Y,
                Z: v * a.Z
            };
        default:
            var f = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, f);
    }
}
function $c48d08609c4efffc$var$fromCieLuv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), c = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), u = 1 / 3 * (52 * n.L / (n.u + 13 * n.L * i) - 1), l = n.L > 903.3 * .008856 ? Math.pow((n.L + 16) / 116, 3) : n.L / 903.3, h = -5 * l, v = (l * (39 * n.L / (n.v + 13 * n.L * c) - 5) - h) / (u - -1 / 3);
            return {
                X: 100 * v,
                Y: 100 * l,
                Z: 100 * (v * u + h)
            };
        case "cielch":
            var p = Math.sqrt(Math.pow(n.u, 2) + Math.pow(n.v, 2)), f = Math.atan2(n.v, n.u);
            return f < 0 && (f += 2 * Math.PI), f = s.toDeg(f), {
                L: n.L,
                C: p,
                h: f
            };
        default:
            var m = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, m);
    }
}
function $c48d08609c4efffc$var$fromCieLch(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cieluv":
            var a = s.toRad(n.h), i = n.C * Math.cos(a), c = n.C * Math.sin(a);
            return {
                L: n.L,
                u: i,
                v: c
            };
        case "hsluv":
            if (n.L > 99.9999999) return {
                hu: n.h,
                s: 0,
                l: 100
            };
            if (n.L < 1e-8) return {
                hu: n.h,
                s: 0,
                l: 0
            };
            for(var u = (n.L + 16) / 1560896, l = u > .008856 ? u : n.L / 903.3, h = s.getTransform("INVERSE_SRGB_XYZ"), v = [], p = 0; p < 3; p++)for(var f = h[p][0], m = h[p][1], d = h[p][2], b = 0; b < 2; b++){
                var g = (284517 * f - 94839 * d) * l, y = (838422 * d + 769860 * m + 731718 * f) * n.L * l - 769860 * b * n.L, _ = (632260 * d - 126452 * m) * l + 126452 * b;
                v.push({
                    m: g / _,
                    b: y / _
                });
            }
            var M = Number.MAX_VALUE, Y = s.toRad(n.h);
            v.forEach(function(r) {
                var e = r.b / (Math.sin(Y) - r.m * Math.cos(Y));
                e >= 0 && (M = Math.min(M, e));
            });
            var L = M;
            return {
                hu: n.h,
                s: n.C / L * 100,
                l: n.L
            };
        default:
            var X = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, X);
    }
}
function $c48d08609c4efffc$var$fromCieLch$1(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cielch":
            if (n.L > 99.9999999) return {
                L: 100,
                C: 0,
                h: n.hu
            };
            if (n.L < 1e-8) return {
                L: 0,
                C: 0,
                h: n.hu
            };
            for(var a = (n.l + 16) / 1560896, i = a > .008856 ? a : n.l / 903.3, c = s.getTransform("INVERSE_SRGB_XYZ"), u = [], l = 0; l < 3; l++)for(var h = c[l][0], v = c[l][1], p = c[l][2], f = 0; f < 2; f++){
                var m = (284517 * h - 94839 * p) * i, d = (838422 * p + 769860 * v + 731718 * h) * n.l * i - 769860 * f * n.l, b = (632260 * p - 126452 * v) * i + 126452 * f;
                u.push({
                    m: m / b,
                    b: d / b
                });
            }
            var g = Number.MAX_VALUE, y = s.toRad(n.hu);
            u.forEach(function(r) {
                var e = r.b / (Math.sin(y) - r.m * Math.cos(y));
                e >= 0 && (g = Math.min(g, e));
            });
            var _ = g;
            return {
                L: n.l,
                C: _ / 100 * n.s,
                h: n.hu
            };
        default:
            var M = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, M);
    }
}
function $c48d08609c4efffc$var$contains(r, e) {
    return Object.keys(r).every(function(r) {
        return -1 !== e.indexOf(r);
    });
}
function $c48d08609c4efffc$var$adapt(r, e, n, t) {
    var o = r.operations.convert(r, "XYZ", e), s = r.operations.convert(r, "lms", n);
    if (t) a = r.operations.convert(r, "lms", t);
    else var a = r.operations.convert(r, "lms", r.helpers.getIlluminant("D65"));
    var i = r.helpers.getTransform("BRADFORD"), c = r.helpers.getTransform("INVERSE_BRADFORD"), u = [
        [
            s.rho / a.rho,
            0,
            0
        ],
        [
            0,
            s.gamma / a.gamma,
            0
        ],
        [
            0,
            0,
            s.beta / a.beta
        ]
    ], l = r.helpers.matrixMultiply(c, u), h = r.helpers.matrixMultiply(l, i), v = [
        [
            o.X
        ],
        [
            o.Y
        ],
        [
            o.Z
        ]
    ], p = r.helpers.matrixMultiply(h, v), f = {
        X: p[0][0],
        Y: p[1][0],
        Z: p[2][0]
    };
    return r.helpers.ready(r, f);
}
function $c48d08609c4efffc$var$adjacent(r, e, n, t) {
    for(var o = r.operations.convert(r, "hsl", t), s = [
        {
            h: o.h,
            s: o.s,
            l: o.l
        }
    ], a = 0; a < n - 1; a++)o.h = r.helpers.negMod(o.h + e, 360), s.push({
        h: o.h,
        s: o.s,
        l: o.l
    });
    return r.helpers.ready(r, s);
}
function $c48d08609c4efffc$var$brightness(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.l += e, t.l < 0 ? t.l = 0 : t.l > 100 && (t.l = 100), r.helpers.ready(r, t);
}
function $c48d08609c4efffc$var$complementary(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.h = (n.h + 180) % 360, r.helpers.ready(r, n);
}
function $c48d08609c4efffc$var$contrast(r, e, n) {
    var t = r.operations.convert(r, "rgb", n);
    return t.r = 255 * ((t.r / 255 - .5) * e + .5), t.r < 0 ? t.r = 0 : t.r > 255 && (t.r = 255), t.g = 255 * ((t.g / 255 - .5) * e + .5), t.g < 0 ? t.g = 0 : t.g > 255 && (t.g = 255), t.b = 255 * ((t.b / 255 - .5) * e + .5), t.b < 0 ? t.b = 0 : t.b > 255 && (t.b = 255), r.helpers.ready(r, t);
}
function $c48d08609c4efffc$var$contrastRatio(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n = (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 >= 128 ? {
        r: 0,
        g: 0,
        b: 0
    } : {
        r: 255,
        g: 255,
        b: 255
    }, r.helpers.ready(r, n);
}
function $c48d08609c4efffc$var$convert(r, e, n) {
    if (Object.keys(r.conversions).indexOf(e) > -1) {
        n.colour ? n = n.colour : n.colours && (n = n.colours);
        var t = r.helpers.determineMode(n);
        return t != e ? r.conversions[t].convert(r, e, n) : n;
    }
    return r.helpers.ready(r, e);
}
function $c48d08609c4efffc$var$difference(r, e, n, t, o) {
    t = t || 1, o = o || 1;
    var s = r.operations.convert(r, "cielab", e), a = r.operations.convert(r, "cielab", n), i = Math.sqrt(Math.pow(s.a, 2) + Math.pow(s.b, 2)), c = i - Math.sqrt(Math.pow(a.a, 2) + Math.pow(a.b, 2)), u = s.L - a.L, l = s.a - a.a, h = s.b - a.b, v = Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2) - Math.pow(c, 2)), p = s.L < 16 ? .511 : .040975 * s.L / (1.01765 * s.L), f = .0638 * i / (1.0131 * i), m = Math.atan2(s.b, s.a), d = m >= 0 ? m : m + 360, b = 164 <= d && d <= 345 ? .56 + Math.abs(.2 * Math.cos(r.helpers.toRad(d + 168))) : .36 + Math.abs(.4 * Math.cos(r.helpers.toRad(d + 35))), g = Math.pow(i, 4) / (Math.pow(i, 4) + 1900), y = f * (g * b + 1 - g), _ = Math.pow(u / (t * p), 2);
    return Math.sqrt(_ + _ + _);
}
function $c48d08609c4efffc$var$fade(r, e, n, t) {
    var o = r.operations.convert(r, "rgb", n), s = r.operations.convert(r, "rgb", t), a = [
        o
    ];
    e -= 1;
    for(var i = (s.r - o.r) / e, c = (s.g - o.g) / e, u = (s.b - o.b) / e, l = {
        r: o.r,
        g: o.g,
        b: o.b
    }, h = 0; h < e - 1; h++)l.r = r.helpers.slopeMod(l.r + i, 255), l.g = r.helpers.slopeMod(l.g + c, 255), l.b = r.helpers.slopeMod(l.b + u, 255), a.push({
        r: l.r,
        g: l.g,
        b: l.b
    });
    return a.push(s), r.helpers.ready(r, a);
}
function $c48d08609c4efffc$var$greyscale(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = (n.r + n.g + n.b) / 3;
    return n = {
        r: t,
        g: t,
        b: t
    }, r.helpers.ready(r, n);
}
function $c48d08609c4efffc$var$hue(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.h = r.helpers.negMod(t.h + e, 360), r.helpers.ready(r, t);
}
function $c48d08609c4efffc$var$invert(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n.r = r.helpers.negMod(255 - n.r, 255), n.g = r.helpers.negMod(255 - n.g, 255), n.b = r.helpers.negMod(255 - n.b, 255), r.helpers.ready(r, n);
}
function $c48d08609c4efffc$var$invertLightness(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.l = 100 - n.l, r.helpers.ready(r, n);
}
function $c48d08609c4efffc$var$mid(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: (t.h + o.h) / 2,
        s: (t.s + o.s) / 2,
        l: (t.l + o.l) / 2
    };
    return r.helpers.ready(r, s);
}
function $c48d08609c4efffc$var$multiply(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: t.h,
        s: t.s,
        l: t.l / 100 * (o.l / 100) * 100
    };
    return s.l = s.l > 100 ? 100 : s.l, s.l = s.l < 0 ? 0 : s.l, r.helpers.ready(r, s);
}
function $c48d08609c4efffc$var$saturation(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.s += e, t.s < 0 ? t.s = 0 : t.s > 100 && (t.s = 100), r.helpers.ready(r, t);
}
function $c48d08609c4efffc$var$sepia(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = {};
    return t.r = .393 * n.r + .769 * n.g + .189 * n.b, t.g = .349 * n.r + .686 * n.g + .168 * n.b, t.b = .272 * n.r + .534 * n.g + .131 * n.b, r.helpers.ready(r, t);
}
function $c48d08609c4efffc$var$shade(r, e, n) {
    var t = r.operations.convert(r, "hsv", n);
    return t.v += e, t.v < 0 ? t.v = 0 : t.v > 100 && (t.v = 100), r.helpers.ready(r, t);
}
function $c48d08609c4efffc$var$temperature(r, e) {
    var n = r.operations.convert(r, "xyY", e), t = (n.x - .332) / (n.y - .1858);
    return -449 * Math.pow(t, 3) + 3525 * Math.pow(t, 2) - 6823.3 * t + 5520.33;
}
function $c48d08609c4efffc$var$tetrad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 3; o++)n.h = (n.h + 90) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
function $c48d08609c4efffc$var$triad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 2; o++)n.h = (n.h + 120) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
var $c48d08609c4efffc$var$fromHex_1 = $c48d08609c4efffc$var$fromHex, $c48d08609c4efffc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(r) {
    return typeof r;
} : function(r) {
    return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
}, $c48d08609c4efffc$var$slicedToArray = function() {
    function r(r, e) {
        var n = [], t = !0, o = !1, s = void 0;
        try {
            for(var a, i = r[Symbol.iterator](); !(t = (a = i.next()).done) && (n.push(a.value), !e || n.length !== e); t = !0);
        } catch (r) {
            o = !0, s = r;
        } finally{
            try {
                !t && i.return && i.return();
            } finally{
                if (o) throw s;
            }
        }
        return n;
    }
    return function(e, n) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return r(e, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}(), $c48d08609c4efffc$var$toConsumableArray = function(r) {
    if (Array.isArray(r)) {
        for(var e = 0, n = Array(r.length); e < r.length; e++)n[e] = r[e];
        return n;
    }
    return Array.from(r);
}, $c48d08609c4efffc$var$fromRgb_1 = $c48d08609c4efffc$var$fromRgb, $c48d08609c4efffc$var$fromCssRgb_1 = $c48d08609c4efffc$var$fromCssRgb, $c48d08609c4efffc$var$fromHsl_1 = $c48d08609c4efffc$var$fromHsl, $c48d08609c4efffc$var$fromCssHsl_1 = $c48d08609c4efffc$var$fromCssHsl, $c48d08609c4efffc$var$fromHsv_1 = $c48d08609c4efffc$var$fromHsv, $c48d08609c4efffc$var$fromCmyk_1 = $c48d08609c4efffc$var$fromCmyk, $c48d08609c4efffc$var$fromYiq_1 = $c48d08609c4efffc$var$fromYiq, $c48d08609c4efffc$var$fromXYZ_1 = $c48d08609c4efffc$var$fromXYZ, $c48d08609c4efffc$var$fromxyY_1 = $c48d08609c4efffc$var$fromxyY, $c48d08609c4efffc$var$fromLms_1 = $c48d08609c4efffc$var$fromLms, $c48d08609c4efffc$var$fromCieLab_1 = $c48d08609c4efffc$var$fromCieLab, $c48d08609c4efffc$var$fromCieLuv_1 = $c48d08609c4efffc$var$fromCieLuv, $c48d08609c4efffc$var$fromCieLch_1 = $c48d08609c4efffc$var$fromCieLch, $c48d08609c4efffc$var$fromHsluv = $c48d08609c4efffc$var$fromCieLch$1, $c48d08609c4efffc$var$index = {
    hex: {
        test: function(r) {
            return "string" == typeof r && "#" === r.slice(0, 1);
        },
        convert: $c48d08609c4efffc$var$fromHex_1
    },
    rgb: {
        test: function(r) {
            return $c48d08609c4efffc$var$contains(r, [
                "r",
                "g",
                "b"
            ]);
        },
        convert: $c48d08609c4efffc$var$fromRgb_1
    },
    cssrgb: {
        test: function(r) {
            return "string" == typeof r && "rgb(" === r.slice(0, 4);
        },
        convert: $c48d08609c4efffc$var$fromCssRgb_1
    },
    hsl: {
        test: function(r) {
            return $c48d08609c4efffc$var$contains(r, [
                "h",
                "s",
                "l"
            ]);
        },
        convert: $c48d08609c4efffc$var$fromHsl_1
    },
    csshsl: {
        test: function(r) {
            return "string" == typeof r && "hsl(" === r.slice(0, 4);
        },
        convert: $c48d08609c4efffc$var$fromCssHsl_1
    },
    hsv: {
        test: function(r) {
            return $c48d08609c4efffc$var$contains(r, [
                "h",
                "s",
                "v"
            ]);
        },
        convert: $c48d08609c4efffc$var$fromHsv_1
    },
    cmyk: {
        test: function(r) {
            return $c48d08609c4efffc$var$contains(r, [
                "c",
                "m",
                "y",
                "k"
            ]);
        },
        convert: $c48d08609c4efffc$var$fromCmyk_1
    },
    yiq: {
        test: function(r) {
            return $c48d08609c4efffc$var$contains(r, [
                "y",
                "i",
                "q"
            ]);
        },
        convert: $c48d08609c4efffc$var$fromYiq_1
    },
    XYZ: {
        test: function(r) {
            return $c48d08609c4efffc$var$contains(r, [
                "X",
                "Y",
                "Z"
            ]);
        },
        convert: $c48d08609c4efffc$var$fromXYZ_1
    },
    xyY: {
        test: function(r) {
            return $c48d08609c4efffc$var$contains(r, [
                "x",
                "y",
                "Y"
            ]);
        },
        convert: $c48d08609c4efffc$var$fromxyY_1
    },
    lms: {
        test: function(r) {
            return $c48d08609c4efffc$var$contains(r, [
                "rho",
                "gamma",
                "beta"
            ]);
        },
        convert: $c48d08609c4efffc$var$fromLms_1
    },
    cielab: {
        test: function(r) {
            return $c48d08609c4efffc$var$contains(r, [
                "L",
                "a",
                "b"
            ]);
        },
        convert: $c48d08609c4efffc$var$fromCieLab_1
    },
    cieluv: {
        test: function(r) {
            return $c48d08609c4efffc$var$contains(r, [
                "L",
                "u",
                "v"
            ]);
        },
        convert: $c48d08609c4efffc$var$fromCieLuv_1
    },
    cielch: {
        test: function(r) {
            return $c48d08609c4efffc$var$contains(r, [
                "L",
                "C",
                "h"
            ]);
        },
        convert: $c48d08609c4efffc$var$fromCieLch_1
    },
    hsluv: {
        test: function(r) {
            return $c48d08609c4efffc$var$contains(r, [
                "hu",
                "s",
                "l"
            ]);
        },
        convert: $c48d08609c4efffc$var$fromHsluv
    }
}, $c48d08609c4efffc$var$adapt_1 = $c48d08609c4efffc$var$adapt, $c48d08609c4efffc$var$adjacent_1 = $c48d08609c4efffc$var$adjacent, $c48d08609c4efffc$var$brightness_1 = $c48d08609c4efffc$var$brightness, $c48d08609c4efffc$var$complementary_1 = $c48d08609c4efffc$var$complementary, $c48d08609c4efffc$var$contrast_1 = $c48d08609c4efffc$var$contrast, $c48d08609c4efffc$var$contrastRatio_1 = $c48d08609c4efffc$var$contrastRatio, $c48d08609c4efffc$var$convert_1 = $c48d08609c4efffc$var$convert, $c48d08609c4efffc$var$difference_1 = $c48d08609c4efffc$var$difference, $c48d08609c4efffc$var$fade_1 = $c48d08609c4efffc$var$fade, $c48d08609c4efffc$var$greyscale_1 = $c48d08609c4efffc$var$greyscale, $c48d08609c4efffc$var$hue_1 = $c48d08609c4efffc$var$hue, $c48d08609c4efffc$var$invert_1 = $c48d08609c4efffc$var$invert, $c48d08609c4efffc$var$invertLightness_1 = $c48d08609c4efffc$var$invertLightness, $c48d08609c4efffc$var$mid_1 = $c48d08609c4efffc$var$mid, $c48d08609c4efffc$var$multiply_1 = $c48d08609c4efffc$var$multiply, $c48d08609c4efffc$var$saturation_1 = $c48d08609c4efffc$var$saturation, $c48d08609c4efffc$var$sepia_1 = $c48d08609c4efffc$var$sepia, $c48d08609c4efffc$var$shade_1 = $c48d08609c4efffc$var$shade, $c48d08609c4efffc$var$temperature_1 = $c48d08609c4efffc$var$temperature, $c48d08609c4efffc$var$tetrad_1 = $c48d08609c4efffc$var$tetrad, $c48d08609c4efffc$var$triad_1 = $c48d08609c4efffc$var$triad, $c48d08609c4efffc$var$index$2 = {
    adapt: $c48d08609c4efffc$var$adapt_1,
    adjacent: $c48d08609c4efffc$var$adjacent_1,
    brightness: $c48d08609c4efffc$var$brightness_1,
    complementary: $c48d08609c4efffc$var$complementary_1,
    contrast: $c48d08609c4efffc$var$contrast_1,
    contrastRatio: $c48d08609c4efffc$var$contrastRatio_1,
    convert: $c48d08609c4efffc$var$convert_1,
    difference: $c48d08609c4efffc$var$difference_1,
    fade: $c48d08609c4efffc$var$fade_1,
    greyscale: $c48d08609c4efffc$var$greyscale_1,
    hue: $c48d08609c4efffc$var$hue_1,
    invert: $c48d08609c4efffc$var$invert_1,
    invertLightness: $c48d08609c4efffc$var$invertLightness_1,
    mid: $c48d08609c4efffc$var$mid_1,
    multiply: $c48d08609c4efffc$var$multiply_1,
    saturation: $c48d08609c4efffc$var$saturation_1,
    sepia: $c48d08609c4efffc$var$sepia_1,
    shade: $c48d08609c4efffc$var$shade_1,
    temperature: $c48d08609c4efffc$var$temperature_1,
    tetrad: $c48d08609c4efffc$var$tetrad_1,
    triad: $c48d08609c4efffc$var$triad_1
}, $c48d08609c4efffc$var$constants = {
    ILLUMINANTS: {
        A: {
            X: 1.0985 * 100,
            Y: 100,
            Z: 35.585
        },
        B: {
            X: 99.072,
            Y: 100,
            Z: 85.223
        },
        C: {
            X: 98.074,
            Y: 100,
            Z: 118.232
        },
        D50: {
            X: 96.422,
            Y: 100,
            Z: 82.521
        },
        D55: {
            X: 95.682,
            Y: 100,
            Z: 92.149
        },
        D65: {
            X: 95.047,
            Y: 100,
            Z: 108.883
        },
        D75: {
            X: 94.972,
            Y: 100,
            Z: 122.638
        },
        E: {
            X: 100,
            Y: 100,
            Z: 100
        },
        F2: {
            X: .99186 * 100,
            Y: 100,
            Z: 67.393
        },
        F7: {
            X: 95.041,
            Y: 100,
            Z: 108.747
        },
        F11: {
            X: 1.00962 * 100,
            Y: 100,
            Z: 64.35
        }
    },
    TRANSFORMS: {
        BRADFORD: [
            [
                .8951,
                .2664,
                -0.1614
            ],
            [
                -0.7502,
                1.7135,
                .0367
            ],
            [
                .0389,
                -0.0685,
                1.0296
            ]
        ],
        INVERSE_BRADFORD: [
            [
                .9869929,
                -0.1470543,
                .1599627
            ],
            [
                .4323053,
                .5183603,
                .0492912
            ],
            [
                -0.0085287,
                .0400428,
                .9684867
            ]
        ],
        SRGB_XYZ: [
            [
                .4124,
                .3576,
                .1805
            ],
            [
                .2126,
                .7152,
                .0722
            ],
            [
                .0193,
                .1192,
                .9505
            ]
        ],
        INVERSE_SRGB_XYZ: [
            [
                3.2406,
                -1.5372,
                -0.4986
            ],
            [
                -0.9689,
                1.8758,
                .0415
            ],
            [
                .0557,
                -0.204,
                1.057
            ]
        ]
    }
}, $c48d08609c4efffc$var$api = function(r, e, n) {
    var t = Object.keys(r.operations).reduce(function(e, t) {
        var o = r.operations[t];
        return e[t] = function() {
            for(var e = arguments.length, t = Array(e), s = 0; s < e; s++)t[s] = arguments[s];
            var a = t.slice(0).map(function(r) {
                return "object" === (void 0 === r ? "undefined" : $c48d08609c4efffc$var$_typeof(r)) ? Object.assign({}, r) : r;
            });
            if (n && n.colours) return function e(n) {
                var t = n.map(function(n) {
                    if (Array.isArray(n)) {
                        var t = e(n);
                        return t.colours || t.colour;
                    }
                    var s = o.apply(void 0, [
                        r
                    ].concat($c48d08609c4efffc$var$toConsumableArray(a), [
                        n
                    ]));
                    return "object" === (void 0 === s ? "undefined" : $c48d08609c4efffc$var$_typeof(s)) ? s.colours || s.colour : s;
                });
                return "number" != typeof t[0] ? r.helpers.ready(r, t) : t;
            }(n.colours);
            return o.apply(void 0, [
                r
            ].concat($c48d08609c4efffc$var$toConsumableArray(a), [
                n ? n.colour : void 0
            ]));
        }, e;
    }, {});
    return n || (t = Object.assign(t, e)), t;
}, $c48d08609c4efffc$var$api_1 = $c48d08609c4efffc$var$api, $c48d08609c4efffc$var$helpers = {
    getIlluminant: function(r) {
        return $c48d08609c4efffc$var$constants.ILLUMINANTS[r];
    },
    getTransform: function(r) {
        return $c48d08609c4efffc$var$constants.TRANSFORMS[r];
    },
    matrixMultiply: function(r, e) {
        for(var n = [], t = 0; t < r.length; t++){
            n[t] = [];
            for(var o = 0; o < e[0].length; o++){
                for(var s = 0, a = 0; a < r[0].length; a++)s += r[t][a] * e[a][o];
                n[t][o] = s;
            }
        }
        return n;
    },
    cbrt: function(r) {
        if (Math.cbrt) return Math.cbrt(r);
        var e = Math.pow(Math.abs(r), 1 / 3);
        return r < 0 ? -e : e;
    },
    toRad: function(r) {
        return r * (Math.PI / 180);
    },
    toDeg: function(r) {
        return r * (180 / Math.PI);
    },
    negMod: function(r, e) {
        return (r % e + e) % e;
    },
    slopeMod: function(r) {
        function e(e, n) {
            return r.apply(this, arguments);
        }
        return e.toString = function() {
            return r.toString();
        }, e;
    }(function(r, e) {
        return r > 2 * e ? slopeMod(r - 2 * e, e) : r > e ? 2 * e - r : r < 0 ? slopeMod(r + 2 * e, e) : r;
    }),
    bounded: function(r, e) {
        return r < e[0] ? r = e[0] : r > e[1] && (r = e[1]), r;
    },
    boundedRgb: function(r) {
        var e = this, n = function(r) {
            return e.bounded(r, [
                0,
                255
            ]);
        };
        return {
            r: n(r.r),
            g: n(r.g),
            b: n(r.b)
        };
    },
    determineMode: function(r) {
        for(var e in $c48d08609c4efffc$var$index)if ($c48d08609c4efffc$var$index.hasOwnProperty(e) && $c48d08609c4efffc$var$index[e].test(r)) return e;
        return null;
    },
    ready: function(r, e) {
        var n = r.conversions, t = r.operations, o = r.helpers, s = {};
        switch(Object.prototype.toString.call(e)){
            case "[object Object]":
            case "[object String]":
                s.colour = e;
                for(var a in n)n.hasOwnProperty(a) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            o.determineMode(e);
                            return t.convert({
                                conversions: n,
                                operations: t,
                                helpers: o
                            }, r, e);
                        },
                        enumerable: !0
                    });
                }(a);
                return s = Object.assign(s, $c48d08609c4efffc$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $c48d08609c4efffc$var$constants, s));
            case "[object Array]":
                s.colours = e;
                for(var i in n)n.hasOwnProperty(i) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            return function e(s) {
                                return s.map(function(s) {
                                    return Array.isArray(s) ? e(s) : t.convert({
                                        conversions: n,
                                        operations: t,
                                        helpers: o
                                    }, r, s);
                                });
                            }(e);
                        },
                        enumerable: !0
                    });
                }(i);
                return s = Object.assign(s, $c48d08609c4efffc$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $c48d08609c4efffc$var$constants, s));
            default:
                return null;
        }
    }
}, $c48d08609c4efffc$var$helpers_1 = $c48d08609c4efffc$var$helpers, $c48d08609c4efffc$var$dependencies = {
    conversions: $c48d08609c4efffc$var$index,
    operations: $c48d08609c4efffc$var$index$2,
    helpers: $c48d08609c4efffc$var$helpers_1
}, $c48d08609c4efffc$var$entry = $c48d08609c4efffc$var$api_1($c48d08609c4efffc$var$dependencies, $c48d08609c4efffc$var$constants);
var $c48d08609c4efffc$export$2e2bcd8739ae039 = $c48d08609c4efffc$var$entry;


function $edabe14e35d9cc15$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $edabe14e35d9cc15$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $edabe14e35d9cc15$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $edabe14e35d9cc15$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $edabe14e35d9cc15$export$7229be6d7219ee6a = function hexToRGBA(hex) {
    var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var rgba = $edabe14e35d9cc15$var$_objectSpread($edabe14e35d9cc15$var$_objectSpread({}, (0, $c48d08609c4efffc$export$2e2bcd8739ae039).convert(hex).rgb), {
        a: opacity
    });
    return "rgba(".concat(Object.values(rgba).join(', '), ")");
};
var $edabe14e35d9cc15$export$bba5a971afe05444 = function getBoxShadow(color) {
    return "0 0 0 2px ".concat(color);
};
var $edabe14e35d9cc15$var$hex = '[a-z0-9]';
var $edabe14e35d9cc15$var$shortHandHexColorPattern = new RegExp("#(".concat($edabe14e35d9cc15$var$hex, ")(").concat($edabe14e35d9cc15$var$hex, ")(").concat($edabe14e35d9cc15$var$hex, ")"), 'i');
var $edabe14e35d9cc15$var$repeat = function repeat(str, times) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(Array(times)).map(function() {
        return str;
    }).join('');
};
var $edabe14e35d9cc15$var$isShortHexColor = function isShortHexColor(color) {
    return color && color.length === 4;
};
var $edabe14e35d9cc15$var$completeHexColor = function completeHexColor(colors) {
    var hex = colors.map(function(color) {
        return $edabe14e35d9cc15$var$repeat(color, 2);
    }).join('');
    return "#".concat(hex);
};
var $edabe14e35d9cc15$var$completeTriplet = function completeTriplet(colors) {
    return "#".concat($edabe14e35d9cc15$var$repeat(colors[1], 6));
};
var $edabe14e35d9cc15$var$isTriplet = function isTriplet(colors) {
    return colors[0] === colors[1] && colors[1] === colors[2];
};
var $edabe14e35d9cc15$export$db8d2130677f868c = function convertHexShorthand(color) {
    if ($edabe14e35d9cc15$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        var matches = color.match($edabe14e35d9cc15$var$shortHandHexColorPattern);
        if (matches) {
            var colors = matches.slice(1, 4);
            if ($edabe14e35d9cc15$var$isTriplet(colors)) return $edabe14e35d9cc15$var$completeTriplet(colors);
            else return $edabe14e35d9cc15$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};
var $edabe14e35d9cc15$export$10a10e7cd1193377 = function generateTextColor(color) {
    var converted = $edabe14e35d9cc15$export$db8d2130677f868c(color);
    return (0, $c48d08609c4efffc$export$2e2bcd8739ae039).contrastRatio(converted).hex;
};
var $edabe14e35d9cc15$export$77a1051494882576 = function getContrastColor(contrastValue, opacityValue, color) {
    return $edabe14e35d9cc15$export$7229be6d7219ee6a((0, $c48d08609c4efffc$export$2e2bcd8739ae039).contrast(contrastValue, color).hex, opacityValue);
};


function $4217f8c937eca669$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4217f8c937eca669$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4217f8c937eca669$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4217f8c937eca669$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4217f8c937eca669$var$generateOpacityValue = function generateOpacityValue(color) {
    return color === '#000000' ? 0.3 : 0.6;
};
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $4217f8c937eca669$var$generateButtonCSSStates = function generateButtonCSSStates(colors, buttonType) {
    var backgroundColor = colors.backgroundColor, color = colors.color, highlightColor = colors.highlightColor;
    // Add less opacity for white text so it is still legible.
    var opacityValue = $4217f8c937eca669$var$generateOpacityValue(color);
    var isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $edabe14e35d9cc15$export$7229be6d7219ee6a)(backgroundColor, 0.65) : (0, $edabe14e35d9cc15$export$77a1051494882576)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $edabe14e35d9cc15$export$bba5a971afe05444)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $edabe14e35d9cc15$export$bba5a971afe05444)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $edabe14e35d9cc15$export$7229be6d7219ee6a)(backgroundColor, 0.8) : (0, $edabe14e35d9cc15$export$77a1051494882576)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $edabe14e35d9cc15$export$bba5a971afe05444)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $edabe14e35d9cc15$export$77a1051494882576)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $edabe14e35d9cc15$export$bba5a971afe05444)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $edabe14e35d9cc15$export$77a1051494882576)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $edabe14e35d9cc15$export$bba5a971afe05444)('transparent')
        }
    };
};
var $4217f8c937eca669$var$generateCreateButtonColors = function generateCreateButtonColors(_themeBackground, themeHighlight) {
    return {
        backgroundColor: themeHighlight,
        color: (0, $edabe14e35d9cc15$export$10a10e7cd1193377)(themeHighlight),
        highlightColor: themeHighlight
    };
};
var $4217f8c937eca669$export$2e4ecffaca289a18 = function generateTheme(themeColors) {
    var backgroundColor = themeColors.backgroundColor, highlightColor = themeColors.highlightColor, name = themeColors.name;
    var color = (0, $edabe14e35d9cc15$export$10a10e7cd1193377)(backgroundColor);
    var colors = $4217f8c937eca669$var$_objectSpread($4217f8c937eca669$var$_objectSpread({}, themeColors), {}, {
        color: color
    });
    if (name === (0, $fb54c92546ddb49f$export$2491e13b198e597d)) return 0, $fb54c92546ddb49f$export$77823bc9863eaa03;
    return {
        mode: {
            create: $4217f8c937eca669$var$generateButtonCSSStates($4217f8c937eca669$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $4217f8c937eca669$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $4217f8c937eca669$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                iconColor: color,
                textColor: color,
                backgroundColor: highlightColor,
                borderRight: "var(--ds-border-width, 1px)".concat(" solid ", (0, $edabe14e35d9cc15$export$7229be6d7219ee6a)(color, 0.5))
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $edabe14e35d9cc15$export$7229be6d7219ee6a)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $edabe14e35d9cc15$export$7229be6d7219ee6a)(highlightColor, 0.8),
                    boxShadow: (0, $edabe14e35d9cc15$export$bba5a971afe05444)((0, $edabe14e35d9cc15$export$7229be6d7219ee6a)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $edabe14e35d9cc15$export$77a1051494882576)(0.1, $4217f8c937eca669$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};


var $2c11322889abbfcf$export$eeee8619e1b91cb0 = (0, $4217f8c937eca669$export$2e4ecffaca289a18)({
    name: (0, $fb54c92546ddb49f$export$2491e13b198e597d),
    backgroundColor: '#FFFFFF',
    highlightColor: '#0052CC'
});
var $2c11322889abbfcf$export$164de7ab8df77ef0 = $2c11322889abbfcf$export$eeee8619e1b91cb0;


var $7fPBF = parcelRequire("7fPBF");

var $a2fb43746167a532$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $7fPBF.createContext)((0, $2c11322889abbfcf$export$164de7ab8df77ef0));
var $a2fb43746167a532$export$d8964aec282183a3 = $a2fb43746167a532$export$2c657da244d00bd6.Provider;




var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

/* popup.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");


var $bRUy3 = parcelRequire("bRUy3");

var $7fPBF = parcelRequire("7fPBF");
function $d4de839e4a8a59ec$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useId().replace(/[:«»]/g, '_');
}
var $d4de839e4a8a59ec$export$6be90bcb437e928f = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($d4de839e4a8a59ec$export$f680877a34711e37()).concat(postfix);
    (0, $7fPBF.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $d4de839e4a8a59ec$export$6ee17796e3d70de2() {
    var uid = $d4de839e4a8a59ec$export$f680877a34711e37();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}



var $7fPBF = parcelRequire("7fPBF");

var $j9spr = parcelRequire("j9spr");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");
var $ed878be13c652cae$export$da4f61fd78d35243 = /*#__PURE__*/ function() {
    function LayerNode(id, parent) {
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, LayerNode);
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(LayerNode, [
        {
            key: "addChild",
            value: function addChild(node) {
                this.childNodes.push(node);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(node) {
                this.childNodes = this.childNodes.filter(function(child) {
                    return child.id !== node.id;
                });
            }
        },
        {
            key: "getLevel",
            value: function getLevel() {
                if (!this.parent) return 1;
                return this.parent.getLevel() + 1;
            }
        },
        {
            key: "getHeight",
            value: function getHeight() {
                if (this.childNodes.length === 0) return 1;
                return Math.max.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(this.childNodes.map(function(child) {
                    return child.getHeight();
                }))) + 1;
            }
        }
    ]);
}();


var $928dd3962972af3c$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $7fPBF.createContext)(0);
var $928dd3962972af3c$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $7fPBF.createContext)({
    current: null
});
var $928dd3962972af3c$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $7fPBF.createContext)({
    current: null
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $928dd3962972af3c$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel, levelNode = _ref.node;
    (0, $7fPBF.useEffect)(function() {
        var levelNodeSafe = levelNode.current;
        var parentNode = levelNodeSafe.parent;
        parentNode === null || parentNode === void 0 || parentNode.addChild(levelNodeSafe);
        return function() {
            parentNode === null || parentNode === void 0 || parentNode.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($928dd3962972af3c$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($928dd3962972af3c$export$18f4d8b5b3a77f59.Provider, {
        value: levelNode
    }, children));
};
var $928dd3962972af3c$export$7c885f891c940977 = function Layering(_ref2) {
    var children = _ref2.children, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? true : _ref2$isDisabled;
    var currentLevel = (0, $7fPBF.useContext)($928dd3962972af3c$export$650d12d3c2ddb8fc);
    var parentNode = (0, $7fPBF.useContext)($928dd3962972af3c$export$18f4d8b5b3a77f59);
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var newNode = (0, $7fPBF.useRef)(new (0, $ed878be13c652cae$export$da4f61fd78d35243)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($928dd3962972af3c$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($928dd3962972af3c$export$fa973f110e8f6ca8.Provider, {
        value: newNode
    }, content);
};



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $3cb1561d4943fc60$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $3c61f8857d97b8d2$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $7fPBF.createContext)(null);


function $94e39b5e33fdb909$export$1d57e79091cc3046() {
    var namespace = (0, $7fPBF.useContext)((0, $3c61f8857d97b8d2$export$644a49f3b8c50fcd));
    return namespace;
}


function $0a30dd083eb527d5$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $7fPBF.useContext)((0, $3cb1561d4943fc60$export$5fbf4d7fae6cdc00));
    var namespace = (0, $94e39b5e33fdb909$export$1d57e79091cc3046)();
    (0, $7fPBF.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $f37fe11f43b035db$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $f37fe11f43b035db$var$ExitingContext = /*#__PURE__*/ (0, $7fPBF.createContext)($f37fe11f43b035db$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $f37fe11f43b035db$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $f37fe11f43b035db$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($f37fe11f43b035db$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $f37fe11f43b035db$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $7fPBF.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $f37fe11f43b035db$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $f37fe11f43b035db$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $f37fe11f43b035db$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $f37fe11f43b035db$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $f37fe11f43b035db$var$ExitingPersistence = /*#__PURE__*/ (0, $7fPBF.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $7fPBF.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $7fPBF.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $7fPBF.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $f37fe11f43b035db$var$childrenToArray(previousChildren);
    var current = $f37fe11f43b035db$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $f37fe11f43b035db$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $f37fe11f43b035db$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $137Lh.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $f37fe11f43b035db$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $f37fe11f43b035db$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $f37fe11f43b035db$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $7fPBF.useContext)($f37fe11f43b035db$var$ExitingContext);
};
$f37fe11f43b035db$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $f37fe11f43b035db$export$2e2bcd8739ae039 = $f37fe11f43b035db$var$ExitingPersistence;



var $137Lh = parcelRequire("137Lh");

var $7fPBF = parcelRequire("7fPBF");
var $946cf4462dcf0c84$export$3dbd3405086fec7b = $7fPBF.createContext();
var $946cf4462dcf0c84$export$cbabb21c2529b130 = $7fPBF.createContext();
function $946cf4462dcf0c84$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $7fPBF.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $7fPBF.useRef(false);
    $7fPBF.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $7fPBF.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $7fPBF.createElement($946cf4462dcf0c84$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $7fPBF.createElement($946cf4462dcf0c84$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}


var $7fPBF = parcelRequire("7fPBF");
var $4ceddc5ee7e9d694$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $4ceddc5ee7e9d694$var$__DEV__ = false;
var $4ceddc5ee7e9d694$var$warning = function() {};
if ($4ceddc5ee7e9d694$var$__DEV__) {
    var $4ceddc5ee7e9d694$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $4ceddc5ee7e9d694$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $4ceddc5ee7e9d694$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$4ceddc5ee7e9d694$exports = $4ceddc5ee7e9d694$var$warning;




var $7fPBF = parcelRequire("7fPBF");
var $102370a2b7376d38$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $102370a2b7376d38$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $102370a2b7376d38$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $102370a2b7376d38$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $102370a2b7376d38$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $102370a2b7376d38$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;


function $707082bb5d4c97c5$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $7fPBF.useContext((0, $946cf4462dcf0c84$export$cbabb21c2529b130));
    var refHandler = $7fPBF.useCallback(function(node) {
        (0, $102370a2b7376d38$export$4bb192c7cacf928f)(innerRef, node);
        (0, $102370a2b7376d38$export$3dfa7c28635fe028)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $7fPBF.useEffect(function() {
        return function() {
            return (0, $102370a2b7376d38$export$4bb192c7cacf928f)(innerRef, null);
        };
    }, []);
    $7fPBF.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($4ceddc5ee7e9d694$exports)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $102370a2b7376d38$export$f52c55943429c8b6)(children)({
        ref: refHandler
    });
}



var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");

var $7fPBF = parcelRequire("7fPBF");

/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $1uJLd = parcelRequire("1uJLd");

var $8MJe2 = parcelRequire("8MJe2");

var $iKdEz = parcelRequire("iKdEz");


var $iQsIh = parcelRequire("iQsIh");

var $7fPBF = parcelRequire("7fPBF");


var $8MJe2 = parcelRequire("8MJe2");

var $137Lh = parcelRequire("137Lh");

var $gQJxI = parcelRequire("gQJxI");

var $jONa6 = parcelRequire("jONa6");

var $bRUy3 = parcelRequire("bRUy3");

var $iKdEz = parcelRequire("iKdEz");

var $jONa6 = parcelRequire("jONa6");
var $4d17af0e603f9214$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $4d17af0e603f9214$var$customThemeOptions = 'UNSAFE_themeOptions';
var $4d17af0e603f9214$var$isThemeKind = function isThemeKind(themeKind) {
    return $4d17af0e603f9214$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $4d17af0e603f9214$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $jONa6.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $4d17af0e603f9214$var$isColorMode = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
var $4d17af0e603f9214$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && $4d17af0e603f9214$var$isColorMode(id)) themeObject[kind] = id;
        if ($4d17af0e603f9214$var$isThemeKind(kind) && $4d17af0e603f9214$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $4d17af0e603f9214$var$customThemeOptions) try {
            themeObject[$4d17af0e603f9214$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
var $4d17af0e603f9214$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $4d17af0e603f9214$var$isColorMode(id) || // custom theme state
        kind === $4d17af0e603f9214$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(id) === 'object' || // other theme states
        $4d17af0e603f9214$var$isThemeKind(kind) && typeof id === 'string' && $4d17af0e603f9214$var$isThemeIds(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};



var $l4CUT = parcelRequire("l4CUT");

var $byAUq = parcelRequire("byAUq");
function $f970a2db9c3f58b1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f970a2db9c3f58b1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f970a2db9c3f58b1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f970a2db9c3f58b1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f970a2db9c3f58b1$var$defaultColorMode = 'light';
var $f970a2db9c3f58b1$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ var $f970a2db9c3f58b1$var$getThemeHtmlAttrs = function getThemeHtmlAttrs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $jONa6.themeStateDefaults)['colorMode'] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $jONa6.themeStateDefaults)['dark'] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $jONa6.themeStateDefaults)['light'] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $jONa6.themeStateDefaults)['contrastMode'] : _ref$contrastMode, _ref$motion = _ref.motion, motion = _ref$motion === void 0 ? (0, $jONa6.themeStateDefaults)['motion']() : _ref$motion, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $jONa6.themeStateDefaults)['shape']() : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $jONa6.themeStateDefaults)['spacing'] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $jONa6.themeStateDefaults)['typography'] : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $jONa6.themeStateDefaults)['UNSAFE_themeOptions'] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $4d17af0e603f9214$export$62c37ab81302621a)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, (0, $gQJxI.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $gQJxI.COLOR_MODE_ATTRIBUTE), colorMode === 'auto' ? $f970a2db9c3f58b1$var$defaultColorMode : colorMode);
    if ((0, $137Lh.fg)('platform_increased-contrast-themes')) result = $f970a2db9c3f58b1$var$_objectSpread($f970a2db9c3f58b1$var$_objectSpread({}, result), {}, (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, (0, $gQJxI.CONTRAST_MODE_ATTRIBUTE), contrastMode === 'auto' ? $f970a2db9c3f58b1$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $l4CUT.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $byAUq.hash)(optionString);
        result[0, $gQJxI.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $f970a2db9c3f58b1$export$2e2bcd8739ae039 = $f970a2db9c3f58b1$var$getThemeHtmlAttrs;


var $8MJe2 = parcelRequire("8MJe2");

var $1uJLd = parcelRequire("1uJLd");

var $iQsIh = parcelRequire("iQsIh");

var $137Lh = parcelRequire("137Lh");

var $8MJe2 = parcelRequire("8MJe2");

var $gQJxI = parcelRequire("gQJxI");

var $jONa6 = parcelRequire("jONa6");

function $dbeab7db05eff90f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dbeab7db05eff90f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dbeab7db05eff90f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dbeab7db05eff90f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $dbeab7db05eff90f$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $jONa6.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $dbeab7db05eff90f$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $gQJxI.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $gQJxI.THEME_DATA_ATTRIBUTE)) || '';
    return $dbeab7db05eff90f$var$_objectSpread($dbeab7db05eff90f$var$_objectSpread({}, (0, $4d17af0e603f9214$export$f19b488f7c0547ee)(theme)), $dbeab7db05eff90f$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $dbeab7db05eff90f$export$2e2bcd8739ae039 = $dbeab7db05eff90f$var$getGlobalTheme;



var $jONa6 = parcelRequire("jONa6");

var $l4CUT = parcelRequire("l4CUT");

var $iKdEz = parcelRequire("iKdEz");

var $137Lh = parcelRequire("137Lh");


var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $8MJe2 = parcelRequire("8MJe2");


var $gQJxI = parcelRequire("gQJxI");

var $1uJLd = parcelRequire("1uJLd");

var $iQsIh = parcelRequire("iQsIh");
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::a20c72d683b08b594c5be4160eec5f78>>
 * @codegenCommand yarn build tokens
 */ 









var $3ae0f0920083829d$var$themeImportsMap = {
    'light': function light() {
        return (parcelRequire("iJaKR"));
    },
    'light-future': function lightFuture() {
        return (parcelRequire("ksKsb"));
    },
    'light-increased-contrast': function lightIncreasedContrast() {
        return (parcelRequire("dyp25"));
    },
    'dark': function dark() {
        return (parcelRequire("koCyL"));
    },
    'dark-future': function darkFuture() {
        return (parcelRequire("g9djP"));
    },
    'dark-increased-contrast': function darkIncreasedContrast() {
        return (parcelRequire("hXzuD"));
    },
    'spacing': function spacing() {
        return (parcelRequire("canJQ"));
    },
    'typography': function typography() {
        return (parcelRequire("d8a8J"));
    },
    'shape': function shape() {
        return (parcelRequire("51zGR"));
    },
    'motion': function motion() {
        return (parcelRequire("956AA"));
    }
};
var $3ae0f0920083829d$export$2e2bcd8739ae039 = $3ae0f0920083829d$var$themeImportsMap;



var $gQJxI = parcelRequire("gQJxI");
var $703e350a61289fb7$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee(themeId) {
        var themeCss, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $gQJxI.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]:not([").concat((0, $gQJxI.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return $703e350a61289fb7$export$8a48286ed7df6720(themeId);
                case 6:
                    themeCss = _context.sent;
                    style = document.createElement('style');
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $703e350a61289fb7$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee2(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return (0, $3ae0f0920083829d$export$2e2bcd8739ae039)[themeId]();
                case 2:
                    _yield$themeImportMap = _context2.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context2.abrupt("return", themeCss);
                case 5:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function loadThemeCss(_x2) {
        return _ref2.apply(this, arguments);
    };
}();
var $703e350a61289fb7$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
var $703e350a61289fb7$export$8662df6937d86fcb = '(prefers-contrast: more)';


var $71f18dbe06a0efa6$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $71f18dbe06a0efa6$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $gQJxI.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
var $71f18dbe06a0efa6$var$darkModeMql = $71f18dbe06a0efa6$var$isMatchMediaAvailable && window.matchMedia((0, $703e350a61289fb7$export$bb1e815119d30f8b));
var $71f18dbe06a0efa6$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, ColorModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "unbindThemeChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$71f18dbe06a0efa6$var$darkModeMql) return 'light';
                return $71f18dbe06a0efa6$var$darkModeMql !== null && $71f18dbe06a0efa6$var$darkModeMql !== void 0 && $71f18dbe06a0efa6$var$darkModeMql.matches ? 'dark' : 'light';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($71f18dbe06a0efa6$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $a091c25729a976b1$exports.bind)($71f18dbe06a0efa6$var$darkModeMql, {
                    type: 'change',
                    listener: $71f18dbe06a0efa6$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $71f18dbe06a0efa6$var$SingletonColorModeObserver = new $71f18dbe06a0efa6$var$ColorModeObserver();
var $71f18dbe06a0efa6$export$2e2bcd8739ae039 = $71f18dbe06a0efa6$var$SingletonColorModeObserver;



var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $8MJe2 = parcelRequire("8MJe2");


var $gQJxI = parcelRequire("gQJxI");

var $efa63c34038e40d8$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $efa63c34038e40d8$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $gQJxI.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
var $efa63c34038e40d8$var$contrastModeMql = $efa63c34038e40d8$var$isMatchMediaAvailable && window.matchMedia((0, $703e350a61289fb7$export$8662df6937d86fcb));
var $efa63c34038e40d8$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, ContrastModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "unbindContrastChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$efa63c34038e40d8$var$contrastModeMql) return 'no-preference';
                return $efa63c34038e40d8$var$contrastModeMql !== null && $efa63c34038e40d8$var$contrastModeMql !== void 0 && $efa63c34038e40d8$var$contrastModeMql.matches ? 'more' : 'no-preference';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($efa63c34038e40d8$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $a091c25729a976b1$exports.bind)($efa63c34038e40d8$var$contrastModeMql, {
                    type: 'change',
                    listener: $efa63c34038e40d8$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $efa63c34038e40d8$var$SingletonContrastModeObserver = new $efa63c34038e40d8$var$ContrastModeObserver();
var $efa63c34038e40d8$export$2e2bcd8739ae039 = $efa63c34038e40d8$var$SingletonContrastModeObserver;


function $f1d804eb4eeba734$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $71f18dbe06a0efa6$export$2e2bcd8739ae039).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $71f18dbe06a0efa6$export$2e2bcd8739ae039).bind();
    } else (0, $71f18dbe06a0efa6$export$2e2bcd8739ae039).unbind();
    if ((0, $137Lh.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $efa63c34038e40d8$export$2e2bcd8739ae039).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $efa63c34038e40d8$export$2e2bcd8739ae039).bind();
        } else (0, $efa63c34038e40d8$export$2e2bcd8739ae039).unbind();
    }
    var themeAttributes = (0, $f970a2db9c3f58b1$export$2e2bcd8739ae039)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $71f18dbe06a0efa6$export$2e2bcd8739ae039).unbind();
        if ((0, $137Lh.fg)('platform_increased-contrast-themes')) (0, $efa63c34038e40d8$export$2e2bcd8739ae039).unbind();
    };
}



var $eMCXm = parcelRequire("eMCXm");

var $j9spr = parcelRequire("j9spr");

var $137Lh = parcelRequire("137Lh");

var $iKdEz = parcelRequire("iKdEz");

var $jONa6 = parcelRequire("jONa6");
function $1c687990636c62a0$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $jONa6.default)).find(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}


var $7cf3094101421df3$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography, motion = themeState.motion;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $137Lh.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $1c687990636c62a0$export$2e2bcd8739ae039)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $137Lh.fg)('platform_increased-contrast-themes')) {
            var increasedContrastTheme = (0, $1c687990636c62a0$export$2e2bcd8739ae039)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(new Set(themePreferences));
};
var $7cf3094101421df3$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(_themeState) {
    var themeOverridePreferences = [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(new Set(themeOverridePreferences));
};



function $7bbd8572ae8daa2b$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $7bbd8572ae8daa2b$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $7bbd8572ae8daa2b$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7bbd8572ae8daa2b$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7bbd8572ae8daa2b$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $7bbd8572ae8daa2b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $7bbd8572ae8daa2b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7bbd8572ae8daa2b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7bbd8572ae8daa2b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7bbd8572ae8daa2b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $7bbd8572ae8daa2b$var$setGlobalTheme = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee3() {
        var nextThemeState, themeLoader, _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$motion, motion, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeState, themePreferences, loadingStrategy, loadingTasks, mode, attrOfMissingCustomStyles, themeOverridePreferences, _iterator, _step, themeId, autoUnbind, _args3 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    nextThemeState = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    _ref2 = typeof nextThemeState === 'function' ? nextThemeState($7bbd8572ae8daa2b$var$_objectSpread($7bbd8572ae8daa2b$var$_objectSpread({}, (0, $jONa6.themeStateDefaults)), {}, {
                        typography: (0, $jONa6.themeStateDefaults)['typography'],
                        shape: (0, $jONa6.themeStateDefaults)['shape'](),
                        motion: (0, $jONa6.themeStateDefaults)['motion']()
                    }, (0, $dbeab7db05eff90f$export$2e2bcd8739ae039)())) : nextThemeState, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $jONa6.themeStateDefaults)['colorMode'] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $jONa6.themeStateDefaults)['contrastMode'] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $jONa6.themeStateDefaults)['dark'] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $jONa6.themeStateDefaults)['light'] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $jONa6.themeStateDefaults)['shape']() : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $jONa6.themeStateDefaults)['spacing'] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $jONa6.themeStateDefaults)['typography'] : _ref2$typography, _ref2$motion = _ref2.motion, motion = _ref2$motion === void 0 ? (0, $jONa6.themeStateDefaults)['motion']() : _ref2$motion, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $jONa6.themeStateDefaults)['UNSAFE_themeOptions'] : _ref2$UNSAFE_themeOpt; // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $137Lh.fg)('platform_increased-contrast-themes')) {
                        if (light === 'light-increased-contrast') light = 'light';
                        if (dark === 'dark-increased-contrast') dark = 'dark';
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        motion: motion,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $7cf3094101421df3$export$dd6aeb7c823fc03d)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $703e350a61289fb7$export$26cd7ae85c7144e5); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 2;
                                        return loadingStrategy(themeId);
                                    case 2:
                                        return _context.abrupt("return", _context.sent);
                                    case 3:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }()); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $l4CUT.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $jONa6.themeStateDefaults)['colorMode'];
                        attrOfMissingCustomStyles = (0, $eMCXm.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 2;
                                        return (parcelRequire("fTANy"));
                                    case 2:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 5:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 11;
                    return Promise.all(loadingTasks);
                case 11:
                    // Load override themes after standard themes
                    themeOverridePreferences = (0, $7cf3094101421df3$export$5d76d7014f4a5d08)(themeState);
                    _iterator = $7bbd8572ae8daa2b$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 13;
                    _iterator.s();
                case 15:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 21;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 19;
                    return loadingStrategy(themeId);
                case 19:
                    _context3.next = 15;
                    break;
                case 21:
                    _context3.next = 26;
                    break;
                case 23:
                    _context3.prev = 23;
                    _context3.t0 = _context3["catch"](13);
                    _iterator.e(_context3.t0);
                case 26:
                    _context3.prev = 26;
                    _iterator.f();
                    return _context3.finish(26);
                case 29:
                    autoUnbind = (0, $f1d804eb4eeba734$export$2e2bcd8739ae039)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 31:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                13,
                23,
                26,
                29
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();
var $7bbd8572ae8daa2b$export$2e2bcd8739ae039 = $7bbd8572ae8daa2b$var$setGlobalTheme;


var $gQJxI = parcelRequire("gQJxI");

var $7fPBF = parcelRequire("7fPBF");
var $090080d94235091d$export$7981b2444296e410 = /*#__PURE__*/ (0, $7fPBF.createContext)(false);
var $090080d94235091d$export$26aa23367bfbab0e = function useIsInsideAppProvider() {
    return (0, $7fPBF.useContext)($090080d94235091d$export$7981b2444296e410);
};
var $090080d94235091d$export$d2def9838ca456c0 = /*#__PURE__*/ (0, $7fPBF.createContext)(false);
var $090080d94235091d$export$a782702263f77544 = function useIsAppProviderThemingEnabled() {
    return (0, $7fPBF.useContext)($090080d94235091d$export$d2def9838ca456c0);
};



var $7fPBF = parcelRequire("7fPBF");
var $ca8cbb4e57fade18$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);
var $ca8cbb4e57fade18$export$b06130bad0bbc70f = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);



var $7fPBF = parcelRequire("7fPBF");
var $4a69f539b1bd25ad$export$332347eeb335453c = /*#__PURE__*/ (0, $7fPBF.createContext)(false);



var $7fPBF = parcelRequire("7fPBF");
var $5f3d2cb8adef153c$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);
var $5f3d2cb8adef153c$export$f7a97b47760e2a13 = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);



var $7fPBF = parcelRequire("7fPBF");

var $376ec2f2cf58213c$export$7ca11437599d653d = function useIsInsideThemeProvider() {
    var _useContext;
    return (_useContext = (0, $7fPBF.useContext)((0, $4a69f539b1bd25ad$export$332347eeb335453c))) !== null && _useContext !== void 0 ? _useContext : false;
};



var $1uJLd = parcelRequire("1uJLd");

var $iQsIh = parcelRequire("iQsIh");
var $f30181cdac346cce$export$f65ca476c09acec0 = function getDocument() {
    if (typeof document !== 'undefined') return document;
    return null;
};





var $gQJxI = parcelRequire("gQJxI");
function $1273d46d06a7a0fb$export$835a0dc855d02822(themeId) {
    var doc = (0, $f30181cdac346cce$export$f65ca476c09acec0)();
    if (!doc) return false;
    return doc.head.querySelector("style[".concat((0, $gQJxI.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
}


var $7fb3101ab11ed529$var$loadThemeCss = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(0, $1273d46d06a7a0fb$export$835a0dc855d02822)(themeId)) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return (0, $3ae0f0920083829d$export$2e2bcd8739ae039)[themeId]();
                case 6:
                    _yield$themeImportMap = _context.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context.abrupt("return", themeCss);
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $7fb3101ab11ed529$var$mountThemeCss = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee2(css, themeId) {
        var doc, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    // SSR-safe: Only mount on client side
                    doc = (0, $f30181cdac346cce$export$f65ca476c09acec0)();
                    if (doc) {
                        _context2.next = 3;
                        break;
                    }
                    return _context2.abrupt("return");
                case 3:
                    style = doc.createElement('style');
                    style.textContent = css;
                    style.dataset.theme = themeId;
                    // Prevent duplicate mounting of themes.
                    // It's possible the theme was already being loaded elsewhere.
                    if (!(0, $1273d46d06a7a0fb$export$835a0dc855d02822)(themeId)) {
                        _context2.next = 8;
                        break;
                    }
                    return _context2.abrupt("return");
                case 8:
                    doc.head.appendChild(style);
                case 9:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function mountThemeCss(_x2, _x3) {
        return _ref2.apply(this, arguments);
    };
}();
var $7fb3101ab11ed529$var$loadAndMountThemeCss = /*#__PURE__*/ function() {
    var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee3(themeId) {
        var themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 2;
                    return $7fb3101ab11ed529$var$loadThemeCss(themeId);
                case 2:
                    themeCss = _context3.sent;
                    if (themeCss) {
                        _context3.next = 5;
                        break;
                    }
                    return _context3.abrupt("return");
                case 5:
                    $7fb3101ab11ed529$var$mountThemeCss(themeCss, themeId);
                case 6:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function loadAndMountThemeCss(_x4) {
        return _ref3.apply(this, arguments);
    };
}();
var $7fb3101ab11ed529$export$7d4a7e812d176b24 = /*#__PURE__*/ function() {
    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee4(theme) {
        var themesToLoad;
        return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee4$(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    themesToLoad = Object.values(theme).filter(function(themeId) {
                        return !!themeId;
                    });
                    themesToLoad.forEach($7fb3101ab11ed529$var$loadAndMountThemeCss);
                case 2:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function loadAndMountThemes(_x5) {
        return _ref4.apply(this, arguments);
    };
}();


function $55291c26a7de8abc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $55291c26a7de8abc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $55291c26a7de8abc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $55291c26a7de8abc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $55291c26a7de8abc$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    spacing: 'spacing',
    typography: 'typography'
};
var $55291c26a7de8abc$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
var $55291c26a7de8abc$var$prefersDarkModeMql = $55291c26a7de8abc$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $55291c26a7de8abc$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $55291c26a7de8abc$var$prefersDarkModeMql !== null && $55291c26a7de8abc$var$prefersDarkModeMql !== void 0 && $55291c26a7de8abc$var$prefersDarkModeMql.matches ? 'dark' : 'light';
    return colorMode;
}
var $55291c26a7de8abc$var$contentStyles = {
    body: "_1e0c1bgi"
};
/**
 * __Theme provider__
 *
 * Provides global theming configuration.
 */ function $55291c26a7de8abc$var$ThemeProvider(_ref) {
    var children = _ref.children, _ref$defaultColorMode = _ref.defaultColorMode, defaultColorMode = _ref$defaultColorMode === void 0 ? 'auto' : _ref$defaultColorMode, defaultTheme = _ref.defaultTheme;
    var _useState = (0, $7fPBF.useState)(defaultColorMode), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), chosenColorMode = _useState2[0], setChosenColorMode = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)($55291c26a7de8abc$var$getReconciledColorMode(defaultColorMode)), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 2), reconciledColorMode = _useState4[0], setReconciledColorMode = _useState4[1];
    var _useState5 = (0, $7fPBF.useState)(function() {
        return $55291c26a7de8abc$var$_objectSpread($55291c26a7de8abc$var$_objectSpread({}, $55291c26a7de8abc$var$defaultThemeSettings), defaultTheme);
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState5, 2), theme = _useState6[0], setTheme = _useState6[1];
    var setColorMode = (0, $7fPBF.useCallback)(function(colorMode) {
        setChosenColorMode(colorMode);
        setReconciledColorMode($55291c26a7de8abc$var$getReconciledColorMode(colorMode));
    }, []);
    var setPartialTheme = (0, $7fPBF.useCallback)(function(nextTheme) {
        setTheme(function(theme) {
            return $55291c26a7de8abc$var$_objectSpread($55291c26a7de8abc$var$_objectSpread({}, theme), nextTheme);
        });
    }, []);
    var lastSetGlobalThemePromiseRef = (0, $7fPBF.useRef)(null);
    var isInsideAppProvider = (0, $090080d94235091d$export$26aa23367bfbab0e)();
    var isAppProviderThemingEnabled = (0, $090080d94235091d$export$a782702263f77544)();
    var isInsideThemeProvider = (0, $376ec2f2cf58213c$export$7ca11437599d653d)();
    /**
   * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
   *
   * This will not use sub-tree theming but instead set the global theme state using the
   * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
   * for compatibility with `@atlaskit/css-reset`.
   *
   * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
   * `html` in order to apply global theme state, which would allow a more consistent approach to
   * theme loading.
   */ var isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider && isAppProviderThemingEnabled;
    (0, $7fPBF.useEffect)(function() {
        if (isRootThemeProvider) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ var cleanupLastFnCall = /*#__PURE__*/ function() {
                var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee() {
                    var unbindFn;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!lastSetGlobalThemePromiseRef.current) {
                                    _context.next = 6;
                                    break;
                                }
                                _context.next = 3;
                                return lastSetGlobalThemePromiseRef.current;
                            case 3:
                                unbindFn = _context.sent;
                                unbindFn();
                                lastSetGlobalThemePromiseRef.current = null;
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function cleanupLastFnCall() {
                    return _ref2.apply(this, arguments);
                };
            }();
            var safelySetGlobalTheme = /*#__PURE__*/ function() {
                var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee2() {
                    var promise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return cleanupLastFnCall();
                            case 2:
                                promise = (0, $7bbd8572ae8daa2b$export$2e2bcd8739ae039)($55291c26a7de8abc$var$_objectSpread($55291c26a7de8abc$var$_objectSpread({}, theme), {}, {
                                    colorMode: reconciledColorMode
                                }));
                                lastSetGlobalThemePromiseRef.current = promise;
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                return function safelySetGlobalTheme() {
                    return _ref3.apply(this, arguments);
                };
            }();
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        } else // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, $7fb3101ab11ed529$export$7d4a7e812d176b24)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, $7fPBF.useEffect)(function() {
        if (!$55291c26a7de8abc$var$prefersDarkModeMql) return;
        var unbindListener = (0, $a091c25729a976b1$exports.bind)($55291c26a7de8abc$var$prefersDarkModeMql, {
            type: 'change',
            listener: function listener(event) {
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    var attrs = $55291c26a7de8abc$var$_objectSpread($55291c26a7de8abc$var$_objectSpread({}, (0, $f970a2db9c3f58b1$export$2e2bcd8739ae039)($55291c26a7de8abc$var$_objectSpread($55291c26a7de8abc$var$_objectSpread({}, theme), {}, {
        colorMode: reconciledColorMode
    }))), {}, (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, (0, $gQJxI.SUBTREE_THEME_ATTRIBUTE), true));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $4a69f539b1bd25ad$export$332347eeb335453c).Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $ca8cbb4e57fade18$export$49ddd74a6729fdb0).Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $ca8cbb4e57fade18$export$b06130bad0bbc70f).Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $5f3d2cb8adef153c$export$2c657da244d00bd6).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $5f3d2cb8adef153c$export$f7a97b47760e2a13).Provider, {
        value: setPartialTheme
    }, !isRootThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, attrs, {
        className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
            $55291c26a7de8abc$var$contentStyles.body
        ])
    }), children) : children)))));
}
var $55291c26a7de8abc$export$2e2bcd8739ae039 = $55291c26a7de8abc$var$ThemeProvider;


var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $8MJe2 = parcelRequire("8MJe2");

var $gQJxI = parcelRequire("gQJxI");

/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $355354ef200fb709$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $dbeab7db05eff90f$export$2e2bcd8739ae039)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $gQJxI.THEME_DATA_ATTRIBUTE),
                            (0, $gQJxI.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($355354ef200fb709$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($355354ef200fb709$export$2e2bcd8739ae039, "callbacks", new Set());



function $344992e01f8a898e$export$20f3076712c8dfa() {
    var value = (0, $7fPBF.useContext)((0, $ca8cbb4e57fade18$export$49ddd74a6729fdb0));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    var theme = (0, $dbeab7db05eff90f$export$2e2bcd8739ae039)();
    var _useState = (0, $7fPBF.useState)((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), resolvedColorMode = _useState2[0], setResolvedColorMode = _useState2[1];
    (0, $7fPBF.useEffect)(function() {
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        var observer = new (0, $355354ef200fb709$export$2e2bcd8739ae039)(function(theme) {
            setResolvedColorMode((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light');
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}



var $137Lh = parcelRequire("137Lh");
var $75cdcdc2da9c0e51$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $75cdcdc2da9c0e51$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $75cdcdc2da9c0e51$export$13f57c02915787b3 = 'atlaskit-portal';


var $a9940fa8ae3de95c$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $75cdcdc2da9c0e51$export$13f57c02915787b3);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $a9940fa8ae3de95c$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $a9940fa8ae3de95c$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $75cdcdc2da9c0e51$export$72f415121273627e));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $75cdcdc2da9c0e51$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = $a9940fa8ae3de95c$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $a9940fa8ae3de95c$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    var parent = $a9940fa8ae3de95c$var$getPortalParent();
    if (parent.contains(container)) parent.removeChild(container);
};
var $a9940fa8ae3de95c$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $a9940fa8ae3de95c$var$getPortalParent().appendChild(container);
};
var $a9940fa8ae3de95c$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $a9940fa8ae3de95c$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($a9940fa8ae3de95c$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $75cdcdc2da9c0e51$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
    return;
};
var $a9940fa8ae3de95c$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($a9940fa8ae3de95c$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $75cdcdc2da9c0e51$export$72f415121273627e));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement('div');
            parent.className = (0, $75cdcdc2da9c0e51$export$e4c79eb95c23a0da);
            parent.style.display = 'flex';
            (_getBody2 = $a9940fa8ae3de95c$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};
var $a9940fa8ae3de95c$export$7b20876b2769b301 = function removePortalParent(parentElement) {
    if ($a9940fa8ae3de95c$var$isDocumentDefined()) {
        if (parentElement) {
            var _getBody3;
            (_getBody3 = $a9940fa8ae3de95c$var$getBody()) === null || _getBody3 === void 0 || _getBody3.removeChild(parentElement);
        }
    }
};


function $7a24f4f7e30ca6e7$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children, _props$isClosed = props.isClosed, isClosed = _props$isClosed === void 0 ? false : _props$isClosed;
    var container = (0, $7fPBF.useMemo)(function() {
        return (0, $a9940fa8ae3de95c$export$26ae5ca175b4ec5a)(zIndex);
    }, [
        zIndex
    ]);
    var colorMode = (0, $344992e01f8a898e$export$20f3076712c8dfa)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $a9940fa8ae3de95c$export$c582005add11e141)(container);
    (0, $7fPBF.useEffect)(function() {
        if ((0, $137Lh.fg)('import_into_jsm_in_template_gallery_killswitch')) {
            if (isClosed) (0, $a9940fa8ae3de95c$export$da99f98bf3fe55b3)(container);
        }
    }, [
        isClosed,
        container
    ]);
    (0, $7fPBF.useEffect)(function() {
        return function() {
            (0, $a9940fa8ae3de95c$export$da99f98bf3fe55b3)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $b4ba1c853f6e1116$exports.createPortal)(colorMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $55291c26a7de8abc$export$2e2bcd8739ae039), {
        defaultColorMode: colorMode
    }, children) : children, container);
}



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");



var $137Lh = parcelRequire("137Lh");

var $7fPBF = parcelRequire("7fPBF");
var $9c7b910eca0a2995$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);



function $051996d2d7dfd8a9$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children, isClosed = props.isClosed;
    var _useState = (0, $7fPBF.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    var colorMode = (0, $344992e01f8a898e$export$20f3076712c8dfa)();
    (0, $9c7b910eca0a2995$export$700979bc83e7db82)(function() {
        if ((0, $137Lh.fg)('import_into_jsm_in_template_gallery_killswitch')) {
            if (!isClosed) {
                var tempPortalContainer = (0, $a9940fa8ae3de95c$export$fef014d7cef9e543)(zIndex);
                setAtlaskitPortal(tempPortalContainer);
                var portalParent = (0, $a9940fa8ae3de95c$export$95029ca7aca2989e)();
                if (!tempPortalContainer || !portalParent) return;
                portalParent.appendChild(tempPortalContainer);
                return function() {
                    if (portalParent) {
                        portalParent.removeChild(tempPortalContainer);
                        !portalParent.hasChildNodes() && (0, $a9940fa8ae3de95c$export$7b20876b2769b301)(portalParent);
                    }
                    setAtlaskitPortal(null);
                };
            }
        } else {
            var _tempPortalContainer = (0, $a9940fa8ae3de95c$export$fef014d7cef9e543)(zIndex);
            setAtlaskitPortal(_tempPortalContainer);
            var _portalParent = (0, $a9940fa8ae3de95c$export$95029ca7aca2989e)();
            if (!_tempPortalContainer || !_portalParent) return;
            _portalParent.appendChild(_tempPortalContainer);
            return function() {
                if (_tempPortalContainer) _portalParent.removeChild(_tempPortalContainer);
                setAtlaskitPortal(null);
            };
        }
    }, [
        zIndex,
        isClosed,
        (0, $137Lh.fg)
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fPBF.Suspense), {
        fallback: null
    }, colorMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $55291c26a7de8abc$export$2e2bcd8739ae039), {
        defaultColorMode: colorMode
    }, children) : children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $b4ba1c853f6e1116$exports.createPortal)(suspendedChildren, atlaskitPortal) : null;
}



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $c0e3c3d3c75daccd$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $7fPBF.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $9c7b910eca0a2995$export$700979bc83e7db82) : (0, $7fPBF.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $c0e3c3d3c75daccd$export$2e2bcd8739ae039 = $c0e3c3d3c75daccd$var$useIsSubsequentRender;



var $7fPBF = parcelRequire("7fPBF");
var $404700fa29e60b98$export$ed5835cc67e87f72 = 'akPortalMount';
var $404700fa29e60b98$export$80816bd900e5bd00 = 'akPortalUnmount';


var $d1aeab223da49d71$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $d1aeab223da49d71$var$getLayerName = function getLayerName(zIndex) {
    return $d1aeab223da49d71$var$zIndexToName.hasOwnProperty(zIndex) ? $d1aeab223da49d71$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $d1aeab223da49d71$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $d1aeab223da49d71$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $d1aeab223da49d71$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $d1aeab223da49d71$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}


var $39fedc8ce04b3295$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $7fPBF.useEffect)(function() {
        (0, $d1aeab223da49d71$export$2e2bcd8739ae039)((0, $404700fa29e60b98$export$ed5835cc67e87f72), zIndexNumber);
        return function() {
            (0, $d1aeab223da49d71$export$2e2bcd8739ae039)((0, $404700fa29e60b98$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $39fedc8ce04b3295$export$2e2bcd8739ae039 = $39fedc8ce04b3295$var$useFirePortalEvent;


function $cd3bc8368572caba$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy, _ref$isClosed = _ref.isClosed, isClosed = _ref$isClosed === void 0 ? false : _ref$isClosed;
    var isSubsequentRender = (0, $c0e3c3d3c75daccd$export$2e2bcd8739ae039)(mountStrategy);
    (0, $39fedc8ce04b3295$export$2e2bcd8739ae039)(zIndex);
    return !(0, $137Lh.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7a24f4f7e30ca6e7$export$2e2bcd8739ae039), {
        zIndex: zIndex,
        isClosed: isClosed
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $051996d2d7dfd8a9$export$2e2bcd8739ae039), {
        zIndex: zIndex,
        isClosed: isClosed
    }, children);
}


/* box.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $ca1b8a586a841420$var$ATOMIC_GROUP_LENGTH = 5;
function $ca1b8a586a841420$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $ca1b8a586a841420$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $2ecd6aa4c91a6f66$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $2ecd6aa4c91a6f66$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $2ecd6aa4c91a6f66$var$baseStyles = null;
var $2ecd6aa4c91a6f66$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhkby5v",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $2ecd6aa4c91a6f66$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $2ecd6aa4c91a6f66$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $2ecd6aa4c91a6f66$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $2ecd6aa4c91a6f66$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $2ecd6aa4c91a6f66$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $2ecd6aa4c91a6f66$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $2ecd6aa4c91a6f66$var$Box = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $2ecd6aa4c91a6f66$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $2ecd6aa4c91a6f66$var$_excluded2);
    var node = /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        style: style,
        ref: ref,
        className: (0, $ca1b8a586a841420$export$2e2bcd8739ae039)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $2ecd6aa4c91a6f66$var$backgroundColorMap[backgroundColor],
            backgroundColor && $2ecd6aa4c91a6f66$var$isSurfaceToken(backgroundColor) && $2ecd6aa4c91a6f66$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $2ecd6aa4c91a6f66$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $2ecd6aa4c91a6f66$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $2ecd6aa4c91a6f66$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $2ecd6aa4c91a6f66$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $7fPBF.createElement((0, $bd8fd1a07ee559ec$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $2ecd6aa4c91a6f66$export$2e2bcd8739ae039 = $2ecd6aa4c91a6f66$var$Box;
function $2ecd6aa4c91a6f66$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $2ecd6aa4c91a6f66$var$setSurfaceTokenMap;
}


/* popper-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $j9spr = parcelRequire("j9spr");

var $iKdEz = parcelRequire("iKdEz");


var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $b3ce7373d625f468$var$ATOMIC_GROUP_LENGTH = 5;
function $b3ce7373d625f468$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $b3ce7373d625f468$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $7fPBF = parcelRequire("7fPBF");


var $d2a040b34e70682b$var$ESCAPE = 'Escape';
function $d2a040b34e70682b$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $7fPBF.useRef)(false);
    var _useLayering = $d2a040b34e70682b$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $7fPBF.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $d2a040b34e70682b$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $7fPBF.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $7fPBF.useEffect)(function() {
        return (0, $a091c25729a976b1$exports.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $d2a040b34e70682b$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $7fPBF.useContext)((0, $928dd3962972af3c$export$650d12d3c2ddb8fc));
    var layerNode = (0, $7fPBF.useContext)((0, $928dd3962972af3c$export$18f4d8b5b3a77f59));
    var rootNode = (0, $7fPBF.useContext)((0, $928dd3962972af3c$export$fa973f110e8f6ca8));
    var isLayerDisabled = (0, $7fPBF.useCallback)(function() {
        // This is an impossible case, added for type safety
        if (!(layerNode !== null && layerNode !== void 0 && layerNode.current) || !(rootNode !== null && rootNode !== void 0 && rootNode.current)) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        layerNode,
        rootNode
    ]);
    var getTopLevel = (0, $7fPBF.useCallback)(function() {
        return rootNode !== null && rootNode !== void 0 && rootNode.current ? rootNode.current.getHeight() : null;
    }, [
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}


/* motion.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $iKdEz = parcelRequire("iKdEz");


var $7fPBF = parcelRequire("7fPBF");

var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $8acd82ed1a6ac19a$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $8acd82ed1a6ac19a$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$8acd82ed1a6ac19a$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $8acd82ed1a6ac19a$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $7fPBF.useState)($8acd82ed1a6ac19a$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $7fPBF.useEffect)(function() {
        if (!$8acd82ed1a6ac19a$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $a091c25729a976b1$exports.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $8acd82ed1a6ac19a$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $8acd82ed1a6ac19a$export$ff7706047246b98b = function prefersReducedMotion() {
    return $8acd82ed1a6ac19a$export$f0f789643ba5a83c;
};



var $68f554f23895ca3d$export$d0038b6e47881463 = function getDurationMs(animation) {
    var match = animation.trim().match(/^(-?\d*\.?\d+)(ms|s)\b/);
    if (!match) return 0;
    var value = parseFloat(match[1]);
    var unit = match[2];
    return unit === 's' ? value * 1000 : value;
};
var $68f554f23895ca3d$export$82b92541889a035d = function resolveMotionToken(token) {
    var cssVarMatch = token.match(/var\(\s*(--[^,\s)]+)/);
    var cssVar = cssVarMatch ? cssVarMatch[1] : null;
    if (cssVar) {
        var _getDocument;
        var documentElement = (_getDocument = (0, $f30181cdac346cce$export$f65ca476c09acec0)()) === null || _getDocument === void 0 ? void 0 : _getDocument.documentElement;
        if (documentElement) return getComputedStyle(documentElement).getPropertyValue(cssVar);
    }
    return '';
};




var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");
/**
 * An empty function which does nothing.
 */ function $ca41a225f1448cd3$export$2e2bcd8739ae039() {}



var $7fPBF = parcelRequire("7fPBF");
var $f28f1ab43e16a9fe$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $7fPBF.useEffect) : (0, $7fPBF.useLayoutEffect);


/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $7fPBF = parcelRequire("7fPBF");
function $4ca6a1236f13563f$export$c485849f2e393253() {
    var identifier = (0, $7fPBF.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}


var $f95a46c554078714$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $7fPBF.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $ca41a225f1448cd3$export$2e2bcd8739ae039)
    };
});
var $f95a46c554078714$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $4ca6a1236f13563f$export$c485849f2e393253)();
    var context = (0, $7fPBF.useContext)($f95a46c554078714$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $f95a46c554078714$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $7fPBF.useRef)([]);
    var indexes = [];
    var _useState = (0, $7fPBF.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $f28f1ab43e16a9fe$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($f95a46c554078714$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $f95a46c554078714$export$2e2bcd8739ae039 = $f95a46c554078714$var$StaggeredEntrance;


var $4730a146b2f8a766$var$styles = {
    base: "_1y0co91m _1bumglyw _sedtglyw"
};
var $4730a146b2f8a766$export$569340a66b14e0dc = /*#__PURE__*/ function(Reanimate) {
    Reanimate["enter"] = "enter";
    Reanimate["exit_then_enter"] = "exit_then_enter";
    return Reanimate;
}({});
/**
 * __Motion__
 *
 * A motion primitive that can be used to animate the entry and exit of components.
 */ var $4730a146b2f8a766$var$Motion = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, enteringAnimation = _ref.enteringAnimation, exitingAnimation = _ref.exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, xcss = _ref.xcss, testId = _ref.testId;
    var staggered = (0, $f95a46c554078714$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $f37fe11f43b035db$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var _useState = (0, $7fPBF.useState)(appear ? 'entering' : 'idle'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var reanimateRef = (0, $7fPBF.useRef)();
    var animationRef = (0, $7fPBF.useRef)();
    (0, $7fPBF.useEffect)(function() {
        if (isExiting) setState('exiting');
    }, [
        isExiting
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ var onAnimationEnd = (0, $7fPBF.useCallback)(function(state, cancelled) {
        // We are done animating, so we set the state to idle
        var newState = 'idle';
        if (state === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('exiting');
        }
        if (state === 'entering') onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('entering');
        if (reanimateRef.current === $4730a146b2f8a766$export$569340a66b14e0dc.exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = $4730a146b2f8a766$export$569340a66b14e0dc.enter;
            newState = 'entering';
        } else if (reanimateRef.current) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    (0, $7fPBF.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is idle, we don't need to do anything
        if (state === 'idle') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if ((0, $8acd82ed1a6ac19a$export$b7baf7667a68d87c)() || !exitingAnimation) {
            onAnimationEnd(state, isCancelled);
            return;
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (state === 'exiting' && exitingAnimation) {
            var duration = (0, $68f554f23895ca3d$export$d0038b6e47881463)((0, $68f554f23895ca3d$export$82b92541889a035d)(exitingAnimation));
            animationRef.current = setTimeout(function() {
                return onAnimationEnd(state, isCancelled);
            }, duration);
        } else if (state === 'entering' && enteringAnimation) {
            var _duration = (0, $68f554f23895ca3d$export$d0038b6e47881463)((0, $68f554f23895ca3d$export$82b92541889a035d)(enteringAnimation));
            animationRef.current = setTimeout(function() {
                return onAnimationEnd(state, isCancelled);
            }, _duration + delay);
        }
        return function() {
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        state,
        exitingAnimation,
        enteringAnimation,
        delay,
        paused
    ]);
    (0, $7fPBF.useImperativeHandle)(ref, function() {
        return {
            reanimate: function reanimate(value) {
                animationRef.current && clearTimeout(animationRef.current);
                reanimateRef.current = value;
                if (value === $4730a146b2f8a766$export$569340a66b14e0dc.exit_then_enter) setState('exiting');
                else if (value === $4730a146b2f8a766$export$569340a66b14e0dc.enter) setState('entering');
            }
        };
    });
    var style = {
        animation: state === 'exiting' ? "".concat(exitingAnimation, " forwards ").concat(paused ? 'paused' : '') : state === 'entering' ? "".concat(enteringAnimation, " backwards ").concat(paused ? 'paused' : '') : undefined
    };
    if (delay) style.animationDelay = "".concat(delay, "ms");
    var hasAnimationStyles = state !== 'idle';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        className: (0, $b3ce7373d625f468$export$2e2bcd8739ae039)([
            hasAnimationStyles && $4730a146b2f8a766$var$styles.base,
            xcss
        ]),
        ref: staggered.ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: hasAnimationStyles ? style : undefined,
        "data-testid": testId
    }, children);
});
var $4730a146b2f8a766$export$2e2bcd8739ae039 = $4730a146b2f8a766$var$Motion;



var $137Lh = parcelRequire("137Lh");

var $j9spr = parcelRequire("j9spr");

var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");

function $5a7577945ba4d648$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $f3e95cf60f991b3e$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $f3e95cf60f991b3e$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $f3e95cf60f991b3e$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $cb70389d1b75072d$export$8960430cfd85939f = Math.max;
var $cb70389d1b75072d$export$96ec731ed4dcb222 = Math.min;
var $cb70389d1b75072d$export$2077e0241d6afd3c = Math.round;



function $c76403bd29ed319a$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $b48f13af3862f004$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $c76403bd29ed319a$export$2e2bcd8739ae039)());
}


function $e7afd89efa353b85$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(element) ? (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $b48f13af3862f004$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $e95acb4acf5ee909$export$2e2bcd8739ae039(node) {
    var win = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $6923eaccf7a43aef$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $fa62512f527d34a4$export$2e2bcd8739ae039(node) {
    if (node === (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node) || !(0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(node)) return (0, $e95acb4acf5ee909$export$2e2bcd8739ae039)(node);
    else return (0, $6923eaccf7a43aef$export$2e2bcd8739ae039)(node);
}


function $b8ce8e5214ef2302$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $7d9656f011992b2b$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $e0a76d77d33c9d6e$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $e7afd89efa353b85$export$2e2bcd8739ae039)((0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element)).left + (0, $e95acb4acf5ee909$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $3e40145ffd569d9c$export$2e2bcd8739ae039(element) {
    return (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $998896b7349c78b7$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $585037a155f95873$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $585037a155f95873$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(offsetParent) && $585037a155f95873$var$isElementScaled(offsetParent);
    var documentElement = (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $998896b7349c78b7$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $fa62512f527d34a4$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $e0a76d77d33c9d6e$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $790f3bf845b39e8e$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $9906540837c752ea$export$2e2bcd8739ae039(element) {
    if ((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $f3e95cf60f991b3e$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $1d462f2c86b4c65a$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(node) && (0, $998896b7349c78b7$export$2e2bcd8739ae039)(node)) return node;
    return $1d462f2c86b4c65a$export$2e2bcd8739ae039((0, $9906540837c752ea$export$2e2bcd8739ae039)(node));
}





function $3d1bbe7c8c599173$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $1d462f2c86b4c65a$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $998896b7349c78b7$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($3d1bbe7c8c599173$export$2e2bcd8739ae039((0, $9906540837c752ea$export$2e2bcd8739ae039)(target)));
}







function $08ccc1de57d53c59$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(element)) >= 0;
}




function $6ebea87f6f98e49c$var$getTrueOffsetParent(element) {
    if (!(0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $6ebea87f6f98e49c$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $c76403bd29ed319a$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $c76403bd29ed319a$export$2e2bcd8739ae039)());
    if (isIE && (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $9906540837c752ea$export$2e2bcd8739ae039)(element);
    if ((0, $f3e95cf60f991b3e$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $6ebea87f6f98e49c$export$2e2bcd8739ae039(element) {
    var window = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(element);
    var offsetParent = $6ebea87f6f98e49c$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $08ccc1de57d53c59$export$2e2bcd8739ae039)(offsetParent) && (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $6ebea87f6f98e49c$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $6ebea87f6f98e49c$var$getContainingBlock(element) || window;
}


var $7c96f63dd602b579$export$1e95b668f3b82d = 'top';
var $7c96f63dd602b579$export$40e543e69a8b3fbb = 'bottom';
var $7c96f63dd602b579$export$79ffe56a765070d2 = 'right';
var $7c96f63dd602b579$export$eabcd2c8791e7bf4 = 'left';
var $7c96f63dd602b579$export$dfb5619354ba860 = 'auto';
var $7c96f63dd602b579$export$aec2ce47c367b8c3 = [
    $7c96f63dd602b579$export$1e95b668f3b82d,
    $7c96f63dd602b579$export$40e543e69a8b3fbb,
    $7c96f63dd602b579$export$79ffe56a765070d2,
    $7c96f63dd602b579$export$eabcd2c8791e7bf4
];
var $7c96f63dd602b579$export$b3571188c770cc5a = 'start';
var $7c96f63dd602b579$export$bd5df0f255a350f8 = 'end';
var $7c96f63dd602b579$export$390fd549c5303b4d = 'clippingParents';
var $7c96f63dd602b579$export$d7b7311ec04a3e8f = 'viewport';
var $7c96f63dd602b579$export$ae5ab1c730825774 = 'popper';
var $7c96f63dd602b579$export$ca50aac9f3ba507f = 'reference';
var $7c96f63dd602b579$export$368f9a87e87fa4e1 = /*#__PURE__*/ $7c96f63dd602b579$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $7c96f63dd602b579$export$b3571188c770cc5a,
        placement + "-" + $7c96f63dd602b579$export$bd5df0f255a350f8
    ]);
}, []);
var $7c96f63dd602b579$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($7c96f63dd602b579$export$aec2ce47c367b8c3, [
    $7c96f63dd602b579$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $7c96f63dd602b579$export$b3571188c770cc5a,
        placement + "-" + $7c96f63dd602b579$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $7c96f63dd602b579$export$421679a7c3d56e = 'beforeRead';
var $7c96f63dd602b579$export$aafa59e2e03f2942 = 'read';
var $7c96f63dd602b579$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $7c96f63dd602b579$export$c65e99957a05207c = 'beforeMain';
var $7c96f63dd602b579$export$f22da7240b7add18 = 'main';
var $7c96f63dd602b579$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $7c96f63dd602b579$export$8d4d2d70e7d46032 = 'beforeWrite';
var $7c96f63dd602b579$export$68d8715fc104d294 = 'write';
var $7c96f63dd602b579$export$70a6e5159acce2e6 = 'afterWrite';
var $7c96f63dd602b579$export$d087d3878fdf71d5 = [
    $7c96f63dd602b579$export$421679a7c3d56e,
    $7c96f63dd602b579$export$aafa59e2e03f2942,
    $7c96f63dd602b579$export$6964f6c886723980,
    $7c96f63dd602b579$export$c65e99957a05207c,
    $7c96f63dd602b579$export$f22da7240b7add18,
    $7c96f63dd602b579$export$bab79516f2d662fe,
    $7c96f63dd602b579$export$8d4d2d70e7d46032,
    $7c96f63dd602b579$export$68d8715fc104d294,
    $7c96f63dd602b579$export$70a6e5159acce2e6
];


function $13c27cceb4b24b2f$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $13c27cceb4b24b2f$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $13c27cceb4b24b2f$var$order(modifiers); // order based on phase
    return (0, $7c96f63dd602b579$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $4c8edc0cb4d5666b$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $320e6f4d2835a922$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $879850b738b0fd85$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $879850b738b0fd85$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $879850b738b0fd85$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $879850b738b0fd85$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $879850b738b0fd85$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(reference) ? (0, $3d1bbe7c8c599173$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $3d1bbe7c8c599173$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $3d1bbe7c8c599173$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $13c27cceb4b24b2f$export$2e2bcd8739ae039)((0, $320e6f4d2835a922$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$879850b738b0fd85$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $585037a155f95873$export$2e2bcd8739ae039)(reference, (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $790f3bf845b39e8e$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $4c8edc0cb4d5666b$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$879850b738b0fd85$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $879850b738b0fd85$export$8f7491d57c8f97a9 = /*#__PURE__*/ $879850b738b0fd85$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $1564186ea0096528$var$passive = {
    passive: true
};
function $1564186ea0096528$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $1564186ea0096528$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $1564186ea0096528$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $1564186ea0096528$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $1564186ea0096528$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $1564186ea0096528$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $1564186ea0096528$var$effect,
    data: {}
};



function $2e8856bdb677ff8e$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $cd593f453867f36a$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $334987ecb6fc56c7$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $c2c9d9550c09d816$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $cd593f453867f36a$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $7c96f63dd602b579$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $7c96f63dd602b579$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $7c96f63dd602b579$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $7c96f63dd602b579$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $334987ecb6fc56c7$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $7c96f63dd602b579$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $7c96f63dd602b579$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $e0848fa64ca744df$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $c2c9d9550c09d816$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e0848fa64ca744df$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $e0848fa64ca744df$var$popperOffsets,
    data: {}
};










var $adff49e8d09ee1e5$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $adff49e8d09ee1e5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $adff49e8d09ee1e5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4);
    var sideY = (0, $7c96f63dd602b579$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(popper);
            if ((0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $7c96f63dd602b579$export$1e95b668f3b82d) || (placement === (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4) || placement === (0, $7c96f63dd602b579$export$79ffe56a765070d2)) && variation === (0, $7c96f63dd602b579$export$bd5df0f255a350f8)) {
            sideY = (0, $7c96f63dd602b579$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4) || (placement === (0, $7c96f63dd602b579$export$1e95b668f3b82d) || placement === (0, $7c96f63dd602b579$export$40e543e69a8b3fbb)) && variation === (0, $7c96f63dd602b579$export$bd5df0f255a350f8)) {
            sideX = (0, $7c96f63dd602b579$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $adff49e8d09ee1e5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $adff49e8d09ee1e5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $adff49e8d09ee1e5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $cd593f453867f36a$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $adff49e8d09ee1e5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $adff49e8d09ee1e5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $adff49e8d09ee1e5$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $adff49e8d09ee1e5$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $5bfb95a331f35baa$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element) || !(0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $5bfb95a331f35baa$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element) || !(0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $5bfb95a331f35baa$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $5bfb95a331f35baa$var$applyStyles,
    effect: $5bfb95a331f35baa$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $a984b8b647b41eeb$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4),
        (0, $7c96f63dd602b579$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4),
        (0, $7c96f63dd602b579$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $a984b8b647b41eeb$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $7c96f63dd602b579$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $a984b8b647b41eeb$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a984b8b647b41eeb$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $a984b8b647b41eeb$var$offset
};


var $690483208b9a3207$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $690483208b9a3207$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $690483208b9a3207$var$hash[matched];
    });
}



var $13515282412eb271$var$hash = {
    start: 'end',
    end: 'start'
};
function $13515282412eb271$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $13515282412eb271$var$hash[matched];
    });
}







function $05957f974ad3b041$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(element);
    var html = (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $b48f13af3862f004$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $e0a76d77d33c9d6e$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $f2541b971d258cf0$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $e95acb4acf5ee909$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $cb70389d1b75072d$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $cb70389d1b75072d$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $e0a76d77d33c9d6e$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $cb70389d1b75072d$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $fa38ef77d76834a0$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $f3e95cf60f991b3e$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $18107b7e48021ffa$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $86796f3d3717fc99$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $86796f3d3717fc99$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $7c96f63dd602b579$export$d7b7311ec04a3e8f) ? (0, $18107b7e48021ffa$export$2e2bcd8739ae039)((0, $05957f974ad3b041$export$2e2bcd8739ae039)(element, strategy)) : (0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(clippingParent) ? $86796f3d3717fc99$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $18107b7e48021ffa$export$2e2bcd8739ae039)((0, $f2541b971d258cf0$export$2e2bcd8739ae039)((0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $86796f3d3717fc99$var$getClippingParents(element) {
    var clippingParents = (0, $3d1bbe7c8c599173$export$2e2bcd8739ae039)((0, $9906540837c752ea$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element) ? (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(clippingParent) && (0, $fa38ef77d76834a0$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $86796f3d3717fc99$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $86796f3d3717fc99$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $86796f3d3717fc99$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $cb70389d1b75072d$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $cb70389d1b75072d$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $cb70389d1b75072d$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $cb70389d1b75072d$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $86796f3d3717fc99$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $1e806166c2cdf48d$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $ff6dcd1b0906e9b8$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $1e806166c2cdf48d$export$2e2bcd8739ae039)(), paddingObject);
}


function $c8d699eb93b3090c$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $52693e6050d55014$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $7c96f63dd602b579$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $7c96f63dd602b579$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $7c96f63dd602b579$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $ff6dcd1b0906e9b8$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c8d699eb93b3090c$export$2e2bcd8739ae039)(padding, (0, $7c96f63dd602b579$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $7c96f63dd602b579$export$ae5ab1c730825774) ? (0, $7c96f63dd602b579$export$ca50aac9f3ba507f) : (0, $7c96f63dd602b579$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $86796f3d3717fc99$export$2e2bcd8739ae039)((0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $c2c9d9550c09d816$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $18107b7e48021ffa$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $7c96f63dd602b579$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $7c96f63dd602b579$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $7c96f63dd602b579$export$79ffe56a765070d2),
                (0, $7c96f63dd602b579$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $7c96f63dd602b579$export$1e95b668f3b82d),
                (0, $7c96f63dd602b579$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $a935996b3496591b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $7c96f63dd602b579$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $cd593f453867f36a$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $7c96f63dd602b579$export$368f9a87e87fa4e1) : (0, $7c96f63dd602b579$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $cd593f453867f36a$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $7c96f63dd602b579$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $a97241372b70cd07$var$getExpandedFallbackPlacements(placement) {
    if ((0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement) === (0, $7c96f63dd602b579$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $690483208b9a3207$export$2e2bcd8739ae039)(placement);
    return [
        (0, $13515282412eb271$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $13515282412eb271$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $a97241372b70cd07$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $690483208b9a3207$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $a97241372b70cd07$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement) === (0, $7c96f63dd602b579$export$dfb5619354ba860) ? (0, $a935996b3496591b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $cd593f453867f36a$export$2e2bcd8739ae039)(placement) === (0, $7c96f63dd602b579$export$b3571188c770cc5a);
        var isVertical = [
            (0, $7c96f63dd602b579$export$1e95b668f3b82d),
            (0, $7c96f63dd602b579$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $7c96f63dd602b579$export$79ffe56a765070d2) : (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $7c96f63dd602b579$export$40e543e69a8b3fbb) : (0, $7c96f63dd602b579$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $690483208b9a3207$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $690483208b9a3207$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $a97241372b70cd07$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $a97241372b70cd07$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $8d60439f259d6a8c$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $14b5cb667dce379f$export$f28d906d67a997f3(min, value, max) {
    return (0, $cb70389d1b75072d$export$8960430cfd85939f)(min, (0, $cb70389d1b75072d$export$96ec731ed4dcb222)(value, max));
}
function $14b5cb667dce379f$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $14b5cb667dce379f$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $cf968237b9d7dd4a$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $cd593f453867f36a$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $334987ecb6fc56c7$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $8d60439f259d6a8c$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $7c96f63dd602b579$export$1e95b668f3b82d) : (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $7c96f63dd602b579$export$40e543e69a8b3fbb) : (0, $7c96f63dd602b579$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $7c96f63dd602b579$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $7c96f63dd602b579$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $790f3bf845b39e8e$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $1e806166c2cdf48d$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $14b5cb667dce379f$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $14b5cb667dce379f$export$f28d906d67a997f3)(tether ? (0, $cb70389d1b75072d$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $cb70389d1b75072d$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $7c96f63dd602b579$export$1e95b668f3b82d) : (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $7c96f63dd602b579$export$40e543e69a8b3fbb) : (0, $7c96f63dd602b579$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $7c96f63dd602b579$export$1e95b668f3b82d),
            (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $14b5cb667dce379f$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $14b5cb667dce379f$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $cf968237b9d7dd4a$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $cf968237b9d7dd4a$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $e7f3cf13e0769248$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $ff6dcd1b0906e9b8$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c8d699eb93b3090c$export$2e2bcd8739ae039)(padding, (0, $7c96f63dd602b579$export$aec2ce47c367b8c3)));
};
function $e7f3cf13e0769248$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $334987ecb6fc56c7$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4),
        (0, $7c96f63dd602b579$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $e7f3cf13e0769248$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $790f3bf845b39e8e$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $7c96f63dd602b579$export$1e95b668f3b82d) : (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $7c96f63dd602b579$export$40e543e69a8b3fbb) : (0, $7c96f63dd602b579$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $14b5cb667dce379f$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $e7f3cf13e0769248$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $fa38ef77d76834a0$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $e7f3cf13e0769248$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $e7f3cf13e0769248$var$arrow,
    effect: $e7f3cf13e0769248$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $74f12d998f890694$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $74f12d998f890694$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $7c96f63dd602b579$export$1e95b668f3b82d),
        (0, $7c96f63dd602b579$export$79ffe56a765070d2),
        (0, $7c96f63dd602b579$export$40e543e69a8b3fbb),
        (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $74f12d998f890694$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $74f12d998f890694$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $74f12d998f890694$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $74f12d998f890694$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $74f12d998f890694$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $74f12d998f890694$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $74f12d998f890694$var$hide
};




var $a5ed26444bdb4d3e$export$d34966752335dd47 = [
    (0, $1564186ea0096528$export$2e2bcd8739ae039),
    (0, $e0848fa64ca744df$export$2e2bcd8739ae039),
    (0, $adff49e8d09ee1e5$export$2e2bcd8739ae039),
    (0, $5bfb95a331f35baa$export$2e2bcd8739ae039),
    (0, $a984b8b647b41eeb$export$2e2bcd8739ae039),
    (0, $a97241372b70cd07$export$2e2bcd8739ae039),
    (0, $cf968237b9d7dd4a$export$2e2bcd8739ae039),
    (0, $e7f3cf13e0769248$export$2e2bcd8739ae039),
    (0, $74f12d998f890694$export$2e2bcd8739ae039)
];
var $a5ed26444bdb4d3e$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $879850b738b0fd85$export$ed5e13716264f202)({
    defaultModifiers: $a5ed26444bdb4d3e$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $d8cf8ca5172c2b64$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $d8cf8ca5172c2b64$var$hasElementType = typeof Element !== 'undefined';
var $d8cf8ca5172c2b64$var$hasMap = typeof Map === 'function';
var $d8cf8ca5172c2b64$var$hasSet = typeof Set === 'function';
var $d8cf8ca5172c2b64$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $d8cf8ca5172c2b64$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$d8cf8ca5172c2b64$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($d8cf8ca5172c2b64$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$d8cf8ca5172c2b64$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($d8cf8ca5172c2b64$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($d8cf8ca5172c2b64$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($d8cf8ca5172c2b64$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$d8cf8ca5172c2b64$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$d8cf8ca5172c2b64$exports = function isEqual(a, b) {
    try {
        return $d8cf8ca5172c2b64$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $1ef5139d3c6891c9$var$EMPTY_MODIFIERS = [];
var $1ef5139d3c6891c9$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $7fPBF.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $1ef5139d3c6891c9$var$EMPTY_MODIFIERS
    };
    var _React$useState = $7fPBF.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $7fPBF.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $b4ba1c853f6e1116$exports.flushSync(function() {
                    setState({
                        styles: (0, $102370a2b7376d38$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $102370a2b7376d38$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $7fPBF.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($d8cf8ca5172c2b64$exports)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $7fPBF.useRef();
    (0, $102370a2b7376d38$export$700979bc83e7db82)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $102370a2b7376d38$export$700979bc83e7db82)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $a5ed26444bdb4d3e$export$8f7491d57c8f97a9);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};


var $00d767b55afb0685$var$NOOP = function NOOP() {
    return void 0;
};
var $00d767b55afb0685$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $00d767b55afb0685$var$EMPTY_MODIFIERS = [];
function $00d767b55afb0685$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $00d767b55afb0685$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $7fPBF.useContext((0, $946cf4462dcf0c84$export$3dbd3405086fec7b));
    var _React$useState = $7fPBF.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $7fPBF.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $7fPBF.useEffect(function() {
        (0, $102370a2b7376d38$export$4bb192c7cacf928f)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $7fPBF.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $1ef5139d3c6891c9$export$f4d5bf230a36dd6e)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $7fPBF.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $00d767b55afb0685$var$NOOP,
            update: update || $00d767b55afb0685$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $102370a2b7376d38$export$f52c55943429c8b6)(children)(childrenProps);
}



var $iKdEz = parcelRequire("iKdEz");
function $76724b68259c0316$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}



// Export types from PopperJS / React Popper
var $e8027c477e280fef$var$viewportPadding = 5;
var $e8027c477e280fef$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $e8027c477e280fef$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $e8027c477e280fef$var$defaultChildrenFn() {
    return null;
}
var $e8027c477e280fef$var$defaultOffset = [
    0,
    8
];
function $e8027c477e280fef$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $e8027c477e280fef$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $e8027c477e280fef$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $7fPBF.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $e8027c477e280fef$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $76724b68259c0316$export$6d8c2b45c99d6e3f)({
            viewportPadding: $e8027c477e280fef$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($e8027c477e280fef$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $7fPBF.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $00d767b55afb0685$export$badac9ada3a0bdf9), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}



var $7fPBF = parcelRequire("7fPBF");
var $374ceec9479fad9a$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $7fPBF.useRef)(true);
    (0, $7fPBF.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fPBF.Fragment), null, children);
};


// eslint-disable-next-line no-duplicate-imports

var $7fPBF = parcelRequire("7fPBF");




var $137Lh = parcelRequire("137Lh");
var $c57e3ba830849183$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
var $c57e3ba830849183$export$3dee5e4542c672d9 = function isInteractiveElement(element) {
    if ($c57e3ba830849183$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};



var $7fPBF = parcelRequire("7fPBF");
var $34a4f11347399562$export$641fa9c94086b46e = function useAnimationFrame() {
    var animationsRef = (0, $7fPBF.useRef)([]);
    var requestFrame = (0, $7fPBF.useCallback)(function(callback) {
        var id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    var cancelFrame = (0, $7fPBF.useCallback)(function(id) {
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter(function(frameId) {
            return frameId !== id;
        });
    }, []);
    var cancelAllFrames = (0, $7fPBF.useCallback)(function() {
        animationsRef.current.forEach(function(id) {
            return cancelAnimationFrame(id);
        });
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};


var $683bbd4362a00b1a$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, capture = _ref.shouldUseCaptureOnOutsideClick, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useLayering = (0, $d2a040b34e70682b$export$c8b4d54e03dee6ed)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    var _useAnimationFrame = (0, $34a4f11347399562$export$641fa9c94086b46e)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var mouseDownTarget = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $ca41a225f1448cd3$export$2e2bcd8739ae039;
        var closePopup = function closePopup(event) {
            if (onClose) {
                var _currentLevel = null;
                if (event.target instanceof HTMLElement) {
                    var _event$target$closest, _event$target$closest2;
                    _currentLevel = (_event$target$closest = (_event$target$closest2 = event.target.closest("[data-ds--level]")) === null || _event$target$closest2 === void 0 ? void 0 : _event$target$closest2.getAttribute('data-ds--level')) !== null && _event$target$closest !== void 0 ? _event$target$closest : null;
                }
                _currentLevel ? onClose(event, Number(_currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $137Lh.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(function() {
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist) return;
            if (isLayerDisabled()) {
                if (target instanceof HTMLElement) {
                    var _target$closest;
                    var layeredElement = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, "[data-ds--level]");
                    if (layeredElement) {
                        var closeType = layeredElement.getAttribute('[data-ds--close--type]');
                        if (closeType === 'single') // if the close type is single, we won't close other disabled layers when clicking outside
                        return;
                        var levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                        if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                        return;
                    }
                }
            }
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            var didClickStartInsidePopup = popupRef && mouseDownTarget.current instanceof Node && popupRef.contains(mouseDownTarget.current);
            if (!isClickOnPopup && !isClickOnTrigger && !didClickStartInsidePopup) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $c57e3ba830849183$export$3dee5e4542c672d9)(document.activeElement) && (0, $137Lh.fg)('platform_dst_popup-disable-focuslock')) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        var onMouseDown = function onMouseDown(event) {
            /**
       * Tracking the target of the mouse down event.
       * This is used to prevent the popup from closing when the user mouses down inside the popup, but then
       * moves the mouse outside the popup before releasing the mouse button.
       *
       * This is a common user interaction - users may have mistakenly clicked on something, or changed their mind,
       * so they try to cancel their click by moving their mouse away from what they had moused down on.
       *
       * Blanket uses the same technique.
       */ mouseDownTarget.current = event.target;
        };
        var onKeyDown = function onKeyDown(event) {
            var key = event.key;
            if ((key === 'Escape' || key === 'Esc') && (0, $137Lh.fg)('platform_dst_nested_escape')) {
                var _eventTarget$closest;
                var eventTarget = event.target instanceof HTMLElement ? event.target : null;
                var layeredAncestor = eventTarget === null || eventTarget === void 0 || (_eventTarget$closest = eventTarget.closest) === null || _eventTarget$closest === void 0 ? void 0 : _eventTarget$closest.call(eventTarget, '[data-ds--level]');
                var levelStr = layeredAncestor === null || layeredAncestor === void 0 ? void 0 : layeredAncestor.getAttribute('data-ds--level');
                if (levelStr && Number(levelStr) > currentLevel) return;
            }
            if ((0, $137Lh.fg)('platform_dst_popup-disable-focuslock')) {
                var shiftKey = event.shiftKey;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(function() {
                        var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    var _document$activeEleme;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(function() {
                            var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(function() {
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc' || shouldCloseOnTab && key === 'Tab') closePopup(event);
            }
        };
        var unbind = (0, $ca41a225f1448cd3$export$2e2bcd8739ae039);
        if ((0, $137Lh.fg)('popup-onclose-fix')) setTimeout(function() {
            unbind = (0, $a091c25729a976b1$exports.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                },
                {
                    type: 'mousedown',
                    listener: onMouseDown
                }
            ]);
        }, 0);
        else unbind = (0, $a091c25729a976b1$exports.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'mousedown',
                listener: onMouseDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        var unbindBlur = (0, $ca41a225f1448cd3$export$2e2bcd8739ae039);
        unbindBlur = (0, $a091c25729a976b1$exports.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return function() {
            if ((0, $137Lh.fg)('popup-onclose-fix')) setTimeout(function() {
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};



var $7fPBF = parcelRequire("7fPBF");
var $08fd599bcf7f4689$exports = {};
var $bb1b0288a0cc47aa$exports = {};
$bb1b0288a0cc47aa$exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $bb1b0288a0cc47aa$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        'input',
        'select',
        'a[href]',
        'textarea',
        'button',
        '[tabindex]'
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(','));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $bb1b0288a0cc47aa$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === 'none') result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === 'hidden';
    };
}


var $08fd599bcf7f4689$var$listeningFocusTrap = null;
function $08fd599bcf7f4689$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === 'string' ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $08fd599bcf7f4689$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($08fd599bcf7f4689$var$listeningFocusTrap) $08fd599bcf7f4689$var$listeningFocusTrap.pause();
        $08fd599bcf7f4689$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        // Ensure that the focused element doesn't capture the event that caused the focus trap activation
        setTimeout(function() {
            $08fd599bcf7f4689$var$tryFocus(firstFocusNode());
        }, 0);
        document.addEventListener('focus', checkFocus, true);
        document.addEventListener('click', checkClick, true);
        document.addEventListener('mousedown', checkPointerDown, true);
        document.addEventListener('touchstart', checkPointerDown, true);
        document.addEventListener('keydown', checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $08fd599bcf7f4689$var$listeningFocusTrap !== trap) return;
        document.removeEventListener('focus', checkFocus, true);
        document.removeEventListener('click', checkClick, true);
        document.removeEventListener('mousedown', checkPointerDown, true);
        document.removeEventListener('touchstart', checkPointerDown, true);
        document.removeEventListener('keydown', checkKey, true);
        $08fd599bcf7f4689$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === 'string') {
            node = document.querySelector(optionValue);
            if (!node) throw new Error('`' + optionName + '` refers to no known node');
        }
        if (typeof optionValue === 'function') {
            node = optionValue();
            if (!node) throw new Error('`' + optionName + '` did not return a node');
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
        if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === 'function') e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $08fd599bcf7f4689$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $08fd599bcf7f4689$var$tryFocus(lastTabbableNode);
            return $08fd599bcf7f4689$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $08fd599bcf7f4689$var$tryFocus(firstTabbableNode);
        $08fd599bcf7f4689$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $bb1b0288a0cc47aa$exports(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $08fd599bcf7f4689$var$tryFocus(lastTabbableNode);
        $08fd599bcf7f4689$var$tryFocus(firstTabbableNode);
    }
}
function $08fd599bcf7f4689$var$isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}
function $08fd599bcf7f4689$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === 'input') node.select();
}
$08fd599bcf7f4689$exports = $08fd599bcf7f4689$var$focusTrap;





var $137Lh = parcelRequire("137Lh");

var $e6a492461c861d8d$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, shouldReturnFocus = _ref.shouldReturnFocus, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useAnimationFrame = (0, $34a4f11347399562$export$641fa9c94086b46e)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var _useLayering = (0, $d2a040b34e70682b$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    (0, $7fPBF.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $ca41a225f1448cd3$export$2e2bcd8739ae039;
        if (shouldDisableFocusTrap && (0, $137Lh.fg)('platform_dst_popup-disable-focuslock')) {
            var isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            var popups = document.querySelectorAll("[data-ds--level=\"".concat(currentLevel - 1, "\"]"));
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(function() {
                    triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $ca41a225f1448cd3$export$2e2bcd8739ae039;
            }
        }
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: (0, $137Lh.fg)('platform_dst_nested_escape') ? false : true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($08fd599bcf7f4689$exports)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(function() {
            focusTrap.activate();
        });
        return function() {
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};


var $980078ac860e7e7d$var$_excluded = [
    "shouldRenderToParent",
    "shouldFitContainer",
    "children",
    "appearance",
    "className",
    "isReferenceHidden",
    "shouldFitViewport"
];
var $980078ac860e7e7d$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
var $980078ac860e7e7d$var$fullWidthStyles = null;
var $980078ac860e7e7d$var$wrapperStyles = {
    root: "_2rko12b0 _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs130s _syazi7uo _1q1l1bhr _nt751r31 _49pcglyw _1hvw1o36",
    rootT26Shape: "_2rko1mok",
    rootLayer: "_1pby1nn1",
    fullWidth: "_1bsb1osq"
};
var $980078ac860e7e7d$var$scrollableStyles = null;
var $980078ac860e7e7d$var$blanketStyles = null;
var $980078ac860e7e7d$var$modalStyles = null;
var $980078ac860e7e7d$var$newModalStyles = null;
var $980078ac860e7e7d$var$focusRingStyles = {
    root: "_mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y"
};
var $980078ac860e7e7d$var$placementMap = {
    'top': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut)"
    },
    'top-start': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut)"
    },
    'top-end': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut)"
    },
    'bottom': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut)"
    },
    'bottom-start': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut)"
    },
    'bottom-end': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut)"
    },
    'left': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut)"
    },
    'left-start': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut)"
    },
    'left-end': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut)"
    },
    'right': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut)"
    },
    'right-start': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut)"
    },
    'right-end': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut)"
    }
};
var $980078ac860e7e7d$var$DefaultPopupComponent = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, shouldFitContainer = props.shouldFitContainer, children = props.children, appearance = props.appearance, className = props.className, _isReferenceHidden = props.isReferenceHidden, shouldFitViewport = props.shouldFitViewport, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(props, $980078ac860e7e7d$var$_excluded);
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $b3ce7373d625f468$export$2e2bcd8739ae039)([
            $980078ac860e7e7d$var$wrapperStyles.root,
            (0, $137Lh.fg)('platform-dst-shape-theme-default') && $980078ac860e7e7d$var$wrapperStyles.rootT26Shape,
            appearance === 'UNSAFE_modal-below-sm' && !(0, $137Lh.fg)('platform_dst_nav4_flyout_menu_slots_close_button') && "_dk5d1b66 _c71ldtre _kqsw1n9t _152t1b66",
            appearance === 'UNSAFE_modal-below-sm' && (0, $137Lh.fg)('platform_dst_nav4_flyout_menu_slots_close_button') && "_dk5d1b66 _c71l1ei0 _kqsw1n9t _152t1b66",
            (!shouldRenderToParent || shouldFitViewport) && "_1reo1wug _18m91wug",
            shouldFitContainer && "_1bsb1osq",
            className
        ])
    }, htmlAttributes, {
        ref: !(0, $137Lh.fg)('platform-dst-motion-uplift') ? ref : undefined
    }), children);
});
function $980078ac860e7e7d$var$PopperWrapper(_ref) {
    var xcss = _ref.xcss, isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $980078ac860e7e7d$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldRenderToParent = _ref.shouldRenderToParent, shouldFitContainer = _ref.shouldFitContainer, shouldDisableFocusLock = _ref.shouldDisableFocusLock, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance;
    var _useState = (0, $7fPBF.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    var shouldDisableFocusTrap = role !== 'dialog';
    (0, $e6a492461c861d8d$export$10c5169755ce7bd7)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $683bbd4362a00b1a$export$92dae2778ae88f9d)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    var _useLayering = (0, $d2a040b34e70682b$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    var mergedModifiers = (0, $7fPBF.useMemo)(function() {
        return [
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(modifiers || []));
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $e8027c477e280fef$export$badac9ada3a0bdf9), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update, isReferenceHidden = _ref2.isReferenceHidden;
        var popupContainer = /*#__PURE__*/ $7fPBF.createElement(PopupContainer, {
            className: (0, $b3ce7373d625f468$export$2e2bcd8739ae039)([
                xcss,
                // @ts-expect-error: `ax` is not typed correctly
                !initialFocusRef && (0, $137Lh.fg)('platform-design-system-apply-popup-wrapper-focus') && $980078ac860e7e7d$var$focusRingStyles.root
            ]),
            appearance: appearance,
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: !(0, $137Lh.fg)('platform-dst-motion-uplift') ? function(node) {
                if (node) {
                    if (typeof _ref3 === 'function') _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            } : undefined,
            style: (0, $137Lh.fg)('platform-dst-motion-uplift') || appearance === 'UNSAFE_modal-below-sm' ? {} : style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent,
            shouldFitContainer: shouldFitContainer,
            shouldFitViewport: shouldFitViewport,
            isReferenceHidden: isReferenceHidden
        }, /*#__PURE__*/ $7fPBF.createElement((0, $374ceec9479fad9a$export$51eddd7655ca235a), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
        var container = /*#__PURE__*/ $7fPBF.createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style,
            // using tabIndex={-1} would cause a bug where Safari focuses
            // first on the browser address bar when using keyboard
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === 'function') _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            "data-testid": "".concat(testId, "--container"),
            className: (0, $b3ce7373d625f468$export$2e2bcd8739ae039)([
                $980078ac860e7e7d$var$wrapperStyles.rootLayer,
                shouldFitContainer && $980078ac860e7e7d$var$wrapperStyles.fullWidth
            ])
        }, placement === 'auto' || placement === 'auto-start' || placement === 'auto-end' ? popupContainer : /*#__PURE__*/ $7fPBF.createElement((0, $4730a146b2f8a766$export$2e2bcd8739ae039), {
            enteringAnimation: $980078ac860e7e7d$var$placementMap[placement].enter,
            exitingAnimation: $980078ac860e7e7d$var$placementMap[placement].exit
        }, popupContainer));
        return /*#__PURE__*/ $7fPBF.createElement((0, $7fPBF.Fragment), null, (0, $137Lh.fg)('platform-dst-motion-uplift') ? container : popupContainer, appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ $7fPBF.createElement("div", {
            className: (0, $b3ce7373d625f468$export$2e2bcd8739ae039)([
                "_1r04idpf _kqsw1n9t _bfhk1i5c"
            ])
        }));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$980078ac860e7e7d$export$2e2bcd8739ae039 = $980078ac860e7e7d$var$PopperWrapper;



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $ccb3268e0e41dfd7$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};


var $c70859cfdb477947$var$_window, $c70859cfdb477947$var$_window$matchMedia, $c70859cfdb477947$var$_window2, $c70859cfdb477947$var$_window2$matchMedia, $c70859cfdb477947$var$_window3, $c70859cfdb477947$var$_window3$matchMedia, $c70859cfdb477947$var$_window4, $c70859cfdb477947$var$_window4$matchMedia, $c70859cfdb477947$var$_window5, $c70859cfdb477947$var$_window5$matchMedia, $c70859cfdb477947$var$_window6, $c70859cfdb477947$var$_window6$matchMedia, $c70859cfdb477947$var$_window7, $c70859cfdb477947$var$_window7$matchMedia, $c70859cfdb477947$var$_window8, $c70859cfdb477947$var$_window8$matchMedia, $c70859cfdb477947$var$_window9, $c70859cfdb477947$var$_window9$matchMedia, $c70859cfdb477947$var$_window0, $c70859cfdb477947$var$_window0$matchMedia, $c70859cfdb477947$var$_window1, $c70859cfdb477947$var$_window1$matchMedia;
var $c70859cfdb477947$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($c70859cfdb477947$var$_window = window) === null || $c70859cfdb477947$var$_window === void 0 || ($c70859cfdb477947$var$_window$matchMedia = $c70859cfdb477947$var$_window.matchMedia) === null || $c70859cfdb477947$var$_window$matchMedia === void 0 ? void 0 : $c70859cfdb477947$var$_window$matchMedia.call($c70859cfdb477947$var$_window, (0, $ccb3268e0e41dfd7$export$987d49ffe1b0900f).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($c70859cfdb477947$var$_window2 = window) === null || $c70859cfdb477947$var$_window2 === void 0 || ($c70859cfdb477947$var$_window2$matchMedia = $c70859cfdb477947$var$_window2.matchMedia) === null || $c70859cfdb477947$var$_window2$matchMedia === void 0 ? void 0 : $c70859cfdb477947$var$_window2$matchMedia.call($c70859cfdb477947$var$_window2, (0, $ccb3268e0e41dfd7$export$987d49ffe1b0900f).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($c70859cfdb477947$var$_window3 = window) === null || $c70859cfdb477947$var$_window3 === void 0 || ($c70859cfdb477947$var$_window3$matchMedia = $c70859cfdb477947$var$_window3.matchMedia) === null || $c70859cfdb477947$var$_window3$matchMedia === void 0 ? void 0 : $c70859cfdb477947$var$_window3$matchMedia.call($c70859cfdb477947$var$_window3, (0, $ccb3268e0e41dfd7$export$987d49ffe1b0900f).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($c70859cfdb477947$var$_window4 = window) === null || $c70859cfdb477947$var$_window4 === void 0 || ($c70859cfdb477947$var$_window4$matchMedia = $c70859cfdb477947$var$_window4.matchMedia) === null || $c70859cfdb477947$var$_window4$matchMedia === void 0 ? void 0 : $c70859cfdb477947$var$_window4$matchMedia.call($c70859cfdb477947$var$_window4, (0, $ccb3268e0e41dfd7$export$987d49ffe1b0900f).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($c70859cfdb477947$var$_window5 = window) === null || $c70859cfdb477947$var$_window5 === void 0 || ($c70859cfdb477947$var$_window5$matchMedia = $c70859cfdb477947$var$_window5.matchMedia) === null || $c70859cfdb477947$var$_window5$matchMedia === void 0 ? void 0 : $c70859cfdb477947$var$_window5$matchMedia.call($c70859cfdb477947$var$_window5, (0, $ccb3268e0e41dfd7$export$987d49ffe1b0900f).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($c70859cfdb477947$var$_window6 = window) === null || $c70859cfdb477947$var$_window6 === void 0 || ($c70859cfdb477947$var$_window6$matchMedia = $c70859cfdb477947$var$_window6.matchMedia) === null || $c70859cfdb477947$var$_window6$matchMedia === void 0 ? void 0 : $c70859cfdb477947$var$_window6$matchMedia.call($c70859cfdb477947$var$_window6, (0, $ccb3268e0e41dfd7$export$987d49ffe1b0900f).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($c70859cfdb477947$var$_window7 = window) === null || $c70859cfdb477947$var$_window7 === void 0 || ($c70859cfdb477947$var$_window7$matchMedia = $c70859cfdb477947$var$_window7.matchMedia) === null || $c70859cfdb477947$var$_window7$matchMedia === void 0 ? void 0 : $c70859cfdb477947$var$_window7$matchMedia.call($c70859cfdb477947$var$_window7, (0, $ccb3268e0e41dfd7$export$987d49ffe1b0900f).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($c70859cfdb477947$var$_window8 = window) === null || $c70859cfdb477947$var$_window8 === void 0 || ($c70859cfdb477947$var$_window8$matchMedia = $c70859cfdb477947$var$_window8.matchMedia) === null || $c70859cfdb477947$var$_window8$matchMedia === void 0 ? void 0 : $c70859cfdb477947$var$_window8$matchMedia.call($c70859cfdb477947$var$_window8, (0, $ccb3268e0e41dfd7$export$987d49ffe1b0900f).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($c70859cfdb477947$var$_window9 = window) === null || $c70859cfdb477947$var$_window9 === void 0 || ($c70859cfdb477947$var$_window9$matchMedia = $c70859cfdb477947$var$_window9.matchMedia) === null || $c70859cfdb477947$var$_window9$matchMedia === void 0 ? void 0 : $c70859cfdb477947$var$_window9$matchMedia.call($c70859cfdb477947$var$_window9, (0, $ccb3268e0e41dfd7$export$987d49ffe1b0900f).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($c70859cfdb477947$var$_window0 = window) === null || $c70859cfdb477947$var$_window0 === void 0 || ($c70859cfdb477947$var$_window0$matchMedia = $c70859cfdb477947$var$_window0.matchMedia) === null || $c70859cfdb477947$var$_window0$matchMedia === void 0 ? void 0 : $c70859cfdb477947$var$_window0$matchMedia.call($c70859cfdb477947$var$_window0, (0, $ccb3268e0e41dfd7$export$987d49ffe1b0900f).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($c70859cfdb477947$var$_window1 = window) === null || $c70859cfdb477947$var$_window1 === void 0 || ($c70859cfdb477947$var$_window1$matchMedia = $c70859cfdb477947$var$_window1.matchMedia) === null || $c70859cfdb477947$var$_window1$matchMedia === void 0 ? void 0 : $c70859cfdb477947$var$_window1$matchMedia.call($c70859cfdb477947$var$_window1, (0, $ccb3268e0e41dfd7$export$987d49ffe1b0900f).below.xl.replace('@media ', '').trim())
};
var $c70859cfdb477947$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $7fPBF.useRef)(listener);
    (0, $7fPBF.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $c70859cfdb477947$var$queries[queryString];
    (0, $7fPBF.useLayoutEffect)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $a091c25729a976b1$exports.bind)(mq, {
            type: 'change',
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};


function $4a219ef45b6d3244$export$4065aef1d79a5730(_ref) {
    var _appearance = _ref.appearance, _shouldRenderToParent = _ref.shouldRenderToParent;
    var mq = (0, $c70859cfdb477947$export$49e55ae2c03d6045)('below.sm', function(e) {
        setIsSmallViewport(!!e.matches);
    });
    var _useState = (0, $7fPBF.useState)(!!(mq !== null && mq !== void 0 && mq.matches)), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), isSmallViewport = _useState2[0], setIsSmallViewport = _useState2[1];
    var appearance = _appearance === 'UNSAFE_modal-below-sm' && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    var shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $5a55a5f3b6574bfb$export$7cc5c058dd769dff = function useGetMemoizedMergedTriggerRef() {
    var _useState = (0, $7fPBF.useState)(function() {
        return (0, $859f0395401445ad$export$2e2bcd8739ae039)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 1), getMemoizedMergedTriggerRef = _useState2[0];
    return getMemoizedMergedTriggerRef;
};



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $56b5f08ac36f7b93$export$5d3a2de79e07b376 = function useGetMemoizedMergedTriggerRefNew() {
    var _useState = (0, $7fPBF.useState)(function() {
        return (0, $859f0395401445ad$export$2e2bcd8739ae039)(function(ref, setTriggerRef) {
            return function(node) {
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 1), getMemoizedMergedTriggerRefNew = _useState2[0];
    return getMemoizedMergedTriggerRefNew;
};


var $634277c72baa6a6b$var$defaultLayer = 400;
var $634277c72baa6a6b$var$wrapperStyles = {
    root: "_kqswh2mm"
};
var $634277c72baa6a6b$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $7fPBF.memo)(function(_ref) {
    var xcss = _ref.xcss, _ref$appearance = _ref.appearance, inAppearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, isOpen = _ref.isOpen, providedId = _ref.id, offset = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, onClose = _ref.onClose, boundary = _ref.boundary, _ref$rootBoundary = _ref.rootBoundary, rootBoundary = _ref$rootBoundary === void 0 ? 'viewport' : _ref$rootBoundary, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, fallbackPlacements = _ref.fallbackPlacements, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? $634277c72baa6a6b$var$defaultLayer : _ref$zIndex, _ref$shouldUseCapture = _ref.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _ref$shouldUseCapture === void 0 ? false : _ref$shouldUseCapture, _ref$shouldRenderToPa = _ref.shouldRenderToParent, inShouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldDisableFoc = _ref.shouldDisableFocusLock, shouldDisableFocusLock = _ref$shouldDisableFoc === void 0 ? false : _ref$shouldDisableFoc, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport;
    var _useState = (0, $7fPBF.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var getMergedTriggerRef = (0, $5a55a5f3b6574bfb$export$7cc5c058dd769dff)();
    var getMergedTriggerRefNew = (0, $56b5f08ac36f7b93$export$5d3a2de79e07b376)();
    var generatedId = (0, $d4de839e4a8a59ec$export$f680877a34711e37)();
    var _usePopupAppearance = (0, $4a219ef45b6d3244$export$4065aef1d79a5730)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    }), appearance = _usePopupAppearance.appearance, shouldRenderToParent = _usePopupAppearance.shouldRenderToParent;
    var id = providedId || generatedId;
    var handleOpenLayerObserverCloseSignal = (0, $7fPBF.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose(null);
    }, [
        onClose
    ]);
    (0, $0a30dd083eb527d5$export$469bb693f11edc7f)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal,
        type: 'popup'
    });
    var renderPopperWrapper = /*#__PURE__*/ $7fPBF.createElement((0, $928dd3962972af3c$export$7c885f891c940977), {
        isDisabled: false
    }, /*#__PURE__*/ $7fPBF.createElement((0, $980078ac860e7e7d$export$2e2bcd8739ae039), {
        xcss: xcss,
        appearance: appearance,
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        shouldReturnFocus: shouldReturnFocus,
        triggerRef: triggerRef,
        strategy: shouldFitContainer ? 'absolute' : strategy,
        role: role,
        label: label,
        titleId: titleId,
        modifiers: modifiers,
        shouldFitViewport: shouldFitViewport
    }));
    var popupContent = /*#__PURE__*/ $7fPBF.createElement((0, $946cf4462dcf0c84$export$d0d38e7dec7a1a61), null, /*#__PURE__*/ $7fPBF.createElement((0, $707082bb5d4c97c5$export$e0be378c32fb70a7), null, function(_ref2) {
        var ref = _ref2.ref;
        return trigger({
            ref: !(0, $137Lh.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
            'aria-controls': isOpen ? id : undefined,
            'aria-expanded': isOpen,
            'aria-haspopup': role === 'dialog' && (0, $137Lh.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
        });
    }), !(0, $137Lh.fg)('platform-dst-motion-uplift') && isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ $7fPBF.createElement((0, $cd3bc8368572caba$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, renderPopperWrapper)), (0, $137Lh.fg)('platform-dst-motion-uplift') && /*#__PURE__*/ $7fPBF.createElement((0, $f37fe11f43b035db$export$2e2bcd8739ae039), null, isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ $7fPBF.createElement((0, $cd3bc8368572caba$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, renderPopperWrapper))));
    if (shouldFitContainer) return /*#__PURE__*/ $7fPBF.createElement((0, $2ecd6aa4c91a6f66$export$2e2bcd8739ae039), {
        xcss: $634277c72baa6a6b$var$wrapperStyles.root
    }, popupContent);
    return popupContent;
});


var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2c055187658302fb$export$2e2bcd8739ae039 = (0, $634277c72baa6a6b$export$129a32eedafa97c5);



var $7fPBF = parcelRequire("7fPBF");

var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");
function $39f1f51c54808bc1$export$2f62ee6831462844() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef();
    var observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef();
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    }), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_React$useState, 2), state = _React$useState2[0], setState = _React$useState2[1];
    var threshold = options.threshold, root = options.root, rootMargin = options.rootMargin;
    var setRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(function(node) {
        observerInstance.current = new IntersectionObserver(function(entries) {
            if (entries && entries.length) {
                var intersection = entries[0];
                var isIntersecting = intersection.isIntersecting, intersectionRatio = intersection.intersectionRatio;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    var numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    var inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        return function() {
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}


var $f34a516af4ebd831$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(function(_ref) {
    var setWidth = _ref.setWidth, offscreen = _ref.offscreen;
    var _useInView = (0, $39f1f51c54808bc1$export$2f62ee6831462844)({
        /* Optional options */ threshold: 0
    }), _useInView2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useInView, 3), inViewRef = _useInView2[0], inView = _useInView2[1], target = _useInView2[2];
    var observer = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(function() {
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver(function(entries) {
            if (!Array.isArray(entries) || !entries.length) return;
            var width = entries[0].contentRect.width;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        var currentObserver = observer.current;
        var resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return function() {
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});


var $66ddca22d5092ead$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $f34a516af4ebd831$export$ff983d2a2b6112ea), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $66ddca22d5092ead$export$2e2bcd8739ae039 = $66ddca22d5092ead$export$b2ad68b9bc407b80;



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");
var $932a0672a1772507$exports = {};
var $26dbabe73f482390$exports = {};
var $f328ff7ee4fde81a$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f328ff7ee4fde81a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$f328ff7ee4fde81a$exports = $f328ff7ee4fde81a$var$isObject;


var $f76380021e37252e$exports = {};
var $13147c93e8511c05$exports = {};
var $6845d21fa7e75b3b$exports = {};
/** Detect free variable `global` from Node.js. */ var $6845d21fa7e75b3b$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
$6845d21fa7e75b3b$exports = $6845d21fa7e75b3b$var$freeGlobal;


/** Detect free variable `self`. */ var $13147c93e8511c05$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $13147c93e8511c05$var$root = $6845d21fa7e75b3b$exports || $13147c93e8511c05$var$freeSelf || Function('return this')();
$13147c93e8511c05$exports = $13147c93e8511c05$var$root;


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $f76380021e37252e$var$now = function() {
    return $13147c93e8511c05$exports.Date.now();
};
$f76380021e37252e$exports = $f76380021e37252e$var$now;


var $027fc05d9ba60754$exports = {};
var $f49ef2e63e1337d0$exports = {};
var $6abb93fe126bbf26$exports = {};
/** Used to match a single whitespace character. */ var $6abb93fe126bbf26$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $6abb93fe126bbf26$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $6abb93fe126bbf26$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$6abb93fe126bbf26$exports = $6abb93fe126bbf26$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $f49ef2e63e1337d0$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $f49ef2e63e1337d0$var$baseTrim(string) {
    return string ? string.slice(0, $6abb93fe126bbf26$exports(string) + 1).replace($f49ef2e63e1337d0$var$reTrimStart, '') : string;
}
$f49ef2e63e1337d0$exports = $f49ef2e63e1337d0$var$baseTrim;



var $2fffc1449db40502$exports = {};
var $ae3fe6c5950c122e$exports = {};
var $c9c36e86f7d6f497$exports = {};

/** Built-in value references. */ var $c9c36e86f7d6f497$var$Symbol = $13147c93e8511c05$exports.Symbol;
$c9c36e86f7d6f497$exports = $c9c36e86f7d6f497$var$Symbol;


var $76f84bdae49ee13c$exports = {};

/** Used for built-in method references. */ var $76f84bdae49ee13c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $76f84bdae49ee13c$var$hasOwnProperty = $76f84bdae49ee13c$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $76f84bdae49ee13c$var$nativeObjectToString = $76f84bdae49ee13c$var$objectProto.toString;
/** Built-in value references. */ var $76f84bdae49ee13c$var$symToStringTag = $c9c36e86f7d6f497$exports ? $c9c36e86f7d6f497$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $76f84bdae49ee13c$var$getRawTag(value) {
    var isOwn = $76f84bdae49ee13c$var$hasOwnProperty.call(value, $76f84bdae49ee13c$var$symToStringTag), tag = value[$76f84bdae49ee13c$var$symToStringTag];
    try {
        value[$76f84bdae49ee13c$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $76f84bdae49ee13c$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$76f84bdae49ee13c$var$symToStringTag] = tag;
        else delete value[$76f84bdae49ee13c$var$symToStringTag];
    }
    return result;
}
$76f84bdae49ee13c$exports = $76f84bdae49ee13c$var$getRawTag;


var $77d9fbfccc3fe2a6$exports = {};
/** Used for built-in method references. */ var $77d9fbfccc3fe2a6$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $77d9fbfccc3fe2a6$var$nativeObjectToString = $77d9fbfccc3fe2a6$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $77d9fbfccc3fe2a6$var$objectToString(value) {
    return $77d9fbfccc3fe2a6$var$nativeObjectToString.call(value);
}
$77d9fbfccc3fe2a6$exports = $77d9fbfccc3fe2a6$var$objectToString;


/** `Object#toString` result references. */ var $ae3fe6c5950c122e$var$nullTag = '[object Null]', $ae3fe6c5950c122e$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $ae3fe6c5950c122e$var$symToStringTag = $c9c36e86f7d6f497$exports ? $c9c36e86f7d6f497$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $ae3fe6c5950c122e$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $ae3fe6c5950c122e$var$undefinedTag : $ae3fe6c5950c122e$var$nullTag;
    return $ae3fe6c5950c122e$var$symToStringTag && $ae3fe6c5950c122e$var$symToStringTag in Object(value) ? $76f84bdae49ee13c$exports(value) : $77d9fbfccc3fe2a6$exports(value);
}
$ae3fe6c5950c122e$exports = $ae3fe6c5950c122e$var$baseGetTag;


var $97dbbc1a069ce16a$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $97dbbc1a069ce16a$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$97dbbc1a069ce16a$exports = $97dbbc1a069ce16a$var$isObjectLike;


/** `Object#toString` result references. */ var $2fffc1449db40502$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $2fffc1449db40502$var$isSymbol(value) {
    return typeof value == 'symbol' || $97dbbc1a069ce16a$exports(value) && $ae3fe6c5950c122e$exports(value) == $2fffc1449db40502$var$symbolTag;
}
$2fffc1449db40502$exports = $2fffc1449db40502$var$isSymbol;


/** Used as references for various `Number` constants. */ var $027fc05d9ba60754$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $027fc05d9ba60754$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $027fc05d9ba60754$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $027fc05d9ba60754$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $027fc05d9ba60754$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $027fc05d9ba60754$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($2fffc1449db40502$exports(value)) return $027fc05d9ba60754$var$NAN;
    if ($f328ff7ee4fde81a$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $f328ff7ee4fde81a$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $f49ef2e63e1337d0$exports(value);
    var isBinary = $027fc05d9ba60754$var$reIsBinary.test(value);
    return isBinary || $027fc05d9ba60754$var$reIsOctal.test(value) ? $027fc05d9ba60754$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $027fc05d9ba60754$var$reIsBadHex.test(value) ? $027fc05d9ba60754$var$NAN : +value;
}
$027fc05d9ba60754$exports = $027fc05d9ba60754$var$toNumber;


/** Error message constants. */ var $26dbabe73f482390$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $26dbabe73f482390$var$nativeMax = Math.max, $26dbabe73f482390$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $26dbabe73f482390$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($26dbabe73f482390$var$FUNC_ERROR_TEXT);
    wait = $027fc05d9ba60754$exports(wait) || 0;
    if ($f328ff7ee4fde81a$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $26dbabe73f482390$var$nativeMax($027fc05d9ba60754$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $26dbabe73f482390$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $f76380021e37252e$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($f76380021e37252e$exports());
    }
    function debounced() {
        var time = $f76380021e37252e$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$26dbabe73f482390$exports = $26dbabe73f482390$var$debounce;



/** Error message constants. */ var $932a0672a1772507$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $932a0672a1772507$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($932a0672a1772507$var$FUNC_ERROR_TEXT);
    if ($f328ff7ee4fde81a$exports(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $26dbabe73f482390$exports(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
$932a0672a1772507$exports = $932a0672a1772507$var$throttle;



// Prevent width detector from triggering too many re-renders
var $29a6ecad9d545dc1$var$THROTTLE_INTERVAL = 64;
// Approx min width of items (based of "More" size)
var $29a6ecad9d545dc1$var$ITEM_APPROX_MINWIDTH = 70;
var $29a6ecad9d545dc1$var$calculateHash = function calculateHash(w, n) {
    return w + '#' + n;
};
var $29a6ecad9d545dc1$var$updateHashRef = function updateHashRef(currentRef, value) {
    currentRef.unshift(value);
    currentRef.length = 3;
};
var $29a6ecad9d545dc1$var$OverflowContext = /*#__PURE__*/ (0, $7fPBF.createContext)({
    isVisible: true,
    openOverflowMenu: (0, $f48d740006cf3f7d$export$2e2bcd8739ae039),
    closeOverflowMenu: (0, $f48d740006cf3f7d$export$2e2bcd8739ae039)
});
var $29a6ecad9d545dc1$export$a3a2def3937905a0 = function OverflowProvider(_ref) {
    var children = _ref.children, isVisible = _ref.isVisible, openOverflowMenu = _ref.openOverflowMenu, closeOverflowMenu = _ref.closeOverflowMenu;
    var Provider = $29a6ecad9d545dc1$var$OverflowContext.Provider;
    var value = (0, $7fPBF.useMemo)(function() {
        return {
            isVisible: isVisible,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: closeOverflowMenu
        };
    }, [
        isVisible,
        openOverflowMenu,
        closeOverflowMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Provider, {
        value: value
    }, children);
};
var $29a6ecad9d545dc1$export$3fcfc71fab3314f2 = function useOverflowStatus() {
    return (0, $7fPBF.useContext)($29a6ecad9d545dc1$var$OverflowContext);
};
var $29a6ecad9d545dc1$export$705aa66a39c35bf7 = function useOverflowController(nodes) {
    var items = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.toArray(nodes);
    var _useState = (0, $7fPBF.useState)(9999), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), width = _useState2[0], setWidth = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)(items.length), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 2), itemsLimit = _useState4[0], setItemsLimit = _useState4[1];
    var _useState5 = (0, $7fPBF.useState)({}), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState5, 2), forceEffectValue = _useState6[0], triggerForceEffect = _useState6[1];
    // Storing items approximate width so we can try expanding when there is enough room
    var itemsWidths = (0, $7fPBF.useRef)([]).current;
    // Storing a couple of width + items count in order to stabilize
    var hashRef = (0, $7fPBF.useRef)([]);
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var throttleSetWidth = (0, $7fPBF.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($932a0672a1772507$exports)))(setWidth, $29a6ecad9d545dc1$var$THROTTLE_INTERVAL), [
        setWidth
    ]);
    (0, $7fPBF.useEffect)(function() {
        var lastItemWidth = itemsWidths[itemsLimit] || 0;
        var wasJustLimited = lastItemWidth < 0;
        var currentHash = $29a6ecad9d545dc1$var$calculateHash(width, itemsLimit);
        if (hashRef.current[0] === currentHash) {
            // After removing an item, if width has not changed yet we schedule a force update
            // to handle case where removing an item does not actually trigger width change
            var t = setTimeout(function() {
                $29a6ecad9d545dc1$var$updateHashRef(hashRef.current, '');
                triggerForceEffect({});
            }, $29a6ecad9d545dc1$var$THROTTLE_INTERVAL * 1.5);
            return function() {
                return clearTimeout(t);
            };
        }
        if (wasJustLimited) {
            // Width was updated either via resize or after changing the limit
            // we cap the width between ITEM_APPROX_MINWIDTH and 2*ITEM_APPROX_MINWIDTH
            // because width is throttled as when fast expanding/resizing partialWidth
            // will not be reliable (edge case)
            var partialWidth = Math.max(Math.min(width + lastItemWidth, $29a6ecad9d545dc1$var$ITEM_APPROX_MINWIDTH * 2), $29a6ecad9d545dc1$var$ITEM_APPROX_MINWIDTH);
            itemsWidths[itemsLimit] = partialWidth;
        }
        if (width < $29a6ecad9d545dc1$var$ITEM_APPROX_MINWIDTH * 0.9 && itemsLimit) {
            // If current width is less than an item approx width we remove an item
            // marking the width as negative so we will calculate it on width update
            // plus we set the hash to stabilise and not removing more than one element
            // until we are sure width was updated
            var nextHash = $29a6ecad9d545dc1$var$calculateHash(width, itemsLimit - 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit - 1);
                itemsWidths[itemsLimit - 1] = -(width || 1);
                $29a6ecad9d545dc1$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
        /**
     * This is not necessarily equal to `lastItemWidth` because the
     * ```js
     * if (wasJustLimited) {}
     * ```
     * branch above modifies `itemsWidths`.
     *
     * Using `lastItemWidth` here can cause collapsing behavior to fail,
     * such as the issue reported in DSP-7329.
     */ var currentLastItemWidth = itemsWidths[itemsLimit] || 0;
        if (width - currentLastItemWidth > $29a6ecad9d545dc1$var$ITEM_APPROX_MINWIDTH * 1.1 && itemsLimit < items.length) {
            // If we have enough room to accomodate next item width we increase the limit
            // unless it has been recently removed
            var _nextHash = $29a6ecad9d545dc1$var$calculateHash(width, itemsLimit + 1);
            if (hashRef.current.indexOf(_nextHash) === -1) {
                setItemsLimit(itemsLimit + 1);
                $29a6ecad9d545dc1$var$updateHashRef(hashRef.current, _nextHash);
            }
            return;
        }
        return;
    }, [
        width,
        hashRef,
        itemsLimit,
        itemsWidths,
        forceEffectValue,
        items.length
    ]);
    return {
        visibleItems: items.slice(0, itemsLimit),
        overflowItems: items.slice(itemsLimit),
        updateWidth: throttleSetWidth
    };
};
var // Used to extract props for useOverflowStatus();
// eslint-disable-next-line import/no-anonymous-default-export
$29a6ecad9d545dc1$export$2e2bcd8739ae039 = function(_props) {};




var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $022e926cdc9ff4be$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($022e926cdc9ff4be$exports, "__esModule", {
    value: true
});
$022e926cdc9ff4be$exports.default = void 0;

var $022e926cdc9ff4be$var$_react = $022e926cdc9ff4be$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $022e926cdc9ff4be$var$_baseNew = $022e926cdc9ff4be$var$_interopRequireDefault((parcelRequire("ep5sO")));
function $022e926cdc9ff4be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $022e926cdc9ff4be$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $022e926cdc9ff4be$var$_react.default.createElement($022e926cdc9ff4be$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$022e926cdc9ff4be$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $022e926cdc9ff4be$var$_default = $022e926cdc9ff4be$exports.default = $022e926cdc9ff4be$var$ChevronDownIcon;




var $8MJe2 = parcelRequire("8MJe2");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");



var $iKdEz = parcelRequire("iKdEz");

var $8MJe2 = parcelRequire("8MJe2");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");
var $d9d3aa9f0354c727$var$_excluded = [
    "children"
];
function $d9d3aa9f0354c727$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $7fPBF.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $7fPBF.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(props, $d9d3aa9f0354c727$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $7fPBF.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $7fPBF.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}


// Create default global light theme
var $8e3d3e3ac4379509$var$dest = (0, $d9d3aa9f0354c727$export$25d302a5b900a763)(function() {
    return {
        mode: 'light'
    };
});
var $8e3d3e3ac4379509$var$Provider = $8e3d3e3ac4379509$var$dest.Provider;
var $8e3d3e3ac4379509$var$Consumer = $8e3d3e3ac4379509$var$dest.Consumer;
var $8e3d3e3ac4379509$export$7692396083754928 = $8e3d3e3ac4379509$var$dest.useTheme;
var $8e3d3e3ac4379509$var$Theme = {
    Provider: $8e3d3e3ac4379509$var$Provider,
    Consumer: $8e3d3e3ac4379509$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8e3d3e3ac4379509$export$2e2bcd8739ae039 = $8e3d3e3ac4379509$var$Theme;




var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");
function $7ef5eb1b79d03b33$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $7fPBF.useRef)(true);
    (0, $7fPBF.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $7fPBF = parcelRequire("7fPBF");

var $1cc23763944a34fc$var$BORDER_WIDTH = 2;
var $1cc23763944a34fc$var$baseFocusOutsideStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    outline: "".concat($1cc23763944a34fc$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $1cc23763944a34fc$var$BORDER_WIDTH
});
var $1cc23763944a34fc$var$baseInsetStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$1cc23763944a34fc$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $1cc23763944a34fc$var$focusRingStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $1cc23763944a34fc$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $1cc23763944a34fc$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $1cc23763944a34fc$var$insetFocusRingStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $1cc23763944a34fc$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $1cc23763944a34fc$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $1cc23763944a34fc$var$FocusRing = /*#__PURE__*/ (0, $7fPBF.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $1cc23763944a34fc$var$baseInsetStyles : $1cc23763944a34fc$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $1cc23763944a34fc$var$insetFocusRingStyles : $1cc23763944a34fc$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $3ebaaabf76fb5db5$export$9b9c0f9d9f3552b8), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $7fPBF.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $7fPBF.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$1cc23763944a34fc$var$FocusRing.displayName = 'FocusRing';
var $1cc23763944a34fc$export$2e2bcd8739ae039 = $1cc23763944a34fc$var$FocusRing;



function $7760ac857756d3d4$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $7760ac857756d3d4$var$tabKeyCode = 9;
function $7760ac857756d3d4$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $7760ac857756d3d4$var$tabKeyCode) return;
    $7760ac857756d3d4$var$abort(event);
}
var $7760ac857756d3d4$var$block = {
    onMouseDownCapture: $7760ac857756d3d4$var$abort,
    onMouseUpCapture: $7760ac857756d3d4$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $7760ac857756d3d4$var$onKey,
    onKeyUpCapture: $7760ac857756d3d4$var$onKey,
    onTouchStartCapture: $7760ac857756d3d4$var$abort,
    onTouchEndCapture: $7760ac857756d3d4$var$abort,
    onPointerDownCapture: $7760ac857756d3d4$var$abort,
    onPointerUpCapture: $7760ac857756d3d4$var$abort,
    onClickCapture: $7760ac857756d3d4$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $7760ac857756d3d4$var$abort
};
var $7760ac857756d3d4$var$doNotBlock = {};
function $7760ac857756d3d4$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $7760ac857756d3d4$var$doNotBlock : $7760ac857756d3d4$var$block;
}


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

function $2b5ee14e6bcd59f1$export$7ad0316cc0dd65a(_ref) {
    var spacing = _ref.spacing;
    return (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : '0 2px',
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

function $04f35238632c6e3e$export$1b5827d324e945b1(_ref) {
    var hasOverlay = _ref.hasOverlay;
    return (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

function $d742ceced8a21a13$export$864eea3f4ec3368f(_ref) {
    var spacing = _ref.spacing;
    return (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : "0 2px",
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}



var $7fPBF = parcelRequire("7fPBF");

var $9e9914169cfaa549$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $7fPBF.isValidElement)(children) && children.type === (0, $d1b9d01570e45f55$export$2e2bcd8739ae039);
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var $560ab36c8189075e$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};


var $3a147e18a4e384a4$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $3a147e18a4e384a4$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $3a147e18a4e384a4$var$iconBeforeSpacingFixStyle = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $3a147e18a4e384a4$var$iconAfterSpacingFixStyle = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $3a147e18a4e384a4$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $9e9914169cfaa549$export$20bbd2efb0d734c4)(children)) return null;
    return spacingStyles;
};
var $3a147e18a4e384a4$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $9e9914169cfaa549$export$20bbd2efb0d734c4)(children)) return children;
    return children ? (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("span", {
        css: childrenStyles
    }, children) : null;
};
var $3a147e18a4e384a4$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'default' : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? 'a' : 'button' : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $f48d740006cf3f7d$export$2e2bcd8739ae039) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $f48d740006cf3f7d$export$2e2bcd8739ae039) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 'default' : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? 'button' : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(props, $3a147e18a4e384a4$var$_excluded);
    var ourRef = (0, $7fPBF.useRef)();
    var setRef = (0, $7fPBF.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $7ef5eb1b79d03b33$export$2e2bcd8739ae039)(ourRef, autoFocus);
    var interactionContext = (0, $7fPBF.useContext)((0, $48ec410b84640600$export$2e2bcd8739ae039));
    var handleClick = (0, $7fPBF.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $593ac790924c31ca$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@atlaskit/button",
        packageVersion: "23.11.3",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $7fPBF.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $7fPBF.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)((0, $04f35238632c6e3e$export$1b5827d324e945b1)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-warning-inverse, #292A2E)", " !important")
        }
    };
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $1cc23763944a34fc$export$2e2bcd8739ae039), null, (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $3a147e18a4e384a4$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $7760ac857756d3d4$export$2e2bcd8739ae039)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $d742ceced8a21a13$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $3a147e18a4e384a4$var$getSpacingFix(children, $3a147e18a4e384a4$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $3a147e18a4e384a4$var$getChildren(children, [
        fadeStyles,
        (0, $2b5ee14e6bcd59f1$export$7ad0316cc0dd65a)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $d742ceced8a21a13$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $3a147e18a4e384a4$var$getSpacingFix(children, $3a147e18a4e384a4$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("span", {
        css: [
            (0, $560ab36c8189075e$export$1a9fe1b84c876bb5),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3a147e18a4e384a4$export$2e2bcd8739ae039 = $3a147e18a4e384a4$var$ButtonBase;



function $d988f83806b6fe3b$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $9e9914169cfaa549$export$20bbd2efb0d734c4)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}



var $7fPBF = parcelRequire("7fPBF");

function $17284fc89b8fb309$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $17284fc89b8fb309$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? 'default' : _ref2$spacing;
    var size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $aacfdd39b28e059d$export$2e2bcd8739ae039), {
        size: size,
        label: ", Loading",
        appearance: $17284fc89b8fb309$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $c0a075e8a009a481$export$437a7f77d13d7916(current, values) {
    return current(values);
}


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// This styling approach works by generating a 'style' and applying with maximum specificity
// To do this we are overwriting all pseudo selectors
function $0efe9e7c0b085f89$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $8MJe2 = parcelRequire("8MJe2");

var $8MJe2 = parcelRequire("8MJe2");

var $137Lh = parcelRequire("137Lh");
function $59b2a1271eae7c3c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $59b2a1271eae7c3c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $59b2a1271eae7c3c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $59b2a1271eae7c3c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $59b2a1271eae7c3c$var$gridSize = 8;
var $59b2a1271eae7c3c$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
var $59b2a1271eae7c3c$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: 'auto'
};
var $59b2a1271eae7c3c$var$lineHeights = {
    default: $59b2a1271eae7c3c$var$heights.default,
    compact: $59b2a1271eae7c3c$var$heights.compact,
    none: 'inherit'
};
var $59b2a1271eae7c3c$var$padding = {
    // 10px gutter
    default: "0 ".concat($59b2a1271eae7c3c$var$gridSize + $59b2a1271eae7c3c$var$gridSize / 4, "px"),
    compact: "0 ".concat($59b2a1271eae7c3c$var$gridSize + $59b2a1271eae7c3c$var$gridSize / 4, "px"),
    none: '0'
};
var $59b2a1271eae7c3c$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($59b2a1271eae7c3c$var$gridSize / 4, "px"),
    default: "0 ".concat($59b2a1271eae7c3c$var$gridSize / 4, "px"),
    none: '0'
};
var $59b2a1271eae7c3c$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
var $59b2a1271eae7c3c$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
var $59b2a1271eae7c3c$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': $59b2a1271eae7c3c$var$_objectSpread($59b2a1271eae7c3c$var$_objectSpread({}, $59b2a1271eae7c3c$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    }),
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $59b2a1271eae7c3c$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    }
};
var $59b2a1271eae7c3c$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    }
};
var $59b2a1271eae7c3c$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
var $59b2a1271eae7c3c$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    }
};
var $59b2a1271eae7c3c$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    }
};
var $59b2a1271eae7c3c$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $59b2a1271eae7c3c$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': $59b2a1271eae7c3c$var$_objectSpread($59b2a1271eae7c3c$var$_objectSpread({}, $59b2a1271eae7c3c$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    })
};
var $59b2a1271eae7c3c$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $59b2a1271eae7c3c$export$955358618f994a11(_ref) {
    var appearance = _ref.appearance, spacing = _ref.spacing, isSelected = _ref.isSelected, shouldFitContainer = _ref.shouldFitContainer, isOnlySingleIcon = _ref.isOnlySingleIcon;
    return $59b2a1271eae7c3c$var$_objectSpread($59b2a1271eae7c3c$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: (0, $137Lh.fg)('platform-dst-shape-theme-default') ? "var(--ds-radius-medium, 6px)" : "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: $59b2a1271eae7c3c$var$heights[spacing],
        lineHeight: $59b2a1271eae7c3c$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $59b2a1271eae7c3c$var$singleIconPadding[spacing] : $59b2a1271eae7c3c$var$padding[spacing],
        verticalAlign: $59b2a1271eae7c3c$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center'
    }, isSelected ? $59b2a1271eae7c3c$var$selectedStyles : $59b2a1271eae7c3c$var$_objectSpread($59b2a1271eae7c3c$var$_objectSpread($59b2a1271eae7c3c$var$_objectSpread($59b2a1271eae7c3c$var$_objectSpread($59b2a1271eae7c3c$var$_objectSpread($59b2a1271eae7c3c$var$_objectSpread($59b2a1271eae7c3c$var$_objectSpread($59b2a1271eae7c3c$var$_objectSpread({}, appearance === 'default' && $59b2a1271eae7c3c$var$defaultStyles), appearance === 'primary' && $59b2a1271eae7c3c$var$primaryStyles), appearance === 'link' && $59b2a1271eae7c3c$var$linkStyles), appearance === 'subtle' && $59b2a1271eae7c3c$var$subtleStyles), appearance === 'subtle-link' && $59b2a1271eae7c3c$var$subtleLinkStyles), appearance === 'warning' && $59b2a1271eae7c3c$var$warningStyles), appearance === 'danger' && $59b2a1271eae7c3c$var$dangerStyles), {}, {
        '&[disabled]': {
            color: "var(--ds-text-disabled, #080F214A)",
            backgroundColor: $59b2a1271eae7c3c$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent',
            cursor: 'not-allowed',
            textDecoration: 'none',
            '&:hovered': {
                backgroundColor: $59b2a1271eae7c3c$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent'
            },
            '&:active': {
                backgroundColor: $59b2a1271eae7c3c$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent'
            }
        }
    }, $59b2a1271eae7c3c$var$hasOverlayStyles)), {}, {
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}


function $a3b9220686004ed1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a3b9220686004ed1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a3b9220686004ed1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a3b9220686004ed1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a3b9220686004ed1$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $a3b9220686004ed1$export$31512de7fa606fa4(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$iconIsOnlyChild = _ref.iconIsOnlyChild, iconIsOnlyChild = _ref$iconIsOnlyChild === void 0 ? false : _ref$iconIsOnlyChild, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, state = _ref.state;
    var result = (0, $59b2a1271eae7c3c$export$955358618f994a11)({
        appearance: appearance,
        spacing: spacing,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    var selector = $a3b9220686004ed1$var$stateToSelectorMap[state];
    if (selector) result = $a3b9220686004ed1$var$_objectSpread($a3b9220686004ed1$var$_objectSpread({}, result), result[selector]);
    if (isLoading) result = $a3b9220686004ed1$var$_objectSpread($a3b9220686004ed1$var$_objectSpread({}, result), result['&[data-has-overlay="true"]']);
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach(function(key) {
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}


var $148be58b0a5259f9$var$Theme = (0, $d9d3aa9f0354c727$export$25d302a5b900a763)(function(themeProps) {
    return {
        buttonStyles: (0, $a3b9220686004ed1$export$31512de7fa606fa4)(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    };
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$148be58b0a5259f9$export$2e2bcd8739ae039 = $148be58b0a5259f9$var$Theme;


var $b6738ae824ea86e7$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isSelected",
    "shouldFitContainer",
    "spacing",
    "isLoading",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseDown",
    "onMouseUp",
    "onFocus",
    "onBlur",
    "theme"
];
function $b6738ae824ea86e7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b6738ae824ea86e7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b6738ae824ea86e7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b6738ae824ea86e7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b6738ae824ea86e7$var$getInteractionState(_ref) {
    var _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? false : _ref$isActive, _ref$isFocus = _ref.isFocus, isFocus = _ref$isFocus === void 0 ? false : _ref$isFocus, _ref$isHover = _ref.isHover, isHover = _ref$isHover === void 0 ? false : _ref$isHover, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
var $b6738ae824ea86e7$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ var $b6738ae824ea86e7$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function CustomThemeButton(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? 'default' : _ref2$appearance, _ref2$autoFocus = _ref2.autoFocus, autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$shouldFitContai = _ref2.shouldFitContainer, shouldFitContainer = _ref2$shouldFitContai === void 0 ? false : _ref2$shouldFitContai, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? 'default' : _ref2$spacing, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, providedOnMouseEnter = _ref2.onMouseEnter, providedOnMouseLeave = _ref2.onMouseLeave, providedOnMouseDown = _ref2.onMouseDown, providedOnMouseUp = _ref2.onMouseUp, providedOnFocus = _ref2.onFocus, providedOnBlur = _ref2.onBlur, _ref2$theme = _ref2.theme, theme = _ref2$theme === void 0 ? (0, $c0a075e8a009a481$export$437a7f77d13d7916) : _ref2$theme, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref2, $b6738ae824ea86e7$var$_excluded);
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    var restProps = $b6738ae824ea86e7$var$_objectSpread({
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    }, rest);
    var _useState = (0, $7fPBF.useState)($b6738ae824ea86e7$var$initial), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var onMouseEnter = (0, $7fPBF.useCallback)(function(event) {
        setState(function(current) {
            return $b6738ae824ea86e7$var$_objectSpread($b6738ae824ea86e7$var$_objectSpread({}, current), {}, {
                isHover: true
            });
        });
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    var onMouseLeave = (0, $7fPBF.useCallback)(function(event) {
        setState(function(current) {
            return $b6738ae824ea86e7$var$_objectSpread($b6738ae824ea86e7$var$_objectSpread({}, current), {}, {
                isHover: false,
                isActive: false
            });
        });
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    var onMouseDown = (0, $7fPBF.useCallback)(function(event) {
        setState(function(current) {
            return $b6738ae824ea86e7$var$_objectSpread($b6738ae824ea86e7$var$_objectSpread({}, current), {}, {
                isActive: true
            });
        });
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    var onMouseUp = (0, $7fPBF.useCallback)(function(event) {
        setState(function(current) {
            return $b6738ae824ea86e7$var$_objectSpread($b6738ae824ea86e7$var$_objectSpread({}, current), {}, {
                isActive: false
            });
        });
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    var onFocus = (0, $7fPBF.useCallback)(function(event) {
        setState(function(current) {
            return $b6738ae824ea86e7$var$_objectSpread($b6738ae824ea86e7$var$_objectSpread({}, current), {}, {
                isFocus: true
            });
        });
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    var onBlur = (0, $7fPBF.useCallback)(function(event) {
        setState(function(current) {
            return $b6738ae824ea86e7$var$_objectSpread($b6738ae824ea86e7$var$_objectSpread({}, current), {}, {
                isFocus: false
            });
        });
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $148be58b0a5259f9$export$2e2bcd8739ae039).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8e3d3e3ac4379509$export$2e2bcd8739ae039).Consumer, null, function(_ref3) {
        var mode = _ref3.mode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $148be58b0a5259f9$export$2e2bcd8739ae039).Consumer, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
            mode: mode,
            state: $b6738ae824ea86e7$var$getInteractionState($b6738ae824ea86e7$var$_objectSpread($b6738ae824ea86e7$var$_objectSpread({}, state), {}, {
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            })),
            iconIsOnlyChild: (0, $d988f83806b6fe3b$export$2e2bcd8739ae039)(restProps),
            isLoading: isLoading
        }, restProps), function(_ref4) {
            var buttonStyles = _ref4.buttonStyles;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $3a147e18a4e384a4$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, restProps, {
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $17284fc89b8fb309$export$2e2bcd8739ae039), restProps) : null,
                "aria-disabled": isLoading || restProps['aria-disabled'],
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $0efe9e7c0b085f89$export$643db0b8d8778e)(buttonStyles)
            }));
        });
    }));
}));
// Tools including enzyme rely on components having a display name
$b6738ae824ea86e7$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $b6738ae824ea86e7$export$2e2bcd8739ae039 = $b6738ae824ea86e7$var$CustomThemeButton;




var $iKdEz = parcelRequire("iKdEz");

var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");


var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");


function $bf339b74c053cf86$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bf339b74c053cf86$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bf339b74c053cf86$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bf339b74c053cf86$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $bf339b74c053cf86$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $8618b7ff1a86c099$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $8606d3c77a5913a9$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $8606d3c77a5913a9$export$1d27a74659855e44)(fn);
    var handler = (0, $7fPBF.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $bf339b74c053cf86$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}


/**
 * An empty function which does nothing.
 */ function $1786091e56344be5$export$2e2bcd8739ae039() {}



var $7fPBF = parcelRequire("7fPBF");

/**
 * Character key codes which can be used in keyboard events.
 */ var $f9adf3c126297ff7$export$390330c10ff2b9a1 = 'ArrowUp';
var $f9adf3c126297ff7$export$a80636c6f41931fe = 'ArrowDown';
var $f9adf3c126297ff7$export$fc4577f2a2af0ae3 = 'ArrowLeft';
var $f9adf3c126297ff7$export$c40f9845adc73fb5 = 'ArrowRight';
var $f9adf3c126297ff7$export$4af703091671bc = 'Home';
var $f9adf3c126297ff7$export$e2bc30913faa5db7 = 'End';
var $f9adf3c126297ff7$export$10f6869ed0a7d75b = 'Tab';
var $f9adf3c126297ff7$export$8152f929a25a0ff4 = 'Enter';
var $f9adf3c126297ff7$export$e51a3576c045c8d5 = 'Space';
var $f9adf3c126297ff7$export$2bb790b9008907b4 = 'Escape';


function $d859f1c67ffb26c8$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $7fPBF.useRef)(false);
    var onKeyDown = (0, $7fPBF.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $f9adf3c126297ff7$export$2bb790b9008907b4)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $7fPBF.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $7fPBF.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $a091c25729a976b1$exports.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}



var $7fPBF = parcelRequire("7fPBF");
function $e82c42714440fd66$export$2e2bcd8739ae039(value) {
    var ref = (0, $7fPBF.useRef)(value);
    (0, $7fPBF.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $61560c705e45c296$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $acc75caf7777a48d$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $7fPBF.createContext)(null);


function $d8b18d17afdece32$export$1d57e79091cc3046() {
    var namespace = (0, $7fPBF.useContext)((0, $acc75caf7777a48d$export$644a49f3b8c50fcd));
    return namespace;
}


function $ec007781e67f4551$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $7fPBF.useContext)((0, $61560c705e45c296$export$5fbf4d7fae6cdc00));
    var namespace = (0, $d8b18d17afdece32$export$1d57e79091cc3046)();
    (0, $7fPBF.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $66ba76182e150ece$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $66ba76182e150ece$var$ExitingContext = /*#__PURE__*/ (0, $7fPBF.createContext)($66ba76182e150ece$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $66ba76182e150ece$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $66ba76182e150ece$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($66ba76182e150ece$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $66ba76182e150ece$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $7fPBF.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $66ba76182e150ece$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $66ba76182e150ece$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $66ba76182e150ece$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $66ba76182e150ece$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $66ba76182e150ece$var$ExitingPersistence = /*#__PURE__*/ (0, $7fPBF.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $7fPBF.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $7fPBF.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $7fPBF.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $66ba76182e150ece$var$childrenToArray(previousChildren);
    var current = $66ba76182e150ece$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $66ba76182e150ece$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $66ba76182e150ece$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $137Lh.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $66ba76182e150ece$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $66ba76182e150ece$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $66ba76182e150ece$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $7fPBF.useContext)($66ba76182e150ece$var$ExitingContext);
};
$66ba76182e150ece$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $66ba76182e150ece$export$2e2bcd8739ae039 = $66ba76182e150ece$var$ExitingPersistence;


var $7fPBF = parcelRequire("7fPBF");
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $7c0nF = parcelRequire("7c0nF");

var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $1932ef18b6d1e2fc$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $1932ef18b6d1e2fc$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$1932ef18b6d1e2fc$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $1932ef18b6d1e2fc$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $7fPBF.useState)($1932ef18b6d1e2fc$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $7fPBF.useEffect)(function() {
        if (!$1932ef18b6d1e2fc$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $a091c25729a976b1$exports.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $1932ef18b6d1e2fc$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $1932ef18b6d1e2fc$export$ff7706047246b98b = function prefersReducedMotion() {
    return $1932ef18b6d1e2fc$export$f0f789643ba5a83c;
};


/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $2148aa4e756e86e1$export$368bacef0dacbe05 = 25;
var $2148aa4e756e86e1$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $2148aa4e756e86e1$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $2148aa4e756e86e1$export$30fa1a2e62ae150c = {
    none: $2148aa4e756e86e1$export$38b928a7167ce124.none,
    small: $2148aa4e756e86e1$export$38b928a7167ce124.small * $2148aa4e756e86e1$var$EXITING_MOTION_MULTIPLIER,
    medium: $2148aa4e756e86e1$export$38b928a7167ce124.medium * $2148aa4e756e86e1$var$EXITING_MOTION_MULTIPLIER,
    large: $2148aa4e756e86e1$export$38b928a7167ce124.large * $2148aa4e756e86e1$var$EXITING_MOTION_MULTIPLIER
};



var $7fPBF = parcelRequire("7fPBF");
// Handle both browser and Node.js environments
var $904e4d4c88281045$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $904e4d4c88281045$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $7fPBF.useRef)([]);
    (0, $7fPBF.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $904e4d4c88281045$var$getHookDeps(opts));
    return (0, $7fPBF.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $904e4d4c88281045$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $7fPBF.useRef)([]);
    (0, $7fPBF.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $904e4d4c88281045$var$getHookDeps(opts));
    return (0, $7fPBF.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};




var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");
/**
 * An empty function which does nothing.
 */ function $5cb406ab07fa9cad$export$2e2bcd8739ae039() {}



var $7fPBF = parcelRequire("7fPBF");
var $47603bb6187cf3d8$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $7fPBF.useEffect) : (0, $7fPBF.useLayoutEffect);


/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $7fPBF = parcelRequire("7fPBF");
function $a2d627bd2f3f6db6$export$c485849f2e393253() {
    var identifier = (0, $7fPBF.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}


var $8c497279037f55b6$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $7fPBF.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $5cb406ab07fa9cad$export$2e2bcd8739ae039)
    };
});
var $8c497279037f55b6$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $a2d627bd2f3f6db6$export$c485849f2e393253)();
    var context = (0, $7fPBF.useContext)($8c497279037f55b6$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $8c497279037f55b6$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $7fPBF.useRef)([]);
    var indexes = [];
    var _useState = (0, $7fPBF.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $47603bb6187cf3d8$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($8c497279037f55b6$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $8c497279037f55b6$export$2e2bcd8739ae039 = $8c497279037f55b6$var$StaggeredEntrance;


var $a9c75c7e1a1f222c$var$zoomIn = null;
var $a9c75c7e1a1f222c$var$zoomOut = null;
var $a9c75c7e1a1f222c$var$fadeIn = null;
var $a9c75c7e1a1f222c$var$fadeOut = null;
var $a9c75c7e1a1f222c$var$fadeInFromTop = null;
var $a9c75c7e1a1f222c$var$fadeOutFromTop = null;
var $a9c75c7e1a1f222c$var$fadeInFromLeft = null;
var $a9c75c7e1a1f222c$var$fadeOutFromLeft = null;
var $a9c75c7e1a1f222c$var$fadeInFromBottom = null;
var $a9c75c7e1a1f222c$var$fadeOutFromBottom = null;
var $a9c75c7e1a1f222c$var$fadeInFromRight = null;
var $a9c75c7e1a1f222c$var$fadeOutFromRight = null;
var $a9c75c7e1a1f222c$var$fadeInFromTopConstant = null;
var $a9c75c7e1a1f222c$var$fadeOutFromTopConstant = null;
var $a9c75c7e1a1f222c$var$fadeInFromLeftConstant = null;
var $a9c75c7e1a1f222c$var$fadeOutFromLeftConstant = null;
var $a9c75c7e1a1f222c$var$fadeInFromBottomConstant = null;
var $a9c75c7e1a1f222c$var$fadeOutFromBottomConstant = null;
var $a9c75c7e1a1f222c$var$fadeInFromRightConstant = null;
var $a9c75c7e1a1f222c$var$fadeOutFromRightConstant = null;
var $a9c75c7e1a1f222c$var$slideInFromTop = null;
var $a9c75c7e1a1f222c$var$slideOutFromTop = null;
var $a9c75c7e1a1f222c$var$slideInFromRight = null;
var $a9c75c7e1a1f222c$var$slideOutFromRight = null;
var $a9c75c7e1a1f222c$var$slideInFromBottom = null;
var $a9c75c7e1a1f222c$var$slideOutFromBottom = null;
var $a9c75c7e1a1f222c$var$slideInFromLeft = null;
var $a9c75c7e1a1f222c$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $a9c75c7e1a1f222c$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $8c497279037f55b6$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $66ba76182e150ece$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $904e4d4c88281045$export$4f34107a2b00f39c)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $7fPBF.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $7fPBF.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $1932ef18b6d1e2fc$export$b7baf7667a68d87c)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $2148aa4e756e86e1$export$30fa1a2e62ae150c)[duration] : (0, $2148aa4e756e86e1$export$38b928a7167ce124)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $7c0nF.default)([
            (0, $7c0nF.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $7c0nF.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $7c0nF.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $7c0nF.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $7c0nF.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $7c0nF.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $7c0nF.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $7c0nF.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $7c0nF.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $7c0nF.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $7c0nF.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $7c0nF.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $7c0nF.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $7c0nF.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $7c0nF.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $7c0nF.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $7c0nF.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $7c0nF.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $7c0nF.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $7c0nF.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $7c0nF.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $7c0nF.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $7c0nF.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $7c0nF.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $7c0nF.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $7c0nF.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $7c0nF.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $7c0nF.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $7c0nF.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $7c0nF.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $7c0nF.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $7c0nF.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $7c0nF.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $7c0nF.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $7c0nF.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $7c0nF.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $7c0nF.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $7c0nF.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $7c0nF.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $7c0nF.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $7c0nF.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $7c0nF.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $7c0nF.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $7c0nF.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $7c0nF.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $7c0nF.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $7c0nF.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $7c0nF.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $7c0nF.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $7c0nF.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $7c0nF.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $a9c75c7e1a1f222c$export$2e2bcd8739ae039 = $a9c75c7e1a1f222c$var$EnteringMotion;


var $c0e7a8d4af09417d$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $c0e7a8d4af09417d$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $c0e7a8d4af09417d$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a9c75c7e1a1f222c$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $c0e7a8d4af09417d$export$2e2bcd8739ae039 = $c0e7a8d4af09417d$var$FadeIn;



var $137Lh = parcelRequire("137Lh");


/* eslint-disable no-console */ var $23c2e80513f43551$var$printed = {};
function $23c2e80513f43551$export$2e2bcd8739ae039(message) {
    if ($23c2e80513f43551$var$printed[message]) return;
    $23c2e80513f43551$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}


function $9dfdb571ec2ba7f3$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $23c2e80513f43551$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $9dfdb571ec2ba7f3$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {}


// Reds
var $9d1029da3944c833$export$4b84fd0e2c617bd = '#FFEBE6';
var $9d1029da3944c833$export$b34b069eff244586 = '#FFBDAD';
var $9d1029da3944c833$export$be802dd0d8b57f35 = '#FF8F73';
var $9d1029da3944c833$export$60847d42f9da92a6 = '#FF7452';
var $9d1029da3944c833$export$4a7404f376229999 = '#FF5630';
var $9d1029da3944c833$export$2010d0fb4295b346 = '#DE350B';
var $9d1029da3944c833$export$2837b5a1a71d5c02 = '#BF2600';
var $9d1029da3944c833$export$8d9596b529bbb9cf = '#FFFAE6';
var $9d1029da3944c833$export$41060a744ab0b7ae = '#FFF0B3';
var $9d1029da3944c833$export$1cc05bbbf340e559 = '#FFE380';
var $9d1029da3944c833$export$5aae31392d72caaa = '#FFC400';
var $9d1029da3944c833$export$c6930421db9fa514 = '#FFAB00';
var $9d1029da3944c833$export$59619663aa6500fb = '#FF991F';
var $9d1029da3944c833$export$874739ea9e379ab6 = '#FF8B00';
var $9d1029da3944c833$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $9d1029da3944c833$export$69a3bf21b9686c2b = '#ABF5D1';
var $9d1029da3944c833$export$afbce1382ec95f73 = '#79F2C0';
var $9d1029da3944c833$export$747d86715d4175de = '#57D9A3';
var $9d1029da3944c833$export$940e1f69e873f202 = '#36B37E';
var $9d1029da3944c833$export$a49394138f7b8e85 = '#00875A';
var $9d1029da3944c833$export$6fa04827ac68a4fb = '#006644';
var $9d1029da3944c833$export$226de0355ed012f8 = '#DEEBFF';
var $9d1029da3944c833$export$8c13c2ee36917869 = '#B3D4FF';
var $9d1029da3944c833$export$ecfc1dff386a3e7a = '#4C9AFF';
var $9d1029da3944c833$export$215b7063051591f1 = '#2684FF';
var $9d1029da3944c833$export$e62e8919cca44969 = '#0065FF';
var $9d1029da3944c833$export$b3de0ae08da2ce64 = '#0052CC';
var $9d1029da3944c833$export$a6ee3d71bc067634 = '#0747A6';
var $9d1029da3944c833$export$67f15409e87642a1 = '#669DF1';
var $9d1029da3944c833$export$f0539dbc42dbb067 = '#8FB8F6';
var $9d1029da3944c833$export$363e4475840015bb = '#EAE6FF';
var $9d1029da3944c833$export$4b0a4417ed59760f = '#C0B6F2';
var $9d1029da3944c833$export$6011520a64d9a187 = '#998DD9';
var $9d1029da3944c833$export$a7175d4e9206bc80 = '#8777D9';
var $9d1029da3944c833$export$b48405b95304b5a1 = '#6554C0';
var $9d1029da3944c833$export$c71e4279dd54a18d = '#5243AA';
var $9d1029da3944c833$export$147899de772240ec = '#403294';
var $9d1029da3944c833$export$2cf711fe14c66f06 = '#E6FCFF';
var $9d1029da3944c833$export$7a8f4d33f6f9772c = '#B3F5FF';
var $9d1029da3944c833$export$776c9c497ef08533 = '#79E2F2';
var $9d1029da3944c833$export$69cb3ca10c1e330e = '#00C7E6';
var $9d1029da3944c833$export$9dc1ef0f3f48059b = '#00B8D9';
var $9d1029da3944c833$export$7c835c78b6fcdef8 = '#00A3BF';
var $9d1029da3944c833$export$6036577f95c3877e = '#008DA6';
var $9d1029da3944c833$export$29a4f05edc054374 = '#FFFFFF';
var $9d1029da3944c833$export$e655ef011c4aa1a2 = '#FAFBFC';
var $9d1029da3944c833$export$9fdfb749e33cdf97 = '#F4F5F7';
var $9d1029da3944c833$export$3e51e8f1440314ba = '#EBECF0';
var $9d1029da3944c833$export$1ce2d1575d444ceb = '#DFE1E6';
var $9d1029da3944c833$export$8754fc7e6d8b3000 = '#C1C7D0';
var $9d1029da3944c833$export$c2e91cbeada39b8b = '#B3BAC5';
var $9d1029da3944c833$export$5f71e19f3a7ad9de = '#A5ADBA';
var $9d1029da3944c833$export$eaa8c8a70ac22806 = '#97A0AF';
var $9d1029da3944c833$export$7c87d337fb91a97d = '#8993A4';
var $9d1029da3944c833$export$d6447c357493214f = '#7A869A';
var $9d1029da3944c833$export$f563ee71e9ee74cd = '#6B778C';
var $9d1029da3944c833$export$e2ef2124cf4024b1 = '#5E6C84';
var $9d1029da3944c833$export$eece5f492e429f08 = '#505F79';
var $9d1029da3944c833$export$c39c0fe0f26207ae = '#42526E';
var $9d1029da3944c833$export$7090862dc3038a9f = '#344563';
var $9d1029da3944c833$export$ad0bacf983b7ddaa = '#253858';
var $9d1029da3944c833$export$7d61b15e0da132af = '#172B4D';
var $9d1029da3944c833$export$fbda843f0a27fe96 = '#091E42';
var $9d1029da3944c833$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $9d1029da3944c833$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $9d1029da3944c833$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $9d1029da3944c833$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $9d1029da3944c833$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $9d1029da3944c833$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $9d1029da3944c833$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $9d1029da3944c833$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $9d1029da3944c833$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $9d1029da3944c833$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $9d1029da3944c833$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $9d1029da3944c833$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $9d1029da3944c833$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $9d1029da3944c833$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $9d1029da3944c833$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $9d1029da3944c833$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $9d1029da3944c833$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $9d1029da3944c833$export$2f6319cf7d736c2a = '#E6EDFA';
var $9d1029da3944c833$export$95126bc8884d6634 = '#DCE5F5';
var $9d1029da3944c833$export$8338d8c35d44ff1 = '#CED9EB';
var $9d1029da3944c833$export$5368d76ae4fbbda7 = '#B8C7E0';
var $9d1029da3944c833$export$9f0a771d16ec8d36 = '#ABBBD6';
var $9d1029da3944c833$export$abcf8c38338b4aa5 = '#9FB0CC';
var $9d1029da3944c833$export$97e81faa16a182c7 = '#8C9CB8';
var $9d1029da3944c833$export$bfe21c59123ecf33 = '#7988A3';
var $9d1029da3944c833$export$ee82aa2ea6a1558 = '#67758F';
var $9d1029da3944c833$export$682927c6ed76be02 = '#56637A';
var $9d1029da3944c833$export$91fd9994c5be9757 = '#455166';
var $9d1029da3944c833$export$d281fbfe3cff2df6 = '#3B475C';
var $9d1029da3944c833$export$3902c91d8b98a753 = '#313D52';
var $9d1029da3944c833$export$8e8133c1ba5845b5 = '#283447';
var $9d1029da3944c833$export$33ff357f6620b39 = '#202B3D';
var $9d1029da3944c833$export$633847cf062b69e0 = '#1B2638';
var $9d1029da3944c833$export$9776a6e503bdbf76 = '#121A29';
var $9d1029da3944c833$export$6c813d5160dff5db = '#0E1624';
var $9d1029da3944c833$export$3d4f271a500072a = '#0D1424';
var $9d1029da3944c833$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $9d1029da3944c833$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $9d1029da3944c833$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $9d1029da3944c833$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $9d1029da3944c833$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $9d1029da3944c833$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $9d1029da3944c833$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $9d1029da3944c833$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $9d1029da3944c833$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $9d1029da3944c833$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $9d1029da3944c833$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $9d1029da3944c833$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $9d1029da3944c833$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $9d1029da3944c833$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $9d1029da3944c833$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $9d1029da3944c833$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $9d1029da3944c833$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $9d1029da3944c833$export$d2adc5dedf09fced = '#292A2E';
var $9d1029da3944c833$export$f51762073d2bb381 = '#94C748';
var $9d1029da3944c833$export$95e26d54def96891 = '#B3DF72';


var $894eebcd10b65368$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $894eebcd10b65368$export$c93026a968943f95 = 'light';
var $894eebcd10b65368$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $894eebcd10b65368$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $9d1029da3944c833$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    (0, $9dfdb571ec2ba7f3$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $894eebcd10b65368$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $894eebcd10b65368$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $894eebcd10b65368$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $9dfdb571ec2ba7f3$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $894eebcd10b65368$export$ba1d834b86d72a09 = $894eebcd10b65368$export$a1b3edb637fb4f35;
var $894eebcd10b65368$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $9d1029da3944c833$export$8d43898f60b96a82), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $9d1029da3944c833$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $9d1029da3944c833$export$920c0d5c49070351), ")")
            }
        }
    };
};


/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $3e2602bfac11e80f$var$registrations = new Set();
var $3e2602bfac11e80f$var$cleanupEndEventListeners = null;
function $3e2602bfac11e80f$var$onDragStart() {
    if ($3e2602bfac11e80f$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $3e2602bfac11e80f$var$cleanupEndEventListeners = (0, $a091c25729a976b1$exports.bindAll)(window, [
        {
            type: 'dragend',
            listener: $3e2602bfac11e80f$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $3e2602bfac11e80f$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $3e2602bfac11e80f$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($3e2602bfac11e80f$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $3e2602bfac11e80f$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $3e2602bfac11e80f$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $3e2602bfac11e80f$var$cleanupEndEventListeners = null;
    var clone = Array.from($3e2602bfac11e80f$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $3e2602bfac11e80f$var$bindStartEvents() {
    return (0, $a091c25729a976b1$exports.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $3e2602bfac11e80f$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $3e2602bfac11e80f$var$onDragStart
        }
    ]);
}
var $3e2602bfac11e80f$var$cleanupStartEventListeners = null;
function $3e2602bfac11e80f$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$3e2602bfac11e80f$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $3e2602bfac11e80f$var$cleanupStartEventListeners = $3e2602bfac11e80f$var$bindStartEvents();
    $3e2602bfac11e80f$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $3e2602bfac11e80f$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $3e2602bfac11e80f$var$registrations.delete(registration);
        if ($3e2602bfac11e80f$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $3e2602bfac11e80f$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $3e2602bfac11e80f$var$cleanupStartEventListeners = null;
        }
    };
}


function $5fc3eb5e3798d51c$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}


function $7f33dcbe54e41f5f$export$2e68479e0a5d8746(mousePos, _ref) {
    var targetElement = _ref.targetElement, tooltipPosition = _ref.tooltipPosition;
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            });
        }
    };
    var targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            });
        }
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            });
        }
    };
    throw new Error("Invalid tooltip position for virtual element: ".concat(tooltipPosition));
}



var $137Lh = parcelRequire("137Lh");
var $0c2c2be3ef6f60a8$var$delayId = null;
function $0c2c2be3ef6f60a8$export$eaf678f6f93f5250() {
    if ($0c2c2be3ef6f60a8$var$delayId != null) {
        window.clearTimeout($0c2c2be3ef6f60a8$var$delayId);
        $0c2c2be3ef6f60a8$var$delayId = null;
    }
}
function $0c2c2be3ef6f60a8$export$5f4d6617421d489b(fn, delay) {
    $0c2c2be3ef6f60a8$export$eaf678f6f93f5250();
    $0c2c2be3ef6f60a8$var$delayId = window.setTimeout(function() {
        $0c2c2be3ef6f60a8$var$delayId = null;
        fn();
    }, delay);
}


// This file is a singleton for managing tooltips
var $ecef1be4a61e27c7$var$active = null;
function $ecef1be4a61e27c7$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($ecef1be4a61e27c7$var$active && $ecef1be4a61e27c7$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $0c2c2be3ef6f60a8$export$eaf678f6f93f5250)();
            $ecef1be4a61e27c7$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $0c2c2be3ef6f60a8$export$eaf678f6f93f5250)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $0c2c2be3ef6f60a8$export$eaf678f6f93f5250)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $0c2c2be3ef6f60a8$export$5f4d6617421d489b)(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        var shouldAlwaysFadeIn = (0, $137Lh.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? entry.shouldAlwaysFadeIn : false;
        var showImmediately = Boolean($ecef1be4a61e27c7$var$active && $ecef1be4a61e27c7$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($ecef1be4a61e27c7$var$active) {
            (0, $0c2c2be3ef6f60a8$export$eaf678f6f93f5250)();
            $ecef1be4a61e27c7$var$active.entry.hide({
                isImmediate: true
            });
            $ecef1be4a61e27c7$var$active.entry.done();
            $ecef1be4a61e27c7$var$active = null;
        }
        // this tooltip is now the active tooltip
        $ecef1be4a61e27c7$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $0c2c2be3ef6f60a8$export$5f4d6617421d489b)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        // Removing old `mousePosition` behind gate because it stored a function.
        // With the gate we just store the coords which are easier to work with.
        mousePosition: (0, $137Lh.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? undefined : getInitialMouse(),
        mousePos: entry.source.type === 'mouse' && (0, $137Lh.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}



var $bRUy3 = parcelRequire("bRUy3");

var $7fPBF = parcelRequire("7fPBF");
function $bdd78397aacc2421$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useId().replace(/[:«»]/g, '_');
}
var $bdd78397aacc2421$export$6be90bcb437e928f = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($bdd78397aacc2421$export$f680877a34711e37()).concat(postfix);
    (0, $7fPBF.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $bdd78397aacc2421$export$6ee17796e3d70de2() {
    var uid = $bdd78397aacc2421$export$f680877a34711e37();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}


function $44c14f6d93a62e21$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $bdd78397aacc2421$export$6ee17796e3d70de2)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}


/* tooltip-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $7c0nF = parcelRequire("7c0nF");
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $7c0nF = parcelRequire("7c0nF");
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $7c0nF = parcelRequire("7c0nF");
var $d8702fad61b6859e$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
var $d8702fad61b6859e$export$5bcbc43c84236222 = function TooltipShortcut(_ref) {
    var shortcut = _ref.shortcut;
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        className: (0, $7c0nF.default)([
            $d8702fad61b6859e$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map(function(segment, index) {
        return /*#__PURE__*/ $7fPBF.createElement("kbd", {
            key: "".concat(segment, "-").concat(index),
            className: (0, $7c0nF.default)([
                $d8702fad61b6859e$var$styles.shortcutSegment
            ])
        }, segment);
    }));
};


var $973c68b5d6a934f3$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $973c68b5d6a934f3$var$TooltipPrimitive = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $7fPBF.createElement("div", {
        role: "tooltip",
        className: (0, $7c0nF.default)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && /*#__PURE__*/ $7fPBF.createElement((0, $d8702fad61b6859e$export$5bcbc43c84236222), {
        shortcut: shortcut
    })));
});
$973c68b5d6a934f3$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $973c68b5d6a934f3$export$2e2bcd8739ae039 = $973c68b5d6a934f3$var$TooltipPrimitive;


var $719d62abeb5a1a67$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $719d62abeb5a1a67$var$TooltipContainer = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $7fPBF.createElement((0, $973c68b5d6a934f3$export$2e2bcd8739ae039), {
        ref: ref,
        style: style,
        className: (0, $7c0nF.default)([
            $719d62abeb5a1a67$var$styles.base,
            truncate && $719d62abeb5a1a67$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut
    }, children);
});
$719d62abeb5a1a67$var$TooltipContainer.displayName = 'TooltipContainer';
var $719d62abeb5a1a67$export$2e2bcd8739ae039 = $719d62abeb5a1a67$var$TooltipContainer;


function $fcc0c712cfedad8f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fcc0c712cfedad8f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fcc0c712cfedad8f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fcc0c712cfedad8f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fcc0c712cfedad8f$var$tooltipZIndex = (0, $894eebcd10b65368$export$7be255094ccdc533).tooltip();
var $fcc0c712cfedad8f$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "21.1.1"
};
// Inverts motion direction
var $fcc0c712cfedad8f$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $fcc0c712cfedad8f$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $fcc0c712cfedad8f$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $719d62abeb5a1a67$export$2e2bcd8739ae039) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $1786091e56344be5$export$2e2bcd8739ae039) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $1786091e56344be5$export$2e2bcd8739ae039) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn, shortcut = _ref.shortcut, _ref$UNSAFE_shouldAlw = _ref.UNSAFE_shouldAlwaysFadeIn, shouldAlwaysFadeIn = _ref$UNSAFE_shouldAlw === void 0 ? false : _ref$UNSAFE_shouldAlw, _ref$UNSAFE_shouldRen = _ref.UNSAFE_shouldRenderToParent, UNSAFE_shouldRenderToParent = _ref$UNSAFE_shouldRen === void 0 ? false : _ref$UNSAFE_shouldRen;
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    var isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    var tooltipPosition = isMousePosition ? mousePosition : position;
    var onShowHandler = (0, $bf339b74c053cf86$export$1a04351537078b55)($fcc0c712cfedad8f$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $fcc0c712cfedad8f$var$analyticsAttributes));
    var onHideHandler = (0, $bf339b74c053cf86$export$1a04351537078b55)($fcc0c712cfedad8f$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $fcc0c712cfedad8f$var$analyticsAttributes));
    var apiRef = (0, $7fPBF.useRef)(null);
    var _useState = (0, $7fPBF.useState)('hide'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $7fPBF.useRef)(null);
    var containerRef = (0, $7fPBF.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $7fPBF.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $e82c42714440fd66$export$2e2bcd8739ae039)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $e82c42714440fd66$export$2e2bcd8739ae039)(onShowHandler);
    var onHideHandlerStable = (0, $e82c42714440fd66$export$2e2bcd8739ae039)(onHideHandler);
    var delayStable = (0, $e82c42714440fd66$export$2e2bcd8739ae039)(delay);
    var canAppearStable = (0, $e82c42714440fd66$export$2e2bcd8739ae039)(canAppear);
    var hasCalledShowHandler = (0, $7fPBF.useRef)(false);
    var shouldAlwaysFadeInStable = (0, $e82c42714440fd66$export$2e2bcd8739ae039)(shouldAlwaysFadeIn);
    var start = (0, $7fPBF.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $7fPBF.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $7fPBF.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $7fPBF.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $7fPBF.useRef)(false);
    (0, $7fPBF.useEffect)(function() {
        return (0, $3e2602bfac11e80f$export$6503ec6e8aabbaf)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $7fPBF.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: (0, $137Lh.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? shouldAlwaysFadeInStable.current : false
        };
        var api = (0, $ecef1be4a61e27c7$export$57bf213be019eeb0)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    var hideTooltipOnEsc = (0, $7fPBF.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $d859f1c67ffb26c8$export$2e2bcd8739ae039)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $7fPBF.useEffect)(function() {
        if (state === 'hide') return 0, $1786091e56344be5$export$2e2bcd8739ae039;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $a091c25729a976b1$exports.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $7fPBF.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $7fPBF.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $7fPBF.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = isMousePosition ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            // Removing old `mouse` behind gate because it stored a function.
            // With the gate we just store the coords which are easier to work with.
            mouse: (0, $137Lh.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? undefined : (0, $5fc3eb5e3798d51c$export$642213d516a9b928)({
                left: event.clientX,
                top: event.clientY
            }),
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $7fPBF.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = isMousePosition ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) {
            if (!(0, $137Lh.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) apiRef.current.mousePosition = (0, $5fc3eb5e3798d51c$export$642213d516a9b928)({
                left: event.clientX,
                top: event.clientY
            });
            apiRef.current.mousePos = {
                clientX: event.clientX,
                clientY: event.clientY
            };
        }
    } : undefined;
    var onMouseOverTooltip = (0, $7fPBF.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $7fPBF.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch (_unused) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $7fPBF.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $7fPBF.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    var handleOpenLayerObserverCloseSignal = (0, $7fPBF.useCallback)(function() {
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $ec007781e67f4551$export$469bb693f11edc7f)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current5, _apiRef$current6;
        if (isMousePosition && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePos && targetRef.current && (0, $137Lh.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) return (0, $7f33dcbe54e41f5f$export$2e68479e0a5d8746)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        if (isMousePosition && (_apiRef$current6 = apiRef.current) !== null && _apiRef$current6 !== void 0 && _apiRef$current6.mousePosition && !(0, $137Lh.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) {
            var _apiRef$current7;
            return (_apiRef$current7 = apiRef.current) === null || _apiRef$current7 === void 0 ? void 0 : _apiRef$current7.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $44c14f6d93a62e21$export$2e2bcd8739ae039)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // Adding `data-testid` to the TriggerProps interface breaks Buttons, so we use type assertion
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $7fPBF.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    var PopperWrapper = UNSAFE_shouldRenderToParent && (0, $137Lh.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? (0, $7fPBF.Fragment) : $fcc0c712cfedad8f$var$TooltipPortal;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, children($fcc0c712cfedad8f$var$_objectSpread($fcc0c712cfedad8f$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(PopperWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e8027c477e280fef$export$badac9ada3a0bdf9), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = isMousePosition ? undefined : $fcc0c712cfedad8f$var$invertedDirection[$fcc0c712cfedad8f$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $66ba76182e150ece$export$2e2bcd8739ae039), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $c0e7a8d4af09417d$export$2e2bcd8739ae039), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $fcc0c712cfedad8f$var$_objectSpread($fcc0c712cfedad8f$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $fcc0c712cfedad8f$export$2e2bcd8739ae039 = $fcc0c712cfedad8f$var$Tooltip;
var $fcc0c712cfedad8f$var$TooltipPortal = function TooltipPortal(_ref7) {
    var children = _ref7.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd3bc8368572caba$export$2e2bcd8739ae039), {
        zIndex: $fcc0c712cfedad8f$var$tooltipZIndex
    }, children);
};



var $7fPBF = parcelRequire("7fPBF");

var $d480615bd38df9e9$export$93d4e7f90805808f = function useTheme() {
    return (0, $7fPBF.useContext)((0, $a2fb43746167a532$export$2c657da244d00bd6));
};



var $8MJe2 = parcelRequire("8MJe2");
function $d5fdedda4fc17def$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d5fdedda4fc17def$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d5fdedda4fc17def$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d5fdedda4fc17def$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d5fdedda4fc17def$export$14dd6915caf431fe = function getPrimaryButtonTheme(_ref) {
    var primaryButton = _ref.mode.primaryButton;
    return function(current, props) {
        var _current = current(props), buttonStyles = _current.buttonStyles, spinnerStyles = _current.spinnerStyles;
        return {
            buttonStyles: $d5fdedda4fc17def$var$_objectSpread($d5fdedda4fc17def$var$_objectSpread($d5fdedda4fc17def$var$_objectSpread($d5fdedda4fc17def$var$_objectSpread({}, buttonStyles), primaryButton.default), props.isSelected && primaryButton.selected), {}, {
                fontWeight: "var(--ds-font-weight-medium, 500)",
                padding: "0 ".concat("var(--ds-space-050, 4px)"),
                marginLeft: 0,
                marginRight: 0,
                ':hover': props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                ':focus': primaryButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': $d5fdedda4fc17def$var$_objectSpread({}, props.state === 'active' && primaryButton.active)
            }),
            spinnerStyles: spinnerStyles
        };
    };
};


var $f5607a9546336e2a$var$_excluded = [
    "children",
    "component",
    "isHighlighted",
    "isLoading",
    "isSelected",
    "onClick",
    "testId",
    "theme",
    "tooltip",
    "shortcut"
];
var $f5607a9546336e2a$var$VAR_BUTTON_SELECTED_COLOR = '--button-selected-color';
var $f5607a9546336e2a$var$VAR_BUTTON_SELECTED_BORDER_COLOR = '--button-selected-border-color';
var $f5607a9546336e2a$var$buttonBaseStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
});
var $f5607a9546336e2a$var$buttonNoOpStyle = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    '--noop': 1
});
var $f5607a9546336e2a$var$buttonHighlightedStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& > *': {
        color: "var(".concat($f5607a9546336e2a$var$VAR_BUTTON_SELECTED_COLOR, ")")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        height: 3,
        position: 'absolute',
        backgroundColor: "var(".concat($f5607a9546336e2a$var$VAR_BUTTON_SELECTED_BORDER_COLOR, ")"),
        borderStartEndRadius: "var(--ds-radius-xsmall, 1px)",
        borderStartStartRadius: "var(--ds-radius-xsmall, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineEnd: "var(--ds-space-050, 4px)",
        insetInlineStart: "var(--ds-space-050, 4px)"
    }
});
var $f5607a9546336e2a$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
    var children = props.children, component = props.component, isHighlighted = props.isHighlighted, isLoading = props.isLoading, isSelected = props.isSelected, onClick = props.onClick, testId = props.testId, theme = props.theme, tooltip = props.tooltip, shortcut = props.shortcut, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(props, $f5607a9546336e2a$var$_excluded);
    var themeFromContext = (0, $d480615bd38df9e9$export$93d4e7f90805808f)();
    var button = (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("div", {
        style: (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, $f5607a9546336e2a$var$VAR_BUTTON_SELECTED_COLOR, themeFromContext.mode.primaryButton.selected.color), $f5607a9546336e2a$var$VAR_BUTTON_SELECTED_BORDER_COLOR, themeFromContext.mode.primaryButton.selected.borderColor),
        css: [
            $f5607a9546336e2a$var$buttonBaseStyles,
            isHighlighted && $f5607a9546336e2a$var$buttonHighlightedStyles
        ],
        role: "listitem",
        "data-vc": "primary-button"
    }, (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $b6738ae824ea86e7$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        appearance: "primary",
        component: component,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        theme: theme || (0, $d5fdedda4fc17def$export$14dd6915caf431fe)(themeFromContext),
        css: [
            $f5607a9546336e2a$var$buttonNoOpStyle
        ] // Typescript working for css mismatch error
    }, rest), children));
    if (tooltip) return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $fcc0c712cfedad8f$export$2e2bcd8739ae039), {
        content: tooltip,
        hideTooltipOnClick: true,
        shortcut: shortcut
    }, button);
    return button;
});


var $7d4930215a35439f$var$_excluded = [
    "component",
    "isHighlighted",
    "isLoading",
    "onClick",
    "testId",
    "theme",
    "tooltip"
];
var $7d4930215a35439f$var$buttonNoOpStyle = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    '--noop': 1
});
var $7d4930215a35439f$export$bb3af89fb196520d = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
    var component = props.component, isHighlighted = props.isHighlighted, isLoading = props.isLoading, onClick = props.onClick, testId = props.testId, theme = props.theme, tooltip = props.tooltip, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(props, $7d4930215a35439f$var$_excluded);
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $f5607a9546336e2a$export$ac16a6a04d9b7c84), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        component: component,
        iconAfter: (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, (/*@__PURE__*/$parcel$interopDefault($022e926cdc9ff4be$exports))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        isHighlighted: isHighlighted,
        isLoading: isLoading,
        onClick: onClick,
        ref: ref,
        testId: testId,
        theme: theme,
        tooltip: tooltip,
        css: [
            $7d4930215a35439f$var$buttonNoOpStyle
        ] // Typescript working for css mismatch error
    }, rest));
});


var $ee25c17e75fc6a6b$var$containerStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    alignItems: 'stretch',
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        margin: "0 ".concat("var(--ds-space-050, 4px)"),
        flexShrink: 0
    }
});
var $ee25c17e75fc6a6b$var$widthObserverContainerStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    width: '100%',
    minWidth: '1px',
    margin: '0px',
    position: 'relative',
    flexShrink: 1
});
var $ee25c17e75fc6a6b$var$overflowItemsStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    color: "var(--ds-text, #292A2E)"
});
var $ee25c17e75fc6a6b$export$43e704064d596a9e = function PrimaryItemsContainer(_ref) {
    var moreLabel = _ref.moreLabel, items = _ref.items, Create = _ref.create, testId = _ref.testId;
    var _useState = (0, $7fPBF.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), isMoreOpen = _useState2[0], setIsMoreOpen = _useState2[1];
    var _useOverflowControlle = (0, $29a6ecad9d545dc1$export$705aa66a39c35bf7)(items), updateWidth = _useOverflowControlle.updateWidth, visibleItems = _useOverflowControlle.visibleItems, overflowItems = _useOverflowControlle.overflowItems;
    var onMoreClick = (0, $7fPBF.useCallback)(function() {
        setIsMoreOpen(!isMoreOpen);
    }, [
        isMoreOpen,
        setIsMoreOpen
    ]);
    var onMoreClose = (0, $7fPBF.useCallback)(function() {
        setIsMoreOpen(false);
    }, []);
    var openOverflowMenu = (0, $7fPBF.useCallback)(function() {
        setIsMoreOpen(true);
    }, []);
    var trigger = (0, $7fPBF.useCallback)(function(triggerProps) {
        return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $7d4930215a35439f$export$bb3af89fb196520d), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
            onClick: onMoreClick,
            isSelected: isMoreOpen,
            testId: testId ? "".concat(testId, "-overflow-menu-trigger") : 'overflow-menu-trigger'
        }, triggerProps), moreLabel);
    }, [
        moreLabel,
        onMoreClick,
        isMoreOpen,
        testId
    ]);
    var content = (0, $7fPBF.useCallback)(function() {
        return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $29a6ecad9d545dc1$export$a3a2def3937905a0), {
            isVisible: false,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: onMoreClose
        }, (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("div", {
            css: $ee25c17e75fc6a6b$var$overflowItemsStyles
        }, overflowItems));
    }, // Overflow items has an unstable reference - so we will only recalculate
    // content if `overflowItems` length changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        overflowItems.length,
        openOverflowMenu,
        onMoreClose
    ]);
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("div", {
        css: $ee25c17e75fc6a6b$var$containerStyles,
        "data-testid": testId && "".concat(testId, "-primary-actions"),
        role: "list"
    }, (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $29a6ecad9d545dc1$export$a3a2def3937905a0), {
        isVisible: true,
        openOverflowMenu: openOverflowMenu,
        closeOverflowMenu: onMoreClose
    }, visibleItems), overflowItems.length > 0 && (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $2c055187658302fb$export$2e2bcd8739ae039), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        content: content,
        isOpen: isMoreOpen,
        onClose: onMoreClose,
        trigger: trigger,
        testId: testId ? "".concat(testId, "-overflow-menu-popup") : 'overflow-menu-popup'
    }), Create && (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(Create, null), (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("div", {
        css: $ee25c17e75fc6a6b$var$widthObserverContainerStyles
    }, (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $66ddca22d5092ead$export$b2ad68b9bc407b80), {
        offscreen: true,
        setWidth: updateWidth
    })));
};


var $436c212ddd6b0459$var$containerStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    display: 'flex',
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $09cd32ac24fc7bec$export$30fa7cc5f2690a43),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderBlockEnd: "var(--ds-border-width, 1px)".concat(" solid ", "var(--ds-border, #0B120E24)"),
    paddingInlineEnd: "var(--ds-space-150, 12px)",
    paddingInlineStart: "var(--ds-space-150, 12px)"
});
var $436c212ddd6b0459$var$leftStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    display: 'flex',
    minWidth: 0,
    height: 'inherit',
    alignItems: 'center',
    flexGrow: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        flexShrink: 0
    }
});
var $436c212ddd6b0459$var$rightStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        flexShrink: 0,
        marginInlineEnd: "var(--ds-space-050, 4px)"
    }
});
var $436c212ddd6b0459$var$noRightMarginStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    marginInlineEnd: 0
});
var $436c212ddd6b0459$var$analyticsData = {
    attributes: {
        navigationLayer: 'global'
    },
    componentName: 'atlassianNavigation'
};
var $436c212ddd6b0459$export$f66ccb39f60980e5 = function AtlassianNavigation(props) {
    var label = props.label, _props$primaryItems = props.primaryItems, primaryItems = _props$primaryItems === void 0 ? [] : _props$primaryItems, AppSwitcher = props.renderAppSwitcher, create = props.renderCreate, Help = props.renderHelp, Notifications = props.renderNotifications, ProductHome = props.renderProductHome, Profile = props.renderProfile, Search = props.renderSearch, SignIn = props.renderSignIn, Settings = props.renderSettings, _props$moreLabel = props.moreLabel, moreLabel = _props$moreLabel === void 0 ? "\u2026" : _props$moreLabel, _props$theme = props.theme, theme = _props$theme === void 0 ? (0, $2c11322889abbfcf$export$164de7ab8df77ef0) : _props$theme, testId = props.testId, _props$isServer = props.isServer, isServer = _props$isServer === void 0 ? false : _props$isServer, _props$isSSRPlacehold = props.isSSRPlaceholderEnabled, isSSRPlaceholderEnabled = _props$isSSRPlacehold === void 0 ? false : _props$isSSRPlacehold;
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $a2fb43746167a532$export$d8964aec282183a3), {
        value: theme
    }, (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $75c91c4e13a5796f$export$d0a82da1a0b94929), {
        data: $436c212ddd6b0459$var$analyticsData
    }, (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("header", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.navigation,
        css: $436c212ddd6b0459$var$containerStyles,
        "data-testid": testId && "".concat(testId, "-header"),
        role: "banner",
        "data-vc": "atlassian-navigation".concat(isServer ? '-ssr' : '')
    }, isServer && isSSRPlaceholderEnabled && {
        'data-ssr-placeholder': 'atlassian-navigation-placeholder'
    }, !isServer && isSSRPlaceholderEnabled && {
        'data-ssr-placeholder-replace': 'atlassian-navigation-placeholder'
    }), (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("nav", {
        css: $436c212ddd6b0459$var$leftStyles,
        "aria-label": label
    }, AppSwitcher && (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(AppSwitcher, null), ProductHome && (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(ProductHome, null), (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $ee25c17e75fc6a6b$export$43e704064d596a9e), {
        testId: testId,
        moreLabel: moreLabel,
        items: primaryItems,
        create: create,
        theme: theme
    })), (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("div", {
        css: $436c212ddd6b0459$var$rightStyles,
        "data-testid": testId && "".concat(testId, "-secondary-actions")
    }, Search && (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(Search, null), (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("div", {
        role: "list",
        css: [
            $436c212ddd6b0459$var$rightStyles,
            $436c212ddd6b0459$var$noRightMarginStyles
        ],
        "data-vc": "atlassian-navigation-secondary-actions"
    }, Notifications && (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(Notifications, null), Help && (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(Help, null), Settings && (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(Settings, null), SignIn && (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(SignIn, null), Profile && (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(Profile, null))))));
};



var $7fPBF = parcelRequire("7fPBF");

var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $8MJe2 = parcelRequire("8MJe2");
var $59a3d6d416cac838$export$4ef52930e33717cd = 'data-theme';
var $59a3d6d416cac838$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $59a3d6d416cac838$export$a00eac3f8684bcd0 = 'data-color-mode';
var $59a3d6d416cac838$export$2112803007239c61 = 'data-contrast-mode';
var $59a3d6d416cac838$export$352e418ed5b6193a = 'data-custom-theme';
var $59a3d6d416cac838$export$6f0c6fb8c80fcc92 = 'ds';
var $59a3d6d416cac838$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $59a3d6d416cac838$export$dddac1532e822863 = "--".concat($59a3d6d416cac838$export$6f0c6fb8c80fcc92, "-token-not-found");
var $59a3d6d416cac838$export$9d7b58831ae93caa = "--".concat($59a3d6d416cac838$export$6f0c6fb8c80fcc92, "-elevation-surface-current");



var $137Lh = parcelRequire("137Lh");
var $04a89e6193e6eb12$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ var $04a89e6193e6eb12$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
var $04a89e6193e6eb12$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'legacy-light',
    'legacy-dark',
    'spacing',
    'shape',
    'typography'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $04a89e6193e6eb12$var$themeOverrideIds = [];
var $04a89e6193e6eb12$export$92ba366331403db2 = [].concat($04a89e6193e6eb12$export$7d43e72a58e3283f, $04a89e6193e6eb12$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $04a89e6193e6eb12$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-legacy-light': {
        id: 'legacy-light',
        displayName: 'Light Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-legacy-dark': {
        id: 'legacy-dark',
        displayName: 'Dark Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    }
};
var $04a89e6193e6eb12$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: function shape() {
        if ((0, $137Lh.fg)('platform-dst-shape-theme-default')) return 'shape';
        return undefined;
    },
    spacing: 'spacing',
    typography: 'typography',
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $04a89e6193e6eb12$export$2e2bcd8739ae039 = $04a89e6193e6eb12$var$themeConfig;



var $bRUy3 = parcelRequire("bRUy3");

var $iKdEz = parcelRequire("iKdEz");

var $3d15ae5ba1988022$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape'
];
var $3d15ae5ba1988022$var$customThemeOptions = 'UNSAFE_themeOptions';
var $3d15ae5ba1988022$var$isThemeKind = function isThemeKind(themeKind) {
    return $3d15ae5ba1988022$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $3d15ae5ba1988022$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $04a89e6193e6eb12$export$7d43e72a58e3283f).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $3d15ae5ba1988022$var$isColorMode = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
var $3d15ae5ba1988022$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && $3d15ae5ba1988022$var$isColorMode(id)) themeObject[kind] = id;
        if ($3d15ae5ba1988022$var$isThemeKind(kind) && $3d15ae5ba1988022$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $3d15ae5ba1988022$var$customThemeOptions) try {
            themeObject[$3d15ae5ba1988022$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
var $3d15ae5ba1988022$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $3d15ae5ba1988022$var$isColorMode(id) || // custom theme state
        kind === $3d15ae5ba1988022$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(id) === 'object' || // other theme states
        $3d15ae5ba1988022$var$isThemeKind(kind) && typeof id === 'string' && $3d15ae5ba1988022$var$isThemeIds(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};


function $e41cfb126c66c7aa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e41cfb126c66c7aa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e41cfb126c66c7aa$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e41cfb126c66c7aa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e41cfb126c66c7aa$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $04a89e6193e6eb12$export$83993de8eb66733).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $e41cfb126c66c7aa$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $59a3d6d416cac838$export$a00eac3f8684bcd0)) || '';
    var theme = element.getAttribute((0, $59a3d6d416cac838$export$4ef52930e33717cd)) || '';
    return $e41cfb126c66c7aa$var$_objectSpread($e41cfb126c66c7aa$var$_objectSpread({}, (0, $3d15ae5ba1988022$export$f19b488f7c0547ee)(theme)), $e41cfb126c66c7aa$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $e41cfb126c66c7aa$export$2e2bcd8739ae039 = $e41cfb126c66c7aa$var$getGlobalTheme;



var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $8MJe2 = parcelRequire("8MJe2");


/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $3fbb22f1ebbf43ea$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $e41cfb126c66c7aa$export$2e2bcd8739ae039)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $59a3d6d416cac838$export$4ef52930e33717cd),
                            (0, $59a3d6d416cac838$export$a00eac3f8684bcd0)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($3fbb22f1ebbf43ea$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))($3fbb22f1ebbf43ea$export$2e2bcd8739ae039, "callbacks", new Set());


/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $bba42a6beceff967$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $7fPBF.useState)((0, $e41cfb126c66c7aa$export$2e2bcd8739ae039)()), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $7fPBF.useEffect)(function() {
        var observer = new (0, $3fbb22f1ebbf43ea$export$2e2bcd8739ae039)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $bba42a6beceff967$export$2e2bcd8739ae039 = $bba42a6beceff967$var$useThemeObserver;


/**
 * These are the default parameters for LogoProps if the user does not specify values.
 */ var $8eafb83749b35973$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
var $8eafb83749b35973$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
}; /**
 * The props for the <Wrapper /> that takes the svg and turns it into a component.
 */ 


/* wrapper.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $8MJe2 = parcelRequire("8MJe2");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $86ebb3b02603ea9e$var$ATOMIC_GROUP_LENGTH = 5;
function $86ebb3b02603ea9e$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $86ebb3b02603ea9e$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


var $458ceb8f9bc6ff8c$var$_excluded = [
    "label",
    "svg",
    "size",
    "appearance",
    "iconColor",
    "textColor",
    "testId"
];
var $458ceb8f9bc6ff8c$var$CSS_VAR_COLOR = '--logo-color';
var $458ceb8f9bc6ff8c$var$CSS_VAR_FILL = '--logo-fill';
var $458ceb8f9bc6ff8c$var$styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ var $458ceb8f9bc6ff8c$var$Wrapper = function Wrapper(_ref) {
    var label = _ref.label, svg = _ref.svg, size = _ref.size, appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor, userDefinedTestId = _ref.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $458ceb8f9bc6ff8c$var$_excluded);
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    var shouldApplyStopColor = appearance === undefined;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    return /*#__PURE__*/ $7fPBF.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        "data-testid": testId,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, $458ceb8f9bc6ff8c$var$CSS_VAR_COLOR, iconColor), $458ceb8f9bc6ff8c$var$CSS_VAR_FILL, textColor),
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }, rest, {
        className: (0, $86ebb3b02603ea9e$export$2e2bcd8739ae039)([
            $458ceb8f9bc6ff8c$var$styles.root,
            shouldApplyStopColor && $458ceb8f9bc6ff8c$var$styles.stop,
            size && $458ceb8f9bc6ff8c$var$styles[size]
        ])
    }));
};
var $458ceb8f9bc6ff8c$export$2e2bcd8739ae039 = $458ceb8f9bc6ff8c$var$Wrapper;


// Reds
var $d7df1392c2cb1415$export$4b84fd0e2c617bd = '#FFEBE6';
var $d7df1392c2cb1415$export$b34b069eff244586 = '#FFBDAD';
var $d7df1392c2cb1415$export$be802dd0d8b57f35 = '#FF8F73';
var $d7df1392c2cb1415$export$60847d42f9da92a6 = '#FF7452';
var $d7df1392c2cb1415$export$4a7404f376229999 = '#FF5630';
var $d7df1392c2cb1415$export$2010d0fb4295b346 = '#DE350B';
var $d7df1392c2cb1415$export$2837b5a1a71d5c02 = '#BF2600';
var $d7df1392c2cb1415$export$8d9596b529bbb9cf = '#FFFAE6';
var $d7df1392c2cb1415$export$41060a744ab0b7ae = '#FFF0B3';
var $d7df1392c2cb1415$export$1cc05bbbf340e559 = '#FFE380';
var $d7df1392c2cb1415$export$5aae31392d72caaa = '#FFC400';
var $d7df1392c2cb1415$export$c6930421db9fa514 = '#FFAB00';
var $d7df1392c2cb1415$export$59619663aa6500fb = '#FF991F';
var $d7df1392c2cb1415$export$874739ea9e379ab6 = '#FF8B00';
var $d7df1392c2cb1415$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $d7df1392c2cb1415$export$69a3bf21b9686c2b = '#ABF5D1';
var $d7df1392c2cb1415$export$afbce1382ec95f73 = '#79F2C0';
var $d7df1392c2cb1415$export$747d86715d4175de = '#57D9A3';
var $d7df1392c2cb1415$export$940e1f69e873f202 = '#36B37E';
var $d7df1392c2cb1415$export$a49394138f7b8e85 = '#00875A';
var $d7df1392c2cb1415$export$6fa04827ac68a4fb = '#006644';
var $d7df1392c2cb1415$export$226de0355ed012f8 = '#DEEBFF';
var $d7df1392c2cb1415$export$8c13c2ee36917869 = '#B3D4FF';
var $d7df1392c2cb1415$export$ecfc1dff386a3e7a = '#4C9AFF';
var $d7df1392c2cb1415$export$215b7063051591f1 = '#2684FF';
var $d7df1392c2cb1415$export$e62e8919cca44969 = '#0065FF';
var $d7df1392c2cb1415$export$b3de0ae08da2ce64 = '#0052CC';
var $d7df1392c2cb1415$export$a6ee3d71bc067634 = '#0747A6';
var $d7df1392c2cb1415$export$67f15409e87642a1 = '#669DF1';
var $d7df1392c2cb1415$export$f0539dbc42dbb067 = '#8FB8F6';
var $d7df1392c2cb1415$export$363e4475840015bb = '#EAE6FF';
var $d7df1392c2cb1415$export$4b0a4417ed59760f = '#C0B6F2';
var $d7df1392c2cb1415$export$6011520a64d9a187 = '#998DD9';
var $d7df1392c2cb1415$export$a7175d4e9206bc80 = '#8777D9';
var $d7df1392c2cb1415$export$b48405b95304b5a1 = '#6554C0';
var $d7df1392c2cb1415$export$c71e4279dd54a18d = '#5243AA';
var $d7df1392c2cb1415$export$147899de772240ec = '#403294';
var $d7df1392c2cb1415$export$2cf711fe14c66f06 = '#E6FCFF';
var $d7df1392c2cb1415$export$7a8f4d33f6f9772c = '#B3F5FF';
var $d7df1392c2cb1415$export$776c9c497ef08533 = '#79E2F2';
var $d7df1392c2cb1415$export$69cb3ca10c1e330e = '#00C7E6';
var $d7df1392c2cb1415$export$9dc1ef0f3f48059b = '#00B8D9';
var $d7df1392c2cb1415$export$7c835c78b6fcdef8 = '#00A3BF';
var $d7df1392c2cb1415$export$6036577f95c3877e = '#008DA6';
var $d7df1392c2cb1415$export$29a4f05edc054374 = '#FFFFFF';
var $d7df1392c2cb1415$export$e655ef011c4aa1a2 = '#FAFBFC';
var $d7df1392c2cb1415$export$9fdfb749e33cdf97 = '#F4F5F7';
var $d7df1392c2cb1415$export$3e51e8f1440314ba = '#EBECF0';
var $d7df1392c2cb1415$export$1ce2d1575d444ceb = '#DFE1E6';
var $d7df1392c2cb1415$export$8754fc7e6d8b3000 = '#C1C7D0';
var $d7df1392c2cb1415$export$c2e91cbeada39b8b = '#B3BAC5';
var $d7df1392c2cb1415$export$5f71e19f3a7ad9de = '#A5ADBA';
var $d7df1392c2cb1415$export$eaa8c8a70ac22806 = '#97A0AF';
var $d7df1392c2cb1415$export$7c87d337fb91a97d = '#8993A4';
var $d7df1392c2cb1415$export$d6447c357493214f = '#7A869A';
var $d7df1392c2cb1415$export$f563ee71e9ee74cd = '#6B778C';
var $d7df1392c2cb1415$export$e2ef2124cf4024b1 = '#5E6C84';
var $d7df1392c2cb1415$export$eece5f492e429f08 = '#505F79';
var $d7df1392c2cb1415$export$c39c0fe0f26207ae = '#42526E';
var $d7df1392c2cb1415$export$7090862dc3038a9f = '#344563';
var $d7df1392c2cb1415$export$ad0bacf983b7ddaa = '#253858';
var $d7df1392c2cb1415$export$7d61b15e0da132af = '#172B4D';
var $d7df1392c2cb1415$export$fbda843f0a27fe96 = '#091E42';
var $d7df1392c2cb1415$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $d7df1392c2cb1415$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $d7df1392c2cb1415$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $d7df1392c2cb1415$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $d7df1392c2cb1415$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $d7df1392c2cb1415$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $d7df1392c2cb1415$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $d7df1392c2cb1415$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $d7df1392c2cb1415$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $d7df1392c2cb1415$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $d7df1392c2cb1415$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $d7df1392c2cb1415$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $d7df1392c2cb1415$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $d7df1392c2cb1415$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $d7df1392c2cb1415$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $d7df1392c2cb1415$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $d7df1392c2cb1415$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $d7df1392c2cb1415$export$2f6319cf7d736c2a = '#E6EDFA';
var $d7df1392c2cb1415$export$95126bc8884d6634 = '#DCE5F5';
var $d7df1392c2cb1415$export$8338d8c35d44ff1 = '#CED9EB';
var $d7df1392c2cb1415$export$5368d76ae4fbbda7 = '#B8C7E0';
var $d7df1392c2cb1415$export$9f0a771d16ec8d36 = '#ABBBD6';
var $d7df1392c2cb1415$export$abcf8c38338b4aa5 = '#9FB0CC';
var $d7df1392c2cb1415$export$97e81faa16a182c7 = '#8C9CB8';
var $d7df1392c2cb1415$export$bfe21c59123ecf33 = '#7988A3';
var $d7df1392c2cb1415$export$ee82aa2ea6a1558 = '#67758F';
var $d7df1392c2cb1415$export$682927c6ed76be02 = '#56637A';
var $d7df1392c2cb1415$export$91fd9994c5be9757 = '#455166';
var $d7df1392c2cb1415$export$d281fbfe3cff2df6 = '#3B475C';
var $d7df1392c2cb1415$export$3902c91d8b98a753 = '#313D52';
var $d7df1392c2cb1415$export$8e8133c1ba5845b5 = '#283447';
var $d7df1392c2cb1415$export$33ff357f6620b39 = '#202B3D';
var $d7df1392c2cb1415$export$633847cf062b69e0 = '#1B2638';
var $d7df1392c2cb1415$export$9776a6e503bdbf76 = '#121A29';
var $d7df1392c2cb1415$export$6c813d5160dff5db = '#0E1624';
var $d7df1392c2cb1415$export$3d4f271a500072a = '#0D1424';
var $d7df1392c2cb1415$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $d7df1392c2cb1415$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $d7df1392c2cb1415$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $d7df1392c2cb1415$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $d7df1392c2cb1415$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $d7df1392c2cb1415$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $d7df1392c2cb1415$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $d7df1392c2cb1415$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $d7df1392c2cb1415$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $d7df1392c2cb1415$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $d7df1392c2cb1415$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $d7df1392c2cb1415$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $d7df1392c2cb1415$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $d7df1392c2cb1415$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $d7df1392c2cb1415$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $d7df1392c2cb1415$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $d7df1392c2cb1415$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $d7df1392c2cb1415$export$d2adc5dedf09fced = '#292A2E';
var $d7df1392c2cb1415$export$f51762073d2bb381 = '#94C748';
var $d7df1392c2cb1415$export$95e26d54def96891 = '#B3DF72';


var $2871e4832ca4bd2f$export$362a25f017e2bc8a = function getColorsFromAppearanceOldLogos(appearance, colorMode) {
    var iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = (0, $d7df1392c2cb1415$export$b3de0ae08da2ce64);
            iconGradientStop = (0, $d7df1392c2cb1415$export$215b7063051591f1);
            iconColor = (0, $d7df1392c2cb1415$export$215b7063051591f1);
            textColor = "var(--ds-text, ".concat((0, $d7df1392c2cb1415$export$7d61b15e0da132af), ")");
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $d7df1392c2cb1415$export$b3de0ae08da2ce64);
            break;
        case 'neutral':
            iconGradientStart = (0, $d7df1392c2cb1415$export$7090862dc3038a9f);
            iconGradientStop = (0, $d7df1392c2cb1415$export$d6447c357493214f);
            iconColor = (0, $d7df1392c2cb1415$export$d6447c357493214f);
            textColor = (0, $d7df1392c2cb1415$export$eece5f492e429f08);
            atlassianLogoTextColor = (0, $d7df1392c2cb1415$export$eece5f492e429f08);
            break;
        case 'inverse':
            iconGradientStart = '#FFFFFF66';
            iconGradientStop = '#FFFFFF';
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    if (colorMode === 'dark' && appearance === 'inverse') {
        iconGradientStart = '#161A1D66';
        iconGradientStop = '#161A1D';
        iconColor = '#161A1D';
        textColor = '#161A1D';
        atlassianLogoTextColor = '#161A1D';
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $2871e4832ca4bd2f$export$bbacc3980e0f3029 = function getColorsFromAppearance(appearance, colorMode) {
    var iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = (0, $d7df1392c2cb1415$export$29a4f05edc054374);
            textColor = (0, $d7df1392c2cb1415$export$29a4f05edc054374);
            atlassianLogoTextColor = (0, $d7df1392c2cb1415$export$29a4f05edc054374);
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $2871e4832ca4bd2f$export$7818df200941dbbf = function getColorsForLoom(appearance, colorMode) {
    var iconColor = $2871e4832ca4bd2f$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
    var textColor = $2871e4832ca4bd2f$export$bbacc3980e0f3029(appearance, colorMode).textColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#EFF0FF';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#252434';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};


var $fd94651bfb983298$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251\"/>\n    </svg>");
};
var $fd94651bfb983298$export$8a485e2e7ed91e8f = function AtlassianIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor, testId = _ref2.testId;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $fd94651bfb983298$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $bfd88f1eb4dd979f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 198 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\">\n      <path fill=".concat(colors.iconColor, " d=\"M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"/>\n      <path fill=").concat(colors.atlassianLogoTextColor, " d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.265 0 1.061-.708 1.698-2.973 1.698-2.619 0-5.733-.92-7.785-2.123v4.813c1.627.778 3.751 1.698 7.785 1.698 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.298-2.902-.637-3.61-1.274-3.61-2.194 0-1.133 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.698v-4.6c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.17h4.318V9.979l1.769 4.035 6.087 11.324h5.379V5.166h-4.247v13.022l-1.628-3.821-4.883-9.201zm-27.319 0h-4.671v20.17h4.671zm-10.05 14.154c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.708 6.795 1.699v-4.6c-1.557-.78-3.893-1.346-6.653-1.346-5.238 0-7.927 2.265-7.927 5.946 0 2.972 1.344 5.308 6.794 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.618 0-5.733-.92-7.785-2.123v4.812c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.166v20.17h9.625l1.486-4.387h-6.44V5.166zm-19.039 0v4.317h5.167v15.854h4.741V9.483h5.592V5.166zm-6.866 0h-6.157L32 25.336h5.379l.99-3.396c1.204.353 2.478.566 3.752.566s2.548-.213 3.751-.567l.991 3.398h5.379c-.07 0-7.078-20.171-7.078-20.171M42.05 18.259c-.92 0-1.77-.141-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354zM97.326 5.166H91.17l-7.078 20.17h5.38l.99-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.114 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.093h-6.157l-7.007 20.17h5.379l.991-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.043 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354\"/>\n    </svg>");
};
var $bfd88f1eb4dd979f$export$765cacec8b0843f3 = function AtlassianLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $bfd88f1eb4dd979f$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $j9spr = parcelRequire("j9spr");

var $7fPBF = parcelRequire("7fPBF");



var $j9spr = parcelRequire("j9spr");

var $7fPBF = parcelRequire("7fPBF");



var $0a833860173a6d7c$var$justifyContentMap = {
    start: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyContent: 'start'
    }),
    center: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyContent: 'center'
    }),
    end: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyContent: 'end'
    }),
    'space-between': (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        justifyContent: 'stretch'
    })
};
var $0a833860173a6d7c$var$flexDirectionMap = {
    column: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        flexDirection: 'column'
    }),
    row: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        flexDirection: 'row'
    })
};
var $0a833860173a6d7c$var$flexWrapMap = {
    wrap: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        flexWrap: 'nowrap'
    })
};
var $0a833860173a6d7c$var$alignItemsMap = {
    start: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignItems: 'start'
    }),
    center: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignItems: 'center'
    }),
    baseline: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignItems: 'baseline'
    }),
    end: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignItems: 'end'
    }),
    stretch: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        alignItems: 'stretch'
    })
};
var $0a833860173a6d7c$var$baseStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $0a833860173a6d7c$var$Flex = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, id = _ref.id;
    var resolvedStyles = (0, $3e5203791fd7c7fc$export$a9c84988c8f81f2d)(xcss);
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(Component, {
        id: id,
        role: role,
        className: resolvedStyles.static,
        css: [
            $0a833860173a6d7c$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $f914dcb93d08bd27$export$bf46c3f9eeafc71f).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $f914dcb93d08bd27$export$bf46c3f9eeafc71f).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $f914dcb93d08bd27$export$bf46c3f9eeafc71f).rowGap[rowGap],
            alignItems && $0a833860173a6d7c$var$alignItemsMap[alignItems],
            direction && $0a833860173a6d7c$var$flexDirectionMap[direction],
            justifyContent && $0a833860173a6d7c$var$justifyContentMap[justifyContent],
            wrap && $0a833860173a6d7c$var$flexWrapMap[wrap]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(resolvedStyles.emotion || [])),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$0a833860173a6d7c$var$Flex.displayName = 'Flex';
var $0a833860173a6d7c$export$2e2bcd8739ae039 = $0a833860173a6d7c$var$Flex;


var $067e8036161c713e$var$flexGrowMap = {
    hug: (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
        width: '100%',
        flexGrow: 1
    })
};
var $067e8036161c713e$var$separatorStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $067e8036161c713e$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("span", {
        css: $067e8036161c713e$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $067e8036161c713e$var$Inline = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, id = _ref2.id, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)($067e8036161c713e$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $7fPBF.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $7fPBF.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $067e8036161c713e$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $0a833860173a6d7c$export$2e2bcd8739ae039), {
        id: id,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$067e8036161c713e$var$Inline.displayName = 'Inline';
var $067e8036161c713e$export$2e2bcd8739ae039 = $067e8036161c713e$var$Inline;

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");
var $047c63fd47a9d222$var$HasTextAncestorContext = /*#__PURE__*/ (0, $7fPBF.createContext)(false);
var $047c63fd47a9d222$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $7fPBF.useContext)($047c63fd47a9d222$var$HasTextAncestorContext);
};
var $047c63fd47a9d222$export$ae933c6cbe5643ad = $047c63fd47a9d222$var$HasTextAncestorContext.Provider;




var $96a603e4012a3253$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $96a603e4012a3253$var$resetStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    margin: 0,
    overflowWrap: 'anywhere'
});
var $96a603e4012a3253$var$strongStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    fontWeight: "var(--ds-font-weight-bold, 653)"
});
var $96a603e4012a3253$var$emStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    fontStyle: 'italic'
});
var $96a603e4012a3253$var$textAlignMap = {
    center: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        textAlign: 'center'
    }),
    end: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        textAlign: 'end'
    }),
    start: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        textAlign: 'start'
    })
};
var $96a603e4012a3253$var$truncationStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
var $96a603e4012a3253$var$wordBreakMap = {
    breakAll: (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        wordBreak: 'break-all'
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $96a603e4012a3253$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $bd8fd1a07ee559ec$export$1aeb4f6b93c4540d)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $f914dcb93d08bd27$export$2185ce37f9bdd963).hasOwnProperty(surface)) return (0, $f914dcb93d08bd27$export$2185ce37f9bdd963)[surface];
    return 'color.text';
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $96a603e4012a3253$var$Text = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)($96a603e4012a3253$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $047c63fd47a9d222$export$9322276ec105d055)();
    var color = $96a603e4012a3253$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(Component, {
        ref: ref,
        css: [
            $96a603e4012a3253$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $f914dcb93d08bd27$export$219d364c0da35ae4)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $f914dcb93d08bd27$export$3a1bcba60b23d7f0)[color],
            maxLines && $96a603e4012a3253$var$truncationStyles,
            maxLines === 1 && $96a603e4012a3253$var$wordBreakMap.breakAll,
            align && $96a603e4012a3253$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $f914dcb93d08bd27$export$38845ca010b93505)[weight],
            Component === 'em' && $96a603e4012a3253$var$emStyles,
            Component === 'strong' && $96a603e4012a3253$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $047c63fd47a9d222$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var $96a603e4012a3253$export$2e2bcd8739ae039 = $96a603e4012a3253$var$Text;


const $7092fc21e9894387$var$iconStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    display: 'none',
    [(0, $8c23171a376c15ae$export$987d49ffe1b0900f).above.xs]: {
        display: 'flex'
    },
    [(0, $8c23171a376c15ae$export$987d49ffe1b0900f).above.sm]: {
        display: 'none'
    }
});
const $7092fc21e9894387$var$logoStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    display: 'none',
    [(0, $8c23171a376c15ae$export$987d49ffe1b0900f).above.sm]: {
        display: 'flex'
    }
});
const $7092fc21e9894387$var$headlineStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    display: 'none',
    [(0, $8c23171a376c15ae$export$987d49ffe1b0900f).above.md]: {
        display: 'flex'
    }
});
const $7092fc21e9894387$var$CustomProductHome = ()=>/*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $067e8036161c713e$export$2e2bcd8739ae039), {
        space: 'space.150',
        alignBlock: 'center',
        children: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $d675dd73cffce3dd$export$2e2bcd8739ae039), {
                href: "https://atlassian.com",
                target: "_blank",
                rel: "noreferrer",
                children: [
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                        xcss: $7092fc21e9894387$var$iconStyles,
                        children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $fd94651bfb983298$export$8a485e2e7ed91e8f), {
                            size: "small",
                            appearance: "brand",
                            testId: "product-home-icon"
                        })
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                        xcss: $7092fc21e9894387$var$logoStyles,
                        children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $bfd88f1eb4dd979f$export$765cacec8b0843f3), {
                            size: "small",
                            appearance: "brand",
                            testId: "product-home-logo"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                xcss: $7092fc21e9894387$var$headlineStyles,
                children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                    size: 'large',
                    testId: 'product-home-title',
                    children: "Email and Privacy Preferences"
                })
            })
        ]
    });
const $7092fc21e9894387$var$Header = ({ headerContent: headerContent })=>{
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $436c212ddd6b0459$export$f66ccb39f60980e5), {
        label: "Email and Privacy Preferences",
        primaryItems: [],
        renderProductHome: $7092fc21e9894387$var$CustomProductHome,
        renderProfile: headerContent,
        testId: "preferences-center"
    });
};
var $7092fc21e9894387$export$2e2bcd8739ae039 = $7092fc21e9894387$var$Header;






/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports

// dimension vars
var $e1bb1f20ef4efe28$export$cbfb0f5b2869b17b = 'leftPanelWidth';
var $e1bb1f20ef4efe28$export$a30f2e00489a8957 = 'leftSidebarWidth';
var $e1bb1f20ef4efe28$export$c103b605cd368aed = 'rightSidebarWidth';
var $e1bb1f20ef4efe28$export$fa34f417972d6341 = 'rightPanelWidth';
var $e1bb1f20ef4efe28$export$3a6a779d9181047c = 'topNavigationHeight';
var $e1bb1f20ef4efe28$export$bcd94a6a792e7f96 = 'bannerHeight';
var $e1bb1f20ef4efe28$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
var $e1bb1f20ef4efe28$export$344062f7cfc9528e = 'left-panel';
var $e1bb1f20ef4efe28$export$c7139cc2d6110b5f = 'right-panel';
var $e1bb1f20ef4efe28$export$238d30785c4bca84 = 'banner';
var $e1bb1f20ef4efe28$export$bec6dca2e63de4ae = 'top-navigation';
var $e1bb1f20ef4efe28$export$d1213e82613ff4df = 'content';
var $e1bb1f20ef4efe28$export$be83e7118304b28e = 56;
var $e1bb1f20ef4efe28$export$4a98ee0bd1ae362 = 56;
var $e1bb1f20ef4efe28$export$539e68c09584883a = 240;
var $e1bb1f20ef4efe28$export$b92df8810d2fcd01 = 280;
var $e1bb1f20ef4efe28$export$c3e41153b9288bcf = 368;
var $e1bb1f20ef4efe28$export$c4d6152f86ea28f6 = 368;
var $e1bb1f20ef4efe28$export$46acf8758e9e2636 = 20;
var $e1bb1f20ef4efe28$export$70740f5ad8360a78 = 16;
var $e1bb1f20ef4efe28$export$991d5285ad765a3d = 240;
var $e1bb1f20ef4efe28$export$6949d4f32b161684 = 200;
var $e1bb1f20ef4efe28$export$d6e7e8af042815bb = 350;
var $e1bb1f20ef4efe28$export$3749e1104328fde4 = 300;
var $e1bb1f20ef4efe28$export$1074d925b0b82be5 = 200;
var $e1bb1f20ef4efe28$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
var $e1bb1f20ef4efe28$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
var $e1bb1f20ef4efe28$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
var $e1bb1f20ef4efe28$export$70c702a8c5895f03 = 'data-grab-area-line';
var $e1bb1f20ef4efe28$export$48a43f91e4becf4e = 'data-grab-area';
var $e1bb1f20ef4efe28$export$dac2fb31a9f6844d = 'data-resize-button';
var $e1bb1f20ef4efe28$export$9ecd22db14e6c70e = 'data-resize-control';
var $e1bb1f20ef4efe28$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
var $e1bb1f20ef4efe28$export$206a08f7f8beb554 = 'Skip to:';
var $e1bb1f20ef4efe28$export$659ee746b31b360d = 'data-layout-container';
var $e1bb1f20ef4efe28$export$f963aecf2d4465bd = "var(--".concat($e1bb1f20ef4efe28$export$cbfb0f5b2869b17b, ", 0px)");
var $e1bb1f20ef4efe28$export$750459958906793 = "var(--".concat($e1bb1f20ef4efe28$export$fa34f417972d6341, ", 0px)");
var $e1bb1f20ef4efe28$export$f897e1ed9f8ed251 = "var(--".concat($e1bb1f20ef4efe28$export$a30f2e00489a8957, ", 0px)");
var $e1bb1f20ef4efe28$export$b44ab66843c05a69 = "var(--".concat($e1bb1f20ef4efe28$export$c103b605cd368aed, ", 0px)");
var $e1bb1f20ef4efe28$export$aeff86a16f13529 = "var(--".concat($e1bb1f20ef4efe28$export$3a6a779d9181047c, ", 0px)");
var $e1bb1f20ef4efe28$export$ed7cc0d417ee89e = "var(--".concat($e1bb1f20ef4efe28$export$bcd94a6a792e7f96, ", 0px)");
var $e1bb1f20ef4efe28$export$d2fa14f05b61e66 = "var(--".concat($e1bb1f20ef4efe28$export$b6744d31294864fd, ", ").concat($e1bb1f20ef4efe28$export$991d5285ad765a3d, "px)");


var $d3f7915c8afb3490$var$contentStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $e1bb1f20ef4efe28$export$d1213e82613ff4df)
});
/**
 * __Content__
 *
 * Provides a slot for your application content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ var $d3f7915c8afb3490$var$Content = function Content(props) {
    var children = props.children, testId = props.testId;
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("div", {
        "data-testid": testId,
        css: $d3f7915c8afb3490$var$contentStyles
    }, children);
};
var $d3f7915c8afb3490$export$2e2bcd8739ae039 = $d3f7915c8afb3490$var$Content;



var $7fPBF = parcelRequire("7fPBF");


var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $adc46454e3d9e2c8$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $adc46454e3d9e2c8$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$adc46454e3d9e2c8$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $adc46454e3d9e2c8$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $7fPBF.useState)($adc46454e3d9e2c8$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $7fPBF.useEffect)(function() {
        if (!$adc46454e3d9e2c8$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $a091c25729a976b1$exports.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $adc46454e3d9e2c8$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $adc46454e3d9e2c8$export$ff7706047246b98b = function prefersReducedMotion() {
    return $adc46454e3d9e2c8$export$f0f789643ba5a83c;
};


var $f3f9aa62ed707d7e$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
var $f3f9aa62ed707d7e$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
var $f3f9aa62ed707d7e$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
var $f3f9aa62ed707d7e$export$fc825baa2ef870d0 = 'cubic-bezier(0.4,0,0,1)';
var $f3f9aa62ed707d7e$export$816ee5d79b5bd9a5 = 'cubic-bezier(0.6,0,0,1)';
var $f3f9aa62ed707d7e$export$53ce3390a1a8f2a2 = 'cubic-bezier(0.8,0,0,1)';
var $f3f9aa62ed707d7e$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';




var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $c22154329a99fe14$var$getIsDragging = function getIsDragging() {
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $e1bb1f20ef4efe28$export$802bb2c050f3db5c)) === 'true';
};
// TODO: I think this should be derived from the sidebar state,
// and not indirectly from observing an attribute change
var $c22154329a99fe14$var$useIsSidebarDragging = function useIsSidebarDragging() {
    var _useState = (0, $7fPBF.useState)($c22154329a99fe14$var$getIsDragging), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), isDragging = _useState2[0], setIsDragging = _useState2[1];
    (0, $7fPBF.useEffect)(function() {
        var observer = new MutationObserver(function() {
            setIsDragging($c22154329a99fe14$var$getIsDragging);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $e1bb1f20ef4efe28$export$802bb2c050f3db5c)
            ]
        });
        return function() {
            observer.disconnect();
        };
    }, []);
    return isDragging;
};
var $c22154329a99fe14$export$2e2bcd8739ae039 = $c22154329a99fe14$var$useIsSidebarDragging;



var $8MJe2 = parcelRequire("8MJe2");

var $bRUy3 = parcelRequire("bRUy3");

// Reliably test against conditions like
// localStorage being full or private mode in Safari being a .
// https://gist.github.com/paulirish/5558557
var $54a9774f5a9436a2$var$isLocalStorageSupported = function isLocalStorageSupported() {
    try {
        // use an random key to test
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        var testKey = "__test_".concat(Date.now(), "__");
        localStorage.setItem(testKey, testKey);
        localStorage.removeItem(testKey);
        return true;
    } catch (_unused) {
        return false;
    }
};
var $54a9774f5a9436a2$var$safeLocalStorage = function safeLocalStorage() {
    if ($54a9774f5a9436a2$var$isLocalStorageSupported()) return localStorage;
    // Returning a mock object here in the case that this is run in SSR mode
    if (typeof window === 'undefined') return {
        getItem: function getItem(_key) {
            return null;
        },
        setItem: function setItem(_key, _value) {
            return null;
        },
        removeItem: function removeItem(_key) {
            return null;
        },
        clear: function clear() {
            return null;
        },
        key: function key(_index) {
            return null;
        },
        get length () {
            return 0;
        }
    };
    if (window.__localStorageFallback && Object.keys(window.__localStorageFallback).length !== 0) return window.__localStorageFallback;
    var storageAPI = {
        getItem: function getItem(key) {
            if (window.__localStorageFallback.hasOwnProperty(key)) return window.__localStorageFallback[key];
            return null;
        },
        setItem: function setItem(key, value) {
            window.__localStorageFallback[key] = String(value);
        },
        removeItem: function removeItem(key) {
            delete window.__localStorageFallback[key];
        },
        clear: function clear() {
            for(var key in window.__localStorageFallback)if (window.__localStorageFallback.hasOwnProperty(key)) delete window.__localStorageFallback[key];
        },
        get length () {
            if (!window.__localStorageFallback) return 0;
            return Object.keys(window.__localStorageFallback).length;
        }
    };
    window.__localStorageFallback = Object.create(storageAPI);
    return window.__localStorageFallback;
};
var $54a9774f5a9436a2$export$2e2bcd8739ae039 = $54a9774f5a9436a2$var$safeLocalStorage;


function $bc7ef42a2451ffb0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bc7ef42a2451ffb0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bc7ef42a2451ffb0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bc7ef42a2451ffb0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bc7ef42a2451ffb0$export$f8355a2df0f4a946 = function mergeGridStateIntoStorage(key, value) {
    var storageValue = JSON.parse((0, $54a9774f5a9436a2$export$2e2bcd8739ae039)().getItem((0, $e1bb1f20ef4efe28$export$451e84a45a9e4a75)) || '{}');
    if (value !== null && (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(value) === 'object') storageValue[key] = $bc7ef42a2451ffb0$var$_objectSpread($bc7ef42a2451ffb0$var$_objectSpread({}, storageValue[key]), value);
    else storageValue[key] = value;
    (0, $54a9774f5a9436a2$export$2e2bcd8739ae039)().setItem((0, $e1bb1f20ef4efe28$export$451e84a45a9e4a75), JSON.stringify(storageValue));
};
var $bc7ef42a2451ffb0$export$d95e99d8116d17dc = function getGridStateFromStorage(key) {
    var storageValue = JSON.parse((0, $54a9774f5a9436a2$export$2e2bcd8739ae039)().getItem((0, $e1bb1f20ef4efe28$export$451e84a45a9e4a75)) || '{}');
    return storageValue[key];
};
var $bc7ef42a2451ffb0$export$17e3760e0b35f1cd = function removeFromGridStateInStorage(key, secondKey) {
    var storageValue = JSON.parse((0, $54a9774f5a9436a2$export$2e2bcd8739ae039)().getItem((0, $e1bb1f20ef4efe28$export$451e84a45a9e4a75)) || '{}');
    if (secondKey && storageValue[key]) delete storageValue[key][secondKey];
    else delete storageValue[key];
    (0, $54a9774f5a9436a2$export$2e2bcd8739ae039)().setItem((0, $e1bb1f20ef4efe28$export$451e84a45a9e4a75), JSON.stringify(storageValue));
};
var $bc7ef42a2451ffb0$export$74732e47915c7839 = function resolveDimension(key) {
    var dimension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var shouldPersist = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (shouldPersist) {
        var cachedGridState = $bc7ef42a2451ffb0$export$d95e99d8116d17dc('gridState');
        return cachedGridState && Object.keys(cachedGridState).length > 0 && cachedGridState[key] ? cachedGridState[key] : dimension;
    }
    return dimension;
};
var $bc7ef42a2451ffb0$export$b089e01213f07bd = function getLeftPanelWidth() {
    if (typeof window === 'undefined') return 0;
    return parseInt(window.getComputedStyle(document.documentElement).getPropertyValue("--".concat((0, $e1bb1f20ef4efe28$export$f963aecf2d4465bd))), 10) || 0;
};
var $bc7ef42a2451ffb0$export$2bca58b6ee823bf7 = function getLeftSidebarPercentage(currentWidth, maxWidth) {
    var total = (currentWidth - (0, $e1bb1f20ef4efe28$export$539e68c09584883a)) / (maxWidth - (0, $e1bb1f20ef4efe28$export$539e68c09584883a));
    if (total < 0) return 0;
    if (total > 1) return 100;
    return Math.floor(total * 100);
};
var $bc7ef42a2451ffb0$export$e895e3e8b708ae2a = function getPageLayoutSlotSelector(slotName) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, (0, $e1bb1f20ef4efe28$export$5253dd9707b8c3ba), slotName);
};
var $bc7ef42a2451ffb0$export$218ece2c32b7db0e = function getPageLayoutSlotCSSSelector(slotName) {
    return "[".concat((0, $e1bb1f20ef4efe28$export$5253dd9707b8c3ba), "='").concat(slotName, "']");
};



var $8MJe2 = parcelRequire("8MJe2");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $ddf576c977c2e750$var$_excluded = [
    "setLeftSidebarState"
];
function $ddf576c977c2e750$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ddf576c977c2e750$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ddf576c977c2e750$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ddf576c977c2e750$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ddf576c977c2e750$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true,
    hasInit: false
};
var $ddf576c977c2e750$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $7fPBF.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $f48d740006cf3f7d$export$2e2bcd8739ae039),
    collapseLeftSidebar: (0, $f48d740006cf3f7d$export$2e2bcd8739ae039),
    leftSidebarState: $ddf576c977c2e750$var$leftSidebarState,
    setLeftSidebarState: (0, $f48d740006cf3f7d$export$2e2bcd8739ae039),
    toggleLeftSidebar: (0, $f48d740006cf3f7d$export$2e2bcd8739ae039)
});
var $ddf576c977c2e750$export$10c7104037a7af62 = function usePageLayoutResize() {
    var _useContext = (0, $7fPBF.useContext)($ddf576c977c2e750$export$aa5a712eea4c2ae8), setLeftSidebarState = _useContext.setLeftSidebarState, context = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_useContext, $ddf576c977c2e750$var$_excluded);
    return context;
};
var $ddf576c977c2e750$export$94561f6055639ef7 = function useLeftSidebarFlyoutLock() {
    var _useContext2 = (0, $7fPBF.useContext)($ddf576c977c2e750$export$aa5a712eea4c2ae8), setLeftSidebarState = _useContext2.setLeftSidebarState;
    (0, $7fPBF.useEffect)(function() {
        setLeftSidebarState(function(current) {
            return $ddf576c977c2e750$var$_objectSpread($ddf576c977c2e750$var$_objectSpread({}, current), {}, {
                flyoutLockCount: current.flyoutLockCount + 1
            });
        });
        return function() {
            setLeftSidebarState(function(current) {
                return $ddf576c977c2e750$var$_objectSpread($ddf576c977c2e750$var$_objectSpread({}, current), {}, {
                    flyoutLockCount: current.flyoutLockCount - 1
                });
            });
        };
    }, [
        setLeftSidebarState
    ]);
};


var $7fPBF = parcelRequire("7fPBF");

var $1e2b1573caccd841$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $7fPBF.createContext)({
    skipLinksData: [],
    registerSkipLink: (0, $f48d740006cf3f7d$export$2e2bcd8739ae039),
    unregisterSkipLink: (0, $f48d740006cf3f7d$export$2e2bcd8739ae039)
});
var $1e2b1573caccd841$export$c9d9cb2ee9590f87 = function useSkipLinks() {
    return (0, $7fPBF.useContext)($1e2b1573caccd841$export$4c5cc3b14c7678a);
};
var $1e2b1573caccd841$export$89d9323301efc7d6 = function useSkipLink(id, skipLinkTitle) {
    var _useSkipLinks = $1e2b1573caccd841$export$c9d9cb2ee9590f87(), registerSkipLink = _useSkipLinks.registerSkipLink, unregisterSkipLink = _useSkipLinks.unregisterSkipLink;
    (0, $7fPBF.useEffect)(function() {
        if (id && skipLinkTitle) registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle
        });
        return function() {
            unregisterSkipLink(id);
        };
    }, [
        id,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports

var $c3c66c1bd34e39a4$var$focusStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            boxShadow: "0px 0px 0px 2px inset ".concat("var(--ds-border-focused, #4688EC)"),
            outline: 'none'
        }
    }
});
/**
 * Sidebars have an outer and inner component,
 * so the nested selector needs to target an extra level deeper.
 */ var $c3c66c1bd34e39a4$var$sidebarFocusStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div > div': {
            boxShadow: "0px 0px 0px 2px inset ".concat("var(--ds-border-focused, #4688EC)"),
            outline: 'none'
        }
    }
});
/**
 * We don't use `@atlaskit/focus-ring` here,
 * because we need inset focus styles and:
 *
 * 1. If we set them directly to the layout element,
 *    then any child element's background will cover the shadow.
 * 2. We cannot wrap `children` in `FocusRing`,
 *    because there's no guarantee the passed child takes `className`.
 */ var $c3c66c1bd34e39a4$var$SlotFocusRing = function SlotFocusRing(_ref) {
    var children = _ref.children, _ref$isSidebar = _ref.isSidebar, isSidebar = _ref$isSidebar === void 0 ? false : _ref$isSidebar;
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $3ebaaabf76fb5db5$export$9b9c0f9d9f3552b8), null, function(_ref2) {
        var css = _ref2.css;
        return children({
            className: isSidebar ? css($c3c66c1bd34e39a4$var$sidebarFocusStyles) : css($c3c66c1bd34e39a4$var$focusStyles)
        });
    });
};
var $c3c66c1bd34e39a4$export$2e2bcd8739ae039 = $c3c66c1bd34e39a4$var$SlotFocusRing;


// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $9f06dd5f55f9dca6$var$prefersReducedMotionStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)((0, $adc46454e3d9e2c8$export$ff7706047246b98b)());
var $9f06dd5f55f9dca6$var$mainStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    minWidth: 0,
    flexGrow: 1,
    marginInlineStart: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: "margin-left ".concat((0, $e1bb1f20ef4efe28$export$3749e1104328fde4), "ms ").concat((0, $f3f9aa62ed707d7e$export$57636bb43b1ccbb0), " 0s")
});
var $9f06dd5f55f9dca6$var$draggingStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    // Make sure drag to resize remains snappy.
    transition: 'none'
});
/**
 * Adds a negative left margin to main,
 * which transitions at the same speed as the left sidebar's width increase.
 * This give an illusion that the flyout is appearing on top of the main content,
 * while main remains in place.
 */ var $9f06dd5f55f9dca6$var$flyoutStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: "calc(-1 * var(--".concat((0, $e1bb1f20ef4efe28$export$b6744d31294864fd), ", ").concat((0, $e1bb1f20ef4efe28$export$991d5285ad765a3d), "px) + ").concat((0, $e1bb1f20ef4efe28$export$46acf8758e9e2636), "px)")
});
/**
 * __Main__
 *
 * Provides a slot for main content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ var $9f06dd5f55f9dca6$var$Main = function Main(props) {
    var children = props.children, testId = props.testId, id = props.id, skipLinkTitle = props.skipLinkTitle;
    (0, $1e2b1573caccd841$export$89d9323301efc7d6)(id, skipLinkTitle);
    var isDragging = (0, $c22154329a99fe14$export$2e2bcd8739ae039)();
    var _useContext = (0, $7fPBF.useContext)((0, $ddf576c977c2e750$export$aa5a712eea4c2ae8)), _useContext$leftSideb = _useContext.leftSidebarState, isFlyoutOpen = _useContext$leftSideb.isFlyoutOpen, isFixed = _useContext$leftSideb.isFixed;
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $c3c66c1bd34e39a4$export$2e2bcd8739ae039), null, function(_ref) {
        var className = _ref.className;
        return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("main", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
            "data-testid": testId,
            css: [
                $9f06dd5f55f9dca6$var$mainStyles,
                isDragging && $9f06dd5f55f9dca6$var$draggingStyles,
                isFlyoutOpen && !isFixed && $9f06dd5f55f9dca6$var$flyoutStyles,
                $9f06dd5f55f9dca6$var$prefersReducedMotionStyles
            ],
            className: className,
            id: id
        }, (0, $bc7ef42a2451ffb0$export$e895e3e8b708ae2a)('main')), children);
    });
};
var $9f06dd5f55f9dca6$export$2e2bcd8739ae039 = $9f06dd5f55f9dca6$var$Main;



var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");

/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $7a3e63dc1837f7f4$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
var $7a3e63dc1837f7f4$export$c881183ca713c214 = $7a3e63dc1837f7f4$export$987d49ffe1b0900f;




var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
var $1ba769a1a0dcf52b$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $7fPBF.useEffect) : (0, $7fPBF.useLayoutEffect);



var $d4a71a64adad918b$var$_window, $d4a71a64adad918b$var$_window$matchMedia, $d4a71a64adad918b$var$_window2, $d4a71a64adad918b$var$_window2$matchMedia, $d4a71a64adad918b$var$_window3, $d4a71a64adad918b$var$_window3$matchMedia, $d4a71a64adad918b$var$_window4, $d4a71a64adad918b$var$_window4$matchMedia, $d4a71a64adad918b$var$_window5, $d4a71a64adad918b$var$_window5$matchMedia, $d4a71a64adad918b$var$_window6, $d4a71a64adad918b$var$_window6$matchMedia, $d4a71a64adad918b$var$_window7, $d4a71a64adad918b$var$_window7$matchMedia, $d4a71a64adad918b$var$_window8, $d4a71a64adad918b$var$_window8$matchMedia, $d4a71a64adad918b$var$_window9, $d4a71a64adad918b$var$_window9$matchMedia, $d4a71a64adad918b$var$_window0, $d4a71a64adad918b$var$_window0$matchMedia, $d4a71a64adad918b$var$_window1, $d4a71a64adad918b$var$_window1$matchMedia;
var $d4a71a64adad918b$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($d4a71a64adad918b$var$_window = window) === null || $d4a71a64adad918b$var$_window === void 0 || ($d4a71a64adad918b$var$_window$matchMedia = $d4a71a64adad918b$var$_window.matchMedia) === null || $d4a71a64adad918b$var$_window$matchMedia === void 0 ? void 0 : $d4a71a64adad918b$var$_window$matchMedia.call($d4a71a64adad918b$var$_window, (0, $7a3e63dc1837f7f4$export$c881183ca713c214).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($d4a71a64adad918b$var$_window2 = window) === null || $d4a71a64adad918b$var$_window2 === void 0 || ($d4a71a64adad918b$var$_window2$matchMedia = $d4a71a64adad918b$var$_window2.matchMedia) === null || $d4a71a64adad918b$var$_window2$matchMedia === void 0 ? void 0 : $d4a71a64adad918b$var$_window2$matchMedia.call($d4a71a64adad918b$var$_window2, (0, $7a3e63dc1837f7f4$export$c881183ca713c214).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($d4a71a64adad918b$var$_window3 = window) === null || $d4a71a64adad918b$var$_window3 === void 0 || ($d4a71a64adad918b$var$_window3$matchMedia = $d4a71a64adad918b$var$_window3.matchMedia) === null || $d4a71a64adad918b$var$_window3$matchMedia === void 0 ? void 0 : $d4a71a64adad918b$var$_window3$matchMedia.call($d4a71a64adad918b$var$_window3, (0, $7a3e63dc1837f7f4$export$c881183ca713c214).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($d4a71a64adad918b$var$_window4 = window) === null || $d4a71a64adad918b$var$_window4 === void 0 || ($d4a71a64adad918b$var$_window4$matchMedia = $d4a71a64adad918b$var$_window4.matchMedia) === null || $d4a71a64adad918b$var$_window4$matchMedia === void 0 ? void 0 : $d4a71a64adad918b$var$_window4$matchMedia.call($d4a71a64adad918b$var$_window4, (0, $7a3e63dc1837f7f4$export$c881183ca713c214).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($d4a71a64adad918b$var$_window5 = window) === null || $d4a71a64adad918b$var$_window5 === void 0 || ($d4a71a64adad918b$var$_window5$matchMedia = $d4a71a64adad918b$var$_window5.matchMedia) === null || $d4a71a64adad918b$var$_window5$matchMedia === void 0 ? void 0 : $d4a71a64adad918b$var$_window5$matchMedia.call($d4a71a64adad918b$var$_window5, (0, $7a3e63dc1837f7f4$export$c881183ca713c214).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($d4a71a64adad918b$var$_window6 = window) === null || $d4a71a64adad918b$var$_window6 === void 0 || ($d4a71a64adad918b$var$_window6$matchMedia = $d4a71a64adad918b$var$_window6.matchMedia) === null || $d4a71a64adad918b$var$_window6$matchMedia === void 0 ? void 0 : $d4a71a64adad918b$var$_window6$matchMedia.call($d4a71a64adad918b$var$_window6, (0, $7a3e63dc1837f7f4$export$c881183ca713c214).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($d4a71a64adad918b$var$_window7 = window) === null || $d4a71a64adad918b$var$_window7 === void 0 || ($d4a71a64adad918b$var$_window7$matchMedia = $d4a71a64adad918b$var$_window7.matchMedia) === null || $d4a71a64adad918b$var$_window7$matchMedia === void 0 ? void 0 : $d4a71a64adad918b$var$_window7$matchMedia.call($d4a71a64adad918b$var$_window7, (0, $7a3e63dc1837f7f4$export$c881183ca713c214).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($d4a71a64adad918b$var$_window8 = window) === null || $d4a71a64adad918b$var$_window8 === void 0 || ($d4a71a64adad918b$var$_window8$matchMedia = $d4a71a64adad918b$var$_window8.matchMedia) === null || $d4a71a64adad918b$var$_window8$matchMedia === void 0 ? void 0 : $d4a71a64adad918b$var$_window8$matchMedia.call($d4a71a64adad918b$var$_window8, (0, $7a3e63dc1837f7f4$export$c881183ca713c214).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($d4a71a64adad918b$var$_window9 = window) === null || $d4a71a64adad918b$var$_window9 === void 0 || ($d4a71a64adad918b$var$_window9$matchMedia = $d4a71a64adad918b$var$_window9.matchMedia) === null || $d4a71a64adad918b$var$_window9$matchMedia === void 0 ? void 0 : $d4a71a64adad918b$var$_window9$matchMedia.call($d4a71a64adad918b$var$_window9, (0, $7a3e63dc1837f7f4$export$c881183ca713c214).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($d4a71a64adad918b$var$_window0 = window) === null || $d4a71a64adad918b$var$_window0 === void 0 || ($d4a71a64adad918b$var$_window0$matchMedia = $d4a71a64adad918b$var$_window0.matchMedia) === null || $d4a71a64adad918b$var$_window0$matchMedia === void 0 ? void 0 : $d4a71a64adad918b$var$_window0$matchMedia.call($d4a71a64adad918b$var$_window0, (0, $7a3e63dc1837f7f4$export$c881183ca713c214).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($d4a71a64adad918b$var$_window1 = window) === null || $d4a71a64adad918b$var$_window1 === void 0 || ($d4a71a64adad918b$var$_window1$matchMedia = $d4a71a64adad918b$var$_window1.matchMedia) === null || $d4a71a64adad918b$var$_window1$matchMedia === void 0 ? void 0 : $d4a71a64adad918b$var$_window1$matchMedia.call($d4a71a64adad918b$var$_window1, (0, $7a3e63dc1837f7f4$export$c881183ca713c214).below.xl.replace('@media ', '').trim())
};
var $d4a71a64adad918b$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $7fPBF.useRef)(listener);
    (0, $7fPBF.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $d4a71a64adad918b$var$queries[queryString];
    (0, $1ba769a1a0dcf52b$export$e5c5a5f917a5871c)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $a091c25729a976b1$exports.bind)(mq, {
            type: 'change',
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};





var $c6d9fbc0fb73f1cd$var$handleDataAttributesAndCb = function handleDataAttributesAndCb() {
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $f48d740006cf3f7d$export$2e2bcd8739ae039);
    var leftSidebarState = arguments.length > 1 ? arguments[1] : undefined;
    document.documentElement.removeAttribute((0, $e1bb1f20ef4efe28$export$5e5e1875c3fd8f4f));
    callback(leftSidebarState);
};
var $c6d9fbc0fb73f1cd$var$leftSidebarSelector = (0, $bc7ef42a2451ffb0$export$218ece2c32b7db0e)('left-sidebar');
var $c6d9fbc0fb73f1cd$export$850bd1bba41f1448 = function SidebarResizeController(_ref) {
    var children = _ref.children, onExpand = _ref.onLeftSidebarExpand, onCollapse = _ref.onLeftSidebarCollapse;
    var _useState = (0, $7fPBF.useState)({
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), leftSidebarState = _useState2[0], setLeftSidebarState = _useState2[1];
    var leftSidebarWidth = leftSidebarState.leftSidebarWidth, lastLeftSidebarWidth = leftSidebarState.lastLeftSidebarWidth, isResizing = leftSidebarState.isResizing, flyoutLockCount = leftSidebarState.flyoutLockCount, isFixed = leftSidebarState.isFixed, isLeftSidebarCollapsed = leftSidebarState.isLeftSidebarCollapsed, isFlyoutOpen = leftSidebarState.isFlyoutOpen, hasInit = leftSidebarState.hasInit;
    // We put the latest callbacks into a ref so we can always have the latest
    // functions in our transitionend listeners
    var stableRef = (0, $7fPBF.useRef)({
        onExpand: onExpand,
        onCollapse: onCollapse
    });
    (0, $7fPBF.useEffect)(function() {
        stableRef.current = {
            onExpand: onExpand,
            onCollapse: onCollapse
        };
    }, [
        onExpand,
        onCollapse
    ]);
    var transition = (0, $7fPBF.useRef)(null);
    var mobileMediaQuery = (0, $d4a71a64adad918b$export$49e55ae2c03d6045)('below.sm');
    var isOpen = mobileMediaQuery !== null && mobileMediaQuery !== void 0 && mobileMediaQuery.matches ? isFlyoutOpen : !isLeftSidebarCollapsed;
    var expandLeftSidebar = (0, $7fPBF.useCallback)(function() {
        var _transition$current2, _transition$current3;
        if (isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't expand at mobile widths; instead we use a flyout which is treated the same otherwise
        if (mobileMediaQuery !== null && mobileMediaQuery !== void 0 && mobileMediaQuery.matches) {
            var _transition$current;
            var flyoutOpenSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $e1bb1f20ef4efe28$export$46acf8758e9e2636),
                lastLeftSidebarWidth: leftSidebarWidth,
                isFlyoutOpen: true,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutOpenSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onExpand` still
            (_transition$current = transition.current) === null || _transition$current === void 0 || _transition$current.complete();
            $c6d9fbc0fb73f1cd$var$handleDataAttributesAndCb(stableRef.current.onExpand, flyoutOpenSidebarState);
            return;
        }
        if (isResizing || !isLeftSidebarCollapsed || // already expanding
        ((_transition$current2 = transition.current) === null || _transition$current2 === void 0 ? void 0 : _transition$current2.action) === 'expand') return;
        // flush existing transition
        (_transition$current3 = transition.current) === null || _transition$current3 === void 0 || _transition$current3.complete();
        var width = Math.max(lastLeftSidebarWidth, (0, $e1bb1f20ef4efe28$export$539e68c09584883a));
        var updatedLeftSidebarState = {
            isLeftSidebarCollapsed: false,
            isFlyoutOpen: false,
            leftSidebarWidth: width,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $c6d9fbc0fb73f1cd$var$handleDataAttributesAndCb(stableRef.current.onExpand, updatedLeftSidebarState);
        }
        var sidebar = document.querySelector($c6d9fbc0fb73f1cd$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if ((0, $adc46454e3d9e2c8$export$b7baf7667a68d87c)() || !sidebar) {
            finish();
            return;
        }
        var unbindEvent = (0, $a091c25729a976b1$exports.bind)(sidebar, {
            type: 'transitionend',
            listener: function listener(event) {
                if (event.target === sidebar && event.propertyName === 'width') {
                    var _transition$current4;
                    (_transition$current4 = transition.current) === null || _transition$current4 === void 0 || _transition$current4.complete();
                }
            }
        });
        var value = {
            action: 'expand',
            complete: function complete() {
                value.abort();
                finish();
            },
            abort: function abort() {
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        lastLeftSidebarWidth,
        flyoutLockCount,
        isFixed,
        leftSidebarWidth,
        hasInit
    ]);
    var collapseLeftSidebar = (0, $7fPBF.useCallback)(function(_event, collapseWithoutTransition) {
        var _transition$current6, _transition$current7;
        if (!isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't collapse at mobile widths; instead we close the flyout.
        if (mobileMediaQuery !== null && mobileMediaQuery !== void 0 && mobileMediaQuery.matches) {
            var _transition$current5;
            var flyoutCloseSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $e1bb1f20ef4efe28$export$46acf8758e9e2636),
                lastLeftSidebarWidth: lastLeftSidebarWidth,
                isFlyoutOpen: false,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutCloseSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onCollapse` still
            (_transition$current5 = transition.current) === null || _transition$current5 === void 0 || _transition$current5.complete();
            $c6d9fbc0fb73f1cd$var$handleDataAttributesAndCb(stableRef.current.onCollapse, flyoutCloseSidebarState);
            return;
        }
        if (isResizing || isLeftSidebarCollapsed || // already collapsing
        ((_transition$current6 = transition.current) === null || _transition$current6 === void 0 ? void 0 : _transition$current6.action) === 'collapse') return;
        // flush existing transition
        (_transition$current7 = transition.current) === null || _transition$current7 === void 0 || _transition$current7.complete();
        // data-attribute is used as a CSS selector to sync the hiding/showing
        // of the nav contents with expand/collapse animation
        document.documentElement.setAttribute((0, $e1bb1f20ef4efe28$export$5e5e1875c3fd8f4f), 'true');
        var updatedLeftSidebarState = {
            isLeftSidebarCollapsed: true,
            isFlyoutOpen: false,
            leftSidebarWidth: (0, $e1bb1f20ef4efe28$export$46acf8758e9e2636),
            lastLeftSidebarWidth: leftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $c6d9fbc0fb73f1cd$var$handleDataAttributesAndCb(stableRef.current.onCollapse, updatedLeftSidebarState);
        }
        var sidebar = document.querySelector($c6d9fbc0fb73f1cd$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if (collapseWithoutTransition || (0, $adc46454e3d9e2c8$export$b7baf7667a68d87c)() || !sidebar) {
            finish();
            return;
        }
        var unbindEvent = (0, $a091c25729a976b1$exports.bind)(sidebar, {
            type: 'transitionend',
            listener: function listener(event) {
                if (sidebar === event.target && event.propertyName === 'width') {
                    var _transition$current8;
                    (_transition$current8 = transition.current) === null || _transition$current8 === void 0 || _transition$current8.complete();
                }
            }
        });
        var value = {
            action: 'collapse',
            complete: function complete() {
                value.abort();
                finish();
            },
            abort: function abort() {
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        flyoutLockCount,
        isFixed,
        lastLeftSidebarWidth,
        hasInit
    ]);
    /**
   * Conditionally toggle the expanding or collapsing the sidebars.
   * This supports our mobile flyout mode as well.
   */ var toggleLeftSidebar = (0, $7fPBF.useCallback)(function(event, collapseWithoutTransition) {
        if (isOpen) collapseLeftSidebar(event, collapseWithoutTransition);
        else expandLeftSidebar();
    }, [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar
    ]);
    // Make sure we finish any lingering transitions when unmounting
    (0, $7fPBF.useEffect)(function mount() {
        return function unmount() {
            var _transition$current9;
            (_transition$current9 = transition.current) === null || _transition$current9 === void 0 || _transition$current9.abort();
        };
    }, []);
    var context = (0, $7fPBF.useMemo)(function() {
        return {
            isLeftSidebarCollapsed: !isOpen,
            // Technically this isn't quite true, but with mobile it's a bit safer if apps are using this to roll their own collapse/expand
            expandLeftSidebar: expandLeftSidebar,
            collapseLeftSidebar: collapseLeftSidebar,
            leftSidebarState: leftSidebarState,
            setLeftSidebarState: setLeftSidebarState,
            toggleLeftSidebar: toggleLeftSidebar
        };
    }, [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar,
        leftSidebarState,
        toggleLeftSidebar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $ddf576c977c2e750$export$aa5a712eea4c2ae8).Provider, {
        value: context
    }, children);
};


var $j9spr = parcelRequire("j9spr");

var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");


var $962ecee2c8b81f69$var$byDOMOrder = function byDOMOrder(a, b) {
    var _a$listIndex, _b$listIndex;
    var elems = Array.from(document.querySelectorAll("[".concat((0, $e1bb1f20ef4efe28$export$5253dd9707b8c3ba), "]")));
    var elemA = document.getElementById(a.id);
    var elemB = document.getElementById(b.id);
    var indexA = (_a$listIndex = a.listIndex) !== null && _a$listIndex !== void 0 ? _a$listIndex : elems.indexOf(elemA);
    var indexB = (_b$listIndex = b.listIndex) !== null && _b$listIndex !== void 0 ? _b$listIndex : elems.indexOf(elemB);
    /**
   * If they are tied it is because one (or both) is
   * a custom skiplink with a set index.
   *
   * Give the custom skiplink priority.
   */ if (indexA === indexB) {
        if (a.listIndex !== undefined) return -1;
        else return 1;
    }
    return indexA - indexB;
};
var $962ecee2c8b81f69$export$da7be99d6a868f3d = function SkipLinksController(_ref) {
    var children = _ref.children;
    var _useState = (0, $7fPBF.useState)([]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), links = _useState2[0], setLinks = _useState2[1];
    var registerSkipLink = (0, $7fPBF.useRef)(function(skipLinkData) {
        // Don't add duplicate SkipLinks
        setLinks(function(oldLinks) {
            if (oldLinks.some(function(_ref2) {
                var id = _ref2.id;
                return id === skipLinkData.id;
            })) return oldLinks;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(oldLinks), [
                skipLinkData
            ]).sort($962ecee2c8b81f69$var$byDOMOrder);
        });
    });
    var unregisterSkipLink = (0, $7fPBF.useRef)(function(id) {
        setLinks(function(links) {
            return links.filter(function(link) {
                return link.id !== id;
            });
        });
    });
    var context = {
        registerSkipLink: registerSkipLink.current,
        skipLinksData: links,
        unregisterSkipLink: unregisterSkipLink.current
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1e2b1573caccd841$export$4c5cc3b14c7678a).Provider, {
        value: context
    }, children);
};



var $j9spr = parcelRequire("j9spr");

var $8MJe2 = parcelRequire("8MJe2");





function $a447a92c953a262c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a447a92c953a262c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a447a92c953a262c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a447a92c953a262c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $a447a92c953a262c$var$prefersReducedMotionStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)((0, $adc46454e3d9e2c8$export$ff7706047246b98b)());
var $a447a92c953a262c$var$skipLinkStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    margin: "var(--ds-space-250, 20px)",
    padding: '0.8rem 1rem',
    position: 'fixed',
    zIndex: -1,
    background: "var(--ds-surface-overlay, #FFFFFF)",
    border: 'none',
    borderRadius: "var(--ds-radius-small, 3px)",
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
    insetInlineStart: -999999,
    opacity: 0,
    transform: 'translateY(-50%)',
    transition: "transform 0.3s ".concat((0, $f3f9aa62ed707d7e$export$57636bb43b1ccbb0)),
    '&:focus-within': {
        zIndex: 2147483640,
        insetInlineStart: 0,
        opacity: 1,
        transform: 'translateY(0%)'
    }
});
var $a447a92c953a262c$var$skipLinkHeadingStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    fontWeight: "var(--ds-font-weight-semibold, 600)"
});
var $a447a92c953a262c$var$skipLinkListStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    listStylePosition: 'outside',
    listStyleType: 'none',
    marginBlockStart: "var(--ds-space-050, 4px)",
    paddingInlineStart: 0
});
var $a447a92c953a262c$var$skipLinkListItemStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    marginBlockStart: 0
});
var $a447a92c953a262c$var$_assignIndex = function assignIndex(num, arr) {
    if (!arr.includes(num)) return num;
    return $a447a92c953a262c$var$_assignIndex(num + 1, arr);
};
var $a447a92c953a262c$export$4241a460557ba901 = function SkipLinkWrapper(_ref) {
    var skipLinksLabel = _ref.skipLinksLabel;
    var _useSkipLinks = (0, $1e2b1573caccd841$export$c9d9cb2ee9590f87)(), skipLinksData = _useSkipLinks.skipLinksData;
    if (skipLinksData.length === 0) return null;
    var sortSkipLinks = function sortSkipLinks(arr) {
        var customLinks = arr.filter(function(link) {
            return Number.isInteger(link.listIndex);
        });
        if (customLinks.length === 0) return arr;
        var usedIndexes = customLinks.map(function(a) {
            return a.listIndex;
        });
        var regularLinksWithIdx = arr.filter(function(link) {
            return link.listIndex === undefined;
        }).map(function(link, idx) {
            var listIndex = $a447a92c953a262c$var$_assignIndex(idx, usedIndexes);
            usedIndexes.push(listIndex);
            return $a447a92c953a262c$var$_objectSpread($a447a92c953a262c$var$_objectSpread({}, link), {}, {
                listIndex: listIndex
            });
        });
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(customLinks), (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(regularLinksWithIdx)).sort(function(a, b) {
            return a.listIndex - b.listIndex;
        });
    };
    var escapeHandler = function escapeHandler(event) {
        if (event.keyCode === 27) {
            var container = document.querySelector("[".concat((0, $e1bb1f20ef4efe28$export$659ee746b31b360d), "=\"true\"]") // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            );
            if (container !== null) container.focus();
        }
    };
    var attachEscHandler = function attachEscHandler() {
        return window.addEventListener('keydown', escapeHandler, false);
    };
    var removeEscHandler = function removeEscHandler() {
        return window.removeEventListener('keydown', escapeHandler, false);
    };
    var emptyLabelOverride = !!(skipLinksLabel !== null && skipLinksLabel !== void 0 && skipLinksLabel.match(/^\s+$/));
    var label = skipLinksLabel || (0, $e1bb1f20ef4efe28$export$206a08f7f8beb554);
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("div", {
        onFocus: attachEscHandler,
        onBlur: removeEscHandler,
        css: [
            $a447a92c953a262c$var$skipLinkStyles,
            $a447a92c953a262c$var$prefersReducedMotionStyles
        ],
        "data-skip-link-wrapper": true
    }, emptyLabelOverride ? null : (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("p", {
        css: $a447a92c953a262c$var$skipLinkHeadingStyles
    }, label), (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("ol", {
        css: $a447a92c953a262c$var$skipLinkListStyles
    }, sortSkipLinks(skipLinksData).map(function(_ref2) {
        var id = _ref2.id, skipLinkTitle = _ref2.skipLinkTitle;
        return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)($a447a92c953a262c$export$ef95c37428582a65, {
            key: id,
            href: "#".concat(id),
            isFocusable: true
        }, skipLinkTitle);
    })));
};
var $a447a92c953a262c$var$_handleBlur = function handleBlur(event) {
    // @ts-ignore
    event.target.removeAttribute('tabindex');
    // @ts-ignore
    event.target.removeEventListener('blur', $a447a92c953a262c$var$_handleBlur);
};
var $a447a92c953a262c$var$focusTargetRef = function focusTargetRef(href) {
    return function(event) {
        event.preventDefault();
        var targetRef = document.querySelector(href);
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        // @ts-ignore
        var key = event.which || event.keycode;
        // if it is a keypress and the key is not
        // space or enter, just ignore it.
        if (key && key !== 13 && key !== 32) return;
        if (targetRef) {
            targetRef.setAttribute('tabindex', '-1');
            // @ts-ignore
            targetRef.addEventListener('blur', $a447a92c953a262c$var$_handleBlur);
            // @ts-ignore
            targetRef.focus();
            document.activeElement && document.activeElement.scrollIntoView({
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                behavior: 'smooth'
            });
            window.scrollTo(0, 0);
        }
        return false;
    };
};
var $a447a92c953a262c$export$ef95c37428582a65 = function SkipLink(_ref3) {
    var href = _ref3.href, children = _ref3.children, isFocusable = _ref3.isFocusable;
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("li", {
        css: $a447a92c953a262c$var$skipLinkListItemStyles
    }, (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $705b4fb71b2918ff$export$2e2bcd8739ae039), {
        tabIndex: isFocusable ? 0 : -1,
        href: href,
        onClick: $a447a92c953a262c$var$focusTargetRef(href)
    }, children));
};


var $d0a14d7762364fd2$var$pageLayoutSelector = (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, (0, $e1bb1f20ef4efe28$export$659ee746b31b360d), true);
var $d0a14d7762364fd2$var$gridTemplateAreasMobile = "\n".concat("\n  \"", (0, $e1bb1f20ef4efe28$export$344062f7cfc9528e), " ").concat((0, $e1bb1f20ef4efe28$export$238d30785c4bca84), "\"\n  ", "\n  \"").concat((0, $e1bb1f20ef4efe28$export$344062f7cfc9528e), " ").concat((0, $e1bb1f20ef4efe28$export$bec6dca2e63de4ae), "\"\n  ", "\n  \"").concat((0, $e1bb1f20ef4efe28$export$344062f7cfc9528e), " ").concat((0, $e1bb1f20ef4efe28$export$d1213e82613ff4df), "\"\n ");
var $d0a14d7762364fd2$var$gridTemplateAreas = "\n".concat("\n  \"", (0, $e1bb1f20ef4efe28$export$344062f7cfc9528e), " ").concat((0, $e1bb1f20ef4efe28$export$238d30785c4bca84), " ").concat((0, $e1bb1f20ef4efe28$export$c7139cc2d6110b5f), "\"\n  ", "\n  \"").concat((0, $e1bb1f20ef4efe28$export$344062f7cfc9528e), " ").concat((0, $e1bb1f20ef4efe28$export$bec6dca2e63de4ae), " ").concat((0, $e1bb1f20ef4efe28$export$c7139cc2d6110b5f), "\"\n", "\n  \"").concat((0, $e1bb1f20ef4efe28$export$344062f7cfc9528e), " ").concat((0, $e1bb1f20ef4efe28$export$d1213e82613ff4df), " ").concat((0, $e1bb1f20ef4efe28$export$c7139cc2d6110b5f), "\"\n ");
var $d0a14d7762364fd2$var$gridStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    display: 'grid',
    height: '100%',
    gridTemplateAreas: $d0a14d7762364fd2$var$gridTemplateAreas,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateColumns: "".concat((0, $e1bb1f20ef4efe28$export$f963aecf2d4465bd), " minmax(0, 1fr) ").concat((0, $e1bb1f20ef4efe28$export$750459958906793)),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateRows: "".concat((0, $e1bb1f20ef4efe28$export$ed7cc0d417ee89e), " ").concat((0, $e1bb1f20ef4efe28$export$aeff86a16f13529), " auto"),
    outline: 'none'
});
var $d0a14d7762364fd2$var$gridStylesMobileStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, (0, $7a3e63dc1837f7f4$export$c881183ca713c214).below.sm, {
    gridTemplateAreas: $d0a14d7762364fd2$var$gridTemplateAreasMobile,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateColumns: "".concat((0, $e1bb1f20ef4efe28$export$f963aecf2d4465bd), " minmax(0, 1fr)")
}));
/**
 * __Page layout__
 *
 * A collection of components which let you compose an application's page layout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ var $d0a14d7762364fd2$var$PageLayout = function PageLayout(_ref) {
    var _ref$skipLinksLabel = _ref.skipLinksLabel, skipLinksLabel = _ref$skipLinksLabel === void 0 ? (0, $e1bb1f20ef4efe28$export$206a08f7f8beb554) : _ref$skipLinksLabel, children = _ref.children, testId = _ref.testId, onLeftSidebarExpand = _ref.onLeftSidebarExpand, onLeftSidebarCollapse = _ref.onLeftSidebarCollapse;
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $7fPBF.Fragment), null, (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $962ecee2c8b81f69$export$da7be99d6a868f3d), null, (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $a447a92c953a262c$export$4241a460557ba901), {
        skipLinksLabel: skipLinksLabel
    }), (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, $d0a14d7762364fd2$var$pageLayoutSelector, {
        "data-testid": testId,
        css: [
            $d0a14d7762364fd2$var$gridStyles,
            $d0a14d7762364fd2$var$gridStylesMobileStyles
        ],
        tabIndex: -1,
        "data-vc": "page-layout"
    }), (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $c6d9fbc0fb73f1cd$export$850bd1bba41f1448), {
        onLeftSidebarCollapse: onLeftSidebarCollapse,
        onLeftSidebarExpand: onLeftSidebarExpand
    }, children))));
};
var $d0a14d7762364fd2$export$2e2bcd8739ae039 = $d0a14d7762364fd2$var$PageLayout;



var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");




var $8MJe2 = parcelRequire("8MJe2");

var $iKdEz = parcelRequire("iKdEz");

var $cafe70309e49c2e7$var$publishGridState = function publishGridState(gridState) {
    Object.entries(gridState).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref, 2), slotName = _ref2[0], value = _ref2[1];
        if (!value) {
            document.documentElement.style.removeProperty("--".concat(slotName));
            (0, $bc7ef42a2451ffb0$export$17e3760e0b35f1cd)('gridState', slotName);
            return;
        }
        //Update the css variable
        document.documentElement.style.setProperty("--".concat(slotName), "".concat(value, "px"));
        // also update state in local storage so that
        // it persists across page refresh, across tabs etc
        (0, $bc7ef42a2451ffb0$export$f8355a2df0f4a946)('gridState', (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, slotName, value));
    });
};
var $cafe70309e49c2e7$export$2e2bcd8739ae039 = $cafe70309e49c2e7$var$publishGridState;




var $7fPBF = parcelRequire("7fPBF");

/**
 * Hoists slot dimension styles to the root element.
 */ var $cfe85745364713cd$var$SlotDimensions = function SlotDimensions(_ref) {
    var variableName = _ref.variableName, value = _ref.value, mobileValue = _ref.mobileValue;
    /**
   * Note don't put multiple variables in multiple lines. eg
   * <style>
   *   {css1}
   *   {css2}
   * </style>
   *
   * React will insert an empty HTML comment in between the text in SSR.
   * This is not a valid tag and will break the page.
   * <style>foo<!-- -->bar</style>
   */ var style = ":root{--".concat(variableName, ":").concat(value, "px;}");
    if (mobileValue) style += " ".concat((0, $7a3e63dc1837f7f4$export$c881183ca713c214).below.sm, " { :root{--").concat(variableName, ":").concat(mobileValue, "px;} }");
    return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("style", null, style));
};
var $cfe85745364713cd$export$2e2bcd8739ae039 = $cfe85745364713cd$var$SlotDimensions;


var $558934874537b23b$var$topNavigationStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $e1bb1f20ef4efe28$export$aeff86a16f13529),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $e1bb1f20ef4efe28$export$bec6dca2e63de4ae)
});
var $558934874537b23b$var$fixedStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    position: 'fixed',
    zIndex: 2,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: (0, $e1bb1f20ef4efe28$export$ed7cc0d417ee89e),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $e1bb1f20ef4efe28$export$750459958906793),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $e1bb1f20ef4efe28$export$f963aecf2d4465bd)
});
/**
 * __Top navigation__
 *
 * Provides a slot for top navigation within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ var $558934874537b23b$var$TopNavigation = function TopNavigation(props) {
    var children = props.children, _props$height = props.height, height = _props$height === void 0 ? (0, $e1bb1f20ef4efe28$export$4a98ee0bd1ae362) : _props$height, _props$isFixed = props.isFixed, isFixed = _props$isFixed === void 0 ? true : _props$isFixed, shouldPersistHeight = props.shouldPersistHeight, testId = props.testId, id = props.id, skipLinkTitle = props.skipLinkTitle;
    var topNavigationHeight = (0, $bc7ef42a2451ffb0$export$74732e47915c7839)((0, $e1bb1f20ef4efe28$export$3a6a779d9181047c), height, shouldPersistHeight);
    (0, $7fPBF.useEffect)(function() {
        (0, $cafe70309e49c2e7$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, (0, $e1bb1f20ef4efe28$export$3a6a779d9181047c), topNavigationHeight));
        return function() {
            (0, $cafe70309e49c2e7$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, (0, $e1bb1f20ef4efe28$export$3a6a779d9181047c), 0));
        };
    }, [
        topNavigationHeight
    ]);
    (0, $1e2b1573caccd841$export$89d9323301efc7d6)(id, skipLinkTitle);
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $c3c66c1bd34e39a4$export$2e2bcd8739ae039), null, function(_ref) {
        var className = _ref.className;
        return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
            css: [
                $558934874537b23b$var$topNavigationStyles,
                isFixed && $558934874537b23b$var$fixedStyles
            ],
            className: className,
            "data-testid": testId,
            id: id
        }, (0, $bc7ef42a2451ffb0$export$e895e3e8b708ae2a)('top-navigation')), (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $cfe85745364713cd$export$2e2bcd8739ae039), {
            variableName: (0, $e1bb1f20ef4efe28$export$3a6a779d9181047c),
            value: topNavigationHeight
        }), children);
    });
};
var $558934874537b23b$export$2e2bcd8739ae039 = $558934874537b23b$var$TopNavigation;


/* LanguageBar.tsx generated by @compiled/babel-plugin v2.0.0 */ 


var $7fPBF = parcelRequire("7fPBF");


var $iKdEz = parcelRequire("iKdEz");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");




var $317b0dc61223a332$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $317b0dc61223a332$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var $317b0dc61223a332$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $f48d740006cf3f7d$export$2e2bcd8739ae039) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $f48d740006cf3f7d$export$2e2bcd8739ae039) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $317b0dc61223a332$var$_excluded);
    var isOnlySingleIcon = (0, $d988f83806b6fe3b$export$2e2bcd8739ae039)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $7fPBF.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    // in Firefox
    var onMouseDown = (0, $7fPBF.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($317b0dc61223a332$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $7fPBF.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($317b0dc61223a332$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $7fPBF.useMemo)(function() {
        return (0, $59b2a1271eae7c3c$export$955358618f994a11)({
            appearance: appearance,
            spacing: spacing,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $3a147e18a4e384a4$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$317b0dc61223a332$var$Button.displayName = 'Button';
var $317b0dc61223a332$export$2e2bcd8739ae039 = $317b0dc61223a332$var$Button;




var $8MJe2 = parcelRequire("8MJe2");

var $emuQy = parcelRequire("emuQy");

var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");



var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");
/* button-base.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $96ab0481e791dbcb$var$ATOMIC_GROUP_LENGTH = 5;
function $96ab0481e791dbcb$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $96ab0481e791dbcb$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $7fPBF = parcelRequire("7fPBF");


var $bRUy3 = parcelRequire("bRUy3");
function $e5f53ec0aebc72ba$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null && (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref) === 'object') ref.current = value;
        });
    };
}



var $7fPBF = parcelRequire("7fPBF");
function $0e1dfe2b81fbd38a$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $7fPBF.useRef)(true);
    (0, $7fPBF.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}



var $bRUy3 = parcelRequire("bRUy3");

var $7fPBF = parcelRequire("7fPBF");
function $d625109a55dc7442$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useId().replace(/[:«»]/g, '_');
}
var $d625109a55dc7442$export$6be90bcb437e928f = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($d625109a55dc7442$export$f680877a34711e37()).concat(postfix);
    (0, $7fPBF.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $d625109a55dc7442$export$6ee17796e3d70de2() {
    var uid = $d625109a55dc7442$export$f680877a34711e37();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}



var $137Lh = parcelRequire("137Lh");
/* pressable.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");


const $625a2a0002b5c0da$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $ca1b8a586a841420$export$2e2bcd8739ae039)(actualStyles);
};



function $915173cc6d534745$var$testPlatform(re) {
    var _userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_userAgentData = window.navigator['userAgentData']) === null || _userAgentData === void 0 ? void 0 : _userAgentData.platform) || window.navigator.platform) : false;
}
function $915173cc6d534745$var$isIPhone() {
    return $915173cc6d534745$var$testPlatform(/^iPhone/i);
}
function $915173cc6d534745$var$isMac() {
    return $915173cc6d534745$var$testPlatform(/^Mac/i);
}
function $915173cc6d534745$var$isIPad() {
    return $915173cc6d534745$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $915173cc6d534745$var$isMac() && navigator.maxTouchPoints > 1;
}
function $915173cc6d534745$var$isIOS() {
    return $915173cc6d534745$var$isIPhone() || $915173cc6d534745$var$isIPad();
}
function $915173cc6d534745$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use;
        var ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}
function $915173cc6d534745$export$e1865c3bedcd822b() {
    return $915173cc6d534745$var$isMac() || $915173cc6d534745$var$isIOS();
}




/* focusable.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $141630e001aa18df$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $141630e001aa18df$var$_excluded2 = [
    "className"
];
var $141630e001aa18df$var$focusRingStyles = null;
var $141630e001aa18df$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $141630e001aa18df$var$Focusable = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $141630e001aa18df$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $141630e001aa18df$var$_excluded2);
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $ca1b8a586a841420$export$2e2bcd8739ae039)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $141630e001aa18df$export$2e2bcd8739ae039 = $141630e001aa18df$var$Focusable;


var $34bbe408102690e7$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $34bbe408102690e7$var$_excluded2 = [
    "className"
];
var $34bbe408102690e7$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $34bbe408102690e7$var$Pressable = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $27bc0e79b61c3ca3$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $34bbe408102690e7$var$_excluded);
    var interactionContext = (0, $7fPBF.useContext)((0, $48ec410b84640600$export$2e2bcd8739ae039));
    var handleClick = (0, $7fPBF.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $593ac790924c31ca$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "18.1.1",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $34bbe408102690e7$var$_excluded2);
    return /*#__PURE__*/ $7fPBF.createElement((0, $141630e001aa18df$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $915173cc6d534745$export$95df08bae54cb4df)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $625a2a0002b5c0da$export$a274e22fb40f762e)($34bbe408102690e7$var$styles.root, isDisabled && $34bbe408102690e7$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $34bbe408102690e7$export$2e2bcd8739ae039 = $34bbe408102690e7$var$Pressable;




var $7fPBF = parcelRequire("7fPBF");
var $bb1660c50c395e45$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);
var $bb1660c50c395e45$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $7fPBF.useContext)($bb1660c50c395e45$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};


function $4c33cdcfa9625bc8$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $4c33cdcfa9625bc8$var$tabKeyCode = 9;
function $4c33cdcfa9625bc8$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $4c33cdcfa9625bc8$var$tabKeyCode) return;
    $4c33cdcfa9625bc8$var$abort(event);
}
function $4c33cdcfa9625bc8$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $4c33cdcfa9625bc8$var$abort,
        onMouseUpCapture: $4c33cdcfa9625bc8$var$abort,
        onKeyDownCapture: $4c33cdcfa9625bc8$var$onKey,
        onKeyUpCapture: $4c33cdcfa9625bc8$var$onKey,
        onTouchStartCapture: $4c33cdcfa9625bc8$var$abort,
        onTouchEndCapture: $4c33cdcfa9625bc8$var$abort,
        onPointerDownCapture: $4c33cdcfa9625bc8$var$abort,
        onPointerUpCapture: $4c33cdcfa9625bc8$var$abort,
        onClickCapture: $4c33cdcfa9625bc8$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $4c33cdcfa9625bc8$var$abort
    } : events;
}



var $7fPBF = parcelRequire("7fPBF");
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $4eca304bc1ee46bd$var$ATOMIC_GROUP_LENGTH = 5;
function $4eca304bc1ee46bd$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $4eca304bc1ee46bd$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $7c50b204d34e7a2d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);


// Reds
var $5e9f1323e96bb134$export$4b84fd0e2c617bd = '#FFEBE6';
var $5e9f1323e96bb134$export$b34b069eff244586 = '#FFBDAD';
var $5e9f1323e96bb134$export$be802dd0d8b57f35 = '#FF8F73';
var $5e9f1323e96bb134$export$60847d42f9da92a6 = '#FF7452';
var $5e9f1323e96bb134$export$4a7404f376229999 = '#FF5630';
var $5e9f1323e96bb134$export$2010d0fb4295b346 = '#DE350B';
var $5e9f1323e96bb134$export$2837b5a1a71d5c02 = '#BF2600';
var $5e9f1323e96bb134$export$8d9596b529bbb9cf = '#FFFAE6';
var $5e9f1323e96bb134$export$41060a744ab0b7ae = '#FFF0B3';
var $5e9f1323e96bb134$export$1cc05bbbf340e559 = '#FFE380';
var $5e9f1323e96bb134$export$5aae31392d72caaa = '#FFC400';
var $5e9f1323e96bb134$export$c6930421db9fa514 = '#FFAB00';
var $5e9f1323e96bb134$export$59619663aa6500fb = '#FF991F';
var $5e9f1323e96bb134$export$874739ea9e379ab6 = '#FF8B00';
var $5e9f1323e96bb134$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $5e9f1323e96bb134$export$69a3bf21b9686c2b = '#ABF5D1';
var $5e9f1323e96bb134$export$afbce1382ec95f73 = '#79F2C0';
var $5e9f1323e96bb134$export$747d86715d4175de = '#57D9A3';
var $5e9f1323e96bb134$export$940e1f69e873f202 = '#36B37E';
var $5e9f1323e96bb134$export$a49394138f7b8e85 = '#00875A';
var $5e9f1323e96bb134$export$6fa04827ac68a4fb = '#006644';
var $5e9f1323e96bb134$export$226de0355ed012f8 = '#DEEBFF';
var $5e9f1323e96bb134$export$8c13c2ee36917869 = '#B3D4FF';
var $5e9f1323e96bb134$export$ecfc1dff386a3e7a = '#4C9AFF';
var $5e9f1323e96bb134$export$215b7063051591f1 = '#2684FF';
var $5e9f1323e96bb134$export$e62e8919cca44969 = '#0065FF';
var $5e9f1323e96bb134$export$b3de0ae08da2ce64 = '#0052CC';
var $5e9f1323e96bb134$export$a6ee3d71bc067634 = '#0747A6';
var $5e9f1323e96bb134$export$67f15409e87642a1 = '#669DF1';
var $5e9f1323e96bb134$export$f0539dbc42dbb067 = '#8FB8F6';
var $5e9f1323e96bb134$export$363e4475840015bb = '#EAE6FF';
var $5e9f1323e96bb134$export$4b0a4417ed59760f = '#C0B6F2';
var $5e9f1323e96bb134$export$6011520a64d9a187 = '#998DD9';
var $5e9f1323e96bb134$export$a7175d4e9206bc80 = '#8777D9';
var $5e9f1323e96bb134$export$b48405b95304b5a1 = '#6554C0';
var $5e9f1323e96bb134$export$c71e4279dd54a18d = '#5243AA';
var $5e9f1323e96bb134$export$147899de772240ec = '#403294';
var $5e9f1323e96bb134$export$2cf711fe14c66f06 = '#E6FCFF';
var $5e9f1323e96bb134$export$7a8f4d33f6f9772c = '#B3F5FF';
var $5e9f1323e96bb134$export$776c9c497ef08533 = '#79E2F2';
var $5e9f1323e96bb134$export$69cb3ca10c1e330e = '#00C7E6';
var $5e9f1323e96bb134$export$9dc1ef0f3f48059b = '#00B8D9';
var $5e9f1323e96bb134$export$7c835c78b6fcdef8 = '#00A3BF';
var $5e9f1323e96bb134$export$6036577f95c3877e = '#008DA6';
var $5e9f1323e96bb134$export$29a4f05edc054374 = '#FFFFFF';
var $5e9f1323e96bb134$export$e655ef011c4aa1a2 = '#FAFBFC';
var $5e9f1323e96bb134$export$9fdfb749e33cdf97 = '#F4F5F7';
var $5e9f1323e96bb134$export$3e51e8f1440314ba = '#EBECF0';
var $5e9f1323e96bb134$export$1ce2d1575d444ceb = '#DFE1E6';
var $5e9f1323e96bb134$export$8754fc7e6d8b3000 = '#C1C7D0';
var $5e9f1323e96bb134$export$c2e91cbeada39b8b = '#B3BAC5';
var $5e9f1323e96bb134$export$5f71e19f3a7ad9de = '#A5ADBA';
var $5e9f1323e96bb134$export$eaa8c8a70ac22806 = '#97A0AF';
var $5e9f1323e96bb134$export$7c87d337fb91a97d = '#8993A4';
var $5e9f1323e96bb134$export$d6447c357493214f = '#7A869A';
var $5e9f1323e96bb134$export$f563ee71e9ee74cd = '#6B778C';
var $5e9f1323e96bb134$export$e2ef2124cf4024b1 = '#5E6C84';
var $5e9f1323e96bb134$export$eece5f492e429f08 = '#505F79';
var $5e9f1323e96bb134$export$c39c0fe0f26207ae = '#42526E';
var $5e9f1323e96bb134$export$7090862dc3038a9f = '#344563';
var $5e9f1323e96bb134$export$ad0bacf983b7ddaa = '#253858';
var $5e9f1323e96bb134$export$7d61b15e0da132af = '#172B4D';
var $5e9f1323e96bb134$export$fbda843f0a27fe96 = '#091E42';
var $5e9f1323e96bb134$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $5e9f1323e96bb134$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $5e9f1323e96bb134$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $5e9f1323e96bb134$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $5e9f1323e96bb134$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $5e9f1323e96bb134$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $5e9f1323e96bb134$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $5e9f1323e96bb134$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $5e9f1323e96bb134$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $5e9f1323e96bb134$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $5e9f1323e96bb134$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $5e9f1323e96bb134$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $5e9f1323e96bb134$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $5e9f1323e96bb134$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $5e9f1323e96bb134$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $5e9f1323e96bb134$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $5e9f1323e96bb134$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $5e9f1323e96bb134$export$2f6319cf7d736c2a = '#E6EDFA';
var $5e9f1323e96bb134$export$95126bc8884d6634 = '#DCE5F5';
var $5e9f1323e96bb134$export$8338d8c35d44ff1 = '#CED9EB';
var $5e9f1323e96bb134$export$5368d76ae4fbbda7 = '#B8C7E0';
var $5e9f1323e96bb134$export$9f0a771d16ec8d36 = '#ABBBD6';
var $5e9f1323e96bb134$export$abcf8c38338b4aa5 = '#9FB0CC';
var $5e9f1323e96bb134$export$97e81faa16a182c7 = '#8C9CB8';
var $5e9f1323e96bb134$export$bfe21c59123ecf33 = '#7988A3';
var $5e9f1323e96bb134$export$ee82aa2ea6a1558 = '#67758F';
var $5e9f1323e96bb134$export$682927c6ed76be02 = '#56637A';
var $5e9f1323e96bb134$export$91fd9994c5be9757 = '#455166';
var $5e9f1323e96bb134$export$d281fbfe3cff2df6 = '#3B475C';
var $5e9f1323e96bb134$export$3902c91d8b98a753 = '#313D52';
var $5e9f1323e96bb134$export$8e8133c1ba5845b5 = '#283447';
var $5e9f1323e96bb134$export$33ff357f6620b39 = '#202B3D';
var $5e9f1323e96bb134$export$633847cf062b69e0 = '#1B2638';
var $5e9f1323e96bb134$export$9776a6e503bdbf76 = '#121A29';
var $5e9f1323e96bb134$export$6c813d5160dff5db = '#0E1624';
var $5e9f1323e96bb134$export$3d4f271a500072a = '#0D1424';
var $5e9f1323e96bb134$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $5e9f1323e96bb134$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $5e9f1323e96bb134$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $5e9f1323e96bb134$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $5e9f1323e96bb134$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $5e9f1323e96bb134$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $5e9f1323e96bb134$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $5e9f1323e96bb134$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $5e9f1323e96bb134$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $5e9f1323e96bb134$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $5e9f1323e96bb134$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $5e9f1323e96bb134$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $5e9f1323e96bb134$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $5e9f1323e96bb134$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $5e9f1323e96bb134$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $5e9f1323e96bb134$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $5e9f1323e96bb134$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $5e9f1323e96bb134$export$d2adc5dedf09fced = '#292A2E';
var $5e9f1323e96bb134$export$f51762073d2bb381 = '#94C748';
var $5e9f1323e96bb134$export$95e26d54def96891 = '#B3DF72';


var $ff18a94076195f50$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $d921bf90aee0495e$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $5e9f1323e96bb134$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-inverse, ".concat((0, $5e9f1323e96bb134$export$29a4f05edc054374), ")");
}
var $d921bf90aee0495e$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $d921bf90aee0495e$var$loadIn = null;
var $d921bf90aee0495e$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $d921bf90aee0495e$var$useLayoutEffect = typeof window === 'undefined' ? (0, $7fPBF.useEffect) : (0, $7fPBF.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $d921bf90aee0495e$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $ff18a94076195f50$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $d921bf90aee0495e$var$getStrokeColor(appearance);
    var context = (0, $7fPBF.useContext)((0, $7c50b204d34e7a2d$export$2e2bcd8739ae039));
    $d921bf90aee0495e$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $4eca304bc1ee46bd$export$2e2bcd8739ae039)([
            $d921bf90aee0495e$var$styles.wrapperStyles,
            $d921bf90aee0495e$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $4eca304bc1ee46bd$export$2e2bcd8739ae039)([
            $d921bf90aee0495e$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $4eca304bc1ee46bd$export$2e2bcd8739ae039)([
            $d921bf90aee0495e$var$styles.circleStyles
        ])
    })));
}));
var $d921bf90aee0495e$export$2e2bcd8739ae039 = $d921bf90aee0495e$var$Spinner;


function $4cd27c6439d5bcfd$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $4cd27c6439d5bcfd$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $4cd27c6439d5bcfd$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d921bf90aee0495e$export$2e2bcd8739ae039), {
        size: $4cd27c6439d5bcfd$var$getIconSpacing(spacing),
        appearance: $4cd27c6439d5bcfd$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}


var $08ba09eb12b4bbf5$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $08ba09eb12b4bbf5$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $08ba09eb12b4bbf5$var$LOADING_LABEL = ', Loading';
var $08ba09eb12b4bbf5$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhkby5v _irr3by5v _1di6by5v",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    spacingCompactT26Shape: "_2rko12b0",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $08ba09eb12b4bbf5$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $08ba09eb12b4bbf5$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
var $08ba09eb12b4bbf5$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _9h8h1yd3",
    interactive: "_30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
var $08ba09eb12b4bbf5$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
var $08ba09eb12b4bbf5$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
var $08ba09eb12b4bbf5$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $08ba09eb12b4bbf5$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $08ba09eb12b4bbf5$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
function(_ref, ref) {
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $08ba09eb12b4bbf5$var$_excluded);
    var localRef = (0, $7fPBF.useRef)(null);
    var splitButtonContext = (0, $bb1660c50c395e45$export$47e2c6fdb142d947)();
    var loadingLabelId = (0, $d625109a55dc7442$export$f680877a34711e37)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $0e1dfe2b81fbd38a$export$2e2bcd8739ae039)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(unsafeRest, $08ba09eb12b4bbf5$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $34bbe408102690e7$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, saferRest, {
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $e5f53ec0aebc72ba$export$2e2bcd8739ae039)([
            localRef,
            ref
        ]),
        xcss: (0, $e636b2257db42c06$export$a274e22fb40f762e)($08ba09eb12b4bbf5$var$styles.base, (0, $137Lh.fg)('platform-dst-shape-theme-default') && $08ba09eb12b4bbf5$var$styles.baseT26Shape, appearance === 'default' && $08ba09eb12b4bbf5$var$defaultStyles.root, appearance === 'default' && isInteractive && $08ba09eb12b4bbf5$var$defaultStyles.interactive, appearance === 'primary' && $08ba09eb12b4bbf5$var$primaryStyles.root, appearance === 'primary' && isInteractive && $08ba09eb12b4bbf5$var$primaryStyles.interactive, appearance === 'warning' && $08ba09eb12b4bbf5$var$warningStyles.root, appearance === 'warning' && isInteractive && $08ba09eb12b4bbf5$var$warningStyles.interactive, appearance === 'danger' && $08ba09eb12b4bbf5$var$dangerStyles.root, appearance === 'danger' && isInteractive && $08ba09eb12b4bbf5$var$dangerStyles.interactive, appearance === 'discovery' && $08ba09eb12b4bbf5$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $08ba09eb12b4bbf5$var$discoveryStyles.interactive, appearance === 'subtle' && $08ba09eb12b4bbf5$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $08ba09eb12b4bbf5$var$subtleStyles.interactive, $08ba09eb12b4bbf5$var$styles.linkDecorationUnset, isSelected && $08ba09eb12b4bbf5$var$selectedStyles.root, isSelected && isSplitButton && $08ba09eb12b4bbf5$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $08ba09eb12b4bbf5$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $08ba09eb12b4bbf5$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $08ba09eb12b4bbf5$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $08ba09eb12b4bbf5$var$selectedStyles.discovery, isDisabled && $08ba09eb12b4bbf5$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $08ba09eb12b4bbf5$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $08ba09eb12b4bbf5$var$defaultStyles.disabled, isCircle && !isSplitButton && $08ba09eb12b4bbf5$var$styles.circle, spacing === 'compact' && $08ba09eb12b4bbf5$var$styles.spacingCompact, spacing === 'compact' && (0, $137Lh.fg)('platform-dst-shape-theme-default') && $08ba09eb12b4bbf5$var$styles.spacingCompactT26Shape, shouldFitContainer && $08ba09eb12b4bbf5$var$styles.fullWidth, hasIconBefore && $08ba09eb12b4bbf5$var$styles.buttonIconBefore, hasIconAfter && $08ba09eb12b4bbf5$var$styles.buttonIconAfter, isIconButton && $08ba09eb12b4bbf5$var$styles.iconButton, isIconButton && spacing === 'compact' && $08ba09eb12b4bbf5$var$styles.iconButtonCompact, isLoading && $08ba09eb12b4bbf5$var$styles.loading, isSplitButton && $08ba09eb12b4bbf5$var$styles.splitButton, isNavigationSplitButton && $08ba09eb12b4bbf5$var$styles.navigationSplitButton),
        isDisabled: (0, $137Lh.fg)('platform-dst_fix_not_focusable_loading_button') ? isDisabled : isEffectivelyDisabled
    }, (0, $137Lh.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-live': 'polite'
    }, isLoading && (0, $137Lh.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-disabled': true
    }, {
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($08ba09eb12b4bbf5$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $4c33cdcfa9625bc8$export$2e2bcd8739ae039)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $bb1660c50c395e45$export$4b86304b2c0d7e71).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
        className: (0, $96ab0481e791dbcb$export$2e2bcd8739ae039)([
            $08ba09eb12b4bbf5$var$styles.loadingOverlay
        ])
    }, (0, $4cd27c6439d5bcfd$export$2e2bcd8739ae039)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d1b9d01570e45f55$export$2e2bcd8739ae039), {
        id: loadingLabelId
    }, $08ba09eb12b4bbf5$var$LOADING_LABEL)));
});
var $08ba09eb12b4bbf5$export$2e2bcd8739ae039 = $08ba09eb12b4bbf5$var$ButtonBase;


/* content.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $7fPBF = parcelRequire("7fPBF");
var $c3cc4ab58ac73f30$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $c3cc4ab58ac73f30$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
        className: (0, $96ab0481e791dbcb$export$2e2bcd8739ae039)([
            $c3cc4ab58ac73f30$var$styles.common,
            type === 'text' && $c3cc4ab58ac73f30$var$styles.text,
            type === 'icon' && $c3cc4ab58ac73f30$var$styles.icon,
            isLoading && $c3cc4ab58ac73f30$var$styles.fade
        ])
    }, children);
};
var $c3cc4ab58ac73f30$export$2e2bcd8739ae039 = $c3cc4ab58ac73f30$var$Content;



var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");
function $44fe0a48fffd21b6$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $44fe0a48fffd21b6$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    var isRenderProp = $44fe0a48fffd21b6$var$isIconRenderProp(Icon);
    var iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $137Lh.fg)('platform_dst_button_chevron_sizing') ? function(iconName) {
            return iconName.startsWith('Chevron') ? 'small' : 'medium';
        } : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Icon, iconProps));
};
var $44fe0a48fffd21b6$export$2e2bcd8739ae039 = $44fe0a48fffd21b6$var$IconRenderer;


var $74ba3b6cf6a48d65$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type"
], $74ba3b6cf6a48d65$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $74ba3b6cf6a48d65$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $74ba3b6cf6a48d65$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(unsafeRest, $74ba3b6cf6a48d65$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $08ba09eb12b4bbf5$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName
    }, saferRest), iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $c3cc4ab58ac73f30$export$2e2bcd8739ae039), {
        type: "icon",
        position: "before",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $44fe0a48fffd21b6$export$2e2bcd8739ae039), {
        icon: iconBefore
    })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $c3cc4ab58ac73f30$export$2e2bcd8739ae039), {
        isLoading: isLoading
    }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $c3cc4ab58ac73f30$export$2e2bcd8739ae039), {
        type: "icon",
        position: "after",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $44fe0a48fffd21b6$export$2e2bcd8739ae039), {
        icon: iconAfter
    })));
}));
$74ba3b6cf6a48d65$var$Button.displayName = 'Button';
var $74ba3b6cf6a48d65$export$2e2bcd8739ae039 = $74ba3b6cf6a48d65$var$Button;


/**
 * Character key codes which can be used in keyboard events.
 */ var $fe366ce437c8f2df$export$390330c10ff2b9a1 = 'ArrowUp';
var $fe366ce437c8f2df$export$a80636c6f41931fe = 'ArrowDown';
var $fe366ce437c8f2df$export$fc4577f2a2af0ae3 = 'ArrowLeft';
var $fe366ce437c8f2df$export$c40f9845adc73fb5 = 'ArrowRight';
var $fe366ce437c8f2df$export$4af703091671bc = 'Home';
var $fe366ce437c8f2df$export$e2bc30913faa5db7 = 'End';
var $fe366ce437c8f2df$export$10f6869ed0a7d75b = 'Tab';
var $fe366ce437c8f2df$export$8152f929a25a0ff4 = 'Enter';
var $fe366ce437c8f2df$export$e51a3576c045c8d5 = 'Space';
var $fe366ce437c8f2df$export$2bb790b9008907b4 = 'Escape';



/**
 * An empty function which does nothing.
 */ function $dca6c1d9b26ab4f1$export$2e2bcd8739ae039() {}



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");
function $37f0004c3fd3493f$export$2e2bcd8739ae039(propValue) {
    var getDefaultPropValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
        return propValue;
    };
    var isControlled = propValue !== undefined;
    var _useState = (0, $7fPBF.useState)(getDefaultPropValue), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), valueState = _useState2[0], setValue = _useState2[1];
    var isControlledRef = (0, $7fPBF.useRef)(isControlled);
    (0, $7fPBF.useEffect)(function() {
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    var value = isControlled ? propValue : valueState;
    var setValueIfUncontrolled = (0, $7fPBF.useCallback)(function(newValue) {
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");
function $5c864840253ea4c6$export$2e2bcd8739ae039() {
    var _useState = (0, $7fPBF.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), isFocused = _useState2[0], setIsFocused = _useState2[1];
    // ensure bindFocus has a stable ref
    var bindFocus = (0, $7fPBF.useRef)({
        onFocus: function onFocus() {
            return setIsFocused(true);
        },
        onBlur: function onBlur() {
            return setIsFocused(false);
        }
    });
    (0, $7fPBF.useEffect)(function() {
        // handle the case where a component might
        // unmount while being focused.
        return function() {
            return setIsFocused(false);
        };
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}


var $f8a69f4ab751b6b7$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($f8a69f4ab751b6b7$exports, "__esModule", {
    value: true
});
$f8a69f4ab751b6b7$exports.default = void 0;

var $f8a69f4ab751b6b7$var$_react = $f8a69f4ab751b6b7$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $f8a69f4ab751b6b7$var$_baseNew = $f8a69f4ab751b6b7$var$_interopRequireDefault((parcelRequire("gxWof")));
function $f8a69f4ab751b6b7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f8a69f4ab751b6b7$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $f8a69f4ab751b6b7$var$_react.default.createElement($f8a69f4ab751b6b7$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$f8a69f4ab751b6b7$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $f8a69f4ab751b6b7$var$_default = $f8a69f4ab751b6b7$exports.default = $f8a69f4ab751b6b7$var$ChevronDownIcon;



var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");

var $j9spr = parcelRequire("j9spr");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");
var $d3095ee70cc12973$export$da4f61fd78d35243 = /*#__PURE__*/ function() {
    function LayerNode(id, parent) {
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, LayerNode);
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(LayerNode, [
        {
            key: "addChild",
            value: function addChild(node) {
                this.childNodes.push(node);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(node) {
                this.childNodes = this.childNodes.filter(function(child) {
                    return child.id !== node.id;
                });
            }
        },
        {
            key: "getLevel",
            value: function getLevel() {
                if (!this.parent) return 1;
                return this.parent.getLevel() + 1;
            }
        },
        {
            key: "getHeight",
            value: function getHeight() {
                if (this.childNodes.length === 0) return 1;
                return Math.max.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(this.childNodes.map(function(child) {
                    return child.getHeight();
                }))) + 1;
            }
        }
    ]);
}();


var $e4ab5d8c3e4e797e$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $7fPBF.createContext)(0);
var $e4ab5d8c3e4e797e$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $7fPBF.createContext)({
    current: null
});
var $e4ab5d8c3e4e797e$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $7fPBF.createContext)({
    current: null
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $e4ab5d8c3e4e797e$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel, levelNode = _ref.node;
    (0, $7fPBF.useEffect)(function() {
        var levelNodeSafe = levelNode.current;
        var parentNode = levelNodeSafe.parent;
        parentNode === null || parentNode === void 0 || parentNode.addChild(levelNodeSafe);
        return function() {
            parentNode === null || parentNode === void 0 || parentNode.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e4ab5d8c3e4e797e$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e4ab5d8c3e4e797e$export$18f4d8b5b3a77f59.Provider, {
        value: levelNode
    }, children));
};
var $e4ab5d8c3e4e797e$export$7c885f891c940977 = function Layering(_ref2) {
    var children = _ref2.children, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? true : _ref2$isDisabled;
    var currentLevel = (0, $7fPBF.useContext)($e4ab5d8c3e4e797e$export$650d12d3c2ddb8fc);
    var parentNode = (0, $7fPBF.useContext)($e4ab5d8c3e4e797e$export$18f4d8b5b3a77f59);
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var newNode = (0, $7fPBF.useRef)(new (0, $d3095ee70cc12973$export$da4f61fd78d35243)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e4ab5d8c3e4e797e$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e4ab5d8c3e4e797e$export$fa973f110e8f6ca8.Provider, {
        value: newNode
    }, content);
};


var $1ada5457914d408b$var$ESCAPE = 'Escape';
function $1ada5457914d408b$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $7fPBF.useRef)(false);
    var _useLayering = $1ada5457914d408b$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $7fPBF.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $1ada5457914d408b$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $7fPBF.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $7fPBF.useEffect)(function() {
        return (0, $a091c25729a976b1$exports.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $1ada5457914d408b$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $7fPBF.useContext)((0, $e4ab5d8c3e4e797e$export$650d12d3c2ddb8fc));
    var layerNode = (0, $7fPBF.useContext)((0, $e4ab5d8c3e4e797e$export$18f4d8b5b3a77f59));
    var rootNode = (0, $7fPBF.useContext)((0, $e4ab5d8c3e4e797e$export$fa973f110e8f6ca8));
    var isLayerDisabled = (0, $7fPBF.useCallback)(function() {
        // This is an impossible case, added for type safety
        if (!(layerNode !== null && layerNode !== void 0 && layerNode.current) || !(rootNode !== null && rootNode !== void 0 && rootNode.current)) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        layerNode,
        rootNode
    ]);
    var getTopLevel = (0, $7fPBF.useCallback)(function() {
        return rootNode !== null && rootNode !== void 0 && rootNode.current ? rootNode.current.getHeight() : null;
    }, [
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}



/* eslint-disable no-console */ var $49a3016d3debbfca$var$printed = {};
function $49a3016d3debbfca$export$2e2bcd8739ae039(message) {
    if ($49a3016d3debbfca$var$printed[message]) return;
    $49a3016d3debbfca$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}


function $83ed31c1769bdd35$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $49a3016d3debbfca$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $83ed31c1769bdd35$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {}


// Reds
var $094b2769b1e0f195$export$4b84fd0e2c617bd = '#FFEBE6';
var $094b2769b1e0f195$export$b34b069eff244586 = '#FFBDAD';
var $094b2769b1e0f195$export$be802dd0d8b57f35 = '#FF8F73';
var $094b2769b1e0f195$export$60847d42f9da92a6 = '#FF7452';
var $094b2769b1e0f195$export$4a7404f376229999 = '#FF5630';
var $094b2769b1e0f195$export$2010d0fb4295b346 = '#DE350B';
var $094b2769b1e0f195$export$2837b5a1a71d5c02 = '#BF2600';
var $094b2769b1e0f195$export$8d9596b529bbb9cf = '#FFFAE6';
var $094b2769b1e0f195$export$41060a744ab0b7ae = '#FFF0B3';
var $094b2769b1e0f195$export$1cc05bbbf340e559 = '#FFE380';
var $094b2769b1e0f195$export$5aae31392d72caaa = '#FFC400';
var $094b2769b1e0f195$export$c6930421db9fa514 = '#FFAB00';
var $094b2769b1e0f195$export$59619663aa6500fb = '#FF991F';
var $094b2769b1e0f195$export$874739ea9e379ab6 = '#FF8B00';
var $094b2769b1e0f195$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $094b2769b1e0f195$export$69a3bf21b9686c2b = '#ABF5D1';
var $094b2769b1e0f195$export$afbce1382ec95f73 = '#79F2C0';
var $094b2769b1e0f195$export$747d86715d4175de = '#57D9A3';
var $094b2769b1e0f195$export$940e1f69e873f202 = '#36B37E';
var $094b2769b1e0f195$export$a49394138f7b8e85 = '#00875A';
var $094b2769b1e0f195$export$6fa04827ac68a4fb = '#006644';
var $094b2769b1e0f195$export$226de0355ed012f8 = '#DEEBFF';
var $094b2769b1e0f195$export$8c13c2ee36917869 = '#B3D4FF';
var $094b2769b1e0f195$export$ecfc1dff386a3e7a = '#4C9AFF';
var $094b2769b1e0f195$export$215b7063051591f1 = '#2684FF';
var $094b2769b1e0f195$export$e62e8919cca44969 = '#0065FF';
var $094b2769b1e0f195$export$b3de0ae08da2ce64 = '#0052CC';
var $094b2769b1e0f195$export$a6ee3d71bc067634 = '#0747A6';
var $094b2769b1e0f195$export$67f15409e87642a1 = '#669DF1';
var $094b2769b1e0f195$export$f0539dbc42dbb067 = '#8FB8F6';
var $094b2769b1e0f195$export$363e4475840015bb = '#EAE6FF';
var $094b2769b1e0f195$export$4b0a4417ed59760f = '#C0B6F2';
var $094b2769b1e0f195$export$6011520a64d9a187 = '#998DD9';
var $094b2769b1e0f195$export$a7175d4e9206bc80 = '#8777D9';
var $094b2769b1e0f195$export$b48405b95304b5a1 = '#6554C0';
var $094b2769b1e0f195$export$c71e4279dd54a18d = '#5243AA';
var $094b2769b1e0f195$export$147899de772240ec = '#403294';
var $094b2769b1e0f195$export$2cf711fe14c66f06 = '#E6FCFF';
var $094b2769b1e0f195$export$7a8f4d33f6f9772c = '#B3F5FF';
var $094b2769b1e0f195$export$776c9c497ef08533 = '#79E2F2';
var $094b2769b1e0f195$export$69cb3ca10c1e330e = '#00C7E6';
var $094b2769b1e0f195$export$9dc1ef0f3f48059b = '#00B8D9';
var $094b2769b1e0f195$export$7c835c78b6fcdef8 = '#00A3BF';
var $094b2769b1e0f195$export$6036577f95c3877e = '#008DA6';
var $094b2769b1e0f195$export$29a4f05edc054374 = '#FFFFFF';
var $094b2769b1e0f195$export$e655ef011c4aa1a2 = '#FAFBFC';
var $094b2769b1e0f195$export$9fdfb749e33cdf97 = '#F4F5F7';
var $094b2769b1e0f195$export$3e51e8f1440314ba = '#EBECF0';
var $094b2769b1e0f195$export$1ce2d1575d444ceb = '#DFE1E6';
var $094b2769b1e0f195$export$8754fc7e6d8b3000 = '#C1C7D0';
var $094b2769b1e0f195$export$c2e91cbeada39b8b = '#B3BAC5';
var $094b2769b1e0f195$export$5f71e19f3a7ad9de = '#A5ADBA';
var $094b2769b1e0f195$export$eaa8c8a70ac22806 = '#97A0AF';
var $094b2769b1e0f195$export$7c87d337fb91a97d = '#8993A4';
var $094b2769b1e0f195$export$d6447c357493214f = '#7A869A';
var $094b2769b1e0f195$export$f563ee71e9ee74cd = '#6B778C';
var $094b2769b1e0f195$export$e2ef2124cf4024b1 = '#5E6C84';
var $094b2769b1e0f195$export$eece5f492e429f08 = '#505F79';
var $094b2769b1e0f195$export$c39c0fe0f26207ae = '#42526E';
var $094b2769b1e0f195$export$7090862dc3038a9f = '#344563';
var $094b2769b1e0f195$export$ad0bacf983b7ddaa = '#253858';
var $094b2769b1e0f195$export$7d61b15e0da132af = '#172B4D';
var $094b2769b1e0f195$export$fbda843f0a27fe96 = '#091E42';
var $094b2769b1e0f195$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $094b2769b1e0f195$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $094b2769b1e0f195$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $094b2769b1e0f195$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $094b2769b1e0f195$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $094b2769b1e0f195$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $094b2769b1e0f195$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $094b2769b1e0f195$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $094b2769b1e0f195$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $094b2769b1e0f195$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $094b2769b1e0f195$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $094b2769b1e0f195$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $094b2769b1e0f195$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $094b2769b1e0f195$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $094b2769b1e0f195$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $094b2769b1e0f195$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $094b2769b1e0f195$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $094b2769b1e0f195$export$2f6319cf7d736c2a = '#E6EDFA';
var $094b2769b1e0f195$export$95126bc8884d6634 = '#DCE5F5';
var $094b2769b1e0f195$export$8338d8c35d44ff1 = '#CED9EB';
var $094b2769b1e0f195$export$5368d76ae4fbbda7 = '#B8C7E0';
var $094b2769b1e0f195$export$9f0a771d16ec8d36 = '#ABBBD6';
var $094b2769b1e0f195$export$abcf8c38338b4aa5 = '#9FB0CC';
var $094b2769b1e0f195$export$97e81faa16a182c7 = '#8C9CB8';
var $094b2769b1e0f195$export$bfe21c59123ecf33 = '#7988A3';
var $094b2769b1e0f195$export$ee82aa2ea6a1558 = '#67758F';
var $094b2769b1e0f195$export$682927c6ed76be02 = '#56637A';
var $094b2769b1e0f195$export$91fd9994c5be9757 = '#455166';
var $094b2769b1e0f195$export$d281fbfe3cff2df6 = '#3B475C';
var $094b2769b1e0f195$export$3902c91d8b98a753 = '#313D52';
var $094b2769b1e0f195$export$8e8133c1ba5845b5 = '#283447';
var $094b2769b1e0f195$export$33ff357f6620b39 = '#202B3D';
var $094b2769b1e0f195$export$633847cf062b69e0 = '#1B2638';
var $094b2769b1e0f195$export$9776a6e503bdbf76 = '#121A29';
var $094b2769b1e0f195$export$6c813d5160dff5db = '#0E1624';
var $094b2769b1e0f195$export$3d4f271a500072a = '#0D1424';
var $094b2769b1e0f195$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $094b2769b1e0f195$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $094b2769b1e0f195$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $094b2769b1e0f195$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $094b2769b1e0f195$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $094b2769b1e0f195$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $094b2769b1e0f195$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $094b2769b1e0f195$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $094b2769b1e0f195$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $094b2769b1e0f195$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $094b2769b1e0f195$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $094b2769b1e0f195$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $094b2769b1e0f195$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $094b2769b1e0f195$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $094b2769b1e0f195$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $094b2769b1e0f195$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $094b2769b1e0f195$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $094b2769b1e0f195$export$d2adc5dedf09fced = '#292A2E';
var $094b2769b1e0f195$export$f51762073d2bb381 = '#94C748';
var $094b2769b1e0f195$export$95e26d54def96891 = '#B3DF72';


var $0a0ec88cfd89a5bc$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $0a0ec88cfd89a5bc$export$c93026a968943f95 = 'light';
var $0a0ec88cfd89a5bc$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $0a0ec88cfd89a5bc$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $094b2769b1e0f195$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    (0, $83ed31c1769bdd35$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $0a0ec88cfd89a5bc$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $0a0ec88cfd89a5bc$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $0a0ec88cfd89a5bc$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $83ed31c1769bdd35$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $0a0ec88cfd89a5bc$export$ba1d834b86d72a09 = $0a0ec88cfd89a5bc$export$a1b3edb637fb4f35;
var $0a0ec88cfd89a5bc$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $094b2769b1e0f195$export$8d43898f60b96a82), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $094b2769b1e0f195$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $094b2769b1e0f195$export$920c0d5c49070351), ")")
            }
        }
    };
};



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");




var $8MJe2 = parcelRequire("8MJe2");


var $137Lh = parcelRequire("137Lh");

var $d4c90676fa20410d$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $d4c90676fa20410d$export$2e2bcd8739ae039() {
    var id = (0, $d625109a55dc7442$export$f680877a34711e37)();
    return "".concat($d4c90676fa20410d$export$8a682ae47622dbb9).concat(id);
}


var $47aae5df48d2fd70$var$actionMap = (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, (0, $fe366ce437c8f2df$export$a80636c6f41931fe), 'next'), (0, $fe366ce437c8f2df$export$390330c10ff2b9a1), 'prev'), (0, $fe366ce437c8f2df$export$4af703091671bc), 'first'), (0, $fe366ce437c8f2df$export$e2bc30913faa5db7), 'last');
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ var $47aae5df48d2fd70$var$getNextFocusableElement = function getNextFocusableElement(refs, currentFocusedIdx) {
    for(var i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        var element = refs[currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ var $47aae5df48d2fd70$var$getPrevFocusableElement = function getPrevFocusableElement(refs, currentFocusedIdx) {
    for(var i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        var element = refs[currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $47aae5df48d2fd70$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    var isNestedMenu = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    return function(e) {
        var _refs$current;
        var currentRefs = (_refs$current = refs.current) !== null && _refs$current !== void 0 ? _refs$current : [];
        var currentFocusedIdx = currentRefs.findIndex(function(_ref) {
            var _document$activeEleme;
            var el = _ref.current;
            return el && ((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.isSameNode(el));
        });
        if ((0, $137Lh.fg)('platform_dst_popup-disable-focuslock')) {
            var _document$activeEleme2;
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            var isNestedDropdown = !!((_document$activeEleme2 = document.activeElement) !== null && _document$activeEleme2 !== void 0 && _document$activeEleme2.closest("[id^=".concat((0, $d4c90676fa20410d$export$8a682ae47622dbb9), "]")));
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $fe366ce437c8f2df$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $fe366ce437c8f2df$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        // Left arrow: only in a submenu — close and return focus to parent. No navigation within menu.
        if (e.key === (0, $fe366ce437c8f2df$export$fc4577f2a2af0ae3)) {
            e.preventDefault();
            if (isNestedMenu) onClose(e);
            return;
        }
        // Right arrow: only when item has submenu — open it. No navigation within menu.
        if (e.key === (0, $fe366ce437c8f2df$export$c40f9845adc73fb5)) {
            var activeElement = document.activeElement;
            if (activeElement instanceof HTMLElement && (activeElement.getAttribute('aria-haspopup') === 'true' || activeElement.getAttribute('aria-haspopup') === 'menu')) {
                e.preventDefault();
                activeElement.click();
            }
            return;
        }
        var action = $47aae5df48d2fd70$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                var nextFocusableElement = $47aae5df48d2fd70$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement === null || nextFocusableElement === void 0 || nextFocusableElement.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                var prevFocusableElement = $47aae5df48d2fd70$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement === null || prevFocusableElement === void 0 || prevFocusableElement.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                var firstFocusableElement = $47aae5df48d2fd70$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement === null || firstFocusableElement === void 0 || firstFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                var lastFocusableElement = $47aae5df48d2fd70$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement === null || lastFocusableElement === void 0 || lastFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}


var $eb6624b74b384c84$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $7fPBF.createContext)({
    menuItemRefs: [],
    registerRef: (0, $dca6c1d9b26ab4f1$export$2e2bcd8739ae039)
});
/**
 * Focus manager logic.
 */ var $eb6624b74b384c84$var$FocusManager = function FocusManager(_ref) {
    var children = _ref.children, onClose = _ref.onClose;
    var menuItemRefs = (0, $7fPBF.useRef)([]);
    // Used to force a re-render only
    var _useState = (0, $7fPBF.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), refresh = _useState2[0], setRefresh = _useState2[1];
    var registerMode = (0, $7fPBF.useRef)('ordered');
    registerMode.current = 'ordered';
    var registerRef = (0, $7fPBF.useCallback)(function(ref) {
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error("Unexpected case of ".concat(registerMode.current));
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    var _useLayering = (0, $1ada5457914d408b$export$c8b4d54e03dee6ed)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    // Root menu (from a button) is at level 1; first submenu is at level 2. ARIA: Left only closes submenus.
    var isNestedMenu = currentLevel > 1;
    // Intentionally rebinding on each render
    (0, $7fPBF.useEffect)(function() {
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $7fPBF.useEffect)(function() {
        return (0, $a091c25729a976b1$exports.bind)(window, {
            type: 'keydown',
            listener: (0, $47aae5df48d2fd70$export$2e2bcd8739ae039)(menuItemRefs, isLayerDisabled, onClose, isNestedMenu)
        });
    }, [
        isLayerDisabled,
        onClose,
        isNestedMenu
    ]);
    var contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($eb6624b74b384c84$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $eb6624b74b384c84$export$2e2bcd8739ae039 = $eb6624b74b384c84$var$FocusManager;


/* menu-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

/* menu-group.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $22931b5fcfc78b42$var$ATOMIC_GROUP_LENGTH = 5;
function $22931b5fcfc78b42$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $22931b5fcfc78b42$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $7fPBF = parcelRequire("7fPBF");
var $3fd46dd48ab010d9$export$443076ec7ebce042 = /*#__PURE__*/ (0, $7fPBF.createContext)('cozy');
var $3fd46dd48ab010d9$export$9ca534b70725964d = /*#__PURE__*/ (0, $7fPBF.createContext)('border');


var $255cd1fdf75ab2a4$var$_excluded = [
    "isLoading",
    "maxWidth",
    "minWidth",
    "minHeight",
    "maxHeight",
    "testId",
    "role",
    "spacing",
    "menuLabel",
    "className"
];
var $255cd1fdf75ab2a4$var$baseStyles = null;
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $255cd1fdf75ab2a4$var$MenuGroup = function MenuGroup(_ref) {
    var isLoading = _ref.isLoading, maxWidth = _ref.maxWidth, minWidth = _ref.minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, testId = _ref.testId, role = _ref.role, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'cozy' : _ref$spacing, menuLabel = _ref.menuLabel, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $255cd1fdf75ab2a4$var$_excluded);
    return /*#__PURE__*/ $7fPBF.createElement((0, $3fd46dd48ab010d9$export$443076ec7ebce042).Provider, {
        value: spacing
    }, /*#__PURE__*/ $7fPBF.createElement((0, $3fd46dd48ab010d9$export$9ca534b70725964d).Provider, {
        value: "border"
    }, /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        "data-testid": testId,
        role: role,
        className: (0, $22931b5fcfc78b42$export$2e2bcd8739ae039)([
            "_1reo1wug _18m91wug _1e0c1txw _kqswpfqs _2lx21bp4",
            UNSAFE_className
        ]),
        "aria-label": menuLabel
    }, rest))));
};
var $255cd1fdf75ab2a4$export$2e2bcd8739ae039 = $255cd1fdf75ab2a4$var$MenuGroup;



var $137Lh = parcelRequire("137Lh");


function $98bcc16954bd5289$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}


function $213629e3ea3ffef6$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}



var $ff9f70b371fd0152$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k"
};
var $ff9f70b371fd0152$var$LoadingIndicator = function LoadingIndicator(_ref) {
    var _ref$statusLabel = _ref.statusLabel, statusLabel = _ref$statusLabel === void 0 ? 'Loading' : _ref$statusLabel, testId = _ref.testId;
    return /*#__PURE__*/ $7fPBF.createElement((0, $2ecd6aa4c91a6f66$export$2e2bcd8739ae039), {
        xcss: $ff9f70b371fd0152$var$styles.spinnerContainer,
        role: "menuitem"
    }, /*#__PURE__*/ $7fPBF.createElement((0, $d921bf90aee0495e$export$2e2bcd8739ae039), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
};
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ var $ff9f70b371fd0152$var$MenuWrapper = function MenuWrapper(_ref2) {
    var children = _ref2.children, isLoading = _ref2.isLoading, maxHeight = _ref2.maxHeight, maxWidth = _ref2.maxWidth, onClose = _ref2.onClose, onUpdate = _ref2.onUpdate, statusLabel = _ref2.statusLabel, setInitialFocusRef = _ref2.setInitialFocusRef, shouldRenderToParent = _ref2.shouldRenderToParent, spacing = _ref2.spacing, testId = _ref2.testId, isTriggeredUsingKeyboard = _ref2.isTriggeredUsingKeyboard, autoFocus = _ref2.autoFocus, menuLabel = _ref2.menuLabel;
    var _useContext = (0, $7fPBF.useContext)((0, $eb6624b74b384c84$export$f18c1d4fc7326096)), menuItemRefs = _useContext.menuItemRefs;
    var closeOnMenuItemClick = function closeOnMenuItemClick(e) {
        var isTargetMenuItemOrDescendant = menuItemRefs.some(function(menuItemRef) {
            var menuItem = menuItemRef.current;
            if (!menuItem) return false;
            var isCheckboxOrRadio = (0, $98bcc16954bd5289$export$2e2bcd8739ae039)(menuItem) || (0, $213629e3ea3ffef6$export$2e2bcd8739ae039)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $7fPBF.useLayoutEffect)(function() {
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $7fPBF.useEffect)(function() {
        var _menuItemRefs$map$fin;
        var firstFocusableRef = (_menuItemRefs$map$fin = menuItemRefs.map(function(_ref3) {
            var current = _ref3.current;
            return current;
        }).find(function(el) {
            return !!el && !el.hasAttribute('disabled');
        })) !== null && _menuItemRefs$map$fin !== void 0 ? _menuItemRefs$map$fin : null;
        if (((0, $137Lh.fg)('platform_dst_menu_item_focus') || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef === null || firstFocusableRef === void 0 || firstFocusableRef.focus();
        setInitialFocusRef === null || setInitialFocusRef === void 0 || setInitialFocusRef(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $255cd1fdf75ab2a4$export$2e2bcd8739ae039), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && "".concat(testId, "--menu-group"),
        menuLabel: menuLabel
    }, isLoading ? /*#__PURE__*/ $7fPBF.createElement($ff9f70b371fd0152$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && "".concat(testId, "--loading-indicator")
    }) : children);
};
var $ff9f70b371fd0152$export$2e2bcd8739ae039 = $ff9f70b371fd0152$var$MenuWrapper;



var $7fPBF = parcelRequire("7fPBF");

var $8f867eaee5479db0$export$756f795847463ebd = /*#__PURE__*/ (0, $7fPBF.createContext)({
    setItemState: (0, $dca6c1d9b26ab4f1$export$2e2bcd8739ae039),
    getItemState: function getItemState() {
        return undefined;
    },
    setGroupState: (0, $dca6c1d9b26ab4f1$export$2e2bcd8739ae039),
    getGroupState: function getGroupState() {
        return {};
    }
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ var $8f867eaee5479db0$var$SelectionStore = function SelectionStore(props) {
    var children = props.children;
    var store = (0, $7fPBF.useRef)({});
    var context = (0, $7fPBF.useMemo)(function() {
        return {
            setItemState: function setItemState(group, id, value) {
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: function getItemState(group, id) {
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: function setGroupState(group, value) {
                store.current[group] = value;
            },
            getGroupState: function getGroupState(group) {
                return store.current[group] || {};
            }
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($8f867eaee5479db0$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $8f867eaee5479db0$export$2e2bcd8739ae039 = $8f867eaee5479db0$var$SelectionStore;


// eslint-disable-next-line sort-imports

var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");

// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $fab79f5a132f918b$var$useRegisterItemWithFocusManager() {
    var hasPopup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _useContext = (0, $7fPBF.useContext)((0, $eb6624b74b384c84$export$f18c1d4fc7326096)), registerRef = _useContext.registerRef;
    var itemRef = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(function() {
        if (hasPopup && (0, $137Lh.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $fab79f5a132f918b$export$2e2bcd8739ae039 = $fab79f5a132f918b$var$useRegisterItemWithFocusManager;



var $a675d37d7e8f2ee4$var$_excluded = [
    "ref",
    "aria-controls",
    "aria-expanded",
    "aria-haspopup"
];
function $a675d37d7e8f2ee4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a675d37d7e8f2ee4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a675d37d7e8f2ee4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a675d37d7e8f2ee4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a675d37d7e8f2ee4$var$MAX_HEIGHT = "calc(100vh - 16px)";
var $a675d37d7e8f2ee4$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
var $a675d37d7e8f2ee4$var$getFallbackPlacements = function getFallbackPlacements(placement) {
    var placementPieces = placement.split('-');
    var mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        var crossAxis = placementPieces[1];
        return [
            "".concat(mainAxis),
            "".concat(mainAxis, "-").concat($a675d37d7e8f2ee4$var$opposites[crossAxis]),
            "".concat($a675d37d7e8f2ee4$var$opposites[mainAxis], "-").concat(crossAxis),
            "".concat($a675d37d7e8f2ee4$var$opposites[mainAxis]),
            "".concat($a675d37d7e8f2ee4$var$opposites[mainAxis], "-").concat($a675d37d7e8f2ee4$var$opposites[crossAxis]),
            'auto'
        ];
    } else return [
        "".concat(mainAxis, "-start"),
        "".concat(mainAxis, "-end"),
        "".concat($a675d37d7e8f2ee4$var$opposites[mainAxis]),
        "".concat($a675d37d7e8f2ee4$var$opposites[mainAxis], "-start"),
        "".concat($a675d37d7e8f2ee4$var$opposites[mainAxis], "-end"),
        "auto"
    ];
};
function $a675d37d7e8f2ee4$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ var $a675d37d7e8f2ee4$var$DropdownMenu = function DropdownMenu(_ref) {
    var _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, children = _ref.children, _ref$defaultOpen = _ref.defaultOpen, defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isOpen = _ref.isOpen, _ref$onOpenChange = _ref.onOpenChange, onOpenChange = _ref$onOpenChange === void 0 ? (0, $dca6c1d9b26ab4f1$export$2e2bcd8739ae039) : _ref$onOpenChange, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, returnFocusRef = _ref.returnFocusRef, spacing = _ref.spacing, statusLabel = _ref.statusLabel, testId = _ref.testId, _trigger = _ref.trigger, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? (0, $0a0ec88cfd89a5bc$export$7be255094ccdc533).modal() : _ref$zIndex, label = _ref.label, interactionName = _ref.interactionName, strategy = _ref.strategy, menuLabel = _ref.menuLabel, _ref$shouldPreventEsc = _ref.shouldPreventEscapePropagation, shouldPreventEscapePropagation = _ref$shouldPreventEsc === void 0 ? false : _ref$shouldPreventEsc;
    var _useControlledState = (0, $37f0004c3fd3493f$export$2e2bcd8739ae039)(isOpen, function() {
        return defaultOpen;
    }), _useControlledState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useControlledState, 2), isLocalOpen = _useControlledState2[0], setLocalIsOpen = _useControlledState2[1];
    var triggerRef = (0, $7fPBF.useRef)(null);
    var _useState = (0, $7fPBF.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), isTriggeredUsingKeyboard = _useState2[0], setTriggeredUsingKeyboard = _useState2[1];
    var id = (0, $d4c90676fa20410d$export$2e2bcd8739ae039)();
    var itemRef = (0, $fab79f5a132f918b$export$2e2bcd8739ae039)();
    var _useLayering = (0, $1ada5457914d408b$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    var fallbackPlacements = (0, $7fPBF.useMemo)(function() {
        return $a675d37d7e8f2ee4$var$getFallbackPlacements(placement);
    }, [
        placement
    ]);
    var handleTriggerClicked = (0, $7fPBF.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    function(event) {
        var newValue = !isLocalOpen;
        var clientX = event.clientX, clientY = event.clientY, type = event.type, detail = event.detail;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            var _itemRef$current;
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef === null || itemRef === void 0 || (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 || _itemRef$current.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    var handleOnClose = (0, $7fPBF.useCallback)(function(event, currentLevel) {
        var _event$target$closest, _event$target;
        var isTabLeftOrEscapeKey = $a675d37d7e8f2ee4$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape' || event.key === (0, $fe366ce437c8f2df$export$fc4577f2a2af0ae3));
        // Stop propagation on ESCAPE or Left arrow if shouldPreventEscapePropagation is true
        if (shouldPreventEscapePropagation && $a675d37d7e8f2ee4$var$isKeyboardEvent(event) && (event.key === 'Escape' || event.key === (0, $fe366ce437c8f2df$export$fc4577f2a2af0ae3))) event.stopPropagation();
        if (event !== null && !isTabLeftOrEscapeKey && event.target instanceof HTMLElement && (_event$target$closest = (_event$target = event.target).closest) !== null && _event$target$closest !== void 0 && _event$target$closest.call(_event$target, "[id^=".concat((0, $d4c90676fa20410d$export$8a682ae47622dbb9), "] [aria-haspopup]"))) {
            var _itemRef$current2;
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            var toCloseLevel = (_itemRef$current2 = itemRef.current) === null || _itemRef$current2 === void 0 ? void 0 : _itemRef$current2.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(function() {
            var _returnFocusRef$curre;
            (_returnFocusRef$curre = returnFocusRef.current) === null || _returnFocusRef$curre === void 0 || _returnFocusRef$curre.focus();
        });
        else if ($a675d37d7e8f2ee4$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape' || event.key === (0, $fe366ce437c8f2df$export$fc4577f2a2af0ae3))) requestAnimationFrame(function() {
            var _itemRef$current3;
            (_itemRef$current3 = itemRef.current) === null || _itemRef$current3 === void 0 || _itemRef$current3.focus();
        });
        else if (triggerRef.current) {
            var _event$target$closest2, _event$target2;
            // Don't focus the trigger if the click was outside of the menu
            var isClickOutsideMenu = (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLElement && ((_event$target$closest2 = (_event$target2 = event.target).closest) === null || _event$target$closest2 === void 0 ? void 0 : _event$target$closest2.call(_event$target2, '[role="menu"]')) === null;
            var shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(function() {
                var _triggerRef$current;
                (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || _triggerRef$current.focus();
            });
        }
        var newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen,
        shouldPreventEscapePropagation
    ]);
    var _useFocus = (0, $5c864840253ea4c6$export$2e2bcd8739ae039)(), isFocused = _useFocus.isFocused, bindFocus = _useFocus.bindFocus;
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $7fPBF.useEffect)(function() {
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $dca6c1d9b26ab4f1$export$2e2bcd8739ae039;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $dca6c1d9b26ab4f1$export$2e2bcd8739ae039;
        return (0, $a091c25729a976b1$exports.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                var isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest("[id^=".concat((0, $d4c90676fa20410d$export$8a682ae47622dbb9), "] [aria-haspopup]"));
                if (e.key === (0, $fe366ce437c8f2df$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $fe366ce437c8f2df$export$e51a3576c045c8d5) || e.key === (0, $fe366ce437c8f2df$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $fe366ce437c8f2df$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ var conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8f867eaee5479db0$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2c055187658302fb$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
        // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
        returnFocusRef === undefined,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        role: shouldRenderToParent && currentLevel > 0 ? 'group' : undefined,
        fallbackPlacements: fallbackPlacements,
        testId: testId && "".concat(testId, "--content"),
        shouldUseCaptureOnOutsideClick: true
    }, conditionalProps, {
        shouldDisableFocusLock: true,
        trigger: function trigger(_ref2) {
            var ref = _ref2.ref, ariaControls = _ref2['aria-controls'], ariaExpanded = _ref2['aria-expanded'], ariaHasPopup = _ref2['aria-haspopup'], rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref2, $a675d37d7e8f2ee4$var$_excluded);
            if (typeof _trigger === 'function') return _trigger($a675d37d7e8f2ee4$var$_objectSpread($a675d37d7e8f2ee4$var$_objectSpread($a675d37d7e8f2ee4$var$_objectSpread({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup
            }, rest), bindFocus), {}, {
                triggerRef: (0, $e5f53ec0aebc72ba$export$2e2bcd8739ae039)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger")
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $74ba3b6cf6a48d65$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, bindFocus, {
                ref: (0, $e5f53ec0aebc72ba$export$2e2bcd8739ae039)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: function iconAfter(iconProps) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f8a69f4ab751b6b7$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, iconProps, {
                        size: "small"
                    }));
                },
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger"),
                "aria-label": label,
                interactionName: interactionName
            }), _trigger);
        },
        content: function content(_ref3) {
            var setInitialFocusRef = _ref3.setInitialFocusRef, update = _ref3.update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $eb6624b74b384c84$export$2e2bcd8739ae039), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $ff9f70b371fd0152$export$2e2bcd8739ae039), {
                spacing: spacing,
                maxHeight: $a675d37d7e8f2ee4$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && "".concat(testId, "--menu-wrapper"),
                menuLabel: menuLabel
            }, children));
        }
    })));
};
var $a675d37d7e8f2ee4$export$2e2bcd8739ae039 = $a675d37d7e8f2ee4$var$DropdownMenu;



var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

/* button-item.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
var $eaf72b84b1dbf4da$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);


/* menu-item-primitive.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $7fPBF = parcelRequire("7fPBF");


var $137Lh = parcelRequire("137Lh");
/* inline.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");


/* flex.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $cd9e14286b8ca05a$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $cd9e14286b8ca05a$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $cd9e14286b8ca05a$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $cd9e14286b8ca05a$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $cd9e14286b8ca05a$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $cd9e14286b8ca05a$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $cd9e14286b8ca05a$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $cd9e14286b8ca05a$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $cd9e14286b8ca05a$var$Flex = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $cd9e14286b8ca05a$var$_excluded);
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, ariaAttributes, {
        role: role,
        className: (0, $22931b5fcfc78b42$export$2e2bcd8739ae039)([
            $cd9e14286b8ca05a$var$styles.root,
            gap && $cd9e14286b8ca05a$var$columnGapMap[gap],
            columnGap && $cd9e14286b8ca05a$var$columnGapMap[columnGap],
            gap && $cd9e14286b8ca05a$var$rowGapMap[gap],
            rowGap && $cd9e14286b8ca05a$var$rowGapMap[rowGap],
            alignItems && $cd9e14286b8ca05a$var$alignItemsMap[alignItems],
            direction && $cd9e14286b8ca05a$var$flexDirectionMap[direction],
            justifyContent && $cd9e14286b8ca05a$var$justifyContentMap[justifyContent],
            wrap && $cd9e14286b8ca05a$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$cd9e14286b8ca05a$var$Flex.displayName = 'Flex';
var $cd9e14286b8ca05a$export$2e2bcd8739ae039 = $cd9e14286b8ca05a$var$Flex;


var $cb719ec0ff6f4945$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $cb719ec0ff6f4945$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $cb719ec0ff6f4945$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, $22931b5fcfc78b42$export$2e2bcd8739ae039)([
            $cb719ec0ff6f4945$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $cb719ec0ff6f4945$var$Inline = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref2, $cb719ec0ff6f4945$var$_excluded);
    var separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $7fPBF.createElement($cb719ec0ff6f4945$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $7fPBF.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $7fPBF.createElement((0, $7fPBF.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $7fPBF.createElement((0, $cd9e14286b8ca05a$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $e636b2257db42c06$export$a274e22fb40f762e)(grow === 'hug' && $cb719ec0ff6f4945$var$styles.hug, grow === 'fill' && $cb719ec0ff6f4945$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$cb719ec0ff6f4945$var$Inline.displayName = 'Inline';
var $cb719ec0ff6f4945$export$2e2bcd8739ae039 = $cb719ec0ff6f4945$var$Inline;



var $c920716421c0064d$var$renderTitle = function renderTitle(Component, props) {
    return(/*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    $7fPBF.createElement(Component, props));
};
var $c920716421c0064d$var$styles = {
    root: "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _4bfu1r31 _1hmsglyw _ajmmnqa1 _kqswh2mm _1e0c1txw _vchhusvi _1bsb1osq _1tke1ylp _1pfhze3t _12l2ze3t _6rthze3t _ahbqze3t _4cvr1h6o _uiztglyw _80omtlke _ymio1r31 _ypr0glyw _zcxs1o36 _nt75194a _mizu194a _1bg41gjf _1ah31gjf _49pcnqa1 _ra3xnqa1 _1hvwdkaa _128mdkaa _9oik1r31 _1bnxglyw _jf4cnqa1 _1cvmnqa1 _4davt94y",
    beforeAfterElement: "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf",
    content: "_12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bah1h6o _16jlkb7n _y3gn1e5h",
    truncate: "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c",
    title: "_11c82smr",
    wordBreak: "_1nmz1hna",
    description: "_11c8dcr7 _syaz1wmz",
    disabledDescription: "_syaz2oi6",
    unselected: "_bfhkqtfy _syaz1r31 _10531r31 _irr31dko _30l31r31 _1di61dko _9h8h1r31",
    disabled: "_80om13gf _bfhkqtfy _syaz2oi6 _irr3qtfy _30l32oi6 _1di6qtfy _9h8h2oi6",
    selectedBorder: "_1mp4yh40 _1cs8stnw _1rus67is _1kt9b3bt _1fkrze3t _iajmze3t _z5wtze3t",
    selectedNotch: "_rfx3bx74 _1mp41y44 _1cs8stnw _1rus67is _1kt9b3bt _1fkrutpp _iajmutpp _z5wtze3t",
    selected: "_bfhk1q4k _syazhu5v _1053hu5v _irr32seo _30l316ov _1di6guph _9h8hhu5v",
    selectedOld: "_30l3hu5v"
};
var $c920716421c0064d$var$spacingMapStyles = {
    cozy: "_1rjcu2gc _18zrpxbi",
    compact: "_1rjc1b66 _18zrutpp _1tkezwfg"
};
var $c920716421c0064d$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ var $c920716421c0064d$var$MenuItemPrimitive = function MenuItemPrimitive(_ref) {
    var children = _ref.children, title = _ref.title, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, UNSAFE_externalClassName = _ref.className, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? false : _ref$shouldTitleWrap, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? false : _ref$shouldDescriptio, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isTitleHeading = _ref.isTitleHeading, isTitleHeading = _ref$isTitleHeading === void 0 ? false : _ref$isTitleHeading, testId = _ref.testId;
    var spacing = (0, $7fPBF.useContext)((0, $3fd46dd48ab010d9$export$443076ec7ebce042));
    var selectionStyle = (0, $7fPBF.useContext)((0, $3fd46dd48ab010d9$export$9ca534b70725964d));
    var UNSAFE_className = UNSAFE_externalClassName;
    return function() {
        return children({
            className: (0, $22931b5fcfc78b42$export$2e2bcd8739ae039)([
                (0, $22931b5fcfc78b42$export$2e2bcd8739ae039)([
                    $c920716421c0064d$var$styles.root,
                    $c920716421c0064d$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $c920716421c0064d$var$styles.unselected,
                    !isDisabled && isSelected && $c920716421c0064d$var$styles.selected,
                    !(0, $137Lh.fg)('platform_fix_a11y_selected_and_hovered_state_color') && !isDisabled && isSelected && $c920716421c0064d$var$styles.selectedOld,
                    !isDisabled && isSelected && selectionStyle === 'border' && $c920716421c0064d$var$styles.selectedBorder,
                    !isDisabled && isSelected && selectionStyle === 'notch' && $c920716421c0064d$var$styles.selectedNotch,
                    isDisabled && $c920716421c0064d$var$styles.disabled
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ $7fPBF.createElement((0, $cb719ec0ff6f4945$export$2e2bcd8739ae039), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $c920716421c0064d$var$gapMap[spacing],
                grow: "fill",
                testId: testId && "".concat(testId, "--container")
            }, iconBefore && /*#__PURE__*/ $7fPBF.createElement("span", {
                "data-item-elem-before": true,
                "data-testid": testId && "".concat(testId, "--icon-before"),
                className: (0, $22931b5fcfc78b42$export$2e2bcd8739ae039)([
                    $c920716421c0064d$var$styles.beforeAfterElement
                ])
            }, iconBefore), title && /*#__PURE__*/ $7fPBF.createElement("div", {
                className: (0, $22931b5fcfc78b42$export$2e2bcd8739ae039)([
                    $c920716421c0064d$var$styles.content
                ])
            }, $c920716421c0064d$var$renderTitle(isTitleHeading ? 'h2' : 'span', {
                children: title,
                className: (0, $22931b5fcfc78b42$export$2e2bcd8739ae039)([
                    $c920716421c0064d$var$styles.title,
                    shouldTitleWrap ? $c920716421c0064d$var$styles.wordBreak : $c920716421c0064d$var$styles.truncate
                ]),
                'data-item-title': true
            }), description && /*#__PURE__*/ $7fPBF.createElement("span", {
                "data-item-description": true,
                className: (0, $22931b5fcfc78b42$export$2e2bcd8739ae039)([
                    $c920716421c0064d$var$styles.description,
                    isDisabled && $c920716421c0064d$var$styles.disabledDescription,
                    shouldDescriptionWrap && $c920716421c0064d$var$styles.wordBreak,
                    !shouldDescriptionWrap && $c920716421c0064d$var$styles.truncate
                ])
            }, description)), iconAfter && /*#__PURE__*/ $7fPBF.createElement("span", {
                "data-item-elem-after": true,
                "data-testid": testId && "".concat(testId, "--icon-after"),
                className: (0, $22931b5fcfc78b42$export$2e2bcd8739ae039)([
                    $c920716421c0064d$var$styles.beforeAfterElement
                ])
            }, iconAfter))
        });
    }();
};
var $c920716421c0064d$export$2e2bcd8739ae039 = $c920716421c0064d$var$MenuItemPrimitive;


var $d43d870fe2269526$var$_excluded = [
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "interactionName"
];
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $d43d870fe2269526$var$ButtonItem = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
    var children = props.children, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, interactionName = props.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(props, $d43d870fe2269526$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $7fPBF.useContext)((0, $eaf72b84b1dbf4da$export$2e2bcd8739ae039));
    var handleClick = (0, $7fPBF.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    return /*#__PURE__*/ $7fPBF.createElement((0, $c920716421c0064d$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        className: UNSAFE_className
    }, rest, {
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isTitleHeading: false,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return /*#__PURE__*/ $7fPBF.createElement("button", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
            "data-testid": testId,
            "aria-current": isSelected ? 'true' : undefined
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: handleClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }), children);
    });
}));
var $d43d870fe2269526$export$2e2bcd8739ae039 = $d43d870fe2269526$var$ButtonItem;


/* custom-item.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");



var $733aa530fb88758c$var$_excluded = [
    "component",
    "isDisabled",
    "isSelected",
    "isTitleHeading",
    "onClick",
    "testId",
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $733aa530fb88758c$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
// Dirty hack to get generics working with forward ref [1/2]
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $733aa530fb88758c$var$CustomItem = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var Component = _ref.component, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isTitleHeading = _ref.isTitleHeading, isTitleHeading = _ref$isTitleHeading === void 0 ? false : _ref$isTitleHeading, onClick = _ref.onClick, testId = _ref.testId, children = _ref.children, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, onMouseDown = _ref.onMouseDown, shouldTitleWrap = _ref.shouldTitleWrap, shouldDescriptionWrap = _ref.shouldDescriptionWrap, UNSAFE_className = _ref.className, UNSAFE_isDraggable = _ref.UNSAFE_isDraggable, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $733aa530fb88758c$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $7fPBF.useContext)((0, $eaf72b84b1dbf4da$export$2e2bcd8739ae039));
    var handleClick = (0, $7fPBF.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    return /*#__PURE__*/ $7fPBF.createElement((0, $c920716421c0064d$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        className: UNSAFE_className
    }, rest, {
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: isTitleHeading,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref2) {
        var children = _ref2.children, className = _ref2.className;
        return /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $733aa530fb88758c$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $733aa530fb88758c$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $733aa530fb88758c$var$preventEvent : handleClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled
        }), children);
    });
}));
var $733aa530fb88758c$export$2e2bcd8739ae039 = $733aa530fb88758c$var$CustomItem;


/* link-item.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $be94a4c6f75f2c43$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $7fPBF.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $be94a4c6f75f2c43$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($be94a4c6f75f2c43$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $be94a4c6f75f2c43$export$2e2bcd8739ae039 = $be94a4c6f75f2c43$var$RouterLinkProvider;


/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $f8dccac8691df1ff$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $7fPBF.useContext)((0, $be94a4c6f75f2c43$export$2931e0ee690eee88)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $f8dccac8691df1ff$export$2e2bcd8739ae039 = $f8dccac8691df1ff$var$useRouterLink;




var $7832dd9a16da1710$var$_excluded = [
    "children",
    "href",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_shouldDisableRouterLink",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $7832dd9a16da1710$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $7832dd9a16da1710$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
var $7832dd9a16da1710$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $7832dd9a16da1710$var$LinkItem = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
    var children = props.children, href = props.href, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, UNSAFE_shouldDisableRouterLink = props.UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable = props.UNSAFE_isDraggable, interactionName = props.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(props, $7832dd9a16da1710$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var RouterLink = (0, $f8dccac8691df1ff$export$2e2bcd8739ae039)();
    var interactionContext = (0, $7fPBF.useContext)((0, $eaf72b84b1dbf4da$export$2e2bcd8739ae039));
    var handleClick = (0, $7fPBF.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    var isExternal = typeof href === 'string' && $7832dd9a16da1710$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $7832dd9a16da1710$var$IS_NON_HTTP_BASED.test(href);
    var isEmptyHref = href == null || href === '';
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ var isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $7fPBF.createElement((0, $c920716421c0064d$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: false,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        title: children,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
            "data-vc": "link-item"
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            href: isDisabled ? undefined : href
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $7832dd9a16da1710$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $7832dd9a16da1710$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $7832dd9a16da1710$var$preventEvent : handleClick,
            "aria-current": isSelected ? 'page' : undefined,
            "aria-disabled": isDisabled,
            ref: ref
        }), children);
    });
}));
var $7832dd9a16da1710$export$2e2bcd8739ae039 = $7832dd9a16da1710$var$LinkItem;



var $6b89ae5977a3bc2b$var$_excluded = [
    "children",
    "component",
    "description",
    "elemAfter",
    "elemBefore",
    "href",
    "isDisabled",
    "isSelected",
    "onClick",
    "rel",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "target",
    "testId",
    "UNSAFE_shouldDisableRouterLink",
    "returnFocusRef",
    "interactionName",
    "role"
];
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ var $6b89ae5977a3bc2b$var$DropdownMenuItem = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, component = _ref.component, description = _ref.description, elemAfter = _ref.elemAfter, elemBefore = _ref.elemBefore, href = _ref.href, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, rel = _ref.rel, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, target = _ref.target, testId = _ref.testId, UNSAFE_shouldDisableRouterLink = _ref.UNSAFE_shouldDisableRouterLink, returnFocusRef = _ref.returnFocusRef, interactionName = _ref.interactionName, role = _ref.role, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $6b89ae5977a3bc2b$var$_excluded);
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    var itemRef = (0, $fab79f5a132f918b$export$2e2bcd8739ae039)(!!rest['aria-haspopup']);
    var handleItemClick = (0, $7fPBF.useCallback)(function(event) {
        if (returnFocusRef !== null && returnFocusRef !== void 0 && returnFocusRef.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $733aa530fb88758c$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $e5f53ec0aebc72ba$export$2e2bcd8739ae039)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        target: target,
        rel: rel,
        interactionName: interactionName
    }, rest), children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7832dd9a16da1710$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $e5f53ec0aebc72ba$export$2e2bcd8739ae039)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName
    }, rest), children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d43d870fe2269526$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $e5f53ec0aebc72ba$export$2e2bcd8739ae039)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        target: target,
        rel: rel,
        interactionName: interactionName
    }, rest), children);
});
var $6b89ae5977a3bc2b$export$2e2bcd8739ae039 = $6b89ae5977a3bc2b$var$DropdownMenuItem;



var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

/* section.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

/* heading-item.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $8bcb60f2bf4287d6$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}


// Reds
var $1d20b6580de3bd74$export$4b84fd0e2c617bd = '#FFEBE6';
var $1d20b6580de3bd74$export$b34b069eff244586 = '#FFBDAD';
var $1d20b6580de3bd74$export$be802dd0d8b57f35 = '#FF8F73';
var $1d20b6580de3bd74$export$60847d42f9da92a6 = '#FF7452';
var $1d20b6580de3bd74$export$4a7404f376229999 = '#FF5630';
var $1d20b6580de3bd74$export$2010d0fb4295b346 = '#DE350B';
var $1d20b6580de3bd74$export$2837b5a1a71d5c02 = '#BF2600';
var $1d20b6580de3bd74$export$8d9596b529bbb9cf = '#FFFAE6';
var $1d20b6580de3bd74$export$41060a744ab0b7ae = '#FFF0B3';
var $1d20b6580de3bd74$export$1cc05bbbf340e559 = '#FFE380';
var $1d20b6580de3bd74$export$5aae31392d72caaa = '#FFC400';
var $1d20b6580de3bd74$export$c6930421db9fa514 = '#FFAB00';
var $1d20b6580de3bd74$export$59619663aa6500fb = '#FF991F';
var $1d20b6580de3bd74$export$874739ea9e379ab6 = '#FF8B00';
var $1d20b6580de3bd74$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $1d20b6580de3bd74$export$69a3bf21b9686c2b = '#ABF5D1';
var $1d20b6580de3bd74$export$afbce1382ec95f73 = '#79F2C0';
var $1d20b6580de3bd74$export$747d86715d4175de = '#57D9A3';
var $1d20b6580de3bd74$export$940e1f69e873f202 = '#36B37E';
var $1d20b6580de3bd74$export$a49394138f7b8e85 = '#00875A';
var $1d20b6580de3bd74$export$6fa04827ac68a4fb = '#006644';
var $1d20b6580de3bd74$export$226de0355ed012f8 = '#DEEBFF';
var $1d20b6580de3bd74$export$8c13c2ee36917869 = '#B3D4FF';
var $1d20b6580de3bd74$export$ecfc1dff386a3e7a = '#4C9AFF';
var $1d20b6580de3bd74$export$215b7063051591f1 = '#2684FF';
var $1d20b6580de3bd74$export$e62e8919cca44969 = '#0065FF';
var $1d20b6580de3bd74$export$b3de0ae08da2ce64 = '#0052CC';
var $1d20b6580de3bd74$export$a6ee3d71bc067634 = '#0747A6';
var $1d20b6580de3bd74$export$67f15409e87642a1 = '#669DF1';
var $1d20b6580de3bd74$export$f0539dbc42dbb067 = '#8FB8F6';
var $1d20b6580de3bd74$export$363e4475840015bb = '#EAE6FF';
var $1d20b6580de3bd74$export$4b0a4417ed59760f = '#C0B6F2';
var $1d20b6580de3bd74$export$6011520a64d9a187 = '#998DD9';
var $1d20b6580de3bd74$export$a7175d4e9206bc80 = '#8777D9';
var $1d20b6580de3bd74$export$b48405b95304b5a1 = '#6554C0';
var $1d20b6580de3bd74$export$c71e4279dd54a18d = '#5243AA';
var $1d20b6580de3bd74$export$147899de772240ec = '#403294';
var $1d20b6580de3bd74$export$2cf711fe14c66f06 = '#E6FCFF';
var $1d20b6580de3bd74$export$7a8f4d33f6f9772c = '#B3F5FF';
var $1d20b6580de3bd74$export$776c9c497ef08533 = '#79E2F2';
var $1d20b6580de3bd74$export$69cb3ca10c1e330e = '#00C7E6';
var $1d20b6580de3bd74$export$9dc1ef0f3f48059b = '#00B8D9';
var $1d20b6580de3bd74$export$7c835c78b6fcdef8 = '#00A3BF';
var $1d20b6580de3bd74$export$6036577f95c3877e = '#008DA6';
var $1d20b6580de3bd74$export$29a4f05edc054374 = '#FFFFFF';
var $1d20b6580de3bd74$export$e655ef011c4aa1a2 = '#FAFBFC';
var $1d20b6580de3bd74$export$9fdfb749e33cdf97 = '#F4F5F7';
var $1d20b6580de3bd74$export$3e51e8f1440314ba = '#EBECF0';
var $1d20b6580de3bd74$export$1ce2d1575d444ceb = '#DFE1E6';
var $1d20b6580de3bd74$export$8754fc7e6d8b3000 = '#C1C7D0';
var $1d20b6580de3bd74$export$c2e91cbeada39b8b = '#B3BAC5';
var $1d20b6580de3bd74$export$5f71e19f3a7ad9de = '#A5ADBA';
var $1d20b6580de3bd74$export$eaa8c8a70ac22806 = '#97A0AF';
var $1d20b6580de3bd74$export$7c87d337fb91a97d = '#8993A4';
var $1d20b6580de3bd74$export$d6447c357493214f = '#7A869A';
var $1d20b6580de3bd74$export$f563ee71e9ee74cd = '#6B778C';
var $1d20b6580de3bd74$export$e2ef2124cf4024b1 = '#5E6C84';
var $1d20b6580de3bd74$export$eece5f492e429f08 = '#505F79';
var $1d20b6580de3bd74$export$c39c0fe0f26207ae = '#42526E';
var $1d20b6580de3bd74$export$7090862dc3038a9f = '#344563';
var $1d20b6580de3bd74$export$ad0bacf983b7ddaa = '#253858';
var $1d20b6580de3bd74$export$7d61b15e0da132af = '#172B4D';
var $1d20b6580de3bd74$export$fbda843f0a27fe96 = '#091E42';
var $1d20b6580de3bd74$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $1d20b6580de3bd74$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $1d20b6580de3bd74$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $1d20b6580de3bd74$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $1d20b6580de3bd74$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $1d20b6580de3bd74$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $1d20b6580de3bd74$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $1d20b6580de3bd74$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $1d20b6580de3bd74$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $1d20b6580de3bd74$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $1d20b6580de3bd74$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $1d20b6580de3bd74$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $1d20b6580de3bd74$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $1d20b6580de3bd74$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $1d20b6580de3bd74$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $1d20b6580de3bd74$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $1d20b6580de3bd74$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $1d20b6580de3bd74$export$2f6319cf7d736c2a = '#E6EDFA';
var $1d20b6580de3bd74$export$95126bc8884d6634 = '#DCE5F5';
var $1d20b6580de3bd74$export$8338d8c35d44ff1 = '#CED9EB';
var $1d20b6580de3bd74$export$5368d76ae4fbbda7 = '#B8C7E0';
var $1d20b6580de3bd74$export$9f0a771d16ec8d36 = '#ABBBD6';
var $1d20b6580de3bd74$export$abcf8c38338b4aa5 = '#9FB0CC';
var $1d20b6580de3bd74$export$97e81faa16a182c7 = '#8C9CB8';
var $1d20b6580de3bd74$export$bfe21c59123ecf33 = '#7988A3';
var $1d20b6580de3bd74$export$ee82aa2ea6a1558 = '#67758F';
var $1d20b6580de3bd74$export$682927c6ed76be02 = '#56637A';
var $1d20b6580de3bd74$export$91fd9994c5be9757 = '#455166';
var $1d20b6580de3bd74$export$d281fbfe3cff2df6 = '#3B475C';
var $1d20b6580de3bd74$export$3902c91d8b98a753 = '#313D52';
var $1d20b6580de3bd74$export$8e8133c1ba5845b5 = '#283447';
var $1d20b6580de3bd74$export$33ff357f6620b39 = '#202B3D';
var $1d20b6580de3bd74$export$633847cf062b69e0 = '#1B2638';
var $1d20b6580de3bd74$export$9776a6e503bdbf76 = '#121A29';
var $1d20b6580de3bd74$export$6c813d5160dff5db = '#0E1624';
var $1d20b6580de3bd74$export$3d4f271a500072a = '#0D1424';
var $1d20b6580de3bd74$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $1d20b6580de3bd74$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $1d20b6580de3bd74$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $1d20b6580de3bd74$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $1d20b6580de3bd74$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $1d20b6580de3bd74$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $1d20b6580de3bd74$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $1d20b6580de3bd74$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $1d20b6580de3bd74$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $1d20b6580de3bd74$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $1d20b6580de3bd74$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $1d20b6580de3bd74$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $1d20b6580de3bd74$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $1d20b6580de3bd74$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $1d20b6580de3bd74$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $1d20b6580de3bd74$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $1d20b6580de3bd74$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $1d20b6580de3bd74$export$d2adc5dedf09fced = '#292A2E';
var $1d20b6580de3bd74$export$f51762073d2bb381 = '#94C748';
var $1d20b6580de3bd74$export$95e26d54def96891 = '#B3DF72';


var $f6a6a058efc17278$var$_excluded = [
    "children",
    "testId",
    "headingLevel",
    "id",
    "className"
];
var $f6a6a058efc17278$var$headingStyles = null;
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $f6a6a058efc17278$var$HeadingItem = /*#__PURE__*/ (0, $7fPBF.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 2 : _ref$headingLevel, id = _ref.id, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $f6a6a058efc17278$var$_excluded);
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        className: (0, $22931b5fcfc78b42$export$2e2bcd8739ae039)([
            "_11c81vhk _1rjcze3t _18zrpxbi _syaz1vvm",
            UNSAFE_className
        ])
    }, rest, {
        style: {
            "--_bbz764": (0, $8bcb60f2bf4287d6$export$2e2bcd8739ae039)("var(--ds-text-subtle, ".concat((0, $1d20b6580de3bd74$export$e2ef2124cf4024b1), ")"))
        }
    }), children);
});
var $f6a6a058efc17278$export$2e2bcd8739ae039 = $f6a6a058efc17278$var$HeadingItem;


var $b0acc52461bf699e$var$_excluded = [
    "children",
    "title",
    "titleId",
    "testId",
    "isScrollable",
    "hasSeparator",
    "id",
    "isList",
    "isSideNavSection",
    "className"
];
var $b0acc52461bf699e$var$itemHeadingTopMargin = 20;
var $b0acc52461bf699e$var$itemHeadingBottomMargin = 6;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
var $b0acc52461bf699e$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
var $b0acc52461bf699e$var$skeletonHeadingHeight = 8;
var $b0acc52461bf699e$var$skeletonHeadingMarginOffset = 3;
var $b0acc52461bf699e$var$skeletonHeadingTopMargin = $b0acc52461bf699e$var$itemHeadingTopMargin + ($b0acc52461bf699e$var$itemHeadingContentHeight - $b0acc52461bf699e$var$skeletonHeadingHeight) - $b0acc52461bf699e$var$skeletonHeadingMarginOffset;
var $b0acc52461bf699e$var$sectionPaddingTopBottom = 6;
var $b0acc52461bf699e$var$styles = {
    root: "_1ywu1ule _cfu11ule _1qdgi2wt _kfgti2wt _aetrb3bt _1kt9b3bt _1p3hi2wt _1l6bgktf _osbldlk8 _auo4rdoj _hp2110yn _1mfv8jkm _1bg41n1a",
    scrollable: "_1reo1wug _18m91wug _1o9zkb7n",
    unscrollable: "_1o9zidpf",
    thinSeparator: "_mqm21ag2",
    noSeparator: "_n7cnyjp0",
    sideNavSectionHeading: "_18zru2gc"
};
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $b0acc52461bf699e$var$Section = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, title = _ref.title, titleId = _ref.titleId, testId = _ref.testId, isScrollable = _ref.isScrollable, hasSeparator = _ref.hasSeparator, id = _ref.id, _ref$isList = _ref.isList, isList = _ref$isList === void 0 ? false : _ref$isList, _ref$isSideNavSection = _ref.isSideNavSection, isSideNavSection = _ref$isSideNavSection === void 0 ? false : _ref$isSideNavSection, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $b0acc52461bf699e$var$_excluded);
    var content = isList ? /*#__PURE__*/ $7fPBF.createElement("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $7fPBF.Children).map((0, $7fPBF.Children).toArray(children), function(child, index) {
        return /*#__PURE__*/ $7fPBF.createElement("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: 'none',
                margin: 0,
                padding: 0
            },
            key: index
        }, child);
    })) : children;
    var childrenMarkup = title !== undefined ? /*#__PURE__*/ $7fPBF.createElement((0, $7fPBF.Fragment), null, /*#__PURE__*/ $7fPBF.createElement((0, $f6a6a058efc17278$export$2e2bcd8739ae039), {
        testId: testId && "".concat(testId, "--heading"),
        "aria-hidden": true,
        className: (0, $22931b5fcfc78b42$export$2e2bcd8739ae039)([
            isSideNavSection && $b0acc52461bf699e$var$styles.sideNavSectionHeading
        ])
    }, title), content) : /*#__PURE__*/ $7fPBF.createElement((0, $7fPBF.Fragment), null, content);
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $22931b5fcfc78b42$export$2e2bcd8739ae039)([
            $b0acc52461bf699e$var$styles.root,
            isScrollable ? $b0acc52461bf699e$var$styles.scrollable : $b0acc52461bf699e$var$styles.unscrollable,
            hasSeparator ? $b0acc52461bf699e$var$styles.thinSeparator : $b0acc52461bf699e$var$styles.noSeparator,
            UNSAFE_className
        ]),
        id: id,
        "aria-label": title,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }), childrenMarkup);
});
var $b0acc52461bf699e$export$2e2bcd8739ae039 = $b0acc52461bf699e$var$Section;


/* group-title.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $7fPBF = parcelRequire("7fPBF");

var $c916906649ee7db1$var$styles = {
    heading: "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ var $c916906649ee7db1$var$GroupTitle = function GroupTitle(_ref) {
    var id = _ref.id, title = _ref.title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2ecd6aa4c91a6f66$export$2e2bcd8739ae039), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $c916906649ee7db1$var$styles.heading
    }, title);
};
var $c916906649ee7db1$export$2e2bcd8739ae039 = $c916906649ee7db1$var$GroupTitle;


var $32a43cba63b7739d$var$_excluded = [
    "children",
    "id",
    "isList",
    "isScrollable",
    "title",
    "testId",
    "hasSeparator"
];
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ var $32a43cba63b7739d$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, title = _ref.title, testId = _ref.testId, hasSeparator = _ref.hasSeparator, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $32a43cba63b7739d$var$_excluded);
    var uid = (0, $d625109a55dc7442$export$f680877a34711e37)();
    var titleId = "dropdown-menu-item-group-title-".concat(uid);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $b0acc52461bf699e$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $c916906649ee7db1$export$2e2bcd8739ae039), {
        id: titleId,
        title: title
    }), children);
});
var $32a43cba63b7739d$export$2e2bcd8739ae039 = $32a43cba63b7739d$var$DropdownMenuItemGroup;


var $9213763bfdf60104$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf60af7e41b379d3a36d6fe455c57ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($9213763bfdf60104$exports, "__esModule", {
    value: true
});
$9213763bfdf60104$exports.default = void 0;

var $9213763bfdf60104$var$_react = $9213763bfdf60104$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $9213763bfdf60104$var$_baseNew = $9213763bfdf60104$var$_interopRequireDefault((parcelRequire("1OCuG")));
function $9213763bfdf60104$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9213763bfdf60104$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $9213763bfdf60104$var$_react.default.createElement($9213763bfdf60104$var$_baseNew.default, Object.assign({
        name: "CheckMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$9213763bfdf60104$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $9213763bfdf60104$var$_default = $9213763bfdf60104$exports.default = $9213763bfdf60104$var$CheckMarkIcon;


var $b419ec0cea5cb950$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($b419ec0cea5cb950$exports, "__esModule", {
    value: true
});
$b419ec0cea5cb950$exports.default = void 0;

var $b419ec0cea5cb950$var$_react = $b419ec0cea5cb950$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $b419ec0cea5cb950$var$_baseNew = $b419ec0cea5cb950$var$_interopRequireDefault((parcelRequire("1OCuG")));
function $b419ec0cea5cb950$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b419ec0cea5cb950$var$CrossIcon = (props)=>/*#__PURE__*/ $b419ec0cea5cb950$var$_react.default.createElement($b419ec0cea5cb950$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$b419ec0cea5cb950$var$CrossIcon.displayName = 'CrossIcon';
var $b419ec0cea5cb950$var$_default = $b419ec0cea5cb950$exports.default = $b419ec0cea5cb950$var$CrossIcon;








var $j9spr = parcelRequire("j9spr");



var $8MJe2 = parcelRequire("8MJe2");

/**
 * Our internal configuration for breakpoints configuration.
 *
 * We explicitly use `-0.01rem` for "max" values to both ensure we do not overlap our media queries, but also don't skip any fractional pixels.  There is a chance this is not safe in some browsers, eg. Safari has weird rounding.
 * @see: https://tzi.fr/css/prevent-double-breakpoint/
 *
 * @experimental Unsafe for direct consumption outside of the design system itself; please use our `media` export instead for media queries.
 */ var $e938e4b54d7876cd$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
var $e938e4b54d7876cd$export$2d293d9871c38e91 = Object.keys($e938e4b54d7876cd$export$e5ee4fe8b989fd09);
var $e938e4b54d7876cd$export$b7ed752a57b4177b = $e938e4b54d7876cd$export$2d293d9871c38e91[0];



function $516d1a824acbd75a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $516d1a824acbd75a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $516d1a824acbd75a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $516d1a824acbd75a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $516d1a824acbd75a$export$918f8818cfbbeb2c = function UNSAFE_buildAboveMediaQueryCSS(input) {
    return (0, $e938e4b54d7876cd$export$2d293d9871c38e91).reduce(function(acc, breakpoint) {
        return $516d1a824acbd75a$var$_objectSpread($516d1a824acbd75a$var$_objectSpread({}, acc), {}, (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, breakpoint, (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, (0, $8c23171a376c15ae$export$987d49ffe1b0900f).above[breakpoint], typeof input === 'function' ? input(breakpoint) : input))));
    }, {});
};
var $516d1a824acbd75a$export$b2a4e2b0c6417297 = function UNSAFE_buildBelowMediaQueryCSS(input) {
    return (0, $e938e4b54d7876cd$export$2d293d9871c38e91).reduce(function(acc, breakpoint) {
        if (breakpoint === 'xxs') return acc;
        return $516d1a824acbd75a$var$_objectSpread($516d1a824acbd75a$var$_objectSpread({}, acc), {}, (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, breakpoint, (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, (0, $8c23171a376c15ae$export$c881183ca713c214).below[breakpoint], typeof input === 'function' ? input(breakpoint) : input))));
    }, {});
};


var $4857edc649d32625$var$hideAboveQueries = (0, $516d1a824acbd75a$export$918f8818cfbbeb2c)({
    display: 'none'
});
var $4857edc649d32625$var$hideBelowQueries = (0, $516d1a824acbd75a$export$b2a4e2b0c6417297)({
    display: 'none'
});
var $4857edc649d32625$export$bed28288a051538 = function Hide(_ref) {
    var above = _ref.above, below = _ref.below, children = _ref.children, _ref$as = _ref.as, AsElement = _ref$as === void 0 ? 'div' : _ref$as, xcss = _ref.xcss;
    var resolvedStyles = (0, $3e5203791fd7c7fc$export$a9c84988c8f81f2d)(xcss);
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(AsElement, {
        className: resolvedStyles.static,
        css: [
            above && $4857edc649d32625$var$hideAboveQueries[above],
            below && $4857edc649d32625$var$hideBelowQueries[below]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(resolvedStyles.emotion || []))
    }, children);
};


const $a8ecf42811a16d58$var$_19 = "._irr36fiy:hover{background-color:var(--_1w39xns)}";
const $a8ecf42811a16d58$var$_18 = "._bfhk1fns{background-color:var(--_11n6snt)}";
const $a8ecf42811a16d58$var$_17 = "._1bah1h6o{justify-content:center}";
const $a8ecf42811a16d58$var$_16 = "._1hfk13x8:after{background-color:var(--_1dobpwl)}";
const $a8ecf42811a16d58$var$_15 = "._1qdggktf:after{height:20px}";
const $a8ecf42811a16d58$var$_14 = "._z0ait94y:after{width:1px}";
const $a8ecf42811a16d58$var$_13 = "._1ywu1ule:after{display:block}";
const $a8ecf42811a16d58$var$_12 = "._aetrb3bt:after{content:\"\"}";
const $a8ecf42811a16d58$var$_11 = "._4t3igktf{height:20px}";
const $a8ecf42811a16d58$var$_10 = "._1bsbt94y{width:1px}";
const $a8ecf42811a16d58$var$_9 = "._16qs1255{box-shadow:0 2px 6px 0 var(--_a4hxpt)}";
const $a8ecf42811a16d58$var$_8 = "._bfhk13x8{background-color:var(--_1dobpwl)}";
const $a8ecf42811a16d58$var$_7 = "._1bsboza4{width:510px}";
const $a8ecf42811a16d58$var$_6 = "._4cvr1h6o{align-items:center}";
const $a8ecf42811a16d58$var$_5 = "._1bah1b1v{justify-content:space-around}";
const $a8ecf42811a16d58$var$_4 = "._1e0c1txw{display:flex}";
const $a8ecf42811a16d58$var$_3 = "._2rko1l7b{border-radius:3px}";
const $a8ecf42811a16d58$var$_2 = "._1yt41ul9{padding:var(--_18cq338)}";
const $a8ecf42811a16d58$var$_ = "._18s8249t{margin:var(--_x2w6pa) auto}";
const $a8ecf42811a16d58$var$languageBarWrapperStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    position: 'fixed',
    top: (0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.800'),
    left: '0',
    width: '100%',
    textAlign: 'center',
    zIndex: 'navigation'
});
const $a8ecf42811a16d58$var$barContentStyles = null;
const $a8ecf42811a16d58$var$contentDelimiterStyles = null;
const $a8ecf42811a16d58$var$closeButtonStyles = null;
const $a8ecf42811a16d58$var$LanguageBar = ()=>{
    const [show, setShow] = (0, $7fPBF.useState)(true);
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    const proposedLanguage = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $0ce633403190319b$export$66e9475a9fd6dfbe));
    const currentLanguage = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $0ce633403190319b$export$20b36ebcfeb0a091));
    const supportedLanguages = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $0ce633403190319b$export$454c8e352dec47e6));
    const dispatch = (0, $7ef2374eddee6a70$export$f51d452c10d5b956)();
    const selectLanguageHandler = (0, $7fPBF.useCallback)((language)=>()=>{
            dispatch((0, $cc45bcc51bf95f36$export$fa43c961ec463ef0)(language));
            setShow(false);
        }, [
        dispatch
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (proposedLanguage == null) setShow(true);
    }, [
        proposedLanguage
    ]);
    if (proposedLanguage == null || !show) return null;
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $4857edc649d32625$export$bed28288a051538), {
        below: "sm",
        children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
            as: "div",
            testId: "language-bar-wrapper",
            xcss: $a8ecf42811a16d58$var$languageBarWrapperStyles,
            children: /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                        children: [
                            $a8ecf42811a16d58$var$_,
                            $a8ecf42811a16d58$var$_2,
                            $a8ecf42811a16d58$var$_3,
                            $a8ecf42811a16d58$var$_4,
                            $a8ecf42811a16d58$var$_5,
                            $a8ecf42811a16d58$var$_6,
                            $a8ecf42811a16d58$var$_7,
                            $a8ecf42811a16d58$var$_8,
                            $a8ecf42811a16d58$var$_9
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("div", {
                        className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                            "_18s8249t _1yt41ul9 _2rko1l7b _1e0c1txw _1bah1b1v _4cvr1h6o _1bsboza4 _bfhk13x8 _16qs1255"
                        ]),
                        style: {
                            "--_x2w6pa": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.050')),
                            "--_18cq338": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.100')),
                            "--_1dobpwl": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.icon.inverse')),
                            "--_a4hxpt": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.background.accent.gray.subtler'))
                        },
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($49831beffa50c42c$exports))), {
                                label: 'header-world-icon',
                                color: (0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.icon.accent.gray')
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $317b0dc61223a332$export$2e2bcd8739ae039), {
                                appearance: 'link',
                                onClick: selectLanguageHandler(proposedLanguage),
                                testId: "proposed-language-bar-button",
                                children: translate((0, $447ba15143f7eed7$exports).PROPOSED_LANGUAGE_MESSAGE, {
                                    language: supportedLanguages[proposedLanguage]
                                })
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                                        children: [
                                            $a8ecf42811a16d58$var$_10,
                                            $a8ecf42811a16d58$var$_11,
                                            $a8ecf42811a16d58$var$_12,
                                            $a8ecf42811a16d58$var$_13,
                                            $a8ecf42811a16d58$var$_14,
                                            $a8ecf42811a16d58$var$_15,
                                            $a8ecf42811a16d58$var$_16
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("div", {
                                        className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                                            "_1bsbt94y _4t3igktf _aetrb3bt _1ywu1ule _z0ait94y _1qdggktf _1hfk13x8"
                                        ]),
                                        style: {
                                            "--_1dobpwl": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.icon.inverse'))
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("div", {
                                children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $a675d37d7e8f2ee4$export$2e2bcd8739ae039), {
                                    testId: "language-bar-dropdown",
                                    trigger: translate((0, $447ba15143f7eed7$exports).ALL_LANGUAGES_MESSAGE),
                                    children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $32a43cba63b7739d$export$2e2bcd8739ae039), {
                                        children: Object.keys(supportedLanguages).map((language)=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $6b89ae5977a3bc2b$export$2e2bcd8739ae039), {
                                                elemBefore: language === currentLanguage ? /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($9213763bfdf60104$exports))), {
                                                    label: 'check-icon',
                                                    size: 'small'
                                                }) : undefined,
                                                onClick: selectLanguageHandler(language),
                                                title: `language-bar-dropdown-item-${language}`,
                                                children: supportedLanguages[language]
                                            }, language))
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                                        children: [
                                            $a8ecf42811a16d58$var$_3,
                                            $a8ecf42811a16d58$var$_4,
                                            $a8ecf42811a16d58$var$_17,
                                            $a8ecf42811a16d58$var$_6,
                                            $a8ecf42811a16d58$var$_18,
                                            $a8ecf42811a16d58$var$_19
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("div", {
                                        onClick: ()=>setShow(false),
                                        "data-testid": "language-bar-close-button",
                                        className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                                            "_2rko1l7b _1e0c1txw _1bah1h6o _4cvr1h6o _bfhk1fns _irr36fiy"
                                        ]),
                                        style: {
                                            "--_11n6snt": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.background.neutral.subtle')),
                                            "--_1w39xns": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.background.neutral.subtle.hovered'))
                                        },
                                        children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($b419ec0cea5cb950$exports))), {
                                            size: "medium",
                                            label: 'message-close-icon',
                                            color: (0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.icon.accent.gray')
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $a8ecf42811a16d58$export$2e2bcd8739ae039 = $a8ecf42811a16d58$var$LanguageBar;





parcelRequire("7fPBF");
var $a0b2fa96bc548ae3$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d66a24f642488d17115358045c30773>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($a0b2fa96bc548ae3$exports, "__esModule", {
    value: true
});
$a0b2fa96bc548ae3$exports.default = void 0;

var $a0b2fa96bc548ae3$var$_react = $a0b2fa96bc548ae3$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $a0b2fa96bc548ae3$var$_baseNew = $a0b2fa96bc548ae3$var$_interopRequireDefault((parcelRequire("1OCuG")));
function $a0b2fa96bc548ae3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: completed items, productivity emoji category. Completed task work type in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a0b2fa96bc548ae3$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $a0b2fa96bc548ae3$var$_react.default.createElement($a0b2fa96bc548ae3$var$_baseNew.default, Object.assign({
        name: "CheckCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0m-2.174-2.52-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$a0b2fa96bc548ae3$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $a0b2fa96bc548ae3$var$_default = $a0b2fa96bc548ae3$exports.default = $a0b2fa96bc548ae3$var$CheckCircleIcon;


var $641719cc12093410$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($641719cc12093410$exports, "__esModule", {
    value: true
});
$641719cc12093410$exports.default = void 0;

var $641719cc12093410$var$_react = $641719cc12093410$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $641719cc12093410$var$_baseNew = $641719cc12093410$var$_interopRequireDefault((parcelRequire("1OCuG")));
function $641719cc12093410$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $641719cc12093410$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $641719cc12093410$var$_react.default.createElement($641719cc12093410$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$641719cc12093410$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $641719cc12093410$var$_default = $641719cc12093410$exports.default = $641719cc12093410$var$StatusErrorIcon;






var $7fPBF = parcelRequire("7fPBF");


/* flag.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $8MJe2 = parcelRequire("8MJe2");

var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $heZxp = parcelRequire("heZxp");/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $4059c65560b999b3$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}





/* heading.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $353cb8d07893398b$var$ATOMIC_GROUP_LENGTH = 5;
function $353cb8d07893398b$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $353cb8d07893398b$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $8MJe2 = parcelRequire("8MJe2");

var $736fbd9eff2a6168$export$4ef52930e33717cd = 'data-theme';
var $736fbd9eff2a6168$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $736fbd9eff2a6168$export$a00eac3f8684bcd0 = 'data-color-mode';
var $736fbd9eff2a6168$export$2112803007239c61 = 'data-contrast-mode';
var $736fbd9eff2a6168$export$352e418ed5b6193a = 'data-custom-theme';
var $736fbd9eff2a6168$export$6f0c6fb8c80fcc92 = 'ds';
var $736fbd9eff2a6168$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $736fbd9eff2a6168$export$dddac1532e822863 = "--".concat($736fbd9eff2a6168$export$6f0c6fb8c80fcc92, "-token-not-found");
var $736fbd9eff2a6168$export$9d7b58831ae93caa = "--".concat($736fbd9eff2a6168$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $3b15dd48580ded12$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3b15dd48580ded12$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3b15dd48580ded12$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3b15dd48580ded12$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3b15dd48580ded12$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $3b15dd48580ded12$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $3b15dd48580ded12$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $3b15dd48580ded12$export$632685d741f3dbbf = $3b15dd48580ded12$var$_objectSpread($3b15dd48580ded12$var$_objectSpread({}, $3b15dd48580ded12$export$958d0ae7f2977ae4), $3b15dd48580ded12$export$d2dc61f58390201c);
var $3b15dd48580ded12$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $3b15dd48580ded12$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $3b15dd48580ded12$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};
var $3b15dd48580ded12$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};
var $3b15dd48580ded12$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};
var $3b15dd48580ded12$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.disabled': "var(--ds-background-disabled, #17171708)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $3b15dd48580ded12$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};
var $3b15dd48580ded12$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #292A2E)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #C9372C)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #E06C00)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #B38600)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #22A06B)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #2898BD)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #357DE8)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #AF59E1)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #7D818A)",
    'color.icon.disabled': "var(--ds-icon-disabled, #080F214A)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #1868DB)",
    'color.icon.brand': "var(--ds-icon-brand, #1868DB)",
    'color.icon.danger': "var(--ds-icon-danger, #C9372C)",
    'color.icon.warning': "var(--ds-icon-warning, #E06C00)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #292A2E)",
    'color.icon.success': "var(--ds-icon-success, #6A9A23)",
    'color.icon.discovery': "var(--ds-icon-discovery, #AF59E1)",
    'color.icon.information': "var(--ds-icon-information, #357DE8)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B6E76)",
    'color.icon.subtle': "var(--ds-icon-subtle, #505258)"
};
var $3b15dd48580ded12$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $3b15dd48580ded12$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
var $3b15dd48580ded12$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
var $3b15dd48580ded12$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $3b15dd48580ded12$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $3b15dd48580ded12$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $3b15dd48580ded12$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $3b15dd48580ded12$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $3b15dd48580ded12$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
/**
 * Token functions are currently allowed for borderRadius in xcss to ease migration.
 * Because 'radius.small' defaults to 3px, we need a mechanism to allow for 4px values to be provided:
 * This is done by calling the token function - token('radius.small')
 *
 * TODO: Remove once shape them is rolled out and fg platform-dst-shape-theme-default removed
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $3b15dd48580ded12$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $3b15dd48580ded12$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $3b15dd48580ded12$export$e615f061ca585a6c = $3b15dd48580ded12$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $3b15dd48580ded12$export$ca0f9c2de39ffed7(spacingProperty, $3b15dd48580ded12$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $3b15dd48580ded12$export$bf46c3f9eeafc71f = $3b15dd48580ded12$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $3b15dd48580ded12$export$ca0f9c2de39ffed7(spacingProperty, $3b15dd48580ded12$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $3b15dd48580ded12$export$e7af83bafe7f9e63 = $3b15dd48580ded12$export$ca0f9c2de39ffed7('backgroundColor', $3b15dd48580ded12$export$d1d79bf68ac056bd);
var $3b15dd48580ded12$export$3a1bcba60b23d7f0 = $3b15dd48580ded12$export$ca0f9c2de39ffed7('color', $3b15dd48580ded12$export$8473307aa00d6ea1);
var $3b15dd48580ded12$export$45f3f4fe16f9f7d5 = $3b15dd48580ded12$export$ca0f9c2de39ffed7('fontWeight', $3b15dd48580ded12$export$303e322c6b1ed114);
var $3b15dd48580ded12$export$68cc305da27dbaa4 = $3b15dd48580ded12$export$ca0f9c2de39ffed7('fontFamily', $3b15dd48580ded12$export$3c7e9587132614b4);
var $3b15dd48580ded12$export$128f10c238242f83 = $3b15dd48580ded12$export$ca0f9c2de39ffed7('font', $3b15dd48580ded12$export$6ffa317d5e70375);
var $3b15dd48580ded12$export$219d364c0da35ae4 = $3b15dd48580ded12$export$ca0f9c2de39ffed7('font', $3b15dd48580ded12$export$236bfe3a33ef1292);
var $3b15dd48580ded12$export$38845ca010b93505 = $3b15dd48580ded12$export$ca0f9c2de39ffed7('fontWeight', $3b15dd48580ded12$export$855cfd311192d666);
var $3b15dd48580ded12$export$ff257d957d48c421 = $3b15dd48580ded12$export$ca0f9c2de39ffed7((0, $736fbd9eff2a6168$export$9d7b58831ae93caa), $3b15dd48580ded12$export$41a358c9c2356760);
var $3b15dd48580ded12$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $3b15dd48580ded12$export$41a358c9c2356760[color] !== undefined;
};
var $3b15dd48580ded12$export$7001ce64d9ff7c7f = $3b15dd48580ded12$export$ca0f9c2de39ffed7('font', $3b15dd48580ded12$export$b805719bc8cb376);



var $7fPBF = parcelRequire("7fPBF");
var $4968213a33496c33$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $7fPBF.createContext)('elevation.surface');
var $4968213a33496c33$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $7fPBF.useContext)($4968213a33496c33$export$1ca2a26fecb070ae);
};
$4968213a33496c33$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $6d63919894553494$export$d1fa8a19e192bc63 = /*#__PURE__*/ (0, $7fPBF.createContext)(0);


var $2bd4f7cd950ad096$export$6a64a1e2d0bbbf75 = function useHeadingLevel() {
    return (0, $7fPBF.useContext)((0, $6d63919894553494$export$d1fa8a19e192bc63));
};


var $7af09a3ba760e845$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = (0, $2bd4f7cd950ad096$export$6a64a1e2d0bbbf75)();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : "h".concat(hLevel)) || fallback
    ];
};


var $ae39dbf01fef6beb$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $ae39dbf01fef6beb$var$styles = {
    reset: "_dxsyidpf _1i144jg8 _nmk4glyw"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $ae39dbf01fef6beb$var$headingColorStyles = {
    'color.text': "_1w90i7uo",
    'color.text.inverse': "_1w9015cr",
    'color.text.warning.inverse': "_1w901yd3"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $ae39dbf01fef6beb$var$headingSizeStyles = {
    xxlarge: "_fqox1iff",
    xlarge: "_fqox12ln",
    large: "_fqox10sd",
    medium: "_fqox1af2",
    small: "_fqox1e3o",
    xsmall: "_fqox1qyo",
    xxsmall: "_fqoxi4vh"
};
/**
 * @codegenEnd
 */ var $ae39dbf01fef6beb$var$useColor = function useColor(colorProp) {
    var surface = (0, $4968213a33496c33$export$1aeb4f6b93c4540d)();
    if (colorProp) return colorProp;
    if ((0, $3b15dd48580ded12$export$2185ce37f9bdd963).hasOwnProperty(surface)) return (0, $3b15dd48580ded12$export$2185ce37f9bdd963)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $ae39dbf01fef6beb$var$Heading = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
    var children = props.children, size = props.size, id = props.id, testId = props.testId, as = props.as, colorProp = props.color;
    var _useHeading = (0, $7af09a3ba760e845$export$97a37b1befbbf9b1)($ae39dbf01fef6beb$var$sizeTagMap[size]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === 'div' && hLevel;
    var color = $ae39dbf01fef6beb$var$useColor(colorProp);
    return /*#__PURE__*/ $7fPBF.createElement(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $353cb8d07893398b$export$2e2bcd8739ae039)([
            $ae39dbf01fef6beb$var$styles.reset,
            $ae39dbf01fef6beb$var$headingSizeStyles[size],
            $ae39dbf01fef6beb$var$headingColorStyles[color]
        ])
    }, children);
});
var $ae39dbf01fef6beb$export$2e2bcd8739ae039 = $ae39dbf01fef6beb$var$Heading;



var $137Lh = parcelRequire("137Lh");
/* box.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $heZxp = parcelRequire("heZxp");

var $7fPBF = parcelRequire("7fPBF");
var $5e10013b4fc49b25$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $7fPBF.createContext)('elevation.surface');
var $5e10013b4fc49b25$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $7fPBF.useContext)($5e10013b4fc49b25$export$1ca2a26fecb070ae);
};
$5e10013b4fc49b25$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


var $b8865657e1570469$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $b8865657e1570469$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $b8865657e1570469$var$baseStyles = null;
var $b8865657e1570469$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhkby5v",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $b8865657e1570469$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $b8865657e1570469$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $b8865657e1570469$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $b8865657e1570469$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $b8865657e1570469$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $b8865657e1570469$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $b8865657e1570469$var$Box = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $b8865657e1570469$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $b8865657e1570469$var$_excluded2);
    var node = /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        style: style,
        ref: ref,
        className: (0, $heZxp.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $b8865657e1570469$var$backgroundColorMap[backgroundColor],
            backgroundColor && $b8865657e1570469$var$isSurfaceToken(backgroundColor) && $b8865657e1570469$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $b8865657e1570469$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $b8865657e1570469$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $b8865657e1570469$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $b8865657e1570469$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $7fPBF.createElement((0, $5e10013b4fc49b25$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $b8865657e1570469$export$2e2bcd8739ae039 = $b8865657e1570469$var$Box;
function $b8865657e1570469$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $b8865657e1570469$var$setSurfaceTokenMap;
}

/* inline.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $heZxp = parcelRequire("heZxp");

/* flex.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $heZxp = parcelRequire("heZxp");
var $4bac9992d06225a8$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $4bac9992d06225a8$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $4bac9992d06225a8$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $4bac9992d06225a8$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $4bac9992d06225a8$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $4bac9992d06225a8$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $4bac9992d06225a8$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $4bac9992d06225a8$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $4bac9992d06225a8$var$Flex = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $4bac9992d06225a8$var$_excluded);
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, ariaAttributes, {
        role: role,
        className: (0, $heZxp.default)([
            $4bac9992d06225a8$var$styles.root,
            gap && $4bac9992d06225a8$var$columnGapMap[gap],
            columnGap && $4bac9992d06225a8$var$columnGapMap[columnGap],
            gap && $4bac9992d06225a8$var$rowGapMap[gap],
            rowGap && $4bac9992d06225a8$var$rowGapMap[rowGap],
            alignItems && $4bac9992d06225a8$var$alignItemsMap[alignItems],
            direction && $4bac9992d06225a8$var$flexDirectionMap[direction],
            justifyContent && $4bac9992d06225a8$var$justifyContentMap[justifyContent],
            wrap && $4bac9992d06225a8$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$4bac9992d06225a8$var$Flex.displayName = 'Flex';
var $4bac9992d06225a8$export$2e2bcd8739ae039 = $4bac9992d06225a8$var$Flex;


var $f6dc54d2afe6a4d1$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $f6dc54d2afe6a4d1$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $f6dc54d2afe6a4d1$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, $heZxp.default)([
            $f6dc54d2afe6a4d1$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $f6dc54d2afe6a4d1$var$Inline = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref2, $f6dc54d2afe6a4d1$var$_excluded);
    var separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $7fPBF.createElement($f6dc54d2afe6a4d1$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $7fPBF.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $7fPBF.createElement((0, $7fPBF.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $7fPBF.createElement((0, $4bac9992d06225a8$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $e636b2257db42c06$export$a274e22fb40f762e)(grow === 'hug' && $f6dc54d2afe6a4d1$var$styles.hug, grow === 'fill' && $f6dc54d2afe6a4d1$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$f6dc54d2afe6a4d1$var$Inline.displayName = 'Inline';
var $f6dc54d2afe6a4d1$export$2e2bcd8739ae039 = $f6dc54d2afe6a4d1$var$Inline;

/* stack.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");



var $97877a8edc6b5060$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "spread",
    "grow",
    "space",
    "children",
    "testId",
    "xcss",
    "role"
];
var $97877a8edc6b5060$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $97877a8edc6b5060$var$Stack = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $97877a8edc6b5060$var$_excluded);
    return /*#__PURE__*/ $7fPBF.createElement((0, $4bac9992d06225a8$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, ariaAttributes, {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $e636b2257db42c06$export$a274e22fb40f762e)(grow === 'hug' && $97877a8edc6b5060$var$styles.hug, grow === 'fill' && $97877a8edc6b5060$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$97877a8edc6b5060$var$Stack.displayName = 'Stack';
var $97877a8edc6b5060$export$2e2bcd8739ae039 = $97877a8edc6b5060$var$Stack;



var $94c19706695d9a55$export$d6830277b06edd6 = 'normal';


/* flag-actions.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ 
var $7fPBF = parcelRequire("7fPBF");

var $heZxp = parcelRequire("heZxp");


var $95aad77dab1e9a95$export$7bcfe3cca4dd78b6 = {
    success: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    error: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text-warning-inverse, #292A2E)",
    normal: "var(--ds-link, #1868DB)"
};



// TODO: DSP-2519 Interaction tokens should be used for hovered and pressed states
// https://product-fabric.atlassian.net/browse/DSP-2519






var $f75e92ad396a7ed0$export$81ba6b63eedb299f = {
    success: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    info: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    error: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    warning: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    normal: {
        default: 'none',
        active: 'none',
        pressed: 'none'
    }
};


var $3f065ac35d50ec42$var$buttonStyles = null;
var $3f065ac35d50ec42$var$fontStyles = null;
var $3f065ac35d50ec42$var$appearanceNormalButtonStyles = null;
var $3f065ac35d50ec42$var$appearanceNormalActionsContainerStyles = null;
var $3f065ac35d50ec42$var$FlagActions = function FlagActions(props) {
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $94c19706695d9a55$export$d6830277b06edd6) : _props$appearance, _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, linkComponent = props.linkComponent, testId = props.testId;
    if (!actions.length) return null;
    var isBold = appearance !== (0, $94c19706695d9a55$export$d6830277b06edd6);
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, $heZxp.default)([
            !isBold && "_1g4l107e _y8dn107e",
            "_11c8fhey"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement((0, $f6dc54d2afe6a4d1$export$2e2bcd8739ae039), {
        space: "space.100",
        shouldWrap: true,
        alignBlock: "center",
        separator: isBold ? undefined : "\xb7",
        testId: testId && "".concat(testId, "-actions")
    }, actions.map(function(action, index) {
        return /*#__PURE__*/ $7fPBF.createElement((0, $b6738ae824ea86e7$export$2e2bcd8739ae039), {
            onClick: action.onClick,
            href: action.href,
            target: action.target,
            appearance: isBold ? 'default' : 'link',
            component: linkComponent,
            spacing: "compact",
            testId: action.testId,
            key: index,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                '--color': (0, $95aad77dab1e9a95$export$7bcfe3cca4dd78b6)[appearance],
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color': (0, $f75e92ad396a7ed0$export$81ba6b63eedb299f)[appearance].default,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color-hover': (0, $f75e92ad396a7ed0$export$81ba6b63eedb299f)[appearance].pressed,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color-active': (0, $f75e92ad396a7ed0$export$81ba6b63eedb299f)[appearance].active
            },
            className: (0, $heZxp.default)([
                "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _1ku2grf3 _1v8mgrf3 _gbuigrf3 _1dwvgrf3 _1bk61a66 _1wy61a66 _b3g31a66 _eqps1a66 _ow071r31 _1p6b1r31 _8dbm1r31 _77mc1r31 _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                appearance === (0, $94c19706695d9a55$export$d6830277b06edd6) && "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
            ])
        }, action.content);
    })));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3f065ac35d50ec42$export$2e2bcd8739ae039 = $3f065ac35d50ec42$var$FlagActions;


var $438786f526d630cf$export$59e42969c95d314 = {
    error: 'color.background.danger.bold',
    info: 'color.background.neutral.bold',
    normal: 'elevation.surface.overlay',
    success: 'color.background.success.bold',
    warning: 'color.background.warning.bold'
};


/* flag-group.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $bRUy3 = parcelRequire("bRUy3");

var $7fPBF = parcelRequire("7fPBF");

var $heZxp = parcelRequire("heZxp");






var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $a1ad98f67aabe587$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $a1ad98f67aabe587$var$ExitingContext = /*#__PURE__*/ (0, $7fPBF.createContext)($a1ad98f67aabe587$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $a1ad98f67aabe587$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a1ad98f67aabe587$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($a1ad98f67aabe587$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $a1ad98f67aabe587$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $7fPBF.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $a1ad98f67aabe587$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $a1ad98f67aabe587$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $a1ad98f67aabe587$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $a1ad98f67aabe587$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $a1ad98f67aabe587$var$ExitingPersistence = /*#__PURE__*/ (0, $7fPBF.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $7fPBF.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $7fPBF.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $7fPBF.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $a1ad98f67aabe587$var$childrenToArray(previousChildren);
    var current = $a1ad98f67aabe587$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $a1ad98f67aabe587$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $a1ad98f67aabe587$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $137Lh.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $a1ad98f67aabe587$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $a1ad98f67aabe587$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $a1ad98f67aabe587$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $7fPBF.useContext)($a1ad98f67aabe587$var$ExitingContext);
};
$a1ad98f67aabe587$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $a1ad98f67aabe587$export$2e2bcd8739ae039 = $a1ad98f67aabe587$var$ExitingPersistence;

/* motion.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $iKdEz = parcelRequire("iKdEz");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $02d82b7bcc8cdbfd$var$ATOMIC_GROUP_LENGTH = 5;
function $02d82b7bcc8cdbfd$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $02d82b7bcc8cdbfd$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $7fPBF = parcelRequire("7fPBF");



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $34452922263080f6$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $34452922263080f6$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$34452922263080f6$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $34452922263080f6$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $7fPBF.useState)($34452922263080f6$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $7fPBF.useEffect)(function() {
        if (!$34452922263080f6$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $a091c25729a976b1$exports.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $34452922263080f6$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $34452922263080f6$export$ff7706047246b98b = function prefersReducedMotion() {
    return $34452922263080f6$export$f0f789643ba5a83c;
};



var $j9spr = parcelRequire("j9spr");

var $a12d6dd64cd09e14$export$d0038b6e47881463 = function getDurationMs(animation) {
    var match = (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(animation.trim().matchAll(/(-?\d*\.?\d+)(ms|s)\b/g));
    if (match.length === 0) return {
        duration: 0,
        delay: 0
    };
    var durationValue = parseFloat(match[0][1]);
    var durationUnit = match[0][2];
    var duration = durationUnit === 's' ? durationValue * 1000 : durationValue;
    var delay = 0;
    if (match[1]) {
        var delayValue = parseFloat(match[1][1]);
        var delayUnit = match[1][2];
        delay = delayUnit === 's' ? delayValue * 1000 : delayValue;
    }
    return {
        duration: duration,
        delay: delay
    };
};
var $a12d6dd64cd09e14$export$75eee42ff540d8ae = function convertToMs(duration) {
    // Use regex to separate the number and the unit
    var matches = duration.match(/^(\d+\.?\d*)(s|ms)$/);
    if (!matches) return 0; // Or return for invalid format
    var value = parseFloat(matches[1]);
    var unit = matches[2];
    if (unit === 's') return value * 1000; // Convert seconds to milliseconds
    else return value; // Already in milliseconds
};
var $a12d6dd64cd09e14$export$82b92541889a035d = function resolveMotionToken(token) {
    var cssVarMatch = token.match(/var\(\s*(--[^,\s)]+)/);
    var cssVar = cssVarMatch ? cssVarMatch[1] : null;
    if (cssVar) {
        var _getDocument;
        var documentElement = (_getDocument = (0, $f30181cdac346cce$export$f65ca476c09acec0)()) === null || _getDocument === void 0 ? void 0 : _getDocument.documentElement;
        if (documentElement) return getComputedStyle(documentElement).getPropertyValue(cssVar);
    }
    return '';
};




var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
var $33e380d2666a4ede$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $7fPBF.useEffect) : (0, $7fPBF.useLayoutEffect);


/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $7fPBF = parcelRequire("7fPBF");
function $4541f9363ab5290d$export$c485849f2e393253() {
    var identifier = (0, $7fPBF.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}


var $32695e8518f8b985$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $7fPBF.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $f48d740006cf3f7d$export$2e2bcd8739ae039)
    };
});
var $32695e8518f8b985$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $4541f9363ab5290d$export$c485849f2e393253)();
    var context = (0, $7fPBF.useContext)($32695e8518f8b985$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $32695e8518f8b985$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $7fPBF.useRef)([]);
    var indexes = [];
    var _useState = (0, $7fPBF.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $33e380d2666a4ede$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($32695e8518f8b985$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $32695e8518f8b985$export$2e2bcd8739ae039 = $32695e8518f8b985$var$StaggeredEntrance;


var $ada36c25659d67df$var$styles = {
    base: "_1y0co91m _1bumglyw _sedtglyw",
    hidden: "_3um015vq",
    entering: "_1o51eoah",
    exiting: "_1o51q7pw"
};
var $ada36c25659d67df$export$569340a66b14e0dc = /*#__PURE__*/ function(Reanimate) {
    Reanimate["enter"] = "enter";
    Reanimate["exit_then_enter"] = "exit_then_enter";
    return Reanimate;
}({});
/**
 * __Motion__
 *
 * A motion primitive that can be used to animate the entry and exit of components.
 */ var $ada36c25659d67df$var$Motion = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, enteringAnimation = _ref.enteringAnimation, enteringAnimationXcss = _ref.enteringAnimationXcss, exitingAnimation = _ref.exitingAnimation, exitingAnimationXcss = _ref.exitingAnimationXcss, onFinishMotion = _ref.onFinish, xcss = _ref.xcss, testId = _ref.testId;
    var staggered = (0, $32695e8518f8b985$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $a1ad98f67aabe587$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var staggeredDelay = isExiting ? 0 : staggered.delay;
    var staggedIsReady = staggered.isReady;
    var _useState = (0, $7fPBF.useState)(appear ? staggedIsReady && !staggeredDelay ? 'entering' : 'init' : 'idle'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var elementRef = (0, $7fPBF.useRef)(null);
    var reanimateRef = (0, $7fPBF.useRef)();
    var animationRef = (0, $7fPBF.useRef)();
    var staggeredEntryRef = (0, $7fPBF.useRef)();
    (0, $7fPBF.useEffect)(function() {
        if (isExiting) setState('exiting');
    }, [
        isExiting
    ]);
    // Handles staggered entry
    (0, $7fPBF.useEffect)(function() {
        if (state !== 'init') return;
        // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(function() {
            setState('entering');
        }, staggeredDelay);
        return function() {
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        state,
        staggedIsReady,
        staggeredDelay
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ var onAnimationEnd = (0, $7fPBF.useCallback)(function(state, cancelled) {
        // We are done animating, so we set the state to idle
        var newState = 'idle';
        if (state === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('exiting');
        }
        if (state === 'entering') onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('entering');
        if (reanimateRef.current === $ada36c25659d67df$export$569340a66b14e0dc.exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = $ada36c25659d67df$export$569340a66b14e0dc.enter;
            newState = 'entering';
        } else if (reanimateRef.current) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    (0, $7fPBF.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (!staggedIsReady) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is idle or init, we don't need to do anything
        if (state === 'idle' || state === 'init') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if ((0, $34452922263080f6$export$b7baf7667a68d87c)() || !exitingAnimation && !exitingAnimationXcss) {
            onAnimationEnd(state, isCancelled);
            return;
        }
        var animationDuration = 0;
        var animationDelay = 0;
        if (state === 'entering' || state === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    var animationTimings = (0, $a12d6dd64cd09e14$export$d0038b6e47881463)((0, $a12d6dd64cd09e14$export$82b92541889a035d)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDelay = animationTimings.delay;
                } else {
                    // Custom motion
                    var _styles = window.getComputedStyle(elementRef.current);
                    if (_styles.animationDuration) animationDuration = (0, $a12d6dd64cd09e14$export$75eee42ff540d8ae)(_styles.animationDuration);
                    if (_styles.animationDelay) animationDelay = (0, $a12d6dd64cd09e14$export$75eee42ff540d8ae)(_styles.animationDelay);
                }
            }
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (state === 'exiting' && (exitingAnimation || exitingAnimationXcss)) animationRef.current = setTimeout(function() {
            return onAnimationEnd(state, isCancelled);
        }, animationDuration + animationDelay);
        else if (state === 'entering' && (enteringAnimation || enteringAnimationXcss)) animationRef.current = setTimeout(function() {
            return onAnimationEnd(state, isCancelled);
        }, animationDuration + animationDelay);
        return function() {
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        state,
        exitingAnimation,
        enteringAnimation,
        exitingAnimationXcss,
        enteringAnimationXcss,
        staggeredDelay,
        staggedIsReady
    ]);
    (0, $7fPBF.useImperativeHandle)(ref, function() {
        return {
            reanimate: function reanimate(value) {
                animationRef.current && clearTimeout(animationRef.current);
                reanimateRef.current = value;
                if (value === $ada36c25659d67df$export$569340a66b14e0dc.exit_then_enter) setState('exiting');
                else if (value === $ada36c25659d67df$export$569340a66b14e0dc.enter) setState('entering');
            }
        };
    });
    var style = {};
    var customAnimation;
    if (state === 'entering') {
        if (enteringAnimation) style.animation = enteringAnimation;
        else if (enteringAnimationXcss) customAnimation = enteringAnimationXcss;
    } else if (state === 'exiting') {
        if (exitingAnimation) style.animation = exitingAnimation;
        else if (exitingAnimationXcss) customAnimation = exitingAnimationXcss;
    }
    var hasAnimationStyles = state !== 'idle' && state !== 'init';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
            hasAnimationStyles && $ada36c25659d67df$var$styles.base,
            state === 'init' && $ada36c25659d67df$var$styles.hidden,
            state === 'entering' && $ada36c25659d67df$var$styles.entering,
            state === 'exiting' && $ada36c25659d67df$var$styles.exiting,
            (0, $e636b2257db42c06$export$a274e22fb40f762e)(xcss, customAnimation)
        ]),
        ref: (0, $9ec85dcfc6117313$export$2e2bcd8739ae039)([
            staggered.ref,
            elementRef
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: hasAnimationStyles ? style : undefined,
        "data-testid": testId
    }, children);
});
var $ada36c25659d67df$export$2e2bcd8739ae039 = $ada36c25659d67df$var$Motion;


var $7fPBF = parcelRequire("7fPBF");
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");


/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $f71fbefa8f6c3895$export$368bacef0dacbe05 = 25;
var $f71fbefa8f6c3895$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $f71fbefa8f6c3895$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $f71fbefa8f6c3895$export$30fa1a2e62ae150c = {
    none: $f71fbefa8f6c3895$export$38b928a7167ce124.none,
    small: $f71fbefa8f6c3895$export$38b928a7167ce124.small * $f71fbefa8f6c3895$var$EXITING_MOTION_MULTIPLIER,
    medium: $f71fbefa8f6c3895$export$38b928a7167ce124.medium * $f71fbefa8f6c3895$var$EXITING_MOTION_MULTIPLIER,
    large: $f71fbefa8f6c3895$export$38b928a7167ce124.large * $f71fbefa8f6c3895$var$EXITING_MOTION_MULTIPLIER
};



var $7fPBF = parcelRequire("7fPBF");
// Handle both browser and Node.js environments
var $27095c47a45ed928$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $27095c47a45ed928$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $7fPBF.useRef)([]);
    (0, $7fPBF.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $27095c47a45ed928$var$getHookDeps(opts));
    return (0, $7fPBF.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $27095c47a45ed928$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $7fPBF.useRef)([]);
    (0, $7fPBF.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $27095c47a45ed928$var$getHookDeps(opts));
    return (0, $7fPBF.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};




var $a5b5d47be4518e83$var$zoomIn = null;
var $a5b5d47be4518e83$var$zoomOut = null;
var $a5b5d47be4518e83$var$fadeIn = null;
var $a5b5d47be4518e83$var$fadeOut = null;
var $a5b5d47be4518e83$var$fadeInFromTop = null;
var $a5b5d47be4518e83$var$fadeOutFromTop = null;
var $a5b5d47be4518e83$var$fadeInFromLeft = null;
var $a5b5d47be4518e83$var$fadeOutFromLeft = null;
var $a5b5d47be4518e83$var$fadeInFromBottom = null;
var $a5b5d47be4518e83$var$fadeOutFromBottom = null;
var $a5b5d47be4518e83$var$fadeInFromRight = null;
var $a5b5d47be4518e83$var$fadeOutFromRight = null;
var $a5b5d47be4518e83$var$fadeInFromTopConstant = null;
var $a5b5d47be4518e83$var$fadeOutFromTopConstant = null;
var $a5b5d47be4518e83$var$fadeInFromLeftConstant = null;
var $a5b5d47be4518e83$var$fadeOutFromLeftConstant = null;
var $a5b5d47be4518e83$var$fadeInFromBottomConstant = null;
var $a5b5d47be4518e83$var$fadeOutFromBottomConstant = null;
var $a5b5d47be4518e83$var$fadeInFromRightConstant = null;
var $a5b5d47be4518e83$var$fadeOutFromRightConstant = null;
var $a5b5d47be4518e83$var$slideInFromTop = null;
var $a5b5d47be4518e83$var$slideOutFromTop = null;
var $a5b5d47be4518e83$var$slideInFromRight = null;
var $a5b5d47be4518e83$var$slideOutFromRight = null;
var $a5b5d47be4518e83$var$slideInFromBottom = null;
var $a5b5d47be4518e83$var$slideOutFromBottom = null;
var $a5b5d47be4518e83$var$slideInFromLeft = null;
var $a5b5d47be4518e83$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $a5b5d47be4518e83$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $32695e8518f8b985$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $a1ad98f67aabe587$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $27095c47a45ed928$export$4f34107a2b00f39c)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $7fPBF.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $7fPBF.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $34452922263080f6$export$b7baf7667a68d87c)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $f71fbefa8f6c3895$export$30fa1a2e62ae150c)[duration] : (0, $f71fbefa8f6c3895$export$38b928a7167ce124)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
            (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $02d82b7bcc8cdbfd$export$2e2bcd8739ae039)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $a5b5d47be4518e83$export$2e2bcd8739ae039 = $a5b5d47be4518e83$var$EnteringMotion;


/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions).
 */ var $40f3b8b015f253a5$var$SlideIn = function SlideIn(_ref) {
    var children = _ref.children, enterFrom = _ref.enterFrom, exitTo = _ref.exitTo, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'medium' : _ref$duration, isPaused = _ref.isPaused, onFinish = _ref.onFinish, _ref$animationTimingF = _ref.animationTimingFunction, animationTimingFunction = _ref$animationTimingF === void 0 ? 'ease-out' : _ref$animationTimingF, _ref$animationTimingF2 = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF2 === void 0 ? 'ease-in' : _ref$animationTimingF2;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a5b5d47be4518e83$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: "slide-in-from-".concat(enterFrom),
        exitingAnimation: "slide-out-from-".concat(exitTo || enterFrom),
        animationTimingFunction: animationTimingFunction,
        animationTimingFunctionExiting: animationTimingFunctionExiting,
        isPaused: isPaused,
        onFinish: onFinish
    }, children);
};
var $40f3b8b015f253a5$export$2e2bcd8739ae039 = $40f3b8b015f253a5$var$SlideIn;



var $137Lh = parcelRequire("137Lh");


/* eslint-disable no-console */ var $bb6e9737a73b7581$var$printed = {};
function $bb6e9737a73b7581$export$2e2bcd8739ae039(message) {
    if ($bb6e9737a73b7581$var$printed[message]) return;
    $bb6e9737a73b7581$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}


function $0440a7eded5169c8$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $bb6e9737a73b7581$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}


var $c163cd89b0fadc16$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $c163cd89b0fadc16$export$c93026a968943f95 = 'light';
var $c163cd89b0fadc16$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $c163cd89b0fadc16$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, #4688EC)";
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    (0, $0440a7eded5169c8$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $c163cd89b0fadc16$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $c163cd89b0fadc16$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $c163cd89b0fadc16$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $0440a7eded5169c8$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $c163cd89b0fadc16$export$ba1d834b86d72a09 = $c163cd89b0fadc16$export$a1b3edb637fb4f35;
var $c163cd89b0fadc16$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, #0515240F)",
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, #0515240F)"
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, #17171708)"
            }
        }
    };
};



var $99322f445ba7cde3$export$1eee5ddc4f6d41c5 = 400;
var $99322f445ba7cde3$var$defaultFlagGroupContext = {
    onDismissed: (0, $f48d740006cf3f7d$export$2e2bcd8739ae039),
    isDismissAllowed: false
};
var $99322f445ba7cde3$export$c57ba665aaa722be = /*#__PURE__*/ (0, $7fPBF.createContext)($99322f445ba7cde3$var$defaultFlagGroupContext);
function $99322f445ba7cde3$export$e91ea202abb66350() {
    return (0, $7fPBF.useContext)($99322f445ba7cde3$export$c57ba665aaa722be);
}
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
var $99322f445ba7cde3$var$groupStyles = {
    root: "_v5641b8g _1bsb1kdj _kqswstnw _u7coidpf _1eqkauwl",
    first: "_v564glyw _t9ec1ygq _1pbyqfx8",
    second: "_1pbyegat",
    nth: "_5sag5cps _t9ec1hw2",
    hidden: "_3um015vq"
};
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
var $99322f445ba7cde3$var$groupStylesNew = {
    root: "_v564t8bh _kqswstnw _u7coidpf _1bsb1kdj _1eqkauwl",
    first: "_t9ec1ygq _1pbyqfx8",
    second: "_t9ec1pi4 _1pbyegat",
    nth: "_t9ec15wd",
    hidden: "_3um015vq"
};
// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
var $99322f445ba7cde3$var$dismissAllowedStyles = null;
var $99322f445ba7cde3$var$flagGroupContainerStyles = null;
/**
 * __Flag group__
 *
 * A flag group is used to group a set of related flags, with entry and exit animations.
 *
 * - [Examples](https://atlassian.design/components/flag/flag-group/examples)
 * - [Code](https://atlassian.design/components/flag/flag-group/code)
 */ var $99322f445ba7cde3$var$FlagGroup = function FlagGroup(props) {
    var id = props.id, _props$label = props.label, label = _props$label === void 0 ? 'Flag notifications' : _props$label, _props$labelTag = props.labelTag, LabelTag = _props$labelTag === void 0 ? 'h2' : _props$labelTag, _props$shouldRenderTo = props.shouldRenderToParent, shouldRenderToParent = _props$shouldRenderTo === void 0 ? false : _props$shouldRenderTo, children = props.children, _props$onDismissed = props.onDismissed, onDismissed = _props$onDismissed === void 0 ? (0, $f48d740006cf3f7d$export$2e2bcd8739ae039) : _props$onDismissed;
    var hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    var dismissFlagContext = (0, $7fPBF.useMemo)(function() {
        return {
            onDismissed: onDismissed,
            isDismissAllowed: true
        };
    }, [
        onDismissed
    ]);
    // Keep a stable reference to the latest children, dismiss handler, and
    // analytics creator so the keydown listener never reads stale closures.
    var _useAnalyticsEvents = (0, $8618b7ff1a86c099$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var latestRef = (0, $7fPBF.useRef)({
        children: children,
        onDismissed: onDismissed,
        createAnalyticsEvent: createAnalyticsEvent
    });
    latestRef.current = {
        children: children,
        onDismissed: onDismissed,
        createAnalyticsEvent: createAnalyticsEvent
    };
    // Accessibility (JRACLOUD-97876): allow keyboard-only and assistive
    // technology users to dismiss the topmost (and only dismissable) flag with
    // the Escape key, without having to tab through the entire page to reach
    // the dismiss button. Behaviour is gated behind a feature flag so it can
    // be rolled out and validated incrementally.
    (0, $7fPBF.useEffect)(function() {
        if (!(0, $137Lh.fg)('platform_dst_flag_keyboard_dismiss')) return;
        if (!hasFlags) return;
        var doc = (0, $f30181cdac346cce$export$f65ca476c09acec0)();
        if (!doc) return;
        return (0, $a091c25729a976b1$exports.bind)(doc, {
            type: 'keydown',
            listener: function listener(event) {
                var _props, _latestRef$current$on, _latestRef$current;
                if (event.key !== 'Escape' || event.defaultPrevented) return;
                var currentChildren = latestRef.current.children;
                var firstFlag = Array.isArray(currentChildren) ? currentChildren.find(Boolean) : currentChildren;
                if (!firstFlag || (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(firstFlag) !== 'object') return;
                var id = (_props = firstFlag.props) === null || _props === void 0 ? void 0 : _props.id;
                if (id === undefined || id === null || id === '') return;
                var analyticsEvent = latestRef.current.createAnalyticsEvent({
                    action: 'dismissed',
                    actionSubject: 'flag',
                    attributes: {
                        dismissedVia: 'keyboardShortcut',
                        key: 'Escape'
                    }
                });
                event.preventDefault();
                (_latestRef$current$on = (_latestRef$current = latestRef.current).onDismissed) === null || _latestRef$current$on === void 0 || _latestRef$current$on.call(_latestRef$current, id, analyticsEvent);
            }
        });
    }, [
        hasFlags
    ]);
    var renderChildren = function renderChildren() {
        return children && (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(children) === 'object' ? (0, $7fPBF.Children).map(children, function(flag, index) {
            var isDismissAllowed = index === 0;
            return (0, $137Lh.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ $7fPBF.createElement((0, $b8865657e1570469$export$2e2bcd8739ae039), {
                xcss: (0, $e636b2257db42c06$export$a274e22fb40f762e)($99322f445ba7cde3$var$groupStylesNew.root, index === 0 && $99322f445ba7cde3$var$groupStylesNew.first, index === 1 && $99322f445ba7cde3$var$groupStylesNew.second, index >= 2 && $99322f445ba7cde3$var$groupStylesNew.nth, index >= 3 && $99322f445ba7cde3$var$groupStylesNew.hidden),
                "data-vc-oob": true
            }, /*#__PURE__*/ $7fPBF.createElement((0, $ada36c25659d67df$export$2e2bcd8739ae039), {
                enteringAnimation: "var(--ds-flag-enter, 250ms cubic-bezier(0, 0.4, 0, 1) SlideIn50PercentLeft, 250ms cubic-bezier(0, 0.4, 0, 1) FadeIn0to100)",
                exitingAnimation: "var(--ds-flag-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOut15PercentLeft, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
            }, /*#__PURE__*/ $7fPBF.createElement($99322f445ba7cde3$export$c57ba665aaa722be.Provider, {
                value: // Only the first flag should be able to be dismissed.
                isDismissAllowed ? dismissFlagContext : $99322f445ba7cde3$var$defaultFlagGroupContext
            }, flag))) : /*#__PURE__*/ $7fPBF.createElement((0, $40f3b8b015f253a5$export$2e2bcd8739ae039), {
                enterFrom: "left",
                fade: "inout",
                duration: "medium",
                animationTimingFunction: "ease-in"
            }, function(_ref) {
                var className = _ref.className, ref = _ref.ref;
                return /*#__PURE__*/ $7fPBF.createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $heZxp.default)([
                        $99322f445ba7cde3$var$groupStyles.root,
                        index === 0 && $99322f445ba7cde3$var$groupStyles.first,
                        index === 1 && $99322f445ba7cde3$var$groupStyles.second,
                        index >= 1 && $99322f445ba7cde3$var$groupStyles.nth,
                        index >= 2 && $99322f445ba7cde3$var$groupStyles.hidden,
                        isDismissAllowed && "_12a7luct",
                        className
                    ]),
                    ref: ref,
                    "data-vc-oob": true
                }, /*#__PURE__*/ $7fPBF.createElement($99322f445ba7cde3$export$c57ba665aaa722be.Provider, {
                    value: // Only the first flag should be able to be dismissed.
                    isDismissAllowed ? dismissFlagContext : $99322f445ba7cde3$var$defaultFlagGroupContext
                }, flag));
            });
        }) : false;
    };
    var isKeyboardDismissEnabled = (0, $137Lh.fg)('platform_dst_flag_keyboard_dismiss');
    // When the keyboard dismiss shortcut is available, surface it to assistive
    // technology users via the existing visually-hidden landmark heading so they
    // know they can press Escape to dismiss the topmost flag.
    var screenReaderLabel = isKeyboardDismissEnabled ? "".concat(label, ". Press Escape to dismiss.") : label;
    var flags = /*#__PURE__*/ $7fPBF.createElement("div", {
        id: id,
        "data-vc-oob": true,
        className: (0, $heZxp.default)([
            "_kqsw1n9t _1pbyxejw _u7cooahv _1e021epz _1iafidpf _il0widpf"
        ])
    }, hasFlags ? /*#__PURE__*/ $7fPBF.createElement((0, $d1b9d01570e45f55$export$2e2bcd8739ae039), null, /*#__PURE__*/ $7fPBF.createElement(LabelTag, null, screenReaderLabel)) : null, /*#__PURE__*/ $7fPBF.createElement((0, $a1ad98f67aabe587$export$2e2bcd8739ae039), {
        appear: false
    }, renderChildren()));
    return shouldRenderToParent ? flags : /*#__PURE__*/ $7fPBF.createElement((0, $cd3bc8368572caba$export$2e2bcd8739ae039), {
        zIndex: (0, $c163cd89b0fadc16$export$7be255094ccdc533).flag()
    }, flags);
};
var $99322f445ba7cde3$export$2e2bcd8739ae039 = $99322f445ba7cde3$var$FlagGroup;


var $8919bc9e56107f4e$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, #FFFFFF)",
    info: "var(--ds-icon-inverse, #FFFFFF)",
    normal: "var(--ds-icon-subtle, #505258)",
    success: "var(--ds-icon-inverse, #FFFFFF)",
    warning: "var(--ds-icon-warning-inverse, #292A2E)"
};



var $7fPBF = parcelRequire("7fPBF");
var $186fdff88c3afb61$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($186fdff88c3afb61$exports, "__esModule", {
    value: true
});
$186fdff88c3afb61$exports.default = void 0;

var $186fdff88c3afb61$var$_react = $186fdff88c3afb61$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $186fdff88c3afb61$var$_baseNew = $186fdff88c3afb61$var$_interopRequireDefault((parcelRequire("f6lOK")));
function $186fdff88c3afb61$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $186fdff88c3afb61$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $186fdff88c3afb61$var$_react.default.createElement($186fdff88c3afb61$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$186fdff88c3afb61$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $186fdff88c3afb61$var$_default = $186fdff88c3afb61$exports.default = $186fdff88c3afb61$var$StatusErrorIcon;


var $fa5d928e9c6324b1$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::456639fbdc991aefe1af05acf697365d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($fa5d928e9c6324b1$exports, "__esModule", {
    value: true
});
$fa5d928e9c6324b1$exports.default = void 0;

var $fa5d928e9c6324b1$var$_react = $fa5d928e9c6324b1$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $fa5d928e9c6324b1$var$_baseNew = $fa5d928e9c6324b1$var$_interopRequireDefault((parcelRequire("f6lOK")));
function $fa5d928e9c6324b1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fa5d928e9c6324b1$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $fa5d928e9c6324b1$var$_react.default.createElement($fa5d928e9c6324b1$var$_baseNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$fa5d928e9c6324b1$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $fa5d928e9c6324b1$var$_default = $fa5d928e9c6324b1$exports.default = $fa5d928e9c6324b1$var$StatusInformationIcon;


var $62bf94bdf62f31e4$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($62bf94bdf62f31e4$exports, "__esModule", {
    value: true
});
$62bf94bdf62f31e4$exports.default = void 0;

var $62bf94bdf62f31e4$var$_react = $62bf94bdf62f31e4$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $62bf94bdf62f31e4$var$_baseNew = $62bf94bdf62f31e4$var$_interopRequireDefault((parcelRequire("f6lOK")));
function $62bf94bdf62f31e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $62bf94bdf62f31e4$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $62bf94bdf62f31e4$var$_react.default.createElement($62bf94bdf62f31e4$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$62bf94bdf62f31e4$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $62bf94bdf62f31e4$var$_default = $62bf94bdf62f31e4$exports.default = $62bf94bdf62f31e4$var$StatusSuccessIcon;


var $c4e27e7a081af661$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee7b3f114c675eea0f953c33a485bcf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($c4e27e7a081af661$exports, "__esModule", {
    value: true
});
$c4e27e7a081af661$exports.default = void 0;

var $c4e27e7a081af661$var$_react = $c4e27e7a081af661$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $c4e27e7a081af661$var$_baseNew = $c4e27e7a081af661$var$_interopRequireDefault((parcelRequire("f6lOK")));
function $c4e27e7a081af661$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c4e27e7a081af661$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $c4e27e7a081af661$var$_react.default.createElement($c4e27e7a081af661$var$_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$c4e27e7a081af661$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $c4e27e7a081af661$var$_default = $c4e27e7a081af661$exports.default = $c4e27e7a081af661$var$StatusWarningIcon;


var $f3dc31fb69a246b3$export$73f08aee70487cd4 = {
    error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($186fdff88c3afb61$exports))), {
        label: ""
    }),
    info: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fa5d928e9c6324b1$exports))), {
        label: ""
    }),
    normal: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fa5d928e9c6324b1$exports))), {
        label: ""
    }),
    success: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($62bf94bdf62f31e4$exports))), {
        label: ""
    }),
    warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c4e27e7a081af661$exports))), {
        label: ""
    })
};


var $ed4499ac0a1dabb8$export$f50075b2584087f = {
    error: 'color.text.inverse',
    info: 'color.text.inverse',
    normal: 'color.text',
    success: 'color.text.inverse',
    warning: 'color.text.warning.inverse'
};


var $db0839dfa06eaa79$export$13b42cd9d596bfe0 = {
    error: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    normal: "var(--ds-text, #292A2E)",
    success: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text-warning-inverse, #292A2E)"
};




var $7fPBF = parcelRequire("7fPBF");


var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");



var $iKdEz = parcelRequire("iKdEz");

var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");


/**
 * An empty function which does nothing.
 */ function $2c09f83bdc18fd04$export$2e2bcd8739ae039() {}



var $7fPBF = parcelRequire("7fPBF");

/**
 * Character key codes which can be used in keyboard events.
 */ var $11de6bfa0a8b51ba$export$390330c10ff2b9a1 = 'ArrowUp';
var $11de6bfa0a8b51ba$export$a80636c6f41931fe = 'ArrowDown';
var $11de6bfa0a8b51ba$export$fc4577f2a2af0ae3 = 'ArrowLeft';
var $11de6bfa0a8b51ba$export$c40f9845adc73fb5 = 'ArrowRight';
var $11de6bfa0a8b51ba$export$4af703091671bc = 'Home';
var $11de6bfa0a8b51ba$export$e2bc30913faa5db7 = 'End';
var $11de6bfa0a8b51ba$export$10f6869ed0a7d75b = 'Tab';
var $11de6bfa0a8b51ba$export$8152f929a25a0ff4 = 'Enter';
var $11de6bfa0a8b51ba$export$e51a3576c045c8d5 = 'Space';
var $11de6bfa0a8b51ba$export$2bb790b9008907b4 = 'Escape';


function $ebfda7a81fcf0bee$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $7fPBF.useRef)(false);
    var onKeyDown = (0, $7fPBF.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $11de6bfa0a8b51ba$export$2bb790b9008907b4)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $7fPBF.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $7fPBF.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $a091c25729a976b1$exports.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}



var $7fPBF = parcelRequire("7fPBF");
function $94f256a0a6952cce$export$2e2bcd8739ae039(value) {
    var ref = (0, $7fPBF.useRef)(value);
    (0, $7fPBF.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $1e2fa2f25d476636$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $2e94b0cb63e892d4$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $7fPBF.createContext)(null);


function $a4780e0f49ffd0ad$export$1d57e79091cc3046() {
    var namespace = (0, $7fPBF.useContext)((0, $2e94b0cb63e892d4$export$644a49f3b8c50fcd));
    return namespace;
}


function $ff62b6af835b4735$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $7fPBF.useContext)((0, $1e2fa2f25d476636$export$5fbf4d7fae6cdc00));
    var namespace = (0, $a4780e0f49ffd0ad$export$1d57e79091cc3046)();
    (0, $7fPBF.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $a40c01a844955f0d$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $a40c01a844955f0d$var$ExitingContext = /*#__PURE__*/ (0, $7fPBF.createContext)($a40c01a844955f0d$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $a40c01a844955f0d$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a40c01a844955f0d$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($a40c01a844955f0d$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $a40c01a844955f0d$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $7fPBF.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $a40c01a844955f0d$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $a40c01a844955f0d$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $a40c01a844955f0d$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $a40c01a844955f0d$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $a40c01a844955f0d$var$ExitingPersistence = /*#__PURE__*/ (0, $7fPBF.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $7fPBF.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $7fPBF.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $7fPBF.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $a40c01a844955f0d$var$childrenToArray(previousChildren);
    var current = $a40c01a844955f0d$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $a40c01a844955f0d$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $a40c01a844955f0d$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $137Lh.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $a40c01a844955f0d$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $a40c01a844955f0d$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $a40c01a844955f0d$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $7fPBF.useContext)($a40c01a844955f0d$var$ExitingContext);
};
$a40c01a844955f0d$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $a40c01a844955f0d$export$2e2bcd8739ae039 = $a40c01a844955f0d$var$ExitingPersistence;


var $7fPBF = parcelRequire("7fPBF");
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $f41f201ca78a311a$var$ATOMIC_GROUP_LENGTH = 5;
function $f41f201ca78a311a$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $f41f201ca78a311a$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $8281b70c38672050$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $8281b70c38672050$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$8281b70c38672050$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $8281b70c38672050$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $7fPBF.useState)($8281b70c38672050$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $7fPBF.useEffect)(function() {
        if (!$8281b70c38672050$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $a091c25729a976b1$exports.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $8281b70c38672050$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $8281b70c38672050$export$ff7706047246b98b = function prefersReducedMotion() {
    return $8281b70c38672050$export$f0f789643ba5a83c;
};


/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $5f096291e16d03b1$export$368bacef0dacbe05 = 25;
var $5f096291e16d03b1$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $5f096291e16d03b1$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $5f096291e16d03b1$export$30fa1a2e62ae150c = {
    none: $5f096291e16d03b1$export$38b928a7167ce124.none,
    small: $5f096291e16d03b1$export$38b928a7167ce124.small * $5f096291e16d03b1$var$EXITING_MOTION_MULTIPLIER,
    medium: $5f096291e16d03b1$export$38b928a7167ce124.medium * $5f096291e16d03b1$var$EXITING_MOTION_MULTIPLIER,
    large: $5f096291e16d03b1$export$38b928a7167ce124.large * $5f096291e16d03b1$var$EXITING_MOTION_MULTIPLIER
};



var $7fPBF = parcelRequire("7fPBF");
// Handle both browser and Node.js environments
var $9007158fc7485c1e$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $9007158fc7485c1e$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $7fPBF.useRef)([]);
    (0, $7fPBF.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $9007158fc7485c1e$var$getHookDeps(opts));
    return (0, $7fPBF.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $9007158fc7485c1e$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $7fPBF.useRef)([]);
    (0, $7fPBF.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $9007158fc7485c1e$var$getHookDeps(opts));
    return (0, $7fPBF.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};




var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");
/**
 * An empty function which does nothing.
 */ function $92f01fea54e05dcf$export$2e2bcd8739ae039() {}



var $7fPBF = parcelRequire("7fPBF");
var $5b5d31c7a97cde50$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $7fPBF.useEffect) : (0, $7fPBF.useLayoutEffect);


/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $7fPBF = parcelRequire("7fPBF");
function $72df6cd713b78060$export$c485849f2e393253() {
    var identifier = (0, $7fPBF.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}


var $cb26f8db09b3d6b3$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $7fPBF.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $92f01fea54e05dcf$export$2e2bcd8739ae039)
    };
});
var $cb26f8db09b3d6b3$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $72df6cd713b78060$export$c485849f2e393253)();
    var context = (0, $7fPBF.useContext)($cb26f8db09b3d6b3$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $cb26f8db09b3d6b3$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $7fPBF.useRef)([]);
    var indexes = [];
    var _useState = (0, $7fPBF.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $5b5d31c7a97cde50$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($cb26f8db09b3d6b3$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $cb26f8db09b3d6b3$export$2e2bcd8739ae039 = $cb26f8db09b3d6b3$var$StaggeredEntrance;


var $d8086a479a477310$var$zoomIn = null;
var $d8086a479a477310$var$zoomOut = null;
var $d8086a479a477310$var$fadeIn = null;
var $d8086a479a477310$var$fadeOut = null;
var $d8086a479a477310$var$fadeInFromTop = null;
var $d8086a479a477310$var$fadeOutFromTop = null;
var $d8086a479a477310$var$fadeInFromLeft = null;
var $d8086a479a477310$var$fadeOutFromLeft = null;
var $d8086a479a477310$var$fadeInFromBottom = null;
var $d8086a479a477310$var$fadeOutFromBottom = null;
var $d8086a479a477310$var$fadeInFromRight = null;
var $d8086a479a477310$var$fadeOutFromRight = null;
var $d8086a479a477310$var$fadeInFromTopConstant = null;
var $d8086a479a477310$var$fadeOutFromTopConstant = null;
var $d8086a479a477310$var$fadeInFromLeftConstant = null;
var $d8086a479a477310$var$fadeOutFromLeftConstant = null;
var $d8086a479a477310$var$fadeInFromBottomConstant = null;
var $d8086a479a477310$var$fadeOutFromBottomConstant = null;
var $d8086a479a477310$var$fadeInFromRightConstant = null;
var $d8086a479a477310$var$fadeOutFromRightConstant = null;
var $d8086a479a477310$var$slideInFromTop = null;
var $d8086a479a477310$var$slideOutFromTop = null;
var $d8086a479a477310$var$slideInFromRight = null;
var $d8086a479a477310$var$slideOutFromRight = null;
var $d8086a479a477310$var$slideInFromBottom = null;
var $d8086a479a477310$var$slideOutFromBottom = null;
var $d8086a479a477310$var$slideInFromLeft = null;
var $d8086a479a477310$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $d8086a479a477310$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $cb26f8db09b3d6b3$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $a40c01a844955f0d$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $9007158fc7485c1e$export$4f34107a2b00f39c)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $7fPBF.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $7fPBF.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $8281b70c38672050$export$b7baf7667a68d87c)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $5f096291e16d03b1$export$30fa1a2e62ae150c)[duration] : (0, $5f096291e16d03b1$export$38b928a7167ce124)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
            (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $d8086a479a477310$export$2e2bcd8739ae039 = $d8086a479a477310$var$EnteringMotion;


var $a17413f6f2903b07$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $a17413f6f2903b07$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $a17413f6f2903b07$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d8086a479a477310$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $a17413f6f2903b07$export$2e2bcd8739ae039 = $a17413f6f2903b07$var$FadeIn;



var $137Lh = parcelRequire("137Lh");


/* eslint-disable no-console */ var $7b26725ae6f3d9c2$var$printed = {};
function $7b26725ae6f3d9c2$export$2e2bcd8739ae039(message) {
    if ($7b26725ae6f3d9c2$var$printed[message]) return;
    $7b26725ae6f3d9c2$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}


function $c029f044296a2259$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $7b26725ae6f3d9c2$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $c029f044296a2259$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {}


// Reds
var $21a948a40df12954$export$4b84fd0e2c617bd = '#FFEBE6';
var $21a948a40df12954$export$b34b069eff244586 = '#FFBDAD';
var $21a948a40df12954$export$be802dd0d8b57f35 = '#FF8F73';
var $21a948a40df12954$export$60847d42f9da92a6 = '#FF7452';
var $21a948a40df12954$export$4a7404f376229999 = '#FF5630';
var $21a948a40df12954$export$2010d0fb4295b346 = '#DE350B';
var $21a948a40df12954$export$2837b5a1a71d5c02 = '#BF2600';
var $21a948a40df12954$export$8d9596b529bbb9cf = '#FFFAE6';
var $21a948a40df12954$export$41060a744ab0b7ae = '#FFF0B3';
var $21a948a40df12954$export$1cc05bbbf340e559 = '#FFE380';
var $21a948a40df12954$export$5aae31392d72caaa = '#FFC400';
var $21a948a40df12954$export$c6930421db9fa514 = '#FFAB00';
var $21a948a40df12954$export$59619663aa6500fb = '#FF991F';
var $21a948a40df12954$export$874739ea9e379ab6 = '#FF8B00';
var $21a948a40df12954$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $21a948a40df12954$export$69a3bf21b9686c2b = '#ABF5D1';
var $21a948a40df12954$export$afbce1382ec95f73 = '#79F2C0';
var $21a948a40df12954$export$747d86715d4175de = '#57D9A3';
var $21a948a40df12954$export$940e1f69e873f202 = '#36B37E';
var $21a948a40df12954$export$a49394138f7b8e85 = '#00875A';
var $21a948a40df12954$export$6fa04827ac68a4fb = '#006644';
var $21a948a40df12954$export$226de0355ed012f8 = '#DEEBFF';
var $21a948a40df12954$export$8c13c2ee36917869 = '#B3D4FF';
var $21a948a40df12954$export$ecfc1dff386a3e7a = '#4C9AFF';
var $21a948a40df12954$export$215b7063051591f1 = '#2684FF';
var $21a948a40df12954$export$e62e8919cca44969 = '#0065FF';
var $21a948a40df12954$export$b3de0ae08da2ce64 = '#0052CC';
var $21a948a40df12954$export$a6ee3d71bc067634 = '#0747A6';
var $21a948a40df12954$export$67f15409e87642a1 = '#669DF1';
var $21a948a40df12954$export$f0539dbc42dbb067 = '#8FB8F6';
var $21a948a40df12954$export$363e4475840015bb = '#EAE6FF';
var $21a948a40df12954$export$4b0a4417ed59760f = '#C0B6F2';
var $21a948a40df12954$export$6011520a64d9a187 = '#998DD9';
var $21a948a40df12954$export$a7175d4e9206bc80 = '#8777D9';
var $21a948a40df12954$export$b48405b95304b5a1 = '#6554C0';
var $21a948a40df12954$export$c71e4279dd54a18d = '#5243AA';
var $21a948a40df12954$export$147899de772240ec = '#403294';
var $21a948a40df12954$export$2cf711fe14c66f06 = '#E6FCFF';
var $21a948a40df12954$export$7a8f4d33f6f9772c = '#B3F5FF';
var $21a948a40df12954$export$776c9c497ef08533 = '#79E2F2';
var $21a948a40df12954$export$69cb3ca10c1e330e = '#00C7E6';
var $21a948a40df12954$export$9dc1ef0f3f48059b = '#00B8D9';
var $21a948a40df12954$export$7c835c78b6fcdef8 = '#00A3BF';
var $21a948a40df12954$export$6036577f95c3877e = '#008DA6';
var $21a948a40df12954$export$29a4f05edc054374 = '#FFFFFF';
var $21a948a40df12954$export$e655ef011c4aa1a2 = '#FAFBFC';
var $21a948a40df12954$export$9fdfb749e33cdf97 = '#F4F5F7';
var $21a948a40df12954$export$3e51e8f1440314ba = '#EBECF0';
var $21a948a40df12954$export$1ce2d1575d444ceb = '#DFE1E6';
var $21a948a40df12954$export$8754fc7e6d8b3000 = '#C1C7D0';
var $21a948a40df12954$export$c2e91cbeada39b8b = '#B3BAC5';
var $21a948a40df12954$export$5f71e19f3a7ad9de = '#A5ADBA';
var $21a948a40df12954$export$eaa8c8a70ac22806 = '#97A0AF';
var $21a948a40df12954$export$7c87d337fb91a97d = '#8993A4';
var $21a948a40df12954$export$d6447c357493214f = '#7A869A';
var $21a948a40df12954$export$f563ee71e9ee74cd = '#6B778C';
var $21a948a40df12954$export$e2ef2124cf4024b1 = '#5E6C84';
var $21a948a40df12954$export$eece5f492e429f08 = '#505F79';
var $21a948a40df12954$export$c39c0fe0f26207ae = '#42526E';
var $21a948a40df12954$export$7090862dc3038a9f = '#344563';
var $21a948a40df12954$export$ad0bacf983b7ddaa = '#253858';
var $21a948a40df12954$export$7d61b15e0da132af = '#172B4D';
var $21a948a40df12954$export$fbda843f0a27fe96 = '#091E42';
var $21a948a40df12954$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $21a948a40df12954$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $21a948a40df12954$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $21a948a40df12954$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $21a948a40df12954$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $21a948a40df12954$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $21a948a40df12954$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $21a948a40df12954$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $21a948a40df12954$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $21a948a40df12954$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $21a948a40df12954$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $21a948a40df12954$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $21a948a40df12954$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $21a948a40df12954$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $21a948a40df12954$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $21a948a40df12954$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $21a948a40df12954$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $21a948a40df12954$export$2f6319cf7d736c2a = '#E6EDFA';
var $21a948a40df12954$export$95126bc8884d6634 = '#DCE5F5';
var $21a948a40df12954$export$8338d8c35d44ff1 = '#CED9EB';
var $21a948a40df12954$export$5368d76ae4fbbda7 = '#B8C7E0';
var $21a948a40df12954$export$9f0a771d16ec8d36 = '#ABBBD6';
var $21a948a40df12954$export$abcf8c38338b4aa5 = '#9FB0CC';
var $21a948a40df12954$export$97e81faa16a182c7 = '#8C9CB8';
var $21a948a40df12954$export$bfe21c59123ecf33 = '#7988A3';
var $21a948a40df12954$export$ee82aa2ea6a1558 = '#67758F';
var $21a948a40df12954$export$682927c6ed76be02 = '#56637A';
var $21a948a40df12954$export$91fd9994c5be9757 = '#455166';
var $21a948a40df12954$export$d281fbfe3cff2df6 = '#3B475C';
var $21a948a40df12954$export$3902c91d8b98a753 = '#313D52';
var $21a948a40df12954$export$8e8133c1ba5845b5 = '#283447';
var $21a948a40df12954$export$33ff357f6620b39 = '#202B3D';
var $21a948a40df12954$export$633847cf062b69e0 = '#1B2638';
var $21a948a40df12954$export$9776a6e503bdbf76 = '#121A29';
var $21a948a40df12954$export$6c813d5160dff5db = '#0E1624';
var $21a948a40df12954$export$3d4f271a500072a = '#0D1424';
var $21a948a40df12954$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $21a948a40df12954$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $21a948a40df12954$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $21a948a40df12954$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $21a948a40df12954$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $21a948a40df12954$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $21a948a40df12954$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $21a948a40df12954$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $21a948a40df12954$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $21a948a40df12954$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $21a948a40df12954$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $21a948a40df12954$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $21a948a40df12954$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $21a948a40df12954$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $21a948a40df12954$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $21a948a40df12954$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $21a948a40df12954$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $21a948a40df12954$export$d2adc5dedf09fced = '#292A2E';
var $21a948a40df12954$export$f51762073d2bb381 = '#94C748';
var $21a948a40df12954$export$95e26d54def96891 = '#B3DF72';


var $666109d1a796f30c$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $666109d1a796f30c$export$c93026a968943f95 = 'light';
var $666109d1a796f30c$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $666109d1a796f30c$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $21a948a40df12954$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    (0, $c029f044296a2259$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $666109d1a796f30c$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $666109d1a796f30c$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $666109d1a796f30c$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $c029f044296a2259$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $666109d1a796f30c$export$ba1d834b86d72a09 = $666109d1a796f30c$export$a1b3edb637fb4f35;
var $666109d1a796f30c$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $21a948a40df12954$export$8d43898f60b96a82), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $21a948a40df12954$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $21a948a40df12954$export$920c0d5c49070351), ")")
            }
        }
    };
};


/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $a0c83a6575a44601$var$registrations = new Set();
var $a0c83a6575a44601$var$cleanupEndEventListeners = null;
function $a0c83a6575a44601$var$onDragStart() {
    if ($a0c83a6575a44601$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $a0c83a6575a44601$var$cleanupEndEventListeners = (0, $a091c25729a976b1$exports.bindAll)(window, [
        {
            type: 'dragend',
            listener: $a0c83a6575a44601$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $a0c83a6575a44601$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $a0c83a6575a44601$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($a0c83a6575a44601$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $a0c83a6575a44601$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $a0c83a6575a44601$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $a0c83a6575a44601$var$cleanupEndEventListeners = null;
    var clone = Array.from($a0c83a6575a44601$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $a0c83a6575a44601$var$bindStartEvents() {
    return (0, $a091c25729a976b1$exports.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $a0c83a6575a44601$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $a0c83a6575a44601$var$onDragStart
        }
    ]);
}
var $a0c83a6575a44601$var$cleanupStartEventListeners = null;
function $a0c83a6575a44601$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$a0c83a6575a44601$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $a0c83a6575a44601$var$cleanupStartEventListeners = $a0c83a6575a44601$var$bindStartEvents();
    $a0c83a6575a44601$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $a0c83a6575a44601$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $a0c83a6575a44601$var$registrations.delete(registration);
        if ($a0c83a6575a44601$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $a0c83a6575a44601$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $a0c83a6575a44601$var$cleanupStartEventListeners = null;
        }
    };
}


function $9c5b0c52a9efffec$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}


function $b0a199abc0c605e8$export$2e68479e0a5d8746(mousePos, _ref) {
    var targetElement = _ref.targetElement, tooltipPosition = _ref.tooltipPosition;
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            });
        }
    };
    var targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            });
        }
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            });
        }
    };
    throw new Error("Invalid tooltip position for virtual element: ".concat(tooltipPosition));
}



var $137Lh = parcelRequire("137Lh");
var $7d90cb9a2b8bcf06$var$delayId = null;
function $7d90cb9a2b8bcf06$export$eaf678f6f93f5250() {
    if ($7d90cb9a2b8bcf06$var$delayId != null) {
        window.clearTimeout($7d90cb9a2b8bcf06$var$delayId);
        $7d90cb9a2b8bcf06$var$delayId = null;
    }
}
function $7d90cb9a2b8bcf06$export$5f4d6617421d489b(fn, delay) {
    $7d90cb9a2b8bcf06$export$eaf678f6f93f5250();
    $7d90cb9a2b8bcf06$var$delayId = window.setTimeout(function() {
        $7d90cb9a2b8bcf06$var$delayId = null;
        fn();
    }, delay);
}


// This file is a singleton for managing tooltips
var $ff0c3a86830deb4e$var$active = null;
function $ff0c3a86830deb4e$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($ff0c3a86830deb4e$var$active && $ff0c3a86830deb4e$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $7d90cb9a2b8bcf06$export$eaf678f6f93f5250)();
            $ff0c3a86830deb4e$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $7d90cb9a2b8bcf06$export$eaf678f6f93f5250)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $7d90cb9a2b8bcf06$export$eaf678f6f93f5250)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $7d90cb9a2b8bcf06$export$5f4d6617421d489b)(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        var shouldAlwaysFadeIn = (0, $137Lh.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? entry.shouldAlwaysFadeIn : false;
        var showImmediately = Boolean($ff0c3a86830deb4e$var$active && $ff0c3a86830deb4e$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($ff0c3a86830deb4e$var$active) {
            (0, $7d90cb9a2b8bcf06$export$eaf678f6f93f5250)();
            $ff0c3a86830deb4e$var$active.entry.hide({
                isImmediate: true
            });
            $ff0c3a86830deb4e$var$active.entry.done();
            $ff0c3a86830deb4e$var$active = null;
        }
        // this tooltip is now the active tooltip
        $ff0c3a86830deb4e$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $7d90cb9a2b8bcf06$export$5f4d6617421d489b)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        // Removing old `mousePosition` behind gate because it stored a function.
        // With the gate we just store the coords which are easier to work with.
        mousePosition: (0, $137Lh.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? undefined : getInitialMouse(),
        mousePos: entry.source.type === 'mouse' && (0, $137Lh.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}



var $bRUy3 = parcelRequire("bRUy3");

var $7fPBF = parcelRequire("7fPBF");
function $17634375c18f2c41$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useId().replace(/[:«»]/g, '_');
}
var $17634375c18f2c41$export$6be90bcb437e928f = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($17634375c18f2c41$export$f680877a34711e37()).concat(postfix);
    (0, $7fPBF.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $17634375c18f2c41$export$6ee17796e3d70de2() {
    var uid = $17634375c18f2c41$export$f680877a34711e37();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}


function $ab58f7c296e0acd2$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $17634375c18f2c41$export$6ee17796e3d70de2)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}


/* tooltip-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $07d4e155814e3836$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
var $07d4e155814e3836$export$5bcbc43c84236222 = function TooltipShortcut(_ref) {
    var shortcut = _ref.shortcut;
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        className: (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
            $07d4e155814e3836$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map(function(segment, index) {
        return /*#__PURE__*/ $7fPBF.createElement("kbd", {
            key: "".concat(segment, "-").concat(index),
            className: (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
                $07d4e155814e3836$var$styles.shortcutSegment
            ])
        }, segment);
    }));
};


var $7aef038b30222afd$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $7aef038b30222afd$var$TooltipPrimitive = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $7fPBF.createElement("div", {
        role: "tooltip",
        className: (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && /*#__PURE__*/ $7fPBF.createElement((0, $07d4e155814e3836$export$5bcbc43c84236222), {
        shortcut: shortcut
    })));
});
$7aef038b30222afd$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $7aef038b30222afd$export$2e2bcd8739ae039 = $7aef038b30222afd$var$TooltipPrimitive;


var $bc1d94d48c463334$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $bc1d94d48c463334$var$TooltipContainer = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $7fPBF.createElement((0, $7aef038b30222afd$export$2e2bcd8739ae039), {
        ref: ref,
        style: style,
        className: (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
            $bc1d94d48c463334$var$styles.base,
            truncate && $bc1d94d48c463334$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut
    }, children);
});
$bc1d94d48c463334$var$TooltipContainer.displayName = 'TooltipContainer';
var $bc1d94d48c463334$export$2e2bcd8739ae039 = $bc1d94d48c463334$var$TooltipContainer;


function $98c1607276079bd8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $98c1607276079bd8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $98c1607276079bd8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $98c1607276079bd8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $98c1607276079bd8$var$tooltipZIndex = (0, $666109d1a796f30c$export$7be255094ccdc533).tooltip();
var $98c1607276079bd8$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "21.1.1"
};
// Inverts motion direction
var $98c1607276079bd8$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $98c1607276079bd8$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $98c1607276079bd8$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $bc1d94d48c463334$export$2e2bcd8739ae039) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $2c09f83bdc18fd04$export$2e2bcd8739ae039) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $2c09f83bdc18fd04$export$2e2bcd8739ae039) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn, shortcut = _ref.shortcut, _ref$UNSAFE_shouldAlw = _ref.UNSAFE_shouldAlwaysFadeIn, shouldAlwaysFadeIn = _ref$UNSAFE_shouldAlw === void 0 ? false : _ref$UNSAFE_shouldAlw, _ref$UNSAFE_shouldRen = _ref.UNSAFE_shouldRenderToParent, UNSAFE_shouldRenderToParent = _ref$UNSAFE_shouldRen === void 0 ? false : _ref$UNSAFE_shouldRen;
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    var isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    var tooltipPosition = isMousePosition ? mousePosition : position;
    var onShowHandler = (0, $bf339b74c053cf86$export$1a04351537078b55)($98c1607276079bd8$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $98c1607276079bd8$var$analyticsAttributes));
    var onHideHandler = (0, $bf339b74c053cf86$export$1a04351537078b55)($98c1607276079bd8$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $98c1607276079bd8$var$analyticsAttributes));
    var apiRef = (0, $7fPBF.useRef)(null);
    var _useState = (0, $7fPBF.useState)('hide'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $7fPBF.useRef)(null);
    var containerRef = (0, $7fPBF.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $7fPBF.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $94f256a0a6952cce$export$2e2bcd8739ae039)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $94f256a0a6952cce$export$2e2bcd8739ae039)(onShowHandler);
    var onHideHandlerStable = (0, $94f256a0a6952cce$export$2e2bcd8739ae039)(onHideHandler);
    var delayStable = (0, $94f256a0a6952cce$export$2e2bcd8739ae039)(delay);
    var canAppearStable = (0, $94f256a0a6952cce$export$2e2bcd8739ae039)(canAppear);
    var hasCalledShowHandler = (0, $7fPBF.useRef)(false);
    var shouldAlwaysFadeInStable = (0, $94f256a0a6952cce$export$2e2bcd8739ae039)(shouldAlwaysFadeIn);
    var start = (0, $7fPBF.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $7fPBF.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $7fPBF.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $7fPBF.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $7fPBF.useRef)(false);
    (0, $7fPBF.useEffect)(function() {
        return (0, $a0c83a6575a44601$export$6503ec6e8aabbaf)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $7fPBF.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: (0, $137Lh.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? shouldAlwaysFadeInStable.current : false
        };
        var api = (0, $ff0c3a86830deb4e$export$57bf213be019eeb0)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    var hideTooltipOnEsc = (0, $7fPBF.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $ebfda7a81fcf0bee$export$2e2bcd8739ae039)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $7fPBF.useEffect)(function() {
        if (state === 'hide') return 0, $2c09f83bdc18fd04$export$2e2bcd8739ae039;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $a091c25729a976b1$exports.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $7fPBF.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $7fPBF.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $7fPBF.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = isMousePosition ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            // Removing old `mouse` behind gate because it stored a function.
            // With the gate we just store the coords which are easier to work with.
            mouse: (0, $137Lh.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? undefined : (0, $9c5b0c52a9efffec$export$642213d516a9b928)({
                left: event.clientX,
                top: event.clientY
            }),
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $7fPBF.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = isMousePosition ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) {
            if (!(0, $137Lh.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) apiRef.current.mousePosition = (0, $9c5b0c52a9efffec$export$642213d516a9b928)({
                left: event.clientX,
                top: event.clientY
            });
            apiRef.current.mousePos = {
                clientX: event.clientX,
                clientY: event.clientY
            };
        }
    } : undefined;
    var onMouseOverTooltip = (0, $7fPBF.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $7fPBF.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch (_unused) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $7fPBF.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $7fPBF.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    var handleOpenLayerObserverCloseSignal = (0, $7fPBF.useCallback)(function() {
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $ff62b6af835b4735$export$469bb693f11edc7f)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current5, _apiRef$current6;
        if (isMousePosition && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePos && targetRef.current && (0, $137Lh.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) return (0, $b0a199abc0c605e8$export$2e68479e0a5d8746)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        if (isMousePosition && (_apiRef$current6 = apiRef.current) !== null && _apiRef$current6 !== void 0 && _apiRef$current6.mousePosition && !(0, $137Lh.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) {
            var _apiRef$current7;
            return (_apiRef$current7 = apiRef.current) === null || _apiRef$current7 === void 0 ? void 0 : _apiRef$current7.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $ab58f7c296e0acd2$export$2e2bcd8739ae039)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // Adding `data-testid` to the TriggerProps interface breaks Buttons, so we use type assertion
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $7fPBF.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    var PopperWrapper = UNSAFE_shouldRenderToParent && (0, $137Lh.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? (0, $7fPBF.Fragment) : $98c1607276079bd8$var$TooltipPortal;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, children($98c1607276079bd8$var$_objectSpread($98c1607276079bd8$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(PopperWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e8027c477e280fef$export$badac9ada3a0bdf9), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = isMousePosition ? undefined : $98c1607276079bd8$var$invertedDirection[$98c1607276079bd8$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a40c01a844955f0d$export$2e2bcd8739ae039), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a17413f6f2903b07$export$2e2bcd8739ae039), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $98c1607276079bd8$var$_objectSpread($98c1607276079bd8$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $98c1607276079bd8$export$2e2bcd8739ae039 = $98c1607276079bd8$var$Tooltip;
var $98c1607276079bd8$var$TooltipPortal = function TooltipPortal(_ref7) {
    var children = _ref7.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd3bc8368572caba$export$2e2bcd8739ae039), {
        zIndex: $98c1607276079bd8$var$tooltipZIndex
    }, children);
};



/* button-base.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");


var $7fPBF = parcelRequire("7fPBF");





var $137Lh = parcelRequire("137Lh");
/* pressable.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");


const $fd31d9b61ebc564e$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $f41f201ca78a311a$export$2e2bcd8739ae039)(actualStyles);
};






/* focusable.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $9458eb44c5507916$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $9458eb44c5507916$var$_excluded2 = [
    "className"
];
var $9458eb44c5507916$var$focusRingStyles = null;
var $9458eb44c5507916$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $9458eb44c5507916$var$Focusable = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $9458eb44c5507916$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $9458eb44c5507916$var$_excluded2);
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $9458eb44c5507916$export$2e2bcd8739ae039 = $9458eb44c5507916$var$Focusable;


var $1ca1b739effc03fb$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $1ca1b739effc03fb$var$_excluded2 = [
    "className"
];
var $1ca1b739effc03fb$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $1ca1b739effc03fb$var$Pressable = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $f48d740006cf3f7d$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $1ca1b739effc03fb$var$_excluded);
    var interactionContext = (0, $7fPBF.useContext)((0, $48ec410b84640600$export$2e2bcd8739ae039));
    var handleClick = (0, $7fPBF.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $593ac790924c31ca$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "19.0.0",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $1ca1b739effc03fb$var$_excluded2);
    return /*#__PURE__*/ $7fPBF.createElement((0, $9458eb44c5507916$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $bf96b6408e362ed6$export$95df08bae54cb4df)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $fd31d9b61ebc564e$export$a274e22fb40f762e)($1ca1b739effc03fb$var$styles.root, isDisabled && $1ca1b739effc03fb$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $1ca1b739effc03fb$export$2e2bcd8739ae039 = $1ca1b739effc03fb$var$Pressable;



/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $7fPBF = parcelRequire("7fPBF");
var $74a8890cc9ccd165$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);



var $7fPBF = parcelRequire("7fPBF");

var $38f312eb60699802$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $7fPBF.useContext)((0, $74a8890cc9ccd165$export$4b86304b2c0d7e71));
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};


function $d5687ecff45b6a4f$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $d5687ecff45b6a4f$var$tabKeyCode = 9;
function $d5687ecff45b6a4f$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $d5687ecff45b6a4f$var$tabKeyCode) return;
    $d5687ecff45b6a4f$var$abort(event);
}
function $d5687ecff45b6a4f$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $d5687ecff45b6a4f$var$abort,
        onMouseUpCapture: $d5687ecff45b6a4f$var$abort,
        onKeyDownCapture: $d5687ecff45b6a4f$var$onKey,
        onKeyUpCapture: $d5687ecff45b6a4f$var$onKey,
        onTouchStartCapture: $d5687ecff45b6a4f$var$abort,
        onTouchEndCapture: $d5687ecff45b6a4f$var$abort,
        onPointerDownCapture: $d5687ecff45b6a4f$var$abort,
        onPointerUpCapture: $d5687ecff45b6a4f$var$abort,
        onClickCapture: $d5687ecff45b6a4f$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $d5687ecff45b6a4f$var$abort
    } : events;
}



var $7fPBF = parcelRequire("7fPBF");

function $c8ad3c74d065482c$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $c8ad3c74d065482c$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $c8ad3c74d065482c$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $aacfdd39b28e059d$export$2e2bcd8739ae039), {
        size: $c8ad3c74d065482c$var$getIconSpacing(spacing),
        appearance: $c8ad3c74d065482c$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}


var $2f27420929ef9635$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $2f27420929ef9635$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $2f27420929ef9635$var$LOADING_LABEL = ', Loading';
var $2f27420929ef9635$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhkby5v _irr3by5v _1di6by5v",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    spacingCompactT26Shape: "_2rko12b0",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $2f27420929ef9635$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $2f27420929ef9635$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
var $2f27420929ef9635$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _9h8h1yd3",
    interactive: "_30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
var $2f27420929ef9635$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
var $2f27420929ef9635$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
var $2f27420929ef9635$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $2f27420929ef9635$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $2f27420929ef9635$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
function(_ref, ref) {
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $2f27420929ef9635$var$_excluded);
    var localRef = (0, $7fPBF.useRef)(null);
    var splitButtonContext = (0, $38f312eb60699802$export$47e2c6fdb142d947)();
    var loadingLabelId = (0, $d4d502868e612e1e$export$f680877a34711e37)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $7ef5eb1b79d03b33$export$2e2bcd8739ae039)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(unsafeRest, $2f27420929ef9635$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1ca1b739effc03fb$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, saferRest, {
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $9ec85dcfc6117313$export$2e2bcd8739ae039)([
            localRef,
            ref
        ]),
        xcss: (0, $e636b2257db42c06$export$a274e22fb40f762e)($2f27420929ef9635$var$styles.base, (0, $137Lh.fg)('platform-dst-shape-theme-default') && $2f27420929ef9635$var$styles.baseT26Shape, appearance === 'default' && $2f27420929ef9635$var$defaultStyles.root, appearance === 'default' && isInteractive && $2f27420929ef9635$var$defaultStyles.interactive, appearance === 'primary' && $2f27420929ef9635$var$primaryStyles.root, appearance === 'primary' && isInteractive && $2f27420929ef9635$var$primaryStyles.interactive, appearance === 'warning' && $2f27420929ef9635$var$warningStyles.root, appearance === 'warning' && isInteractive && $2f27420929ef9635$var$warningStyles.interactive, appearance === 'danger' && $2f27420929ef9635$var$dangerStyles.root, appearance === 'danger' && isInteractive && $2f27420929ef9635$var$dangerStyles.interactive, appearance === 'discovery' && $2f27420929ef9635$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $2f27420929ef9635$var$discoveryStyles.interactive, appearance === 'subtle' && $2f27420929ef9635$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $2f27420929ef9635$var$subtleStyles.interactive, $2f27420929ef9635$var$styles.linkDecorationUnset, isSelected && $2f27420929ef9635$var$selectedStyles.root, isSelected && isSplitButton && $2f27420929ef9635$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $2f27420929ef9635$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $2f27420929ef9635$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $2f27420929ef9635$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $2f27420929ef9635$var$selectedStyles.discovery, isDisabled && $2f27420929ef9635$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $2f27420929ef9635$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $2f27420929ef9635$var$defaultStyles.disabled, isCircle && !isSplitButton && $2f27420929ef9635$var$styles.circle, spacing === 'compact' && $2f27420929ef9635$var$styles.spacingCompact, spacing === 'compact' && (0, $137Lh.fg)('platform-dst-shape-theme-default') && $2f27420929ef9635$var$styles.spacingCompactT26Shape, shouldFitContainer && $2f27420929ef9635$var$styles.fullWidth, hasIconBefore && $2f27420929ef9635$var$styles.buttonIconBefore, hasIconAfter && $2f27420929ef9635$var$styles.buttonIconAfter, isIconButton && $2f27420929ef9635$var$styles.iconButton, isIconButton && spacing === 'compact' && $2f27420929ef9635$var$styles.iconButtonCompact, isLoading && $2f27420929ef9635$var$styles.loading, isSplitButton && $2f27420929ef9635$var$styles.splitButton, isNavigationSplitButton && $2f27420929ef9635$var$styles.navigationSplitButton),
        isDisabled: (0, $137Lh.fg)('platform-dst_fix_not_focusable_loading_button') ? isDisabled : isEffectivelyDisabled
    }, (0, $137Lh.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-live': 'polite'
    }, isLoading && (0, $137Lh.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-disabled': true
    }, {
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($2f27420929ef9635$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $d5687ecff45b6a4f$export$2e2bcd8739ae039)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $74a8890cc9ccd165$export$4b86304b2c0d7e71).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
        className: (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
            $2f27420929ef9635$var$styles.loadingOverlay
        ])
    }, (0, $c8ad3c74d065482c$export$2e2bcd8739ae039)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d1b9d01570e45f55$export$2e2bcd8739ae039), {
        id: loadingLabelId
    }, $2f27420929ef9635$var$LOADING_LABEL)));
});
var $2f27420929ef9635$export$2e2bcd8739ae039 = $2f27420929ef9635$var$ButtonBase;


/* content.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $7fPBF = parcelRequire("7fPBF");
var $bb87128a2cadd975$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $bb87128a2cadd975$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
        className: (0, $f41f201ca78a311a$export$2e2bcd8739ae039)([
            $bb87128a2cadd975$var$styles.common,
            type === 'text' && $bb87128a2cadd975$var$styles.text,
            type === 'icon' && $bb87128a2cadd975$var$styles.icon,
            isLoading && $bb87128a2cadd975$var$styles.fade
        ])
    }, children);
};
var $bb87128a2cadd975$export$2e2bcd8739ae039 = $bb87128a2cadd975$var$Content;



var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");
function $e3ca56ebdfbd43d2$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $e3ca56ebdfbd43d2$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    var isRenderProp = $e3ca56ebdfbd43d2$var$isIconRenderProp(Icon);
    var iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $137Lh.fg)('platform_dst_button_chevron_sizing') ? function(iconName) {
            return iconName.startsWith('Chevron') ? 'small' : 'medium';
        } : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Icon, iconProps));
};
var $e3ca56ebdfbd43d2$export$2e2bcd8739ae039 = $e3ca56ebdfbd43d2$var$IconRenderer;


var $729d339602a97fd3$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $729d339602a97fd3$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $729d339602a97fd3$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $729d339602a97fd3$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(unsafeRest, $729d339602a97fd3$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2f27420929ef9635$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $bb87128a2cadd975$export$2e2bcd8739ae039), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e3ca56ebdfbd43d2$export$2e2bcd8739ae039), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d1b9d01570e45f55$export$2e2bcd8739ae039), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $98c1607276079bd8$export$2e2bcd8739ae039), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents,
        shortcut: tooltip === null || tooltip === void 0 ? void 0 : tooltip.shortcut
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2f27420929ef9635$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === 'circle',
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $9ec85dcfc6117313$export$2e2bcd8739ae039)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $bb87128a2cadd975$export$2e2bcd8739ae039), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e3ca56ebdfbd43d2$export$2e2bcd8739ae039), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d1b9d01570e45f55$export$2e2bcd8739ae039), null, label)));
    });
}));
$729d339602a97fd3$var$IconButton.displayName = 'IconButton';
var $729d339602a97fd3$export$2e2bcd8739ae039 = $729d339602a97fd3$var$IconButton;


var $cba802a82a24161e$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($cba802a82a24161e$exports, "__esModule", {
    value: true
});
$cba802a82a24161e$exports.default = void 0;

var $cba802a82a24161e$var$_react = $cba802a82a24161e$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $cba802a82a24161e$var$_baseNew = $cba802a82a24161e$var$_interopRequireDefault((parcelRequire("f6lOK")));
function $cba802a82a24161e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cba802a82a24161e$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $cba802a82a24161e$var$_react.default.createElement($cba802a82a24161e$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$cba802a82a24161e$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $cba802a82a24161e$var$_default = $cba802a82a24161e$exports.default = $cba802a82a24161e$var$ChevronDownIcon;


var $2630094b350cbf69$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b6f832dcdc2d7a1f91afd5e9b90e10b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($2630094b350cbf69$exports, "__esModule", {
    value: true
});
$2630094b350cbf69$exports.default = void 0;

var $2630094b350cbf69$var$_react = $2630094b350cbf69$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $2630094b350cbf69$var$_baseNew = $2630094b350cbf69$var$_interopRequireDefault((parcelRequire("f6lOK")));
function $2630094b350cbf69$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2630094b350cbf69$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $2630094b350cbf69$var$_react.default.createElement($2630094b350cbf69$var$_baseNew.default, Object.assign({
        name: "ChevronUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 9.97-6-6a.75.75 0 0 0-1.004-.052l-.056.052-6 6 1.06 1.06L8 5.56l5.47 5.47z"/>`
    }, props));
$2630094b350cbf69$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $2630094b350cbf69$var$_default = $2630094b350cbf69$exports.default = $2630094b350cbf69$var$ChevronUpIcon;


var $ffb8a32ff5060866$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($ffb8a32ff5060866$exports, "__esModule", {
    value: true
});
$ffb8a32ff5060866$exports.default = void 0;

var $ffb8a32ff5060866$var$_react = $ffb8a32ff5060866$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $ffb8a32ff5060866$var$_baseNew = $ffb8a32ff5060866$var$_interopRequireDefault((parcelRequire("f6lOK")));
function $ffb8a32ff5060866$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ffb8a32ff5060866$var$CrossIcon = (props)=>/*#__PURE__*/ $ffb8a32ff5060866$var$_react.default.createElement($ffb8a32ff5060866$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$ffb8a32ff5060866$var$CrossIcon.displayName = 'CrossIcon';
var $ffb8a32ff5060866$var$_default = $ffb8a32ff5060866$exports.default = $ffb8a32ff5060866$var$CrossIcon;



var $cb1074cf62da3033$var$DismissButtonComponent = function DismissButtonComponent(_ref) {
    var appearance = _ref.appearance, onClick = _ref.onClick, isBold = _ref.isBold, isExpanded = _ref.isExpanded, testId = _ref.testId;
    var ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($ffb8a32ff5060866$exports)));
    var buttonLabel = 'Dismiss';
    var buttonTestId = testId && "".concat(testId, "-dismiss");
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($2630094b350cbf69$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($cba802a82a24161e$exports)));
        buttonLabel = isExpanded ? 'Collapse' : 'Expand';
        buttonTestId = testId && "".concat(testId, "-toggle");
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $729d339602a97fd3$export$2e2bcd8739ae039), {
        icon: function icon(iconProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(ButtonIcon, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, iconProps, {
                size: "small",
                label: "",
                color: (0, $db0839dfa06eaa79$export$13b42cd9d596bfe0)[appearance]
            }));
        },
        appearance: "subtle",
        spacing: "compact",
        label: buttonLabel,
        onClick: onClick,
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId
    });
};
var $cb1074cf62da3033$var$DismissButton = /*#__PURE__*/ (0, $7fPBF.memo)($cb1074cf62da3033$var$DismissButtonComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cb1074cf62da3033$export$2e2bcd8739ae039 = $cb1074cf62da3033$var$DismissButton;

/* expander.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");

var $a6c67c5a8158581e$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $a6c67c5a8158581e$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $a6c67c5a8158581e$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a5b5d47be4518e83$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $a6c67c5a8158581e$export$2e2bcd8739ae039 = $a6c67c5a8158581e$var$FadeIn;



var $c11bc3509ee19ee7$var$styles = {
    expander: "_1bsb1osq",
    container: "_v5641xzp"
};
var $c11bc3509ee19ee7$var$Expander = function Expander(_ref) {
    var children = _ref.children, isExpanded = _ref.isExpanded, testId = _ref.testId;
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ $7fPBF.createElement((0, $b8865657e1570469$export$2e2bcd8739ae039), {
        xcss: $c11bc3509ee19ee7$var$styles.expander,
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && "".concat(testId, "-expander")
    }, /*#__PURE__*/ $7fPBF.createElement((0, $a1ad98f67aabe587$export$2e2bcd8739ae039), {
        appear: true
    }, isExpanded && /*#__PURE__*/ $7fPBF.createElement((0, $a6c67c5a8158581e$export$2e2bcd8739ae039), null, function(props) {
        return /*#__PURE__*/ $7fPBF.createElement((0, $b8865657e1570469$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
            xcss: $c11bc3509ee19ee7$var$styles.container
        }, props), /*#__PURE__*/ $7fPBF.createElement((0, $97877a8edc6b5060$export$2e2bcd8739ae039), {
            space: "space.100"
        }, children));
    })));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c11bc3509ee19ee7$export$2e2bcd8739ae039 = $c11bc3509ee19ee7$var$Expander;


function $374f1491cdd22e01$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $374f1491cdd22e01$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $374f1491cdd22e01$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $374f1491cdd22e01$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $374f1491cdd22e01$var$styles = {
    overflowWrap: "_1i4qfg65",
    flag: "_2rkofajl _1reo15vq _18m915vq _v564z97a _16qs130s _1pbyni7l _1bsb1osq",
    flagT26Shape: "_2rko1mok"
};
var $374f1491cdd22e01$var$CSS_VAR_ICON_COLOR = '--flag-icon-color';
var $374f1491cdd22e01$var$descriptionStyles = null;
var $374f1491cdd22e01$var$iconWrapperStyles = null;
var $374f1491cdd22e01$var$flagWrapperStyles = null;
var $374f1491cdd22e01$var$analyticsAttributes = {
    componentName: 'flag',
    packageName: "@atlaskit/flag",
    packageVersion: "0.0.0-development"
};
var $374f1491cdd22e01$var$transitionStyles = null;
/**
 * __Flag__
 *
 * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
 * often displayed using a flag group.
 *
 * - [Examples](https://atlassian.design/components/flag/examples)
 * - [Code](https://atlassian.design/components/flag/code)
 * - [Usage](https://atlassian.design/components/flag/usage)
 */ var $374f1491cdd22e01$var$Flag = function Flag(props) {
    var _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $94c19706695d9a55$export$d6830277b06edd6) : _props$appearance, icon = props.icon, title = props.title, description = props.description, linkComponent = props.linkComponent, onMouseOver = props.onMouseOver, _props$onFocus = props.onFocus, onFocus = _props$onFocus === void 0 ? (0, $f48d740006cf3f7d$export$2e2bcd8739ae039) : _props$onFocus, onMouseOut = props.onMouseOut, _props$onBlur = props.onBlur, onBlur = _props$onBlur === void 0 ? (0, $f48d740006cf3f7d$export$2e2bcd8739ae039) : _props$onBlur, _props$onDismissed = props.onDismissed, onDismissedProp = _props$onDismissed === void 0 ? (0, $f48d740006cf3f7d$export$2e2bcd8739ae039) : _props$onDismissed, testId = props.testId, id = props.id, analyticsContext = props.analyticsContext, delayAnnouncement = props.delayAnnouncement, _props$headingLevel = props.headingLevel, headingLevel = _props$headingLevel === void 0 ? 2 : _props$headingLevel;
    var _useState = (0, $7fPBF.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), isDelayToAnnounce = _useState2[0], setIsDelayToAnnounce = _useState2[1];
    var _useFlagGroup = (0, $99322f445ba7cde3$export$e91ea202abb66350)(), onDismissedFromFlagGroup = _useFlagGroup.onDismissed, isDismissAllowed = _useFlagGroup.isDismissAllowed;
    var onDismissed = (0, $7fPBF.useCallback)(function(id, analyticsEvent) {
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    var _useState3 = (0, $7fPBF.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 2), isExpanded = _useState4[0], setIsExpanded = _useState4[1];
    var onDismissedAnalytics = (0, $593ac790924c31ca$export$a4687b0234b40e28)($374f1491cdd22e01$var$_objectSpread({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext
    }, $374f1491cdd22e01$var$analyticsAttributes));
    var isBold = appearance !== (0, $94c19706695d9a55$export$d6830277b06edd6);
    var toggleExpand = (0, $7fPBF.useCallback)(function() {
        setIsExpanded(function(previous) {
            return !previous;
        });
    }, []);
    var buttonActionCallback = (0, $7fPBF.useCallback)(function() {
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $7fPBF.useEffect)(function() {
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, $7fPBF.useEffect)(function() {
        if (!delayAnnouncement) return;
        setTimeout(function() {
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    var onFocusAnalytics = (0, $593ac790924c31ca$export$a4687b0234b40e28)($374f1491cdd22e01$var$_objectSpread({
        fn: onFocus,
        action: 'focused',
        analyticsData: analyticsContext
    }, $374f1491cdd22e01$var$analyticsAttributes));
    var onBlurAnalytics = (0, $593ac790924c31ca$export$a4687b0234b40e28)($374f1491cdd22e01$var$_objectSpread({
        fn: onBlur,
        action: 'blurred',
        analyticsData: analyticsContext
    }, $374f1491cdd22e01$var$analyticsAttributes));
    var autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    var textColor = (0, $ed4499ac0a1dabb8$export$f50075b2584087f)[appearance];
    var iconColor = (0, $8919bc9e56107f4e$export$7f70afe2167f8235)[appearance];
    var iconGlyph = (0, $f3dc31fb69a246b3$export$73f08aee70487cd4)[appearance];
    var isDismissable = isBold || isDismissAllowed;
    var shouldRenderGap = !isBold && (description || actions.length) || isExpanded;
    // when delayAnnouncement is available we will use a hidden content for announcement
    var delayedAnnouncement = delayAnnouncement ? /*#__PURE__*/ $7fPBF.createElement((0, $d1b9d01570e45f55$export$2e2bcd8739ae039), null, title, description) : undefined;
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        role: "alert",
        "data-testid": testId
    }, autoDismissProps, {
        className: (0, $heZxp.default)([
            "_1bsb1osq"
        ])
    }), /*#__PURE__*/ $7fPBF.createElement((0, $b8865657e1570469$export$2e2bcd8739ae039), {
        padding: "space.200",
        backgroundColor: (0, $438786f526d630cf$export$59e42969c95d314)[appearance],
        xcss: (0, $e636b2257db42c06$export$a274e22fb40f762e)($374f1491cdd22e01$var$styles.flag, (0, $137Lh.fg)('platform-dst-shape-theme-default') && $374f1491cdd22e01$var$styles.flagT26Shape)
    }, /*#__PURE__*/ $7fPBF.createElement((0, $f6dc54d2afe6a4d1$export$2e2bcd8739ae039), {
        alignBlock: "start",
        space: "space.200"
    }, /*#__PURE__*/ $7fPBF.createElement("div", {
        "data-testid": testId && "".concat(testId, "-icon-container"),
        className: (0, $heZxp.default)([
            "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf _syaz16r9"
        ]),
        style: $374f1491cdd22e01$var$_objectSpread($374f1491cdd22e01$var$_objectSpread({}, (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, $374f1491cdd22e01$var$CSS_VAR_ICON_COLOR, iconColor)), {}, {
            "--_11v68d2": (0, $4059c65560b999b3$export$2e2bcd8739ae039)("var(".concat($374f1491cdd22e01$var$CSS_VAR_ICON_COLOR, ")"))
        })
    }, icon || iconGlyph), /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, $heZxp.default)([
            "_v5641hdc _16jlkb7n"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement((0, $97877a8edc6b5060$export$2e2bcd8739ae039), {
        space: shouldRenderGap ? 'space.100' : 'space.0' // Gap exists even when not expanded due to Expander internals always being in the DOM
    }, isDelayToAnnounce && delayedAnnouncement, /*#__PURE__*/ $7fPBF.createElement((0, $f6dc54d2afe6a4d1$export$2e2bcd8739ae039), {
        alignBlock: "stretch",
        space: "space.100",
        spread: "space-between"
    }, /*#__PURE__*/ $7fPBF.createElement((0, $b8865657e1570469$export$2e2bcd8739ae039), {
        paddingBlockStart: "space.050",
        paddingBlockEnd: "space.025",
        xcss: $374f1491cdd22e01$var$styles.overflowWrap
    }, /*#__PURE__*/ $7fPBF.createElement((0, $ae39dbf01fef6beb$export$2e2bcd8739ae039), {
        as: "h".concat(headingLevel),
        size: "xsmall",
        color: textColor
    }, /*#__PURE__*/ $7fPBF.createElement("span", {
        /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce
    }, title))), isDismissable ? !(isBold && !description && !actions.length) && /*#__PURE__*/ $7fPBF.createElement((0, $cb1074cf62da3033$export$2e2bcd8739ae039), {
        testId: testId,
        appearance: appearance,
        isBold: isBold,
        isExpanded: isExpanded,
        onClick: isBold ? toggleExpand : buttonActionCallback
    }) : null), /*#__PURE__*/ $7fPBF.createElement((0, $c11bc3509ee19ee7$export$2e2bcd8739ae039), {
        isExpanded: !isBold || isExpanded,
        testId: testId
    }, description && /*#__PURE__*/ $7fPBF.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            color: (0, $db0839dfa06eaa79$export$13b42cd9d596bfe0)[appearance]
        },
        "data-testid": testId && "".concat(testId, "-description"),
        "aria-hidden": isDelayToAnnounce,
        className: (0, $heZxp.default)([
            "_11c8fhey _1reo1wug _18m91wug _c71l53f4 _1i4qfg65"
        ])
    }, description), /*#__PURE__*/ $7fPBF.createElement((0, $3f065ac35d50ec42$export$2e2bcd8739ae039), {
        actions: actions,
        appearance: appearance,
        linkComponent: linkComponent,
        testId: testId
    })))))));
};
var $374f1491cdd22e01$export$2e2bcd8739ae039 = $374f1491cdd22e01$var$Flag;



var $a254ace60a4a8d45$var$packageName = "@atlaskit/flag";
var $a254ace60a4a8d45$var$packageVersion = "0.0.0-development";
var $a254ace60a4a8d45$export$66c3d409977b5615 = 8;
/**
 * __Auto dismiss flag__
 *
 * An auto dismiss flag is dismissed automatically after eight seconds.
 *
 * - [Examples](https://atlassian.design/components/flag/auto-dismiss-flag/examples)
 * - [Code](https://atlassian.design/components/flag/auto-dismiss-flag/code)
 */ var $a254ace60a4a8d45$var$AutoDismissFlag = function AutoDismissFlag(props) {
    var id = props.id, analyticsContext = props.analyticsContext, _props$onDismissed = props.onDismissed, onDismissedProp = _props$onDismissed === void 0 ? (0, $f48d740006cf3f7d$export$2e2bcd8739ae039) : _props$onDismissed, _props$autoDismissSec = props.autoDismissSeconds, autoDismissSeconds = _props$autoDismissSec === void 0 ? $a254ace60a4a8d45$export$66c3d409977b5615 : _props$autoDismissSec;
    var autoDismissTimer = (0, $7fPBF.useRef)(null);
    var _useFlagGroup = (0, $99322f445ba7cde3$export$e91ea202abb66350)(), onDismissedFromFlagGroup = _useFlagGroup.onDismissed, isDismissAllowed = _useFlagGroup.isDismissAllowed;
    var onDismissed = (0, $7fPBF.useCallback)(function(id, analyticsEvent) {
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    var onDismissedAnalytics = (0, $593ac790924c31ca$export$a4687b0234b40e28)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        componentName: 'flag',
        packageName: $a254ace60a4a8d45$var$packageName,
        packageVersion: $a254ace60a4a8d45$var$packageVersion
    });
    var isAutoDismissAllowed = isDismissAllowed && onDismissed;
    var dismissFlag = (0, $7fPBF.useCallback)(function() {
        if (isAutoDismissAllowed) onDismissedAnalytics(id);
    }, [
        id,
        onDismissedAnalytics,
        isAutoDismissAllowed
    ]);
    var stopAutoDismissTimer = (0, $7fPBF.useCallback)(function() {
        if (autoDismissTimer.current) {
            clearTimeout(autoDismissTimer.current);
            autoDismissTimer.current = null;
        }
    }, []);
    var startAutoDismissTimer = (0, $7fPBF.useCallback)(function() {
        if (!isAutoDismissAllowed) return;
        stopAutoDismissTimer();
        autoDismissTimer.current = window.setTimeout(dismissFlag, autoDismissSeconds * 1000);
    }, [
        dismissFlag,
        stopAutoDismissTimer,
        isAutoDismissAllowed,
        autoDismissSeconds
    ]);
    (0, $7fPBF.useEffect)(function() {
        startAutoDismissTimer();
        return stopAutoDismissTimer;
    }, [
        startAutoDismissTimer,
        stopAutoDismissTimer
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $374f1491cdd22e01$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, props, {
        onMouseOver: stopAutoDismissTimer,
        onFocus: stopAutoDismissTimer,
        onMouseOut: startAutoDismissTimer,
        onBlur: startAutoDismissTimer
    }));
};
var $a254ace60a4a8d45$export$2e2bcd8739ae039 = $a254ace60a4a8d45$var$AutoDismissFlag;






const $edcf2f5ac8c95255$var$fullUser = {
    email: 'v**********@atlassian.com',
    groups: {
        newsletters: {
            key: 'newsletters',
            title: 'Newsletters & Digests',
            description: 'From IT to DevOps, these emails will keep you up to date with the latest Industry trends and best practices.',
            type: (0, $91cadcf42f447377$export$d460f747b73abb10).SUBSCRIPTIONS,
            tabs: {
                root: {
                    items: {
                        atlassianTeamPlaybook: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        industryBestPractices: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        atlassianBlog: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        jiraInsidersNewsletter: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        jiraServerNewsletter: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        jiraOps: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        confluenceInsidersNewsletter: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        gitInsidersNewsletter: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        atlassianUniversity: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        devOpsDigest: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        jiraMacApp: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        atlassianCommunity: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        developerEcosystemNewsletter: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        productSurveys: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF
                    }
                }
            }
        },
        product_recommendations: {
            key: 'product_recommendations',
            title: 'Product Recommendations',
            description: 'Discover how Atlassian products work better together. Sign up for useful product suggestions that boost productivity and collaboration.',
            type: (0, $91cadcf42f447377$export$d460f747b73abb10).SUBSCRIPTIONS,
            tabs: {
                cloud: {
                    key: 'cloud',
                    title: 'Atlassian Cloud',
                    items: {
                        jiraSoftwareProductRecommendationsCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        jiraServiceDeskProductRecommendationsCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        jiraCoreProductRecommendationsCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        confluenceProductRecommendationsCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        bitbucketProductRecommendationsCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        atlassianAccessProductRecommendationsCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        atlassianCloudAppsProductRecommendationsCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        trelloProductRecommendationsCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        trelloPowerUpsProductRecommendationsCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        statuspageProductRecommendationsCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        opsgenieProductRecommendationsCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        jiraAlignProductRecommendationsCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        automationForJiraProductRecommendationsCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        generalProductRecommendationsCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF
                    }
                },
                server: {
                    key: 'server',
                    title: 'Atlassian Server / Data Center',
                    items: {
                        jiraSoftwareProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        jiraServiceDeskProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        jiraCoreProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        confluenceProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        bitbucketProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        crowdProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        sourcetreeProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        bambooProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        fisheyeProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        crucibleProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        atlassianServerAppsProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        analyticsForConfluenceAppProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        automationForJiraProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        iconsForJiraProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF
                    }
                }
            }
        },
        product_upgrades: {
            key: 'product_upgrades',
            title: 'Product Upgrades',
            description: 'Upgrade your product experience. Learn about the different features available in our product tiers and deployments to make the right choice for your company.',
            type: (0, $91cadcf42f447377$export$d460f747b73abb10).SUBSCRIPTIONS,
            tabs: {
                cloud: {
                    key: 'cloud',
                    title: 'Atlassian Cloud',
                    items: {
                        jiraSoftwareProductUpgradesCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        jiraServiceDeskProductUpgradesCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        jiraCoreProductUpgradesCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        confluenceProductUpgradesCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        bitbucketProductUpgradesCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        atlassianAccessProductUpgradesCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        atlassianCloudAppsProductUpgradesCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        trelloProductUpgradesCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        trelloPowerUpsProductUpgradesCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        statuspageProductUpgradesCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        opsgenieProductUpgradesCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        jiraAlignProductUpgradesCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        automationForJiraProductUpgradesCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        generalProductUpgradesCloud: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF
                    }
                },
                server: {
                    key: 'server',
                    title: 'Atlassian Server / Data Center',
                    items: {
                        jiraSoftwareProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        jiraServiceDeskProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        jiraCoreProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        confluenceProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        bitbucketProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        crowdProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        sourcetreeProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        bambooProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        fisheyeProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        crucibleProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        atlassianServerAppsProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        analyticsForConfluenceAppProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        automationForJiraProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        iconsForJiraProductRecommendationsServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF
                    }
                }
            }
        },
        tips_and_tricks: {
            key: 'tips_and_tricks',
            title: 'Tips & Tricks',
            description: 'Get the most out of your tools. Sign up to receive the latest announcements about your favorite products.',
            type: (0, $91cadcf42f447377$export$d460f747b73abb10).SUBSCRIPTIONS,
            tabs: {
                cloud: {
                    key: 'cloud',
                    title: 'Atlassian Cloud',
                    items: {
                        jiraSoftwareProductUpgradesServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        jiraServiceDeskProductUpgradesServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        confluenceProductUpgradesServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        bitbucketProductUpgradesServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        sourcetreeProductUpgradesServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        bambooProductUpgradesServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        crucibleProductUpgradesServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        atlassianServerAppsProductUpgradesServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        automationForJiraProductUpgradesServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        iconsForJiraProductUpgradesServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF
                    }
                },
                server: {
                    key: 'server',
                    title: 'Atlassian Server / Data Center',
                    items: {
                        jiraSoftwareTipsAndTricksServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        jiraServiceDeskTipsAndTricksServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        confluenceTipsAndTricksServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        bitbucketTipsAndTricksServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        sourcetreeTipsAndTricksServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        bambooTipsAndTricksServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        crucibleTipsAndTricksServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        atlassianServerAppsTipsAndTricksServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        automationForJiraTipsAndTricksServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        iconsForJiraTipsAndTricksServer: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF
                    }
                }
            }
        },
        tech_alerts: {
            key: 'tech_alerts',
            title: 'Tech Alerts',
            description: 'Stay up-to-date on security advisories, maintenance notifications, and pricing updates that affect your account. Note: if you are a tech administrator, you will always receive these notifications.',
            type: (0, $91cadcf42f447377$export$d460f747b73abb10).SUBSCRIPTIONS,
            tabs: {
                root: {
                    items: {
                        jiraSoftwareTechAlerts: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        jiraCoreTechAlerts: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        jiraServiceDeskTechAlerts: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        hipchatTechAlerts: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        confluenceTechAlerts: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        fisheyeTechAlerts: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        bambooTechAlerts: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        crucibleTechAlerts: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        crowdTechAlerts: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                        cloverTechAlerts: (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF,
                        bitbucketTechAlerts: (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON
                    }
                }
            }
        }
    }
};
const $edcf2f5ac8c95255$var$emptyUser = {
    email: 'e**********@atlassian.com',
    groups: {}
};
const $edcf2f5ac8c95255$var$downForMaintenance = {
    downForMaintenanceMessage: 'down_for_maintenance.message'
};
const $edcf2f5ac8c95255$var$dataStore = new Map();
$edcf2f5ac8c95255$var$dataStore.set('1', $edcf2f5ac8c95255$var$fullUser);
$edcf2f5ac8c95255$var$dataStore.set('2', $edcf2f5ac8c95255$var$emptyUser);
$edcf2f5ac8c95255$var$dataStore.set('3', $edcf2f5ac8c95255$var$downForMaintenance);
$edcf2f5ac8c95255$var$dataStore.set('4', $edcf2f5ac8c95255$var$fullUser);
const $edcf2f5ac8c95255$export$12b1f9d03b823a51 = (hid)=>{
    if (hid) return $edcf2f5ac8c95255$var$dataStore.get(hid);
};



const $e845741c6335a85b$var$parseUrlQueryString = (query)=>(0, (/*@__PURE__*/$parcel$interopDefault($3cc271bb186f0140$exports))).parse(query, {
        ignoreQueryPrefix: true,
        allowDots: true
    });
var $e845741c6335a85b$export$2e2bcd8739ae039 = $e845741c6335a85b$var$parseUrlQueryString;


const $524c694f3271f0de$var$listIdToKeyMap = {
    219880: [
        'all'
    ],
    287489: [
        'productAnnouncements'
    ],
    287490: [
        'events',
        'generalEvents',
        'summitUserConference',
        'atlasCampDeveloperConference'
    ],
    287491: [
        'tipsTricksAndBestPractices',
        'productRecommendations',
        'specialOffers',
        'marketplaceNewsletter'
    ],
    1081095: [
        'jiraTechAlerts'
    ],
    1081282: [
        'confluenceTechAlerts'
    ],
    1081343: [
        'bambooTechAlerts'
    ],
    1081388: [
        'crucibleTechAlerts'
    ],
    1081451: [
        'cloverTechAlerts'
    ],
    1081489: [
        'fisheyeTechAlerts'
    ],
    1081543: [
        'crowdTechAlerts'
    ],
    1231860: [
        'bitbucketPromotions'
    ],
    1239131: [
        'jiraInsidersNewsletter'
    ],
    1243499: [
        'developerEcosystemNewsletter'
    ],
    1246925: [
        'confluenceInsidersNewsletter'
    ],
    1267986: [
        'events',
        'generalEvents',
        'summitUserConference',
        'atlasCampDeveloperConference'
    ],
    1275007: [
        'gitInsidersNewsletter'
    ],
    1370882: [
        'productSurveys'
    ],
    1370962: [
        'jiraInsidersNewsletter'
    ],
    1370965: [
        'gitInsidersNewsletter'
    ],
    1370967: [
        'bitbucketTechAlerts'
    ],
    1370968: [
        'hipchatTechAlerts'
    ],
    1370971: [
        'jiraCoreTechAlerts'
    ],
    1370973: [
        'jiraServiceDeskTechAlerts'
    ],
    1370974: [
        'jiraSoftwareTechAlerts'
    ],
    1382366: [
        'tipsTricksAndBestPractices'
    ],
    1382367: [
        'tipsTricksAndBestPractices'
    ],
    1382368: [
        'tipsTricksAndBestPractices'
    ],
    1382369: [
        'tipsTricksAndBestPractices'
    ],
    1382370: [
        'tipsTricksAndBestPractices'
    ],
    1382371: [
        'tipsTricksAndBestPractices'
    ],
    1382372: [
        'tipsTricksAndBestPractices'
    ],
    1382373: [
        'tipsTricksAndBestPractices'
    ],
    1382374: [
        'tipsTricksAndBestPractices'
    ],
    1382375: [
        'tipsTricksAndBestPractices'
    ],
    1382376: [
        'tipsTricksAndBestPractices'
    ],
    1382377: [
        'tipsTricksAndBestPractices'
    ],
    1382378: [
        'tipsTricksAndBestPractices'
    ],
    1382379: [
        'tipsTricksAndBestPractices'
    ],
    1382380: [
        'tipsTricksAndBestPractices'
    ],
    1382381: [
        'tipsTricksAndBestPractices'
    ],
    1395680: [
        'atlassianTeamPlaybook'
    ],
    1397949: [
        'summitUserConference'
    ],
    1401671: [
        'jiraServerNewsletter'
    ],
    1402390: [
        'atlassianBlog'
    ],
    1406704: [
        'summitUserConference'
    ],
    1412633: [
        'developerEcosystemNewsletter'
    ],
    1412722: [
        'devOpsDigest'
    ],
    1412810: [
        'tipsTricksAndBestPractices'
    ],
    1413519: [
        'atlassianCommunity'
    ],
    1416115: [
        'atlassianCommunity'
    ],
    1420843: [
        'atlasCampDeveloperConference'
    ],
    1423233: [
        'tipsTricksAndBestPractices'
    ],
    1423442: [
        'generalEvents'
    ],
    1423449: [
        'atlassianTeamPlaybook'
    ],
    1423487: [
        'productRecommendations'
    ],
    1432855: [
        'jiraOps'
    ]
};
const $524c694f3271f0de$export$c3b1ee5e50dbae17 = (source, keys, listId)=>{
    if (source == null || source !== 'mc' || listId == null) return keys;
    const keysSet = keys == null ? new Set() : new Set(keys.split(','));
    const keyArray = $524c694f3271f0de$var$listIdToKeyMap[listId];
    if (keyArray != null) keyArray.forEach((keyElement)=>{
        keysSet.add(keyElement);
    });
    return Array.from(keysSet).join(',');
};




const $a87b710a60abd11e$export$a52d76f06c2d44c0 = (query)=>{
    const { hid: hid, key: key, source: source, lid: lid, subscribeKeys: subscribeKeys, jobId: jobId } = (0, $e845741c6335a85b$export$2e2bcd8739ae039)(query);
    const unsubscribeKeys = (0, $524c694f3271f0de$export$c3b1ee5e50dbae17)(source, key, Number(lid));
    const decodeSubscribeKeys = subscribeKeys === null || subscribeKeys === void 0 ? void 0 : subscribeKeys.replace('+', '').replace('%20', '');
    return {
        hid: hid,
        source: source,
        unsubscribeKeys: unsubscribeKeys,
        subscribeKeys: decodeSubscribeKeys,
        jobId: jobId
    };
};





var $e11fceb31fd1a0cb$export$e743037aea74f514 = /*#__PURE__*/ function(TriState) {
    TriState[TriState["false"] = 0] = "false";
    TriState[TriState["true"] = 1] = "true";
    TriState[TriState["busy"] = 2] = "busy";
    return TriState;
}({});


const $8bebd03d19fe43b4$export$3f0ed83b7cd726b4 = (id, description)=>{
    return {
        description: description,
        iconType: 'success',
        id: id,
        key: id,
        title: 'Success',
        isAutoDismissFlag: true
    };
};
const $8bebd03d19fe43b4$export$4be607b64c8e8c80 = (id, description)=>{
    return {
        description: description,
        iconType: 'error',
        id: id,
        key: id,
        title: 'Error',
        isAutoDismissFlag: false
    };
};


const $80022746ba8cd68a$export$67da628992e8bb92 = 'preferences';
const $80022746ba8cd68a$export$6871e08c9c3b9797 = `${$80022746ba8cd68a$export$67da628992e8bb92}/loadUser`;
const $80022746ba8cd68a$export$3ba8a56dc6b23d2b = `${$80022746ba8cd68a$export$67da628992e8bb92}/unsubscribeAll`;
const $80022746ba8cd68a$export$1a788c0d2586d018 = `${$80022746ba8cd68a$export$67da628992e8bb92}/unsubscribe`;
const $80022746ba8cd68a$export$30f55fa357ca2ae5 = `${$80022746ba8cd68a$export$67da628992e8bb92}/subscribe`;
const $80022746ba8cd68a$export$f03e0b4dc877be9a = `${$80022746ba8cd68a$export$67da628992e8bb92}/initialization`;
const $80022746ba8cd68a$export$22260131648f9419 = `${$80022746ba8cd68a$export$67da628992e8bb92}/sendItemFromUI`;



const $3d2cac913f314860$var$initialState = {
    urlQueryParams: undefined,
    hid: undefined,
    email: undefined,
    groups: {},
    initialStates: {},
    status: {
        status: 'ok'
    },
    filter: {
        groupKey: 'all'
    },
    actionResult: undefined,
    consentDialog: {
        showDialog: false,
        update: undefined
    },
    consentDeclinePrDialog: {
        showDialog: false,
        update: undefined
    },
    globalUnsubscribeDialog: {
        showDialog: false,
        update: undefined
    },
    doubleOptInDialog: {
        showDialog: false,
        update: undefined
    },
    notifications: []
};
const $3d2cac913f314860$export$ffa1c39529f5195b = (0, $15d924278321bdfd$export$6abd22dc03e5063f)((0, $80022746ba8cd68a$export$6871e08c9c3b9797), async (hid, { rejectWithValue: rejectWithValue })=>{
    const mockUserPreferences = (0, $edcf2f5ac8c95255$export$12b1f9d03b823a51)(hid);
    if (mockUserPreferences) return mockUserPreferences;
    try {
        if (hid) return await (0, $71fbb9240bd0b42c$export$fa5a5f9acf0b4757)(hid);
        else return (await (0, $71fbb9240bd0b42c$export$c1cf1b7b7ca0c54c)()).data;
    } catch (e) {
        if ((0, $747d656b899e6115$export$2e2bcd8739ae039).isAxiosError(e)) return rejectWithValue(e.status);
        else throw e;
    }
});
const $3d2cac913f314860$export$34ae4e8891fc3f3d = (0, $15d924278321bdfd$export$6abd22dc03e5063f)((0, $80022746ba8cd68a$export$3ba8a56dc6b23d2b), async (_, { getState: getState, rejectWithValue: rejectWithValue, dispatch: dispatch })=>{
    var _getState_preferences;
    const hid = (_getState_preferences = getState().preferences) === null || _getState_preferences === void 0 ? void 0 : _getState_preferences.hid;
    if (!hid) return rejectWithValue(null);
    const userPreferences = (0, $edcf2f5ac8c95255$export$12b1f9d03b823a51)(hid);
    if (userPreferences == null) {
        const groups = getState().preferences.groups;
        await (0, $71fbb9240bd0b42c$export$e2a4d9289365ff88)(hid);
        // mark all subscriptions as unsubscribed and revoke all consents
        Object.keys(groups).forEach((groupKey)=>{
            if (groups[groupKey].type === (0, $91cadcf42f447377$export$d460f747b73abb10).SUBSCRIPTIONS || groups[groupKey].type === (0, $91cadcf42f447377$export$d460f747b73abb10).CONSENTS) Object.keys(groups[groupKey].tabs).forEach((tabKey)=>{
                Object.keys(groups[groupKey].tabs[tabKey].items).forEach((itemKey)=>{
                    dispatch($3d2cac913f314860$export$b7f4ae9cfec1a518({
                        groupKey: groupKey,
                        tabKey: tabKey,
                        itemKey: itemKey,
                        state: (0, $e11fceb31fd1a0cb$export$e743037aea74f514).false
                    }));
                });
            });
        });
    } else if (hid === '5') return rejectWithValue(null);
});
const $3d2cac913f314860$var$findKey = (state, targetKey)=>{
    for (const groupKey of Object.keys(state.groups)){
        for (const tabKey of Object.keys(state.groups[groupKey].tabs))for (const itemKey of Object.keys(state.groups[groupKey].tabs[tabKey].items)){
            if (itemKey === targetKey) return {
                groupKey: groupKey,
                tabKey: tabKey,
                itemKey: itemKey
            };
        }
    }
    throw new Error("Item key '" + targetKey + "' not found.");
};
const $3d2cac913f314860$export$f500693cef883ffd = (0, $15d924278321bdfd$export$6abd22dc03e5063f)((0, $80022746ba8cd68a$export$1a788c0d2586d018), async (_, { dispatch: dispatch, getState: getState, rejectWithValue: rejectWithValue })=>{
    var _getState_preferences;
    const { urlQueryParams: urlQueryParams } = getState().preferences;
    const hid = (_getState_preferences = getState().preferences) === null || _getState_preferences === void 0 ? void 0 : _getState_preferences.hid;
    if (urlQueryParams == null || !hid) return rejectWithValue(null);
    const { unsubscribeKeys: unsubscribeKeys, jobId: jobId } = urlQueryParams;
    if (unsubscribeKeys === 'all') {
        dispatch($3d2cac913f314860$export$34ae4e8891fc3f3d());
        return [
            unsubscribeKeys
        ];
    } else if (unsubscribeKeys) {
        await (0, $71fbb9240bd0b42c$export$a1e4533914e154bd)(hid, unsubscribeKeys, jobId);
        // uncheck all unsubscribed items
        const subscriptionKeys = unsubscribeKeys.split(',');
        const emptyGroupKey = '';
        const keysWithGroup = [];
        subscriptionKeys.forEach((subscriptionKey)=>{
            try {
                const { groupKey: groupKey, tabKey: tabKey, itemKey: itemKey } = $3d2cac913f314860$var$findKey(getState().preferences, subscriptionKey);
                keysWithGroup.push(groupKey + ':' + subscriptionKey);
                dispatch($3d2cac913f314860$export$b7f4ae9cfec1a518({
                    groupKey: groupKey,
                    tabKey: tabKey,
                    itemKey: itemKey,
                    state: (0, $e11fceb31fd1a0cb$export$e743037aea74f514).false
                }));
            } catch (e) {
                // This can occur if the subscription is not listed in the UI
                keysWithGroup.push(emptyGroupKey + ':' + subscriptionKey);
            }
        });
        return keysWithGroup;
    } else return [];
}, {
    condition: (_, { getState: getState })=>{
        const { urlQueryParams: urlQueryParams, status: status } = getState().preferences;
        return status.status === 'ok' && (urlQueryParams === null || urlQueryParams === void 0 ? void 0 : urlQueryParams.unsubscribeKeys) != null;
    }
});
const $3d2cac913f314860$export$ec068583843480e7 = (0, $15d924278321bdfd$export$6abd22dc03e5063f)((0, $80022746ba8cd68a$export$30f55fa357ca2ae5), async (_, { dispatch: dispatch, getState: getState, rejectWithValue: rejectWithValue })=>{
    const { urlQueryParams: urlQueryParams } = getState().preferences;
    const hid = getState().preferences.hid;
    if (urlQueryParams == null || !hid) return rejectWithValue(null);
    const { subscribeKeys: subscribeKeys } = urlQueryParams;
    if (subscribeKeys == null) return [];
    // check all subscribed items
    const keys = subscribeKeys.split(',');
    const keysWithGroup = [];
    keys.forEach((key)=>{
        const { groupKey: groupKey, tabKey: tabKey, itemKey: itemKey } = $3d2cac913f314860$var$findKey(getState().preferences, key);
        keysWithGroup.push(groupKey + ':' + itemKey);
        dispatch($3d2cac913f314860$export$b7f4ae9cfec1a518({
            groupKey: groupKey,
            tabKey: tabKey,
            itemKey: itemKey,
            state: (0, $e11fceb31fd1a0cb$export$e743037aea74f514).true
        }));
    });
    const subscriptions = keys.map((key)=>({
            key: key,
            subscribed: true
        }));
    await (0, $71fbb9240bd0b42c$export$d12a00019f220cc1)(hid, subscriptions);
    return keysWithGroup;
}, {
    condition: (_, { getState: getState })=>{
        const { urlQueryParams: urlQueryParams, status: status } = getState().preferences;
        return status.status === 'ok' && (urlQueryParams === null || urlQueryParams === void 0 ? void 0 : urlQueryParams.subscribeKeys) != null;
    }
});
const $3d2cac913f314860$export$a3910a3548679a09 = (0, $15d924278321bdfd$export$6abd22dc03e5063f)((0, $80022746ba8cd68a$export$f03e0b4dc877be9a), async (args, { dispatch: dispatch, getState: getState })=>{
    const { urlQueryParams: urlQueryParams } = getState().preferences;
    if (urlQueryParams == null) return;
    const { hid: hid, source: source, unsubscribeKeys: unsubscribeKeys, subscribeKeys: subscribeKeys } = urlQueryParams;
    (0, $0e08eda71bb24540$export$e2ad6fafbc50701c)(hid, source, unsubscribeKeys, subscribeKeys);
    // initialize all structures w/info from ConsentHub
    await dispatch($3d2cac913f314860$export$ffa1c39529f5195b(hid));
    (0, $f30b917334351296$export$712ea50be43a7858)(()=>{
        dispatch($3d2cac913f314860$export$f500693cef883ffd());
        dispatch($3d2cac913f314860$export$ec068583843480e7());
    });
});
const $3d2cac913f314860$var$requestConsentConfirmation = (update, preferenceState)=>{
    if (preferenceState.groups['consents'] === undefined) return false;
    const gmoi = preferenceState.groups['consents'].tabs['root'].items['generalMarketingOptIn'];
    if (update.bypassConsentCheck) return false;
    // only check consent if they are consenting or subscribing, not revoking or unsubscribing
    if (update.state !== (0, $e11fceb31fd1a0cb$export$e743037aea74f514).true) return false;
    const needsGmoi = gmoi !== undefined && (gmoi == null || gmoi !== (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON);
    for (const item of update.keys){
        const { groupKey: groupKey } = $3d2cac913f314860$var$findKey(preferenceState, item);
        // Show consent modal if:
        // - Group is 'product_recommendations' OR item is 'generalMarketingOptIn'
        // - AND generalMarketingOptIn currently is null or false.
        // - AND consent modal isn't open
        if ((groupKey === 'product_recommendations' || item === 'generalMarketingOptIn') && needsGmoi && !preferenceState.consentDialog.showDialog) return true;
    }
    return false;
};
// Worst name for a function ever
const $3d2cac913f314860$var$requestConfirmationForPrUnsub = (update, preferenceState)=>{
    let anyPrSubbed = false;
    try {
        for (const tabKey of Object.keys(preferenceState.groups['product_recommendations'].tabs)){
            for (const itemKey of Object.keys(preferenceState.groups['product_recommendations'].tabs[tabKey].items))if (preferenceState.groups['product_recommendations'].tabs[tabKey].items[itemKey] === (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON) {
                anyPrSubbed = true;
                break;
            }
            if (anyPrSubbed) break;
        }
    } catch (e) {
    // No issue here. Just means PR group is missing.
    }
    if (update.bypassConsentDeclinePrCheck) return false;
    // only request confirmation if they are revoking consent
    if (update.state !== (0, $e11fceb31fd1a0cb$export$e743037aea74f514).false) return false;
    for (const item of update.keys){
        // Show confirmation modal if:
        // - Item is 'generalMarketingOptIn'
        // - AND any product recommendation is subscribed
        // - AND confirmation modal isn't open
        if (item === 'generalMarketingOptIn' && anyPrSubbed && !preferenceState.consentDeclinePrDialog.showDialog) return true;
    }
    return false;
};
const $3d2cac913f314860$var$requestGlobalUnsubscribe = (preferenceState)=>{
    for (const groupKey of Object.keys(preferenceState.groups)){
        for (const tabKey of Object.keys(preferenceState.groups[groupKey].tabs))for (const itemKey of Object.keys(preferenceState.groups[groupKey].tabs[tabKey].items)){
            const itemStatus = preferenceState.groups[groupKey].tabs[tabKey].items[itemKey];
            if (itemStatus === (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON || itemStatus === (0, $91cadcf42f447377$export$3d4da522aa66ad7).PENDING) return false;
        }
    }
    return true;
};
const $3d2cac913f314860$var$showDoubleOptIn = (update, response)=>{
    return !!(update.keys.includes('generalMarketingOptIn') && response.groups && response.groups['consents'].tabs['root'].items['generalMarketingOptIn'] === (0, $91cadcf42f447377$export$3d4da522aa66ad7).PENDING);
};
const $3d2cac913f314860$var$generateConsentsPayload = (prefState, update)=>{
    if (update.state === (0, $e11fceb31fd1a0cb$export$e743037aea74f514).busy) throw new Error('Attempting to generate ConsentHub consents payload with invalid consent state.');
    const payload = [];
    for (const item of update.keys){
        const { groupKey: groupKey, itemKey: itemKey } = $3d2cac913f314860$var$findKey(prefState, item);
        const type = prefState.groups[groupKey].type;
        if (type === (0, $91cadcf42f447377$export$d460f747b73abb10).CONSENTS) {
            let targetState = false;
            if (update.state === (0, $e11fceb31fd1a0cb$export$e743037aea74f514).true) targetState = true;
            payload.push({
                key: itemKey,
                displayedText: 'Changed via Pref. Center UI',
                granted: targetState
            });
        }
    }
    return payload;
};
const $3d2cac913f314860$var$generateSubscriptionsPayload = (prefState, update)=>{
    if (update.state === (0, $e11fceb31fd1a0cb$export$e743037aea74f514).busy) throw new Error('Attempting to generate ConsentHub subscriptions payload with invalid subscription state.');
    const payload = [];
    for (const item of update.keys){
        const { groupKey: groupKey, itemKey: itemKey } = $3d2cac913f314860$var$findKey(prefState, item);
        const type = prefState.groups[groupKey].type;
        if (type === (0, $91cadcf42f447377$export$d460f747b73abb10).SUBSCRIPTIONS) {
            let targetState = false;
            if (update.state === (0, $e11fceb31fd1a0cb$export$e743037aea74f514).true) targetState = true;
            payload.push({
                key: itemKey,
                subscribed: targetState
            });
        }
    }
    return payload;
};
const $3d2cac913f314860$var$setStates = (prefState, update, dispatch, targetState)=>{
    for (const item of Object.values(update.keys)){
        const { groupKey: groupKey, tabKey: tabKey, itemKey: itemKey } = $3d2cac913f314860$var$findKey(prefState, item);
        dispatch($3d2cac913f314860$export$b7f4ae9cfec1a518({
            groupKey: groupKey,
            tabKey: tabKey,
            itemKey: itemKey,
            state: targetState
        }));
    }
};
const $3d2cac913f314860$export$807cff22f0457821 = (0, $15d924278321bdfd$export$6abd22dc03e5063f)((0, $80022746ba8cd68a$export$22260131648f9419), async (update, { dispatch: dispatch, getState: getState, rejectWithValue: rejectWithValue })=>{
    var _getState_preferences;
    const hid = (_getState_preferences = getState().preferences) === null || _getState_preferences === void 0 ? void 0 : _getState_preferences.hid;
    if (!hid) return rejectWithValue(null);
    if ($3d2cac913f314860$var$requestConsentConfirmation(update, getState().preferences)) {
        dispatch($3d2cac913f314860$export$6b7ef6c2de46cbd4({
            showDialog: true,
            update: update
        }));
        return rejectWithValue(null);
    } else if (update.sourceGroup === 'product_recommendations' && update.state === (0, $e11fceb31fd1a0cb$export$e743037aea74f514).true) {
        if (update.sourceComponent === 'ItemCard') (0, $0e08eda71bb24540$export$b2d5c41c71279068)(true, {
            source: update.sourceItem
        });
        else if (update.sourceComponent === 'GroupContent') (0, $0e08eda71bb24540$export$19e5a6bca6f03118)(true, {
            groupName: update.sourceGroup,
            tabName: update.sourceTab
        });
    }
    if ($3d2cac913f314860$var$requestConfirmationForPrUnsub(update, getState().preferences)) {
        dispatch($3d2cac913f314860$export$cab60deb7aecd81e({
            showDialog: true,
            update: update
        }));
        return rejectWithValue(null);
    } else if (update.sourceGroup === 'consents' && update.state === (0, $e11fceb31fd1a0cb$export$e743037aea74f514).false) {
        if (update.sourceComponent === 'ItemCard') (0, $0e08eda71bb24540$export$c369c41080a75c3d)({
            source: update.sourceItem
        });
        else if (update.sourceComponent === 'GroupContent') (0, $0e08eda71bb24540$export$f1757086d8a8d8f4)();
    }
    const request = {
        hid: hid,
        formUrl: window.location.href,
        site: 'atlassian',
        consents: $3d2cac913f314860$var$generateConsentsPayload(getState().preferences, update),
        subscriptions: $3d2cac913f314860$var$generateSubscriptionsPayload(getState().preferences, update),
        source: 'PREFERENCES_CENTER',
        action: 'UPDATE_PREFERENCES'
    };
    try {
        // update checkbox(es) w/spinner for all items in consent/subscription payloads
        $3d2cac913f314860$var$setStates(getState().preferences, update, dispatch, (0, $e11fceb31fd1a0cb$export$e743037aea74f514).busy);
        const response = await (0, $71fbb9240bd0b42c$export$3ab4aed8562cb58d)(request);
        if (response.downForMaintenanceMessage != null) // don't show the modal error, just refresh for a proper DFM page.
        window.location.reload();
        if ($3d2cac913f314860$var$showDoubleOptIn(update, response)) dispatch($3d2cac913f314860$export$71d5718099bcf953({
            showDialog: true
        }));
        else if (!update.skipNotification) dispatch($3d2cac913f314860$export$6ee970972faf5a9e());
        return response;
    } catch (e) {
        // reset checkbox(es)
        let targetState = (0, $e11fceb31fd1a0cb$export$e743037aea74f514).false;
        if (update.state === (0, $e11fceb31fd1a0cb$export$e743037aea74f514).false) targetState = (0, $e11fceb31fd1a0cb$export$e743037aea74f514).true;
        $3d2cac913f314860$var$setStates(getState().preferences, update, dispatch, targetState);
        dispatch($3d2cac913f314860$export$40aa0bed012fe51a());
    }
});
const $3d2cac913f314860$var$findSubscriptionGroup = (keys, state)=>{
    if (keys == null || keys === 'all' || keys.includes(',')) return undefined;
    if (state.groups == null) return undefined;
    try {
        const { groupKey: groupKey, tabKey: tabKey } = $3d2cac913f314860$var$findKey(state, keys);
        return {
            groupKey: groupKey,
            tabKey: tabKey
        };
    } catch (e) {
        // If we can't find the key, show them all.
        return undefined;
    }
};
const $3d2cac913f314860$var$preferencesSlice = (0, $15d924278321bdfd$export$4d8d9bd83c24ae8b)({
    name: (0, $80022746ba8cd68a$export$67da628992e8bb92),
    initialState: $3d2cac913f314860$var$initialState,
    reducers: {
        logSuccessNotification: (state)=>{
            const newFlagId = state.notifications.length + 1;
            const newFlagData = (0, $8bebd03d19fe43b4$export$3f0ed83b7cd726b4)(newFlagId, 'Your preferences were updated. Please be patient, as it can take up to 5 business days for these changes to go into effect.');
            state.notifications.unshift(newFlagData);
        },
        logErrorNotification: (state)=>{
            const newFlagId = state.notifications.length + 1;
            const newFlagData = (0, $8bebd03d19fe43b4$export$4be607b64c8e8c80)(newFlagId, 'There was an error while updating your preferences. Please try again.');
            state.notifications.unshift(newFlagData);
        },
        removeNotification (state) {
            state.notifications.shift();
        },
        setItemState: (state, action)=>{
            const { groupKey: groupKey, tabKey: tabKey, itemKey: itemKey, state: targetState } = action.payload;
            switch(targetState){
                case (0, $e11fceb31fd1a0cb$export$e743037aea74f514).true:
                    state.groups[groupKey].tabs[tabKey].items[itemKey] = (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON;
                    break;
                case (0, $e11fceb31fd1a0cb$export$e743037aea74f514).false:
                    state.groups[groupKey].tabs[tabKey].items[itemKey] = (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF;
                    break;
                case (0, $e11fceb31fd1a0cb$export$e743037aea74f514).busy:
                    state.groups[groupKey].tabs[tabKey].items[itemKey] = undefined;
                    break;
            }
        },
        closeNotification: (state)=>{
            state.actionResult = $3d2cac913f314860$var$initialState.actionResult;
        },
        showAllGroups: (state)=>{
            state.filter = $3d2cac913f314860$var$initialState.filter;
            state.actionResult = $3d2cac913f314860$var$initialState.actionResult;
        },
        showConsentDialog: (state, action)=>{
            state.consentDialog = action.payload;
        },
        showConsentDeclinePrDialog: (state, action)=>{
            state.consentDeclinePrDialog = action.payload;
        },
        showGlobalUnsubscribeDialog: (state, action)=>{
            state.globalUnsubscribeDialog = action.payload;
        },
        showDoubleOptInDialog: (state, action)=>{
            state.doubleOptInDialog = action.payload;
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($3d2cac913f314860$export$a3910a3548679a09.pending, (state, { meta: meta })=>{
            const subscriptionReferralUrlParams = (0, $a87b710a60abd11e$export$a52d76f06c2d44c0)(meta.arg.query);
            if (subscriptionReferralUrlParams.hid || meta.arg.useSso) state.urlQueryParams = subscriptionReferralUrlParams;
            else state.status = {
                status: 'not-found'
            };
        });
        builder.addCase($3d2cac913f314860$export$ffa1c39529f5195b.fulfilled, (state, { payload: payload })=>{
            const { downForMaintenanceMessage: downForMaintenanceMessage, email: email, groups: groups, hid: hid } = payload;
            if (downForMaintenanceMessage != null) state.status = {
                status: 'down-for-maintenance',
                message: downForMaintenanceMessage
            };
            else if (email == null || hid == null) state.status = {
                status: 'not-found'
            };
            else if (groups == null || Object.keys(groups).length === 0) {
                state.email = email;
                state.hid = hid;
                state.status = {
                    status: 'empty'
                };
            } else {
                var _state_urlQueryParams;
                state.status = $3d2cac913f314860$var$initialState.status;
                state.email = email;
                state.hid = hid;
                state.groups = groups;
                state.filter = $3d2cac913f314860$var$findSubscriptionGroup((_state_urlQueryParams = state.urlQueryParams) === null || _state_urlQueryParams === void 0 ? void 0 : _state_urlQueryParams.unsubscribeKeys, state) || $3d2cac913f314860$var$initialState.filter;
                const initialStates = {};
                Object.keys(groups).forEach((groupKey)=>{
                    Object.keys(groups[groupKey].tabs).forEach((tabKey)=>{
                        Object.keys(groups[groupKey].tabs[tabKey].items).forEach((itemKey)=>{
                            initialStates[itemKey] = groups[groupKey].tabs[tabKey].items[itemKey];
                        });
                    });
                });
                state.initialStates = initialStates;
            }
        });
        builder.addCase($3d2cac913f314860$export$807cff22f0457821.fulfilled, (state, { payload: payload })=>{
            if (payload === undefined || payload.groups === undefined) return;
            state.groups = payload.groups;
            // Given the received data, determine if GlobalUnsubscribeDialog Modal should be shown.
            if ($3d2cac913f314860$var$requestGlobalUnsubscribe(state)) state.globalUnsubscribeDialog = {
                showDialog: true
            };
        });
        builder.addCase($3d2cac913f314860$export$ffa1c39529f5195b.rejected, (state, action)=>{
            if (action.payload === 401) state.status = {
                status: 'login-required'
            };
            else state.status = {
                status: 'not-found'
            };
        });
        builder.addCase($3d2cac913f314860$export$34ae4e8891fc3f3d.pending, (state)=>{
            state.actionResult = $3d2cac913f314860$var$initialState.actionResult;
        });
        builder.addCase($3d2cac913f314860$export$34ae4e8891fc3f3d.fulfilled, (state)=>{
            state.actionResult = {
                key: 'unsubscribeAll',
                status: 'success'
            };
            window.scrollTo(0, 0);
        });
        builder.addCase($3d2cac913f314860$export$34ae4e8891fc3f3d.rejected, (state)=>{
            state.actionResult = {
                key: 'request',
                status: 'error'
            };
            window.scrollTo(0, 0);
        });
        builder.addCase($3d2cac913f314860$export$f500693cef883ffd.fulfilled, (state, { payload: payload })=>{
            if (payload.length === 1 && payload[0] === 'all') state.actionResult = {
                key: 'unsubscribeAll',
                status: 'success'
            };
            else state.actionResult = {
                key: 'unsubscribeKeys',
                status: 'success',
                data: payload
            };
            window.scrollTo(0, 0);
        });
        builder.addCase($3d2cac913f314860$export$f500693cef883ffd.rejected, (state)=>{
            state.actionResult = {
                key: 'request',
                status: 'error'
            };
            window.scrollTo(0, 0);
        });
        builder.addCase($3d2cac913f314860$export$ec068583843480e7.fulfilled, (state, { payload: payload })=>{
            state.actionResult = {
                key: 'subscribeKeys',
                status: 'success',
                data: payload
            };
            window.scrollTo(0, 0);
        });
    }
});
const { closeNotification: $3d2cac913f314860$export$d684d3158aada635, setItemState: $3d2cac913f314860$export$b7f4ae9cfec1a518, showAllGroups: $3d2cac913f314860$export$923ce4fee941073a, showConsentDialog: $3d2cac913f314860$export$6b7ef6c2de46cbd4, showConsentDeclinePrDialog: $3d2cac913f314860$export$cab60deb7aecd81e, showGlobalUnsubscribeDialog: $3d2cac913f314860$export$3bb76b2ce1d4f171, showDoubleOptInDialog: $3d2cac913f314860$export$71d5718099bcf953, logSuccessNotification: $3d2cac913f314860$export$6ee970972faf5a9e, logErrorNotification: $3d2cac913f314860$export$40aa0bed012fe51a, removeNotification: $3d2cac913f314860$export$92eb0ea44f8c9242 } = $3d2cac913f314860$var$preferencesSlice.actions;
var $3d2cac913f314860$export$2e2bcd8739ae039 = $3d2cac913f314860$var$preferencesSlice.reducer;



const $a3651c3b6b796a9d$var$NotificationFlagGroup = ()=>{
    const dispatch = (0, $7ef2374eddee6a70$export$f51d452c10d5b956)();
    const notifications = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((state)=>state.preferences.notifications);
    const handleDismiss = ()=>{
        dispatch((0, $3d2cac913f314860$export$92eb0ea44f8c9242)());
    };
    const getIcon = (iconType)=>{
        switch(iconType){
            case 'success':
                return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($a0b2fa96bc548ae3$exports))), {
                    label: "Success",
                    color: (0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.icon.success')
                });
            case 'error':
                return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($641719cc12093410$exports))), {
                    label: "Error",
                    color: (0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.icon.danger')
                });
        }
    };
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $99322f445ba7cde3$export$2e2bcd8739ae039), {
            onDismissed: handleDismiss,
            children: notifications.map((notification)=>notification.isAutoDismissFlag ? /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $a254ace60a4a8d45$export$2e2bcd8739ae039), {
                    id: notification.id,
                    icon: getIcon(notification.iconType),
                    title: notification.title,
                    description: notification.description
                }, notification.key) : /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $374f1491cdd22e01$export$2e2bcd8739ae039), {
                    id: notification.id,
                    icon: getIcon(notification.iconType),
                    title: notification.title,
                    description: notification.description
                }, notification.key))
        })
    });
};
var $a3651c3b6b796a9d$export$2e2bcd8739ae039 = $a3651c3b6b796a9d$var$NotificationFlagGroup;



const $ef58838c74859603$var$layoutContentStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    width: '100%',
    minHeight: 'calc(100vh - var(--topNavigationHeight, 56px))',
    display: 'grid',
    gridTemplateRows: '1fr auto',
    gridTemplateColumns: '100%'
});
const $ef58838c74859603$var$mainStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    margin: '0 auto',
    maxWidth: '1200px',
    padding: 'space.200',
    paddingTop: 'space.400'
});
const $ef58838c74859603$var$LayoutWrapper = ({ headerContent: headerContent, children: children })=>/*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $c69938f751e7a026$export$ffb0004e005737fa), {
        children: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $a8ecf42811a16d58$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $a3651c3b6b796a9d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $d0a14d7762364fd2$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $558934874537b23b$export$2e2bcd8739ae039), {
                        testId: "top-navigation",
                        children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $7092fc21e9894387$export$2e2bcd8739ae039), {
                            headerContent: headerContent
                        })
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d3f7915c8afb3490$export$2e2bcd8739ae039), {
                        testId: "content",
                        children: /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                            xcss: $ef58838c74859603$var$layoutContentStyles,
                            children: [
                                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $9f06dd5f55f9dca6$export$2e2bcd8739ae039), {
                                    testId: "main",
                                    children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                                        xcss: $ef58838c74859603$var$mainStyles,
                                        children: children
                                    })
                                }),
                                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $8bc21533085bc562$export$2e2bcd8739ae039), {})
                            ]
                        })
                    })
                ]
            })
        ]
    });
var $ef58838c74859603$export$2e2bcd8739ae039 = $ef58838c74859603$var$LayoutWrapper;




/* NavigationButton.tsx generated by @compiled/babel-plugin v2.0.0 */ 


var $c6a488ed42a48e22$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::702c7642ca2bbc12ec1dc2b75efbc1ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($c6a488ed42a48e22$exports, "__esModule", {
    value: true
});
$c6a488ed42a48e22$exports.default = void 0;

var $c6a488ed42a48e22$var$_react = $c6a488ed42a48e22$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $c6a488ed42a48e22$var$_baseNew = $c6a488ed42a48e22$var$_interopRequireDefault((parcelRequire("1OCuG")));
function $c6a488ed42a48e22$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6a488ed42a48e22$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c6a488ed42a48e22$var$_react.default.createElement($c6a488ed42a48e22$var$_baseNew.default, Object.assign({
        name: "ArrowRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$c6a488ed42a48e22$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c6a488ed42a48e22$var$_default = $c6a488ed42a48e22$exports.default = $c6a488ed42a48e22$var$ArrowRightIcon;


parcelRequire("7fPBF");


const $6125038cd8bf4a75$var$_5 = "._otyr14lv{margin-bottom:var(--_cpuyf2)}";
const $6125038cd8bf4a75$var$_4 = "._19pkebsi{margin-top:var(--_1ldm4z7)}";
const $6125038cd8bf4a75$var$_3 = "._1bahesu3{justify-content:flex-end}";
const $6125038cd8bf4a75$var$_2 = "._1e0c1txw{display:flex}";
const $6125038cd8bf4a75$var$_ = "._1yt411xh{padding:0 var(--_fhuf0z)}";
const $6125038cd8bf4a75$var$styles = null;
const $6125038cd8bf4a75$var$NavigationButton = ({ isVisible: isVisible, appearance: appearance, onClick: onClick })=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                children: [
                    $6125038cd8bf4a75$var$_,
                    $6125038cd8bf4a75$var$_2,
                    $6125038cd8bf4a75$var$_3,
                    $6125038cd8bf4a75$var$_4,
                    $6125038cd8bf4a75$var$_5
                ]
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("div", {
                className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                    "_1yt411xh _1e0c1txw _1bahesu3 _19pkebsi _otyr14lv"
                ]),
                style: {
                    "--_fhuf0z": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.300')),
                    "--_1ldm4z7": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.negative.200')),
                    "--_cpuyf2": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.200'))
                },
                children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $317b0dc61223a332$export$2e2bcd8739ae039), {
                    appearance: appearance,
                    iconAfter: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($c6a488ed42a48e22$exports))), {
                        label: 'arrow-right-icon',
                        size: 'small'
                    }),
                    onClick: onClick,
                    testId: "navigation-button",
                    children: translate((0, $447ba15143f7eed7$exports).GOTO_PREFERENCES_CENTER_BUTTON_LABEL)
                })
            })
        ]
    });
};
var $6125038cd8bf4a75$export$2e2bcd8739ae039 = $6125038cd8bf4a75$var$NavigationButton;





/* ActionNotification.tsx generated by @compiled/babel-plugin v2.0.0 */ 

parcelRequire("7fPBF");

const $e745f2f77eae858d$export$a2262118789c43db = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.consent.actionResult, (actionResult)=>actionResult);
const $e745f2f77eae858d$export$f4442397935fb087 = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.consent.status, (status)=>status);
const $e745f2f77eae858d$export$e4521e30be8f0d13 = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.consent.urlQueryParams, (urlQueryParams)=>urlQueryParams === null || urlQueryParams === void 0 ? void 0 : urlQueryParams.hid);



/* Notification.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $9tqwB = parcelRequire("9tqwB");


parcelRequire("7fPBF");
/* section-message.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $a8e19196a072296f$var$ATOMIC_GROUP_LENGTH = 5;
function $a8e19196a072296f$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $a8e19196a072296f$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}




var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $bRUy3 = parcelRequire("bRUy3");
function $829dfca01c5f74fd$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null && (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref) === 'object') ref.current = value;
        });
    };
}




var $iKdEz = parcelRequire("iKdEz");

var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");


var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");


var $j9spr = parcelRequire("j9spr");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $eihxX = parcelRequire("eihxX");

var $eaTmW = parcelRequire("eaTmW");

var $eKeTJ = parcelRequire("eKeTJ");

var $l8Sa3 = parcelRequire("l8Sa3");

var $8MJe2 = parcelRequire("8MJe2");

var $bRUy3 = parcelRequire("bRUy3");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $8MJe2 = parcelRequire("8MJe2");
function $9feab80b29d3e7b1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9feab80b29d3e7b1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9feab80b29d3e7b1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9feab80b29d3e7b1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9feab80b29d3e7b1$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $9feab80b29d3e7b1$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $9feab80b29d3e7b1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $9feab80b29d3e7b1$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(updater) === 'object') this.payload = $9feab80b29d3e7b1$var$_objectSpread($9feab80b29d3e7b1$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $3d512310f2e4d93f$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eihxX)))(t, $3d512310f2e4d93f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(t).constructor) : o.apply(t, e));
}
function $3d512310f2e4d93f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3d512310f2e4d93f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $3d512310f2e4d93f$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($eKeTJ)))((0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $3d512310f2e4d93f$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $3d512310f2e4d93f$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $3d512310f2e4d93f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, UIAnalyticsEvent);
        _this = $3d512310f2e4d93f$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($l8Sa3)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $3d512310f2e4d93f$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $9feab80b29d3e7b1$export$2e2bcd8739ae039));



var $7fPBF = parcelRequire("7fPBF");

var $f1192e77f6bd51d0$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $7fPBF.useContext)((0, $e420dde09fb890a4$export$2e2bcd8739ae039));
};


function $a3f5a64cfb7537d3$export$5bf35293e545f20c() {
    var analyticsContext = (0, $f1192e77f6bd51d0$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $6ff1114199100bef$export$33752cf3ee811995)(function(payload) {
        return new (0, $3d512310f2e4d93f$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $7fPBF = parcelRequire("7fPBF");
var $266405aa856934a4$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $7fPBF.useRef)(value);
    ref.current = value;
    return ref;
};


function $c6beef6a43d1d249$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c6beef6a43d1d249$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c6beef6a43d1d249$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c6beef6a43d1d249$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c6beef6a43d1d249$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $a3f5a64cfb7537d3$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $266405aa856934a4$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $266405aa856934a4$export$1d27a74659855e44)(fn);
    var handler = (0, $7fPBF.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $c6beef6a43d1d249$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}


/**
 * An empty function which does nothing.
 */ function $251abc5d608ae7f2$export$2e2bcd8739ae039() {}



var $7fPBF = parcelRequire("7fPBF");

/**
 * Character key codes which can be used in keyboard events.
 */ var $157bdc080ba17a6c$export$390330c10ff2b9a1 = 'ArrowUp';
var $157bdc080ba17a6c$export$a80636c6f41931fe = 'ArrowDown';
var $157bdc080ba17a6c$export$4af703091671bc = 'Home';
var $157bdc080ba17a6c$export$e2bc30913faa5db7 = 'End';
var $157bdc080ba17a6c$export$10f6869ed0a7d75b = 'Tab';
var $157bdc080ba17a6c$export$8152f929a25a0ff4 = 'Enter';
var $157bdc080ba17a6c$export$e51a3576c045c8d5 = 'Space';
var $157bdc080ba17a6c$export$2bb790b9008907b4 = 'Escape';


function $eb906a69ba6e0d42$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $7fPBF.useRef)(false);
    var onKeyDown = (0, $7fPBF.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $157bdc080ba17a6c$export$2bb790b9008907b4)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $7fPBF.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $7fPBF.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $a091c25729a976b1$exports.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}



var $7fPBF = parcelRequire("7fPBF");
function $2cecc30476b65a5e$export$2e2bcd8739ae039(value) {
    var ref = (0, $7fPBF.useRef)(value);
    (0, $7fPBF.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $aa0ac65426838261$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $dcabe3c9c6164ef7$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $7fPBF.createContext)(null);


function $5f015f8e2c849994$export$1d57e79091cc3046() {
    var namespace = (0, $7fPBF.useContext)((0, $dcabe3c9c6164ef7$export$644a49f3b8c50fcd));
    return namespace;
}


function $55e1b101d9344e2a$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $7fPBF.useContext)((0, $aa0ac65426838261$export$5fbf4d7fae6cdc00));
    var namespace = (0, $5f015f8e2c849994$export$1d57e79091cc3046)();
    (0, $7fPBF.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $2ed21daab903509c$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $2ed21daab903509c$var$ExitingContext = /*#__PURE__*/ (0, $7fPBF.createContext)($2ed21daab903509c$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $2ed21daab903509c$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $2ed21daab903509c$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($2ed21daab903509c$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $2ed21daab903509c$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $7fPBF.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $2ed21daab903509c$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $2ed21daab903509c$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $2ed21daab903509c$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $2ed21daab903509c$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $2ed21daab903509c$var$ExitingPersistence = /*#__PURE__*/ (0, $7fPBF.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $7fPBF.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $7fPBF.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $7fPBF.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $2ed21daab903509c$var$childrenToArray(previousChildren);
    var current = $2ed21daab903509c$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $2ed21daab903509c$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $2ed21daab903509c$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $2ed21daab903509c$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $2ed21daab903509c$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $2ed21daab903509c$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $7fPBF.useContext)($2ed21daab903509c$var$ExitingContext);
};
$2ed21daab903509c$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $2ed21daab903509c$export$2e2bcd8739ae039 = $2ed21daab903509c$var$ExitingPersistence;


var $7fPBF = parcelRequire("7fPBF");
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");


var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $4afff59a97f94ea3$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $4afff59a97f94ea3$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$4afff59a97f94ea3$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $4afff59a97f94ea3$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $7fPBF.useState)($4afff59a97f94ea3$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $7fPBF.useEffect)(function() {
        if (!$4afff59a97f94ea3$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $a091c25729a976b1$exports.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $4afff59a97f94ea3$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $4afff59a97f94ea3$export$ff7706047246b98b = function prefersReducedMotion() {
    return $4afff59a97f94ea3$export$f0f789643ba5a83c;
};


/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $3eba637fa282cc33$export$368bacef0dacbe05 = 25;
var $3eba637fa282cc33$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $3eba637fa282cc33$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $3eba637fa282cc33$export$30fa1a2e62ae150c = {
    none: $3eba637fa282cc33$export$38b928a7167ce124.none,
    small: $3eba637fa282cc33$export$38b928a7167ce124.small * $3eba637fa282cc33$var$EXITING_MOTION_MULTIPLIER,
    medium: $3eba637fa282cc33$export$38b928a7167ce124.medium * $3eba637fa282cc33$var$EXITING_MOTION_MULTIPLIER,
    large: $3eba637fa282cc33$export$38b928a7167ce124.large * $3eba637fa282cc33$var$EXITING_MOTION_MULTIPLIER
};



var $7fPBF = parcelRequire("7fPBF");
// Handle both browser and Node.js environments
var $9223b00ccb3e4340$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $9223b00ccb3e4340$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $7fPBF.useRef)([]);
    (0, $7fPBF.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $9223b00ccb3e4340$var$getHookDeps(opts));
    return (0, $7fPBF.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $9223b00ccb3e4340$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $7fPBF.useRef)([]);
    (0, $7fPBF.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $9223b00ccb3e4340$var$getHookDeps(opts));
    return (0, $7fPBF.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};




var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");
/**
 * An empty function which does nothing.
 */ function $e8e58f1425a756a4$export$2e2bcd8739ae039() {}



var $7fPBF = parcelRequire("7fPBF");
var $085a34079f7deec9$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $7fPBF.useEffect) : (0, $7fPBF.useLayoutEffect);


/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $7fPBF = parcelRequire("7fPBF");
function $c77dd9d8a0fa6240$export$c485849f2e393253() {
    var identifier = (0, $7fPBF.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}


var $548fb31a1da9599d$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $7fPBF.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $e8e58f1425a756a4$export$2e2bcd8739ae039)
    };
});
var $548fb31a1da9599d$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $c77dd9d8a0fa6240$export$c485849f2e393253)();
    var context = (0, $7fPBF.useContext)($548fb31a1da9599d$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $548fb31a1da9599d$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $7fPBF.useRef)([]);
    var indexes = [];
    var _useState = (0, $7fPBF.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $085a34079f7deec9$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($548fb31a1da9599d$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $548fb31a1da9599d$export$2e2bcd8739ae039 = $548fb31a1da9599d$var$StaggeredEntrance;


var $b7a085b60be96051$var$zoomIn = null;
var $b7a085b60be96051$var$zoomOut = null;
var $b7a085b60be96051$var$fadeIn = null;
var $b7a085b60be96051$var$fadeOut = null;
var $b7a085b60be96051$var$fadeInFromTop = null;
var $b7a085b60be96051$var$fadeOutFromTop = null;
var $b7a085b60be96051$var$fadeInFromLeft = null;
var $b7a085b60be96051$var$fadeOutFromLeft = null;
var $b7a085b60be96051$var$fadeInFromBottom = null;
var $b7a085b60be96051$var$fadeOutFromBottom = null;
var $b7a085b60be96051$var$fadeInFromRight = null;
var $b7a085b60be96051$var$fadeOutFromRight = null;
var $b7a085b60be96051$var$fadeInFromTopConstant = null;
var $b7a085b60be96051$var$fadeOutFromTopConstant = null;
var $b7a085b60be96051$var$fadeInFromLeftConstant = null;
var $b7a085b60be96051$var$fadeOutFromLeftConstant = null;
var $b7a085b60be96051$var$fadeInFromBottomConstant = null;
var $b7a085b60be96051$var$fadeOutFromBottomConstant = null;
var $b7a085b60be96051$var$fadeInFromRightConstant = null;
var $b7a085b60be96051$var$fadeOutFromRightConstant = null;
var $b7a085b60be96051$var$slideInFromTop = null;
var $b7a085b60be96051$var$slideOutFromTop = null;
var $b7a085b60be96051$var$slideInFromRight = null;
var $b7a085b60be96051$var$slideOutFromRight = null;
var $b7a085b60be96051$var$slideInFromBottom = null;
var $b7a085b60be96051$var$slideOutFromBottom = null;
var $b7a085b60be96051$var$slideInFromLeft = null;
var $b7a085b60be96051$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $b7a085b60be96051$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $548fb31a1da9599d$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $2ed21daab903509c$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $9223b00ccb3e4340$export$4f34107a2b00f39c)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $7fPBF.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $7fPBF.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $4afff59a97f94ea3$export$b7baf7667a68d87c)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $3eba637fa282cc33$export$30fa1a2e62ae150c)[duration] : (0, $3eba637fa282cc33$export$38b928a7167ce124)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
            (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $b7a085b60be96051$export$2e2bcd8739ae039 = $b7a085b60be96051$var$EnteringMotion;


var $3230b5a772f27ff3$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $3230b5a772f27ff3$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $3230b5a772f27ff3$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $b7a085b60be96051$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $3230b5a772f27ff3$export$2e2bcd8739ae039 = $3230b5a772f27ff3$var$FadeIn;




var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");

var $7fPBF = parcelRequire("7fPBF");

var $6dd95b12038218ef$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $6dd95b12038218ef$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $6dd95b12038218ef$export$13f57c02915787b3 = 'atlaskit-portal';


var $6ac48e6c1afb4f92$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $6dd95b12038218ef$export$13f57c02915787b3);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $6ac48e6c1afb4f92$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $6ac48e6c1afb4f92$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $6dd95b12038218ef$export$72f415121273627e));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $6dd95b12038218ef$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = $6ac48e6c1afb4f92$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $6ac48e6c1afb4f92$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $6ac48e6c1afb4f92$var$getPortalParent().removeChild(container);
};
var $6ac48e6c1afb4f92$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $6ac48e6c1afb4f92$var$getPortalParent().appendChild(container);
};
var $6ac48e6c1afb4f92$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $6ac48e6c1afb4f92$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($6ac48e6c1afb4f92$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $6dd95b12038218ef$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
};
var $6ac48e6c1afb4f92$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($6ac48e6c1afb4f92$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $6dd95b12038218ef$export$72f415121273627e));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement('div');
            parent.className = (0, $6dd95b12038218ef$export$e4c79eb95c23a0da);
            parent.style.display = 'flex';
            (_getBody2 = $6ac48e6c1afb4f92$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};


function $c2eb1c9562cd5dfd$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $7fPBF.useMemo)(function() {
        return (0, $6ac48e6c1afb4f92$export$26ae5ca175b4ec5a)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $6ac48e6c1afb4f92$export$c582005add11e141)(container);
    (0, $7fPBF.useEffect)(function() {
        return function() {
            (0, $6ac48e6c1afb4f92$export$da99f98bf3fe55b3)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $b4ba1c853f6e1116$exports.createPortal)(children, container);
}



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
var $cb36cb76319329e6$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);



function $8ad6746e539e668b$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $7fPBF.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $cb36cb76319329e6$export$700979bc83e7db82)(function() {
        var tempPortalContainer = (0, $6ac48e6c1afb4f92$export$fef014d7cef9e543)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $6ac48e6c1afb4f92$export$95029ca7aca2989e)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fPBF.Suspense), {
        fallback: null
    }, children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $b4ba1c853f6e1116$exports.createPortal)(suspendedChildren, atlaskitPortal) : null;
}



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $a859983a00699dcd$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $7fPBF.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $cb36cb76319329e6$export$700979bc83e7db82) : (0, $7fPBF.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $a859983a00699dcd$export$2e2bcd8739ae039 = $a859983a00699dcd$var$useIsSubsequentRender;



var $7fPBF = parcelRequire("7fPBF");
var $99efb1f650022c2a$export$ed5835cc67e87f72 = 'akPortalMount';
var $99efb1f650022c2a$export$80816bd900e5bd00 = 'akPortalUnmount';


var $f83b09929ef7565c$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $f83b09929ef7565c$var$getLayerName = function getLayerName(zIndex) {
    return $f83b09929ef7565c$var$zIndexToName.hasOwnProperty(zIndex) ? $f83b09929ef7565c$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $f83b09929ef7565c$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $f83b09929ef7565c$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $f83b09929ef7565c$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $f83b09929ef7565c$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}


var $0c9a18e9f537b60f$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $7fPBF.useEffect)(function() {
        (0, $f83b09929ef7565c$export$2e2bcd8739ae039)((0, $99efb1f650022c2a$export$ed5835cc67e87f72), zIndexNumber);
        return function() {
            (0, $f83b09929ef7565c$export$2e2bcd8739ae039)((0, $99efb1f650022c2a$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $0c9a18e9f537b60f$export$2e2bcd8739ae039 = $0c9a18e9f537b60f$var$useFirePortalEvent;


function $099a039097f78591$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $a859983a00699dcd$export$2e2bcd8739ae039)(mountStrategy);
    (0, $0c9a18e9f537b60f$export$2e2bcd8739ae039)(zIndex);
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    return !(0, $137Lh.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $c2eb1c9562cd5dfd$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8ad6746e539e668b$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children);
}


/* eslint-disable no-console */ var $cea87828058f094f$var$printed = {};
function $cea87828058f094f$export$2e2bcd8739ae039(message) {
    if ($cea87828058f094f$var$printed[message]) return;
    $cea87828058f094f$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}


function $88a3f946674d63c4$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $cea87828058f094f$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $88a3f946674d63c4$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {}



var $8f68627398411bfa$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $8f68627398411bfa$export$c93026a968943f95 = 'light';
var $8f68627398411bfa$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $8f68627398411bfa$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $d7df1392c2cb1415$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    (0, $88a3f946674d63c4$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $8f68627398411bfa$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $8f68627398411bfa$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $8f68627398411bfa$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $88a3f946674d63c4$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $8f68627398411bfa$export$ba1d834b86d72a09 = $8f68627398411bfa$export$a1b3edb637fb4f35;
var $8f68627398411bfa$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $d7df1392c2cb1415$export$8d43898f60b96a82), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $d7df1392c2cb1415$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $d7df1392c2cb1415$export$920c0d5c49070351), ")")
            }
        }
    };
};


/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $4df4d11522e68ff9$var$registrations = new Set();
var $4df4d11522e68ff9$var$cleanupEndEventListeners = null;
function $4df4d11522e68ff9$var$onDragStart() {
    if ($4df4d11522e68ff9$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $4df4d11522e68ff9$var$cleanupEndEventListeners = (0, $a091c25729a976b1$exports.bindAll)(window, [
        {
            type: 'dragend',
            listener: $4df4d11522e68ff9$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $4df4d11522e68ff9$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $4df4d11522e68ff9$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($4df4d11522e68ff9$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $4df4d11522e68ff9$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $4df4d11522e68ff9$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $4df4d11522e68ff9$var$cleanupEndEventListeners = null;
    var clone = Array.from($4df4d11522e68ff9$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $4df4d11522e68ff9$var$bindStartEvents() {
    return (0, $a091c25729a976b1$exports.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $4df4d11522e68ff9$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $4df4d11522e68ff9$var$onDragStart
        }
    ]);
}
var $4df4d11522e68ff9$var$cleanupStartEventListeners = null;
function $4df4d11522e68ff9$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$4df4d11522e68ff9$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $4df4d11522e68ff9$var$cleanupStartEventListeners = $4df4d11522e68ff9$var$bindStartEvents();
    $4df4d11522e68ff9$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $4df4d11522e68ff9$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $4df4d11522e68ff9$var$registrations.delete(registration);
        if ($4df4d11522e68ff9$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $4df4d11522e68ff9$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $4df4d11522e68ff9$var$cleanupStartEventListeners = null;
        }
    };
}


var $d76c5f4fe8eacdc3$var$delayId = null;
function $d76c5f4fe8eacdc3$export$eaf678f6f93f5250() {
    if ($d76c5f4fe8eacdc3$var$delayId != null) {
        window.clearTimeout($d76c5f4fe8eacdc3$var$delayId);
        $d76c5f4fe8eacdc3$var$delayId = null;
    }
}
function $d76c5f4fe8eacdc3$export$5f4d6617421d489b(fn, delay) {
    $d76c5f4fe8eacdc3$export$eaf678f6f93f5250();
    $d76c5f4fe8eacdc3$var$delayId = window.setTimeout(function() {
        $d76c5f4fe8eacdc3$var$delayId = null;
        fn();
    }, delay);
}


// This file is a singleton for managing tooltips
var $7200cef029097d20$var$active = null;
function $7200cef029097d20$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($7200cef029097d20$var$active && $7200cef029097d20$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $d76c5f4fe8eacdc3$export$eaf678f6f93f5250)();
            $7200cef029097d20$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $d76c5f4fe8eacdc3$export$eaf678f6f93f5250)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $d76c5f4fe8eacdc3$export$eaf678f6f93f5250)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $d76c5f4fe8eacdc3$export$5f4d6617421d489b)(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($7200cef029097d20$var$active && $7200cef029097d20$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($7200cef029097d20$var$active) {
            (0, $d76c5f4fe8eacdc3$export$eaf678f6f93f5250)();
            $7200cef029097d20$var$active.entry.hide({
                isImmediate: true
            });
            $7200cef029097d20$var$active.entry.done();
            $7200cef029097d20$var$active = null;
        }
        // this tooltip is now the active tooltip
        $7200cef029097d20$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $d76c5f4fe8eacdc3$export$5f4d6617421d489b)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}



var $bRUy3 = parcelRequire("bRUy3");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $8d229a0b9f3c696a$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === 'number' || typeof item === 'string') return index ? "idx-".concat(index) : "val-".concat(item);
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};
var $8d229a0b9f3c696a$export$e2a22331486dcca0 = $8d229a0b9f3c696a$export$bdbb4cbb3078e58d();


var $4e2083026e10ea19$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = '';
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $8d229a0b9f3c696a$export$bdbb4cbb3078e58d)()
    };
};
var $4e2083026e10ea19$export$e575061ef2a070eb = $4e2083026e10ea19$export$1921362e86c73c88();
var $4e2083026e10ea19$export$b4d5da5f34fb77ad = $7fPBF.createContext($4e2083026e10ea19$export$1921362e86c73c88());
var $4e2083026e10ea19$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $4e2083026e10ea19$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : '';
};


var $e9144a1b4dc9c62e$var$generateUID = function(context) {
    var quartz = context || (0, $4e2083026e10ea19$export$e575061ef2a070eb);
    var prefix = (0, $4e2083026e10ea19$export$36e24695f02d4503)(quartz);
    var id = (0, $4e2083026e10ea19$export$218c8c3169c024d2)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $e9144a1b4dc9c62e$var$useUIDState = function() {
    var context = (0, $7fPBF.useContext)((0, $4e2083026e10ea19$export$b4d5da5f34fb77ad));
    var uid = (0, $7fPBF.useState)(function() {
        return $e9144a1b4dc9c62e$var$generateUID(context);
    })[0];
    return uid;
};
var $e9144a1b4dc9c62e$export$87d05f07e65211f1 = function() {
    var uid = $e9144a1b4dc9c62e$var$useUIDState().uid;
    return uid;
};
var $e9144a1b4dc9c62e$export$bb5ca5fba6fb4f1f = function() {
    var gen = $e9144a1b4dc9c62e$var$useUIDState().gen;
    return gen;
};



var $137Lh = parcelRequire("137Lh");
var $1874be580c09b9ad$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $1874be580c09b9ad$var$react18UseId = ($1874be580c09b9ad$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useId) !== null && $1874be580c09b9ad$var$_React$useId !== void 0 ? $1874be580c09b9ad$var$_React$useId : undefined;
function $1874be580c09b9ad$export$f680877a34711e37() {
    if ($1874be580c09b9ad$var$react18UseId && (0, $137Lh.fg)('platform-dst-react-18-use-id')) {
        if ((0, $137Lh.fg)('platform-dst-react-18-use-id-selector-safe')) // tl;dr: React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`
        // in hundreds of tests. So we replace it with a safe string of `_` to match future
        // React 19 functionality: https://github.com/facebook/react/pull/33422
        return $1874be580c09b9ad$var$react18UseId().replace(/[:«»]/g, '_');
        return $1874be580c09b9ad$var$react18UseId();
    }
    return "uid".concat((0, $e9144a1b4dc9c62e$export$87d05f07e65211f1)());
}
var $1874be580c09b9ad$export$6be90bcb437e928f = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($1874be580c09b9ad$export$f680877a34711e37()).concat(postfix);
    (0, $7fPBF.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $1874be580c09b9ad$export$6ee17796e3d70de2() {
    if ($1874be580c09b9ad$var$react18UseId && (0, $137Lh.fg)('platform-dst-react-18-use-id')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- cleanup with feature gating
        var uid = $1874be580c09b9ad$export$f680877a34711e37();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $e9144a1b4dc9c62e$export$bb5ca5fba6fb4f1f)();
}


function $dd8b918006d372e7$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $1874be580c09b9ad$export$6ee17796e3d70de2)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}


/* tooltip-container.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $ec507a4930905b6f$var$ATOMIC_GROUP_LENGTH = 5;
function $ec507a4930905b6f$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $ec507a4930905b6f$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $7fPBF = parcelRequire("7fPBF");

/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $bc5652f50b317222$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c81o8v _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
var $bc5652f50b317222$export$5bcbc43c84236222 = function TooltipShortcut(_ref) {
    var shortcut = _ref.shortcut;
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        className: (0, $ec507a4930905b6f$export$2e2bcd8739ae039)([
            $bc5652f50b317222$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map(function(segment, index) {
        return /*#__PURE__*/ $7fPBF.createElement("kbd", {
            key: "".concat(segment, "-").concat(index),
            className: (0, $ec507a4930905b6f$export$2e2bcd8739ae039)([
                $bc5652f50b317222$var$styles.shortcutSegment
            ])
        }, segment);
    }));
};


var $5730497d4606fabe$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $5730497d4606fabe$var$TooltipPrimitive = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $7fPBF.createElement("div", {
        role: "tooltip",
        className: (0, $ec507a4930905b6f$export$2e2bcd8739ae039)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && /*#__PURE__*/ $7fPBF.createElement((0, $bc5652f50b317222$export$5bcbc43c84236222), {
        shortcut: shortcut
    })));
});
$5730497d4606fabe$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $5730497d4606fabe$export$2e2bcd8739ae039 = $5730497d4606fabe$var$TooltipPrimitive;


var $54864e6d5e9e5b85$var$styles = {
    base: "_2rkofajl _11c8dcr7 _vchhusvi _p12fp3fh _bfhkgkf6 _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $54864e6d5e9e5b85$var$TooltipContainer = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $7fPBF.createElement((0, $5730497d4606fabe$export$2e2bcd8739ae039), {
        ref: ref,
        style: style,
        className: (0, $ec507a4930905b6f$export$2e2bcd8739ae039)([
            $54864e6d5e9e5b85$var$styles.base,
            truncate && $54864e6d5e9e5b85$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut
    }, children);
});
$54864e6d5e9e5b85$var$TooltipContainer.displayName = 'TooltipContainer';
var $54864e6d5e9e5b85$export$2e2bcd8739ae039 = $54864e6d5e9e5b85$var$TooltipContainer;


function $bffa5859205d541c$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}


function $02c8d8cf164791b6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $02c8d8cf164791b6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $02c8d8cf164791b6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $02c8d8cf164791b6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $02c8d8cf164791b6$var$tooltipZIndex = (0, $8f68627398411bfa$export$7be255094ccdc533).tooltip();
var $02c8d8cf164791b6$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "20.10.0"
};
// Inverts motion direction
var $02c8d8cf164791b6$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $02c8d8cf164791b6$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $02c8d8cf164791b6$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $54864e6d5e9e5b85$export$2e2bcd8739ae039) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $251abc5d608ae7f2$export$2e2bcd8739ae039) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $251abc5d608ae7f2$export$2e2bcd8739ae039) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn, shortcut = _ref.shortcut;
    var tooltipPosition = position === 'mouse' ? mousePosition : position;
    var onShowHandler = (0, $c6beef6a43d1d249$export$1a04351537078b55)($02c8d8cf164791b6$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $02c8d8cf164791b6$var$analyticsAttributes));
    var onHideHandler = (0, $c6beef6a43d1d249$export$1a04351537078b55)($02c8d8cf164791b6$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $02c8d8cf164791b6$var$analyticsAttributes));
    var apiRef = (0, $7fPBF.useRef)(null);
    var _useState = (0, $7fPBF.useState)('hide'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $7fPBF.useRef)(null);
    var containerRef = (0, $7fPBF.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $7fPBF.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $2cecc30476b65a5e$export$2e2bcd8739ae039)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $2cecc30476b65a5e$export$2e2bcd8739ae039)(onShowHandler);
    var onHideHandlerStable = (0, $2cecc30476b65a5e$export$2e2bcd8739ae039)(onHideHandler);
    var delayStable = (0, $2cecc30476b65a5e$export$2e2bcd8739ae039)(delay);
    var canAppearStable = (0, $2cecc30476b65a5e$export$2e2bcd8739ae039)(canAppear);
    var hasCalledShowHandler = (0, $7fPBF.useRef)(false);
    var start = (0, $7fPBF.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $7fPBF.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $7fPBF.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $7fPBF.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $7fPBF.useRef)(false);
    (0, $7fPBF.useEffect)(function() {
        return (0, $4df4d11522e68ff9$export$6503ec6e8aabbaf)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $7fPBF.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        var api = (0, $7200cef029097d20$export$57bf213be019eeb0)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    var hideTooltipOnEsc = (0, $7fPBF.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $eb906a69ba6e0d42$export$2e2bcd8739ae039)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $7fPBF.useEffect)(function() {
        if (state === 'hide') return 0, $251abc5d608ae7f2$export$2e2bcd8739ae039;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $a091c25729a976b1$exports.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $7fPBF.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $7fPBF.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $7fPBF.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $bffa5859205d541c$export$642213d516a9b928)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $7fPBF.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === 'mouse' ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $bffa5859205d541c$export$642213d516a9b928)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $7fPBF.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $7fPBF.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch (_) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $7fPBF.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $7fPBF.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    var handleOpenLayerObserverCloseSignal = (0, $7fPBF.useCallback)(function() {
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $55e1b101d9344e2a$export$469bb693f11edc7f)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current5;
        if (position === 'mouse' && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePosition) {
            var _apiRef$current6;
            return (_apiRef$current6 = apiRef.current) === null || _apiRef$current6 === void 0 ? void 0 : _apiRef$current6.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $dd8b918006d372e7$export$2e2bcd8739ae039)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // Adding `data-testid` to the TriggerProps interface breaks Buttons, so we use type assertion
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $7fPBF.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, children($02c8d8cf164791b6$var$_objectSpread($02c8d8cf164791b6$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $099a039097f78591$export$2e2bcd8739ae039), {
        zIndex: $02c8d8cf164791b6$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e8027c477e280fef$export$badac9ada3a0bdf9), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === 'mouse' ? undefined : $02c8d8cf164791b6$var$invertedDirection[$02c8d8cf164791b6$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2ed21daab903509c$export$2e2bcd8739ae039), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $3230b5a772f27ff3$export$2e2bcd8739ae039), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $02c8d8cf164791b6$var$_objectSpread($02c8d8cf164791b6$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $02c8d8cf164791b6$export$2e2bcd8739ae039 = $02c8d8cf164791b6$var$Tooltip;



/* button-base.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $emuQy = parcelRequire("emuQy");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $75c608d6b671fa0e$var$ATOMIC_GROUP_LENGTH = 5;
function $75c608d6b671fa0e$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $75c608d6b671fa0e$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");
function $6afd19bdc8eb4b69$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $7fPBF.useRef)(true);
    (0, $7fPBF.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}




var $137Lh = parcelRequire("137Lh");
/* pressable.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");


const $8b53c91ed5888ed9$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $75c608d6b671fa0e$export$2e2bcd8739ae039)(actualStyles);
};



var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");


function $b306b75fafee4635$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b306b75fafee4635$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b306b75fafee4635$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b306b75fafee4635$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b306b75fafee4635$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $a3f5a64cfb7537d3$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $266405aa856934a4$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $266405aa856934a4$export$1d27a74659855e44)(fn);
    var handler = (0, $7fPBF.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $b306b75fafee4635$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}


function $b36fe1c7aef2f1dd$var$testPlatform(re) {
    var _userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_userAgentData = window.navigator['userAgentData']) === null || _userAgentData === void 0 ? void 0 : _userAgentData.platform) || window.navigator.platform) : false;
}
function $b36fe1c7aef2f1dd$var$isIPhone() {
    return $b36fe1c7aef2f1dd$var$testPlatform(/^iPhone/i);
}
function $b36fe1c7aef2f1dd$var$isMac() {
    return $b36fe1c7aef2f1dd$var$testPlatform(/^Mac/i);
}
function $b36fe1c7aef2f1dd$var$isIPad() {
    return $b36fe1c7aef2f1dd$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $b36fe1c7aef2f1dd$var$isMac() && navigator.maxTouchPoints > 1;
}
function $b36fe1c7aef2f1dd$var$isIOS() {
    return $b36fe1c7aef2f1dd$var$isIPhone() || $b36fe1c7aef2f1dd$var$isIPad();
}
function $b36fe1c7aef2f1dd$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use;
        var ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}
function $b36fe1c7aef2f1dd$export$e1865c3bedcd822b() {
    return $b36fe1c7aef2f1dd$var$isMac() || $b36fe1c7aef2f1dd$var$isIOS();
}




/* focusable.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $eaf35c9a5a3efba2$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $eaf35c9a5a3efba2$var$_excluded2 = [
    "className"
];
var $eaf35c9a5a3efba2$var$focusRingStyles = null;
var $eaf35c9a5a3efba2$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $eaf35c9a5a3efba2$var$Focusable = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $eaf35c9a5a3efba2$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $eaf35c9a5a3efba2$var$_excluded2);
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $75c608d6b671fa0e$export$2e2bcd8739ae039)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $eaf35c9a5a3efba2$export$2e2bcd8739ae039 = $eaf35c9a5a3efba2$var$Focusable;


var $edbc7dc1496345d3$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $edbc7dc1496345d3$var$_excluded2 = [
    "className"
];
var $edbc7dc1496345d3$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $edbc7dc1496345d3$var$Pressable = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $251abc5d608ae7f2$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $edbc7dc1496345d3$var$_excluded);
    var interactionContext = (0, $7fPBF.useContext)((0, $48ec410b84640600$export$2e2bcd8739ae039));
    var handleClick = (0, $7fPBF.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $b306b75fafee4635$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $edbc7dc1496345d3$var$_excluded2);
    return /*#__PURE__*/ $7fPBF.createElement((0, $eaf35c9a5a3efba2$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $b36fe1c7aef2f1dd$export$95df08bae54cb4df)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $8b53c91ed5888ed9$export$a274e22fb40f762e)($edbc7dc1496345d3$var$styles.root, isDisabled && $edbc7dc1496345d3$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $edbc7dc1496345d3$export$2e2bcd8739ae039 = $edbc7dc1496345d3$var$Pressable;




var $7fPBF = parcelRequire("7fPBF");
var $aeb3d7d71a8ba7d7$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);
var $aeb3d7d71a8ba7d7$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $7fPBF.useContext)($aeb3d7d71a8ba7d7$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};


function $7f89a6b9b75d6b6b$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $7f89a6b9b75d6b6b$var$tabKeyCode = 9;
function $7f89a6b9b75d6b6b$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $7f89a6b9b75d6b6b$var$tabKeyCode) return;
    $7f89a6b9b75d6b6b$var$abort(event);
}
function $7f89a6b9b75d6b6b$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $7f89a6b9b75d6b6b$var$abort,
        onMouseUpCapture: $7f89a6b9b75d6b6b$var$abort,
        onKeyDownCapture: $7f89a6b9b75d6b6b$var$onKey,
        onKeyUpCapture: $7f89a6b9b75d6b6b$var$onKey,
        onTouchStartCapture: $7f89a6b9b75d6b6b$var$abort,
        onTouchEndCapture: $7f89a6b9b75d6b6b$var$abort,
        onPointerDownCapture: $7f89a6b9b75d6b6b$var$abort,
        onPointerUpCapture: $7f89a6b9b75d6b6b$var$abort,
        onClickCapture: $7f89a6b9b75d6b6b$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $7f89a6b9b75d6b6b$var$abort
    } : events;
}



var $7fPBF = parcelRequire("7fPBF");
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $1045179e72543f64$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);


// Reds
var $0d39188637e59efc$export$4b84fd0e2c617bd = '#FFEBE6';
var $0d39188637e59efc$export$b34b069eff244586 = '#FFBDAD';
var $0d39188637e59efc$export$be802dd0d8b57f35 = '#FF8F73';
var $0d39188637e59efc$export$60847d42f9da92a6 = '#FF7452';
var $0d39188637e59efc$export$4a7404f376229999 = '#FF5630';
var $0d39188637e59efc$export$2010d0fb4295b346 = '#DE350B';
var $0d39188637e59efc$export$2837b5a1a71d5c02 = '#BF2600';
var $0d39188637e59efc$export$8d9596b529bbb9cf = '#FFFAE6';
var $0d39188637e59efc$export$41060a744ab0b7ae = '#FFF0B3';
var $0d39188637e59efc$export$1cc05bbbf340e559 = '#FFE380';
var $0d39188637e59efc$export$5aae31392d72caaa = '#FFC400';
var $0d39188637e59efc$export$c6930421db9fa514 = '#FFAB00';
var $0d39188637e59efc$export$59619663aa6500fb = '#FF991F';
var $0d39188637e59efc$export$874739ea9e379ab6 = '#FF8B00';
var $0d39188637e59efc$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $0d39188637e59efc$export$69a3bf21b9686c2b = '#ABF5D1';
var $0d39188637e59efc$export$afbce1382ec95f73 = '#79F2C0';
var $0d39188637e59efc$export$747d86715d4175de = '#57D9A3';
var $0d39188637e59efc$export$940e1f69e873f202 = '#36B37E';
var $0d39188637e59efc$export$a49394138f7b8e85 = '#00875A';
var $0d39188637e59efc$export$6fa04827ac68a4fb = '#006644';
var $0d39188637e59efc$export$226de0355ed012f8 = '#DEEBFF';
var $0d39188637e59efc$export$8c13c2ee36917869 = '#B3D4FF';
var $0d39188637e59efc$export$ecfc1dff386a3e7a = '#4C9AFF';
var $0d39188637e59efc$export$215b7063051591f1 = '#2684FF';
var $0d39188637e59efc$export$e62e8919cca44969 = '#0065FF';
var $0d39188637e59efc$export$b3de0ae08da2ce64 = '#0052CC';
var $0d39188637e59efc$export$a6ee3d71bc067634 = '#0747A6';
var $0d39188637e59efc$export$67f15409e87642a1 = '#669DF1';
var $0d39188637e59efc$export$f0539dbc42dbb067 = '#8FB8F6';
var $0d39188637e59efc$export$363e4475840015bb = '#EAE6FF';
var $0d39188637e59efc$export$4b0a4417ed59760f = '#C0B6F2';
var $0d39188637e59efc$export$6011520a64d9a187 = '#998DD9';
var $0d39188637e59efc$export$a7175d4e9206bc80 = '#8777D9';
var $0d39188637e59efc$export$b48405b95304b5a1 = '#6554C0';
var $0d39188637e59efc$export$c71e4279dd54a18d = '#5243AA';
var $0d39188637e59efc$export$147899de772240ec = '#403294';
var $0d39188637e59efc$export$2cf711fe14c66f06 = '#E6FCFF';
var $0d39188637e59efc$export$7a8f4d33f6f9772c = '#B3F5FF';
var $0d39188637e59efc$export$776c9c497ef08533 = '#79E2F2';
var $0d39188637e59efc$export$69cb3ca10c1e330e = '#00C7E6';
var $0d39188637e59efc$export$9dc1ef0f3f48059b = '#00B8D9';
var $0d39188637e59efc$export$7c835c78b6fcdef8 = '#00A3BF';
var $0d39188637e59efc$export$6036577f95c3877e = '#008DA6';
var $0d39188637e59efc$export$29a4f05edc054374 = '#FFFFFF';
var $0d39188637e59efc$export$e655ef011c4aa1a2 = '#FAFBFC';
var $0d39188637e59efc$export$9fdfb749e33cdf97 = '#F4F5F7';
var $0d39188637e59efc$export$3e51e8f1440314ba = '#EBECF0';
var $0d39188637e59efc$export$1ce2d1575d444ceb = '#DFE1E6';
var $0d39188637e59efc$export$8754fc7e6d8b3000 = '#C1C7D0';
var $0d39188637e59efc$export$c2e91cbeada39b8b = '#B3BAC5';
var $0d39188637e59efc$export$5f71e19f3a7ad9de = '#A5ADBA';
var $0d39188637e59efc$export$eaa8c8a70ac22806 = '#97A0AF';
var $0d39188637e59efc$export$7c87d337fb91a97d = '#8993A4';
var $0d39188637e59efc$export$d6447c357493214f = '#7A869A';
var $0d39188637e59efc$export$f563ee71e9ee74cd = '#6B778C';
var $0d39188637e59efc$export$e2ef2124cf4024b1 = '#5E6C84';
var $0d39188637e59efc$export$eece5f492e429f08 = '#505F79';
var $0d39188637e59efc$export$c39c0fe0f26207ae = '#42526E';
var $0d39188637e59efc$export$7090862dc3038a9f = '#344563';
var $0d39188637e59efc$export$ad0bacf983b7ddaa = '#253858';
var $0d39188637e59efc$export$7d61b15e0da132af = '#172B4D';
var $0d39188637e59efc$export$fbda843f0a27fe96 = '#091E42';
var $0d39188637e59efc$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $0d39188637e59efc$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $0d39188637e59efc$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $0d39188637e59efc$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $0d39188637e59efc$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $0d39188637e59efc$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $0d39188637e59efc$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $0d39188637e59efc$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $0d39188637e59efc$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $0d39188637e59efc$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $0d39188637e59efc$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $0d39188637e59efc$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $0d39188637e59efc$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $0d39188637e59efc$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $0d39188637e59efc$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $0d39188637e59efc$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $0d39188637e59efc$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $0d39188637e59efc$export$2f6319cf7d736c2a = '#E6EDFA';
var $0d39188637e59efc$export$95126bc8884d6634 = '#DCE5F5';
var $0d39188637e59efc$export$8338d8c35d44ff1 = '#CED9EB';
var $0d39188637e59efc$export$5368d76ae4fbbda7 = '#B8C7E0';
var $0d39188637e59efc$export$9f0a771d16ec8d36 = '#ABBBD6';
var $0d39188637e59efc$export$abcf8c38338b4aa5 = '#9FB0CC';
var $0d39188637e59efc$export$97e81faa16a182c7 = '#8C9CB8';
var $0d39188637e59efc$export$bfe21c59123ecf33 = '#7988A3';
var $0d39188637e59efc$export$ee82aa2ea6a1558 = '#67758F';
var $0d39188637e59efc$export$682927c6ed76be02 = '#56637A';
var $0d39188637e59efc$export$91fd9994c5be9757 = '#455166';
var $0d39188637e59efc$export$d281fbfe3cff2df6 = '#3B475C';
var $0d39188637e59efc$export$3902c91d8b98a753 = '#313D52';
var $0d39188637e59efc$export$8e8133c1ba5845b5 = '#283447';
var $0d39188637e59efc$export$33ff357f6620b39 = '#202B3D';
var $0d39188637e59efc$export$633847cf062b69e0 = '#1B2638';
var $0d39188637e59efc$export$9776a6e503bdbf76 = '#121A29';
var $0d39188637e59efc$export$6c813d5160dff5db = '#0E1624';
var $0d39188637e59efc$export$3d4f271a500072a = '#0D1424';
var $0d39188637e59efc$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $0d39188637e59efc$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $0d39188637e59efc$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $0d39188637e59efc$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $0d39188637e59efc$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $0d39188637e59efc$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $0d39188637e59efc$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $0d39188637e59efc$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $0d39188637e59efc$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $0d39188637e59efc$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $0d39188637e59efc$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $0d39188637e59efc$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $0d39188637e59efc$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $0d39188637e59efc$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $0d39188637e59efc$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $0d39188637e59efc$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $0d39188637e59efc$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $0d39188637e59efc$export$d2adc5dedf09fced = '#292A2E';
var $0d39188637e59efc$export$f51762073d2bb381 = '#94C748';
var $0d39188637e59efc$export$95e26d54def96891 = '#B3DF72';


var $7f36d486e8601cf5$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $a959f5b70a1e1ae4$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $0d39188637e59efc$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-inverse, ".concat((0, $0d39188637e59efc$export$29a4f05edc054374), ")");
}
var $a959f5b70a1e1ae4$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $a959f5b70a1e1ae4$var$loadIn = null;
var $a959f5b70a1e1ae4$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $a959f5b70a1e1ae4$var$useLayoutEffect = typeof window === 'undefined' ? (0, $7fPBF.useEffect) : (0, $7fPBF.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $a959f5b70a1e1ae4$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $7f36d486e8601cf5$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $a959f5b70a1e1ae4$var$getStrokeColor(appearance);
    var context = (0, $7fPBF.useContext)((0, $1045179e72543f64$export$2e2bcd8739ae039));
    $a959f5b70a1e1ae4$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
            $a959f5b70a1e1ae4$var$styles.wrapperStyles,
            $a959f5b70a1e1ae4$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
            $a959f5b70a1e1ae4$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
            $a959f5b70a1e1ae4$var$styles.circleStyles
        ])
    })));
}));
var $a959f5b70a1e1ae4$export$2e2bcd8739ae039 = $a959f5b70a1e1ae4$var$Spinner;


function $8bcd40eb14c0b604$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $8bcd40eb14c0b604$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $8bcd40eb14c0b604$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a959f5b70a1e1ae4$export$2e2bcd8739ae039), {
        size: $8bcd40eb14c0b604$var$getIconSpacing(spacing),
        appearance: $8bcd40eb14c0b604$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}


var $59e5af357e5b399a$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $59e5af357e5b399a$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $59e5af357e5b399a$var$LOADING_LABEL = ', Loading';
var $59e5af357e5b399a$var$styles = {
    base: "_2rkofajl _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhk1fvb _irr31fvb _1di61fvb",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    spacingCompactT26Shape: "_2rko12b0",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $59e5af357e5b399a$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $59e5af357e5b399a$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $59e5af357e5b399a$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $59e5af357e5b399a$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $59e5af357e5b399a$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $59e5af357e5b399a$var$subtleStyles = {
    root: "_bfhkqtfy _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr34mfv _30l3azsu _1di619qy _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $59e5af357e5b399a$var$selectedStyles = {
    root: "_bfhk15s3 _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $59e5af357e5b399a$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
function(_ref, ref) {
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $59e5af357e5b399a$var$_excluded);
    var localRef = (0, $7fPBF.useRef)(null);
    var splitButtonContext = (0, $aeb3d7d71a8ba7d7$export$47e2c6fdb142d947)();
    var loadingLabelId = (0, $1874be580c09b9ad$export$f680877a34711e37)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $6afd19bdc8eb4b69$export$2e2bcd8739ae039)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(unsafeRest, $59e5af357e5b399a$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $edbc7dc1496345d3$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, saferRest, {
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $829dfca01c5f74fd$export$2e2bcd8739ae039)([
            localRef,
            ref
        ]),
        xcss: (0, $e636b2257db42c06$export$a274e22fb40f762e)($59e5af357e5b399a$var$styles.base, (0, $137Lh.fg)('platform-dst-shape-theme-default') && $59e5af357e5b399a$var$styles.baseT26Shape, appearance === 'default' && $59e5af357e5b399a$var$defaultStyles.root, appearance === 'default' && isInteractive && $59e5af357e5b399a$var$defaultStyles.interactive, appearance === 'primary' && $59e5af357e5b399a$var$primaryStyles.root, appearance === 'primary' && isInteractive && $59e5af357e5b399a$var$primaryStyles.interactive, appearance === 'warning' && $59e5af357e5b399a$var$warningStyles.root, appearance === 'warning' && isInteractive && $59e5af357e5b399a$var$warningStyles.interactive, appearance === 'danger' && $59e5af357e5b399a$var$dangerStyles.root, appearance === 'danger' && isInteractive && $59e5af357e5b399a$var$dangerStyles.interactive, appearance === 'discovery' && $59e5af357e5b399a$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $59e5af357e5b399a$var$discoveryStyles.interactive, appearance === 'subtle' && $59e5af357e5b399a$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $59e5af357e5b399a$var$subtleStyles.interactive, $59e5af357e5b399a$var$styles.linkDecorationUnset, isSelected && $59e5af357e5b399a$var$selectedStyles.root, isSelected && isSplitButton && $59e5af357e5b399a$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $59e5af357e5b399a$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $59e5af357e5b399a$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $59e5af357e5b399a$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $59e5af357e5b399a$var$selectedStyles.discovery, isDisabled && $59e5af357e5b399a$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $59e5af357e5b399a$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $59e5af357e5b399a$var$defaultStyles.disabled, isCircle && !isSplitButton && $59e5af357e5b399a$var$styles.circle, spacing === 'compact' && $59e5af357e5b399a$var$styles.spacingCompact, spacing === 'compact' && (0, $137Lh.fg)('platform-dst-shape-theme-default') && $59e5af357e5b399a$var$styles.spacingCompactT26Shape, hasIconBefore && $59e5af357e5b399a$var$styles.buttonIconBefore, shouldFitContainer && $59e5af357e5b399a$var$styles.fullWidth, hasIconAfter && $59e5af357e5b399a$var$styles.buttonIconAfter, isIconButton && $59e5af357e5b399a$var$styles.iconButton, isIconButton && spacing === 'compact' && $59e5af357e5b399a$var$styles.iconButtonCompact, isLoading && $59e5af357e5b399a$var$styles.loading, isSplitButton && $59e5af357e5b399a$var$styles.splitButton, isNavigationSplitButton && $59e5af357e5b399a$var$styles.navigationSplitButton),
        isDisabled: (0, $137Lh.fg)('platform-dst_fix_not_focusable_loading_button') ? isDisabled : isEffectivelyDisabled
    }, (0, $137Lh.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-live': 'polite'
    }, isLoading && (0, $137Lh.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-disabled': true
    }, {
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($59e5af357e5b399a$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $7f89a6b9b75d6b6b$export$2e2bcd8739ae039)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $aeb3d7d71a8ba7d7$export$4b86304b2c0d7e71).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
        className: (0, $75c608d6b671fa0e$export$2e2bcd8739ae039)([
            $59e5af357e5b399a$var$styles.loadingOverlay
        ])
    }, (0, $8bcd40eb14c0b604$export$2e2bcd8739ae039)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d1b9d01570e45f55$export$2e2bcd8739ae039), {
        id: loadingLabelId
    }, $59e5af357e5b399a$var$LOADING_LABEL)));
});
var $59e5af357e5b399a$export$2e2bcd8739ae039 = $59e5af357e5b399a$var$ButtonBase;


/* content.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $7fPBF = parcelRequire("7fPBF");
var $a96744643ef2b167$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    beforeIcon: "_1he91b66 _w795v77o",
    afterIcon: "_1he9v77o _w7951b66",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $a96744643ef2b167$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
        className: (0, $75c608d6b671fa0e$export$2e2bcd8739ae039)([
            $a96744643ef2b167$var$styles.common,
            type === 'text' && $a96744643ef2b167$var$styles.text,
            type === 'icon' && $a96744643ef2b167$var$styles.icon,
            isLoading && $a96744643ef2b167$var$styles.fade,
            position === 'before' && $a96744643ef2b167$var$styles.beforeIcon,
            position === 'after' && $a96744643ef2b167$var$styles.afterIcon
        ])
    }, children);
};
var $a96744643ef2b167$export$2e2bcd8739ae039 = $a96744643ef2b167$var$Content;



var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");
function $b21fac8d8ea3853c$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $b21fac8d8ea3853c$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    var isRenderProp = $b21fac8d8ea3853c$var$isIconRenderProp(Icon);
    var iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $137Lh.fg)('platform_dst_button_chevron_sizing') ? function(iconName) {
            return iconName.startsWith('Chevron') ? 'small' : 'medium';
        } : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Icon, iconProps));
};
var $b21fac8d8ea3853c$export$2e2bcd8739ae039 = $b21fac8d8ea3853c$var$IconRenderer;


var $352e631d3a01791b$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $352e631d3a01791b$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $352e631d3a01791b$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $352e631d3a01791b$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(unsafeRest, $352e631d3a01791b$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $59e5af357e5b399a$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a96744643ef2b167$export$2e2bcd8739ae039), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $b21fac8d8ea3853c$export$2e2bcd8739ae039), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d1b9d01570e45f55$export$2e2bcd8739ae039), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $02c8d8cf164791b6$export$2e2bcd8739ae039), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents,
        shortcut: tooltip === null || tooltip === void 0 ? void 0 : tooltip.shortcut
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $59e5af357e5b399a$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === 'circle',
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $829dfca01c5f74fd$export$2e2bcd8739ae039)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a96744643ef2b167$export$2e2bcd8739ae039), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $b21fac8d8ea3853c$export$2e2bcd8739ae039), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d1b9d01570e45f55$export$2e2bcd8739ae039), null, label)));
    });
}));
$352e631d3a01791b$var$IconButton.displayName = 'IconButton';
var $352e631d3a01791b$export$2e2bcd8739ae039 = $352e631d3a01791b$var$IconButton;


/* heading.partial.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");


var $8MJe2 = parcelRequire("8MJe2");

var $d2a5e011a8583d14$export$4ef52930e33717cd = 'data-theme';
var $d2a5e011a8583d14$export$a00eac3f8684bcd0 = 'data-color-mode';
var $d2a5e011a8583d14$export$2112803007239c61 = 'data-contrast-mode';
var $d2a5e011a8583d14$export$352e418ed5b6193a = 'data-custom-theme';
var $d2a5e011a8583d14$export$6f0c6fb8c80fcc92 = 'ds';
var $d2a5e011a8583d14$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $d2a5e011a8583d14$export$dddac1532e822863 = "--".concat($d2a5e011a8583d14$export$6f0c6fb8c80fcc92, "-token-not-found");
var $d2a5e011a8583d14$export$9d7b58831ae93caa = "--".concat($d2a5e011a8583d14$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $ff9caa2dd565125d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ff9caa2dd565125d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ff9caa2dd565125d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ff9caa2dd565125d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ff9caa2dd565125d$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $ff9caa2dd565125d$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $ff9caa2dd565125d$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $ff9caa2dd565125d$export$632685d741f3dbbf = $ff9caa2dd565125d$var$_objectSpread($ff9caa2dd565125d$var$_objectSpread({}, $ff9caa2dd565125d$export$958d0ae7f2977ae4), $ff9caa2dd565125d$export$d2dc61f58390201c);
var $ff9caa2dd565125d$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $ff9caa2dd565125d$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $ff9caa2dd565125d$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $ff9caa2dd565125d$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $ff9caa2dd565125d$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $ff9caa2dd565125d$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $ff9caa2dd565125d$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $ff9caa2dd565125d$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B778C)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $ff9caa2dd565125d$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $ff9caa2dd565125d$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $ff9caa2dd565125d$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $ff9caa2dd565125d$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $ff9caa2dd565125d$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $ff9caa2dd565125d$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $ff9caa2dd565125d$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $ff9caa2dd565125d$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $ff9caa2dd565125d$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $ff9caa2dd565125d$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $ff9caa2dd565125d$export$e615f061ca585a6c = $ff9caa2dd565125d$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $ff9caa2dd565125d$export$ca0f9c2de39ffed7(spacingProperty, $ff9caa2dd565125d$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $ff9caa2dd565125d$export$bf46c3f9eeafc71f = $ff9caa2dd565125d$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $ff9caa2dd565125d$export$ca0f9c2de39ffed7(spacingProperty, $ff9caa2dd565125d$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $ff9caa2dd565125d$export$e7af83bafe7f9e63 = $ff9caa2dd565125d$export$ca0f9c2de39ffed7('backgroundColor', $ff9caa2dd565125d$export$d1d79bf68ac056bd);
var $ff9caa2dd565125d$export$3a1bcba60b23d7f0 = $ff9caa2dd565125d$export$ca0f9c2de39ffed7('color', $ff9caa2dd565125d$export$8473307aa00d6ea1);
var $ff9caa2dd565125d$export$45f3f4fe16f9f7d5 = $ff9caa2dd565125d$export$ca0f9c2de39ffed7('fontWeight', $ff9caa2dd565125d$export$303e322c6b1ed114);
var $ff9caa2dd565125d$export$68cc305da27dbaa4 = $ff9caa2dd565125d$export$ca0f9c2de39ffed7('fontFamily', $ff9caa2dd565125d$export$3c7e9587132614b4);
var $ff9caa2dd565125d$export$128f10c238242f83 = $ff9caa2dd565125d$export$ca0f9c2de39ffed7('font', $ff9caa2dd565125d$export$6ffa317d5e70375);
var $ff9caa2dd565125d$export$219d364c0da35ae4 = $ff9caa2dd565125d$export$ca0f9c2de39ffed7('font', $ff9caa2dd565125d$export$236bfe3a33ef1292);
var $ff9caa2dd565125d$export$38845ca010b93505 = $ff9caa2dd565125d$export$ca0f9c2de39ffed7('fontWeight', $ff9caa2dd565125d$export$855cfd311192d666);
var $ff9caa2dd565125d$export$ff257d957d48c421 = $ff9caa2dd565125d$export$ca0f9c2de39ffed7((0, $d2a5e011a8583d14$export$9d7b58831ae93caa), $ff9caa2dd565125d$export$41a358c9c2356760);
var $ff9caa2dd565125d$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $ff9caa2dd565125d$export$41a358c9c2356760[color] !== undefined;
};



var $7fPBF = parcelRequire("7fPBF");
var $7792ea71b9e08bdf$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $7fPBF.createContext)('elevation.surface');
var $7792ea71b9e08bdf$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $7fPBF.useContext)($7792ea71b9e08bdf$export$1ca2a26fecb070ae);
};
$7792ea71b9e08bdf$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';



var $7fPBF = parcelRequire("7fPBF");
// Allows support for heading levels 1-9 via aria-level
var $38df12b5706c32a7$var$HeadingLevelContext = /*#__PURE__*/ (0, $7fPBF.createContext)(0);
/**
 * @internal
 * @returns The current heading level context.
 */ var $38df12b5706c32a7$var$useHeadingLevel = function useHeadingLevel() {
    return (0, $7fPBF.useContext)($38df12b5706c32a7$var$HeadingLevelContext);
};
var $38df12b5706c32a7$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $38df12b5706c32a7$var$useHeadingLevel();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $38df12b5706c32a7$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $38df12b5706c32a7$var$useHeadingLevel();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($38df12b5706c32a7$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $38df12b5706c32a7$export$2e2bcd8739ae039 = $38df12b5706c32a7$var$HeadingLevelContextProvider;


var $d3725f4de12370c1$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
var $d3725f4de12370c1$var$styles = {
    reset: "_1mouidpf _1dyz4jg8 _1p1dglyw"
};
var $d3725f4de12370c1$var$headingColorStylesMap = {
    'color.text': "_syaz1fxt",
    'color.text.inverse': "_syaz15cr",
    'color.text.warning.inverse': "_syazal3n"
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c47bed69b7a147a63fdb8c394e98514a>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $d3725f4de12370c1$var$headingSizeStylesMap = {
    xxlarge: "_11c84xcc",
    xlarge: "_11c81c04",
    large: "_11c8nf1z",
    medium: "_11c8lodh",
    small: "_11c8nbxd",
    xsmall: "_11c8140y",
    xxsmall: "_11c81vhk"
};
/**
 * @codegenEnd
 */ var $d3725f4de12370c1$var$useColor = function useColor(colorProp) {
    var surface = (0, $7792ea71b9e08bdf$export$1aeb4f6b93c4540d)();
    if (colorProp) return colorProp;
    if ((0, $ff9caa2dd565125d$export$2185ce37f9bdd963).hasOwnProperty(surface)) return (0, $ff9caa2dd565125d$export$2185ce37f9bdd963)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $d3725f4de12370c1$var$Heading = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
    var children = props.children, size = props.size, id = props.id, testId = props.testId, as = props.as, colorProp = props.color;
    var _useHeading = (0, $38df12b5706c32a7$export$97a37b1befbbf9b1)($d3725f4de12370c1$var$sizeTagMap[size]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === 'div' && hLevel;
    var color = $d3725f4de12370c1$var$useColor(colorProp);
    return /*#__PURE__*/ $7fPBF.createElement(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
            $d3725f4de12370c1$var$styles.reset,
            size && $d3725f4de12370c1$var$headingSizeStylesMap[size],
            $d3725f4de12370c1$var$headingColorStylesMap[color]
        ])
    }, children);
});
var $d3725f4de12370c1$export$2e2bcd8739ae039 = $d3725f4de12370c1$var$Heading;


var $29e89e9de0ccad8a$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($29e89e9de0ccad8a$exports, "__esModule", {
    value: true
});
$29e89e9de0ccad8a$exports.default = void 0;

var $29e89e9de0ccad8a$var$_react = $29e89e9de0ccad8a$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $29e89e9de0ccad8a$var$_baseNew = $29e89e9de0ccad8a$var$_interopRequireDefault((parcelRequire("b0TAn")));
function $29e89e9de0ccad8a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $29e89e9de0ccad8a$var$CrossIcon = (props)=>/*#__PURE__*/ $29e89e9de0ccad8a$var$_react.default.createElement($29e89e9de0ccad8a$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$29e89e9de0ccad8a$var$CrossIcon.displayName = 'CrossIcon';
var $29e89e9de0ccad8a$var$_default = $29e89e9de0ccad8a$exports.default = $29e89e9de0ccad8a$var$CrossIcon;



var $137Lh = parcelRequire("137Lh");
/* inline.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $23c1aab1bdfc6fcf$var$ATOMIC_GROUP_LENGTH = 5;
function $23c1aab1bdfc6fcf$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $23c1aab1bdfc6fcf$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



/* flex.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $bdffc04dc2670e1f$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $bdffc04dc2670e1f$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $bdffc04dc2670e1f$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $bdffc04dc2670e1f$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $bdffc04dc2670e1f$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $bdffc04dc2670e1f$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $bdffc04dc2670e1f$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $bdffc04dc2670e1f$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $bdffc04dc2670e1f$var$Flex = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $bdffc04dc2670e1f$var$_excluded);
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, ariaAttributes, {
        role: role,
        className: (0, $23c1aab1bdfc6fcf$export$2e2bcd8739ae039)([
            $bdffc04dc2670e1f$var$styles.root,
            gap && $bdffc04dc2670e1f$var$columnGapMap[gap],
            columnGap && $bdffc04dc2670e1f$var$columnGapMap[columnGap],
            gap && $bdffc04dc2670e1f$var$rowGapMap[gap],
            rowGap && $bdffc04dc2670e1f$var$rowGapMap[rowGap],
            alignItems && $bdffc04dc2670e1f$var$alignItemsMap[alignItems],
            direction && $bdffc04dc2670e1f$var$flexDirectionMap[direction],
            justifyContent && $bdffc04dc2670e1f$var$justifyContentMap[justifyContent],
            wrap && $bdffc04dc2670e1f$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$bdffc04dc2670e1f$var$Flex.displayName = 'Flex';
var $bdffc04dc2670e1f$export$2e2bcd8739ae039 = $bdffc04dc2670e1f$var$Flex;


var $5fa408adf3a7e83e$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $5fa408adf3a7e83e$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $5fa408adf3a7e83e$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, $23c1aab1bdfc6fcf$export$2e2bcd8739ae039)([
            $5fa408adf3a7e83e$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $5fa408adf3a7e83e$var$Inline = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref2, $5fa408adf3a7e83e$var$_excluded);
    var separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $7fPBF.createElement($5fa408adf3a7e83e$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $7fPBF.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $7fPBF.createElement((0, $7fPBF.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $7fPBF.createElement((0, $bdffc04dc2670e1f$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $e636b2257db42c06$export$a274e22fb40f762e)(grow === 'hug' && $5fa408adf3a7e83e$var$styles.hug, grow === 'fill' && $5fa408adf3a7e83e$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$5fa408adf3a7e83e$var$Inline.displayName = 'Inline';
var $5fa408adf3a7e83e$export$2e2bcd8739ae039 = $5fa408adf3a7e83e$var$Inline;

/* stack.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");



var $866013f255c614e9$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "spread",
    "grow",
    "space",
    "children",
    "testId",
    "xcss",
    "role"
];
var $866013f255c614e9$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $866013f255c614e9$var$Stack = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $866013f255c614e9$var$_excluded);
    return /*#__PURE__*/ $7fPBF.createElement((0, $bdffc04dc2670e1f$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, ariaAttributes, {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $e636b2257db42c06$export$a274e22fb40f762e)(grow === 'hug' && $866013f255c614e9$var$styles.hug, grow === 'fill' && $866013f255c614e9$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$866013f255c614e9$var$Stack.displayName = 'Stack';
var $866013f255c614e9$export$2e2bcd8739ae039 = $866013f255c614e9$var$Stack;



var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");
var $8e33261c5c57c9b6$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b3613c7e18556761a1c0b5ad2c9a88f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($8e33261c5c57c9b6$exports, "__esModule", {
    value: true
});
$8e33261c5c57c9b6$exports.default = void 0;

var $8e33261c5c57c9b6$var$_react = $8e33261c5c57c9b6$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $8e33261c5c57c9b6$var$_baseNew = $8e33261c5c57c9b6$var$_interopRequireDefault((parcelRequire("b0TAn")));
function $8e33261c5c57c9b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusDiscovery".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8e33261c5c57c9b6$var$StatusDiscoveryIcon = (props)=>/*#__PURE__*/ $8e33261c5c57c9b6$var$_react.default.createElement($8e33261c5c57c9b6$var$_baseNew.default, Object.assign({
        name: "StatusDiscoveryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10.5 15.06v-3.81a.75.75 0 0 1 .75-.75h3.81z"/><path fill="currentcolor" fill-rule="evenodd" d="M13 1a2 2 0 0 1 2 2v6h-4.75C9.56 9 9 9.56 9 10.25V15H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM4 9h3V7.5H4zm0-5v1.5h7V4z" clip-rule="evenodd"/>`
    }, props));
$8e33261c5c57c9b6$var$StatusDiscoveryIcon.displayName = 'StatusDiscoveryIcon';
var $8e33261c5c57c9b6$var$_default = $8e33261c5c57c9b6$exports.default = $8e33261c5c57c9b6$var$StatusDiscoveryIcon;


var $a502fe2da2f2733f$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($a502fe2da2f2733f$exports, "__esModule", {
    value: true
});
$a502fe2da2f2733f$exports.default = void 0;

var $a502fe2da2f2733f$var$_react = $a502fe2da2f2733f$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $a502fe2da2f2733f$var$_baseNew = $a502fe2da2f2733f$var$_interopRequireDefault((parcelRequire("b0TAn")));
function $a502fe2da2f2733f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a502fe2da2f2733f$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $a502fe2da2f2733f$var$_react.default.createElement($a502fe2da2f2733f$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$a502fe2da2f2733f$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $a502fe2da2f2733f$var$_default = $a502fe2da2f2733f$exports.default = $a502fe2da2f2733f$var$StatusErrorIcon;


var $75b69a83cb8865ce$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::456639fbdc991aefe1af05acf697365d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($75b69a83cb8865ce$exports, "__esModule", {
    value: true
});
$75b69a83cb8865ce$exports.default = void 0;

var $75b69a83cb8865ce$var$_react = $75b69a83cb8865ce$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $75b69a83cb8865ce$var$_baseNew = $75b69a83cb8865ce$var$_interopRequireDefault((parcelRequire("b0TAn")));
function $75b69a83cb8865ce$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75b69a83cb8865ce$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $75b69a83cb8865ce$var$_react.default.createElement($75b69a83cb8865ce$var$_baseNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$75b69a83cb8865ce$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $75b69a83cb8865ce$var$_default = $75b69a83cb8865ce$exports.default = $75b69a83cb8865ce$var$StatusInformationIcon;


var $21633511c8e1b93e$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($21633511c8e1b93e$exports, "__esModule", {
    value: true
});
$21633511c8e1b93e$exports.default = void 0;

var $21633511c8e1b93e$var$_react = $21633511c8e1b93e$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $21633511c8e1b93e$var$_baseNew = $21633511c8e1b93e$var$_interopRequireDefault((parcelRequire("b0TAn")));
function $21633511c8e1b93e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $21633511c8e1b93e$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $21633511c8e1b93e$var$_react.default.createElement($21633511c8e1b93e$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$21633511c8e1b93e$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $21633511c8e1b93e$var$_default = $21633511c8e1b93e$exports.default = $21633511c8e1b93e$var$StatusSuccessIcon;


var $a86d75d381b64e7e$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee7b3f114c675eea0f953c33a485bcf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($a86d75d381b64e7e$exports, "__esModule", {
    value: true
});
$a86d75d381b64e7e$exports.default = void 0;

var $a86d75d381b64e7e$var$_react = $a86d75d381b64e7e$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $a86d75d381b64e7e$var$_baseNew = $a86d75d381b64e7e$var$_interopRequireDefault((parcelRequire("b0TAn")));
function $a86d75d381b64e7e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a86d75d381b64e7e$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $a86d75d381b64e7e$var$_react.default.createElement($a86d75d381b64e7e$var$_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$a86d75d381b64e7e$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $a86d75d381b64e7e$var$_default = $a86d75d381b64e7e$exports.default = $a86d75d381b64e7e$var$StatusWarningIcon;



function $cff6e30d40c26c68$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cff6e30d40c26c68$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cff6e30d40c26c68$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cff6e30d40c26c68$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cff6e30d40c26c68$var$appearanceIconSchema = {
    information: {
        backgroundColor: "var(--ds-background-information, ".concat((0, $d7df1392c2cb1415$export$226de0355ed012f8), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($75b69a83cb8865ce$exports))),
        primaryIconColor: "var(--ds-icon-information, ".concat((0, $d7df1392c2cb1415$export$a6ee3d71bc067634), ")")
    },
    warning: {
        backgroundColor: "var(--ds-background-warning, ".concat((0, $d7df1392c2cb1415$export$8d9596b529bbb9cf), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($a86d75d381b64e7e$exports))),
        primaryIconColor: "var(--ds-icon-warning, ".concat((0, $d7df1392c2cb1415$export$874739ea9e379ab6), ")")
    },
    error: {
        backgroundColor: "var(--ds-background-danger, ".concat((0, $d7df1392c2cb1415$export$4b84fd0e2c617bd), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($a502fe2da2f2733f$exports))),
        primaryIconColor: "var(--ds-icon-danger, ".concat((0, $d7df1392c2cb1415$export$2837b5a1a71d5c02), ")")
    },
    success: {
        backgroundColor: "var(--ds-background-success, ".concat((0, $d7df1392c2cb1415$export$8a6341c32b6a3ee6), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($21633511c8e1b93e$exports))),
        primaryIconColor: "var(--ds-icon-success, ".concat((0, $d7df1392c2cb1415$export$6fa04827ac68a4fb), ")")
    },
    discovery: {
        backgroundColor: "var(--ds-background-discovery, ".concat((0, $d7df1392c2cb1415$export$363e4475840015bb), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($8e33261c5c57c9b6$exports))),
        primaryIconColor: "var(--ds-icon-discovery, ".concat((0, $d7df1392c2cb1415$export$147899de772240ec), ")")
    }
};
function $cff6e30d40c26c68$export$e9b82d2e21ac0c1f(appearance, icon) {
    var appearanceIconStyles = $cff6e30d40c26c68$var$appearanceIconSchema[appearance] || $cff6e30d40c26c68$var$appearanceIconSchema.information;
    var AppearanceIcon = function AppearanceIcon(_ref) {
        var primaryColor = _ref.primaryColor;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(appearanceIconStyles.Icon, {
            color: primaryColor,
            spacing: "spacious",
            label: appearance
        });
    };
    var Icon = icon || AppearanceIcon;
    return $cff6e30d40c26c68$var$_objectSpread($cff6e30d40c26c68$var$_objectSpread({}, appearanceIconStyles), {}, {
        Icon: Icon
    });
}


var $91a181e7dea5ded3$var$sectionMessageStyles = {
    container: "_2rko12b0 _1rjcpxbi _18zrpxbi _1nmz1hna",
    containerT26Shape: "_2rko1mok",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c8fhey _syazi7uo",
    actionsContainer: "_11c8fhey",
    dismissButtonContainer: "_1pfh1i6y"
};
var $91a181e7dea5ded3$var$appearanceStyles = {
    information: "_bfhk19ip",
    warning: "_bfhk1917",
    error: "_bfhk1gly",
    success: "_bfhk1y9u",
    discovery: "_bfhk6vm6"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ var $91a181e7dea5ded3$var$SectionMessage = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function SectionMessage(_ref, ref) {
    var children = _ref.children, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'information' : _ref$appearance, actions = _ref.actions, title = _ref.title, icon = _ref.icon, isDismissible = _ref.isDismissible, onDismiss = _ref.onDismiss, testId = _ref.testId;
    var _useState = (0, $7fPBF.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), dismissed = _useState2[0], setDismissed = _useState2[1];
    var handleDismiss = (0, $7fPBF.useCallback)(function() {
        onDismiss === null || onDismiss === void 0 || onDismiss();
        setDismissed(true);
    }, [
        onDismiss
    ]);
    var _getAppearanceIconSty = (0, $cff6e30d40c26c68$export$e9b82d2e21ac0c1f)(appearance, icon), primaryColor = _getAppearanceIconSty.primaryIconColor, secondaryColor = _getAppearanceIconSty.backgroundColor, Icon = _getAppearanceIconSty.Icon;
    var actionElements = actions && actions.type === (0, $7fPBF.Fragment) ? actions.props.children : actions;
    var actionsArray = (0, $7fPBF.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ $7fPBF.createElement("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
            $91a181e7dea5ded3$var$sectionMessageStyles.container,
            (0, $137Lh.fg)('platform-dst-shape-theme-default') && $91a181e7dea5ded3$var$sectionMessageStyles.containerT26Shape,
            $91a181e7dea5ded3$var$appearanceStyles[appearance]
        ])
    }, /*#__PURE__*/ $7fPBF.createElement((0, $5fa408adf3a7e83e$export$2e2bcd8739ae039), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ $7fPBF.createElement("div", {
        className: (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
            $91a181e7dea5ded3$var$sectionMessageStyles.iconContainer
        ])
    }, /*#__PURE__*/ $7fPBF.createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        color: primaryColor,
        spacing: "spacious"
    })), /*#__PURE__*/ $7fPBF.createElement((0, $866013f255c614e9$export$2e2bcd8739ae039), {
        space: "space.100",
        testId: testId && "".concat(testId, "--content"),
        xcss: $91a181e7dea5ded3$var$sectionMessageStyles.contentContainer
    }, !!title && /*#__PURE__*/ $7fPBF.createElement((0, $d3725f4de12370c1$export$2e2bcd8739ae039), {
        as: "h2",
        size: "small"
    }, title), /*#__PURE__*/ $7fPBF.createElement("div", {
        className: (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
            $91a181e7dea5ded3$var$sectionMessageStyles.content
        ])
    }, children), actionsArray.length > 0 && /*#__PURE__*/ $7fPBF.createElement((0, $5fa408adf3a7e83e$export$2e2bcd8739ae039), {
        shouldWrap: true,
        testId: testId && "".concat(testId, "--actions"),
        separator: "\xB7",
        space: "space.100",
        rowSpace: "space.0",
        role: actionsArray.length > 1 ? 'list' : undefined,
        xcss: $91a181e7dea5ded3$var$sectionMessageStyles.actionsContainer
    }, actionsArray.map(function(action, id) {
        return(/*#__PURE__*/ // Only use a listitem role if more than one action is present
        $7fPBF.createElement((0, $5fa408adf3a7e83e$export$2e2bcd8739ae039), {
            role: actionsArray.length > 1 ? 'listitem' : undefined,
            key: id
        }, action));
    }))), isDismissible && /*#__PURE__*/ $7fPBF.createElement("div", {
        className: (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
            $91a181e7dea5ded3$var$sectionMessageStyles.dismissButtonContainer
        ])
    }, /*#__PURE__*/ $7fPBF.createElement((0, $352e631d3a01791b$export$2e2bcd8739ae039), {
        testId: testId && "".concat(testId, "--dismiss-button"),
        label: "Dismiss",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($29e89e9de0ccad8a$exports))),
        appearance: "subtle",
        onClick: handleDismiss,
        spacing: "compact"
    }))));
});
$91a181e7dea5ded3$var$SectionMessage.displayName = 'SectionMessage';
var $91a181e7dea5ded3$export$2e2bcd8739ae039 = $91a181e7dea5ded3$var$SectionMessage;

/* section-message-action.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $7fPBF = parcelRequire("7fPBF");



var $iKdEz = parcelRequire("iKdEz");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");


var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");
var $14df6e03fac80ed6$var$_excluded = [
    "children"
];
function $14df6e03fac80ed6$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $7fPBF.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $7fPBF.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(props, $14df6e03fac80ed6$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $7fPBF.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $7fPBF.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}


// Create default global light theme
var $034bea2d324ecf61$var$_createTheme = (0, $14df6e03fac80ed6$export$25d302a5b900a763)(function() {
    return {
        mode: 'light'
    };
}), $034bea2d324ecf61$var$Provider = $034bea2d324ecf61$var$_createTheme.Provider, $034bea2d324ecf61$var$Consumer = $034bea2d324ecf61$var$_createTheme.Consumer, $034bea2d324ecf61$export$7692396083754928 = $034bea2d324ecf61$var$_createTheme.useTheme;
var $034bea2d324ecf61$var$Theme = {
    Provider: $034bea2d324ecf61$var$Provider,
    Consumer: $034bea2d324ecf61$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$034bea2d324ecf61$export$2e2bcd8739ae039 = $034bea2d324ecf61$var$Theme;




var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");







function $4c63706c235afb73$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $4c63706c235afb73$var$tabKeyCode = 9;
function $4c63706c235afb73$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $4c63706c235afb73$var$tabKeyCode) return;
    $4c63706c235afb73$var$abort(event);
}
var $4c63706c235afb73$var$block = {
    onMouseDownCapture: $4c63706c235afb73$var$abort,
    onMouseUpCapture: $4c63706c235afb73$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $4c63706c235afb73$var$onKey,
    onKeyUpCapture: $4c63706c235afb73$var$onKey,
    onTouchStartCapture: $4c63706c235afb73$var$abort,
    onTouchEndCapture: $4c63706c235afb73$var$abort,
    onPointerDownCapture: $4c63706c235afb73$var$abort,
    onPointerUpCapture: $4c63706c235afb73$var$abort,
    onClickCapture: $4c63706c235afb73$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $4c63706c235afb73$var$abort
};
var $4c63706c235afb73$var$doNotBlock = {};
function $4c63706c235afb73$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $4c63706c235afb73$var$doNotBlock : $4c63706c235afb73$var$block;
}



var $8MJe2 = parcelRequire("8MJe2");


var $137Lh = parcelRequire("137Lh");
function $2a26d846f98f39cb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2a26d846f98f39cb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2a26d846f98f39cb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2a26d846f98f39cb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2a26d846f98f39cb$var$gridSize = 8;
var $2a26d846f98f39cb$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $2a26d846f98f39cb$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: 'auto'
};
var $2a26d846f98f39cb$var$lineHeights = {
    default: $2a26d846f98f39cb$var$heights.default,
    compact: $2a26d846f98f39cb$var$heights.compact,
    none: 'inherit'
};
var $2a26d846f98f39cb$var$padding = {
    // 10px gutter
    default: "0 ".concat($2a26d846f98f39cb$var$gridSize + $2a26d846f98f39cb$var$gridSize / 4, "px"),
    compact: "0 ".concat($2a26d846f98f39cb$var$gridSize + $2a26d846f98f39cb$var$gridSize / 4, "px"),
    none: '0'
};
var $2a26d846f98f39cb$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($2a26d846f98f39cb$var$gridSize / 4, "px"),
    default: "0 ".concat($2a26d846f98f39cb$var$gridSize / 4, "px"),
    none: '0'
};
var $2a26d846f98f39cb$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
var $2a26d846f98f39cb$var$innerMargin = {
    content: "0 ".concat($2a26d846f98f39cb$var$gridSize / 4, "px"),
    icon: "0 ".concat($2a26d846f98f39cb$var$gridSize / 4, "px")
};
var $2a26d846f98f39cb$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
var $2a26d846f98f39cb$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': $2a26d846f98f39cb$var$_objectSpread($2a26d846f98f39cb$var$_objectSpread({}, $2a26d846f98f39cb$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    }),
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $2a26d846f98f39cb$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    }
};
var $2a26d846f98f39cb$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    }
};
var $2a26d846f98f39cb$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
var $2a26d846f98f39cb$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    }
};
var $2a26d846f98f39cb$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    }
};
var $2a26d846f98f39cb$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $2a26d846f98f39cb$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': $2a26d846f98f39cb$var$_objectSpread($2a26d846f98f39cb$var$_objectSpread({}, $2a26d846f98f39cb$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    })
};
var $2a26d846f98f39cb$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $2a26d846f98f39cb$export$955358618f994a11(_ref) {
    var appearance = _ref.appearance, spacing = _ref.spacing, isSelected = _ref.isSelected, shouldFitContainer = _ref.shouldFitContainer, isOnlySingleIcon = _ref.isOnlySingleIcon;
    return $2a26d846f98f39cb$var$_objectSpread($2a26d846f98f39cb$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: (0, $137Lh.fg)('platform-dst-shape-theme-default') ? "var(--ds-radius-medium, 6px)" : "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: $2a26d846f98f39cb$var$heights[spacing],
        lineHeight: $2a26d846f98f39cb$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $2a26d846f98f39cb$var$singleIconPadding[spacing] : $2a26d846f98f39cb$var$padding[spacing],
        verticalAlign: $2a26d846f98f39cb$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center'
    }, isSelected ? $2a26d846f98f39cb$var$selectedStyles : $2a26d846f98f39cb$var$_objectSpread($2a26d846f98f39cb$var$_objectSpread($2a26d846f98f39cb$var$_objectSpread($2a26d846f98f39cb$var$_objectSpread($2a26d846f98f39cb$var$_objectSpread($2a26d846f98f39cb$var$_objectSpread($2a26d846f98f39cb$var$_objectSpread($2a26d846f98f39cb$var$_objectSpread({}, appearance === 'default' && $2a26d846f98f39cb$var$defaultStyles), appearance === 'primary' && $2a26d846f98f39cb$var$primaryStyles), appearance === 'link' && $2a26d846f98f39cb$var$linkStyles), appearance === 'subtle' && $2a26d846f98f39cb$var$subtleStyles), appearance === 'subtle-link' && $2a26d846f98f39cb$var$subtleLinkStyles), appearance === 'warning' && $2a26d846f98f39cb$var$warningStyles), appearance === 'danger' && $2a26d846f98f39cb$var$dangerStyles), {}, {
        '&[disabled]': {
            color: "var(--ds-text-disabled, #080F214A)",
            backgroundColor: $2a26d846f98f39cb$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent',
            cursor: 'not-allowed',
            textDecoration: 'none',
            '&:hovered': {
                backgroundColor: $2a26d846f98f39cb$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent'
            },
            '&:active': {
                backgroundColor: $2a26d846f98f39cb$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent'
            }
        }
    }, $2a26d846f98f39cb$var$hasOverlayStyles)), {}, {
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $2a26d846f98f39cb$export$864eea3f4ec3368f(_ref2) {
    var spacing = _ref2.spacing;
    return (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $2a26d846f98f39cb$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}
function $2a26d846f98f39cb$export$7ad0316cc0dd65a(_ref3) {
    var spacing = _ref3.spacing;
    return (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $2a26d846f98f39cb$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}
function $2a26d846f98f39cb$export$1b5827d324e945b1(_ref4) {
    var hasOverlay = _ref4.hasOverlay;
    return (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}
var $2a26d846f98f39cb$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};



var $7fPBF = parcelRequire("7fPBF");

var $2d565e5f20f59a81$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $7fPBF.isValidElement)(children) && children.type === (0, $d1b9d01570e45f55$export$2e2bcd8739ae039);
};


var $a62ad84e2d8e5d7c$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $a62ad84e2d8e5d7c$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $a62ad84e2d8e5d7c$var$iconBeforeSpacingFixStyle = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $a62ad84e2d8e5d7c$var$iconAfterSpacingFixStyle = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $a62ad84e2d8e5d7c$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $2d565e5f20f59a81$export$20bbd2efb0d734c4)(children)) return null;
    return spacingStyles;
};
var $a62ad84e2d8e5d7c$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $2d565e5f20f59a81$export$20bbd2efb0d734c4)(children)) return children;
    return children ? (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("span", {
        css: childrenStyles
    }, children) : null;
};
var $a62ad84e2d8e5d7c$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'default' : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? 'a' : 'button' : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $251abc5d608ae7f2$export$2e2bcd8739ae039) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $251abc5d608ae7f2$export$2e2bcd8739ae039) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 'default' : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? 'button' : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(props, $a62ad84e2d8e5d7c$var$_excluded);
    var ourRef = (0, $7fPBF.useRef)();
    var setRef = (0, $7fPBF.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $6afd19bdc8eb4b69$export$2e2bcd8739ae039)(ourRef, autoFocus);
    var interactionContext = (0, $7fPBF.useContext)((0, $48ec410b84640600$export$2e2bcd8739ae039));
    var handleClick = (0, $7fPBF.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $b306b75fafee4635$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@atlaskit/button",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $7fPBF.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $7fPBF.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)((0, $2a26d846f98f39cb$export$1b5827d324e945b1)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $d7df1392c2cb1415$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $d7df1392c2cb1415$export$c39c0fe0f26207ae), ")"), " !important")
        }
    };
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $1cc23763944a34fc$export$2e2bcd8739ae039), null, (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $a62ad84e2d8e5d7c$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $4c63706c235afb73$export$2e2bcd8739ae039)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $2a26d846f98f39cb$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $a62ad84e2d8e5d7c$var$getSpacingFix(children, $a62ad84e2d8e5d7c$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $a62ad84e2d8e5d7c$var$getChildren(children, [
        fadeStyles,
        (0, $2a26d846f98f39cb$export$7ad0316cc0dd65a)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $2a26d846f98f39cb$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $a62ad84e2d8e5d7c$var$getSpacingFix(children, $a62ad84e2d8e5d7c$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("span", {
        css: [
            (0, $2a26d846f98f39cb$export$1a9fe1b84c876bb5),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a62ad84e2d8e5d7c$export$2e2bcd8739ae039 = $a62ad84e2d8e5d7c$var$ButtonBase;




function $82f4d4fc20d65bbe$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $2d565e5f20f59a81$export$20bbd2efb0d734c4)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}


var $2808c53964b8171a$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $2808c53964b8171a$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var $2808c53964b8171a$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $251abc5d608ae7f2$export$2e2bcd8739ae039) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $251abc5d608ae7f2$export$2e2bcd8739ae039) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $2808c53964b8171a$var$_excluded);
    var _useGlobalTheme = (0, $034bea2d324ecf61$export$7692396083754928)(), mode = _useGlobalTheme.mode;
    var isOnlySingleIcon = (0, $82f4d4fc20d65bbe$export$2e2bcd8739ae039)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $7fPBF.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    var onMouseDown = (0, $7fPBF.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($2808c53964b8171a$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $7fPBF.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($2808c53964b8171a$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $7fPBF.useMemo)(function() {
        return (0, $2a26d846f98f39cb$export$955358618f994a11)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a62ad84e2d8e5d7c$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$2808c53964b8171a$var$Button.displayName = 'Button';
var $2808c53964b8171a$export$2e2bcd8739ae039 = $2808c53964b8171a$var$Button;



/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $e8d263de07a52c6a$var$ATOMIC_GROUP_LENGTH = 5;
function $e8d263de07a52c6a$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $e8d263de07a52c6a$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



/* anchor.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $bRUy3 = parcelRequire("bRUy3");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");


const $9ab9c3cc2d020754$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $23c1aab1bdfc6fcf$export$2e2bcd8739ae039)(actualStyles);
};





var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $a0189d1a495196e5$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $7fPBF.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $a0189d1a495196e5$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($a0189d1a495196e5$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $a0189d1a495196e5$export$2e2bcd8739ae039 = $a0189d1a495196e5$var$RouterLinkProvider;


/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $260902f14aa9119e$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $7fPBF.useContext)((0, $a0189d1a495196e5$export$2931e0ee690eee88)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $260902f14aa9119e$export$2e2bcd8739ae039 = $260902f14aa9119e$var$useRouterLink;






/* focusable.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $de5629ef2a2a7bcc$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $de5629ef2a2a7bcc$var$_excluded2 = [
    "className"
];
var $de5629ef2a2a7bcc$var$focusRingStyles = null;
var $de5629ef2a2a7bcc$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $de5629ef2a2a7bcc$var$Focusable = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $de5629ef2a2a7bcc$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $de5629ef2a2a7bcc$var$_excluded2);
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $23c1aab1bdfc6fcf$export$2e2bcd8739ae039)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $de5629ef2a2a7bcc$export$2e2bcd8739ae039 = $de5629ef2a2a7bcc$var$Focusable;


var $7fd621ed5675fa49$var$_excluded = [
    "href",
    "children",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss",
    "newWindowLabel"
], $7fd621ed5675fa49$var$_excluded2 = [
    "className"
];
var $7fd621ed5675fa49$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
var $7fd621ed5675fa49$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $7fd621ed5675fa49$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $7fd621ed5675fa49$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $251abc5d608ae7f2$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, _ref$newWindowLabel = _ref.newWindowLabel, newWindowLabel = _ref$newWindowLabel === void 0 ? '(opens new window)' : _ref$newWindowLabel, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $7fd621ed5675fa49$var$_excluded);
    var interactionContext = (0, $7fPBF.useContext)((0, $48ec410b84640600$export$2e2bcd8739ae039));
    var handleClick = (0, $7fPBF.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $1874be580c09b9ad$export$f680877a34711e37)();
    var onClick = (0, $b306b75fafee4635$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "@atlaskit/primitives",
        packageVersion: "17.1.0",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $7fd621ed5675fa49$var$_excluded2);
    var RouterLink = (0, $260902f14aa9119e$export$2e2bcd8739ae039)();
    var isExternal = typeof href === 'string' && $7fd621ed5675fa49$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $7fd621ed5675fa49$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(href) === 'object';
    (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $7fPBF.createElement((0, $de5629ef2a2a7bcc$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        xcss: (0, $9ab9c3cc2d020754$export$a274e22fb40f762e)($7fd621ed5675fa49$var$styles.root, $7fd621ed5675fa49$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }), children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ $7fPBF.createElement((0, $d1b9d01570e45f55$export$2e2bcd8739ae039), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $7fd621ed5675fa49$var$Anchor = /*#__PURE__*/ (0, $7fPBF.forwardRef)($7fd621ed5675fa49$var$AnchorNoRef);
var $7fd621ed5675fa49$export$2e2bcd8739ae039 = $7fd621ed5675fa49$var$Anchor;

/* box.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
var $7f77d4b244246ed5$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $7fPBF.createContext)('elevation.surface');
var $7f77d4b244246ed5$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $7fPBF.useContext)($7f77d4b244246ed5$export$1ca2a26fecb070ae);
};
$7f77d4b244246ed5$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


var $046496fb8108649c$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $046496fb8108649c$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $046496fb8108649c$var$baseStyles = null;
var $046496fb8108649c$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhkby5v",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $046496fb8108649c$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $046496fb8108649c$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $046496fb8108649c$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $046496fb8108649c$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $046496fb8108649c$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $046496fb8108649c$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $046496fb8108649c$var$Box = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $046496fb8108649c$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $046496fb8108649c$var$_excluded2);
    var node = /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        style: style,
        ref: ref,
        className: (0, $23c1aab1bdfc6fcf$export$2e2bcd8739ae039)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $046496fb8108649c$var$backgroundColorMap[backgroundColor],
            backgroundColor && $046496fb8108649c$var$isSurfaceToken(backgroundColor) && $046496fb8108649c$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $046496fb8108649c$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $046496fb8108649c$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $046496fb8108649c$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $046496fb8108649c$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $7fPBF.createElement((0, $7f77d4b244246ed5$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $046496fb8108649c$export$2e2bcd8739ae039 = $046496fb8108649c$var$Box;
function $046496fb8108649c$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $046496fb8108649c$var$setSurfaceTokenMap;
}


var $1f2edd6b838e2b0d$var$_excluded = [
    "children",
    "testId",
    "appearance",
    "newWindowLabel",
    "target",
    "className",
    "style"
];
var $1f2edd6b838e2b0d$var$styles = {
    visitedLink: "_ect4ttxp _10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _ect4ttxp _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _ect4ttxp _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _ect4ttxp _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
var $1f2edd6b838e2b0d$var$iconStyles = null;
var $1f2edd6b838e2b0d$var$LinkWithoutRef = function LinkWithoutRef(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, newWindowLabel = _ref.newWindowLabel, target = _ref.target, _preventedClassName = _ref.className, _preventedStyle = _ref.style, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $1f2edd6b838e2b0d$var$_excluded);
    return /*#__PURE__*/ $7fPBF.createElement((0, $7fd621ed5675fa49$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, htmlAttributes, {
        target: target,
        ref: ref,
        xcss: (0, $e636b2257db42c06$export$a274e22fb40f762e)(appearance === 'default' && $1f2edd6b838e2b0d$var$styles.defaultAppearance, appearance === 'subtle' && $1f2edd6b838e2b0d$var$styles.subtleAppearance, appearance === 'inverse' && $1f2edd6b838e2b0d$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $1f2edd6b838e2b0d$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }), children, target === '_blank' && /*#__PURE__*/ $7fPBF.createElement((0, $046496fb8108649c$export$2e2bcd8739ae039), {
        as: "span",
        xcss: $1f2edd6b838e2b0d$var$styles.iconWrapper,
        testId: testId && "".concat(testId, "__icon")
    }, "\uFEFF", /*#__PURE__*/ $7fPBF.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $e8d263de07a52c6a$export$2e2bcd8739ae039)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ var $1f2edd6b838e2b0d$var$Link = /*#__PURE__*/ (0, $7fPBF.forwardRef)($1f2edd6b838e2b0d$var$LinkWithoutRef);
var $1f2edd6b838e2b0d$export$2e2bcd8739ae039 = $1f2edd6b838e2b0d$var$Link;


/* pressable.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");







var $2e8490be0b0e330f$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $2e8490be0b0e330f$var$_excluded2 = [
    "className"
];
var $2e8490be0b0e330f$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $2e8490be0b0e330f$var$Pressable = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $251abc5d608ae7f2$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $2e8490be0b0e330f$var$_excluded);
    var interactionContext = (0, $7fPBF.useContext)((0, $48ec410b84640600$export$2e2bcd8739ae039));
    var handleClick = (0, $7fPBF.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $b306b75fafee4635$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "17.1.0",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $2e8490be0b0e330f$var$_excluded2);
    return /*#__PURE__*/ $7fPBF.createElement((0, $de5629ef2a2a7bcc$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $b36fe1c7aef2f1dd$export$95df08bae54cb4df)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $9ab9c3cc2d020754$export$a274e22fb40f762e)($2e8490be0b0e330f$var$styles.root, isDisabled && $2e8490be0b0e330f$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $2e8490be0b0e330f$export$2e2bcd8739ae039 = $2e8490be0b0e330f$var$Pressable;


var $c5afab4d5c610ba2$var$styles = {
    common: "_11c8fhey",
    anchor: "_k48pi7a9",
    pressable: "_syaz13af _k48p1wq8 _bfhk1j28 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _9h8h12zz"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ var $c5afab4d5c610ba2$var$SectionMessageAction = /*#__PURE__*/ (0, $7fPBF.memo)(function SectionMessageAction(_ref) {
    var children = _ref.children, onClick = _ref.onClick, href = _ref.href, testId = _ref.testId, linkComponent = _ref.linkComponent, target = _ref.target;
    if (!linkComponent) {
        if (href) return /*#__PURE__*/ $7fPBF.createElement("span", {
            className: (0, $a8e19196a072296f$export$2e2bcd8739ae039)([
                $c5afab4d5c610ba2$var$styles.common,
                $c5afab4d5c610ba2$var$styles.anchor
            ])
        }, /*#__PURE__*/ $7fPBF.createElement((0, $1f2edd6b838e2b0d$export$2e2bcd8739ae039), {
            testId: testId,
            onClick: onClick,
            href: href,
            target: target
        }, children));
        if (onClick) return /*#__PURE__*/ $7fPBF.createElement((0, $2e8490be0b0e330f$export$2e2bcd8739ae039), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $e636b2257db42c06$export$a274e22fb40f762e)($c5afab4d5c610ba2$var$styles.common, $c5afab4d5c610ba2$var$styles.pressable)
        }, children);
        return /*#__PURE__*/ $7fPBF.createElement((0, $046496fb8108649c$export$2e2bcd8739ae039), {
            as: "span",
            testId: testId,
            xcss: $c5afab4d5c610ba2$var$styles.common
        }, children);
    }
    // TODO: Remove this once the deprecated `linkComponent` prop is removed.
    return onClick || href ? /*#__PURE__*/ $7fPBF.createElement((0, $2808c53964b8171a$export$2e2bcd8739ae039), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined
    }, children) : /*#__PURE__*/ $7fPBF.createElement((0, $7fPBF.Fragment), null, children);
});
var $c5afab4d5c610ba2$export$2e2bcd8739ae039 = $c5afab4d5c610ba2$var$SectionMessageAction;



const $548d2678bd231d64$var$_ = "._p12f5o3v{max-width:900px}";
const $548d2678bd231d64$var$styles = null;
const $548d2678bd231d64$var$Notification = ({ title: title, appearance: appearance, onClose: onClose, children: children, actions: actions })=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    const actionsArray = [];
    if (actions) actionsArray.push(...actions);
    if (onClose) actionsArray.push(/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $c5afab4d5c610ba2$export$2e2bcd8739ae039), {
        testId: 'notification-dismiss-button',
        onClick: onClose,
        children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_DISMISS_BUTTON_LABEL)
    }, 'notification-dismiss-button'));
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                children: [
                    $548d2678bd231d64$var$_
                ]
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("div", {
                className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                    "_p12f5o3v"
                ]),
                children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $91a181e7dea5ded3$export$2e2bcd8739ae039), {
                    appearance: appearance,
                    title: title,
                    actions: actionsArray.length > 0 ? actionsArray : undefined,
                    children: children
                })
            })
        ]
    });
};
const $548d2678bd231d64$export$3e68361a3d3e7b9f = (props)=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)($548d2678bd231d64$var$Notification, (0, $9tqwB._)({
        appearance: 'error'
    }, props));
const $548d2678bd231d64$export$e80deec18a12daba = (props)=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)($548d2678bd231d64$var$Notification, (0, $9tqwB._)({
        appearance: 'success'
    }, props));
const $548d2678bd231d64$export$8cc5afb04fcb8e07 = (props)=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)($548d2678bd231d64$var$Notification, (0, $9tqwB._)({
        appearance: 'warning'
    }, props));





parcelRequire("7fPBF");
const $01a16cfcd495a436$export$b29f828819edca8d = (value, start, end)=>{
    const source = value.split(' ');
    const target = source.slice(start, end).join(' ');
    let before = [];
    if (start < 0) before = source.slice(0, source.length + start);
    else if (start > 0) before = source.slice(0, start);
    let after = [];
    if (end != null && end < 0) after = source.slice(source.length + end);
    else if (end != null && end > 0) after = source.slice(end);
    return {
        before: before.join(' '),
        target: target,
        after: after.join(' ')
    };
};




const $8773d15fad8814a3$var$WrapStrong = ({ value: value, start: start, end: end })=>{
    const { before: before, target: target, after: after } = (0, $01a16cfcd495a436$export$b29f828819edca8d)(value, start, end);
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $c69938f751e7a026$export$ffb0004e005737fa), {
        children: [
            before,
            /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("strong", {
                children: [
                    " ",
                    target,
                    " "
                ]
            }),
            after
        ]
    });
};
var $8773d15fad8814a3$export$2e2bcd8739ae039 = $8773d15fad8814a3$var$WrapStrong;




parcelRequire("7fPBF");

const $aabac7154905f978$var$ErrorRequest = ()=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $548d2678bd231d64$export$3e68361a3d3e7b9f), {
        title: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_ERROR_MESSAGE_TITLE),
        children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("p", {
            children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $8773d15fad8814a3$export$2e2bcd8739ae039), {
                value: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_ERROR_MESSAGE_DESCRIPTION),
                start: -4
            })
        })
    });
};
var $aabac7154905f978$export$2e2bcd8739ae039 = $aabac7154905f978$var$ErrorRequest;







parcelRequire("7fPBF");

const $b022cce77af6b4bc$var$SuccessUpdateConsent = ({ data: data })=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    let content = /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $c69938f751e7a026$export$ffb0004e005737fa), {
        children: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("p", {
                children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_UPDATE_SUCCESS_MESSAGE_DESCRIPTION)
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("small", {
                children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $8773d15fad8814a3$export$2e2bcd8739ae039), {
                    value: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_NOTE_MESSAGE),
                    start: 0,
                    end: 2
                })
            })
        ]
    });
    if (data === 'DOUBLE_OPT_IN') content = /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("p", {
        children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_UPDATE_CONSENT_DOUBLE_OPT_IN_MESSAGE)
    });
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $548d2678bd231d64$export$e80deec18a12daba), {
        title: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_UPDATE_SUCCESS_MESSAGE_TITLE),
        children: content
    });
};
var $b022cce77af6b4bc$export$2e2bcd8739ae039 = $b022cce77af6b4bc$var$SuccessUpdateConsent;







var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

parcelRequire("7fPBF");

const $7551ffa32d2a4800$var$styles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    height: '100%',
    marginTop: '0',
    marginBottom: '0',
    marginLeft: 'space.0',
    marginRight: 'space.0',
    [(0, $8c23171a376c15ae$export$987d49ffe1b0900f).above.sm]: {
        marginLeft: 'space.400',
        marginRight: 'space.400'
    },
    [(0, $8c23171a376c15ae$export$987d49ffe1b0900f).above.md]: {
        marginLeft: 'space.800',
        marginRight: 'space.800'
    },
    [(0, $8c23171a376c15ae$export$987d49ffe1b0900f).above.lg]: {
        marginLeft: 'space.1000',
        marginRight: 'space.1000'
    }
});
const $7551ffa32d2a4800$export$3a31c848ced7e406 = (attributes)=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d245204bc35d9406$export$2e2bcd8739ae039), (0, $2qxEV._)((0, $9tqwB._)({
        as: "div"
    }, attributes), {
        xcss: $7551ffa32d2a4800$var$styles
    }));
$7551ffa32d2a4800$export$3a31c848ced7e406.displayName = 'PageWrapper';




const $cccf8465b61394af$var$_5 = "._otyr14lv{margin-bottom:var(--_cpuyf2)}";
const $cccf8465b61394af$var$_4 = "._19pk1ul9{margin-top:var(--_18cq338)}";
const $cccf8465b61394af$var$_3 = "._1bah1h6o{justify-content:center}";
const $cccf8465b61394af$var$_2 = "._1e0c1txw{display:flex}";
const $cccf8465b61394af$var$_ = "._1yt44uxf{padding:0 var(--_r6pg4u) var(--_cpuyf2)}";
const $cccf8465b61394af$var$styles = null;
const $cccf8465b61394af$var$resolveActionResultStatus = (status, data)=>{
    switch(status){
        case 'success':
            return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $b022cce77af6b4bc$export$2e2bcd8739ae039), {
                data: data
            });
        case 'error':
            return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $aabac7154905f978$export$2e2bcd8739ae039), {});
    }
};
const $cccf8465b61394af$var$ActionNotification = ()=>{
    const actionResult = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $e745f2f77eae858d$export$a2262118789c43db));
    if (actionResult == null) return null;
    const notification = $cccf8465b61394af$var$resolveActionResultStatus(actionResult.status, actionResult.action);
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $7551ffa32d2a4800$export$3a31c848ced7e406), {
        children: /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                    children: [
                        $cccf8465b61394af$var$_,
                        $cccf8465b61394af$var$_2,
                        $cccf8465b61394af$var$_3,
                        $cccf8465b61394af$var$_4,
                        $cccf8465b61394af$var$_5
                    ]
                }),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("div", {
                    "data-testid": "consent-action-notification",
                    className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                        "_1yt44uxf _1e0c1txw _1bah1h6o _19pk1ul9 _otyr14lv"
                    ]),
                    style: {
                        "--_r6pg4u": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.400')),
                        "--_cpuyf2": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.200')),
                        "--_18cq338": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.100'))
                    },
                    children: notification
                })
            ]
        })
    });
};
var $cccf8465b61394af$export$2e2bcd8739ae039 = $cccf8465b61394af$var$ActionNotification;






parcelRequire("7fPBF");
/* InfoView.tsx generated by @compiled/babel-plugin v2.0.0 */ 



parcelRequire("7fPBF");
const $63d0fb3ee0a87d37$var$LinkButton = ({ appearance: appearance, href: href, target: target, iconAfter: iconAfter, onClick: onClick, children: children })=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $b6738ae824ea86e7$export$2e2bcd8739ae039), {
        appearance: appearance !== null && appearance !== void 0 ? appearance : 'subtle-link',
        href: href,
        target: target,
        rel: 'noreferrer',
        iconAfter: iconAfter,
        onClick: onClick,
        children: children
    });
var $63d0fb3ee0a87d37$export$2e2bcd8739ae039 = $63d0fb3ee0a87d37$var$LinkButton;




parcelRequire("7fPBF");



const $9bbee8e48028edce$var$_5 = "._4cvr1h6o{align-items:center}";
const $9bbee8e48028edce$var$_4 = "._1bah1h6o{justify-content:center}";
const $9bbee8e48028edce$var$_3 = "._2lx21bp4{flex-direction:column}";
const $9bbee8e48028edce$var$_2 = "._1e0c1txw{display:flex}";
const $9bbee8e48028edce$var$_ = "._1yt414lv{padding:var(--_cpuyf2)}";
const $9bbee8e48028edce$var$infoViewWrapperStyle = null;
const $9bbee8e48028edce$var$infoViewTitleWrapperStyle = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    textAlign: 'center',
    marginTop: 'space.300',
    marginBottom: 'space.300',
    marginLeft: '0',
    marginRight: '0'
});
const $9bbee8e48028edce$var$InfoView = ({ title: title, hero: hero })=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                children: [
                    $9bbee8e48028edce$var$_,
                    $9bbee8e48028edce$var$_2,
                    $9bbee8e48028edce$var$_3,
                    $9bbee8e48028edce$var$_4,
                    $9bbee8e48028edce$var$_5
                ]
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("div", {
                className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                    "_1yt414lv _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o"
                ]),
                style: {
                    "--_cpuyf2": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.200'))
                },
                children: [
                    hero,
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                        as: "h3",
                        xcss: $9bbee8e48028edce$var$infoViewTitleWrapperStyle,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $63d0fb3ee0a87d37$export$2e2bcd8739ae039), {
                        appearance: 'primary',
                        href: 'https://www.atlassian.com',
                        children: translate((0, $447ba15143f7eed7$exports).GOTO_ATLASSIAN_BUTTON_LABEL)
                    })
                ]
            })
        ]
    });
};
var $9bbee8e48028edce$export$2e2bcd8739ae039 = $9bbee8e48028edce$var$InfoView;





/* BuildingImage.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


parcelRequire("7fPBF");


var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

parcelRequire("7fPBF");
const $6a6ffc0befe8bbd7$var$SvgBuildingFunctionality = (props)=>/*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("svg", (0, $2qxEV._)((0, $9tqwB._)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 468.37 558.91"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("defs", {
                children: [
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "linear-gradient",
                        x1: 197.53,
                        y1: 106.01,
                        x2: 230.87,
                        y2: 106.01,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0,
                                stopColor: "#344563"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.52,
                                stopColor: "#172b4d"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "linear-gradient-2",
                        x1: 186.82,
                        y1: 92.83,
                        x2: 186.82,
                        y2: 83.27,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0,
                                stopColor: "#a17f68"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 1,
                                stopColor: "#916d5a"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "linear-gradient-3",
                        x1: 148.3,
                        y1: 103.48,
                        x2: 181.59,
                        y2: 103.48,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0,
                                stopColor: "#344563"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.52,
                                stopColor: "#091e42"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "linear-gradient-4",
                        x1: 168.5,
                        y1: 114.03,
                        x2: 187.15,
                        y2: 95.38,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.48,
                                stopColor: "#172b4d"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 1,
                                stopColor: "#344563"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("linearGradient", {
                        id: "linear-gradient-5",
                        x1: 198.76,
                        y1: 119.43,
                        x2: 198.76,
                        y2: 89.34,
                        xlinkHref: "#linear-gradient-4"
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "N75",
                        x1: -513.46,
                        y1: 9361.18,
                        x2: -394.06,
                        y2: 9361.18,
                        gradientTransform: "rotate(99.68 3603.132 5129.663)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0,
                                stopColor: "#e5e8ec"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 1,
                                stopColor: "#e5e8ec",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("linearGradient", {
                        id: "N75-2",
                        x1: -585.26,
                        y1: 9005.02,
                        x2: -465.85,
                        y2: 9005.02,
                        gradientTransform: "rotate(99.68 3500.572 5043.116)",
                        xlinkHref: "#N75"
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "linear-gradient-6",
                        x1: 309.05,
                        y1: 443.4,
                        x2: 393.51,
                        y2: 358.95,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0,
                                stopColor: "#c1c7d0"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 1,
                                stopColor: "#dfe1e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "New_Gradient_Swatch_12",
                        x1: 294.7,
                        y1: 429.05,
                        x2: 379.15,
                        y2: 344.6,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0,
                                stopColor: "#00b8d9"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 1,
                                stopColor: "#79e2f2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("linearGradient", {
                        id: "N75-3",
                        x1: -629.11,
                        y1: 9518.35,
                        x2: -509.71,
                        y2: 9518.35,
                        gradientTransform: "rotate(99.68 3710.337 5220.13)",
                        xlinkHref: "#N75"
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("linearGradient", {
                        id: "linear-gradient-7",
                        x1: 230.99,
                        y1: 307.64,
                        x2: 315.44,
                        y2: 223.19,
                        xlinkHref: "#linear-gradient-6"
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("linearGradient", {
                        id: "N75-4",
                        x1: -445.12,
                        y1: 9221.13,
                        x2: -325.71,
                        y2: 9221.13,
                        gradientTransform: "rotate(99.68 3500.572 5043.116)",
                        xlinkHref: "#N75"
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("linearGradient", {
                        id: "N75-5",
                        x1: -402.42,
                        y1: 9471.56,
                        x2: -283.01,
                        y2: 9471.56,
                        gradientTransform: "rotate(99.68 3705.697 5216.214)",
                        xlinkHref: "#N75"
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("linearGradient", {
                        id: "N75-6",
                        x1: -361.89,
                        y1: 9709.41,
                        x2: -242.49,
                        y2: 9709.41,
                        gradientTransform: "rotate(99.68 3904.497 5383.976)",
                        xlinkHref: "#N75"
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "New_Gradient_Swatch_15",
                        x1: 429.34,
                        y1: 537.44,
                        x2: 429.34,
                        y2: 446.6,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0,
                                stopColor: "#0065ff"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 1,
                                stopColor: "#4c9aff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "linear-gradient-8",
                        x1: 326.37,
                        y1: 320.21,
                        x2: 371.48,
                        y2: 320.21,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0,
                                stopColor: "#fff0b2"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 1,
                                stopColor: "#ffc400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("linearGradient", {
                        id: "linear-gradient-9",
                        x1: 324.1,
                        y1: 302.17,
                        x2: 338.02,
                        y2: 302.17,
                        xlinkHref: "#linear-gradient-8"
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "New_Gradient_Swatch_7",
                        x1: 103.18,
                        y1: 322.47,
                        x2: 147.53,
                        y2: 322.47,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0,
                                stopColor: "#ffc400"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 1,
                                stopColor: "#fff0b2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "linear-gradient-10",
                        x1: 234.19,
                        y1: 117.42,
                        x2: 234.19,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.54,
                                stopColor: "#c1c7d0"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.71,
                                stopColor: "#c1c7d0",
                                stopOpacity: 0.61
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.91,
                                stopColor: "#c1c7d0",
                                stopOpacity: 0.17
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 1,
                                stopColor: "#c1c7d0",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "New_Gradient_Swatch_5",
                        x1: 361.32,
                        y1: 500.83,
                        x2: 361.32,
                        y2: 447.46,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0,
                                stopColor: "#ff991f"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 1,
                                stopColor: "#ffc400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("linearGradient", {
                        id: "New_Gradient_Swatch_5-2",
                        x1: 341.8,
                        y1: 473.94,
                        x2: 379.72,
                        y2: 473.94,
                        xlinkHref: "#New_Gradient_Swatch_5"
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("linearGradient", {
                        id: "linear-gradient-11",
                        x1: 320.88,
                        y1: 390.86,
                        x2: 382.38,
                        y2: 452.37,
                        xlinkHref: "#linear-gradient-8"
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("radialGradient", {
                        id: "radial-gradient",
                        cx: 231.33,
                        cy: 317.71,
                        r: 96.52,
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0,
                                stopColor: "#fff0b2"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.16,
                                stopColor: "#ffe587",
                                stopOpacity: 0.76
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.32,
                                stopColor: "#ffdb5f",
                                stopOpacity: 0.53
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.49,
                                stopColor: "#ffd33d",
                                stopOpacity: 0.34
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.64,
                                stopColor: "#ffcd22",
                                stopOpacity: 0.19
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.78,
                                stopColor: "#ffc810",
                                stopOpacity: 0.09
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.9,
                                stopColor: "#ffc504",
                                stopOpacity: 0.02
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 1,
                                stopColor: "#ffc400",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("style", {
                        children: ".bcls-2{fill:#a17f68}.bcls-4{fill:#172b4d}.bcls-6{fill:#091e42}.bcls-9{fill:#2684ff}.bcls-10,.bcls-34,.bcls-35{fill:none}.bcls-10,.bcls-34{stroke:#dfe1e5}.bcls-10{stroke-miterlimit:10;stroke-width:.48px}.bcls-34,.bcls-35{stroke-linecap:round}.bcls-15{fill:#0052cc}.bcls-17{fill:#0065ff}.bcls-22{fill:#c1c7d0}.bcls-26{fill:#00c7e5}.bcls-34,.bcls-35{stroke-width:4.85px;stroke-linejoin:round}.bcls-35{stroke:#0065ff;stroke-width:4.02px}.bcls-38{fill:#72594b}.bcls-44{fill:#dfe1e5}.bcls-45{fill:#b3bac5}.bcls-46{fill:#42526e}"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("g", {
                style: {
                    isolation: "isolate"
                },
                children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("g", {
                    id: "Layer_2",
                    children: /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("g", {
                        id: "Layer_1-2",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-2",
                                d: "M229.69 103.77c-.94 0-1.63-1.48-1.81-2.48a4.17 4.17 0 0 1 .69-3.15c.89-1.17 1.74-.83 3.29-2.14s1.89-2.62 2.32-2.51.41 1.17.19 2.07c-.41 1.68-1.51 1.76-2.21 3.51-.56 1.39-.06 1.85-.83 3.17-.27.47-.88 1.5-1.64 1.53Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-2",
                                d: "M229.52 97.75s5.66-.72 6.68-1.82 1.15-2.18 1.76-2.05-.09 2.25.16 2.57.72.17.63.84a5.64 5.64 0 0 1-.52 2.2c-.42.71-3.12 3.26-4.43 3.66s-4 1.37-5.3.86.31-5.28.31-5.28Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M201.23 92.91c.92 1.45 1.85 2.91 2.79 4.36q3.66 5.72 7.34 11.34l16.48-10 3 7.4c-2.66 2.05-6.6 5-11.61 8.19s-7.35 5.46-10.38 4.83c-1.66-.34-2.7-1.3-4.54-3a31.42 31.42 0 0 1-6.81-9.58q1.89-6.79 3.73-13.54Z",
                                style: {
                                    fill: "url(#linear-gradient)"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-4",
                                d: "M205.17 149.6h-36.28l5-30.17h25.28l6 30.17z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M192.42 89.78a7 7 0 0 1-11.2.52 4.52 4.52 0 0 0 1-1 5.44 5.44 0 0 0 .51-.87 8.6 8.6 0 0 0 0-4.62l8.94-.58c-.1.83-.23 2-.38 3.4a3.49 3.49 0 0 0 .21 2.09 2.75 2.75 0 0 0 .92 1.06Z",
                                style: {
                                    fill: "url(#linear-gradient-2)"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-6",
                                d: "m186.89 223.28.43-1.58a36.06 36.06 0 0 0 6.51-3.56 36.79 36.79 0 0 0 5-4.08l5.67.4a33.67 33.67 0 0 1 .73 3.7 34.47 34.47 0 0 1 .3 3.68h-3.48c-.33-.21-.65-.43-1-.65-.23.26-.46.53-.7.79a41.22 41.22 0 0 1-8.73 1.33 42.82 42.82 0 0 1-4.73-.03ZM163.06 220.4l.62-1.56a29.29 29.29 0 0 0 11.32-7.66l5.43.82a17.86 17.86 0 0 1 1.27 7.66l-3.41.35-1-1.13-1.23 1-3.23.44h-3.85c-1.98.04-3.98.06-5.92.08Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M181.59 89.39a13.62 13.62 0 0 0-6.05 2.53 14.28 14.28 0 0 0-3.93 4.85 66.41 66.41 0 0 1-9 12.15l-8.23-7.07q-3 5-6.1 10a24.18 24.18 0 0 0 6.93 4.23c2.35.92 4.53 1.79 7.24 1.39 1-.14 2.71-.43 6.42-3.41a69.36 69.36 0 0 0 7.89-7.45Z",
                                style: {
                                    fill: "url(#linear-gradient-3)"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M177.08 117.53c-.27 1.72-.67 4.32-1.05 7.5a216 216 0 0 0-1.31 35.51c.37 10.64.45 26.74-.76 51.29h2.37a60.07 60.07 0 0 0 11-1l.57-54.42q3.67 28.95 7.36 57.91a23.6 23.6 0 0 0 13.84 0q-1-15.49-2.82-32-1-9.36-2.27-18.35c-.16-4.26-.4-7.75-.6-10.13a165 165 0 0 0-4.88-30.53c-.71-2.68-1.37-4.83-1.77-6.14-6.47.23-13.17.22-19.68.36Z",
                                style: {
                                    fill: "#0049b0"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-9",
                                d: "M191.24 87.78a5.84 5.84 0 0 1-8.39.22l-.66 1.34a5.62 5.62 0 0 0 10 0Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-9",
                                d: "M178.62 90.15a11.29 11.29 0 0 1 3.57-.81 5.55 5.55 0 0 0 9.91 0c.72.09 2.62.92 4.11 1.13a8.23 8.23 0 0 1 1.83.42 7.45 7.45 0 0 1 3.49 2.46c1.65 2.1 1.37 6.31-1.27 10-1.28 4-3.57 5.94-4.86 9.91.53 1.39 1.06 2.78 1.6 4.17q-5.56.07-11.22.1h-8.7c-.69-4.49-.85-5.1-1.84-6.67a22.15 22.15 0 0 1-2.17-5.36 6.75 6.75 0 0 1-.17-1.47c-.06-3.2 1.48-3.48 1.79-8.16.09-1.41 0-2.54.85-3.67a6.6 6.6 0 0 1 3.08-2.05Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-6",
                                d: "M163.49 109.21h-11.55a2.26 2.26 0 0 1-2.12-1.49l-5.56-15.5a1.12 1.12 0 0 1 1.05-1.51h11.56A2.24 2.24 0 0 1 159 92.2l5.57 15.51a1.12 1.12 0 0 1-1.08 1.5Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-2",
                                d: "M150.62 102.77c-.19 1.15-1.28 2.39-2.14 2.23a1.6 1.6 0 0 1-1-1.1c-.15-.47.06-.63-.13-1.06s-.6-.47-.76-1c-.09-.26 0-.31 0-.94 0-.83-.16-.87-.08-1.17a1.77 1.77 0 0 1 2-1c.26.08.21.18.64.38.67.33 1 .18 1.22.43s.15.55.15 1.3c-.04 1.35.19 1.34.1 1.93Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-4",
                                d: "M201.35 119.43c.43.86.85 1.74 1.25 2.65a59.16 59.16 0 0 1 4.63 27.52h-13.07l-1.95-30.17Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-2",
                                d: "M190.3 84.41c.72-.38 1.28-.74 1.66-1a7.58 7.58 0 0 0 2.43-4.2 7.39 7.39 0 0 0-.06-3l-.18-.87a8.15 8.15 0 0 0-5.1-6l-.18-.08a8 8 0 0 0-2.36-.51 8.19 8.19 0 0 0-2.41.19c-1.45.35-4.09 1.56-5 4a29.6 29.6 0 0 0-.8 4.74 14.66 14.66 0 0 1-.28 1.45 13.49 13.49 0 0 1-.6 1.83l1.23.54a11.07 11.07 0 0 0 .79 3.5 3.22 3.22 0 0 0 .9 1.47c.49.38 1.19.55 3.57.09a20.61 20.61 0 0 0 6.39-2.15Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-6",
                                d: "M177.3 74.5c1.4.2 2.89.36 4.46.47 2.1.15 4.07.19 5.89.15q.09 7.71.19 15.41c1.19-.73 6.28-4.07 7.51-10.31.28-1.47 1.19-6.1-1.67-9.66a9.51 9.51 0 0 0-4-2.85c-.92-.35-5.45-2-9.09.79a9 9 0 0 0-3.29 6Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("ellipse", {
                                className: "bcls-10",
                                cx: 177.46,
                                cy: 76.95,
                                rx: 1.1,
                                ry: 1.53
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("ellipse", {
                                className: "bcls-10",
                                cx: 181.37,
                                cy: 76.95,
                                rx: 1.1,
                                ry: 1.53
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-10",
                                d: "M178.56 76.95h1.71"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                style: {
                                    strokeWidth: ".48px",
                                    strokeLinecap: "round",
                                    strokeMiterlimit: 10,
                                    stroke: "#dfe1e5",
                                    fill: "none"
                                },
                                d: "M182.48 76.95h6.21"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M171.83 96.1c-1.11 2-2.54 4.24-4.56 7.24q3.31 8 6.62 16.09c.45.09.92.17 1.41.25.92.13 1.79.21 2.6.25a43.12 43.12 0 0 0 1.09-7c.35-4.78-.27-7.33-.32-10.69a32.24 32.24 0 0 1 2.55-12.78c-.37.07-.76.16-1.16.27s-.92.26-1.44.44a12.56 12.56 0 0 0-2.12.88l-.3.17c-1.34.78-4.2 4.65-4.37 4.88Z",
                                style: {
                                    fill: "url(#linear-gradient-4)"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M206.35 102.22c-1.28 3.15-4.87 15.19-5 17.21h-9.14a29.17 29.17 0 0 1-.56-12.94c.61-3.17 1.64-5.26 1.71-9.1a23.76 23.76 0 0 0-1.26-8c.74.08 1.51.2 2.31.32a17.46 17.46 0 0 1 2.59.49 19.64 19.64 0 0 1 3.39 1.71c1.15.72 5.25 8.15 5.96 10.31Z",
                                style: {
                                    fill: "url(#linear-gradient-5)"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-4",
                                d: "m170.34 149.6 5.69-.1c.62-9.86 1.87-29.57 1.87-29.57l-2.6-.25Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                                cx: 231.33,
                                cy: 317.71,
                                r: 96.52,
                                style: {
                                    opacity: 0.38,
                                    fill: "url(#radial-gradient)"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                id: "_Rectangle_",
                                className: "bcls-15",
                                d: "M78.06 355.76h78.06v90.84H78.06z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M128.73 419.35c-8.89-16.26-4.13-23.6-14.16-38.4a76.14 76.14 0 0 0-29.81-25.19h-6.7v90.84H156c-9.79-5.75-20.08-14.09-27.27-27.25Z",
                                style: {
                                    fill: "url(#N75)",
                                    mixBlendMode: "multiply"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                id: "_Rectangle_2",
                                className: "bcls-17",
                                d: "M156.12 355.76h78.06v90.84h-78.06z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                id: "_Rectangle_3",
                                style: {
                                    fill: "#00b8d9"
                                },
                                d: "M234.19 355.76h78.06v90.84h-78.06z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M312.25 440.5c-12.62-5.5-31.72-14.28-43.07-35.05-8.88-16.26-4.13-23.6-14.15-38.4a70.47 70.47 0 0 0-9.66-11.29h-11.18v90.84h78.06Z",
                                style: {
                                    fill: "url(#N75-2)",
                                    mixBlendMode: "multiply"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                style: {
                                    fill: "url(#linear-gradient-6)"
                                },
                                d: "M312.25 355.76h78.06v90.84h-78.06z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M342.58 390.39c0 6.73.28 13.45.63 20.17 4.92-.08 13.48-.11 21.62-.11.05-7 .22-14 .23-21 0-.2 13-.27 25.25-.26v-33.43h-78.06v34.38c13.43-.05 30.33.02 30.33.25Z",
                                style: {
                                    fill: "url(#New_Gradient_Swatch_12)"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                id: "_Rectangle_4",
                                className: "bcls-22",
                                d: "M156.12 220h78.06v90.84h-78.06z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M234.19 309.71c-12.19-5.66-27.95-14.65-37.82-32.71-8.88-16.26-4.13-23.6-14.15-38.39A75.1 75.1 0 0 0 163.69 220h-7.57v90.84h78.07Z",
                                style: {
                                    fill: "url(#N75-3)",
                                    mixBlendMode: "multiply"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                style: {
                                    fill: "url(#linear-gradient-7)"
                                },
                                d: "M234.19 220h78.06v90.84h-78.06z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-15",
                                d: "M90.39 340.13h30.04v15.63H90.39zM141.11 340.13h30.04v15.63h-30.04zM191.82 340.13h30.04v15.63h-30.04z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                id: "_Rectangle_5",
                                className: "bcls-15",
                                d: "M0 446.6h78.06v90.84H0z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M49.71 510.19c-8.88-16.26-4.13-23.6-14.15-38.4A76.21 76.21 0 0 0 5.75 446.6H0v90.84h77c-9.8-5.75-20.1-14.09-27.29-27.25Z",
                                style: {
                                    fill: "url(#N75-4)",
                                    mixBlendMode: "multiply"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                id: "_Rectangle_6",
                                className: "bcls-17",
                                d: "M78.06 446.6h78.06v90.84H78.06z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-15",
                                d: "M12.33 430.97h30.04v15.63H12.33zM63.04 430.97h30.04v15.63H63.04zM113.76 430.97h30.04v15.63h-30.04z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-26",
                                d: "M246.52 340.13h30.04v15.63h-30.04zM297.23 340.13h30.04v15.63h-30.04zM347.94 340.13h30.04v15.63h-30.04z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                id: "_Rectangle_7",
                                className: "bcls-15",
                                d: "M156.12 446.6h78.06v90.84h-78.06z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M206 510.19c-8.88-16.26-4.13-23.6-14.16-38.4A76.14 76.14 0 0 0 162 446.6h-5.9v90.84h77.15c-9.77-5.75-20.07-14.09-27.25-27.25Z",
                                style: {
                                    fill: "url(#N75-5)",
                                    mixBlendMode: "multiply"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                id: "_Rectangle_8",
                                className: "bcls-17",
                                d: "M234.19 446.6h78.06v90.84h-78.06z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                id: "_Rectangle_9",
                                className: "bcls-15",
                                d: "M312.25 446.6h78.06v90.84h-78.06z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M362.51 510.19c-8.88-16.26-4.13-23.6-14.16-38.4a76.14 76.14 0 0 0-29.81-25.19h-6.29v90.84h77.54c-9.79-5.75-20.09-14.09-27.28-27.25Z",
                                style: {
                                    fill: "url(#N75-6)",
                                    mixBlendMode: "multiply"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                style: {
                                    fill: "url(#New_Gradient_Swatch_15)"
                                },
                                d: "M390.31 446.6h78.06v90.84h-78.06z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-15",
                                d: "M168.45 430.97h30.04v15.63h-30.04zM219.17 430.97h30.04v15.63h-30.04zM269.88 430.97h30.04v15.63h-30.04zM324.58 430.97h30.04v15.63h-30.04zM375.29 430.97h30.04v15.63h-30.04zM426.01 430.97h30.04v15.63h-30.04z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-22",
                                d: "M219.17 204.37h30.04V220h-30.04z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M350.56 328.76 371.23 316a.54.54 0 0 0-.34-1l-22.26 2.24-.52-5.14a.54.54 0 0 0-.82-.4l-20.66 12.79a.54.54 0 0 0 .33 1l22.27-2.24.52 5.15a.54.54 0 0 0 .81.36Z",
                                style: {
                                    fill: "url(#linear-gradient-8)"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "m334.41 304.86 3.6-11.58a.24.24 0 0 0-.4-.23l-7.63 8.1-1.89-1.78a.23.23 0 0 0-.38.11l-3.6 11.58a.23.23 0 0 0 .39.23l7.64-8.1L334 305a.24.24 0 0 0 .41-.14Z",
                                style: {
                                    fill: "url(#linear-gradient-9)"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "m128 314.16-24.26 1.54a.54.54 0 0 0-.17 1l20.69 8.52-2 4.79a.53.53 0 0 0 .53.73l24.21-1.51a.53.53 0 0 0 .17-1l-20.7-8.53 2-4.78a.53.53 0 0 0-.47-.76Z",
                                style: {
                                    fill: "url(#New_Gradient_Swatch_7)"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                style: {
                                    stroke: "url(#linear-gradient-10)",
                                    strokeWidth: "4.85px",
                                    strokeMiterlimit: 10,
                                    fill: "none"
                                },
                                d: "M234.19 117.42V0"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-34",
                                d: "M234.19 166.27 156.12 220v88.56"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-35",
                                d: "M225.59 162.93a8.6 8.6 0 1 0 10.41-8.41 2.24 2.24 0 0 1-1.78-2.19v-7.18"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                                className: "bcls-35",
                                cx: 234.19,
                                cy: 123.8,
                                r: 6.38
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-17",
                                d: "M235.88 146.1h-3.38a4.2 4.2 0 0 1-4.18-3.77l-1.14-10.89a4.21 4.21 0 0 1 4.18-4.64H237a4.21 4.21 0 0 1 4.18 4.64l-1.13 10.89a4.21 4.21 0 0 1-4.17 3.77Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-22",
                                d: "M168.45 204.37h30.04V220h-30.04z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-34",
                                d: "M312.25 308.56V220l-78.06-53.73"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-22",
                                d: "M269.88 204.37h30.04V220h-30.04z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                style: {
                                    stroke: "#cfd4db",
                                    strokeWidth: "2.13px",
                                    strokeLinejoin: "round",
                                    strokeLinecap: "round",
                                    fill: "none"
                                },
                                d: "M325.66 384.85v-9.02h-9.91v-6.32h23.95"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("rect", {
                                x: 317.73,
                                y: 366.76,
                                width: 21.88,
                                height: 6.06,
                                rx: 1.97,
                                ry: 1.97,
                                style: {
                                    fill: "#344563"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-38",
                                d: "M325.26 389.78a3.63 3.63 0 0 0 3-.61c3-2.25.3-11.06-.66-10.94-.15 0-2.1-.27-2.25-.25a19.56 19.56 0 0 0-2.25 1.22c-.75.68-.67 2.08-.73 3.32a6.39 6.39 0 0 0 .77 3.35Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M383.89 424.57c.13.41.31 1 .51 1.81.56 2.22.91 4.51 1.21 10.86.25 5.34 0 3.73.19 6.43.19 2.88.48 4.83-.57 7a7.61 7.61 0 0 1-1.2 1.76l-18.48 17.26-4.77-3.2 17.87-19.51-3-22.44 4.29-1.14Z",
                                style: {
                                    fill: "#ffab00"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-38",
                                d: "M377.94 454a18.16 18.16 0 0 0-1.8-4.69 20 20 0 0 1-2.15.55c-.8.16-1.43.22-1.76.26-1.9.28-5.52.71-15.28 1.46a27.43 27.43 0 0 0-1.84 2.57 30.56 30.56 0 0 0-3.87 9.31c-6.62 27.24-7.1 28.16-7.1 28.16q-1.38 7.86-2.67 15.93c-1.68 10.64-4 30.8-5.24 41a4.21 4.21 0 0 0 1.23 1.82 4.33 4.33 0 0 0 2 .89c2.51.35 6.89-12.86 6.89-12.86 3.61-10.88 4.6-25.23 4.62-26.73a40.91 40.91 0 0 0-.47-6.8q4.29-8.13 8.57-16.37 3.33-6.39 6.61-12.76-.09 15.3 0 31 .15 19.09.6 37.67a3.19 3.19 0 0 0 1.22.63 3.6 3.6 0 0 0 2.19-.23 6.27 6.27 0 0 0 3-1.79 189.17 189.17 0 0 0 2.95-23.29c.7-11.06-.32-10.28.29-19.22.94-13.57 4.55-32.9 3.6-39.18-.21-1.07-1.07-5.05-1.59-7.33Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-4",
                                d: "M367 398.91c-.73-1.12-1.67-2.82-1.06-3.67s1.82-.23 5-.11c4.49.17 5-.6 7.26.13a8.61 8.61 0 0 1 4.51 3.13c2.17 3.07 1.17 6.92.86 8.08a12.89 12.89 0 0 1-5.85 7.45l-2.45 1.56-6.89-11.89Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M374.87 419.65h-9.32a17.22 17.22 0 0 0 1-10.5l5.69-.28c.07.34.17.82.33 1.4a3.82 3.82 0 0 0 .62 1.58c.65.61 1.89.25 2.26.13-.19 2.56-.39 5.12-.58 7.67Z",
                                style: {
                                    fill: "#543e36"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M376.9 500.47v-.53c.37-5.41 1.17-11.71 1.94-17.81 1.15-9.1 2.24-17.69 1.65-21.6-.17-1.09-1-5.15-1.56-7.36a19.41 19.41 0 0 0-.71-2.36 19.63 19.63 0 0 0-1.19-2.6l-.41-.75-.82.25a17.93 17.93 0 0 1-2 .52c-.58.11-1.06.18-1.4.22h-.31c-1.79.26-5.31.69-15.21 1.44h-.46l-.28.35a30.28 30.28 0 0 0-5.91 12.3c-5.9 24.29-6.9 27.57-7 28v.25c-.39 2.2-.77 4.43-1.15 6.67 3 2.43 7.37 3.13 11.72 2.85l6.27-12q2.32-4.45 4.61-8.89v19.74a22.27 22.27 0 0 0 12.22 1.31Z",
                                style: {
                                    fill: "url(#New_Gradient_Swatch_5)"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M376.43 467.67a14.4 14.4 0 0 0 3.05-6.39 19.33 19.33 0 0 0-.52-8.11 22.29 22.29 0 0 0-.71-2.36 19.63 19.63 0 0 0-1.19-2.6l-.41-.75-.82.25a17.93 17.93 0 0 1-2 .52c-.58.11-1.06.18-1.4.22h-.31c-1.79.26-5.31.69-15.21 1.44h-.46l-.28.35a31.55 31.55 0 0 0-1.91 2.67c-3.41 5.41-4.6 12.53-6.26 18.68q-1.86 6.9-3.5 13.86c-.27 1.16-3.39 11.25-2.5 12 3 2.43 7.37 3.13 11.72 2.85l6.27-12c2.53-4.86 4.68-9.46 8.74-13.25 2.55-2.34 5.5-4.61 7.7-7.38Z",
                                style: {
                                    fill: "url(#New_Gradient_Swatch_5-2)"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-38",
                                d: "m367 398.91-1.37 3.09-4 2.45c.32.56.64 1.13 1 1.69-.12 2-.23 4.07-.35 6.11a15.24 15.24 0 0 0 3.9 2c.54.19.77.19 5.55.36 2.05.07 3.08.09 3.54-.47a2.7 2.7 0 0 0 .17-2.53c-.32-.76-.7-.69-1.06-1.43-.55-1.16.14-1.84-.21-2.93s-1.17-.86-2.45-2.2c-1.45-1.51-1.16-2.5-2.6-4.29a8 8 0 0 0-2.12-1.85Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M332.07 419.64a77.13 77.13 0 0 0 23 9.95c0 2.72-.12 5.58-.35 8.57a129.63 129.63 0 0 1-1.91 14.52 39.4 39.4 0 0 0 27.2 2.08 95.5 95.5 0 0 1 2.8-20.76q.63-2.52 1.35-4.86a6.36 6.36 0 0 0-2.52-7.19h-.05s-.39-.26-1-.62c0 0-1.1-.65-2.24-1.22-4.79-2.39-13.54-3.2-13.54-3.2-11.95-1.12-11.54-.91-13.85-1.28a58.44 58.44 0 0 1-12.6-3.52q-4.17-12.7-8.35-25.41l-6.62 1.73c1.07 5.43 2.43 11.25 4.17 17.37 1.44 4.87 2.95 9.51 4.51 13.84Z",
                                style: {
                                    fill: "url(#linear-gradient-11)"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-44",
                                d: "M373.05 547.23h-7.21c.1-1.24.17-2.55.19-3.93v-2.51a18.86 18.86 0 0 1 3.6-.27 18.22 18.22 0 0 1 3.24.34 20 20 0 0 0 .2 6.37ZM342.15 552.52h-7.21c.06-1.28 1.23-5.19 1.29-6.47 1.3-.14 2.63-.3 4-.47s2.37-.31 3.54-.48q-.48 1.77-.9 3.72c-.31 1.28-.53 2.52-.72 3.7Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-45",
                                d: "M371.73 550a3.67 3.67 0 0 0-3.67 3.6h3.76V550Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-45",
                                d: "M371.46 550a3.68 3.68 0 0 1 3.67 3.6h-3.77V550Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                id: "_Path_",
                                className: "bcls-46",
                                d: "M367.33 546.71s-.51-1.12-1-1.36c-1-.46-.09 2.6-2.37 4.58a8.42 8.42 0 0 1-2.84 1.65.89.89 0 0 0-.51.87v.85h13.79a15.66 15.66 0 0 0-1.23-6.62Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-45",
                                d: "M343.34 555.31a3.66 3.66 0 0 0-3.66 3.6h3.76v-3.59Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                id: "_Path_2",
                                className: "bcls-46",
                                d: "M336.43 552c-.14.06-.52-1.13-1.05-1.36-1-.46-2.72 2.6-5.72 4.58a12.8 12.8 0 0 1-3.76 1.65.9.9 0 0 0-.68.87v.85h18.23a15.51 15.51 0 0 0-.4-4.08 16.27 16.27 0 0 0-.83-2.55Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "bcls-4",
                                d: "M362.64 406.12a1.5 1.5 0 0 0-.51.68 1.6 1.6 0 0 0 0 .94 6.21 6.21 0 0 0 1.54.53 6.05 6.05 0 0 0 1.19.12c0 .32-.08.74-.15 1.24-.18 1.33-.29 1.46-.4 1.52-.42.24-1.3-.26-1.64-1a1.77 1.77 0 0 1-.18-.82 2.86 2.86 0 0 0-.9 1.45 2.67 2.67 0 0 0 .36 2.09 4.57 4.57 0 0 0 2.72 1.64h.38c5.19.26 5.54.26 5.86.16 2.93-.88 2.73-9.85 2.72-10.23l-3.26-2a4.25 4.25 0 0 1 .41 3.66c-.11.27-.71 1.79-1.93 2s-1.92-1.13-4.37-1.82a8.94 8.94 0 0 0-1.84-.16Z"
                            })
                        ]
                    })
                })
            })
        ]
    }));
var $6a6ffc0befe8bbd7$export$2e2bcd8739ae039 = $6a6ffc0befe8bbd7$var$SvgBuildingFunctionality;


const $139978517f0651d4$var$_2 = "._c71lr0r7{max-height:250px}";
const $139978517f0651d4$var$_ = "._1yt414lv{padding:var(--_cpuyf2)}";
const $139978517f0651d4$var$styles = null;
const $139978517f0651d4$export$fe8dceec803a025 = (attributes)=>/*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                children: [
                    $139978517f0651d4$var$_,
                    $139978517f0651d4$var$_2
                ]
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $6a6ffc0befe8bbd7$export$2e2bcd8739ae039), (0, $2qxEV._)((0, $9tqwB._)({}, attributes), {
                className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                    "_1yt414lv _c71lr0r7"
                ]),
                style: {
                    "--_cpuyf2": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.200'))
                }
            }))
        ]
    });
$139978517f0651d4$export$fe8dceec803a025.displayName = 'BuildingImage';


const $69541c48b8b26100$var$DownForMaintenanceView = ({ message: message })=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $9bbee8e48028edce$export$2e2bcd8739ae039), {
        title: translate(message),
        hero: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $139978517f0651d4$export$fe8dceec803a025), {})
    });
};
var $69541c48b8b26100$export$2e2bcd8739ae039 = $69541c48b8b26100$var$DownForMaintenanceView;





parcelRequire("7fPBF");


const $2a77727daa1ec115$var$StatusView = ()=>{
    const { status: status, message: message } = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $e745f2f77eae858d$export$f4442397935fb087));
    if (status === 'down-for-maintenance') return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $7551ffa32d2a4800$export$3a31c848ced7e406), {
        children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $69541c48b8b26100$export$2e2bcd8739ae039), {
            message: message
        })
    });
    else return null;
};
var $2a77727daa1ec115$export$2e2bcd8739ae039 = $2a77727daa1ec115$var$StatusView;






var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


const $cebbc76cf001488c$var$requireString = (value)=>value != null && (typeof value === 'string' || typeof value === 'number') ? `${value}` : undefined;
const $cebbc76cf001488c$var$createConsents = (grant, revoke)=>{
    let consents = [];
    consents = consents.concat($cebbc76cf001488c$var$setConsentStates(grant, true));
    consents = consents.concat($cebbc76cf001488c$var$setConsentStates(revoke, false));
    return consents;
};
const $cebbc76cf001488c$var$setConsentStates = (source, targetState)=>{
    const consents = [];
    if (source == null) return consents;
    Object.keys(source).forEach((key)=>{
        consents.push({
            key: key,
            granted: targetState,
            displayedText: source[key]
        });
    });
    return consents;
};
const $cebbc76cf001488c$var$createSubscriptions = (subscribe)=>{
    const value = $cebbc76cf001488c$var$requireString(subscribe);
    if (!value) return undefined;
    return value.split(',').map((item)=>({
            key: item,
            subscribed: true
        }));
};
const $cebbc76cf001488c$export$491adab2bc41e40 = (query)=>{
    const { hid: hid, site: site, formUrl: formUrl, subscribe: subscribe, grant: grant, action: action, source: source, revoke: revoke } = (0, $e845741c6335a85b$export$2e2bcd8739ae039)(query);
    return {
        hid: $cebbc76cf001488c$var$requireString(hid),
        site: $cebbc76cf001488c$var$requireString(site),
        formUrl: $cebbc76cf001488c$var$requireString(formUrl),
        action: $cebbc76cf001488c$var$requireString(action),
        source: $cebbc76cf001488c$var$requireString(source),
        consents: $cebbc76cf001488c$var$createConsents(grant, revoke),
        subscriptions: $cebbc76cf001488c$var$createSubscriptions(subscribe)
    };
};





const $29d5400afff223b9$export$7b4c03a439536a80 = 'consent';
const $29d5400afff223b9$export$184c143ba6f02162 = `${$29d5400afff223b9$export$7b4c03a439536a80}/sendConsentFromLink`;
const $29d5400afff223b9$export$e941224c3d280b02 = `${$29d5400afff223b9$export$7b4c03a439536a80}/updateConsentFromLink`;


const $cdfa88e4a0cef872$var$initialState = {
    urlQueryParams: undefined,
    status: {
        status: 'ok'
    },
    actionResult: undefined
};
const $cdfa88e4a0cef872$export$8dafef78dd350222 = (0, $15d924278321bdfd$export$6abd22dc03e5063f)((0, $29d5400afff223b9$export$184c143ba6f02162), async (_, { getState: getState, rejectWithValue: rejectWithValue })=>{
    const { urlQueryParams: urlQueryParams } = getState().consent;
    if (urlQueryParams == null) return rejectWithValue(null);
    const response = await (0, $71fbb9240bd0b42c$export$3ab4aed8562cb58d)(urlQueryParams);
    if (response.downForMaintenanceMessage != null) return rejectWithValue(response.downForMaintenanceMessage);
}, {
    condition: (arg, { getState: getState })=>getState().consent.urlQueryParams != null
});
const $cdfa88e4a0cef872$export$6486b849b39045bb = (0, $15d924278321bdfd$export$6abd22dc03e5063f)((0, $29d5400afff223b9$export$e941224c3d280b02), async (_, { dispatch: dispatch })=>{
    await dispatch($cdfa88e4a0cef872$export$8dafef78dd350222());
});
const $cdfa88e4a0cef872$var$consentSlice = (0, $15d924278321bdfd$export$4d8d9bd83c24ae8b)({
    name: (0, $29d5400afff223b9$export$7b4c03a439536a80),
    initialState: $cdfa88e4a0cef872$var$initialState,
    reducers: {
        empty: ()=>{}
    },
    extraReducers: (builder)=>{
        builder.addCase($cdfa88e4a0cef872$export$6486b849b39045bb.pending, (state, { meta: meta })=>{
            const consentReferralUrlParams = (0, $cebbc76cf001488c$export$491adab2bc41e40)(meta.arg);
            if (consentReferralUrlParams.hid) state.urlQueryParams = (0, $2qxEV._)((0, $9tqwB._)({}, consentReferralUrlParams), {
                hid: consentReferralUrlParams.hid
            });
            else state.actionResult = {
                status: 'error'
            };
        });
        builder.addCase($cdfa88e4a0cef872$export$8dafef78dd350222.fulfilled, (state)=>{
            var _state_urlQueryParams;
            state.actionResult = {
                status: 'success',
                action: (_state_urlQueryParams = state.urlQueryParams) === null || _state_urlQueryParams === void 0 ? void 0 : _state_urlQueryParams.action
            };
        });
        builder.addCase($cdfa88e4a0cef872$export$8dafef78dd350222.rejected, (state, action)=>{
            if (action.payload != null) state.status = {
                status: 'down-for-maintenance',
                message: action.payload
            };
            else state.actionResult = {
                status: 'error'
            };
        });
    }
});
var $cdfa88e4a0cef872$export$2e2bcd8739ae039 = $cdfa88e4a0cef872$var$consentSlice.reducer;







const $100065b339a92676$var$_4 = "._1bah1h6o{justify-content:center}";
const $100065b339a92676$var$_3 = "._4cvr1h6o{align-items:center}";
const $100065b339a92676$var$_2 = "._2lx21bp4{flex-direction:column}";
const $100065b339a92676$var$_ = "._1e0c1txw{display:flex}";
const $100065b339a92676$var$styles = null;
const $100065b339a92676$var$Consent = ()=>{
    const dispatch = (0, $7ef2374eddee6a70$export$f51d452c10d5b956)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    (0, $7fPBF.useEffect)(()=>{
        dispatch((0, $cdfa88e4a0cef872$export$6486b849b39045bb)(location.search));
    }, [
        dispatch,
        location
    ]);
    const isPending = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $7a501a2d8adab3c3$export$9d56a93b8e84b384)([
        (0, $29d5400afff223b9$export$e941224c3d280b02)
    ]));
    const status = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $e745f2f77eae858d$export$f4442397935fb087));
    const hid = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $e745f2f77eae858d$export$e4521e30be8f0d13));
    const navigationClickHandler = (0, $7fPBF.useCallback)(()=>navigate(`/?hid=${hid}`), [
        navigate,
        hid
    ]);
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $ef58838c74859603$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $2a77727daa1ec115$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $7551ffa32d2a4800$export$3a31c848ced7e406), {
                children: /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                            children: [
                                $100065b339a92676$var$_,
                                $100065b339a92676$var$_2,
                                $100065b339a92676$var$_3,
                                $100065b339a92676$var$_4
                            ]
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("div", {
                            className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                                "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o"
                            ]),
                            children: isPending ? /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $aacfdd39b28e059d$export$2e2bcd8739ae039), {
                                size: "large",
                                label: "Loading",
                                testId: "loading-spinner"
                            }) : /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $c69938f751e7a026$export$ffb0004e005737fa), {
                                children: [
                                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $cccf8465b61394af$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $6125038cd8bf4a75$export$2e2bcd8739ae039), {
                                        appearance: 'primary',
                                        isVisible: status.status === 'ok' && hid != null,
                                        onClick: navigationClickHandler
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $100065b339a92676$export$2e2bcd8739ae039 = $100065b339a92676$var$Consent;







/* NotFoundView.tsx generated by @compiled/babel-plugin v2.0.0 */ 

parcelRequire("7fPBF");




var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

parcelRequire("7fPBF");
const $38c55a02ec9b8a11$var$SvgMoving = (props)=>/*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("svg", (0, $2qxEV._)((0, $9tqwB._)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 581.46 278.83"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("defs", {
                children: [
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "linear-gradient",
                        x1: 487.37,
                        y1: 255.77,
                        x2: 549.17,
                        y2: 193.96,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0,
                                stopColor: "#00a3bf"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 1,
                                stopColor: "#00c7e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "linear-gradient-2",
                        y1: 2064.73,
                        x2: 581.46,
                        y2: 2064.73,
                        gradientTransform: "matrix(1 0 0 -2.47 0 5364.37)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0,
                                stopColor: "#172b4d",
                                stopOpacity: 0.1
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.02,
                                stopColor: "#172b4d",
                                stopOpacity: 0.23
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.08,
                                stopColor: "#172b4d",
                                stopOpacity: 0.51
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.15,
                                stopColor: "#172b4d",
                                stopOpacity: 0.73
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.24,
                                stopColor: "#172b4d",
                                stopOpacity: 0.89
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.36,
                                stopColor: "#172b4d",
                                stopOpacity: 0.98
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.7,
                                stopColor: "#172b4d"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "linear-gradient-3",
                        x1: 352.14,
                        y1: 237.25,
                        x2: 468.8,
                        y2: 120.6,
                        gradientTransform: "rotate(-90 410.47 178.93)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.26,
                                stopColor: "#c1c7d0"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.89,
                                stopColor: "#dfe1e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "linear-gradient-5",
                        x1: 191.16,
                        y1: 263.67,
                        x2: 337.31,
                        y2: 263.67,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0,
                                stopColor: "#c1c7d0"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.74,
                                stopColor: "#a5adba"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("linearGradient", {
                        id: "linear-gradient-6",
                        x1: 191.16,
                        y1: 261.81,
                        x2: 337.31,
                        y2: 261.81,
                        xlinkHref: "#linear-gradient-3"
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "linear-gradient-7",
                        x1: 7621.51,
                        y1: 133.78,
                        x2: 7582.74,
                        y2: 66.63,
                        gradientTransform: "matrix(-1 0 0 1 8014.38 0)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.26,
                                stopColor: "#c1c7d0"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.49,
                                stopColor: "#c7ccd4"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.79,
                                stopColor: "#d7dadf"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.89,
                                stopColor: "#dfe1e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "linear-gradient-8",
                        x1: 7565.51,
                        y1: 232.66,
                        x2: 7497.92,
                        y2: 115.6,
                        gradientTransform: "matrix(-1 0 0 1 8014.38 0)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.26,
                                stopColor: "#c1c7d0"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.89,
                                stopColor: "#ebecf0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("linearGradient", {
                        id: "New_Gradient_Swatch_11",
                        x1: 113.14,
                        y1: 197.29,
                        x2: 162.34,
                        y2: 148.09,
                        gradientTransform: "translate(-51.44 51.13)",
                        xlinkHref: "#linear-gradient"
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "linear-gradient-9",
                        x1: 284.38,
                        y1: 112.68,
                        x2: 398.7,
                        y2: -1.64,
                        gradientTransform: "rotate(-8.14 1039.08 480.808)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0,
                                stopColor: "#dfe1e5"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.21,
                                stopColor: "#e9eaed"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.66,
                                stopColor: "#f9fafa"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 1,
                                stopColor: "#fff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("linearGradient", {
                        id: "linear-gradient-10",
                        x1: 38.67,
                        y1: 260.31,
                        x2: 156.62,
                        y2: 260.31,
                        xlinkHref: "#linear-gradient-3"
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("clipPath", {
                        id: "clip-path",
                        children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            id: "_Clipping_Path_",
                            className: "mcls-1",
                            d: "M485.28 171.09h31.52c12.14 0 22 9.25 22 20.66a20.66 20.66 0 0 0 13.2 18.94l11.1 4.56a20.67 20.67 0 0 1 13.18 18.94v19.49h-91Z"
                        })
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("clipPath", {
                        id: "clip-path-2",
                        children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-2",
                            d: "M171.03 108.84h166.28v115.77H171.03z"
                        })
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("style", {
                        children: ".mcls-1{fill:url(#linear-gradient)}.mcls-2,.mcls-39{fill:none}.mcls-4{fill:#dfe1e5}.mcls-6{fill:#97a0af}.mcls-7{fill:#253858}.mcls-8{fill:#a5adba}.mcls-39{stroke-miterlimit:10}.mcls-11{fill:#c1c7d0}.mcls-12{fill:#5e6c84}.mcls-14{fill:#79e2f2}.mcls-16{fill:#fff}.mcls-17{fill:#72594b}.mcls-18{fill:#344563}.mcls-23{fill:#b3bac5}.mcls-26{fill:#42526e}.mcls-27{fill:#e1c5b6}.mcls-28{fill:#00a3bf}.mcls-29{fill:#0065ff}.mcls-31{fill:#e6fcff}.mcls-32{fill:#091e42;opacity:.1}.mcls-33{fill:#b2d4ff}.mcls-39{stroke:#2684ff;stroke-width:5.13px;opacity:.4}.mcls-40{fill:#4c9aff}.mcls-41{fill:#b5917c}.mcls-43{fill:#162b4c}.mcls-44{fill:#172b4d}"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("g", {
                id: "Layer_2",
                children: /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("g", {
                    id: "Layer_1-2",
                    children: [
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            d: "M2.69 267.21h574.18a4.58 4.58 0 0 1 4.58 4.58v2.27a4.58 4.58 0 0 1-4.58 4.58H2.69A2.69 2.69 0 0 1 0 276v-6a2.69 2.69 0 0 1 2.69-2.69Z",
                            style: {
                                opacity: 0.05,
                                fill: "url(#linear-gradient-2)"
                            }
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 269.43,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 269.6,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 269.77,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 269.94,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 270.11,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 270.28,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 270.46,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 270.63,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 270.8,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 270.97,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 271.14,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 271.31,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 271.48,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 271.65,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 271.82,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 271.99,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 272.16,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 272.33,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 272.51,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 272.68,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 272.85,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 273.02,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 273.19,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 273.36,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 273.53,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 273.7,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 273.87,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 274.04,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 274.21,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 274.38,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 274.56,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 274.73,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 274.9,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 275.07,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 275.24,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 275.41,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 275.58,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 275.75,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 275.92,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 276.09,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 276.26,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 276.43,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 276.61,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 276.78,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 276.95,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 277.12,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 277.29,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 277.46,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 277.63,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 277.8,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 277.97,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 278.14,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 278.31,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 278.48,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 278.66,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 278.83,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 279,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 279.17,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 279.34,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 279.51,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 279.68,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 279.85,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 280.02,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 280.19,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 280.36,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 280.53,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 280.71,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 280.88,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 281.05,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 281.22,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 281.39,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 281.56,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 281.73,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 281.9,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 282.07,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 282.24,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 282.41,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 282.58,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 282.76,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 282.93,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 283.1,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 283.27,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 283.44,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 283.61,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 283.78,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 283.95,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 284.12,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 284.29,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 284.46,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 284.63,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 284.81,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 284.98,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 285.15,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 285.32,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 285.49,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 285.66,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 285.83,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 286,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 286.17,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 286.34,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 286.51,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 286.68,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 286.86,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 287.03,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 287.2,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 287.37,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 287.54,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 287.71,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 287.88,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 288.05,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-4",
                            cx: 288.22,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            cx: 288.22,
                            cy: 260.61,
                            r: 17.97,
                            style: {
                                fill: "#505f79"
                            }
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-6",
                            d: "M288.22 260.61H572a5.08 5.08 0 0 1-5.08 5.08H293.3a5.08 5.08 0 0 1-5.08-5.08Z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-7",
                            d: "M269 260.61a23.44 23.44 0 0 1 46.87 0"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            id: "_Rectangle_",
                            className: "mcls-8",
                            transform: "rotate(-180 413.76 175.635)",
                            d: "M342.25 97.6h143.03v156.08H342.25z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            transform: "rotate(90 410.47 178.93)",
                            style: {
                                fill: "url(#linear-gradient-3)"
                            },
                            d: "M348.88 123.86h123.18v110.13H348.88z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            style: {
                                strokeWidth: "2.56px",
                                strokeMiterlimit: 10,
                                stroke: "#ebecf0",
                                fill: "none"
                            },
                            d: "m357.46 1.28-58.16 98.86"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            id: "_Rectangle_2",
                            className: "mcls-11",
                            transform: "rotate(-180 286.3 175.635)",
                            d: "M230.35 97.6h111.89v156.08H230.35z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-12",
                            transform: "rotate(90 286.3 175.64)",
                            d: "M213.2 124.63h146.21v102.02H213.2z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            id: "_Clipping_Path_2",
                            className: "mcls-1",
                            d: "M485.28 171.09h31.52c12.14 0 22 9.25 22 20.66a20.66 20.66 0 0 0 13.2 18.94l11.1 4.56a20.67 20.67 0 0 1 13.18 18.94v19.49h-91Z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("g", {
                            style: {
                                clipPath: "url(#clip-path)"
                            },
                            children: [
                                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                                    className: "mcls-14",
                                    cx: 573.38,
                                    cy: 225.37,
                                    r: 8.06
                                }),
                                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                    id: "_Rectangle_3",
                                    d: "M489.17 175.61h29.76a16.59 16.59 0 0 1 16.59 16.59v20.18h-46.35v-36.77Z",
                                    style: {
                                        fill: "#b3f5ff"
                                    }
                                }),
                                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                    className: "mcls-2",
                                    d: "m515.51 203.64-.53-.3a3.5 3.5 0 0 1-.28.39l-3.2.12a18.51 18.51 0 0 1 1.12 2.66c1.44.82 3.06 1.66 4.84 2.47.73.33 1.45.63 2.15.91a12.7 12.7 0 0 1-2-5.85 3.33 3.33 0 0 1-2.1-.4ZM520.28 200.28l1.57-.12.06 1.34a1.8 1.8 0 0 1-.89 1.63 2.25 2.25 0 0 1-.45.19l-.48.12c.28 4 2.5 7.28 5.1 7.28a3.92 3.92 0 0 0 2.88-1.46l-3.61-6.26a.84.84 0 0 1 1.46-.85l3.21 5.56a11.16 11.16 0 0 0 1.19-5.13c0-4.41-2.35-8.13-5.13-8.13-2 0-3.82 2-4.65 4.77a1.2 1.2 0 0 1-.17.67Z"
                                }),
                                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                    className: "mcls-16",
                                    d: "M492.46 194.51V193.73a4.76 4.76 0 0 1-2.46-1.53 5.2 5.2 0 0 1-.79-1v2.51a8 8 0 0 1 1.82 1.14q.65-.2 1.43-.34ZM498.35 193.74a4 4 0 0 0 .09.87h.27v-1.95l-.19.07a3.61 3.61 0 0 0-.17 1.01ZM490.62 180a3 3 0 0 1 1.62 1.8 5.34 5.34 0 0 1 2.52-.38 16.48 16.48 0 0 0-5.6-4.29v2.54a3.22 3.22 0 0 1 1.46.33ZM531.82 212.38l-1.26-2.18a8 8 0 0 1-1.19 1.32l.5.86ZM524.77 201.86a.83.83 0 0 0-.31 1.15l3.61 6.25a7.46 7.46 0 0 0 1.06-1.54l-3.21-5.56a.84.84 0 0 0-1.15-.3Z"
                                }),
                                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                    className: "mcls-17",
                                    d: "M521 203.13a1.8 1.8 0 0 0 .89-1.63l-.06-1.34-1.57.12a12.4 12.4 0 0 0-.22 2.31v.85l.48-.12a2.25 2.25 0 0 0 .48-.19Z"
                                }),
                                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                    className: "mcls-18",
                                    d: "M530.56 210.2a13 13 0 0 0 2.26-7.61c0-6-3.35-10.63-7.63-10.63-3.48 0-6.34 3.07-7.29 7.42l2.65-.24v.09c.83-2.79 2.62-4.77 4.65-4.77 2.78 0 5.13 3.72 5.13 8.13a11.16 11.16 0 0 1-1.19 5.13 7.46 7.46 0 0 1-1.06 1.54 3.92 3.92 0 0 1-2.88 1.46c-2.6 0-4.82-3.26-5.1-7.28v-.85a12.4 12.4 0 0 1 .22-2.31l.09-.38a1.15 1.15 0 0 1-.61.47l-.46.16-.72.64a3.78 3.78 0 0 1-1 .61v.81c0 .49 0 1 .07 1.45a12.7 12.7 0 0 0 2 5.85c1.12.45 2.2.85 3.22 1.2l-.68 1.28h6.05a7.32 7.32 0 0 0 1.17-.86 8 8 0 0 0 1.11-1.31Z"
                                }),
                                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                    className: "mcls-17",
                                    d: "M515.35 201.51a2.51 2.51 0 0 1-.37 1.83l.53.3a3.33 3.33 0 0 0 2.12.4c0-.47-.07-1-.07-1.45v-.81a3.78 3.78 0 0 0 1-.61l.72-.64.46-.16a1.15 1.15 0 0 0 .61-.47 1.2 1.2 0 0 0 .17-.67s0-.06 0-.09l-2.65.24-1.19.12-1.81 1a2.37 2.37 0 0 1 .48 1.01Z"
                                }),
                                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                    className: "mcls-18",
                                    d: "M503.93 204.11h.68c-.41-.61-.8-1.22-1.13-1.79a4.55 4.55 0 0 1 .45 1.79ZM511.5 203.85l3.2-.12a3.5 3.5 0 0 0 .28-.39 2.51 2.51 0 0 0 .37-1.83 2.37 2.37 0 0 0-.45-1l-5.93-.34c.14.16.28.31.41.47a17.32 17.32 0 0 1 2.12 3.21Z"
                                }),
                                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                    className: "mcls-7",
                                    d: "M519.61 209.89c-.7-.28-1.42-.58-2.15-.91-1.78-.81-3.4-1.65-4.84-2.47a18.51 18.51 0 0 0-1.12-2.66 17.32 17.32 0 0 0-2.14-3.21c-.13-.16-.27-.31-.41-.47a18.21 18.21 0 0 0-10.24-5.51h-.27a19.66 19.66 0 0 0-3.82-.31 20 20 0 0 0-2.16.21q-.78.13-1.47.3a8.11 8.11 0 0 1 2.95 6.26v11.31h8.87c-.76-2.89-.38-4.51.2-5.47a5 5 0 0 0 .93-2.59 1.48 1.48 0 0 0 0-.21 4.55 4.55 0 0 0-.45-1.81c.33.57.72 1.18 1.13 1.79a38 38 0 0 0 2.34 3.15c.85 1 1.69 1.91 2.5 2.7a25.31 25.31 0 0 0 5.75 2.44h6.95l.68-1.28c-1.03-.41-2.11-.81-3.23-1.26Z"
                                }),
                                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                    className: "mcls-17",
                                    d: "M497.8 188.35c-.19 0-.38-.68-.66-.66s-.45.73-.52 1.22a9.47 9.47 0 0 0 .14 2c-.06 1.31-1.76 2.8-3.56 2.86a2.8 2.8 0 0 1-.72-.06V194.49a20 20 0 0 1 2.16-.21 19.66 19.66 0 0 1 3.82.31 4 4 0 0 1-.09-.87 3.61 3.61 0 0 1 .17-1l.19-.07.29-.12 1.3-.51-.44-3.22c.05-.2.51-.51.59-.74s-.34-.3-.65-.47-.33-.24-.39-.39a15.69 15.69 0 0 0-1.22-2.2 7.57 7.57 0 0 0-.22 2c.01.53.01 1.31-.19 1.35Z"
                                }),
                                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                    className: "mcls-7",
                                    d: "M492.48 193.73a2.8 2.8 0 0 0 .72.06c1.8-.06 3.5-1.55 3.56-2.86a9.47 9.47 0 0 1-.14-2c.07-.49.25-1.2.52-1.22s.47.7.66.66.17-.82.17-1.27a7.57 7.57 0 0 1 .22-2 1.81 1.81 0 0 0 0-.84 4 4 0 0 0-2.16-2.4 4 4 0 0 0-1.29-.35 5.34 5.34 0 0 0-2.52.38 3 3 0 0 0-1.62-1.8 3.22 3.22 0 0 0-1.45-.28v11.44a5.2 5.2 0 0 0 .79 1 4.76 4.76 0 0 0 2.54 1.48Z"
                                }),
                                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                    className: "mcls-12",
                                    d: "M493.94 201.07a8.11 8.11 0 0 0-2.95-6.26 8 8 0 0 0-1.82-1.14v18.71h4.77Z"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-6",
                            d: "M352 260.61a23.44 23.44 0 0 1 46.87 0"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            style: {
                                fill: "#00c7e5"
                            },
                            d: "M485.28 242.64h90.95v11.04h-90.95z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-6",
                            d: "M434.41 260.61a23.44 23.44 0 0 1 46.87 0"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            d: "M246.79 253.68h333.07a1.59 1.59 0 0 1 1.59 1.59V259a1.59 1.59 0 0 1-1.59 1.59H246.79v-6.94.03Z",
                            style: {
                                fill: "#ebecf0"
                            }
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-11",
                            d: "M512.09 260.61a23.44 23.44 0 0 1 46.87 0"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            style: {
                                fill: "url(#linear-gradient-5)"
                            },
                            d: "M293.16 278.58h-102l50.45-29.82h95.7v3.72l-44.15 26.1z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            style: {
                                fill: "url(#linear-gradient-6)"
                            },
                            d: "M293.16 274.86h-102l44.15-26.1h102l-44.15 26.1z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-11",
                            d: "M191.16 274.86h102v3.72h-102z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-11",
                            transform: "rotate(42.67 414.96 179.009)",
                            d: "M403.47 91.72h22.94v174.57h-22.94z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-23",
                            transform: "rotate(42.67 418.016 180.072)",
                            d: "M406.53 92.78h22.94v174.57h-22.94z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-6",
                            d: "M358.7 114.05v123.17l-16.45 16.46V97.6l16.45 16.45z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            style: {
                                fill: "url(#linear-gradient-7)"
                            },
                            d: "M468.82 114.05H358.7L342.25 97.6h143.03l-16.46 16.45z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            style: {
                                fill: "url(#linear-gradient-8)"
                            },
                            d: "M468.82 114.05v123.17l16.46 16.46V97.6l-16.46 16.45z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-6",
                            d: "M468.82 237.22H358.7l-16.45 16.46h143.03l-16.46-16.46z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-7",
                            d: "M375.43 242.64h-10.12a18 18 0 1 0 0 35.94h10.12a18 18 0 0 0 0-35.94ZM457.84 242.64h-10.12a18 18 0 0 0 0 35.94h10.12a18 18 0 1 0 0-35.94ZM547.14 242.64H537a18 18 0 1 0 0 35.94h10.12a18 18 0 1 0 0-35.94Z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-26",
                            cx: 375.43,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-27",
                            d: "m174.35 237.28 2.43-.77 2.16-3.46.47-3.61h-1.76l-4.33 6.24 1.03 1.6z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-26",
                            cx: 457.84,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-26",
                            cx: 547.14,
                            cy: 260.61,
                            r: 17.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-28",
                            cx: 375.43,
                            cy: 260.61,
                            r: 10.27
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("rect", {
                            className: "mcls-29",
                            x: 28.95,
                            y: 223.66,
                            width: 33.77,
                            height: 33.96,
                            rx: 2.11,
                            ry: 2.11
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("rect", {
                            x: 69.41,
                            y: 190.27,
                            width: 33.77,
                            height: 67.09,
                            rx: 2.11,
                            ry: 2.11,
                            transform: "translate(-9.48 3.89)",
                            style: {
                                fill: "url(#New_Gradient_Swatch_11)"
                            }
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("rect", {
                            className: "mcls-7",
                            x: 113.23,
                            y: 160.1,
                            width: 33.77,
                            height: 95.87,
                            rx: 2.11,
                            ry: 2.11,
                            transform: "rotate(3.37 130.137 208.135)"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-28",
                            cx: 457.84,
                            cy: 260.61,
                            r: 10.27
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-28",
                            cx: 547.14,
                            cy: 260.61,
                            r: 10.27
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            id: "_Ellipse_",
                            className: "mcls-14",
                            cx: 357.46,
                            cy: 49.43,
                            r: 48.15
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-31",
                            d: "M352.31 53.17 341.9 42.76a1.29 1.29 0 0 0-1.83 0l-9 9a1.3 1.3 0 0 0 0 1.84L351.4 74a1.3 1.3 0 0 0 1.83 0L380 47.26l-8-13.78ZM387.49 39.74a1.3 1.3 0 0 0 0-1.83l-9-9a1.3 1.3 0 0 0-1.84 0l-2.73 2.73 8 13.79Z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-32",
                            d: "M383 90.22a48.08 48.08 0 0 0 22.53-38.65h-20.12l-3.57-6.18-1.84 1.87 3.2 5.55a2.19 2.19 0 0 0-.14.72ZM356.39 1.31c-.93 0-1.85.06-2.77.14a1.63 1.63 0 0 0 .16.47L372 33.48l1.88-1.88Z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-31",
                            d: "M373.88 31.6 372 33.48l7.96 13.78 1.88-1.87-7.96-13.79z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-32",
                            d: "M373.88 31.6 372 33.48l7.96 13.78 1.88-1.87-7.96-13.79z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("rect", {
                            className: "mcls-29",
                            x: 394.56,
                            y: 56.69,
                            width: 40.9,
                            height: 40.9,
                            rx: 1.97,
                            ry: 1.97
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-33",
                            d: "m423 88.66-7.36-5.85-7.36 5.85a1.59 1.59 0 0 1-2.54-1.41V68.68a1.68 1.68 0 0 1 1.6-1.75H424a1.68 1.68 0 0 1 1.6 1.75v18.57a1.59 1.59 0 0 1-2.6 1.41Z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            style: {
                                strokeLinecap: "round",
                                strokeWidth: "2.56px",
                                strokeMiterlimit: 10,
                                stroke: "#ebecf0",
                                fill: "none"
                            },
                            d: "m357.46 1.28 55.59 96.3v156.1"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            style: {
                                stroke: "#c1c7d0",
                                strokeWidth: "2.56px",
                                strokeMiterlimit: 10,
                                fill: "none"
                            },
                            d: "m143.68 266.28 32.01-32.01"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-11",
                            cx: 109.28,
                            cy: 267.4,
                            r: 8.68
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-11",
                            cx: 30.11,
                            cy: 267.4,
                            r: 8.68
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-8",
                            cx: 30.3,
                            cy: 267.4,
                            r: 4.19
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-8",
                            cx: 109.48,
                            cy: 267.4,
                            r: 4.19
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("g", {
                            style: {
                                clipPath: "url(#clip-path-2)"
                            },
                            children: [
                                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                    className: "mcls-7",
                                    d: "m274.31 192.47 12.58.92 11-4.63 1.88 3.33-13.19 5.21-13.25 2c.35-2.3.67-4.57.98-6.83Z"
                                }),
                                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("rect", {
                                    id: "_Rectangle_4",
                                    x: 198.04,
                                    y: 123.84,
                                    width: 180.62,
                                    height: 69.51,
                                    rx: 2.87,
                                    ry: 2.87,
                                    transform: "rotate(7.47 288.498 158.695)",
                                    style: {
                                        fill: "url(#linear-gradient-9)"
                                    }
                                }),
                                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                    className: "mcls-32",
                                    d: "m327.55 198.79 36.44 4.78v-70.1l-36.44-4.78v70.1z"
                                }),
                                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                                    cx: 355.25,
                                    cy: 182.61,
                                    r: 11.6,
                                    style: {
                                        opacity: 0.8,
                                        fill: "#2684ff"
                                    }
                                }),
                                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("rect", {
                                    className: "mcls-29",
                                    x: 205.98,
                                    y: 152.89,
                                    width: 22.41,
                                    height: 22.41,
                                    rx: 3.36,
                                    ry: 3.36,
                                    transform: "rotate(7.47 217.246 164.193)"
                                }),
                                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                    className: "mcls-39",
                                    d: "m210.91 125.77 160.73 21.08M209.25 138.46l100.28 13.16M238.36 165.64l67.68 8.87"
                                }),
                                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                    className: "mcls-40",
                                    d: "m214.59 170.1-4.82-6.27 2.55-1.95 2.86 3.72 7.75-5.95 1.95 2.54-10.29 7.91z"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("ellipse", {
                            className: "mcls-32",
                            cx: 260.19,
                            cy: 267.4,
                            rx: 29.83,
                            ry: 5.59
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-18",
                            d: "M254.09 263.06a7.56 7.56 0 0 0-1.79 1.17 7.77 7.77 0 0 0-1.4 1.62c.15.29.31.59.5.89a12.89 12.89 0 0 0 3.37 3.61l3.79-.44a1 1 0 0 0 0-.31c-.28-1-2-1.1-2.15-1.11a4.74 4.74 0 0 1-.71-2 4.88 4.88 0 0 1 .21-2.08Z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-7",
                            cx: 261.38,
                            cy: 200.79,
                            r: 7.54
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-18",
                            d: "M265 211.41c2.26-2.42 8.22-2.15 10.36.63s.21 8.46-2.2 15c-.67 1.8-1.7 4.44-6.54 14.8-2.69 5.76-3.25 6.83-4.95 10.54-2.42 5.3-4.26 9.66-5.42 12.46l-3.44-1.12c1.12-3.88 1.91-7.07 2.41-9.23 1.06-4.57 1.43-7 2.68-11 .83-2.6 1.66-4.67 2.22-6q.65-3.12 1.25-6.33 1.19-6.24 2.11-12.23a9.78 9.78 0 0 1 0-4 7.79 7.79 0 0 1 1.52-3.52ZM277.66 262.84c-.08.54-.15 1.13-.19 1.74a20.28 20.28 0 0 0 0 2.32.63.63 0 0 0 .69.59l7.82-1a1.47 1.47 0 0 0-.39-1c-.36-.33-.82-.24-1.39-.27a6.1 6.1 0 0 1-3.09-1.16 4.81 4.81 0 0 1-1.3-1.55Z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-26",
                            d: "M269.26 207.65a6.69 6.69 0 0 1 5.19.12c2.08 1.07 3.29 3.54 4.36 13.19.53 4.8.87 10 1 17.94.1 5.94 0 7.35.15 12.61.16 4.9.44 8.9.65 11.54l-3.86.7a207.77 207.77 0 0 1-3.28-11.85 30.68 30.68 0 0 1-1.2-7.56 38.52 38.52 0 0 1 .52-6.15c.11-.63.23-1.22.35-1.76-.4-1.27-1-3.25-1.91-5.66-1.07-3-2-5.62-3.42-8.9-2.37-5.51-3.13-6-2.95-8a7.6 7.6 0 0 1 4.4-6.22Z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-7",
                            d: "M275 186a6.23 6.23 0 0 1 .67 4.22 5.31 5.31 0 0 1-1.87 3.09 3.83 3.83 0 0 1-1.37.65 2.82 2.82 0 0 1-1.39.08c-1.65-.65-.72-7.43 1.31-9.35a1.43 1.43 0 0 1 1-.48c.79.06 1.32 1.16 1.65 1.79Z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-18",
                            d: "M263.21 215.59a13.12 13.12 0 0 0 16.4-2.26 11.43 11.43 0 0 1-1.52-2.32 11.92 11.92 0 0 1-1-7.18c.32-1.67.8-1.92.66-3.17a2.34 2.34 0 0 0 0-.26 13.39 13.39 0 0 0-1.23-3.15c-.47-.81-1.06-1.92-1.81-3.47a22.44 22.44 0 0 0-11.86 3.35 53.76 53.76 0 0 0 1.53 5.55c1 2.92 1.67 4.12 1.3 6a20.7 20.7 0 0 1-1.13 2.89 34.84 34.84 0 0 0-1.34 4.02Z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            id: "_Path_",
                            className: "mcls-41",
                            d: "M275.13 188.51c0 .06-.11.14-.28.31a3.72 3.72 0 0 1-.35.31c0 .26.06.54.07.84a13.63 13.63 0 0 1 0 1.56 10.66 10.66 0 0 1-1.57.47 8.24 8.24 0 0 1-2.94.25 5.37 5.37 0 0 1-1.95-.51 4.34 4.34 0 0 1 3.06-8.07 3.67 3.67 0 0 1 2.1 1.5c.27.47.17.54.62 1.32a7.84 7.84 0 0 0 .45.73c.52.78.89 1.01.79 1.29Z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-41",
                            d: "M267.69 190.41a4.74 4.74 0 0 1 .72 4.33c.79.39 1.59.8 2.4 1.24 1.16.62 2.28 1.25 3.35 1.87l-1.7-3.15c0-.36-.09-.75-.11-1.17a13 13 0 0 1 0-1.45ZM260.34 172.25l.43-3.23a12.75 12.75 0 0 0-.4-1.81c-.14-.45-.28-.82-.61-.94a.66.66 0 0 0-.35-.05.49.49 0 0 0-.18-.47.47.47 0 0 0-.51-.05.45.45 0 0 0-.22.44.52.52 0 0 0-.34 0c-.42.2-.47 1.14-.16 2.34-.43-.51-.93-.74-1.23-.59a.41.41 0 0 0-.19.2l.94 1.37a3.73 3.73 0 0 0 .27 1 3.66 3.66 0 0 0 1.1 1.4Z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-7",
                            d: "M272.14 187.6c-.37.59-.63.35-1 .88-.76 1.11.28 2.27-.42 3.3-.34.49-.77.23-1 .7-.39.69.44 1.3.3 2.42a2.63 2.63 0 0 1-1.49 2c-.91.38-1.42-.25-2.09.1-1 .51-.33 2.11-1.2 3.22-1.15 1.47-4.19 1.95-6.39.59a5.84 5.84 0 0 1-2.39-5.71 6.5 6.5 0 0 1 2.43-4.16c1.26-1 2.12-.77 3.28-2a6.32 6.32 0 0 0 1.44-2.33 8.33 8.33 0 0 1 2.4-3.21 6.17 6.17 0 0 1 3.81-1c.87 0 2.52 0 3.21 1.08a1.85 1.85 0 0 1 .28 1.5c-.08.22-.17.26-.35.5-.64.76-.35 1.36-.82 2.12Z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-18",
                            d: "m268.7 198.6-4.56-12.6q-1.81-7.42-3.64-14.84l-2.26.38a126.52 126.52 0 0 0 5.66 30ZM264.63 184.62a4.56 4.56 0 0 1 9.12 0Z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-18",
                            d: "M269.06 182.72h6.26a1.9 1.9 0 0 1 1.9 1.9h-8.16v-1.9Z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            d: "M38.67 253.22h118v11.87a2.31 2.31 0 0 1-2.31 2.31H38.67v-14.18Z",
                            style: {
                                fill: "url(#linear-gradient-10)"
                            }
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-4",
                            d: "M15.56 253.22h35.2v14.18H17.87a2.31 2.31 0 0 1-2.31-2.31v-11.87Z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-16",
                            cx: 64.77,
                            cy: 267.4,
                            r: 8.68
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-16",
                            cx: 143.95,
                            cy: 267.4,
                            r: 8.68
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-23",
                            cx: 64.77,
                            cy: 267.4,
                            r: 4.19
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("circle", {
                            className: "mcls-23",
                            cx: 143.95,
                            cy: 267.4,
                            r: 4.19
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-27",
                            d: "m177.09 228.98-2.01 1.55-2.63 3.74h1.18l2.06-1.19 2.43-1.06.82-3.04h-1.85z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-7",
                            d: "m196.64 204.47-13.36 9.62a4.61 4.61 0 0 0-1.58 2l-5.6 13.36 3.11 1.79 7.51-12.63 10.1-4.79Z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            id: "_Clipping_Path_12",
                            className: "mcls-43",
                            d: "m188.18 278.83-8.41-.52.34-5.32 2.69.86a3.58 3.58 0 0 0 1.33 2.3c1.18.84 2.55.33 3.46 1.33a2.43 2.43 0 0 1 .59 1.35Z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            id: "_Clipping_Path_13",
                            className: "mcls-43",
                            d: "m219.2 271.38-9.31-.52.33-5.92 3 .3c.21 2 .9 2.81 1.48 3.2 1.26.9 2.83.32 3.85 1.46a2.6 2.6 0 0 1 .65 1.48Z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-27",
                            d: "M204.77 206.24a6.45 6.45 0 0 1-6.2-.82 10.47 10.47 0 0 0 2.1-6l5.21.66Z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-27",
                            d: "M209 195.1c.12.76.29 1.58.5 2.45s.42 1.53.64 2.21l-1.16.17-.52 3.12a8.24 8.24 0 0 1-3.53.31c-1.13-.08-2.28-.15-2.87-1a4.45 4.45 0 0 1-.43-.91 4 4 0 0 0-.26-.56c-.11-.23-.28-.55-.5-.94a2.78 2.78 0 0 0 1.27.22 1.58 1.58 0 0 0 1.18-.38 2.71 2.71 0 0 1-1.11-1.55 3.07 3.07 0 0 1 1.76-3.21c.22-.1.54-.22 3.61-.06Z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-44",
                            d: "M191.51 224.66c-.77 1.53-1.43 3.15-2.1 4.86a73 73 0 0 0-4.58 19.75c-.88 2.28-1.72 4.72-2.52 7.29a107.38 107.38 0 0 0-3.73 17.2l4.46.83 7.51-23.32c.41-1 1-2.38 1.72-4.11 5.19-12.58 5.65-14.8 4.9-17-.45-1.29-1.65-3.55-5.66-5.5Z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-44",
                            d: "M200.48 225.05a3.11 3.11 0 0 1 .52 0c1.36.21 3.67 1.42 9 8.09 1.49 1.87 3.38 4.38 5.42 7.48a3 3 0 0 1 .49 1.83q-.27 5-.77 10.27c-.43 4.5-1 8.82-1.55 12.95a5.88 5.88 0 0 1-2.56.67 6 6 0 0 1-3.25-.86 52.3 52.3 0 0 0 .43-5.84c.06-3.45-.25-5.19-.36-8.61a68 68 0 0 1 .19-8 271.76 271.76 0 0 1-10.49-3.8c-5.18-2-6.54-2.72-7.41-4.21-1.95-3.32.1-7.78.84-9.24 4 .8 5.78.49 6.64 0a5.59 5.59 0 0 1 2.86-.73Z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-18",
                            d: "M194.82 207.44a5 5 0 0 1 5.54-3.9l7.26 1 1.52 10.55q-1.71 6.72-3.43 13.42l-5.39.78a13.8 13.8 0 0 1-10-2.42l-.81-.57 4.7-16Z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-27",
                            d: "m225.19 230.62 1.05 1.83.78.65-.16 1.8.76.43.82-.87v1.06h.75l1.18-2.98-1.38-2.39-2.59-1.79-1.21 2.26z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-18",
                            d: "m203.21 205.09 6.89 15.3a8.49 8.49 0 0 0 3.23 3.71l11.88 7.47 2.39-2.69-11.87-9.81a47.79 47.79 0 0 1-2.22-6.94c-.6-2.57-.67-3.92-1.92-5.33a7.19 7.19 0 0 0-8.38-1.71Z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-44",
                            d: "M200.48 201.12h2.61a1.35 1.35 0 0 0 .92-.64c.26-.61-.48-1.1-.43-2s.92-1.9 1.4-1.79c.12 0 .34.16.5.83h1a3.08 3.08 0 0 1 1.41-1.93c1-.5 1.74-.06 2.41-.53.46-.33.88-1.15.57-3.3-.91-.05-2.12-.11-3.55-.16-4.43-.16-5.06 0-5.71.38a4.75 4.75 0 0 0-2.12 4.23c.14 1 .76 1.56 1 3.28a7.56 7.56 0 0 1-.01 1.63Z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            style: {
                                stroke: "#c1c7d0",
                                strokeLinecap: "round",
                                strokeWidth: "2.56px",
                                strokeMiterlimit: 10,
                                fill: "none"
                            },
                            d: "M171.41 234.27h8.57"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-18",
                            d: "M199.63 197.05a4.56 4.56 0 1 1 7.79-4.73Z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-18",
                            d: "M202.33 190.88h6.26a1.9 1.9 0 0 1 1.9 1.9h-8.16v-1.9Z",
                            transform: "rotate(-31.25 206.405 191.831)"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            id: "_Rectangle_5",
                            className: "mcls-40",
                            d: "M303.04 72.42h21.97v25.57h-21.97z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-40",
                            d: "M299.85 69.1h6.39v3.33h-6.39zM287.79 69.1h6.39v3.33h-6.39zM311.9 69.1h6.39v3.33h-6.39z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            id: "_Rectangle_6",
                            style: {
                                fill: "#2684ff"
                            },
                            d: "M281.07 72.42h21.97v25.57h-21.97z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-33",
                            d: "M310.89 88h6.58v10h-6.58z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-29",
                            d: "M288.76 88h6.58v10h-6.58z"
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            className: "mcls-32",
                            d: "M485.28 171.09h3.93v82.58h-3.93z"
                        })
                    ]
                })
            })
        ]
    }));
var $38c55a02ec9b8a11$export$2e2bcd8739ae039 = $38c55a02ec9b8a11$var$SvgMoving;


const $c90d30f66179d2c0$var$_2 = "._p12f1kdj{max-width:25pc}";
const $c90d30f66179d2c0$var$_ = "._1yt414lv{padding:var(--_cpuyf2)}";
const $c90d30f66179d2c0$var$styles = null;
const $c90d30f66179d2c0$var$NotFoundView = ()=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $9bbee8e48028edce$export$2e2bcd8739ae039), {
        title: translate((0, $447ba15143f7eed7$exports).USER_NOT_FOUND_MESSAGE),
        hero: /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                    children: [
                        $c90d30f66179d2c0$var$_,
                        $c90d30f66179d2c0$var$_2
                    ]
                }),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $38c55a02ec9b8a11$export$2e2bcd8739ae039), {
                    className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                        "_1yt414lv _p12f1kdj"
                    ]),
                    style: {
                        "--_cpuyf2": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.200'))
                    }
                })
            ]
        })
    });
};
var $c90d30f66179d2c0$export$2e2bcd8739ae039 = $c90d30f66179d2c0$var$NotFoundView;





var $7fPBF = parcelRequire("7fPBF");

const $24b14210ebbca78e$var$NotFound = ()=>{
    (0, $7fPBF.useEffect)(()=>{
        (0, $275512fd46801a1e$export$bd13a0a8c0977b2f)('Not Found');
    }, []);
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $ef58838c74859603$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $c90d30f66179d2c0$export$2e2bcd8739ae039), {})
    });
};
var $24b14210ebbca78e$export$2e2bcd8739ae039 = $24b14210ebbca78e$var$NotFound;






var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");

const $84c3e18687517729$export$99bb917aa12beaf8 = (values)=>{
    if (values == null || values.length === 0) return '';
    else if (values.length === 1) return values[0];
    else return `${values.slice(0, -1).join(', ')} and ${values.slice(-1)}`;
};





const $603bd90c46957049$export$faf42b3a43b63a45 = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.preferences.email, (email)=>email);
const $603bd90c46957049$export$cd62b380406677c3 = (0, $8098b29b64296697$export$595d22ed68ca2841)((state, groupKey)=>state.preferences.groups[groupKey], (group)=>group);
const $603bd90c46957049$export$d2800e0e69cd41a5 = (groupKey, tabKey)=>(0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.preferences.groups, (groups)=>{
        return Object.keys(groups[groupKey].tabs[tabKey].items);
    });
const $603bd90c46957049$export$48df6acab50c159b = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.preferences.groups, (state)=>state.preferences.filter, (groups, filter)=>{
    let groupKeys = Object.keys(groups);
    if (filter.groupKey !== 'all') groupKeys = groupKeys.filter((key)=>key === filter.groupKey);
    return groupKeys;
});
const $603bd90c46957049$export$c5a1c46e828bfb34 = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.preferences.filter, (filter)=>filter);
const $603bd90c46957049$export$43d45db6467effac = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.preferences.filter, (subscriptionGroupForView)=>subscriptionGroupForView.groupKey === 'all');
const $603bd90c46957049$export$f26c97331adc89d5 = (groupKey, itemKey, tabKey)=>(0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.preferences.groups, (groups)=>{
        try {
            return groups[groupKey].tabs[tabKey !== null && tabKey !== void 0 ? tabKey : 'root'].items[itemKey];
        } catch (e) {
            return undefined;
        }
    });
const $603bd90c46957049$export$d3a73181b80e0de7 = (itemKey)=>(0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.preferences.initialStates, (initialStates)=>initialStates[itemKey]);
const $603bd90c46957049$export$a2262118789c43db = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.preferences.actionResult, (actionResult)=>actionResult);
const $603bd90c46957049$export$b4f431af37c9cd8b = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.preferences.status, (status)=>status);
const $603bd90c46957049$export$5bb16d4fc4eb5b53 = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.preferences.consentDialog, (consentDialog)=>consentDialog);
const $603bd90c46957049$export$e15e41f6dd0733a8 = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.preferences.consentDeclinePrDialog, (consentDeclinePrDialog)=>consentDeclinePrDialog);
const $603bd90c46957049$export$4c4595253c03ba56 = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.preferences.globalUnsubscribeDialog, (globalUnsubscribeDialog)=>globalUnsubscribeDialog);
const $603bd90c46957049$export$aa0ab7810228523b = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.preferences.doubleOptInDialog, (doubleOptInDialog)=>doubleOptInDialog);
const $603bd90c46957049$export$5eb6bff4dfa33c8a = (0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>{
    var _state_preferences;
    return (_state_preferences = state.preferences) === null || _state_preferences === void 0 ? void 0 : _state_preferences.hid;
}, (hid)=>hid);






var $7fPBF = parcelRequire("7fPBF");


const $8c30ca0181fdf91d$var$ErrorAcceptGmoi = ({ onClose: onClose })=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    (0, $7fPBF.useEffect)(()=>{
        (0, $0e08eda71bb24540$export$46324d0949923406)();
    }, []);
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $548d2678bd231d64$export$3e68361a3d3e7b9f), {
        title: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_ERROR_MESSAGE_TITLE),
        onClose: onClose,
        children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("p", {
            children: translate((0, $447ba15143f7eed7$exports).GMOI_REQUEST_ERROR_MESSAGE)
        })
    });
};
var $8c30ca0181fdf91d$export$2e2bcd8739ae039 = $8c30ca0181fdf91d$var$ErrorAcceptGmoi;








var $7fPBF = parcelRequire("7fPBF");


const $3b522bd925217c58$var$ErrorRequest = ({ onClose: onClose })=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    (0, $7fPBF.useEffect)(()=>{
        (0, $0e08eda71bb24540$export$d6067dcb8ad24019)();
    });
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $548d2678bd231d64$export$3e68361a3d3e7b9f), {
        title: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_ERROR_MESSAGE_TITLE),
        onClose: onClose,
        children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("p", {
            children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $8773d15fad8814a3$export$2e2bcd8739ae039), {
                value: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_ERROR_MESSAGE_DESCRIPTION),
                start: -4
            })
        })
    });
};
var $3b522bd925217c58$export$2e2bcd8739ae039 = $3b522bd925217c58$var$ErrorRequest;







var $7fPBF = parcelRequire("7fPBF");



var $j9spr = parcelRequire("j9spr");

var $7fPBF = parcelRequire("7fPBF");



var $e994e5e247638dae$var$flexGrowMap = {
    hug: (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $e994e5e247638dae$var$Stack = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role, id = _ref.id;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $e994e5e247638dae$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $0a833860173a6d7c$export$2e2bcd8739ae039), {
        id: id,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$e994e5e247638dae$var$Stack.displayName = 'Stack';
var $e994e5e247638dae$export$2e2bcd8739ae039 = $e994e5e247638dae$var$Stack;




parcelRequire("7fPBF");


const $00311d30dbeb7c25$export$8bf0c85141e34136 = ()=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $c5afab4d5c610ba2$export$2e2bcd8739ae039), {
        onClick: ()=>window.open('https://support.atlassian.com/atlassian-account/docs/manage-your-email-and-notification-preferences/', '_blank'),
        children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_LEARN_MORE_BUTTON_LABEL)
    });
};
const $00311d30dbeb7c25$export$97c812ea8115c82b = (props)=>{
    const { translate: translate, keyWithTitle: keyWithTitle } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    const href = (0, $d9fd026bfea79ab9$export$b66bb29c5006f12f)('/');
    const subscribeToCallback = ()=>{
        var _props_onSubscribeCallback;
        const params = new URLSearchParams({
            hid: props.hid,
            subscribeKeys: props.subscriptionKey
        });
        window.location.href = `${href}?${params.toString()}`;
        (_props_onSubscribeCallback = props.onSubscribeCallback) === null || _props_onSubscribeCallback === void 0 ? void 0 : _props_onSubscribeCallback.call(props);
    };
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $c5afab4d5c610ba2$export$2e2bcd8739ae039), {
        onClick: subscribeToCallback,
        children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_SUBSCRIBE_TO_BUTTON_LABEL, {
            subscription: translate(keyWithTitle(props.subscriptionKey)) || ''
        })
    });
};


const $8a0e3720aadb081f$var$SuccessGlobalUnsubscribe = ({ onClose: onClose })=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    (0, $7fPBF.useEffect)(()=>{
        (0, $0e08eda71bb24540$export$24a9508d2a444047)();
    }, []);
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $548d2678bd231d64$export$e80deec18a12daba), {
        title: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_GLOBAL_UNSUBSCRIBE_MESSAGE_TITLE),
        onClose: onClose,
        actions: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $00311d30dbeb7c25$export$8bf0c85141e34136), {}, 'learn-more')
        ],
        children: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $e994e5e247638dae$export$2e2bcd8739ae039), {
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                        as: "p",
                        children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_UNSUBSCRIBE_MESSAGE_BODY_PRIMARY)
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                        as: "p",
                        children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_UNSUBSCRIBE_MESSAGE_BODY_SECONDARY)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                size: "small",
                children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_UNSUBSCRIBE_MESSAGE_BODY_TERTIARY)
            })
        ]
    });
};
var $8a0e3720aadb081f$export$2e2bcd8739ae039 = $8a0e3720aadb081f$var$SuccessGlobalUnsubscribe;







var $7fPBF = parcelRequire("7fPBF");




const $b2aa151dc8a94c41$var$SuccessSubscribeKeys = ({ data: data, onClose: onClose })=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    (0, $7fPBF.useEffect)(()=>{
        (0, $0e08eda71bb24540$export$3830a8576e3e4291)();
    }, []);
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $548d2678bd231d64$export$e80deec18a12daba), {
        title: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_SUBSCRIBE_MESSAGE_TITLE, {
            subscriptions: data || ''
        }),
        onClose: onClose,
        actions: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $00311d30dbeb7c25$export$8bf0c85141e34136), {}, 'learn-more')
        ],
        children: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $e994e5e247638dae$export$2e2bcd8739ae039), {
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                        as: "p",
                        children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_SUBSCRIBE_MESSAGE_BODY_PRIMARY)
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                        as: "p",
                        children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_SUBSCRIBE_MESSAGE_BODY_SECONDARY)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                size: "small",
                children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_SUBSCRIBE_MESSAGE_BODY_TERTIARY)
            })
        ]
    });
};
var $b2aa151dc8a94c41$export$2e2bcd8739ae039 = $b2aa151dc8a94c41$var$SuccessSubscribeKeys;







var $7fPBF = parcelRequire("7fPBF");




const $63f6bb9c35df9152$var$SuccessUnsubscribeKeys = ({ data: data, onClose: onClose })=>{
    var _searchParams_get;
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    // get list of subscriptions the user unsubscribed from by parsing the query params
    const searchParams = new URLSearchParams(window.location.search);
    const subscriptions = (_searchParams_get = searchParams.get('key')) === null || _searchParams_get === void 0 ? void 0 : _searchParams_get.split(',');
    (0, $7fPBF.useEffect)(()=>{
        subscriptions === null || subscriptions === void 0 ? void 0 : subscriptions.map((subscription)=>(0, $0e08eda71bb24540$export$f508667310aad4a2)({
                source: subscription
            }));
    }, [
        subscriptions
    ]);
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("div", {
        "data-testid": 'unsubscribe-key-success',
        children: /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $548d2678bd231d64$export$e80deec18a12daba), {
            title: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_UNSUBSCRIBE_MESSAGE_TITLE, {
                subscriptions: data || ''
            }),
            onClose: onClose,
            actions: [
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $00311d30dbeb7c25$export$8bf0c85141e34136), {}, 'learn-more')
            ],
            children: [
                /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $e994e5e247638dae$export$2e2bcd8739ae039), {
                    space: "space.100",
                    children: [
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                            as: "p",
                            children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_UNSUBSCRIBE_MESSAGE_BODY_PRIMARY)
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                            as: "p",
                            children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_UNSUBSCRIBE_MESSAGE_BODY_SECONDARY)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                    size: "small",
                    children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_UNSUBSCRIBE_MESSAGE_BODY_TERTIARY)
                })
            ]
        })
    });
};
var $63f6bb9c35df9152$export$2e2bcd8739ae039 = $63f6bb9c35df9152$var$SuccessUnsubscribeKeys;







var $7fPBF = parcelRequire("7fPBF");



const $0ad4fbc82d36f8fc$var$SuccessUpdatePreferences = ({ onClose: onClose })=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    (0, $7fPBF.useEffect)(()=>{
        (0, $0e08eda71bb24540$export$a5babd368b9bd0a8)();
    }, []);
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $548d2678bd231d64$export$e80deec18a12daba), {
        title: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_UPDATE_SUCCESS_MESSAGE_TITLE),
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $e994e5e247638dae$export$2e2bcd8739ae039), {
                space: "space.100",
                children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                    as: "p",
                    children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_UPDATE_SUCCESS_MESSAGE_DESCRIPTION)
                })
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                size: "small",
                children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_NOTE_MESSAGE)
            })
        ]
    });
};
var $0ad4fbc82d36f8fc$export$2e2bcd8739ae039 = $0ad4fbc82d36f8fc$var$SuccessUpdatePreferences;








var $7fPBF = parcelRequire("7fPBF");

const $bce5319e3dfe5388$var$SuccessWithWarning = ({ success: Success, warning: Warning, onClose: onClose })=>{
    const [successIsVisible, setSuccessIsVisible] = (0, $7fPBF.useState)(true);
    const [warningIsVisible, setWarningIsVisible] = (0, $7fPBF.useState)(true);
    (0, $7fPBF.useEffect)(()=>{
        if (!successIsVisible && !warningIsVisible) onClose();
    }, [
        successIsVisible,
        warningIsVisible
    ]);
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $e994e5e247638dae$export$2e2bcd8739ae039), {
        space: "space.100",
        children: [
            successIsVisible && /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)(Success, {
                onClose: ()=>setSuccessIsVisible(false)
            }),
            warningIsVisible && /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)(Warning, {
                onClose: ()=>setWarningIsVisible(false)
            })
        ]
    });
};
var $bce5319e3dfe5388$export$2e2bcd8739ae039 = $bce5319e3dfe5388$var$SuccessWithWarning;











parcelRequire("7fPBF");

const $1b587718cdc002ab$var$productInvitationsKey = 'productInvitations';
const $1b587718cdc002ab$var$ProductInvitationsWarning = ({ onClose: onClose })=>{
    const { translate: translate, keyWithTitle: keyWithTitle } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    const hid = (0, $f30b917334351296$export$2105062e25df4afe)((0, $603bd90c46957049$export$5eb6bff4dfa33c8a));
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $548d2678bd231d64$export$8cc5afb04fcb8e07), {
        title: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_PRODUCT_INVITATIONS_WARNING_TITLE),
        onClose: onClose,
        actions: hid ? [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $00311d30dbeb7c25$export$97c812ea8115c82b), {
                hid: hid,
                subscriptionKey: $1b587718cdc002ab$var$productInvitationsKey,
                onSubscribeCallback: (0, $0e08eda71bb24540$export$e40784e30c403486)
            }, 'subscribe-to-product-invitations')
        ] : undefined,
        children: /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $e994e5e247638dae$export$2e2bcd8739ae039), {
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                    as: "p",
                    children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_PRODUCT_INVITATIONS_WARNING_BODY_PRIMARY, {
                        subscription: translate(keyWithTitle($1b587718cdc002ab$var$productInvitationsKey))
                    })
                }),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                    as: "p",
                    children: translate((0, $447ba15143f7eed7$exports).NOTIFICATION_PRODUCT_INVITATIONS_WARNING_BODY_SECONDARY, {
                        section: translate(keyWithTitle('product_surveys'))
                    })
                })
            ]
        })
    });
};
var $1b587718cdc002ab$export$2e2bcd8739ae039 = $1b587718cdc002ab$var$ProductInvitationsWarning;




const $6b41785aa38675ed$var$actionNotificationStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    display: 'flex',
    justifyContent: 'center',
    marginTop: 'space.100',
    marginBottom: 'space.200'
});
const $6b41785aa38675ed$var$resolveSuccessActionResult = (key, onClose, data)=>{
    switch(key){
        case 'unsubscribeAll':
            return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $bce5319e3dfe5388$export$2e2bcd8739ae039), {
                success: (0, $8a0e3720aadb081f$export$2e2bcd8739ae039),
                warning: (0, $1b587718cdc002ab$export$2e2bcd8739ae039),
                onClose: onClose
            });
        case 'updatePreferences':
            return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $0ad4fbc82d36f8fc$export$2e2bcd8739ae039), {
                onClose: onClose
            });
        case 'unsubscribeKeys':
            return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $63f6bb9c35df9152$export$2e2bcd8739ae039), {
                onClose: onClose,
                data: data
            });
        case 'subscribeKeys':
            return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $b2aa151dc8a94c41$export$2e2bcd8739ae039), {
                onClose: onClose,
                data: data
            });
        default:
            return null;
    }
};
const $6b41785aa38675ed$var$resolveErrorActionResult = (key, onClose)=>{
    switch(key){
        case 'acceptGmoi':
            return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $8c30ca0181fdf91d$export$2e2bcd8739ae039), {
                onClose: onClose
            });
        case 'request':
            return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $3b522bd925217c58$export$2e2bcd8739ae039), {
                onClose: onClose
            });
        default:
            return null;
    }
};
const $6b41785aa38675ed$var$resolveActionResultStatus = (status)=>{
    switch(status){
        case 'success':
            return $6b41785aa38675ed$var$resolveSuccessActionResult;
        case 'error':
            return $6b41785aa38675ed$var$resolveErrorActionResult;
    }
};
const $6b41785aa38675ed$var$ActionNotification = ()=>{
    const dispatch = (0, $7ef2374eddee6a70$export$f51d452c10d5b956)();
    const messageCloseHandler = (0, $7fPBF.useCallback)(()=>dispatch((0, $3d2cac913f314860$export$d684d3158aada635)()), [
        dispatch
    ]);
    const actionResult = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$a2262118789c43db));
    const { translate: translate, keyWithTitle: keyWithTitle } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    if (actionResult == null) return null;
    const subscriptionsWithGroup = [];
    const actionResultData = actionResult.data;
    if (actionResultData !== null && actionResultData !== undefined) {
        for (const subscriptions of actionResultData)// Subscriptions will be in the format ['groupKey1:subscriptionKey1', 'groupKey2:subscriptionKey2', ...]
        // groupKey will be empty for the hidden subscriptions
        for (const subscription of subscriptions.split(',')){
            const groupAndSubscriptionKey = subscription.split(':');
            const groupKey = groupAndSubscriptionKey[0];
            const subscriptionKey = groupAndSubscriptionKey[1];
            // For hidden subscriptions only use the subscriptionKey for the message
            if (groupKey) subscriptionsWithGroup.push(translate(keyWithTitle(groupKey)) + ': ' + translate(keyWithTitle(subscriptionKey)));
            else subscriptionsWithGroup.push(translate(keyWithTitle(subscriptionKey)));
        }
    }
    const notification = $6b41785aa38675ed$var$resolveActionResultStatus(actionResult.status)(actionResult.key, messageCloseHandler, (0, $84c3e18687517729$export$99bb917aa12beaf8)(subscriptionsWithGroup));
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
        xcss: $6b41785aa38675ed$var$actionNotificationStyles,
        testId: "preferences-center-action-notification",
        children: notification
    });
};
var $6b41785aa38675ed$export$2e2bcd8739ae039 = $6b41785aa38675ed$var$ActionNotification;




/* Skeleton.tsx generated by @compiled/babel-plugin v2.0.0 */ 

parcelRequire("7fPBF");
/* skeleton-heading-item.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $fa75feeaa55cf7b8$var$ATOMIC_GROUP_LENGTH = 5;
function $fa75feeaa55cf7b8$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $fa75feeaa55cf7b8$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


var $effa30ea74c01e92$var$styles = {
    skeleton: "_1rjcze3t _18zrpxbi _14mj53f4 _1ywu1ule _z0ai1r5k _1qdgu2gc _1hfkizff _aetrb3bt",
    customWidth: "_z0airzut"
};
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 * packages/design-system/menu/src/menu-item/skeleton-item.tsx
 *
 * Please update both.
 */ var $effa30ea74c01e92$var$shimmerKeyframes = null;
/**
 * These styles are defined using `css` rather than `cssMap` as there is a
 * bug when using `cssMap` that causes a build failure due to the use of keyframes.
 */ var $effa30ea74c01e92$var$shimmerStyles = null;
/**
 * __Skeleton heading item__
 *
 * A skeleton heading item is used in place of a heading item when its contents it not ready.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $effa30ea74c01e92$var$SkeletonHeadingItem = function SkeletonHeadingItem(_ref) {
    var _ref$isShimmering = _ref.isShimmering, isShimmering = _ref$isShimmering === void 0 ? false : _ref$isShimmering, testId = _ref.testId, width = _ref.width, xcss = _ref.xcss;
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        className: (0, $fa75feeaa55cf7b8$export$2e2bcd8739ae039)([
            $effa30ea74c01e92$var$styles.skeleton,
            width && $effa30ea74c01e92$var$styles.customWidth,
            isShimmering && "",
            isShimmering && "_unfq1yy8 _9nev1yy8 _kwc012o8 _joxl12o8 _18f312c5 _evp612c5 _19oh1254 _10881254 _18lgp3kn _zo24p3kn _1hfkizff _1rusizff",
            xcss
        ]),
        style: {
            '--width': width
        },
        "data-ds--menu--skeleton-heading-item": true,
        "data-testid": testId
    });
};
var $effa30ea74c01e92$export$2e2bcd8739ae039 = $effa30ea74c01e92$var$SkeletonHeadingItem;

/* skeleton-item.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $2fc3df4631a6889f$var$skeletonItemElemSize = 20;
var $2fc3df4631a6889f$var$styles = {
    root: "_1rjcze3t _18zrv47k _1e0c1txw _1tke1ylp _4cvr1h6o _lcxvglyw _14mj53f4 _1qdgrdoj _1hfkizff _aetrb3bt _3mxot94y",
    defaultWidth: "_sf1e1n8h _4rfy1ssb _baud1nrf _mr7o1vuk _69tq19wn _kt4d1n05",
    customWidth: "_11w8rzut",
    beforeElement: "_1mp4gktf _kfgtgktf _7bjqidpf _1rusizff _1kt9b3bt _1mbqdlk8 _1rhxv77o",
    avatar: "_rfx31rr0",
    icon: "_rfx3fajl",
    sideNavSkeleton: "_18zru2gc _kfgt1k8s _1mbqpxbi _1mp41k8s"
};
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 * packages/design-system/menu/src/menu-item/skeleton-heading-item.tsx
 *
 * Please update both.
 */ var $2fc3df4631a6889f$var$shimmerKeyframes = null;
/**
 * These styles are defined using `css` rather than `cssMap` as there is a bug when using
 * `cssMap` that causes a build failure due to the use of keyframes within this pseudo-element.
 */ var $2fc3df4631a6889f$var$shimmerStyles = null;
/**
 * __Skeleton item__
 *
 * A skeleton item is used in place of an item when its contents it not ready.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $2fc3df4631a6889f$var$SkeletonItem = function SkeletonItem(_ref) {
    var hasAvatar = _ref.hasAvatar, hasIcon = _ref.hasIcon, _ref$isShimmering = _ref.isShimmering, isShimmering = _ref$isShimmering === void 0 ? false : _ref$isShimmering, _ref$isSideNavSkeleto = _ref.isSideNavSkeleton, isSideNavSkeleton = _ref$isSideNavSkeleto === void 0 ? false : _ref$isSideNavSkeleto, testId = _ref.testId, width = _ref.width, xcss = _ref.xcss;
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        className: (0, $fa75feeaa55cf7b8$export$2e2bcd8739ae039)([
            $2fc3df4631a6889f$var$styles.root,
            (hasAvatar || hasIcon) && $2fc3df4631a6889f$var$styles.beforeElement,
            hasAvatar && $2fc3df4631a6889f$var$styles.avatar,
            hasIcon && $2fc3df4631a6889f$var$styles.icon,
            width ? $2fc3df4631a6889f$var$styles.customWidth : $2fc3df4631a6889f$var$styles.defaultWidth,
            isSideNavSkeleton && $2fc3df4631a6889f$var$styles.sideNavSkeleton,
            isShimmering && "",
            isShimmering && "_unfq1yy8 _9nev1yy8 _kwc012o8 _joxl12o8 _18f312c5 _evp612c5 _19oh1254 _10881254 _18lgp3kn _zo24p3kn _1hfkizff _1rusizff",
            xcss
        ]),
        style: {
            '--width': width
        },
        "data-testid": testId
    });
};
var $2fc3df4631a6889f$export$2e2bcd8739ae039 = $2fc3df4631a6889f$var$SkeletonItem;






const $6b7c307e3b08d158$var$_5 = "._67531crf>div:first-of-type:after{height:9pt}";
const $6b7c307e3b08d158$var$_4 = "._p12f1w8u{max-width:80%}";
const $6b7c307e3b08d158$var$_3 = "._2lx21bp4{flex-direction:column}";
const $6b7c307e3b08d158$var$_2 = "._1e0c1txw{display:flex}";
const $6b7c307e3b08d158$var$_ = "._1yt41ul9{padding:var(--_18cq338)}";
const $6b7c307e3b08d158$var$styles = null;
const $6b7c307e3b08d158$var$Skeleton = ()=>{
    const isPending = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $7a501a2d8adab3c3$export$6a1923cb7c064699));
    if (!isPending) return null;
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $7551ffa32d2a4800$export$3a31c848ced7e406), {
        children: /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                    children: [
                        $6b7c307e3b08d158$var$_,
                        $6b7c307e3b08d158$var$_2,
                        $6b7c307e3b08d158$var$_3,
                        $6b7c307e3b08d158$var$_4,
                        $6b7c307e3b08d158$var$_5
                    ]
                }),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("div", {
                    "data-testid": "skeleton-wrapper",
                    className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                        "_1yt41ul9 _1e0c1txw _2lx21bp4 _p12f1w8u _67531crf"
                    ]),
                    style: {
                        "--_18cq338": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.100'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $effa30ea74c01e92$export$2e2bcd8739ae039), {
                            isShimmering: true
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $2fc3df4631a6889f$export$2e2bcd8739ae039), {
                            isShimmering: true
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $2fc3df4631a6889f$export$2e2bcd8739ae039), {
                            isShimmering: true,
                            hasIcon: true
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $2fc3df4631a6889f$export$2e2bcd8739ae039), {
                            isShimmering: true,
                            hasIcon: true
                        }),
                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $2fc3df4631a6889f$export$2e2bcd8739ae039), {
                            isShimmering: true,
                            hasIcon: true
                        })
                    ]
                })
            ]
        })
    });
};
var $6b7c307e3b08d158$export$2e2bcd8739ae039 = $6b7c307e3b08d158$var$Skeleton;







parcelRequire("7fPBF");


/* EmptyView.tsx generated by @compiled/babel-plugin v2.0.0 */ 

parcelRequire("7fPBF");




var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

parcelRequire("7fPBF");
const $5317b8d7579cfa5a$var$SvgIncomingMessage = (props)=>/*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("svg", (0, $2qxEV._)((0, $9tqwB._)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 535.538 474.071"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("defs", {
                children: [
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "linear-gradient",
                        x1: -136.716,
                        y1: 85.338,
                        x2: 4.399,
                        y2: 85.338,
                        gradientTransform: "matrix(.818 -.355 0 1 88.514 172.44)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.121,
                                stopColor: "#fff",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.4,
                                stopColor: "#bbd6ff",
                                stopOpacity: 0.332
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.816,
                                stopColor: "#5a9cff",
                                stopOpacity: 0.809
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 1,
                                stopColor: "#3384ff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "linear-gradient-2",
                        x1: 292.375,
                        y1: 66.313,
                        x2: 311.681,
                        y2: 66.313,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.657,
                                stopColor: "#0065ff"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.756,
                                stopColor: "#0060f0"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.937,
                                stopColor: "#0052cc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("linearGradient", {
                        id: "linear-gradient-4",
                        x1: -158.115,
                        y1: 294.262,
                        x2: 51.105,
                        y2: 294.262,
                        xlinkHref: "#linear-gradient"
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("linearGradient", {
                        id: "linear-gradient-5",
                        x1: -158.115,
                        y1: 309.083,
                        x2: 51.105,
                        y2: 309.083,
                        xlinkHref: "#linear-gradient"
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("linearGradient", {
                        id: "linear-gradient-6",
                        x1: -158.115,
                        y1: 301.206,
                        x2: 51.105,
                        y2: 301.206,
                        xlinkHref: "#linear-gradient"
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "linear-gradient-7",
                        x1: 376.152,
                        y1: 474.071,
                        x2: 376.152,
                        y2: 246.333,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0,
                                stopColor: "#0065ff",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.661,
                                stopColor: "#0065ff",
                                stopOpacity: 0.673
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 1,
                                stopColor: "#0065ff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "linear-gradient-8",
                        x1: 381.752,
                        y1: 248.741,
                        x2: 319.155,
                        y2: 35.582,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0,
                                stopColor: "#6bd5e5"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.203,
                                stopColor: "#67d4e4"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.394,
                                stopColor: "#5cd0e2"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.579,
                                stopColor: "#49c9de"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.759,
                                stopColor: "#2fbfd8"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.857,
                                stopColor: "#1db9d4"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "linear-gradient-9",
                        x1: 297.786,
                        y1: 271.526,
                        x2: 297.786,
                        y2: 100.805,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0,
                                stopColor: "#00a3bf"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.818,
                                stopColor: "#00c7e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "linear-gradient-10",
                        x1: 242.54,
                        y1: 73.753,
                        x2: 473.423,
                        y2: 304.635,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.119,
                                stopColor: "#7a869a",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 1,
                                stopColor: "#7a869a"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "linear-gradient-11",
                        x1: 22.116,
                        y1: 169.947,
                        x2: 173.833,
                        y2: 18.23,
                        gradientTransform: "matrix(.818 -.355 0 1 88.514 172.44)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0,
                                stopColor: "#0065ff"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.818,
                                stopColor: "#3384ff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "linear-gradient-12",
                        x1: 287.083,
                        y1: 124.032,
                        x2: 287.083,
                        y2: 77.423,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.547,
                                stopColor: "#0052cc"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.902,
                                stopColor: "#2684ff"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.933,
                                stopColor: "#2481fc"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.958,
                                stopColor: "#1c77f2"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.98,
                                stopColor: "#1067e1"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 1,
                                stopColor: "#0052cc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "linear-gradient-13",
                        x1: 298.353,
                        y1: 125.998,
                        x2: 298.353,
                        y2: 77.25,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.481,
                                stopColor: "#0052cc"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.926,
                                stopColor: "#2684ff"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.945,
                                stopColor: "#227ffa"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.969,
                                stopColor: "#1771eb"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.994,
                                stopColor: "#0559d3"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 1,
                                stopColor: "#0052cc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "linear-gradient-14",
                        x1: 274.475,
                        y1: 59.599,
                        x2: 295.653,
                        y2: 59.599,
                        gradientTransform: "rotate(37.942 286.848 58.43)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.628,
                                stopColor: "#0065ff"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.765,
                                stopColor: "#005ae1"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.852,
                                stopColor: "#0052cc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "New_Gradient_Swatch_13",
                        x1: -40.95,
                        y1: -1059.962,
                        x2: -36.771,
                        y2: -1064.142,
                        gradientTransform: "matrix(1 0 0 -1.522 312.893 -1573.203)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0,
                                stopColor: "#00c7e5"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 1,
                                stopColor: "#b3f5ff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("linearGradient", {
                        id: "New_Gradient_Swatch_13-2",
                        x1: -40.594,
                        y1: -1065.291,
                        x2: -37.128,
                        y2: -1068.757,
                        gradientTransform: "matrix(1 0 0 -1.522 320.464 -1580.944)",
                        xlinkHref: "#New_Gradient_Swatch_13"
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("linearGradient", {
                        id: "New_Gradient_Swatch_13-3",
                        x1: -40.185,
                        y1: -1070.019,
                        x2: -37.537,
                        y2: -1072.667,
                        gradientTransform: "matrix(1 0 0 -1.522 326.899 -1587.525)",
                        xlinkHref: "#New_Gradient_Swatch_13"
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "linear-gradient-16",
                        x1: 295.563,
                        y1: 77.114,
                        x2: 319.051,
                        y2: 62.939,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.279,
                                stopColor: "#2684ff"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.56,
                                stopColor: "#086cff"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.628,
                                stopColor: "#0065ff"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.765,
                                stopColor: "#005ae1"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.852,
                                stopColor: "#0052cc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "New_Gradient_Swatch_11",
                        x1: 310.986,
                        y1: 194.755,
                        x2: 363.199,
                        y2: 194.755,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0,
                                stopColor: "#00a3bf"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 1,
                                stopColor: "#00c7e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "New_Gradient_Swatch_2",
                        x1: 330.492,
                        y1: 219.33,
                        x2: 330.492,
                        y2: 191.873,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0,
                                stopColor: "#ff5630"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 1,
                                stopColor: "#ff8f73"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("linearGradient", {
                        id: "New_Gradient_Swatch_2-2",
                        x1: 343.475,
                        y1: 219.534,
                        x2: 343.475,
                        y2: 191.768,
                        xlinkHref: "#New_Gradient_Swatch_2"
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                        id: "linear-gradient-17",
                        x1: 116.917,
                        y1: -2418.323,
                        x2: 110.364,
                        y2: -2429.673,
                        gradientTransform: "matrix(.912 -.365 -.022 -1.088 -45.115 -2378.143)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0,
                                stopColor: "#fff",
                                stopOpacity: 0.4
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.92,
                                stopColor: "#fff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("radialGradient", {
                        id: "radial-gradient",
                        cx: 333.607,
                        cy: 227.537,
                        r: 18.393,
                        gradientTransform: "rotate(81.59 311.98 208.873) scale(1 .836)",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.164,
                                stopColor: "#00b8d9"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.363,
                                stopColor: "#00b5d6"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.525,
                                stopColor: "#00adcc"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.642,
                                stopColor: "#00a3bf"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("radialGradient", {
                        id: "radial-gradient-2",
                        cx: 336.354,
                        cy: 227.33,
                        r: 22.804,
                        gradientTransform: "matrix(.032 .999 -.663 .021 476.454 -113.664)",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0,
                                stopColor: "#00c7e5"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.398,
                                stopColor: "#00c4e2"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.741,
                                stopColor: "#00b9da"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                                offset: 0.765,
                                stopColor: "#00b8d9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("clipPath", {
                        id: "clip-path",
                        children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            id: "_Clipping_Path_",
                            d: "M103.743 321.455 0 366.224V225.881l103.743-33.508v129.082z"
                        })
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("clipPath", {
                        id: "clip-path-2",
                        children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                            id: "_Clipping_Path_2",
                            className: "cls-2",
                            d: "M309.714 54.989c2.04 1.878 2.36 5.189 1.57 8.535-.382 1.62-.347 2.447-.557 3.721a28.089 28.089 0 0 0 .471 10.876c-.47.12-1.175.287-2.04.446a42.432 42.432 0 0 1-5.06.528c-2.593.185-3.9.282-4.588.244a21.493 21.493 0 0 1-3.845-.563c.732-5.805-.342-9.334-1.546-11.525-.741-1.349-2.216-3.436-1.6-5.588.234-.812.749-1.575 1.206-3.334a16.269 16.269 0 0 0 .423-2.3l1.942-1.586a4.353 4.353 0 0 0 7.127-1.082 8.549 8.549 0 0 1 1.19-.086c.445.003 3.478.031 5.307 1.714Z"
                        })
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("style", {
                        children: ".cls-2{fill:url(#linear-gradient-2)}.cls-33,.cls-9{fill:#00c7e5}.cls-9{opacity:.3}.cls-22,.cls-43,.cls-45{fill:none}.cls-43{stroke-miterlimit:10}.cls-12{fill:#9ce3ee}.cls-16{fill:#1db9d4}.cls-18{fill:#3384ff}.cls-21{fill:#fff}.cls-22{stroke:#ff5230;stroke-width:2.321px}.cls-23{fill:#e0ada6}.cls-24{fill:#253858}.cls-36{fill:#344563}.cls-37{fill:#b5917c}.cls-43{stroke:#ff5630;stroke-width:2px}"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("g", {
                style: {
                    isolation: "isolate"
                },
                children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("g", {
                    id: "Layer_2",
                    children: /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("g", {
                        id: "Layer_1-2",
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("g", {
                                style: {
                                    mixBlendMode: "multiply",
                                    opacity: 0.19
                                },
                                children: [
                                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                        id: "_Clipping_Path_3",
                                        style: {
                                            fill: "url(#linear-gradient)"
                                        },
                                        d: "M103.743 321.455 0 366.224V225.881l103.743-33.508v129.082z"
                                    }),
                                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("g", {
                                        style: {
                                            clipPath: "url(#clip-path)"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                                style: {
                                                    fill: "url(#linear-gradient-4)"
                                                },
                                                d: "m5.398 302.743 39.117-16.962"
                                            }),
                                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                                style: {
                                                    fill: "url(#linear-gradient-5)"
                                                },
                                                d: "m5.398 317.564 39.117-16.962"
                                            }),
                                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                                style: {
                                                    fill: "url(#linear-gradient-6)"
                                                },
                                                d: "m5.398 309.687 39.117-16.962"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-9",
                                d: "M151.657 108.409c8.351.127 7.9 4.325 14.51 3.148 7.577-1.348 8.567-11.762 19.038-11.762 17.342 0 17.333 18.018 17.333 18.018s2.945 8.756 9.98 9.083a1.288 1.288 0 0 1 .287.025c0 .219-68.3.082-91.323.036-6.854-.014-20.048-.044-26.595-.062 10.939-4.014 16.046-4.736 18.487-4.09 5.563 1.472 2.827-6.3 12.407-8.45 7.553-1.694 8.888 1.251 12.952 1.251 7.198.001 2.781-6.215 12.924-7.197ZM474.391 8.614c8.351.127 7.9 4.325 14.51 3.148C496.477 10.413 497.468 0 507.938 0c17.342 0 17.333 18.018 17.333 18.018s2.945 8.756 9.98 9.083a1.288 1.288 0 0 1 .287.025c0 .219-68.3.082-91.323.036-6.854-.014-20.048-.044-26.595-.062 10.939-4.014 16.046-4.736 18.487-4.09 5.563 1.472 2.827-6.3 12.407-8.45 7.553-1.694 8.888 1.251 12.952 1.251 7.199.001 2.781-6.211 12.925-7.197Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                style: {
                                    strokeWidth: "19.44px",
                                    stroke: "url(#linear-gradient-7)",
                                    strokeMiterlimit: 10,
                                    fill: "none"
                                },
                                d: "M376.152 246.333v227.738"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-9",
                                d: "M508.348 292.622c-1.236-12.277-4.055-16.728-14.045-16.8s-10.56 3.127-13.713 5.658-5.688 1.941-9.706 1.224-8.655-1.181-12.673 1.434-4.637 3.8-10.077 3.333c-4.73-.4-5.955-.353-8.172.27a16.478 16.478 0 0 0-3.05 1.34c-5.09 2.58-6.065 4.342-9.4 5.643a17.024 17.024 0 0 1-6.146 1.1l86.984.4Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                id: "_Path_",
                                d: "M427.644 49.459a58.919 58.919 0 0 0-18.08 2.828c-.288.088-128.712 40.5-129 40.6a58.992 58.992 0 0 0-41.748 56.411v122.321h117.939l129.858-44.872V104.422c0-32.567-26.402-54.963-58.969-54.963Z",
                                style: {
                                    fill: "url(#linear-gradient-8)"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-12",
                                d: "m486.613 211.789-.006-.017-129.378 43.646.777 2.303 128.607-43.386v-2.546zM486.607 203.459l-129.378 43.645.777 2.303 128.607-43.385v-2.546l-.006-.017zM486.607 118.245l-129.378 43.647.777 2.302 128.607-43.386v-2.546l-.006-.017zM486.607 109.932l-129.378 43.646.777 2.303 128.607-43.386v-2.547l-.006-.016z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M373.347 256.707v-126.15a58.977 58.977 0 0 0-37.716-55.005l-5.756 1.812a58.988 58.988 0 0 1 38.925 55.468v122.73Z",
                                style: {
                                    fill: "#ebecf0",
                                    opacity: 0.62,
                                    mixBlendMode: "multiply"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                id: "_Path_2",
                                d: "M297.786 90.325a58.969 58.969 0 0 0-58.969 58.969v122.325h117.938V149.294a58.969 58.969 0 0 0-58.969-58.969Z",
                                style: {
                                    fill: "#0065ff"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "m356.755 224.881-16.42 6.494c-22.883-13.854-38.335-39.285-38.371-65.094a75.843 75.843 0 0 0-37.723-65.476 58.891 58.891 0 0 0-25.423 48.446v122.275l93.075-36.811Z",
                                style: {
                                    fill: "url(#linear-gradient-9)"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-16",
                                d: "M297.786 90.325c-1.346 0-2.676.061-4 .15h8a60.186 60.186 0 0 0-4-.15Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-16",
                                d: "M301.964 166.281c.038 25.809 15.488 51.24 38.371 65.094l16.42-6.494v-75.587a58.961 58.961 0 0 0-54.969-58.819h-8a58.628 58.628 0 0 0-29.546 10.33 75.843 75.843 0 0 1 37.724 65.476Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M301.964 166.281c.038 25.809 15.488 51.24 38.371 65.094l16.42-6.494v-75.587a58.961 58.961 0 0 0-54.969-58.819h-8a58.628 58.628 0 0 0-29.546 10.33 75.843 75.843 0 0 1 37.724 65.476Z",
                                style: {
                                    fill: "url(#linear-gradient-10)",
                                    mixBlendMode: "multiply"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                id: "_Clipping_Path_4",
                                className: "cls-18",
                                d: "M297.917 433.7c-32.568 0-58.969-23.636-58.969-52.792V271.393h117.937v109.512c0 29.157-26.401 52.795-58.968 52.795Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                id: "_Path_3",
                                style: {
                                    fill: "url(#linear-gradient-11)"
                                },
                                d: "M248.699 258.602 94.887 325.299V194.551l153.812-51.335v115.386z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                style: {
                                    fill: "#ff5230"
                                },
                                d: "m378.124 72.088-4.777 1.853v182.757l4.777-1.853V98.244l29.21-10.698V62.231l-29.21 9.857z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-21",
                                d: "m241.831 179.947-21.375 9.269v-27.067l21.375-8.336v26.134z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-22",
                                d: "M184.7 192.47c3.309-1.435 3.309 1.722 6.617.288s3.31-4.592 6.619-6.027 3.309 1.722 6.617.288 3.311-4.593 6.622-6.028a3.993 3.993 0 0 1 1.624-.384M184.7 204.221c3.309-1.435 3.309 1.722 6.617.288s3.31-4.592 6.619-6.027 3.309 1.722 6.617.288 3.311-4.593 6.622-6.028a3.677 3.677 0 0 1 1.9-.367M184.7 198.346c3.309-1.435 3.309 1.722 6.617.288s3.31-4.592 6.619-6.027 3.309 1.722 6.617.288 3.311-4.593 6.622-6.028a5.342 5.342 0 0 1 .731-.26"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                id: "_Path_4",
                                className: "cls-22",
                                d: "M233.332 177.632c0 7.232-4.8 15.175-10.711 17.74s-10.711-1.218-10.711-8.451 4.8-15.175 10.711-17.74 10.711 1.219 10.711 8.451Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-23",
                                d: "M294.376 79.076c-12.172 4.071-18.2 6.466-20.009 10.37-.934 2.015-.583 2.9-.54 9.438a145.2 145.2 0 0 1-.868 16.945 8.264 8.264 0 0 1-.512 1.669c-1.59 3.715-5.3 4.673-5.027 5.717.2.75 2.316 1.016 3.925.662 1.025-.226 2.276-1.3 4.777-3.452.867-.746 1.486-1.243 1.649-2.123a9.087 9.087 0 0 0-.216-2.337 9.486 9.486 0 0 1-.162-1.872c-.244-1.455 4.407-10.288 5.368-16.663a21.635 21.635 0 0 0 .239-3.257 74.506 74.506 0 0 0 15.765-4.81 10.342 10.342 0 0 0 2.226-8.013 9.3 9.3 0 0 0-1.742-3.927c-1.226.394-2.886.988-4.873 1.653Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-23",
                                d: "M284.676 102.975c-.15-2.27-.348-4.542-.351-6.817 0-2.691.171-4.973.361-7.719a3.957 3.957 0 0 1 2.007-3.143l16.747-8.046 5 .235a4.429 4.429 0 0 1 2.162.986c1.229 1.065 1.552 3.11 1.667 3.892a10.032 10.032 0 0 1 .042 2.741c-.439 2.713-6.071 3.573-14.672 6.366l-3.6 1.242a42.646 42.646 0 0 1-.166 7.178 43.081 43.081 0 0 1-3.518 12.958c-1.654 2.708-1.723 4.592-1.445 5.84a3.774 3.774 0 0 1 .246 2.152c-.316 1-1.2 1.254-3.072 2.489-2.366 1.562-2.107 1.92-3.223 2.32-1.95.7-4.671.3-5.036-.775-.508-1.49 4.153-2.421 6.481-6.73 1.224-2.272.939-6.571.37-15.169Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-24",
                                d: "M294.6 45.948c-.676.278.958 3.069-.149 5.954-1.095 2.853-3.733 2.834-4.242 5.507-.274 1.44.13 3.338 1.3 3.907 1.513.735 3.614-1.081 3.87-1.3 3.012-2.6 3.435-7.77 1.712-11.312-.738-1.528-1.982-2.964-2.491-2.756Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-23",
                                d: "M296.717 49.781a7.179 7.179 0 0 1 .278 2.366 7.255 7.255 0 0 1-.948 3.218 9.468 9.468 0 0 0 6.548-.574 9.161 9.161 0 0 1 1.247-7.191Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M300.99 81.349a9.3 9.3 0 0 0-1.742-3.927c-1.225.394-2.884.989-4.872 1.653-12.172 4.071-18.2 6.466-20.009 10.37-.934 2.015-.583 2.9-.54 9.438a145.1 145.1 0 0 1-.791 16.22 7.846 7.846 0 0 1 4.366-1.337c.269-2.135 4.453-10.326 5.359-16.338a21.635 21.635 0 0 0 .239-3.255 74.506 74.506 0 0 0 15.765-4.81 10.342 10.342 0 0 0 2.225-8.014Z",
                                style: {
                                    fill: "url(#linear-gradient-12)"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M312.266 82.363c-.115-.782-.438-2.828-1.667-3.892a4.429 4.429 0 0 0-2.162-.986l-5-.235-16.745 8.05a3.957 3.957 0 0 0-2.007 3.143c-.19 2.746-.365 5.029-.361 7.719 0 2.275.2 4.547.351 6.817.48 7.25.754 11.437.094 13.936a8.371 8.371 0 0 1 3.371-.667c.266 0 .52.018.772.038a10.68 10.68 0 0 1 1.438-3.433 43.081 43.081 0 0 0 3.518-12.958 42.646 42.646 0 0 0 .166-7.178l3.6-1.242c8.6-2.793 14.233-3.653 14.672-6.366a10.032 10.032 0 0 0-.04-2.746Z",
                                style: {
                                    fill: "url(#linear-gradient-13)"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-23",
                                d: "M294.891 55.53a28.349 28.349 0 0 1-5.13 3.058 34.548 34.548 0 0 0-4.955 2.559c-.483.308-.873.576-1.136.761 0-.683-.016-1.722-.095-2.987-.132-2.1-.35-3.4-.763-6.434-.147-1.079-.356-2.66-.594-4.6l-2.557-.357a58.4 58.4 0 0 0-.907 7.629 33.021 33.021 0 0 0 .21 7.41 28.43 28.43 0 0 0 .655 3.071 1.507 1.507 0 0 0 1.548 1.116 30.456 30.456 0 0 0 4.025-.522c2.936-.582 8.66-1.718 11.341-5.974.441-.7 1.615-2.565.85-3.762a3.022 3.022 0 0 0-2.492-.968Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M296.532 60.256c.441-.7 1.615-2.565.85-3.762a3.022 3.022 0 0 0-2.491-.964 28.349 28.349 0 0 1-5.13 3.058 34.548 34.548 0 0 0-4.955 2.559c-.483.308-.873.576-1.136.761 0-.683-.016-1.722-.095-2.987-.132-2.1-.35-3.4-.763-6.434-.068-.5-.15-1.114-.241-1.812a7.146 7.146 0 0 1-3.4.032 58.706 58.706 0 0 0-.414 4.449 33.021 33.021 0 0 0 .21 7.41 28.43 28.43 0 0 0 .655 3.071 1.507 1.507 0 0 0 1.548 1.116 30.456 30.456 0 0 0 4.025-.522c2.932-.583 8.656-1.719 11.337-5.975Z",
                                style: {
                                    fill: "url(#linear-gradient-14)"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                id: "_Clipping_Path_5",
                                className: "cls-2",
                                d: "M309.714 54.989c2.04 1.878 2.36 5.189 1.57 8.535-.382 1.62-.347 2.447-.557 3.721a28.089 28.089 0 0 0 .471 10.876c-.47.12-1.175.287-2.04.446a42.432 42.432 0 0 1-5.06.528c-2.593.185-3.9.282-4.588.244a21.493 21.493 0 0 1-3.845-.563c.732-5.805-.342-9.334-1.546-11.525-.741-1.349-2.216-3.436-1.6-5.588.234-.812.749-1.575 1.206-3.334a16.269 16.269 0 0 0 .423-2.3l1.942-1.586a4.353 4.353 0 0 0 7.127-1.082 8.549 8.549 0 0 1 1.19-.086c.445.003 3.478.031 5.307 1.714Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-18",
                                d: "m292.038 65.434.114-3.497",
                                style: {
                                    clipPath: "url(#clip-path-2)"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-23",
                                d: "M294.322 39.432a4.769 4.769 0 0 0-1.3 3.069l-.022.659s.032.373-.871 1.615c-.279.384 1.2.782 1.2.782a5.74 5.74 0 0 0 .12 1.793c.06.255.1.32.217.8a9.069 9.069 0 0 0 .325 1.35c.2.327.768.627 2.47.4a10.764 10.764 0 0 1 4.46-.637 2.55 2.55 0 0 0 2.923-1.657 6.142 6.142 0 0 0 1.085-1.827 6.281 6.281 0 0 0-.518-5.645 6.913 6.913 0 0 0-.9-1.112 5.019 5.019 0 0 0-4.3-1.345l-2.123.319a4.775 4.775 0 0 0-2.766 1.436Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-24",
                                d: "M292.259 41.751q1.318.089 2.7.219t2.7.3a15.394 15.394 0 0 0-.161 2.507 25.653 25.653 0 0 0 1.034 4.752 7.074 7.074 0 0 1-.183 4.769c-.8 1.6-1.192 1.914-1.152 3.041a3.906 3.906 0 0 0 2.839 3.482c2.047.417 4.018-1.722 4.846-2.621 1.688-1.832 2.029-3.546 3.36-3.68a2.322 2.322 0 0 1 1.623.592 8.665 8.665 0 0 0 .721-5.071 8.354 8.354 0 0 0-.988-2.728A17.917 17.917 0 0 0 307.682 45a12.717 12.717 0 0 1-1.636-3.761 6.357 6.357 0 0 0-2.2-3.4 6.505 6.505 0 0 0-2.4-.837 11.92 11.92 0 0 0-4.553-.179 5.665 5.665 0 0 0-4.635 4.925Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-23",
                                d: "M282.515 46.878a3.58 3.58 0 0 1-.829.9 2.138 2.138 0 0 1-.906.3c-.713.106-.937.763-1.194.647s.063-.816-.2-1.957c-.149-.656-.325-.716-.331-1.241a3.367 3.367 0 0 1 .36-1.366c.277-.69.469-.769.575-.785a.6.6 0 0 1 .462.189c.112-.526.281-.691.429-.73.276-.074.728.223.728.223.052-.072.38-.523.631-.448.086.026.135.1.292.469.293.681.244.69.335.785.312.324.765.08.995.393a.765.765 0 0 1 .065.595c-.065.373-.266.528-.72 1.1-.334.413-.24.348-.692.926Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-23",
                                d: "M280.112 47.633c-.11-.3.2-.677.857-1.362a4.23 4.23 0 0 1 1.506-1.11c.726-.3.8-.039 1.521-.364.6-.267.817-.56 1.313-.529.284.018.629.141.65.312s-.24.3-.452.426a9.5 9.5 0 0 0-1.456 1.088 2.133 2.133 0 0 1-.5 1.134 2.231 2.231 0 0 1-1.091.654c-.882.275-2.165.247-2.348-.249Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M272.4 39.873h3.271V47.5a.39.39 0 0 1-.39.39h-2.492a.39.39 0 0 1-.39-.39v-7.627Z",
                                transform: "rotate(-91.278 274.03 43.883)",
                                style: {
                                    fill: "url(#New_Gradient_Swatch_13)"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M280.384 40.15h2.434v6.729a.4.4 0 0 1-.4.4h-1.64a.4.4 0 0 1-.4-.4V40.15h.006Z",
                                transform: "rotate(-91.278 281.6 43.714)",
                                style: {
                                    fill: "url(#New_Gradient_Swatch_13-2)"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                transform: "rotate(-91.26 288.056 43.493)",
                                style: {
                                    fill: "url(#New_Gradient_Swatch_13-3)"
                                },
                                d: "M287.277 40.696h1.52v5.748h-1.52z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("rect", {
                                className: "cls-33",
                                x: 289.992,
                                y: 43.2,
                                width: 2.421,
                                height: 0.586,
                                rx: 0.237,
                                ry: 0.237,
                                transform: "rotate(-91.278 291.202 43.494)"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("rect", {
                                className: "cls-33",
                                x: 267.587,
                                y: 43.501,
                                width: 3.922,
                                height: 0.949,
                                rx: 0.385,
                                ry: 0.385,
                                transform: "rotate(-91.278 269.547 43.976)"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-23",
                                d: "M282.441 43.68a.511.511 0 0 1-.354-.086c-.264-.172-.25-.509-.359-.513-.132 0-.144.492-.427.586a.459.459 0 0 1-.4-.1c-.206-.165-.129-.4-.26-.467-.23-.119-.605.532-.906.45-.268-.073-.447-.706-.272-1.2.248-.7 1.13-.907 1.431-.979a3.717 3.717 0 0 1 2 .233c.6.166.8.308.914.5a1.365 1.365 0 0 1 .128.823c-.015.2-.034.452-.155.493-.2.066-.42-.509-.7-.467s-.281.655-.64.727Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-24",
                                d: "M277.555 115.964a8.1 8.1 0 0 1-.121-.83 9.138 9.138 0 0 1-.036-.633 25.65 25.65 0 0 0-.911 1.442c-1.244 2.12-1.339 2.969-2.118 3.4-.5.276-1.337.419-2.832-.262-.6.483-1.456 1.2-2.457 2.128-1.6 1.482-1.72 1.778-1.66 2 .19.716 2.212 1.039 3.925.662 1.025-.226 2.276-1.3 4.777-3.452 1.074-.923 1.554-1.4 1.649-2.123a9.413 9.413 0 0 0-.216-2.332ZM288.791 117.2a6.228 6.228 0 0 0-1.162.927c-1.453 1.478-1.133 2.67-2.387 3.627a3.564 3.564 0 0 1-2.465.693 3.36 3.36 0 0 1-1.656-.7c-1.9 1.469-3.619 2.186-3.3 3.121.366 1.074 3.086 1.474 5.036.775.76-.272.883-.525 1.631-1.152a13.559 13.559 0 0 1 1.592-1.167c.914-.588 1.36-.72 1.865-1.074a4.044 4.044 0 0 0 .492-.4 3.451 3.451 0 0 0 .834-1.011c.225-.513 0-.872-.256-2.152a16.404 16.404 0 0 1-.224-1.487Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-23",
                                d: "M308.174 54.517a2.986 2.986 0 0 1 2.27 1.081c.757.81 1.031 1.843 1.132 3.558a21.578 21.578 0 0 1-.393 5.566c-.4 1.93-.964 4.7-1.7 8.559a47.38 47.38 0 0 1-6.229 15.759l-2.512-.842c.383-1.091.653-1.973.809-2.5 1.577-5.334 1.393-7.84 3.206-11.717.363-.776.7-1.375.878-1.688q-.089-1.532-.148-3.1c-.151-4.062-.128-7.965.029-11.694a3.4 3.4 0 0 1 2.658-2.982Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-23",
                                d: "M299.05 89.428a7.251 7.251 0 0 0-1.69.948 8.338 8.338 0 0 0 .352 3.753.533.533 0 0 0 .276.162.438.438 0 0 1 .769.2.686.686 0 0 0 .806-.306.651.651 0 0 0 .5.658.635.635 0 0 0 .61-.247l.171-3.151a1.783 1.783 0 0 1 .53-.3c.413-.147.645-.047 1.084-.2a1.66 1.66 0 0 0 .482-.253c.8-.646.544-2.44.544-2.44l-2.6-.379a3.486 3.486 0 0 1-.755 1.231 7.2 7.2 0 0 0-1.079.324Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M311.576 59.157c-.1-1.716-.374-2.748-1.132-3.558a2.986 2.986 0 0 0-2.27-1.081 3.4 3.4 0 0 0-2.655 2.979c-.157 3.728-.18 7.632-.029 11.694q.058 1.57.148 3.1c-.18.313-.515.912-.878 1.688-1.8 3.839-1.635 6.338-3.163 11.564a7.265 7.265 0 0 1 2.859 1.449 47.251 47.251 0 0 0 5.029-13.711c.733-3.861 1.295-6.63 1.7-8.559a21.578 21.578 0 0 0 .391-5.565Z",
                                style: {
                                    fill: "url(#linear-gradient-16)"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M333.718 191.873a3.834 3.834 0 0 0 6.334-.1 4.47 4.47 0 0 1-.469-1.168 5.684 5.684 0 0 1-.107-1.561 11.506 11.506 0 0 1 .256-2.04L334 188.516Z",
                                style: {
                                    fill: "#9c7761"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-36",
                                d: "m339.54 187.134 1.371-.959a2.9 2.9 0 0 0 1.176-1.755l.121-.553a17.7 17.7 0 0 0 .405-4.114 2.4 2.4 0 0 0-1.314-2.081l-.215-.11a13.483 13.483 0 0 0-5.015-1.438l-3.42-.291a1.692 1.692 0 0 0-1.689-.668c-.778.24-.926 1.316-.736 2a2.23 2.23 0 0 0 1.08 1.279l2.891 5.979Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-37",
                                d: "M331.946 178.316a19.268 19.268 0 0 0-1.106 4.642 7.76 7.76 0 0 1-.393.674c-.576.883-1.171 1.407-1.009 1.624.014.019.693.28.809.372.243.193.1 2.253.573 3.094.951 1.707 6.531 2.087 8.322-.46a3.492 3.492 0 0 0 .59-2.073 2.378 2.378 0 0 1-.3-.113 2.509 2.509 0 0 1-1.187-1.136c-.453-.961.281-1.735-.191-2.117a.812.812 0 0 0-.754-.089c-.69.27-.79 1.7-.79 1.7h-.022c-.012 0-.269-.058-1.041-.242-.011-2.5-.663-3.433-1.3-3.8a5.411 5.411 0 0 1-1.259-.824 4.432 4.432 0 0 1-.942-1.252Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M329.07 215.784c.2 2.652.5 6.55.938 11.278.561 6.079.854 9.118 1.054 10.139 1.068 5.443 3.8 14.295 4.627 19.139a6.489 6.489 0 0 1-.049 2.661 7.59 7.59 0 0 1-2.434 3.818c-1.275 1.057-2.5 1.284-2.431 1.7.067.4 1.248.673 2.307.49 1.192-.207 1.256-.828 3.018-1.794a13.534 13.534 0 0 0 2.535-1.394 2.048 2.048 0 0 0 .224-.33 4.092 4.092 0 0 0 .114-3.182l-3.011-43.223Z",
                                style: {
                                    fill: "url(#radial-gradient)"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M335.257 215.317c1.026 13.008 1.433 18.1 1.459 18.314v.021c.271 2.312.56 2.64.592 3.636.028.864-.19.6-.378 2.58-.074.781-.091 1.4-.1 1.754-.012.4-.01.879.02 1.57.2 4.669.978 5.03 1.568 10.766a65.067 65.067 0 0 1 .42 8.672 59.428 59.428 0 0 1-.194 3.628 3.236 3.236 0 0 1 .787 1.068c.419.935.11 1.578.6 2.031a1.9 1.9 0 0 0 1.342.346c.727.019 2.108-.151 2.316-.822.155-.5-.437-.954-.886-1.607-.863-1.252-.821-2.682-.658-4.721.42-5.239 1.431-11.831 1.715-14.466.194-1.806.347-3.664.347-3.664.041-.489.082-1.017.129-1.7.346-4.964.405-9.217.524-17.724.052-3.737.067-6.821.071-8.909a1.083 1.083 0 0 0-.089-.727c-.451-.8-2.123-.6-4.2-.418-1.227.108-3.066.255-5.385.372Z",
                                style: {
                                    fill: "url(#radial-gradient-2)"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-36",
                                d: "M338.967 258.206a8.031 8.031 0 0 1-2.8.528c-.154 0-.3-.015-.455-.023-.024.1-.039.193-.069.291 0 0-.062.231-.151.467a6.588 6.588 0 0 1-2.046 2.941 3.243 3.243 0 0 0-2.538 1.536 2.2 2.2 0 0 0-.193.813 4.151 4.151 0 0 0 2.371.253 4.29 4.29 0 0 0 .63-.185 7.609 7.609 0 0 0 2.425-1.478 7.891 7.891 0 0 0 2.889-1.265q0-.453-.01-.908-.02-1.494-.053-2.97Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-36",
                                d: "m342.141 262.552.054-.633a17.023 17.023 0 0 1-3.352.274v.436a59.428 59.428 0 0 1-.194 3.628 3.236 3.236 0 0 1 .787 1.068c.419.935.11 1.578.6 2.031a1.9 1.9 0 0 0 1.342.346c.727.019 2.108-.151 2.316-.822.155-.5-.437-.954-.886-1.607-.872-1.251-.831-2.682-.667-4.721Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M360.073 172.63a40.724 40.724 0 0 1-1.923 4.724c-1.283 2.656-2.315 4.035-3.09 6.734a19.522 19.522 0 0 0-.559 2.6 42.566 42.566 0 0 0-5.741 4.041q-.238.2-.468.4a4.361 4.361 0 0 1-1.76.921 4.479 4.479 0 0 1-1.313.131c-1.961-.062-4.655-.357-5.167-.414a4.278 4.278 0 0 1-3.468 1.6 4.149 4.149 0 0 1-2.866-1.5c-.652.062-2.82.264-4.72.323a4.516 4.516 0 0 1-1.368-.141 4.357 4.357 0 0 1-1.719-.91q-.24-.207-.487-.413a42.559 42.559 0 0 0-5.741-4.041 19.546 19.546 0 0 0-.559-2.6c-.775-2.7-1.807-4.078-3.09-6.734a40.768 40.768 0 0 1-1.923-4.724l-3.126.817a65.794 65.794 0 0 0 2.847 12.148 65.737 65.737 0 0 0 1.7 4.487 26.549 26.549 0 0 0 4.452 5.052 38.819 38.819 0 0 1 4.927 4.369 20.523 20.523 0 0 1 2.226 3.123c.014.182.028.365.046.548a55.569 55.569 0 0 0 2.754 12.653 28.651 28.651 0 0 0 16.961-.489c-.1-4.405-.093-9.01.056-13.8a59.959 59.959 0 0 1 3.48-3.619c4.619-4.411 7.285-5.523 8.969-9.247a21.013 21.013 0 0 0 .948-3.08 179.594 179.594 0 0 0 2.847-12.148Z",
                                style: {
                                    fill: "url(#New_Gradient_Swatch_11)"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "M333.91 203.121q-.024-5.737-.192-11.248l-4.32.229a14.847 14.847 0 0 1-2.256 10.629l-.071 14.929a24.162 24.162 0 0 0 6.606 1.67q.259-7.866.233-16.209Z",
                                style: {
                                    fill: "url(#New_Gradient_Swatch_2)"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                d: "m345.14 192.084-5.088-.316-.057 27.766a8.089 8.089 0 0 0 5.7-2.373 6.914 6.914 0 0 0 1.206-1.821l.056-13.8a16.043 16.043 0 0 1-1.814-9.457Z",
                                style: {
                                    fill: "url(#New_Gradient_Swatch_2-2)"
                                }
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-37",
                                d: "M311.945 173.192a1.731 1.731 0 0 0 1.685.105 2.571 2.571 0 0 0 1.342-2.216c.053-.913-.4-1.176-.528-2.452a5.9 5.9 0 0 1 .072-1.632 1.556 1.556 0 0 0-.829.4 1.792 1.792 0 0 0-.35 1.882 2.688 2.688 0 0 0-1.239.847c-.707.886-.934 2.442-.153 3.066Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-43",
                                d: "m313.526 172.494-3.155-12.467"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-37",
                                d: "M311.1 174.071a153.312 153.312 0 0 0-.886-3.729 1.64 1.64 0 0 1-.047-.682 2.727 2.727 0 0 1 2.754-1.911c.109.017.4.063.475.25s-.138.368-.049.61c.071.19.236.164.281.334.066.251-.26.439-.177.637.054.129.214.1.293.238.1.175-.034.421-.085.517a1.581 1.581 0 0 1-1.053.689 1.307 1.307 0 0 1 .771.618c.321.678-.273 1.527-.761 1.925a2.38 2.38 0 0 1-1.516.504ZM362.227 172.866a1.731 1.731 0 0 1-1.685.105 2.571 2.571 0 0 1-1.342-2.216c-.053-.913.4-1.176.528-2.452a5.9 5.9 0 0 0-.072-1.632 1.556 1.556 0 0 1 .829.4 1.792 1.792 0 0 1 .35 1.882 2.688 2.688 0 0 1 1.239.847c.708.885.934 2.442.153 3.066Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-43",
                                d: "m360.646 172.168 3.156-12.467"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-37",
                                d: "M363.074 173.745c.351-1.545.633-2.733.886-3.729a1.64 1.64 0 0 0 .047-.682 2.727 2.727 0 0 0-2.754-1.911c-.109.017-.4.063-.475.25s.138.368.049.61c-.071.19-.236.164-.281.334-.066.251.26.439.177.637-.054.129-.214.1-.293.238-.1.175.034.421.085.517a1.581 1.581 0 0 0 1.053.689 1.307 1.307 0 0 0-.771.618c-.321.678.273 1.527.761 1.925a2.38 2.38 0 0 0 1.516.504Z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-45",
                                d: "m193.431 225.452-35.068 13.455v5.37l35.068-14.103v-4.722zM193.431 233.407l-35.068 14.103v4.877l35.068-14.331v-4.649z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-33",
                                d: "M193.431 223.845 158.363 237.3v1.607l35.068-13.455v-1.607z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-33",
                                d: "M193.431 223.845v-1.606l-35.068 13.455v1.606l35.068-13.455zM193.431 239.676v-1.62l-35.068 14.331v1.62l35.068-14.331zM158.363 254.007v1.621l35.068-14.331v-1.621l-35.068 14.331zM193.431 231.791l-35.068 14.102v1.617l35.068-14.103v-1.616z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                className: "cls-33",
                                d: "M193.431 231.791v-1.617l-35.068 14.103v1.616l35.068-14.102z"
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("g", {
                                id: "Layer_2-2",
                                children: /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("g", {
                                    id: "Blue",
                                    children: [
                                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                            d: "M112.683 209.117c-.354-.3-.9-.06-1.114.6l-5.381 15.769c-.159.466-.014.9.324.962a.542.542 0 0 0 .305-.036l7.882-3.159a1.1 1.1 0 0 0 .6-.7c1.609-4.864.448-10.827-2.616-13.436Z",
                                            style: {
                                                fill: "url(#linear-gradient-17)"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                                            className: "cls-21",
                                            d: "M116.582 195.167c-3.043 7.254-2.7 13.8-.508 17.938l3.987 7.545a.458.458 0 0 0 .615.211l7.882-3.159a1.2 1.2 0 0 0 .66-1.078.745.745 0 0 0-.079-.333s-11.126-21.066-11.4-21.592c-.257-.468-.863-.238-1.157.468Z"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    }));
var $5317b8d7579cfa5a$export$2e2bcd8739ae039 = $5317b8d7579cfa5a$var$SvgIncomingMessage;


const $8b4253205fa0e537$var$_2 = "._c71lr0r7{max-height:250px}";
const $8b4253205fa0e537$var$_ = "._1yt414lv{padding:var(--_cpuyf2)}";
const $8b4253205fa0e537$var$styles = null;
const $8b4253205fa0e537$var$EmptyView = ()=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $9bbee8e48028edce$export$2e2bcd8739ae039), {
        title: translate((0, $447ba15143f7eed7$exports).EMPTY_USER_SUBSCRIPTIONS_MESSAGE),
        hero: /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                    children: [
                        $8b4253205fa0e537$var$_,
                        $8b4253205fa0e537$var$_2
                    ]
                }),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $5317b8d7579cfa5a$export$2e2bcd8739ae039), {
                    className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                        "_1yt414lv _c71lr0r7"
                    ]),
                    style: {
                        "--_cpuyf2": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.200'))
                    }
                })
            ]
        })
    });
};
var $8b4253205fa0e537$export$2e2bcd8739ae039 = $8b4253205fa0e537$var$EmptyView;




/* LoginRedirect.tsx generated by @compiled/babel-plugin v2.0.0 */ 


parcelRequire("7fPBF");


const $f56c96ad0de33be2$var$_ = "._18s8115o{margin:var(--_fhuf0z) 0}";
const $f56c96ad0de33be2$var$loginRedirectStyles = null;
function $f56c96ad0de33be2$export$d4318c1a3847aad() {
    if ((0, $35a545355f14a0c7$export$6bc7b24d4e862158)().name === (0, $c1e4a1336f2cb96e$exports).PROD) window.location.href = 'https://id.atlassian.com/login?continue=' + (0, $35a545355f14a0c7$export$6bc7b24d4e862158)().url;
    else window.location.href = 'https://id.stg.internal.atlassian.com/login?continue=' + (0, $35a545355f14a0c7$export$6bc7b24d4e862158)().url;
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                children: [
                    $f56c96ad0de33be2$var$_
                ]
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("div", {
                className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                    "_18s8115o"
                ]),
                style: {
                    "--_fhuf0z": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.300'))
                },
                children: [
                    "Please wait... ",
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $aacfdd39b28e059d$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
}





/* MyAtlassianRedirect.tsx generated by @compiled/babel-plugin v2.0.0 */ 


parcelRequire("7fPBF");


const $23d1d3647ccb7078$var$_ = "._18s8115o{margin:var(--_fhuf0z) 0}";
const $23d1d3647ccb7078$var$myAtlassianRedirectStyles = null;
function $23d1d3647ccb7078$export$e3fd8340be658180() {
    if ((0, $35a545355f14a0c7$export$6bc7b24d4e862158)().name === (0, $c1e4a1336f2cb96e$exports).PROD) window.location.href = 'https://id.atlassian.com/manage-profile/email';
    else window.location.href = 'https://id.stg.internal.atlassian.com/manage-profile/email';
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                children: [
                    $23d1d3647ccb7078$var$_
                ]
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("div", {
                className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                    "_18s8115o"
                ]),
                style: {
                    "--_fhuf0z": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.300'))
                },
                children: [
                    "Please wait... ",
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $aacfdd39b28e059d$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
}




const $85d7791daea50a70$var$StatusView = ()=>{
    const { status: status, message: message } = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$b4f431af37c9cd8b));
    switch(status){
        case 'login-required':
            return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $7551ffa32d2a4800$export$3a31c848ced7e406), {
                children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $f56c96ad0de33be2$export$d4318c1a3847aad), {})
            });
        case 'not-found':
            (0, $0e08eda71bb24540$export$df7ac42928b20388)();
            return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $7551ffa32d2a4800$export$3a31c848ced7e406), {
                children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $23d1d3647ccb7078$export$e3fd8340be658180), {})
            });
        case 'down-for-maintenance':
            (0, $0e08eda71bb24540$export$6f7cca16e34ea87f)();
            return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $7551ffa32d2a4800$export$3a31c848ced7e406), {
                children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $69541c48b8b26100$export$2e2bcd8739ae039), {
                    message: message
                })
            });
        case 'empty':
            (0, $0e08eda71bb24540$export$f1239e0c91a8acb6)();
            return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $7551ffa32d2a4800$export$3a31c848ced7e406), {
                children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $8b4253205fa0e537$export$2e2bcd8739ae039), {})
            });
        default:
            return null;
    }
};
var $85d7791daea50a70$export$2e2bcd8739ae039 = $85d7791daea50a70$var$StatusView;








var $7fPBF = parcelRequire("7fPBF");





var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");



var $33609f2058f20722$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type"
], $33609f2058f20722$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $33609f2058f20722$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $33609f2058f20722$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(unsafeRest, $33609f2058f20722$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2f27420929ef9635$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName
    }, saferRest), iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $bb87128a2cadd975$export$2e2bcd8739ae039), {
        type: "icon",
        position: "before",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e3ca56ebdfbd43d2$export$2e2bcd8739ae039), {
        icon: iconBefore
    })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $bb87128a2cadd975$export$2e2bcd8739ae039), {
        isLoading: isLoading
    }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $bb87128a2cadd975$export$2e2bcd8739ae039), {
        type: "icon",
        position: "after",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e3ca56ebdfbd43d2$export$2e2bcd8739ae039), {
        icon: iconAfter
    })));
}));
$33609f2058f20722$var$Button.displayName = 'Button';
var $33609f2058f20722$export$2e2bcd8739ae039 = $33609f2058f20722$var$Button;




var $iKdEz = parcelRequire("iKdEz");

var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");

/**
 * Character key codes which can be used in keyboard events.
 */ var $8e49427eac361e67$export$390330c10ff2b9a1 = 'ArrowUp';
var $8e49427eac361e67$export$a80636c6f41931fe = 'ArrowDown';
var $8e49427eac361e67$export$fc4577f2a2af0ae3 = 'ArrowLeft';
var $8e49427eac361e67$export$c40f9845adc73fb5 = 'ArrowRight';
var $8e49427eac361e67$export$4af703091671bc = 'Home';
var $8e49427eac361e67$export$e2bc30913faa5db7 = 'End';
var $8e49427eac361e67$export$10f6869ed0a7d75b = 'Tab';
var $8e49427eac361e67$export$8152f929a25a0ff4 = 'Enter';
var $8e49427eac361e67$export$e51a3576c045c8d5 = 'Space';
var $8e49427eac361e67$export$2bb790b9008907b4 = 'Escape';


function $7df57ff683b2c713$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $7fPBF.useRef)(false);
    var onKeyDown = (0, $7fPBF.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $8e49427eac361e67$export$2bb790b9008907b4)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $7fPBF.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $7fPBF.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $a091c25729a976b1$exports.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}



var $7fPBF = parcelRequire("7fPBF");
function $fcc36874ed8a4956$export$2e2bcd8739ae039(value) {
    var ref = (0, $7fPBF.useRef)(value);
    (0, $7fPBF.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}





var $j9spr = parcelRequire("j9spr");

var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");


var $iKdEz = parcelRequire("iKdEz");
function $376b77374090c7b9$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}



// Export types from PopperJS / React Popper
var $847ce031d2d8d783$var$viewportPadding = 5;
var $847ce031d2d8d783$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $847ce031d2d8d783$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $847ce031d2d8d783$var$defaultChildrenFn() {
    return null;
}
var $847ce031d2d8d783$var$defaultOffset = [
    0,
    8
];
function $847ce031d2d8d783$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $847ce031d2d8d783$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $847ce031d2d8d783$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $7fPBF.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $847ce031d2d8d783$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $376b77374090c7b9$export$6d8c2b45c99d6e3f)({
            viewportPadding: $847ce031d2d8d783$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($847ce031d2d8d783$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $7fPBF.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $00d767b55afb0685$export$badac9ada3a0bdf9), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}




var $b2267258dd23b289$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $b2267258dd23b289$export$c93026a968943f95 = 'light';
var $b2267258dd23b289$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $b2267258dd23b289$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, #4688EC)";
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    (0, $0440a7eded5169c8$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $b2267258dd23b289$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $b2267258dd23b289$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $b2267258dd23b289$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $0440a7eded5169c8$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $b2267258dd23b289$export$ba1d834b86d72a09 = $b2267258dd23b289$export$a1b3edb637fb4f35;
var $b2267258dd23b289$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, #0515240F)",
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, #0515240F)"
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, #17171708)"
            }
        }
    };
};


/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $3cfe7b01c6f0c991$var$registrations = new Set();
var $3cfe7b01c6f0c991$var$cleanupEndEventListeners = null;
function $3cfe7b01c6f0c991$var$onDragStart() {
    if ($3cfe7b01c6f0c991$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $3cfe7b01c6f0c991$var$cleanupEndEventListeners = (0, $a091c25729a976b1$exports.bindAll)(window, [
        {
            type: 'dragend',
            listener: $3cfe7b01c6f0c991$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $3cfe7b01c6f0c991$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $3cfe7b01c6f0c991$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($3cfe7b01c6f0c991$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $3cfe7b01c6f0c991$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $3cfe7b01c6f0c991$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $3cfe7b01c6f0c991$var$cleanupEndEventListeners = null;
    var clone = Array.from($3cfe7b01c6f0c991$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $3cfe7b01c6f0c991$var$bindStartEvents() {
    return (0, $a091c25729a976b1$exports.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $3cfe7b01c6f0c991$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $3cfe7b01c6f0c991$var$onDragStart
        }
    ]);
}
var $3cfe7b01c6f0c991$var$cleanupStartEventListeners = null;
function $3cfe7b01c6f0c991$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$3cfe7b01c6f0c991$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $3cfe7b01c6f0c991$var$cleanupStartEventListeners = $3cfe7b01c6f0c991$var$bindStartEvents();
    $3cfe7b01c6f0c991$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $3cfe7b01c6f0c991$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $3cfe7b01c6f0c991$var$registrations.delete(registration);
        if ($3cfe7b01c6f0c991$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $3cfe7b01c6f0c991$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $3cfe7b01c6f0c991$var$cleanupStartEventListeners = null;
        }
    };
}


function $417d5e84a7e7b72d$export$2e68479e0a5d8746(mousePos, _ref) {
    var targetElement = _ref.targetElement, tooltipPosition = _ref.tooltipPosition;
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            });
        }
    };
    var targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            });
        }
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            });
        }
    };
    throw new Error("Invalid tooltip position for virtual element: ".concat(tooltipPosition));
}


var $3578842e096a878d$var$delayId = null;
function $3578842e096a878d$var$clearScheduled() {
    if ($3578842e096a878d$var$delayId != null) {
        window.clearTimeout($3578842e096a878d$var$delayId);
        $3578842e096a878d$var$delayId = null;
    }
}
function $3578842e096a878d$var$scheduleTimeout(fn, delay) {
    $3578842e096a878d$var$clearScheduled();
    $3578842e096a878d$var$delayId = window.setTimeout(function() {
        $3578842e096a878d$var$delayId = null;
        fn();
    }, delay);
}
// This file is a singleton for managing tooltips
var $3578842e096a878d$var$active = null;
function $3578842e096a878d$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($3578842e096a878d$var$active && $3578842e096a878d$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            $3578842e096a878d$var$clearScheduled();
            $3578842e096a878d$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            $3578842e096a878d$var$clearScheduled();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            $3578842e096a878d$var$clearScheduled();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        $3578842e096a878d$var$scheduleTimeout(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function start() {
        var shouldAlwaysFadeIn = entry.shouldAlwaysFadeIn;
        var showImmediately = Boolean($3578842e096a878d$var$active && $3578842e096a878d$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($3578842e096a878d$var$active) {
            $3578842e096a878d$var$clearScheduled();
            $3578842e096a878d$var$active.entry.hide({
                isImmediate: true
            });
            $3578842e096a878d$var$active.entry.done();
            $3578842e096a878d$var$active = null;
        }
        // this tooltip is now the active tooltip
        $3578842e096a878d$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        $3578842e096a878d$var$scheduleTimeout(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePos: entry.source.type === 'mouse' ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}



function $6c5a5916e5709122$export$6ee17796e3d70de2() {
    var uid = (0, $d4d502868e612e1e$export$f680877a34711e37)();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}


function $dc3e6a72de006682$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $6c5a5916e5709122$export$6ee17796e3d70de2)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}


/* tooltip-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $bd9f8ed4bc0f1d8b$var$ATOMIC_GROUP_LENGTH = 5;
function $bd9f8ed4bc0f1d8b$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $bd9f8ed4bc0f1d8b$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $6e7cbf77b3d9f260$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
var $6e7cbf77b3d9f260$export$5bcbc43c84236222 = function TooltipShortcut(_ref) {
    var shortcut = _ref.shortcut;
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        className: (0, $bd9f8ed4bc0f1d8b$export$2e2bcd8739ae039)([
            $6e7cbf77b3d9f260$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map(function(segment, index) {
        return /*#__PURE__*/ $7fPBF.createElement("kbd", {
            key: "".concat(segment, "-").concat(index),
            className: (0, $bd9f8ed4bc0f1d8b$export$2e2bcd8739ae039)([
                $6e7cbf77b3d9f260$var$styles.shortcutSegment
            ])
        }, segment);
    }));
};


var $c8acd05b3aa7f96b$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $c8acd05b3aa7f96b$var$TooltipPrimitive = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $7fPBF.createElement("div", {
        role: "tooltip",
        className: (0, $bd9f8ed4bc0f1d8b$export$2e2bcd8739ae039)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && /*#__PURE__*/ $7fPBF.createElement((0, $6e7cbf77b3d9f260$export$5bcbc43c84236222), {
        shortcut: shortcut
    })));
});
$c8acd05b3aa7f96b$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $c8acd05b3aa7f96b$export$2e2bcd8739ae039 = $c8acd05b3aa7f96b$var$TooltipPrimitive;


var $b2a3cb92d05a29d0$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $b2a3cb92d05a29d0$var$TooltipContainer = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $7fPBF.createElement((0, $c8acd05b3aa7f96b$export$2e2bcd8739ae039), {
        ref: ref,
        style: style,
        className: (0, $bd9f8ed4bc0f1d8b$export$2e2bcd8739ae039)([
            $b2a3cb92d05a29d0$var$styles.base,
            truncate && $b2a3cb92d05a29d0$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut
    }, children);
});
$b2a3cb92d05a29d0$var$TooltipContainer.displayName = 'TooltipContainer';
var $b2a3cb92d05a29d0$export$2e2bcd8739ae039 = $b2a3cb92d05a29d0$var$TooltipContainer;


function $5645981c356a41bc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5645981c356a41bc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5645981c356a41bc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5645981c356a41bc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5645981c356a41bc$var$tooltipZIndex = (0, $b2267258dd23b289$export$7be255094ccdc533).tooltip();
var $5645981c356a41bc$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "21.2.0"
};
// Inverts motion direction
var $5645981c356a41bc$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $5645981c356a41bc$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $5645981c356a41bc$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $b2a3cb92d05a29d0$export$2e2bcd8739ae039) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $f48d740006cf3f7d$export$2e2bcd8739ae039) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $f48d740006cf3f7d$export$2e2bcd8739ae039) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn, shortcut = _ref.shortcut, _ref$UNSAFE_shouldAlw = _ref.UNSAFE_shouldAlwaysFadeIn, shouldAlwaysFadeIn = _ref$UNSAFE_shouldAlw === void 0 ? false : _ref$UNSAFE_shouldAlw, _ref$UNSAFE_shouldRen = _ref.UNSAFE_shouldRenderToParent, UNSAFE_shouldRenderToParent = _ref$UNSAFE_shouldRen === void 0 ? false : _ref$UNSAFE_shouldRen;
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    var isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    var tooltipPosition = isMousePosition ? mousePosition : position;
    var onShowHandler = (0, $bf339b74c053cf86$export$1a04351537078b55)($5645981c356a41bc$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $5645981c356a41bc$var$analyticsAttributes));
    var onHideHandler = (0, $bf339b74c053cf86$export$1a04351537078b55)($5645981c356a41bc$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $5645981c356a41bc$var$analyticsAttributes));
    var apiRef = (0, $7fPBF.useRef)(null);
    var _useState = (0, $7fPBF.useState)('hide'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $7fPBF.useRef)(null);
    var containerRef = (0, $7fPBF.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $7fPBF.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $fcc36874ed8a4956$export$2e2bcd8739ae039)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $fcc36874ed8a4956$export$2e2bcd8739ae039)(onShowHandler);
    var onHideHandlerStable = (0, $fcc36874ed8a4956$export$2e2bcd8739ae039)(onHideHandler);
    var delayStable = (0, $fcc36874ed8a4956$export$2e2bcd8739ae039)(delay);
    var canAppearStable = (0, $fcc36874ed8a4956$export$2e2bcd8739ae039)(canAppear);
    var hasCalledShowHandler = (0, $7fPBF.useRef)(false);
    var shouldAlwaysFadeInStable = (0, $fcc36874ed8a4956$export$2e2bcd8739ae039)(shouldAlwaysFadeIn);
    var start = (0, $7fPBF.useCallback)(function(api) {
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $7fPBF.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $7fPBF.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $7fPBF.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $7fPBF.useRef)(false);
    (0, $7fPBF.useEffect)(function() {
        return (0, $3cfe7b01c6f0c991$export$6503ec6e8aabbaf)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $7fPBF.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: shouldAlwaysFadeInStable.current
        };
        var api = (0, $3578842e096a878d$export$57bf213be019eeb0)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    var hideTooltipOnEsc = (0, $7fPBF.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $7df57ff683b2c713$export$2e2bcd8739ae039)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $7fPBF.useEffect)(function() {
        if (state === 'hide') return 0, $f48d740006cf3f7d$export$2e2bcd8739ae039;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $a091c25729a976b1$exports.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $7fPBF.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $7fPBF.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $7fPBF.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = isMousePosition ? {
            type: 'mouse',
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $7fPBF.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = isMousePosition ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePos = {
            clientX: event.clientX,
            clientY: event.clientY
        };
    } : undefined;
    var onMouseOverTooltip = (0, $7fPBF.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $7fPBF.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch (_unused) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $7fPBF.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $7fPBF.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    var handleOpenLayerObserverCloseSignal = (0, $7fPBF.useCallback)(function() {
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $e85233b93e6c09f0$export$469bb693f11edc7f)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current5;
        if (isMousePosition && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePos && targetRef.current) return (0, $417d5e84a7e7b72d$export$2e68479e0a5d8746)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $dc3e6a72de006682$export$2e2bcd8739ae039)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // Adding `data-testid` to the TriggerProps interface breaks Buttons, so we use type assertion
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $7fPBF.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    var PopperWrapper = UNSAFE_shouldRenderToParent ? (0, $7fPBF.Fragment) : $5645981c356a41bc$var$TooltipPortal;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, children($5645981c356a41bc$var$_objectSpread($5645981c356a41bc$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(PopperWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $847ce031d2d8d783$export$badac9ada3a0bdf9), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = isMousePosition ? undefined : $5645981c356a41bc$var$invertedDirection[$5645981c356a41bc$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a1ad98f67aabe587$export$2e2bcd8739ae039), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a6c67c5a8158581e$export$2e2bcd8739ae039), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $5645981c356a41bc$var$_objectSpread($5645981c356a41bc$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $5645981c356a41bc$export$2e2bcd8739ae039 = $5645981c356a41bc$var$Tooltip;
var $5645981c356a41bc$var$TooltipPortal = function TooltipPortal(_ref7) {
    var children = _ref7.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd3bc8368572caba$export$2e2bcd8739ae039), {
        zIndex: $5645981c356a41bc$var$tooltipZIndex
    }, children);
};


parcelRequire("7fPBF");

const $6bf45c7456588943$var$GlobalUnsubscribeButton = ({ isDisabled: isDisabled, onClick: onClick })=>{
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $5645981c356a41bc$export$2e2bcd8739ae039), {
        content: translate((0, $447ba15143f7eed7$exports).UNSUBSCRIBE_ALL_TOOLTIP_LABEL),
        children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $33609f2058f20722$export$2e2bcd8739ae039), {
            onClick: onClick,
            isDisabled: isDisabled,
            testId: "global-unsubscribe-button",
            children: translate((0, $447ba15143f7eed7$exports).UNSUBSCRIBE_ALL_BUTTON_LABEL)
        })
    });
};
var $6bf45c7456588943$export$2e2bcd8739ae039 = $6bf45c7456588943$var$GlobalUnsubscribeButton;







const $788f88bb6ebc19d1$var$ActionsBar = ({ email: email, onUnsubscribeClick: onUnsubscribeClick })=>{
    const status = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$b4f431af37c9cd8b));
    const isPending = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $7a501a2d8adab3c3$export$9d56a93b8e84b384)([
        (0, $80022746ba8cd68a$export$6871e08c9c3b9797)
    ]));
    if (isPending || email == null) return null;
    const statusNotOk = status.status !== 'ok';
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $067e8036161c713e$export$2e2bcd8739ae039), {
        testId: "actions-bar",
        space: "space.150",
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $6bf45c7456588943$export$2e2bcd8739ae039), {
                isDisabled: statusNotOk,
                onClick: onUnsubscribeClick
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                maxLines: 1,
                color: 'color.text.subtlest',
                children: email
            })
        ]
    });
};
var $788f88bb6ebc19d1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $7fPBF.memo)($788f88bb6ebc19d1$var$ActionsBar);






var $7fPBF = parcelRequire("7fPBF");

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

parcelRequire("7fPBF");

const $37732ea9e62e519b$var$accordionSectionStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    paddingBottom: 'space.300',
    [(0, $8c23171a376c15ae$export$987d49ffe1b0900f).above.xs]: {
        paddingBottom: 'space.600'
    }
});
const $37732ea9e62e519b$var$accordionHeaderStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 'space.200',
    gap: 'space.100'
});
const $37732ea9e62e519b$var$AccordionSection = ({ isOpen: isOpen, showMarker: showMarker, title: title, onClick: onClick, children: children })=>{
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
        xcss: $37732ea9e62e519b$var$accordionSectionStyles,
        children: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                xcss: $37732ea9e62e519b$var$accordionHeaderStyles,
                testId: "accordion-section-header",
                onClick: onClick,
                children: [
                    title,
                    showMarker && /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                        testId: "accordion-section-marker",
                        children: isOpen ? /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("span", {
                            children: "\u25BC"
                        }) : /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("span", {
                            children: "\u25B2"
                        })
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("section", {
                "data-testid": "accordion-section-content",
                children: children
            })
        ]
    });
};
var $37732ea9e62e519b$export$2e2bcd8739ae039 = $37732ea9e62e519b$var$AccordionSection;


const $bbdf7a0d01a379ab$var$Accordion = ({ sections: sections, showMarker: showMarker, alwaysOpen: alwaysOpen })=>{
    const [openSections, changeOpenSection] = (0, $7fPBF.useState)({
        0: true
    });
    const onClickHandler = (0, $7fPBF.useCallback)((id)=>()=>{
            const currentSectionOpenState = openSections[id];
            changeOpenSection((0, $2qxEV._)((0, $9tqwB._)({}, openSections), {
                [id]: !currentSectionOpenState
            }));
        }, [
        openSections,
        changeOpenSection
    ]);
    const isOpen = (index)=>alwaysOpen || openSections[index];
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $c69938f751e7a026$export$ffb0004e005737fa), {
        children: sections.map((section, index)=>{
            return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $37732ea9e62e519b$export$2e2bcd8739ae039), {
                isOpen: isOpen(index),
                showMarker: !!showMarker,
                title: section.title,
                onClick: onClickHandler(index),
                children: section.content
            }, index);
        })
    });
};
var $bbdf7a0d01a379ab$export$2e2bcd8739ae039 = $bbdf7a0d01a379ab$var$Accordion;













var $7fPBF = parcelRequire("7fPBF");


var $9tqwB = parcelRequire("9tqwB");

parcelRequire("7fPBF");


/* tabs.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $8MJe2 = parcelRequire("8MJe2");
var $bd53982ab96faaf8$exports = {};

var $hJ0zT = parcelRequire("hJ0zT");

var $4Qso2 = parcelRequire("4Qso2");

var $5ng8R = parcelRequire("5ng8R");

var $gPUQJ = parcelRequire("gPUQJ");
function $bd53982ab96faaf8$var$_toArray(r) {
    return $hJ0zT(r) || $4Qso2(r) || $5ng8R(r) || $gPUQJ();
}
$bd53982ab96faaf8$exports = $bd53982ab96faaf8$var$_toArray, $bd53982ab96faaf8$exports.__esModule = true, $bd53982ab96faaf8$exports["default"] = $bd53982ab96faaf8$exports;



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $26688c0f6e4f2dff$var$ATOMIC_GROUP_LENGTH = 5;
function $26688c0f6e4f2dff$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $26688c0f6e4f2dff$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $7fPBF = parcelRequire("7fPBF");
var $0e1f4f0723fe683b$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $7fPBF.createContext)(null);


/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $7fPBF = parcelRequire("7fPBF");
var $c91b523793070514$export$2054129d247c3102 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);


function $37ee778e4e8d27bc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $37ee778e4e8d27bc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $37ee778e4e8d27bc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $37ee778e4e8d27bc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $37ee778e4e8d27bc$var$baseStyles = null;
var $37ee778e4e8d27bc$var$tabsStyles = null;
var $37ee778e4e8d27bc$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "@atlaskit/tabs",
    packageVersion: "0.0.0-development"
};
var $37ee778e4e8d27bc$var$getTabPanelWithContext = function getTabPanelWithContext(_ref) {
    var tabPanel = _ref.tabPanel, index = _ref.index, isSelected = _ref.isSelected, tabsId = _ref.tabsId;
    return(// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ $7fPBF.createElement((0, $c91b523793070514$export$2054129d247c3102).Provider, {
        value: {
            role: 'tabpanel',
            id: "".concat(tabsId, "-").concat(index, "-tab"),
            hidden: isSelected ? undefined : true,
            'aria-labelledby': "".concat(tabsId, "-").concat(index),
            tabIndex: isSelected ? 0 : -1
        },
        key: index
    }, tabPanel));
};
/**
 * __Tabs__
 *
 * Tabs acts as a container for all Tab components.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ var $37ee778e4e8d27bc$var$Tabs = function Tabs(props) {
    var _props$shouldUnmountT = props.shouldUnmountTabPanelOnChange, shouldUnmountTabPanelOnChange = _props$shouldUnmountT === void 0 ? false : _props$shouldUnmountT, SelectedType = props.selected, defaultSelected = props.defaultSelected, onChangeProp = props.onChange, id = props.id, analyticsContext = props.analyticsContext, children = props.children, testId = props.testId;
    var _useState = (0, $7fPBF.useState)(SelectedType || defaultSelected || 0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), selectedState = _useState2[0], setSelected = _useState2[1];
    var selected = SelectedType === undefined ? selectedState : SelectedType;
    var childrenArray = (0, $7fPBF.Children).toArray(children)// Don't include any conditional children
    .filter(function(child) {
        return Boolean(child);
    });
    // First child should be a tabList followed by tab panels
    var _childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($bd53982ab96faaf8$exports)))(childrenArray), tabList = _childrenArray[0], tabPanels = _childrenArray.slice(1);
    // Keep track of visited and add to a set
    var visited = (0, $7fPBF.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    var onChange = (0, $7fPBF.useCallback)(function(index, analyticsEvent) {
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    var onChangeAnalytics = (0, $593ac790924c31ca$export$a4687b0234b40e28)($37ee778e4e8d27bc$var$_objectSpread({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext
    }, $37ee778e4e8d27bc$var$analyticsAttributes));
    var tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $37ee778e4e8d27bc$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map(function(tabIndex) {
        return $37ee778e4e8d27bc$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        });
    });
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        "data-testid": testId,
        className: (0, $26688c0f6e4f2dff$export$2e2bcd8739ae039)([
            "_1e0c1txw _p12f1osq _1tkeidpf _i0dl1osq _2lx21bp4 _16jlkb7n",
            "_1c3y1txw _ftfaidpf _18i0kb7n _185bglyw"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement((0, $0e1f4f0723fe683b$export$aa6907f9fd69e93b).Provider, {
        value: {
            selected: selected,
            onChange: onChangeAnalytics,
            tabsId: id
        }
    }, tabList), /*#__PURE__*/ $7fPBF.createElement((0, $7fPBF.Fragment), null, tabPanelsWithContext));
};
var $37ee778e4e8d27bc$export$2e2bcd8739ae039 = $37ee778e4e8d27bc$var$Tabs;

/* tab-list.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $7fPBF = parcelRequire("7fPBF");
var $3855518c327f6f0e$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $7fPBF.createContext)(null);



var $7fPBF = parcelRequire("7fPBF");

function $ad065e8d8e8d1952$export$2e2bcd8739ae039() {
    var tabListData = (0, $7fPBF.useContext)((0, $0e1f4f0723fe683b$export$aa6907f9fd69e93b));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
}


var $6ac5c86c95d2529e$var$baseStyles = null;
var $6ac5c86c95d2529e$var$tabListStyles = null;
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ var $6ac5c86c95d2529e$var$TabList = function TabList(_ref) {
    var children = _ref.children;
    var _useTabList = (0, $ad065e8d8e8d1952$export$2e2bcd8739ae039)(), tabsId = _useTabList.tabsId, selected = _useTabList.selected, onChange = _useTabList.onChange;
    var ref = /*#__PURE__*/ (0, $7fPBF.createRef)();
    // Don't include any conditional children
    var childrenArray = (0, $7fPBF.Children).toArray(children).filter(Boolean);
    var length = childrenArray.length;
    var selectTabByIndex = (0, $7fPBF.useCallback)(function(index) {
        var _ref$current;
        var newSelectedNode = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.querySelector("[id='".concat(tabsId, "-").concat(index, "']"));
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    var onKeyDown = (0, $7fPBF.useCallback)(function(e) {
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        var lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            var _newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(_newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        var selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        var modifier = e.key === 'ArrowRight' ? 1 : -1;
        var newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    var getTabWithContext = (0, $7fPBF.useCallback)(function(_ref2) {
        var tab = _ref2.tab, isSelected = _ref2.isSelected, index = _ref2.index;
        return /*#__PURE__*/ $7fPBF.createElement((0, $3855518c327f6f0e$export$5a5d356ca5f10a0a).Provider, {
            value: {
                onClick: function onClick() {
                    return onChange(index);
                },
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: "".concat(tabsId, "-").concat(index),
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': "".concat(tabsId, "-").concat(index, "-tab"),
                tabIndex: isSelected ? 0 : -1
            },
            key: index
        }, tab);
    }, [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        role: "tablist",
        ref: ref,
        className: (0, $26688c0f6e4f2dff$export$2e2bcd8739ae039)([
            "_1e0c1txw _kqswh2mm _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _qwyt1qi0 _7hip15vq _1fud15vq _bb0mh2mm _1quzazsu _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _1lzu1uh4 _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazazsu _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1b8d1uh4 _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i20i7uo _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _rsmzz0c1 _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem6x5g _pascidpf _eid3idpf _zr3eidpf _fntnidpf _1mp41kw7 _kfgte4h9 _1cs8stnw _1rus1l7x _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc"
        ])
    }, childrenArray.map(function(child, index) {
        return getTabWithContext({
            tab: child,
            index: index,
            isSelected: index === selected
        });
    }));
};
var $6ac5c86c95d2529e$export$2e2bcd8739ae039 = $6ac5c86c95d2529e$var$TabList;


var $7fPBF = parcelRequire("7fPBF");

function $83577d932e161ce4$export$2e2bcd8739ae039() {
    var tabData = (0, $7fPBF.useContext)((0, $3855518c327f6f0e$export$5a5d356ca5f10a0a));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
}


const $d5fd265980f256d2$var$tabsStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    paddingBottom: 'space.200'
});
const $d5fd265980f256d2$var$Tab = (props)=>{
    const tabAttributes = (0, $83577d932e161ce4$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d245204bc35d9406$export$2e2bcd8739ae039), (0, $9tqwB._)({}, tabAttributes, props));
};
const $d5fd265980f256d2$var$Tabs = ({ tabKeys: tabKeys, groupKey: groupKey, onChange: onChange })=>{
    const { translate: translate, keyWithTitle: keyWithTitle } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    if (tabKeys.length < 2) return null;
    const sortedTabsMeta = [
        ...tabKeys
    ].sort((left, right)=>left.localeCompare(right));
    const groupTabsTestId = 'groupTabsTestId';
    function handleOnChange(index) {
        onChange(sortedTabsMeta[index], groupKey || '');
    }
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
        xcss: $d5fd265980f256d2$var$tabsStyles,
        children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $37ee778e4e8d27bc$export$2e2bcd8739ae039), {
            onChange: handleOnChange,
            id: (groupKey || 'default') + '_tabs',
            testId: groupTabsTestId,
            children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $6ac5c86c95d2529e$export$2e2bcd8739ae039), {
                children: sortedTabsMeta.map((key)=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)($d5fd265980f256d2$var$Tab, {
                        testId: groupTabsTestId + `-${key}-tab`,
                        children: translate(keyWithTitle(key))
                    }, key))
            })
        })
    });
};
var $d5fd265980f256d2$export$2e2bcd8739ae039 = $d5fd265980f256d2$var$Tabs;






var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");

/* lozenge.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $aFlfF = parcelRequire("aFlfF");

var $137Lh = parcelRequire("137Lh");
/* lozenge.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

/* lozenge-base.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $8MJe2 = parcelRequire("8MJe2");


var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $aFlfF = parcelRequire("aFlfF");


var $da428317fd2ac5f3$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($da428317fd2ac5f3$exports, "__esModule", {
    value: true
});
$da428317fd2ac5f3$exports.default = void 0;

var $da428317fd2ac5f3$var$_react = $da428317fd2ac5f3$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $da428317fd2ac5f3$var$_baseNew = $da428317fd2ac5f3$var$_interopRequireDefault((parcelRequire("kR6Cn")));
function $da428317fd2ac5f3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $da428317fd2ac5f3$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $da428317fd2ac5f3$var$_react.default.createElement($da428317fd2ac5f3$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$da428317fd2ac5f3$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $da428317fd2ac5f3$var$_default = $da428317fd2ac5f3$exports.default = $da428317fd2ac5f3$var$ChevronDownIcon;



var $emuQy = parcelRequire("emuQy");

var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");
var $866b9cc2511f5a5d$export$ff879f35a69d56b7 = function useElementRef() {
    var elementRef = (0, $7fPBF.useRef)(null);
    var setRef = (0, $7fPBF.useCallback)(function(ref) {
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};




var $7fPBF = parcelRequire("7fPBF");

var $7d0a88e05b8419c3$export$9e95200239cd148b = function useSnapshotBeforeUpdate(cb) {
    var isFirstRender = (0, $7fPBF.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $33e380d2666a4ede$export$e5c5a5f917a5871c)(function() {
        isFirstRender.current = false;
    }, []);
};


var $c018b04a9c663b15$var$_excluded = [
    "children"
];
/**
 * Which dimension(s) of the element to animate.
 *
 * - `'width'` animates only width changes.
 * - `'height'` animates only height changes.
 * - `'both'` animates width and height changes simultaneously.
 */ /**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $c018b04a9c663b15$var$parseCSSTimeToMs(value) {
    var parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $c018b04a9c663b15$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $c018b04a9c663b15$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
var $c018b04a9c663b15$export$a300664a1a230956 = function useResizing(_ref) {
    var dimension = _ref.dimension, duration = _ref.duration, easing = _ref.easing, onFinishMotion = _ref.onFinishMotion;
    var prevDimensions = (0, $7fPBF.useRef)();
    var _useElementRef = (0, $866b9cc2511f5a5d$export$ff879f35a69d56b7)(), _useElementRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useElementRef, 2), element = _useElementRef2[0], setElementRef = _useElementRef2[1];
    var setTimeout = (0, $27095c47a45ed928$export$4f34107a2b00f39c)({
        cleanup: 'next-effect'
    });
    var requestAnimationFrame = (0, $27095c47a45ed928$export$1775f27e7c8051ca)();
    (0, $7d0a88e05b8419c3$export$9e95200239cd148b)(function() {
        if ((0, $34452922263080f6$export$b7baf7667a68d87c)() || !element) return;
        var rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $33e380d2666a4ede$export$e5c5a5f917a5871c)(function() {
        if ((0, $34452922263080f6$export$b7baf7667a68d87c)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        var rect = element.getBoundingClientRect();
        var nextDimensions = {
            width: rect.width,
            height: rect.height
        };
        if (!$c018b04a9c663b15$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
            return;
        }
        var propertyList = $c018b04a9c663b15$var$getDimensionPropertyList(dimension);
        var newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = "".concat(prevDimensions.current.width, "px");
        if (dimension === 'height' || dimension === 'both') newStyles.height = "".concat(prevDimensions.current.height, "px");
        Object.assign(element.style, newStyles);
        var resolvedDuration = $c018b04a9c663b15$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = "".concat(nextDimensions.width, "px");
                if (dimension === 'height' || dimension === 'both') element.style.height = "".concat(nextDimensions.height, "px");
                setTimeout(function() {
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
var $c018b04a9c663b15$export$9942248a1ae255c2 = function Resizing(_ref2) {
    var children = _ref2.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref2, $c018b04a9c663b15$var$_excluded);
    var resizing = $c018b04a9c663b15$export$a300664a1a230956(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, children(resizing));
};



var $137Lh = parcelRequire("137Lh");


var $j9spr = parcelRequire("j9spr");

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");





var $8MJe2 = parcelRequire("8MJe2");

var $5ad6d3084cc70f15$export$4ef52930e33717cd = 'data-theme';
var $5ad6d3084cc70f15$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $5ad6d3084cc70f15$export$a00eac3f8684bcd0 = 'data-color-mode';
var $5ad6d3084cc70f15$export$2112803007239c61 = 'data-contrast-mode';
var $5ad6d3084cc70f15$export$352e418ed5b6193a = 'data-custom-theme';
var $5ad6d3084cc70f15$export$6f0c6fb8c80fcc92 = 'ds';
var $5ad6d3084cc70f15$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $5ad6d3084cc70f15$export$dddac1532e822863 = "--".concat($5ad6d3084cc70f15$export$6f0c6fb8c80fcc92, "-token-not-found");
var $5ad6d3084cc70f15$export$9d7b58831ae93caa = "--".concat($5ad6d3084cc70f15$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $938b0f5cba479b6b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $938b0f5cba479b6b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $938b0f5cba479b6b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $938b0f5cba479b6b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $938b0f5cba479b6b$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $938b0f5cba479b6b$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $938b0f5cba479b6b$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $938b0f5cba479b6b$export$632685d741f3dbbf = $938b0f5cba479b6b$var$_objectSpread($938b0f5cba479b6b$var$_objectSpread({}, $938b0f5cba479b6b$export$958d0ae7f2977ae4), $938b0f5cba479b6b$export$d2dc61f58390201c);
var $938b0f5cba479b6b$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $938b0f5cba479b6b$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $938b0f5cba479b6b$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};
var $938b0f5cba479b6b$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};
var $938b0f5cba479b6b$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};
var $938b0f5cba479b6b$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.disabled': "var(--ds-background-disabled, #17171708)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $938b0f5cba479b6b$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};
var $938b0f5cba479b6b$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #292A2E)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #C9372C)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #E06C00)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #B38600)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #22A06B)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #2898BD)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #357DE8)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #AF59E1)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #7D818A)",
    'color.icon.disabled': "var(--ds-icon-disabled, #080F214A)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #1868DB)",
    'color.icon.brand': "var(--ds-icon-brand, #1868DB)",
    'color.icon.danger': "var(--ds-icon-danger, #C9372C)",
    'color.icon.warning': "var(--ds-icon-warning, #E06C00)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #292A2E)",
    'color.icon.success': "var(--ds-icon-success, #6A9A23)",
    'color.icon.discovery': "var(--ds-icon-discovery, #AF59E1)",
    'color.icon.information': "var(--ds-icon-information, #357DE8)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B6E76)",
    'color.icon.subtle': "var(--ds-icon-subtle, #505258)"
};
var $938b0f5cba479b6b$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $938b0f5cba479b6b$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
var $938b0f5cba479b6b$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
var $938b0f5cba479b6b$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $938b0f5cba479b6b$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $938b0f5cba479b6b$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $938b0f5cba479b6b$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $938b0f5cba479b6b$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $938b0f5cba479b6b$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
/**
 * Token functions are currently allowed for borderRadius in xcss to ease migration.
 * Because 'radius.small' defaults to 3px, we need a mechanism to allow for 4px values to be provided:
 * This is done by calling the token function - token('radius.small')
 *
 * TODO: Remove once shape them is rolled out and fg platform-dst-shape-theme-default removed
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $938b0f5cba479b6b$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $938b0f5cba479b6b$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $938b0f5cba479b6b$export$e615f061ca585a6c = $938b0f5cba479b6b$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $938b0f5cba479b6b$export$ca0f9c2de39ffed7(spacingProperty, $938b0f5cba479b6b$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $938b0f5cba479b6b$export$bf46c3f9eeafc71f = $938b0f5cba479b6b$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $938b0f5cba479b6b$export$ca0f9c2de39ffed7(spacingProperty, $938b0f5cba479b6b$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $938b0f5cba479b6b$export$e7af83bafe7f9e63 = $938b0f5cba479b6b$export$ca0f9c2de39ffed7('backgroundColor', $938b0f5cba479b6b$export$d1d79bf68ac056bd);
var $938b0f5cba479b6b$export$3a1bcba60b23d7f0 = $938b0f5cba479b6b$export$ca0f9c2de39ffed7('color', $938b0f5cba479b6b$export$8473307aa00d6ea1);
var $938b0f5cba479b6b$export$45f3f4fe16f9f7d5 = $938b0f5cba479b6b$export$ca0f9c2de39ffed7('fontWeight', $938b0f5cba479b6b$export$303e322c6b1ed114);
var $938b0f5cba479b6b$export$68cc305da27dbaa4 = $938b0f5cba479b6b$export$ca0f9c2de39ffed7('fontFamily', $938b0f5cba479b6b$export$3c7e9587132614b4);
var $938b0f5cba479b6b$export$128f10c238242f83 = $938b0f5cba479b6b$export$ca0f9c2de39ffed7('font', $938b0f5cba479b6b$export$6ffa317d5e70375);
var $938b0f5cba479b6b$export$219d364c0da35ae4 = $938b0f5cba479b6b$export$ca0f9c2de39ffed7('font', $938b0f5cba479b6b$export$236bfe3a33ef1292);
var $938b0f5cba479b6b$export$38845ca010b93505 = $938b0f5cba479b6b$export$ca0f9c2de39ffed7('fontWeight', $938b0f5cba479b6b$export$855cfd311192d666);
var $938b0f5cba479b6b$export$ff257d957d48c421 = $938b0f5cba479b6b$export$ca0f9c2de39ffed7((0, $5ad6d3084cc70f15$export$9d7b58831ae93caa), $938b0f5cba479b6b$export$41a358c9c2356760);
var $938b0f5cba479b6b$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $938b0f5cba479b6b$export$41a358c9c2356760[color] !== undefined;
};
var $938b0f5cba479b6b$export$7001ce64d9ff7c7f = $938b0f5cba479b6b$export$ca0f9c2de39ffed7('font', $938b0f5cba479b6b$export$b805719bc8cb376);



var $j9spr = parcelRequire("j9spr");

var $8MJe2 = parcelRequire("8MJe2");

var $iKdEz = parcelRequire("iKdEz");

var $bRUy3 = parcelRequire("bRUy3");


function $80fa0c7b02938949$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $80fa0c7b02938949$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $80fa0c7b02938949$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $80fa0c7b02938949$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $80fa0c7b02938949$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $80fa0c7b02938949$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $80fa0c7b02938949$export$9a199fbafee0014e = {
    backgroundColor: (0, $938b0f5cba479b6b$export$d1d79bf68ac056bd),
    blockSize: (0, $938b0f5cba479b6b$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $938b0f5cba479b6b$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $938b0f5cba479b6b$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $938b0f5cba479b6b$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $938b0f5cba479b6b$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $938b0f5cba479b6b$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $938b0f5cba479b6b$export$e1b83c5210c471b8),
    borderBottomColor: (0, $938b0f5cba479b6b$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $938b0f5cba479b6b$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $938b0f5cba479b6b$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $938b0f5cba479b6b$export$e1b83c5210c471b8),
    borderColor: (0, $938b0f5cba479b6b$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $938b0f5cba479b6b$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $938b0f5cba479b6b$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $938b0f5cba479b6b$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $938b0f5cba479b6b$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $938b0f5cba479b6b$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $938b0f5cba479b6b$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $938b0f5cba479b6b$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $938b0f5cba479b6b$export$e1b83c5210c471b8),
    borderLeftColor: (0, $938b0f5cba479b6b$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $938b0f5cba479b6b$export$e1b83c5210c471b8),
    borderRadius: (0, $938b0f5cba479b6b$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $938b0f5cba479b6b$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $938b0f5cba479b6b$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $938b0f5cba479b6b$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $938b0f5cba479b6b$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $938b0f5cba479b6b$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $938b0f5cba479b6b$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $938b0f5cba479b6b$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $938b0f5cba479b6b$export$e1b83c5210c471b8),
    borderWidth: (0, $938b0f5cba479b6b$export$e1b83c5210c471b8),
    bottom: (0, $938b0f5cba479b6b$export$632685d741f3dbbf),
    boxShadow: (0, $938b0f5cba479b6b$export$7aff6e7ba39bb774),
    color: (0, $938b0f5cba479b6b$export$8473307aa00d6ea1),
    columnGap: (0, $938b0f5cba479b6b$export$958d0ae7f2977ae4),
    font: (0, $938b0f5cba479b6b$export$6ffa317d5e70375),
    fontFamily: (0, $938b0f5cba479b6b$export$3c7e9587132614b4),
    fontWeight: (0, $938b0f5cba479b6b$export$303e322c6b1ed114),
    gap: (0, $938b0f5cba479b6b$export$958d0ae7f2977ae4),
    height: (0, $938b0f5cba479b6b$export$6ccdbebca2ee545f),
    inlineSize: (0, $938b0f5cba479b6b$export$6ccdbebca2ee545f),
    inset: (0, $938b0f5cba479b6b$export$632685d741f3dbbf),
    insetBlock: (0, $938b0f5cba479b6b$export$632685d741f3dbbf),
    insetBlockEnd: (0, $938b0f5cba479b6b$export$632685d741f3dbbf),
    insetBlockStart: (0, $938b0f5cba479b6b$export$632685d741f3dbbf),
    insetInline: (0, $938b0f5cba479b6b$export$632685d741f3dbbf),
    insetInlineEnd: (0, $938b0f5cba479b6b$export$632685d741f3dbbf),
    insetInlineStart: (0, $938b0f5cba479b6b$export$632685d741f3dbbf),
    left: (0, $938b0f5cba479b6b$export$632685d741f3dbbf),
    margin: (0, $938b0f5cba479b6b$export$632685d741f3dbbf),
    marginBlock: (0, $938b0f5cba479b6b$export$632685d741f3dbbf),
    marginBlockEnd: (0, $938b0f5cba479b6b$export$632685d741f3dbbf),
    marginBlockStart: (0, $938b0f5cba479b6b$export$632685d741f3dbbf),
    marginBottom: (0, $938b0f5cba479b6b$export$632685d741f3dbbf),
    marginInline: (0, $938b0f5cba479b6b$export$632685d741f3dbbf),
    marginInlineEnd: (0, $938b0f5cba479b6b$export$632685d741f3dbbf),
    marginInlineStart: (0, $938b0f5cba479b6b$export$632685d741f3dbbf),
    marginLeft: (0, $938b0f5cba479b6b$export$632685d741f3dbbf),
    marginRight: (0, $938b0f5cba479b6b$export$632685d741f3dbbf),
    marginTop: (0, $938b0f5cba479b6b$export$632685d741f3dbbf),
    maxBlockSize: (0, $938b0f5cba479b6b$export$6ccdbebca2ee545f),
    maxHeight: (0, $938b0f5cba479b6b$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $938b0f5cba479b6b$export$6ccdbebca2ee545f),
    maxWidth: (0, $938b0f5cba479b6b$export$6ccdbebca2ee545f),
    minBlockSize: (0, $938b0f5cba479b6b$export$6ccdbebca2ee545f),
    minHeight: (0, $938b0f5cba479b6b$export$6ccdbebca2ee545f),
    minInlineSize: (0, $938b0f5cba479b6b$export$6ccdbebca2ee545f),
    minWidth: (0, $938b0f5cba479b6b$export$6ccdbebca2ee545f),
    opacity: (0, $938b0f5cba479b6b$export$daf94a976c798b4f),
    outlineColor: (0, $938b0f5cba479b6b$export$1531ad5bb3fbedac),
    outlineOffset: (0, $938b0f5cba479b6b$export$632685d741f3dbbf),
    outlineWidth: (0, $938b0f5cba479b6b$export$e1b83c5210c471b8),
    padding: (0, $938b0f5cba479b6b$export$958d0ae7f2977ae4),
    paddingBlock: (0, $938b0f5cba479b6b$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $938b0f5cba479b6b$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $938b0f5cba479b6b$export$958d0ae7f2977ae4),
    paddingBottom: (0, $938b0f5cba479b6b$export$958d0ae7f2977ae4),
    paddingInline: (0, $938b0f5cba479b6b$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $938b0f5cba479b6b$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $938b0f5cba479b6b$export$958d0ae7f2977ae4),
    paddingLeft: (0, $938b0f5cba479b6b$export$958d0ae7f2977ae4),
    paddingRight: (0, $938b0f5cba479b6b$export$958d0ae7f2977ae4),
    paddingTop: (0, $938b0f5cba479b6b$export$958d0ae7f2977ae4),
    right: (0, $938b0f5cba479b6b$export$632685d741f3dbbf),
    rowGap: (0, $938b0f5cba479b6b$export$958d0ae7f2977ae4),
    top: (0, $938b0f5cba479b6b$export$632685d741f3dbbf),
    width: (0, $938b0f5cba479b6b$export$6ccdbebca2ee545f),
    zIndex: (0, $938b0f5cba479b6b$export$b5f31a7e431d2eab)
};
var $80fa0c7b02938949$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $80fa0c7b02938949$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return false;
};
var $80fa0c7b02938949$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $80fa0c7b02938949$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $80fa0c7b02938949$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($80fa0c7b02938949$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(value) === 'object' && $80fa0c7b02938949$var$safeSelectors.test(key)) {
            styleObj[key] = $80fa0c7b02938949$var$_transformStyles(value);
            return;
        }
        if ($80fa0c7b02938949$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($80fa0c7b02938949$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $80fa0c7b02938949$export$9a199fbafee0014e)) return;
        var tokenValue = $80fa0c7b02938949$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $80fa0c7b02938949$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $80fa0c7b02938949$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, $80fa0c7b02938949$var$uniqueSymbol, (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $80fa0c7b02938949$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $80fa0c7b02938949$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $80fa0c7b02938949$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$80fa0c7b02938949$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $80fa0c7b02938949$export$f6c783d06584602c(style) {
    return $80fa0c7b02938949$var$baseXcss(style);
}


var $65126f1c0e6d437d$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $65126f1c0e6d437d$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $65126f1c0e6d437d$var$focusRingStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $938b0f5cba479b6b$export$1531ad5bb3fbedac)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $938b0f5cba479b6b$export$958d0ae7f2977ae4)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $938b0f5cba479b6b$export$e1b83c5210c471b8)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: "".concat((0, $938b0f5cba479b6b$export$e1b83c5210c471b8)['border.width'], " solid")
        }
    }
});
var $65126f1c0e6d437d$var$baseStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});
var $65126f1c0e6d437d$var$enabledStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    cursor: 'pointer'
});
var $65126f1c0e6d437d$var$disabledStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    cursor: 'not-allowed'
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $65126f1c0e6d437d$var$Pressable = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $f48d740006cf3f7d$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $65126f1c0e6d437d$var$_excluded);
    var interactionContext = (0, $7fPBF.useContext)((0, $48ec410b84640600$export$2e2bcd8739ae039));
    var handleClick = (0, $7fPBF.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $593ac790924c31ca$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "19.0.0",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $65126f1c0e6d437d$var$_excluded2);
    var resolvedStyles = (0, $80fa0c7b02938949$export$a9c84988c8f81f2d)(xcss);
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("button", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $65126f1c0e6d437d$var$baseStyles,
            $65126f1c0e6d437d$var$focusRingStyles,
            isDisabled ? $65126f1c0e6d437d$var$disabledStyles : $65126f1c0e6d437d$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $938b0f5cba479b6b$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $938b0f5cba479b6b$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $938b0f5cba479b6b$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $938b0f5cba479b6b$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $938b0f5cba479b6b$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $938b0f5cba479b6b$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $938b0f5cba479b6b$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $938b0f5cba479b6b$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(resolvedStyles.emotion || [])),
        "data-testid": testId
    }), children);
});
var $65126f1c0e6d437d$export$2e2bcd8739ae039 = $65126f1c0e6d437d$var$Pressable;



/* icon-renderer.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");
/* box.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $aFlfF = parcelRequire("aFlfF");

var $7fPBF = parcelRequire("7fPBF");
var $bbbfca73e75f834e$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $7fPBF.createContext)('elevation.surface');
var $bbbfca73e75f834e$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $7fPBF.useContext)($bbbfca73e75f834e$export$1ca2a26fecb070ae);
};
$bbbfca73e75f834e$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


var $a1b6e8ffae0f0cbd$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $a1b6e8ffae0f0cbd$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $a1b6e8ffae0f0cbd$var$baseStyles = null;
var $a1b6e8ffae0f0cbd$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhkby5v",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $a1b6e8ffae0f0cbd$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $a1b6e8ffae0f0cbd$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $a1b6e8ffae0f0cbd$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $a1b6e8ffae0f0cbd$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $a1b6e8ffae0f0cbd$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $a1b6e8ffae0f0cbd$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $a1b6e8ffae0f0cbd$var$Box = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $a1b6e8ffae0f0cbd$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $a1b6e8ffae0f0cbd$var$_excluded2);
    var node = /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        style: style,
        ref: ref,
        className: (0, $aFlfF.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $a1b6e8ffae0f0cbd$var$backgroundColorMap[backgroundColor],
            backgroundColor && $a1b6e8ffae0f0cbd$var$isSurfaceToken(backgroundColor) && $a1b6e8ffae0f0cbd$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $a1b6e8ffae0f0cbd$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $a1b6e8ffae0f0cbd$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $a1b6e8ffae0f0cbd$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $a1b6e8ffae0f0cbd$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $7fPBF.createElement((0, $bbbfca73e75f834e$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $a1b6e8ffae0f0cbd$export$2e2bcd8739ae039 = $a1b6e8ffae0f0cbd$var$Box;
function $a1b6e8ffae0f0cbd$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $a1b6e8ffae0f0cbd$var$setSurfaceTokenMap;
}


// Map lozenge colors to appropriate icon colors
var $678ce4fa7811fd0f$var$getIconColor = function getIconColor(color) {
    // For semantic colors, use corresponding semantic icon colors
    switch(color){
        case 'success':
            return "var(--ds-icon-success, #6A9A23)";
        case 'warning':
            return "var(--ds-icon-warning, #E06C00)";
        case 'danger':
            return "var(--ds-icon-danger, #C9372C)";
        case 'information':
            return "var(--ds-icon-information, #357DE8)";
        case 'neutral':
            return "var(--ds-icon-subtlest, #6B6E76)";
        case 'discovery':
            return "var(--ds-icon-discovery, #AF59E1)";
        // For accent colors, use corresponding accent icon colors
        case 'accent-red':
            return "var(--ds-icon-accent-red, #C9372C)";
        case 'accent-orange':
            return "var(--ds-icon-accent-orange, #E06C00)";
        case 'accent-yellow':
            return "var(--ds-icon-accent-yellow, #B38600)";
        case 'accent-lime':
            return "var(--ds-icon-accent-lime, #6A9A23)";
        case 'accent-green':
            return "var(--ds-icon-accent-green, #22A06B)";
        case 'accent-teal':
            return "var(--ds-icon-accent-teal, #2898BD)";
        case 'accent-blue':
            return "var(--ds-icon-accent-blue, #357DE8)";
        case 'accent-purple':
            return "var(--ds-icon-accent-purple, #AF59E1)";
        case 'accent-magenta':
            return "var(--ds-icon-accent-magenta, #CD519D)";
        case 'accent-gray':
            return "var(--ds-icon-accent-gray, #7D818A)";
        default:
            return "var(--ds-icon-subtlest, #6B6E76)";
    }
};
var $678ce4fa7811fd0f$var$styles = {
    motion: "_k8m01ylx _1oeci9qs _6fl41d08"
};
var $678ce4fa7811fd0f$export$32ff197eed95e568 = function IconRenderer(_ref) {
    var Icon = _ref.icon, color = _ref.color, testId = _ref.testId, size = _ref.size;
    var iconColor = $678ce4fa7811fd0f$var$getIconColor(color);
    return (0, $137Lh.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a1b6e8ffae0f0cbd$export$2e2bcd8739ae039), {
        xcss: $678ce4fa7811fd0f$var$styles.motion,
        style: {
            color: iconColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Icon, {
        label: "",
        size: size,
        testId: testId
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Icon, {
        color: iconColor,
        label: "",
        size: size,
        testId: testId
    });
};
var $678ce4fa7811fd0f$export$2e2bcd8739ae039 = $678ce4fa7811fd0f$export$32ff197eed95e568;


// Map legacy appearance to new color values
var $83f4e1c55f9bf623$var$legacyAppearanceMap = {
    default: 'neutral',
    removed: 'danger',
    inprogress: 'information',
    new: 'discovery',
    moved: 'warning'
};
var $83f4e1c55f9bf623$export$acf5d2b7dc999bda = function resolveLozengeColor() {
    var _legacyAppearanceMap$;
    var appearance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'neutral';
    if (appearance.startsWith('accent-')) return appearance;
    return (_legacyAppearanceMap$ = $83f4e1c55f9bf623$var$legacyAppearanceMap[appearance]) !== null && _legacyAppearanceMap$ !== void 0 ? _legacyAppearanceMap$ : appearance;
};
var $83f4e1c55f9bf623$export$a3fc04b8551e006a = function getThemeStyles(resolvedColor) {
    var isAccent = resolvedColor.startsWith('accent-');
    var category = isAccent ? 'accent' : 'semantic';
    var key = isAccent ? resolvedColor.replace('accent-', '') : resolvedColor;
    return {
        category: category,
        key: key
    };
};


function $5408c79bb7f92208$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5408c79bb7f92208$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5408c79bb7f92208$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5408c79bb7f92208$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Get the pressed background color for the selected lozenge dropdown trigger
var $5408c79bb7f92208$var$pressedBackgroundMapping = {
    success: "var(--ds-background-success-subtler-pressed, #B3DF72)",
    warning: "var(--ds-background-warning-subtler-pressed, #FBC828)",
    danger: "var(--ds-background-danger-subtler-pressed, #FD9891)",
    information: "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    neutral: "var(--ds-background-neutral-pressed, #080F214A)",
    discovery: "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'accent-red': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'accent-orange': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'accent-yellow': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'accent-lime': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'accent-green': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'accent-teal': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'accent-blue': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'accent-purple': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'accent-magenta': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'accent-gray': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
};
var $5408c79bb7f92208$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1j28 _kqswh2mm _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k92 _1q51v77o _85i5v77o _bozg1b66 _y4ti1b66",
    motionContainer: "_k8m01rje _1oeci9qs _6fl41d08",
    containerSpacious: "_2rko1qi0 _1tkeviql _1q511b66 _85i51b66 _bozgutpp _y4tiutpp",
    containerBadgePadding: "_y4ti303w",
    text: "_11c8wadc _1reo15vq _18m915vq _o5721q9c",
    textEllipsis: "_1bto1l2s",
    textClip: "_1btozryt",
    textSpacious: "_11c8fhey _k48p1wq8",
    textSelected: "_syaz6x5g",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw",
    metricBadgeWrapper: "_1e0c1txw",
    'metric.semantic.success': "_1bn8d6jc _4ayg1wl5",
    'metric.semantic.warning': "_1bn8bkku _4aygzr32",
    'metric.semantic.danger': "_1bn8jkmi _4ayg1r4b",
    'metric.semantic.information': "_1bn8ar1y _4ayg1c1j",
    'metric.semantic.neutral': "_1bn814je _4ayg1fkg _iymy8hz0 _16burnys",
    'metric.semantic.discovery': "_1bn85usi _4ayg18vq",
    'metric.inverse': "_1bn8vuon _4aygvuon",
    'semantic.success': "_1b3i4pcx _3wu01mps _bfhk14j0 _syaz1p1e",
    'semantic.warning': "_1b3iervl _3wu01xiv _bfhk10f4 _syazmgs1",
    'semantic.danger': "_1b3is4qr _3wu01bqt _bfhk18wg _syaz1blx",
    'semantic.information': "_1b3iyhbg _3wu0vbh5 _bfhk8lbg _syaz1qd9",
    'semantic.neutral': "_1b3i1cv2 _3wu01ihb _bfhki8nm _syazi7uo",
    'semantic.discovery': "_1b3iqm1h _3wu0v30g _bfhke670 _syaz1g72",
    'accent.red': "_1b3inbxb _3wu016y8 _bfhk1rtt _syazhwvp",
    'accent.orange': "_1b3i1j6y _3wu01b2s _bfhk165s _syaz7i1p",
    'accent.yellow': "_1b3i1oqg _3wu0feiv _bfhk1773 _syazekll",
    'accent.lime': "_1b3i8645 _3wu0nf89 _bfhkz2ec _syaz1ik3",
    'accent.green': "_1b3i17hp _3wu01crs _bfhk1wnw _syaz1y78",
    'accent.teal': "_1b3i8uof _3wu01h3o _bfhk1a17 _syaz12v7",
    'accent.blue': "_1b3i6txe _3wu01w55 _bfhk1dy8 _syaz1kyx",
    'accent.purple': "_1b3iuq3u _3wu01hqq _bfhk1nm4 _syaz1mn1",
    'accent.magenta': "_1b3iv8hk _3wu0uwd0 _bfhkv9ra _syaz1qur",
    'accent.gray': "_1b3i1diz _3wu08yml _bfhkysee _syaz1tmo",
    'interactive.semantic.success': "_irr31r82 _1di6d6jc",
    'interactive.semantic.warning': "_irr31yx4 _1di6bkku",
    'interactive.semantic.danger': "_irr370oi _1di6jkmi",
    'interactive.semantic.information': "_irr315aw _1di6ar1y",
    'interactive.semantic.neutral': "_irr3plhp _1di61gdz",
    'interactive.semantic.discovery': "_irr3rumk _1di65usi",
    'interactive.accent.red': "_irr3affd _1di61j5a",
    'interactive.accent.orange': "_irr31ei0 _1di6dpo3",
    'interactive.accent.yellow': "_irr31uw7 _1di61r9w",
    'interactive.accent.lime': "_irr31gf0 _1di62kxc",
    'interactive.accent.green': "_irr31e2h _1di6ybhx",
    'interactive.accent.teal': "_irr3kwwr _1di61jb0",
    'interactive.accent.blue': "_irr3815t _1di6rwxf",
    'interactive.accent.purple': "_irr3attl _1di63nfk",
    'interactive.accent.magenta': "_irr31axx _1di642ri",
    'interactive.accent.gray': "_irr3wejn _1di618ut",
    iconBorderFilter: "_1h6dzs9d _4uq11yqs _1k671038 _m71tr3uz _13muu67f _168qx19p _oe6mmko7 _189qkb7n _u8p61h4e _1t75u67f _hg5mr3uz _1f28f1ug _1xe213rw _1easxmrh _1r9r1ss3",
    iconBorderInteractiveFilter: "_1iel6xdd _111i1h4e _18dicjiy _hyog26zw _fdt01r5k _46v5hwvj _ylgq1r5k _bg3q9by0 _196p1btq _18mn783i _l0666xdd _pclnn8xv _ockq1r5k _aewt1n8h _4cvx7ddx _1cp21w66 _q4zt1csi _1gqs1mvc _75gv2l9f _1lh71sfd _ui3h1ct7 _11o31cha",
    containerSelected: "_1xe213kw",
    content: "_zulp1b66 _1e0c116y _4cvr1h6o",
    contentSpacious: "_zulp12x7",
    loadingContent: "_tzy4idpf",
    containerBadge: "_1ftrbpke",
    containerBadgeInteractive: "_1axm1bqy"
};
/**
 * __New Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 * This is the updated version with the new North Star visual language.
 */ var $5408c79bb7f92208$var$LozengeBase = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, appearance = _ref.appearance, iconBefore = _ref.iconBefore, trailingMetric = _ref.trailingMetric, trailingMetricAppearance = _ref.trailingMetricAppearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, isSelected = _ref.isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, onClick = _ref.onClick, style = _ref.style, analyticsContext = _ref.analyticsContext, interactionName = _ref.interactionName, ariaControls = _ref['aria-controls'], ariaExpanded = _ref['aria-expanded'], ariaHaspopup = _ref['aria-haspopup'], ariaLabel = _ref['aria-label'];
    var _useState = (0, $7fPBF.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), resizing = _useState2[0], setResizing = _useState2[1];
    var onFinishMotion = function onFinishMotion() {
        return setResizing(false);
    };
    var resizingWidth = (0, $c018b04a9c663b15$export$a300664a1a230956)({
        dimension: 'width',
        duration: "var(--ds-duration-medium, 200ms)",
        easing: "var(--ds-easing-inout-bold, cubic-bezier(0.4, 0, 0, 1))",
        onFinishMotion: onFinishMotion
    });
    var isInitialRender = (0, $7fPBF.useRef)(true);
    var isInteractive = typeof onClick === 'function';
    // Determine the effective color, with fallback logic for legacy appearances
    var resolvedColor = (0, $83f4e1c55f9bf623$export$acf5d2b7dc999bda)(appearance) || 'neutral';
    var _getThemeStyles = (0, $83f4e1c55f9bf623$export$a3fc04b8551e006a)(resolvedColor), category = _getThemeStyles.category, key = _getThemeStyles.key;
    var colorStyleKey = "".concat(category, ".").concat(key);
    var interactiveStyleKey = "interactive.".concat(category, ".").concat(key);
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    var resolvedTrailingMetricAppearance = trailingMetricAppearance ? trailingMetricAppearance === 'inverse' ? 'inverse' : (0, $83f4e1c55f9bf623$export$acf5d2b7dc999bda)(trailingMetricAppearance) : resolvedColor;
    var metricBadgeAppearance = resolvedTrailingMetricAppearance === 'inverse' ? 'inverse' : resolvedTrailingMetricAppearance != null && resolvedTrailingMetricAppearance.startsWith('accent-') ? 'neutral' : resolvedTrailingMetricAppearance !== null && resolvedTrailingMetricAppearance !== void 0 ? resolvedTrailingMetricAppearance : 'neutral';
    var metricStyleKey = resolvedTrailingMetricAppearance === 'inverse' ? 'metric.inverse' : resolvedTrailingMetricAppearance != null && !resolvedTrailingMetricAppearance.startsWith('accent-') ? "metric.semantic.".concat((0, $83f4e1c55f9bf623$export$a3fc04b8551e006a)(resolvedTrailingMetricAppearance).key) : 'metric.semantic.neutral';
    var commonStyleOverrides = {
        backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
        maxWidth: maxWidthIsPc ? maxWidth : '100%'
    };
    var hasTrailingMetric = trailingMetric != null && trailingMetric !== '';
    var childrenKey = typeof children === 'string' ? children : undefined;
    (0, $7fPBF.useLayoutEffect)(function() {
        // Ignore initial render
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        setResizing(true);
    }, [
        childrenKey
    ]);
    var enableMotionFG = (0, $137Lh.fg)('platform-dst-motion-uplift');
    var innerContent = /*#__PURE__*/ $7fPBF.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        style: {
            // When maxWidth is a percentage, constrain the content wrapper
            // so text truncation works correctly within the flex layout
            maxWidth: maxWidthIsPc ? '100%' : undefined
        }
    }, enableMotionFG ? resizingWidth : undefined, {
        className: (0, $aFlfF.default)([
            $5408c79bb7f92208$var$styles.content,
            spacing === 'spacious' && $5408c79bb7f92208$var$styles.contentSpacious,
            isLoading && $5408c79bb7f92208$var$styles.loadingContent
        ])
    }), iconBefore && /*#__PURE__*/ $7fPBF.createElement((0, $678ce4fa7811fd0f$export$2e2bcd8739ae039), {
        size: spacing === 'spacious' ? 'medium' : 'small',
        icon: iconBefore,
        color: resolvedColor,
        testId: testId && "".concat(testId, "--icon")
    }), /*#__PURE__*/ $7fPBF.createElement("span", {
        style: {
            maxWidth: maxWidthIsPc ? undefined : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")"),
            color: style === null || style === void 0 ? void 0 : style.color
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $aFlfF.default)([
            $5408c79bb7f92208$var$styles.text,
            enableMotionFG && resizing ? $5408c79bb7f92208$var$styles.textClip : $5408c79bb7f92208$var$styles.textEllipsis,
            spacing === 'spacious' && $5408c79bb7f92208$var$styles.textSpacious
        ])
    }, children), hasTrailingMetric && !resolvedColor.startsWith('accent-') && /*#__PURE__*/ $7fPBF.createElement("span", {
        "data-lozenge-metric-wrapper": true,
        "data-testid": testId && "".concat(testId, "--metric"),
        className: (0, $aFlfF.default)([
            $5408c79bb7f92208$var$styles.metricBadgeWrapper
        ])
    }, /*#__PURE__*/ $7fPBF.createElement((0, $35fbf3ba688956a9$export$2e2bcd8739ae039), {
        appearance: metricBadgeAppearance
    }, trailingMetric)), isInteractive && /*#__PURE__*/ $7fPBF.createElement((0, (/*@__PURE__*/$parcel$interopDefault($da428317fd2ac5f3$exports))), {
        label: "",
        size: "small",
        color: 'currentColor',
        testId: testId && "".concat(testId, "--chevron")
    }));
    if (isInteractive) return /*#__PURE__*/ $7fPBF.createElement((0, $65126f1c0e6d437d$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        ref: ref,
        xcss: (0, $e636b2257db42c06$export$a274e22fb40f762e)($5408c79bb7f92208$var$styles.container, (0, $137Lh.fg)('platform-dst-motion-uplift') && $5408c79bb7f92208$var$styles.motionContainer, spacing === 'spacious' && $5408c79bb7f92208$var$styles.containerSpacious, !isSelected && $5408c79bb7f92208$var$styles.iconBorderFilter, !isLoading && $5408c79bb7f92208$var$styles.iconBorderInteractiveFilter, $5408c79bb7f92208$var$styles[colorStyleKey], !isLoading && $5408c79bb7f92208$var$styles[interactiveStyleKey], isSelected && $5408c79bb7f92208$var$styles.containerSelected, hasTrailingMetric && $5408c79bb7f92208$var$styles.containerBadge, hasTrailingMetric && $5408c79bb7f92208$var$styles.containerBadgeInteractive, hasTrailingMetric && $5408c79bb7f92208$var$styles[metricStyleKey])
    }, isLoading && {
        'aria-busy': true,
        'aria-disabled': true,
        isDisabled: true
    }, {
        "aria-label": isLoading ? 'Loading' : ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        onClick: isLoading ? undefined : onClick,
        style: $5408c79bb7f92208$var$_objectSpread($5408c79bb7f92208$var$_objectSpread({}, commonStyleOverrides), {}, {
            // Specified because Pressable has a default border:none which overrides the border specified on the container
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            border: "solid ".concat("var(--ds-border-width, 1px)", " ", isSelected ? 'oklch(from var(--border-color) calc(l * var(--border-pressed-l-factor)) c h) !important' : 'transparent'),
            backgroundColor: isSelected ? $5408c79bb7f92208$var$pressedBackgroundMapping[resolvedColor] : undefined,
            cursor: isLoading ? 'progress' : 'pointer'
        }),
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LozengeDropdownTrigger"
    }), innerContent, isLoading && /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, $aFlfF.default)([
            $5408c79bb7f92208$var$styles.loadingOverlay
        ])
    }, /*#__PURE__*/ $7fPBF.createElement((0, $aacfdd39b28e059d$export$2e2bcd8739ae039), {
        size: spacing === 'spacious' ? 'small' : 'xsmall',
        label: ", Loading",
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    })));
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        ref: ref,
        style: commonStyleOverrides,
        "data-testid": testId,
        className: (0, $aFlfF.default)([
            $5408c79bb7f92208$var$styles.container,
            spacing === 'spacious' && $5408c79bb7f92208$var$styles.containerSpacious,
            spacing !== 'spacious' && hasTrailingMetric && $5408c79bb7f92208$var$styles.containerBadgePadding,
            $5408c79bb7f92208$var$styles[colorStyleKey],
            hasTrailingMetric && $5408c79bb7f92208$var$styles[metricStyleKey],
            $5408c79bb7f92208$var$styles.iconBorderFilter,
            $5408c79bb7f92208$var$styles.containerBadge
        ])
    }, innerContent);
}));
var $5408c79bb7f92208$export$2e2bcd8739ae039 = $5408c79bb7f92208$var$LozengeBase;


/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $1a466649bf6696b1$var$Lozenge = function Lozenge(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style, testId = _ref.testId, children = _ref.children, iconBefore = _ref.iconBefore, trailingMetric = _ref.trailingMetric, trailingMetricAppearance = _ref.trailingMetricAppearance;
    var baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        children: children
    };
    return /*#__PURE__*/ $7fPBF.createElement((0, $5408c79bb7f92208$export$2e2bcd8739ae039), baseProps, children);
};
$1a466649bf6696b1$var$Lozenge.displayName = 'Lozenge';
var $1a466649bf6696b1$export$2e2bcd8739ae039 = $1a466649bf6696b1$var$Lozenge;


/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ var $35a55e0507ba7e43$var$styles = {
    container: "_2rkofajl _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect4ttxp _1wyb1skh _zg8l4jg8 _k48pwu06 _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhksm61",
    'bg.subtle.inprogress': "_bfhksm61",
    'bg.subtle.moved': "_bfhksm61",
    'bg.subtle.new': "_bfhksm61",
    'bg.subtle.removed': "_bfhksm61",
    'bg.subtle.success': "_bfhksm61",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syazi7uo",
    'text.bold': "_syazwwip"
};
var $35a55e0507ba7e43$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed'
];
var $35a55e0507ba7e43$var$newSemanticColors = [
    'success',
    'discovery',
    'warning',
    'danger',
    'information',
    'neutral'
];
var $35a55e0507ba7e43$var$appearanceMapping = {
    neutral: 'default',
    default: 'default',
    information: 'inprogress',
    inprogress: 'inprogress',
    warning: 'moved',
    moved: 'moved',
    removed: 'removed',
    danger: 'removed',
    success: 'success',
    discovery: 'new',
    new: 'new'
};
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $35a55e0507ba7e43$var$LegacyLozenge = /*#__PURE__*/ (0, $7fPBF.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$isBold = _ref.isBold, isBold = _ref$isBold === void 0 ? false : _ref$isBold, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style;
    var appearanceStyle = isBold ? 'bold' : 'subtle';
    var appearanceType = (0, $7fPBF.useMemo)(function() {
        return $35a55e0507ba7e43$var$appearanceTypes.includes(appearance) || $35a55e0507ba7e43$var$newSemanticColors.includes(appearance) ? $35a55e0507ba7e43$var$appearanceMapping[appearance] : 'default';
    }, [
        appearance
    ]);
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $aFlfF.default)([
            $35a55e0507ba7e43$var$styles.container,
            $35a55e0507ba7e43$var$styles["bg.".concat(appearanceStyle, ".").concat(appearanceType)],
            appearanceStyle === 'subtle' && $35a55e0507ba7e43$var$styles["outline.subtle.".concat(appearanceType)],
            appearanceStyle === 'subtle' && $35a55e0507ba7e43$var$styles.containerSubtle
        ])
    }, /*#__PURE__*/ $7fPBF.createElement("span", {
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $aFlfF.default)([
            $35a55e0507ba7e43$var$styles.text,
            (0, $137Lh.fg)('platform-lozenge-custom-letterspacing') && $35a55e0507ba7e43$var$styles.customLetterspacing,
            $35a55e0507ba7e43$var$styles["text.".concat(appearanceStyle)]
        ])
    }, children));
});
$35a55e0507ba7e43$var$LegacyLozenge.displayName = 'Lozenge';
/**
 * Wrapper component that switches between old and new Lozenge based on feature flag
 */ var $35a55e0507ba7e43$var$LozengeWrapper = /*#__PURE__*/ (0, $7fPBF.memo)(function(props) {
    if ((0, $137Lh.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) return /*#__PURE__*/ $7fPBF.createElement((0, $1a466649bf6696b1$export$2e2bcd8739ae039), props);
    return /*#__PURE__*/ $7fPBF.createElement($35a55e0507ba7e43$var$LegacyLozenge, props);
});
$35a55e0507ba7e43$var$LozengeWrapper.displayName = 'Lozenge';
var $35a55e0507ba7e43$export$2e2bcd8739ae039 = $35a55e0507ba7e43$var$LozengeWrapper;



const $5fd605fd49ab1b9b$var$contentHeaderStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    paddingBottom: 'space.200'
});
const $5fd605fd49ab1b9b$var$descriptionStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    display: 'none',
    [(0, $8c23171a376c15ae$export$987d49ffe1b0900f).above.xs]: {
        display: 'flex'
    }
});
const $5fd605fd49ab1b9b$var$selectLabelStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    color: 'color.text.subtle',
    whiteSpace: 'nowrap'
});
const $5fd605fd49ab1b9b$var$ContentHeader = ({ text: text, onClickAll: onClickAll, onClickNone: onClickNone, groupKey: groupKey })=>{
    const { translate: translate, keyWithCallout: keyWithCallout } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    const calloutText = translate(keyWithCallout(groupKey));
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $067e8036161c713e$export$2e2bcd8739ae039), {
        xcss: $5fd605fd49ab1b9b$var$contentHeaderStyles,
        space: 'space.200',
        spread: 'space-between',
        alignBlock: 'baseline',
        children: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("div", {
                children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                    xcss: $5fd605fd49ab1b9b$var$descriptionStyles,
                    children: /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $96a603e4012a3253$export$2e2bcd8739ae039), {
                        size: 'large',
                        children: [
                            !calloutText.startsWith(groupKey) ? /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("span", {
                                children: [
                                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $35a55e0507ba7e43$export$2e2bcd8739ae039), {
                                        isBold: true,
                                        children: calloutText
                                    }),
                                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("span", {
                                        children: " "
                                    })
                                ]
                            }) : null,
                            translate(text || '')
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $067e8036161c713e$export$2e2bcd8739ae039), {
                space: 'space.100',
                alignBlock: 'baseline',
                children: [
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                        xcss: $5fd605fd49ab1b9b$var$selectLabelStyles,
                        children: translate((0, $447ba15143f7eed7$exports).SELECT_LABEL)
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $317b0dc61223a332$export$2e2bcd8739ae039), {
                        testId: 'dynamicConfigElementsGroupSelectAllButton',
                        appearance: 'subtle',
                        onClick: onClickAll,
                        children: translate((0, $447ba15143f7eed7$exports).SELECT_ALL_BUTTON_LABEL)
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $317b0dc61223a332$export$2e2bcd8739ae039), {
                        testId: 'dynamicConfigElementsGroupSelectNoneButton',
                        appearance: 'subtle',
                        onClick: onClickNone,
                        children: translate((0, $447ba15143f7eed7$exports).SELECT_NONE_BUTTON_LABEL)
                    })
                ]
            })
        ]
    });
};
var $5fd605fd49ab1b9b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $7fPBF.memo)($5fd605fd49ab1b9b$var$ContentHeader);




/* ItemCard.tsx generated by @compiled/babel-plugin v2.0.0 */ 


var $7fPBF = parcelRequire("7fPBF");



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

parcelRequire("7fPBF");
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::978af025984c14496c17f030fc144641>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $7fPBF = parcelRequire("7fPBF");


var $137Lh = parcelRequire("137Lh");

var $cd6db93af55ef7e3$var$styles = {
    root: "_1e0c1o8l",
    TEMP_assets: "_9aea1fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $cd6db93af55ef7e3$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $cd6db93af55ef7e3$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $cd6db93af55ef7e3$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $cd6db93af55ef7e3$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
var $cd6db93af55ef7e3$var$rovoDarkAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
var $cd6db93af55ef7e3$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ var $cd6db93af55ef7e3$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl",
    '12': "_4t3i1crf",
    '16': "_4t3i7vkz",
    '20': "_4t3igktf",
    '24': "_4t3i1tcg",
    '32': "_4t3izwfg"
};
function $cd6db93af55ef7e3$export$be58b4326e23250f(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? '20' : _ref$size, label = _ref.label, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, userDefinedTestId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, customIconColor = _ref.iconColor, _ref$isAssets = _ref.isAssets, isAssets = _ref$isAssets === void 0 ? false : _ref$isAssets, _ref$type = _ref.type, type = _ref$type === void 0 ? 'tile' : _ref$type;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && customIconColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $86ebb3b02603ea9e$export$2e2bcd8739ae039)([
            $cd6db93af55ef7e3$var$styles.root,
            $cd6db93af55ef7e3$var$sizeMap[size],
            colorMode === 'dark' ? $cd6db93af55ef7e3$var$dataCenterDarkAppearanceMap[appearance] : $cd6db93af55ef7e3$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $cd6db93af55ef7e3$var$rovoDarkAppearanceMap[appearance] : $cd6db93af55ef7e3$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $cd6db93af55ef7e3$var$cloudDarkAppearanceMap[appearance] : $cd6db93af55ef7e3$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && (0, $137Lh.fg)('assets-platform-branding') && $cd6db93af55ef7e3$var$styles.TEMP_assets
        ])
    });
}


// `height` is set to 100% to allow the SVG to scale with the parent element
var $d9defcc45ed17055$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.444 5h3.111l.98 2.61 2.75-.457 1.555 2.694L17.07 12l1.77 2.153-1.555 2.694-2.75-.457-.979 2.61h-3.11l-.98-2.61-2.75.457-1.555-2.694L6.931 12 5.16 9.847l1.555-2.694 2.75.457zM12 14.625a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $d9defcc45ed17055$export$ef8e5f836dd989d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Admin' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $d9defcc45ed17055$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f6b875f42d16c31c8841f1ef82618390>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");
/* logo-wrapper.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
var $7fPBF = parcelRequire("7fPBF");


var $137Lh = parcelRequire("137Lh");

var $86c6c6571f1aae09$var$styles = {
    root: "_1e0c1o8l _vwz4idpf",
    TEMP_assets: "_9aea1fkg"
};
// These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
var $86c6c6571f1aae09$var$logoTextColorMap = {
    light: "_syazqlpt",
    dark: "_syazz6c6"
};
var $86c6c6571f1aae09$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $86c6c6571f1aae09$var$textLightAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1e01",
    inverse: "_1wycu67f",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $86c6c6571f1aae09$var$textDarkAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1gvk",
    inverse: "_1wyc5a6q",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $86c6c6571f1aae09$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $86c6c6571f1aae09$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $86c6c6571f1aae09$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $86c6c6571f1aae09$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
var $86c6c6571f1aae09$var$rovoDarkAppearanceMap = {
    brand: "_1703lrxy _1evoh727 _epb51yy8 _1osdxeun",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
var $86c6c6571f1aae09$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
function $86c6c6571f1aae09$export$f827d3c5a9c3f644(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$size = _ref.size, size = _ref$size === void 0 ? 'small' : _ref$size, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, label = _ref.label, userDefinedTestId = _ref.testId, customIconColor = _ref.iconColor, customTextColor = _ref.textColor, _ref$isAssets = _ref.isAssets, isAssets = _ref$isAssets === void 0 ? false : _ref$isAssets, _ref$type = _ref.type, type = _ref$type === void 0 ? 'tile' : _ref$type;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor === 'inherit' ? customTextColor : customIconColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-text-color': customTextColor || 'inherit'
        },
        "data-testid": testId,
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $86ebb3b02603ea9e$export$2e2bcd8739ae039)([
            $86c6c6571f1aae09$var$styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            $86c6c6571f1aae09$var$logoTextColorMap[colorMode !== null && colorMode !== void 0 ? colorMode : 'light'],
            $86c6c6571f1aae09$var$sizeMap[size],
            colorMode === 'dark' ? $86c6c6571f1aae09$var$textDarkAppearanceMap[appearance] : $86c6c6571f1aae09$var$textLightAppearanceMap[appearance],
            colorMode === 'dark' ? $86c6c6571f1aae09$var$dataCenterDarkAppearanceMap[appearance] : $86c6c6571f1aae09$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $86c6c6571f1aae09$var$rovoDarkAppearanceMap[appearance] : $86c6c6571f1aae09$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $86c6c6571f1aae09$var$cloudDarkAppearanceMap[appearance] : $86c6c6571f1aae09$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && (0, $137Lh.fg)('assets-platform-branding') && $86c6c6571f1aae09$var$styles.TEMP_assets
        ])
    });
}


// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $b7eaa396af4bb025$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M124.84 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-20.15-10.4c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-14.07-8.52v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.85c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-22.02-4.01c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M13.826 6.4h4.255l1.338 3.569 3.76-.626 2.128 3.684-2.422 2.945 2.421 2.943L23.18 22.6l-3.76-.626-1.338 3.57h-4.255l-1.338-3.57-3.76.625L6.6 18.915l2.421-2.943L6.6 13.028l2.127-3.685 3.76.626zm2.128 13.16a3.59 3.59 0 1 0 0-7.178 3.59 3.59 0 0 0 0 7.179\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $b7eaa396af4bb025$export$61afcb38c001e19(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Admin' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $b7eaa396af4bb025$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::722075a08a8f598253aef877e81d3776>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $27343cad4462b865$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M18.545 18.545a4.49 4.49 0 0 0-4.48-4.48h-4.13v-3.78h-4.48v7.434c0 .576.25.826.826.826zM5.455 5.455a4.454 4.454 0 0 0 4.455 4.48h4.155v3.78h4.48V6.28q0-.825-.826-.826z\"/>\n</svg>\n";
function $27343cad4462b865$export$70a0c2f5862937b6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Align' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $27343cad4462b865$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3765620b2b4a8b62ff9327c31a8491d2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $0eefe72489d48a5b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 106 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M105.76 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-19.6 7.75v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52M68.73 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-2.54-.03c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM49.6 21.32c-1.53 0-3.1-.18-4.82-.52l-1.69 4.54H40l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.68 7.43 45.6 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M23.735 23.735c0-2.928-2.396-5.295-5.295-5.295h-4.88v-4.466H8.265v8.785c0 .68.296.976.976.976zM8.265 8.265c0 2.928 2.337 5.295 5.265 5.295h4.91v4.466h5.295V9.241q0-.976-.976-.976z\"/>\n</svg>\n";
function $0eefe72489d48a5b$export$8b5103382c06639c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Align' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $0eefe72489d48a5b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cb69048bab05ca24708a4807daf973fa>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $b393203e1c7594b2$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.63 5.88v9.19h3.06v-9.2zM5.88 18.13h11.81v-1.75H5.87zm0-3.07v-4.81h3.06v4.81zm4.37-6.56v6.56h3.06V8.5z\"/>\n</svg>\n";
function $b393203e1c7594b2$export$af3460f51ce3602a(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Analytics' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $b393203e1c7594b2$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bacdce044c632033f444ff3fb8aec626>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $972fc5e8668bd5f4$var$svg = "<svg height=\"100%\" viewBox=\"0 0 161 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M160.66 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.6 1.41v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M129.13 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-7.46-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-14.12 3.77h-1.72L100.77 10h2.82l4.91 13.13L113.41 10h2.82l-5.8 14.84c-1.72 4.39-2.7 6.66-6.59 6.66-1.32 0-2.05-.12-2.82-.43V28.8c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.81m-7.8.94c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM79.5 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM74.1 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-24.66 4.97c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.5 7.83v12.25h4.08V7.83zM7.83 24.17h15.75v-2.33H7.83zm0-4.09v-6.42h4.08v6.42zm5.84-8.75v8.75h4.08v-8.75z\"/>\n</svg>\n";
function $972fc5e8668bd5f4$export$f0bac2b7ac3e3504(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Analytics' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $972fc5e8668bd5f4$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bdf3eea5e378fdf57510e12d7a73d069>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $64f3eb4d21a447bc$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z\"/>\n</svg>\n";
var $64f3eb4d21a447bc$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729\"/>\n</svg>\n";
function $64f3eb4d21a447bc$export$d89497e7f33ca6f5(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Assets' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $64f3eb4d21a447bc$var$svg,
        customThemeSvg: $64f3eb4d21a447bc$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a0f34baf8663cd71b78e62846baabe5a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $5913d823a24d0cba$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M125.8 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.77-.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.5c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.13-3.56c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63-.01c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-22.22.15c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M11.667 15.425a4.335 4.335 0 0 0 3.758-3.758h2.742V9.5h-3.023A4.335 4.335 0 1 0 9.5 15.144v3.023h2.167zm-.542-2.675a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M24.67 10.58a2.71 2.71 0 1 1-5.42 0 2.71 2.71 0 0 1 5.42 0M10.58 24.67a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m11.38 0a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m-3.79-3.79h-3.79v2.17h3.79zm2.71-6.5v3.79h2.17v-3.79z\"/>\n</svg>\n";
function $5913d823a24d0cba$export$81c47abe19675c4c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Assets' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $5913d823a24d0cba$var$svg,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eb2b70bfad61d30e19bb65dd0ce89de7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $1401f80fbd87af06$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M9.215 12.652a2.75 2.75 0 0 0 2.749 2.742v4.205a6.964 6.964 0 0 1-6.849-5.727l-.049-.317zm9.26 0a.44.44 0 0 1 .436.468c-.222 3.311-2.783 5.989-6.043 6.414l-.904-4.14a2.75 2.75 0 0 0 2.723-2.37.44.44 0 0 1 .44-.372zM11.963 9.91a2.75 2.75 0 0 0-2.748 2.742H5v-.065c.033-3.495 2.668-6.374 6.059-6.816zm0-5.972a.436.436 0 0 1 .72-.33l4.824 4.138a.436.436 0 0 1 0 .662l-4.823 4.139a.436.436 0 0 1-.72-.331z\"/>\n</svg>\n";
function $1401f80fbd87af06$export$e812398311cab9a3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bamboo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $1401f80fbd87af06$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2321f2dda4d95bdf7f57b6fa4abea572>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $10b8bb0abf413d2f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 154 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M146 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-16.68 13.49c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-12.07 5.52c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-21.58-8.82v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.23-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M12.287 16.869a3.665 3.665 0 0 0 3.665 3.656v5.607c-4.71 0-8.602-3.52-9.196-8.06zm12.347 0a.584.584 0 0 1 .581.624c-.295 4.415-3.71 7.986-8.057 8.554l-1.206-5.521a3.67 3.67 0 0 0 3.63-3.161.59.59 0 0 1 .589-.496zm-8.683-3.656a3.664 3.664 0 0 0-3.665 3.656h-5.62v-.088c.044-4.66 3.557-8.498 8.078-9.088zm0-7.964a.58.58 0 0 1 .96-.44l6.432 5.518c.27.232.27.65 0 .883l-6.431 5.517a.581.581 0 0 1-.96-.44z\"/>\n</svg>\n";
function $10b8bb0abf413d2f$export$7c51958462d750e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bamboo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $10b8bb0abf413d2f$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::851eef4fe42af84bd69327ee9c4f8fd9>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $ee7c37f7a95674cb$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582\"/>\n</svg>\n";
var $ee7c37f7a95674cb$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z\"/>\n</svg>\n";
function $ee7c37f7a95674cb$export$5fc1066e677788d4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $ee7c37f7a95674cb$var$svg,
        customThemeSvg: $ee7c37f7a95674cb$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::478f827cfee38d4db58962bbd974c1b0>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $91c2d5905dabc876$var$svg = "<svg height=\"100%\" viewBox=\"0 0 166 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.4-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.17-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.27 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.69 5.43z\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.029.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.572 0 .743.285.657.771\"/>\n</svg>\n";
function $91c2d5905dabc876$export$f7ef5e5488e4b430(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $91c2d5905dabc876$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ac8f22afdb6e4b999b2444d5d77ea16>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $0d0a7c8ab027634f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"m17.843 11.763-.986 6.024c-.065.365-.322.58-.686.58H7.81c-.365 0-.622-.215-.686-.58L5.387 7.047c-.064-.364.129-.6.472-.6h12.262c.343 0 .536.236.472.6l-.472 2.83c-.064.407-.3.579-.686.579h-7.374c-.107 0-.172.064-.15.193l.579 3.558c.021.086.085.15.171.15h2.658c.086 0 .15-.064.172-.15l.407-2.572c.043-.322.257-.45.558-.45h2.894c.428 0 .557.214.493.578\"/>\n</svg>\n";
function $0d0a7c8ab027634f$export$d3ab16bbf4f954ee(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $0d0a7c8ab027634f$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8ba6d4a8459456d84acb6ec3954e8bd>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $bae800d655fb5d3b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 166 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.85-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.39-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.028.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.571 0 .743.285.657.771\"/>\n</svg>\n";
function $bae800d655fb5d3b$export$cc55e2a4c4b40552(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $bae800d655fb5d3b$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::746df89d4e9f9114099c723d030eeb4f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $dd87b83dddb54df5$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.125 16.5h8.125V6H5.75v13zM12 12.125a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75m4-.875a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0m-7.125.875a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $dd87b83dddb54df5$export$52cd484a7ef4f2b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $dd87b83dddb54df5$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e1380d2508da72b3317d1f5d85a933aa>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $9ab3de5044174c8a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.65m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M24.167 21.834h-10.5l-5.833 3.5v-17.5h16.333zm-12.25-5.833a1.167 1.167 0 1 0 0-2.334 1.167 1.167 0 0 0 0 2.334M16 16a1.167 1.167 0 1 0 0-2.334A1.167 1.167 0 0 0 16 16m5.25-1.167a1.167 1.167 0 1 1-2.334 0 1.167 1.167 0 0 1 2.333 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $9ab3de5044174c8a$export$a529e78951cd6709(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $9ab3de5044174c8a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3fab57be3a885672ac53325ee0c1c49f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $5caa168089207a9d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M18.563 16.688h-8.438L5.438 19.5V5.438h13.125zm-6.83-9.375-.255.647c-.362.92-.543 1.38-.878 1.727-.334.346-.787.543-1.694.938l-.388.17v.535l.388.17c.907.394 1.36.592 1.694.938.335.346.516.807.878 1.727l.255.648h.535l.255-.648c.362-.92.543-1.38.877-1.727.335-.346.788-.544 1.694-.939l.388-.169v-.535l-.388-.17c-.906-.395-1.36-.592-1.694-.938-.334-.347-.515-.807-.877-1.727l-.255-.647z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $5caa168089207a9d$export$402a257da320c93c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $5caa168089207a9d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::081a9e6d7349520af47983a112236857>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $c88daa759082a180$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.95c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M24.75 22.25H13.5L7.25 26V7.25h17.5zm-9.107-12.5-.34.864c-.482 1.226-.724 1.84-1.17 2.302s-1.05.725-2.258 1.251l-.518.226v.714l.518.226c1.209.526 1.813.79 2.259 1.251.445.462.687 1.076 1.17 2.303l.34.863h.714l.34-.864c.482-1.227.724-1.84 1.17-2.302s1.049-.725 2.258-1.251l.517-.226v-.714l-.517-.226c-1.21-.526-1.813-.79-2.259-1.251-.445-.462-.687-1.075-1.17-2.302l-.34-.864z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $c88daa759082a180$export$a3af32a9109d706d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $c88daa759082a180$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9070ed1fb6d25ad0943826ab7bba1e15>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $ee9d893cd2ae686f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z\"/>\n</svg>\n";
function $ee9d893cd2ae686f$export$f7857fe64d7161d9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Compass' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $ee9d893cd2ae686f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4e23709162b5f175d326f7ea087e40e7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $74ed9b37980c3e0b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 162 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.79 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63 0c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-25.9-3.49c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01v-2.7h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97M89.5 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.83c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.69 15.16v4.24h-4.25v-4.24zv-4.24H8.93a.74.74 0 0 0-.74.74v11.25a.74.74 0 0 0 .74.75h11.26a.74.74 0 0 0 .75-.74v-7.76zm0-8.48v4.24h4.26v4.24h4.24V7.42a.74.74 0 0 0-.73-.75h-.01z\"/>\n</svg>\n";
function $74ed9b37980c3e0b$export$a16f50a81d183ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Compass' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $74ed9b37980c3e0b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::829e0f22b9c4efb73ab4df551090a45e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $eaeb817fcc69516d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673\"/>\n</svg>\n";
var $eaeb817fcc69516d$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135\"/>\n</svg>\n";
function $eaeb817fcc69516d$export$68f3db7f6af48bcb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $eaeb817fcc69516d$var$svg,
        customThemeSvg: $eaeb817fcc69516d$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0daf403b816e69883a4b967c46646721>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $4a5e292b420c1b12$var$svg = "<svg height=\"100%\" viewBox=\"0 0 188 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.51-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.24 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.442 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.083.302.388.494l3.135 1.948c.167.11.305.165.444.165.166 0 .277-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.692.22 2.83.768l3.273 1.537c.333.165.693.083.86-.302l1.553-3.403c.167-.384.056-.63-.333-.823M8.761 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.305-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.691 8.29c-.167-.11-.306-.165-.444-.165-.167 0-.278.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.693-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302l-1.554 3.403c-.166.384-.055.63.333.823\"/>\n</svg>\n";
function $4a5e292b420c1b12$export$a88b0b0da9ef63ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $4a5e292b420c1b12$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bce70ee3b947e0126577758400fc4f1>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $8b442e08b1b1f19c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M17.37 14.265c-3.704-1.79-4.785-2.058-6.346-2.058-1.83 0-3.391.761-4.785 2.902l-.229.35c-.187.288-.229.39-.229.514s.063.227.292.37l2.35 1.462c.125.083.23.124.333.124.125 0 .208-.062.333-.247l.375-.577c.582-.885 1.102-1.173 1.768-1.173.583 0 1.27.165 2.122.577l2.455 1.152c.25.124.52.062.645-.226l1.165-2.552c.125-.289.042-.474-.25-.618M6.572 9.757c3.703 1.791 4.785 2.059 6.346 2.059 1.83 0 3.39-.762 4.785-2.902l.229-.35c.187-.288.228-.391.228-.515 0-.123-.062-.226-.29-.37l-2.352-1.462c-.125-.082-.229-.123-.333-.123-.125 0-.208.061-.333.247l-.374.576c-.583.885-1.103 1.173-1.769 1.173-.582 0-1.269-.164-2.122-.576L8.132 6.361c-.25-.123-.52-.061-.645.227L6.322 9.14c-.125.288-.041.473.25.617\"/>\n</svg>\n";
function $8b442e08b1b1f19c$export$53305f1f2855d3be(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $8b442e08b1b1f19c$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b75e0d02e27316bd7bdb7f42b65d9cdd>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $5f5927820ebc1e8e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 188 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.5-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.23 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.2-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.441 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.084.302.389.494l3.134 1.948c.167.11.306.165.444.165.167 0 .278-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.693.22 2.83.768l3.273 1.537c.333.165.694.083.86-.302l1.554-3.403c.166-.384.055-.63-.333-.823M8.762 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.306-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.69 8.29c-.167-.11-.305-.165-.444-.165-.166 0-.277.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.692-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302L8.43 12.187c-.167.384-.056.63.332.823\"/>\n</svg>\n";
function $5f5927820ebc1e8e$export$b3e508cb103e1f93(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $5f5927820ebc1e8e$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25ef791c6b8e2aa654d6c789ba21ad2c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $1b6d46e94d354047$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M18.71 7.463 12 4.993l-6.71 2.47a.44.44 0 0 0-.29.433l.14 3.807c.103 3.148 1.684 5.489 4.163 7.018a.446.446 0 0 0 .646-.204l1.445-3.412a.22.22 0 0 0-.14-.298 2.585 2.585 0 1 1 1.492 0 .22.22 0 0 0-.14.298l1.446 3.412a.446.446 0 0 0 .645.204c2.48-1.529 4.06-3.87 4.163-7.018L19 7.896a.44.44 0 0 0-.29-.433\"/>\n</svg>\n";
function $1b6d46e94d354047$export$eaf73f391f7103bd(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Crowd' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $1b6d46e94d354047$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::982589d5ed3432ac5a8edfba2cd36cef>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $17a4766c3ac7e836$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M113.97 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.72 0h-3.37l-2.64-7.42-1.41-4.72-1.41 4.72-2.64 7.42h-3.37L84.45 10h2.91l4.42 13 4.48-13h2.51l4.48 13 4.41-13h2.91zm-28.47.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.77 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-5.76 5.48v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M24.946 9.951 16 6.657 7.054 9.95a.59.59 0 0 0-.387.577l.187 5.076c.137 4.197 2.245 7.319 5.55 9.357.31.19.719.063.86-.272l1.928-4.55a.294.294 0 0 0-.185-.396 3.447 3.447 0 1 1 1.987 0 .294.294 0 0 0-.185.397l1.927 4.549c.142.335.55.463.86.272 3.305-2.038 5.413-5.16 5.55-9.357l.187-5.076a.59.59 0 0 0-.387-.577\"/>\n</svg>\n";
function $17a4766c3ac7e836$export$3c371bdbcdfcdce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Crowd' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $17a4766c3ac7e836$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1029c08533fbdcff5f0df8497f235af8>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $d20c2d2217ea4edc$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z\"/>\n</svg>\n";
var $d20c2d2217ea4edc$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5\"/>\n</svg>\n";
function $d20c2d2217ea4edc$export$6da5aa77c402ba0f(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Customer Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $d20c2d2217ea4edc$var$svg,
        customThemeSvg: $d20c2d2217ea4edc$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16a7ad488321186b3a9c29a86e47e09f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $b685dd092d0990d8$var$svg = "<svg height=\"100%\" viewBox=\"0 0 456 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M451.86 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.08-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.51-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M234.91 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.24 0h-3.53L217.69 10h2.76l4.97 13.09L230.36 10h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.65 2.45 6.65 6.07m-26.4-3.5v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H146.5c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.15-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M94.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45H94.1zm-6.7.58c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.89 2.79v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M21.91 23.23a9.3 9.3 0 0 1-5.91 2.1H8.53v-.62l5.12-5.04a4.34 4.34 0 0 0 2.35.69c.86 0 1.67-.25 2.35-.69zm1.32-1.32a9.3 9.3 0 0 0 2.1-5.91c0-2.24-.79-4.3-2.11-5.91l-3.56 3.56c.43.68.69 1.48.69 2.35s-.25 1.67-.69 2.35zM21.91 8.77l-3.56 3.56a4.34 4.34 0 0 0-2.35-.69c-.86 0-1.67.25-2.35.69l-3.56-3.56A9.3 9.3 0 0 1 16 6.67c2.24 0 4.3.79 5.91 2.11M8.77 10.09A9.3 9.3 0 0 0 6.67 16c0 2.24.79 4.3 2.11 5.91l3.56-3.56a4.34 4.34 0 0 1-.69-2.35c0-.86.25-1.67.69-2.35z\"/>\n</svg>\n";
function $b685dd092d0990d8$export$f597f0f7fadce0b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Customer Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $b685dd092d0990d8$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d6e69e54d35c5132352d2d869cff6623>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $fada354a983089f0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 48 48\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H12C5.373 48 0 42.627 0 36z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m36.22 26.75 4.9 7.25h-4.78c-.52-.6-1.02-1.31-1.47-1.98-.68-1.02-.68-2.41.03-3.41zm-7.3-5.5L24.02 14h4.78c.52.6 1.02 1.31 1.47 1.98.68 1.02.68 2.41-.02 3.41zm6.98-6.02c.5-.84 1.07-1.16 1.95-1.16l3.9-.07-12.68 19.27a1.46 1.46 0 0 1-1.22.67H23.6c4.07-6.25 8.37-12.37 12.31-18.7M8 33.94h6.89c6.16 0 9.92-3.88 9.92-9.94s-3.76-9.94-9.92-9.94H8l4.28 3.9h-1.76C9.13 17.96 8 19.12 8 20.55v13.38m4.41-3.9V17.96h2.46c3.52 0 5.49 2.38 5.49 6.04 0 3.65-1.97 6.04-5.46 6.04z\"/>\n</svg>\n";
function $fada354a983089f0$export$9951d02c2d848122(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Dx' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $fada354a983089f0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5632c329668d03156b9d75797e5dc114>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $7e275d3a2fa1254a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z\"/>\n</svg>\n";
function $7e275d3a2fa1254a$export$1e02e7298035a77c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Focus' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $7e275d3a2fa1254a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7c78daeae8d28d39afbbd3766abb4915>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $b522db2dfdeabc9a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 117 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.03 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.71 3.58v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M64.6 25.64c-4.6 0-7.3-3.4-7.3-8S60 9.7 64.6 9.7c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.97 5.67h-9.14v7.51h-2.76V5.19h12.94v2.64H45.49v7.36h9.14z\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M27.607 16.272c-2.176-2.176-5.712-2.152-7.865 0l-1.812 1.812c-1 1-2.625 1-3.625 0L12.8 16.578l-3.933 3.934 1.505 1.505a8.126 8.126 0 0 0 11.49 0zm-22.982-.541c2.176 2.175 5.668 2.196 7.844.02l1.834-1.834c1-1 2.625-1 3.625 0l1.505 1.505 3.934-3.933-1.505-1.505a8.126 8.126 0 0 0-11.49 0l-5.745 5.745z\"/>\n</svg>\n";
function $b522db2dfdeabc9a$export$3a6e8b37e069a69d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Focus' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $b522db2dfdeabc9a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7d4207f3a6122eec8b52c0ed3ab03186>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $31451dc35cbaaaa4$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $31451dc35cbaaaa4$export$9eb74917ea768ed4(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Goals' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $31451dc35cbaaaa4$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d5250a44d64b619624a2300ae730252c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $07ee1acfadb2cd88$var$svg = "<svg height=\"100%\" viewBox=\"0 0 116 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M115.55 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.12 4.13c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M58.71 24.2c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.36 16a3.36 3.36 0 1 1-6.72 0 3.36 3.36 0 0 1 6.72 0\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M16 25.375a9.375 9.375 0 1 0 0-18.75 9.375 9.375 0 1 0 0 18.75M21.86 16a5.86 5.86 0 1 1-11.72 0 5.86 5.86 0 0 1 11.72 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $07ee1acfadb2cd88$export$c527a545aa426db3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Goals' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $07ee1acfadb2cd88$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c2c28215ef3af884cc4092d906edf31>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $44cfde75faf0f3fe$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649\"/>\n</svg>\n";
function $44cfde75faf0f3fe$export$3f95fcfdc25a741d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $44cfde75faf0f3fe$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::626a07e2e2912ec06af277d2d5db332f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $142a025e9183bb7e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 120 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M108.4 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.8-9.04v9.05H96.7V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.86 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-27.42-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-3.98 5.21c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M8.188 14.644h15.623c.449 0 .688-.24.688-.688V8.688c0-.449-.24-.688-.688-.688h-3.292c-.45 0-.689.24-.689.688v2.664h-1.496V8.688c0-.449-.24-.688-.688-.688h-3.293c-.448 0-.688.24-.688.688v2.664H12.17V8.688c0-.449-.24-.688-.689-.688H8.188c-.449 0-.688.24-.688.688v5.268c0 .449.24.688.688.688m.27 4.609a10.4 10.4 0 0 1-.599-2.993c-.03-.389.15-.598.569-.598H23.57c.42 0 .599.18.599.538q-.09 1.662-.629 3.053c-.18.479-.448.688-.957.688H9.415c-.508 0-.778-.21-.957-.688m13.856 2.484c-1.436 1.766-3.8 2.903-6.314 2.903s-4.939-1.137-6.345-2.903c-.36-.479-.18-.778.18-.778h12.33c.359 0 .538.3.15.778\"/>\n</svg>\n";
function $142a025e9183bb7e$export$2b896c4d595a4331(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $142a025e9183bb7e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ab0c68a2f803392c4d77e5d4f8659ba>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $3002d8ad792111f7$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.875 10.688v7.437h4.375V13.75h3.5v4.375h4.375v-7.437L12 5z\"/>\n</svg>\n";
function $3002d8ad792111f7$export$92c8767b874048d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Home' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $3002d8ad792111f7$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d61eb22cff5da1c656082efc821f6f1>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $c6a4849ca73911a6$var$svg = "<svg height=\"100%\" viewBox=\"0 0 121 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M113.57 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM93.3 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.33 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M56.41 5.19h2.76v20.15h-2.76v-8.71H45.8v8.71h-2.76V5.19h2.76v8.8h10.61z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M7.25 14.125V24.75h6.25V18.5h5v6.25h6.25V14.125L16 6z\"/>\n</svg>\n";
function $c6a4849ca73911a6$export$8b6b7f1b1b2367d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Home' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $c6a4849ca73911a6$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::62c4afc29c8c7e7934b1ed03e01bed0a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $3fcf5f8a03513dbf$var$svg = "<svg height=\"100%\" viewBox=\"0 0 32 32\">\n    <g clip-path=\"url(#clip0_95164_16219)\">\n        <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n        <g clip-path=\"url(#clip1_95164_16219)\">\n            <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z\" clip-rule=\"evenodd\"/>\n        </g>\n    </g>\n    <defs>\n        <clipPath id=\"clip0_95164_16219\">\n            <path fill=\"var(--icon-color, white)\" d=\"M0 0h32v32H0z\"/>\n        </clipPath>\n        <clipPath id=\"clip1_95164_16219\">\n            <path fill=\"var(--icon-color, white)\" d=\"M2 2h28v28H2z\"/>\n        </clipPath>\n    </defs>\n</svg>\n";
function $3fcf5f8a03513dbf$export$80b8b269d8b5014e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $3fcf5f8a03513dbf$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a77d70c2c04e5e73e648a0ad5112dc40>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $ea661920ace4c24b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 95 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M91.61 17.67c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-24.52-6.64V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65M56.4 5.19h2.76v20.15H56.4v-8.71H45.79v8.71h-2.76V5.19h2.76v8.8H56.4z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $ea661920ace4c24b$export$7a38180641471460(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $ea661920ace4c24b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f17f23e6bd151211e03a04b1664f0b0e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $2bb4669003ccdd0b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z\"/>\n</svg>\n";
var $2bb4669003ccdd0b$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z\"/>\n</svg>\n";
function $2bb4669003ccdd0b$export$c4b5b1f965d8b3eb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $2bb4669003ccdd0b$var$svg,
        customThemeSvg: $2bb4669003ccdd0b$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df776258869a3130361a6ba2c751d097>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $24bd1f69144f0adc$var$svg = "<svg height=\"100%\" viewBox=\"0 0 83 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M11.965 20.698h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.423 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.503 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.7zm4.818-4.82h-1.803c-2.72 0-4.67-1.665-4.67-4.104h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z\"/>\n</svg>\n";
function $24bd1f69144f0adc$export$bf4c5f97b468e8d6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $24bd1f69144f0adc$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::02b69897dd1f526e42aaff5e30bc839d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $0c931319b684f9a0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M8.974 15.523H7.62c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.647v7.317c-1.817 0-3.036-1.472-3.036-3.525zm3.591-3.636h-1.352c-2.04 0-3.503-1.227-3.503-3.056h7.272c.376 0 .642.245.642.625v7.317c-1.817 0-3.059-1.473-3.059-3.525zm3.614-3.614h-1.353c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.624v7.318c-1.817 0-3.036-1.473-3.036-3.525z\"/>\n</svg>\n";
function $0c931319b684f9a0$export$f8455b5667a3ee0c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $0c931319b684f9a0$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b08a11f7ffc5e2a665e1e2e29500a413>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $14b6a500a70d3014$var$svg = "<svg height=\"100%\" viewBox=\"0 0 83 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M11.965 20.699h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.424 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.502 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.699zm4.818-4.819h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z\"/>\n</svg>\n";
function $14b6a500a70d3014$export$3224b07bc93ef23e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $14b6a500a70d3014$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ea9a70f21b9bf06f0562e8a589aebe3a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $0860e3b70877c35f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#c97cf4)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z\"/>\n</svg>\n";
var $0860e3b70877c35f$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228\"/>\n</svg>\n";
function $0860e3b70877c35f$export$21bfbeb62fdcce8d(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Product Discovery' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $0860e3b70877c35f$var$svg,
        customThemeSvg: $0860e3b70877c35f$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d46dae9c30d1c41e6105c8e55da0baf3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e6e51381d67c700a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 327 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M317.88 24.35h-1.72L310.62 10h2.82l4.91 13.13 4.9-13.13h2.82l-5.8 14.84c-1.72 4.39-2.7 6.65-6.59 6.65-1.32 0-2.06-.12-2.82-.43v-2.27c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.82m-13.25-8.05v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.72.6h-3.53L268.87 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.39 10.42v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-13.88-1.42c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.7-15.22c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zM207.68 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-13.41-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-14.99-1.32c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.78 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84h-4.02v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14h-3.71v8.28zm-27.87 1.56c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#c97cf4)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M17.448 6.967c2.544.746 5.113.746 7.656 0 .225-.05.375.1.325.323-.724 2.612-.724 5.025 0 7.637.05.199-.1.373-.325.298a14.3 14.3 0 0 0-7.656 0c-.2.075-.374-.1-.3-.298.674-2.612.674-5.025 0-7.637-.074-.223.1-.373.3-.323m1.023 9.253v.423c0 1.965-1.372 3.408-3.068 3.408a3.04 3.04 0 0 1-3.043-3.06c0-1.691 1.372-3.034 3.292-3.034h.5V8.012c-.25-.025-.5-.025-.749-.025a9.02 9.02 0 0 0-9.028 9.03c0 4.999 4.04 9.004 9.028 9.004s9.053-4.03 9.053-9.005v-.796z\"/>\n</svg>\n";
function $e6e51381d67c700a$export$602140a6a10b02bf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Product Discovery' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $e6e51381d67c700a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e2d37a9192bbf925d9b10d289d7da029>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $31f4d7bc90a6d8c6$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z\"/>\n</svg>\n";
var $31f4d7bc90a6d8c6$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z\"/>\n</svg>\n";
function $31f4d7bc90a6d8c6$export$3c6158790f5e01c4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $31f4d7bc90a6d8c6$var$svg,
        customThemeSvg: $31f4d7bc90a6d8c6$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4540a2dfb459d6f1eaf4284aabf73763>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $c4d33795b15f59b2$var$svg = "<svg height=\"100%\" viewBox=\"0 0 372 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M18.268 13.604h5.951c.894 0 1.199.85.654 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.523-8.959zm-4.6 4.577h-5.95c-.894 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z\"/>\n</svg>\n";
function $c4d33795b15f59b2$export$de148263c75d2bc1(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $c4d33795b15f59b2$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4937c2a7de5c7b37259bbb6dfd98c7b5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $69b17e491a622576$var$svg = "<svg height=\"100%\" viewBox=\"0 0 25 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M14.117 10.203h4.464c.67 0 .899.637.49 1.144l-6.98 8.616c-2.257-1.798-2.044-4.643-.393-6.72zm-3.45 3.433H6.205c-.67 0-.899-.638-.49-1.144l6.981-8.617c2.256 1.799 2.011 4.61.376 6.704z\"/>\n</svg>\n";
function $69b17e491a622576$export$65fae0eaf343f2ca(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $69b17e491a622576$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e1505ad8f23324b28749a17c4fb70aef>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $829a6585d61fbf4e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 372 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.17-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M18.268 13.604h5.95c.895 0 1.2.85.655 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.524-8.959zm-4.6 4.577h-5.95c-.895 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z\"/>\n</svg>\n";
function $829a6585d61fbf4e$export$f64bc7a7f04428d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $829a6585d61fbf4e$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::469fe83de93b711b16f637f8e80db481>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $537177344accafb5$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302\"/>\n</svg>\n";
function $537177344accafb5$export$8d789f76fde3e05(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $537177344accafb5$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::92775a97534ebe8c7c43289d98cf43c7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $2ea3cacca69dfac7$var$svg = "<svg height=\"100%\" viewBox=\"0 0 103 32\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19\"/>\n</svg>\n";
function $2ea3cacca69dfac7$export$78c0b4d8be34c9b2(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $2ea3cacca69dfac7$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a46bf694d751f816eb650ef61277af79>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $739d7ffcbd2d9a95$var$svg = "<svg height=\"100%\" viewBox=\"0 0 100 32\">\n    <path fill=\"var(--icon-color, #101214)\" d=\"M66.71 5.11c0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82 0 .39-.26.62-1.08.62-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.06 0 2.85-.92 2.85-2.26m0 .03c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.5c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16m26.29-2.11v7.32h1.57V4.81l.64 1.46 2.21 4.11h1.95V3.06h-1.54v4.73l-.59-1.39-1.77-3.34zm-9.91 0h-1.7v7.32h1.7zM79.45 8.2c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.47c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16 0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82s-.26.62-1.08.62c-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.03 0 2.85-.92 2.85-2.29M53.5 3.06v7.32h3.49l.54-1.59h-2.34V3.06zm-6.91 0v1.57h1.88v5.75h1.72V4.63h2.03V3.06zm-2.49 0h-2.24l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95c-.03 0-2.57-7.32-2.57-7.32m-1.13 4.75c-.33 0-.64-.05-.93-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m20.06-4.75H60.8l-2.57 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zM61.9 7.81c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m27.32-4.75h-2.23l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zm-1.11 4.75c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19a3.7 3.7 0 0 1-.92.13\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.664-1.775-1.025-2.692 4.664V7.125h-2.048v5.385l-2.694-4.664-1.774 1.025 2.693 4.663-4.664-2.692-1.024 1.774 4.664 2.693H6.958v2.048h5.385L7.68 20.05l1.024 1.775 4.663-2.693-2.692 4.664 1.774 1.024 2.693-4.664v5.386h2.049v-5.385l2.692 4.663 1.774-1.024-2.692-4.664 4.663 2.693 1.025-1.775-4.664-2.692h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.594 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M39.32 27.74v-13.7h2.52v13.7zm24.13-9.31h2.4v1.14c.51-.91 1.7-1.4 2.72-1.4 1.27 0 2.29.55 2.76 1.55.74-1.14 1.72-1.55 2.95-1.55 1.72 0 3.37 1.04 3.37 3.54v6.04h-2.44v-5.53c0-1-.49-1.76-1.65-1.76-1.08 0-1.72.83-1.72 1.84v5.45h-2.49v-5.53c0-1-.51-1.76-1.65-1.76-1.1 0-1.74.81-1.74 1.84v5.45h-2.52zm-15.93 9.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.05 4.93-4.89 4.93m0-7.58a2.65 2.65 0 0 0-2.65 2.65 2.65 2.65 0 0 0 2.65 2.65c1.46 0 2.65-1.19 2.65-2.65a2.65 2.65 0 0 0-2.65-2.65m10.26 7.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.06 4.93-4.89 4.93m0-7.61a2.69 2.69 0 0 0-2.68 2.68 2.69 2.69 0 0 0 2.68 2.68 2.69 2.69 0 0 0 2.68-2.68 2.69 2.69 0 0 0-2.68-2.68\"/>\n</svg>\n";
function $739d7ffcbd2d9a95$export$68d7391318cdef11(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $739d7ffcbd2d9a95$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e02144c4c9c59030582cda1b1253ad33>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $a961f9b6b9b1b9a4$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#625df5)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302\"/>\n</svg>\n";
function $a961f9b6b9b1b9a4$export$38c7b37a3e5e8d70(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $a961f9b6b9b1b9a4$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5be5723422b7854419d856a94f32ac63>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $ee7c4ed318abc97c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 103 32\">\n    <path fill=\"var(--tile-color,#625df5)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19\"/>\n</svg>\n";
function $ee7c4ed318abc97c$export$71743a944cb62e48(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $ee7c4ed318abc97c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::beefaa24a87f689ce1de7425b081e3a3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $c74e6bb6c0272a6c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848\"/>\n</svg>\n";
function $c74e6bb6c0272a6c$export$eeccc49dc7a12d9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Opsgenie' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $c74e6bb6c0272a6c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c628c4e6fb32586c4ae7ee08ce8a67f3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $8acd5c19197c0a46$var$svg = "<svg height=\"100%\" viewBox=\"0 0 164 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M156.69 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM143.39 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-3.68-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.47-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.06 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-4.72 3.52c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-16.29-3.49c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3.01v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-20.11.01c-6.22 0-9.72-4.29-9.72-10.43 0-6.07 3.5-10.33 9.72-10.33 6.2 0 9.69 4.26 9.69 10.34 0 6.13-3.5 10.43-9.69 10.43m0-18.12c-4.97 0-6.96 3.53-6.96 7.7 0 4.26 1.99 7.79 6.96 7.79 4.94 0 6.93-3.53 6.93-7.79 0-4.17-1.99-7.7-6.93-7.7\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.905 25.684c-.638.47-.974.437-1.612-.033-3.088-2.216-5.942-4.734-7.855-7.352-.202-.269-.1-.638.201-.806l3.491-2.182q.454-.302.806.1c1.343 1.545 2.652 3.056 4.163 4.13 1.51-1.074 2.82-2.585 4.163-4.13q.352-.402.805-.1l3.491 2.182c.303.168.403.537.202.806-1.914 2.618-4.767 5.136-7.855 7.385m-.806-9.635c2.753 0 5.035-2.249 5.035-5.001s-2.282-5.07-5.035-5.07-5.036 2.283-5.036 5.07c0 2.786 2.216 5.001 5.036 5.001\"/>\n</svg>\n";
function $8acd5c19197c0a46$export$a5b9122e89b32ad3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Opsgenie' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $8acd5c19197c0a46$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dd8a9cb4b351840981b01e2d2f3f81dc>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $cf63544333fadcc6$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $cf63544333fadcc6$export$5ed3e1bb3b04fc02(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Projects' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $cf63544333fadcc6$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a0db3f343269e63fd1e6e69f81074bb>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $1cf77a2be38ae174$var$svg = "<svg height=\"100%\" viewBox=\"0 0 145 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M144.54 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.75-.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M99.43 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM83.8 31.25v-2.36c.31.03.49.03.77.03 1.13 0 2.05-.49 2.05-1.87V10h2.64v17.36c0 2.82-1.59 4.02-4.11 4.02-.67 0-1.13-.06-1.35-.12m2.3-25.3c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84M76.07 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M62.3 16.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84H45.8v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14H45.8v8.28z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m6.152 19.486 2.651-2.652-2.651-2.651 2.21-2.21h5.303l3.977-3.977h6.187v6.187l-3.977 3.977v5.304l-2.21 2.21-2.652-2.652-2.651 2.651-2.429-2.428 3.978-3.978-1.326-1.325-3.978 3.977zM20.736 13.3a1.562 1.562 0 1 1-2.21-2.21 1.562 1.562 0 0 1 2.21 2.21\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $1cf77a2be38ae174$export$e3d1678155aaab99(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Projects' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $1cf77a2be38ae174$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::381f7987563be8499a0e54ff3032bfd7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $9e635b0ac89314d2$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M11.057 5.257a1.57 1.57 0 0 1 1.539.015l4.621 2.668c.484.279.783.797.783 1.354v5.336a1.56 1.56 0 0 1-.782 1.355l-3.474 2.005a2 2 0 0 0 .12-.691v-5.337c0-.733-.39-1.409-1.026-1.774l-2.59-1.495V6.626q.001-.246.074-.473c.117-.364.366-.68.707-.877z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.881 5.94 6.408 7.945A1.56 1.56 0 0 0 5.625 9.3v5.337c0 .557.3 1.075.783 1.354l4.621 2.668c.475.274 1.06.279 1.539.015l.027-.019a1.57 1.57 0 0 0 .781-1.35v-2.067l-2.589-1.495a2.05 2.05 0 0 1-1.026-1.775V6.631a2 2 0 0 1 .12-.691\"/>\n</svg>\n";
function $9e635b0ac89314d2$export$e23ae35269442b4f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $9e635b0ac89314d2$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f01ddc6d7673bd212094955c82b9af78>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $5d6c574f27abc9c5$var$svg = "<svg height=\"100%\" viewBox=\"0 0 106 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M98.36 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.87 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896q.017-.046.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682.17-.527.529-.983 1.021-1.267h.002z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1\"/>\n</svg>\n";
function $5d6c574f27abc9c5$export$b0e15f0a1c9f4c55(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $5d6c574f27abc9c5$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd407d7bb5fab179d28c0061a631e8e8>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $66e792a2c4bc2438$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M11.26 4.71a1.7 1.7 0 0 1 1.666.017l5.006 2.89c.524.302.848.863.848 1.467v5.78a1.69 1.69 0 0 1-.848 1.467l-3.763 2.172.024-.07c.07-.216.107-.445.107-.679v-5.78c0-.794-.423-1.526-1.112-1.922l-2.805-1.62V6.195q.001-.267.08-.512c.126-.395.396-.737.765-.95l.002-.001z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M9.986 5.45 6.223 7.623a1.69 1.69 0 0 0-.848 1.466v5.78c0 .605.324 1.166.848 1.468l5.006 2.89a1.7 1.7 0 0 0 1.666.016l.03-.02c.37-.214.64-.556.768-.95q.078-.247.079-.513v-2.24l-2.805-1.618a2.22 2.22 0 0 1-1.112-1.922V6.2a2.2 2.2 0 0 1 .13-.75\"/>\n</svg>\n";
function $66e792a2c4bc2438$export$8b784b3227531b3e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $66e792a2c4bc2438$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a68b50724bc9a8775db11ff04136c5ca>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $9246fce972234d01$var$svg = "<svg height=\"100%\" viewBox=\"0 0 165 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M158.79 25.33h-3.53L149.32 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.64-13.24c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM121.91 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.26.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.86 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682a2.26 2.26 0 0 1 1.021-1.267h.002z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1\"/>\n</svg>\n";
function $9246fce972234d01$export$4145bd793c9ed1d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $9246fce972234d01$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::73933e32619ad2ec27398b610bcd63a9>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $e26ed6774aa9392d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M10.7.368a2.75 2.75 0 0 1 2.748 0l8.016 4.626a2.75 2.75 0 0 1 1.375 2.38v9.252c0 .982-.524 1.889-1.375 2.38l-8.016 4.626a2.75 2.75 0 0 1-2.749 0l-8.016-4.626a2.75 2.75 0 0 1-1.374-2.38V7.374c0-.982.524-1.889 1.374-2.38z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.181 6.096 6.777 8.06a1.53 1.53 0 0 0-.768 1.327v5.229c0 .547.294 1.054.768 1.327l.807.466 3.722 2.149a1.54 1.54 0 0 0 1.508.014l.027-.018a1.54 1.54 0 0 0 .766-1.323v-2.026l-1.97-1.137-.568-.327a2 2 0 0 1-1.006-1.74V6.775a2 2 0 0 1 .118-.678\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M12.842 5.441a1.54 1.54 0 0 0-1.508-.014l-.028.019a1.54 1.54 0 0 0-.765 1.323v2.025l1.91 1.102.628.362a2 2 0 0 1 1.006 1.74v5.228a2 2 0 0 1-.118.678l3.404-1.965c.476-.273.767-.778.767-1.327V9.383c0-.546-.293-1.054-.767-1.327l-.868-.501z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $e26ed6774aa9392d$export$813cff80931d9dbf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev Agent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $e26ed6774aa9392d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1097e9235bd2bf7714fe3af3e77f7fcd>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $a2e7880f406c4d20$var$svg = "<svg height=\"100%\" viewBox=\"0 0 160 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M153.94 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zM136.3 12.42c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-25.13-16.9h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.52h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.25.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M45 8.16h-4.05v7.36H45c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M12.52.49a3.67 3.67 0 0 1 3.666 0l10.688 6.17a3.66 3.66 0 0 1 1.833 3.173v12.336a3.66 3.66 0 0 1-1.833 3.173L16.186 31.51a3.67 3.67 0 0 1-3.665 0L1.833 25.341A3.66 3.66 0 0 1 0 22.168V9.832c0-1.309.7-2.519 1.833-3.173z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m11.83 8.128-4.54 2.62a2.04 2.04 0 0 0-1.022 1.77v6.972c0 .728.39 1.405 1.023 1.77l1.076.62 4.963 2.865a2.05 2.05 0 0 0 2.01.02l.037-.025c.445-.257.771-.67.925-1.146q.094-.297.095-.619v-2.7l-2.627-1.516-.757-.436a2.67 2.67 0 0 1-1.34-2.32v-6.97a2.7 2.7 0 0 1 .157-.904\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M15.377 7.255a2.05 2.05 0 0 0-2.01-.019l-.038.026c-.445.257-.77.67-.924 1.145a2 2 0 0 0-.095.618v2.7l2.545 1.47.839.483a2.67 2.67 0 0 1 1.34 2.319v6.972a2.7 2.7 0 0 1-.157.903l4.54-2.62a2.04 2.04 0 0 0 1.022-1.77v-6.971c0-.729-.39-1.405-1.023-1.77l-1.157-.668z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $a2e7880f406c4d20$export$58747af448450872(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev Agent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $a2e7880f406c4d20$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::368a9db7195075ae1012389340d31ec4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $42730eb72cd73255$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--rovo-blue-color, #1868db)\" fill-rule=\"evenodd\" d=\"m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-green-color, #6a9a23)\" fill-rule=\"evenodd\" d=\"m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-purple-color, #af59e1)\" fill-rule=\"evenodd\" d=\"m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-yellow-color, #fca700)\" fill-rule=\"evenodd\" d=\"M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $42730eb72cd73255$export$9e62346a60cfb459(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $42730eb72cd73255$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2febaef4c79ceb55003ced8071cfd766>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $a9ca86753bf40875$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M93.5 25.97c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.3c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M44.99 8.16h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--rovo-blue-color, #1868db)\" fill-rule=\"evenodd\" d=\"m15.892 22.385-9.538 5.559-4.538-2.613A3.63 3.63 0 0 1 0 22.19V9.821C0 8.524.69 7.33 1.816 6.682l8.058-4.649-.052.152a4.7 4.7 0 0 0-.228 1.452v12.37a4.74 4.74 0 0 0 2.38 4.113z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-green-color, #6a9a23)\" fill-rule=\"evenodd\" d=\"m13.318 20.895-9.591 5.538 8.809 5.082a3.64 3.64 0 0 0 3.568.034l.065-.043a3.63 3.63 0 0 0 1.642-2.034c.11-.35.17-.718.17-1.096v-4.792z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-purple-color, #af59e1)\" fill-rule=\"evenodd\" d=\"M26.893 6.67 21.02 3.285l-7.873 6.52 3.587 2.075a4.74 4.74 0 0 1 2.38 4.115v12.369a4.7 4.7 0 0 1-.28 1.603l8.058-4.649a3.62 3.62 0 0 0 1.816-3.139V9.81a3.63 3.63 0 0 0-1.816-3.139\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-yellow-color, #fca700)\" fill-rule=\"evenodd\" d=\"m15.244 11.022-4.519-2.606V3.625c0-.378.059-.747.17-1.096a3.63 3.63 0 0 1 1.64-2.033l.002-.001.064-.044a3.64 3.64 0 0 1 3.569.034l8.665 5z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $a9ca86753bf40875$export$5e38d02efdb45577(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $a9ca86753bf40875$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::75130c29b2f378bebaec50386a50a8f1>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $6582e936710d9d1c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M5 10.688a5.69 5.69 0 0 0 5.697 5.687c1.01 0 1.958-.262 2.78-.723L16.832 19 19 16.834l-3.347-3.341c.471-.828.74-1.785.74-2.806A5.69 5.69 0 0 0 10.697 5 5.69 5.69 0 0 0 5 10.688m2.191 0c0 1.932 1.57 3.5 3.506 3.5a3.503 3.503 0 0 0 3.505-3.5c0-1.933-1.57-3.5-3.505-3.5a3.503 3.503 0 0 0-3.506 3.5\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $6582e936710d9d1c$export$82eafebb825fc23f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $6582e936710d9d1c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e7d097901f1cc1f3bda7d447dd700321>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $ebe28c7d22afffd3$var$svg = "<svg height=\"100%\" viewBox=\"0 0 130 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M128.82 16.35v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.04 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10H88v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M7.127 14.833a7.583 7.583 0 0 0 11.286 6.62l4.464 4.464 2.887-2.888-4.455-4.455a7.583 7.583 0 1 0-14.181-3.74m2.917 0a4.667 4.667 0 1 0 9.333 0 4.667 4.667 0 0 0-9.333 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $ebe28c7d22afffd3$export$fa08cbfe393f2a68(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $ebe28c7d22afffd3$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed55e7b276490b3799d556c893e1267e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $e539d4c6185ff9cb$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6.625a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.76 17.176a5.791 5.791 0 1 1 5.038-2.935l3.403 3.403-2.205 2.204-3.409-3.408a5.77 5.77 0 0 1-2.827.736m-.274-9.37-.242.615c-.344.874-.516 1.312-.833 1.64-.318.33-.749.518-1.61.893l-.37.16v.51l.37.16c.861.376 1.292.563 1.61.893.317.329.49.766.833 1.64l.242.616h.51l.242-.616c.344-.874.516-1.311.834-1.64.317-.33.748-.517 1.61-.893l.368-.16v-.51l-.369-.16c-.861-.375-1.292-.563-1.61-.892-.317-.33-.489-.766-.833-1.64l-.242-.616z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $e539d4c6185ff9cb$export$3599582ddc9fc5cf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $e539d4c6185ff9cb$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::013a7cd7e2e1e4bf4f8e830bbe958755>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $dd880e9d70219e03$var$svg = "<svg height=\"100%\" viewBox=\"0 0 130 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M128.82 16.35v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.05 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M14.346 22.068a7.721 7.721 0 1 1 6.718-3.913l4.537 4.536-2.94 2.94-4.545-4.545a7.7 7.7 0 0 1-3.77.982m-.364-12.494-.323.82c-.459 1.167-.688 1.75-1.112 2.188-.423.44-.997.69-2.146 1.19l-.492.214v.68l.492.213c1.149.5 1.723.75 2.146 1.19.424.439.653 1.022 1.112 2.188l.323.82h.679l.323-.82c.459-1.166.688-1.75 1.111-2.188.424-.44.998-.69 2.147-1.19l.491-.214v-.679l-.491-.214c-1.149-.5-1.723-.75-2.147-1.19-.423-.438-.652-1.021-1.111-2.187l-.323-.82z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $dd880e9d70219e03$export$d669f6cbbb67e061(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $dd880e9d70219e03$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cd83e9aeafaa2f880babb870f3c31a26>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $2b50dcbafbfb2116$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12 9.796c-1.924 0-3.796.832-5.324 2.118q-.238.227-.475.227c-.132 0-.263-.076-.369-.202L3.908 9.771c-.105-.126-.158-.252-.158-.353 0-.151.08-.277.237-.429C6.307 7.023 9.127 5.914 12 5.914s5.693 1.109 8.013 3.075c.158.152.237.278.237.429 0 .1-.053.227-.158.353l-1.924 2.168c-.106.126-.238.202-.37.202q-.236 0-.474-.227c-1.529-1.286-3.4-2.118-5.324-2.118m0 8.118c-2.135 0-3.875-1.664-3.875-3.68 0-2.018 1.74-3.682 3.875-3.682s3.875 1.64 3.875 3.681-1.74 3.68-3.875 3.68\"/>\n</svg>\n";
function $2b50dcbafbfb2116$export$f3f5aa321d88adf9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Statuspage' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $2b50dcbafbfb2116$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e27288819df7a1e20b51bb337bc50dec>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e2e5d79dcb56a140$var$svg = "<svg height=\"100%\" viewBox=\"0 0 192 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M184.96 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-10.55-4.47c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.61-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19H85V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.95-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.26-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M15.896 13.196c-2.464 0-4.86 1.114-6.817 2.835q-.303.304-.607.304c-.169 0-.338-.102-.473-.27l-2.463-2.902c-.135-.17-.202-.338-.202-.473 0-.202.1-.371.303-.573C8.607 9.484 12.217 8 15.896 8c3.678 0 7.29 1.484 10.259 4.117.202.202.303.37.303.573 0 .135-.067.304-.202.473l-2.463 2.902c-.135.168-.304.27-.473.27q-.303 0-.607-.304c-1.958-1.721-4.353-2.835-6.817-2.835m0 10.867c-2.733 0-4.96-2.228-4.96-4.927 0-2.7 2.227-4.927 4.96-4.927s4.96 2.193 4.96 4.927-2.227 4.927-4.96 4.927\"/>\n</svg>\n";
function $e2e5d79dcb56a140$export$2bc88a281410ffa7(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Statuspage' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $e2e5d79dcb56a140$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::557dd965c02920b468bc15d2f1c373a3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $cf38428144987501$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M10.7 11.222V19h7.8v-7.778z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.6 7.609 10.05 5 5.5 7.609v5.217l3.64 2.087V9.667h5.46z\"/>\n</svg>\n";
function $cf38428144987501$export$290a0f24614cde9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $cf38428144987501$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b99049506cac915656bc5da47e2c0efd>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e2f699f0b3d58b1e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 124 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.17 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.125 14.125V24.75H24.75V14.125z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z\"/>\n</svg>\n";
function $e2f699f0b3d58b1e$export$273fd56580e523ae(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $e2f699f0b3d58b1e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::195bd3a19deb671fe29f779e9de58b90>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $b1aa18decf8d6790$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.594 18.563v-7.97h7.969v7.97zm3.808-6.488-.163.429c-.235.615-.352.922-.572 1.155s-.52.368-1.12.638l-.222.1v.357l.222.099c.6.27.9.405 1.12.638s.337.54.572 1.156l.163.428h.347l.163-.429c.235-.615.352-.922.572-1.155s.52-.368 1.12-.638l.221-.1v-.357l-.22-.1c-.601-.269-.901-.404-1.121-.637s-.337-.54-.572-1.155l-.164-.429z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.813 7.195 10.125 4.5 5.438 7.195v5.39l3.75 2.157V9.187h5.625z\"/>\n</svg>\n";
function $b1aa18decf8d6790$export$8bb9894377e04e04(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $b1aa18decf8d6790$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ffb29c88c1e14c5de425429a700acab3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $bf3aca8d575ad488$var$svg = "<svg height=\"100%\" viewBox=\"0 0 124 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M14.125 24.75V14.125H24.75V24.75zm5.078-8.65-.218.571c-.312.82-.469 1.23-.762 1.541s-.694.49-1.494.85l-.295.133v.476l.295.133c.8.36 1.2.54 1.494.85.293.311.45.721.762 1.541l.218.572h.462l.218-.572c.313-.82.469-1.23.762-1.54s.694-.491 1.494-.851l.295-.133v-.476l-.295-.132c-.8-.36-1.2-.54-1.494-.85-.293-.312-.45-.722-.762-1.542l-.218-.571z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z\"/>\n</svg>\n";
function $bf3aca8d575ad488$export$170353c338ac5f4a(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $bf3aca8d575ad488$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c1fd3fd4e53954a78af7441133f6a6a1>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $74e3324b25c5c711$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $74e3324b25c5c711$export$4b05688514531169(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Talent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $74e3324b25c5c711$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d69737e709e7c4233a800f13f41c3e31>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $aeee659e99fc9c80$var$svg = "<svg height=\"100%\" viewBox=\"0 0 122 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M117.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H82.4c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-14.47.57c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m16.577 4.907 3.035 6.763 7.372.797.354 1.09-5.495 4.977 1.52 7.257-.927.672-6.431-3.687-6.433 3.687-.926-.672 1.52-7.257-5.495-4.978.353-1.089 7.372-.797 3.035-6.763zm-.668 11.936a2.476 2.476 0 0 0-2.476 2.477v.904a4.8 4.8 0 0 0 2.369.644h.07a4.8 4.8 0 0 0 2.514-.73v-.818a2.477 2.477 0 0 0-2.477-2.477m0-4.511a1.857 1.857 0 1 0 0 3.714 1.857 1.857 0 0 0 0-3.714\"/>\n</svg>\n";
function $aeee659e99fc9c80$export$1b3979d995ebbc6e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Talent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $aeee659e99fc9c80$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::679db22f20a8bcb2df3bd71c0103c3c9>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $ef8db58e13ec61d6$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63\"/>\n</svg>\n";
function $ef8db58e13ec61d6$export$1bcbc9c337da86da(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Teams' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $ef8db58e13ec61d6$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7c293c2724f1e375a5c30a276e34a2a8>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $f9e69da4298a85cd$var$svg = "<svg height=\"100%\" viewBox=\"0 0 127 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M126.58 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-24.66-4.36v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.33.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM61.99 12.08c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H57.55c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M10.75 14.83a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m10.5 0a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.23 1.75a3.86 3.86 0 0 1 3.86 3.86v3.72h-9.62l2.21-5.23a3.86 3.86 0 0 1 3.55-2.35M6.67 20.67v3.5h6.42l1.75-4.08a3.5 3.5 0 0 0-3.5-3.5h-.58a4.08 4.08 0 0 0-4.08 4.08\"/>\n</svg>\n";
function $f9e69da4298a85cd$export$bfd8d1c4da84ce71(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Teams' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $f9e69da4298a85cd$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da40a1303dd7741d385217c7a3d33831>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $2845c3a0dda90eef$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1558bc)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z\"/>\n</svg>\n";
var $2845c3a0dda90eef$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z\"/>\n</svg>\n";
function $2845c3a0dda90eef$export$4384da9b8b140bf4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Trello' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cd6db93af55ef7e3$export$be58b4326e23250f), {
        svg: $2845c3a0dda90eef$var$svg,
        customThemeSvg: $2845c3a0dda90eef$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ecc5f242ac350bfbaf81aa84a699e7e9>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $7fPBF = parcelRequire("7fPBF");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $ddc776d43aab1190$var$svg = "<svg height=\"100%\" viewBox=\"0 0 113 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M104.97 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M96.21 25.3c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-8 0c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM72.86 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H68.42c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.48-8.44v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#1558bc)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M12.9 24c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H8.13C7.51 8 7 8.49 7 9.1v13.8c0 .61.5 1.1 1.13 1.1zm10.97-6.34c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H19.1c-.62 0-1.13.49-1.13 1.1v7.47c0 .61.5 1.1 1.13 1.1z\"/>\n</svg>\n";
function $ddc776d43aab1190$export$1b13139dfc0336af(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Trello' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $86c6c6571f1aae09$export$f827d3c5a9c3f644), {
        svg: $ddc776d43aab1190$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}



var $7fPBF = parcelRequire("7fPBF");




var $3095db0c6f9e13d4$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $3095db0c6f9e13d4$export$84109e099492cb5f = function AtlassianAdminIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Admin' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $3095db0c6f9e13d4$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $51de8758bdd5f267$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 295 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M294.31 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $51de8758bdd5f267$export$f845d9b9254f0541 = function AtlassianAdminLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Admin' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $51de8758bdd5f267$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $c08b60f1d1bd7b7d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $c08b60f1d1bd7b7d$export$74517ed253186308 = function AtlassianAdministrationIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Administration' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $c08b60f1d1bd7b7d$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $4dba799d2db29a7e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 404 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M403.77 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-23.336 9.292c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.57 0 7.237 3.343 7.237 7.943s-2.667 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.489s1.442 5.55 4.723 5.55c3.251 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49zm-13.488-6.195c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-7.461-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.078v2.453h-4.078zm-18.943-2.913c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.637v15.333zm-17.793-9.046v9.046h-2.576V10h2.576v2.699c.89-1.81 2.423-3.098 5.428-2.914v2.576c-3.373-.337-5.428.675-5.428 3.926m-10.037 4.293c0 1.35.797 2.27 2.423 2.27.613 0 1.196-.123 1.656-.215v2.545c-.46.123-.982.245-1.779.245-3.281 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.079v2.453h-4.079zm-6.696.583c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.675-2.974 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.121 2.086 5.121 4.754M297.497 5.952c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-3.678-8.985v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $4dba799d2db29a7e$export$833abe6c2ce5ebfd = function AtlassianAdministrationLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Administration' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $4dba799d2db29a7e$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");

var $bRUy3 = parcelRequire("bRUy3");

var $7fPBF = parcelRequire("7fPBF");


var $137Lh = parcelRequire("137Lh");
var $5e365994c35e24b2$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $5e365994c35e24b2$var$react18UseId = ($5e365994c35e24b2$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useId) !== null && $5e365994c35e24b2$var$_React$useId !== void 0 ? $5e365994c35e24b2$var$_React$useId : undefined;
function $5e365994c35e24b2$export$f680877a34711e37() {
    if ($5e365994c35e24b2$var$react18UseId && (0, $137Lh.fg)('platform-dst-react-18-use-id')) {
        if ((0, $137Lh.fg)('platform-dst-react-18-use-id-selector-safe')) // tl;dr: React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`
        // in hundreds of tests. So we replace it with a safe string of `_` to match future
        // React 19 functionality: https://github.com/facebook/react/pull/33422
        return $5e365994c35e24b2$var$react18UseId().replace(/[:«»]/g, '_');
        return $5e365994c35e24b2$var$react18UseId();
    }
    return "uid".concat((0, $e9144a1b4dc9c62e$export$87d05f07e65211f1)());
}
var $5e365994c35e24b2$export$6be90bcb437e928f = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($5e365994c35e24b2$export$f680877a34711e37()).concat(postfix);
    (0, $7fPBF.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $5e365994c35e24b2$export$6ee17796e3d70de2() {
    if ($5e365994c35e24b2$var$react18UseId && (0, $137Lh.fg)('platform-dst-react-18-use-id')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- cleanup with feature gating
        var uid = $5e365994c35e24b2$export$f680877a34711e37();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $e9144a1b4dc9c62e$export$bb5ca5fba6fb4f1f)();
}






var $c12d9aedd79d3ec5$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$362a25f017e2bc8a)(appearance, colorMode);
    return "<svg height=\"32\" viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <linearGradient id=\"".concat(id, "-a\" x1=\"12.595\" x2=\"12.595\" y1=\"40\" y2=\"30\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient id=\"").concat(id, "-b\" x1=\"28.595\" x2=\"28.595\" y1=\"40\" y2=\"27\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient xlink:href=\"#").concat(id, "-b\" id=\"").concat(id, "-c\" x1=\"20.595\" x2=\"20.595\" y2=\"22\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-b\" id=\"").concat(id, "-d\" x1=\"36.595\" x2=\"36.595\" y2=\"20\"/>\n  </defs>\n  <path d=\"M10.595 30h4v10h-4z\" fill=\"url(#").concat(id, "-a)\"/>\n  <path d=\"M26.595 27h4v13h-4z\" fill=\"url(#").concat(id, "-b)\"/>\n  <path d=\"M18.595 22h4v18h-4z\" fill=\"url(#").concat(id, "-c)\"/>\n  <path d=\"M34.595 20h4v20h-4z\" fill=\"url(#").concat(id, "-d)\"/>\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m9.009 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z\" />\n</svg>");
};
var $c12d9aedd79d3ec5$export$c42ad8a0b925c762 = function AtlassianAnalyticsIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Analytics' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor, testId = _ref2.testId;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $5e365994c35e24b2$export$f680877a34711e37)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $c12d9aedd79d3ec5$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};


var $7fPBF = parcelRequire("7fPBF");





var $2339c88bd283994c$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        textColor: textColor,
        iconColor: iconColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$362a25f017e2bc8a)(appearance, colorMode);
    return "\n  <svg height=\"32\" viewBox=\"0 0 477 48\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <linearGradient id=\"".concat(id, "-a\" x1=\"447.285\" x2=\"447.285\" y1=\"40\" y2=\"30\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-b\" x1=\"463.285\" x2=\"463.285\" y2=\"27\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-c\" x1=\"455.285\" x2=\"455.285\" y2=\"22\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-d\" x1=\"471.285\" x2=\"471.285\" y2=\"20\"/>\n  </defs>\n  <g fill=\"").concat(colors.atlassianLogoTextColor, "\">\n    <path d=\"M106.72 18.359c0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835m0 0c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445M209.1 10.346v28.455h6.063V17.103l2.556 5.76 8.575 15.938h7.623V10.346h-6.064V28.71l-2.295-5.327-6.886-13.037H209.1zM163.909 10.346h6.626v28.455h-6.626zM156.263 30.399c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445 0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835M55.243 10.346v28.455h13.62l2.145-6.15h-9.095V10.346h-6.67zM28.334 10.346v6.15h7.363v22.305h6.67V16.496h7.882v-6.15H28.334zM18.663 10.346h-8.74L0 38.801h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM92.344 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM194.414 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524Z\"/>\n  </g>\n  <g fill=\"").concat(colors.textColor, "\">\n    <path d=\"m254.776 31.987-2.53 6.809H247.6l11.916-30.225h5.244l11.916 30.225h-4.646l-2.53-6.855c-2.714.552-5.061.828-7.499.828-2.3 0-4.646-.276-7.223-.782Zm13.479-3.496-6.119-16.562-6.119 16.608c2.254.368 4.141.552 5.98.552 1.933 0 3.911-.23 6.257-.598ZM298.984 38.796h-3.957V24.902c0-4.141-1.656-5.981-5.428-5.981-3.681 0-6.211 2.438-6.211 7.085v12.79h-3.957V15.794h3.957v3.772c1.472-2.715 4.187-4.232 7.269-4.232 5.291 0 8.327 3.634 8.327 9.983v13.479ZM320.097 34.656c-1.472 3.036-4.232 4.6-7.775 4.6-6.119 0-9.201-5.199-9.201-11.961 0-6.486 3.22-11.961 9.661-11.961 3.358 0 5.935 1.518 7.314 4.508v-4.048h3.957v23.002h-3.957v-4.14Zm-6.717.92c3.542 0 6.717-2.254 6.717-7.361v-1.84c0-5.106-2.898-7.361-6.256-7.361-4.463 0-6.763 2.944-6.763 8.281 0 5.521 2.208 8.281 6.303 8.281ZM336.196 38.935c-3.772 0-6.165-1.794-6.165-6.027V6.179h3.957v26.269c0 2.07 1.38 2.806 3.083 2.806.414 0 .69 0 1.15-.046v3.542c-.322.092-1.012.184-2.024.184ZM347.328 37.324l-8.327-21.53h4.232l7.361 19.69 7.361-19.69h4.232l-8.695 22.267c-2.576 6.579-4.048 9.983-9.891 9.983-1.979 0-3.083-.184-4.232-.644v-3.404c1.334.414 2.852.552 4.002.552 3.22 0 4.646-2.208 6.533-7.223h-2.576ZM374.698 35.07c.92 0 1.794-.185 2.484-.322v3.818c-.69.184-1.472.368-2.668.368-4.923 0-7.315-2.898-7.315-7.177V19.473h-3.727v-3.68h3.727v-4.877h3.864v4.877h6.119v3.68h-6.119v12.191c0 2.024 1.196 3.405 3.635 3.405ZM384.265 6.961c1.61 0 2.76 1.012 2.76 2.76s-1.15 2.76-2.76 2.76-2.76-1.012-2.76-2.76 1.15-2.76 2.76-2.76Zm-2.024 8.833h3.957v23.002h-3.957V15.794ZM408.416 38.198c-1.38.736-3.496 1.058-5.612 1.058-8.189 0-12.007-4.968-12.007-12.007 0-6.947 3.818-11.915 12.007-11.915 2.07 0 3.68.276 5.475 1.104v3.681c-1.472-.69-3.037-1.104-5.199-1.104-5.98 0-8.419 3.772-8.419 8.235s2.484 8.235 8.511 8.235c2.346 0 3.818-.322 5.244-.828v3.542ZM420.144 39.256c-3.451 0-6.257-.782-8.005-1.702v-4.187c1.978 1.15 5.291 2.254 8.188 2.254 3.037 0 4.601-1.242 4.601-3.036 0-1.749-1.334-2.761-5.705-3.818-5.106-1.242-7.269-3.221-7.269-6.993 0-4.002 3.082-6.44 8.327-6.44 2.99 0 5.705.736 7.407 1.656v4.094c-2.76-1.38-5.014-2.117-7.453-2.117-2.898 0-4.462 1.013-4.462 2.807 0 1.61 1.104 2.622 5.336 3.635 5.106 1.242 7.683 3.128 7.683 7.13 0 3.819-2.484 6.717-8.649 6.717Z\"/>\n  </g>\n  <path fill=\"url(#").concat(id, "-a)\" d=\"M445.285 30h4v10h-4z\"/>\n  <path fill=\"url(#").concat(id, "-b)\" d=\"M461.285 27h4v13h-4z\"/>\n  <path fill=\"url(#").concat(id, "-c)\" d=\"M453.285 22h4v18h-4z\"/>\n  <path fill=\"url(#").concat(id, "-d)\" d=\"M469.285 20h4v20h-4z\"/>\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m443.699 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z\"/>\n</svg>");
};
var $2339c88bd283994c$export$e6470bfc39010cc4 = function AtlassianAnalyticsLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Analytics' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $5e365994c35e24b2$export$f680877a34711e37)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        size: size,
        iconColor: iconColor,
        svg: $2339c88bd283994c$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $72fbb20ba78b51dd$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95\"/>\n    </svg>");
};
var $72fbb20ba78b51dd$export$5fc1066e677788d4 = function BitbucketIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $72fbb20ba78b51dd$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $aa7454de44a5fb3c$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 158 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill=".concat(colors.iconColor, " d=\"m20.46 15.152-1.619 9.885c-.105.598-.527.95-1.125.95H3.996c-.599 0-1.02-.352-1.126-.95L.02 7.412c-.105-.598.211-.985.774-.985h20.123c.563 0 .88.387.774.985l-.774 4.644c-.106.668-.493.95-1.126.95H7.69c-.176 0-.281.105-.246.316l.95 5.84c.035.141.14.247.281.247h4.363c.14 0 .246-.106.281-.247l.668-4.221c.07-.528.423-.739.915-.739h4.75c.703 0 .914.352.809.95\"/>\n        <path fill=").concat(colors.textColor, " d=\"M153.212 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-13.537-8.494c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-23.82.613h-2.638V3.799h2.638v13.585l6.593-7.176h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.176zm-5.648-2.76v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-27.843-3.588v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.982 1.81-2.79 2.821-4.846 2.821-3.526 0-5.55-2.422-5.55-6.654m-5.388-1.319c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.699h-2.637V3.798h2.637v9.17c.982-2.025 2.822-3.067 5.183-3.067 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-14.974-5.06c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zM53.328 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S56.242 8 55.168 8s-1.84-.676-1.84-1.84m.49 19.38V10.207h2.638V25.54zm-9.828-9.046h-6.194v6.287h6.256c2.637 0 3.833-.951 3.833-2.975 0-2.147-1.134-3.312-3.894-3.312m-.889-8.464h-5.305v6.01h5.305c2.607 0 3.68-1.195 3.68-3.127 0-1.963-1.165-2.883-3.68-2.883m-8.065 17.51V5.394h8.433c4.11 0 6.103 2.024 6.103 5.274 0 2.423-1.104 3.926-3.373 4.478 2.974.49 4.446 2.116 4.446 4.968 0 3.22-2.177 5.428-6.685 5.428z\"/>\n      </svg>");
};
var $aa7454de44a5fb3c$export$bd40525f5333524b = function BitbucketLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $aa7454de44a5fb3c$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $a0118ca7eeda4998$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M15.667 15.66v5.942H9.713V15.66zV9.722H4.807c-.58.004-1.047.47-1.043 1.04v15.755a1.04 1.04 0 0 0 1.028 1.054h15.771a1.04 1.04 0 0 0 1.042-1.04V15.66zm0-11.88v5.942h5.967v5.938h5.935V4.82a1.04 1.04 0 0 0-1.028-1.053h-.014z\"/>\n      </svg>\n    ");
};
var $a0118ca7eeda4998$export$f7857fe64d7161d9 = function CompassIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $a0118ca7eeda4998$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $c6ad4536c7c96f69$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 155 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path fill=".concat(colors.iconColor, " d=\"M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z\"/>\n    <path fill=\"").concat(colors.textColor, "\" d=\"M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n  </svg>");
};
var $c6ad4536c7c96f69$export$eb7d748e4f9c9676 = function CompassLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $c6ad4536c7c96f69$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $9b739d594c5ba755$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098\"/>\n    </svg>");
};
var $9b739d594c5ba755$export$68f3db7f6af48bcb = function ConfluenceIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Confluence' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $9b739d594c5ba755$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $9ad33901574c9200$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 180 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M20.602 20.234c-6.584-3.183-8.507-3.66-11.281-3.66-3.255 0-6.03 1.355-8.507 5.16l-.407.622c-.333.513-.407.696-.407.915s.111.403.518.659l4.18 2.598c.221.146.406.22.591.22.222 0 .37-.11.592-.44l.666-1.024c1.035-1.574 1.96-2.086 3.144-2.086 1.035 0 2.256.293 3.772 1.025l4.365 2.049c.444.22.925.11 1.146-.403l2.072-4.537c.222-.512.074-.842-.444-1.098M1.406 12.22c6.583 3.184 8.507 3.66 11.28 3.66 3.256 0 6.03-1.354 8.508-5.16l.407-.622c.332-.512.406-.695.406-.915s-.11-.402-.518-.658L17.31 5.927c-.222-.147-.407-.22-.592-.22-.222 0-.37.11-.592.44l-.665 1.024c-1.036 1.573-1.96 2.086-3.144 2.086-1.036 0-2.257-.293-3.773-1.025L4.18 6.183c-.444-.22-.925-.11-1.147.402L.962 11.123c-.222.512-.074.841.444 1.098\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M172.49 12.293c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-14.503-6.226v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.791-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-22.921-4.262c-2.79 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.441-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.942 7.237-7.942 4.723 0 6.624 3.281 6.624 7.942v1.196h-11.193c.368 2.607 2.054 4.294 5.673 4.294 1.778 0 3.281-.338 4.661-.828zm-29.1-5.734v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.981 1.81-2.791 2.821-4.845 2.821-3.527 0-5.551-2.422-5.551-6.654m-2.231 6.317c-.215.061-.674.122-1.35.122-2.514 0-4.108-1.196-4.108-4.017V3.798h2.637v17.51c0 1.38.92 1.871 2.055 1.871.275 0 .459 0 .766-.03zM88.157 8.582v1.625h3.956v2.454h-3.956v12.88h-2.576V12.66h-2.484v-2.454h2.484V8.521c0-2.852 1.595-4.784 4.876-4.784a6.3 6.3 0 0 1 1.779.245v2.423a8.7 8.7 0 0 0-1.656-.154c-1.626 0-2.423.95-2.423 2.33m-7.327 7.974v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-23.336 9.292c-4.6 0-7.298-3.404-7.298-8.004s2.698-7.942 7.298-7.942c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.493c-3.28 0-4.722 2.576-4.722 5.49s1.441 5.55 4.722 5.55c3.251 0 4.662-2.637 4.662-5.55s-1.41-5.49-4.662-5.49m-9.233 9.629v2.668c-1.257.828-3.25 1.196-5.336 1.196-6.624 0-10.365-3.986-10.365-10.334 0-6.134 3.741-10.427 10.304-10.427 1.963 0 3.925.368 5.367 1.41v2.669c-1.442-.92-3.036-1.411-5.367-1.411-4.723 0-7.544 3.128-7.544 7.759s2.913 7.697 7.697 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n    </svg>\n    ");
};
var $9ad33901574c9200$export$1b2e4fe6ef471556 = function ConfluenceLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Confluence' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $9ad33901574c9200$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $8002a6a9ba672835$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 48 48\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<path fill=\"".concat(colors.iconColor, "\" d=\"M45.4277 24.5018C41.4108 20.4849 34.8821 20.5276 30.908 24.5018L27.5636 27.8462C25.717 29.6927 22.7177 29.6927 20.8712 27.8462L18.0925 25.0675L10.8309 32.3291L13.6096 35.1078C19.4658 40.9641 28.9654 40.9641 34.8216 35.1078L45.4277 24.5018ZM3 23.5018C7.01684 27.5186 13.4637 27.5578 17.4805 23.5409L20.8676 20.1538C22.7142 18.3073 25.7135 18.3073 27.56 20.1538L30.3387 22.9325L37.6003 15.6709L34.8216 12.8922C28.9654 7.03593 19.4658 7.03593 13.6096 12.8922L3.00356 23.4982L3 23.5018Z\"/>\n\t\t</svg>\n\t\t");
};
var $8002a6a9ba672835$export$1e02e7298035a77c = function FocusIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Focus' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $8002a6a9ba672835$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $01930ff09b14dd01$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 168 48\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<path fill=\"".concat(colors.iconColor, "\" d=\"M42.4277 24.5018C38.4108 20.4849 31.8821 20.5276 27.908 24.5018L24.5636 27.8462C22.717 29.6927 19.7177 29.6927 17.8712 27.8462L15.0925 25.0675L7.83088 32.3291L10.6096 35.1078C16.4658 40.9641 25.9654 40.9641 31.8216 35.1078L42.4277 24.5018ZM0 23.5018C4.01684 27.5186 10.4637 27.5578 14.4805 23.5409L17.8676 20.1538C19.7142 18.3073 22.7135 18.3073 24.56 20.1538L27.3387 22.9325L34.6003 15.6709L31.8216 12.8922C25.9654 7.03593 16.4658 7.03593 10.6096 12.8922L0.00355592 23.4982L0 23.5018Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M167.405 31.746C167.405 35.564 164.921 38.462 158.757 38.462C155.307 38.462 152.501 37.68 150.753 36.76V32.574C152.731 33.724 156.043 34.828 158.941 34.828C161.977 34.828 163.541 33.586 163.541 31.792C163.541 30.044 162.207 29.032 157.837 27.974C152.731 26.732 150.569 24.754 150.569 20.982C150.569 16.98 153.651 14.542 158.895 14.542C161.885 14.542 164.599 15.278 166.301 16.198V20.292C163.541 18.912 161.287 18.176 158.849 18.176C155.951 18.176 154.387 19.188 154.387 20.982C154.387 22.592 155.491 23.604 159.723 24.616C164.829 25.858 167.405 27.744 167.405 31.746Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M126.009 28.48V15.002H129.965V28.894C129.965 33.034 131.621 34.874 135.393 34.874C139.073 34.874 141.603 32.436 141.603 27.79V15.002H145.559V38.002H141.603V34.23C140.131 36.944 137.417 38.462 134.335 38.462C129.045 38.462 126.009 34.828 126.009 28.48Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M121.953 33.862V37.404C120.573 38.14 118.457 38.462 116.341 38.462C108.153 38.462 104.335 33.494 104.335 26.456C104.335 19.51 108.153 14.542 116.341 14.542C118.411 14.542 120.021 14.818 121.815 15.646V19.326C120.343 18.636 118.779 18.222 116.617 18.222C110.637 18.222 108.199 21.994 108.199 26.456C108.199 30.918 110.683 34.69 116.709 34.69C119.055 34.69 120.527 34.368 121.953 33.862Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M90.2616 38.462C83.3616 38.462 79.3136 33.356 79.3136 26.456C79.3136 19.556 83.3616 14.542 90.2616 14.542C97.1156 14.542 101.118 19.556 101.118 26.456C101.118 33.356 97.1156 38.462 90.2616 38.462ZM90.2616 18.222C85.3396 18.222 83.1776 22.086 83.1776 26.456C83.1776 30.826 85.3396 34.782 90.2616 34.782C95.1376 34.782 97.2536 30.826 97.2536 26.456C97.2536 22.086 95.1376 18.222 90.2616 18.222Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M75.298 26.732H61.59V38.002H57.45V7.78003H76.862V11.736H61.59V22.776H75.298V26.732Z\"/>\n\t\t</svg>\n\t\t");
};
var $01930ff09b14dd01$export$33908560ea1b226d = function FocusLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Focus' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $01930ff09b14dd01$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $10c744883a107350$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M5.584 14.4h20.83c.599 0 .918-.32.918-.918V6.459c0-.599-.319-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v7.023c0 .599.319.918.917.918zm.36 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.199-.799.758-.799h20.191c.559 0 .798.24.798.719q-.12 2.214-.838 4.07c-.24.638-.598.918-1.277.918H7.221c-.679 0-1.038-.28-1.277-.918m18.475 3.312c-1.915 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.478-.638-.239-1.038.24-1.038h16.44c.48 0 .719.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $10c744883a107350$export$3f95fcfdc25a741d = function GuardIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $10c744883a107350$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $d26e7488354657e1$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 114 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M.918 13.733h20.83c.598 0 .918-.32.918-.918V5.792c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.918.32-.918.918v3.551h-1.995V5.792c0-.599-.319-.918-.918-.918H9.139c-.599 0-.918.32-.918.918v3.551H6.225V5.792c0-.599-.32-.918-.918-.918H.917c-.598 0-.917.32-.917.918v7.023c0 .599.32.918.918.918m.359 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.2-.799.758-.799h20.191c.56 0 .799.24.799.719q-.12 2.214-.838 4.07c-.24.638-.599.918-1.277.918H2.554c-.679 0-1.038-.28-1.277-.918m18.476 3.312c-1.916 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.479-.638-.24-1.038.24-1.038h16.44c.479 0 .718.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M102.398 17.874c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.502 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52zm8.679 7.667v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.466-6.133-7.974 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005V3.798h2.637v21.743zm-17.793-9.047v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925m-17.869 1.381c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.976 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.637v15.333zM56.68 19.193v-8.985h2.637v9.261c0 2.76 1.105 3.987 3.62 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637v15.333h-2.638v-2.514c-.981 1.809-2.79 2.821-4.845 2.821-3.527 0-5.55-2.423-5.55-6.655zm-3.973 5.213c-1.595.951-4.539 1.442-6.808 1.442-6.931 0-10.672-4.232-10.672-10.335 0-6.563 4.262-10.457 11.438-10.457 1.595 0 3.466.184 5.244.797v2.76c-1.533-.613-3.342-.89-5.213-.89-5.98 0-8.71 2.975-8.71 7.729 0 4.661 2.76 7.758 8.557 7.758.95 0 2.269-.092 3.404-.429v-5.612h-5.152v-2.637h7.912z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $d26e7488354657e1$export$a4a891d202775deb = function GuardLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $d26e7488354657e1$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $89badb7e09bd7da5$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n    </svg>");
};
var $89badb7e09bd7da5$export$c4b5b1f965d8b3eb = function JiraIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $89badb7e09bd7da5$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $bfb325ecf6215374$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 77 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404\"/>\n    </svg>");
};
var $bfb325ecf6215374$export$17d3acb0b4379d02 = function JiraLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $bfb325ecf6215374$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $c0174fcd83e30e01$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path\n      fill=\"".concat(colors.iconColor, "\"\n      d=\"M25.52 25.727c0-3.604-2.949-6.517-6.517-6.517h-6.007v-5.497H6.48v10.813c0 .837.364 1.201 1.201 1.201zM6.48 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z\"\n    />\n  </svg>");
};
var $c0174fcd83e30e01$export$407687b2dd89cc68 = function JiraAlignIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Align' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $c0174fcd83e30e01$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $7f0e665c95c08e80$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg viewBox=\"0 0 146 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M19.04 25.727c0-3.604-2.949-6.517-6.517-6.517H6.517v-5.497H0v10.813c0 .837.364 1.201 1.201 1.201zM0 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z\" fill=\"".concat(colors.iconColor, "\"/>\n      <path d=\"M144.993 16.555v8.985h-2.638v-9.26c0-2.76-1.104-3.988-3.618-3.988-2.454 0-4.14 1.626-4.14 4.723v8.525h-2.638V10.207h2.638v2.515c.981-1.81 2.79-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-19.589 7.759V22.78c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.465-6.072-7.973 0-4.324 2.116-7.974 6.379-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.054 5.152-4.906m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.975 0-4.508 1.962-4.508 5.52M107.96 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S110.873 8 109.8 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.638Zm-2.537-.03c-.215.061-.675.122-1.349.122-2.515 0-4.11-1.196-4.11-4.017V3.798h2.638v17.51c0 1.38.92 1.871 2.054 1.871.276 0 .46 0 .767-.03v2.36ZM88.83 21.523c-1.534 0-3.098-.184-4.815-.521l-1.687 4.539h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.57c-1.81.368-3.373.552-4.999.552Zm0-2.453c1.287 0 2.606-.153 4.17-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369Zm-27.807-1.196c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925ZM42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.637Zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404\" fill=\"").concat(colors.textColor, "\"/>\n    </svg>\n  ");
};
var $7f0e665c95c08e80$export$ee11e928d3d045fd = function JiraAlignLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Align' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $7f0e665c95c08e80$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $0220eebb07adb628$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z\"/>\n    </svg>");
};
var $0220eebb07adb628$export$21bfbeb62fdcce8d = function JiraProductDiscoveryIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Product Discovery' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $0220eebb07adb628$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $36b7889fefdc48ff$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 318 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z\" />\n      <path fill=\"").concat(colors.textColor, "\" d=\"M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404\" />\n    </svg>");
};
var $36b7889fefdc48ff$export$c49a2b642fe9eef4 = function JiraProductDiscoveryLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Product Discovery' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $36b7889fefdc48ff$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $8b020727b1a17434$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z\"/>\n    </svg>");
};
var $8b020727b1a17434$export$3c6158790f5e01c4 = function JiraServiceManagementIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Service Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $8b020727b1a17434$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $c8663250dd0ec80d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 362 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z\" />\n      <path fill=").concat(colors.textColor, " d=\"M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404\" />\n    </svg>");
};
var $c8663250dd0ec80d$export$dabef2be6cd28c20 = function JiraServiceManagementLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Service Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $c8663250dd0ec80d$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $a3a19e092ee56f24$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$7818df200941dbbf)(appearance, colorMode);
    return "<svg\n    fill=\"none\"\n    height=\"32\"\n    viewBox=\"0 0 32 32\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    focusable=\"false\"\n    aria-hidden=\"true\"\n  >\n    <path\n      d=\"M27.333 15.508h-6.628l5.74-3.315-1.26-2.184-5.74 3.314 3.313-5.74-2.184-1.26-3.313 5.74V5.434h-2.522v6.628l-3.314-5.74-2.184 1.26 3.314 5.74-5.74-3.314-1.26 2.184 5.74 3.314H4.667v2.521h6.627l-5.74 3.314 1.261 2.184 5.74-3.313-3.314 5.74 2.184 1.26 3.314-5.74V28.1h2.521v-6.627l3.313 5.74 2.184-1.261-3.314-5.74 5.74 3.313 1.261-2.184-5.74-3.313h6.628zM16 20.198a3.442 3.442 0 1 1 0-6.885 3.442 3.442 0 0 1 0 6.884\"\n      fill=\"".concat(colors.iconColor, "\"\n    />\n  </svg>");
};
var $a3a19e092ee56f24$export$8d789f76fde3e05 = function LoomIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $a3a19e092ee56f24$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $e3bd7e3f84bc76d5$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$7818df200941dbbf)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 98 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M29.657 13.659h-8.672l7.51-4.337-1.649-2.857-7.51 4.336 4.335-7.51-2.857-1.65-4.336 7.51V.479H13.18v8.672l-4.337-7.51-2.856 1.65 4.336 7.51-7.51-4.336-1.65 2.857 7.51 4.336H0v3.299h8.671l-7.51 4.336 1.65 2.858 7.51-4.336-4.336 7.51 2.857 1.65 4.336-7.511v8.672h3.3v-8.671l4.335 7.51 2.857-1.65-4.336-7.51 7.51 4.336 1.65-2.858-7.51-4.335h8.672v-3.3zM14.83 19.794a4.503 4.503 0 1 1 0-9.006 4.503 4.503 0 0 1 0 9.006\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M37.303 26.155V4.459h3.983v21.696zm38.204-14.743h3.803v1.798c.808-1.438 2.696-2.218 4.313-2.218 2.007 0 3.624.87 4.373 2.457 1.167-1.798 2.726-2.457 4.673-2.457 2.725 0 5.33 1.648 5.33 5.604v9.559h-3.862v-8.75c0-1.588-.78-2.786-2.607-2.786-1.707 0-2.726 1.318-2.726 2.907v8.63H84.85v-8.75c0-1.59-.808-2.787-2.606-2.787-1.738 0-2.757 1.288-2.757 2.907v8.63h-3.981zm-25.219 15.17c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.251 7.798-7.737 7.798m0-11.996a4.2 4.2 0 0 0-4.197 4.199c0 2.315 1.883 4.199 4.197 4.199s4.196-1.884 4.196-4.2a4.2 4.2 0 0 0-4.196-4.198m16.245 11.996c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.253 7.798-7.737 7.798m0-12.046c-2.34 0-4.245 1.906-4.245 4.247s1.904 4.247 4.245 4.247a4.25 4.25 0 0 0 4.245-4.247 4.25 4.25 0 0 0-4.245-4.247\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $e3bd7e3f84bc76d5$export$94e206806e36c2ec = function LoomLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $e3bd7e3f84bc76d5$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");


var $ea868076f062db5f$export$1bf47cdade1a9fcb = function LoomAttributionIcon(_ref) {
    var appearance = _ref.appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label, _ref$size = _ref.size, size = _ref$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref$size, testId = _ref.testId, _ref$iconColor = _ref.iconColor, iconColor = _ref$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref$iconColor, _ref$textColor = _ref.textColor, textColor = _ref$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a3a19e092ee56f24$export$8d789f76fde3e05), {
        appearance: appearance,
        label: label,
        size: size,
        testId: testId,
        iconColor: iconColor,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $851d611d31971793$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$7818df200941dbbf)(appearance, colorMode);
    return "<svg\n\t\tfill=\"none\"\n\t\theight=\"32\"\n\t\txmlns=\"http://www.w3.org/2000/svg\"\n\t\tfocusable=\"false\"\n\t\taria-hidden=\"true\"\n\t\tviewBox=\"0 0 88 32\"\n\t>\n\t\t<path\n\t\t\td=\"M29.488 12.765h-8.983l7.78-4.344-1.544-2.585-7.78 4.344 4.492-7.523-2.674-1.493-4.491 7.522V0H13.2v8.687L8.71 1.164 6.035 2.657l4.49 7.522-7.778-4.343L1.204 8.42l7.779 4.344H0v2.986h8.982l-7.778 4.343 1.543 2.585 7.78-4.342-4.492 7.522 2.674 1.493L13.2 19.83v8.687h3.087v-8.873l4.574 7.663 2.507-1.4-4.575-7.663 7.946 4.437 1.544-2.586-7.779-4.343h8.982v-2.986h.001Zm-14.744 5.552c-2.318 0-4.197-1.817-4.197-4.059s1.88-4.059 4.197-4.059 4.198 1.817 4.198 4.06c0 2.24-1.88 4.058-4.198 4.058\"\n\t\t\tfill=\"".concat(colors.iconColor, "\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M38.379 26.847V10.094h3.18v16.753zm30.503-11.79h3.036v1.438c.646-1.15 2.153-1.773 3.444-1.773 1.602 0 2.893.695 3.49 1.964.932-1.438 2.177-1.964 3.731-1.964 2.175 0 4.256 1.318 4.256 4.48v7.642h-3.084V19.85c0-1.27-.623-2.228-2.081-2.228-1.363 0-2.177 1.054-2.177 2.324v6.9h-3.155V19.85c0-1.27-.646-2.228-2.081-2.228-1.387 0-2.2 1.03-2.2 2.324v6.9h-3.18V15.057Zm-20.134 12.13c-3.582 0-6.176-2.66-6.176-6.234 0-3.517 2.585-6.242 6.176-6.242 3.609 0 6.177 2.75 6.177 6.242 0 3.547-2.596 6.234-6.177 6.234m0-9.59a3.357 3.357 0 0 0 0 6.713 3.357 3.357 0 0 0 0-6.713m12.966 9.59c-3.583 0-6.177-2.66-6.177-6.234 0-3.517 2.586-6.242 6.177-6.242 3.608 0 6.176 2.75 6.176 6.242 0 3.547-2.597 6.234-6.176 6.234m0-9.63a3.397 3.397 0 0 0-3.39 3.395 3.397 3.397 0 0 0 3.39 3.395 3.396 3.396 0 0 0 0-6.79M64.933 5.63c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473a4.46 4.46 0 0 1-2.197-.63v1.417c.483.263 1.233.473 2.197.473 1.5.052 2.197-.683 2.197-1.785Zm16.662-4.067v5.988h1.3V3.007l.542 1.23 1.841 3.368h1.626V1.563h-1.3v3.85l-.488-1.123-1.463-2.727zm-8.056 0h-1.465v6.042h1.465zm-23.981 0v6.042h2.863l.432-1.295h-1.945V1.563zm-5.671 0v1.295h1.604v4.747h1.44V2.858h1.715V1.563zm-2.177 0h-1.802l-2.066 6.042h1.59l.317-1.025a4 4 0 0 0 1.113.162q.556 0 1.113-.162l.318 1.025h1.59zm-.9 3.938a3 3 0 0 1-.743-.108l.742-2.643.742 2.643c-.265.054-.477.108-.742.108Zm16.577-3.938H55.53L53.4 7.605h1.638l.328-1.025q.573.162 1.146.162.574 0 1.147-.162l.328 1.025h1.638l-2.24-6.042Zm-.928 3.938c-.273 0-.546-.054-.765-.108l.765-2.643.764 2.643a3.3 3.3 0 0 1-.764.108m21.98-3.938h-1.857l-2.13 6.042h1.638l.328-1.025q.574.162 1.147.162c.573 0 .764-.054 1.146-.162l.328 1.025h1.638zm-.93 3.938c-.272 0-.545-.054-.763-.108l.764-2.643.765 2.643a3.3 3.3 0 0 1-.765.108Zm-6.894.129c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473-.75 0-1.608-.263-2.197-.63v1.417c.482.263 1.233.473 2.197.473 1.447.052 2.197-.683 2.197-1.785Z\"\n\t\t\tfill=\"").concat(colors.textColor, "\"\n\t\t/>\n\t</svg>");
};
var $851d611d31971793$export$6e87ce8d41eda665 = function LoomAttributionLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom Attribution' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $851d611d31971793$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $a1db71cc771d6df3$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M17.114 28.127c-.785.578-1.199.537-1.984-.041-3.8-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.992.124c1.652 1.9 3.264 3.76 5.123 5.082 1.86-1.322 3.47-3.181 5.123-5.082q.434-.495.992-.124l4.297 2.686c.372.206.496.66.248.991-2.355 3.223-5.867 6.322-9.668 9.09m-.992-11.858c3.388 0 6.198-2.768 6.198-6.156s-2.81-6.239-6.198-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156\"/>\n    </svg>");
};
var $a1db71cc771d6df3$export$eeccc49dc7a12d9f = function OpsgenieIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Opsgenie' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $a1db71cc771d6df3$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $a647b5a9c71c8c53$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 154 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.78 28.127c-.785.578-1.198.537-1.983-.041-3.801-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.991.124c1.653 1.9 3.264 3.76 5.124 5.082 1.859-1.322 3.47-3.181 5.123-5.082q.435-.495.992-.124l4.297 2.686c.371.206.495.66.247.991-2.355 3.223-5.867 6.322-9.668 9.09m-.99-11.857c3.388 0 6.197-2.768 6.197-6.156s-2.81-6.239-6.197-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M146.689 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zM133.385 6.16c0-1.166.767-1.84 1.841-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84c-1.074 0-1.841-.675-1.841-1.84m.491 19.38V10.208h2.638v15.334zm-3.677-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-18.639-.614v-1.533c-.981 2.024-2.821 3.067-5.182 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.378-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.834 0 5.152-2.055 5.152-4.907m-8.678-6.44c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m-4.703 3.497c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.17-.52-5.336-1.134v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.89-1.84-3.802-2.545-3.404-.829-4.846-2.147-4.846-4.662 0-2.668 2.055-4.293 5.55-4.293 1.994 0 3.804.49 4.938 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.121 2.085 5.121 4.753m-16.274-3.496c0-3.68-1.472-5.52-4.202-5.52-2.36 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.509-1.962 4.509-5.52m-3.803 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.637V10.207h2.637v2.76c.981-2.024 2.821-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.147 7.973-6.44 7.973m-20.121 0c-6.225 0-9.721-4.293-9.721-10.426 0-6.072 3.496-10.335 9.721-10.335 6.195 0 9.69 4.263 9.69 10.335 0 6.133-3.495 10.426-9.69 10.426m0-18.124c-4.968 0-6.961 3.527-6.961 7.698 0 4.262 1.993 7.789 6.961 7.789 4.937 0 6.93-3.527 6.93-7.79 0-4.17-1.993-7.697-6.93-7.697\" />\n    </svg>");
};
var $a647b5a9c71c8c53$export$a1c6484cdecc2c4b = function OpsgenieLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Opsgenie' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $a647b5a9c71c8c53$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $42e930e74f9f8683$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n    <g fill=\"".concat(colors.iconColor, "\" fill-rule=\"evenodd\">\n      <path d=\"M17.06 4.246a2.79 2.79 0 0 0-2.736-.026l-.049.033-.002.001c-.605.35-1.048.91-1.256 1.558-.085.268-.13.552-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566a2.77 2.77 0 0 0 1.392-2.407v-9.487c0-.991-.532-1.912-1.392-2.408z\"/>\n      <path d=\"m6.058 9 6.176-3.566a3.7 3.7 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155l4.604 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.851.47-1.89.461-2.735-.026L6.06 23.301a2.78 2.78 0 0 1-1.392-2.408v-9.486c0-.996.529-1.912 1.391-2.408z\"/>\n    </g>\n  </svg>");
};
var $42e930e74f9f8683$export$e23ae35269442b4f = function RovoIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $42e930e74f9f8683$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $8423a59c6edc0a50$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 100 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path\n        d=\"M12.393 4.246a2.79 2.79 0 0 0-2.735-.026.4.4 0 0 1-.05.033l-.001.001c-.606.35-1.048.91-1.257 1.558q-.129.404-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566A2.77 2.77 0 0 0 22 20.884v-9.487c0-.991-.532-1.912-1.392-2.408z\"\n        fill=\"".concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"m1.391 9 6.176-3.566a3.6 3.6 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155h.001l4.603 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.85.47-1.89.461-2.734-.026l-8.216-4.743A2.78 2.78 0 0 1 0 20.893v-9.486c0-.996.529-1.912 1.391-2.408z\"\n        fill=\"").concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"M91.688 25.848c-4.6 0-7.298-3.404-7.298-8.004S87.088 9.9 91.688 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004zm0-13.494c-3.28 0-4.722 2.576-4.722 5.49 0 2.913 1.441 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.41-5.49-4.662-5.49M77.675 25.54H74.15L68.2 10.208h2.76l4.968 13.094 4.938-13.095h2.76zm-17.462.308c-4.6 0-7.299-3.404-7.299-8.004s2.7-7.943 7.3-7.943c4.568 0 7.236 3.342 7.236 7.942s-2.668 8.004-7.237 8.004zm0-13.494c-3.281 0-4.723 2.576-4.723 5.49 0 2.913 1.442 5.55 4.723 5.55 3.25 0 4.661-2.637 4.661-5.55 0-2.914-1.41-5.49-4.66-5.49zM43.177 8.03H39.13v7.36h4.048c3.588 0 4.692-1.38 4.692-3.68 0-2.177-1.134-3.68-4.692-3.68zm7.452 3.619c0 3.036-1.288 5.09-3.956 5.949l4.938 7.943H48.36l-4.447-7.514H39.13v7.514h-2.76V5.393h7.115c4.815 0 7.145 2.392 7.145 6.256z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $8423a59c6edc0a50$export$a0f6cb8061290bbb = function RovoLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $8423a59c6edc0a50$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $f3a9f3796143f630$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M16 12.604c-3.033 0-5.981 1.37-8.39 3.489q-.375.373-.748.373c-.208 0-.415-.124-.581-.332l-3.032-3.572c-.166-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706 3.655-3.24 8.1-5.067 12.627-5.067s8.97 1.827 12.626 5.067c.249.249.374.457.374.706 0 .166-.084.374-.25.581l-3.032 3.572c-.166.208-.373.332-.581.332q-.374 0-.748-.374c-2.409-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.365 0-6.106-2.742-6.106-6.064S12.635 13.85 16 13.85s6.106 2.7 6.106 6.064-2.741 6.063-6.105 6.063\"/>\n    </svg>");
};
var $f3a9f3796143f630$export$f3f5aa321d88adf9 = function StatuspageIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Statuspage' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $f3a9f3796143f630$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $d6020ef477dc54c9$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 188 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M13 12.604c-3.032 0-5.98 1.37-8.39 3.489q-.373.373-.747.373c-.208 0-.416-.124-.582-.332L.25 12.562c-.167-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706C4.029 8.035 8.473 6.208 13 6.208s8.971 1.827 12.626 5.067c.25.249.374.457.374.706 0 .166-.083.374-.25.581l-3.031 3.572c-.166.208-.374.332-.582.332q-.373 0-.747-.374c-2.41-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.364 0-6.105-2.742-6.105-6.064S9.635 13.85 13 13.85c3.364 0 6.105 2.7 6.105 6.064s-2.74 6.063-6.105 6.063\" />\n      <path fill=\"").concat(colors.textColor, "\" d=\"M180.293 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.981 2.024-2.821 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.982 2.024-2.822 3.066-5.183 3.066-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-16.091-7.666c0-3.68-1.472-5.52-4.201-5.52-2.361 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.508-1.962 4.508-5.52m-3.802 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.638V10.207h2.638v2.76c.981-2.024 2.821-3.066 5.182-3.066 4.079 0 6.134 3.465 6.134 7.973 0 4.324-2.147 7.973-6.44 7.973m-10.56-4.477c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.52-5.336-1.134v-2.79c1.318.766 3.526 1.502 5.458 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.889-1.84-3.803-2.545-3.404-.829-4.845-2.147-4.845-4.662 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-27.598-2.177v-8.985h2.638v9.26c0 2.76 1.104 3.988 3.618 3.988 2.454 0 4.14-1.626 4.14-4.723v-8.525h2.638V25.54h-2.638v-2.515c-.981 1.81-2.79 2.821-4.845 2.821-3.527 0-5.55-2.422-5.55-6.654m-7.155 1.596c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454H85.39zm-18.943-2.914c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-17.258-4.752c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454h-4.078zm-6.894-.798c0 3.496-2.085 5.858-7.084 5.858-3.894 0-5.704-.767-7.268-1.564v-2.822c1.871.982 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975 0-1.778-1.104-2.729-4.937-3.649-4.539-1.104-6.563-2.668-6.563-5.98 0-3.128 2.392-5.459 7.084-5.459 2.914 0 4.784.706 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.846 3.373 4.262 1.074 6.654 2.454 6.654 6.072\" />\n    </svg>");
};
var $d6020ef477dc54c9$export$bb4ae5b41b43be04 = function StatuspageLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Statuspage' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $d6020ef477dc54c9$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $7fPBF = parcelRequire("7fPBF");




var $1766ce248ff1f309$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " clip-rule=\"evenodd\" d=\"M24.286 5.337H7.714a2.585 2.585 0 0 0-2.585 2.585v16.572a2.585 2.585 0 0 0 2.585 2.584h16.572a2.585 2.585 0 0 0 2.585-2.584V7.922a2.585 2.585 0 0 0-2.585-2.585m-9.791 15.66a.86.86 0 0 1-.859.858h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86zm8.362-4.953a.86.86 0 0 1-.859.859h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86z\" fill-rule=\"evenodd\"/>\n    </svg>");
};
var $1766ce248ff1f309$export$4384da9b8b140bf4 = function TrelloIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Trello' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $1766ce248ff1f309$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $7fPBF = parcelRequire("7fPBF");




var $8520bd5de24d7beb$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2871e4832ca4bd2f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 106 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" clip-rule=\"evenodd\" d=\"M19.157 4.67H2.585A2.585 2.585 0 0 0 0 7.255v16.572a2.585 2.585 0 0 0 2.585 2.585h16.572a2.585 2.585 0 0 0 2.584-2.585V7.255a2.585 2.585 0 0 0-2.584-2.585M9.365 20.33a.86.86 0 0 1-.858.858H4.873a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86zm8.362-4.952a.86.86 0 0 1-.858.858h-3.634a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86z\" fill-rule=\"evenodd\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M97.64 25.848c-4.6 0-7.298-3.404-7.298-8.004S93.04 9.9 97.64 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.494c-3.281 0-4.722 2.576-4.722 5.49 0 2.913 1.44 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.411-5.49-4.662-5.49M88.874 25.51c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zm-7.996 0c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zM65.532 12.293c-2.79 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.44-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196H61.085c.368 2.606 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zm-19.48-8.434v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M32.943 5.393H48.03V8.03h-6.164v17.511h-2.76V8.031h-6.164z\"/>\n    </svg>");
};
var $8520bd5de24d7beb$export$60e26212f3b61a28 = function TrelloLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Trello' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8eafb83749b35973$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $bba42a6beceff967$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $458ceb8f9bc6ff8c$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $8520bd5de24d7beb$var$svg({
            appearance: appearance,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};










var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $137Lh = parcelRequire("137Lh");
var $e2efc7f4b69fbe2b$var$_excluded = [
    "size",
    "shouldUseNewLogoDesign"
], $e2efc7f4b69fbe2b$var$_excluded2 = [
    "size",
    "shouldUseNewLogoDesign"
], $e2efc7f4b69fbe2b$var$_excluded3 = [
    "shouldUseHexLogo"
], $e2efc7f4b69fbe2b$var$_excluded4 = [
    "size"
];
var $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb = function createFeatureFlaggedComponent(LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref) {
        var size = _ref.size, shouldUseNewLogoDesign = _ref.shouldUseNewLogoDesign, props = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $e2efc7f4b69fbe2b$var$_excluded);
        if ((0, $137Lh.fg)('platform-logo-rebrand') || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
            size: size || 'medium'
        }, props));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(LegacyComponent, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
            size: size
        }, props));
    };
};
var $e2efc7f4b69fbe2b$export$436fcf6e31fbacea = function createFeatureFlaggedServiceCollectionComponent(LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref2) {
        var size = _ref2.size, shouldUseNewLogoDesign = _ref2.shouldUseNewLogoDesign, props = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref2, $e2efc7f4b69fbe2b$var$_excluded2);
        if ((0, $137Lh.fg)('platform-logo-rebrand-servco') || (0, $137Lh.fg)('platform-logo-rebrand') || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
            size: size || 'medium'
        }, props));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(LegacyComponent, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
            size: size
        }, props));
    };
};
var $e2efc7f4b69fbe2b$export$2469203854060337 = function createFeatureFlaggedRovoComponent(LegacyComponent, NewComponent, NewHexComponent) {
    var RovoHexWrapped = $e2efc7f4b69fbe2b$export$667425256e2e7296(NewHexComponent);
    var RovoServiceCollectionWrapped = $e2efc7f4b69fbe2b$export$436fcf6e31fbacea(LegacyComponent, NewComponent);
    return function(_ref3) {
        var shouldUseHexLogo = _ref3.shouldUseHexLogo, props = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref3, $e2efc7f4b69fbe2b$var$_excluded3);
        // Return hex logo if feature flag enabled. Otherwise revert to old set of components
        if ((0, $137Lh.fg)('platform-logo-rebrand-rovo-hex') || shouldUseHexLogo) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(RovoHexWrapped, props);
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(RovoServiceCollectionWrapped, props);
    };
};
var $e2efc7f4b69fbe2b$export$667425256e2e7296 = function tempSizeWrapper(NewComponent) {
    return function(_ref4) {
        var size = _ref4.size, props = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref4, $e2efc7f4b69fbe2b$var$_excluded4);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
            size: size || 'medium'
        }, props));
    };
};
var $e2efc7f4b69fbe2b$export$3fe521abfbbe6ab3 = function teamEUFlaggedIcon(LegacyComponent, NewComponent) {
    return function(props) {
        var Logo = (0, $137Lh.fg)('platform-logo-rebrand-team-eu') ? $e2efc7f4b69fbe2b$export$667425256e2e7296(NewComponent) : $e2efc7f4b69fbe2b$export$667425256e2e7296(LegacyComponent);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Logo, props);
    };
};
var $e2efc7f4b69fbe2b$export$172fd793eb6ecac4 = [
    // Program logos
    {
        name: 'atlassian',
        type: 'legacy',
        category: 'program'
    },
    {
        name: 'atlassian-access',
        type: 'legacy',
        category: 'program'
    },
    {
        name: 'atlassian-marketplace',
        type: 'legacy',
        category: 'program'
    },
    // Home collection
    {
        name: 'home',
        type: 'new',
        category: 'app'
    },
    {
        name: 'hub',
        type: 'new',
        category: 'app'
    },
    // Teamwork collection
    {
        name: 'confluence',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'jira',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'loom',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'loom-blurple',
        type: 'new',
        category: 'app',
        skipExample: true
    },
    {
        name: 'loom-attribution',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'rovo',
        type: 'rovo-hex',
        category: 'app'
    },
    // Strategy collection
    {
        name: 'align',
        type: 'new',
        category: 'app'
    },
    {
        name: 'focus',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'talent',
        type: 'new',
        category: 'app'
    },
    // App collection
    {
        name: 'jira-product-discovery',
        type: 'migration',
        category: 'app'
    },
    // Dev collection
    {
        name: 'bitbucket',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'compass',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'dx',
        type: 'new',
        category: 'app',
        skipLogo: true
    },
    {
        name: 'rovo-dev',
        type: 'new',
        category: 'app'
    },
    {
        name: 'rovo-dev-agent',
        type: 'new',
        category: 'agent'
    },
    // Customer collection
    {
        name: 'jira-service-management',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'assets',
        type: 'new',
        category: 'app'
    },
    {
        name: 'customer-service-management',
        type: 'new',
        category: 'app'
    },
    {
        name: 'opsgenie',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'statuspage',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'trello',
        type: 'migration',
        category: 'app'
    },
    // Platform Collection
    {
        name: 'admin',
        type: 'new',
        category: 'app'
    },
    {
        name: 'analytics',
        type: 'new',
        category: 'app'
    },
    {
        name: 'chat',
        type: 'new',
        category: 'app'
    },
    {
        name: 'goals',
        type: 'new',
        category: 'app'
    },
    {
        name: 'guard',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'projects',
        type: 'new',
        category: 'app'
    },
    {
        name: 'search',
        type: 'new',
        category: 'app'
    },
    {
        name: 'studio',
        type: 'new',
        category: 'app'
    },
    {
        name: 'teams',
        type: 'new',
        category: 'app'
    },
    // Data Center
    {
        name: 'jira-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'jira-service-management-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'confluence-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'bitbucket-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'bamboo',
        type: 'new',
        category: 'app'
    },
    {
        name: 'crowd',
        type: 'new',
        category: 'app'
    },
    // Deprecated
    {
        name: 'atlassian-administration',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlassian-admin',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlassian-analytics',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlas',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-align',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-software',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-work-management',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    }
];
var $e2efc7f4b69fbe2b$export$62e1212796a86b1b = $e2efc7f4b69fbe2b$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'program' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
});
var $e2efc7f4b69fbe2b$export$e0dee4a765830f4d = $e2efc7f4b69fbe2b$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'app' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
});
var $e2efc7f4b69fbe2b$export$a13ce90e90d7bfc1 = $e2efc7f4b69fbe2b$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'agent' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
}) || [];
var $e2efc7f4b69fbe2b$export$516fce44c502c1d3 = $e2efc7f4b69fbe2b$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'legacy';
});
var $e2efc7f4b69fbe2b$export$b805fae8e798ed39 = $e2efc7f4b69fbe2b$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'migration';
});
var $e2efc7f4b69fbe2b$export$3f9abd26214cd85f = $e2efc7f4b69fbe2b$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'new';
});


var $541f1648413af912$export$ef8e5f836dd989d3 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $d9defcc45ed17055$export$ef8e5f836dd989d3));
var $541f1648413af912$export$ebcd30672e67406 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $b7eaa396af4bb025$export$61afcb38c001e19));
var $541f1648413af912$export$af3460f51ce3602a = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $b393203e1c7594b2$export$af3460f51ce3602a));
var $541f1648413af912$export$c8415b6abe4a8587 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $972fc5e8668bd5f4$export$f0bac2b7ac3e3504));
var $541f1648413af912$export$d89497e7f33ca6f5 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $64f3eb4d21a447bc$export$d89497e7f33ca6f5));
var $541f1648413af912$export$48ca930f3071e3e4 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $5913d823a24d0cba$export$81c47abe19675c4c));
var $541f1648413af912$export$52cd484a7ef4f2b9 = (0, $e2efc7f4b69fbe2b$export$3fe521abfbbe6ab3)((0, $dd87b83dddb54df5$export$52cd484a7ef4f2b9), (0, $5caa168089207a9d$export$402a257da320c93c));
var $541f1648413af912$export$9ca9881809919df8 = (0, $e2efc7f4b69fbe2b$export$3fe521abfbbe6ab3)((0, $9ab3de5044174c8a$export$a529e78951cd6709), (0, $c88daa759082a180$export$a3af32a9109d706d));
var $541f1648413af912$export$6da5aa77c402ba0f = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $d20c2d2217ea4edc$export$6da5aa77c402ba0f));
var $541f1648413af912$export$abc95e6180bb1d88 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $b685dd092d0990d8$export$f597f0f7fadce0b9));
var $541f1648413af912$export$9eb74917ea768ed4 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $31451dc35cbaaaa4$export$9eb74917ea768ed4));
var $541f1648413af912$export$d2577aa28451395f = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $07ee1acfadb2cd88$export$c527a545aa426db3));
var $541f1648413af912$export$92c8767b874048d = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $3002d8ad792111f7$export$92c8767b874048d));
var $541f1648413af912$export$d5648119d5b68e90 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $c6a4849ca73911a6$export$8b6b7f1b1b2367d3));
var $541f1648413af912$export$80b8b269d8b5014e = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $3fcf5f8a03513dbf$export$80b8b269d8b5014e));
var $541f1648413af912$export$fc9bd6687b80fe3b = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $ea661920ace4c24b$export$7a38180641471460));
var $541f1648413af912$export$5ed3e1bb3b04fc02 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $cf63544333fadcc6$export$5ed3e1bb3b04fc02));
var $541f1648413af912$export$aeefab651bcf2338 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $1cf77a2be38ae174$export$e3d1678155aaab99));
var $541f1648413af912$export$8b784b3227531b3e = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $66e792a2c4bc2438$export$8b784b3227531b3e));
var $541f1648413af912$export$f0750468d67c6902 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $9246fce972234d01$export$4145bd793c9ed1d0));
var $541f1648413af912$export$813cff80931d9dbf = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $e26ed6774aa9392d$export$813cff80931d9dbf));
var $541f1648413af912$export$409b7a5b7f180eba = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $a2e7880f406c4d20$export$58747af448450872));
var $541f1648413af912$export$82eafebb825fc23f = (0, $e2efc7f4b69fbe2b$export$3fe521abfbbe6ab3)((0, $6582e936710d9d1c$export$82eafebb825fc23f), (0, $e539d4c6185ff9cb$export$3599582ddc9fc5cf));
var $541f1648413af912$export$e4c5487c9a8ae3b1 = (0, $e2efc7f4b69fbe2b$export$3fe521abfbbe6ab3)((0, $ebe28c7d22afffd3$export$fa08cbfe393f2a68), (0, $dd880e9d70219e03$export$d669f6cbbb67e061));
var $541f1648413af912$export$290a0f24614cde9f = (0, $e2efc7f4b69fbe2b$export$3fe521abfbbe6ab3)((0, $cf38428144987501$export$290a0f24614cde9f), (0, $b1aa18decf8d6790$export$8bb9894377e04e04));
var $541f1648413af912$export$8aceb78c659789b6 = (0, $e2efc7f4b69fbe2b$export$3fe521abfbbe6ab3)((0, $e2f699f0b3d58b1e$export$273fd56580e523ae), (0, $bf3aca8d575ad488$export$170353c338ac5f4a));
var $541f1648413af912$export$4b05688514531169 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $74e3324b25c5c711$export$4b05688514531169));
var $541f1648413af912$export$4f6453e012279f89 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $aeee659e99fc9c80$export$1b3979d995ebbc6e));
var $541f1648413af912$export$1bcbc9c337da86da = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $ef8db58e13ec61d6$export$1bcbc9c337da86da));
var $541f1648413af912$export$9b1a0a0c574cec2a = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $f9e69da4298a85cd$export$bfd8d1c4da84ce71));
var $541f1648413af912$export$e812398311cab9a3 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $1401f80fbd87af06$export$e812398311cab9a3));
var $541f1648413af912$export$765f5afcc1a5a7e3 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $10b8bb0abf413d2f$export$7c51958462d750e));
var $541f1648413af912$export$d3ab16bbf4f954ee = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $0d0a7c8ab027634f$export$d3ab16bbf4f954ee));
var $541f1648413af912$export$36044946916e84a0 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $bae800d655fb5d3b$export$cc55e2a4c4b40552));
var $541f1648413af912$export$53305f1f2855d3be = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $8b442e08b1b1f19c$export$53305f1f2855d3be));
var $541f1648413af912$export$5e06396bce773a3 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $5f5927820ebc1e8e$export$b3e508cb103e1f93));
var $541f1648413af912$export$eaf73f391f7103bd = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $1b6d46e94d354047$export$eaf73f391f7103bd));
var $541f1648413af912$export$6128b385660fd3c6 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $17a4766c3ac7e836$export$3c371bdbcdfcdce));
var $541f1648413af912$export$f8455b5667a3ee0c = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $0c931319b684f9a0$export$f8455b5667a3ee0c));
var $541f1648413af912$export$eb152ab3801b2ae3 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $14b6a500a70d3014$export$3224b07bc93ef23e));
var $541f1648413af912$export$65fae0eaf343f2ca = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $69b17e491a622576$export$65fae0eaf343f2ca));
var $541f1648413af912$export$fffc0d480fb1ebf1 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $829a6585d61fbf4e$export$f64bc7a7f04428d0));
var $541f1648413af912$export$74517ed253186308 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $c08b60f1d1bd7b7d$export$74517ed253186308), (0, $d9defcc45ed17055$export$ef8e5f836dd989d3));
var $541f1648413af912$export$833abe6c2ce5ebfd = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $4dba799d2db29a7e$export$833abe6c2ce5ebfd), (0, $b7eaa396af4bb025$export$61afcb38c001e19));
var $541f1648413af912$export$84109e099492cb5f = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $3095db0c6f9e13d4$export$84109e099492cb5f), (0, $d9defcc45ed17055$export$ef8e5f836dd989d3));
var $541f1648413af912$export$f845d9b9254f0541 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $51de8758bdd5f267$export$f845d9b9254f0541), (0, $b7eaa396af4bb025$export$61afcb38c001e19));
var $541f1648413af912$export$c42ad8a0b925c762 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $c12d9aedd79d3ec5$export$c42ad8a0b925c762), (0, $b393203e1c7594b2$export$af3460f51ce3602a));
var $541f1648413af912$export$e6470bfc39010cc4 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $2339c88bd283994c$export$e6470bfc39010cc4), (0, $972fc5e8668bd5f4$export$f0bac2b7ac3e3504));
var $541f1648413af912$export$5fc1066e677788d4 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $72fbb20ba78b51dd$export$5fc1066e677788d4), (0, $ee7c37f7a95674cb$export$5fc1066e677788d4));
var $541f1648413af912$export$bd40525f5333524b = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $aa7454de44a5fb3c$export$bd40525f5333524b), (0, $91c2d5905dabc876$export$f7ef5e5488e4b430));
var $541f1648413af912$export$f7857fe64d7161d9 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $a0118ca7eeda4998$export$f7857fe64d7161d9), (0, $ee9d893cd2ae686f$export$f7857fe64d7161d9));
var $541f1648413af912$export$eb7d748e4f9c9676 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $c6ad4536c7c96f69$export$eb7d748e4f9c9676), (0, $74ed9b37980c3e0b$export$a16f50a81d183ce));
var $541f1648413af912$export$9951d02c2d848122 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $fada354a983089f0$export$9951d02c2d848122));
var $541f1648413af912$export$68f3db7f6af48bcb = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $9b739d594c5ba755$export$68f3db7f6af48bcb), (0, $eaeb817fcc69516d$export$68f3db7f6af48bcb));
var $541f1648413af912$export$1b2e4fe6ef471556 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $9ad33901574c9200$export$1b2e4fe6ef471556), (0, $4a5e292b420c1b12$export$a88b0b0da9ef63ce));
var $541f1648413af912$export$70a0c2f5862937b6 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $27343cad4462b865$export$70a0c2f5862937b6));
var $541f1648413af912$export$1b8596b4b0ef673b = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $0eefe72489d48a5b$export$8b5103382c06639c));
var $541f1648413af912$export$407687b2dd89cc68 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $c0174fcd83e30e01$export$407687b2dd89cc68), (0, $27343cad4462b865$export$70a0c2f5862937b6));
var $541f1648413af912$export$ee11e928d3d045fd = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $7f0e665c95c08e80$export$ee11e928d3d045fd), (0, $0eefe72489d48a5b$export$8b5103382c06639c));
var $541f1648413af912$export$c4b5b1f965d8b3eb = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $89badb7e09bd7da5$export$c4b5b1f965d8b3eb), (0, $2bb4669003ccdd0b$export$c4b5b1f965d8b3eb));
var $541f1648413af912$export$17d3acb0b4379d02 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $bfb325ecf6215374$export$17d3acb0b4379d02), (0, $24bd1f69144f0adc$export$bf4c5f97b468e8d6));
var $541f1648413af912$export$21bfbeb62fdcce8d = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $0220eebb07adb628$export$21bfbeb62fdcce8d), (0, $0860e3b70877c35f$export$21bfbeb62fdcce8d));
var $541f1648413af912$export$c49a2b642fe9eef4 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $36b7889fefdc48ff$export$c49a2b642fe9eef4), (0, $e6e51381d67c700a$export$602140a6a10b02bf));
var $541f1648413af912$export$3c6158790f5e01c4 = (0, $e2efc7f4b69fbe2b$export$436fcf6e31fbacea)((0, $8b020727b1a17434$export$3c6158790f5e01c4), (0, $31f4d7bc90a6d8c6$export$3c6158790f5e01c4));
var $541f1648413af912$export$dabef2be6cd28c20 = (0, $e2efc7f4b69fbe2b$export$436fcf6e31fbacea)((0, $c8663250dd0ec80d$export$dabef2be6cd28c20), (0, $c4d33795b15f59b2$export$de148263c75d2bc1));
var $541f1648413af912$export$8d789f76fde3e05 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $a3a19e092ee56f24$export$8d789f76fde3e05), (0, $537177344accafb5$export$8d789f76fde3e05));
var $541f1648413af912$export$94e206806e36c2ec = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $e3bd7e3f84bc76d5$export$94e206806e36c2ec), (0, $2ea3cacca69dfac7$export$78c0b4d8be34c9b2));
var $541f1648413af912$export$1bf47cdade1a9fcb = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $ea868076f062db5f$export$1bf47cdade1a9fcb), (0, $537177344accafb5$export$8d789f76fde3e05));
var $541f1648413af912$export$6e87ce8d41eda665 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $851d611d31971793$export$6e87ce8d41eda665), (0, $739d7ffcbd2d9a95$export$68d7391318cdef11));
var $541f1648413af912$export$e84e925618e0e5bc = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $ee7c4ed318abc97c$export$71743a944cb62e48));
var $541f1648413af912$export$1940ba72c868b663 = (0, $e2efc7f4b69fbe2b$export$667425256e2e7296)((0, $a961f9b6b9b1b9a4$export$38c7b37a3e5e8d70));
var $541f1648413af912$export$eeccc49dc7a12d9f = (0, $e2efc7f4b69fbe2b$export$436fcf6e31fbacea)((0, $a1db71cc771d6df3$export$eeccc49dc7a12d9f), (0, $c74e6bb6c0272a6c$export$eeccc49dc7a12d9f));
var $541f1648413af912$export$a1c6484cdecc2c4b = (0, $e2efc7f4b69fbe2b$export$436fcf6e31fbacea)((0, $a647b5a9c71c8c53$export$a1c6484cdecc2c4b), (0, $8acd5c19197c0a46$export$a5b9122e89b32ad3));
var $541f1648413af912$export$f3f5aa321d88adf9 = (0, $e2efc7f4b69fbe2b$export$436fcf6e31fbacea)((0, $f3a9f3796143f630$export$f3f5aa321d88adf9), (0, $2b50dcbafbfb2116$export$f3f5aa321d88adf9));
var $541f1648413af912$export$bb4ae5b41b43be04 = (0, $e2efc7f4b69fbe2b$export$436fcf6e31fbacea)((0, $d6020ef477dc54c9$export$bb4ae5b41b43be04), (0, $e2e5d79dcb56a140$export$2bc88a281410ffa7));
var $541f1648413af912$export$4384da9b8b140bf4 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $1766ce248ff1f309$export$4384da9b8b140bf4), (0, $2845c3a0dda90eef$export$4384da9b8b140bf4));
var $541f1648413af912$export$60e26212f3b61a28 = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $8520bd5de24d7beb$export$60e26212f3b61a28), (0, $ddc776d43aab1190$export$1b13139dfc0336af));
var $541f1648413af912$export$e23ae35269442b4f = (0, $e2efc7f4b69fbe2b$export$2469203854060337)((0, $42e930e74f9f8683$export$e23ae35269442b4f), (0, $9e635b0ac89314d2$export$e23ae35269442b4f), (0, $42730eb72cd73255$export$9e62346a60cfb459));
var $541f1648413af912$export$a0f6cb8061290bbb = (0, $e2efc7f4b69fbe2b$export$2469203854060337)((0, $8423a59c6edc0a50$export$a0f6cb8061290bbb), (0, $5d6c574f27abc9c5$export$b0e15f0a1c9f4c55), (0, $a9ca86753bf40875$export$5e38d02efdb45577));
var $541f1648413af912$export$3f95fcfdc25a741d = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $10c744883a107350$export$3f95fcfdc25a741d), (0, $44cfde75faf0f3fe$export$3f95fcfdc25a741d));
var $541f1648413af912$export$a4a891d202775deb = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $d26e7488354657e1$export$a4a891d202775deb), (0, $142a025e9183bb7e$export$2b896c4d595a4331));
var $541f1648413af912$export$1e02e7298035a77c = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $8002a6a9ba672835$export$1e02e7298035a77c), (0, $7e275d3a2fa1254a$export$1e02e7298035a77c));
var $541f1648413af912$export$33908560ea1b226d = (0, $e2efc7f4b69fbe2b$export$e30d2ddc605f6bb)((0, $01930ff09b14dd01$export$33908560ea1b226d), (0, $b522db2dfdeabc9a$export$3a6e8b37e069a69d));


/* icons.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


parcelRequire("7fPBF");

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

parcelRequire("7fPBF");
const $e2f8cedcfded7cdc$var$SvgGeneralMarketingOptIn = (props)=>/*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("svg", (0, $2qxEV._)((0, $9tqwB._)({
        id: "aG",
        xmlns: "http://www.w3.org/2000/svg",
        x: 0,
        y: 0,
        viewBox: "0 0 172.9 128.6",
        style: {
            enableBackground: "new 0 0 172.9 128.6"
        },
        xmlSpace: "preserve"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("style", {
                children: ".st1G{fill:url(#SVGID_00000029012837056082208560000011312880847900416384_)}.st2G{fill:url(#SVGID_00000093866359683467538180000002566768084245135011_)}.st3G{fill:url(#SVGID_00000132075466675391807810000017507509499009587351_)}"
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                id: "SVGID_1_GMOI",
                gradientUnits: "userSpaceOnUse",
                x1: 75.272,
                y1: -581.805,
                x2: 75.272,
                y2: -478.965,
                gradientTransform: "matrix(1 0 0 -1 0 -466.11)",
                children: [
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                        offset: 0,
                        style: {
                            stopColor: "#0052cc"
                        }
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                        offset: 1,
                        style: {
                            stopColor: "#2684ff"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                d: "M107.2 15.8c-.3-1.1-1.1-2-2.1-2.5s-2.1-.6-3.2-.3l-17.6 5.7c-2.2.7-3.4 3.1-2.7 5.3l.9 2.7-44.6 32.9-17.7 5.8c-1.1.3-2 1.1-2.5 2.1s-.6 2.1-.2 3.2l10.7 33c.6 1.8 2.2 2.9 4 2.9.4 0 .8-.1 1.3-.2l17.6-5.7 9.1.1c1.8 8.6 9.5 15.1 18.6 15.1s16.6-6.4 18.5-14.8l9.3.1.9 2.7c.3 1.1 1.1 2 2.1 2.5.6.3 1.2.4 1.9.4.4 0 .9-.1 1.3-.2l17.6-5.7c2.2-.7 3.4-3.1 2.7-5.3l-25.9-79.8zM34.9 97l-8.1-25 10.3-3.4 8.1 25c0 .1-10.3 3.4-10.3 3.4zm43.9 10.3c-4.4 0-8.2-2.7-9.8-6.6l19.6.1c-1.6 3.8-5.4 6.5-9.8 6.5zM53.5 92.2l-4.4-13.6L44.7 65l40.5-29.8 12.4 38.2 6.2 19c0 .1-50.3-.2-50.3-.2zm60.7 4.8-.5-1.6-11.1-34.2L91 25.5l9.6-3.1 23.2 71.5-9.6 3.1z",
                style: {
                    fill: "url(#SVGID_1_GMOI)"
                }
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                id: "SVGID_00000027600303583147959230000014547028643630307720_",
                gradientUnits: "userSpaceOnUse",
                x1: 122.356,
                y1: -500.219,
                x2: 132.348,
                y2: -480.93,
                gradientTransform: "matrix(1 0 0 -1 0 -466.11)",
                children: [
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                        offset: 0,
                        style: {
                            stopColor: "#0052cc"
                        }
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                        offset: 1,
                        style: {
                            stopColor: "#2684ff"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                style: {
                    fill: "url(#SVGID_00000027600303583147959230000014547028643630307720_)"
                },
                d: "M121.3 36.2c.6.3 1.3.4 1.9.4 1.5 0 3-.8 3.8-2.3l7.6-14.8c1.1-2.1.2-4.6-1.8-5.7s-4.6-.2-5.7 1.8l-7.6 14.8c-1.1 2.2-.2 4.8 1.8 5.8z"
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                id: "SVGID_00000088117863559892969280000004110498432163659143_",
                gradientUnits: "userSpaceOnUse",
                x1: 134.193,
                y1: -537.748,
                x2: 153.345,
                y2: -546.868,
                gradientTransform: "matrix(1 0 0 -1 0 -466.11)",
                children: [
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                        offset: 0,
                        style: {
                            stopColor: "#0052cc"
                        }
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                        offset: 1,
                        style: {
                            stopColor: "#2684ff"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                style: {
                    fill: "url(#SVGID_00000088117863559892969280000004110498432163659143_)"
                },
                d: "m152.9 76.2-14.8-7.6c-2.1-1.1-4.6-.2-5.7 1.8-1.1 2.1-.2 4.6 1.8 5.7l14.8 7.6c.6.3 1.3.4 1.9.4 1.5 0 3-.8 3.8-2.3 1.1-2.1.3-4.6-1.8-5.6z"
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("linearGradient", {
                id: "SVGID_00000145751960127603169490000018030763481166983320_",
                gradientUnits: "userSpaceOnUse",
                x1: 133.223,
                y1: -517.617,
                x2: 154.015,
                y2: -510.329,
                gradientTransform: "matrix(1 0 0 -1 0 -466.11)",
                children: [
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                        offset: 0,
                        style: {
                            stopColor: "#0052cc"
                        }
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("stop", {
                        offset: 1,
                        style: {
                            stopColor: "#2684ff"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                style: {
                    fill: "url(#SVGID_00000145751960127603169490000018030763481166983320_)"
                },
                d: "M131.6 51.8c.6 1.8 2.2 2.9 4 2.9.4 0 .9-.1 1.3-.2l15.8-5.2c2.2-.7 3.4-3.1 2.7-5.3-.7-2.2-3.1-3.4-5.3-2.7l-15.8 5.2c-2.1.7-3.3 3.1-2.7 5.3z"
            })
        ]
    }));
var $e2f8cedcfded7cdc$export$2e2bcd8739ae039 = $e2f8cedcfded7cdc$var$SvgGeneralMarketingOptIn;


const $22f1cdb487390d65$var$_2 = "._4t3ickbl{height:3pc}";
const $22f1cdb487390d65$var$_ = "._1bsbckbl{width:3pc}";
const $22f1cdb487390d65$var$styles = null;
const $22f1cdb487390d65$export$ddb421af37c7fad5 = (attributes)=>/*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                children: [
                    $22f1cdb487390d65$var$_,
                    $22f1cdb487390d65$var$_2
                ]
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $e2f8cedcfded7cdc$export$2e2bcd8739ae039), (0, $2qxEV._)((0, $9tqwB._)({}, attributes), {
                className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                    "_1bsbckbl _4t3ickbl"
                ])
            }))
        ]
    });
$22f1cdb487390d65$export$ddb421af37c7fad5.displayName = 'MarketingIcon';


const $1c3aade99c91fb27$var$titleToIconType = {
    // Confluence Data Center
    productUpgradesConfluenceDataCenter: 'confluenceDataCenter',
    productRecommendationsConfluenceDataCenter: 'confluenceDataCenter',
    // JSM Data Center
    productUpgradesJiraServiceDeskDataCenter: 'jsmDataCenter',
    productRecommendationsJiraServiceDeskDataCenter: 'jsmDataCenter',
    // Bitbucket Data Center
    productUpgradesBitbucketDataCenter: 'bitbucketDataCenter',
    productRecommendationsBitbucketDataCenter: 'bitbucketDataCenter',
    // Crowd
    crowdTechAlerts: 'crowd',
    productUpgradesCrowdDataCenter: 'crowd',
    productRecommendationsCrowdDataCenter: 'crowd',
    // Jira Data Center
    productRecommendationsJiraCoreDataCenter: 'jiraDataCenter',
    productUpgradesJiraCoreDataCenter: 'jiraDataCenter',
    productRecommendationsJiraSoftwareDataCenter: 'jiraDataCenter',
    productUpgradesJiraSoftwareDataCenter: 'jiraDataCenter',
    // Bamboo
    bambooTechAlerts: 'bamboo',
    // Rovo
    productRecommendationsRovoCloud: 'rovo',
    // Rovo Dev
    productRecommendationsRovoDev: 'rovoDev',
    productUpgradesRovoDev: 'rovoDev',
    // Jira Product Discovery
    productRecommendationsJiraProductDiscoveryCloud: 'jiraProductDiscovery',
    productUpgradesJiraProductDiscoveryCloud: 'jiraProductDiscovery',
    // Jira
    jiraMacApp: 'jira',
    automationForJiraProductRecommendationsCloud: 'jira',
    automationForJiraProductUpgradesCloud: 'jira',
    automationForJiraTipsAndTricksCloud: 'jira',
    automationForJiraProductRecommendationsServer: 'jira',
    iconsForJiraProductRecommendationsServer: 'jira',
    automationForJiraProductUpgradesServer: 'jira',
    iconsForJiraProductUpgradesServer: 'jira',
    automationForJiraTipsAndTricksServer: 'jira',
    iconsForJiraTipsAndTricksServer: 'jira',
    productRecommendationsAdvancedRoadmapsForJiraCloud: 'jira',
    productRecommendationsJiraSoftwareCloud: 'jira',
    productUpgradesAdvancedRoadmapsForJiraCloud: 'jira',
    productUpgradesJiraSoftwareCloud: 'jira',
    jiraSoftwareTechAlerts: 'jira',
    jiraCloudCSComms: 'jira',
    jiraServerNewsletter: 'jira',
    jiraSoftwareProductRecommendationsCloud: 'jira',
    jiraSoftwareProductRecommendationsServer: 'jira',
    jiraSoftwareProductUpgradesCloud: 'jira',
    jiraSoftwareProductUpgradesServer: 'jira',
    jiraSoftwareTipsAndTricksCloud: 'jira',
    jiraSoftwareTipsAndTricksServer: 'jira',
    productUpgradesJiraSoftwareServer: 'jira',
    productRecommendationsJiraSoftwareServer: 'jira',
    jiraOps: 'jira',
    jiraCoreTechAlerts: 'jira',
    jiraCoreProductRecommendationsCloud: 'jira',
    jiraCoreProductRecommendationsServer: 'jira',
    jiraCoreProductUpgradesCloud: 'jira',
    jiraCoreTipsAndTricksCloud: 'jira',
    productRecommendationsJiraCoreCloud: 'jira',
    productRecommendationsJiraCoreServer: 'jira',
    productUpgradesJiraCoreCloud: 'jira',
    productUpgradesJiraCoreServer: 'jira',
    // JSM
    jiraServiceDeskTechAlerts: 'jsm',
    jiraServiceDeskProductRecommendationsCloud: 'jsm',
    jiraServiceDeskProductRecommendationsServer: 'jsm',
    jiraServiceDeskProductUpgradesCloud: 'jsm',
    jiraServiceDeskProductUpgradesServer: 'jsm',
    jiraServiceDeskTipsAndTricksCloud: 'jsm',
    jiraServiceDeskTipsAndTricksServer: 'jsm',
    jsmCloudCSComms: 'jsm',
    productRecommendationsJiraServiceDeskCloud: 'jsm',
    productRecommendationsJiraServiceDeskServer: 'jsm',
    productUpgradesJiraServiceDeskCloud: 'jsm',
    productUpgradesJiraServiceDeskServer: 'jsm',
    // Confluence
    confluenceCloudCSComms: 'confluence',
    confluenceInsidersNewsletter: 'confluence',
    confluenceTechAlerts: 'confluence',
    confluenceProductRecommendationsCloud: 'confluence',
    confluenceProductRecommendationsServer: 'confluence',
    confluenceProductUpgradesCloud: 'confluence',
    confluenceProductUpgradesServer: 'confluence',
    confluenceTipsAndTricksCloud: 'confluence',
    confluenceTipsAndTricksServer: 'confluence',
    analyticsForConfluenceAppProductRecommendationsServer: 'confluence',
    productRecommendationsConfluenceCloud: 'confluence',
    productRecommendationsConfluenceServer: 'confluence',
    productUpgradesConfluenceCloud: 'confluence',
    productUpgradesConfluenceServer: 'confluence',
    // Bitbucket
    bitbucketTechAlerts: 'bitbucket',
    bitbucketProductRecommendationsCloud: 'bitbucket',
    bitbucketProductRecommendationsServer: 'bitbucket',
    bitbucketProductUpgradesCloud: 'bitbucket',
    bitbucketProductUpgradesServer: 'bitbucket',
    bitbucketTipsAndTricksCloud: 'bitbucket',
    bitbucketTipsAndTricksServer: 'bitbucket',
    productUpgradesBitbucketCloud: 'bitbucket',
    productUpgradesBitbucketServer: 'bitbucket',
    productRecommendationsBitbucketCloud: 'bitbucket',
    productRecommendationsBitbucketServer: 'bitbucket',
    // Trello
    trelloCSComms: 'trello',
    trelloProductRecommendationsCloud: 'trello',
    trelloPowerUpsProductRecommendationsCloud: 'trello',
    trelloProductUpgradesCloud: 'trello',
    trelloPowerUpsProductUpgradesCloud: 'trello',
    trelloTipsAndTricksCloud: 'trello',
    trelloPowerUpsTipsAndTricksCloud: 'trello',
    productUpgradesTrello: 'trello',
    productRecommendationsTrello: 'trello',
    trelloNewsletter: 'trello',
    trelloEnterprise: 'trello',
    // Statuspage
    statuspageProductRecommendationsCloud: 'statuspage',
    statuspageProductUpgradesCloud: 'statuspage',
    statuspageTipsAndTricksCloud: 'statuspage',
    productRecommendationsStatuspageCloud: 'statuspage',
    productUpgradesStatuspageCloud: 'statuspage',
    // Opsgenie
    opsgenieProductRecommendationsCloud: 'opsgenie',
    opsgenieProductUpgradesCloud: 'opsgenie',
    opsgenieTipsAndTricksCloud: 'opsgenie',
    opsgenieOnboarding: 'opsgenie',
    productRecommendationsOpsgenieCloud: 'opsgenie',
    productUpgradesOpsgenieCloud: 'opsgenie',
    // Jira Align
    jiraAlignProductRecommendationsCloud: 'jiraAlign',
    jiraAlignProductUpgradesCloud: 'jiraAlign',
    jiraAlignTipsAndTricksCloud: 'jiraAlign',
    productRecommendationsJiraAlignCloud: 'jiraAlign',
    productRecommendationsJiraAlignDataCenter: 'jiraAlign',
    productRecommendationsJiraAlignServer: 'jiraAlign',
    productUpgradesJiraAlignCloud: 'jiraAlign',
    productUpgradesJiraAlignDataCenter: 'jiraAlign',
    productUpgradesJiraAlignServer: 'jiraAlign',
    // Compass
    compassDigest: 'compass',
    compassNewsletter: 'compass',
    productRecommendationsCompassCloud: 'compass',
    productUpgradesCompassCloud: 'compass',
    // Marketing
    generalMarketingOptIn: 'marketing',
    // Guard
    beaconNewsletter: 'guard',
    productRecommendationsAtlassianAccess: 'guard',
    productUpgradesAtlassianAccess: 'guard',
    // Loom
    loomProductEngagements: 'loom',
    loomReplayNewsletter: 'loom',
    productRecommendationsLoomCloud: 'loom',
    productUpgradesLoomCloud: 'loom',
    loomCloudCSComms: 'loom'
};
const $1c3aade99c91fb27$var$defaultProps = {
    size: 'xlarge',
    appearance: 'brand',
    shouldUseNewLogoDesign: true
};
const $1c3aade99c91fb27$var$iconFactories = {
    confluenceDataCenter: ()=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $541f1648413af912$export$53305f1f2855d3be), (0, $2qxEV._)((0, $9tqwB._)({}, $1c3aade99c91fb27$var$defaultProps), {
            testId: "confluence-data-center-icon"
        })),
    jsmDataCenter: ()=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $541f1648413af912$export$65fae0eaf343f2ca), (0, $2qxEV._)((0, $9tqwB._)({}, $1c3aade99c91fb27$var$defaultProps), {
            testId: "jsm-data-center-icon"
        })),
    bitbucketDataCenter: ()=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $541f1648413af912$export$d3ab16bbf4f954ee), (0, $2qxEV._)((0, $9tqwB._)({}, $1c3aade99c91fb27$var$defaultProps), {
            testId: "bitbucket-data-center-icon"
        })),
    crowd: ()=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $541f1648413af912$export$eaf73f391f7103bd), (0, $2qxEV._)((0, $9tqwB._)({}, $1c3aade99c91fb27$var$defaultProps), {
            testId: "crowd-icon"
        })),
    jiraDataCenter: ()=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $541f1648413af912$export$f8455b5667a3ee0c), (0, $2qxEV._)((0, $9tqwB._)({}, $1c3aade99c91fb27$var$defaultProps), {
            testId: "jira-data-center-icon"
        })),
    bamboo: ()=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $541f1648413af912$export$e812398311cab9a3), (0, $2qxEV._)((0, $9tqwB._)({}, $1c3aade99c91fb27$var$defaultProps), {
            testId: "bamboo-icon"
        })),
    rovo: ()=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $541f1648413af912$export$e23ae35269442b4f), (0, $2qxEV._)((0, $9tqwB._)({}, $1c3aade99c91fb27$var$defaultProps), {
            testId: "rovo-icon"
        })),
    rovoDev: ()=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $541f1648413af912$export$8b784b3227531b3e), (0, $2qxEV._)((0, $9tqwB._)({}, $1c3aade99c91fb27$var$defaultProps), {
            testId: "rovo-dev-icon"
        })),
    jiraProductDiscovery: ()=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $541f1648413af912$export$21bfbeb62fdcce8d), (0, $2qxEV._)((0, $9tqwB._)({}, $1c3aade99c91fb27$var$defaultProps), {
            testId: "jira-product-discovery-icon"
        })),
    jira: ()=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $541f1648413af912$export$c4b5b1f965d8b3eb), (0, $2qxEV._)((0, $9tqwB._)({}, $1c3aade99c91fb27$var$defaultProps), {
            testId: "jira-icon"
        })),
    jsm: ()=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $541f1648413af912$export$3c6158790f5e01c4), (0, $2qxEV._)((0, $9tqwB._)({}, $1c3aade99c91fb27$var$defaultProps), {
            testId: "jira-service-management-icon"
        })),
    confluence: ()=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $541f1648413af912$export$68f3db7f6af48bcb), (0, $2qxEV._)((0, $9tqwB._)({}, $1c3aade99c91fb27$var$defaultProps), {
            testId: "confluence-icon"
        })),
    bitbucket: ()=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $541f1648413af912$export$5fc1066e677788d4), (0, $2qxEV._)((0, $9tqwB._)({}, $1c3aade99c91fb27$var$defaultProps), {
            testId: "bitbucket-icon"
        })),
    trello: ()=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $541f1648413af912$export$4384da9b8b140bf4), (0, $2qxEV._)((0, $9tqwB._)({}, $1c3aade99c91fb27$var$defaultProps), {
            testId: "trello-icon"
        })),
    statuspage: ()=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $541f1648413af912$export$f3f5aa321d88adf9), (0, $2qxEV._)((0, $9tqwB._)({}, $1c3aade99c91fb27$var$defaultProps), {
            testId: "statuspage-icon"
        })),
    opsgenie: ()=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $541f1648413af912$export$eeccc49dc7a12d9f), (0, $2qxEV._)((0, $9tqwB._)({}, $1c3aade99c91fb27$var$defaultProps), {
            testId: "opsgenie-icon"
        })),
    jiraAlign: ()=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $541f1648413af912$export$407687b2dd89cc68), (0, $2qxEV._)((0, $9tqwB._)({}, $1c3aade99c91fb27$var$defaultProps), {
            testId: "jira-align-icon"
        })),
    compass: ()=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $541f1648413af912$export$f7857fe64d7161d9), (0, $2qxEV._)((0, $9tqwB._)({}, $1c3aade99c91fb27$var$defaultProps), {
            testId: "compass-icon"
        })),
    marketing: ()=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $22f1cdb487390d65$export$ddb421af37c7fad5), {
            "data-testid": "marketing-icon"
        }),
    guard: ()=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $541f1648413af912$export$3f95fcfdc25a741d), (0, $2qxEV._)((0, $9tqwB._)({}, $1c3aade99c91fb27$var$defaultProps), {
            testId: "atlassian-guard-icon"
        })),
    loom: ()=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $541f1648413af912$export$8d789f76fde3e05), (0, $2qxEV._)((0, $9tqwB._)({}, $1c3aade99c91fb27$var$defaultProps), {
            testId: "loom-icon"
        })),
    atlassian: ()=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $fd94651bfb983298$export$8a485e2e7ed91e8f), (0, $2qxEV._)((0, $9tqwB._)({}, $1c3aade99c91fb27$var$defaultProps), {
            testId: "atlassian-icon"
        }))
};
const $1c3aade99c91fb27$var$ItemIcon = ({ title: title })=>{
    const iconType = $1c3aade99c91fb27$var$titleToIconType[title] || 'atlassian';
    return $1c3aade99c91fb27$var$iconFactories[iconType]();
};
var $1c3aade99c91fb27$export$2e2bcd8739ae039 = $1c3aade99c91fb27$var$ItemIcon;













var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

parcelRequire("7fPBF");
const $6409f46430b0ad10$var$SvgChecked = (props)=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("svg", (0, $2qxEV._)((0, $9tqwB._)({
        id: "Capa_1",
        xmlns: "http://www.w3.org/2000/svg",
        x: 0,
        y: 0,
        width: 24,
        height: 24,
        viewBox: "0 0 474.8 474.801",
        style: {
            enableBackground: "new 0 0 474.8 474.801"
        },
        xmlSpace: "preserve"
    }, props), {
        children: /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                    d: "M396.283 257.097c-1.14-.575-2.282-.862-3.433-.862-2.478 0-4.661.951-6.563 2.857l-18.274 18.271c-1.708 1.715-2.566 3.806-2.566 6.283v72.513c0 12.565-4.463 23.314-13.415 32.264-8.945 8.945-19.701 13.418-32.264 13.418H82.226c-12.564 0-23.319-4.473-32.264-13.418-8.947-8.949-13.418-19.698-13.418-32.264V118.622c0-12.562 4.471-23.316 13.418-32.264 8.945-8.946 19.7-13.418 32.264-13.418H319.77c4.188 0 8.47.571 12.847 1.714 1.143.378 1.999.571 2.563.571 2.478 0 4.668-.949 6.57-2.852l13.99-13.99c2.282-2.281 3.142-5.043 2.566-8.276-.571-3.046-2.286-5.236-5.141-6.567-10.272-4.752-21.412-7.139-33.403-7.139H82.226c-22.65 0-42.018 8.042-58.102 24.126C8.042 76.613 0 95.978 0 118.629v237.543c0 22.647 8.042 42.014 24.125 58.098 16.084 16.088 35.452 24.13 58.102 24.13h237.541c22.647 0 42.017-8.042 58.101-24.13 16.085-16.084 24.134-35.45 24.134-58.098v-90.797c-.002-3.994-1.915-6.752-5.72-8.278z"
                }),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
                    d: "m467.95 93.216-31.409-31.409c-4.568-4.567-9.996-6.851-16.279-6.851-6.275 0-11.707 2.284-16.271 6.851L219.265 246.532l-75.084-75.089c-4.569-4.57-9.995-6.851-16.274-6.851-6.28 0-11.704 2.281-16.274 6.851l-31.405 31.405c-4.568 4.568-6.854 9.994-6.854 16.277 0 6.28 2.286 11.704 6.854 16.274l122.767 122.767c4.569 4.571 9.995 6.851 16.274 6.851 6.279 0 11.704-2.279 16.274-6.851l232.404-232.403c4.565-4.567 6.854-9.994 6.854-16.274s-2.283-11.706-6.851-16.273z"
                })
            ]
        })
    }));
var $6409f46430b0ad10$export$2e2bcd8739ae039 = $6409f46430b0ad10$var$SvgChecked;



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

parcelRequire("7fPBF");
const $9b78ef673cff192c$var$SvgUnchecked = (props)=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("svg", (0, $2qxEV._)((0, $9tqwB._)({
        id: "Capa_1",
        xmlns: "http://www.w3.org/2000/svg",
        x: 0,
        y: 0,
        width: 20,
        height: 20,
        viewBox: "0 0 401.998 401.998",
        style: {
            enableBackground: "new 0 0 401.998 401.998"
        },
        xmlSpace: "preserve"
    }, props), {
        children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("path", {
            fill: "currentColor",
            d: "M377.87 24.126C361.786 8.042 342.417 0 319.769 0H82.227C59.579 0 40.211 8.042 24.125 24.126 8.044 40.212.002 59.576.002 82.228v237.543c0 22.647 8.042 42.014 24.123 58.101 16.086 16.085 35.454 24.127 58.102 24.127h237.542c22.648 0 42.011-8.042 58.102-24.127 16.085-16.087 24.126-35.453 24.126-58.101V82.228c-.004-22.648-8.046-42.016-24.127-58.102zm-12.422 295.645c0 12.559-4.47 23.314-13.415 32.264-8.945 8.945-19.698 13.411-32.265 13.411H82.227c-12.563 0-23.317-4.466-32.264-13.411-8.945-8.949-13.418-19.705-13.418-32.264V82.228c0-12.562 4.473-23.316 13.418-32.264 8.947-8.946 19.701-13.418 32.264-13.418h237.542c12.566 0 23.319 4.473 32.265 13.418 8.945 8.947 13.415 19.701 13.415 32.264v237.543h-.001z"
        })
    }));
var $9b78ef673cff192c$export$2e2bcd8739ae039 = $9b78ef673cff192c$var$SvgUnchecked;


/* icon.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");

var $gVgMi = parcelRequire("gVgMi");
function $ab6305b9bfa57046$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ab6305b9bfa57046$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ab6305b9bfa57046$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ab6305b9bfa57046$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $ab6305b9bfa57046$var$iconStyles = null;
var $ab6305b9bfa57046$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $ab6305b9bfa57046$var$baseHcmStyles = null;
var $ab6305b9bfa57046$var$primaryEqualsSecondaryHcmStyles = null;
var $ab6305b9bfa57046$var$secondaryTransparentHcmStyles = null;
var $ab6305b9bfa57046$export$f04a61298a47a40f = /*#__PURE__*/ (0, $7fPBF.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $7fPBF.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $7fPBF.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $ab6305b9bfa57046$var$_objectSpread($ab6305b9bfa57046$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $gVgMi.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $ab6305b9bfa57046$var$sizeStyles[size]
        ])
    }));
});
var $ab6305b9bfa57046$export$2e2bcd8739ae039 = $ab6305b9bfa57046$export$f04a61298a47a40f;



const $302c88871644c20a$var$_17 = "@media (min-width:64rem){._1e3cg31l{grid-column:span 2}}";
const $302c88871644c20a$var$_16 = "._irr393m5:hover{background-color:var(--_1svj906)}";
const $302c88871644c20a$var$_15 = "._1bah1yb4{justify-content:space-between}";
const $302c88871644c20a$var$_14 = "._4cvr1h6o{align-items:center}";
const $302c88871644c20a$var$_13 = "._1e0c1txw{display:flex}";
const $302c88871644c20a$var$_12 = "._syaz1prm{color:var(--_540bhb)}";
const $302c88871644c20a$var$_11 = "._80omtlke{cursor:pointer}";
const $302c88871644c20a$var$_10 = "._u5f314lv{padding-right:var(--_cpuyf2)}";
const $302c88871644c20a$var$_9 = "._19bv14lv{padding-left:var(--_cpuyf2)}";
const $302c88871644c20a$var$_8 = "._n3td1ul9{padding-bottom:var(--_18cq338)}";
const $302c88871644c20a$var$_7 = "._ca0q1ul9{padding-top:var(--_18cq338)}";
const $302c88871644c20a$var$_6 = "._bfhk1qb5{background-color:var(--_p1xkbi)}";
const $302c88871644c20a$var$_5 = "._1h6d1nw4{border-color:var(--_lnnecg)}";
const $302c88871644c20a$var$_4 = "._1dqonqa1{border-style:solid}";
const $302c88871644c20a$var$_3 = "._189et94y{border-width:1px}";
const $302c88871644c20a$var$_2 = "._zulp7cul{gap:var(--_1wcbtwk)}";
const $302c88871644c20a$var$_ = "._2rko1l7b{border-radius:3px}";
const $302c88871644c20a$var$cardStyles = null;
const $302c88871644c20a$var$largeCardStyles = null;
const $302c88871644c20a$var$largeCardHeaderStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    paddingBottom: 'space.100',
    cursor: 'pointer',
    color: 'color.text',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 'space.150'
});
const $302c88871644c20a$var$largeCardDescriptionStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    margin: '0'
});
const $302c88871644c20a$var$cardTitleStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    flexGrow: 1
});
const $302c88871644c20a$var$cardCheckboxStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    minHeight: '32px',
    minWidth: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start'
});
const $302c88871644c20a$var$ItemCard = ({ type: type, itemKey: itemKey, groupKey: groupKey, tabKey: tabKey })=>{
    const { translate: translate, keyWithTitle: keyWithTitle, keyWithDescription: keyWithDescription } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    const dispatch = (0, $7ef2374eddee6a70$export$f51d452c10d5b956)();
    const state = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$f26c97331adc89d5)(groupKey, itemKey, tabKey));
    const initialState = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$d3a73181b80e0de7)(itemKey));
    const titleTranslated = translate(keyWithTitle(itemKey));
    const descriptionTranslated = translate(keyWithDescription(itemKey));
    const changed = state !== initialState;
    const cardClickHandler = (0, $7fPBF.useCallback)(()=>{
        let targetState = (0, $e11fceb31fd1a0cb$export$e743037aea74f514).false;
        if (state !== (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON) targetState = (0, $e11fceb31fd1a0cb$export$e743037aea74f514).true;
        if (type === (0, $91cadcf42f447377$export$d460f747b73abb10).SUBSCRIPTIONS && (groupKey !== 'product_recommendations' || targetState === (0, $e11fceb31fd1a0cb$export$e743037aea74f514).false)) (0, $0e08eda71bb24540$export$b2d5c41c71279068)(Boolean(targetState), {
            source: itemKey
        });
        dispatch((0, $3d2cac913f314860$export$807cff22f0457821)({
            keys: [
                itemKey
            ],
            state: targetState,
            bypassConsentCheck: false,
            bypassConsentDeclinePrCheck: false,
            skipNotification: false,
            sourceGroup: groupKey,
            sourceItem: itemKey,
            sourceComponent: 'ItemCard'
        }));
    }, [
        dispatch,
        groupKey,
        itemKey,
        state,
        type
    ]);
    let element = /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $aacfdd39b28e059d$export$2e2bcd8739ae039), {});
    if (state === (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON && !changed) element = /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $ab6305b9bfa57046$export$2e2bcd8739ae039), {
        primaryColor: (0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.icon.selected'),
        glyph: (0, $6409f46430b0ad10$export$2e2bcd8739ae039),
        label: 'Checked',
        testId: 'checkedSvgIcon'
    });
    else if (state === (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON && changed) element = /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $ab6305b9bfa57046$export$2e2bcd8739ae039), {
        primaryColor: (0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.icon.success'),
        glyph: (0, $6409f46430b0ad10$export$2e2bcd8739ae039),
        label: 'Checked',
        testId: 'checked-icon-changed'
    });
    else if ((state === (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF || state === (0, $91cadcf42f447377$export$3d4da522aa66ad7).PENDING) && !changed) element = /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $ab6305b9bfa57046$export$2e2bcd8739ae039), {
        primaryColor: (0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.icon.selected'),
        glyph: (0, $9b78ef673cff192c$export$2e2bcd8739ae039),
        label: 'Unchecked',
        testId: 'uncheckedSvgIcon'
    });
    else if ((state === (0, $91cadcf42f447377$export$3d4da522aa66ad7).OFF || state === (0, $91cadcf42f447377$export$3d4da522aa66ad7).PENDING) && changed) element = /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $ab6305b9bfa57046$export$2e2bcd8739ae039), {
        primaryColor: (0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.icon.success'),
        glyph: (0, $9b78ef673cff192c$export$2e2bcd8739ae039),
        label: 'Unchecked',
        testId: 'unchecked-icon-changed'
    });
    if (type === (0, $91cadcf42f447377$export$d460f747b73abb10).SUBSCRIPTIONS) return /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                children: [
                    $302c88871644c20a$var$_,
                    $302c88871644c20a$var$_2,
                    $302c88871644c20a$var$_3,
                    $302c88871644c20a$var$_4,
                    $302c88871644c20a$var$_5,
                    $302c88871644c20a$var$_6,
                    $302c88871644c20a$var$_7,
                    $302c88871644c20a$var$_8,
                    $302c88871644c20a$var$_9,
                    $302c88871644c20a$var$_10,
                    $302c88871644c20a$var$_11,
                    $302c88871644c20a$var$_12,
                    $302c88871644c20a$var$_13,
                    $302c88871644c20a$var$_14,
                    $302c88871644c20a$var$_15,
                    $302c88871644c20a$var$_16
                ]
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("div", {
                onClick: cardClickHandler,
                "data-test-item-key": itemKey,
                "data-test-is-checked": state === (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                "data-testid": 'dynamicConfigElementWrapper',
                className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                    "_2rko1l7b _zulp7cul _189et94y _1dqonqa1 _1h6d1nw4 _bfhk1qb5 _ca0q1ul9 _n3td1ul9 _19bv14lv _u5f314lv _80omtlke _syaz1prm _1e0c1txw _4cvr1h6o _1bah1yb4 _irr393m5"
                ]),
                style: {
                    "--_p1xkbi": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('elevation.surface.raised')),
                    "--_18cq338": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.100')),
                    "--_cpuyf2": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.200')),
                    "--_lnnecg": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.border')),
                    "--_540bhb": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.text')),
                    "--_1wcbtwk": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.150')),
                    "--_1svj906": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('elevation.surface.raised.hovered'))
                },
                children: [
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $1c3aade99c91fb27$export$2e2bcd8739ae039), {
                        title: itemKey
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                        xcss: $302c88871644c20a$var$cardTitleStyles,
                        children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $ae39dbf01fef6beb$export$2e2bcd8739ae039), {
                            size: 'small',
                            children: titleTranslated
                        })
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                        xcss: $302c88871644c20a$var$cardCheckboxStyles,
                        children: element
                    })
                ]
            })
        ]
    });
    else return /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $e954cdbfe522d5cb$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $45806fc118e88e4e$export$2e2bcd8739ae039), {
                children: [
                    $302c88871644c20a$var$_,
                    $302c88871644c20a$var$_3,
                    $302c88871644c20a$var$_4,
                    $302c88871644c20a$var$_5,
                    $302c88871644c20a$var$_6,
                    $302c88871644c20a$var$_7,
                    $302c88871644c20a$var$_8,
                    $302c88871644c20a$var$_9,
                    $302c88871644c20a$var$_10,
                    $302c88871644c20a$var$_11,
                    $302c88871644c20a$var$_12,
                    $302c88871644c20a$var$_16,
                    $302c88871644c20a$var$_17
                ]
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("div", {
                onClick: cardClickHandler,
                "data-test-item-key": itemKey,
                "data-test-is-checked": state === (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON,
                "data-testid": 'largeDynamicConfigElementWrapper',
                className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
                    "_2rko1l7b _189et94y _1dqonqa1 _1h6d1nw4 _bfhk1qb5 _ca0q1ul9 _n3td1ul9 _19bv14lv _u5f314lv _80omtlke _syaz1prm _irr393m5 _1e3cg31l"
                ]),
                style: {
                    "--_p1xkbi": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('elevation.surface.raised')),
                    "--_18cq338": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.100')),
                    "--_cpuyf2": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('space.200')),
                    "--_lnnecg": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.border')),
                    "--_540bhb": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('color.text')),
                    "--_1svj906": (0, $151b1d922dd4b2cf$export$2e2bcd8739ae039)((0, $727d537db95bcc31$export$2e2bcd8739ae039)('elevation.surface.raised.hovered'))
                },
                children: [
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                        xcss: $302c88871644c20a$var$largeCardHeaderStyles,
                        children: [
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $1c3aade99c91fb27$export$2e2bcd8739ae039), {
                                title: itemKey
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                                xcss: $302c88871644c20a$var$cardTitleStyles,
                                children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $ae39dbf01fef6beb$export$2e2bcd8739ae039), {
                                    size: 'small',
                                    children: titleTranslated
                                })
                            }),
                            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                                xcss: $302c88871644c20a$var$cardCheckboxStyles,
                                children: element
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
                        xcss: $302c88871644c20a$var$largeCardDescriptionStyles,
                        children: descriptionTranslated
                    })
                ]
            })
        ]
    });
};
var $302c88871644c20a$export$2e2bcd8739ae039 = $302c88871644c20a$var$ItemCard;









const $d2783296604b3204$var$itemCardGridStyles = (0, $3e5203791fd7c7fc$export$f6c783d06584602c)({
    [(0, $8c23171a376c15ae$export$987d49ffe1b0900f).above.xxs]: {
        gridTemplateColumns: 'repeat(1, 1fr)'
    },
    [(0, $8c23171a376c15ae$export$987d49ffe1b0900f).above.sm]: {
        gridTemplateColumns: 'repeat(2, 1fr)'
    },
    [(0, $8c23171a376c15ae$export$987d49ffe1b0900f).above.md]: {
        gridTemplateColumns: 'repeat(4, 1fr)'
    }
});
const $d2783296604b3204$var$GroupContent = ({ type: type, groupKey: groupKey, tabKey: tabKey })=>{
    const dispatch = (0, $7ef2374eddee6a70$export$f51d452c10d5b956)();
    const { translate: translate, keyWithTitle: keyWithTitle, keyWithDescription: keyWithDescription } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    const items = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$d2800e0e69cd41a5)(groupKey, tabKey));
    const handleSelectAll = (0, $7fPBF.useCallback)(()=>{
        if (type === (0, $91cadcf42f447377$export$d460f747b73abb10).SUBSCRIPTIONS && groupKey !== 'product_recommendations') (0, $0e08eda71bb24540$export$19e5a6bca6f03118)(true, {
            groupName: groupKey,
            tabName: tabKey
        });
        dispatch((0, $3d2cac913f314860$export$807cff22f0457821)({
            keys: items,
            state: (0, $e11fceb31fd1a0cb$export$e743037aea74f514).true,
            bypassConsentCheck: false,
            bypassConsentDeclinePrCheck: false,
            skipNotification: false,
            sourceGroup: groupKey,
            sourceTab: tabKey,
            sourceComponent: 'GroupContent'
        }));
    }, [
        dispatch,
        items,
        groupKey,
        type,
        tabKey
    ]);
    const handleSelectNone = (0, $7fPBF.useCallback)(()=>{
        if (type === (0, $91cadcf42f447377$export$d460f747b73abb10).SUBSCRIPTIONS) (0, $0e08eda71bb24540$export$19e5a6bca6f03118)(false, {
            groupName: groupKey,
            tabName: tabKey
        });
        dispatch((0, $3d2cac913f314860$export$807cff22f0457821)({
            keys: items,
            state: (0, $e11fceb31fd1a0cb$export$e743037aea74f514).false,
            bypassConsentCheck: false,
            bypassConsentDeclinePrCheck: false,
            skipNotification: false,
            sourceGroup: groupKey,
            sourceComponent: 'GroupContent'
        }));
    }, [
        dispatch,
        items,
        type,
        groupKey,
        tabKey
    ]);
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $5fd605fd49ab1b9b$export$2e2bcd8739ae039), {
                text: translate(keyWithDescription(groupKey)),
                onClickAll: handleSelectAll,
                onClickNone: handleSelectNone,
                groupKey: groupKey
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $650de54fef58c216$export$2e2bcd8739ae039), {
                xcss: $d2783296604b3204$var$itemCardGridStyles,
                gap: 'space.200',
                children: [
                    ...items
                ].sort((left, right)=>{
                    return translate(keyWithTitle(left)).localeCompare(translate(keyWithTitle(right)));
                }).map((itemKey)=>{
                    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $302c88871644c20a$export$2e2bcd8739ae039), {
                        type: type,
                        itemKey: itemKey,
                        groupKey: groupKey,
                        tabKey: tabKey
                    }, itemKey);
                })
            })
        ]
    });
};
var $d2783296604b3204$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $7fPBF.memo)($d2783296604b3204$var$GroupContent);






const $02759c0d95d5e37e$var$GroupView = ({ groupKey: groupKey })=>{
    const [selectedTab, setTab] = (0, $7fPBF.useState)();
    const group = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((state)=>(0, $603bd90c46957049$export$cd62b380406677c3)(state, groupKey));
    const visibleGroup = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$c5a1c46e828bfb34));
    const switchTab = (tab, group)=>{
        (0, $0e08eda71bb24540$export$1e7f31c83a73d717)({
            tabName: tab,
            groupName: group
        });
        setTab(tab);
    };
    if (group == null) return null;
    let tabKeys = Object.keys(group.tabs);
    if (visibleGroup.groupKey !== 'all') tabKeys = tabKeys.filter((tabKey)=>tabKey === visibleGroup.tabKey);
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("div", {
        "data-test-group-key": groupKey,
        children: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d5fd265980f256d2$export$2e2bcd8739ae039), {
                tabKeys: tabKeys,
                onChange: switchTab,
                groupKey: groupKey
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d2783296604b3204$export$2e2bcd8739ae039), {
                type: group.type,
                groupKey: groupKey,
                tabKey: selectedTab !== null && selectedTab !== void 0 ? selectedTab : tabKeys[0]
            })
        ]
    });
};
var $02759c0d95d5e37e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $7fPBF.memo)($02759c0d95d5e37e$var$GroupView);





var $7fPBF = parcelRequire("7fPBF");
const $1cebaa730be84287$export$2b1363e3b7173105 = {
    mobileS: 320,
    mobileM: 375,
    mobileL: 576,
    tablet: 768,
    laptopS: 1024,
    laptopM: 1280,
    laptopL: 1440,
    desktopS: 2560,
    desktopM: 3200,
    desktopL: 3440,
    uhd4k: 3840,
    dci4k: 4096
};




const $765c94124ed861f4$export$de363e709c412c8a = (callback, limit = 1000)=>{
    let lastFunc;
    let lastRan;
    return function() {
        if (!lastRan) {
            callback.apply(this);
            lastRan = Date.now();
        } else {
            if (lastFunc) clearTimeout(lastFunc);
            lastFunc = setTimeout(()=>{
                if (Date.now() - lastRan >= limit) {
                    callback.apply(this);
                    lastRan = Date.now();
                }
            }, limit - (Date.now() - lastRan));
        }
    };
};
const $765c94124ed861f4$export$478ddf13a1b06431 = ()=>{
    const [isMobile, setMobile] = (0, $7fPBF.useState)(window.innerWidth <= (0, $1cebaa730be84287$export$2b1363e3b7173105).mobileL);
    (0, $7fPBF.useEffect)(()=>{
        const handleResize = ()=>{
            setMobile(window.innerWidth <= (0, $1cebaa730be84287$export$2b1363e3b7173105).mobileL);
        };
        const throttledHandleResize = $765c94124ed861f4$export$de363e709c412c8a(handleResize);
        window.addEventListener('resize', throttledHandleResize);
        return ()=>window.removeEventListener('resize', throttledHandleResize);
    }, []);
    return isMobile;
};






const $88ea1b053c235b63$var$PreferenceGroup = ()=>{
    const dispatch = (0, $7ef2374eddee6a70$export$f51d452c10d5b956)();
    const { translate: translate, keyWithTitle: keyWithTitle } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    const isPending = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $7a501a2d8adab3c3$export$6a1923cb7c064699));
    const groupKeys = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$48df6acab50c159b));
    const visibleGroup = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$c5a1c46e828bfb34));
    const isAllGroups = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$43d45db6467effac));
    const { status: status } = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$b4f431af37c9cd8b));
    const isMobile = (0, $765c94124ed861f4$export$478ddf13a1b06431)();
    const navigationClickHandler = (0, $7fPBF.useCallback)(()=>{
        (0, $0e08eda71bb24540$export$ac0c4a766e9f767e)();
        dispatch((0, $3d2cac913f314860$export$923ce4fee941073a)());
    }, [
        dispatch
    ]);
    if (isPending || groupKeys.length === 0 || status !== 'ok') return null;
    const tabTitle = visibleGroup.tabKey != null && visibleGroup.tabKey !== 'root' ? `${translate(keyWithTitle(visibleGroup.tabKey))} - ` : '';
    const sections = groupKeys.map((key)=>{
        const groupTitle = `${tabTitle} ${translate(keyWithTitle(key))}`;
        return {
            title: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $ae39dbf01fef6beb$export$2e2bcd8739ae039), {
                size: 'large',
                children: groupTitle
            }),
            content: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $02759c0d95d5e37e$export$2e2bcd8739ae039), {
                groupKey: key
            }),
            groupKey: key
        };
    });
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $d245204bc35d9406$export$2e2bcd8739ae039), {
        testId: "preference-group-container",
        children: [
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $bbdf7a0d01a379ab$export$2e2bcd8739ae039), {
                alwaysOpen: groupKeys.length === 1 || !isMobile,
                showMarker: isMobile && groupKeys.length !== 1,
                sections: sections
            }),
            /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $6125038cd8bf4a75$export$2e2bcd8739ae039), {
                isVisible: !isAllGroups,
                onClick: navigationClickHandler
            })
        ]
    });
};
var $88ea1b053c235b63$export$2e2bcd8739ae039 = $88ea1b053c235b63$var$PreferenceGroup;








var $7fPBF = parcelRequire("7fPBF");
/* modal-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $7fPBF = parcelRequire("7fPBF");

var $iRmtv = parcelRequire("iRmtv");
function $939dffaddf93a85b$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");

var $fa189bd1dd0951d2$exports = {};

$parcel$export($fa189bd1dd0951d2$exports, "FOCUS_GROUP", function () { return $fa189bd1dd0951d2$export$4f9a06cb7441a087; });
$parcel$export($fa189bd1dd0951d2$exports, "FOCUS_DISABLED", function () { return $fa189bd1dd0951d2$export$aeda8252e54b50f7; });
$parcel$export($fa189bd1dd0951d2$exports, "FOCUS_ALLOW", function () { return $fa189bd1dd0951d2$export$54ecf528c58f9ef6; });
$parcel$export($fa189bd1dd0951d2$exports, "FOCUS_AUTO", function () { return $fa189bd1dd0951d2$export$70e9b4a1820af101; });
$parcel$export($fa189bd1dd0951d2$exports, "FOCUS_NO_AUTOFOCUS", function () { return $fa189bd1dd0951d2$export$134ebef29fd94853; });
/**
 * defines a focus group
 */ var $fa189bd1dd0951d2$export$4f9a06cb7441a087 = 'data-focus-lock';
var $fa189bd1dd0951d2$export$aeda8252e54b50f7 = 'data-focus-lock-disabled';
var $fa189bd1dd0951d2$export$54ecf528c58f9ef6 = 'data-no-focus-lock';
var $fa189bd1dd0951d2$export$70e9b4a1820af101 = 'data-autofocus-inside';
var $fa189bd1dd0951d2$export$134ebef29fd94853 = 'data-no-autofocus';



var $7fPBF = parcelRequire("7fPBF");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $b92e63d00f44a32a$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $7fPBF = parcelRequire("7fPBF");
function $9852bc1860f56139$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $7fPBF.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $3aa02bc85fadbfb9$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
var $3aa02bc85fadbfb9$var$currentValues = new WeakMap();
function $3aa02bc85fadbfb9$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $9852bc1860f56139$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $b92e63d00f44a32a$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $3aa02bc85fadbfb9$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $3aa02bc85fadbfb9$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $b92e63d00f44a32a$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $b92e63d00f44a32a$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $3aa02bc85fadbfb9$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



var $7fPBF = parcelRequire("7fPBF");

var $f38eebd6dad36293$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $f38eebd6dad36293$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fPBF.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $f38eebd6dad36293$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $f38eebd6dad36293$export$b8c7b07253306600
    }));
};
$f38eebd6dad36293$var$InFocusGuard.propTypes = {};
var $f38eebd6dad36293$export$2e2bcd8739ae039 = $f38eebd6dad36293$var$InFocusGuard;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $1e2082910c54650f$var$extendStatics = function(d, b) {
    $1e2082910c54650f$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $1e2082910c54650f$var$extendStatics(d, b);
};
function $1e2082910c54650f$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $1e2082910c54650f$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $1e2082910c54650f$export$18ce0697a983be9b = function() {
    $1e2082910c54650f$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1e2082910c54650f$export$18ce0697a983be9b.apply(this, arguments);
};
function $1e2082910c54650f$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $1e2082910c54650f$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $1e2082910c54650f$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $1e2082910c54650f$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $1e2082910c54650f$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $1e2082910c54650f$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $1e2082910c54650f$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $1e2082910c54650f$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $1e2082910c54650f$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $1e2082910c54650f$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $1e2082910c54650f$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $1e2082910c54650f$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $1e2082910c54650f$export$45d3717a4c69092e(o, m, p);
}
function $1e2082910c54650f$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $1e2082910c54650f$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $1e2082910c54650f$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($1e2082910c54650f$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $1e2082910c54650f$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $1e2082910c54650f$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $1e2082910c54650f$export$10c90e4f7922046c(v) {
    return this instanceof $1e2082910c54650f$export$10c90e4f7922046c ? (this.v = v, this) : new $1e2082910c54650f$export$10c90e4f7922046c(v);
}
function $1e2082910c54650f$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $1e2082910c54650f$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $1e2082910c54650f$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $1e2082910c54650f$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $1e2082910c54650f$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $1e2082910c54650f$export$19a8beecd37a4c45 === "function" ? $1e2082910c54650f$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $1e2082910c54650f$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $1e2082910c54650f$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $1e2082910c54650f$var$ownKeys = function(o) {
    $1e2082910c54650f$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $1e2082910c54650f$var$ownKeys(o);
};
function $1e2082910c54650f$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $1e2082910c54650f$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $1e2082910c54650f$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $1e2082910c54650f$var$__setModuleDefault(result, mod);
    return result;
}
function $1e2082910c54650f$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $1e2082910c54650f$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $1e2082910c54650f$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $1e2082910c54650f$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $1e2082910c54650f$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $1e2082910c54650f$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $1e2082910c54650f$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $1e2082910c54650f$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $1e2082910c54650f$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $1e2082910c54650f$export$2e2bcd8739ae039 = {
    __extends: $1e2082910c54650f$export$a8ba968b8961cb8a,
    __assign: $1e2082910c54650f$export$18ce0697a983be9b,
    __rest: $1e2082910c54650f$export$3c9a16f847548506,
    __decorate: $1e2082910c54650f$export$29e00dfd3077644b,
    __param: $1e2082910c54650f$export$d5ad3fd78186038f,
    __esDecorate: $1e2082910c54650f$export$3a84e1ae4e97e9b0,
    __runInitializers: $1e2082910c54650f$export$d831c04e792af3d,
    __propKey: $1e2082910c54650f$export$6a2a36740a146cb8,
    __setFunctionName: $1e2082910c54650f$export$d1a06452d3489bc7,
    __metadata: $1e2082910c54650f$export$f1db080c865becb9,
    __awaiter: $1e2082910c54650f$export$1050f835b63b671e,
    __generator: $1e2082910c54650f$export$67ebef60e6f28a6,
    __createBinding: $1e2082910c54650f$export$45d3717a4c69092e,
    __exportStar: $1e2082910c54650f$export$f33643c0debef087,
    __values: $1e2082910c54650f$export$19a8beecd37a4c45,
    __read: $1e2082910c54650f$export$8d051b38c9118094,
    __spread: $1e2082910c54650f$export$afc72e2116322959,
    __spreadArrays: $1e2082910c54650f$export$6388937ca91ccae8,
    __spreadArray: $1e2082910c54650f$export$1216008129fb82ed,
    __await: $1e2082910c54650f$export$10c90e4f7922046c,
    __asyncGenerator: $1e2082910c54650f$export$e427f37a30a4de9b,
    __asyncDelegator: $1e2082910c54650f$export$bbd80228419bb833,
    __asyncValues: $1e2082910c54650f$export$e3b29a3d6162315f,
    __makeTemplateObject: $1e2082910c54650f$export$4fb47efe1390b86f,
    __importStar: $1e2082910c54650f$export$c21735bcef00d192,
    __importDefault: $1e2082910c54650f$export$da59b14a69baef04,
    __classPrivateFieldGet: $1e2082910c54650f$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $1e2082910c54650f$export$d40a35129aaff81f,
    __classPrivateFieldIn: $1e2082910c54650f$export$81fdc39f203e4e04,
    __addDisposableResource: $1e2082910c54650f$export$88ac25d8e944e405,
    __disposeResources: $1e2082910c54650f$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $1e2082910c54650f$export$889dfb5d17574b0b
};


function $efceb32ecd78f18d$var$ItoI(a) {
    return a;
}
function $efceb32ecd78f18d$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $efceb32ecd78f18d$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $efceb32ecd78f18d$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $efceb32ecd78f18d$var$ItoI;
    return $efceb32ecd78f18d$var$innerCreateMedium(defaults, middleware);
}
function $efceb32ecd78f18d$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $efceb32ecd78f18d$var$innerCreateMedium(null);
    medium.options = (0, $1e2082910c54650f$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $4b5bcfe03091b424$export$5733e022b1d538cb = (0, $efceb32ecd78f18d$export$9ffbfcaf067b02c6)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $4b5bcfe03091b424$export$b3e9a9312f73723c = (0, $efceb32ecd78f18d$export$9ffbfcaf067b02c6)();
var $4b5bcfe03091b424$export$3a1d52767cbc07b8 = (0, $efceb32ecd78f18d$export$9ffbfcaf067b02c6)();
var $4b5bcfe03091b424$export$892cbf28e5518020 = (0, $efceb32ecd78f18d$export$e13ec7dd7a14088d)({
    async: true,
    ssr: typeof document !== 'undefined'
});



var $7fPBF = parcelRequire("7fPBF");
var $3cd45ad9294a7063$export$f5272e9b1168239c = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);


var $e17e6ac998763caf$var$emptyArray = [];
var $e17e6ac998763caf$var$FocusLock = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _useState = (0, $7fPBF.useState)(), realObserved = _useState[0], setObserved = _useState[1];
    var observed = (0, $7fPBF.useRef)();
    var isActive = (0, $7fPBF.useRef)(false);
    var originalFocusedElement = (0, $7fPBF.useRef)(null);
    var _useState2 = (0, $7fPBF.useState)({}), update = _useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $e17e6ac998763caf$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _useState3 = (0, $7fPBF.useState)({}), id = _useState3[0];
    var onActivation = (0, $7fPBF.useCallback)(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = (0, $7fPBF.useCallback)(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = (0, $7fPBF.useCallback)(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = (0, $7fPBF.useCallback)(function(event) {
        if (isActive.current) (0, $4b5bcfe03091b424$export$5733e022b1d538cb).useMedium(event);
    }, []);
    var onBlur = (0, $4b5bcfe03091b424$export$b3e9a9312f73723c).useMedium;
    var setObserveNode = (0, $7fPBF.useCallback)(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)((_extends2 = {}, _extends2[0, $fa189bd1dd0951d2$export$aeda8252e54b50f7] = disabled && 'disabled', _extends2[0, $fa189bd1dd0951d2$export$4f9a06cb7441a087] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $3aa02bc85fadbfb9$export$74665b213cb5c4cf)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = (0, $7fPBF.useMemo)(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fPBF.Fragment), null, hasLeadingGuards && [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $f38eebd6dad36293$export$b8c7b07253306600)
        }),
        hasPositiveIndices ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $f38eebd6dad36293$export$b8c7b07253306600)
        }) : null
    ], !disabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(SideCar, {
        id: id,
        sideCar: (0, $4b5bcfe03091b424$export$892cbf28e5518020),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions,
        noFocusGuards: noFocusGuards
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Container, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $3cd45ad9294a7063$export$f5272e9b1168239c).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $f38eebd6dad36293$export$b8c7b07253306600)
    }));
});
$e17e6ac998763caf$var$FocusLock.propTypes = {};
var $e17e6ac998763caf$export$2e2bcd8739ae039 = $e17e6ac998763caf$var$FocusLock;



var $7fPBF = parcelRequire("7fPBF");

function $b106bdebf5664d73$export$2e2bcd8739ae039(t, e) {
    return $b106bdebf5664d73$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $b106bdebf5664d73$export$2e2bcd8739ae039(t, e);
}


function $8a816d5676e4c4a3$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $b106bdebf5664d73$export$2e2bcd8739ae039)(t, o);
}


function $fdc11dc7c710e893$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $fdc11dc7c710e893$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fdc11dc7c710e893$export$2e2bcd8739ae039(o);
}



function $2e1e524cd9f35d24$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $fdc11dc7c710e893$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $fdc11dc7c710e893$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $888901748170578d$export$2e2bcd8739ae039(t) {
    var i = (0, $2e1e524cd9f35d24$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $fdc11dc7c710e893$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $0244b1b9113fb618$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $888901748170578d$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}



var $7fPBF = parcelRequire("7fPBF");
function $a2ab6f3d408e39f4$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $8a816d5676e4c4a3$export$2e2bcd8739ae039)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $7fPBF.PureComponent));
        (0, $0244b1b9113fb618$export$2e2bcd8739ae039)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $a2ab6f3d408e39f4$export$2e2bcd8739ae039 = $a2ab6f3d408e39f4$var$withSideEffect;


/*
IE11 support
 */ var $64c6313292c996c0$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $64c6313292c996c0$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $64c6313292c996c0$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};



var $547637f472749193$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var $547637f472749193$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $547637f472749193$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $547637f472749193$var$isInert = function(node) {
    return node.hasAttribute('inert');
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var $547637f472749193$var$isVisibleUncached = function(node, checkParent) {
    return !node || $547637f472749193$var$isTopNode(node) || !$547637f472749193$var$isElementHidden(node) && !$547637f472749193$var$isInert(node) && checkParent($547637f472749193$var$getParentNode(node));
};
var $547637f472749193$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $547637f472749193$var$isVisibleUncached(node, $547637f472749193$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $547637f472749193$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$547637f472749193$var$isTopNode(node) ? $547637f472749193$export$b8550e27de209d85(node) ? checkParent($547637f472749193$var$getParentNode(node)) : false : true;
};
var $547637f472749193$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $547637f472749193$var$isAutoFocusAllowedUncached(node, $547637f472749193$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $547637f472749193$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $547637f472749193$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === 'BUTTON';
};
var $547637f472749193$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === 'INPUT';
};
var $547637f472749193$export$9d74f6fbc6f469d0 = function(node) {
    return $547637f472749193$export$88a6ceeed5737ba3(node) && node.type === 'radio';
};
var $547637f472749193$export$8197b0ea56b3b055 = function(node) {
    return !(($547637f472749193$export$88a6ceeed5737ba3(node) || $547637f472749193$export$65aad1b6bc934b11(node)) && (node.type === 'hidden' || node.disabled));
};
var $547637f472749193$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $fa189bd1dd0951d2$export$134ebef29fd94853));
    return ![
        true,
        'true',
        ''
    ].includes(attribute);
};
var $547637f472749193$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $547637f472749193$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $547637f472749193$export$602e5a0d338d7750 = function(node) {
    return !$547637f472749193$export$d94b8b58ec2f30eb(node);
};
var $547637f472749193$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};



var $abeb253dfaf92653$export$350ee6c095d98996 = function(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var $abeb253dfaf92653$var$getTabIndex = function(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute('tabindex')) return 0;
    }
    return node.tabIndex;
};
var $abeb253dfaf92653$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $64c6313292c996c0$export$45b10814cc054894)(nodes).map(function(node, index) {
        var tabIndex = $abeb253dfaf92653$var$getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($abeb253dfaf92653$export$350ee6c095d98996);
};




/**
 * list of the object to be considered as focusable
 */ var $af200ddb1312cc2b$export$8555f4622e95784 = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
];


var $25f7971b265ebd60$var$queryTabbables = (0, $af200ddb1312cc2b$export$8555f4622e95784).join(',');
var $25f7971b265ebd60$var$queryGuardTabbables = "".concat($25f7971b265ebd60$var$queryTabbables, ", [data-focus-guard]");
var $25f7971b265ebd60$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $64c6313292c996c0$export$45b10814cc054894)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $25f7971b265ebd60$var$queryGuardTabbables : $25f7971b265ebd60$var$queryTabbables) ? [
            child
        ] : [], $25f7971b265ebd60$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $25f7971b265ebd60$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $25f7971b265ebd60$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $25f7971b265ebd60$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $25f7971b265ebd60$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $25f7971b265ebd60$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $64c6313292c996c0$export$45b10814cc054894)(parent.parentNode.querySelectorAll($25f7971b265ebd60$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $25f7971b265ebd60$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $fa189bd1dd0951d2$export$70e9b4a1820af101), "]"));
    return (0, $64c6313292c996c0$export$45b10814cc054894)(parentFocus).map(function(node) {
        return $25f7971b265ebd60$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};


var $47993c2562b99895$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $64c6313292c996c0$export$45b10814cc054894)(nodes).filter(function(node) {
        return (0, $547637f472749193$export$3c9dc299685ad160)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $547637f472749193$export$8197b0ea56b3b055)(node);
    });
};
var $47993c2562b99895$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $64c6313292c996c0$export$45b10814cc054894)(nodes).filter(function(node) {
        return (0, $547637f472749193$export$bcaa50628f6a736e)(cache, node);
    });
};
var $47993c2562b99895$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $abeb253dfaf92653$export$cb40ee071f0d5226)($47993c2562b99895$export$6266a5cd5915dc33((0, $25f7971b265ebd60$export$f6768025e418420e)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $47993c2562b99895$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
    return (0, $abeb253dfaf92653$export$cb40ee071f0d5226)($47993c2562b99895$export$6266a5cd5915dc33((0, $25f7971b265ebd60$export$f6768025e418420e)(topNodes), visibilityCache), false);
};
var $47993c2562b99895$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $47993c2562b99895$export$6266a5cd5915dc33((0, $25f7971b265ebd60$export$853fa94d922e78b9)(topNode), visibilityCache);
};
var $47993c2562b99895$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $47993c2562b99895$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $64c6313292c996c0$export$45b10814cc054894)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $47993c2562b99895$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $47993c2562b99895$export$2344b14b097df817(child, element);
        });
    }
};


function $576094e59912fd4a$var$weakRef(value) {
    if (!value) return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === 'undefined') return function() {
        return value || null;
    };
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var $576094e59912fd4a$export$5061a7725be48ff9 = function(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: $576094e59912fd4a$var$weakRef(currentElement),
            parent: $576094e59912fd4a$var$weakRef(currentElement.parentElement),
            left: $576094e59912fd4a$var$weakRef(currentElement.previousElementSibling),
            right: $576094e59912fd4a$var$weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: $576094e59912fd4a$var$weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var $576094e59912fd4a$var$restoreFocusTo = function(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, $47993c2562b99895$export$3738e313571e2ad2)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var $576094e59912fd4a$export$d357db6e554ff59a = function(targetElement) {
    var location = $576094e59912fd4a$export$5061a7725be48ff9(targetElement);
    return function() {
        return $576094e59912fd4a$var$restoreFocusTo(location);
    };
};



/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $a60e58db6a2c2b86$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $a60e58db6a2c2b86$var$getTopParent = function(node) {
    return node.parentNode ? $a60e58db6a2c2b86$var$getTopParent(node.parentNode) : node;
};
var $a60e58db6a2c2b86$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $64c6313292c996c0$export$75093a47a9fa838d)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $fa189bd1dd0951d2$export$4f9a06cb7441a087));
        acc.push.apply(acc, group ? $a60e58db6a2c2b86$var$filterNested((0, $64c6313292c996c0$export$45b10814cc054894)($a60e58db6a2c2b86$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $fa189bd1dd0951d2$export$4f9a06cb7441a087), "=\"").concat(group, "\"]:not([").concat((0, $fa189bd1dd0951d2$export$aeda8252e54b50f7), "=\"disabled\"])")))) : [
            currentNode
        ]);
        return acc;
    }, []);
};





var $588912932a813bc4$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $588912932a813bc4$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $588912932a813bc4$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $588912932a813bc4$var$getParents(nodeA);
    var parentsB = $588912932a813bc4$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $588912932a813bc4$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $64c6313292c996c0$export$75093a47a9fa838d)(baseActiveElement);
    var leftEntries = (0, $64c6313292c996c0$export$75093a47a9fa838d)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $588912932a813bc4$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $588912932a813bc4$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $47993c2562b99895$export$2344b14b097df817)(common, topCommon)) topCommon = common;
                else topCommon = $588912932a813bc4$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $588912932a813bc4$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $47993c2562b99895$export$dc26309a71d1ce47)(node, visibilityCache));
    }, []);
};




var $253f6a637ee87d7a$export$f89ac71e91767111 = function(topNode) {
    var entries = (0, $a60e58db6a2c2b86$export$7e87c4720b9b279b)(topNode).filter((0, $547637f472749193$export$602e5a0d338d7750));
    var commonParent = (0, $588912932a813bc4$export$a9a7252b5f2e280e)(topNode, topNode, entries);
    var outerNodes = (0, $abeb253dfaf92653$export$cb40ee071f0d5226)((0, $25f7971b265ebd60$export$f6768025e418420e)([
        commonParent
    ], true), true, true);
    var innerElements = (0, $25f7971b265ebd60$export$f6768025e418420e)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $547637f472749193$export$d94b8b58ec2f30eb)(node)
        };
    });
};

var $eb3698ab71ab4cb2$export$c12b3da842c43a8 = function(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ('focus' in target) target.focus(focusOptions);
    if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
};




var $64ebddb8bb3b2b77$export$1b42c72592537703 = function(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error('no element or scope given');
        return {};
    }
    var shards = (0, $64c6313292c996c0$export$75093a47a9fa838d)(scope);
    if (shards.every(function(shard) {
        return !(0, $47993c2562b99895$export$2344b14b097df817)(shard, element);
    })) {
        console.error('Active element is not contained in the scope');
        return {};
    }
    var focusables = useTabbables ? (0, $47993c2562b99895$export$3738e313571e2ad2)(shards, new Map()) : (0, $47993c2562b99895$export$493d05a3a8e6532d)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var $64ebddb8bb3b2b77$var$getBoundary = function(shards, useTabbables) {
    var set = useTabbables ? (0, $47993c2562b99895$export$3738e313571e2ad2)((0, $64c6313292c996c0$export$75093a47a9fa838d)(shards), new Map()) : (0, $47993c2562b99895$export$493d05a3a8e6532d)((0, $64c6313292c996c0$export$75093a47a9fa838d)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var $64ebddb8bb3b2b77$var$defaultOptions = function(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var $64ebddb8bb3b2b77$var$moveFocus = function(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = $64ebddb8bb3b2b77$var$defaultOptions(options);
    var solution = $64ebddb8bb3b2b77$export$1b42c72592537703(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, $eb3698ab71ab4cb2$export$c12b3da842c43a8)(target.node, newOptions.focusOptions);
};
var $64ebddb8bb3b2b77$export$3b0237e8566c8d65 = function(fromElement, options) {
    if (options === void 0) options = {};
    $64ebddb8bb3b2b77$var$moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var $64ebddb8bb3b2b77$export$33b47db07a82b2fb = function(fromElement, options) {
    if (options === void 0) options = {};
    $64ebddb8bb3b2b77$var$moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var $64ebddb8bb3b2b77$var$pickBoundary = function(scope, options, what) {
    var _a;
    var boundary = $64ebddb8bb3b2b77$var$getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, $eb3698ab71ab4cb2$export$c12b3da842c43a8)(node.node, options.focusOptions);
};
var $64ebddb8bb3b2b77$export$2a791d8097a66406 = function(scope, options) {
    if (options === void 0) options = {};
    $64ebddb8bb3b2b77$var$pickBoundary(scope, options, 'first');
};
var $64ebddb8bb3b2b77$export$6a79073ddabfd6c3 = function(scope, options) {
    if (options === void 0) options = {};
    $64ebddb8bb3b2b77$var$pickBoundary(scope, options, 'last');
};




/**
 * returns active element from document or from nested shadowdoms
 */ var $119b6a97cad53c72$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};


var $959530f54ab600d9$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $959530f54ab600d9$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $119b6a97cad53c72$export$78d20aae35adef88)(function() {
        return activeElement.contentWindow.document;
    }) ? $959530f54ab600d9$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};


var $d07a703fa09abac5$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $d07a703fa09abac5$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $64c6313292c996c0$export$45b10814cc054894)(topNode.querySelectorAll('iframe')).some(function(node) {
        return $d07a703fa09abac5$var$focusInFrame(node, activeElement);
    }));
};
var $d07a703fa09abac5$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $959530f54ab600d9$export$cd4e5573fbe2b576)((0, $64c6313292c996c0$export$bcd7afcd904dce14)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $a60e58db6a2c2b86$export$7e87c4720b9b279b)(topNode).some(function(node) {
        return (0, $47993c2562b99895$export$2344b14b097df817)(node, activeElement) || $d07a703fa09abac5$var$focusInsideIframe(node, activeElement);
    });
};





var $a97e568617aa70ca$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $959530f54ab600d9$export$cd4e5573fbe2b576)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $64c6313292c996c0$export$45b10814cc054894)(inDocument.querySelectorAll("[".concat((0, $fa189bd1dd0951d2$export$54ecf528c58f9ef6), "]"))).some(function(node) {
        return (0, $47993c2562b99895$export$2344b14b097df817)(node, activeElement);
    });
};








var $bd831ddde50e963f$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $547637f472749193$export$9d74f6fbc6f469d0)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $bd831ddde50e963f$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $547637f472749193$export$9d74f6fbc6f469d0)(node) && node.name) return $bd831ddde50e963f$var$findSelectedRadio(node, nodes);
    return node;
};
var $bd831ddde50e963f$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($bd831ddde50e963f$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};



var $8b19cf57210745e9$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $bd831ddde50e963f$export$5261662167ad7ced)(nodes[0], nodes);
    return nodes[0];
};
var $8b19cf57210745e9$export$e06728ee87c96122 = function(nodes, node) {
    return nodes.indexOf((0, $bd831ddde50e963f$export$5261662167ad7ced)(node, nodes));
};



var $3ebc112684578f24$export$85710b12cf912438 = 'NEW_FOCUS';
var $3ebc112684578f24$export$65842178e9bb4205 = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $547637f472749193$export$d94b8b58ec2f30eb)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return $3ebc112684578f24$export$85710b12cf912438;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return $3ebc112684578f24$export$85710b12cf912438;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $bd831ddde50e963f$export$4a5a72a7124e45f9)(outerNodes);
    var currentFocusableIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var previousFocusableIndex = lastNode ? correctedNodes.indexOf(lastNode) : currentFocusableIndex;
    var tabbableNodes = correctedNodes.filter(function(node) {
        return node.tabIndex >= 0;
    });
    var currentTabbableIndex = activeElement !== undefined ? tabbableNodes.indexOf(activeElement) : -1;
    var previousTabbableIndex = lastNode ? tabbableNodes.indexOf(lastNode) : currentTabbableIndex;
    var focusIndexDiff = currentTabbableIndex >= 0 && previousTabbableIndex >= 0 ? previousTabbableIndex - currentTabbableIndex : previousFocusableIndex - currentFocusableIndex;
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, $8b19cf57210745e9$export$e06728ee87c96122)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, $8b19cf57210745e9$export$e06728ee87c96122)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(focusIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};








var $0b3e04baa5c9ad06$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $547637f472749193$export$698b339b0c8edae3)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== 'false' || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $0b3e04baa5c9ad06$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $47993c2562b99895$export$2f70373d403a5d2b)(nodes.filter($0b3e04baa5c9ad06$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $8b19cf57210745e9$export$f4e86cfa0679b9cc)(autoFocusable);
    return (0, $8b19cf57210745e9$export$f4e86cfa0679b9cc)((0, $47993c2562b99895$export$2f70373d403a5d2b)(orderedNodes));
};





var $c48dba24faa76008$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $547637f472749193$export$4e62c701997796c1));
};
var $c48dba24faa76008$export$305758c744b57f6f = function(topNode, lastNode) {
    var activeElement = (0, $959530f54ab600d9$export$cd4e5573fbe2b576)((0, $64c6313292c996c0$export$75093a47a9fa838d)(topNode).length > 0 ? document : (0, $64c6313292c996c0$export$bcd7afcd904dce14)(topNode).ownerDocument);
    var entries = (0, $a60e58db6a2c2b86$export$7e87c4720b9b279b)(topNode).filter((0, $547637f472749193$export$602e5a0d338d7750));
    var commonParent = (0, $588912932a813bc4$export$a9a7252b5f2e280e)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $47993c2562b99895$export$493d05a3a8e6532d)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, $547637f472749193$export$602e5a0d338d7750)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, $47993c2562b99895$export$493d05a3a8e6532d)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $c48dba24faa76008$var$reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $3ebc112684578f24$export$65842178e9bb4205)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, $3ebc112684578f24$export$85710b12cf912438)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, $0b3e04baa5c9ad06$export$cfb742983e257555)(anyFocusable, innerTabbable, (0, $588912932a813bc4$export$8f99714c70a37db1)(entries, visibilityCache)) || (0, $0b3e04baa5c9ad06$export$cfb742983e257555)(anyFocusable, innerFocusables, (0, $588912932a813bc4$export$8f99714c70a37db1)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};


var $d1bc10d32209a709$var$guardCount = 0;
var $d1bc10d32209a709$var$lockDisabled = false;
var $d1bc10d32209a709$export$cd599851e879a025 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $c48dba24faa76008$export$305758c744b57f6f)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if ($d1bc10d32209a709$var$lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if ($d1bc10d32209a709$var$guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $d1bc10d32209a709$var$lockDisabled = true;
            setTimeout(function() {
                $d1bc10d32209a709$var$lockDisabled = false;
            }, 1);
            return;
        }
        $d1bc10d32209a709$var$guardCount++;
        (0, $eb3698ab71ab4cb2$export$c12b3da842c43a8)(focusable.node, options.focusOptions);
        $d1bc10d32209a709$var$guardCount--;
    }
};





/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var $60b760cce460b4f8$export$1a988e7317c65621 = $fa189bd1dd0951d2$exports;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var $60b760cce460b4f8$var$deprecated_default_moveFocusInside = (0, $d1bc10d32209a709$export$cd599851e879a025);
var $60b760cce460b4f8$export$2e2bcd8739ae039 //
 = $60b760cce460b4f8$var$deprecated_default_moveFocusInside;


function $2d6186134c60e3e5$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $2d6186134c60e3e5$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $2d6186134c60e3e5$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};



var $aaf28cf1dce384e3$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $aaf28cf1dce384e3$var$isFreeFocus = function isFreeFocus() {
    return $aaf28cf1dce384e3$var$focusOnBody() || (0, $a97e568617aa70ca$export$be6b21806d3fd485)();
};
var $aaf28cf1dce384e3$var$lastActiveTrap = null;
var $aaf28cf1dce384e3$var$lastActiveFocus = null;
var $aaf28cf1dce384e3$var$tryRestoreFocus = function tryRestoreFocus() {
    return null;
};
var $aaf28cf1dce384e3$var$lastPortaledElement = null;
var $aaf28cf1dce384e3$var$focusWasOutsideWindow = false;
var $aaf28cf1dce384e3$var$windowFocused = false;
var $aaf28cf1dce384e3$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $aaf28cf1dce384e3$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($aaf28cf1dce384e3$var$lastActiveTrap.whiteList || $aaf28cf1dce384e3$var$defaultWhitelist)(activeElement);
};
var $aaf28cf1dce384e3$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $aaf28cf1dce384e3$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $aaf28cf1dce384e3$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $aaf28cf1dce384e3$var$lastPortaledElement && $aaf28cf1dce384e3$var$lastPortaledElement.portaledElement === element;
};
function $aaf28cf1dce384e3$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $aaf28cf1dce384e3$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($aaf28cf1dce384e3$var$focusWasOutsideWindow);
    return $aaf28cf1dce384e3$var$focusWasOutsideWindow === 'meanwhile';
};
var $aaf28cf1dce384e3$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $aaf28cf1dce384e3$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $aaf28cf1dce384e3$var$checkInHost(activeElement, area, area);
    });
};
var $aaf28cf1dce384e3$var$getNodeFocusables = function getNodeFocusables(nodes) {
    return (0, $47993c2562b99895$export$493d05a3a8e6532d)(nodes, new Map());
};
var $aaf28cf1dce384e3$var$isNotFocusable = function isNotFocusable(node) {
    return !$aaf28cf1dce384e3$var$getNodeFocusables([
        node.parentNode
    ]).some(function(el) {
        return el.node === node;
    });
};
var $aaf28cf1dce384e3$var$activateTrap = function activateTrap() {
    var result = false;
    if ($aaf28cf1dce384e3$var$lastActiveTrap) {
        var _lastActiveTrap = $aaf28cf1dce384e3$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions, noFocusGuards = _lastActiveTrap.noFocusGuards;
        var workingNode = observed || $aaf28cf1dce384e3$var$lastPortaledElement && $aaf28cf1dce384e3$var$lastPortaledElement.portaledElement;
        if ($aaf28cf1dce384e3$var$focusOnBody() && $aaf28cf1dce384e3$var$lastActiveFocus && $aaf28cf1dce384e3$var$lastActiveFocus !== document.body) {
            if (!document.body.contains($aaf28cf1dce384e3$var$lastActiveFocus) || $aaf28cf1dce384e3$var$isNotFocusable($aaf28cf1dce384e3$var$lastActiveFocus)) {
                var newTarget = $aaf28cf1dce384e3$var$tryRestoreFocus();
                if (newTarget) newTarget.focus();
            }
        }
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $2d6186134c60e3e5$export$c613fed06e332533)).filter(Boolean));
            var shouldForceRestoreFocus = function shouldForceRestoreFocus() {
                if (!$aaf28cf1dce384e3$var$focusWasOutside(crossFrame) || !noFocusGuards || !$aaf28cf1dce384e3$var$lastActiveFocus || $aaf28cf1dce384e3$var$windowFocused) return false;
                var nodes = $aaf28cf1dce384e3$var$getNodeFocusables(workingArea);
                var lastIndex = nodes.findIndex(function(_ref) {
                    var node = _ref.node;
                    return node === $aaf28cf1dce384e3$var$lastActiveFocus;
                });
                return lastIndex === 0 || lastIndex === nodes.length - 1;
            };
            if (!activeElement || $aaf28cf1dce384e3$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || shouldForceRestoreFocus() || !$aaf28cf1dce384e3$var$isFreeFocus() || !$aaf28cf1dce384e3$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $d07a703fa09abac5$export$20115f8da7baa6fa)(workingArea) || activeElement && $aaf28cf1dce384e3$var$withinHost(activeElement, workingArea) || $aaf28cf1dce384e3$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$aaf28cf1dce384e3$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $d1bc10d32209a709$export$cd599851e879a025)(workingArea, $aaf28cf1dce384e3$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $aaf28cf1dce384e3$var$lastPortaledElement = {};
                        }
                    }
                    $aaf28cf1dce384e3$var$lastActiveFocus = document && document.activeElement;
                    if ($aaf28cf1dce384e3$var$lastActiveFocus !== document.body) $aaf28cf1dce384e3$var$tryRestoreFocus = (0, $576094e59912fd4a$export$d357db6e554ff59a)($aaf28cf1dce384e3$var$lastActiveFocus);
                    $aaf28cf1dce384e3$var$focusWasOutsideWindow = false;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $253f6a637ee87d7a$export$f89ac71e91767111)(workingArea);
                var focusedIndex = allNodes.map(function(_ref2) {
                    var node = _ref2.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref3) {
                        var guard = _ref3.guard, node = _ref3.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref4) {
                        var node = _ref4.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $aaf28cf1dce384e3$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $aaf28cf1dce384e3$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $aaf28cf1dce384e3$var$onTrap = function onTrap(event) {
    if ($aaf28cf1dce384e3$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $aaf28cf1dce384e3$var$onBlur = function onBlur() {
    return (0, $2d6186134c60e3e5$export$6523025722806278)($aaf28cf1dce384e3$var$activateTrap);
};
var $aaf28cf1dce384e3$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $aaf28cf1dce384e3$var$recordPortal(currentNode, source);
};
var $aaf28cf1dce384e3$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $aaf28cf1dce384e3$var$FocusTrap = function FocusTrap(_ref5) {
    var children = _ref5.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        onBlur: $aaf28cf1dce384e3$var$onBlur,
        onFocus: $aaf28cf1dce384e3$var$onFocus
    }, children);
};
$aaf28cf1dce384e3$var$FocusTrap.propTypes = {};
var $aaf28cf1dce384e3$var$onWindowFocus = function onWindowFocus() {
    $aaf28cf1dce384e3$var$windowFocused = true;
};
var $aaf28cf1dce384e3$var$onWindowBlur = function onWindowBlur() {
    $aaf28cf1dce384e3$var$windowFocused = false;
    $aaf28cf1dce384e3$var$focusWasOutsideWindow = 'just';
    (0, $2d6186134c60e3e5$export$6523025722806278)(function() {
        $aaf28cf1dce384e3$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $aaf28cf1dce384e3$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $aaf28cf1dce384e3$var$onTrap);
    document.addEventListener('focusout', $aaf28cf1dce384e3$var$onBlur);
    window.addEventListener('focus', $aaf28cf1dce384e3$var$onWindowFocus);
    window.addEventListener('blur', $aaf28cf1dce384e3$var$onWindowBlur);
};
var $aaf28cf1dce384e3$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $aaf28cf1dce384e3$var$onTrap);
    document.removeEventListener('focusout', $aaf28cf1dce384e3$var$onBlur);
    window.removeEventListener('focus', $aaf28cf1dce384e3$var$onWindowFocus);
    window.removeEventListener('blur', $aaf28cf1dce384e3$var$onWindowBlur);
};
function $aaf28cf1dce384e3$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref6) {
        var disabled = _ref6.disabled;
        return !disabled;
    });
}
var $aaf28cf1dce384e3$var$focusLockAPI = {
    moveFocusInside: (0, $d1bc10d32209a709$export$cd599851e879a025),
    focusInside: (0, $d07a703fa09abac5$export$20115f8da7baa6fa),
    focusNextElement: (0, $64ebddb8bb3b2b77$export$3b0237e8566c8d65),
    focusPrevElement: (0, $64ebddb8bb3b2b77$export$33b47db07a82b2fb),
    focusFirstElement: (0, $64ebddb8bb3b2b77$export$2a791d8097a66406),
    focusLastElement: (0, $64ebddb8bb3b2b77$export$6a79073ddabfd6c3),
    captureFocusRestore: (0, $576094e59912fd4a$export$d357db6e554ff59a)
};
function $aaf28cf1dce384e3$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$aaf28cf1dce384e3$var$lastActiveTrap) $aaf28cf1dce384e3$var$attachHandler();
    var lastTrap = $aaf28cf1dce384e3$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $aaf28cf1dce384e3$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref7) {
            var id = _ref7.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $aaf28cf1dce384e3$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($aaf28cf1dce384e3$var$focusLockAPI);
        $aaf28cf1dce384e3$var$activateTrap(true);
        (0, $2d6186134c60e3e5$export$6523025722806278)($aaf28cf1dce384e3$var$activateTrap);
    } else {
        $aaf28cf1dce384e3$var$detachHandler();
        $aaf28cf1dce384e3$var$lastActiveFocus = null;
    }
}
(0, $4b5bcfe03091b424$export$5733e022b1d538cb).assignSyncMedium($aaf28cf1dce384e3$var$onFocus);
(0, $4b5bcfe03091b424$export$b3e9a9312f73723c).assignMedium($aaf28cf1dce384e3$var$onBlur);
(0, $4b5bcfe03091b424$export$3a1d52767cbc07b8).assignMedium(function(cb) {
    return cb($aaf28cf1dce384e3$var$focusLockAPI);
});
var $aaf28cf1dce384e3$export$2e2bcd8739ae039 = (0, $a2ab6f3d408e39f4$export$2e2bcd8739ae039)($aaf28cf1dce384e3$var$reducePropsToState, $aaf28cf1dce384e3$var$handleStateChangeOnClient)($aaf28cf1dce384e3$var$FocusWatcher);


var $b301888438efb0fe$var$FocusLockCombination = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e17e6ac998763caf$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        sideCar: (0, $aaf28cf1dce384e3$export$2e2bcd8739ae039),
        ref: ref
    }, props));
});
var $b301888438efb0fe$var$_ref = (0, $e17e6ac998763caf$export$2e2bcd8739ae039).propTypes || {}, $b301888438efb0fe$var$sideCar = $b301888438efb0fe$var$_ref.sideCar, $b301888438efb0fe$var$propTypes = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)($b301888438efb0fe$var$_ref, [
    "sideCar"
]);
$b301888438efb0fe$var$FocusLockCombination.propTypes = {};
var $b301888438efb0fe$export$2e2bcd8739ae039 = $b301888438efb0fe$var$FocusLockCombination;



var $2cb7353992a884b7$export$2e2bcd8739ae039 = (0, $b301888438efb0fe$export$2e2bcd8739ae039);


var $eefcbb4433f6e9f3$exports = {};
'use strict';
Object.defineProperty($eefcbb4433f6e9f3$exports, "__esModule", {
    value: true
});
var $6708ffe7bd9e8461$exports = {};
'use strict';
Object.defineProperty($6708ffe7bd9e8461$exports, "__esModule", {
    value: true
});
var $6708ffe7bd9e8461$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $7fPBF = parcelRequire("7fPBF");
var $6708ffe7bd9e8461$var$_react2 = $6708ffe7bd9e8461$var$_interopRequireDefault($7fPBF);
var $913ab7e52a911d58$exports = {};
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if ($913ab7e52a911d58$exports) $913ab7e52a911d58$exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();


var $d70035f4e2813f1f$exports = {};
'use strict';
Object.defineProperty($d70035f4e2813f1f$exports, "__esModule", {
    value: true
});
$d70035f4e2813f1f$exports.TouchScrollable = undefined;
var $d70035f4e2813f1f$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $d70035f4e2813f1f$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $7fPBF = parcelRequire("7fPBF");

var $ff3334bd4206e4db$exports = {};
'use strict';
Object.defineProperty($ff3334bd4206e4db$exports, "__esModule", {
    value: true
});
$ff3334bd4206e4db$exports.pipe = $ff3334bd4206e4db$exports.listenerOptions = undefined;
$ff3334bd4206e4db$exports.preventTouchMove = $ff3334bd4206e4db$var$preventTouchMove;
$ff3334bd4206e4db$exports.allowTouchMove = $ff3334bd4206e4db$var$allowTouchMove;
$ff3334bd4206e4db$exports.preventInertiaScroll = $ff3334bd4206e4db$var$preventInertiaScroll;
$ff3334bd4206e4db$exports.isTouchDevice = $ff3334bd4206e4db$var$isTouchDevice;
$ff3334bd4206e4db$exports.camelToKebab = $ff3334bd4206e4db$var$camelToKebab;
$ff3334bd4206e4db$exports.parse = $ff3334bd4206e4db$var$parse;
$ff3334bd4206e4db$exports.getPadding = $ff3334bd4206e4db$var$getPadding;
$ff3334bd4206e4db$exports.getWindowHeight = $ff3334bd4206e4db$var$getWindowHeight;
$ff3334bd4206e4db$exports.getDocumentHeight = $ff3334bd4206e4db$var$getDocumentHeight;
$ff3334bd4206e4db$exports.makeStyleTag = $ff3334bd4206e4db$var$makeStyleTag;
$ff3334bd4206e4db$exports.injectStyles = $ff3334bd4206e4db$var$injectStyles;
$ff3334bd4206e4db$exports.insertStyleTag = $ff3334bd4206e4db$var$insertStyleTag;

var $ff3334bd4206e4db$var$listenerOptions = $ff3334bd4206e4db$exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $ff3334bd4206e4db$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $ff3334bd4206e4db$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $ff3334bd4206e4db$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $ff3334bd4206e4db$var$isTouchDevice() {
    if (!$913ab7e52a911d58$exports.canUseDOM) return false;
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $ff3334bd4206e4db$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function $ff3334bd4206e4db$var$parse(val) {
    return isNaN(val) ? val : val + 'px';
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $ff3334bd4206e4db$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $ff3334bd4206e4db$var$pipe = $ff3334bd4206e4db$exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($ff3334bd4206e4db$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $ff3334bd4206e4db$var$getPadding() {
    if (!$913ab7e52a911d58$exports.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $ff3334bd4206e4db$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($913ab7e52a911d58$exports.canUseDOM) return window.innerHeight * multiplier;
}
function $ff3334bd4206e4db$var$getDocumentHeight() {
    if ($913ab7e52a911d58$exports.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $ff3334bd4206e4db$var$makeStyleTag() {
    if (!$913ab7e52a911d58$exports.canUseDOM) return;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    tag.setAttribute('data-react-scrolllock', '');
    return tag;
}
function $ff3334bd4206e4db$var$injectStyles(tag, css) {
    if (!$913ab7e52a911d58$exports.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $ff3334bd4206e4db$var$insertStyleTag(tag) {
    if (!$913ab7e52a911d58$exports.canUseDOM) return;
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}


function $d70035f4e2813f1f$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $d70035f4e2813f1f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d70035f4e2813f1f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $d70035f4e2813f1f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $d70035f4e2813f1f$var$TouchScrollable = $d70035f4e2813f1f$exports.TouchScrollable = function(_PureComponent) {
    $d70035f4e2813f1f$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $d70035f4e2813f1f$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $d70035f4e2813f1f$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $d70035f4e2813f1f$var$_possibleConstructorReturn(_this, _ret);
    }
    $d70035f4e2813f1f$var$_createClass(TouchScrollable, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$913ab7e52a911d58$exports.canUseEventListeners) return;
                this.scrollableArea.addEventListener('touchstart', $ff3334bd4206e4db$exports.preventInertiaScroll, $ff3334bd4206e4db$exports.listenerOptions);
                this.scrollableArea.addEventListener('touchmove', $ff3334bd4206e4db$exports.allowTouchMove, $ff3334bd4206e4db$exports.listenerOptions);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (!$913ab7e52a911d58$exports.canUseEventListeners) return;
                this.scrollableArea.removeEventListener('touchstart', $ff3334bd4206e4db$exports.preventInertiaScroll, $ff3334bd4206e4db$exports.listenerOptions);
                this.scrollableArea.removeEventListener('touchmove', $ff3334bd4206e4db$exports.allowTouchMove, $ff3334bd4206e4db$exports.listenerOptions);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, rest = $d70035f4e2813f1f$var$_objectWithoutProperties(_props, [
                    'children'
                ]);
                return typeof children === 'function' ? children(this.getScrollableArea) : (0, $7fPBF.cloneElement)(children, $d70035f4e2813f1f$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($7fPBF.PureComponent);


var $a052f3204f708fdc$exports = {};
'use strict';
Object.defineProperty($a052f3204f708fdc$exports, "__esModule", {
    value: true
});
var $a052f3204f708fdc$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
$a052f3204f708fdc$exports.default = $a052f3204f708fdc$var$withLockSheet;

var $7fPBF = parcelRequire("7fPBF");
var $a052f3204f708fdc$var$_react2 = $a052f3204f708fdc$var$_interopRequireDefault($7fPBF);

function $a052f3204f708fdc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a052f3204f708fdc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a052f3204f708fdc$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a052f3204f708fdc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $a052f3204f708fdc$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $a052f3204f708fdc$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $a052f3204f708fdc$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $a052f3204f708fdc$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $ff3334bd4206e4db$exports.makeStyleTag)();
                if (!sheet) return;
                (0, $ff3334bd4206e4db$exports.injectStyles)(sheet, styles);
                (0, $ff3334bd4206e4db$exports.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $ff3334bd4206e4db$exports.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $ff3334bd4206e4db$exports.getPadding)() : null;
                var styles = 'body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n        ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n      }';
                return styles;
            }, _temp), $a052f3204f708fdc$var$_possibleConstructorReturn(_this, _ret);
        }
        $a052f3204f708fdc$var$_createClass(SheetProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: 'removeSheet',
                value: function removeSheet() {
                    if (!this.sheet) return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $a052f3204f708fdc$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($7fPBF.PureComponent);
}


var $6708ffe7bd9e8461$var$_withLockSheet2 = $6708ffe7bd9e8461$var$_interopRequireDefault($a052f3204f708fdc$exports);
var $ae9ffb51564bedce$exports = {};
'use strict';
Object.defineProperty($ae9ffb51564bedce$exports, "__esModule", {
    value: true
});
var $ae9ffb51564bedce$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
$ae9ffb51564bedce$exports.default = $ae9ffb51564bedce$var$withTouchListeners;

var $7fPBF = parcelRequire("7fPBF");
var $ae9ffb51564bedce$var$_react2 = $ae9ffb51564bedce$var$_interopRequireDefault($7fPBF);


function $ae9ffb51564bedce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ae9ffb51564bedce$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ae9ffb51564bedce$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $ae9ffb51564bedce$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $ae9ffb51564bedce$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $ae9ffb51564bedce$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $ae9ffb51564bedce$var$_classCallCheck(this, TouchProvider);
            return $ae9ffb51564bedce$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $ae9ffb51564bedce$var$_createClass(TouchProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (!$913ab7e52a911d58$exports.canUseDOM || !(0, $ff3334bd4206e4db$exports.isTouchDevice)()) return;
                    document.addEventListener('touchmove', $ff3334bd4206e4db$exports.preventTouchMove, $ff3334bd4206e4db$exports.listenerOptions);
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (!$913ab7e52a911d58$exports.canUseDOM || !(0, $ff3334bd4206e4db$exports.isTouchDevice)()) return;
                    document.removeEventListener('touchmove', $ff3334bd4206e4db$exports.preventTouchMove, $ff3334bd4206e4db$exports.listenerOptions);
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $ae9ffb51564bedce$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($7fPBF.PureComponent);
}


var $6708ffe7bd9e8461$var$_withTouchListeners2 = $6708ffe7bd9e8461$var$_interopRequireDefault($ae9ffb51564bedce$exports);

function $6708ffe7bd9e8461$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6708ffe7bd9e8461$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6708ffe7bd9e8461$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $6708ffe7bd9e8461$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $6708ffe7bd9e8461$var$ScrollLock = function(_PureComponent) {
    $6708ffe7bd9e8461$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $6708ffe7bd9e8461$var$_classCallCheck(this, ScrollLock);
        return $6708ffe7bd9e8461$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $6708ffe7bd9e8461$var$_createClass(ScrollLock, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$913ab7e52a911d58$exports.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return children ? $6708ffe7bd9e8461$var$_react2.default.createElement($d70035f4e2813f1f$exports.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($7fPBF.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $6708ffe7bd9e8461$var$compose = (0, $ff3334bd4206e4db$exports.pipe)($6708ffe7bd9e8461$var$_withTouchListeners2.default, $6708ffe7bd9e8461$var$_withLockSheet2.default);
var $6708ffe7bd9e8461$var$SheetLock = $6708ffe7bd9e8461$var$compose($6708ffe7bd9e8461$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $6708ffe7bd9e8461$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $6708ffe7bd9e8461$var$_react2.default.createElement($6708ffe7bd9e8461$var$SheetLock, props) : props.children;
};
$6708ffe7bd9e8461$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
$6708ffe7bd9e8461$exports.default = $6708ffe7bd9e8461$var$LockToggle;


Object.defineProperty($eefcbb4433f6e9f3$exports, 'default', {
    enumerable: true,
    get: function get() {
        return $eefcbb4433f6e9f3$var$_interopRequireDefault($6708ffe7bd9e8461$exports).default;
    }
});

Object.defineProperty($eefcbb4433f6e9f3$exports, 'TouchScrollable', {
    enumerable: true,
    get: function get() {
        return $d70035f4e2813f1f$exports.TouchScrollable;
    }
});
function $eefcbb4433f6e9f3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}



/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");
const $11e6ea2b308c3093$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $11e6ea2b308c3093$var$ATOMIC_GROUP_LENGTH = 5;
function $11e6ea2b308c3093$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $11e6ea2b308c3093$var$UNDERSCORE_UNICODE ? $11e6ea2b308c3093$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $e02bd199f5bb52fc$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}



var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");


var $j9spr = parcelRequire("j9spr");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $eihxX = parcelRequire("eihxX");

var $eaTmW = parcelRequire("eaTmW");

var $eKeTJ = parcelRequire("eKeTJ");

var $l8Sa3 = parcelRequire("l8Sa3");

var $8MJe2 = parcelRequire("8MJe2");

var $bRUy3 = parcelRequire("bRUy3");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $8MJe2 = parcelRequire("8MJe2");
function $294720a8d6604d4a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $294720a8d6604d4a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $294720a8d6604d4a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $294720a8d6604d4a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $294720a8d6604d4a$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $294720a8d6604d4a$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $294720a8d6604d4a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $294720a8d6604d4a$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(updater) === 'object') this.payload = $294720a8d6604d4a$var$_objectSpread($294720a8d6604d4a$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $770e64262e583ed8$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($eihxX)))(t, $770e64262e583ed8$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(t).constructor) : o.apply(t, e));
}
function $770e64262e583ed8$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($770e64262e583ed8$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $770e64262e583ed8$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($eKeTJ)))((0, (/*@__PURE__*/$parcel$interopDefault($eaTmW)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $770e64262e583ed8$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $770e64262e583ed8$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $770e64262e583ed8$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, UIAnalyticsEvent);
        _this = $770e64262e583ed8$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($l8Sa3)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $770e64262e583ed8$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $294720a8d6604d4a$export$2e2bcd8739ae039));



var $7fPBF = parcelRequire("7fPBF");

var $f125197a22118c89$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $7fPBF.useContext)((0, $e420dde09fb890a4$export$2e2bcd8739ae039));
};


function $3cac21e71ca99dc8$export$5bf35293e545f20c() {
    var analyticsContext = (0, $f125197a22118c89$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $6ff1114199100bef$export$33752cf3ee811995)(function(payload) {
        return new (0, $770e64262e583ed8$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $7fPBF = parcelRequire("7fPBF");
var $c335bb3ddd37fe3b$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $7fPBF.useRef)(value);
    ref.current = value;
    return ref;
};


function $e75ff324315e680c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e75ff324315e680c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e75ff324315e680c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e75ff324315e680c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e75ff324315e680c$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $3cac21e71ca99dc8$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $c335bb3ddd37fe3b$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $c335bb3ddd37fe3b$export$1d27a74659855e44)(fn);
    var handler = (0, $7fPBF.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $e75ff324315e680c$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}


/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $e594dcfa2fc03192$export$2e2bcd8739ae039() {}


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $cc5d95c5b888d6a5$export$4b84fd0e2c617bd = '#FFEBE6';
var $cc5d95c5b888d6a5$export$b34b069eff244586 = '#FFBDAD';
var $cc5d95c5b888d6a5$export$be802dd0d8b57f35 = '#FF8F73';
var $cc5d95c5b888d6a5$export$60847d42f9da92a6 = '#FF7452';
var $cc5d95c5b888d6a5$export$4a7404f376229999 = '#FF5630';
var $cc5d95c5b888d6a5$export$2010d0fb4295b346 = '#DE350B';
var $cc5d95c5b888d6a5$export$2837b5a1a71d5c02 = '#BF2600';
var $cc5d95c5b888d6a5$export$8d9596b529bbb9cf = '#FFFAE6';
var $cc5d95c5b888d6a5$export$41060a744ab0b7ae = '#FFF0B3';
var $cc5d95c5b888d6a5$export$1cc05bbbf340e559 = '#FFE380';
var $cc5d95c5b888d6a5$export$5aae31392d72caaa = '#FFC400';
var $cc5d95c5b888d6a5$export$c6930421db9fa514 = '#FFAB00';
var $cc5d95c5b888d6a5$export$59619663aa6500fb = '#FF991F';
var $cc5d95c5b888d6a5$export$874739ea9e379ab6 = '#FF8B00';
var $cc5d95c5b888d6a5$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $cc5d95c5b888d6a5$export$69a3bf21b9686c2b = '#ABF5D1';
var $cc5d95c5b888d6a5$export$afbce1382ec95f73 = '#79F2C0';
var $cc5d95c5b888d6a5$export$747d86715d4175de = '#57D9A3';
var $cc5d95c5b888d6a5$export$940e1f69e873f202 = '#36B37E';
var $cc5d95c5b888d6a5$export$a49394138f7b8e85 = '#00875A';
var $cc5d95c5b888d6a5$export$6fa04827ac68a4fb = '#006644';
var $cc5d95c5b888d6a5$export$226de0355ed012f8 = '#DEEBFF';
var $cc5d95c5b888d6a5$export$8c13c2ee36917869 = '#B3D4FF';
var $cc5d95c5b888d6a5$export$ecfc1dff386a3e7a = '#4C9AFF';
var $cc5d95c5b888d6a5$export$215b7063051591f1 = '#2684FF';
var $cc5d95c5b888d6a5$export$e62e8919cca44969 = '#0065FF';
var $cc5d95c5b888d6a5$export$b3de0ae08da2ce64 = '#0052CC';
var $cc5d95c5b888d6a5$export$a6ee3d71bc067634 = '#0747A6';
var $cc5d95c5b888d6a5$export$67f15409e87642a1 = '#669DF1';
var $cc5d95c5b888d6a5$export$f0539dbc42dbb067 = '#8FB8F6';
var $cc5d95c5b888d6a5$export$363e4475840015bb = '#EAE6FF';
var $cc5d95c5b888d6a5$export$4b0a4417ed59760f = '#C0B6F2';
var $cc5d95c5b888d6a5$export$6011520a64d9a187 = '#998DD9';
var $cc5d95c5b888d6a5$export$a7175d4e9206bc80 = '#8777D9';
var $cc5d95c5b888d6a5$export$b48405b95304b5a1 = '#6554C0';
var $cc5d95c5b888d6a5$export$c71e4279dd54a18d = '#5243AA';
var $cc5d95c5b888d6a5$export$147899de772240ec = '#403294';
var $cc5d95c5b888d6a5$export$2cf711fe14c66f06 = '#E6FCFF';
var $cc5d95c5b888d6a5$export$7a8f4d33f6f9772c = '#B3F5FF';
var $cc5d95c5b888d6a5$export$776c9c497ef08533 = '#79E2F2';
var $cc5d95c5b888d6a5$export$69cb3ca10c1e330e = '#00C7E6';
var $cc5d95c5b888d6a5$export$9dc1ef0f3f48059b = '#00B8D9';
var $cc5d95c5b888d6a5$export$7c835c78b6fcdef8 = '#00A3BF';
var $cc5d95c5b888d6a5$export$6036577f95c3877e = '#008DA6';
var $cc5d95c5b888d6a5$export$29a4f05edc054374 = '#FFFFFF';
var $cc5d95c5b888d6a5$export$e655ef011c4aa1a2 = '#FAFBFC';
var $cc5d95c5b888d6a5$export$9fdfb749e33cdf97 = '#F4F5F7';
var $cc5d95c5b888d6a5$export$3e51e8f1440314ba = '#EBECF0';
var $cc5d95c5b888d6a5$export$1ce2d1575d444ceb = '#DFE1E6';
var $cc5d95c5b888d6a5$export$8754fc7e6d8b3000 = '#C1C7D0';
var $cc5d95c5b888d6a5$export$c2e91cbeada39b8b = '#B3BAC5';
var $cc5d95c5b888d6a5$export$5f71e19f3a7ad9de = '#A5ADBA';
var $cc5d95c5b888d6a5$export$eaa8c8a70ac22806 = '#97A0AF';
var $cc5d95c5b888d6a5$export$7c87d337fb91a97d = '#8993A4';
var $cc5d95c5b888d6a5$export$d6447c357493214f = '#7A869A';
var $cc5d95c5b888d6a5$export$f563ee71e9ee74cd = '#6B778C';
var $cc5d95c5b888d6a5$export$e2ef2124cf4024b1 = '#5E6C84';
var $cc5d95c5b888d6a5$export$eece5f492e429f08 = '#505F79';
var $cc5d95c5b888d6a5$export$c39c0fe0f26207ae = '#42526E';
var $cc5d95c5b888d6a5$export$7090862dc3038a9f = '#344563';
var $cc5d95c5b888d6a5$export$ad0bacf983b7ddaa = '#253858';
var $cc5d95c5b888d6a5$export$7d61b15e0da132af = '#172B4D';
var $cc5d95c5b888d6a5$export$fbda843f0a27fe96 = '#091E42';
var $cc5d95c5b888d6a5$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $cc5d95c5b888d6a5$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $cc5d95c5b888d6a5$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $cc5d95c5b888d6a5$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $cc5d95c5b888d6a5$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $cc5d95c5b888d6a5$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $cc5d95c5b888d6a5$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $cc5d95c5b888d6a5$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $cc5d95c5b888d6a5$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $cc5d95c5b888d6a5$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $cc5d95c5b888d6a5$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $cc5d95c5b888d6a5$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $cc5d95c5b888d6a5$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $cc5d95c5b888d6a5$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $cc5d95c5b888d6a5$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $cc5d95c5b888d6a5$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $cc5d95c5b888d6a5$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $cc5d95c5b888d6a5$export$2f6319cf7d736c2a = '#E6EDFA';
var $cc5d95c5b888d6a5$export$95126bc8884d6634 = '#DCE5F5';
var $cc5d95c5b888d6a5$export$8338d8c35d44ff1 = '#CED9EB';
var $cc5d95c5b888d6a5$export$5368d76ae4fbbda7 = '#B8C7E0';
var $cc5d95c5b888d6a5$export$9f0a771d16ec8d36 = '#ABBBD6';
var $cc5d95c5b888d6a5$export$abcf8c38338b4aa5 = '#9FB0CC';
var $cc5d95c5b888d6a5$export$97e81faa16a182c7 = '#8C9CB8';
var $cc5d95c5b888d6a5$export$bfe21c59123ecf33 = '#7988A3';
var $cc5d95c5b888d6a5$export$ee82aa2ea6a1558 = '#67758F';
var $cc5d95c5b888d6a5$export$682927c6ed76be02 = '#56637A';
var $cc5d95c5b888d6a5$export$91fd9994c5be9757 = '#455166';
var $cc5d95c5b888d6a5$export$d281fbfe3cff2df6 = '#3B475C';
var $cc5d95c5b888d6a5$export$3902c91d8b98a753 = '#313D52';
var $cc5d95c5b888d6a5$export$8e8133c1ba5845b5 = '#283447';
var $cc5d95c5b888d6a5$export$33ff357f6620b39 = '#202B3D';
var $cc5d95c5b888d6a5$export$633847cf062b69e0 = '#1B2638';
var $cc5d95c5b888d6a5$export$9776a6e503bdbf76 = '#121A29';
var $cc5d95c5b888d6a5$export$6c813d5160dff5db = '#0E1624';
var $cc5d95c5b888d6a5$export$3d4f271a500072a = '#0D1424';
var $cc5d95c5b888d6a5$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $cc5d95c5b888d6a5$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $cc5d95c5b888d6a5$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $cc5d95c5b888d6a5$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $cc5d95c5b888d6a5$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $cc5d95c5b888d6a5$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $cc5d95c5b888d6a5$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $cc5d95c5b888d6a5$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $cc5d95c5b888d6a5$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $cc5d95c5b888d6a5$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $cc5d95c5b888d6a5$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $cc5d95c5b888d6a5$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $cc5d95c5b888d6a5$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $cc5d95c5b888d6a5$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $cc5d95c5b888d6a5$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $cc5d95c5b888d6a5$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $cc5d95c5b888d6a5$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $cc5d95c5b888d6a5$export$d2adc5dedf09fced = '#292A2E';
var $cc5d95c5b888d6a5$export$f51762073d2bb381 = '#94C748';
var $cc5d95c5b888d6a5$export$95e26d54def96891 = '#B3DF72';



function $7fc59c5c15274b69$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7fc59c5c15274b69$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7fc59c5c15274b69$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7fc59c5c15274b69$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7fc59c5c15274b69$var$packageName = "@atlaskit/blanket";
var $7fc59c5c15274b69$var$packageVersion = "15.0.0";
var $7fc59c5c15274b69$var$analyticsAttributes = {
    componentName: 'blanket',
    packageName: $7fc59c5c15274b69$var$packageName,
    packageVersion: $7fc59c5c15274b69$var$packageVersion
};
var $7fc59c5c15274b69$var$baseStyles = null;
var $7fc59c5c15274b69$var$shouldAllowClickThroughStyles = null;
var $7fc59c5c15274b69$var$invisibleStyles = null;
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ var $7fc59c5c15274b69$var$Blanket = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function Blanket(_ref, ref) {
    var _ref$shouldAllowClick = _ref.shouldAllowClickThrough, shouldAllowClickThrough = _ref$shouldAllowClick === void 0 ? false : _ref$shouldAllowClick, _ref$isTinted = _ref.isTinted, isTinted = _ref$isTinted === void 0 ? false : _ref$isTinted, _ref$onBlanketClicked = _ref.onBlanketClicked, onBlanketClicked = _ref$onBlanketClicked === void 0 ? (0, $e594dcfa2fc03192$export$2e2bcd8739ae039) : _ref$onBlanketClicked, testId = _ref.testId, children = _ref.children, analyticsContext = _ref.analyticsContext;
    var mouseDownTarget = (0, $7fPBF.useRef)(null);
    var onBlanketClickedWithAnalytics = (0, $e75ff324315e680c$export$a4687b0234b40e28)($7fc59c5c15274b69$var$_objectSpread({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext
    }, $7fc59c5c15274b69$var$analyticsAttributes));
    var blanketClickOutsideChildren = (0, $7fPBF.useCallback)(function(e) {
        return e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined;
    }, [
        onBlanketClickedWithAnalytics
    ]);
    var onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    var onMouseDown = (0, $7fPBF.useCallback)(function(e) {
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $11e6ea2b308c3093$export$2e2bcd8739ae039)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhk705f _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk1j28"
        ]),
        style: {
            "--_10avjlk": (0, $e02bd199f5bb52fc$export$2e2bcd8739ae039)("var(--ds-blanket, ".concat((0, $cc5d95c5b888d6a5$export$486ab785e4bac3c6), ")"))
        }
    }, children);
}));
$7fc59c5c15274b69$var$Blanket.displayName = 'Blanket';
var $7fc59c5c15274b69$export$2e2bcd8739ae039 = $7fc59c5c15274b69$var$Blanket;



/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $7fPBF = parcelRequire("7fPBF");

var $j9spr = parcelRequire("j9spr");

var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");
var $be447a836c53885c$export$da4f61fd78d35243 = /*#__PURE__*/ function() {
    function LayerNode(id, parent) {
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, LayerNode);
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(LayerNode, [
        {
            key: "addChild",
            value: function addChild(node) {
                this.childNodes.push(node);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(node) {
                this.childNodes = this.childNodes.filter(function(child) {
                    return child.id !== node.id;
                });
            }
        },
        {
            key: "getLevel",
            value: function getLevel() {
                if (!this.parent) return 1;
                return this.parent.getLevel() + 1;
            }
        },
        {
            key: "getHeight",
            value: function getHeight() {
                if (this.childNodes.length === 0) return 1;
                return Math.max.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(this.childNodes.map(function(child) {
                    return child.getHeight();
                }))) + 1;
            }
        }
    ]);
}();


/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $7fPBF = parcelRequire("7fPBF");
var $c47374427c3e37b9$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $7fPBF.createContext)(0);


/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $7fPBF = parcelRequire("7fPBF");
var $2c3f43e69962af60$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $7fPBF.createContext)({
    current: null
});


/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $7fPBF = parcelRequire("7fPBF");
var $bb589654996716b3$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $7fPBF.createContext)({
    current: null
});


var $b834a4da819e1421$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel, levelNode = _ref.node;
    (0, $7fPBF.useEffect)(function() {
        var levelNodeSafe = levelNode.current;
        var parentNode = levelNodeSafe.parent;
        parentNode === null || parentNode === void 0 || parentNode.addChild(levelNodeSafe);
        return function() {
            parentNode === null || parentNode === void 0 || parentNode.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $c47374427c3e37b9$export$650d12d3c2ddb8fc).Provider, {
        value: currentLevel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2c3f43e69962af60$export$18f4d8b5b3a77f59).Provider, {
        value: levelNode
    }, children));
};
var $b834a4da819e1421$export$7c885f891c940977 = function Layering(_ref2) {
    var children = _ref2.children, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? true : _ref2$isDisabled;
    var currentLevel = (0, $7fPBF.useContext)((0, $c47374427c3e37b9$export$650d12d3c2ddb8fc));
    var parentNode = (0, $7fPBF.useContext)((0, $2c3f43e69962af60$export$18f4d8b5b3a77f59));
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var newNode = (0, $7fPBF.useRef)(new (0, $be447a836c53885c$export$da4f61fd78d35243)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($b834a4da819e1421$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $bb589654996716b3$export$fa973f110e8f6ca8).Provider, {
        value: newNode
    }, content);
};






var $137Lh = parcelRequire("137Lh");


var $efca76a44a24c722$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $efca76a44a24c722$export$c93026a968943f95 = 'light';
var $efca76a44a24c722$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $efca76a44a24c722$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, #4688EC)";
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    (0, $0440a7eded5169c8$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $efca76a44a24c722$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $efca76a44a24c722$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $efca76a44a24c722$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $0440a7eded5169c8$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $efca76a44a24c722$export$ba1d834b86d72a09 = $efca76a44a24c722$export$a1b3edb637fb4f35;
var $efca76a44a24c722$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, #0515240F)",
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, #0515240F)"
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, #17171708)"
            }
        }
    };
};



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $c0643f6731b03b38$var$uniqueReferencedValue = {};
function $c0643f6731b03b38$export$2e2bcd8739ae039(initializer) {
    var ref = (0, $7fPBF.useRef)($c0643f6731b03b38$var$uniqueReferencedValue);
    if (ref.current === $c0643f6731b03b38$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}


function $516cd57f73bbe395$export$2e2bcd8739ae039(callback) {
    var ref = (0, $c0643f6731b03b38$export$2e2bcd8739ae039)(function() {
        return callback;
    });
    return ref.current;
}



var $7fPBF = parcelRequire("7fPBF");
function $3e9e7c31cab41255$export$2e2bcd8739ae039(value) {
    var ref = (0, $7fPBF.useRef)();
    (0, $7fPBF.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");
function $9fde66a920c3713d$export$2e2bcd8739ae039(initialState) {
    var _useState = (0, $7fPBF.useState)(initialState), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueRef = (0, $7fPBF.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}



/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ var $395dcebe8a28322c$var$modalStackRegister = [];
function $395dcebe8a28322c$export$2e2bcd8739ae039(_ref) {
    var onStackChange = _ref.onStackChange;
    var _useExitingPersistenc = (0, $a1ad98f67aabe587$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting;
    var _useStateRef = (0, $9fde66a920c3713d$export$2e2bcd8739ae039)(0), _useStateRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useStateRef, 2), stackIndexRef = _useStateRef2[0], setStackIndex = _useStateRef2[1];
    var currentStackIndex = stackIndexRef.current;
    var previousStackIndex = (0, $3e9e7c31cab41255$export$2e2bcd8739ae039)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    var updateStack = (0, $516cd57f73bbe395$export$2e2bcd8739ae039)(function() {
        var newStackIndex = $395dcebe8a28322c$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $7fPBF.useEffect)(function() {
        var currentStackIndex = $395dcebe8a28322c$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $395dcebe8a28322c$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $395dcebe8a28322c$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $395dcebe8a28322c$var$modalStackRegister.forEach(function(cb) {
            return cb();
        });
    }, [
        updateStack,
        isExiting
    ]);
    (0, $7fPBF.useEffect)(function() {
        return function() {
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            var currentStackIndex = $395dcebe8a28322c$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $395dcebe8a28322c$var$modalStackRegister.splice(currentStackIndex, 1);
                $395dcebe8a28322c$var$modalStackRegister.forEach(function(cb) {
                    return cb();
                });
            }
        };
    }, [
        updateStack
    ]);
    (0, $7fPBF.useEffect)(function() {
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}



var $iKdEz = parcelRequire("iKdEz");

var $7fPBF = parcelRequire("7fPBF");

/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $a082a6b1512440da$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $a082a6b1512440da$export$2e2bcd8739ae039() {
    var _useState = (0, $7fPBF.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), scrollTopOffset = _useState2[0], setScrollTopOffset = _useState2[1];
    (0, $7fPBF.useLayoutEffect)(function() {
        setScrollTopOffset($a082a6b1512440da$var$getScrollDistance());
    }, []);
    var onWindowScroll = (0, $7fPBF.useCallback)(function() {
        if ($a082a6b1512440da$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $7fPBF.useEffect)(function() {
        return (0, $a091c25729a976b1$exports.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}


/* modal-dialog.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $iKdEz = parcelRequire("iKdEz");

var $bRUy3 = parcelRequire("bRUy3");

var $7fPBF = parcelRequire("7fPBF");

var $iRmtv = parcelRequire("iRmtv");





var $7fPBF = parcelRequire("7fPBF");




var $9a1b26136f3a7f68$var$ESCAPE = 'Escape';
function $9a1b26136f3a7f68$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $7fPBF.useRef)(false);
    var _useLayering = $9a1b26136f3a7f68$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $7fPBF.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $9a1b26136f3a7f68$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $7fPBF.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $7fPBF.useEffect)(function() {
        return (0, $a091c25729a976b1$exports.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $9a1b26136f3a7f68$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $7fPBF.useContext)((0, $c47374427c3e37b9$export$650d12d3c2ddb8fc));
    var layerNode = (0, $7fPBF.useContext)((0, $2c3f43e69962af60$export$18f4d8b5b3a77f59));
    var rootNode = (0, $7fPBF.useContext)((0, $bb589654996716b3$export$fa973f110e8f6ca8));
    var isLayerDisabled = (0, $7fPBF.useCallback)(function() {
        // This is an impossible case, added for type safety
        if (!(layerNode !== null && layerNode !== void 0 && layerNode.current) || !(rootNode !== null && rootNode !== void 0 && rootNode.current)) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        layerNode,
        rootNode
    ]);
    var getTopLevel = (0, $7fPBF.useCallback)(function() {
        return rootNode !== null && rootNode !== void 0 && rootNode.current ? rootNode.current.getHeight() : null;
    }, [
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}





var $137Lh = parcelRequire("137Lh");
/** Create a new combined function that will call all the provided functions */ function $8847aab58ded244d$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function cleanup() {
        fns.forEach(function(fn) {
            return fn();
        });
    };
}





var $7fPBF = parcelRequire("7fPBF");
var $e531343e66f94fe5$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
var $e531343e66f94fe5$export$dece24112a937f92 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);



var $7fPBF = parcelRequire("7fPBF");
function $6d635366f5fb15d1$export$2e2bcd8739ae039(_ref) {
    var onOpenComplete = _ref.onOpenComplete, onCloseComplete = _ref.onCloseComplete;
    var motionRef = (0, $7fPBF.useRef)(null);
    var onMotionFinish = (0, $7fPBF.useCallback)(function(state) {
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}





var $iKdEz = parcelRequire("iKdEz");


var $iKdEz = parcelRequire("iKdEz");
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
var $bc71d1a75f4b886f$export$6eafea55f7947469 = 'data-pdnd-honey-pot';


function $b28717be80d270e6$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $bc71d1a75f4b886f$export$6eafea55f7947469));
}


function $f9d1fd311d4d59fd$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    var _document$elementsFro = document.elementsFromPoint(client.x, client.y), _document$elementsFro2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_document$elementsFro, 2), top = _document$elementsFro2[0], second = _document$elementsFro2[1];
    if (!top) return null;
    if ((0, $b28717be80d270e6$export$821bdcd739a2706b)(top)) return second !== null && second !== void 0 ? second : null;
    return top;
}



var $8MJe2 = parcelRequire("8MJe2");

// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
var $6501d511685a84e4$export$7d0a15ee70427305 = 2147483647;


/**
 * Resets user agent styles for `[popover]` elements.
 *
 * Browsers apply these defaults to popovers (per the WHATWG HTML spec rendering section):
 * - `inset: 0` + `margin: auto` → centers the popover in the viewport
 * - `border: solid` → visible border
 * - `padding: 0.25em` → internal spacing
 * - `overflow: auto` → scrollbars when content overflows
 * - `color: CanvasText` + `background-color: Canvas` → system theme colors
 *
 * This object neutralizes those defaults so the popover behaves like a plain
 * positioned element. `width` and `height` (UA default: `fit-content`) are not
 * reset here because consumers set their own dimensions.
 */ var $6666020385f87acc$export$74004cb910cdc478 = {
    inset: 'unset',
    border: 'none',
    padding: 0,
    margin: 0,
    overflow: 'visible',
    color: 'inherit',
    background: 'transparent'
};


/** Provide a function that you only ever want to be called a single time */ function $68e346ba3911f1c2$export$d2de3aaeafa91619(fn) {
    var cache = null;
    return function wrapped() {
        if (!cache) {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}


var $a42bcff4ba79aa09$export$1150b66d0ff92823 = (0, $68e346ba3911f1c2$export$d2de3aaeafa91619)(function supportsPopover() {
    return typeof HTMLElement !== 'undefined' && typeof HTMLElement.prototype.showPopover === 'function';
});



function $193d546856b964fc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $193d546856b964fc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $193d546856b964fc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $193d546856b964fc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $193d546856b964fc$var$honeyPotSize = 2;
var $193d546856b964fc$var$halfHoneyPotSize = $193d546856b964fc$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $193d546856b964fc$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $193d546856b964fc$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $193d546856b964fc$var$halfHoneyPotSize,
        y: point.y - $193d546856b964fc$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $193d546856b964fc$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $193d546856b964fc$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $193d546856b964fc$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $193d546856b964fc$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $193d546856b964fc$var$getHoneyPotRectFor(_ref) {
    var client = _ref.client;
    var point = $193d546856b964fc$var$preventGoingForwardsOffScreen($193d546856b964fc$var$preventGoingBackwardsOffScreen($193d546856b964fc$var$pullBackByHalfHoneyPotSize($193d546856b964fc$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $193d546856b964fc$var$honeyPotSize,
        height: $193d546856b964fc$var$honeyPotSize
    });
}
function $193d546856b964fc$var$getRectStyles(_ref2) {
    var clientRect = _ref2.clientRect;
    return {
        left: "".concat(clientRect.left, "px"),
        top: "".concat(clientRect.top, "px"),
        width: "".concat(clientRect.width, "px"),
        height: "".concat(clientRect.height, "px")
    };
}
function $193d546856b964fc$var$isWithin(_ref3) {
    var client = _ref3.client, clientRect = _ref3.clientRect;
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $193d546856b964fc$var$mountHoneyPot(_ref4) {
    var initial = _ref4.initial;
    var element = document.createElement('div');
    element.setAttribute((0, $bc71d1a75f4b886f$export$6eafea55f7947469), 'true');
    // Using popover="manual" to place the element in the browser's top layer.
    // This ensures the honey pot is visually on top of everything else,
    // including elements using z-index and other stacking contexts.
    // "manual" means no light dismiss — we manage the lifecycle ourselves.
    // Falls back to position:fixed + maxZIndex when the popover API is not available.
    if ((0, $a42bcff4ba79aa09$export$1150b66d0ff92823)()) element.setAttribute('popover', 'manual');
    // can shift during the drag thanks to Firefox
    var clientRect = $193d546856b964fc$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, $193d546856b964fc$var$_objectSpread($193d546856b964fc$var$_objectSpread({
        position: 'fixed'
    }, (0, $a42bcff4ba79aa09$export$1150b66d0ff92823)() ? // needs to come first as it has 'inset: unset' which
    // needs to be overridden by our top / left values
    (0, $6666020385f87acc$export$74004cb910cdc478) : {
        // Fallback: using maximum possible z-index so that this element
        // will always be on top of other positioned content.
        zIndex: (0, $6501d511685a84e4$export$7d0a15ee70427305)
    }), {}, {
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box',
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto'
    }, $193d546856b964fc$var$getRectStyles({
        clientRect: clientRect
    })));
    document.body.appendChild(element);
    if ((0, $a42bcff4ba79aa09$export$1150b66d0ff92823)()) element.showPopover();
    /**
   *  🦊 In firefox we can get `"pointermove"` events after the drag
   * has started, which is a spec violation.
   * The final `"pointermove"` will reveal where the "depressed" position
   * is for our honey pot fix.
   */ var unbindPointerMove = (0, $a091c25729a976b1$exports.bind)(window, {
        type: 'pointermove',
        listener: function listener(event) {
            var client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $193d546856b964fc$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $193d546856b964fc$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish(_ref5) {
        var current = _ref5.current;
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($193d546856b964fc$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        var unbindPostDragEvents = (0, $a091c25729a976b1$exports.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $193d546856b964fc$export$8ecad27c959e89e0() {
    var latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $a091c25729a976b1$exports.bind)(window, {
            type: 'pointermove',
            listener: function listener(event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        var finish = null;
        return function onPostEvent(_ref6) {
            var eventName = _ref6.eventName, payload = _ref6.payload;
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                var input = payload.location.initial.input;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                var initial = latestPointerMove !== null && latestPointerMove !== void 0 ? latestPointerMove : {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $193d546856b964fc$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                var _finish;
                var _input = payload.location.current.input;
                (_finish = finish) === null || _finish === void 0 || _finish({
                    current: {
                        x: _input.clientX,
                        y: _input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}



var $j9spr = parcelRequire("j9spr");




var $b749e65f3d5c9991$export$b7d78993b74f766d = (0, $68e346ba3911f1c2$export$d2de3aaeafa91619)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});



var $1e42c1bc9239c98e$export$95df08bae54cb4df = (0, $68e346ba3911f1c2$export$d2de3aaeafa91619)(function isSafari() {
    var _navigator = navigator, userAgent = _navigator.userAgent;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});




/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
var $17cf273859fa5ad7$var$symbols = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
function $17cf273859fa5ad7$export$de68634bd94ed596(_ref) {
    var dragEnter = _ref.dragEnter;
    if (!(0, $1e42c1bc9239c98e$export$95df08bae54cb4df)()) return false;
    return dragEnter.hasOwnProperty($17cf273859fa5ad7$var$symbols.isEnteringWindow);
}
function $17cf273859fa5ad7$export$f21837c338005454(_ref2) {
    var dragLeave = _ref2.dragLeave;
    if (!(0, $1e42c1bc9239c98e$export$95df08bae54cb4df)()) return false;
    return dragLeave.hasOwnProperty($17cf273859fa5ad7$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $1e42c1bc9239c98e$export$95df08bae54cb4df)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    var state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $a091c25729a976b1$exports.bindAll)(window, [
        {
            type: 'dragstart',
            listener: function listener() {
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: function listener(event) {
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                event[$17cf273859fa5ad7$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: function listener(event) {
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    event[$17cf273859fa5ad7$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();


/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $3619bfcf994fa6a6$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $3619bfcf994fa6a6$export$e46810fef53b5b0e(eventTarget) {
    return $3619bfcf994fa6a6$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}


function $d9ba60099687cc3c$export$57d220c74e84a273(_ref) {
    var dragLeave = _ref.dragLeave;
    var type = dragLeave.type, relatedTarget = dragLeave.relatedTarget;
    if (type !== 'dragleave') return false;
    if ((0, $1e42c1bc9239c98e$export$95df08bae54cb4df)()) return (0, $17cf273859fa5ad7$export$f21837c338005454)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   * (foreign element)
   */ if ((0, $b749e65f3d5c9991$export$b7d78993b74f766d)()) return (0, $3619bfcf994fa6a6$export$e46810fef53b5b0e)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is `null` *(standard check)*
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}


function $0b2b9d5d1129a1ca$export$ac5e5b0daf997b2(_ref) {
    var onDragEnd = _ref.onDragEnd;
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            }()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}


function $2675101a3ff07002$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}


var $c15db151bfb9ee49$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $c15db151bfb9ee49$export$2e2bcd8739ae039 = $c15db151bfb9ee49$var$rafSchd;


var $f003e67bc5e20f24$var$scheduleOnDrag = (0, $c15db151bfb9ee49$export$2e2bcd8739ae039)(function(fn) {
    return fn();
});
var $f003e67bc5e20f24$var$dragStart = function() {
    var scheduled = null;
    function schedule(fn) {
        var frameId = requestAnimationFrame(function() {
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
}();
function $f003e67bc5e20f24$export$9f13ecc44e83d682(_ref) {
    var source = _ref.source, initial = _ref.initial, dispatchEvent = _ref.dispatchEvent;
    var previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    var dispatch = {
        start: function start(_ref2) {
            var nativeSetDragImage = _ref2.nativeSetDragImage;
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            var location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $f003e67bc5e20f24$var$dragStart.schedule(function() {
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate: function dragUpdate(_ref3) {
            var current = _ref3.current;
            $f003e67bc5e20f24$var$dragStart.flush();
            $f003e67bc5e20f24$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag: function drag(_ref4) {
            var current = _ref4.current;
            $f003e67bc5e20f24$var$scheduleOnDrag(function() {
                $f003e67bc5e20f24$var$dragStart.flush();
                var location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop: function drop(_ref5) {
            var current = _ref5.current, updatedSourcePayload = _ref5.updatedSourcePayload;
            $f003e67bc5e20f24$var$dragStart.flush();
            $f003e67bc5e20f24$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload !== null && updatedSourcePayload !== void 0 ? updatedSourcePayload : source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}


var $b1bf1305423c2f0a$var$globalState = {
    isActive: false
};
function $b1bf1305423c2f0a$var$canStart() {
    return !$b1bf1305423c2f0a$var$globalState.isActive;
}
function $b1bf1305423c2f0a$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $b1bf1305423c2f0a$var$hasHierarchyChanged(_ref) {
    var current = _ref.current, next = _ref.next;
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(var i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $b1bf1305423c2f0a$var$start(_ref2) {
    var event = _ref2.event, dragType = _ref2.dragType, getDropTargetsOver = _ref2.getDropTargetsOver, dispatchEvent = _ref2.dispatchEvent;
    if (!$b1bf1305423c2f0a$var$canStart()) return;
    var initial = $b1bf1305423c2f0a$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $b1bf1305423c2f0a$var$globalState.isActive = true;
    var state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $b1bf1305423c2f0a$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    var dispatch = (0, $f003e67bc5e20f24$export$9f13ecc44e83d682)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        var hasChanged = $b1bf1305423c2f0a$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        var input = (0, $2675101a3ff07002$export$7c112ceec8941e67)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        var target = (0, $b28717be80d270e6$export$821bdcd739a2706b)(event.target) ? (0, $f9d1fd311d4d59fd$export$81d0353f25f5dd)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        var nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $b1bf1305423c2f0a$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $b1bf1305423c2f0a$var$globalState.isActive = false;
        unbindEvents();
    }
    var unbindEvents = (0, $a091c25729a976b1$exports.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener: function listener(event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener: function listener(event) {
                if (!(0, $d9ba60099687cc3c$export$57d220c74e84a273)({
                    dragLeave: event
                })) return;
                /**
       * At this point we don't know if a drag is being cancelled,
       * or if a drag is leaving the `window`.
       *
       * Both have:
       *   1. "dragleave" (with `relatedTarget: null`)
       *   2. "dragend" (a "dragend" can occur when outside the `window`)
       *
       * **Clearing drop targets**
       *
       * For either case we are clearing the the drop targets
       *
       * - cancelling: we clear drop targets in `"dragend"` anyway
       * - leaving the `window`: we clear the drop targets (to clear stickiness)
       *
       * **Leaving the window and finishing the drag**
       *
       * _internal drags_
       *
       * - The drag continues when the user is outside the `window`
       *   and can resume if the user drags back over the `window`,
       *   or end when the user drops in an external `window`.
       * - We will get a `"dragend"`, or we can listen for other
       *   events to determine the drag is finished when the user re-enters the `window`).
       *
       * _external drags_
       *
       * - We conclude the drag operation.
       * - We have no idea if the user will drag back over the `window`,
       *   or if the drag ends elsewhere.
       * - We will create a new drag if the user re-enters the `window`.
       *
       * **Not updating `input`**
       *
       * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
       * Workaround: intentionally not updating `input` in "dragleave"
       * rather than the users current input values
       * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
       * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
       **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener: function listener(event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $2675101a3ff07002$export$7c112ceec8941e67)(event)
                };
                /** If there are no drop targets, then we will get
       * a "drop" event if:
       * - `preventUnhandled()` is being used
       * - there is an unmanaged drop target (eg another library)
       * In these cases, it's up to the consumer
       * to handle the drop if it's not over one of our drop targets
       * - `preventUnhandled()` will cancel the "drop"
       * - unmanaged drop targets can handle the "drop" how they want to
       * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $b1bf1305423c2f0a$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener: function listener(event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $2675101a3ff07002$export$7c112ceec8941e67)(event)
                };
                cancel();
            }
        }
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))((0, $0b2b9d5d1129a1ca$export$ac5e5b0daf997b2)({
        onDragEnd: cancel
    }))), // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $b1bf1305423c2f0a$var$getNativeSetDragImage(event)
    });
}
function $b1bf1305423c2f0a$var$setDropEffectOnEvent(_ref3) {
    var _current$;
    var event = _ref3.event, current = _ref3.current;
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    var innerMost = (_current$ = current[0]) === null || _current$ === void 0 ? void 0 : _current$.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $b1bf1305423c2f0a$var$getStartLocation(_ref4) {
    var event = _ref4.event, dragType = _ref4.dragType, getDropTargetsOver = _ref4.getDropTargetsOver;
    var input = (0, $2675101a3ff07002$export$7c112ceec8941e67)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    var dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
var $b1bf1305423c2f0a$export$3efdceeb8ca25c51 = {
    canStart: $b1bf1305423c2f0a$var$canStart,
    start: $b1bf1305423c2f0a$var$start
};


// Extending `Map` to allow us to link Key and Values together
var $6bece9ac86ae72a6$var$ledger = new Map();
function $6bece9ac86ae72a6$var$registerUsage(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount;
    var entry = $6bece9ac86ae72a6$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    var initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $6bece9ac86ae72a6$var$ledger.set(typeKey, initial);
    return initial;
}
function $6bece9ac86ae72a6$export$6503ec6e8aabbaf(args) {
    var entry = $6bece9ac86ae72a6$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $6bece9ac86ae72a6$var$ledger.delete(args.typeKey);
    };
}



var $8MJe2 = parcelRequire("8MJe2");

var $j9spr = parcelRequire("j9spr");


function $0d06b6a30f917978$export$5dcb5c23b6ba980a(element, _ref) {
    var attribute = _ref.attribute, value = _ref.value;
    element.setAttribute(attribute, value);
    return function() {
        return element.removeAttribute(attribute);
    };
}


function $d5b19bf156af47c8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d5b19bf156af47c8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d5b19bf156af47c8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d5b19bf156af47c8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d5b19bf156af47c8$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $d5b19bf156af47c8$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $d5b19bf156af47c8$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $d5b19bf156af47c8$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $d5b19bf156af47c8$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $d5b19bf156af47c8$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $d5b19bf156af47c8$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $d5b19bf156af47c8$export$47d10e7bd9c81890(_ref) {
    var typeKey = _ref.typeKey, defaultDropEffect = _ref.defaultDropEffect;
    var registry = new WeakMap();
    var dropTargetDataAtt = "data-drop-target-for-".concat(typeKey);
    var dropTargetSelector = "[".concat(dropTargetDataAtt, "]");
    function addToRegistry(args) {
        registry.set(args.element, args);
        return function() {
            return registry.delete(args.element);
        };
    }
    function dropTargetForConsumers(args) {
        var existing;
        var cleanup = (0, $8847aab58ded244d$export$1be1fc439b849fdf)((0, $0d06b6a30f917978$export$5dcb5c23b6ba980a)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $68e346ba3911f1c2$export$d2de3aaeafa91619)(cleanup);
    }
    function getActualDropTargets(_ref2) {
        var _args$getData, _args$getData2, _args$getDropEffect, _args$getDropEffect2;
        var source = _ref2.source, target = _ref2.target, input = _ref2.input, _ref2$result = _ref2.result, result = _ref2$result === void 0 ? [] : _ref2$result;
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        var closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        var args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        var feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        var data = (_args$getData = (_args$getData2 = args.getData) === null || _args$getData2 === void 0 ? void 0 : _args$getData2.call(args, feedback)) !== null && _args$getData !== void 0 ? _args$getData : {};
        var dropEffect = (_args$getDropEffect = (_args$getDropEffect2 = args.getDropEffect) === null || _args$getDropEffect2 === void 0 ? void 0 : _args$getDropEffect2.call(args, feedback)) !== null && _args$getDropEffect !== void 0 ? _args$getDropEffect : defaultDropEffect;
        var record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(result), [
                record
            ])
        });
    }
    function notifyCurrent(_ref3) {
        var eventName = _ref3.eventName, payload = _ref3.payload;
        var _iterator = $d5b19bf156af47c8$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _entry$eventName;
                var record = _step.value;
                var entry = registry.get(record.element);
                var args = $d5b19bf156af47c8$var$_objectSpread($d5b19bf156af47c8$var$_objectSpread({}, payload), {}, {
                    self: record
                });
                entry === null || entry === void 0 || (_entry$eventName = entry[eventName]) === null || _entry$eventName === void 0 || _entry$eventName.call(entry, // I cannot seem to get the types right here.
                // TS doesn't seem to like that one event can need `nativeSetDragImage`
                // @ts-expect-error
                args);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }
    var actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: function onDropTargetChange(_ref4) {
            var payload = _ref4.payload;
            var isCurrent = new Set(payload.location.current.dropTargets.map(function(record) {
                return record.element;
            }));
            var visited = new Set();
            var _iterator2 = $d5b19bf156af47c8$var$_createForOfIteratorHelper(payload.location.previous.dropTargets), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _entry$onDropTargetCh;
                    var record = _step2.value;
                    visited.add(record.element);
                    var entry = registry.get(record.element);
                    var isOver = isCurrent.has(record.element);
                    var args = $d5b19bf156af47c8$var$_objectSpread($d5b19bf156af47c8$var$_objectSpread({}, payload), {}, {
                        self: record
                    });
                    entry === null || entry === void 0 || (_entry$onDropTargetCh = entry.onDropTargetChange) === null || _entry$onDropTargetCh === void 0 || _entry$onDropTargetCh.call(entry, args);
                    // if we cannot find the drop target in the current array, then it has been left
                    if (!isOver) {
                        var _entry$onDragLeave;
                        entry === null || entry === void 0 || (_entry$onDragLeave = entry.onDragLeave) === null || _entry$onDragLeave === void 0 || _entry$onDragLeave.call(entry, args);
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var _iterator3 = $d5b19bf156af47c8$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var _entry$onDropTargetCh2, _entry$onDragEnter;
                    var _record = _step3.value;
                    // already published an update to this drop target
                    if (visited.has(_record.element)) continue;
                    // at this point we have a new drop target that is being entered into
                    var _args = $d5b19bf156af47c8$var$_objectSpread($d5b19bf156af47c8$var$_objectSpread({}, payload), {}, {
                        self: _record
                    });
                    var _entry = registry.get(_record.element);
                    _entry === null || _entry === void 0 || (_entry$onDropTargetCh2 = _entry.onDropTargetChange) === null || _entry$onDropTargetCh2 === void 0 || _entry$onDropTargetCh2.call(_entry, _args);
                    _entry === null || _entry === void 0 || (_entry$onDragEnter = _entry.onDragEnter) === null || _entry$onDragEnter === void 0 || _entry$onDragEnter.call(_entry, _args);
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver(_ref5) {
        var source = _ref5.source, target = _ref5.target, input = _ref5.input, current = _ref5.current;
        var actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        var lastCaptureOrdered = $d5b19bf156af47c8$var$copyReverse(current);
        var actualCaptureOrdered = $d5b19bf156af47c8$var$copyReverse(actual);
        var resultCaptureOrdered = [];
        for(var index = 0; index < lastCaptureOrdered.length; index++){
            var _argsForLast$getIsSti;
            var last = lastCaptureOrdered[index];
            var fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            var parent = resultCaptureOrdered[index - 1];
            var lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if ((parent === null || parent === void 0 ? void 0 : parent.element) !== (lastParent === null || lastParent === void 0 ? void 0 : lastParent.element)) break;
            // We need to check whether the old drop target can still be dropped on
            var argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            var feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!((_argsForLast$getIsSti = argsForLast.getIsSticky) !== null && _argsForLast$getIsSti !== void 0 && _argsForLast$getIsSti.call(argsForLast, feedback))) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push($d5b19bf156af47c8$var$_objectSpread($d5b19bf156af47c8$var$_objectSpread({}, last), {}, {
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            }));
        }
        // return bubble ordered result
        return $d5b19bf156af47c8$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}



var $8MJe2 = parcelRequire("8MJe2");

function $2b12e329680e6a0e$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $2b12e329680e6a0e$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $2b12e329680e6a0e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2b12e329680e6a0e$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2b12e329680e6a0e$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $2b12e329680e6a0e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $2b12e329680e6a0e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2b12e329680e6a0e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2b12e329680e6a0e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2b12e329680e6a0e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2b12e329680e6a0e$export$5dd4ed888d5b12ca() {
    var registry = new Set();
    var dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        var entry = $2b12e329680e6a0e$var$_objectSpread({}, args);
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        }
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $68e346ba3911f1c2$export$d2de3aaeafa91619)(cleanup);
    }
    function dispatchEvent(_ref) {
        var eventName = _ref.eventName, payload = _ref.payload;
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            var _iterator = $2b12e329680e6a0e$var$_createForOfIteratorHelper(registry), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var monitor = _step.value;
                    tryAddToActive(monitor);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        var active = Array.from(dragging.active);
        for(var _i = 0, _active = active; _i < _active.length; _i++){
            var _monitor = _active[_i];
            // A monitor can be removed by another monitor during an event.
            // We need to check that the monitor is still registered before calling it
            if (dragging.active.has(_monitor)) {
                var _monitor$eventName;
                // @ts-expect-error: I cannot get this type working!
                (_monitor$eventName = _monitor[eventName]) === null || _monitor$eventName === void 0 || _monitor$eventName.call(_monitor, payload);
            }
        }
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}


function $5122e0d0088f4b41$export$2aa3a33160990d96(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount, dispatchEventToSource = _ref.dispatchEventToSource, onPostDispatch = _ref.onPostDispatch, defaultDropEffect = _ref.defaultDropEffect;
    var monitorAPI = (0, $2b12e329680e6a0e$export$5dd4ed888d5b12ca)();
    var dropTargetAPI = (0, $d5b19bf156af47c8$export$47d10e7bd9c81890)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource === null || dispatchEventToSource === void 0 || dispatchEventToSource(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch === null || onPostDispatch === void 0 || onPostDispatch(args);
    }
    function start(_ref2) {
        var event = _ref2.event, dragType = _ref2.dragType;
        (0, $b1bf1305423c2f0a$export$3efdceeb8ca25c51).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            var api = {
                canStart: (0, $b1bf1305423c2f0a$export$3efdceeb8ca25c51).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $6bece9ac86ae72a6$export$6503ec6e8aabbaf)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}






var $01bac06922e89b20$export$a11b0059900ceec8 = (0, $68e346ba3911f1c2$export$d2de3aaeafa91619)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
var $01bac06922e89b20$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';



// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $4c8d3d867b71c91e$export$fd3d00026297c0ad = 'text/plain';


// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $f29473ed1a3cd5be$export$4c44a460f123106 = 'text/uri-list';


/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ var $f77bfd9efc16c1d5$export$c9c4cc54e73b125d = 'application/vnd.pdnd';


var $8ed119f46b74ba61$var$draggableRegistry = new WeakMap();
function $8ed119f46b74ba61$var$addToRegistry(args) {
    $8ed119f46b74ba61$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $8ed119f46b74ba61$var$draggableRegistry.delete(args.element);
    };
}
var $8ed119f46b74ba61$var$honeyPotFix = (0, $193d546856b964fc$export$8ecad27c959e89e0)();
var $8ed119f46b74ba61$var$adapter = (0, $5122e0d0088f4b41$export$2aa3a33160990d96)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount: function mount(api) {
        /**  Binding event listeners the `document` rather than `window` so that
     * this adapter always gets preference over the text adapter.
     * `document` is the first `EventTarget` under `window`
     * https://twitter.com/alexandereardon/status/1604658588311465985
     */ return (0, $8847aab58ded244d$export$1be1fc439b849fdf)($8ed119f46b74ba61$var$honeyPotFix.bindEvents(), (0, $a091c25729a976b1$exports.bind)(document, {
            type: 'dragstart',
            listener: function listener(event) {
                var _entry$dragHandle, _entry$getInitialData, _entry$getInitialData2, _entry$dragHandle2, _entry$getInitialData3, _entry$getInitialData4;
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                var target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return;
                // see if the thing being dragged is owned by us
                var entry = $8ed119f46b74ba61$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return;
                /**
         * A text selection drag _can_ have the `draggable` element be
         * the `event.target` if the user is dragging the text selection
         * from the `draggable`.
         *
         * To know if the `draggable` is being dragged, we look at whether any
         * `"text/plain"` data is being dragged. If it is, then a text selection
         * drag is occurring.
         *
         * This behaviour has been validated on:
         *
         * - Chrome@128 on Android@14
         * - Chrome@128 on iOS@17.6.1
         * - Chrome@128 on Windows@11
         * - Chrome@128 on MacOS@14.6.1
         * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
         * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
         *
         * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
         * but unfortunately ProseMirror is always setting `""` as the dragged text
         *
         * Note: Unfortunately editor is (heavily) leaning on the current functionality today
         * and unwinding it will be a decent amount of effort. So for now, a text selection
         * where the `event.target` is a `draggable` element will still trigger the
         * element adapter.
         *
         * // Future state:
         * if(event.dataTransfer.getData(textMediaType)) {
         * 	return;
         * }
         *
         */ var input = (0, $2675101a3ff07002$export$7c112ceec8941e67)(event);
                var feedback = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle = entry.dragHandle) !== null && _entry$dragHandle !== void 0 ? _entry$dragHandle : null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    var over = (0, $f9d1fd311d4d59fd$export$81d0353f25f5dd)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return;
                    }
                }
                /**
         *  **Goal**
         *  Pass information to other applications
         *
         * **Approach**
         *  Put data into the native data store
         *
         *  **What about the native adapter?**
         *  When the element adapter puts native data into the native data store
         *  the native adapter is not triggered in the current window,
         *  but a native adapter in an external window _can_ be triggered
         *
         *  **Why bake this into core?**
         *  This functionality could be pulled out and exposed inside of
         *  `onGenerateDragPreview`. But decided to make it a part of the
         *  base API as it felt like a common enough use case and ended
         *  up being a similar amount of code to include this function as
         *  it was to expose the hook for it
         */ var nativeData = (_entry$getInitialData = (_entry$getInitialData2 = entry.getInitialDataForExternal) === null || _entry$getInitialData2 === void 0 ? void 0 : _entry$getInitialData2.call(entry, feedback)) !== null && _entry$getInitialData !== void 0 ? _entry$getInitialData : null;
                if (nativeData) for(var _i = 0, _Object$entries = Object.entries(nativeData); _i < _Object$entries.length; _i++){
                    var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], data = _Object$entries$_i[1];
                    event.dataTransfer.setData(key, data !== null && data !== void 0 ? data : '');
                }
                /**
         *  📱 For Android devices, a drag operation will not start unless
         * "text/plain" or "text/uri-list" data exists in the native data store
         * https://twitter.com/alexandereardon/status/1732189803754713424
         *
         * Tested on:
         * Device: Google Pixel 5
         * Android version: 14 (November 5, 2023)
         * Chrome version: 120.0
         */ if ((0, $01bac06922e89b20$export$a11b0059900ceec8)() && !event.dataTransfer.types.includes((0, $4c8d3d867b71c91e$export$fd3d00026297c0ad)) && !event.dataTransfer.types.includes((0, $f29473ed1a3cd5be$export$4c44a460f123106))) event.dataTransfer.setData((0, $4c8d3d867b71c91e$export$fd3d00026297c0ad), (0, $01bac06922e89b20$export$aceb3ed8b7f7bd2c));
                /**
         * 1. Must set any media type for `iOS15` to work
         * 2. We are also doing adding data so that the native adapter
         * can know that the element adapter has handled this drag
         *
         * We used to wrap this `setData()` in a `try/catch` for Firefox,
         * but it looks like that was not needed.
         *
         * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
         *
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
         * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
         *
         * // just checking a few more combinations to be super safe
         *
         * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
         * - ✅ Chrome@78 (Oct 2019) on Windows 10
         * - ✅ Safari@14.1 on macOS Big Sur
         */ event.dataTransfer.setData((0, $f77bfd9efc16c1d5$export$c9c4cc54e73b125d), '');
                var payload = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle2 = entry.dragHandle) !== null && _entry$dragHandle2 !== void 0 ? _entry$dragHandle2 : null,
                    data: (_entry$getInitialData3 = (_entry$getInitialData4 = entry.getInitialData) === null || _entry$getInitialData4 === void 0 ? void 0 : _entry$getInitialData4.call(entry, feedback)) !== null && _entry$getInitialData3 !== void 0 ? _entry$getInitialData3 : {}
                };
                var dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: function dispatchEventToSource(_ref) {
        var _draggableRegistry$ge, _draggableRegistry$ge2;
        var eventName = _ref.eventName, payload = _ref.payload;
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        (_draggableRegistry$ge = $8ed119f46b74ba61$var$draggableRegistry.get(payload.source.element)) === null || _draggableRegistry$ge === void 0 || (_draggableRegistry$ge2 = _draggableRegistry$ge[eventName]) === null || _draggableRegistry$ge2 === void 0 || _draggableRegistry$ge2.call(_draggableRegistry$ge, // I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $8ed119f46b74ba61$var$honeyPotFix.getOnPostDispatch()
});
var $8ed119f46b74ba61$export$e7140b68045b5036 = $8ed119f46b74ba61$var$adapter.dropTarget;
var $8ed119f46b74ba61$export$59a074bac4c54f54 = $8ed119f46b74ba61$var$adapter.monitor;
function $8ed119f46b74ba61$export$c746a5152d4ba26c(args) {
    var existing;
    var cleanup = (0, $8847aab58ded244d$export$1be1fc439b849fdf)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $8ed119f46b74ba61$var$adapter.registerUsage(), $8ed119f46b74ba61$var$addToRegistry(args), (0, $0d06b6a30f917978$export$5dcb5c23b6ba980a)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
    // Wrapping in `once` to prevent unexpected side effects if consumers call
    // the clean up function multiple times.
    return (0, $68e346ba3911f1c2$export$d2de3aaeafa91619)(cleanup);
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrag()`) on for a `draggable()` */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForElements()` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForElements` */ 


 // Payload for the draggable being dragged



var $j9spr = parcelRequire("j9spr");

/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $09d4f4c67999ed78$var$setStyle(el, _ref) {
    var property = _ref.property, rule = _ref.rule, _ref$priority = _ref.priority, priority = _ref$priority === void 0 ? '' : _ref$priority;
    var originalValue = el.style.getPropertyValue(property);
    var originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $09d4f4c67999ed78$var$hasSameOrigin(href1, href2) {
    var url1;
    var url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch (_unused) {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $09d4f4c67999ed78$var$isIframeOnAnotherDomain(iframe) {
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
   */ if (iframe.srcdoc) return false;
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
   */ if (iframe.src.startsWith('data:')) return false;
    return !$09d4f4c67999ed78$var$hasSameOrigin(window.location.href, iframe.src);
}
var $09d4f4c67999ed78$var$registry = new Map();
function $09d4f4c67999ed78$var$applyFix(watchForEndOfInteraction) {
    var iframes = Array.from(document.querySelectorAll('iframe')).filter($09d4f4c67999ed78$var$isIframeOnAnotherDomain);
    var cleanups = iframes.map(function(iframe) {
        var entry = $09d4f4c67999ed78$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $09d4f4c67999ed78$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $09d4f4c67999ed78$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $09d4f4c67999ed78$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $8847aab58ded244d$export$1be1fc439b849fdf).apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(cleanups))();
    }
    var cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $09d4f4c67999ed78$export$a74bff2507e6126b(_ref2) {
    var watchForInteractionStart = _ref2.watchForInteractionStart, watchForInteractionEnd = _ref2.watchForInteractionEnd;
    var registrationCount = 0;
    var stopWatchingInteractionStart = null;
    function start() {
        $09d4f4c67999ed78$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            var _stopWatchingInteract;
            registrationCount--;
            if (registrationCount !== 0) return;
            (_stopWatchingInteract = stopWatchingInteractionStart) === null || _stopWatchingInteract === void 0 || _stopWatchingInteract();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}


function $907c8937691d0a6f$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var unbindEvents = (0, $a091c25729a976b1$exports.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $8ed119f46b74ba61$export$59a074bac4c54f54)({
        onGenerateDragPreview: function onGenerateDragPreview() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $8847aab58ded244d$export$1be1fc439b849fdf)(unbindEvents, unbindMonitor);
}
function $907c8937691d0a6f$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $a091c25729a976b1$exports.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener(event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
var $907c8937691d0a6f$var$api = (0, $09d4f4c67999ed78$export$a74bff2507e6126b)({
    watchForInteractionStart: $907c8937691d0a6f$var$watchForInteractionStart,
    watchForInteractionEnd: $907c8937691d0a6f$var$watchForInteractionEnd
});
function $907c8937691d0a6f$export$ec28e97c7d8b1b35() {
    return $907c8937691d0a6f$var$api.registerUsage();
}



var $j9spr = parcelRequire("j9spr");







function $562864d65a169a18$export$d1c6f249e893cdf4(_ref) {
    var dragEnter = _ref.dragEnter;
    var type = dragEnter.type, relatedTarget = dragEnter.relatedTarget;
    if (type !== 'dragenter') return false;
    if ((0, $1e42c1bc9239c98e$export$95df08bae54cb4df)()) return (0, $17cf273859fa5ad7$export$de68634bd94ed596)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is the `iframe` element in the parent `window`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is an element inside the child `iframe`
   * (foreign element)
   */ if ((0, $b749e65f3d5c9991$export$b7d78993b74f766d)()) return (0, $3619bfcf994fa6a6$export$e46810fef53b5b0e)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is `null` *(standard check)*
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is the `iframe` element in the parent `window`
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}





function $f8b583d741e0f6c3$export$a8e56a860d7957c7(_ref) {
    var type = _ref.type, value = _ref.value;
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $f77bfd9efc16c1d5$export$c9c4cc54e73b125d)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $4c8d3d867b71c91e$export$fd3d00026297c0ad) && value === (0, $01bac06922e89b20$export$aceb3ed8b7f7bd2c)) return false;
    return true;
}
function $f8b583d741e0f6c3$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter(function(type) {
        return $f8b583d741e0f6c3$export$a8e56a860d7957c7({
            type: type,
            value: transfer.getData(type)
        });
    });
}
function $f8b583d741e0f6c3$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter(function(item) {
        return item.kind === 'file' || $f8b583d741e0f6c3$export$a8e56a860d7957c7({
            type: item.type,
            value: dataTransfer.getData(item.type)
        });
    });
}
var $f8b583d741e0f6c3$var$didDragStartLocally = false;
var $f8b583d741e0f6c3$var$adapter = (0, $5122e0d0088f4b41$export$2aa3a33160990d96)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $a091c25729a976b1$exports.bind)(window, {
            type: 'dragenter',
            listener: function listener(event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($f8b583d741e0f6c3$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $562864d65a169a18$export$d1c6f249e893cdf4)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                var types = $f8b583d741e0f6c3$export$8c257a3856120a77(event.dataTransfer);
                if (!types.length) return;
                var locked = {
                    types: types,
                    items: [],
                    getStringData: function getStringData() {
                        return null;
                    }
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload: function getDropPayload(event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            var items = $f8b583d741e0f6c3$export$8d28cfecded8dcab(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            var nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData: function getStringData(mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    var value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!$f8b583d741e0f6c3$export$a8e56a860d7957c7({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
function $f8b583d741e0f6c3$export$9edc779df9a85289(args) {
    // not removing unused events, just leaning on the type system
    return $f8b583d741e0f6c3$var$adapter.dropTarget(args);
}
function $f8b583d741e0f6c3$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return $f8b583d741e0f6c3$var$adapter.monitor(args);
}
(function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $f8b583d741e0f6c3$var$adapter.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    var idle = {
        type: 'idle'
    };
    var state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        $f8b583d741e0f6c3$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $a091c25729a976b1$exports.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))((0, $0b2b9d5d1129a1ca$export$ac5e5b0daf997b2)({
            onDragEnd: clear
        }))), // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $a091c25729a976b1$exports.bind)(window, {
        type: 'dragstart',
        listener: function listener() {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            $f8b583d741e0f6c3$var$didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})(); /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ 


 // The data that is being dragged



function $12c5d7db9c9fd030$var$watchForInteractionStart(_ref) {
    var start = _ref.start;
    return (0, $f8b583d741e0f6c3$export$bb1740f3194979c1)({
        onDragStart: function onDragStart() {
            start();
        }
    });
}
function $12c5d7db9c9fd030$var$watchForInteractionEnd(_ref2) {
    var stop = _ref2.stop;
    return (0, $f8b583d741e0f6c3$export$bb1740f3194979c1)({
        onDrop: function onDrop() {
            stop();
        }
    });
}
var $12c5d7db9c9fd030$var$api = (0, $09d4f4c67999ed78$export$a74bff2507e6126b)({
    watchForInteractionStart: $12c5d7db9c9fd030$var$watchForInteractionStart,
    watchForInteractionEnd: $12c5d7db9c9fd030$var$watchForInteractionEnd
});
function $12c5d7db9c9fd030$export$27d79116d3a4e7d5() {
    return $12c5d7db9c9fd030$var$api.registerUsage();
}









// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $019a2a9d86291703$export$338a9f6c7a1f02b0 = 'text/html';




function $f7e69e03886a92e0$var$findTextNode(event) {
    var _event$dataTransfer;
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $1e42c1bc9239c98e$export$95df08bae54cb4df)()) return null;
    /**
   * According to the spec, `event.target` should be the `Text` node that
   * the drag started from when dragging a text selection.
   *
   * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
   *
   * However, in Safari the closest `HTMLElement` is returned.
   * So we need to figure out if text is dragging ourselves.
   *
   * → https://bugs.webkit.org/show_bug.cgi?id=268959
   */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!((_event$dataTransfer = event.dataTransfer) !== null && _event$dataTransfer !== void 0 && _event$dataTransfer.getData((0, $4c8d3d867b71c91e$export$fd3d00026297c0ad)))) return null;
    /**
   * Grab the first Text node and use that.
   * Only doing a single level search as that is all we need for this bug.
   */ var text = Array.from(event.target.childNodes).find(function(node) {
        return node.nodeType === Node.TEXT_NODE;
    });
    return text !== null && text !== void 0 ? text : null;
}
var $f7e69e03886a92e0$var$honeyPotFix = (0, $193d546856b964fc$export$8ecad27c959e89e0)();
var $f7e69e03886a92e0$var$adapter = (0, $5122e0d0088f4b41$export$2aa3a33160990d96)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $8847aab58ded244d$export$1be1fc439b849fdf)($f7e69e03886a92e0$var$honeyPotFix.bindEvents(), (0, $a091c25729a976b1$exports.bind)(window, {
            type: 'dragstart',
            listener: function listener(event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $f77bfd9efc16c1d5$export$c9c4cc54e73b125d))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $4c8d3d867b71c91e$export$fd3d00026297c0ad))) return;
                var target = $f7e69e03886a92e0$var$findTextNode(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                var payload = {
                    // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target: target,
                    plain: event.dataTransfer.getData((0, $4c8d3d867b71c91e$export$fd3d00026297c0ad)),
                    HTML: event.dataTransfer.getData((0, $019a2a9d86291703$export$338a9f6c7a1f02b0))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: $f7e69e03886a92e0$var$honeyPotFix.getOnPostDispatch()
});
function $f7e69e03886a92e0$export$9bfaa8eb182300d1(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $f7e69e03886a92e0$var$adapter.dropTarget(args);
}
// A shared single usage registration as any text can be dragged at any time
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    $f7e69e03886a92e0$var$adapter.registerUsage();
})();
function $f7e69e03886a92e0$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $f7e69e03886a92e0$var$adapter.monitor(args);
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Argument given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */  /** Argument given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ 


 // Payload for the text selection being dragged



function $778617bf987e527d$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var frameId = null;
    var unbindEvents = (0, $a091c25729a976b1$exports.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener: function listener() {
                /**
       * The pdnd `onDragStart()` fires in the frame after "dragstart"
       * So we are delaying our isDragging check to give a chance
       * for `onDragStart()` to set the value correctly.
       *
       * Note: could not use "pointercancel" as it is not
       * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
       */ frameId = requestAnimationFrame(function() {
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $f7e69e03886a92e0$export$2e178e3647f5e6e9)({
        onDragStart: function onDragStart() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $8847aab58ded244d$export$1be1fc439b849fdf)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $778617bf987e527d$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $a091c25729a976b1$exports.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener() {
            // A text selection drag will only start when there is
            // an active text selection.
            var selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
var $778617bf987e527d$var$api = (0, $09d4f4c67999ed78$export$a74bff2507e6126b)({
    watchForInteractionStart: $778617bf987e527d$var$watchForInteractionStart,
    watchForInteractionEnd: $778617bf987e527d$var$watchForInteractionEnd
});
function $778617bf987e527d$export$9c0606fcefb5d1e2() {
    return $778617bf987e527d$var$api.registerUsage();
}


var $5d54e0353823d276$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};


/* positioner.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $iRmtv = parcelRequire("iRmtv");
var $a94201cbfcfbf04d$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
var $a94201cbfcfbf04d$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
var $a94201cbfcfbf04d$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
var $a94201cbfcfbf04d$export$fc825baa2ef870d0 = 'cubic-bezier(0.4,0,0,1)';
var $a94201cbfcfbf04d$export$816ee5d79b5bd9a5 = 'cubic-bezier(0.6,0,0,1)';
var $a94201cbfcfbf04d$export$53ce3390a1a8f2a2 = 'cubic-bezier(0.8,0,0,1)';
var $a94201cbfcfbf04d$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';




// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
var $14b3e8fade42555c$var$positionerStyles = null;
var $14b3e8fade42555c$var$stackStyles = {
    stackTransition: "_k8m01e03 _1bumglyw _sedtglyw",
    stackTransform: "_t9ec1b95",
    stackIdle: "_t9ecglyw"
};
// Hardcoded pixels are based off a 60px base gutter
var $14b3e8fade42555c$var$scrollStyles = {
    viewport: "_4t3i1wug _kqswh2mm _1f6n1wqb _1eot1wug _eoawglyw",
    body: "_we1i18uh _e8uozwhf _y1k5stnw _5ee41nf8 _1urridpf _1juqidpf _yakv1wug _4lht1wug _eoawglyw",
    fullScreen: ""
};
function $14b3e8fade42555c$var$getScrollBehavior(_ref) {
    var isFullScreen = _ref.isFullScreen, shouldScrollInViewport = _ref.shouldScrollInViewport;
    if (isFullScreen) return 'fullScreen';
    if (shouldScrollInViewport) return 'viewport';
    return 'body';
}
var $14b3e8fade42555c$var$Positioner = function Positioner(props) {
    var children = props.children, stackIndex = props.stackIndex, shouldScrollInViewport = props.shouldScrollInViewport, testId = props.testId, isFullScreen = props.isFullScreen;
    var scrollBehavior = $14b3e8fade42555c$var$getScrollBehavior({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        style: {
            '--modal-dialog-translate-y': "calc(".concat(stackIndex, "px * ", "var(--ds-space-100, 8px)", ")"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            transitionDuration: "".concat((0, $f71fbefa8f6c3895$export$38b928a7167ce124).medium, "ms"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            transitionTimingFunction: (0, $a94201cbfcfbf04d$export$c07234257a03d5e9)
        },
        "data-testid": testId && "".concat(testId, "--positioner"),
        className: (0, $iRmtv.default)([
            "_1e0c1txw _1bsb1osq _p12f1osq _4t3i1osq _kqsw1n9t _1pby16oo _2lx21bp4 _152tidpf _1e02idpf",
            $14b3e8fade42555c$var$stackStyles.stackTransition,
            stackIndex > 0 ? $14b3e8fade42555c$var$stackStyles.stackTransform : $14b3e8fade42555c$var$stackStyles.stackIdle,
            $14b3e8fade42555c$var$scrollStyles[scrollBehavior]
        ])
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$14b3e8fade42555c$export$2e2bcd8739ae039 = $14b3e8fade42555c$var$Positioner;


var $2461feae78b6999a$var$dialogWidth = function dialogWidth(input) {
    if (!input) return 'auto';
    var isWidthName = (0, $5d54e0353823d276$export$7e3df82ee760448c).values.indexOf(input.toString()) !== -1;
    var widthName = isWidthName && input;
    if (widthName) return "".concat((0, $5d54e0353823d276$export$7e3df82ee760448c).widths[widthName], "px");
    return typeof input === 'number' ? "".concat(input, "px") : input;
};
var $2461feae78b6999a$var$dialogHeight = function dialogHeight(input) {
    if (!input) return 'auto';
    return typeof input === 'number' ? "".concat(input, "px") : input;
};
var $2461feae78b6999a$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
var $2461feae78b6999a$var$dialogStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _1bsb1osq _p12fauwl _4t3i1osq _1tkeidpf _c71l1kxc _2lx21bp4 _bfhk1bhr _syazi7uo _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _1dg11kw7 _mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y _we1i1kw7 _zg7p130s _yakv1kw7 _4lht1kw7 _1xlt6m9r",
    borderRadius: "_epkxfajl",
    borderRadiusT26Shape: "_epkxpb1k",
    motion: "_4t3i1osq _c71l1kw7 _p12f1kw7 _1jyk1wug _yakv1kw7 _4lht1kw7",
    fullscreen: "_1jyk1osq"
};
var $2461feae78b6999a$var$viewportScrollStyles = null;
var $2461feae78b6999a$var$bodyScrollStyles = null;
var $2461feae78b6999a$var$ModalDialog = function ModalDialog(props) {
    var _props$width = props.width, width = _props$width === void 0 ? 'medium' : _props$width, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, shouldCloseOnEscapePress = props.shouldCloseOnEscapePress, providedAutoFocus = props.autoFocus, stackIndex = props.stackIndex, onClose = props.onClose, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, height = props.height, hasProvidedOnClose = props.hasProvidedOnClose, children = props.children, label = props.label, testId = props.testId, _props$isFullScreen = props.isFullScreen, isFullScreen = _props$isFullScreen === void 0 ? false : _props$isFullScreen, _props$UNSAFE_shouldD = props.UNSAFE_shouldDisableMotionUplift, UNSAFE_shouldDisableMotionUplift = _props$UNSAFE_shouldD === void 0 ? false : _props$UNSAFE_shouldD;
    var id = (0, $d4d502868e612e1e$export$f680877a34711e37)();
    var titleId = "modal-dialog-title-".concat(id);
    var defaultTestId = testId || 'modal-dialog';
    // https://product-fabric.atlassian.net/browse/DSP-24307
    // If flag and falsy, use true instead.
    // When we remove boolean `autoFocus`, we won't have to worry about this
    var autoFocus = !providedAutoFocus ? true : providedAutoFocus;
    (0, $7fPBF.useEffect)(function() {
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, $8847aab58ded244d$export$1be1fc439b849fdf)((0, $907c8937691d0a6f$export$ec28e97c7d8b1b35)(), (0, $778617bf987e527d$export$9c0606fcefb5d1e2)(), (0, $12c5d7db9c9fd030$export$27d79116d3a4e7d5)());
    }, []);
    (0, $7ef5eb1b79d03b33$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(autoFocus) === 'object' ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(autoFocus) === 'object');
    var _useOnMotionFinish = (0, $6d635366f5fb15d1$export$2e2bcd8739ae039)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    }), _useOnMotionFinish2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useOnMotionFinish, 2), motionRef = _useOnMotionFinish2[0], onMotionFinish = _useOnMotionFinish2[1];
    var modalDialogContext = (0, $7fPBF.useMemo)(function() {
        return {
            testId: defaultTestId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose,
            isFullScreen: isFullScreen
        };
    }, [
        defaultTestId,
        titleId,
        onClose,
        hasProvidedOnClose,
        isFullScreen
    ]);
    (0, $9a1b26136f3a7f68$export$4a4bf067ea9e7886)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    var _useLayering = (0, $9a1b26136f3a7f68$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    return /*#__PURE__*/ $7fPBF.createElement((0, $14b3e8fade42555c$export$2e2bcd8739ae039), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: defaultTestId,
        isFullScreen: isFullScreen
    }, /*#__PURE__*/ $7fPBF.createElement((0, $e531343e66f94fe5$export$ab57792b9b6974a6).Provider, {
        value: modalDialogContext
    }, /*#__PURE__*/ $7fPBF.createElement((0, $e531343e66f94fe5$export$dece24112a937f92).Provider, {
        value: shouldScrollInViewport
    }, !UNSAFE_shouldDisableMotionUplift && (0, $137Lh.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ $7fPBF.createElement((0, $ada36c25659d67df$export$2e2bcd8739ae039), {
        enteringAnimation: "var(--ds-modal-enter, 250ms cubic-bezier(0.4, 0, 0, 1) ScaleIn95to100)",
        exitingAnimation: "var(--ds-modal-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to95)",
        onFinish: onMotionFinish,
        xcss: (0, $e636b2257db42c06$export$a274e22fb40f762e)($2461feae78b6999a$var$dialogStyles.motion, isFullScreen && $2461feae78b6999a$var$dialogStyles.fullscreen)
    }, /*#__PURE__*/ $7fPBF.createElement("section", {
        "aria-label": label,
        ref: motionRef,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-width': $2461feae78b6999a$var$dialogWidth(width),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-height': $2461feae78b6999a$var$dialogHeight(height)
        },
        role: "dialog",
        "aria-labelledby": label ? undefined : titleId,
        "data-testid": defaultTestId,
        "data-modal-stack": stackIndex,
        tabIndex: -1,
        "aria-modal": true,
        "data-ds--level": currentLevel,
        className: (0, $iRmtv.default)([
            $2461feae78b6999a$var$dialogStyles.root,
            !isFullScreen && $2461feae78b6999a$var$dialogStyles.borderRadius,
            !isFullScreen && (0, $137Lh.fg)('platform-dst-shape-theme-default') && $2461feae78b6999a$var$dialogStyles.borderRadiusT26Shape,
            shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7"
        ])
    }, children)) : /*#__PURE__*/ $7fPBF.createElement((0, $a6c67c5a8158581e$export$2e2bcd8739ae039), {
        entranceDirection: isFullScreen ? undefined : 'bottom',
        onFinish: onMotionFinish
    }, function(bottomFadeInProps) {
        return /*#__PURE__*/ $7fPBF.createElement("section", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, bottomFadeInProps, {
            "aria-label": label,
            ref: (0, $9ec85dcfc6117313$export$2e2bcd8739ae039)([
                bottomFadeInProps.ref,
                motionRef
            ]),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-width': $2461feae78b6999a$var$dialogWidth(width),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-height': $2461feae78b6999a$var$dialogHeight(height)
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $iRmtv.default)([
                $2461feae78b6999a$var$dialogStyles.root,
                !isFullScreen && $2461feae78b6999a$var$dialogStyles.borderRadius,
                !isFullScreen && (0, $137Lh.fg)('platform-dst-shape-theme-default') && $2461feae78b6999a$var$dialogStyles.borderRadiusT26Shape,
                shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7",
                bottomFadeInProps.className
            ]),
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": defaultTestId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true,
            "data-ds--level": currentLevel
        }), children);
    }))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2461feae78b6999a$export$2e2bcd8739ae039 = $2461feae78b6999a$var$ModalDialog;


var $adfcc25ee31e4e47$var$fillScreenStyles = null;
var $adfcc25ee31e4e47$var$allowlistElements = function allowlistElements(element, callback) {
    // Allow focus to reach elements outside the modal:
    // if AUI dialog is allowListed and visible
    if (document.querySelector('.aui-blanket:not([hidden])')) return false;
    // allows to pass a callback function to allow elements be ignored by focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
};
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $adfcc25ee31e4e47$var$InternalModalWrapper = function InternalModalWrapper(props) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, focusLockAllowlist = props.focusLockAllowlist, _props$shouldCloseOnE = props.shouldCloseOnEscapePress, shouldCloseOnEscapePress = _props$shouldCloseOnE === void 0 ? true : _props$shouldCloseOnE, _props$shouldCloseOnO = props.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _props$shouldCloseOnO === void 0 ? true : _props$shouldCloseOnO, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, _props$shouldReturnFo = props.shouldReturnFocus, shouldReturnFocus = _props$shouldReturnFo === void 0 ? true : _props$shouldReturnFo, stackIndexOverride = props.stackIndex, providedOnClose = props.onClose, _props$onStackChange = props.onStackChange, onStackChange = _props$onStackChange === void 0 ? (0, $f48d740006cf3f7d$export$2e2bcd8739ae039) : _props$onStackChange, isBlanketHidden = props.isBlanketHidden, children = props.children, height = props.height, width = props.width, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, label = props.label, testId = props.testId, isFullScreen = props.isFullScreen, _props$UNSAFE_shouldD = props.UNSAFE_shouldDisableMotionUplift, UNSAFE_shouldDisableMotionUplift = _props$UNSAFE_shouldD === void 0 ? false : _props$UNSAFE_shouldD;
    var calculatedStackIndex = (0, $395dcebe8a28322c$export$2e2bcd8739ae039)({
        onStackChange: onStackChange
    });
    var stackIndex = stackIndexOverride || calculatedStackIndex;
    var isForeground = stackIndex === 0;
    // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    // When flag is true and a ref is not supplied, autofocus is true. See https://product-fabric.atlassian.net/browse/DSP-24307
    // When we remove boolean `autoFocus`, we won't have to worry about this
    var autoFocusLock = typeof autoFocus === 'boolean';
    var onCloseHandler = (0, $593ac790924c31ca$export$a4687b0234b40e28)({
        fn: providedOnClose || (0, $f48d740006cf3f7d$export$2e2bcd8739ae039),
        action: 'closed',
        componentName: 'modalDialog',
        packageName: "@atlaskit/modal-dialog",
        packageVersion: "14.18.1"
    });
    var onBlanketClicked = (0, $7fPBF.useCallback)(function(e) {
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    // This ensures to prevent additional re-renders while nothing is passed to focusLockAllowlist explicitly.
    var allowListCallback = (0, $7fPBF.useCallback)(function(element) {
        return $adfcc25ee31e4e47$var$allowlistElements(element, focusLockAllowlist);
    }, [
        focusLockAllowlist
    ]);
    (0, $a082a6b1512440da$export$2e2bcd8739ae039)();
    (0, $e85233b93e6c09f0$export$469bb693f11edc7f)({
        type: 'modal',
        // Modal dialog is conditionally rendered when visible, so when this runs it is always open.
        isOpen: true,
        // Passing a no-op for now, as there isn't a real use case for closing the modal dialog programmatically
        // by the OpenLayerObserver. The only current use case is closing layers when resizing the nav layout,
        // which cannot happen while a modal dialog is open.
        onClose: (0, $f48d740006cf3f7d$export$2e2bcd8739ae039)
    });
    var modalDialogWithBlanket = /*#__PURE__*/ $7fPBF.createElement((0, $7fc59c5c15274b69$export$2e2bcd8739ae039), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && "".concat(testId, "--blanket")
    }, /*#__PURE__*/ $7fPBF.createElement((0, $2461feae78b6999a$export$2e2bcd8739ae039), {
        testId: testId,
        label: label,
        autoFocus: autoFocus,
        stackIndex: stackIndex,
        onClose: onCloseHandler,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
        shouldScrollInViewport: shouldScrollInViewport,
        height: height,
        width: width,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete,
        hasProvidedOnClose: Boolean(providedOnClose),
        isFullScreen: isFullScreen,
        UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift
    }, children));
    var returnFocus = true;
    var onDeactivation = (0, $f48d740006cf3f7d$export$2e2bcd8739ae039);
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = function onDeactivation() {
        window.setTimeout(function() {
            var _shouldReturnFocus$cu;
            (_shouldReturnFocus$cu = shouldReturnFocus.current) === null || _shouldReturnFocus$cu === void 0 || _shouldReturnFocus$cu.focus();
        }, 0);
    };
    return /*#__PURE__*/ $7fPBF.createElement((0, $b834a4da819e1421$export$7c885f891c940977), {
        isDisabled: false
    }, /*#__PURE__*/ $7fPBF.createElement((0, $cd3bc8368572caba$export$2e2bcd8739ae039), {
        zIndex: (0, $efca76a44a24c722$export$7be255094ccdc533).modal()
    }, !UNSAFE_shouldDisableMotionUplift && (0, $137Lh.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ $7fPBF.createElement((0, $ada36c25659d67df$export$2e2bcd8739ae039), {
        enteringAnimation: "var(--ds-blanket-enter, 250ms cubic-bezier(0.4, 0, 0, 1) FadeIn0to100)",
        exitingAnimation: "var(--ds-blanket-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    }, /*#__PURE__*/ $7fPBF.createElement("div", {
        "aria-hidden": !isForeground,
        className: (0, $iRmtv.default)([
            "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement((0, $2cb7353992a884b7$export$2e2bcd8739ae039), {
        autoFocus: autoFocusLock,
        returnFocus: returnFocus,
        onDeactivation: onDeactivation,
        whiteList: allowListCallback
    }, /*#__PURE__*/ $7fPBF.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eefcbb4433f6e9f3$exports))), null), shouldScrollInViewport ? /*#__PURE__*/ $7fPBF.createElement((0, $eefcbb4433f6e9f3$exports.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket))) : /*#__PURE__*/ $7fPBF.createElement((0, $a6c67c5a8158581e$export$2e2bcd8739ae039), null, function(fadeInProps) {
        return /*#__PURE__*/ $7fPBF.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, fadeInProps, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $iRmtv.default)([
                "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0",
                fadeInProps.className
            ]),
            "aria-hidden": !isForeground
        }), /*#__PURE__*/ $7fPBF.createElement((0, $2cb7353992a884b7$export$2e2bcd8739ae039), {
            autoFocus: autoFocusLock,
            returnFocus: returnFocus,
            onDeactivation: onDeactivation,
            whiteList: allowListCallback
        }, /*#__PURE__*/ $7fPBF.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eefcbb4433f6e9f3$exports))), null), shouldScrollInViewport ? /*#__PURE__*/ $7fPBF.createElement((0, $eefcbb4433f6e9f3$exports.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket));
    })));
};
var $adfcc25ee31e4e47$export$2e2bcd8739ae039 = $adfcc25ee31e4e47$var$InternalModalWrapper;


function $95611d2ac5b62126$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $adfcc25ee31e4e47$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, props, {
        isFullScreen: false
    }));
}

/* modal-body.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $iRmtv = parcelRequire("iRmtv");

var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");

var $007dd3816635191b$export$33ffd74ebf07f060 = function useModal() {
    var modalContext = (0, $7fPBF.useContext)((0, $e531343e66f94fe5$export$ab57792b9b6974a6));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};


/* scroll-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $iKdEz = parcelRequire("iKdEz");


var $7fPBF = parcelRequire("7fPBF");






/* focusable.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $iRmtv = parcelRequire("iRmtv");
var $2eb21ba491269645$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $2eb21ba491269645$var$_excluded2 = [
    "className"
];
var $2eb21ba491269645$var$focusRingStyles = null;
var $2eb21ba491269645$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $2eb21ba491269645$var$Focusable = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $2eb21ba491269645$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $2eb21ba491269645$var$_excluded2);
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $iRmtv.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $2eb21ba491269645$export$2e2bcd8739ae039 = $2eb21ba491269645$var$Focusable;


var $171cde25fbd921b6$var$keylineColor = "var(--ds-border, #0B120E24)";
var $171cde25fbd921b6$var$styles = {
    base: "_kkes1kw7 _1e0c1kw7 _2lx21kw7 _16jlkb7n _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1reo15vq _18m91wug _1jykn7od _wzg61wug",
    topKeyline: "_mqm21uh4",
    bottomKeyline: "_179r1uh4"
};
var $171cde25fbd921b6$var$keylineHeight = 2;
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ var $171cde25fbd921b6$var$ScrollContainer = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var testId = _ref.testId, children = _ref.children;
    var scrollableRef = (0, $7fPBF.useRef)(null);
    var _useState = (0, $7fPBF.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), showTopKeyline = _useState2[0], setTopKeyline = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 2), showBottomKeyline = _useState4[0], setBottomKeyline = _useState4[1];
    var _useState5 = (0, $7fPBF.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState5, 2), showContentFocus = _useState6[0], setContentFocus = _useState6[1];
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $7fPBF.useEffect)(function() {
        var schedule = (0, $c15db151bfb9ee49$export$2e2bcd8739ae039)(function() {
            var target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    var setLazyKeylines = (0, $516cd57f73bbe395$export$2e2bcd8739ae039)((0, $c15db151bfb9ee49$export$2e2bcd8739ae039)(function() {
        var target = scrollableRef.current;
        if (target) {
            var scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $171cde25fbd921b6$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $171cde25fbd921b6$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $7fPBF.useEffect)(function() {
        var target = scrollableRef.current;
        setLazyKeylines();
        var unbindWindowEvent = (0, $a091c25729a976b1$exports.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        var unbindTargetEvent = target ? (0, $a091c25729a976b1$exports.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $f48d740006cf3f7d$export$2e2bcd8739ae039);
        return function() {
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2eb21ba491269645$export$2e2bcd8739ae039), {
        as: "div",
        isInset: true,
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        testId: testId && "".concat(testId, "--scrollable"),
        ref: (0, $9ec85dcfc6117313$export$2e2bcd8739ae039)([
            ref,
            scrollableRef
        ]),
        xcss: (0, $e636b2257db42c06$export$a274e22fb40f762e)($171cde25fbd921b6$var$styles.base, showTopKeyline && $171cde25fbd921b6$var$styles.topKeyline, showBottomKeyline && $171cde25fbd921b6$var$styles.bottomKeyline)
    }, children);
});
$171cde25fbd921b6$var$ScrollContainer.displayName = 'ScrollContainer';
var $171cde25fbd921b6$export$2e2bcd8739ae039 = $171cde25fbd921b6$var$ScrollContainer;



var $7fPBF = parcelRequire("7fPBF");

function $7b74817fdec7e710$export$2e2bcd8739ae039() {
    var shouldScrollInViewport = (0, $7fPBF.useContext)((0, $e531343e66f94fe5$export$dece24112a937f92));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}


var $b3739a2c2476e4e5$var$styles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _11c8fhey",
    paddingBlock: "_1rjcv77o",
    paddingInline: "_18zr1ejb"
};
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $b3739a2c2476e4e5$var$ModalBody = function ModalBody(props) {
    var children = props.children, userDefinedTestId = props.testId, _props$hasInlinePaddi = props.hasInlinePadding, hasInlinePadding = _props$hasInlinePaddi === void 0 ? true : _props$hasInlinePaddi;
    var _useModal = (0, $007dd3816635191b$export$33ffd74ebf07f060)(), modalTestId = _useModal.testId;
    var shouldScrollInViewport = (0, $7b74817fdec7e710$export$2e2bcd8739ae039)();
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--body");
    return shouldScrollInViewport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        "data-testid": testId,
        className: (0, $iRmtv.default)([
            $b3739a2c2476e4e5$var$styles.root,
            hasInlinePadding && $b3739a2c2476e4e5$var$styles.paddingInline
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $eefcbb4433f6e9f3$exports.TouchScrollable), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $171cde25fbd921b6$export$2e2bcd8739ae039), {
        testId: userDefinedTestId || modalTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        "data-testid": testId,
        className: (0, $iRmtv.default)([
            $b3739a2c2476e4e5$var$styles.root,
            /**
     * Adding block padding for scroll keylines, which are only shown when the scrolling
     * is on the container.
     */ $b3739a2c2476e4e5$var$styles.paddingBlock,
            hasInlinePadding && $b3739a2c2476e4e5$var$styles.paddingInline
        ])
    }, children)));
};
var $b3739a2c2476e4e5$export$2e2bcd8739ae039 = $b3739a2c2476e4e5$var$ModalBody;

/* modal-footer.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $iRmtv = parcelRequire("iRmtv");

var $845716ea19676e23$var$footerStyles = null;
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $845716ea19676e23$var$ModalFooter = function ModalFooter(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $007dd3816635191b$export$33ffd74ebf07f060)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--footer");
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        "data-testid": testId,
        className: (0, $iRmtv.default)([
            "_zulpu2gc _18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bahesu3 _1pfh1i6y _85i51ejb _1q51pxbi"
        ])
    }, children);
};
var $845716ea19676e23$export$2e2bcd8739ae039 = $845716ea19676e23$var$ModalFooter;

/* modal-header.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $iRmtv = parcelRequire("iRmtv");

var $7fPBF = parcelRequire("7fPBF");
/* flex.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");

var $iRmtv = parcelRequire("iRmtv");
var $30fd0ae3863801e1$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $30fd0ae3863801e1$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $30fd0ae3863801e1$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $30fd0ae3863801e1$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $30fd0ae3863801e1$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $30fd0ae3863801e1$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $30fd0ae3863801e1$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $30fd0ae3863801e1$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $30fd0ae3863801e1$var$Flex = /*#__PURE__*/ (0, $7fPBF.memo)(/*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $30fd0ae3863801e1$var$_excluded);
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, ariaAttributes, {
        role: role,
        className: (0, $iRmtv.default)([
            $30fd0ae3863801e1$var$styles.root,
            gap && $30fd0ae3863801e1$var$columnGapMap[gap],
            columnGap && $30fd0ae3863801e1$var$columnGapMap[columnGap],
            gap && $30fd0ae3863801e1$var$rowGapMap[gap],
            rowGap && $30fd0ae3863801e1$var$rowGapMap[rowGap],
            alignItems && $30fd0ae3863801e1$var$alignItemsMap[alignItems],
            direction && $30fd0ae3863801e1$var$flexDirectionMap[direction],
            justifyContent && $30fd0ae3863801e1$var$justifyContentMap[justifyContent],
            wrap && $30fd0ae3863801e1$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$30fd0ae3863801e1$var$Flex.displayName = 'Flex';
var $30fd0ae3863801e1$export$2e2bcd8739ae039 = $30fd0ae3863801e1$var$Flex;



var $7fPBF = parcelRequire("7fPBF");

var $0d4992c8c1557c6e$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($0d4992c8c1557c6e$exports, "__esModule", {
    value: true
});
$0d4992c8c1557c6e$exports.default = void 0;

var $0d4992c8c1557c6e$var$_react = $0d4992c8c1557c6e$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $0d4992c8c1557c6e$var$_baseNew = $0d4992c8c1557c6e$var$_interopRequireDefault((parcelRequire("kHIu0")));
function $0d4992c8c1557c6e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0d4992c8c1557c6e$var$CrossIcon = (props)=>/*#__PURE__*/ $0d4992c8c1557c6e$var$_react.default.createElement($0d4992c8c1557c6e$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$0d4992c8c1557c6e$var$CrossIcon.displayName = 'CrossIcon';
var $0d4992c8c1557c6e$var$_default = $0d4992c8c1557c6e$exports.default = $0d4992c8c1557c6e$var$CrossIcon;


var $6df3aa8eabe874e9$export$de65de8213222d10 = function CloseButton(_ref) {
    var label = _ref.label, onBlur = _ref.onBlur, onClick = _ref.onClick, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $729d339602a97fd3$export$2e2bcd8739ae039), {
        testId: testId && "".concat(testId, "--close-button"),
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($0d4992c8c1557c6e$exports))),
        label: label || 'Close Modal',
        onBlur: onBlur,
        onClick: onClick
    });
};



var $78ffec079aff50d9$var$styles = {
    header: "_18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bah1yb4 _6rth1i6y _85i5pxbi _1q511ejb",
    flex: "_2lx21sbv _1bsb1osq",
    titleContainer: "_1ul9idpf"
};
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $78ffec079aff50d9$var$ModalHeader = function ModalHeader(props) {
    var children = props.children, userDefinedTestId = props.testId, _props$hasCloseButton = props.hasCloseButton, hasCloseButton = _props$hasCloseButton === void 0 ? false : _props$hasCloseButton;
    var _useModal = (0, $007dd3816635191b$export$33ffd74ebf07f060)(), hasProvidedOnClose = _useModal.hasProvidedOnClose, onClose = _useModal.onClose, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--header");
    // Only show if an onClose was provided for the modal dialog
    var shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        "data-testid": testId,
        className: (0, $iRmtv.default)([
            $78ffec079aff50d9$var$styles.header
        ])
    }, shouldShowCloseButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $30fd0ae3863801e1$export$2e2bcd8739ae039), {
        gap: "space.200",
        justifyContent: "space-between",
        xcss: $78ffec079aff50d9$var$styles.flex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $30fd0ae3863801e1$export$2e2bcd8739ae039), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $6df3aa8eabe874e9$export$de65de8213222d10), {
        onClick: onClose,
        testId: modalTestId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $30fd0ae3863801e1$export$2e2bcd8739ae039), {
        justifyContent: "start",
        alignItems: "center",
        xcss: $78ffec079aff50d9$var$styles.titleContainer
    }, children)) : children);
};
var $78ffec079aff50d9$export$2e2bcd8739ae039 = $78ffec079aff50d9$var$ModalHeader;

/* modal-title.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $iRmtv = parcelRequire("iRmtv");
var $916824fcac3dc8a3$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($916824fcac3dc8a3$exports, "__esModule", {
    value: true
});
$916824fcac3dc8a3$exports.default = void 0;

var $916824fcac3dc8a3$var$_react = $916824fcac3dc8a3$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $916824fcac3dc8a3$var$_baseNew = $916824fcac3dc8a3$var$_interopRequireDefault((parcelRequire("kHIu0")));
function $916824fcac3dc8a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $916824fcac3dc8a3$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $916824fcac3dc8a3$var$_react.default.createElement($916824fcac3dc8a3$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$916824fcac3dc8a3$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $916824fcac3dc8a3$var$_default = $916824fcac3dc8a3$exports.default = $916824fcac3dc8a3$var$StatusErrorIcon;


var $26545dff2c625c5f$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee7b3f114c675eea0f953c33a485bcf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($26545dff2c625c5f$exports, "__esModule", {
    value: true
});
$26545dff2c625c5f$exports.default = void 0;

var $26545dff2c625c5f$var$_react = $26545dff2c625c5f$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $26545dff2c625c5f$var$_baseNew = $26545dff2c625c5f$var$_interopRequireDefault((parcelRequire("kHIu0")));
function $26545dff2c625c5f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $26545dff2c625c5f$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $26545dff2c625c5f$var$_react.default.createElement($26545dff2c625c5f$var$_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$26545dff2c625c5f$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $26545dff2c625c5f$var$_default = $26545dff2c625c5f$exports.default = $26545dff2c625c5f$var$StatusWarningIcon;



var $643b6d5cc9e6a567$var$iconColor = {
    danger: "var(--ds-icon-danger, #C9372C)",
    warning: "var(--ds-icon-warning, #E06C00)"
};
var $643b6d5cc9e6a567$var$iconStyles = null;
var $643b6d5cc9e6a567$var$titleStyles = null;
var $643b6d5cc9e6a567$var$textStyles = null;
var $643b6d5cc9e6a567$var$truncatedTextStyles = null;
var $643b6d5cc9e6a567$var$TitleIcon = function TitleIcon(_ref) {
    var appearance = _ref.appearance;
    var Icon = appearance === 'danger' ? (0, (/*@__PURE__*/$parcel$interopDefault($916824fcac3dc8a3$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($26545dff2c625c5f$exports)));
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, $iRmtv.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _syaz1kw7 _1wyb1kw7 _zg8l1kw7 _k48p1kw7 _1dyz1kw7 _vwz41kw7"
        ])
    }, /*#__PURE__*/ $7fPBF.createElement(Icon, {
        label: appearance,
        color: $643b6d5cc9e6a567$var$iconColor[appearance],
        spacing: "spacious"
    }));
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $643b6d5cc9e6a567$var$ModalTitle = function ModalTitle(props) {
    var appearance = props.appearance, children = props.children, _props$isMultiline = props.isMultiline, isMultiline = _props$isMultiline === void 0 ? true : _props$isMultiline, userDefinedTestId = props.testId;
    var _useModal = (0, $007dd3816635191b$export$33ffd74ebf07f060)(), titleId = _useModal.titleId, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--title");
    return /*#__PURE__*/ $7fPBF.createElement("h1", {
        "data-testid": testId,
        className: (0, $iRmtv.default)([
            "_zulpu2gc _11c81af2 _1e0c1txw _1ul9idpf _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t"
        ])
    }, appearance && /*#__PURE__*/ $7fPBF.createElement($643b6d5cc9e6a567$var$TitleIcon, {
        appearance: appearance
    }), /*#__PURE__*/ $7fPBF.createElement("span", {
        id: titleId,
        "data-testid": testId && "".concat(testId, "-text"),
        className: (0, $iRmtv.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _11c81af2 _1ul9idpf _slp31hna",
            !isMultiline && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ])
    }, children));
};
var $643b6d5cc9e6a567$export$2e2bcd8739ae039 = $643b6d5cc9e6a567$var$ModalTitle;


var $7fPBF = parcelRequire("7fPBF");

/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $61dd53007c997406$var$ModalTransition = function ModalTransition(props) {
    var _props$children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a1ad98f67aabe587$export$2e2bcd8739ae039), {
        appear: true
    }, (_props$children = props.children) !== null && _props$children !== void 0 ? _props$children : null);
};
var $61dd53007c997406$export$2e2bcd8739ae039 = $61dd53007c997406$var$ModalTransition;



var $7fPBF = parcelRequire("7fPBF");






const $ab16c582615dabed$var$ConsentDeclinePrDialog = ()=>{
    const dispatch = (0, $7ef2374eddee6a70$export$f51d452c10d5b956)();
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    const dialogPayload = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$e15e41f6dd0733a8));
    const acceptHandler = (0, $7fPBF.useCallback)(async ()=>{
        var _dialogPayload_update;
        (0, $0e08eda71bb24540$export$ee3c89fcd945a704)({
            source: (_dialogPayload_update = dialogPayload.update) === null || _dialogPayload_update === void 0 ? void 0 : _dialogPayload_update.sourceItem,
            componentName: 'modal'
        });
        // send originating request
        if (dialogPayload.update !== null) dispatch((0, $3d2cac913f314860$export$807cff22f0457821)(dialogPayload.update));
        // close dialog
        dispatch((0, $3d2cac913f314860$export$cab60deb7aecd81e)({
            showDialog: false
        }));
    }, [
        dispatch,
        dialogPayload
    ]);
    const cancelHandler = (0, $7fPBF.useCallback)(()=>{
        var _dialogPayload_update;
        (0, $0e08eda71bb24540$export$76b1ce7baa042b11)({
            source: (_dialogPayload_update = dialogPayload.update) === null || _dialogPayload_update === void 0 ? void 0 : _dialogPayload_update.sourceItem,
            componentName: 'modal'
        });
        // close dialog
        dispatch((0, $3d2cac913f314860$export$cab60deb7aecd81e)({
            showDialog: false
        }));
    }, [
        dispatch,
        dialogPayload
    ]);
    const actions = [
        {
            text: translate((0, $447ba15143f7eed7$exports).CONSENT_DECLINE_PR_ACCEPT_BUTTON_LABEL),
            onClick: acceptHandler,
            autoFocus: true,
            appearance: 'warning',
            testId: 'consent-decline-pr-accept-button'
        },
        {
            text: translate((0, $447ba15143f7eed7$exports).CONSENT_DECLINE_PR_CANCEL_BUTTON_LABEL),
            onClick: cancelHandler,
            appearance: 'subtle',
            testId: 'consent-decline-pr-cancel-button'
        }
    ];
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $61dd53007c997406$export$2e2bcd8739ae039), {
        children: dialogPayload.showDialog && /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $95611d2ac5b62126$export$2e2bcd8739ae039), {
            onClose: cancelHandler,
            testId: "consentDeclinePr",
            children: [
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $78ffec079aff50d9$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $643b6d5cc9e6a567$export$2e2bcd8739ae039), {
                        appearance: 'warning',
                        children: translate((0, $447ba15143f7eed7$exports).CONSENT_DECLINE_PR_DIALOG_LABEL)
                    })
                }),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $b3739a2c2476e4e5$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("p", {
                        dangerouslySetInnerHTML: {
                            __html: translate((0, $447ba15143f7eed7$exports).CONSENT_DECLINE_PR_DIALOG_MESSAGE)
                        }
                    })
                }),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $845716ea19676e23$export$2e2bcd8739ae039), {
                    children: actions.map((a)=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $317b0dc61223a332$export$2e2bcd8739ae039), {
                            appearance: a.appearance,
                            onClick: a.onClick,
                            autoFocus: a.autoFocus,
                            testId: a.testId,
                            children: a.text
                        }, a.testId))
                })
            ]
        })
    });
};
var $ab16c582615dabed$export$2e2bcd8739ae039 = $ab16c582615dabed$var$ConsentDeclinePrDialog;







var $7fPBF = parcelRequire("7fPBF");








const $b9140ff8d659df65$var$ConsentDialog = ()=>{
    var _dialogPayload_update, _dialogPayload_update1;
    const dispatch = (0, $7ef2374eddee6a70$export$f51d452c10d5b956)();
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    const dialogPayload = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$5bb16d4fc4eb5b53));
    const currentGmoi = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$f26c97331adc89d5)('consents', 'generalMarketingOptIn'));
    const updateKeys = (0, $7fPBF.useMemo)(()=>[], []);
    let message = '';
    if (((_dialogPayload_update = dialogPayload.update) === null || _dialogPayload_update === void 0 ? void 0 : _dialogPayload_update.sourceGroup) === 'product_recommendations') {
        if (currentGmoi !== (0, $91cadcf42f447377$export$3d4da522aa66ad7).ON) {
            message = translate((0, $447ba15143f7eed7$exports).CONSENT_DIALOG_GMOI_MESSAGE);
            updateKeys.push('generalMarketingOptIn');
        }
    } else if (((_dialogPayload_update1 = dialogPayload.update) === null || _dialogPayload_update1 === void 0 ? void 0 : _dialogPayload_update1.sourceGroup) === 'consents') {
        if (dialogPayload.update.sourceItem === 'generalMarketingOptIn') {
            message = translate((0, $447ba15143f7eed7$exports).CONSENT_DIALOG_GMOI_MESSAGE);
            updateKeys.push('generalMarketingOptIn');
        } else if (dialogPayload.update.sourceItem === undefined) {
            if (dialogPayload.update.keys.length === 1 && dialogPayload.update.keys[0] === 'generalMarketingOptIn') message = translate((0, $447ba15143f7eed7$exports).CONSENT_DIALOG_GMOI_MESSAGE);
            for (const item of dialogPayload.update.keys)updateKeys.push(item);
        }
    }
    const acceptHandler = (0, $7fPBF.useCallback)(async ()=>{
        var _dialogPayload_update, _dialogPayload_update1, _dialogPayload_update2, _dialogPayload_update3, _dialogPayload_update4;
        const sourceItem = (_dialogPayload_update = dialogPayload.update) === null || _dialogPayload_update === void 0 ? void 0 : _dialogPayload_update.sourceItem;
        const sourceGroup = (_dialogPayload_update1 = dialogPayload.update) === null || _dialogPayload_update1 === void 0 ? void 0 : _dialogPayload_update1.sourceGroup;
        const sourceTab = (_dialogPayload_update2 = dialogPayload.update) === null || _dialogPayload_update2 === void 0 ? void 0 : _dialogPayload_update2.sourceTab;
        (0, $0e08eda71bb24540$export$1ee474b7e28ef3c0)({
            source: sourceItem,
            groupName: sourceGroup,
            componentName: 'modal'
        });
        if (sourceGroup === 'product_recommendations') {
            if (sourceItem) (0, $0e08eda71bb24540$export$b2d5c41c71279068)(true, {
                source: sourceItem
            });
            else (0, $0e08eda71bb24540$export$19e5a6bca6f03118)(true, {
                groupName: sourceGroup,
                tabName: sourceTab
            });
        }
        // accept consents and originating request
        const keys = [];
        keys.push(...updateKeys);
        if (dialogPayload.update !== undefined && dialogPayload.update !== null) keys.push(...dialogPayload.update.keys);
        dispatch((0, $3d2cac913f314860$export$807cff22f0457821)({
            keys: keys,
            state: (0, $e11fceb31fd1a0cb$export$e743037aea74f514).true,
            bypassConsentCheck: false,
            bypassConsentDeclinePrCheck: false,
            skipNotification: false,
            sourceGroup: (_dialogPayload_update3 = dialogPayload.update) === null || _dialogPayload_update3 === void 0 ? void 0 : _dialogPayload_update3.sourceGroup,
            sourceItem: (_dialogPayload_update4 = dialogPayload.update) === null || _dialogPayload_update4 === void 0 ? void 0 : _dialogPayload_update4.sourceItem
        }));
        // close dialog
        dispatch((0, $3d2cac913f314860$export$6b7ef6c2de46cbd4)({
            showDialog: false
        }));
    }, [
        dispatch,
        dialogPayload,
        updateKeys
    ]);
    const cancelHandler = (0, $7fPBF.useCallback)(()=>{
        var _dialogPayload_update, _dialogPayload_update1;
        (0, $0e08eda71bb24540$export$f9f36241b679fafe)({
            source: (_dialogPayload_update = dialogPayload.update) === null || _dialogPayload_update === void 0 ? void 0 : _dialogPayload_update.sourceItem,
            groupName: (_dialogPayload_update1 = dialogPayload.update) === null || _dialogPayload_update1 === void 0 ? void 0 : _dialogPayload_update1.sourceGroup,
            componentName: 'modal'
        });
        // close dialog
        dispatch((0, $3d2cac913f314860$export$6b7ef6c2de46cbd4)({
            showDialog: false
        }));
    }, [
        dispatch,
        dialogPayload
    ]);
    const actions = [
        {
            text: translate((0, $447ba15143f7eed7$exports).CONSENT_DIALOG_ACCEPT_BUTTON_LABEL),
            onClick: acceptHandler,
            autoFocus: true,
            appearance: 'primary',
            testId: 'consent-dialog-accept-button'
        },
        {
            text: translate((0, $447ba15143f7eed7$exports).CONSENT_DIALOG_DECLINE_BUTTON_LABEL),
            onClick: cancelHandler,
            appearance: 'subtle',
            testId: 'consent-dialog-cancel-button'
        }
    ];
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $61dd53007c997406$export$2e2bcd8739ae039), {
        children: dialogPayload.showDialog && /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $95611d2ac5b62126$export$2e2bcd8739ae039), {
            onClose: cancelHandler,
            testId: "consentDialog",
            children: [
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $78ffec079aff50d9$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $643b6d5cc9e6a567$export$2e2bcd8739ae039), {
                        children: translate((0, $447ba15143f7eed7$exports).CONSENT_DIALOG_LABEL)
                    })
                }),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $b3739a2c2476e4e5$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("p", {
                        dangerouslySetInnerHTML: {
                            __html: message
                        }
                    })
                }),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $845716ea19676e23$export$2e2bcd8739ae039), {
                    children: actions.map((a)=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $317b0dc61223a332$export$2e2bcd8739ae039), {
                            appearance: a.appearance,
                            onClick: a.onClick,
                            autoFocus: a.autoFocus,
                            testId: a.testId,
                            children: a.text
                        }, a.testId))
                })
            ]
        })
    });
};
var $b9140ff8d659df65$export$2e2bcd8739ae039 = $b9140ff8d659df65$var$ConsentDialog;







var $7fPBF = parcelRequire("7fPBF");







const $68c6614e902c1d6d$var$GlobalUnsubscribeDialog = ({ onUnsubscribeClick: onUnsubscribeClick })=>{
    const dispatch = (0, $7ef2374eddee6a70$export$f51d452c10d5b956)();
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    const dialogPayload = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$4c4595253c03ba56));
    const acceptHandler = (0, $7fPBF.useCallback)(async ()=>{
        onUnsubscribeClick();
        // Close dialog
        dispatch((0, $3d2cac913f314860$export$3bb76b2ce1d4f171)({
            showDialog: false
        }));
    }, [
        dispatch,
        onUnsubscribeClick
    ]);
    const cancelHandler = (0, $7fPBF.useCallback)(()=>{
        (0, $0e08eda71bb24540$export$11887f10ee02c881)();
        // Close dialog
        dispatch((0, $3d2cac913f314860$export$3bb76b2ce1d4f171)({
            showDialog: false
        }));
    }, [
        dispatch
    ]);
    const actions = [
        {
            text: translate((0, $447ba15143f7eed7$exports).GLOBAL_UNSUBSCRIBE_DIALOG_ACCEPT_BUTTON_LABEL),
            onClick: acceptHandler,
            autoFocus: true,
            appearance: 'primary',
            testId: 'global-unsubscribe-dialog-accept-button'
        },
        {
            text: translate((0, $447ba15143f7eed7$exports).GLOBAL_UNSUBSCRIBE_DIALOG_DECLINE_BUTTON_LABEL),
            onClick: cancelHandler,
            appearance: 'subtle',
            testId: 'global-unsubscribe-dialog-cancel-button'
        }
    ];
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $61dd53007c997406$export$2e2bcd8739ae039), {
        children: dialogPayload.showDialog && /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $95611d2ac5b62126$export$2e2bcd8739ae039), {
            onClose: cancelHandler,
            children: [
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $78ffec079aff50d9$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $643b6d5cc9e6a567$export$2e2bcd8739ae039), {
                        children: translate((0, $447ba15143f7eed7$exports).GLOBAL_UNSUBSCRIBE_DIALOG_LABEL)
                    })
                }),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $b3739a2c2476e4e5$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("p", {
                        dangerouslySetInnerHTML: {
                            __html: translate((0, $447ba15143f7eed7$exports).GLOBAL_UNSUBSCRIBE_DIALOG_MESSAGE)
                        }
                    })
                }),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $845716ea19676e23$export$2e2bcd8739ae039), {
                    children: actions.map((a)=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $317b0dc61223a332$export$2e2bcd8739ae039), {
                            appearance: a.appearance,
                            onClick: a.onClick,
                            autoFocus: a.autoFocus,
                            testId: a.testId,
                            children: a.text
                        }, a.testId))
                })
            ]
        })
    });
};
var $68c6614e902c1d6d$export$2e2bcd8739ae039 = $68c6614e902c1d6d$var$GlobalUnsubscribeDialog;






var $7fPBF = parcelRequire("7fPBF");







const $8e2882318f59e87f$var$DoubleOptInDialog = ()=>{
    const dispatch = (0, $7ef2374eddee6a70$export$f51d452c10d5b956)();
    const { translate: translate } = (0, $a69d01c0ea406f35$export$9fc83ad70ead8663)();
    const dialogPayload = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$aa0ab7810228523b));
    const acceptHandler = (0, $7fPBF.useCallback)(async ()=>{
        (0, $0e08eda71bb24540$export$203cbc4ee16257d7)();
        // Close dialog
        dispatch((0, $3d2cac913f314860$export$71d5718099bcf953)({
            showDialog: false
        }));
    }, [
        dispatch
    ]);
    const actions = [
        {
            text: translate((0, $447ba15143f7eed7$exports).DOUBLE_OPT_IN_DIALOG_ACCEPT_BUTTON_LABEL),
            onClick: acceptHandler,
            autoFocus: true,
            appearance: 'primary',
            testId: 'double-opt-in-dialog-accept-button'
        }
    ];
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $61dd53007c997406$export$2e2bcd8739ae039), {
        children: dialogPayload.showDialog && /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $95611d2ac5b62126$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $78ffec079aff50d9$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $643b6d5cc9e6a567$export$2e2bcd8739ae039), {
                        children: translate((0, $447ba15143f7eed7$exports).DOUBLE_OPT_IN_DIALOG_LABEL)
                    })
                }),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $b3739a2c2476e4e5$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)("p", {
                        dangerouslySetInnerHTML: {
                            __html: translate((0, $447ba15143f7eed7$exports).DOUBLE_OPT_IN_DIALOG_MESSAGE)
                        }
                    })
                }),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $845716ea19676e23$export$2e2bcd8739ae039), {
                    children: actions.map((a)=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $317b0dc61223a332$export$2e2bcd8739ae039), {
                            appearance: a.appearance,
                            onClick: a.onClick,
                            autoFocus: a.autoFocus,
                            testId: a.testId,
                            children: a.text
                        }, a.testId))
                })
            ]
        })
    });
};
var $8e2882318f59e87f$export$2e2bcd8739ae039 = $8e2882318f59e87f$var$DoubleOptInDialog;






var $7fPBF = parcelRequire("7fPBF");
var $e5f7b614fbcf0ffb$exports = {};
"use strict";
Object.defineProperty($e5f7b614fbcf0ffb$exports, "__esModule", {
    value: true
});
$e5f7b614fbcf0ffb$exports.ConfigMapSchema = $e5f7b614fbcf0ffb$exports.ConfigError = $e5f7b614fbcf0ffb$exports.ConfigCollection = $e5f7b614fbcf0ffb$exports.ConfigClient = void 0;
var $e3102180980df047$exports = {};
"use strict";
Object.defineProperty($e3102180980df047$exports, "__esModule", {
    value: true
});
$e3102180980df047$exports.ConfigClient = void 0;
var $4983e8507bb0e9f6$exports = {};
"use strict";
Object.defineProperty($4983e8507bb0e9f6$exports, "__esModule", {
    value: true
});
$4983e8507bb0e9f6$exports.standardToMap = $4983e8507bb0e9f6$exports.minimalToMap = $4983e8507bb0e9f6$exports.StandardConfigSchema = $4983e8507bb0e9f6$exports.MinimalConfigSchema = $4983e8507bb0e9f6$exports.ConfigMapSchema = $4983e8507bb0e9f6$exports.AnyConfigSchema = $4983e8507bb0e9f6$exports.ConfigError = $4983e8507bb0e9f6$exports.ConfigCollection = void 0;
var $f101546a3944c6b9$exports = {};
"use strict";
Object.defineProperty($f101546a3944c6b9$exports, "__esModule", {
    value: true
});
$f101546a3944c6b9$exports.ConfigCollection = $f101546a3944c6b9$exports.ParseError = void 0;
var $0dd09485e7441d3b$exports = {};
"use strict";
Object.defineProperty($0dd09485e7441d3b$exports, "__esModule", {
    value: true
});
$0dd09485e7441d3b$exports.ConfigMapSchema = $0dd09485e7441d3b$exports.AnyConfigSchema = $0dd09485e7441d3b$exports.MinimalConfigSchema = $0dd09485e7441d3b$exports.StandardConfigSchema = $0dd09485e7441d3b$exports.ConfigError = void 0;
$0dd09485e7441d3b$exports.minimalToMap = $0dd09485e7441d3b$var$minimalToMap;
$0dd09485e7441d3b$exports.standardToMap = $0dd09485e7441d3b$var$standardToMap;
$0dd09485e7441d3b$exports.mapToMinimal = $0dd09485e7441d3b$var$mapToMinimal;
$0dd09485e7441d3b$exports.mapToStandard = $0dd09485e7441d3b$var$mapToStandard;

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
var $f40331732e852e18$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($f40331732e852e18$export$7debb50ef11d5e0b || ($f40331732e852e18$export$7debb50ef11d5e0b = {}));
var $f40331732e852e18$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return (0, $9tqwB._)({}, first, second);
    };
})($f40331732e852e18$export$4aa2142c225fd5c7 || ($f40331732e852e18$export$4aa2142c225fd5c7 = {}));
const $f40331732e852e18$export$5716da67bfaa244d = $f40331732e852e18$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $f40331732e852e18$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $f40331732e852e18$export$5716da67bfaa244d.undefined;
        case "string":
            return $f40331732e852e18$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $f40331732e852e18$export$5716da67bfaa244d.nan : $f40331732e852e18$export$5716da67bfaa244d.number;
        case "boolean":
            return $f40331732e852e18$export$5716da67bfaa244d.boolean;
        case "function":
            return $f40331732e852e18$export$5716da67bfaa244d.function;
        case "bigint":
            return $f40331732e852e18$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $f40331732e852e18$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $f40331732e852e18$export$5716da67bfaa244d.array;
            if (data === null) return $f40331732e852e18$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $f40331732e852e18$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $f40331732e852e18$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $f40331732e852e18$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $f40331732e852e18$export$5716da67bfaa244d.date;
            return $f40331732e852e18$export$5716da67bfaa244d.object;
        default:
            return $f40331732e852e18$export$5716da67bfaa244d.unknown;
    }
};
const $f40331732e852e18$export$5ba560653e4a1035 = $f40331732e852e18$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $f40331732e852e18$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $f40331732e852e18$export$f98dac4b251ab333 extends Error {
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $f40331732e852e18$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $f40331732e852e18$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
}
$f40331732e852e18$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $f40331732e852e18$export$f98dac4b251ab333(issues);
    return error;
};
const $f40331732e852e18$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $f40331732e852e18$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $f40331732e852e18$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $f40331732e852e18$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$f40331732e852e18$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$f40331732e852e18$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$f40331732e852e18$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $f40331732e852e18$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $f40331732e852e18$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $f40331732e852e18$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $f40331732e852e18$var$overrideErrorMap = $f40331732e852e18$export$341b0b6e0a6f5099;
function $f40331732e852e18$export$1097a8289cfd22d7(map) {
    $f40331732e852e18$var$overrideErrorMap = map;
}
function $f40331732e852e18$export$32f27c719778d4c4() {
    return $f40331732e852e18$var$overrideErrorMap;
}
const $f40331732e852e18$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = (0, $2qxEV._)((0, $9tqwB._)({}, issueData), {
        path: fullPath
    });
    if (issueData.message !== undefined) return (0, $2qxEV._)((0, $9tqwB._)({}, issueData), {
        path: fullPath,
        message: issueData.message
    });
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return (0, $2qxEV._)((0, $9tqwB._)({}, issueData), {
        path: fullPath,
        message: errorMessage
    });
};
const $f40331732e852e18$export$1526d2e05f74572 = [];
function $f40331732e852e18$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = $f40331732e852e18$export$32f27c719778d4c4();
    const issue = $f40331732e852e18$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === $f40331732e852e18$export$341b0b6e0a6f5099 ? undefined : $f40331732e852e18$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $f40331732e852e18$export$5b20a5c3d05c1f6f {
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $f40331732e852e18$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $f40331732e852e18$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $f40331732e852e18$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $f40331732e852e18$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
    constructor(){
        this.value = "valid";
    }
}
const $f40331732e852e18$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $f40331732e852e18$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $f40331732e852e18$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $f40331732e852e18$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $f40331732e852e18$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $f40331732e852e18$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $f40331732e852e18$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $f40331732e852e18$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $f40331732e852e18$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
var $f40331732e852e18$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($f40331732e852e18$var$errorUtil || ($f40331732e852e18$var$errorUtil = {}));
var $f40331732e852e18$var$_ZodEnum_cache, $f40331732e852e18$var$_ZodNativeEnum_cache;
class $f40331732e852e18$var$ParseInputLazyPath {
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
}
const $f40331732e852e18$var$handleResult = (ctx, result)=>{
    if ($f40331732e852e18$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $f40331732e852e18$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $f40331732e852e18$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        var _a, _b;
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message !== null && message !== void 0 ? message : ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $f40331732e852e18$export$19342e026b58ebb7 {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $f40331732e852e18$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $f40331732e852e18$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $f40331732e852e18$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $f40331732e852e18$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($f40331732e852e18$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $f40331732e852e18$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $f40331732e852e18$var$handleResult(ctx, result);
    }
    "~validate"(data) {
        var _a, _b;
        const ctx = {
            common: {
                issues: [],
                async: !!this["~standard"].async
            },
            path: [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $f40331732e852e18$export$3e9057828ebd5c7a(data)
        };
        if (!this["~standard"].async) try {
            const result = this._parseSync({
                data: data,
                path: [],
                parent: ctx
            });
            return $f40331732e852e18$export$1ea939691cdc45b8(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            };
        } catch (err) {
            if ((_b = (_a = err === null || err === void 0 ? void 0 : err.message) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes("encountered")) this["~standard"].async = true;
            ctx.common = {
                issues: [],
                async: true
            };
        }
        return this._parseAsync({
            data: data,
            path: [],
            parent: ctx
        }).then((result)=>$f40331732e852e18$export$1ea939691cdc45b8(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            });
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $f40331732e852e18$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($f40331732e852e18$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $f40331732e852e18$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue((0, $9tqwB._)({
                    code: $f40331732e852e18$export$5ba560653e4a1035.custom
                }, getIssueProperties(val)));
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $f40331732e852e18$export$a60af00cc0ce2582({
            schema: this,
            typeName: $f40331732e852e18$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $f40331732e852e18$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $f40331732e852e18$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $f40331732e852e18$export$7acfc3e64785411.create(this);
    }
    promise() {
        return $f40331732e852e18$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $f40331732e852e18$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $f40331732e852e18$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $f40331732e852e18$export$a60af00cc0ce2582((0, $2qxEV._)((0, $9tqwB._)({}, $f40331732e852e18$var$processCreateParams(this._def)), {
            schema: this,
            typeName: $f40331732e852e18$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        }));
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $f40331732e852e18$export$bb19b37874861e7e((0, $2qxEV._)((0, $9tqwB._)({}, $f40331732e852e18$var$processCreateParams(this._def)), {
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $f40331732e852e18$export$558106ce543bd011.ZodDefault
        }));
    }
    brand() {
        return new $f40331732e852e18$export$66b0c798a395271f((0, $9tqwB._)({
            typeName: $f40331732e852e18$export$558106ce543bd011.ZodBranded,
            type: this
        }, $f40331732e852e18$var$processCreateParams(this._def)));
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $f40331732e852e18$export$75a44ec6249ac76b((0, $2qxEV._)((0, $9tqwB._)({}, $f40331732e852e18$var$processCreateParams(this._def)), {
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $f40331732e852e18$export$558106ce543bd011.ZodCatch
        }));
    }
    describe(description) {
        const This = this.constructor;
        return new This((0, $2qxEV._)((0, $9tqwB._)({}, this._def), {
            description: description
        }));
    }
    pipe(target) {
        return $f40331732e852e18$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $f40331732e852e18$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
        this["~standard"] = {
            version: 1,
            vendor: "zod",
            validate: (data)=>this["~validate"](data)
        };
    }
}
const $f40331732e852e18$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $f40331732e852e18$var$cuid2Regex = /^[0-9a-z]+$/;
const $f40331732e852e18$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $f40331732e852e18$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $f40331732e852e18$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $f40331732e852e18$var$jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
const $f40331732e852e18$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $f40331732e852e18$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $f40331732e852e18$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $f40331732e852e18$var$emojiRegex;
// faster, simpler, safer
const $f40331732e852e18$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $f40331732e852e18$var$ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
// const ipv6Regex =
// /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const $f40331732e852e18$var$ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const $f40331732e852e18$var$ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $f40331732e852e18$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// https://base64.guru/standards/base64url
const $f40331732e852e18$var$base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $f40331732e852e18$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $f40331732e852e18$var$dateRegex = new RegExp(`^${$f40331732e852e18$var$dateRegexSource}$`);
function $f40331732e852e18$var$timeRegexSource(args) {
    // let regex = `\\d{2}:\\d{2}:\\d{2}`;
    let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
    if (args.precision) regex = `${regex}\\.\\d{${args.precision}}`;
    else if (args.precision == null) regex = `${regex}(\\.\\d+)?`;
    return regex;
}
function $f40331732e852e18$var$timeRegex(args) {
    return new RegExp(`^${$f40331732e852e18$var$timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function $f40331732e852e18$export$a4b563879add27a(args) {
    let regex = `${$f40331732e852e18$var$dateRegexSource}T${$f40331732e852e18$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $f40331732e852e18$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $f40331732e852e18$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $f40331732e852e18$var$ipv6Regex.test(ip)) return true;
    return false;
}
function $f40331732e852e18$var$isValidJWT(jwt, alg) {
    if (!$f40331732e852e18$var$jwtRegex.test(jwt)) return false;
    try {
        const [header] = jwt.split(".");
        // Convert base64url to base64
        const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded !== "object" || decoded === null) return false;
        if (!decoded.typ || !decoded.alg) return false;
        if (alg && decoded.alg !== alg) return false;
        return true;
    } catch (_a) {
        return false;
    }
}
function $f40331732e852e18$var$isValidCidr(ip, version) {
    if ((version === "v4" || !version) && $f40331732e852e18$var$ipv4CidrRegex.test(ip)) return true;
    if ((version === "v6" || !version) && $f40331732e852e18$var$ipv6CidrRegex.test(ip)) return true;
    return false;
}
class $f40331732e852e18$export$1230eb29b8d3b502 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $f40331732e852e18$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        const status = new $f40331732e852e18$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$f40331732e852e18$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$f40331732e852e18$var$emojiRegex) $f40331732e852e18$var$emojiRegex = new RegExp($f40331732e852e18$var$_emojiRegex, "u");
                if (!$f40331732e852e18$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$f40331732e852e18$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$f40331732e852e18$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        validation: "nanoid",
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$f40331732e852e18$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$f40331732e852e18$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$f40331732e852e18$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $f40331732e852e18$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $f40331732e852e18$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $f40331732e852e18$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$f40331732e852e18$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        validation: "duration",
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$f40331732e852e18$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "jwt") {
                if (!$f40331732e852e18$var$isValidJWT(input.data, check.alg)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        validation: "jwt",
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cidr") {
                if (!$f40331732e852e18$var$isValidCidr(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        validation: "cidr",
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$f40331732e852e18$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        validation: "base64",
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64url") {
                if (!$f40331732e852e18$var$base64urlRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        validation: "base64url",
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $f40331732e852e18$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), (0, $9tqwB._)({
            validation: validation,
            code: $f40331732e852e18$export$5ba560653e4a1035.invalid_string
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    _addCheck(check) {
        return new $f40331732e852e18$export$1230eb29b8d3b502((0, $2qxEV._)((0, $9tqwB._)({}, this._def), {
            checks: [
                ...this._def.checks,
                check
            ]
        }));
    }
    email(message) {
        return this._addCheck((0, $9tqwB._)({
            kind: "email"
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    url(message) {
        return this._addCheck((0, $9tqwB._)({
            kind: "url"
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    emoji(message) {
        return this._addCheck((0, $9tqwB._)({
            kind: "emoji"
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    uuid(message) {
        return this._addCheck((0, $9tqwB._)({
            kind: "uuid"
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    nanoid(message) {
        return this._addCheck((0, $9tqwB._)({
            kind: "nanoid"
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    cuid(message) {
        return this._addCheck((0, $9tqwB._)({
            kind: "cuid"
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    cuid2(message) {
        return this._addCheck((0, $9tqwB._)({
            kind: "cuid2"
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    ulid(message) {
        return this._addCheck((0, $9tqwB._)({
            kind: "ulid"
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    base64(message) {
        return this._addCheck((0, $9tqwB._)({
            kind: "base64"
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    base64url(message) {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return this._addCheck((0, $9tqwB._)({
            kind: "base64url"
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    jwt(options) {
        return this._addCheck((0, $9tqwB._)({
            kind: "jwt"
        }, $f40331732e852e18$var$errorUtil.errToObj(options)));
    }
    ip(options) {
        return this._addCheck((0, $9tqwB._)({
            kind: "ip"
        }, $f40331732e852e18$var$errorUtil.errToObj(options)));
    }
    cidr(options) {
        return this._addCheck((0, $9tqwB._)({
            kind: "cidr"
        }, $f40331732e852e18$var$errorUtil.errToObj(options)));
    }
    datetime(options) {
        var _a, _b;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck((0, $9tqwB._)({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false
        }, $f40331732e852e18$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck((0, $9tqwB._)({
            kind: "time",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision
        }, $f40331732e852e18$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
    }
    duration(message) {
        return this._addCheck((0, $9tqwB._)({
            kind: "duration"
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    regex(regex, message) {
        return this._addCheck((0, $9tqwB._)({
            kind: "regex",
            regex: regex
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    includes(value, options) {
        return this._addCheck((0, $9tqwB._)({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position
        }, $f40331732e852e18$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
    }
    startsWith(value, message) {
        return this._addCheck((0, $9tqwB._)({
            kind: "startsWith",
            value: value
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    endsWith(value, message) {
        return this._addCheck((0, $9tqwB._)({
            kind: "endsWith",
            value: value
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    min(minLength, message) {
        return this._addCheck((0, $9tqwB._)({
            kind: "min",
            value: minLength
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    max(maxLength, message) {
        return this._addCheck((0, $9tqwB._)({
            kind: "max",
            value: maxLength
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    length(len, message) {
        return this._addCheck((0, $9tqwB._)({
            kind: "length",
            value: len
        }, $f40331732e852e18$var$errorUtil.errToObj(message)));
    }
    /**
     * Equivalent to `.min(1)`
     */ nonempty(message) {
        return this.min(1, $f40331732e852e18$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $f40331732e852e18$export$1230eb29b8d3b502((0, $2qxEV._)((0, $9tqwB._)({}, this._def), {
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        }));
    }
    toLowerCase() {
        return new $f40331732e852e18$export$1230eb29b8d3b502((0, $2qxEV._)((0, $9tqwB._)({}, this._def), {
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        }));
    }
    toUpperCase() {
        return new $f40331732e852e18$export$1230eb29b8d3b502((0, $2qxEV._)((0, $9tqwB._)({}, this._def), {
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        }));
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isCIDR() {
        return !!this._def.checks.find((ch)=>ch.kind === "cidr");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get isBase64url() {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return !!this._def.checks.find((ch)=>ch.kind === "base64url");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$f40331732e852e18$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $f40331732e852e18$export$1230eb29b8d3b502((0, $9tqwB._)({
        checks: [],
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
    }, $f40331732e852e18$var$processCreateParams(params)));
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $f40331732e852e18$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $f40331732e852e18$export$5b070a55c0c43e09 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $f40331732e852e18$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $f40331732e852e18$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$f40331732e852e18$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($f40331732e852e18$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $f40331732e852e18$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $f40331732e852e18$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $f40331732e852e18$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $f40331732e852e18$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $f40331732e852e18$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $f40331732e852e18$export$5b070a55c0c43e09((0, $2qxEV._)((0, $9tqwB._)({}, this._def), {
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $f40331732e852e18$var$errorUtil.toString(message)
                }
            ]
        }));
    }
    _addCheck(check) {
        return new $f40331732e852e18$export$5b070a55c0c43e09((0, $2qxEV._)((0, $9tqwB._)({}, this._def), {
            checks: [
                ...this._def.checks,
                check
            ]
        }));
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $f40331732e852e18$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $f40331732e852e18$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
}
$f40331732e852e18$export$5b070a55c0c43e09.create = (params)=>{
    return new $f40331732e852e18$export$5b070a55c0c43e09((0, $9tqwB._)({
        checks: [],
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$67d741fd70ff98f4 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) try {
            input.data = BigInt(input.data);
        } catch (_a) {
            return this._getInvalidInput(input);
        }
        const parsedType = this._getType(input);
        if (parsedType !== $f40331732e852e18$export$5716da67bfaa244d.bigint) return this._getInvalidInput(input);
        let ctx = undefined;
        const status = new $f40331732e852e18$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $f40331732e852e18$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _getInvalidInput(input) {
        const ctx = this._getOrReturnCtx(input);
        $f40331732e852e18$export$db7caee60e5d514d(ctx, {
            code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
            expected: $f40331732e852e18$export$5716da67bfaa244d.bigint,
            received: ctx.parsedType
        });
        return $f40331732e852e18$export$9a105a556e65c2c0;
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $f40331732e852e18$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $f40331732e852e18$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $f40331732e852e18$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $f40331732e852e18$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $f40331732e852e18$export$67d741fd70ff98f4((0, $2qxEV._)((0, $9tqwB._)({}, this._def), {
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $f40331732e852e18$var$errorUtil.toString(message)
                }
            ]
        }));
    }
    _addCheck(check) {
        return new $f40331732e852e18$export$67d741fd70ff98f4((0, $2qxEV._)((0, $9tqwB._)({}, this._def), {
            checks: [
                ...this._def.checks,
                check
            ]
        }));
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
}
$f40331732e852e18$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $f40331732e852e18$export$67d741fd70ff98f4((0, $9tqwB._)({
        checks: [],
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$723d146f80596191 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $f40331732e852e18$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        return $f40331732e852e18$export$c6813a8d51f77eaf(input.data);
    }
}
$f40331732e852e18$export$723d146f80596191.create = (params)=>{
    return new $f40331732e852e18$export$723d146f80596191((0, $9tqwB._)({
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$e974be33bdc55521 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $f40331732e852e18$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_date
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        const status = new $f40331732e852e18$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $f40331732e852e18$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $f40331732e852e18$export$e974be33bdc55521((0, $2qxEV._)((0, $9tqwB._)({}, this._def), {
            checks: [
                ...this._def.checks,
                check
            ]
        }));
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $f40331732e852e18$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$f40331732e852e18$export$e974be33bdc55521.create = (params)=>{
    return new $f40331732e852e18$export$e974be33bdc55521((0, $9tqwB._)({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodDate
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$bcc3b40f6b638044 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $f40331732e852e18$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        return $f40331732e852e18$export$c6813a8d51f77eaf(input.data);
    }
}
$f40331732e852e18$export$bcc3b40f6b638044.create = (params)=>{
    return new $f40331732e852e18$export$bcc3b40f6b638044((0, $9tqwB._)({
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodSymbol
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$4e780e961c30340d extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $f40331732e852e18$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        return $f40331732e852e18$export$c6813a8d51f77eaf(input.data);
    }
}
$f40331732e852e18$export$4e780e961c30340d.create = (params)=>{
    return new $f40331732e852e18$export$4e780e961c30340d((0, $9tqwB._)({
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodUndefined
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$a96281f914484f2d extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $f40331732e852e18$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        return $f40331732e852e18$export$c6813a8d51f77eaf(input.data);
    }
}
$f40331732e852e18$export$a96281f914484f2d.create = (params)=>{
    return new $f40331732e852e18$export$a96281f914484f2d((0, $9tqwB._)({
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodNull
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$b9d1edb536b4e4eb extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        return $f40331732e852e18$export$c6813a8d51f77eaf(input.data);
    }
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
}
$f40331732e852e18$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $f40331732e852e18$export$b9d1edb536b4e4eb((0, $9tqwB._)({
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodAny
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$ef3b1bb1630977ae extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        return $f40331732e852e18$export$c6813a8d51f77eaf(input.data);
    }
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
}
$f40331732e852e18$export$ef3b1bb1630977ae.create = (params)=>{
    return new $f40331732e852e18$export$ef3b1bb1630977ae((0, $9tqwB._)({
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodUnknown
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$1e576a20c3ce9fb5 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $f40331732e852e18$export$db7caee60e5d514d(ctx, {
            code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
            expected: $f40331732e852e18$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $f40331732e852e18$export$9a105a556e65c2c0;
    }
}
$f40331732e852e18$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $f40331732e852e18$export$1e576a20c3ce9fb5((0, $9tqwB._)({
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodNever
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$7d39f5df85f21031 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $f40331732e852e18$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        return $f40331732e852e18$export$c6813a8d51f77eaf(input.data);
    }
}
$f40331732e852e18$export$7d39f5df85f21031.create = (params)=>{
    return new $f40331732e852e18$export$7d39f5df85f21031((0, $9tqwB._)({
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodVoid
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$7acfc3e64785411 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $f40331732e852e18$export$5716da67bfaa244d.array) {
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $f40331732e852e18$export$5ba560653e4a1035.too_big : $f40331732e852e18$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                    code: $f40331732e852e18$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                    code: $f40331732e852e18$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $f40331732e852e18$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $f40331732e852e18$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $f40331732e852e18$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $f40331732e852e18$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $f40331732e852e18$export$7acfc3e64785411((0, $2qxEV._)((0, $9tqwB._)({}, this._def), {
            minLength: {
                value: minLength,
                message: $f40331732e852e18$var$errorUtil.toString(message)
            }
        }));
    }
    max(maxLength, message) {
        return new $f40331732e852e18$export$7acfc3e64785411((0, $2qxEV._)((0, $9tqwB._)({}, this._def), {
            maxLength: {
                value: maxLength,
                message: $f40331732e852e18$var$errorUtil.toString(message)
            }
        }));
    }
    length(len, message) {
        return new $f40331732e852e18$export$7acfc3e64785411((0, $2qxEV._)((0, $9tqwB._)({}, this._def), {
            exactLength: {
                value: len,
                message: $f40331732e852e18$var$errorUtil.toString(message)
            }
        }));
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$f40331732e852e18$export$7acfc3e64785411.create = (schema, params)=>{
    return new $f40331732e852e18$export$7acfc3e64785411((0, $9tqwB._)({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodArray
    }, $f40331732e852e18$var$processCreateParams(params)));
};
function $f40331732e852e18$var$deepPartialify(schema) {
    if (schema instanceof $f40331732e852e18$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $f40331732e852e18$export$aa56fec1e9d629b8.create($f40331732e852e18$var$deepPartialify(fieldSchema));
        }
        return new $f40331732e852e18$export$736315c5b55efbad((0, $2qxEV._)((0, $9tqwB._)({}, schema._def), {
            shape: ()=>newShape
        }));
    } else if (schema instanceof $f40331732e852e18$export$7acfc3e64785411) return new $f40331732e852e18$export$7acfc3e64785411((0, $2qxEV._)((0, $9tqwB._)({}, schema._def), {
        type: $f40331732e852e18$var$deepPartialify(schema.element)
    }));
    else if (schema instanceof $f40331732e852e18$export$aa56fec1e9d629b8) return $f40331732e852e18$export$aa56fec1e9d629b8.create($f40331732e852e18$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $f40331732e852e18$export$aaac0b8b429cef5) return $f40331732e852e18$export$aaac0b8b429cef5.create($f40331732e852e18$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $f40331732e852e18$export$e2a18bb771d8e6a3) return $f40331732e852e18$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$f40331732e852e18$var$deepPartialify(item)));
    else return schema;
}
class $f40331732e852e18$export$736315c5b55efbad extends $f40331732e852e18$export$19342e026b58ebb7 {
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $f40331732e852e18$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $f40331732e852e18$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $f40331732e852e18$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $f40331732e852e18$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $f40331732e852e18$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                        code: $f40331732e852e18$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $f40331732e852e18$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $f40331732e852e18$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $f40331732e852e18$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $f40331732e852e18$var$errorUtil.errToObj;
        return new $f40331732e852e18$export$736315c5b55efbad((0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({}, this._def), {
            unknownKeys: "strict"
        }), message !== undefined ? {
            errorMap: (issue, ctx)=>{
                var _a, _b, _c, _d;
                const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                if (issue.code === "unrecognized_keys") return {
                    message: (_d = $f40331732e852e18$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                };
                return {
                    message: defaultError
                };
            }
        } : {}));
    }
    strip() {
        return new $f40331732e852e18$export$736315c5b55efbad((0, $2qxEV._)((0, $9tqwB._)({}, this._def), {
            unknownKeys: "strip"
        }));
    }
    passthrough() {
        return new $f40331732e852e18$export$736315c5b55efbad((0, $2qxEV._)((0, $9tqwB._)({}, this._def), {
            unknownKeys: "passthrough"
        }));
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $f40331732e852e18$export$736315c5b55efbad((0, $2qxEV._)((0, $9tqwB._)({}, this._def), {
            shape: ()=>(0, $9tqwB._)({}, this._def.shape(), augmentation)
        }));
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $f40331732e852e18$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>(0, $9tqwB._)({}, this._def.shape(), merging._def.shape()),
            typeName: $f40331732e852e18$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $f40331732e852e18$export$736315c5b55efbad((0, $2qxEV._)((0, $9tqwB._)({}, this._def), {
            catchall: index
        }));
    }
    pick(mask) {
        const shape = {};
        $f40331732e852e18$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $f40331732e852e18$export$736315c5b55efbad((0, $2qxEV._)((0, $9tqwB._)({}, this._def), {
            shape: ()=>shape
        }));
    }
    omit(mask) {
        const shape = {};
        $f40331732e852e18$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $f40331732e852e18$export$736315c5b55efbad((0, $2qxEV._)((0, $9tqwB._)({}, this._def), {
            shape: ()=>shape
        }));
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $f40331732e852e18$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $f40331732e852e18$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $f40331732e852e18$export$736315c5b55efbad((0, $2qxEV._)((0, $9tqwB._)({}, this._def), {
            shape: ()=>newShape
        }));
    }
    required(mask) {
        const newShape = {};
        $f40331732e852e18$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $f40331732e852e18$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $f40331732e852e18$export$736315c5b55efbad((0, $2qxEV._)((0, $9tqwB._)({}, this._def), {
            shape: ()=>newShape
        }));
    }
    keyof() {
        return $f40331732e852e18$var$createZodEnum($f40331732e852e18$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
}
$f40331732e852e18$export$736315c5b55efbad.create = (shape, params)=>{
    return new $f40331732e852e18$export$736315c5b55efbad((0, $9tqwB._)({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $f40331732e852e18$export$1e576a20c3ce9fb5.create(),
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodObject
    }, $f40331732e852e18$var$processCreateParams(params)));
};
$f40331732e852e18$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $f40331732e852e18$export$736315c5b55efbad((0, $9tqwB._)({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $f40331732e852e18$export$1e576a20c3ce9fb5.create(),
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodObject
    }, $f40331732e852e18$var$processCreateParams(params)));
};
$f40331732e852e18$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $f40331732e852e18$export$736315c5b55efbad((0, $9tqwB._)({
        shape: shape,
        unknownKeys: "strip",
        catchall: $f40331732e852e18$export$1e576a20c3ce9fb5.create(),
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodObject
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$a8b236cb5070a311 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $f40331732e852e18$export$f98dac4b251ab333(result.ctx.common.issues));
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = (0, $2qxEV._)((0, $9tqwB._)({}, ctx), {
                common: (0, $2qxEV._)((0, $9tqwB._)({}, ctx.common), {
                    issues: []
                }),
                parent: null
            });
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = (0, $2qxEV._)((0, $9tqwB._)({}, ctx), {
                    common: (0, $2qxEV._)((0, $9tqwB._)({}, ctx.common), {
                        issues: []
                    }),
                    parent: null
                });
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $f40331732e852e18$export$f98dac4b251ab333(issues));
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$f40331732e852e18$export$a8b236cb5070a311.create = (types, params)=>{
    return new $f40331732e852e18$export$a8b236cb5070a311((0, $9tqwB._)({
        options: types,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodUnion
    }, $f40331732e852e18$var$processCreateParams(params)));
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $f40331732e852e18$var$getDiscriminator = (type)=>{
    if (type instanceof $f40331732e852e18$export$378d0cfce37406e6) return $f40331732e852e18$var$getDiscriminator(type.schema);
    else if (type instanceof $f40331732e852e18$export$a60af00cc0ce2582) return $f40331732e852e18$var$getDiscriminator(type.innerType());
    else if (type instanceof $f40331732e852e18$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $f40331732e852e18$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $f40331732e852e18$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return $f40331732e852e18$export$7debb50ef11d5e0b.objectValues(type.enum);
    else if (type instanceof $f40331732e852e18$export$bb19b37874861e7e) return $f40331732e852e18$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $f40331732e852e18$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $f40331732e852e18$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $f40331732e852e18$export$aa56fec1e9d629b8) return [
        undefined,
        ...$f40331732e852e18$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $f40331732e852e18$export$aaac0b8b429cef5) return [
        null,
        ...$f40331732e852e18$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $f40331732e852e18$export$66b0c798a395271f) return $f40331732e852e18$var$getDiscriminator(type.unwrap());
    else if (type instanceof $f40331732e852e18$export$5d1f7ef05c4e493a) return $f40331732e852e18$var$getDiscriminator(type.unwrap());
    else if (type instanceof $f40331732e852e18$export$75a44ec6249ac76b) return $f40331732e852e18$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $f40331732e852e18$export$5ef2424805ac76a3 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $f40331732e852e18$export$5716da67bfaa244d.object) {
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $f40331732e852e18$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $f40331732e852e18$export$5ef2424805ac76a3((0, $9tqwB._)({
            typeName: $f40331732e852e18$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap
        }, $f40331732e852e18$var$processCreateParams(params)));
    }
}
function $f40331732e852e18$var$mergeValues(a, b) {
    const aType = $f40331732e852e18$export$3e9057828ebd5c7a(a);
    const bType = $f40331732e852e18$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $f40331732e852e18$export$5716da67bfaa244d.object && bType === $f40331732e852e18$export$5716da67bfaa244d.object) {
        const bKeys = $f40331732e852e18$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $f40331732e852e18$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = (0, $9tqwB._)({}, a, b);
        for (const key of sharedKeys){
            const sharedValue = $f40331732e852e18$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $f40331732e852e18$export$5716da67bfaa244d.array && bType === $f40331732e852e18$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $f40331732e852e18$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $f40331732e852e18$export$5716da67bfaa244d.date && bType === $f40331732e852e18$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $f40331732e852e18$export$c02deaf0bb5203d4 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($f40331732e852e18$export$afa861e3c5730743(parsedLeft) || $f40331732e852e18$export$afa861e3c5730743(parsedRight)) return $f40331732e852e18$export$9a105a556e65c2c0;
            const merged = $f40331732e852e18$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                    code: $f40331732e852e18$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $f40331732e852e18$export$9a105a556e65c2c0;
            }
            if ($f40331732e852e18$export$910b6cdd390341b3(parsedLeft) || $f40331732e852e18$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$f40331732e852e18$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $f40331732e852e18$export$c02deaf0bb5203d4((0, $9tqwB._)({
        left: left,
        right: right,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodIntersection
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$e2a18bb771d8e6a3 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $f40331732e852e18$export$5716da67bfaa244d.array) {
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $f40331732e852e18$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $f40331732e852e18$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $f40331732e852e18$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $f40331732e852e18$export$e2a18bb771d8e6a3((0, $2qxEV._)((0, $9tqwB._)({}, this._def), {
            rest: rest
        }));
    }
}
$f40331732e852e18$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $f40331732e852e18$export$e2a18bb771d8e6a3((0, $9tqwB._)({
        items: schemas,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodTuple,
        rest: null
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$a2acc09968cb4b7f extends $f40331732e852e18$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $f40331732e852e18$export$5716da67bfaa244d.object) {
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $f40331732e852e18$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $f40331732e852e18$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return $f40331732e852e18$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $f40331732e852e18$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $f40331732e852e18$export$19342e026b58ebb7) return new $f40331732e852e18$export$a2acc09968cb4b7f((0, $9tqwB._)({
            keyType: first,
            valueType: second,
            typeName: $f40331732e852e18$export$558106ce543bd011.ZodRecord
        }, $f40331732e852e18$var$processCreateParams(third)));
        return new $f40331732e852e18$export$a2acc09968cb4b7f((0, $9tqwB._)({
            keyType: $f40331732e852e18$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $f40331732e852e18$export$558106ce543bd011.ZodRecord
        }, $f40331732e852e18$var$processCreateParams(second)));
    }
}
class $f40331732e852e18$export$163b6a2b712d9542 extends $f40331732e852e18$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $f40331732e852e18$export$5716da67bfaa244d.map) {
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $f40331732e852e18$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $f40331732e852e18$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $f40331732e852e18$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $f40331732e852e18$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$f40331732e852e18$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $f40331732e852e18$export$163b6a2b712d9542((0, $9tqwB._)({
        valueType: valueType,
        keyType: keyType,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodMap
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$977057706f816712 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $f40331732e852e18$export$5716da67bfaa244d.set) {
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                    code: $f40331732e852e18$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                    code: $f40331732e852e18$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $f40331732e852e18$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $f40331732e852e18$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $f40331732e852e18$export$977057706f816712((0, $2qxEV._)((0, $9tqwB._)({}, this._def), {
            minSize: {
                value: minSize,
                message: $f40331732e852e18$var$errorUtil.toString(message)
            }
        }));
    }
    max(maxSize, message) {
        return new $f40331732e852e18$export$977057706f816712((0, $2qxEV._)((0, $9tqwB._)({}, this._def), {
            maxSize: {
                value: maxSize,
                message: $f40331732e852e18$var$errorUtil.toString(message)
            }
        }));
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$f40331732e852e18$export$977057706f816712.create = (valueType, params)=>{
    return new $f40331732e852e18$export$977057706f816712((0, $9tqwB._)({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodSet
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$d4602ba55673f53c extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $f40331732e852e18$export$5716da67bfaa244d.function) {
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $f40331732e852e18$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $f40331732e852e18$export$32f27c719778d4c4(),
                    $f40331732e852e18$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $f40331732e852e18$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $f40331732e852e18$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $f40331732e852e18$export$32f27c719778d4c4(),
                    $f40331732e852e18$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $f40331732e852e18$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $f40331732e852e18$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $f40331732e852e18$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $f40331732e852e18$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $f40331732e852e18$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $f40331732e852e18$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $f40331732e852e18$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $f40331732e852e18$export$d4602ba55673f53c((0, $2qxEV._)((0, $9tqwB._)({}, this._def), {
            args: $f40331732e852e18$export$e2a18bb771d8e6a3.create(items).rest($f40331732e852e18$export$ef3b1bb1630977ae.create())
        }));
    }
    returns(returnType) {
        return new $f40331732e852e18$export$d4602ba55673f53c((0, $2qxEV._)((0, $9tqwB._)({}, this._def), {
            returns: returnType
        }));
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $f40331732e852e18$export$d4602ba55673f53c((0, $9tqwB._)({
            args: args ? args : $f40331732e852e18$export$e2a18bb771d8e6a3.create([]).rest($f40331732e852e18$export$ef3b1bb1630977ae.create()),
            returns: returns || $f40331732e852e18$export$ef3b1bb1630977ae.create(),
            typeName: $f40331732e852e18$export$558106ce543bd011.ZodFunction
        }, $f40331732e852e18$var$processCreateParams(params)));
    }
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
}
class $f40331732e852e18$export$378d0cfce37406e6 extends $f40331732e852e18$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$f40331732e852e18$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $f40331732e852e18$export$378d0cfce37406e6((0, $9tqwB._)({
        getter: getter,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodLazy
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$7e44096782a165d3 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$f40331732e852e18$export$7e44096782a165d3.create = (value, params)=>{
    return new $f40331732e852e18$export$7e44096782a165d3((0, $9tqwB._)({
        value: value,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodLiteral
    }, $f40331732e852e18$var$processCreateParams(params)));
};
function $f40331732e852e18$var$createZodEnum(values, params) {
    return new $f40331732e852e18$export$d325d1f0e1c20179((0, $9tqwB._)({
        values: values,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodEnum
    }, $f40331732e852e18$var$processCreateParams(params)));
}
class $f40331732e852e18$export$d325d1f0e1c20179 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                expected: $f40331732e852e18$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        if (!$f40331732e852e18$var$__classPrivateFieldGet(this, $f40331732e852e18$var$_ZodEnum_cache, "f")) $f40331732e852e18$var$__classPrivateFieldSet(this, $f40331732e852e18$var$_ZodEnum_cache, new Set(this._def.values), "f");
        if (!$f40331732e852e18$var$__classPrivateFieldGet(this, $f40331732e852e18$var$_ZodEnum_cache, "f").has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        return $f40331732e852e18$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $f40331732e852e18$export$d325d1f0e1c20179.create(values, (0, $9tqwB._)({}, this._def, newDef));
    }
    exclude(values, newDef = this._def) {
        return $f40331732e852e18$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), (0, $9tqwB._)({}, this._def, newDef));
    }
    constructor(){
        super(...arguments);
        $f40331732e852e18$var$_ZodEnum_cache.set(this, void 0);
    }
}
$f40331732e852e18$var$_ZodEnum_cache = new WeakMap();
$f40331732e852e18$export$d325d1f0e1c20179.create = $f40331732e852e18$var$createZodEnum;
class $f40331732e852e18$export$370b2e8d6d6f5c56 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const nativeEnumValues = $f40331732e852e18$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $f40331732e852e18$export$5716da67bfaa244d.string && ctx.parsedType !== $f40331732e852e18$export$5716da67bfaa244d.number) {
            const expectedValues = $f40331732e852e18$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                expected: $f40331732e852e18$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        if (!$f40331732e852e18$var$__classPrivateFieldGet(this, $f40331732e852e18$var$_ZodNativeEnum_cache, "f")) $f40331732e852e18$var$__classPrivateFieldSet(this, $f40331732e852e18$var$_ZodNativeEnum_cache, new Set($f40331732e852e18$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values)), "f");
        if (!$f40331732e852e18$var$__classPrivateFieldGet(this, $f40331732e852e18$var$_ZodNativeEnum_cache, "f").has(input.data)) {
            const expectedValues = $f40331732e852e18$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        return $f40331732e852e18$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
    constructor(){
        super(...arguments);
        $f40331732e852e18$var$_ZodNativeEnum_cache.set(this, void 0);
    }
}
$f40331732e852e18$var$_ZodNativeEnum_cache = new WeakMap();
$f40331732e852e18$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $f40331732e852e18$export$370b2e8d6d6f5c56((0, $9tqwB._)({
        values: values,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodNativeEnum
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$3f196b0127d6e50a extends $f40331732e852e18$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $f40331732e852e18$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $f40331732e852e18$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $f40331732e852e18$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$f40331732e852e18$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $f40331732e852e18$export$3f196b0127d6e50a((0, $9tqwB._)({
        type: schema,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodPromise
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$a60af00cc0ce2582 extends $f40331732e852e18$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $f40331732e852e18$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $f40331732e852e18$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return $f40331732e852e18$export$9a105a556e65c2c0;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $f40331732e852e18$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $f40331732e852e18$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $f40331732e852e18$export$325a211da9693fcf(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return $f40331732e852e18$export$9a105a556e65c2c0;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $f40331732e852e18$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $f40331732e852e18$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $f40331732e852e18$export$325a211da9693fcf(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $f40331732e852e18$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $f40331732e852e18$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$f40331732e852e18$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$f40331732e852e18$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $f40331732e852e18$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$f40331732e852e18$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $f40331732e852e18$export$a60af00cc0ce2582((0, $9tqwB._)({
        schema: schema,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodEffects,
        effect: effect
    }, $f40331732e852e18$var$processCreateParams(params)));
};
$f40331732e852e18$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $f40331732e852e18$export$a60af00cc0ce2582((0, $9tqwB._)({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodEffects
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$aa56fec1e9d629b8 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $f40331732e852e18$export$5716da67bfaa244d.undefined) return $f40331732e852e18$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$f40331732e852e18$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $f40331732e852e18$export$aa56fec1e9d629b8((0, $9tqwB._)({
        innerType: type,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodOptional
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$aaac0b8b429cef5 extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $f40331732e852e18$export$5716da67bfaa244d.null) return $f40331732e852e18$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$f40331732e852e18$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $f40331732e852e18$export$aaac0b8b429cef5((0, $9tqwB._)({
        innerType: type,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodNullable
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$bb19b37874861e7e extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $f40331732e852e18$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$f40331732e852e18$export$bb19b37874861e7e.create = (type, params)=>{
    return new $f40331732e852e18$export$bb19b37874861e7e((0, $9tqwB._)({
        innerType: type,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$75a44ec6249ac76b extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = (0, $2qxEV._)((0, $9tqwB._)({}, ctx), {
            common: (0, $2qxEV._)((0, $9tqwB._)({}, ctx.common), {
                issues: []
            })
        });
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: (0, $9tqwB._)({}, newCtx)
        });
        if ($f40331732e852e18$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $f40331732e852e18$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $f40331732e852e18$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$f40331732e852e18$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $f40331732e852e18$export$75a44ec6249ac76b((0, $9tqwB._)({
        innerType: type,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch
    }, $f40331732e852e18$var$processCreateParams(params)));
};
class $f40331732e852e18$export$26ccfa0145e8511f extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $f40331732e852e18$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $f40331732e852e18$export$db7caee60e5d514d(ctx, {
                code: $f40331732e852e18$export$5ba560653e4a1035.invalid_type,
                expected: $f40331732e852e18$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $f40331732e852e18$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$f40331732e852e18$export$26ccfa0145e8511f.create = (params)=>{
    return new $f40331732e852e18$export$26ccfa0145e8511f((0, $9tqwB._)({
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodNaN
    }, $f40331732e852e18$var$processCreateParams(params)));
};
const $f40331732e852e18$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $f40331732e852e18$export$66b0c798a395271f extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $f40331732e852e18$export$a3c3ef8a0e95c6da extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $f40331732e852e18$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $f40331732e852e18$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $f40331732e852e18$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $f40331732e852e18$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $f40331732e852e18$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $f40331732e852e18$export$5d1f7ef05c4e493a extends $f40331732e852e18$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ($f40331732e852e18$export$1ea939691cdc45b8(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return $f40331732e852e18$export$aefee5ebe1dcfd9e(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$f40331732e852e18$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $f40331732e852e18$export$5d1f7ef05c4e493a((0, $9tqwB._)({
        innerType: type,
        typeName: $f40331732e852e18$export$558106ce543bd011.ZodReadonly
    }, $f40331732e852e18$var$processCreateParams(params)));
};
////////////////////////////////////////
////////////////////////////////////////
//////////                    //////////
//////////      z.custom      //////////
//////////                    //////////
////////////////////////////////////////
////////////////////////////////////////
function $f40331732e852e18$var$cleanParams(params, data) {
    const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
        message: params
    } : params;
    const p2 = typeof p === "string" ? {
        message: p
    } : p;
    return p2;
}
function $f40331732e852e18$export$4c00f665f0d4b443(check, _params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $f40331732e852e18$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        const r = check(data);
        if (r instanceof Promise) return r.then((r)=>{
            var _a, _b;
            if (!r) {
                const params = $f40331732e852e18$var$cleanParams(_params, data);
                const _fatal = (_b = (_a = params.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
                ctx.addIssue((0, $2qxEV._)((0, $9tqwB._)({
                    code: "custom"
                }, params), {
                    fatal: _fatal
                }));
            }
        });
        if (!r) {
            const params = $f40331732e852e18$var$cleanParams(_params, data);
            const _fatal = (_b = (_a = params.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            ctx.addIssue((0, $2qxEV._)((0, $9tqwB._)({
                code: "custom"
            }, params), {
                fatal: _fatal
            }));
        }
        return;
    });
    return $f40331732e852e18$export$b9d1edb536b4e4eb.create();
}
const $f40331732e852e18$export$1ee8ee30835eab8b = {
    object: $f40331732e852e18$export$736315c5b55efbad.lazycreate
};
var $f40331732e852e18$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($f40331732e852e18$export$558106ce543bd011 || ($f40331732e852e18$export$558106ce543bd011 = {}));
const $f40331732e852e18$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$f40331732e852e18$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $f40331732e852e18$export$22b082955e083ec3 = $f40331732e852e18$export$1230eb29b8d3b502.create;
const $f40331732e852e18$export$98e628dec113755e = $f40331732e852e18$export$5b070a55c0c43e09.create;
const $f40331732e852e18$export$9e06de0973666692 = $f40331732e852e18$export$26ccfa0145e8511f.create;
const $f40331732e852e18$export$a0f65b52274bcc00 = $f40331732e852e18$export$67d741fd70ff98f4.create;
const $f40331732e852e18$export$4a21f16c33752377 = $f40331732e852e18$export$723d146f80596191.create;
const $f40331732e852e18$export$324d90190a8b822a = $f40331732e852e18$export$e974be33bdc55521.create;
const $f40331732e852e18$export$8f701197936bc2a6 = $f40331732e852e18$export$bcc3b40f6b638044.create;
const $f40331732e852e18$export$1db45310990710a5 = $f40331732e852e18$export$4e780e961c30340d.create;
const $f40331732e852e18$export$7b1b591b262c240 = $f40331732e852e18$export$a96281f914484f2d.create;
const $f40331732e852e18$export$4154a199d7d90455 = $f40331732e852e18$export$b9d1edb536b4e4eb.create;
const $f40331732e852e18$export$19282c40b967aec6 = $f40331732e852e18$export$ef3b1bb1630977ae.create;
const $f40331732e852e18$export$b3e22bcfd64c1022 = $f40331732e852e18$export$1e576a20c3ce9fb5.create;
const $f40331732e852e18$export$490e536ee7389aeb = $f40331732e852e18$export$7d39f5df85f21031.create;
const $f40331732e852e18$export$2f23118c22fb2630 = $f40331732e852e18$export$7acfc3e64785411.create;
const $f40331732e852e18$export$be5493f9613cbbe = $f40331732e852e18$export$736315c5b55efbad.create;
const $f40331732e852e18$export$8fb0df5f40d0b477 = $f40331732e852e18$export$736315c5b55efbad.strictCreate;
const $f40331732e852e18$export$971dd5b0dfd021b6 = $f40331732e852e18$export$a8b236cb5070a311.create;
const $f40331732e852e18$export$4b888e40c4ee26dd = $f40331732e852e18$export$5ef2424805ac76a3.create;
const $f40331732e852e18$export$bc86dfbf7795668c = $f40331732e852e18$export$c02deaf0bb5203d4.create;
const $f40331732e852e18$export$65e3907585753458 = $f40331732e852e18$export$e2a18bb771d8e6a3.create;
const $f40331732e852e18$export$e5185e241753e543 = $f40331732e852e18$export$a2acc09968cb4b7f.create;
const $f40331732e852e18$export$871de8747c9eaa88 = $f40331732e852e18$export$163b6a2b712d9542.create;
const $f40331732e852e18$export$adaa4cf7ef1b65be = $f40331732e852e18$export$977057706f816712.create;
const $f40331732e852e18$export$44e51c8aac7c2deb = $f40331732e852e18$export$d4602ba55673f53c.create;
const $f40331732e852e18$export$488013bae63b21da = $f40331732e852e18$export$378d0cfce37406e6.create;
const $f40331732e852e18$export$c8ec6e1ec9fefcb0 = $f40331732e852e18$export$7e44096782a165d3.create;
const $f40331732e852e18$export$78a99c8d44d72635 = $f40331732e852e18$export$d325d1f0e1c20179.create;
const $f40331732e852e18$export$6fe7eca19ebe5199 = $f40331732e852e18$export$370b2e8d6d6f5c56.create;
const $f40331732e852e18$export$c957ef27a0ebfd4 = $f40331732e852e18$export$3f196b0127d6e50a.create;
const $f40331732e852e18$export$dc573d8a6576cdb3 = $f40331732e852e18$export$a60af00cc0ce2582.create;
const $f40331732e852e18$export$516e28dec6a4b6d4 = $f40331732e852e18$export$aa56fec1e9d629b8.create;
const $f40331732e852e18$export$133fc36489ac9add = $f40331732e852e18$export$aaac0b8b429cef5.create;
const $f40331732e852e18$export$fc37fe19dfda43ee = $f40331732e852e18$export$a60af00cc0ce2582.createWithPreprocess;
const $f40331732e852e18$export$43f28b24e1eb8181 = $f40331732e852e18$export$a3c3ef8a0e95c6da.create;
const $f40331732e852e18$export$3b3d07727c5b702c = ()=>$f40331732e852e18$export$22b082955e083ec3().optional();
const $f40331732e852e18$export$eb150471a61fced6 = ()=>$f40331732e852e18$export$98e628dec113755e().optional();
const $f40331732e852e18$export$269251733cdcbbf1 = ()=>$f40331732e852e18$export$4a21f16c33752377().optional();
const $f40331732e852e18$export$8c14e57e778d3873 = {
    string: (arg)=>$f40331732e852e18$export$1230eb29b8d3b502.create((0, $2qxEV._)((0, $9tqwB._)({}, arg), {
            coerce: true
        })),
    number: (arg)=>$f40331732e852e18$export$5b070a55c0c43e09.create((0, $2qxEV._)((0, $9tqwB._)({}, arg), {
            coerce: true
        })),
    boolean: (arg)=>$f40331732e852e18$export$723d146f80596191.create((0, $2qxEV._)((0, $9tqwB._)({}, arg), {
            coerce: true
        })),
    bigint: (arg)=>$f40331732e852e18$export$67d741fd70ff98f4.create((0, $2qxEV._)((0, $9tqwB._)({}, arg), {
            coerce: true
        })),
    date: (arg)=>$f40331732e852e18$export$e974be33bdc55521.create((0, $2qxEV._)((0, $9tqwB._)({}, arg), {
            coerce: true
        }))
};
const $f40331732e852e18$export$96c94437c95d7862 = $f40331732e852e18$export$9a105a556e65c2c0;
var $f40331732e852e18$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $f40331732e852e18$export$341b0b6e0a6f5099,
    setErrorMap: $f40331732e852e18$export$1097a8289cfd22d7,
    getErrorMap: $f40331732e852e18$export$32f27c719778d4c4,
    makeIssue: $f40331732e852e18$export$244a85fde9c419ed,
    EMPTY_PATH: $f40331732e852e18$export$1526d2e05f74572,
    addIssueToContext: $f40331732e852e18$export$db7caee60e5d514d,
    ParseStatus: $f40331732e852e18$export$5b20a5c3d05c1f6f,
    INVALID: $f40331732e852e18$export$9a105a556e65c2c0,
    DIRTY: $f40331732e852e18$export$325a211da9693fcf,
    OK: $f40331732e852e18$export$c6813a8d51f77eaf,
    isAborted: $f40331732e852e18$export$afa861e3c5730743,
    isDirty: $f40331732e852e18$export$910b6cdd390341b3,
    isValid: $f40331732e852e18$export$1ea939691cdc45b8,
    isAsync: $f40331732e852e18$export$aefee5ebe1dcfd9e,
    get util () {
        return $f40331732e852e18$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $f40331732e852e18$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $f40331732e852e18$export$5716da67bfaa244d,
    getParsedType: $f40331732e852e18$export$3e9057828ebd5c7a,
    ZodType: $f40331732e852e18$export$19342e026b58ebb7,
    datetimeRegex: $f40331732e852e18$export$a4b563879add27a,
    ZodString: $f40331732e852e18$export$1230eb29b8d3b502,
    ZodNumber: $f40331732e852e18$export$5b070a55c0c43e09,
    ZodBigInt: $f40331732e852e18$export$67d741fd70ff98f4,
    ZodBoolean: $f40331732e852e18$export$723d146f80596191,
    ZodDate: $f40331732e852e18$export$e974be33bdc55521,
    ZodSymbol: $f40331732e852e18$export$bcc3b40f6b638044,
    ZodUndefined: $f40331732e852e18$export$4e780e961c30340d,
    ZodNull: $f40331732e852e18$export$a96281f914484f2d,
    ZodAny: $f40331732e852e18$export$b9d1edb536b4e4eb,
    ZodUnknown: $f40331732e852e18$export$ef3b1bb1630977ae,
    ZodNever: $f40331732e852e18$export$1e576a20c3ce9fb5,
    ZodVoid: $f40331732e852e18$export$7d39f5df85f21031,
    ZodArray: $f40331732e852e18$export$7acfc3e64785411,
    ZodObject: $f40331732e852e18$export$736315c5b55efbad,
    ZodUnion: $f40331732e852e18$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $f40331732e852e18$export$5ef2424805ac76a3,
    ZodIntersection: $f40331732e852e18$export$c02deaf0bb5203d4,
    ZodTuple: $f40331732e852e18$export$e2a18bb771d8e6a3,
    ZodRecord: $f40331732e852e18$export$a2acc09968cb4b7f,
    ZodMap: $f40331732e852e18$export$163b6a2b712d9542,
    ZodSet: $f40331732e852e18$export$977057706f816712,
    ZodFunction: $f40331732e852e18$export$d4602ba55673f53c,
    ZodLazy: $f40331732e852e18$export$378d0cfce37406e6,
    ZodLiteral: $f40331732e852e18$export$7e44096782a165d3,
    ZodEnum: $f40331732e852e18$export$d325d1f0e1c20179,
    ZodNativeEnum: $f40331732e852e18$export$370b2e8d6d6f5c56,
    ZodPromise: $f40331732e852e18$export$3f196b0127d6e50a,
    ZodEffects: $f40331732e852e18$export$a60af00cc0ce2582,
    ZodTransformer: $f40331732e852e18$export$a60af00cc0ce2582,
    ZodOptional: $f40331732e852e18$export$aa56fec1e9d629b8,
    ZodNullable: $f40331732e852e18$export$aaac0b8b429cef5,
    ZodDefault: $f40331732e852e18$export$bb19b37874861e7e,
    ZodCatch: $f40331732e852e18$export$75a44ec6249ac76b,
    ZodNaN: $f40331732e852e18$export$26ccfa0145e8511f,
    BRAND: $f40331732e852e18$export$cf2deea74cde46b4,
    ZodBranded: $f40331732e852e18$export$66b0c798a395271f,
    ZodPipeline: $f40331732e852e18$export$a3c3ef8a0e95c6da,
    ZodReadonly: $f40331732e852e18$export$5d1f7ef05c4e493a,
    custom: $f40331732e852e18$export$4c00f665f0d4b443,
    Schema: $f40331732e852e18$export$19342e026b58ebb7,
    ZodSchema: $f40331732e852e18$export$19342e026b58ebb7,
    late: $f40331732e852e18$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $f40331732e852e18$export$558106ce543bd011;
    },
    coerce: $f40331732e852e18$export$8c14e57e778d3873,
    any: $f40331732e852e18$export$4154a199d7d90455,
    array: $f40331732e852e18$export$2f23118c22fb2630,
    bigint: $f40331732e852e18$export$a0f65b52274bcc00,
    boolean: $f40331732e852e18$export$4a21f16c33752377,
    date: $f40331732e852e18$export$324d90190a8b822a,
    discriminatedUnion: $f40331732e852e18$export$4b888e40c4ee26dd,
    effect: $f40331732e852e18$export$dc573d8a6576cdb3,
    'enum': $f40331732e852e18$export$78a99c8d44d72635,
    'function': $f40331732e852e18$export$44e51c8aac7c2deb,
    'instanceof': $f40331732e852e18$export$3d916e7c22dbd8b5,
    intersection: $f40331732e852e18$export$bc86dfbf7795668c,
    lazy: $f40331732e852e18$export$488013bae63b21da,
    literal: $f40331732e852e18$export$c8ec6e1ec9fefcb0,
    map: $f40331732e852e18$export$871de8747c9eaa88,
    nan: $f40331732e852e18$export$9e06de0973666692,
    nativeEnum: $f40331732e852e18$export$6fe7eca19ebe5199,
    never: $f40331732e852e18$export$b3e22bcfd64c1022,
    'null': $f40331732e852e18$export$7b1b591b262c240,
    nullable: $f40331732e852e18$export$133fc36489ac9add,
    number: $f40331732e852e18$export$98e628dec113755e,
    object: $f40331732e852e18$export$be5493f9613cbbe,
    oboolean: $f40331732e852e18$export$269251733cdcbbf1,
    onumber: $f40331732e852e18$export$eb150471a61fced6,
    optional: $f40331732e852e18$export$516e28dec6a4b6d4,
    ostring: $f40331732e852e18$export$3b3d07727c5b702c,
    pipeline: $f40331732e852e18$export$43f28b24e1eb8181,
    preprocess: $f40331732e852e18$export$fc37fe19dfda43ee,
    promise: $f40331732e852e18$export$c957ef27a0ebfd4,
    record: $f40331732e852e18$export$e5185e241753e543,
    set: $f40331732e852e18$export$adaa4cf7ef1b65be,
    strictObject: $f40331732e852e18$export$8fb0df5f40d0b477,
    string: $f40331732e852e18$export$22b082955e083ec3,
    symbol: $f40331732e852e18$export$8f701197936bc2a6,
    transformer: $f40331732e852e18$export$dc573d8a6576cdb3,
    tuple: $f40331732e852e18$export$65e3907585753458,
    'undefined': $f40331732e852e18$export$1db45310990710a5,
    union: $f40331732e852e18$export$971dd5b0dfd021b6,
    unknown: $f40331732e852e18$export$19282c40b967aec6,
    'void': $f40331732e852e18$export$490e536ee7389aeb,
    NEVER: $f40331732e852e18$export$96c94437c95d7862,
    ZodIssueCode: $f40331732e852e18$export$5ba560653e4a1035,
    quotelessJson: $f40331732e852e18$export$913eddeaf297cfea,
    ZodError: $f40331732e852e18$export$f98dac4b251ab333
});


var $0dd09485e7441d3b$var$ConfigError;
(function(ConfigError) {
    ConfigError["NotFound"] = "not_found";
    ConfigError["InvalidState"] = "state_invalid";
    ConfigError["IncorrectType"] = "incorrect_type";
})($0dd09485e7441d3b$var$ConfigError || ($0dd09485e7441d3b$exports.ConfigError = $0dd09485e7441d3b$var$ConfigError = {}));
$0dd09485e7441d3b$exports.StandardConfigSchema = $f40331732e852e18$export$2e2bcd8739ae039.record($f40331732e852e18$export$2e2bcd8739ae039.string(), $f40331732e852e18$export$2e2bcd8739ae039.object({
    value: $f40331732e852e18$export$2e2bcd8739ae039.union([
        $f40331732e852e18$export$2e2bcd8739ae039.boolean(),
        $f40331732e852e18$export$2e2bcd8739ae039.string(),
        $f40331732e852e18$export$2e2bcd8739ae039.number(),
        $f40331732e852e18$export$2e2bcd8739ae039.string().array(),
        $f40331732e852e18$export$2e2bcd8739ae039.number().array()
    ])
}));
$0dd09485e7441d3b$exports.MinimalConfigSchema = $f40331732e852e18$export$2e2bcd8739ae039.tuple([
    // list of boolean configs which are on
    $f40331732e852e18$export$2e2bcd8739ae039.string().array(),
    // list of string config tuples
    $f40331732e852e18$export$2e2bcd8739ae039.array($f40331732e852e18$export$2e2bcd8739ae039.string()).refine((arr)=>arr.length % 2 === 0),
    // list of number config tuples
    $f40331732e852e18$export$2e2bcd8739ae039.array($f40331732e852e18$export$2e2bcd8739ae039.union([
        $f40331732e852e18$export$2e2bcd8739ae039.string(),
        $f40331732e852e18$export$2e2bcd8739ae039.number()
    ])).refine((arr)=>{
        if (arr.length % 2 !== 0) return false;
        for(let i = 0; i < arr.length; i += 2){
            if (typeof arr[i] !== "string") return false;
            if (typeof arr[i + 1] !== "number") return false;
        }
        return true;
    }),
    // list of string list config tuples
    $f40331732e852e18$export$2e2bcd8739ae039.array($f40331732e852e18$export$2e2bcd8739ae039.union([
        $f40331732e852e18$export$2e2bcd8739ae039.string(),
        $f40331732e852e18$export$2e2bcd8739ae039.string().array()
    ])).refine((arr)=>{
        if (arr.length % 2 !== 0) return false;
        for(let i = 0; i < arr.length; i += 2){
            const key = arr[i];
            const val = arr[i + 1];
            if (typeof key !== "string") return false;
            if (!Array.isArray(val) || !val.every((x)=>typeof x === "string")) return false;
        }
        return true;
    }),
    // list of number list config tuples
    $f40331732e852e18$export$2e2bcd8739ae039.array($f40331732e852e18$export$2e2bcd8739ae039.union([
        $f40331732e852e18$export$2e2bcd8739ae039.string(),
        $f40331732e852e18$export$2e2bcd8739ae039.number().array()
    ])).refine((arr)=>{
        if (arr.length % 2 !== 0) return false;
        for(let i = 0; i < arr.length; i += 2){
            const key = arr[i];
            const val = arr[i + 1];
            if (typeof key !== "string") return false;
            if (!Array.isArray(val) || !val.every((x)=>typeof x === "number")) return false;
        }
        return true;
    })
]);
$0dd09485e7441d3b$exports.AnyConfigSchema = $f40331732e852e18$export$2e2bcd8739ae039.union([
    $0dd09485e7441d3b$exports.StandardConfigSchema,
    $0dd09485e7441d3b$exports.MinimalConfigSchema
]);
$0dd09485e7441d3b$exports.ConfigMapSchema = $f40331732e852e18$export$2e2bcd8739ae039.map($f40331732e852e18$export$2e2bcd8739ae039.string(), $f40331732e852e18$export$2e2bcd8739ae039.object({
    value: $f40331732e852e18$export$2e2bcd8739ae039.union([
        $f40331732e852e18$export$2e2bcd8739ae039.boolean(),
        $f40331732e852e18$export$2e2bcd8739ae039.string(),
        $f40331732e852e18$export$2e2bcd8739ae039.number(),
        $f40331732e852e18$export$2e2bcd8739ae039.string().array(),
        $f40331732e852e18$export$2e2bcd8739ae039.number().array()
    ])
}));
function $0dd09485e7441d3b$var$pairs(arr, fn) {
    for(let i = 0; i < arr.length; i += 2){
        const key = arr[i];
        const val = arr[i + 1];
        if (typeof key !== "string") throw new Error(`Expected a string while iterating pairs, got: ${arr[i]}`);
        fn(key, val);
    }
}
function $0dd09485e7441d3b$var$minimalToMap(minimal) {
    const map = new Map();
    minimal[0].forEach((boolean)=>map.set(boolean, {
            value: true
        }));
    $0dd09485e7441d3b$var$pairs(minimal[1], (a, b)=>map.set(a, {
            value: b
        }));
    $0dd09485e7441d3b$var$pairs(minimal[2], (a, b)=>map.set(a, {
            value: b
        }));
    $0dd09485e7441d3b$var$pairs(minimal[3], (a, b)=>map.set(a, {
            value: b
        }));
    $0dd09485e7441d3b$var$pairs(minimal[4], (a, b)=>map.set(a, {
            value: b
        }));
    return map;
}
function $0dd09485e7441d3b$var$standardToMap(standard) {
    const map = new Map();
    Object.entries(standard).forEach(([key, value])=>map.set(key, value));
    return map;
}
function $0dd09485e7441d3b$var$mapToMinimal(map) {
    const minimal = [
        [],
        [],
        [],
        [],
        []
    ];
    for (const [key, { value: value }] of map.entries())switch(typeof value){
        case "boolean":
            if (value) minimal[0].push(key);
            break;
        case "string":
            minimal[1].push(key, value);
            break;
        case "number":
            minimal[2].push(key, value);
            break;
        default:
            if (!Array.isArray(value)) throw new Error(`Unexpected configuration value: ${value}`);
            const allStrings = value.every((x)=>typeof x === "string");
            if (allStrings) {
                minimal[3].push(key, value);
                break;
            }
            const allNumbers = value.every((x)=>typeof x === "number");
            if (allNumbers) {
                minimal[4].push(key, value);
                break;
            }
            throw new Error(`Unexpected configuration value: ${value}`);
    }
    return minimal;
}
function $0dd09485e7441d3b$var$mapToStandard(map) {
    return Object.fromEntries(map.entries());
}


class $f101546a3944c6b9$var$ParseError extends Error {
    constructor(message, cause){
        super(message);
        this.cause = cause;
    }
}
$f101546a3944c6b9$exports.ParseError = $f101546a3944c6b9$var$ParseError;
function $f101546a3944c6b9$var$safeParse(json) {
    try {
        return {
            data: $0dd09485e7441d3b$exports.AnyConfigSchema.parse(JSON.parse(json)),
            success: true
        };
    } catch (error) {
        if (error instanceof Error) return {
            success: false,
            error: error
        };
        return {
            success: false,
            error: new $f101546a3944c6b9$var$ParseError("An unknown error occurred during parsing", error)
        };
    }
}
class $f101546a3944c6b9$var$ConfigCollection {
    static fromValues(values, options) {
        const result = $f101546a3944c6b9$var$safeParse(values);
        if (!result.success) {
            const parseError = new $f101546a3944c6b9$var$ParseError("Failed to deserialize config", result.error);
            if (options === null || options === void 0 ? void 0 : options.throw) throw parseError;
            console.error(parseError);
            return $f101546a3944c6b9$var$ConfigCollection.empty();
        }
        return new $f101546a3944c6b9$var$ConfigCollection(Array.isArray(result.data) ? (0, $0dd09485e7441d3b$exports.minimalToMap)(result.data) : (0, $0dd09485e7441d3b$exports.standardToMap)(result.data));
    }
    static empty() {
        return new $f101546a3944c6b9$var$ConfigCollection(new Map());
    }
    toJson(format) {
        switch(format){
            case "standard":
                return JSON.stringify((0, $0dd09485e7441d3b$exports.mapToStandard)(this.config));
            case "minimal":
                return JSON.stringify((0, $0dd09485e7441d3b$exports.mapToMinimal)(this.config));
        }
    }
    getBoolean(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: $0dd09485e7441d3b$exports.ConfigError.NotFound
        };
        const { value: value } = config;
        if (typeof value !== "boolean") return {
            error: $0dd09485e7441d3b$exports.ConfigError.IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getString(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: $0dd09485e7441d3b$exports.ConfigError.NotFound
        };
        const { value: value } = config;
        if (typeof value !== "string") return {
            error: $0dd09485e7441d3b$exports.ConfigError.IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getNumber(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: $0dd09485e7441d3b$exports.ConfigError.NotFound
        };
        const { value: value } = config;
        if (typeof value !== "number") return {
            error: $0dd09485e7441d3b$exports.ConfigError.IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getStringList(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: $0dd09485e7441d3b$exports.ConfigError.NotFound
        };
        const { value: value } = config;
        if (!Array.isArray(value) || !value.every((x)=>typeof x === "string")) return {
            error: $0dd09485e7441d3b$exports.ConfigError.IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getNumberList(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: $0dd09485e7441d3b$exports.ConfigError.NotFound
        };
        const { value: value } = config;
        if (!Array.isArray(value) || !value.every((x)=>typeof x === "number")) return {
            error: $0dd09485e7441d3b$exports.ConfigError.IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    constructor(config){
        this.config = config;
    }
}
$f101546a3944c6b9$exports.ConfigCollection = $f101546a3944c6b9$var$ConfigCollection;


Object.defineProperty($4983e8507bb0e9f6$exports, "ConfigCollection", {
    enumerable: true,
    get: function() {
        return $f101546a3944c6b9$exports.ConfigCollection;
    }
});

Object.defineProperty($4983e8507bb0e9f6$exports, "ConfigError", {
    enumerable: true,
    get: function() {
        return $0dd09485e7441d3b$exports.ConfigError;
    }
});
Object.defineProperty($4983e8507bb0e9f6$exports, "AnyConfigSchema", {
    enumerable: true,
    get: function() {
        return $0dd09485e7441d3b$exports.AnyConfigSchema;
    }
});
Object.defineProperty($4983e8507bb0e9f6$exports, "ConfigMapSchema", {
    enumerable: true,
    get: function() {
        return $0dd09485e7441d3b$exports.ConfigMapSchema;
    }
});
Object.defineProperty($4983e8507bb0e9f6$exports, "MinimalConfigSchema", {
    enumerable: true,
    get: function() {
        return $0dd09485e7441d3b$exports.MinimalConfigSchema;
    }
});
Object.defineProperty($4983e8507bb0e9f6$exports, "StandardConfigSchema", {
    enumerable: true,
    get: function() {
        return $0dd09485e7441d3b$exports.StandardConfigSchema;
    }
});
Object.defineProperty($4983e8507bb0e9f6$exports, "minimalToMap", {
    enumerable: true,
    get: function() {
        return $0dd09485e7441d3b$exports.minimalToMap;
    }
});
Object.defineProperty($4983e8507bb0e9f6$exports, "standardToMap", {
    enumerable: true,
    get: function() {
        return $0dd09485e7441d3b$exports.standardToMap;
    }
});


class $e3102180980df047$var$ConfigClient {
    static async fetch(options) {
        var _a;
        const fetch = (_a = options.fetch) !== null && _a !== void 0 ? _a : globalThis.fetch;
        const response = await fetch(`${options.ffsBaseUrl}/api/v2/configurations`, {
            method: "POST",
            body: JSON.stringify(options.context),
            headers: {
                "content-type": "application/json",
                "x-api-key": options.ffsApiKey
            }
        });
        if (!response.ok) throw new Error(`Unexpected response ${response.status}: ${await response.text()}`);
        const valuesPayload = await response.text();
        return $4983e8507bb0e9f6$exports.ConfigCollection.fromValues(valuesPayload);
    }
}
$e3102180980df047$exports.ConfigClient = $e3102180980df047$var$ConfigClient;


Object.defineProperty($e5f7b614fbcf0ffb$exports, "ConfigClient", {
    enumerable: true,
    get: function() {
        return $e3102180980df047$exports.ConfigClient;
    }
});

Object.defineProperty($e5f7b614fbcf0ffb$exports, "ConfigCollection", {
    enumerable: true,
    get: function() {
        return $4983e8507bb0e9f6$exports.ConfigCollection;
    }
});
Object.defineProperty($e5f7b614fbcf0ffb$exports, "ConfigError", {
    enumerable: true,
    get: function() {
        return $4983e8507bb0e9f6$exports.ConfigError;
    }
});
Object.defineProperty($e5f7b614fbcf0ffb$exports, "ConfigMapSchema", {
    enumerable: true,
    get: function() {
        return $4983e8507bb0e9f6$exports.ConfigMapSchema;
    }
});



const $d377413f5e2ec9d9$var$defaultFeatureFlags = {
    'pc-frontend-down-for-maintenance': false,
    'pc-frontend-use-sso': false
};
const $d377413f5e2ec9d9$var$FeatureFlagProviderContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext($d377413f5e2ec9d9$var$defaultFeatureFlags);
const $d377413f5e2ec9d9$var$getFfsConfig = ()=>{
    switch((0, $35a545355f14a0c7$export$6bc7b24d4e862158)().name){
        case (0, $c1e4a1336f2cb96e$exports).STAGE:
            return {
                apiKey: '4fe8b2e3-2652-4c3b-ae74-a68f018b02c1',
                baseUrl: 'https://api.stg.atlassian.com/flags'
            };
        case (0, $c1e4a1336f2cb96e$exports).PROD:
            return {
                apiKey: 'f7e6ffcd-c5c4-476d-b870-5fe4dc7903e8',
                baseUrl: 'https://api.atlassian.com/flags'
            };
        default:
            return {
                apiKey: '3d7da3c9-0e4a-4e84-bb50-0e85faeb1f11',
                baseUrl: 'https://api.dev.atlassian.com/flags'
            };
    }
};
const $d377413f5e2ec9d9$var$readBoolean = (configCollection, flag, defaultValue)=>{
    const configValue = configCollection.getBoolean(flag);
    if (!configValue || 'error' in configValue) return defaultValue;
    return configValue.value;
};
const $d377413f5e2ec9d9$export$90335b3ff08f335 = ()=>(0, $7fPBF.useContext)($d377413f5e2ec9d9$var$FeatureFlagProviderContext);
const $d377413f5e2ec9d9$export$ec0c43a58fca1a2 = (props)=>{
    const [featureFlagsLoaded, setFeatureFlagsLoaded] = (0, $7fPBF.useState)(false);
    const [featureFlags, setFeatureFlags] = (0, $7fPBF.useState)($d377413f5e2ec9d9$var$defaultFeatureFlags);
    (0, $7fPBF.useEffect)(()=>{
        async function fetchConfig() {
            try {
                const ffsConfig = $d377413f5e2ec9d9$var$getFfsConfig();
                const config = await (0, $e5f7b614fbcf0ffb$exports.ConfigClient).fetch({
                    ffsBaseUrl: ffsConfig.baseUrl,
                    ffsApiKey: ffsConfig.apiKey,
                    context: {
                        namespace: 'atl-preferences-center_web',
                        identifiers: {
                            randomizationId: crypto.randomUUID()
                        },
                        metadata: {}
                    }
                });
                setFeatureFlags({
                    ['pc-frontend-down-for-maintenance']: $d377413f5e2ec9d9$var$readBoolean(config, 'pc-frontend-down-for-maintenance', $d377413f5e2ec9d9$var$defaultFeatureFlags['pc-frontend-down-for-maintenance']),
                    ['pc-frontend-use-sso']: $d377413f5e2ec9d9$var$readBoolean(config, 'pc-frontend-use-sso', $d377413f5e2ec9d9$var$defaultFeatureFlags['pc-frontend-use-sso'])
                });
            } catch (e) {
                console.error('Failed to fetch feature flags', e);
            }
            setFeatureFlagsLoaded(true);
        }
        fetchConfig();
    }, []);
    if (!featureFlagsLoaded) return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $c69938f751e7a026$export$ffb0004e005737fa), {}); // show blank page while feature flags are loading
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)($d377413f5e2ec9d9$var$FeatureFlagProviderContext.Provider, {
        value: featureFlags,
        children: props.children
    });
};


const $49ba1be7e4639afe$var$PreferencesCenter = ()=>{
    const dispatch = (0, $7ef2374eddee6a70$export$f51d452c10d5b956)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const email = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $603bd90c46957049$export$faf42b3a43b63a45));
    const featureFlags = (0, $d377413f5e2ec9d9$export$90335b3ff08f335)();
    (0, $7fPBF.useEffect)(()=>{
        dispatch((0, $3d2cac913f314860$export$a3910a3548679a09)({
            query: location.search,
            useSso: featureFlags['pc-frontend-use-sso']
        }));
    }, [
        dispatch,
        location,
        featureFlags
    ]);
    const unsubscribeHandler = (0, $7fPBF.useCallback)(()=>{
        (0, $0e08eda71bb24540$export$2661a9b7d6c9d40)();
        dispatch((0, $3d2cac913f314860$export$34ae4e8891fc3f3d)());
    }, [
        dispatch
    ]);
    const actionBarHandler = (0, $7fPBF.useCallback)(()=>email == null ? null : /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $788f88bb6ebc19d1$export$2e2bcd8739ae039), {
            email: email,
            onUnsubscribeClick: unsubscribeHandler
        }), [
        email,
        unsubscribeHandler
    ]);
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $ef58838c74859603$export$2e2bcd8739ae039), {
        headerContent: actionBarHandler,
        children: /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)("div", {
            children: [
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $6b41785aa38675ed$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $6b7c307e3b08d158$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $88ea1b053c235b63$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $85d7791daea50a70$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $b9140ff8d659df65$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $ab16c582615dabed$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $68c6614e902c1d6d$export$2e2bcd8739ae039), {
                    onUnsubscribeClick: unsubscribeHandler
                }),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $8e2882318f59e87f$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $49ba1be7e4639afe$export$2e2bcd8739ae039 = $49ba1be7e4639afe$var$PreferencesCenter;









const $6c559b868a542118$var$App = ()=>{
    const dispatch = (0, $7ef2374eddee6a70$export$f51d452c10d5b956)();
    (0, $7fPBF.useEffect)(()=>{
        dispatch((0, $cc45bcc51bf95f36$export$d1f0f8da0682c531)());
    }, [
        dispatch
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const script = document.createElement('script');
        const environment = (0, $35a545355f14a0c7$export$6bc7b24d4e862158)().name;
        script.dataset.domain = '01964a8b-758a-751f-b483-0ec1e112bff6';
        if (environment === (0, $c1e4a1336f2cb96e$exports).PROD) {
            script.src = 'https://atl-onetrust-wrapper.atlassian.com/assets/atl-onetrust-wrapper.min.js';
            script.dataset.domain = '01964ae5-b19b-70b7-9a2d-f40c3cdc5ead';
        } else if (environment === (0, $c1e4a1336f2cb96e$exports).STAGE) script.src = 'https://atl-onetrust-wrapper.stg-east.frontend.public.atl-paas.net/assets/atl-onetrust-wrapper.min.js';
        else script.src = 'https://atl-onetrust-wrapper.ddev.frontend.public.atl-paas.net/assets/atl-onetrust-wrapper.min.js';
        script.dataset.sync = 'false';
        script.dataset.test = (environment !== (0, $c1e4a1336f2cb96e$exports).PROD).toString();
        script.dataset.geofence = 'true';
        document.head.appendChild(script);
        return ()=>{
            document.head.removeChild(script);
        };
    }, []);
    const translationsInitialized = (0, $7ef2374eddee6a70$export$a7347740d65f620b)((0, $0ce633403190319b$export$2a9f106f311b16ff));
    return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $c69938f751e7a026$export$ffb0004e005737fa), {
        children: translationsInitialized && /*#__PURE__*/ (0, $c69938f751e7a026$export$25062201e9e25d76)((0, $d9fd026bfea79ab9$export$3565eb3d00ca5a74), {
            children: [
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                    path: '/',
                    element: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $49ba1be7e4639afe$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                    path: '/consent',
                    element: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $100065b339a92676$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                    path: '/not-found',
                    element: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $24b14210ebbca78e$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                    path: '*',
                    element: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d9fd026bfea79ab9$export$444b3ab0cb9aec40), {
                        to: '/not-found',
                        replace: true
                    })
                })
            ]
        })
    });
};
var $6c559b868a542118$export$2e2bcd8739ae039 = $6c559b868a542118$var$App;



const $39e0699b89d33240$var$initialState = {
    loading: {},
    env: 'local'
};
const $39e0699b89d33240$var$typePrefixRegex = /^(.*)\//;
const $39e0699b89d33240$var$setLoadingState = (state, action, loadingType)=>{
    var _action_type_match;
    const typePrefix = (_action_type_match = action.type.match($39e0699b89d33240$var$typePrefixRegex)) === null || _action_type_match === void 0 ? void 0 : _action_type_match[1];
    if (typePrefix) state.loading[typePrefix] = loadingType;
};
const $39e0699b89d33240$var$appSlice = (0, $15d924278321bdfd$export$4d8d9bd83c24ae8b)({
    name: 'requestStatus',
    initialState: $39e0699b89d33240$var$initialState,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addMatcher((action)=>action.type.endsWith('/pending'), (state, action)=>$39e0699b89d33240$var$setLoadingState(state, action, 'pending'));
        builder.addMatcher((action)=>action.type.endsWith('/fulfilled'), (state, action)=>$39e0699b89d33240$var$setLoadingState(state, action, 'idle'));
        builder.addMatcher((action)=>action.type.endsWith('/rejected'), (state, action)=>$39e0699b89d33240$var$setLoadingState(state, action, 'idle'));
    }
});
const { reducer: $39e0699b89d33240$var$reducer } = $39e0699b89d33240$var$appSlice;
var $39e0699b89d33240$export$2e2bcd8739ae039 = $39e0699b89d33240$var$reducer;




const $7a501a2d8adab3c3$export$9d56a93b8e84b384 = (actions)=>(0, $8098b29b64296697$export$595d22ed68ca2841)((state)=>state.app.loading, (loading)=>actions.some((action)=>loading[action] === 'pending'));
const $7a501a2d8adab3c3$export$6a1923cb7c064699 = $7a501a2d8adab3c3$export$9d56a93b8e84b384([
    (0, $80022746ba8cd68a$export$6871e08c9c3b9797),
    (0, $80022746ba8cd68a$export$30f55fa357ca2ae5),
    (0, $80022746ba8cd68a$export$1a788c0d2586d018)
]);










const $b91bb6c1ec048c06$export$a8a69c316169e623 = (0, $78916fc80cd27125$export$66e4520cdb265d18)({
    app: (0, $39e0699b89d33240$export$2e2bcd8739ae039),
    preferences: (0, $3d2cac913f314860$export$2e2bcd8739ae039),
    consent: (0, $cdfa88e4a0cef872$export$2e2bcd8739ae039),
    localization: (0, $cc45bcc51bf95f36$export$2e2bcd8739ae039)
});
const $b91bb6c1ec048c06$var$store = (0, $15d924278321bdfd$export$7d8a5b498da695ac)({
    reducer: $b91bb6c1ec048c06$export$a8a69c316169e623,
    devTools: false
});
var $b91bb6c1ec048c06$export$2e2bcd8739ae039 = $b91bb6c1ec048c06$var$store;



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
var $b353b064a96cf357$exports = {};
// This file is a compatibility shim for bundlers (e.g. webpack 4) that do not
// support the package.json `exports` field for resolving subpath exports.

$b353b064a96cf357$exports = (parcelRequire("6jZHp"));


const $37b03cd1fa6d4fb8$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;


const $961dedfff8dbd514$export$31499a9cd224b78c = "10.62.0";


const $df8678217e707dd5$export$f1a6cdb1459e81d1 = globalThis;


function $3d29ea41beb10247$export$19eade501500c6c1() {
    $3d29ea41beb10247$export$c8bfa33e4e8ae492((0, $df8678217e707dd5$export$f1a6cdb1459e81d1));
    return 0, $df8678217e707dd5$export$f1a6cdb1459e81d1;
}
function $3d29ea41beb10247$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.version = __SENTRY__.version || (0, $961dedfff8dbd514$export$31499a9cd224b78c);
    return __SENTRY__[0, $961dedfff8dbd514$export$31499a9cd224b78c] = __SENTRY__[0, $961dedfff8dbd514$export$31499a9cd224b78c] || {};
}
function $3d29ea41beb10247$export$7e223ec222791509(name, creator, obj = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $961dedfff8dbd514$export$31499a9cd224b78c] = __SENTRY__[0, $961dedfff8dbd514$export$31499a9cd224b78c] || {};
    return carrier[name] || (carrier[name] = creator());
}




const $d8898b8567c29ee9$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
const $d8898b8567c29ee9$var$PREFIX = "Sentry Logger ";
const $d8898b8567c29ee9$export$77c4ce905194557b = {};
function $d8898b8567c29ee9$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $df8678217e707dd5$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($d8898b8567c29ee9$export$77c4ce905194557b);
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $d8898b8567c29ee9$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $d8898b8567c29ee9$var$enable() {
    $d8898b8567c29ee9$var$_getLoggerSettings().enabled = true;
}
function $d8898b8567c29ee9$var$disable() {
    $d8898b8567c29ee9$var$_getLoggerSettings().enabled = false;
}
function $d8898b8567c29ee9$var$isEnabled() {
    return $d8898b8567c29ee9$var$_getLoggerSettings().enabled;
}
function $d8898b8567c29ee9$var$log(...args) {
    $d8898b8567c29ee9$var$_maybeLog("log", ...args);
}
function $d8898b8567c29ee9$var$warn(...args) {
    $d8898b8567c29ee9$var$_maybeLog("warn", ...args);
}
function $d8898b8567c29ee9$var$error(...args) {
    $d8898b8567c29ee9$var$_maybeLog("error", ...args);
}
function $d8898b8567c29ee9$var$_maybeLog(level, ...args) {
    if (!(0, $37b03cd1fa6d4fb8$export$16a28057038b10ef)) return;
    if ($d8898b8567c29ee9$var$isEnabled()) $d8898b8567c29ee9$export$cda52e2a8927a2ca(()=>{
        (0, $df8678217e707dd5$export$f1a6cdb1459e81d1).console[level](`${$d8898b8567c29ee9$var$PREFIX}[${level}]:`, ...args);
    });
}
function $d8898b8567c29ee9$var$_getLoggerSettings() {
    if (!(0, $37b03cd1fa6d4fb8$export$16a28057038b10ef)) return {
        enabled: false
    };
    return (0, $3d29ea41beb10247$export$7e223ec222791509)("loggerSettings", ()=>({
            enabled: false
        }));
}
const $d8898b8567c29ee9$export$1c9f709888824e05 = {
    enable: /** Enable logging. */ $d8898b8567c29ee9$var$enable,
    disable: /** Disable logging. */ $d8898b8567c29ee9$var$disable,
    isEnabled: /** Check if logging is enabled. */ $d8898b8567c29ee9$var$isEnabled,
    log: /** Log a message. */ $d8898b8567c29ee9$var$log,
    warn: /** Log a warning. */ $d8898b8567c29ee9$var$warn,
    error: /** Log an error. */ $d8898b8567c29ee9$var$error
};



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
const $a6df8b9dd4ca405a$var$STACKTRACE_FRAME_LIMIT = 50;
const $a6df8b9dd4ca405a$export$27c7e15d453fc0ac = "?";
const $a6df8b9dd4ca405a$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $a6df8b9dd4ca405a$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
function $a6df8b9dd4ca405a$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            if (line.length > 1024) line = line.slice(0, 1024);
            const cleanedLine = $a6df8b9dd4ca405a$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($a6df8b9dd4ca405a$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            if (cleanedLine.includes("Error: ")) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $a6df8b9dd4ca405a$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $a6df8b9dd4ca405a$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
function $a6df8b9dd4ca405a$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $a6df8b9dd4ca405a$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
function $a6df8b9dd4ca405a$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    if (/sentryWrapped/.test($a6df8b9dd4ca405a$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    localStack.reverse();
    if ($a6df8b9dd4ca405a$var$STRIP_FRAME_REGEXP.test($a6df8b9dd4ca405a$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        if ($a6df8b9dd4ca405a$var$STRIP_FRAME_REGEXP.test($a6df8b9dd4ca405a$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $a6df8b9dd4ca405a$var$STACKTRACE_FRAME_LIMIT).map((frame)=>(0, $2qxEV._)((0, $9tqwB._)({}, frame), {
            filename: frame.filename || $a6df8b9dd4ca405a$var$getLastStackFrame(localStack).filename,
            function: frame.function || $a6df8b9dd4ca405a$export$27c7e15d453fc0ac
        }));
}
function $a6df8b9dd4ca405a$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $a6df8b9dd4ca405a$var$defaultFunctionName = "<anonymous>";
function $a6df8b9dd4ca405a$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $a6df8b9dd4ca405a$var$defaultFunctionName;
        return fn.name || $a6df8b9dd4ca405a$var$defaultFunctionName;
    } catch (e) {
        return $a6df8b9dd4ca405a$var$defaultFunctionName;
    }
}
function $a6df8b9dd4ca405a$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            exception.values.forEach((value)=>{
                if (value.stacktrace.frames) frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (e) {
            return void 0;
        }
    }
    return void 0;
}
function $a6df8b9dd4ca405a$export$60c0d6c8e038267a(path) {
    let filename = (path === null || path === void 0 ? void 0 : path.startsWith("file://")) ? path.slice(7) : path;
    if (filename === null || filename === void 0 ? void 0 : filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}


const $53b768e21077af87$var$handlers = {};
const $53b768e21077af87$var$instrumented = {};
function $53b768e21077af87$export$a4e09611e30da72e(type, handler) {
    $53b768e21077af87$var$handlers[type] = $53b768e21077af87$var$handlers[type] || [];
    $53b768e21077af87$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $53b768e21077af87$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
function $53b768e21077af87$export$b17eab759a1cb5fe() {
    Object.keys($53b768e21077af87$var$handlers).forEach((key)=>{
        $53b768e21077af87$var$handlers[key] = void 0;
    });
}
function $53b768e21077af87$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$53b768e21077af87$var$instrumented[type]) {
        $53b768e21077af87$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).error(`Error while instrumenting ${type}`, e);
        }
    }
}
function $53b768e21077af87$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $53b768e21077af87$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${(0, $a6df8b9dd4ca405a$export$aad197c7121a6651)(handler)}
Error:`, e);
    }
}


var $9tqwB = parcelRequire("9tqwB");


const $85e272e760900bb9$var$objectToString = Object.prototype.toString;
function $85e272e760900bb9$export$e6127cc7fe7395c3(wat) {
    switch($85e272e760900bb9$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $85e272e760900bb9$export$49034edbe6b62415(wat, Error);
    }
}
function $85e272e760900bb9$var$isBuiltin(wat, className) {
    return $85e272e760900bb9$var$objectToString.call(wat) === `[object ${className}]`;
}
function $85e272e760900bb9$export$9f9636d330b71954(wat) {
    return $85e272e760900bb9$var$isBuiltin(wat, "ErrorEvent");
}
function $85e272e760900bb9$export$ef9e2056653f0c8e(wat) {
    return $85e272e760900bb9$var$isBuiltin(wat, "DOMError");
}
function $85e272e760900bb9$export$12e869b2a583f783(wat) {
    return $85e272e760900bb9$var$isBuiltin(wat, "DOMException");
}
function $85e272e760900bb9$export$844ec244b1367d54(wat) {
    return $85e272e760900bb9$var$isBuiltin(wat, "String");
}
function $85e272e760900bb9$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function $85e272e760900bb9$export$c3825b437cbdea5c(wat) {
    return wat === null || $85e272e760900bb9$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
function $85e272e760900bb9$export$53b83ca8eaab0383(wat) {
    return $85e272e760900bb9$var$isBuiltin(wat, "Object");
}
function $85e272e760900bb9$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $85e272e760900bb9$export$49034edbe6b62415(wat, Event);
}
function $85e272e760900bb9$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $85e272e760900bb9$export$49034edbe6b62415(wat, Element);
}
function $85e272e760900bb9$export$49841c62b9eff15(wat) {
    return $85e272e760900bb9$var$isBuiltin(wat, "RegExp");
}
function $85e272e760900bb9$export$f5b060c2914b97c8(wat) {
    return Boolean((wat === null || wat === void 0 ? void 0 : wat.then) && typeof wat.then === "function");
}
function $85e272e760900bb9$export$bc2894c7158efbac(wat) {
    return $85e272e760900bb9$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $85e272e760900bb9$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (e) {
        return false;
    }
}
function $85e272e760900bb9$export$7916fad0ebc23f48(wat) {
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
function $85e272e760900bb9$export$6d3d1f317d7cda57(request) {
    return typeof Request !== "undefined" && $85e272e760900bb9$export$49034edbe6b62415(request, Request);
}


function $85a434b6cfc19e37$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    if (typeof wrapped === "function") $85a434b6cfc19e37$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch (e) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Failed to replace method "${name}" in object`, source);
    }
}
function $85a434b6cfc19e37$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch (e) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
function $85a434b6cfc19e37$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $85a434b6cfc19e37$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (e) {}
}
function $85a434b6cfc19e37$export$e00416b3cd122575(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== "function") throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($85a434b6cfc19e37$export$e6cc1e135e2092e5(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $85a434b6cfc19e37$export$5c1499e2e5d010ae(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
function $85a434b6cfc19e37$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $85a434b6cfc19e37$export$62ff257738bf57f5(value) {
    if ((0, $85e272e760900bb9$export$e6127cc7fe7395c3)(value)) return (0, $9tqwB._)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $85a434b6cfc19e37$var$getOwnProperties(value));
    if ((0, $85e272e760900bb9$export$9671ea99bd126ace)(value)) {
        const { type: type, target: target, currentTarget: currentTarget, detail: detail } = value;
        return (0, $9tqwB._)({
            type: type,
            target: target,
            currentTarget: currentTarget
        }, detail ? {
            detail: detail
        } : {}, $85a434b6cfc19e37$var$getOwnProperties(value));
    }
    return value;
}
function $85a434b6cfc19e37$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) return Object.fromEntries(Object.entries(obj));
    return {};
}
function $85a434b6cfc19e37$export$b0244d5063c0b61b(exception) {
    const keys = Object.keys($85a434b6cfc19e37$export$62ff257738bf57f5(exception));
    keys.sort();
    return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
function $85a434b6cfc19e37$export$d25f2688db1bb433(inputValue) {
    const memoizationMap = /* @__PURE__ */ new Map();
    return $85a434b6cfc19e37$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $85a434b6cfc19e37$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) return memoVal;
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($85a434b6cfc19e37$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($85a434b6cfc19e37$var$isPojo(inputValue)) {
        const returnValue = {};
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== void 0) returnValue[key] = $85a434b6cfc19e37$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    return inputValue;
}
function $85a434b6cfc19e37$var$isPojo(input) {
    const constructor = input.constructor;
    return constructor === Object || constructor === void 0;
}
function $85a434b6cfc19e37$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == void 0:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $85e272e760900bb9$export$c3825b437cbdea5c)(wat):
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




const $ed8e12a1b26c7e3d$var$WINDOW = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1);
function $ed8e12a1b26c7e3d$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
function $ed8e12a1b26c7e3d$export$1c08bd1a7eb3c472() {
    try {
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
function $ed8e12a1b26c7e3d$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
function $ed8e12a1b26c7e3d$export$67fc34576016d6ec() {
    return "history" in $ed8e12a1b26c7e3d$var$WINDOW && !!$ed8e12a1b26c7e3d$var$WINDOW.history;
}
const $ed8e12a1b26c7e3d$export$edf3cb81fd7d2a3e = $ed8e12a1b26c7e3d$var$_isFetchSupported;
function $ed8e12a1b26c7e3d$var$_isFetchSupported() {
    if (!("fetch" in $ed8e12a1b26c7e3d$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("data:,");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
function $ed8e12a1b26c7e3d$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $ed8e12a1b26c7e3d$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$ed8e12a1b26c7e3d$var$_isFetchSupported()) return false;
    if ($ed8e12a1b26c7e3d$export$d5f608b368e73f38($ed8e12a1b26c7e3d$var$WINDOW.fetch)) return true;
    let result = false;
    const doc = $ed8e12a1b26c7e3d$var$WINDOW.document;
    if (doc && typeof doc.createElement === "function") try {
        var _sandbox_contentWindow;
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if ((_sandbox_contentWindow = sandbox.contentWindow) === null || _sandbox_contentWindow === void 0 ? void 0 : _sandbox_contentWindow.fetch) result = $ed8e12a1b26c7e3d$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $ed8e12a1b26c7e3d$export$531055a6c684a70a() {
    return "ReportingObserver" in $ed8e12a1b26c7e3d$var$WINDOW;
}
function $ed8e12a1b26c7e3d$export$2d308b428295192f() {
    if (!$ed8e12a1b26c7e3d$var$_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}



const $b7c04b6a834a93ab$export$56d8a8a25bd48b81 = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1);


let $a2d725b30741e272$var$lastHref;
function $a2d725b30741e272$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $53b768e21077af87$export$a4e09611e30da72e)(type, handler);
    (0, $53b768e21077af87$export$e18d6c5462c01368)(type, $a2d725b30741e272$export$d9b613a6254a184e);
}
function $a2d725b30741e272$export$d9b613a6254a184e() {
    (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).addEventListener("popstate", ()=>{
        const to = (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).location.href;
        const from = $a2d725b30741e272$var$lastHref;
        $a2d725b30741e272$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $53b768e21077af87$export$b18c893e424d3127)("history", handlerData);
    });
    if (!(0, $ed8e12a1b26c7e3d$export$67fc34576016d6ec)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : void 0;
            if (url) {
                const from = $a2d725b30741e272$var$lastHref;
                const to = $a2d725b30741e272$var$getAbsoluteUrl(String(url));
                $a2d725b30741e272$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $53b768e21077af87$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $85a434b6cfc19e37$export$9563e054e6f787fb)((0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).history, "pushState", historyReplacementFunction);
    (0, $85a434b6cfc19e37$export$9563e054e6f787fb)((0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).history, "replaceState", historyReplacementFunction);
}
function $a2d725b30741e272$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).location.origin);
        return url.toString();
    } catch (e) {
        return urlOrPath;
    }
}


var $9tqwB = parcelRequire("9tqwB");

let $8aca1af6321ba44f$var$RESOLVED_RUNNER;
function $8aca1af6321ba44f$export$ff239213cb80e2da(cb) {
    if ($8aca1af6321ba44f$var$RESOLVED_RUNNER !== void 0) return $8aca1af6321ba44f$var$RESOLVED_RUNNER ? $8aca1af6321ba44f$var$RESOLVED_RUNNER(cb) : cb();
    const sym = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
    const globalWithSymbol = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1);
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
        $8aca1af6321ba44f$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $8aca1af6321ba44f$var$RESOLVED_RUNNER(cb);
    }
    $8aca1af6321ba44f$var$RESOLVED_RUNNER = null;
    return cb();
}
function $8aca1af6321ba44f$export$9869d72de32a3917() {
    return $8aca1af6321ba44f$export$ff239213cb80e2da(()=>Math.random());
}
function $8aca1af6321ba44f$export$65b1bada40c91b34() {
    return $8aca1af6321ba44f$export$ff239213cb80e2da(()=>Date.now());
}



const $b007b72e24b33b62$var$ONE_SECOND_IN_MS = 1e3;
function $b007b72e24b33b62$export$7740643b9eeaf0c4() {
    return (0, $8aca1af6321ba44f$export$65b1bada40c91b34)() / $b007b72e24b33b62$var$ONE_SECOND_IN_MS;
}
function $b007b72e24b33b62$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1);
    if (!(performance === null || performance === void 0 ? void 0 : performance.now) || !performance.timeOrigin) return $b007b72e24b33b62$export$7740643b9eeaf0c4;
    const timeOrigin = performance.timeOrigin;
    return ()=>{
        return (timeOrigin + (0, $8aca1af6321ba44f$export$ff239213cb80e2da)(()=>performance.now())) / $b007b72e24b33b62$var$ONE_SECOND_IN_MS;
    };
}
let $b007b72e24b33b62$var$_cachedTimestampInSeconds;
function $b007b72e24b33b62$export$ee52dced521e3e18() {
    const func = $b007b72e24b33b62$var$_cachedTimestampInSeconds !== null && $b007b72e24b33b62$var$_cachedTimestampInSeconds !== void 0 ? $b007b72e24b33b62$var$_cachedTimestampInSeconds : $b007b72e24b33b62$var$_cachedTimestampInSeconds = $b007b72e24b33b62$var$createUnixTimestampInSecondsFunc();
    return func();
}
let $b007b72e24b33b62$var$cachedTimeOrigin = null;
function $b007b72e24b33b62$var$getBrowserTimeOrigin() {
    var _performance_timing;
    const { performance: performance } = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1);
    if (!(performance === null || performance === void 0 ? void 0 : performance.now)) return void 0;
    const threshold = 3e5;
    const performanceNow = (0, $8aca1af6321ba44f$export$ff239213cb80e2da)(()=>performance.now());
    const dateNow = (0, $8aca1af6321ba44f$export$65b1bada40c91b34)();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === "number") {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    const navigationStart = (_performance_timing = performance.timing) === null || _performance_timing === void 0 ? void 0 : _performance_timing.navigationStart;
    if (typeof navigationStart === "number") {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    return dateNow - performanceNow;
}
function $b007b72e24b33b62$export$baf075a948ffc0bf() {
    if ($b007b72e24b33b62$var$cachedTimeOrigin === null) $b007b72e24b33b62$var$cachedTimeOrigin = $b007b72e24b33b62$var$getBrowserTimeOrigin();
    return $b007b72e24b33b62$var$cachedTimeOrigin;
}


var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");



function $dff99a7a1f7c3087$export$f0b98edec95fcb33(value) {
    try {
        const WeakRefImpl = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1).WeakRef;
        if (typeof WeakRefImpl === "function") return new WeakRefImpl(value);
    } catch (e) {}
    return value;
}
function $dff99a7a1f7c3087$export$a0592ad8c3586cf(ref) {
    if (!ref) return void 0;
    if (typeof ref === "object" && "deref" in ref && typeof ref.deref === "function") try {
        return ref.deref();
    } catch (e) {
        return void 0;
    }
    return ref;
}


const $9f9cfe5727c3ad26$var$SCOPE_SPAN_FIELD = "_sentrySpan";
function $9f9cfe5727c3ad26$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(scope, $9f9cfe5727c3ad26$var$SCOPE_SPAN_FIELD, (0, $dff99a7a1f7c3087$export$f0b98edec95fcb33)(span));
    else delete scope[$9f9cfe5727c3ad26$var$SCOPE_SPAN_FIELD];
}
function $9f9cfe5727c3ad26$export$91f063ebb8eff307(scope) {
    return (0, $dff99a7a1f7c3087$export$a0592ad8c3586cf)(scope[$9f9cfe5727c3ad26$var$SCOPE_SPAN_FIELD]);
}




var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $9tqwB = parcelRequire("9tqwB");




const $e335bea78aa151c5$var$SENTRY_SKIP_NORMALIZATION = /* @__PURE__ */ Symbol.for("sentry.skipNormalization");
const $e335bea78aa151c5$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = /* @__PURE__ */ Symbol.for("sentry.overrideNormalizationDepth");
function $e335bea78aa151c5$export$280812de8e91ea53(obj) {
    (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(obj, $e335bea78aa151c5$var$SENTRY_SKIP_NORMALIZATION, true);
}
function $e335bea78aa151c5$export$610d1422c4bdc4c1(obj, depth) {
    (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(obj, $e335bea78aa151c5$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
function $e335bea78aa151c5$export$c8d26b7b28f926c7(value) {
    return Boolean(value[$e335bea78aa151c5$var$SENTRY_SKIP_NORMALIZATION]);
}
function $e335bea78aa151c5$export$fe95a19841c4b155(value) {
    const v = value[$e335bea78aa151c5$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === "number" ? v : void 0;
}




let $7879d292a118e15d$var$stringifier;
function $7879d292a118e15d$export$575c40989754ba4d(newStringifier) {
    $7879d292a118e15d$var$stringifier = newStringifier;
}
function $7879d292a118e15d$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        return $7879d292a118e15d$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
function $7879d292a118e15d$export$23fbbb20bed71033(object, depth = 3, maxSize = 102400) {
    const normalized = $7879d292a118e15d$export$a3295358bff77e(object, depth);
    if ($7879d292a118e15d$var$jsonSize(normalized) > maxSize) return $7879d292a118e15d$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
function $7879d292a118e15d$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $7879d292a118e15d$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $7879d292a118e15d$export$a110e5bc79f44a84(key, value);
    if (!stringified.startsWith("[object ")) return stringified;
    if ((0, $e335bea78aa151c5$export$c8d26b7b28f926c7)(value)) return value;
    const overrideDepth = (0, $e335bea78aa151c5$export$fe95a19841c4b155)(value);
    const remainingDepth = overrideDepth !== void 0 ? overrideDepth : depth;
    if (remainingDepth === 0) return stringified.replace("object ", "");
    if (memoize(value)) return "[Circular ~]";
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        return $7879d292a118e15d$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (e) {}
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    const visitable = (0, $85a434b6cfc19e37$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $7879d292a118e15d$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    unmemoize(value);
    return normalized;
}
function $7879d292a118e15d$export$a110e5bc79f44a84(key, value) {
    try {
        if ($7879d292a118e15d$var$stringifier) {
            const stringified = $7879d292a118e15d$var$stringifier(value);
            if (stringified) return stringified;
        }
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${(0, $a6df8b9dd4ca405a$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        const objName = $7879d292a118e15d$var$getConstructorName(value);
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
function $7879d292a118e15d$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === void 0 ? void 0 : prototype.constructor) ? prototype.constructor.name : "null prototype";
}
function $7879d292a118e15d$var$utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}
function $7879d292a118e15d$var$jsonSize(value) {
    return $7879d292a118e15d$var$utf8Length(JSON.stringify(value));
}
function $7879d292a118e15d$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath.replace(/\\/g, "/").replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (e) {}
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "").replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
function $7879d292a118e15d$var$memoBuilder() {
    const inner = /* @__PURE__ */ new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}


function $6c937b4b236937d4$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
function $6c937b4b236937d4$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $6c937b4b236937d4$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        if ((0, $85e272e760900bb9$export$c3825b437cbdea5c)(value)) output.push(String(value));
        else if (value instanceof Error) output.push(value.message ? `${value.name}: ${value.message}` : value.name);
        else output.push((0, $7879d292a118e15d$export$a110e5bc79f44a84)(void 0, value));
    }
    return output.join(delimiter);
}
function $6c937b4b236937d4$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $85e272e760900bb9$export$844ec244b1367d54)(value)) return false;
    if ((0, $85e272e760900bb9$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $85e272e760900bb9$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === "function") return pattern(value);
    return false;
}
function $6c937b4b236937d4$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    for (const pattern of patterns){
        if ($6c937b4b236937d4$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch)) return true;
    }
    return false;
}



function $df365b8ef5885c2b$var$getCrypto() {
    const gbl = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
let $df365b8ef5885c2b$var$emptyUuid;
function $df365b8ef5885c2b$var$getRandomByte() {
    return (0, $8aca1af6321ba44f$export$9869d72de32a3917)() * 16;
}
function $df365b8ef5885c2b$export$19f53698e68b2496(crypto = $df365b8ef5885c2b$var$getCrypto()) {
    try {
        if (crypto === null || crypto === void 0 ? void 0 : crypto.randomUUID) return (0, $8aca1af6321ba44f$export$ff239213cb80e2da)(()=>crypto.randomUUID()).replace(/-/g, "");
    } catch (e) {}
    if (!$df365b8ef5885c2b$var$emptyUuid) $df365b8ef5885c2b$var$emptyUuid = "10000000100040008000100000000000";
    return $df365b8ef5885c2b$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($df365b8ef5885c2b$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $df365b8ef5885c2b$var$getFirstException(event) {
    var _event_exception_values, _event_exception;
    return (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values[0];
}
function $df365b8ef5885c2b$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $df365b8ef5885c2b$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $df365b8ef5885c2b$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $df365b8ef5885c2b$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $df365b8ef5885c2b$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $9tqwB._)({}, defaultMechanism, currentMechanism, newMechanism);
    if (newMechanism && "data" in newMechanism) {
        const mergedData = (0, $9tqwB._)({}, currentMechanism === null || currentMechanism === void 0 ? void 0 : currentMechanism.data, newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
const $df365b8ef5885c2b$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $df365b8ef5885c2b$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
function $df365b8ef5885c2b$export$d364f2020ab30578(input) {
    const match = input.match($df365b8ef5885c2b$var$SEMVER_REGEXP) || [];
    const major = $df365b8ef5885c2b$var$_parseInt(match[1]);
    const minor = $df365b8ef5885c2b$var$_parseInt(match[2]);
    const patch = $df365b8ef5885c2b$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? void 0 : major,
        minor: isNaN(minor) ? void 0 : minor,
        patch: isNaN(patch) ? void 0 : patch,
        prerelease: match[4]
    };
}
function $df365b8ef5885c2b$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    if (frame.lineno === void 0) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $6c937b4b236937d4$export$4215662d762d6f9d)(line, 0));
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    frame.context_line = (0, $6c937b4b236937d4$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $6c937b4b236937d4$export$4215662d762d6f9d)(line, 0));
}
function $df365b8ef5885c2b$export$6de4ffac6a2f1098(exception) {
    if ($df365b8ef5885c2b$export$4a38e013f66150b(exception)) return true;
    try {
        (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (e) {}
    return false;
}
function $df365b8ef5885c2b$export$4a38e013f66150b(exception) {
    try {
        return exception.__sentry_captured__;
    } catch (e) {}
}



function $4ea28bfd5ee93486$export$14a186326edbb264(context) {
    const startingTime = (0, $b007b72e24b33b62$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $df365b8ef5885c2b$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$4ea28bfd5ee93486$var$sessionToJSON(session)
    };
    if (context) $4ea28bfd5ee93486$export$531818e825e774db(session, context);
    return session;
}
function $4ea28bfd5ee93486$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $b007b72e24b33b62$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) session.sid = context.sid.length === 32 ? context.sid : (0, $df365b8ef5885c2b$export$19f53698e68b2496)();
    if (context.init !== void 0) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = void 0;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
function $4ea28bfd5ee93486$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $4ea28bfd5ee93486$export$531818e825e774db(session, context);
}
function $4ea28bfd5ee93486$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1e3).toISOString(),
        timestamp: new Date(session.timestamp * 1e3).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : void 0,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}





var $9tqwB = parcelRequire("9tqwB");
function $6758701f8e924183$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    const output = (0, $9tqwB._)({}, initialObj);
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $6758701f8e924183$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}




function $f56fc4041ba3a369$export$dc6d7ea554bcce10() {
    return (0, $df365b8ef5885c2b$export$19f53698e68b2496)();
}
function $f56fc4041ba3a369$export$295213bc4d0c54ad() {
    return (0, $df365b8ef5885c2b$export$19f53698e68b2496)().substring(16);
}






const $88388f6b019104ff$var$DEFAULT_MAX_BREADCRUMBS = 100;
class $88388f6b019104ff$export$775b6bb06e53a214 {
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $88388f6b019104ff$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = (0, $9tqwB._)({}, this._tags);
        newScope._attributes = (0, $9tqwB._)({}, this._attributes);
        newScope._extra = (0, $9tqwB._)({}, this._extra);
        newScope._contexts = (0, $9tqwB._)({}, this._contexts);
        if (this._contexts.flags) newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = (0, $9tqwB._)({}, this._sdkProcessingMetadata);
        newScope._propagationContext = (0, $9tqwB._)({}, this._propagationContext);
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        (0, $9f9cfe5727c3ad26$export$3f25fa50c18e20ca)(newScope, (0, $9f9cfe5727c3ad26$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        this._user = user || {
            email: void 0,
            id: void 0,
            ip_address: void 0,
            username: void 0
        };
        if (this._session) (0, $4ea28bfd5ee93486$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || void 0;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = (0, $9tqwB._)({}, this._tags, tags);
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param newAttributes - The attributes to set on the scope, as key-value pairs.
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: 150,
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = (0, $9tqwB._)({}, this._attributes, newAttributes);
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param key - The attribute key.
   * @param value - The attribute value.
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', 150);
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = (0, $9tqwB._)({}, this._extra, extras);
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = (0, $2qxEV._)((0, $9tqwB._)({}, this._extra), {
            [key]: extra
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $88388f6b019104ff$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $85e272e760900bb9$export$53b83ca8eaab0383)(scopeToMerge) ? captureContext : void 0;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = (0, $9tqwB._)({}, this._tags, tags);
        this._attributes = (0, $9tqwB._)({}, this._attributes, attributes);
        this._extra = (0, $9tqwB._)({}, this._extra, extra);
        this._contexts = (0, $9tqwB._)({}, this._contexts, contexts);
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = void 0;
        this._transactionName = void 0;
        this._fingerprint = void 0;
        this._session = void 0;
        this._conversationId = void 0;
        (0, $9f9cfe5727c3ad26$export$3f25fa50c18e20ca)(this, void 0);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $f56fc4041ba3a369$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $8aca1af6321ba44f$export$9869d72de32a3917)()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $88388f6b019104ff$var$DEFAULT_MAX_BREADCRUMBS;
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = (0, $2qxEV._)((0, $9tqwB._)({
            timestamp: (0, $b007b72e24b33b62$export$7740643b9eeaf0c4)()
        }, breadcrumb), {
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $6c937b4b236937d4$export$6a506b36fdea397d)(breadcrumb.message, 2048) : breadcrumb.message
        });
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            var _this__client;
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            (_this__client = this._client) === null || _this__client === void 0 ? void 0 : _this__client.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $9f9cfe5727c3ad26$export$91f063ebb8eff307)(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $6758701f8e924183$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = (hint === null || hint === void 0 ? void 0 : hint.event_id) || (0, $df365b8ef5885c2b$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, (0, $2qxEV._)((0, $9tqwB._)({
            originalException: exception,
            syntheticException: syntheticException
        }, hint), {
            event_id: eventId
        }), this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = (hint === null || hint === void 0 ? void 0 : hint.event_id) || (0, $df365b8ef5885c2b$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        var _hint_syntheticException;
        const syntheticException = (_hint_syntheticException = hint === null || hint === void 0 ? void 0 : hint.syntheticException) !== null && _hint_syntheticException !== void 0 ? _hint_syntheticException : new Error(message);
        this._client.captureMessage(message, level, (0, $2qxEV._)((0, $9tqwB._)({
            originalException: message,
            syntheticException: syntheticException
        }, hint), {
            event_id: eventId
        }), this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || (hint === null || hint === void 0 ? void 0 : hint.event_id) || (0, $df365b8ef5885c2b$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, (0, $2qxEV._)((0, $9tqwB._)({}, hint), {
            event_id: eventId
        }), this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
    // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $f56fc4041ba3a369$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $8aca1af6321ba44f$export$9869d72de32a3917)()
        };
    }
}


function $303b3b8942f870bd$export$6f1b9191db9c4d5() {
    return (0, $3d29ea41beb10247$export$7e223ec222791509)("defaultCurrentScope", ()=>new (0, $88388f6b019104ff$export$775b6bb06e53a214)());
}
function $303b3b8942f870bd$export$de9862929b76bf57() {
    return (0, $3d29ea41beb10247$export$7e223ec222791509)("defaultIsolationScope", ()=>new (0, $88388f6b019104ff$export$775b6bb06e53a214)());
}



const $7a8fa26b5d72274f$var$isActualPromise = (p)=>p instanceof Promise && !p[$7a8fa26b5d72274f$var$kChainedCopy];
const $7a8fa26b5d72274f$var$kChainedCopy = /* @__PURE__ */ Symbol("chained PromiseLike");
const $7a8fa26b5d72274f$export$64da0f40b0f924ba = (original, onSuccess, onError)=>{
    const chained = original.then((value)=>{
        onSuccess(value);
        return value;
    }, (err)=>{
        onError(err);
        throw err;
    });
    return $7a8fa26b5d72274f$var$isActualPromise(chained) && $7a8fa26b5d72274f$var$isActualPromise(original) ? chained : $7a8fa26b5d72274f$var$copyProps(original, chained);
};
const $7a8fa26b5d72274f$var$copyProps = (original, chained)=>{
    if (!chained) return original;
    let mutated = false;
    for(const key in original){
        if (key in chained) continue;
        mutated = true;
        const value = original[key];
        if (typeof value === "function") Object.defineProperty(chained, key, {
            value: (...args)=>value.apply(original, args),
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    }
    if (mutated) Object.assign(chained, {
        [$7a8fa26b5d72274f$var$kChainedCopy]: true
    });
    return chained;
};




class $349a8e27b595687d$export$d36ec451f120cfba {
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $85e272e760900bb9$export$f5b060c2914b97c8)(maybePromiseResult)) return (0, $7a8fa26b5d72274f$export$64da0f40b0f924ba)(maybePromiseResult, ()=>this._popScope(), ()=>this._popScope());
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $88388f6b019104ff$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $88388f6b019104ff$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
}
function $349a8e27b595687d$var$getAsyncContextStack() {
    const registry = (0, $3d29ea41beb10247$export$19eade501500c6c1)();
    const sentry = (0, $3d29ea41beb10247$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $349a8e27b595687d$export$d36ec451f120cfba((0, $303b3b8942f870bd$export$6f1b9191db9c4d5)(), (0, $303b3b8942f870bd$export$de9862929b76bf57)());
}
function $349a8e27b595687d$var$withScope(callback) {
    return $349a8e27b595687d$var$getAsyncContextStack().withScope(callback);
}
function $349a8e27b595687d$var$withSetScope(scope, callback) {
    const stack = $349a8e27b595687d$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $349a8e27b595687d$var$withIsolationScope(callback) {
    return $349a8e27b595687d$var$getAsyncContextStack().withScope(()=>{
        return callback($349a8e27b595687d$var$getAsyncContextStack().getIsolationScope());
    });
}
function $349a8e27b595687d$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $349a8e27b595687d$var$withIsolationScope,
        withScope: $349a8e27b595687d$var$withScope,
        withSetScope: $349a8e27b595687d$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $349a8e27b595687d$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$349a8e27b595687d$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$349a8e27b595687d$var$getAsyncContextStack().getIsolationScope()
    };
}


function $e26a4b07a4ad38af$export$774ae0e6b6e444ca(strategy) {
    const registry = (0, $3d29ea41beb10247$export$19eade501500c6c1)();
    const sentry = (0, $3d29ea41beb10247$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
function $e26a4b07a4ad38af$export$f639b0c2752203be(carrier) {
    const sentry = (0, $3d29ea41beb10247$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    return (0, $349a8e27b595687d$export$329d4d4d54e42710)();
}
function $e26a4b07a4ad38af$export$adc7055cab43e3ca() {
    var _getAsyncContextStrategy_getTracingChannelBinding, _getAsyncContextStrategy;
    return (_getAsyncContextStrategy_getTracingChannelBinding = (_getAsyncContextStrategy = $e26a4b07a4ad38af$export$f639b0c2752203be((0, $3d29ea41beb10247$export$19eade501500c6c1)())).getTracingChannelBinding) === null || _getAsyncContextStrategy_getTracingChannelBinding === void 0 ? void 0 : _getAsyncContextStrategy_getTracingChannelBinding.call(_getAsyncContextStrategy);
}
function $e26a4b07a4ad38af$export$9f8f4d5fa4eb1c48(asyncLocalStorage, getScopes) {
    return {
        asyncLocalStorage: asyncLocalStorage,
        getStoreWithActiveSpan: (span)=>{
            const { scope: scope, isolationScope: isolationScope } = getScopes();
            const activeScope = scope.clone();
            (0, $9f9cfe5727c3ad26$export$3f25fa50c18e20ca)(activeScope, span);
            return {
                scope: activeScope,
                isolationScope: isolationScope
            };
        }
    };
}



var $9tqwB = parcelRequire("9tqwB");

function $b466939a0d6f1536$export$f5706f332d297c38(maybeObj) {
    return typeof maybeObj === "object" && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes("value");
}
function $b466939a0d6f1536$export$f18f8779fed6dfa(rawValue, useFallback) {
    const { value: value, unit: unit } = $b466939a0d6f1536$export$f5706f332d297c38(rawValue) ? rawValue : {
        value: rawValue,
        unit: void 0
    };
    const attributeValue = $b466939a0d6f1536$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === "string" ? {
        unit: unit
    } : {};
    if (attributeValue) return (0, $9tqwB._)({}, attributeValue, checkedUnit);
    if (!useFallback || useFallback === "skip-undefined" && value === void 0) return;
    let stringValue = "";
    try {
        var _JSON_stringify;
        stringValue = (_JSON_stringify = JSON.stringify(value)) !== null && _JSON_stringify !== void 0 ? _JSON_stringify : "";
    } catch (e) {}
    return (0, $9tqwB._)({
        value: stringValue,
        type: "string"
    }, checkedUnit);
}
function $b466939a0d6f1536$export$4954cae66e755861(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes !== null && attributes !== void 0 ? attributes : {})){
        const typedValue = $b466939a0d6f1536$export$f18f8779fed6dfa(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
function $b466939a0d6f1536$export$97341f7cd97c59f(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    for (const [key, attr] of Object.entries(attributes)){
        var _attr_unit;
        weight += key.length * 2;
        weight += attr.type.length * 2;
        var _attr_unit_length;
        weight += ((_attr_unit_length = (_attr_unit = attr.unit) === null || _attr_unit === void 0 ? void 0 : _attr_unit.length) !== null && _attr_unit_length !== void 0 ? _attr_unit_length : 0) * 2;
        const val = attr.value;
        if (Array.isArray(val)) weight += $b466939a0d6f1536$var$estimatePrimitiveSizeInBytes(val[0]) * val.length;
        else if ((0, $85e272e760900bb9$export$c3825b437cbdea5c)(val)) weight += $b466939a0d6f1536$var$estimatePrimitiveSizeInBytes(val);
        else weight += 100;
    }
    return weight;
}
function $b466939a0d6f1536$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "boolean") return 4;
    else if (typeof value === "number") return 8;
    return 0;
}
function $b466939a0d6f1536$var$getTypedAttributeValue(value) {
    if (Array.isArray(value)) return {
        value: value,
        type: "array"
    };
    const primitiveType = typeof value === "string" ? "string" : typeof value === "boolean" ? "boolean" : typeof value === "number" && !Number.isNaN(value) ? Number.isInteger(value) ? "integer" : "double" : null;
    if (primitiveType) return {
        value: value,
        type: primitiveType
    };
}







let $6486f3d311605b78$var$_externalPropagationContextProvider;
function $6486f3d311605b78$export$b5defb3466e9689b(fn) {
    $6486f3d311605b78$var$_externalPropagationContextProvider = fn;
}
function $6486f3d311605b78$export$92547f779c920a71() {
    return $6486f3d311605b78$var$_externalPropagationContextProvider === null || $6486f3d311605b78$var$_externalPropagationContextProvider === void 0 ? void 0 : $6486f3d311605b78$var$_externalPropagationContextProvider();
}
function $6486f3d311605b78$export$53f0ae651a1c4298() {
    return $6486f3d311605b78$var$_externalPropagationContextProvider !== void 0;
}
function $6486f3d311605b78$export$c7be4b0125a10cba() {
    const carrier = (0, $3d29ea41beb10247$export$19eade501500c6c1)();
    const acs = (0, $e26a4b07a4ad38af$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
function $6486f3d311605b78$export$68f3af03034c9e90() {
    const carrier = (0, $3d29ea41beb10247$export$19eade501500c6c1)();
    const acs = (0, $e26a4b07a4ad38af$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
function $6486f3d311605b78$export$aa55d5ab8e05984f() {
    return (0, $3d29ea41beb10247$export$7e223ec222791509)("globalScope", ()=>new (0, $88388f6b019104ff$export$775b6bb06e53a214)());
}
function $6486f3d311605b78$export$ec58d9285c204497(...rest) {
    const carrier = (0, $3d29ea41beb10247$export$19eade501500c6c1)();
    const acs = (0, $e26a4b07a4ad38af$export$f639b0c2752203be)(carrier);
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
function $6486f3d311605b78$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $3d29ea41beb10247$export$19eade501500c6c1)();
    const acs = (0, $e26a4b07a4ad38af$export$f639b0c2752203be)(carrier);
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
function $6486f3d311605b78$export$6bb76d6eba7e258c() {
    return $6486f3d311605b78$export$c7be4b0125a10cba().getClient();
}
function $6486f3d311605b78$export$1e83db7ee4876dc4(scope) {
    const externalContext = $6486f3d311605b78$export$92547f779c920a71();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $f56fc4041ba3a369$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}


const $fdf17a1e56d9d4ca$export$d7a7d984b0791405 = "sentry.source";
const $fdf17a1e56d9d4ca$export$ccfe0a40627cc34b = "sentry.sample_rate";
const $fdf17a1e56d9d4ca$export$889fb736668e1ecc = "sentry.previous_trace_sample_rate";
const $fdf17a1e56d9d4ca$export$1a413bd9a88fdb09 = "sentry.op";
const $fdf17a1e56d9d4ca$export$cca8dd30f57f805e = "sentry.origin";
const $fdf17a1e56d9d4ca$export$ba73f34502b7a3b3 = "sentry.idle_span_finish_reason";
const $fdf17a1e56d9d4ca$export$f5f95cff026507b5 = "sentry.measurement_unit";
const $fdf17a1e56d9d4ca$export$69cd5c610c7bb96a = "sentry.measurement_value";
const $fdf17a1e56d9d4ca$export$f5cefb258679b29e = "sentry.release";
const $fdf17a1e56d9d4ca$export$d1b1dbb47f5ba57c = "sentry.environment";
const $fdf17a1e56d9d4ca$export$4626f2be16112c1c = "sentry.segment.name";
const $fdf17a1e56d9d4ca$export$25fa4a1832d3736a = "sentry.segment.id";
const $fdf17a1e56d9d4ca$export$87a4807042e1f1bb = "sentry.sdk.name";
const $fdf17a1e56d9d4ca$export$301ebe936458e291 = "sentry.sdk.version";
const $fdf17a1e56d9d4ca$export$bd847b1cc92ae587 = "sentry.sdk.integrations";
const $fdf17a1e56d9d4ca$export$1f9cc1d34ea098a0 = "user.id";
const $fdf17a1e56d9d4ca$export$b7466609ef46c07e = "user.email";
const $fdf17a1e56d9d4ca$export$8d592bdaea63b930 = "user.ip_address";
const $fdf17a1e56d9d4ca$export$c05ee933d3f74b2b = "user.name";
const $fdf17a1e56d9d4ca$export$165ce9a229f6f050 = "sentry.custom_span_name";
const $fdf17a1e56d9d4ca$export$1efec95406bbe327 = "sentry.profile_id";
const $fdf17a1e56d9d4ca$export$fea48ba9f4550879 = "sentry.exclusive_time";
const $fdf17a1e56d9d4ca$export$b016f89ac1066ec = "cache.hit";
const $fdf17a1e56d9d4ca$export$3110e4c3f4386399 = "cache.key";
const $fdf17a1e56d9d4ca$export$86be76deee227ff2 = "cache.item_size";
const $fdf17a1e56d9d4ca$export$be7a251980e7e946 = "http.request.method";
const $fdf17a1e56d9d4ca$export$25dfd73e0e32c6e1 = "url.full";
const $fdf17a1e56d9d4ca$export$ff77b5fd5b2d627b = "sentry.link.type";
const $fdf17a1e56d9d4ca$export$71a4a707257f2774 = "gen_ai.conversation.id";


const $f217ebe7a0a6fc3c$export$136e25984ba4a383 = 0;
const $f217ebe7a0a6fc3c$export$58f7963109c806fc = 1;
const $f217ebe7a0a6fc3c$export$f966a0446ece71e = 2;
function $f217ebe7a0a6fc3c$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $f217ebe7a0a6fc3c$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: "not_found"
            };
        case 409:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: "already_exists"
            };
        case 413:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: "cancelled"
            };
        default:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: "unavailable"
            };
        case 504:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: "internal_error"
            };
    }
    return {
        code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
        message: "internal_error"
    };
}
function $f217ebe7a0a6fc3c$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $f217ebe7a0a6fc3c$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}




const $f7bbc910493e6179$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $f7bbc910493e6179$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
const $f7bbc910493e6179$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceInference");
function $f7bbc910493e6179$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(span, $f7bbc910493e6179$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, (0, $dff99a7a1f7c3087$export$f0b98edec95fcb33)(isolationScope));
        (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(span, $f7bbc910493e6179$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
function $f7bbc910493e6179$export$c08fbc656a245d03(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$f7bbc910493e6179$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: (0, $dff99a7a1f7c3087$export$a0592ad8c3586cf)(spanWithScopes[$f7bbc910493e6179$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}
function $f7bbc910493e6179$export$d135494e80cbbcae(span) {
    (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(span, $f7bbc910493e6179$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD, true);
}
function $f7bbc910493e6179$export$2e69b79005fc86eb(span) {
    return span[$f7bbc910493e6179$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD] === true;
}









const $4d0fefb7946dcfa7$export$6e69537d67fa20f = "sentry-";
const $4d0fefb7946dcfa7$export$eb0401070c617ea5 = /^sentry-/;
const $4d0fefb7946dcfa7$export$bdd844ddb2def819 = 8192;
function $4d0fefb7946dcfa7$export$5b96ee2c8421f107(baggageHeader) {
    const baggageObject = $4d0fefb7946dcfa7$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return void 0;
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith($4d0fefb7946dcfa7$export$6e69537d67fa20f)) {
            const nonPrefixedKey = key.slice($4d0fefb7946dcfa7$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return void 0;
}
function $4d0fefb7946dcfa7$export$56766feef403f365(dynamicSamplingContext) {
    if (!dynamicSamplingContext) return void 0;
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$4d0fefb7946dcfa7$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $4d0fefb7946dcfa7$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
function $4d0fefb7946dcfa7$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $85e272e760900bb9$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return void 0;
    if (Array.isArray(baggageHeader)) return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $4d0fefb7946dcfa7$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $4d0fefb7946dcfa7$var$baggageHeaderToObject(baggageHeader);
}
function $4d0fefb7946dcfa7$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf("=");
        if (eqIdx === -1) return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch (e) {
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
function $4d0fefb7946dcfa7$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) return void 0;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $4d0fefb7946dcfa7$export$bdd844ddb2def819) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}
function $4d0fefb7946dcfa7$export$7b8640b7baaa3922(existing, incoming) {
    if (!existing) return incoming;
    const existingEntries = $4d0fefb7946dcfa7$export$397de414d189db00(existing);
    const incomingEntries = $4d0fefb7946dcfa7$export$397de414d189db00(incoming);
    if (!incomingEntries) return existing;
    const merged = {};
    let hasNewSentryEntries = false;
    const newSentryEntries = {};
    const newNonSentryEntries = {};
    for (const [key, value] of Object.entries(incomingEntries))if (key.startsWith($4d0fefb7946dcfa7$export$6e69537d67fa20f)) {
        newSentryEntries[key] = value;
        hasNewSentryEntries = true;
    } else newNonSentryEntries[key] = value;
    if (existingEntries) {
        for (const [key, value] of Object.entries(existingEntries))if (!hasNewSentryEntries || !key.startsWith($4d0fefb7946dcfa7$export$6e69537d67fa20f)) merged[key] = value;
    }
    if (hasNewSentryEntries) Object.assign(merged, newSentryEntries);
    var _merged_key;
    for (const [key, value] of Object.entries(newNonSentryEntries))(_merged_key = merged[key]) !== null && _merged_key !== void 0 ? _merged_key : merged[key] = value;
    return $4d0fefb7946dcfa7$export$12a7349a29a6e3c2(merged);
}




const $94fe38c0afc4d11c$var$ORG_ID_REGEX = /^o(\d+)\./;
const $94fe38c0afc4d11c$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $94fe38c0afc4d11c$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
function $94fe38c0afc4d11c$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
function $94fe38c0afc4d11c$export$b892860177f70a30(str) {
    const match = $94fe38c0afc4d11c$var$DSN_REGEX.exec(str);
    if (!match) {
        (0, $d8898b8567c29ee9$export$cda52e2a8927a2ca)(()=>{
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return void 0;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $94fe38c0afc4d11c$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $94fe38c0afc4d11c$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $94fe38c0afc4d11c$var$validateDsn(dsn) {
    if (!(0, $37b03cd1fa6d4fb8$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $d8898b8567c29ee9$export$1c9f709888824e05).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $d8898b8567c29ee9$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$94fe38c0afc4d11c$var$isValidProtocol(protocol)) {
        (0, $d8898b8567c29ee9$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $d8898b8567c29ee9$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
function $94fe38c0afc4d11c$export$5914f4e7748c29c9(host) {
    const match = host.match($94fe38c0afc4d11c$var$ORG_ID_REGEX);
    return match === null || match === void 0 ? void 0 : match[1];
}
function $94fe38c0afc4d11c$export$b7ac9b8efa4bb595(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $94fe38c0afc4d11c$export$5914f4e7748c29c9(host);
    return org_id;
}
function $94fe38c0afc4d11c$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $94fe38c0afc4d11c$export$b892860177f70a30(from) : $94fe38c0afc4d11c$var$dsnFromComponents(from);
    if (!components || !$94fe38c0afc4d11c$var$validateDsn(components)) return void 0;
    return components;
}


function $ab7c7053b878f035$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return void 0;
    return rate;
}




const $ae017cc8b57317cd$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
function $ae017cc8b57317cd$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return void 0;
    const matches = traceparent.match($ae017cc8b57317cd$export$394a210812ba3012);
    if (!matches) return void 0;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
function $ae017cc8b57317cd$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $ae017cc8b57317cd$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $4d0fefb7946dcfa7$export$5b96ee2c8421f107)(baggage);
    if (!(traceparentData === null || traceparentData === void 0 ? void 0 : traceparentData.traceId)) return {
        traceId: (0, $f56fc4041ba3a369$export$dc6d7ea554bcce10)(),
        sampleRand: (0, $8aca1af6321ba44f$export$9869d72de32a3917)()
    };
    const sampleRand = $ae017cc8b57317cd$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
        sampleRand
    };
}
function $ae017cc8b57317cd$export$f35d907436da45cf(traceId = (0, $f56fc4041ba3a369$export$dc6d7ea554bcce10)(), spanId = (0, $f56fc4041ba3a369$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = "";
    if (sampled !== void 0) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
function $ae017cc8b57317cd$export$1aff3752542747dd(traceId = (0, $f56fc4041ba3a369$export$dc6d7ea554bcce10)(), spanId = (0, $f56fc4041ba3a369$export$295213bc4d0c54ad)(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? "01" : "00"}`;
}
function $ae017cc8b57317cd$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    const parsedSampleRand = (0, $ab7c7053b878f035$export$a5bd2d81656d9546)(dsc === null || dsc === void 0 ? void 0 : dsc.sample_rand);
    if (parsedSampleRand !== void 0) return parsedSampleRand;
    const parsedSampleRate = (0, $ab7c7053b878f035$export$a5bd2d81656d9546)(dsc === null || dsc === void 0 ? void 0 : dsc.sample_rate);
    if (parsedSampleRate && (traceparentData === null || traceparentData === void 0 ? void 0 : traceparentData.parentSampled) !== void 0) return traceparentData.parentSampled ? // Returns a sample rand with positive sampling decision [0, sampleRate)
    (0, $8aca1af6321ba44f$export$9869d72de32a3917)() * parsedSampleRate : // Returns a sample rand with negative sampling decision [sampleRate, 1)
    parsedSampleRate + (0, $8aca1af6321ba44f$export$9869d72de32a3917)() * (1 - parsedSampleRate);
    else return (0, $8aca1af6321ba44f$export$9869d72de32a3917)();
}
function $ae017cc8b57317cd$export$18811bc99eefceaa(client, baggageOrgId) {
    const clientOrgId = (0, $94fe38c0afc4d11c$export$b7ac9b8efa4bb595)(client);
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false;
    if (strictTraceContinuation) {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}




const $cac16f6eada858e7$export$208d5b368507fb8b = 0;
const $cac16f6eada858e7$export$eb571cd9b5d98de8 = 1;
let $cac16f6eada858e7$var$hasShownSpanDropWarning = false;
function $cac16f6eada858e7$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $cac16f6eada858e7$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
function $cac16f6eada858e7$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    const parent_span_id = isRemote ? spanId : $cac16f6eada858e7$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $f7bbc910493e6179$export$c08fbc656a245d03)(span).scope;
    const span_id = isRemote ? (scope === null || scope === void 0 ? void 0 : scope.getPropagationContext().propagationSpanId) || (0, $f56fc4041ba3a369$export$295213bc4d0c54ad)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
function $cac16f6eada858e7$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $cac16f6eada858e7$export$5caecac1caaf3a71(span);
    return (0, $ae017cc8b57317cd$export$f35d907436da45cf)(traceId, spanId, sampled);
}
function $cac16f6eada858e7$export$cda58d87bc594e9f(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $cac16f6eada858e7$export$5caecac1caaf3a71(span);
    return (0, $ae017cc8b57317cd$export$1aff3752542747dd)(traceId, spanId, sampled);
}
function $cac16f6eada858e7$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map((_param)=>{
        var { context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes } = _param, restContext = (0, $bLhVg._)(_param.context, [
            "spanId",
            "traceId",
            "traceFlags"
        ]);
        return (0, $9tqwB._)({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $cac16f6eada858e7$export$eb571cd9b5d98de8,
            attributes: attributes
        }, restContext);
    });
    else return void 0;
}
function $cac16f6eada858e7$export$9015adcf158ef3a5(links) {
    if (links === null || links === void 0 ? void 0 : links.length) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $cac16f6eada858e7$export$eb571cd9b5d98de8,
            attributes: attributes
        }));
    else return void 0;
}
function $cac16f6eada858e7$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $cac16f6eada858e7$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $cac16f6eada858e7$var$ensureTimestampInSeconds(input.getTime());
    return (0, $b007b72e24b33b62$export$ee52dced521e3e18)();
}
function $cac16f6eada858e7$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1e3 : timestamp;
}
function $cac16f6eada858e7$export$92d8c23565496537(span) {
    if ($cac16f6eada858e7$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($cac16f6eada858e7$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: $cac16f6eada858e7$var$getOtelParentSpanId(span),
            start_timestamp: $cac16f6eada858e7$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $cac16f6eada858e7$export$3f7581298f56c6d7(endTime) || void 0,
            status: $cac16f6eada858e7$export$e238a77ea3a8cd66(status),
            op: attributes[0, $fdf17a1e56d9d4ca$export$1a413bd9a88fdb09],
            origin: attributes[0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e],
            links: $cac16f6eada858e7$export$cb3e3a12e0eec16c(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $cac16f6eada858e7$export$db0cad9e44f67af8(span) {
    if ($cac16f6eada858e7$var$spanIsSentrySpan(span)) return span.getStreamedSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($cac16f6eada858e7$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            name: name,
            span_id: span_id,
            trace_id: trace_id,
            parent_span_id: $cac16f6eada858e7$var$getOtelParentSpanId(span),
            start_timestamp: $cac16f6eada858e7$export$3f7581298f56c6d7(startTime),
            end_timestamp: $cac16f6eada858e7$export$3f7581298f56c6d7(endTime),
            is_segment: span === $cac16f6eada858e7$export$7a3106f345d83bb6(span),
            status: $cac16f6eada858e7$export$457dcd3df4e9f5c6(status),
            attributes: attributes,
            links: $cac16f6eada858e7$export$9015adcf158ef3a5(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        name: "",
        end_timestamp: 0,
        status: "ok",
        is_segment: span === $cac16f6eada858e7$export$7a3106f345d83bb6(span)
    };
}
function $cac16f6eada858e7$var$getOtelParentSpanId(span) {
    var _span_parentSpanContext;
    return "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? (_span_parentSpanContext = span.parentSpanContext) === null || _span_parentSpanContext === void 0 ? void 0 : _span_parentSpanContext.spanId : void 0;
}
function $cac16f6eada858e7$export$5402aa553bcf35f3(spanJson) {
    var _spanJson_links;
    return (0, $2qxEV._)((0, $9tqwB._)({}, spanJson), {
        attributes: (0, $b466939a0d6f1536$export$4954cae66e755861)(spanJson.attributes),
        links: (_spanJson_links = spanJson.links) === null || _spanJson_links === void 0 ? void 0 : _spanJson_links.map((link)=>(0, $2qxEV._)((0, $9tqwB._)({}, link), {
                attributes: (0, $b466939a0d6f1536$export$4954cae66e755861)(link.attributes)
            }))
    });
}
function $cac16f6eada858e7$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
function $cac16f6eada858e7$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
function $cac16f6eada858e7$export$5caecac1caaf3a71(span) {
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $cac16f6eada858e7$export$eb571cd9b5d98de8;
}
function $cac16f6eada858e7$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $f217ebe7a0a6fc3c$export$136e25984ba4a383)) return void 0;
    if (status.code === (0, $f217ebe7a0a6fc3c$export$58f7963109c806fc)) return "ok";
    return status.message || "internal_error";
}
function $cac16f6eada858e7$export$457dcd3df4e9f5c6(status) {
    return !status || status.code === (0, $f217ebe7a0a6fc3c$export$58f7963109c806fc) || status.code === (0, $f217ebe7a0a6fc3c$export$136e25984ba4a383) || status.message === "cancelled" ? "ok" : "error";
}
const $cac16f6eada858e7$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $cac16f6eada858e7$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
function $cac16f6eada858e7$export$81397d924722cc65(span, childSpan) {
    const rootSpan = span[$cac16f6eada858e7$var$ROOT_SPAN_FIELD] || span;
    (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(childSpan, $cac16f6eada858e7$var$ROOT_SPAN_FIELD, rootSpan);
    if (span[$cac16f6eada858e7$var$CHILD_SPANS_FIELD]) span[$cac16f6eada858e7$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(span, $cac16f6eada858e7$var$CHILD_SPANS_FIELD, /* @__PURE__ */ new Set([
        childSpan
    ]));
}
function $cac16f6eada858e7$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$cac16f6eada858e7$var$CHILD_SPANS_FIELD]) span[$cac16f6eada858e7$var$CHILD_SPANS_FIELD].delete(childSpan);
}
function $cac16f6eada858e7$export$340c5c8a13ffc680(span) {
    const resultSet = /* @__PURE__ */ new Set();
    function addSpanChildren(span2) {
        if (resultSet.has(span2)) return;
        else if ($cac16f6eada858e7$export$5caecac1caaf3a71(span2)) {
            resultSet.add(span2);
            const childSpans = span2[$cac16f6eada858e7$var$CHILD_SPANS_FIELD] ? Array.from(span2[$cac16f6eada858e7$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
const $cac16f6eada858e7$export$c4c6a79b1260ca1b = $cac16f6eada858e7$export$7a3106f345d83bb6;
function $cac16f6eada858e7$export$7a3106f345d83bb6(span) {
    return span[$cac16f6eada858e7$var$ROOT_SPAN_FIELD] || span;
}
function $cac16f6eada858e7$export$1be426a8e585c83e() {
    const carrier = (0, $3d29ea41beb10247$export$19eade501500c6c1)();
    const acs = (0, $e26a4b07a4ad38af$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $9f9cfe5727c3ad26$export$91f063ebb8eff307)((0, $6486f3d311605b78$export$c7be4b0125a10cba)());
}
function $cac16f6eada858e7$export$d11691ff45a3e535() {
    if (!$cac16f6eada858e7$var$hasShownSpanDropWarning) {
        (0, $d8898b8567c29ee9$export$cda52e2a8927a2ca)(()=>{
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.");
        });
        $cac16f6eada858e7$var$hasShownSpanDropWarning = true;
    }
}
function $cac16f6eada858e7$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405)]: "custom",
        [(0, $fdf17a1e56d9d4ca$export$165ce9a229f6f050)]: name
    });
}



const $0ff4a1c827ec052f$var$WINDOW = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1);
const $0ff4a1c827ec052f$var$DEFAULT_MAX_STRING_LENGTH = 80;
function $0ff4a1c827ec052f$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $0ff4a1c827ec052f$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $0ff4a1c827ec052f$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (e) {
        return "<unknown>";
    }
}
function $0ff4a1c827ec052f$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!(elem === null || elem === void 0 ? void 0 : elem.tagName)) return "";
    if ($0ff4a1c827ec052f$var$WINDOW.HTMLElement) {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    const keyAttrPairs = (keyAttrs === null || keyAttrs === void 0 ? void 0 : keyAttrs.length) ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs === null || keyAttrPairs === void 0 ? void 0 : keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $85e272e760900bb9$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
function $0ff4a1c827ec052f$export$1cfafeee2987818b() {
    try {
        return $0ff4a1c827ec052f$var$WINDOW.document.location.href;
    } catch (e) {
        return "";
    }
}
function $0ff4a1c827ec052f$export$26727cfcc4d7e0fc(elem, maxTraverseHeight = 5) {
    if (!$0ff4a1c827ec052f$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    for(let i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}


const $e3f8d2d1d7c51bd6$var$DEFAULT_BASE_URL = "thismessage:/";
function $e3f8d2d1d7c51bd6$export$e258e13805402ba7(url) {
    return "isRelative" in url;
}
function $e3f8d2d1d7c51bd6$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.indexOf("://") <= 0 && url.indexOf("//") !== 0;
    const base = urlBase !== null && urlBase !== void 0 ? urlBase : isRelative ? $e3f8d2d1d7c51bd6$var$DEFAULT_BASE_URL : void 0;
    try {
        if ("canParse" in URL && !URL.canParse(url, base)) return void 0;
        const fullUrlObject = new URL(url, base);
        if (isRelative) return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch (e) {}
    return void 0;
}
function $e3f8d2d1d7c51bd6$export$5339fcdc8e2a427c(url) {
    if ($e3f8d2d1d7c51bd6$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = "";
    newUrl.hash = "";
    if ([
        "80",
        "443"
    ].includes(newUrl.port)) newUrl.port = "";
    if (newUrl.password) newUrl.password = "%filtered%";
    if (newUrl.username) newUrl.username = "%filtered%";
    return newUrl.toString();
}
function $e3f8d2d1d7c51bd6$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    var _request_method;
    var _request_method_toUpperCase;
    const method = (_request_method_toUpperCase = request === null || request === void 0 ? void 0 : (_request_method = request.method) === null || _request_method === void 0 ? void 0 : _request_method.toUpperCase()) !== null && _request_method_toUpperCase !== void 0 ? _request_method_toUpperCase : "GET";
    const route = routeName ? routeName : urlObject ? kind === "client" ? $e3f8d2d1d7c51bd6$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : "/";
    return `${method} ${route}`;
}
function $e3f8d2d1d7c51bd6$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: spanOrigin,
        [(0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405)]: "url"
    };
    if (routeName) {
        attributes[kind === "server" ? "http.route" : "url.template"] = routeName;
        attributes[0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405] = "route";
    }
    if (request === null || request === void 0 ? void 0 : request.method) attributes[0, $fdf17a1e56d9d4ca$export$be7a251980e7e946] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes["url.query"] = urlObject.search;
        if (urlObject.hash) attributes["url.fragment"] = urlObject.hash;
        if (urlObject.pathname) {
            attributes["url.path"] = urlObject.pathname;
            if (urlObject.pathname === "/") attributes[0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405] = "route";
        }
        if (!$e3f8d2d1d7c51bd6$export$e258e13805402ba7(urlObject)) {
            attributes[0, $fdf17a1e56d9d4ca$export$25dfd73e0e32c6e1] = urlObject.href;
            if (urlObject.port) attributes["url.port"] = urlObject.port;
            if (urlObject.protocol) attributes["url.scheme"] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === "server" ? "server.address" : "url.domain"] = urlObject.hostname;
        }
    }
    return [
        $e3f8d2d1d7c51bd6$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
function $e3f8d2d1d7c51bd6$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
function $e3f8d2d1d7c51bd6$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
function $e3f8d2d1d7c51bd6$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = (host === null || host === void 0 ? void 0 : host.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "")) || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}
function $e3f8d2d1d7c51bd6$export$8abd806fcaf234fa(url, includeDataPrefix = true) {
    if (url.startsWith("data:")) {
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : "text/plain";
        const isBase64 = url.includes(";base64,");
        const dataStart = url.indexOf(",");
        let dataPrefix = "";
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ",base64" : ""}${dataPrefix ? `,${dataPrefix}` : ""}`;
    }
    return url;
}





function $293a838d63649350$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $cac16f6eada858e7$export$1be426a8e585c83e)()) {
    const rootSpan = activeSpan && (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $fdf17a1e56d9d4ca$export$69cd5c610c7bb96a)]: value,
            [(0, $fdf17a1e56d9d4ca$export$f5f95cff026507b5)]: unit
        });
    }
}
function $293a838d63649350$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return void 0;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $fdf17a1e56d9d4ca$export$f5f95cff026507b5];
        const value = attributes[0, $fdf17a1e56d9d4ca$export$69cd5c610c7bb96a];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}



const $d6cf245db051044b$var$DEFAULT_MAX_STRING_LENGTH = 80;
const $d6cf245db051044b$var$accessors = {};
try {
    if (typeof Node !== "undefined") $d6cf245db051044b$var$accessors.parentNode = Object.getOwnPropertyDescriptor(Node.prototype, "parentNode").get;
    if (typeof Element !== "undefined") {
        $d6cf245db051044b$var$accessors.tagName = Object.getOwnPropertyDescriptor(Element.prototype, "tagName").get;
        $d6cf245db051044b$var$accessors.id = Object.getOwnPropertyDescriptor(Element.prototype, "id").get;
        $d6cf245db051044b$var$accessors.className = Object.getOwnPropertyDescriptor(Element.prototype, "className").get;
        $d6cf245db051044b$var$accessors.getAttribute = Element.prototype.getAttribute;
    }
    if (typeof HTMLElement !== "undefined") $d6cf245db051044b$var$accessors.dataset = Object.getOwnPropertyDescriptor(HTMLElement.prototype, "dataset").get;
} catch (e) {}
function $d6cf245db051044b$var$_safeRead(el, prop, arg) {
    const fn = $d6cf245db051044b$var$accessors[prop];
    if (fn) try {
        return fn.call(el, arg);
    } catch (e) {}
    const val = el[prop];
    return typeof val === "function" ? val.call(el, arg) : val;
}
function $d6cf245db051044b$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $d6cf245db051044b$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $d6cf245db051044b$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = $d6cf245db051044b$var$_safeRead(currentElem, "parentNode");
        }
        return out.reverse().join(separator);
    } catch (e) {
        return "<unknown>";
    }
}
function $d6cf245db051044b$var$_htmlElementAsString(el, keyAttrs) {
    const out = [];
    const tagName = $d6cf245db051044b$var$_safeRead(el, "tagName");
    if (!tagName) return "";
    if (typeof HTMLElement !== "undefined") {
        if (el instanceof HTMLElement) {
            const dataset = $d6cf245db051044b$var$_safeRead(el, "dataset");
            if (dataset) {
                if (dataset["sentryComponent"]) return dataset["sentryComponent"];
                if (dataset["sentryElement"]) return dataset["sentryElement"];
            }
        }
    }
    out.push(tagName.toLowerCase());
    const keyAttrPairs = (keyAttrs === null || keyAttrs === void 0 ? void 0 : keyAttrs.length) ? keyAttrs.filter((keyAttr)=>$d6cf245db051044b$var$_safeRead(el, "getAttribute", keyAttr)).map((keyAttr)=>[
            keyAttr,
            $d6cf245db051044b$var$_safeRead(el, "getAttribute", keyAttr)
        ]) : null;
    if (keyAttrPairs === null || keyAttrPairs === void 0 ? void 0 : keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        const id = $d6cf245db051044b$var$_safeRead(el, "id");
        if (id) out.push(`#${id}`);
        const className = $d6cf245db051044b$var$_safeRead(el, "className");
        if (className && (0, $85e272e760900bb9$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = $d6cf245db051044b$var$_safeRead(el, "getAttribute", k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}




const $3e6faad079da1d06$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;






const $ce24286dabfea45c$var$getRating = (value, thresholds)=>{
    if (value > thresholds[1]) return "poor";
    if (value > thresholds[0]) return "needs-improvement";
    return "good";
};
const $ce24286dabfea45c$export$17679dccdd551979 = (callback, metric, thresholds, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue !== null && prevValue !== void 0 ? prevValue : 0);
                if (delta || prevValue === void 0) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = $ce24286dabfea45c$var$getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};




const $f907d1cd0e842264$export$6431553786c94949 = (checkResponseStart = true)=>{
    var _WINDOW_performance_getEntriesByType, _WINDOW_performance;
    const navigationEntry = (_WINDOW_performance = (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).performance) === null || _WINDOW_performance === void 0 ? void 0 : (_WINDOW_performance_getEntriesByType = _WINDOW_performance.getEntriesByType) === null || _WINDOW_performance_getEntriesByType === void 0 ? void 0 : _WINDOW_performance_getEntriesByType.call(_WINDOW_performance, "navigation")[0];
    if (// sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !checkResponseStart || navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()) return navigationEntry;
};


const $465128e00102ae0f$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $f907d1cd0e842264$export$6431553786c94949)();
    var _navEntry_activationStart;
    return (_navEntry_activationStart = navEntry === null || navEntry === void 0 ? void 0 : navEntry.activationStart) !== null && _navEntry_activationStart !== void 0 ? _navEntry_activationStart : 0;
};



function $714f4a09de6c5df8$export$26d3d892edc56833(type, listener, options) {
    if ((0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).document) (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).addEventListener(type, listener, options);
}
function $714f4a09de6c5df8$export$324d7b4b46528191(type, listener, options) {
    if ((0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).document) (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).removeEventListener(type, listener, options);
}


let $7a8db8f65d4c7464$var$firstHiddenTime = -1;
const $7a8db8f65d4c7464$var$onHiddenFunctions = /* @__PURE__ */ new Set();
const $7a8db8f65d4c7464$var$initHiddenTime = ()=>{
    var _WINDOW_document, _WINDOW_document1;
    return ((_WINDOW_document = (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.visibilityState) === "hidden" && !((_WINDOW_document1 = (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).document) === null || _WINDOW_document1 === void 0 ? void 0 : _WINDOW_document1.prerendering) ? 0 : Infinity;
};
const $7a8db8f65d4c7464$var$onVisibilityUpdate = (event)=>{
    if ($7a8db8f65d4c7464$var$isPageHidden(event) && $7a8db8f65d4c7464$var$firstHiddenTime > -1) {
        if (event.type === "visibilitychange" || event.type === "pagehide") for (const onHiddenFunction of $7a8db8f65d4c7464$var$onHiddenFunctions)onHiddenFunction();
        if (!isFinite($7a8db8f65d4c7464$var$firstHiddenTime)) {
            $7a8db8f65d4c7464$var$firstHiddenTime = event.type === "visibilitychange" ? event.timeStamp : 0;
            (0, $714f4a09de6c5df8$export$324d7b4b46528191)("prerenderingchange", $7a8db8f65d4c7464$var$onVisibilityUpdate, true);
        }
    }
};
const $7a8db8f65d4c7464$export$443f86b2c77012c4 = ()=>{
    if ((0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).document && $7a8db8f65d4c7464$var$firstHiddenTime < 0) {
        var _globalThis_performance_getEntriesByType_filter_;
        const activationStart = (0, $465128e00102ae0f$export$d3e828b3c7b5b845)();
        const firstVisibilityStateHiddenTime = !(0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).document.prerendering ? (_globalThis_performance_getEntriesByType_filter_ = globalThis.performance.getEntriesByType("visibility-state").filter((e)=>e.name === "hidden" && e.startTime > activationStart)[0]) === null || _globalThis_performance_getEntriesByType_filter_ === void 0 ? void 0 : _globalThis_performance_getEntriesByType_filter_.startTime : void 0;
        $7a8db8f65d4c7464$var$firstHiddenTime = firstVisibilityStateHiddenTime !== null && firstVisibilityStateHiddenTime !== void 0 ? firstVisibilityStateHiddenTime : $7a8db8f65d4c7464$var$initHiddenTime();
        (0, $714f4a09de6c5df8$export$26d3d892edc56833)("visibilitychange", $7a8db8f65d4c7464$var$onVisibilityUpdate, true);
        (0, $714f4a09de6c5df8$export$26d3d892edc56833)("pagehide", $7a8db8f65d4c7464$var$onVisibilityUpdate, true);
        (0, $714f4a09de6c5df8$export$26d3d892edc56833)("prerenderingchange", $7a8db8f65d4c7464$var$onVisibilityUpdate, true);
    }
    return {
        get firstHiddenTime () {
            return $7a8db8f65d4c7464$var$firstHiddenTime;
        },
        onHidden (cb) {
            $7a8db8f65d4c7464$var$onHiddenFunctions.add(cb);
        }
    };
};
function $7a8db8f65d4c7464$var$isPageHidden(event) {
    var _WINDOW_document;
    return event.type === "pagehide" || ((_WINDOW_document = (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.visibilityState) === "hidden";
}



const $770ab45bbf4ac46c$export$407ea409d1f3b539 = ()=>{
    return `v5-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};




const $bbefd35bb982c087$export$3c29b44508a0612b = (name, value = -1)=>{
    const navEntry = (0, $f907d1cd0e842264$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        var _WINDOW_document, _WINDOW_document1;
        if (((_WINDOW_document = (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.prerendering) || (0, $465128e00102ae0f$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else if ((_WINDOW_document1 = (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).document) === null || _WINDOW_document1 === void 0 ? void 0 : _WINDOW_document1.wasDiscarded) navigationType = "restore";
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, "-");
    }
    const entries = [];
    return {
        name: name,
        value: value,
        rating: "good",
        // If needed, will be updated when reported. `const` to keep the type from widening to `string`.
        delta: 0,
        entries: entries,
        id: (0, $770ab45bbf4ac46c$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


const $1f469f1ecddbdb6a$var$instanceMap = /* @__PURE__ */ new WeakMap();
function $1f469f1ecddbdb6a$export$7c74c9b2462ddb3c(identityObj, ClassObj) {
    try {
        if (!$1f469f1ecddbdb6a$var$instanceMap.get(identityObj)) $1f469f1ecddbdb6a$var$instanceMap.set(identityObj, new ClassObj());
        return $1f469f1ecddbdb6a$var$instanceMap.get(identityObj);
    } catch (_e) {
        return new ClassObj();
    }
}


class $0c2b3f59633c2909$export$4050f7f955e19aa0 {
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _processEntry(entry) {
        var _this__onAfterProcessingUnexpectedShift, _this;
        if (entry.hadRecentInput) return;
        const firstSessionEntry = this._sessionEntries[0];
        const lastSessionEntry = this._sessionEntries[this._sessionEntries.length - 1];
        if (this._sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1e3 && entry.startTime - firstSessionEntry.startTime < 5e3) {
            this._sessionValue += entry.value;
            this._sessionEntries.push(entry);
        } else {
            this._sessionValue = entry.value;
            this._sessionEntries = [
                entry
            ];
        }
        (_this__onAfterProcessingUnexpectedShift = (_this = this)._onAfterProcessingUnexpectedShift) === null || _this__onAfterProcessingUnexpectedShift === void 0 ? void 0 : _this__onAfterProcessingUnexpectedShift.call(_this, entry);
    }
    constructor(){
        // oxlint-disable-next-line sdk/no-class-field-initializers
        this._sessionValue = 0;
        // oxlint-disable-next-line sdk/no-class-field-initializers
        this._sessionEntries = [];
    }
}



var $9tqwB = parcelRequire("9tqwB");
const $287207a03a3b6c4c$export$d1203567a167490e = (type, callback, opts = {})=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                Promise.resolve().then(()=>{
                    callback(list.getEntries());
                });
            });
            po.observe((0, $9tqwB._)({
                type: type,
                buffered: true
            }, opts));
            return po;
        }
    } catch (e) {}
    return;
};


const $1ab0135bc0534957$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};








const $fcdd16d5718d2a9d$export$8bdb38a5671b594e = (callback)=>{
    var _WINDOW_document;
    if ((_WINDOW_document = (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.prerendering) addEventListener("prerenderingchange", ()=>callback(), true);
    else callback();
};


const $043c6cda0aa525f8$export$e610c735b5510cec = [
    1800,
    3e3
];
const $043c6cda0aa525f8$export$fe3c86b74e15d5de = (onReport, opts = {})=>{
    (0, $fcdd16d5718d2a9d$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $7a8db8f65d4c7464$export$443f86b2c77012c4)();
        const metric = (0, $bbefd35bb982c087$export$3c29b44508a0612b)("FCP");
        let report;
        const handleEntries = (entries)=>{
            for (const entry of entries)if (entry.name === "first-contentful-paint") {
                po.disconnect();
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    metric.value = Math.max(entry.startTime - (0, $465128e00102ae0f$export$d3e828b3c7b5b845)(), 0);
                    metric.entries.push(entry);
                    report(true);
                }
            }
        };
        const po = (0, $287207a03a3b6c4c$export$d1203567a167490e)("paint", handleEntries);
        if (po) report = (0, $ce24286dabfea45c$export$17679dccdd551979)(onReport, metric, $043c6cda0aa525f8$export$e610c735b5510cec, opts.reportAllChanges);
    });
};


const $2b0a7fa8f72a92b4$export$3f20d8e089ac35b2 = [
    0.1,
    0.25
];
const $2b0a7fa8f72a92b4$export$a7873055838e5ad8 = (onReport, opts = {})=>{
    (0, $043c6cda0aa525f8$export$fe3c86b74e15d5de)((0, $1ab0135bc0534957$export$b841d51e31c12bab)(()=>{
        const metric = (0, $bbefd35bb982c087$export$3c29b44508a0612b)("CLS", 0);
        let report;
        const visibilityWatcher = (0, $7a8db8f65d4c7464$export$443f86b2c77012c4)();
        const layoutShiftManager = (0, $1f469f1ecddbdb6a$export$7c74c9b2462ddb3c)(opts, (0, $0c2b3f59633c2909$export$4050f7f955e19aa0));
        const handleEntries = (entries)=>{
            for (const entry of entries)layoutShiftManager._processEntry(entry);
            if (layoutShiftManager._sessionValue > metric.value) {
                metric.value = layoutShiftManager._sessionValue;
                metric.entries = layoutShiftManager._sessionEntries;
                report();
            }
        };
        const po = (0, $287207a03a3b6c4c$export$d1203567a167490e)("layout-shift", handleEntries);
        if (po) {
            var _WINDOW_setTimeout;
            report = (0, $ce24286dabfea45c$export$17679dccdd551979)(onReport, metric, $2b0a7fa8f72a92b4$export$3f20d8e089ac35b2, opts.reportAllChanges);
            visibilityWatcher.onHidden(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
            (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81) === null || (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81) === void 0 ? void 0 : (_WINDOW_setTimeout = (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).setTimeout) === null || _WINDOW_setTimeout === void 0 ? void 0 : _WINDOW_setTimeout.call((0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81), report);
        }
    }));
};







let $e4aaeea8f75ec67e$var$interactionCountEstimate = 0;
let $e4aaeea8f75ec67e$var$minKnownInteractionId = Infinity;
let $e4aaeea8f75ec67e$var$maxKnownInteractionId = 0;
const $e4aaeea8f75ec67e$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $e4aaeea8f75ec67e$var$minKnownInteractionId = Math.min($e4aaeea8f75ec67e$var$minKnownInteractionId, e.interactionId);
            $e4aaeea8f75ec67e$var$maxKnownInteractionId = Math.max($e4aaeea8f75ec67e$var$maxKnownInteractionId, e.interactionId);
            $e4aaeea8f75ec67e$var$interactionCountEstimate = $e4aaeea8f75ec67e$var$maxKnownInteractionId ? ($e4aaeea8f75ec67e$var$maxKnownInteractionId - $e4aaeea8f75ec67e$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $e4aaeea8f75ec67e$var$po;
const $e4aaeea8f75ec67e$export$8a962f2683a476d1 = ()=>{
    return $e4aaeea8f75ec67e$var$po ? $e4aaeea8f75ec67e$var$interactionCountEstimate : performance.interactionCount || 0;
};
const $e4aaeea8f75ec67e$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $e4aaeea8f75ec67e$var$po) return;
    $e4aaeea8f75ec67e$var$po = (0, $287207a03a3b6c4c$export$d1203567a167490e)("event", $e4aaeea8f75ec67e$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};


const $b987ba5d7481d0f7$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
let $b987ba5d7481d0f7$var$prevInteractionCount = 0;
const $b987ba5d7481d0f7$var$getInteractionCountForNavigation = ()=>{
    return (0, $e4aaeea8f75ec67e$export$8a962f2683a476d1)() - $b987ba5d7481d0f7$var$prevInteractionCount;
};
class $b987ba5d7481d0f7$export$aaa80641d584351c {
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
    _resetInteractions() {
        $b987ba5d7481d0f7$var$prevInteractionCount = (0, $e4aaeea8f75ec67e$export$8a962f2683a476d1)();
        this._longestInteractionList.length = 0;
        this._longestInteractionMap.clear();
    }
    /**
   * Returns the estimated p98 longest interaction based on the stored
   * interaction candidates and the interaction count for the current page.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _estimateP98LongestInteraction() {
        const candidateInteractionIndex = Math.min(this._longestInteractionList.length - 1, Math.floor($b987ba5d7481d0f7$var$getInteractionCountForNavigation() / 50));
        return this._longestInteractionList[candidateInteractionIndex];
    }
    /**
   * Takes a performance entry and adds it to the list of worst interactions
   * if its duration is long enough to make it among the worst. If the
   * entry is part of an existing interaction, it is merged and the latency
   * and entries list is updated as needed.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _processEntry(entry) {
        var _this__onBeforeProcessingEntry, _this;
        (_this__onBeforeProcessingEntry = (_this = this)._onBeforeProcessingEntry) === null || _this__onBeforeProcessingEntry === void 0 ? void 0 : _this__onBeforeProcessingEntry.call(_this, entry);
        if (!(entry.interactionId || entry.entryType === "first-input")) return;
        const minLongestInteraction = this._longestInteractionList.at(-1);
        let interaction = this._longestInteractionMap.get(entry.interactionId);
        if (interaction || this._longestInteractionList.length < $b987ba5d7481d0f7$var$MAX_INTERACTIONS_TO_CONSIDER || // If the above conditions are false, `minLongestInteraction` will be set.
        entry.duration > minLongestInteraction._latency) {
            var _this__onAfterProcessingINPCandidate, _this1;
            if (interaction) {
                if (entry.duration > interaction._latency) {
                    interaction.entries = [
                        entry
                    ];
                    interaction._latency = entry.duration;
                } else if (entry.duration === interaction._latency && entry.startTime === interaction.entries[0].startTime) interaction.entries.push(entry);
            } else {
                interaction = {
                    id: entry.interactionId,
                    entries: [
                        entry
                    ],
                    _latency: entry.duration
                };
                this._longestInteractionMap.set(interaction.id, interaction);
                this._longestInteractionList.push(interaction);
            }
            this._longestInteractionList.sort((a, b)=>b._latency - a._latency);
            if (this._longestInteractionList.length > $b987ba5d7481d0f7$var$MAX_INTERACTIONS_TO_CONSIDER) {
                const removedInteractions = this._longestInteractionList.splice($b987ba5d7481d0f7$var$MAX_INTERACTIONS_TO_CONSIDER);
                for (const interaction2 of removedInteractions)this._longestInteractionMap.delete(interaction2.id);
            }
            (_this__onAfterProcessingINPCandidate = (_this1 = this)._onAfterProcessingINPCandidate) === null || _this__onAfterProcessingINPCandidate === void 0 ? void 0 : _this__onAfterProcessingINPCandidate.call(_this1, interaction);
        }
    }
    constructor(){
        /**
     * A list of longest interactions on the page (by latency) sorted so the
     * longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER
     * long.
     */ // oxlint-disable-next-line sdk/no-class-field-initializers
        this._longestInteractionList = [];
        /**
     * A mapping of longest interactions by their interaction ID.
     * This is used for faster lookup.
     */ // oxlint-disable-next-line sdk/no-class-field-initializers
        this._longestInteractionMap = /* @__PURE__ */ new Map();
    }
}








const $b71c182abb79b9ce$export$d3314d5863fc1fef = (cb)=>{
    var _WINDOW_document;
    const rIC = (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).requestIdleCallback || (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).setTimeout;
    if (((_WINDOW_document = (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.visibilityState) === "hidden") cb();
    else {
        cb = (0, $1ab0135bc0534957$export$b841d51e31c12bab)(cb);
        (0, $714f4a09de6c5df8$export$26d3d892edc56833)("visibilitychange", cb, {
            once: true,
            capture: true
        });
        (0, $714f4a09de6c5df8$export$26d3d892edc56833)("pagehide", cb, {
            once: true,
            capture: true
        });
        rIC(()=>{
            cb();
            (0, $714f4a09de6c5df8$export$324d7b4b46528191)("visibilitychange", cb, {
                capture: true
            });
            (0, $714f4a09de6c5df8$export$324d7b4b46528191)("pagehide", cb, {
                capture: true
            });
        });
    }
};


const $3406d2817f56259c$export$7f4cb060ded9173c = [
    200,
    500
];
const $3406d2817f56259c$var$DEFAULT_DURATION_THRESHOLD = 40;
const $3406d2817f56259c$export$7df4b36ecaed99e1 = (onReport, opts = {})=>{
    if (!(globalThis.PerformanceEventTiming && "interactionId" in PerformanceEventTiming.prototype)) return;
    const visibilityWatcher = (0, $7a8db8f65d4c7464$export$443f86b2c77012c4)();
    (0, $fcdd16d5718d2a9d$export$8bdb38a5671b594e)(()=>{
        (0, $e4aaeea8f75ec67e$export$67d90cda6b78a2eb)();
        const metric = (0, $bbefd35bb982c087$export$3c29b44508a0612b)("INP");
        let report;
        const interactionManager = (0, $1f469f1ecddbdb6a$export$7c74c9b2462ddb3c)(opts, (0, $b987ba5d7481d0f7$export$aaa80641d584351c));
        const handleEntries = (entries)=>{
            (0, $b71c182abb79b9ce$export$d3314d5863fc1fef)(()=>{
                for (const entry of entries)interactionManager._processEntry(entry);
                const inp = interactionManager._estimateP98LongestInteraction();
                if (inp && inp._latency !== metric.value) {
                    metric.value = inp._latency;
                    metric.entries = inp.entries;
                    report();
                }
            });
        };
        var _opts_durationThreshold;
        const po = (0, $287207a03a3b6c4c$export$d1203567a167490e)("event", handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: (_opts_durationThreshold = opts.durationThreshold) !== null && _opts_durationThreshold !== void 0 ? _opts_durationThreshold : $3406d2817f56259c$var$DEFAULT_DURATION_THRESHOLD
        });
        report = (0, $ce24286dabfea45c$export$17679dccdd551979)(onReport, metric, $3406d2817f56259c$export$7f4cb060ded9173c, opts.reportAllChanges);
        if (po) {
            po.observe({
                type: "first-input",
                buffered: true
            });
            visibilityWatcher.onHidden(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
        }
    });
};








class $70ee8c75b34d4cb6$export$6a641ef2a067ec62 {
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
    _processEntry(entry) {
        var _this__onBeforeProcessingEntry, _this;
        (_this__onBeforeProcessingEntry = (_this = this)._onBeforeProcessingEntry) === null || _this__onBeforeProcessingEntry === void 0 ? void 0 : _this__onBeforeProcessingEntry.call(_this, entry);
    }
}






const $48a5216c49f5758b$export$948521ca5b0e1b17 = [
    2500,
    4e3
];
const $48a5216c49f5758b$export$947b1626ab8d5632 = (onReport, opts = {})=>{
    (0, $fcdd16d5718d2a9d$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $7a8db8f65d4c7464$export$443f86b2c77012c4)();
        const metric = (0, $bbefd35bb982c087$export$3c29b44508a0612b)("LCP");
        let report;
        const lcpEntryManager = (0, $1f469f1ecddbdb6a$export$7c74c9b2462ddb3c)(opts, (0, $70ee8c75b34d4cb6$export$6a641ef2a067ec62));
        const handleEntries = (entries)=>{
            if (!opts.reportAllChanges) entries = entries.slice(-1);
            for (const entry of entries){
                lcpEntryManager._processEntry(entry);
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    metric.value = Math.max(entry.startTime - (0, $465128e00102ae0f$export$d3e828b3c7b5b845)(), 0);
                    metric.entries = [
                        entry
                    ];
                    report();
                }
            }
        };
        const po = (0, $287207a03a3b6c4c$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
        if (po) {
            report = (0, $ce24286dabfea45c$export$17679dccdd551979)(onReport, metric, $48a5216c49f5758b$export$948521ca5b0e1b17, opts.reportAllChanges);
            const stopListening = (0, $1ab0135bc0534957$export$b841d51e31c12bab)(()=>{
                handleEntries(po.takeRecords());
                po.disconnect();
                report(true);
            });
            const stopListeningWrapper = (event)=>{
                if (event.isTrusted) {
                    (0, $b71c182abb79b9ce$export$d3314d5863fc1fef)(stopListening);
                    (0, $714f4a09de6c5df8$export$324d7b4b46528191)(event.type, stopListeningWrapper, {
                        capture: true
                    });
                }
            };
            for (const type of [
                "keydown",
                "click",
                "visibilitychange"
            ])(0, $714f4a09de6c5df8$export$26d3d892edc56833)(type, stopListeningWrapper, {
                capture: true
            });
        }
    });
};









const $426d5525c53b5cf2$export$65c59ea8064668fc = [
    800,
    1800
];
const $426d5525c53b5cf2$var$whenReady = (callback)=>{
    var _WINDOW_document, _WINDOW_document1;
    if ((_WINDOW_document = (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.prerendering) (0, $fcdd16d5718d2a9d$export$8bdb38a5671b594e)(()=>$426d5525c53b5cf2$var$whenReady(callback));
    else if (((_WINDOW_document1 = (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).document) === null || _WINDOW_document1 === void 0 ? void 0 : _WINDOW_document1.readyState) !== "complete") addEventListener("load", ()=>$426d5525c53b5cf2$var$whenReady(callback), true);
    else setTimeout(callback);
};
const $426d5525c53b5cf2$export$33a01e6c5f2c7e33 = (onReport, opts = {})=>{
    const metric = (0, $bbefd35bb982c087$export$3c29b44508a0612b)("TTFB");
    const report = (0, $ce24286dabfea45c$export$17679dccdd551979)(onReport, metric, $426d5525c53b5cf2$export$65c59ea8064668fc, opts.reportAllChanges);
    $426d5525c53b5cf2$var$whenReady(()=>{
        const navigationEntry = (0, $f907d1cd0e842264$export$6431553786c94949)();
        if (navigationEntry) {
            metric.value = Math.max(navigationEntry.responseStart - (0, $465128e00102ae0f$export$d3e828b3c7b5b845)(), 0);
            metric.entries = [
                navigationEntry
            ];
            report(true);
        }
    });
};


const $5d4e4d5b5c2c563b$var$handlers = {};
const $5d4e4d5b5c2c563b$var$instrumented = {};
let $5d4e4d5b5c2c563b$var$_previousCls;
let $5d4e4d5b5c2c563b$var$_previousLcp;
let $5d4e4d5b5c2c563b$var$_previousTtfb;
let $5d4e4d5b5c2c563b$var$_previousInp;
function $5d4e4d5b5c2c563b$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $5d4e4d5b5c2c563b$var$addMetricObserver("cls", callback, $5d4e4d5b5c2c563b$var$instrumentCls, $5d4e4d5b5c2c563b$var$_previousCls, stopOnCallback);
}
function $5d4e4d5b5c2c563b$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $5d4e4d5b5c2c563b$var$addMetricObserver("lcp", callback, $5d4e4d5b5c2c563b$var$instrumentLcp, $5d4e4d5b5c2c563b$var$_previousLcp, stopOnCallback);
}
function $5d4e4d5b5c2c563b$export$699d9529c099a797(callback) {
    return $5d4e4d5b5c2c563b$var$addMetricObserver("ttfb", callback, $5d4e4d5b5c2c563b$var$instrumentTtfb, $5d4e4d5b5c2c563b$var$_previousTtfb);
}
function $5d4e4d5b5c2c563b$export$da3b76aa2022cbd7(callback) {
    return $5d4e4d5b5c2c563b$var$addMetricObserver("inp", callback, $5d4e4d5b5c2c563b$var$instrumentInp, $5d4e4d5b5c2c563b$var$_previousInp);
}
function $5d4e4d5b5c2c563b$export$69816c1a049f8db6(type, callback) {
    $5d4e4d5b5c2c563b$var$addHandler(type, callback);
    if (!$5d4e4d5b5c2c563b$var$instrumented[type]) {
        $5d4e4d5b5c2c563b$var$instrumentPerformanceObserver(type);
        $5d4e4d5b5c2c563b$var$instrumented[type] = true;
    }
    return $5d4e4d5b5c2c563b$var$getCleanupCallback(type, callback);
}
function $5d4e4d5b5c2c563b$var$triggerHandlers(type, data) {
    const typeHandlers = $5d4e4d5b5c2c563b$var$handlers[type];
    if (!(typeHandlers === null || typeHandlers === void 0 ? void 0 : typeHandlers.length)) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $3e6faad079da1d06$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${(0, $a6df8b9dd4ca405a$export$aad197c7121a6651)(handler)}
Error:`, e);
    }
}
function $5d4e4d5b5c2c563b$var$instrumentCls() {
    return (0, $2b0a7fa8f72a92b4$export$a7873055838e5ad8)((metric)=>{
        $5d4e4d5b5c2c563b$var$triggerHandlers("cls", {
            metric: metric
        });
        $5d4e4d5b5c2c563b$var$_previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $5d4e4d5b5c2c563b$var$instrumentLcp() {
    return (0, $48a5216c49f5758b$export$947b1626ab8d5632)((metric)=>{
        $5d4e4d5b5c2c563b$var$triggerHandlers("lcp", {
            metric: metric
        });
        $5d4e4d5b5c2c563b$var$_previousLcp = metric;
    }, // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $5d4e4d5b5c2c563b$var$instrumentTtfb() {
    return (0, $426d5525c53b5cf2$export$33a01e6c5f2c7e33)((metric)=>{
        $5d4e4d5b5c2c563b$var$triggerHandlers("ttfb", {
            metric: metric
        });
        $5d4e4d5b5c2c563b$var$_previousTtfb = metric;
    });
}
function $5d4e4d5b5c2c563b$var$instrumentInp() {
    return (0, $3406d2817f56259c$export$7df4b36ecaed99e1)((metric)=>{
        $5d4e4d5b5c2c563b$var$triggerHandlers("inp", {
            metric: metric
        });
        $5d4e4d5b5c2c563b$var$_previousInp = metric;
    });
}
function $5d4e4d5b5c2c563b$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $5d4e4d5b5c2c563b$var$addHandler(type, callback);
    let stopListening;
    if (!$5d4e4d5b5c2c563b$var$instrumented[type]) {
        stopListening = instrumentFn();
        $5d4e4d5b5c2c563b$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $5d4e4d5b5c2c563b$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : void 0);
}
function $5d4e4d5b5c2c563b$var$instrumentPerformanceObserver(type) {
    const options = {};
    if (type === "event") options.durationThreshold = 0;
    (0, $287207a03a3b6c4c$export$d1203567a167490e)(type, (entries)=>{
        $5d4e4d5b5c2c563b$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $5d4e4d5b5c2c563b$var$addHandler(type, handler) {
    $5d4e4d5b5c2c563b$var$handlers[type] = $5d4e4d5b5c2c563b$var$handlers[type] || [];
    $5d4e4d5b5c2c563b$var$handlers[type].push(handler);
}
function $5d4e4d5b5c2c563b$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $5d4e4d5b5c2c563b$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}
function $5d4e4d5b5c2c563b$export$7affb50b622d8714(entry) {
    return "duration" in entry;
}


function $8d60f2ee7fd1c983$export$71511d61b312f219() {
    $8d60f2ee7fd1c983$export$71511d61b312f219 = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8d60f2ee7fd1c983$export$71511d61b312f219.apply(this, arguments);
}


function $7ae6b455e4a352e9$export$71511d61b312f219(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}



var $9tqwB = parcelRequire("9tqwB");

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");









function $e47550d94a838770$export$18ce21a8b7efd7e9(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $e47550d94a838770$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
function $e47550d94a838770$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ((0, $85e272e760900bb9$export$f5b060c2914b97c8)(value)) return (0, $7a8fa26b5d72274f$export$64da0f40b0f924ba)(value, (result)=>{
        onFinally();
        onSuccess(result);
    }, (err)=>{
        onError(err);
        onFinally();
    });
    onFinally();
    onSuccess(value);
    return value;
}



function $8540c501196729c9$export$1f70765132c3c225(maybeOptions) {
    var _getClient;
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || ((_getClient = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)()) === null || _getClient === void 0 ? void 0 : _getClient.getOptions());
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}





function $3ba72cc613510e20$var$logIgnoredSpan(droppedSpan) {
    (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
function $3ba72cc613510e20$export$5d569ac97c389400(span, ignoreSpans) {
    if (!(ignoreSpans === null || ignoreSpans === void 0 ? void 0 : ignoreSpans.length)) return false;
    for (const pattern of ignoreSpans){
        if ($3ba72cc613510e20$var$isStringOrRegExp(pattern)) {
            if (span.description && (0, $6c937b4b236937d4$export$cdded5b28a5f8c6d)(span.description, pattern)) {
                (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && $3ba72cc613510e20$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
        if (!pattern.name && !pattern.op && !hasAttributes) continue;
        const nameMatches = pattern.name ? span.description && (0, $6c937b4b236937d4$export$cdded5b28a5f8c6d)(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && (0, $6c937b4b236937d4$export$cdded5b28a5f8c6d)(span.op, pattern.op) : true;
        const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(([key, valuePattern])=>{
            var _span_attributes;
            return $3ba72cc613510e20$var$_matchesAttributeValue((_span_attributes = span.attributes) === null || _span_attributes === void 0 ? void 0 : _span_attributes[key], valuePattern);
        }) : true;
        if (nameMatches && opMatches && attrsMatch) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && $3ba72cc613510e20$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
function $3ba72cc613510e20$var$_matchesAttributeValue(actual, pat) {
    if (typeof actual === "string" && (typeof pat === "string" || pat instanceof RegExp)) return (0, $6c937b4b236937d4$export$cdded5b28a5f8c6d)(actual, pat);
    if (Array.isArray(actual) && Array.isArray(pat)) return actual.length === pat.length && actual.every((v, i)=>v === pat[i]);
    return actual === pat;
}
function $3ba72cc613510e20$export$ddf57376e818b444(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $3ba72cc613510e20$var$isStringOrRegExp(value) {
    return typeof value === "string" || value instanceof RegExp;
}


function $5da71dc6e7ad8d8b$export$6ea47215d699c04a(client) {
    return client.getOptions().traceLifecycle === "stream";
}









var $9tqwB = parcelRequire("9tqwB");
const $370456451b52ff1d$export$849dbeeeda01ae98 = "production";
const $370456451b52ff1d$export$6829f580e78306fa = "development";












const $ca20a23f2fb66f57$var$NON_RECORDING_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.nonRecordingSpan");
class $ca20a23f2fb66f57$export$d6636b700b76c516 {
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $cac16f6eada858e7$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $f56fc4041ba3a369$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $f56fc4041ba3a369$export$295213bc4d0c54ad)();
        this.dropReason = spanContext.dropReason;
        (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(this, $ca20a23f2fb66f57$var$NON_RECORDING_SPAN_FIELD, true);
    }
}
function $ca20a23f2fb66f57$export$61cc547d99783aa7(span) {
    return !!span && span[$ca20a23f2fb66f57$var$NON_RECORDING_SPAN_FIELD] === true;
}



const $5c79f8c2b5cb59fa$var$FROZEN_DSC_FIELD = "_frozenDsc";
function $5c79f8c2b5cb59fa$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(spanWithMaybeDsc, $5c79f8c2b5cb59fa$var$FROZEN_DSC_FIELD, dsc);
}
function $5c79f8c2b5cb59fa$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = {
        environment: options.environment || (0, $370456451b52ff1d$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: (0, $94fe38c0afc4d11c$export$b7ac9b8efa4bb595)(client)
    };
    client.emit("createDsc", dsc);
    return dsc;
}
function $5c79f8c2b5cb59fa$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $5c79f8c2b5cb59fa$export$366bad00d6815eed(propagationContext.traceId, client);
}
function $5c79f8c2b5cb59fa$export$a117f995597e25df(span) {
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(span);
    const rootSpanJson = (0, $cac16f6eada858e7$export$92d8c23565496537)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    var _traceState_get, _ref;
    const rootSpanSampleRate = (_ref = (_traceState_get = traceState === null || traceState === void 0 ? void 0 : traceState.get("sentry.sample_rate")) !== null && _traceState_get !== void 0 ? _traceState_get : rootSpanAttributes[0, $fdf17a1e56d9d4ca$export$ccfe0a40627cc34b]) !== null && _ref !== void 0 ? _ref : rootSpanAttributes[0, $fdf17a1e56d9d4ca$export$889fb736668e1ecc];
    function applyLocalSampleRateToDsc(dsc2) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc2.sample_rate = `${rootSpanSampleRate}`;
        return dsc2;
    }
    const frozenDsc = rootSpan[$5c79f8c2b5cb59fa$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    if ((0, $ca20a23f2fb66f57$export$61cc547d99783aa7)(rootSpan) && !(0, $8540c501196729c9$export$1f70765132c3c225)(client.getOptions())) {
        const capturedScope = (0, $f7bbc910493e6179$export$c08fbc656a245d03)(rootSpan).scope;
        if (capturedScope) return applyLocalSampleRateToDsc((0, $9tqwB._)({}, $5c79f8c2b5cb59fa$export$89ef1736f08c6b2b(client, capturedScope)));
    }
    const traceStateDsc = traceState === null || traceState === void 0 ? void 0 : traceState.get("sentry.dsc");
    const dscOnTraceState = traceStateDsc && (0, $4d0fefb7946dcfa7$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    const dsc = $5c79f8c2b5cb59fa$export$366bad00d6815eed(span.spanContext().traceId, client);
    var _rootSpanAttributes_SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
    const source = (_rootSpanAttributes_SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = rootSpanAttributes[0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405]) !== null && _rootSpanAttributes_SEMANTIC_ATTRIBUTE_SENTRY_SOURCE !== void 0 ? _rootSpanAttributes_SEMANTIC_ATTRIBUTE_SENTRY_SOURCE : rootSpanAttributes["sentry.span.source"];
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    if ((0, $8540c501196729c9$export$1f70765132c3c225)()) {
        var // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        _getCapturedScopesOnSpan_scope;
        dsc.sampled = String((0, $cac16f6eada858e7$export$5caecac1caaf3a71)(rootSpan));
        var // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        _traceState_get1;
        dsc.sample_rand = (_traceState_get1 = traceState === null || traceState === void 0 ? void 0 : traceState.get("sentry.sample_rand")) !== null && _traceState_get1 !== void 0 ? _traceState_get1 : (_getCapturedScopesOnSpan_scope = (0, $f7bbc910493e6179$export$c08fbc656a245d03)(rootSpan).scope) === null || _getCapturedScopesOnSpan_scope === void 0 ? void 0 : _getCapturedScopesOnSpan_scope.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
function $5c79f8c2b5cb59fa$export$95cf936fdacaff7b(span) {
    const dsc = $5c79f8c2b5cb59fa$export$a117f995597e25df(span);
    return (0, $4d0fefb7946dcfa7$export$56766feef403f365)(dsc);
}





function $ac09a37575b310ba$export$2f3d84e767c9592b(span) {
    if (!(0, $37b03cd1fa6d4fb8$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = (0, $cac16f6eada858e7$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $cac16f6eada858e7$export$5caecac1caaf3a71)(span);
    const rootSpan = (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op2, description: description2 } = (0, $cac16f6eada858e7$export$92d8c23565496537)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op2) infoParts.push(`root op: ${op2}`);
        if (description2) infoParts.push(`root description: ${description2}`);
    }
    (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`${header}
  ${infoParts.join("\n  ")}`);
}
function $ac09a37575b310ba$export$b77c830667a4d630(span) {
    if (!(0, $37b03cd1fa6d4fb8$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = (0, $cac16f6eada858e7$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(msg);
}



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");




function $c763fd1ae3ee0fd4$export$5f833db634b217bb(options, samplingContext, sampleRand) {
    if (!(0, $8540c501196729c9$export$1f70765132c3c225)(options)) return [
        false
    ];
    let localSampleRateWasApplied = void 0;
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler((0, $2qxEV._)((0, $9tqwB._)({}, samplingContext), {
            inheritOrSampleWith: (fallbackSampleRate)=>{
                if (typeof samplingContext.parentSampleRate === "number") return samplingContext.parentSampleRate;
                if (typeof samplingContext.parentSampled === "boolean") return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        }));
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== void 0) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    const parsedSampleRate = (0, $ab7c7053b878f035$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === void 0) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    if (!parsedSampleRate) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    const shouldSample = sampleRand < parsedSampleRate;
    if (!shouldSample) (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}




var $9tqwB = parcelRequire("9tqwB");



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


function $c26cfd9b49302c59$export$d3f49b33a1f44720(callback) {
    (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(callback, "_streamed", true);
    return callback;
}
function $c26cfd9b49302c59$export$ca3e1ec3cdcc76ac(callback) {
    return !!callback && typeof callback === "function" && "_streamed" in callback && !!callback._streamed;
}




var $9tqwB = parcelRequire("9tqwB");





function $5e31f551d021d379$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
function $5e31f551d021d379$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
function $5e31f551d021d379$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
function $5e31f551d021d379$export$604a45d95a155e2b(envelope, types) {
    return $5e31f551d021d379$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
function $5e31f551d021d379$var$encodeUTF8(input) {
    const carrier = (0, $3d29ea41beb10247$export$c8bfa33e4e8ae492)((0, $df8678217e707dd5$export$f1a6cdb1459e81d1));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
function $5e31f551d021d379$var$decodeUTF8(input) {
    const carrier = (0, $3d29ea41beb10247$export$c8bfa33e4e8ae492)((0, $df8678217e707dd5$export$f1a6cdb1459e81d1));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
function $5e31f551d021d379$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $5e31f551d021d379$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $5e31f551d021d379$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`
${JSON.stringify(itemHeaders)}
`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                stringifiedPayload = JSON.stringify((0, $7879d292a118e15d$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $5e31f551d021d379$var$concatBuffers(parts);
}
function $5e31f551d021d379$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
function $5e31f551d021d379$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === "string" ? $5e31f551d021d379$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(10);
        if (i < 0) i = buffer.length;
        return JSON.parse($5e31f551d021d379$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : void 0;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
function $5e31f551d021d379$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
function $5e31f551d021d379$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === "string" ? $5e31f551d021d379$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $5e31f551d021d379$var$DATA_CATEGORY_OVERRIDES = {
    sessions: "session",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    raw_security: "security",
    log: "log_item",
    trace_metric: "metric"
};
function $5e31f551d021d379$var$_isOverriddenType(type) {
    return type in $5e31f551d021d379$var$DATA_CATEGORY_OVERRIDES;
}
function $5e31f551d021d379$export$b11169581eeaf237(type) {
    return $5e31f551d021d379$var$_isOverriddenType(type) ? $5e31f551d021d379$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
function $5e31f551d021d379$export$d369f3b2758f6743(metadataOrEvent) {
    if (!(metadataOrEvent === null || metadataOrEvent === void 0 ? void 0 : metadataOrEvent.sdk)) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
function $5e31f551d021d379$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    var _event_sdkProcessingMetadata;
    const dynamicSamplingContext = (_event_sdkProcessingMetadata = event.sdkProcessingMetadata) === null || _event_sdkProcessingMetadata === void 0 ? void 0 : _event_sdkProcessingMetadata.dynamicSamplingContext;
    return (0, $9tqwB._)({
        event_id: event.event_id,
        sent_at: new Date((0, $8aca1af6321ba44f$export$65b1bada40c91b34)()).toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: (0, $94fe38c0afc4d11c$export$44d472fbb931a776)(dsn)
    }, dynamicSamplingContext && {
        trace: dynamicSamplingContext
    });
}





function $0ca80a3f5337ad93$export$8a6cdb6116a9fd2b(event, newSdkInfo) {
    var _event_sdk, _event_sdk1, _event_sdk2, _event_sdk3;
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = (0, $2qxEV._)((0, $9tqwB._)({}, eventSdkInfo), {
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...((_event_sdk = event.sdk) === null || _event_sdk === void 0 ? void 0 : _event_sdk.integrations) || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...((_event_sdk1 = event.sdk) === null || _event_sdk1 === void 0 ? void 0 : _event_sdk1.packages) || [],
            ...newSdkInfo.packages || []
        ],
        settings: ((_event_sdk2 = event.sdk) === null || _event_sdk2 === void 0 ? void 0 : _event_sdk2.settings) || newSdkInfo.settings ? (0, $9tqwB._)({}, (_event_sdk3 = event.sdk) === null || _event_sdk3 === void 0 ? void 0 : _event_sdk3.settings, newSdkInfo.settings) : void 0
    });
    return event;
}
function $0ca80a3f5337ad93$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $5e31f551d021d379$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = (0, $9tqwB._)({
        sent_at: new Date((0, $8aca1af6321ba44f$export$65b1bada40c91b34)()).toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: (0, $94fe38c0afc4d11c$export$44d472fbb931a776)(dsn)
    });
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $5e31f551d021d379$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
function $0ca80a3f5337ad93$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $5e31f551d021d379$export$d369f3b2758f6743)(metadata);
    const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $0ca80a3f5337ad93$export$8a6cdb6116a9fd2b(event, metadata === null || metadata === void 0 ? void 0 : metadata.sdk);
    const envelopeHeaders = (0, $5e31f551d021d379$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $5e31f551d021d379$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
function $0ca80a3f5337ad93$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc2) {
        return !!dsc2.trace_id && !!dsc2.public_key;
    }
    const dsc = (0, $5c79f8c2b5cb59fa$export$a117f995597e25df)(spans[0]);
    const dsn = client === null || client === void 0 ? void 0 : client.getDsn();
    const tunnel = client === null || client === void 0 ? void 0 : client.getOptions().tunnel;
    const headers = (0, $9tqwB._)({
        sent_at: new Date((0, $8aca1af6321ba44f$export$65b1bada40c91b34)()).toISOString()
    }, dscHasRequiredProps(dsc) && {
        trace: dsc
    }, !!tunnel && dsn && {
        dsn: (0, $94fe38c0afc4d11c$export$44d472fbb931a776)(dsn)
    });
    const { beforeSendSpan: beforeSendSpan, ignoreSpans: ignoreSpans } = (client === null || client === void 0 ? void 0 : client.getOptions()) || {};
    const filteredSpans = (ignoreSpans === null || ignoreSpans === void 0 ? void 0 : ignoreSpans.length) ? spans.filter((span)=>{
        const json = (0, $cac16f6eada858e7$export$92d8c23565496537)(span);
        return !(0, $3ba72cc613510e20$export$5d569ac97c389400)({
            description: json.description,
            op: json.op,
            attributes: json.data
        }, ignoreSpans);
    }) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client === null || client === void 0 ? void 0 : client.recordDroppedEvent("before_send", "span", droppedSpans);
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $cac16f6eada858e7$export$92d8c23565496537)(span);
        const processedSpan = !(0, $c26cfd9b49302c59$export$ca3e1ec3cdcc76ac)(beforeSendSpan) ? beforeSendSpan(spanJson) : spanJson;
        if (!processedSpan) {
            (0, $cac16f6eada858e7$export$d11691ff45a3e535)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $cac16f6eada858e7$export$92d8c23565496537);
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $5e31f551d021d379$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $5e31f551d021d379$export$f93f7f385160c44e)(headers, items);
}












const $4c5fac8529c371f2$var$MAX_SPAN_COUNT = 1e3;
class $4c5fac8529c371f2$export$a92149b045260d9f {
    /** @inheritDoc */ addLink(link) {
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $cac16f6eada858e7$export$eb571cd9b5d98de8) : (0, $cac16f6eada858e7$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === void 0) delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $cac16f6eada858e7$export$3f7581298f56c6d7)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        if (!(0, $f7bbc910493e6179$export$2e69b79005fc86eb)(this)) this.setAttribute((0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405), "custom");
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        if (this._endTime) return;
        this._endTime = (0, $cac16f6eada858e7$export$3f7581298f56c6d7)(endTimestamp);
        (0, $ac09a37575b310ba$export$b77c830667a4d630)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $fdf17a1e56d9d4ca$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $cac16f6eada858e7$export$e238a77ea3a8cd66)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e],
            profile_id: this._attributes[0, $fdf17a1e56d9d4ca$export$1efec95406bbe327],
            exclusive_time: this._attributes[0, $fdf17a1e56d9d4ca$export$fea48ba9f4550879],
            measurements: (0, $293a838d63649350$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(this) === this || void 0,
            segment_id: this._isStandaloneSpan ? (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(this).spanContext().spanId : void 0,
            links: (0, $cac16f6eada858e7$export$cb3e3a12e0eec16c)(this._links)
        };
    }
    /**
   * Get {@link StreamedSpanJSON} representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToStreamedSpanJSON(span)` instead.
   */ getStreamedSpanJSON() {
        var _this__name, _this__endTime;
        return {
            name: (_this__name = this._name) !== null && _this__name !== void 0 ? _this__name : "",
            span_id: this._spanId,
            trace_id: this._traceId,
            parent_span_id: this._parentSpanId,
            start_timestamp: this._startTime,
            // just in case _endTime is not set, we use the start time (i.e. duration 0)
            end_timestamp: (_this__endTime = this._endTime) !== null && _this__endTime !== void 0 ? _this__endTime : this._startTime,
            is_segment: this._isStandaloneSpan || this === (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(this),
            status: (0, $cac16f6eada858e7$export$457dcd3df4e9f5c6)(this._status),
            attributes: this._attributes,
            links: (0, $cac16f6eada858e7$export$9015adcf158ef3a5)(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log("[Tracing] Adding an event to span:", name);
        const time = $4c5fac8529c371f2$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $b007b72e24b33b62$export$ee52dced521e3e18)();
        const attributes = $4c5fac8529c371f2$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $cac16f6eada858e7$export$3f7581298f56c6d7)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
        if (client) {
            client.emit("spanEnd", this);
            if (!this._isStandaloneSpan) client.emit("afterSpanEnd", this);
        }
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(this);
        if (!isSegmentSpan) return;
        if (this._isStandaloneSpan) {
            if (this._sampled) $4c5fac8529c371f2$var$sendSpanEnvelope((0, $0ca80a3f5337ad93$export$19a0081d4b39d77)([
                this
            ], client));
            else {
                (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        } else if (client && (0, $5da71dc6e7ad8d8b$export$6ea47215d699c04a)(client)) {
            client.emit("afterSegmentSpanEnd", this);
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $f7bbc910493e6179$export$c08fbc656a245d03)(this).scope || (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        var _capturedSpanScope_getScopeData_sdkProcessingMetadata;
        if (!$4c5fac8529c371f2$var$isFullFinishedSpan((0, $cac16f6eada858e7$export$92d8c23565496537)(this))) return void 0;
        if (!this._name) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $f7bbc910493e6179$export$c08fbc656a245d03)(this);
        const normalizedRequest = capturedSpanScope === null || capturedSpanScope === void 0 ? void 0 : (_capturedSpanScope_getScopeData_sdkProcessingMetadata = capturedSpanScope.getScopeData().sdkProcessingMetadata) === null || _capturedSpanScope_getScopeData_sdkProcessingMetadata === void 0 ? void 0 : _capturedSpanScope_getScopeData_sdkProcessingMetadata.normalizedRequest;
        if (this._sampled !== true) return void 0;
        const finishedSpans = (0, $cac16f6eada858e7$export$340c5c8a13ffc680)(this).filter((span)=>span !== this && !$4c5fac8529c371f2$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $cac16f6eada858e7$export$92d8c23565496537)(span)).filter($4c5fac8529c371f2$var$isFullFinishedSpan);
        const source = this._attributes[0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405];
        delete this._attributes[0, $fdf17a1e56d9d4ca$export$165ce9a229f6f050];
        let hasGenAiSpans = false;
        spans.forEach((span)=>{
            var _span_op;
            delete span.data[0, $fdf17a1e56d9d4ca$export$165ce9a229f6f050];
            if ((_span_op = span.op) === null || _span_op === void 0 ? void 0 : _span_op.startsWith("gen_ai.")) hasGenAiSpans = true;
        });
        const transaction = (0, $9tqwB._)({
            contexts: {
                trace: (0, $cac16f6eada858e7$export$4c3967a8a2f6bbd6)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $4c5fac8529c371f2$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $4c5fac8529c371f2$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: (0, $5c79f8c2b5cb59fa$export$a117f995597e25df)(this),
                hasGenAiSpans: hasGenAiSpans
            },
            request: normalizedRequest
        }, source && {
            transaction_info: {
                source: source
            }
        });
        const measurements = (0, $293a838d63649350$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, void 0, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
    /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $f56fc4041ba3a369$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $f56fc4041ba3a369$export$295213bc4d0c54ad)();
        this._startTime = spanContext.startTimestamp || (0, $b007b72e24b33b62$export$ee52dced521e3e18)();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes((0, $9tqwB._)({
            [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: "manual",
            [(0, $fdf17a1e56d9d4ca$export$1a413bd9a88fdb09)]: spanContext.op
        }, spanContext.attributes));
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        if (this._endTime) this._onSpanEnded();
    }
}
function $4c5fac8529c371f2$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
function $4c5fac8529c371f2$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
function $4c5fac8529c371f2$var$isStandaloneSpan(span) {
    return span instanceof $4c5fac8529c371f2$export$a92149b045260d9f && span.isStandaloneSpan();
}
function $4c5fac8529c371f2$var$sendSpanEnvelope(envelope) {
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    client.sendEnvelope(envelope);
}




const $93c45d57befd4356$export$61ab4e30f2201736 = "__SENTRY_SUPPRESS_TRACING__";
function $93c45d57befd4356$export$a1bd95187356f372(options, callback) {
    const acs = $93c45d57befd4356$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $93c45d57befd4356$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope === null || customScope === void 0 ? void 0 : customScope.clone();
    return (0, $6486f3d311605b78$export$ec58d9285c204497)(customForkedScope, ()=>{
        const wrapper = $93c45d57befd4356$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
            const parentSpan = $93c45d57befd4356$var$getParentSpan(scope, customParentSpan);
            const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? $93c45d57befd4356$var$startMissingRequiredParentSpan(scope, client) : $93c45d57befd4356$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$93c45d57befd4356$var$_isIgnoredSpan(activeSpan) || !parentSpan) (0, $9f9cfe5727c3ad26$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $e47550d94a838770$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                const { status: status } = (0, $cac16f6eada858e7$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $f217ebe7a0a6fc3c$export$f966a0446ece71e),
                    message: "internal_error"
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
function $93c45d57befd4356$export$c10292ad04b92aea(options, callback) {
    const acs = $93c45d57befd4356$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $93c45d57befd4356$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope === null || customScope === void 0 ? void 0 : customScope.clone();
    return (0, $6486f3d311605b78$export$ec58d9285c204497)(customForkedScope, ()=>{
        const wrapper = $93c45d57befd4356$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
            const parentSpan = $93c45d57befd4356$var$getParentSpan(scope, customParentSpan);
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? $93c45d57befd4356$var$startMissingRequiredParentSpan(scope, (0, $6486f3d311605b78$export$6bb76d6eba7e258c)()) : $93c45d57befd4356$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$93c45d57befd4356$var$_isIgnoredSpan(activeSpan) || !parentSpan) (0, $9f9cfe5727c3ad26$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $e47550d94a838770$export$18ce21a8b7efd7e9)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                const { status: status } = (0, $cac16f6eada858e7$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $f217ebe7a0a6fc3c$export$f966a0446ece71e),
                    message: "internal_error"
                });
            });
        });
    });
}
function $93c45d57befd4356$export$63dbba021a6b4047(options) {
    const acs = $93c45d57befd4356$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $93c45d57befd4356$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    const wrapper = options.scope ? (callback)=>(0, $6486f3d311605b78$export$ec58d9285c204497)(options.scope, callback) : customParentSpan !== void 0 ? (callback)=>$93c45d57befd4356$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
        const parentSpan = $93c45d57befd4356$var$getParentSpan(scope, customParentSpan);
        const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
        const missingRequiredParent = options.onlyIfParent && !parentSpan;
        if (missingRequiredParent) return $93c45d57befd4356$var$startMissingRequiredParentSpan(scope, client);
        return $93c45d57befd4356$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
const $93c45d57befd4356$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $3d29ea41beb10247$export$19eade501500c6c1)();
    const acs = (0, $e26a4b07a4ad38af$export$f639b0c2752203be)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    const incomingDsc = (0, $4d0fefb7946dcfa7$export$5b96ee2c8421f107)(baggage);
    if (client && !(0, $ae017cc8b57317cd$export$18811bc99eefceaa)(client, incomingDsc === null || incomingDsc === void 0 ? void 0 : incomingDsc.org_id)) return $93c45d57befd4356$export$f90b03291402f553(callback);
    return (0, $6486f3d311605b78$export$ec58d9285c204497)((scope)=>{
        const propagationContext = (0, $ae017cc8b57317cd$export$261f383d16a93e39)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        (0, $9f9cfe5727c3ad26$export$3f25fa50c18e20ca)(scope, void 0);
        return callback();
    });
};
function $93c45d57befd4356$export$e57ac09b143d92a2(span, callback) {
    const acs = $93c45d57befd4356$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $6486f3d311605b78$export$ec58d9285c204497)((scope)=>{
        (0, $9f9cfe5727c3ad26$export$3f25fa50c18e20ca)(scope, span || void 0);
        return callback(scope);
    });
}
function $93c45d57befd4356$export$869298f9835abc68(callback) {
    const acs = $93c45d57befd4356$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $6486f3d311605b78$export$ec58d9285c204497)((scope)=>{
        scope.setSDKProcessingMetadata({
            [$93c45d57befd4356$export$61ab4e30f2201736]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$93c45d57befd4356$export$61ab4e30f2201736]: void 0
        });
        return res;
    });
}
function $93c45d57befd4356$export$f90b03291402f553(callback) {
    const acs = $93c45d57befd4356$var$getAcs();
    if (acs.startNewTrace) return acs.startNewTrace(callback);
    return (0, $6486f3d311605b78$export$ec58d9285c204497)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $f56fc4041ba3a369$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $8aca1af6321ba44f$export$9869d72de32a3917)()
        });
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $93c45d57befd4356$export$e57ac09b143d92a2(null, callback);
    });
}
function $93c45d57befd4356$var$startMissingRequiredParentSpan(scope, client) {
    client === null || client === void 0 ? void 0 : client.recordDroppedEvent("no_parent_span", "span");
    const span = new (0, $ca20a23f2fb66f57$export$d6636b700b76c516)({
        traceId: scope.getPropagationContext().traceId
    });
    (0, $f7bbc910493e6179$export$cddb4027e3b0dd66)(span, scope, (0, $6486f3d311605b78$export$68f3af03034c9e90)());
    return span;
}
function $93c45d57befd4356$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    const isolationScope = (0, $6486f3d311605b78$export$68f3af03034c9e90)();
    if (!(0, $8540c501196729c9$export$1f70765132c3c225)()) {
        const scopePropagationContext = (0, $9tqwB._)({}, isolationScope.getPropagationContext(), scope.getPropagationContext());
        const traceId = parentSpan ? parentSpan.spanContext().traceId : scopePropagationContext.traceId;
        const span2 = new (0, $ca20a23f2fb66f57$export$d6636b700b76c516)({
            traceId: traceId
        });
        if (parentSpan && !forceTransaction) (0, $cac16f6eada858e7$export$81397d924722cc65)(parentSpan, span2);
        (0, $f7bbc910493e6179$export$cddb4027e3b0dd66)(span2, scope, isolationScope);
        return span2;
    }
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    if ($93c45d57befd4356$var$_shouldIgnoreStreamedSpan(client, spanArguments)) {
        if (!$93c45d57befd4356$var$_isTracingSuppressed(scope)) client === null || client === void 0 ? void 0 : client.recordDroppedEvent("ignored", "span");
        var _parentSpan_spanContext_traceId;
        const ignoredSpan = new (0, $ca20a23f2fb66f57$export$d6636b700b76c516)({
            dropReason: "ignored",
            traceId: (_parentSpan_spanContext_traceId = parentSpan === null || parentSpan === void 0 ? void 0 : parentSpan.spanContext().traceId) !== null && _parentSpan_spanContext_traceId !== void 0 ? _parentSpan_spanContext_traceId : scope.getPropagationContext().traceId
        });
        (0, $f7bbc910493e6179$export$cddb4027e3b0dd66)(ignoredSpan, scope, isolationScope);
        return ignoredSpan;
    }
    let span;
    if (parentSpan && !forceTransaction) {
        span = $93c45d57befd4356$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope);
        (0, $cac16f6eada858e7$export$81397d924722cc65)(parentSpan, span);
    } else if (parentSpan) {
        const dsc = (0, $5c79f8c2b5cb59fa$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $cac16f6eada858e7$export$5caecac1caaf3a71)(parentSpan);
        span = $93c45d57befd4356$var$_startRootSpan((0, $9tqwB._)({
            traceId: traceId,
            parentSpanId: parentSpanId
        }, spanArguments), scope, isolationScope, parentSampled);
        (0, $5c79f8c2b5cb59fa$export$7398c93e763ca9fd)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = (0, $9tqwB._)({}, isolationScope.getPropagationContext(), scope.getPropagationContext());
        span = $93c45d57befd4356$var$_startRootSpan((0, $9tqwB._)({
            traceId: traceId,
            parentSpanId: parentSpanId
        }, spanArguments), scope, isolationScope, parentSampled);
        if (dsc) (0, $5c79f8c2b5cb59fa$export$7398c93e763ca9fd)(span, dsc);
    }
    (0, $ac09a37575b310ba$export$2f3d84e767c9592b)(span);
    return span;
}
function $93c45d57befd4356$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = (0, $9tqwB._)({
        isStandalone: exp.standalone
    }, options);
    if (options.startTime) {
        const ctx = (0, $9tqwB._)({}, initialCtx);
        ctx.startTimestamp = (0, $cac16f6eada858e7$export$3f7581298f56c6d7)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $93c45d57befd4356$var$getAcs() {
    const carrier = (0, $3d29ea41beb10247$export$19eade501500c6c1)();
    return (0, $e26a4b07a4ad38af$export$f639b0c2752203be)(carrier);
}
function $93c45d57befd4356$var$_startRootSpan(spanArguments, scope, isolationScope, parentSampled) {
    var _currentPropagationContext_dsc;
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    const options = (client === null || client === void 0 ? void 0 : client.getOptions()) || {};
    const { name: name = "" } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: (0, $9tqwB._)({}, spanArguments.attributes),
        spanName: name,
        parentSampled: parentSampled
    };
    client === null || client === void 0 ? void 0 : client.emit("beforeSampling", mutableSpanSamplingData, {
        decision: false
    });
    var _mutableSpanSamplingData_parentSampled;
    const finalParentSampled = (_mutableSpanSamplingData_parentSampled = mutableSpanSamplingData.parentSampled) !== null && _mutableSpanSamplingData_parentSampled !== void 0 ? _mutableSpanSamplingData_parentSampled : parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const isTracingSuppressed = $93c45d57befd4356$var$_isTracingSuppressed(scope);
    const [sampled, sampleRate, localSampleRateWasApplied] = isTracingSuppressed ? [
        false
    ] : (0, $c763fd1ae3ee0fd4$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        parentSampleRate: (0, $ab7c7053b878f035$export$a5bd2d81656d9546)((_currentPropagationContext_dsc = currentPropagationContext.dsc) === null || _currentPropagationContext_dsc === void 0 ? void 0 : _currentPropagationContext_dsc.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new (0, $4c5fac8529c371f2$export$a92149b045260d9f)((0, $2qxEV._)((0, $9tqwB._)({}, spanArguments), {
        attributes: (0, $9tqwB._)({
            [(0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405)]: "custom",
            [(0, $fdf17a1e56d9d4ca$export$ccfe0a40627cc34b)]: sampleRate !== void 0 && localSampleRateWasApplied ? sampleRate : void 0
        }, finalAttributes),
        sampled: sampled
    }));
    if (!sampled && client && !isTracingSuppressed) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log("[Tracing] Discarding root span because its trace was not chosen to be sampled.");
        client.recordDroppedEvent("sample_rate", (0, $5da71dc6e7ad8d8b$export$6ea47215d699c04a)(client) ? "span" : "transaction");
    }
    (0, $f7bbc910493e6179$export$cddb4027e3b0dd66)(rootSpan, scope, isolationScope);
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
function $93c45d57befd4356$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const isTracingSuppressed = $93c45d57befd4356$var$_isTracingSuppressed(scope);
    const sampled = isTracingSuppressed ? false : (0, $cac16f6eada858e7$export$5caecac1caaf3a71)(parentSpan);
    const childSpan = sampled ? new (0, $4c5fac8529c371f2$export$a92149b045260d9f)((0, $2qxEV._)((0, $9tqwB._)({}, spanArguments), {
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    })) : new (0, $ca20a23f2fb66f57$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $cac16f6eada858e7$export$81397d924722cc65)(parentSpan, childSpan);
    (0, $f7bbc910493e6179$export$cddb4027e3b0dd66)(childSpan, scope, isolationScope);
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    if (!client) return childSpan;
    if ((0, $5da71dc6e7ad8d8b$export$6ea47215d699c04a)(client) && (0, $ca20a23f2fb66f57$export$61cc547d99783aa7)(childSpan)) {
        if ((0, $ca20a23f2fb66f57$export$61cc547d99783aa7)(parentSpan) && parentSpan.dropReason) {
            childSpan.dropReason = parentSpan.dropReason;
            client.recordDroppedEvent(parentSpan.dropReason, "span");
        } else if (!isTracingSuppressed) {
            childSpan.dropReason = "sample_rate";
            client.recordDroppedEvent("sample_rate", "span");
        }
    }
    client.emit("spanStart", childSpan);
    if (spanArguments.endTimestamp) {
        client.emit("spanEnd", childSpan);
        client.emit("afterSpanEnd", childSpan);
    }
    return childSpan;
}
function $93c45d57befd4356$var$getParentSpan(scope, customParentSpan) {
    if (customParentSpan) return customParentSpan;
    if (customParentSpan === null) return void 0;
    const span = (0, $9f9cfe5727c3ad26$export$91f063ebb8eff307)(scope);
    if (!span) return void 0;
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(span);
    return span;
}
function $93c45d57befd4356$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== void 0 ? (callback)=>{
        return $93c45d57befd4356$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}
function $93c45d57befd4356$var$_shouldIgnoreStreamedSpan(client, spanArguments) {
    var _spanArguments_attributes;
    const ignoreSpans = client === null || client === void 0 ? void 0 : client.getOptions().ignoreSpans;
    if (!client || !(0, $5da71dc6e7ad8d8b$export$6ea47215d699c04a)(client) || !(ignoreSpans === null || ignoreSpans === void 0 ? void 0 : ignoreSpans.length)) return false;
    return (0, $3ba72cc613510e20$export$5d569ac97c389400)({
        description: spanArguments.name || "",
        op: ((_spanArguments_attributes = spanArguments.attributes) === null || _spanArguments_attributes === void 0 ? void 0 : _spanArguments_attributes[0, $fdf17a1e56d9d4ca$export$1a413bd9a88fdb09]) || spanArguments.op,
        attributes: spanArguments.attributes
    }, ignoreSpans);
}
function $93c45d57befd4356$var$_isIgnoredSpan(span) {
    return (0, $ca20a23f2fb66f57$export$61cc547d99783aa7)(span) && span.dropReason === "ignored";
}
function $93c45d57befd4356$var$_isTracingSuppressed(scope) {
    return scope.getScopeData().sdkProcessingMetadata[$93c45d57befd4356$export$61ab4e30f2201736] === true;
}





const $54e4fda4a93f056f$export$91ec2be6fdd8f1b4 = (cb)=>{
    const onHiddenOrPageHide = (event)=>{
        var _WINDOW_document;
        if (event.type === "pagehide" || ((_WINDOW_document = (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.visibilityState) === "hidden") cb(event);
    };
    (0, $714f4a09de6c5df8$export$26d3d892edc56833)("visibilitychange", onHiddenOrPageHide, {
        capture: true,
        once: true
    });
    (0, $714f4a09de6c5df8$export$26d3d892edc56833)("pagehide", onHiddenOrPageHide, {
        capture: true,
        once: true
    });
};


function $f43b6f40a361b790$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
function $f43b6f40a361b790$export$7567a67bdb69a23d(parentSpan, startTimeInSeconds, endTime, _param) {
    var ctx = (0, $8d60f2ee7fd1c983$export$71511d61b312f219)({}, (0, $7ae6b455e4a352e9$export$71511d61b312f219)(_param));
    const parentStartTime = (0, $cac16f6eada858e7$export$92d8c23565496537)(parentSpan).start_timestamp;
    if (parentStartTime && parentStartTime > startTimeInSeconds) {
        if (typeof parentSpan.updateStartTime === "function") parentSpan.updateStartTime(startTimeInSeconds);
    }
    return (0, $93c45d57befd4356$export$e57ac09b143d92a2)(parentSpan, ()=>{
        const span = (0, $93c45d57befd4356$export$63dbba021a6b4047)((0, $9tqwB._)({
            startTime: startTimeInSeconds
        }, ctx));
        if (span) span.end(endTime);
        return span;
    });
}
function $f43b6f40a361b790$export$b71b9c7b60c5a4aa(options) {
    var _WINDOW_navigator;
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    if (!client) return;
    const { name: name, transaction: transaction, attributes: passedAttributes, startTime: startTime } = options;
    const { release: release, environment: environment } = client.getOptions();
    const { userInfo: userInfo } = client.getDataCollectionOptions();
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay === null || replay === void 0 ? void 0 : replay.getReplayId();
    const scope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
    const user = scope.getUser();
    const userDisplay = user !== void 0 ? user.email || user.id || user.ip_address : void 0;
    let profileId;
    try {
        profileId = scope.getScopeData().contexts.profile.profile_id;
    } catch (e) {}
    const attributes = (0, $9tqwB._)({
        release: release,
        environment: environment,
        user: userDisplay || void 0,
        profile_id: profileId || void 0,
        replay_id: replayId || void 0,
        transaction: transaction,
        // Web vital score calculation relies on the user agent to account for different
        // browsers setting different thresholds for what is considered a good/meh/bad value.
        // For example: Chrome vs. Chrome Mobile
        "user_agent.original": (_WINDOW_navigator = (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).navigator) === null || _WINDOW_navigator === void 0 ? void 0 : _WINDOW_navigator.userAgent,
        // This tells Sentry to infer the IP address from the request
        "client.address": userInfo ? "{{auto}}" : void 0
    }, passedAttributes);
    return (0, $93c45d57befd4356$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        experimental: {
            standalone: true
        }
    });
}
function $f43b6f40a361b790$export$f72a13c439a30cab() {
    return (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).addEventListener && (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).performance;
}
function $f43b6f40a361b790$export$b4785dbd4a81b33f(time) {
    return time / 1e3;
}
function $f43b6f40a361b790$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) name = _name;
    return {
        name: name,
        version: version
    };
}
function $f43b6f40a361b790$export$c7533a7b4a9f2e94(entryType) {
    try {
        return PerformanceObserver.supportedEntryTypes.includes(entryType);
    } catch (e) {
        return false;
    }
}
function $f43b6f40a361b790$export$382ad360b45665ab(client, collectorCallback) {
    let pageloadSpan;
    let collected = false;
    function _runCollectorCallbackOnce(event) {
        if (!collected && pageloadSpan) collectorCallback(event, pageloadSpan.spanContext().spanId, pageloadSpan);
        collected = true;
    }
    (0, $54e4fda4a93f056f$export$91ec2be6fdd8f1b4)(()=>{
        _runCollectorCallbackOnce("pagehide");
    });
    const unsubscribeStartNavigation = client.on("beforeStartNavigationSpan", (_, options)=>{
        if (!(options === null || options === void 0 ? void 0 : options.isRedirect)) {
            _runCollectorCallbackOnce("navigation");
            unsubscribeStartNavigation();
            unsubscribeAfterStartPageLoadSpan();
        }
    });
    const unsubscribeAfterStartPageLoadSpan = client.on("afterStartPageLoadSpan", (span)=>{
        pageloadSpan = span;
        unsubscribeAfterStartPageLoadSpan();
    });
}


function $bc0094395f1965c8$export$585bab03c6c18c45(client) {
    let standaloneCLsValue = 0;
    let standaloneClsEntry;
    if (!(0, $f43b6f40a361b790$export$c7533a7b4a9f2e94)("layout-shift")) return;
    const cleanupClsHandler = (0, $5d4e4d5b5c2c563b$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneCLsValue = metric.value;
        standaloneClsEntry = entry;
    }, true);
    (0, $f43b6f40a361b790$export$382ad360b45665ab)(client, (reportEvent, pageloadSpanId)=>{
        $bc0094395f1965c8$export$910bd4e865129f07(standaloneCLsValue, standaloneClsEntry, pageloadSpanId, reportEvent);
        cleanupClsHandler();
    });
}
function $bc0094395f1965c8$export$910bd4e865129f07(clsValue, entry, pageloadSpanId, reportEvent) {
    var _entry_sources_;
    (0, $3e6faad079da1d06$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Sending CLS span (${clsValue})`);
    const startTime = entry ? (0, $f43b6f40a361b790$export$b4785dbd4a81b33f)(((0, $b007b72e24b33b62$export$baf075a948ffc0bf)() || 0) + entry.startTime) : (0, $b007b72e24b33b62$export$ee52dced521e3e18)();
    const routeName = (0, $6486f3d311605b78$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = entry ? (0, $d6cf245db051044b$export$5647df6b7814ac86)((_entry_sources_ = entry.sources[0]) === null || _entry_sources_ === void 0 ? void 0 : _entry_sources_.node) : "Layout shift";
    const attributes = {
        [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: "auto.http.browser.cls",
        [(0, $fdf17a1e56d9d4ca$export$1a413bd9a88fdb09)]: "ui.webvital.cls",
        [(0, $fdf17a1e56d9d4ca$export$fea48ba9f4550879)]: 0,
        // attach the pageload span id to the CLS span so that we can link them in the UI
        "sentry.pageload.span_id": pageloadSpanId,
        // describes what triggered the web vital to be reported
        "sentry.report_event": reportEvent
    };
    if (entry === null || entry === void 0 ? void 0 : entry.sources) entry.sources.forEach((source, index)=>{
        attributes[`cls.source.${index + 1}`] = (0, $d6cf245db051044b$export$5647df6b7814ac86)(source.node);
    });
    const span = (0, $f43b6f40a361b790$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent("cls", {
            [(0, $fdf17a1e56d9d4ca$export$f5f95cff026507b5)]: "",
            [(0, $fdf17a1e56d9d4ca$export$69cd5c610c7bb96a)]: clsValue
        });
        span.end(startTime);
    }
}








const $1cda4029ac36714a$export$ccce4d286bdc973b = 6e4;
function $1cda4029ac36714a$export$e59775b7d17699ba(lcpValue) {
    return lcpValue != null && lcpValue > 0 && lcpValue <= $1cda4029ac36714a$export$ccce4d286bdc973b;
}
function $1cda4029ac36714a$export$485112b2cb5f79dc(client) {
    let standaloneLcpValue = 0;
    let standaloneLcpEntry;
    if (!(0, $f43b6f40a361b790$export$c7533a7b4a9f2e94)("largest-contentful-paint")) return;
    const cleanupLcpHandler = (0, $5d4e4d5b5c2c563b$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry || !$1cda4029ac36714a$export$e59775b7d17699ba(metric.value)) return;
        standaloneLcpValue = metric.value;
        standaloneLcpEntry = entry;
    }, true);
    (0, $f43b6f40a361b790$export$382ad360b45665ab)(client, (reportEvent, pageloadSpanId)=>{
        $1cda4029ac36714a$export$1c28dab7ad4ec937(standaloneLcpValue, standaloneLcpEntry, pageloadSpanId, reportEvent);
        cleanupLcpHandler();
    });
}
function $1cda4029ac36714a$export$1c28dab7ad4ec937(lcpValue, entry, pageloadSpanId, reportEvent) {
    if (!$1cda4029ac36714a$export$e59775b7d17699ba(lcpValue)) return;
    (0, $3e6faad079da1d06$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Sending LCP span (${lcpValue})`);
    const startTime = (0, $f43b6f40a361b790$export$b4785dbd4a81b33f)(((0, $b007b72e24b33b62$export$baf075a948ffc0bf)() || 0) + ((entry === null || entry === void 0 ? void 0 : entry.startTime) || 0));
    const routeName = (0, $6486f3d311605b78$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = entry ? (0, $d6cf245db051044b$export$5647df6b7814ac86)(entry.element) : "Largest contentful paint";
    const attributes = {
        [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: "auto.http.browser.lcp",
        [(0, $fdf17a1e56d9d4ca$export$1a413bd9a88fdb09)]: "ui.webvital.lcp",
        [(0, $fdf17a1e56d9d4ca$export$fea48ba9f4550879)]: 0,
        // LCP is a point-in-time metric
        // attach the pageload span id to the LCP span so that we can link them in the UI
        "sentry.pageload.span_id": pageloadSpanId,
        // describes what triggered the web vital to be reported
        "sentry.report_event": reportEvent
    };
    if (entry) {
        entry.element && (attributes["lcp.element"] = (0, $d6cf245db051044b$export$5647df6b7814ac86)(entry.element));
        entry.id && (attributes["lcp.id"] = entry.id);
        entry.url && (attributes["lcp.url"] = entry.url);
        entry.loadTime != null && (attributes["lcp.loadTime"] = entry.loadTime);
        entry.renderTime != null && (attributes["lcp.renderTime"] = entry.renderTime);
        entry.size != null && (attributes["lcp.size"] = entry.size);
    }
    const span = (0, $f43b6f40a361b790$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent("lcp", {
            [(0, $fdf17a1e56d9d4ca$export$f5f95cff026507b5)]: "millisecond",
            [(0, $fdf17a1e56d9d4ca$export$69cd5c610c7bb96a)]: lcpValue
        });
        span.end(startTime);
    }
}



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


function $4b982bae59115902$var$getAbsoluteTime(time) {
    return time ? (((0, $b007b72e24b33b62$export$baf075a948ffc0bf)() || performance.timeOrigin) + time) / 1e3 : time;
}
function $4b982bae59115902$export$ec50b091612e7e00(resourceTiming) {
    var _getBrowserPerformanceAPI;
    const timingSpanData = {};
    if (resourceTiming.nextHopProtocol != void 0) {
        const { name: name, version: version } = (0, $f43b6f40a361b790$export$57c6f824442f9fe1)(resourceTiming.nextHopProtocol);
        timingSpanData["network.protocol.version"] = version;
        timingSpanData["network.protocol.name"] = name;
    }
    if (!((0, $b007b72e24b33b62$export$baf075a948ffc0bf)() || ((_getBrowserPerformanceAPI = (0, $f43b6f40a361b790$export$f72a13c439a30cab)()) === null || _getBrowserPerformanceAPI === void 0 ? void 0 : _getBrowserPerformanceAPI.timeOrigin))) return timingSpanData;
    return $4b982bae59115902$var$dropUndefinedKeysFromObject((0, $2qxEV._)((0, $9tqwB._)({}, timingSpanData), {
        "http.request.redirect_start": $4b982bae59115902$var$getAbsoluteTime(resourceTiming.redirectStart),
        "http.request.redirect_end": $4b982bae59115902$var$getAbsoluteTime(resourceTiming.redirectEnd),
        "http.request.worker_start": $4b982bae59115902$var$getAbsoluteTime(resourceTiming.workerStart),
        "http.request.fetch_start": $4b982bae59115902$var$getAbsoluteTime(resourceTiming.fetchStart),
        "http.request.domain_lookup_start": $4b982bae59115902$var$getAbsoluteTime(resourceTiming.domainLookupStart),
        "http.request.domain_lookup_end": $4b982bae59115902$var$getAbsoluteTime(resourceTiming.domainLookupEnd),
        "http.request.connect_start": $4b982bae59115902$var$getAbsoluteTime(resourceTiming.connectStart),
        "http.request.secure_connection_start": $4b982bae59115902$var$getAbsoluteTime(resourceTiming.secureConnectionStart),
        "http.request.connection_end": $4b982bae59115902$var$getAbsoluteTime(resourceTiming.connectEnd),
        "http.request.request_start": $4b982bae59115902$var$getAbsoluteTime(resourceTiming.requestStart),
        "http.request.response_start": $4b982bae59115902$var$getAbsoluteTime(resourceTiming.responseStart),
        "http.request.response_end": $4b982bae59115902$var$getAbsoluteTime(resourceTiming.responseEnd),
        // For TTFB we actually want the relative time from timeOrigin to responseStart
        // This way, TTFB always measures the "first page load" experience.
        // see: https://web.dev/articles/ttfb#measure-resource-requests
        "http.request.time_to_first_byte": resourceTiming.responseStart != null ? resourceTiming.responseStart / 1e3 : void 0
    }));
}
function $4b982bae59115902$var$dropUndefinedKeysFromObject(attrs) {
    return Object.fromEntries(Object.entries(attrs).filter(([, value])=>value != null));
}







const $00afd3b4f9d0757f$var$MAX_INT_AS_BYTES = 2147483647;
let $00afd3b4f9d0757f$var$_performanceCursor = 0;
let $00afd3b4f9d0757f$var$_measurements = {};
let $00afd3b4f9d0757f$var$_lcpEntry;
let $00afd3b4f9d0757f$var$_clsEntry;
function $00afd3b4f9d0757f$export$7c69f0412d101b88({ recordClsStandaloneSpans: recordClsStandaloneSpans, recordLcpStandaloneSpans: recordLcpStandaloneSpans, client: client }) {
    const performance = (0, $f43b6f40a361b790$export$f72a13c439a30cab)();
    if (performance && (0, $b007b72e24b33b62$export$baf075a948ffc0bf)()) {
        if (performance.mark) (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).performance.mark("sentry-tracing-init");
        const lcpCleanupCallback = recordLcpStandaloneSpans ? (0, $1cda4029ac36714a$export$485112b2cb5f79dc)(client) : recordLcpStandaloneSpans === false ? $00afd3b4f9d0757f$var$_trackLCP() : void 0;
        const clsCleanupCallback = recordClsStandaloneSpans ? (0, $bc0094395f1965c8$export$585bab03c6c18c45)(client) : recordClsStandaloneSpans === false ? $00afd3b4f9d0757f$var$_trackCLS() : void 0;
        const ttfbCleanupCallback = $00afd3b4f9d0757f$var$_trackTtfb();
        const fpFcpCleanupCallback = $00afd3b4f9d0757f$var$_trackFpFcp();
        return ()=>{
            ttfbCleanupCallback();
            fpFcpCleanupCallback();
            lcpCleanupCallback === null || lcpCleanupCallback === void 0 ? void 0 : lcpCleanupCallback();
            clsCleanupCallback === null || clsCleanupCallback === void 0 ? void 0 : clsCleanupCallback();
        };
    }
    return ()=>void 0;
}
function $00afd3b4f9d0757f$export$f396d19077034ad2() {
    (0, $5d4e4d5b5c2c563b$export$69816c1a049f8db6)("longtask", ({ entries: entries })=>{
        const parent = (0, $cac16f6eada858e7$export$1be426a8e585c83e)();
        if (!parent) return;
        const { op: parentOp, start_timestamp: parentStartTimestamp } = (0, $cac16f6eada858e7$export$92d8c23565496537)(parent);
        for (const entry of entries){
            const startTime = (0, $f43b6f40a361b790$export$b4785dbd4a81b33f)((0, $b007b72e24b33b62$export$baf075a948ffc0bf)() + entry.startTime);
            const duration = (0, $f43b6f40a361b790$export$b4785dbd4a81b33f)(entry.duration);
            if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            (0, $f43b6f40a361b790$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: "Main UI thread blocked",
                op: "ui.long-task",
                attributes: {
                    [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            });
        }
    });
}
function $00afd3b4f9d0757f$export$5b823ab2ccbc801d() {
    const observer = new PerformanceObserver((list)=>{
        const parent = (0, $cac16f6eada858e7$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of list.getEntries()){
            if (!entry.scripts[0]) continue;
            const startTime = (0, $f43b6f40a361b790$export$b4785dbd4a81b33f)((0, $b007b72e24b33b62$export$baf075a948ffc0bf)() + entry.startTime);
            const { start_timestamp: parentStartTimestamp, op: parentOp } = (0, $cac16f6eada858e7$export$92d8c23565496537)(parent);
            if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            const duration = (0, $f43b6f40a361b790$export$b4785dbd4a81b33f)(entry.duration);
            const attributes = {
                [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            };
            const initialScript = entry.scripts[0];
            const { invoker: invoker, invokerType: invokerType, sourceURL: sourceURL, sourceFunctionName: sourceFunctionName, sourceCharPosition: sourceCharPosition } = initialScript;
            attributes["browser.script.invoker"] = invoker;
            attributes["browser.script.invoker_type"] = invokerType;
            if (sourceURL) attributes["code.filepath"] = sourceURL;
            if (sourceFunctionName) attributes["code.function"] = sourceFunctionName;
            if (sourceCharPosition !== -1) attributes["browser.script.source_char_position"] = sourceCharPosition;
            (0, $f43b6f40a361b790$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: "Main UI thread blocked",
                op: "ui.long-animation-frame",
                attributes: attributes
            });
        }
    });
    observer.observe({
        type: "long-animation-frame",
        buffered: true
    });
}
function $00afd3b4f9d0757f$export$e27543e0976315e4() {
    (0, $5d4e4d5b5c2c563b$export$69816c1a049f8db6)("event", ({ entries: entries })=>{
        const parent = (0, $cac16f6eada858e7$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of entries)if (entry.name === "click") {
            const startTime = (0, $f43b6f40a361b790$export$b4785dbd4a81b33f)((0, $b007b72e24b33b62$export$baf075a948ffc0bf)() + entry.startTime);
            const duration = (0, $f43b6f40a361b790$export$b4785dbd4a81b33f)(entry.duration);
            const spanOptions = {
                name: (0, $d6cf245db051044b$export$5647df6b7814ac86)(entry.target),
                op: `ui.interaction.${entry.name}`,
                startTime: startTime,
                attributes: {
                    [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            };
            const componentName = (0, $0ff4a1c827ec052f$export$26727cfcc4d7e0fc)(entry.target);
            if (componentName) spanOptions.attributes["ui.component_name"] = componentName;
            (0, $f43b6f40a361b790$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, spanOptions);
        }
    });
}
function $00afd3b4f9d0757f$var$_trackCLS() {
    return (0, $5d4e4d5b5c2c563b$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $00afd3b4f9d0757f$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $00afd3b4f9d0757f$var$_clsEntry = entry;
    }, true);
}
function $00afd3b4f9d0757f$var$_trackLCP() {
    return (0, $5d4e4d5b5c2c563b$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry || !(0, $1cda4029ac36714a$export$e59775b7d17699ba)(metric.value)) return;
        $00afd3b4f9d0757f$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $00afd3b4f9d0757f$var$_lcpEntry = entry;
    }, true);
}
function $00afd3b4f9d0757f$var$_trackTtfb() {
    return (0, $5d4e4d5b5c2c563b$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $00afd3b4f9d0757f$var$_measurements["ttfb"] = {
            value: metric.value,
            unit: "millisecond"
        };
    });
}
function $00afd3b4f9d0757f$var$_trackFpFcp() {
    return (0, $5d4e4d5b5c2c563b$export$69816c1a049f8db6)("paint", ({ entries: entries })=>{
        const firstHidden = (0, $7a8db8f65d4c7464$export$443f86b2c77012c4)();
        for (const entry of entries){
            const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
            if (entry.name === "first-paint" && shouldRecord) $00afd3b4f9d0757f$var$_measurements["fp"] = {
                value: entry.startTime,
                unit: "millisecond"
            };
            if (entry.name === "first-contentful-paint" && shouldRecord) $00afd3b4f9d0757f$var$_measurements["fcp"] = {
                value: entry.startTime,
                unit: "millisecond"
            };
        }
    });
}
function $00afd3b4f9d0757f$export$5f8fa6b3467a7443(span, options) {
    const performance = (0, $f43b6f40a361b790$export$f72a13c439a30cab)();
    const origin = (0, $b007b72e24b33b62$export$baf075a948ffc0bf)();
    if (!(performance === null || performance === void 0 ? void 0 : performance.getEntries) || !origin) return;
    const { spanStreamingEnabled: spanStreamingEnabled, ignorePerformanceApiSpans: ignorePerformanceApiSpans, ignoreResourceSpans: ignoreResourceSpans } = options;
    const timeOrigin = (0, $f43b6f40a361b790$export$b4785dbd4a81b33f)(origin);
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $cac16f6eada858e7$export$92d8c23565496537)(span);
    performanceEntries.slice($00afd3b4f9d0757f$var$_performanceCursor).forEach((entry)=>{
        const startTime = (0, $f43b6f40a361b790$export$b4785dbd4a81b33f)(entry.startTime);
        const duration = (0, $f43b6f40a361b790$export$b4785dbd4a81b33f)(// Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
        // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
        // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
        // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
        Math.max(0, entry.duration));
        if (op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $00afd3b4f9d0757f$export$90a8fd571ed9a1bc(span, entry, timeOrigin);
                break;
            case "mark":
            case "paint":
            case "measure":
                $00afd3b4f9d0757f$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans);
                break;
            case "resource":
                $00afd3b4f9d0757f$export$c82fe1a70634f317(span, entry, entry.name, startTime, duration, timeOrigin, ignoreResourceSpans);
                break;
        }
    });
    $00afd3b4f9d0757f$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $00afd3b4f9d0757f$var$_trackNavigator(span, spanStreamingEnabled);
}
function $00afd3b4f9d0757f$export$d14e394b690acc17(span, options) {
    var _getBrowserPerformanceAPI;
    const origin = (0, $b007b72e24b33b62$export$baf075a948ffc0bf)();
    if (!((_getBrowserPerformanceAPI = (0, $f43b6f40a361b790$export$f72a13c439a30cab)()) === null || _getBrowserPerformanceAPI === void 0 ? void 0 : _getBrowserPerformanceAPI.getEntries) || !origin) {
        $00afd3b4f9d0757f$var$resetWebVitalState();
        return;
    }
    const { spanStreamingEnabled: spanStreamingEnabled, recordClsOnPageloadSpan: recordClsOnPageloadSpan, recordLcpOnPageloadSpan: recordLcpOnPageloadSpan } = options;
    const timeOrigin = (0, $f43b6f40a361b790$export$b4785dbd4a81b33f)(origin);
    if ((0, $cac16f6eada858e7$export$92d8c23565496537)(span).op === "pageload") {
        $00afd3b4f9d0757f$var$_addTtfbRequestTimeToMeasurements($00afd3b4f9d0757f$var$_measurements);
        if (spanStreamingEnabled) {
            const setAttr = (shortWebVitalName, value, customAttrName)=>{
                const attrKey = customAttrName !== null && customAttrName !== void 0 ? customAttrName : `browser.web_vital.${shortWebVitalName}.value`;
                span.setAttribute(attrKey, value);
                (0, $3e6faad079da1d06$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log("Setting web vital attribute", {
                    [attrKey]: value
                }, "on pageload span");
            };
            [
                "ttfb",
                "fp",
                "fcp"
            ].forEach((measurementName)=>{
                if ($00afd3b4f9d0757f$var$_measurements[measurementName]) setAttr(measurementName, $00afd3b4f9d0757f$var$_measurements[measurementName].value);
            });
            if ($00afd3b4f9d0757f$var$_measurements["ttfb.requestTime"]) setAttr("ttfb.requestTime", $00afd3b4f9d0757f$var$_measurements["ttfb.requestTime"].value, "browser.web_vital.ttfb.request_time");
        } else {
            if (!recordClsOnPageloadSpan) delete $00afd3b4f9d0757f$var$_measurements.cls;
            if (!recordLcpOnPageloadSpan) delete $00afd3b4f9d0757f$var$_measurements.lcp;
            Object.entries($00afd3b4f9d0757f$var$_measurements).forEach(([measurementName, measurement])=>{
                (0, $293a838d63649350$export$7cc31b475d33a706)(measurementName, measurement.value, measurement.unit, span);
            });
            $00afd3b4f9d0757f$var$_setWebVitalAttributes(span, options);
        }
        span.setAttribute(spanStreamingEnabled ? "browser.performance.time_origin" : "performance.timeOrigin", timeOrigin);
        span.setAttribute(spanStreamingEnabled ? "browser.performance.navigation.activation_start" : "performance.activationStart", (0, $465128e00102ae0f$export$d3e828b3c7b5b845)());
    }
    $00afd3b4f9d0757f$var$resetWebVitalState();
}
function $00afd3b4f9d0757f$var$resetWebVitalState() {
    $00afd3b4f9d0757f$var$_lcpEntry = void 0;
    $00afd3b4f9d0757f$var$_clsEntry = void 0;
    $00afd3b4f9d0757f$var$_measurements = {};
}
function $00afd3b4f9d0757f$var$isReact19MeasureEntry(entry) {
    if ((entry === null || entry === void 0 ? void 0 : entry.entryType) !== "measure") return;
    try {
        return entry.detail.devtools.track === "Components \u269B";
    } catch (e) {
        return;
    }
}
function $00afd3b4f9d0757f$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans) {
    if ($00afd3b4f9d0757f$var$isReact19MeasureEntry(entry)) return;
    if ([
        "mark",
        "measure"
    ].includes(entry.entryType) && (0, $6c937b4b236937d4$export$a7a5ec66062ea5d)(entry.name, ignorePerformanceApiSpans)) return;
    const navEntry = (0, $f907d1cd0e842264$export$6431553786c94949)(false);
    const requestTime = (0, $f43b6f40a361b790$export$b4785dbd4a81b33f)(navEntry ? navEntry.requestStart : 0);
    const measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
    const startTimeStamp = timeOrigin + startTime;
    const measureEndTimestamp = startTimeStamp + duration;
    const attributes = {
        [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: "auto.resource.browser.metrics"
    };
    if (measureStartTimestamp !== startTimeStamp) {
        attributes["sentry.browser.measure_happened_before_request"] = true;
        attributes["sentry.browser.measure_start_time"] = measureStartTimestamp;
    }
    $00afd3b4f9d0757f$var$_addDetailToSpanAttributes(attributes, entry);
    if (measureStartTimestamp <= measureEndTimestamp) (0, $f43b6f40a361b790$export$7567a67bdb69a23d)(span, measureStartTimestamp, measureEndTimestamp, {
        name: entry.name,
        op: entry.entryType,
        attributes: attributes
    });
}
function $00afd3b4f9d0757f$var$_addDetailToSpanAttributes(attributes, performanceMeasure) {
    try {
        const detail = performanceMeasure.detail;
        if (!detail) return;
        if (typeof detail === "object") {
            for (const [key, value] of Object.entries(detail)){
                if (value && (0, $85e272e760900bb9$export$c3825b437cbdea5c)(value)) attributes[`sentry.browser.measure.detail.${key}`] = value;
                else if (value !== void 0) try {
                    attributes[`sentry.browser.measure.detail.${key}`] = JSON.stringify(value);
                } catch (e) {}
            }
            return;
        }
        if ((0, $85e272e760900bb9$export$c3825b437cbdea5c)(detail)) {
            attributes["sentry.browser.measure.detail"] = detail;
            return;
        }
        try {
            attributes["sentry.browser.measure.detail"] = JSON.stringify(detail);
        } catch (e) {}
    } catch (e) {}
}
function $00afd3b4f9d0757f$export$90a8fd571ed9a1bc(span, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $00afd3b4f9d0757f$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin);
    });
    $00afd3b4f9d0757f$var$_addPerformanceNavigationTiming(span, entry, "secureConnection", timeOrigin, "TLS/SSL");
    $00afd3b4f9d0757f$var$_addPerformanceNavigationTiming(span, entry, "fetch", timeOrigin, "cache");
    $00afd3b4f9d0757f$var$_addPerformanceNavigationTiming(span, entry, "domainLookup", timeOrigin, "DNS");
    $00afd3b4f9d0757f$var$_addRequest(span, entry, timeOrigin);
}
function $00afd3b4f9d0757f$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin, name = event) {
    const eventEnd = $00afd3b4f9d0757f$var$_getEndPropertyNameForNavigationTiming(event);
    const end = entry[eventEnd];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $f43b6f40a361b790$export$7567a67bdb69a23d)(span, timeOrigin + (0, $f43b6f40a361b790$export$b4785dbd4a81b33f)(start), timeOrigin + (0, $f43b6f40a361b790$export$b4785dbd4a81b33f)(end), {
        op: `browser.${name}`,
        name: entry.name,
        attributes: (0, $9tqwB._)({
            [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
        }, event === "redirect" && entry.redirectCount != null ? {
            "http.redirect_count": entry.redirectCount
        } : {})
    });
}
function $00afd3b4f9d0757f$var$_getEndPropertyNameForNavigationTiming(event) {
    if (event === "secureConnection") return "connectEnd";
    if (event === "fetch") return "domainLookupStart";
    return `${event}End`;
}
function $00afd3b4f9d0757f$var$_addRequest(span, entry, timeOrigin) {
    const requestStartTimestamp = timeOrigin + (0, $f43b6f40a361b790$export$b4785dbd4a81b33f)(entry.requestStart);
    const responseEndTimestamp = timeOrigin + (0, $f43b6f40a361b790$export$b4785dbd4a81b33f)(entry.responseEnd);
    const responseStartTimestamp = timeOrigin + (0, $f43b6f40a361b790$export$b4785dbd4a81b33f)(entry.responseStart);
    if (entry.responseEnd) {
        (0, $f43b6f40a361b790$export$7567a67bdb69a23d)(span, requestStartTimestamp, responseEndTimestamp, {
            op: "browser.request",
            name: entry.name,
            attributes: {
                [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            }
        });
        (0, $f43b6f40a361b790$export$7567a67bdb69a23d)(span, responseStartTimestamp, responseEndTimestamp, {
            op: "browser.response",
            name: entry.name,
            attributes: {
                [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            }
        });
    }
}
function $00afd3b4f9d0757f$export$c82fe1a70634f317(span, entry, resourceUrl, startTime, duration, timeOrigin, ignoredResourceSpanOps) {
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const op = entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other";
    if (ignoredResourceSpanOps === null || ignoredResourceSpanOps === void 0 ? void 0 : ignoredResourceSpanOps.includes(op)) return;
    const attributes = {
        [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: "auto.resource.browser.metrics"
    };
    const parsedUrl = (0, $e3f8d2d1d7c51bd6$export$7a5253c0f62e0150)(resourceUrl);
    if (parsedUrl.protocol) attributes["url.scheme"] = parsedUrl.protocol.split(":").pop();
    if (parsedUrl.host) attributes["server.address"] = parsedUrl.host;
    attributes["url.same_origin"] = resourceUrl.includes((0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).location.origin);
    $00afd3b4f9d0757f$export$6ce741ceee01ab2f(entry, attributes, [
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus
        [
            "responseStatus",
            "http.response.status_code"
        ],
        [
            "transferSize",
            "http.response_transfer_size"
        ],
        [
            "encodedBodySize",
            "http.response_content_length"
        ],
        [
            "decodedBodySize",
            "http.decoded_response_content_length"
        ],
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/renderBlockingStatus
        [
            "renderBlockingStatus",
            "resource.render_blocking_status"
        ],
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/deliveryType
        [
            "deliveryType",
            "http.response_delivery_type"
        ]
    ]);
    const attributesWithResourceTiming = (0, $9tqwB._)({}, attributes, (0, $4b982bae59115902$export$ec50b091612e7e00)(entry));
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $f43b6f40a361b790$export$7567a67bdb69a23d)(span, startTimestamp, endTimestamp, {
        name: resourceUrl.replace((0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).location.origin, ""),
        op: op,
        attributes: attributesWithResourceTiming
    });
}
function $00afd3b4f9d0757f$var$_trackNavigator(span, spanStreamingEnabled) {
    const navigator = (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) span.setAttribute(spanStreamingEnabled ? "network.connection.effective_type" : "effectiveConnectionType", connection.effectiveType);
        if (connection.type) span.setAttribute(spanStreamingEnabled ? "network.connection.type" : "connectionType", connection.type);
        if ((0, $f43b6f40a361b790$export$27169ccae1b439e3)(connection.rtt)) {
            if (spanStreamingEnabled) span.setAttribute("network.connection.rtt", connection.rtt);
            else if ((0, $cac16f6eada858e7$export$92d8c23565496537)(span).op === "pageload") (0, $293a838d63649350$export$7cc31b475d33a706)("connection.rtt", connection.rtt, "millisecond");
        }
    }
    if ((0, $f43b6f40a361b790$export$27169ccae1b439e3)(navigator.deviceMemory)) {
        if (spanStreamingEnabled) span.setAttribute("device.memory.estimated_capacity", navigator.deviceMemory);
        else span.setAttribute("deviceMemory", `${navigator.deviceMemory} GB`);
    }
    if ((0, $f43b6f40a361b790$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) {
        if (spanStreamingEnabled) span.setAttribute("device.processor_count", navigator.hardwareConcurrency);
        else span.setAttribute("hardwareConcurrency", String(navigator.hardwareConcurrency));
    }
}
function $00afd3b4f9d0757f$var$_setWebVitalAttributes(span, options) {
    if ($00afd3b4f9d0757f$var$_lcpEntry && options.recordLcpOnPageloadSpan) {
        if ($00afd3b4f9d0757f$var$_lcpEntry.element) span.setAttribute("lcp.element", (0, $d6cf245db051044b$export$5647df6b7814ac86)($00afd3b4f9d0757f$var$_lcpEntry.element));
        if ($00afd3b4f9d0757f$var$_lcpEntry.id) span.setAttribute("lcp.id", $00afd3b4f9d0757f$var$_lcpEntry.id);
        if ($00afd3b4f9d0757f$var$_lcpEntry.url) span.setAttribute("lcp.url", $00afd3b4f9d0757f$var$_lcpEntry.url.trim().slice(0, 200));
        if ($00afd3b4f9d0757f$var$_lcpEntry.loadTime != null) span.setAttribute("lcp.loadTime", $00afd3b4f9d0757f$var$_lcpEntry.loadTime);
        if ($00afd3b4f9d0757f$var$_lcpEntry.renderTime != null) span.setAttribute("lcp.renderTime", $00afd3b4f9d0757f$var$_lcpEntry.renderTime);
        span.setAttribute("lcp.size", $00afd3b4f9d0757f$var$_lcpEntry.size);
    }
    if (($00afd3b4f9d0757f$var$_clsEntry === null || $00afd3b4f9d0757f$var$_clsEntry === void 0 ? void 0 : $00afd3b4f9d0757f$var$_clsEntry.sources) && options.recordClsOnPageloadSpan) $00afd3b4f9d0757f$var$_clsEntry.sources.forEach((source, index)=>span.setAttribute(`cls.source.${index + 1}`, (0, $d6cf245db051044b$export$5647df6b7814ac86)(source.node)));
}
function $00afd3b4f9d0757f$export$6ce741ceee01ab2f(entry, attributes, properties) {
    properties.forEach(([entryKey, attributeKey])=>{
        const entryVal = entry[entryKey];
        if (entryVal != null && (typeof entryVal === "number" && entryVal < $00afd3b4f9d0757f$var$MAX_INT_AS_BYTES || typeof entryVal === "string")) attributes[attributeKey] = entryVal;
    });
}
function $00afd3b4f9d0757f$var$_addTtfbRequestTimeToMeasurements(_measurements2) {
    const navEntry = (0, $f907d1cd0e842264$export$6431553786c94949)(false);
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) _measurements2["ttfb.requestTime"] = {
        value: responseStart - requestStart,
        unit: "millisecond"
    };
}


const $03d071cefd392f71$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

const $437be5401ebe48b5$export$56d8a8a25bd48b81 = (0, $b353b064a96cf357$exports.GLOBAL_OBJ);
let $437be5401ebe48b5$var$ignoreOnError = 0;
function $437be5401ebe48b5$export$b79738ab10c590b2() {
    return $437be5401ebe48b5$var$ignoreOnError > 0;
}
function $437be5401ebe48b5$export$1265a142ff5ba165() {
    $437be5401ebe48b5$var$ignoreOnError++;
    setTimeout(()=>{
        $437be5401ebe48b5$var$ignoreOnError--;
    });
}
function $437be5401ebe48b5$export$4997ffc0176396a6(fn, options = {}) {
    function isFunction(fn2) {
        return typeof fn2 === "function";
    }
    if (!isFunction(fn)) return fn;
    try {
        const hasOwnWrapper = Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__");
        if (hasOwnWrapper) {
            const wrapper = fn.__sentry_wrapped__;
            if (typeof wrapper === "function") return wrapper;
            else return fn;
        }
        if ((0, $b353b064a96cf357$exports.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        return fn;
    }
    const sentryWrapped = function(...args) {
        (0, $b353b064a96cf357$exports.GLOBAL_OBJ)._sentryWrappedDepth = ((0, $b353b064a96cf357$exports.GLOBAL_OBJ)._sentryWrappedDepth || 0) + 1;
        try {
            const wrappedArguments = args.map((arg)=>$437be5401ebe48b5$export$4997ffc0176396a6(arg, options));
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $437be5401ebe48b5$export$1265a142ff5ba165();
            (0, $b353b064a96cf357$exports.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $b353b064a96cf357$exports.addExceptionTypeValue)(event, void 0, void 0);
                        (0, $b353b064a96cf357$exports.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = (0, $2qxEV._)((0, $9tqwB._)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0, $b353b064a96cf357$exports.captureException)(ex);
            });
            throw ex;
        } finally{
            (0, $b353b064a96cf357$exports.GLOBAL_OBJ)._sentryWrappedDepth = ((0, $b353b064a96cf357$exports.GLOBAL_OBJ)._sentryWrappedDepth || 0) - 1;
        }
    };
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (e) {}
    (0, $b353b064a96cf357$exports.markFunctionWrapped)(sentryWrapped, fn);
    (0, $b353b064a96cf357$exports.addNonEnumerableProperty)(fn, "__sentry_wrapped__", sentryWrapped);
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    } catch (e) {}
    return sentryWrapped;
}
function $437be5401ebe48b5$export$a3c4a8453e8936f0() {
    const url = (0, $b353b064a96cf357$exports.getLocationHref)();
    const { referrer: referrer } = $437be5401ebe48b5$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $437be5401ebe48b5$export$56d8a8a25bd48b81.navigator || {};
    const headers = (0, $9tqwB._)({}, referrer && {
        Referer: referrer
    }, userAgent && {
        "User-Agent": userAgent
    });
    const request = {
        url: url,
        headers: headers
    };
    return request;
}



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");







function $2676de91bc47760e$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = "fetch";
    const removeHandler = (0, $53b768e21077af87$export$a4e09611e30da72e)(type, handler);
    (0, $53b768e21077af87$export$e18d6c5462c01368)(type, ()=>$2676de91bc47760e$var$instrumentFetch(void 0, skipNativeFetchCheck));
    return removeHandler;
}
function $2676de91bc47760e$export$1a79663eb318fe6a(handler) {
    const type = "fetch-body-resolved";
    const removeHandler = (0, $53b768e21077af87$export$a4e09611e30da72e)(type, handler);
    (0, $53b768e21077af87$export$e18d6c5462c01368)(type, ()=>$2676de91bc47760e$var$instrumentFetch($2676de91bc47760e$var$streamHandler));
    return removeHandler;
}
function $2676de91bc47760e$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $ed8e12a1b26c7e3d$export$c82d238e23c40b21)()) return;
    (0, $85a434b6cfc19e37$export$9563e054e6f787fb)((0, $df8678217e707dd5$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return function(...args) {
            const virtualError = new Error();
            const { method: method, url: url } = $2676de91bc47760e$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $b007b72e24b33b62$export$ee52dced521e3e18)() * 1e3,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $2676de91bc47760e$var$getHeadersFromFetchArgs(args)
            };
            if (!onFetchResolved) (0, $53b768e21077af87$export$b18c893e424d3127)("fetch", (0, $9tqwB._)({}, handlerData));
            return originalFetch.apply((0, $df8678217e707dd5$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $53b768e21077af87$export$b18c893e424d3127)("fetch", (0, $2qxEV._)((0, $9tqwB._)({}, handlerData), {
                    endTimestamp: (0, $b007b72e24b33b62$export$ee52dced521e3e18)() * 1e3,
                    response: response
                }));
                return response;
            }, (error)=>{
                (0, $53b768e21077af87$export$b18c893e424d3127)("fetch", (0, $2qxEV._)((0, $9tqwB._)({}, handlerData), {
                    endTimestamp: (0, $b007b72e24b33b62$export$ee52dced521e3e18)() * 1e3,
                    error: error
                }));
                if ((0, $85e272e760900bb9$export$e6127cc7fe7395c3)(error) && error.stack === void 0) {
                    error.stack = virtualError.stack;
                    (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(error, "framesToPop", 1);
                }
                const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
                var _client_getOptions_enhanceFetchErrorMessages;
                const enhanceOption = (_client_getOptions_enhanceFetchErrorMessages = client === null || client === void 0 ? void 0 : client.getOptions().enhanceFetchErrorMessages) !== null && _client_getOptions_enhanceFetchErrorMessages !== void 0 ? _client_getOptions_enhanceFetchErrorMessages : "always";
                const shouldEnhance = enhanceOption !== false;
                if (shouldEnhance && error instanceof TypeError && (error.message === "Failed to fetch" || error.message === "Load failed" || error.message === "NetworkError when attempting to fetch resource.")) try {
                    const url2 = new URL(handlerData.fetchData.url);
                    const hostname = url2.host;
                    if (enhanceOption === "always") error.message = `${error.message} (${hostname})`;
                    else (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(error, "__sentry_fetch_url_host__", hostname);
                } catch (e) {}
                throw error;
            });
        };
    });
}
async function $2676de91bc47760e$var$resolveResponse(res, onFinishedResolving) {
    if (res === null || res === void 0 ? void 0 : res.body) {
        const body = res.body;
        const responseReader = body.getReader();
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{});
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{});
                }, 5e3);
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch (e) {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{});
    }
}
function $2676de91bc47760e$var$streamHandler(response) {
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch (e) {
        return;
    }
    $2676de91bc47760e$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $53b768e21077af87$export$b18c893e424d3127)("fetch-body-resolved", {
            endTimestamp: (0, $b007b72e24b33b62$export$ee52dced521e3e18)() * 1e3,
            response: response
        });
    });
}
function $2676de91bc47760e$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $2676de91bc47760e$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($2676de91bc47760e$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
function $2676de91bc47760e$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [resource, options] = fetchArgs;
        return {
            url: $2676de91bc47760e$var$getUrlFromResource(resource),
            method: $2676de91bc47760e$var$hasProp(options, "method") ? String(options.method).toUpperCase() : // Request object as first argument
            (0, $85e272e760900bb9$export$6d3d1f317d7cda57)(resource) && $2676de91bc47760e$var$hasProp(resource, "method") ? String(resource.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $2676de91bc47760e$var$getUrlFromResource(arg),
        method: $2676de91bc47760e$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
function $2676de91bc47760e$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === "object" && optionsArgument !== null && "headers" in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $85e272e760900bb9$export$6d3d1f317d7cda57)(requestArgument)) return new Headers(requestArgument.headers);
    } catch (e) {}
    return;
}




const $425e0f9c169ee798$export$b14a8888f80a0b3e = [];
function $425e0f9c169ee798$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
function $425e0f9c169ee798$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $425e0f9c169ee798$var$filterDuplicates(integrations);
}
function $425e0f9c169ee798$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        if (integration === null || integration === void 0 ? void 0 : integration.beforeSetup) integration.beforeSetup(client);
    });
    integrations.forEach((integration)=>{
        if (integration) $425e0f9c169ee798$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
function $425e0f9c169ee798$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)if (integration === null || integration === void 0 ? void 0 : integration.afterAllSetup) integration.afterAllSetup(client);
}
function $425e0f9c169ee798$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    if (!$425e0f9c169ee798$export$b14a8888f80a0b3e.includes(integration.name) && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $425e0f9c169ee798$export$b14a8888f80a0b3e.push(integration.name);
    }
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    [
        "processSpan",
        "processSegmentSpan"
    ].forEach((hook)=>{
        const callback = integration[hook];
        if (typeof callback === "function") client.on(hook, (span)=>callback.call(integration, span, client));
    });
    (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Integration installed: ${integration.name}`);
}
function $425e0f9c169ee798$export$2d8f5188773bcddd(integration) {
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
function $425e0f9c169ee798$export$2323046b9414659f(fn) {
    return fn;
}


const $e7e00d70eeed282d$var$responseToStreamSpan = /* @__PURE__ */ new WeakMap();
const $e7e00d70eeed282d$var$responseToFallbackTimeout = /* @__PURE__ */ new WeakMap();
const $e7e00d70eeed282d$var$STREAM_RESOLVE_FALLBACK_MS = 9e4;
const $e7e00d70eeed282d$var$STREAMING_CONTENT_TYPES = [
    "text/event-stream",
    "application/x-ndjson",
    "application/stream+json"
];
const $e7e00d70eeed282d$export$b49e0d1a48dc8754 = (0, $425e0f9c169ee798$export$2323046b9414659f)(()=>{
    return {
        name: "FetchStreamPerformance",
        setup () {
            (0, $2676de91bc47760e$export$1a79663eb318fe6a)((handlerData)=>{
                if (handlerData.response) {
                    const streamSpan = $e7e00d70eeed282d$var$responseToStreamSpan.get(handlerData.response);
                    if (streamSpan && handlerData.endTimestamp) {
                        streamSpan.end(handlerData.endTimestamp);
                        const fallbackTimeout = $e7e00d70eeed282d$var$responseToFallbackTimeout.get(handlerData.response);
                        if (fallbackTimeout) clearTimeout(fallbackTimeout);
                    }
                }
            });
            (0, $2676de91bc47760e$export$f75d3c772c923df0)((handlerData)=>{
                if (handlerData.endTimestamp && handlerData.response) {
                    var _handlerData_response_headers, _handlerData_response_headers1, _handlerData_fetchData, _handlerData_fetchData1;
                    const contentType = ((_handlerData_response_headers = handlerData.response.headers) === null || _handlerData_response_headers === void 0 ? void 0 : _handlerData_response_headers.get("content-type")) || "";
                    if (((_handlerData_response_headers1 = handlerData.response.headers) === null || _handlerData_response_headers1 === void 0 ? void 0 : _handlerData_response_headers1.get("content-length")) || !$e7e00d70eeed282d$var$STREAMING_CONTENT_TYPES.some((t)=>contentType.startsWith(t))) return;
                    const url = ((_handlerData_fetchData = handlerData.fetchData) === null || _handlerData_fetchData === void 0 ? void 0 : _handlerData_fetchData.url) || "";
                    const method = ((_handlerData_fetchData1 = handlerData.fetchData) === null || _handlerData_fetchData1 === void 0 ? void 0 : _handlerData_fetchData1.method) || "GET";
                    const parsedUrl = (0, $e3f8d2d1d7c51bd6$export$2004d912a9ead694)(url);
                    const sanitizedUrl = url.startsWith("data:") ? (0, $e3f8d2d1d7c51bd6$export$8abd806fcaf234fa)(url) : parsedUrl ? (0, $e3f8d2d1d7c51bd6$export$5339fcdc8e2a427c)(parsedUrl) : url;
                    const streamSpan = (0, $93c45d57befd4356$export$63dbba021a6b4047)({
                        name: `${method} ${sanitizedUrl}`,
                        startTime: handlerData.endTimestamp,
                        attributes: {
                            url: (0, $e3f8d2d1d7c51bd6$export$8abd806fcaf234fa)(url),
                            "http.method": method,
                            type: "fetch",
                            [(0, $fdf17a1e56d9d4ca$export$1a413bd9a88fdb09)]: "http.client.stream",
                            [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: "auto.http.browser.stream"
                        }
                    });
                    $e7e00d70eeed282d$var$responseToStreamSpan.set(handlerData.response, streamSpan);
                    const fallbackTimeout = setTimeout(()=>{
                        if (streamSpan.isRecording()) streamSpan.end();
                    }, $e7e00d70eeed282d$var$STREAM_RESOLVE_FALLBACK_MS);
                    $e7e00d70eeed282d$var$responseToFallbackTimeout.set(handlerData.response, fallbackTimeout);
                }
            });
        }
    };
});




var $3MsYN = parcelRequire("3MsYN");

function $3a8ae0c240b87a96$export$4e09c449d6c407f7() {
    return typeof window !== "undefined" && (!(0, $3MsYN.isNodeEnv)() || $3a8ae0c240b87a96$var$isElectronNodeRenderer());
}
function $3a8ae0c240b87a96$var$isElectronNodeRenderer() {
    const process = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1).process;
    return (process === null || process === void 0 ? void 0 : process.type) === "renderer";
}






const $744792c01979fadb$var$LAST_INTERACTIONS = [];
const $744792c01979fadb$var$INTERACTIONS_SPAN_MAP = /* @__PURE__ */ new Map();
const $744792c01979fadb$var$ELEMENT_NAME_TIMESTAMP_MAP = /* @__PURE__ */ new Map();
const $744792c01979fadb$export$619786413bcce1e1 = 60;
function $744792c01979fadb$export$f17d06681a4744a3() {
    const performance = (0, $f43b6f40a361b790$export$f72a13c439a30cab)();
    if (performance && (0, $b007b72e24b33b62$export$baf075a948ffc0bf)()) {
        const inpCallback = $744792c01979fadb$export$eeab203db0ed99a9();
        return ()=>{
            inpCallback();
        };
    }
    return ()=>void 0;
}
const $744792c01979fadb$export$7cd941f925ded42f = {
    click: "click",
    pointerdown: "click",
    pointerup: "click",
    mousedown: "click",
    mouseup: "click",
    touchstart: "click",
    touchend: "click",
    mouseover: "hover",
    mouseout: "hover",
    mouseenter: "hover",
    mouseleave: "hover",
    pointerover: "hover",
    pointerout: "hover",
    pointerenter: "hover",
    pointerleave: "hover",
    dragstart: "drag",
    dragend: "drag",
    drag: "drag",
    dragenter: "drag",
    dragleave: "drag",
    dragover: "drag",
    drop: "drag",
    keydown: "press",
    keyup: "press",
    keypress: "press",
    input: "press"
};
function $744792c01979fadb$export$eeab203db0ed99a9() {
    return (0, $5d4e4d5b5c2c563b$export$da3b76aa2022cbd7)($744792c01979fadb$export$7bcb98fe01441521);
}
const $744792c01979fadb$export$7bcb98fe01441521 = ({ metric: metric })=>{
    if (metric.value == void 0) return;
    const duration = (0, $f43b6f40a361b790$export$b4785dbd4a81b33f)(metric.value);
    if (duration > $744792c01979fadb$export$619786413bcce1e1) return;
    const entry = metric.entries.find((entry2)=>entry2.duration === metric.value && $744792c01979fadb$export$7cd941f925ded42f[entry2.name]);
    if (!entry) return;
    const { interactionId: interactionId } = entry;
    const interactionType = $744792c01979fadb$export$7cd941f925ded42f[entry.name];
    const startTime = (0, $f43b6f40a361b790$export$b4785dbd4a81b33f)((0, $b007b72e24b33b62$export$baf075a948ffc0bf)() + entry.startTime);
    const activeSpan = (0, $cac16f6eada858e7$export$1be426a8e585c83e)();
    const rootSpan = activeSpan ? (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(activeSpan) : void 0;
    const cachedInteractionContext = interactionId != null ? $744792c01979fadb$var$INTERACTIONS_SPAN_MAP.get(interactionId) : void 0;
    const spanToUse = (cachedInteractionContext === null || cachedInteractionContext === void 0 ? void 0 : cachedInteractionContext.span) || rootSpan;
    const routeName = spanToUse ? (0, $cac16f6eada858e7$export$92d8c23565496537)(spanToUse).description : (0, $6486f3d311605b78$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = (cachedInteractionContext === null || cachedInteractionContext === void 0 ? void 0 : cachedInteractionContext.elementName) || (0, $d6cf245db051044b$export$5647df6b7814ac86)(entry.target);
    const attributes = {
        [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: "auto.http.browser.inp",
        [(0, $fdf17a1e56d9d4ca$export$1a413bd9a88fdb09)]: `ui.interaction.${interactionType}`,
        [(0, $fdf17a1e56d9d4ca$export$fea48ba9f4550879)]: entry.duration
    };
    const span = (0, $f43b6f40a361b790$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent("inp", {
            [(0, $fdf17a1e56d9d4ca$export$f5f95cff026507b5)]: "millisecond",
            [(0, $fdf17a1e56d9d4ca$export$69cd5c610c7bb96a)]: metric.value
        });
        span.end(startTime + duration);
    }
};
function $744792c01979fadb$export$e4a670d077ebcfef(interactionId) {
    return interactionId != null ? $744792c01979fadb$var$INTERACTIONS_SPAN_MAP.get(interactionId) : void 0;
}
function $744792c01979fadb$export$e4e04d43e223cce2() {
    const interactionEvents = Object.keys($744792c01979fadb$export$7cd941f925ded42f);
    if ((0, $3a8ae0c240b87a96$export$4e09c449d6c407f7)()) interactionEvents.forEach((eventType)=>{
        (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).addEventListener(eventType, captureElementFromEvent, {
            capture: true,
            passive: true
        });
    });
    function captureElementFromEvent(event) {
        const target = event.target;
        if (!target) return;
        const elementName = (0, $d6cf245db051044b$export$5647df6b7814ac86)(target);
        const timestamp = Math.round(event.timeStamp);
        $744792c01979fadb$var$ELEMENT_NAME_TIMESTAMP_MAP.set(timestamp, elementName);
        if ($744792c01979fadb$var$ELEMENT_NAME_TIMESTAMP_MAP.size > 50) {
            const firstKey = $744792c01979fadb$var$ELEMENT_NAME_TIMESTAMP_MAP.keys().next().value;
            if (firstKey !== void 0) $744792c01979fadb$var$ELEMENT_NAME_TIMESTAMP_MAP.delete(firstKey);
        }
    }
    function resolveElementNameFromEntry(entry) {
        const timestamp = Math.round(entry.startTime);
        let elementName = $744792c01979fadb$var$ELEMENT_NAME_TIMESTAMP_MAP.get(timestamp);
        if (!elementName) for(let offset = -5; offset <= 5; offset++){
            const nearbyName = $744792c01979fadb$var$ELEMENT_NAME_TIMESTAMP_MAP.get(timestamp + offset);
            if (nearbyName) {
                elementName = nearbyName;
                break;
            }
        }
        return elementName || "<unknown>";
    }
    const handleEntries = ({ entries: entries })=>{
        const activeSpan = (0, $cac16f6eada858e7$export$1be426a8e585c83e)();
        const activeRootSpan = activeSpan && (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(activeSpan);
        entries.forEach((entry)=>{
            if (!(0, $5d4e4d5b5c2c563b$export$7affb50b622d8714)(entry)) return;
            const interactionId = entry.interactionId;
            if (interactionId == null) return;
            if ($744792c01979fadb$var$INTERACTIONS_SPAN_MAP.has(interactionId)) return;
            const elementName = entry.target ? (0, $d6cf245db051044b$export$5647df6b7814ac86)(entry.target) : resolveElementNameFromEntry(entry);
            if ($744792c01979fadb$var$LAST_INTERACTIONS.length > 10) {
                const last = $744792c01979fadb$var$LAST_INTERACTIONS.shift();
                $744792c01979fadb$var$INTERACTIONS_SPAN_MAP.delete(last);
            }
            $744792c01979fadb$var$LAST_INTERACTIONS.push(interactionId);
            $744792c01979fadb$var$INTERACTIONS_SPAN_MAP.set(interactionId, {
                span: activeRootSpan,
                elementName: elementName
            });
        });
    };
    (0, $5d4e4d5b5c2c563b$export$69816c1a049f8db6)("event", handleEntries);
    (0, $5d4e4d5b5c2c563b$export$69816c1a049f8db6)("first-input", handleEntries);
}


var $9tqwB = parcelRequire("9tqwB");








function $54251ffda19cb2f6$export$f4adb23e57c1dac6(options) {
    var _WINDOW_navigator, _spanToStreamedSpanJSON_attributes;
    const { name: name, op: op, origin: origin, metricName: metricName, value: value, attributes: passedAttributes, parentSpan: parentSpan, reportEvent: reportEvent, startTime: startTime, endTime: endTime } = options;
    const routeName = (0, $6486f3d311605b78$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const attributes = (0, $9tqwB._)({
        [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: origin,
        [(0, $fdf17a1e56d9d4ca$export$1a413bd9a88fdb09)]: op,
        [(0, $fdf17a1e56d9d4ca$export$fea48ba9f4550879)]: 0,
        [`browser.web_vital.${metricName}.value`]: value,
        "sentry.transaction": routeName,
        // Web vital score calculation relies on the user agent
        "user_agent.original": (_WINDOW_navigator = (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).navigator) === null || _WINDOW_navigator === void 0 ? void 0 : _WINDOW_navigator.userAgent
    }, passedAttributes);
    if (parentSpan && ((_spanToStreamedSpanJSON_attributes = (0, $cac16f6eada858e7$export$db0cad9e44f67af8)(parentSpan).attributes) === null || _spanToStreamedSpanJSON_attributes === void 0 ? void 0 : _spanToStreamedSpanJSON_attributes[0, $fdf17a1e56d9d4ca$export$1a413bd9a88fdb09]) === "pageload") attributes["sentry.pageload.span_id"] = parentSpan.spanContext().spanId;
    if (reportEvent) attributes[`browser.web_vital.${metricName}.report_event`] = reportEvent;
    const span = (0, $93c45d57befd4356$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        parentSpan: // if we have a pageload span, we let the web vital span start as its parent. This ensures that
        // it is not started as a segment span, without having to manually set it to a "standalone" v2 span
        // that has `segment: false` but no actual parent span.
        parentSpan
    });
    if (span) span.end(endTime !== null && endTime !== void 0 ? endTime : startTime);
}
function $54251ffda19cb2f6$export$73747c030e2325c0(client) {
    let lcpValue = 0;
    let lcpEntry;
    if (!(0, $f43b6f40a361b790$export$c7533a7b4a9f2e94)("largest-contentful-paint")) return;
    const cleanupLcpHandler = (0, $5d4e4d5b5c2c563b$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry || !(0, $1cda4029ac36714a$export$e59775b7d17699ba)(metric.value)) return;
        lcpValue = metric.value;
        lcpEntry = entry;
    }, true);
    (0, $f43b6f40a361b790$export$382ad360b45665ab)(client, (reportEvent, _, pageloadSpan)=>{
        $54251ffda19cb2f6$export$1adcb85d073cd594(lcpValue, lcpEntry, pageloadSpan, reportEvent);
        cleanupLcpHandler();
    });
}
function $54251ffda19cb2f6$export$1adcb85d073cd594(lcpValue, entry, pageloadSpan, reportEvent) {
    if (!(0, $1cda4029ac36714a$export$e59775b7d17699ba)(lcpValue)) return;
    (0, $3e6faad079da1d06$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Sending LCP span (${lcpValue})`);
    const performanceTimeOrigin = (0, $b007b72e24b33b62$export$baf075a948ffc0bf)() || 0;
    const timeOrigin = (0, $f43b6f40a361b790$export$b4785dbd4a81b33f)(performanceTimeOrigin);
    const endTime = (0, $f43b6f40a361b790$export$b4785dbd4a81b33f)(performanceTimeOrigin + ((entry === null || entry === void 0 ? void 0 : entry.startTime) || 0));
    const name = entry ? (0, $d6cf245db051044b$export$5647df6b7814ac86)(entry.element) : "Largest contentful paint";
    const attributes = {};
    (entry === null || entry === void 0 ? void 0 : entry.element) && (attributes["browser.web_vital.lcp.element"] = (0, $d6cf245db051044b$export$5647df6b7814ac86)(entry.element));
    (entry === null || entry === void 0 ? void 0 : entry.id) && (attributes["browser.web_vital.lcp.id"] = entry.id);
    (entry === null || entry === void 0 ? void 0 : entry.url) && (attributes["browser.web_vital.lcp.url"] = entry.url);
    (entry === null || entry === void 0 ? void 0 : entry.loadTime) != null && (attributes["browser.web_vital.lcp.load_time"] = entry.loadTime);
    (entry === null || entry === void 0 ? void 0 : entry.renderTime) != null && (attributes["browser.web_vital.lcp.render_time"] = entry.renderTime);
    (entry === null || entry === void 0 ? void 0 : entry.size) != null && (attributes["browser.web_vital.lcp.size"] = entry.size);
    $54251ffda19cb2f6$export$f4adb23e57c1dac6({
        name: name,
        op: "ui.webvital.lcp",
        origin: "auto.http.browser.lcp",
        metricName: "lcp",
        value: lcpValue,
        attributes: attributes,
        parentSpan: pageloadSpan,
        reportEvent: reportEvent,
        startTime: timeOrigin,
        endTime: endTime
    });
}
function $54251ffda19cb2f6$export$f2ca9ed704743eb2(client) {
    let clsValue = 0;
    let clsEntry;
    if (!(0, $f43b6f40a361b790$export$c7533a7b4a9f2e94)("layout-shift")) return;
    const cleanupClsHandler = (0, $5d4e4d5b5c2c563b$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        clsValue = metric.value;
        clsEntry = entry;
    }, true);
    (0, $f43b6f40a361b790$export$382ad360b45665ab)(client, (reportEvent, _, pageloadSpan)=>{
        $54251ffda19cb2f6$export$736c846d4f7aff83(clsValue, clsEntry, pageloadSpan, reportEvent);
        cleanupClsHandler();
    });
}
function $54251ffda19cb2f6$export$736c846d4f7aff83(clsValue, entry, pageloadSpan, reportEvent) {
    var _entry_sources_;
    (0, $3e6faad079da1d06$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Sending CLS span (${clsValue})`);
    const startTime = entry ? (0, $f43b6f40a361b790$export$b4785dbd4a81b33f)(((0, $b007b72e24b33b62$export$baf075a948ffc0bf)() || 0) + entry.startTime) : (0, $b007b72e24b33b62$export$ee52dced521e3e18)();
    const name = entry ? (0, $d6cf245db051044b$export$5647df6b7814ac86)((_entry_sources_ = entry.sources[0]) === null || _entry_sources_ === void 0 ? void 0 : _entry_sources_.node) : "Layout shift";
    const attributes = {};
    if (entry === null || entry === void 0 ? void 0 : entry.sources) entry.sources.forEach((source, index)=>{
        attributes[`browser.web_vital.cls.source.${index + 1}`] = (0, $d6cf245db051044b$export$5647df6b7814ac86)(source.node);
    });
    $54251ffda19cb2f6$export$f4adb23e57c1dac6({
        name: name,
        op: "ui.webvital.cls",
        origin: "auto.http.browser.cls",
        metricName: "cls",
        value: clsValue,
        attributes: attributes,
        parentSpan: pageloadSpan,
        reportEvent: reportEvent,
        startTime: startTime
    });
}
function $54251ffda19cb2f6$export$4a8cbc644515d57b() {
    const performance = (0, $f43b6f40a361b790$export$f72a13c439a30cab)();
    if (!performance || !(0, $b007b72e24b33b62$export$baf075a948ffc0bf)()) return;
    const onInp = ({ metric: metric })=>{
        if (metric.value == null) return;
        const duration = (0, $f43b6f40a361b790$export$b4785dbd4a81b33f)(metric.value);
        if (duration > (0, $744792c01979fadb$export$619786413bcce1e1)) return;
        const entry = metric.entries.find((e)=>e.duration === metric.value && (0, $744792c01979fadb$export$7cd941f925ded42f)[e.name]);
        if (!entry) return;
        $54251ffda19cb2f6$export$bd315e549441b68a(metric.value, entry);
    };
    (0, $5d4e4d5b5c2c563b$export$da3b76aa2022cbd7)(onInp);
}
function $54251ffda19cb2f6$export$bd315e549441b68a(inpValue, entry) {
    (0, $3e6faad079da1d06$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Sending INP span (${inpValue})`);
    const startTime = (0, $f43b6f40a361b790$export$b4785dbd4a81b33f)((0, $b007b72e24b33b62$export$baf075a948ffc0bf)() + entry.startTime);
    const duration = (0, $f43b6f40a361b790$export$b4785dbd4a81b33f)(inpValue);
    const interactionType = (0, $744792c01979fadb$export$7cd941f925ded42f)[entry.name];
    const cachedContext = (0, $744792c01979fadb$export$e4a670d077ebcfef)(entry.interactionId);
    const activeSpan = (0, $cac16f6eada858e7$export$1be426a8e585c83e)();
    const rootSpan = activeSpan ? (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(activeSpan) : void 0;
    const spanToUse = (cachedContext === null || cachedContext === void 0 ? void 0 : cachedContext.span) || rootSpan;
    const routeName = spanToUse ? (0, $cac16f6eada858e7$export$db0cad9e44f67af8)(spanToUse).name : (0, $6486f3d311605b78$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = (cachedContext === null || cachedContext === void 0 ? void 0 : cachedContext.elementName) || (0, $d6cf245db051044b$export$5647df6b7814ac86)(entry.target);
    $54251ffda19cb2f6$export$f4adb23e57c1dac6({
        name: name,
        op: `ui.interaction.${interactionType}`,
        origin: "auto.http.browser.inp",
        metricName: "inp",
        value: inpValue,
        attributes: {
            [(0, $fdf17a1e56d9d4ca$export$fea48ba9f4550879)]: entry.duration,
            "sentry.transaction": routeName
        },
        startTime: startTime,
        endTime: startTime + duration,
        parentSpan: spanToUse
    });
}


const $d6071b41fea963d0$export$8748555bacc7091c = "WebVitals";
const $d6071b41fea963d0$export$1ab4995602e8adaa = (0, $b353b064a96cf357$exports.defineIntegration)((options = {})=>{
    var _options_ignore;
    const ignored = new Set((_options_ignore = options.ignore) !== null && _options_ignore !== void 0 ? _options_ignore : []);
    return {
        name: $d6071b41fea963d0$export$8748555bacc7091c,
        setup (client) {
            const spanStreamingEnabled = (0, $b353b064a96cf357$exports.hasSpanStreamingEnabled)(client);
            var _options__experiments;
            const { enableStandaloneClsSpans: enableStandaloneClsSpans, enableStandaloneLcpSpans: enableStandaloneLcpSpans } = (_options__experiments = options._experiments) !== null && _options__experiments !== void 0 ? _options__experiments : {};
            const recordClsStandaloneSpans = spanStreamingEnabled || ignored.has("cls") ? void 0 : enableStandaloneClsSpans || false;
            const recordLcpStandaloneSpans = spanStreamingEnabled || ignored.has("lcp") ? void 0 : enableStandaloneLcpSpans || false;
            const finalizeWebVitals = (0, $00afd3b4f9d0757f$export$7c69f0412d101b88)({
                recordClsStandaloneSpans: recordClsStandaloneSpans,
                recordLcpStandaloneSpans: recordLcpStandaloneSpans,
                client: client
            });
            const pageloadSpans = /* @__PURE__ */ new WeakSet();
            client.on("afterStartPageLoadSpan", (span)=>{
                pageloadSpans.add(span);
            });
            client.on("spanEnd", (span)=>{
                if (!pageloadSpans.delete(span)) return;
                finalizeWebVitals();
                (0, $00afd3b4f9d0757f$export$d14e394b690acc17)(span, {
                    // CLS/LCP are recorded as pageload span measurements only when they're neither
                    // tracked as standalone spans nor handled by span streaming (and not ignored).
                    recordClsOnPageloadSpan: recordClsStandaloneSpans === false,
                    recordLcpOnPageloadSpan: recordLcpStandaloneSpans === false,
                    spanStreamingEnabled: spanStreamingEnabled
                });
            });
            if (spanStreamingEnabled) {
                if (!ignored.has("lcp")) (0, $54251ffda19cb2f6$export$73747c030e2325c0)(client);
                if (!ignored.has("cls")) (0, $54251ffda19cb2f6$export$f2ca9ed704743eb2)(client);
                if (!ignored.has("inp")) (0, $54251ffda19cb2f6$export$4a8cbc644515d57b)();
            } else if (!ignored.has("inp")) (0, $744792c01979fadb$export$f17d06681a4744a3)();
        },
        afterAllSetup () {
            if (!ignored.has("inp")) (0, $744792c01979fadb$export$e4e04d43e223cce2)();
        }
    };
});





function $7ea9b22cd3a72ae0$export$6f18f55521af71a1() {
    if ((0, $437be5401ebe48b5$export$56d8a8a25bd48b81).document) (0, $437be5401ebe48b5$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
        const activeSpan = (0, $b353b064a96cf357$exports.getActiveSpan)();
        if (!activeSpan) return;
        const rootSpan = (0, $b353b064a96cf357$exports.getRootSpan)(activeSpan);
        if ((0, $437be5401ebe48b5$export$56d8a8a25bd48b81).document.hidden && rootSpan) {
            const cancelledStatus = "cancelled";
            const { op: op, status: status } = (0, $b353b064a96cf357$exports.spanToJSON)(rootSpan);
            if (0, $03d071cefd392f71$export$16a28057038b10ef) (0, $b353b064a96cf357$exports.debug).log(`[Tracing] Transaction: ${cancelledStatus} -> since tab moved to the background, op: ${op}`);
            if (!status) rootSpan.setStatus({
                code: (0, $b353b064a96cf357$exports.SPAN_STATUS_ERROR),
                message: cancelledStatus
            });
            rootSpan.setAttribute("sentry.cancellation_reason", "document.hidden");
            rootSpan.end();
        }
    });
    else (0, $03d071cefd392f71$export$16a28057038b10ef) && (0, $b353b064a96cf357$exports.debug).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");












const $cf4e861431bc45c6$export$c8d616af96ac729f = 3600;
const $cf4e861431bc45c6$export$16b6aa13b3c0f075 = "sentry_previous_trace";
const $cf4e861431bc45c6$export$237518aee8726f02 = "sentry.previous_trace";
function $cf4e861431bc45c6$export$830d9ee659c6e4c4(client, { linkPreviousTrace: linkPreviousTrace, consistentTraceSampling: consistentTraceSampling }) {
    const useSessionStorage = linkPreviousTrace === "session-storage";
    let inMemoryPreviousTraceInfo = useSessionStorage ? $cf4e861431bc45c6$export$ef546bba8a402d99() : void 0;
    client.on("spanStart", (span)=>{
        if ((0, $b353b064a96cf357$exports.getRootSpan)(span) !== span) return;
        const oldPropagationContext = (0, $b353b064a96cf357$exports.getCurrentScope)().getPropagationContext();
        inMemoryPreviousTraceInfo = $cf4e861431bc45c6$export$ae31cf84cbfc630e(inMemoryPreviousTraceInfo, span, oldPropagationContext);
        if (useSessionStorage) $cf4e861431bc45c6$export$e3dcc2666496dd96(inMemoryPreviousTraceInfo);
    });
    let isFirstTraceOnPageload = true;
    if (consistentTraceSampling) client.on("beforeSampling", (mutableSamplingContextData)=>{
        if (!inMemoryPreviousTraceInfo) return;
        const scope = (0, $b353b064a96cf357$exports.getCurrentScope)();
        const currentPropagationContext = scope.getPropagationContext();
        if (isFirstTraceOnPageload && currentPropagationContext.parentSpanId) {
            isFirstTraceOnPageload = false;
            return;
        }
        scope.setPropagationContext((0, $2qxEV._)((0, $9tqwB._)({}, currentPropagationContext), {
            dsc: (0, $2qxEV._)((0, $9tqwB._)({}, currentPropagationContext.dsc), {
                sample_rate: String(inMemoryPreviousTraceInfo.sampleRate),
                sampled: String($cf4e861431bc45c6$export$f394c5f143a7b597(inMemoryPreviousTraceInfo.spanContext))
            }),
            sampleRand: inMemoryPreviousTraceInfo.sampleRand
        }));
        mutableSamplingContextData.parentSampled = $cf4e861431bc45c6$export$f394c5f143a7b597(inMemoryPreviousTraceInfo.spanContext);
        mutableSamplingContextData.parentSampleRate = inMemoryPreviousTraceInfo.sampleRate;
        mutableSamplingContextData.spanAttributes = (0, $2qxEV._)((0, $9tqwB._)({}, mutableSamplingContextData.spanAttributes), {
            [(0, $b353b064a96cf357$exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE)]: inMemoryPreviousTraceInfo.sampleRate
        });
    });
}
function $cf4e861431bc45c6$export$ae31cf84cbfc630e(previousTraceInfo, span, oldPropagationContext) {
    const spanJson = (0, $b353b064a96cf357$exports.spanToJSON)(span);
    function getSampleRate() {
        try {
            var _spanJson_data, _oldPropagationContext_dsc;
            var _spanJson_data_SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
            const oldSampleRate = Number((_spanJson_data_SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = (_spanJson_data = spanJson.data) === null || _spanJson_data === void 0 ? void 0 : _spanJson_data[0, $b353b064a96cf357$exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]) !== null && _spanJson_data_SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE !== void 0 ? _spanJson_data_SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE : (_oldPropagationContext_dsc = oldPropagationContext.dsc) === null || _oldPropagationContext_dsc === void 0 ? void 0 : _oldPropagationContext_dsc.sample_rate);
            return Number.isNaN(oldSampleRate) ? 0 : oldSampleRate;
        } catch (e) {
            return 0;
        }
    }
    const updatedPreviousTraceInfo = {
        spanContext: span.spanContext(),
        startTimestamp: spanJson.start_timestamp,
        sampleRate: getSampleRate(),
        sampleRand: oldPropagationContext.sampleRand
    };
    if (!previousTraceInfo) return updatedPreviousTraceInfo;
    const previousTraceSpanCtx = previousTraceInfo.spanContext;
    if (previousTraceSpanCtx.traceId === spanJson.trace_id) return previousTraceInfo;
    if (Date.now() / 1e3 - previousTraceInfo.startTimestamp <= $cf4e861431bc45c6$export$c8d616af96ac729f) {
        if (0, $03d071cefd392f71$export$16a28057038b10ef) (0, $b353b064a96cf357$exports.debug).log(`Adding previous_trace \`${JSON.stringify(previousTraceSpanCtx)}\` link to span \`${JSON.stringify((0, $9tqwB._)({
            op: spanJson.op
        }, span.spanContext()))}\``);
        span.addLink({
            context: previousTraceSpanCtx,
            attributes: {
                [(0, $b353b064a96cf357$exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE)]: "previous_trace"
            }
        });
        span.setAttribute($cf4e861431bc45c6$export$237518aee8726f02, `${previousTraceSpanCtx.traceId}-${previousTraceSpanCtx.spanId}-${$cf4e861431bc45c6$export$f394c5f143a7b597(previousTraceSpanCtx) ? 1 : 0}`);
    }
    return updatedPreviousTraceInfo;
}
function $cf4e861431bc45c6$export$e3dcc2666496dd96(previousTraceInfo) {
    try {
        (0, $437be5401ebe48b5$export$56d8a8a25bd48b81).sessionStorage.setItem($cf4e861431bc45c6$export$16b6aa13b3c0f075, JSON.stringify(previousTraceInfo));
    } catch (e) {
        (0, $03d071cefd392f71$export$16a28057038b10ef) && (0, $b353b064a96cf357$exports.debug).warn("Could not store previous trace in sessionStorage", e);
    }
}
function $cf4e861431bc45c6$export$ef546bba8a402d99() {
    try {
        var _WINDOW_sessionStorage;
        const previousTraceInfo = (_WINDOW_sessionStorage = (0, $437be5401ebe48b5$export$56d8a8a25bd48b81).sessionStorage) === null || _WINDOW_sessionStorage === void 0 ? void 0 : _WINDOW_sessionStorage.getItem($cf4e861431bc45c6$export$16b6aa13b3c0f075);
        return JSON.parse(previousTraceInfo);
    } catch (e) {
        return void 0;
    }
}
function $cf4e861431bc45c6$export$f394c5f143a7b597(ctx) {
    return ctx.traceFlags === 1;
}



var $9tqwB = parcelRequire("9tqwB");



const $8700a702c00468d1$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
function $8700a702c00468d1$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $53b768e21077af87$export$a4e09611e30da72e)(type, handler);
    (0, $53b768e21077af87$export$e18d6c5462c01368)(type, $8700a702c00468d1$export$c67d533bf77cbf54);
}
function $8700a702c00468d1$export$c67d533bf77cbf54() {
    if (!(0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            const virtualError = new Error();
            const startTimestamp = (0, $b007b72e24b33b62$export$ee52dced521e3e18)() * 1e3;
            const method = (0, $85e272e760900bb9$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : void 0;
            const url = $8700a702c00468d1$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$8700a702c00468d1$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            if (method === "POST" && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                const xhrInfo = xhrOpenThisArg[$8700a702c00468d1$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {}
                    const handlerData = {
                        endTimestamp: (0, $b007b72e24b33b62$export$ee52dced521e3e18)() * 1e3,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $53b768e21077af87$export$b18c893e424d3127)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === "function") xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener("readystatechange", onreadystatechangeHandler);
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$8700a702c00468d1$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $85e272e760900bb9$export$844ec244b1367d54)(header) && (0, $85e272e760900bb9$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$8700a702c00468d1$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== void 0) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $b007b72e24b33b62$export$ee52dced521e3e18)() * 1e3,
                xhr: sendThisArg
            };
            (0, $53b768e21077af87$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
function $8700a702c00468d1$var$parseXhrUrlArg(url) {
    if ((0, $85e272e760900bb9$export$844ec244b1367d54)(url)) return url;
    try {
        return url.toString();
    } catch (e) {}
    return void 0;
}



const $d62dd922bf22e2c2$export$363d064b9116000e = /* @__PURE__ */ Symbol.for("sentry__originalRequestBody");
function $d62dd922bf22e2c2$export$2f1b0f57f243f270(formData) {
    return new URLSearchParams(formData).toString();
}
function $d62dd922bf22e2c2$export$945a2d5364608d5(body, _debug = (0, $d8898b8567c29ee9$export$1c9f709888824e05)) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $d62dd922bf22e2c2$export$2f1b0f57f243f270(body)
        ];
        if (!body) return [
            void 0
        ];
    } catch (error) {
        (0, $3e6faad079da1d06$export$16a28057038b10ef) && _debug.error(error, "Failed to serialize body", body);
        return [
            void 0,
            "BODY_PARSE_ERROR"
        ];
    }
    (0, $3e6faad079da1d06$export$16a28057038b10ef) && _debug.log("Skipping network body because of body type", body);
    return [
        void 0,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function $d62dd922bf22e2c2$export$ad44edf8012ec314(fetchArgs = []) {
    if (fetchArgs.length >= 2 && fetchArgs[1] && typeof fetchArgs[1] === "object" && "body" in fetchArgs[1]) return fetchArgs[1].body;
    if (fetchArgs.length >= 1 && fetchArgs[0] instanceof Request) {
        const request = fetchArgs[0];
        const originalBody = request[$d62dd922bf22e2c2$export$363d064b9116000e];
        if (originalBody !== void 0) return originalBody;
        return void 0;
    }
    return void 0;
}
function $d62dd922bf22e2c2$export$ce71c337afb62ea(xhr) {
    let headers;
    try {
        headers = xhr.getAllResponseHeaders();
    } catch (error) {
        (0, $3e6faad079da1d06$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).error(error, "Failed to get xhr response headers", xhr);
        return {};
    }
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        if (value) acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}



function $00bffb38a33d83ba$export$8193ac587e359dc0(baggageHeader) {
    return baggageHeader.split(",").some((value)=>value.trim().startsWith("sentry-"));
}
function $00bffb38a33d83ba$export$f2a087db7564c909(url) {
    try {
        const parsed = new URL(url, (0, $437be5401ebe48b5$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch (e) {
        return void 0;
    }
}
function $00bffb38a33d83ba$export$5803eedf1027ce61(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
function $00bffb38a33d83ba$export$9dc5b8b2fb320da0(headers) {
    try {
        return new Headers(headers);
    } catch (e) {
        return void 0;
    }
}


const $8af1d568eaf861c6$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    trackFetchStreamPerformance: false
};
function $8af1d568eaf861c6$export$864489cb3478db3e(client, _options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, tracePropagationTargets: tracePropagationTargets, onRequestSpanStart: onRequestSpanStart, onRequestSpanEnd: onRequestSpanEnd } = (0, $9tqwB._)({}, $8af1d568eaf861c6$export$cc17fb3c0bc95cd7, _options);
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    const shouldAttachHeadersWithTargets = (url)=>$8af1d568eaf861c6$export$c260386ab3f0b3dd(url, tracePropagationTargets);
    const spans = {};
    const propagateTraceparent = client.getOptions().propagateTraceparent;
    if (traceFetch) (0, $b353b064a96cf357$exports.addFetchInstrumentationHandler)((handlerData)=>{
        const createdSpan = (0, $b353b064a96cf357$exports.instrumentFetchRequest)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans, {
            propagateTraceparent: propagateTraceparent,
            onRequestSpanEnd: onRequestSpanEnd
        });
        if (createdSpan) {
            const fullUrl = (0, $00bffb38a33d83ba$export$f2a087db7564c909)(handlerData.fetchData.url);
            const host = fullUrl ? (0, $b353b064a96cf357$exports.parseUrl)(fullUrl).host : void 0;
            const sanitizedFullUrl = fullUrl ? (0, $b353b064a96cf357$exports.stripDataUrlContent)(fullUrl) : void 0;
            createdSpan.setAttributes({
                "http.url": sanitizedFullUrl,
                // `url.full` must match `http.url`. Setting it here ensures parentless `http.client`
                // segment spans don't get `url.full` backfilled with the host page URL (see httpContextIntegration).
                "url.full": sanitizedFullUrl,
                "server.address": host
            });
            if (enableHTTPTimings) $8af1d568eaf861c6$var$addHTTPTimings(createdSpan, client);
            onRequestSpanStart === null || onRequestSpanStart === void 0 ? void 0 : onRequestSpanStart(createdSpan, {
                headers: handlerData.headers
            });
        }
    });
    if (traceXHR) (0, $8700a702c00468d1$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $8af1d568eaf861c6$var$xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans, propagateTraceparent, onRequestSpanEnd);
        if (createdSpan) {
            var _handlerData_xhr___sentry_xhr_v3__;
            if (enableHTTPTimings) $8af1d568eaf861c6$var$addHTTPTimings(createdSpan, client);
            onRequestSpanStart === null || onRequestSpanStart === void 0 ? void 0 : onRequestSpanStart(createdSpan, {
                headers: (0, $00bffb38a33d83ba$export$9dc5b8b2fb320da0)((_handlerData_xhr___sentry_xhr_v3__ = handlerData.xhr.__sentry_xhr_v3__) === null || _handlerData_xhr___sentry_xhr_v3__ === void 0 ? void 0 : _handlerData_xhr___sentry_xhr_v3__.request_headers)
            });
        }
    });
}
const $8af1d568eaf861c6$var$HTTP_TIMING_WAIT_MS = 300;
function $8af1d568eaf861c6$var$addHTTPTimings(span, client) {
    const { url: url } = (0, $b353b064a96cf357$exports.spanToJSON)(span).data;
    if (!url || typeof url !== "string") return;
    let onEntryFound = ()=>void setTimeout(unsubscribePerformanceObsever);
    if ((0, $b353b064a96cf357$exports.hasSpanStreamingEnabled)(client)) {
        const originalEnd = span.end.bind(span);
        span.end = (endTimestamp)=>{
            const capturedEndTimestamp = endTimestamp !== null && endTimestamp !== void 0 ? endTimestamp : (0, $b353b064a96cf357$exports.timestampInSeconds)();
            let isEnded = false;
            const endSpanAndCleanup = ()=>{
                if (isEnded) return;
                isEnded = true;
                setTimeout(unsubscribePerformanceObsever);
                originalEnd(capturedEndTimestamp);
                clearTimeout(fallbackTimeout);
            };
            onEntryFound = endSpanAndCleanup;
            const fallbackTimeout = setTimeout(endSpanAndCleanup, $8af1d568eaf861c6$var$HTTP_TIMING_WAIT_MS);
        };
    }
    const unsubscribePerformanceObsever = (0, $5d4e4d5b5c2c563b$export$69816c1a049f8db6)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ((0, $00bffb38a33d83ba$export$5803eedf1027ce61)(entry) && entry.name.endsWith(url)) {
                span.setAttributes((0, $4b982bae59115902$export$ec50b091612e7e00)(entry));
                onEntryFound();
            }
        });
    });
}
function $8af1d568eaf861c6$export$c260386ab3f0b3dd(targetUrl, tracePropagationTargets) {
    const href = (0, $b353b064a96cf357$exports.getLocationHref)();
    if (!href) {
        const isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
        if (!tracePropagationTargets) return isRelativeSameOriginRequest;
        else return (0, $b353b064a96cf357$exports.stringMatchesSomePattern)(targetUrl, tracePropagationTargets);
    } else {
        let resolvedUrl;
        let currentOrigin;
        try {
            resolvedUrl = new URL(targetUrl, href);
            currentOrigin = new URL(href).origin;
        } catch (e) {
            return false;
        }
        const isSameOriginRequest = resolvedUrl.origin === currentOrigin;
        if (!tracePropagationTargets) return isSameOriginRequest;
        else return (0, $b353b064a96cf357$exports.stringMatchesSomePattern)(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && (0, $b353b064a96cf357$exports.stringMatchesSomePattern)(resolvedUrl.pathname, tracePropagationTargets);
    }
}
function $8af1d568eaf861c6$var$xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeaders2, spans, propagateTraceparent, onRequestSpanEnd) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr === null || xhr === void 0 ? void 0 : xhr[0, $8700a702c00468d1$export$55b6bb1e45c6cf59];
    if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) return void 0;
    const { url: url, method: method } = sentryXhrData;
    const shouldCreateSpanResult = (0, $b353b064a96cf357$exports.hasSpansEnabled)() && shouldCreateSpan(url);
    if (handlerData.endTimestamp) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span2 = spans[spanId];
        if (span2) {
            if (shouldCreateSpanResult && sentryXhrData.status_code !== void 0) {
                (0, $b353b064a96cf357$exports.setHttpStatus)(span2, sentryXhrData.status_code);
                span2.end();
                onRequestSpanEnd === null || onRequestSpanEnd === void 0 ? void 0 : onRequestSpanEnd(span2, {
                    headers: (0, $00bffb38a33d83ba$export$9dc5b8b2fb320da0)((0, $d62dd922bf22e2c2$export$ce71c337afb62ea)(xhr)),
                    error: handlerData.error
                });
            }
            delete spans[spanId];
        }
        return void 0;
    }
    const fullUrl = (0, $00bffb38a33d83ba$export$f2a087db7564c909)(url);
    const parsedUrl = fullUrl ? (0, $b353b064a96cf357$exports.parseUrl)(fullUrl) : (0, $b353b064a96cf357$exports.parseUrl)(url);
    const sanitizedFullUrl = fullUrl ? (0, $b353b064a96cf357$exports.stripDataUrlContent)(fullUrl) : void 0;
    const urlForSpanName = (0, $b353b064a96cf357$exports.stripDataUrlContent)((0, $b353b064a96cf357$exports.stripUrlQueryAndFragment)(url));
    const client = (0, $b353b064a96cf357$exports.getClient)();
    const hasParent = !!(0, $b353b064a96cf357$exports.getActiveSpan)();
    const shouldEmitSpan = hasParent || !!client && (0, $b353b064a96cf357$exports.hasSpanStreamingEnabled)(client);
    const span = shouldCreateSpanResult && shouldEmitSpan ? (0, $b353b064a96cf357$exports.startInactiveSpan)({
        name: `${method} ${urlForSpanName}`,
        attributes: (0, $9tqwB._)({
            url: (0, $b353b064a96cf357$exports.stripDataUrlContent)(url),
            type: "xhr",
            "http.method": method,
            "http.url": sanitizedFullUrl,
            // `url.full` must match `http.url`. Setting it here ensures parentless `http.client`
            // segment spans don't get `url.full` backfilled with the host page URL (see httpContextIntegration).
            "url.full": sanitizedFullUrl,
            "server.address": parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.host,
            [(0, $b353b064a96cf357$exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.http.browser",
            [(0, $b353b064a96cf357$exports.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "http.client"
        }, (parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.search) && {
            "http.query": parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.search
        }, (parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.hash) && {
            "http.fragment": parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.hash
        })
    }) : new (0, $b353b064a96cf357$exports.SentryNonRecordingSpan)();
    if (shouldCreateSpanResult && !shouldEmitSpan) client === null || client === void 0 ? void 0 : client.recordDroppedEvent("no_parent_span", "span");
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
    if (shouldAttachHeaders2(url)) $8af1d568eaf861c6$var$addTracingHeadersToXhrRequest(xhr, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    (0, $b353b064a96cf357$exports.hasSpansEnabled)() && shouldEmitSpan ? span : void 0, propagateTraceparent);
    if (client) client.emit("beforeOutgoingRequestSpan", span, handlerData);
    return span;
}
function $8af1d568eaf861c6$var$addTracingHeadersToXhrRequest(xhr, span, propagateTraceparent) {
    const { "sentry-trace": sentryTrace, baggage: baggage, traceparent: traceparent } = (0, $b353b064a96cf357$exports.getTraceData)({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    if (sentryTrace) $8af1d568eaf861c6$var$setHeaderOnXhr(xhr, sentryTrace, baggage, traceparent);
}
function $8af1d568eaf861c6$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader, traceparentHeader) {
    var _xhr___sentry_xhr_v3__;
    const originalHeaders = (_xhr___sentry_xhr_v3__ = xhr.__sentry_xhr_v3__) === null || _xhr___sentry_xhr_v3__ === void 0 ? void 0 : _xhr___sentry_xhr_v3__.request_headers;
    if ((originalHeaders === null || originalHeaders === void 0 ? void 0 : originalHeaders["sentry-trace"]) || !xhr.setRequestHeader) return;
    try {
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (traceparentHeader && !(originalHeaders === null || originalHeaders === void 0 ? void 0 : originalHeaders["traceparent"])) xhr.setRequestHeader("traceparent", traceparentHeader);
        if (sentryBaggageHeader) {
            const originalBaggageHeader = originalHeaders === null || originalHeaders === void 0 ? void 0 : originalHeaders["baggage"];
            if (!originalBaggageHeader || !(0, $00bffb38a33d83ba$export$8193ac587e359dc0)(originalBaggageHeader)) xhr.setRequestHeader("baggage", sentryBaggageHeader);
        }
    } catch (e) {}
}


const $c773bc56c44c435b$export$bbd2089f30bd3708 = "BrowserTracing";
const $c773bc56c44c435b$var$BOT_USER_AGENT_RE = /Googlebot|Google-InspectionTool|Storebot-Google|Bingbot|Slurp|DuckDuckBot|Baiduspider|YandexBot|Facebot|facebookexternalhit|LinkedInBot|Twitterbot|Applebot/i;
function $c773bc56c44c435b$export$e189d11d152c4191() {
    const nav = (0, $437be5401ebe48b5$export$56d8a8a25bd48b81).navigator;
    if (!(nav === null || nav === void 0 ? void 0 : nav.userAgent)) return false;
    return $c773bc56c44c435b$var$BOT_USER_AGENT_RE.test(nav.userAgent);
}
const $c773bc56c44c435b$var$DEFAULT_BROWSER_TRACING_OPTIONS = (0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({}, (0, $b353b064a96cf357$exports.TRACING_DEFAULTS)), {
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableLongAnimationFrame: true,
    enableInp: true,
    ignoreResourceSpans: [],
    ignorePerformanceApiSpans: [],
    detectRedirects: true,
    linkPreviousTrace: "in-memory",
    consistentTraceSampling: false,
    enableReportPageLoaded: false,
    _experiments: {}
}), (0, $8af1d568eaf861c6$export$cc17fb3c0bc95cd7));
const $c773bc56c44c435b$export$b4109253475213e9 = (options = {})=>{
    if ("enableElementTiming" in options) (0, $b353b064a96cf357$exports.consoleSandbox)(()=>{
        console.warn("[Sentry] `enableElementTiming` is deprecated and no longer has any effect. Use the standalone `elementTimingIntegration` instead.");
    });
    const latestRoute = {
        name: void 0,
        source: void 0
    };
    const optionalWindowDocument = (0, $437be5401ebe48b5$export$56d8a8a25bd48b81).document;
    const { enableInp: enableInp, enableLongTask: enableLongTask, enableLongAnimationFrame: enableLongAnimationFrame, _experiments: { enableInteractions: enableInteractions, enableStandaloneClsSpans: enableStandaloneClsSpans, enableStandaloneLcpSpans: enableStandaloneLcpSpans }, beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, childSpanTimeout: childSpanTimeout, markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: // eslint-disable-next-line typescript/no-deprecated
    trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, ignoreResourceSpans: ignoreResourceSpans, ignorePerformanceApiSpans: ignorePerformanceApiSpans, instrumentPageLoad: instrumentPageLoad, instrumentNavigation: instrumentNavigation, detectRedirects: detectRedirects, linkPreviousTrace: linkPreviousTrace, consistentTraceSampling: consistentTraceSampling, enableReportPageLoaded: enableReportPageLoaded, onRequestSpanStart: onRequestSpanStart, onRequestSpanEnd: onRequestSpanEnd } = (0, $9tqwB._)({}, $c773bc56c44c435b$var$DEFAULT_BROWSER_TRACING_OPTIONS, options);
    const _isBot = $c773bc56c44c435b$export$e189d11d152c4191();
    let lastInteractionTimestamp;
    let _pageloadSpan;
    function _createRouteSpan(client, startSpanOptions, makeActive = true) {
        const isPageloadSpan = startSpanOptions.op === "pageload";
        const initialSpanName = startSpanOptions.name;
        const finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
        const attributes = finalStartSpanOptions.attributes || {};
        if (initialSpanName !== finalStartSpanOptions.name) {
            attributes[0, $b353b064a96cf357$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "custom";
            finalStartSpanOptions.attributes = attributes;
        }
        if (!makeActive) {
            const now = (0, $b353b064a96cf357$exports.dateTimestampInSeconds)();
            (0, $b353b064a96cf357$exports.startInactiveSpan)((0, $2qxEV._)((0, $9tqwB._)({}, finalStartSpanOptions), {
                startTime: now
            })).end(now);
            return;
        }
        latestRoute.name = finalStartSpanOptions.name;
        latestRoute.source = attributes[0, $b353b064a96cf357$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        const idleSpan = (0, $b353b064a96cf357$exports.startIdleSpan)(finalStartSpanOptions, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout,
            // should wait for finish signal if it's a pageload transaction
            disableAutoFinish: isPageloadSpan,
            beforeSpanEnd: (span)=>{
                (0, $00afd3b4f9d0757f$export$5f8fa6b3467a7443)(span, {
                    ignoreResourceSpans: ignoreResourceSpans,
                    ignorePerformanceApiSpans: ignorePerformanceApiSpans,
                    spanStreamingEnabled: (0, $b353b064a96cf357$exports.hasSpanStreamingEnabled)(client)
                });
                $c773bc56c44c435b$var$setActiveIdleSpan(client, void 0);
                const scope = (0, $b353b064a96cf357$exports.getCurrentScope)();
                const oldPropagationContext = scope.getPropagationContext();
                scope.setPropagationContext((0, $2qxEV._)((0, $9tqwB._)({}, oldPropagationContext), {
                    traceId: idleSpan.spanContext().traceId,
                    sampled: (0, $b353b064a96cf357$exports.spanIsSampled)(idleSpan),
                    dsc: (0, $b353b064a96cf357$exports.getDynamicSamplingContextFromSpan)(span)
                }));
                if (isPageloadSpan) _pageloadSpan = void 0;
            },
            trimIdleSpanEndTimestamp: !enableReportPageLoaded
        });
        if (isPageloadSpan && enableReportPageLoaded) _pageloadSpan = idleSpan;
        $c773bc56c44c435b$var$setActiveIdleSpan(client, idleSpan);
        function emitFinish() {
            if (optionalWindowDocument && [
                "interactive",
                "complete"
            ].includes(optionalWindowDocument.readyState)) {
                client.emit("idleSpanEnableAutoFinish", idleSpan);
                optionalWindowDocument.removeEventListener("readystatechange", emitFinish);
            }
        }
        if (isPageloadSpan && !enableReportPageLoaded && optionalWindowDocument) {
            optionalWindowDocument.addEventListener("readystatechange", emitFinish);
            emitFinish();
        }
    }
    return {
        name: $c773bc56c44c435b$export$bbd2089f30bd3708,
        setup (client) {
            var _PerformanceObserver_supportedEntryTypes;
            if (_isBot) {
                (0, $03d071cefd392f71$export$16a28057038b10ef) && (0, $b353b064a96cf357$exports.debug).log("[Tracing] Skipping browserTracingIntegration setup for bot user agent.");
                return;
            }
            (0, $b353b064a96cf357$exports.registerSpanErrorInstrumentation)();
            if (enableLongAnimationFrame && (0, $b353b064a96cf357$exports.GLOBAL_OBJ).PerformanceObserver && ((_PerformanceObserver_supportedEntryTypes = PerformanceObserver.supportedEntryTypes) === null || _PerformanceObserver_supportedEntryTypes === void 0 ? void 0 : _PerformanceObserver_supportedEntryTypes.includes("long-animation-frame"))) (0, $00afd3b4f9d0757f$export$5b823ab2ccbc801d)();
            else if (enableLongTask) (0, $00afd3b4f9d0757f$export$f396d19077034ad2)();
            if (enableInteractions) (0, $00afd3b4f9d0757f$export$e27543e0976315e4)();
            if (detectRedirects && optionalWindowDocument) {
                const interactionHandler = ()=>{
                    lastInteractionTimestamp = (0, $b353b064a96cf357$exports.timestampInSeconds)();
                };
                addEventListener("click", interactionHandler, {
                    capture: true
                });
                addEventListener("keydown", interactionHandler, {
                    capture: true,
                    passive: true
                });
            }
            function maybeEndActiveSpan() {
                const activeSpan = $c773bc56c44c435b$var$getActiveIdleSpan(client);
                if (activeSpan && !(0, $b353b064a96cf357$exports.spanToJSON)(activeSpan).timestamp) {
                    (0, $03d071cefd392f71$export$16a28057038b10ef) && (0, $b353b064a96cf357$exports.debug).log(`[Tracing] Finishing current active span with op: ${(0, $b353b064a96cf357$exports.spanToJSON)(activeSpan).op}`);
                    activeSpan.setAttribute((0, $b353b064a96cf357$exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), "cancelled");
                    activeSpan.end();
                }
            }
            client.on("startNavigationSpan", (startSpanOptions, navigationOptions)=>{
                if ((0, $b353b064a96cf357$exports.getClient)() !== client) return;
                if (navigationOptions === null || navigationOptions === void 0 ? void 0 : navigationOptions.isRedirect) {
                    (0, $03d071cefd392f71$export$16a28057038b10ef) && (0, $b353b064a96cf357$exports.debug).warn("[Tracing] Detected redirect, navigation span will not be the root span, but a child span.");
                    _createRouteSpan(client, (0, $9tqwB._)({
                        op: "navigation.redirect"
                    }, startSpanOptions), false);
                    return;
                }
                lastInteractionTimestamp = void 0;
                maybeEndActiveSpan();
                (0, $b353b064a96cf357$exports.getIsolationScope)().setPropagationContext({
                    traceId: (0, $b353b064a96cf357$exports.generateTraceId)(),
                    sampleRand: Math.random(),
                    propagationSpanId: (0, $b353b064a96cf357$exports.hasSpansEnabled)() ? void 0 : (0, $b353b064a96cf357$exports.generateSpanId)()
                });
                const scope = (0, $b353b064a96cf357$exports.getCurrentScope)();
                scope.setPropagationContext({
                    traceId: (0, $b353b064a96cf357$exports.generateTraceId)(),
                    sampleRand: Math.random(),
                    propagationSpanId: (0, $b353b064a96cf357$exports.hasSpansEnabled)() ? void 0 : (0, $b353b064a96cf357$exports.generateSpanId)()
                });
                scope.setSDKProcessingMetadata({
                    normalizedRequest: void 0
                });
                _createRouteSpan(client, (0, $2qxEV._)((0, $9tqwB._)({
                    op: "navigation"
                }, startSpanOptions), {
                    // Navigation starts a new trace and is NOT parented under any active interaction (e.g. ui.action.click)
                    parentSpan: null,
                    forceTransaction: true
                }));
            });
            client.on("startPageLoadSpan", (startSpanOptions, traceOptions = {})=>{
                if ((0, $b353b064a96cf357$exports.getClient)() !== client) return;
                maybeEndActiveSpan();
                const sentryTrace = traceOptions.sentryTrace || $c773bc56c44c435b$export$f147b32b03c9cf11("sentry-trace") || $c773bc56c44c435b$export$5bb9693b37f7c2ae("sentry-trace");
                const baggage = traceOptions.baggage || $c773bc56c44c435b$export$f147b32b03c9cf11("baggage") || $c773bc56c44c435b$export$5bb9693b37f7c2ae("baggage");
                const propagationContext = (0, $b353b064a96cf357$exports.propagationContextFromHeaders)(sentryTrace, baggage);
                const scope = (0, $b353b064a96cf357$exports.getCurrentScope)();
                scope.setPropagationContext(propagationContext);
                if (!(0, $b353b064a96cf357$exports.hasSpansEnabled)()) scope.getPropagationContext().propagationSpanId = (0, $b353b064a96cf357$exports.generateSpanId)();
                scope.setSDKProcessingMetadata({
                    normalizedRequest: (0, $437be5401ebe48b5$export$a3c4a8453e8936f0)()
                });
                _createRouteSpan(client, (0, $9tqwB._)({
                    op: "pageload"
                }, startSpanOptions));
            });
            client.on("endPageloadSpan", ()=>{
                if (enableReportPageLoaded && _pageloadSpan) {
                    _pageloadSpan.setAttribute((0, $b353b064a96cf357$exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), "reportPageLoaded");
                    _pageloadSpan.end();
                }
            });
        },
        afterAllSetup (client) {
            var _client_getIntegrationByName;
            if (_isBot) return;
            if (client.addIntegration && !((_client_getIntegrationByName = client.getIntegrationByName) === null || _client_getIntegrationByName === void 0 ? void 0 : _client_getIntegrationByName.call(client, (0, $d6071b41fea963d0$export$8748555bacc7091c)))) client.addIntegration((0, $d6071b41fea963d0$export$1ab4995602e8adaa)({
                ignore: enableInp ? [] : [
                    "inp"
                ],
                _experiments: {
                    enableStandaloneClsSpans: enableStandaloneClsSpans,
                    enableStandaloneLcpSpans: enableStandaloneLcpSpans
                }
            }));
            let startingUrl = (0, $b353b064a96cf357$exports.getLocationHref)();
            if (linkPreviousTrace !== "off") (0, $cf4e861431bc45c6$export$830d9ee659c6e4c4)(client, {
                linkPreviousTrace: linkPreviousTrace,
                consistentTraceSampling: consistentTraceSampling
            });
            if ((0, $437be5401ebe48b5$export$56d8a8a25bd48b81).location) {
                if (instrumentPageLoad) {
                    const origin = (0, $b353b064a96cf357$exports.browserPerformanceTimeOrigin)();
                    $c773bc56c44c435b$export$aa44a07f82af519f(client, {
                        name: (0, $437be5401ebe48b5$export$56d8a8a25bd48b81).location.pathname,
                        // pageload should always start at timeOrigin (and needs to be in s, not ms)
                        startTime: origin ? origin / 1e3 : void 0,
                        attributes: {
                            [(0, $b353b064a96cf357$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url",
                            [(0, $b353b064a96cf357$exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.pageload.browser"
                        }
                    });
                }
                if (instrumentNavigation) (0, $a2d725b30741e272$export$3f18c56c58114e75)(({ to: to, from: from })=>{
                    if (from === void 0 && (startingUrl === null || startingUrl === void 0 ? void 0 : startingUrl.indexOf(to)) !== -1) {
                        startingUrl = void 0;
                        return;
                    }
                    startingUrl = void 0;
                    const parsed = (0, $b353b064a96cf357$exports.parseStringToURLObject)(to);
                    const activeSpan = $c773bc56c44c435b$var$getActiveIdleSpan(client);
                    const navigationIsRedirect = activeSpan && detectRedirects && $c773bc56c44c435b$var$isRedirect(activeSpan, lastInteractionTimestamp);
                    $c773bc56c44c435b$export$7d159749bd9969ad(client, {
                        name: (parsed === null || parsed === void 0 ? void 0 : parsed.pathname) || (0, $437be5401ebe48b5$export$56d8a8a25bd48b81).location.pathname,
                        attributes: {
                            [(0, $b353b064a96cf357$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url",
                            [(0, $b353b064a96cf357$exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.navigation.browser"
                        }
                    }, {
                        url: to,
                        isRedirect: navigationIsRedirect
                    });
                });
            }
            if (markBackgroundSpan) (0, $7ea9b22cd3a72ae0$export$6f18f55521af71a1)();
            if (enableInteractions) $c773bc56c44c435b$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
            (0, $8af1d568eaf861c6$export$864489cb3478db3e)(client, {
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                tracePropagationTargets: client.getOptions().tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings,
                onRequestSpanStart: onRequestSpanStart,
                onRequestSpanEnd: onRequestSpanEnd
            });
            if (trackFetchStreamPerformance) client.addIntegration((0, $e7e00d70eeed282d$export$b49e0d1a48dc8754)());
        }
    };
};
function $c773bc56c44c435b$export$aa44a07f82af519f(client, spanOptions, traceOptions) {
    client.emit("startPageLoadSpan", spanOptions, traceOptions);
    (0, $b353b064a96cf357$exports.getCurrentScope)().setTransactionName(spanOptions.name);
    const pageloadSpan = $c773bc56c44c435b$var$getActiveIdleSpan(client);
    if (pageloadSpan) client.emit("afterStartPageLoadSpan", pageloadSpan);
    return pageloadSpan;
}
function $c773bc56c44c435b$export$7d159749bd9969ad(client, spanOptions, options) {
    const { url: url, isRedirect: isRedirect2 } = options || {};
    client.emit("beforeStartNavigationSpan", spanOptions, {
        isRedirect: isRedirect2
    });
    client.emit("startNavigationSpan", spanOptions, {
        isRedirect: isRedirect2
    });
    const scope = (0, $b353b064a96cf357$exports.getCurrentScope)();
    scope.setTransactionName(spanOptions.name);
    if (url && !isRedirect2) scope.setSDKProcessingMetadata({
        normalizedRequest: (0, $2qxEV._)((0, $9tqwB._)({}, (0, $437be5401ebe48b5$export$a3c4a8453e8936f0)()), {
            url: url
        })
    });
    return $c773bc56c44c435b$var$getActiveIdleSpan(client);
}
function $c773bc56c44c435b$export$f147b32b03c9cf11(metaName) {
    const optionalWindowDocument = (0, $437be5401ebe48b5$export$56d8a8a25bd48b81).document;
    const metaTag = optionalWindowDocument === null || optionalWindowDocument === void 0 ? void 0 : optionalWindowDocument.querySelector(`meta[name=${metaName}]`);
    return (metaTag === null || metaTag === void 0 ? void 0 : metaTag.getAttribute("content")) || void 0;
}
function $c773bc56c44c435b$export$5bb9693b37f7c2ae(name) {
    var _WINDOW_performance_getEntriesByType, _WINDOW_performance, _navigation_serverTiming;
    const navigation = (_WINDOW_performance = (0, $437be5401ebe48b5$export$56d8a8a25bd48b81).performance) === null || _WINDOW_performance === void 0 ? void 0 : (_WINDOW_performance_getEntriesByType = _WINDOW_performance.getEntriesByType) === null || _WINDOW_performance_getEntriesByType === void 0 ? void 0 : _WINDOW_performance_getEntriesByType.call(_WINDOW_performance, "navigation")[0];
    const entry = navigation === null || navigation === void 0 ? void 0 : (_navigation_serverTiming = navigation.serverTiming) === null || _navigation_serverTiming === void 0 ? void 0 : _navigation_serverTiming.find((entry2)=>entry2.name === name);
    return entry === null || entry === void 0 ? void 0 : entry.description;
}
function $c773bc56c44c435b$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
    const optionalWindowDocument = (0, $437be5401ebe48b5$export$56d8a8a25bd48b81).document;
    let inflightInteractionSpan;
    const registerInteractionTransaction = ()=>{
        const op = "ui.action.click";
        const activeIdleSpan = $c773bc56c44c435b$var$getActiveIdleSpan(client);
        if (activeIdleSpan) {
            const currentRootSpanOp = (0, $b353b064a96cf357$exports.spanToJSON)(activeIdleSpan).op;
            if ([
                "navigation",
                "pageload"
            ].includes(currentRootSpanOp)) {
                (0, $03d071cefd392f71$export$16a28057038b10ef) && (0, $b353b064a96cf357$exports.debug).warn(`[Tracing] Did not create ${op} span because a pageload or navigation span is in progress.`);
                return void 0;
            }
        }
        if (inflightInteractionSpan) {
            inflightInteractionSpan.setAttribute((0, $b353b064a96cf357$exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), "interactionInterrupted");
            inflightInteractionSpan.end();
            inflightInteractionSpan = void 0;
        }
        if (!latestRoute.name) {
            (0, $03d071cefd392f71$export$16a28057038b10ef) && (0, $b353b064a96cf357$exports.debug).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return void 0;
        }
        inflightInteractionSpan = (0, $b353b064a96cf357$exports.startIdleSpan)({
            name: latestRoute.name,
            op: op,
            attributes: {
                [(0, $b353b064a96cf357$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: latestRoute.source || "url"
            }
        }, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout
        });
    };
    if (optionalWindowDocument) addEventListener("click", registerInteractionTransaction, {
        capture: true
    });
}
const $c773bc56c44c435b$var$ACTIVE_IDLE_SPAN_PROPERTY = "_sentry_idleSpan";
function $c773bc56c44c435b$var$getActiveIdleSpan(client) {
    return client[$c773bc56c44c435b$var$ACTIVE_IDLE_SPAN_PROPERTY];
}
function $c773bc56c44c435b$var$setActiveIdleSpan(client, span) {
    (0, $b353b064a96cf357$exports.addNonEnumerableProperty)(client, $c773bc56c44c435b$var$ACTIVE_IDLE_SPAN_PROPERTY, span);
}
const $c773bc56c44c435b$var$REDIRECT_THRESHOLD = 1.5;
function $c773bc56c44c435b$var$isRedirect(activeSpan, lastInteractionTimestamp) {
    const spanData = (0, $b353b064a96cf357$exports.spanToJSON)(activeSpan);
    const now = (0, $b353b064a96cf357$exports.dateTimestampInSeconds)();
    const startTimestamp = spanData.start_timestamp;
    if (now - startTimestamp > $c773bc56c44c435b$var$REDIRECT_THRESHOLD) return false;
    if (lastInteractionTimestamp && now - lastInteractionTimestamp <= $c773bc56c44c435b$var$REDIRECT_THRESHOLD) return false;
    return true;
}


var $9tqwB = parcelRequire("9tqwB");

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $9tqwB = parcelRequire("9tqwB");


var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

function $30b34c487def1b34$export$a6c2d27607295951(stackParser, ex) {
    const frames = $30b34c487def1b34$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $30b34c487def1b34$export$2e9ae379995d99e3(ex),
        value: $30b34c487def1b34$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === void 0 && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $30b34c487def1b34$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $b353b064a96cf357$exports.getClient)();
    const normalizeDepth = client === null || client === void 0 ? void 0 : client.getOptions().normalizeDepth;
    const errorFromProp = $30b34c487def1b34$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $b353b064a96cf357$exports.normalizeToSize)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $30b34c487def1b34$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $b353b064a96cf357$exports.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $30b34c487def1b34$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $30b34c487def1b34$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $30b34c487def1b34$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $30b34c487def1b34$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
function $30b34c487def1b34$var$parseStackFrames(stackParser, ex) {
    const stacktrace = ex.stacktrace || ex.stack || "";
    const skipLines = $30b34c487def1b34$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $30b34c487def1b34$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {}
    return [];
}
const $30b34c487def1b34$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $30b34c487def1b34$var$getSkipFirstStackStringLines(ex) {
    if (ex && $30b34c487def1b34$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
function $30b34c487def1b34$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === "number") return ex.framesToPop;
    return 0;
}
function $30b34c487def1b34$var$isWebAssemblyException(exception) {
    if (typeof WebAssembly !== "undefined" && typeof WebAssembly.Exception !== "undefined") return exception instanceof WebAssembly.Exception;
    else return false;
}
function $30b34c487def1b34$export$2e9ae379995d99e3(ex) {
    const name = ex === null || ex === void 0 ? void 0 : ex.name;
    if (!name && $30b34c487def1b34$var$isWebAssemblyException(ex)) {
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : "WebAssembly.Exception";
    }
    return name;
}
function $30b34c487def1b34$export$86005d1b62804363(ex) {
    const message = ex === null || ex === void 0 ? void 0 : ex.message;
    if ($30b34c487def1b34$var$isWebAssemblyException(ex)) {
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return "wasm exception";
    }
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return (0, $b353b064a96cf357$exports._INTERNAL_enhanceErrorWithSentryInfo)(message.error);
    return (0, $b353b064a96cf357$exports._INTERNAL_enhanceErrorWithSentryInfo)(ex);
}
function $30b34c487def1b34$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = (hint === null || hint === void 0 ? void 0 : hint.syntheticException) || void 0;
    const event = $30b34c487def1b34$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $b353b064a96cf357$exports.addExceptionMechanism)(event);
    event.level = "error";
    if (hint === null || hint === void 0 ? void 0 : hint.event_id) event.event_id = hint.event_id;
    return (0, $b353b064a96cf357$exports.resolvedSyncPromise)(event);
}
function $30b34c487def1b34$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const syntheticException = (hint === null || hint === void 0 ? void 0 : hint.syntheticException) || void 0;
    const event = $30b34c487def1b34$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint === null || hint === void 0 ? void 0 : hint.event_id) event.event_id = hint.event_id;
    return (0, $b353b064a96cf357$exports.resolvedSyncPromise)(event);
}
function $30b34c487def1b34$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $b353b064a96cf357$exports.isErrorEvent)(exception) && exception.error) {
        const errorEvent = exception;
        return $30b34c487def1b34$var$eventFromError(stackParser, errorEvent.error);
    }
    if ((0, $b353b064a96cf357$exports.isDOMError)(exception) || (0, $b353b064a96cf357$exports.isDOMException)(exception)) {
        const domException = exception;
        if ("stack" in exception) {
            var _event_exception_values, _event_exception;
            event = $30b34c487def1b34$var$eventFromError(stackParser, exception);
            const firstException = (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values[0];
            if (attachStacktrace && syntheticException && firstException && !firstException.stacktrace) {
                const frames = $30b34c487def1b34$var$parseStackFrames(stackParser, syntheticException);
                if (frames.length) {
                    firstException.stacktrace = {
                        frames: frames
                    };
                    (0, $b353b064a96cf357$exports.addExceptionMechanism)(event, {
                        synthetic: true
                    });
                }
            }
        } else {
            const name = domException.name || ((0, $b353b064a96cf357$exports.isDOMError)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $30b34c487def1b34$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $b353b064a96cf357$exports.addExceptionTypeValue)(event, message);
        }
        if ("code" in domException) event.tags = (0, $2qxEV._)((0, $9tqwB._)({}, event.tags), {
            "DOMException.code": `${domException.code}`
        });
        return event;
    }
    if ((0, $b353b064a96cf357$exports.isError)(exception)) return $30b34c487def1b34$var$eventFromError(stackParser, exception);
    if ((0, $b353b064a96cf357$exports.isPlainObject)(exception) || (0, $b353b064a96cf357$exports.isEvent)(exception)) {
        const objectException = exception;
        event = $30b34c487def1b34$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $b353b064a96cf357$exports.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    event = $30b34c487def1b34$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $b353b064a96cf357$exports.addExceptionTypeValue)(event, `${exception}`, void 0);
    (0, $b353b064a96cf357$exports.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $30b34c487def1b34$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $30b34c487def1b34$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $b353b064a96cf357$exports.addExceptionMechanism)(event, {
            synthetic: true
        });
    }
    if ((0, $b353b064a96cf357$exports.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $30b34c487def1b34$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $b353b064a96cf357$exports.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    if ((0, $b353b064a96cf357$exports.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $b353b064a96cf357$exports.isEvent)(exception)) {
        const className = $30b34c487def1b34$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $30b34c487def1b34$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch (e) {}
}
function $30b34c487def1b34$var$getErrorPropertyFromObject(obj) {
    return Object.values(obj).find((v)=>v instanceof Error);
}



class $31a3c3a87f4e980b$export$1df9218a526d318d extends (0, $b353b064a96cf357$exports.Client) {
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $30b34c487def1b34$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = "info", hint) {
        return (0, $30b34c487def1b34$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        var _opts__metadata;
        const opts = $31a3c3a87f4e980b$export$4e107b20a7f977(options);
        const sdkSource = (0, $437be5401ebe48b5$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $b353b064a96cf357$exports.getSDKSource)();
        (0, $b353b064a96cf357$exports.applySdkMetadata)(opts, "browser", [
            "browser"
        ], sdkSource);
        super(opts);
        const { userInfo: userInfo } = this.getDataCollectionOptions();
        if ((_opts__metadata = opts._metadata) === null || _opts__metadata === void 0 ? void 0 : _opts__metadata.sdk) opts._metadata.sdk.settings = (0, $9tqwB._)({
            // Only allow IP inferral by Relay if the user opted in via dataCollection
            infer_ip: userInfo ? "auto" : "never"
        }, opts._metadata.sdk.settings);
        const { sendClientReports: sendClientReports, enableLogs: enableLogs, _experiments: _experiments, enableMetrics: enableMetricsOption } = this._options;
        var _ref;
        const enableMetrics = (_ref = enableMetricsOption !== null && enableMetricsOption !== void 0 ? enableMetricsOption : _experiments === null || _experiments === void 0 ? void 0 : _experiments.enableMetrics) !== null && _ref !== void 0 ? _ref : true;
        if ((0, $437be5401ebe48b5$export$56d8a8a25bd48b81).document && (sendClientReports || enableLogs || enableMetrics)) (0, $437be5401ebe48b5$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $437be5401ebe48b5$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
                if (sendClientReports) this._flushOutcomes();
                if (enableLogs) (0, $b353b064a96cf357$exports._INTERNAL_flushLogsBuffer)(this);
                if (enableMetrics) (0, $b353b064a96cf357$exports._INTERNAL_flushMetricsBuffer)(this);
            }
        });
        if (userInfo) this.on("beforeSendSession", (0, $b353b064a96cf357$exports.addAutoIpAddressToSession));
    }
}
function $31a3c3a87f4e980b$export$4e107b20a7f977(optionsArg) {
    var _WINDOW_SENTRY_RELEASE;
    return (0, $9tqwB._)({
        release: typeof __SENTRY_RELEASE__ === "string" ? __SENTRY_RELEASE__ : (_WINDOW_SENTRY_RELEASE = (0, $437be5401ebe48b5$export$56d8a8a25bd48b81).SENTRY_RELEASE) === null || _WINDOW_SENTRY_RELEASE === void 0 ? void 0 : _WINDOW_SENTRY_RELEASE.id,
        // This supports the variable that sentry-webpack-plugin injects
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true
    }, optionsArg);
}



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");



const $e2f6a75a34783fde$var$DEBOUNCE_DURATION = 1e3;
let $e2f6a75a34783fde$var$debounceTimerID;
let $e2f6a75a34783fde$var$lastCapturedEventType;
let $e2f6a75a34783fde$var$lastCapturedEventTargetId;
function $e2f6a75a34783fde$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $53b768e21077af87$export$a4e09611e30da72e)(type, handler);
    (0, $53b768e21077af87$export$e18d6c5462c01368)(type, $e2f6a75a34783fde$export$3014bbf0af0e1d4a);
}
function $e2f6a75a34783fde$export$3014bbf0af0e1d4a() {
    if (!(0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).document) return;
    const triggerDOMHandler = (0, $53b768e21077af87$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $e2f6a75a34783fde$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).document.addEventListener("click", globalDOMEventHandler, false);
    (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).document.addEventListener("keypress", globalDOMEventHandler, false);
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        var _globalObject_target, _proto_hasOwnProperty;
        const globalObject = (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81);
        const proto = (_globalObject_target = globalObject[target]) === null || _globalObject_target === void 0 ? void 0 : _globalObject_target.prototype;
        if (!(proto === null || proto === void 0 ? void 0 : (_proto_hasOwnProperty = proto.hasOwnProperty) === null || _proto_hasOwnProperty === void 0 ? void 0 : _proto_hasOwnProperty.call(proto, "addEventListener"))) return;
        (0, $85a434b6cfc19e37$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $e2f6a75a34783fde$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {}
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $85a434b6cfc19e37$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = void 0;
                            delete handlers[type];
                        }
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {}
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
function $e2f6a75a34783fde$var$isSimilarToLastCapturedEvent(event) {
    if (event.type !== $e2f6a75a34783fde$var$lastCapturedEventType) return false;
    try {
        if (!event.target || event.target._sentryId !== $e2f6a75a34783fde$var$lastCapturedEventTargetId) return false;
    } catch (e) {}
    return true;
}
function $e2f6a75a34783fde$var$shouldSkipDOMEvent(eventType, target) {
    if (eventType !== "keypress") return false;
    if (!(target === null || target === void 0 ? void 0 : target.tagName)) return true;
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
function $e2f6a75a34783fde$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        if (!event || event["_sentryCaptured"]) return;
        const target = $e2f6a75a34783fde$var$getEventTarget(event);
        if ($e2f6a75a34783fde$var$shouldSkipDOMEvent(event.type, target)) return;
        (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(target, "_sentryId", (0, $df365b8ef5885c2b$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        if (!$e2f6a75a34783fde$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $e2f6a75a34783fde$var$lastCapturedEventType = event.type;
            $e2f6a75a34783fde$var$lastCapturedEventTargetId = target ? target._sentryId : void 0;
        }
        clearTimeout($e2f6a75a34783fde$var$debounceTimerID);
        $e2f6a75a34783fde$var$debounceTimerID = (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).setTimeout(()=>{
            $e2f6a75a34783fde$var$lastCapturedEventTargetId = void 0;
            $e2f6a75a34783fde$var$lastCapturedEventType = void 0;
        }, $e2f6a75a34783fde$var$DEBOUNCE_DURATION);
    };
}
function $e2f6a75a34783fde$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        return null;
    }
}




const $6345fc92bb1e1d94$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $6345fc92bb1e1d94$var$INTEGRATION_NAME = "Breadcrumbs";
const $6345fc92bb1e1d94$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = (0, $9tqwB._)({
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true
    }, options);
    return {
        name: $6345fc92bb1e1d94$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $b353b064a96cf357$exports.addConsoleInstrumentationHandler)($6345fc92bb1e1d94$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $e2f6a75a34783fde$export$5aeffd3db2cf9df7)($6345fc92bb1e1d94$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $8700a702c00468d1$export$26ace48dd54c9aea)($6345fc92bb1e1d94$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $b353b064a96cf357$exports.addFetchInstrumentationHandler)($6345fc92bb1e1d94$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $a2d725b30741e272$export$3f18c56c58114e75)($6345fc92bb1e1d94$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on("beforeSendEvent", $6345fc92bb1e1d94$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $6345fc92bb1e1d94$export$c079d904b326663a = (0, $b353b064a96cf357$exports.defineIntegration)($6345fc92bb1e1d94$var$_breadcrumbsIntegration);
function $6345fc92bb1e1d94$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $b353b064a96cf357$exports.getClient)() !== client) return;
        (0, $b353b064a96cf357$exports.addBreadcrumb)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $b353b064a96cf357$exports.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
function $6345fc92bb1e1d94$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $b353b064a96cf357$exports.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : void 0;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : void 0;
        if (maxStringLength && maxStringLength > $6345fc92bb1e1d94$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $03d071cefd392f71$export$16a28057038b10ef) && (0, $b353b064a96cf357$exports.debug).warn(`\`dom.maxStringLength\` cannot exceed ${$6345fc92bb1e1d94$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$6345fc92bb1e1d94$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $6345fc92bb1e1d94$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        try {
            const event = handlerData.event;
            const element = $6345fc92bb1e1d94$var$_isEvent(event) ? event.target : event;
            target = (0, $d6cf245db051044b$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $b353b064a96cf357$exports.getComponentName)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $b353b064a96cf357$exports.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
function $6345fc92bb1e1d94$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $b353b064a96cf357$exports.getClient)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $b353b064a96cf357$exports.severityLevelFromString)(handlerData.level),
            message: (0, $b353b064a96cf357$exports.safeJoin)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $b353b064a96cf357$exports.safeJoin)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else return;
        }
        (0, $b353b064a96cf357$exports.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
function $6345fc92bb1e1d94$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $b353b064a96cf357$exports.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $8700a702c00468d1$export$55b6bb1e45c6cf59];
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: "xhr",
            data: data,
            type: "http",
            level: (0, $b353b064a96cf357$exports.getBreadcrumbLogLevelFromHttpStatusCode)(status_code)
        };
        client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
        (0, $b353b064a96cf357$exports.addBreadcrumb)(breadcrumb, hint);
    };
}
function $6345fc92bb1e1d94$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $b353b064a96cf357$exports.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") return;
        if (handlerData.error) {
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: handlerData.fetchData,
                level: "error",
                type: "http"
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $b353b064a96cf357$exports.addBreadcrumb)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = (0, $2qxEV._)((0, $9tqwB._)({}, handlerData.fetchData), {
                status_code: response === null || response === void 0 ? void 0 : response.status
            });
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: data,
                type: "http",
                level: (0, $b353b064a96cf357$exports.getBreadcrumbLogLevelFromHttpStatusCode)(data.status_code)
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $b353b064a96cf357$exports.addBreadcrumb)(breadcrumb, hint);
        }
    };
}
function $6345fc92bb1e1d94$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $b353b064a96cf357$exports.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $b353b064a96cf357$exports.parseUrl)((0, $437be5401ebe48b5$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $b353b064a96cf357$exports.parseUrl)(from) : void 0;
        const parsedTo = (0, $b353b064a96cf357$exports.parseUrl)(to);
        if (!(parsedFrom === null || parsedFrom === void 0 ? void 0 : parsedFrom.path)) parsedFrom = parsedLoc;
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $b353b064a96cf357$exports.addBreadcrumb)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $6345fc92bb1e1d94$var$_isEvent(event) {
    return !!event && !!event.target;
}



var $9tqwB = parcelRequire("9tqwB");


const $e83828a914926395$var$DEFAULT_EVENT_TARGET = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,BroadcastChannel,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,SharedWorker,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");
const $e83828a914926395$var$INTEGRATION_NAME = "BrowserApiErrors";
const $e83828a914926395$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = (0, $9tqwB._)({
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false
    }, options);
    return {
        name: $e83828a914926395$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $b353b064a96cf357$exports.fill)((0, $437be5401ebe48b5$export$56d8a8a25bd48b81), "setTimeout", $e83828a914926395$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $b353b064a96cf357$exports.fill)((0, $437be5401ebe48b5$export$56d8a8a25bd48b81), "setInterval", $e83828a914926395$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $b353b064a96cf357$exports.fill)((0, $437be5401ebe48b5$export$56d8a8a25bd48b81), "requestAnimationFrame", $e83828a914926395$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $437be5401ebe48b5$export$56d8a8a25bd48b81)) (0, $b353b064a96cf357$exports.fill)(XMLHttpRequest.prototype, "send", $e83828a914926395$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $e83828a914926395$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$e83828a914926395$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
const $e83828a914926395$export$59bfe9f1c76150e = (0, $b353b064a96cf357$exports.defineIntegration)($e83828a914926395$var$_browserApiErrorsIntegration);
function $e83828a914926395$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $437be5401ebe48b5$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                handled: false,
                type: `auto.browser.browserapierrors.${(0, $b353b064a96cf357$exports.getFunctionName)(original)}`
            }
        });
        return original.apply(this, args);
    };
}
function $e83828a914926395$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $437be5401ebe48b5$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        handler: (0, $b353b064a96cf357$exports.getFunctionName)(original)
                    },
                    handled: false,
                    type: "auto.browser.browserapierrors.requestAnimationFrame"
                }
            })
        ]);
    };
}
function $e83828a914926395$var$_wrapXHR(originalSend) {
    return function(...args) {
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") (0, $b353b064a96cf357$exports.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            handler: (0, $b353b064a96cf357$exports.getFunctionName)(original)
                        },
                        handled: false,
                        type: `auto.browser.browserapierrors.xhr.${prop}`
                    }
                };
                const originalFunction = (0, $b353b064a96cf357$exports.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $b353b064a96cf357$exports.getFunctionName)(originalFunction);
                return (0, $437be5401ebe48b5$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $e83828a914926395$var$_wrapEventTarget(target, integrationOptions) {
    var _globalObject_target, _proto_hasOwnProperty;
    const globalObject = (0, $437be5401ebe48b5$export$56d8a8a25bd48b81);
    const proto = (_globalObject_target = globalObject[target]) === null || _globalObject_target === void 0 ? void 0 : _globalObject_target.prototype;
    if (!(proto === null || proto === void 0 ? void 0 : (_proto_hasOwnProperty = proto.hasOwnProperty) === null || _proto_hasOwnProperty === void 0 ? void 0 : _proto_hasOwnProperty.call(proto, "addEventListener"))) return;
    (0, $b353b064a96cf357$exports.fill)(proto, "addEventListener", function(original) {
        return function(eventName, fn, options) {
            try {
                if ($e83828a914926395$var$isEventListenerObject(fn)) fn.handleEvent = (0, $437be5401ebe48b5$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            handler: (0, $b353b064a96cf357$exports.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.handleEvent"
                    }
                });
            } catch (e) {}
            if (integrationOptions.unregisterOriginalCallbacks) $e83828a914926395$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $437be5401ebe48b5$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            handler: (0, $b353b064a96cf357$exports.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.addEventListener"
                    }
                }),
                options
            ]);
        };
    });
    (0, $b353b064a96cf357$exports.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            try {
                if (Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__")) {
                    const originalEventHandler = fn.__sentry_wrapped__;
                    if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
                }
            } catch (e) {}
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $e83828a914926395$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === "function";
}
function $e83828a914926395$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === "object" && "removeEventListener" in target && typeof target.removeEventListener === "function") target.removeEventListener(eventName, fn);
}






const $243e9b09baa28783$export$1baa7880e357371c = (0, $b353b064a96cf357$exports.defineIntegration)((options = {})=>{
    var _options_lifecycle;
    const lifecycle = (_options_lifecycle = options.lifecycle) !== null && _options_lifecycle !== void 0 ? _options_lifecycle : "route";
    return {
        name: "BrowserSession",
        setupOnce () {
            if (typeof (0, $437be5401ebe48b5$export$56d8a8a25bd48b81).document === "undefined") {
                (0, $03d071cefd392f71$export$16a28057038b10ef) && (0, $b353b064a96cf357$exports.debug).warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
                return;
            }
            (0, $b353b064a96cf357$exports.startSession)({
                ignoreDuration: true
            });
            (0, $b353b064a96cf357$exports.captureSession)();
            const isolationScope = (0, $b353b064a96cf357$exports.getIsolationScope)();
            let previousUser = isolationScope.getUser();
            isolationScope.addScopeListener((scope)=>{
                const maybeNewUser = scope.getUser();
                if ((previousUser === null || previousUser === void 0 ? void 0 : previousUser.id) !== (maybeNewUser === null || maybeNewUser === void 0 ? void 0 : maybeNewUser.id) || (previousUser === null || previousUser === void 0 ? void 0 : previousUser.ip_address) !== (maybeNewUser === null || maybeNewUser === void 0 ? void 0 : maybeNewUser.ip_address)) {
                    (0, $b353b064a96cf357$exports.captureSession)();
                    previousUser = maybeNewUser;
                }
            });
            if (lifecycle === "route") (0, $a2d725b30741e272$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                if (from !== to) {
                    (0, $b353b064a96cf357$exports.startSession)({
                        ignoreDuration: true
                    });
                    (0, $b353b064a96cf357$exports.captureSession)();
                }
            });
        }
    };
});



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


const $b24879b1551d47c8$var$INTEGRATION_NAME = "CultureContext";
const $b24879b1551d47c8$var$_cultureContextIntegration = ()=>{
    return {
        name: $b24879b1551d47c8$var$INTEGRATION_NAME,
        preprocessEvent (event) {
            var _event_contexts;
            const culture = $b24879b1551d47c8$var$getCultureContext();
            if (culture) event.contexts = (0, $2qxEV._)((0, $9tqwB._)({}, event.contexts), {
                culture: (0, $9tqwB._)({}, culture, (_event_contexts = event.contexts) === null || _event_contexts === void 0 ? void 0 : _event_contexts.culture)
            });
        },
        processSegmentSpan (span) {
            const culture = $b24879b1551d47c8$var$getCultureContext();
            if (culture) (0, $b353b064a96cf357$exports.safeSetSpanJSONAttributes)(span, {
                "culture.locale": culture.locale,
                "culture.timezone": culture.timezone,
                "culture.calendar": culture.calendar
            });
        }
    };
};
const $b24879b1551d47c8$export$ec5976aacdc85985 = (0, $b353b064a96cf357$exports.defineIntegration)($b24879b1551d47c8$var$_cultureContextIntegration);
function $b24879b1551d47c8$var$getCultureContext() {
    try {
        const intl = (0, $437be5401ebe48b5$export$56d8a8a25bd48b81).Intl;
        if (!intl) return void 0;
        const options = intl.DateTimeFormat().resolvedOptions();
        return {
            locale: options.locale,
            timezone: options.timeZone,
            calendar: options.calendar
        };
    } catch (e) {
        return void 0;
    }
}



var $9tqwB = parcelRequire("9tqwB");




const $008435ba3a09b2ce$var$INTEGRATION_NAME = "GlobalHandlers";
const $008435ba3a09b2ce$var$_globalHandlersIntegration = (options = {})=>{
    const _options = (0, $9tqwB._)({
        onerror: true,
        onunhandledrejection: true
    }, options);
    return {
        name: $008435ba3a09b2ce$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $008435ba3a09b2ce$var$_installGlobalOnErrorHandler(client);
                $008435ba3a09b2ce$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $008435ba3a09b2ce$var$_installGlobalOnUnhandledRejectionHandler(client);
                $008435ba3a09b2ce$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $008435ba3a09b2ce$export$66acc70e8cf2b71a = (0, $b353b064a96cf357$exports.defineIntegration)($008435ba3a09b2ce$var$_globalHandlersIntegration);
function $008435ba3a09b2ce$var$_installGlobalOnErrorHandler(client) {
    (0, $b353b064a96cf357$exports.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $008435ba3a09b2ce$var$getOptions();
        if ((0, $b353b064a96cf357$exports.getClient)() !== client || (0, $437be5401ebe48b5$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $008435ba3a09b2ce$var$_enhanceEventWithInitialFrame((0, $30b34c487def1b34$export$9dd56ed1ef0c3420)(stackParser, error || msg, void 0, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $b353b064a96cf357$exports.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onerror"
            }
        });
    });
}
function $008435ba3a09b2ce$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $b353b064a96cf357$exports.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $008435ba3a09b2ce$var$getOptions();
        if ((0, $b353b064a96cf357$exports.getClient)() !== client || (0, $437be5401ebe48b5$export$b79738ab10c590b2)()) return;
        const error = $008435ba3a09b2ce$export$b2cc40fa8241780(e);
        const event = (0, $b353b064a96cf357$exports.isPrimitive)(error) ? $008435ba3a09b2ce$export$1353b5b36844a9ed(error) : (0, $30b34c487def1b34$export$9dd56ed1ef0c3420)(stackParser, error, void 0, attachStacktrace, true);
        event.level = "error";
        (0, $b353b064a96cf357$exports.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onunhandledrejection"
            }
        });
    });
}
function $008435ba3a09b2ce$export$b2cc40fa8241780(error) {
    if ((0, $b353b064a96cf357$exports.isPrimitive)(error)) return error;
    try {
        if ("reason" in error) return error.reason;
        if ("detail" in error && "reason" in error.detail) return error.detail.reason;
    } catch (e) {}
    return error;
}
function $008435ba3a09b2ce$export$1353b5b36844a9ed(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $008435ba3a09b2ce$var$_enhanceEventWithInitialFrame(event, url, lineno, colno) {
    const e = event.exception = event.exception || {};
    const ev = e.values = e.values || [];
    const ev0 = ev[0] = ev[0] || {};
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    const ev0sf = ev0s.frames = ev0s.frames || [];
    var _getFilenameFromUrl;
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        lineno: lineno,
        filename: (_getFilenameFromUrl = $008435ba3a09b2ce$var$getFilenameFromUrl(url)) !== null && _getFilenameFromUrl !== void 0 ? _getFilenameFromUrl : (0, $b353b064a96cf357$exports.getLocationHref)(),
        function: (0, $b353b064a96cf357$exports.UNKNOWN_FUNCTION),
        in_app: true
    });
    return event;
}
function $008435ba3a09b2ce$var$globalHandlerLog(type) {
    (0, $03d071cefd392f71$export$16a28057038b10ef) && (0, $b353b064a96cf357$exports.debug).log(`Global Handler attached: ${type}`);
}
function $008435ba3a09b2ce$var$getOptions() {
    const client = (0, $b353b064a96cf357$exports.getClient)();
    const options = (client === null || client === void 0 ? void 0 : client.getOptions()) || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}
function $008435ba3a09b2ce$var$getFilenameFromUrl(url) {
    if (!(0, $b353b064a96cf357$exports.isString)(url) || url.length === 0) return void 0;
    if (url.startsWith("data:")) return `<${(0, $b353b064a96cf357$exports.stripDataUrlContent)(url, false)}>`;
    return url;
}



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


const $ae48a345b36d4dea$export$1378794447170364 = (0, $b353b064a96cf357$exports.defineIntegration)(()=>{
    return {
        name: "HttpContext",
        preprocessEvent (event) {
            var _event_request;
            if (!(0, $437be5401ebe48b5$export$56d8a8a25bd48b81).navigator && !(0, $437be5401ebe48b5$export$56d8a8a25bd48b81).location && !(0, $437be5401ebe48b5$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $437be5401ebe48b5$export$a3c4a8453e8936f0)();
            const headers = (0, $9tqwB._)({}, reqData.headers, (_event_request = event.request) === null || _event_request === void 0 ? void 0 : _event_request.headers);
            event.request = (0, $2qxEV._)((0, $9tqwB._)({}, reqData, event.request), {
                headers: headers
            });
        },
        processSegmentSpan (span) {
            var _span_attributes;
            const spanOp = (_span_attributes = span.attributes) === null || _span_attributes === void 0 ? void 0 : _span_attributes[0, $b353b064a96cf357$exports.SEMANTIC_ATTRIBUTE_SENTRY_OP];
            if (!(0, $437be5401ebe48b5$export$56d8a8a25bd48b81).navigator && !(0, $437be5401ebe48b5$export$56d8a8a25bd48b81).location && !(0, $437be5401ebe48b5$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $437be5401ebe48b5$export$a3c4a8453e8936f0)();
            (0, $b353b064a96cf357$exports.safeSetSpanJSONAttributes)(span, {
                // Coerce empty string to undefined so the helper's nullish check drops it,
                // rather than writing an empty `url.full` attribute onto the span.
                "url.full": spanOp !== "http.client" ? reqData.url : void 0,
                "http.request.header.user_agent": reqData.headers["User-Agent"],
                "http.request.header.referer": reqData.headers["Referer"]
            });
        }
    };
});




const $e21518743e269de2$var$DEFAULT_KEY = "cause";
const $e21518743e269de2$var$DEFAULT_LIMIT = 5;
const $e21518743e269de2$var$INTEGRATION_NAME = "LinkedErrors";
const $e21518743e269de2$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $e21518743e269de2$var$DEFAULT_LIMIT;
    const key = options.key || $e21518743e269de2$var$DEFAULT_KEY;
    return {
        name: $e21518743e269de2$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options2 = client.getOptions();
            (0, $b353b064a96cf357$exports.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $30b34c487def1b34$export$a6c2d27607295951), options2.stackParser, key, limit, event, hint);
        }
    };
};
const $e21518743e269de2$export$ebabb00eb7f3a395 = (0, $b353b064a96cf357$exports.defineIntegration)($e21518743e269de2$var$_linkedErrorsIntegration);



const $5169eff32bb2cc1c$var$OPERA10_PRIORITY = 10;
const $5169eff32bb2cc1c$var$OPERA11_PRIORITY = 20;
const $5169eff32bb2cc1c$var$CHROME_PRIORITY = 30;
const $5169eff32bb2cc1c$var$WINJS_PRIORITY = 40;
const $5169eff32bb2cc1c$var$GECKO_PRIORITY = 50;
function $5169eff32bb2cc1c$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === "<anonymous>" ? (0, $b353b064a96cf357$exports.UNKNOWN_FUNCTION) : func,
        in_app: true
    };
    if (lineno !== void 0) frame.lineno = lineno;
    if (colno !== void 0) frame.colno = colno;
    return frame;
}
const $5169eff32bb2cc1c$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
const $5169eff32bb2cc1c$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $5169eff32bb2cc1c$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
const $5169eff32bb2cc1c$var$chromeDataUriRegex = /at (.+?) ?\(data:(.+?),/;
const $5169eff32bb2cc1c$var$chromeStackParserFn = (line)=>{
    const dataUriMatch = line.match($5169eff32bb2cc1c$var$chromeDataUriRegex);
    if (dataUriMatch) return {
        filename: `<data:${dataUriMatch[2]}>`,
        function: dataUriMatch[1]
    };
    const noFnParts = $5169eff32bb2cc1c$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line2, col] = noFnParts;
        return $5169eff32bb2cc1c$var$createFrame(filename, (0, $b353b064a96cf357$exports.UNKNOWN_FUNCTION), +line2, +col);
    }
    const parts = $5169eff32bb2cc1c$var$chromeRegex.exec(line);
    if (parts) {
        var _parts_;
        const isEval = ((_parts_ = parts[2]) === null || _parts_ === void 0 ? void 0 : _parts_.indexOf("eval")) === 0;
        if (isEval) {
            const subMatch = $5169eff32bb2cc1c$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                parts[2] = subMatch[1];
                parts[3] = subMatch[2];
                parts[4] = subMatch[3];
            }
        }
        const [func, filename] = $5169eff32bb2cc1c$var$extractSafariExtensionDetails(parts[1] || (0, $b353b064a96cf357$exports.UNKNOWN_FUNCTION), parts[2]);
        return $5169eff32bb2cc1c$var$createFrame(filename, func, parts[3] ? +parts[3] : void 0, parts[4] ? +parts[4] : void 0);
    }
    return;
};
const $5169eff32bb2cc1c$export$263a749fff749872 = [
    $5169eff32bb2cc1c$var$CHROME_PRIORITY,
    $5169eff32bb2cc1c$var$chromeStackParserFn
];
const $5169eff32bb2cc1c$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $5169eff32bb2cc1c$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $5169eff32bb2cc1c$var$gecko = (line)=>{
    const parts = $5169eff32bb2cc1c$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $5169eff32bb2cc1c$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = "";
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $b353b064a96cf357$exports.UNKNOWN_FUNCTION);
        [func, filename] = $5169eff32bb2cc1c$var$extractSafariExtensionDetails(func, filename);
        return $5169eff32bb2cc1c$var$createFrame(filename, func, parts[4] ? +parts[4] : void 0, parts[5] ? +parts[5] : void 0);
    }
    return;
};
const $5169eff32bb2cc1c$export$cdba47a5dd2804d = [
    $5169eff32bb2cc1c$var$GECKO_PRIORITY,
    $5169eff32bb2cc1c$var$gecko
];
const $5169eff32bb2cc1c$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $5169eff32bb2cc1c$var$winjs = (line)=>{
    const parts = $5169eff32bb2cc1c$var$winjsRegex.exec(line);
    return parts ? $5169eff32bb2cc1c$var$createFrame(parts[2], parts[1] || (0, $b353b064a96cf357$exports.UNKNOWN_FUNCTION), +parts[3], parts[4] ? +parts[4] : void 0) : void 0;
};
const $5169eff32bb2cc1c$export$179460296da408e8 = [
    $5169eff32bb2cc1c$var$WINJS_PRIORITY,
    $5169eff32bb2cc1c$var$winjs
];
const $5169eff32bb2cc1c$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $5169eff32bb2cc1c$var$opera10 = (line)=>{
    const parts = $5169eff32bb2cc1c$var$opera10Regex.exec(line);
    return parts ? $5169eff32bb2cc1c$var$createFrame(parts[2], parts[3] || (0, $b353b064a96cf357$exports.UNKNOWN_FUNCTION), +parts[1]) : void 0;
};
const $5169eff32bb2cc1c$export$f892b52c880ffc7a = [
    $5169eff32bb2cc1c$var$OPERA10_PRIORITY,
    $5169eff32bb2cc1c$var$opera10
];
const $5169eff32bb2cc1c$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $5169eff32bb2cc1c$var$opera11 = (line)=>{
    const parts = $5169eff32bb2cc1c$var$opera11Regex.exec(line);
    return parts ? $5169eff32bb2cc1c$var$createFrame(parts[5], parts[3] || parts[4] || (0, $b353b064a96cf357$exports.UNKNOWN_FUNCTION), +parts[1], +parts[2]) : void 0;
};
const $5169eff32bb2cc1c$export$af11af13f09fb0dc = [
    $5169eff32bb2cc1c$var$OPERA11_PRIORITY,
    $5169eff32bb2cc1c$var$opera11
];
const $5169eff32bb2cc1c$export$7197c0fe6554c079 = [
    $5169eff32bb2cc1c$export$263a749fff749872,
    $5169eff32bb2cc1c$export$cdba47a5dd2804d
];
const $5169eff32bb2cc1c$export$2b2b997d81bf3907 = (0, $b353b064a96cf357$exports.createStackParser)(...$5169eff32bb2cc1c$export$7197c0fe6554c079);
const $5169eff32bb2cc1c$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : (0, $b353b064a96cf357$exports.UNKNOWN_FUNCTION),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};



var $9tqwB = parcelRequire("9tqwB");




const $3bac9bbc1b963200$var$cachedImplementations = {};
function $3bac9bbc1b963200$export$e464f4a514ac28a8(name) {
    const cached = $3bac9bbc1b963200$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81)[name];
    if ((0, $ed8e12a1b26c7e3d$export$d5f608b368e73f38)(impl)) return $3bac9bbc1b963200$var$cachedImplementations[name] = impl.bind((0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81));
    const document = (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).document;
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow === null || contentWindow === void 0 ? void 0 : contentWindow[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $3e6faad079da1d06$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    if (!impl) return impl;
    return $3bac9bbc1b963200$var$cachedImplementations[name] = impl.bind((0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81));
}
function $3bac9bbc1b963200$export$8aa36702e8c8978(name) {
    $3bac9bbc1b963200$var$cachedImplementations[name] = void 0;
}
function $3bac9bbc1b963200$export$e7aa7bc5c1b3cfb3(...rest) {
    return $3bac9bbc1b963200$export$e464f4a514ac28a8("fetch")(...rest);
}
function $3bac9bbc1b963200$export$831dc9f2ab0a617b(...rest) {
    return $3bac9bbc1b963200$export$e464f4a514ac28a8("setTimeout")(...rest);
}


const $141b8c0af9761dc1$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE = 40;
function $141b8c0af9761dc1$export$b2311068c46d7cc8(options, nativeFetch = (0, $3bac9bbc1b963200$export$e464f4a514ac28a8)("fetch")) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    async function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = (0, $9tqwB._)({
            body: request.body,
            method: "POST",
            referrerPolicy: "strict-origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 6e4 && pendingCount < 15
        }, options.fetchOptions);
        try {
            const response = await nativeFetch(options.url, requestOptions);
            return {
                statusCode: response.status,
                headers: {
                    "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                    "retry-after": response.headers.get("Retry-After")
                }
            };
        } catch (e) {
            (0, $3bac9bbc1b963200$export$8aa36702e8c8978)("fetch");
            throw e;
        } finally{
            pendingBodySize -= requestSize;
            pendingCount--;
        }
    }
    return (0, $b353b064a96cf357$exports.createTransport)(options, makeRequest, (0, $b353b064a96cf357$exports.makePromiseBuffer)(options.bufferSize || $141b8c0af9761dc1$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE));
}


function $3c847d25aac5a3f2$export$45a5e7f76e0caa8d(wat) {
    if (typeof Element === "undefined") return false;
    try {
        return wat instanceof Element;
    } catch (e) {
        return false;
    }
}


const $7297cbf2d0486041$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX = /^HTML(\w*)Element$/;
function $7297cbf2d0486041$export$4c88c355e6072df5(value) {
    if (typeof window !== "undefined" && value === window) return "[Window]";
    if (typeof document !== "undefined" && value === document) return "[Document]";
    if ((0, $3c847d25aac5a3f2$export$45a5e7f76e0caa8d)(value)) {
        const objName = $7297cbf2d0486041$var$getConstructorName(value);
        if ($7297cbf2d0486041$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX.test(objName)) return `[HTMLElement: ${(0, $d6cf245db051044b$export$5647df6b7814ac86)(value)}]`;
    }
    return void 0;
}
function $7297cbf2d0486041$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === void 0 ? void 0 : prototype.constructor) ? prototype.constructor.name : "null prototype";
}





function $fec3fc268afb8040$export$dc236a86065879fc() {
    if ($fec3fc268afb8040$var$_isEmbeddedBrowserExtension()) {
        if (0, $03d071cefd392f71$export$16a28057038b10ef) (0, $b353b064a96cf357$exports.consoleSandbox)(()=>{
            console.error("[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/");
        });
        return true;
    }
    return false;
}
function $fec3fc268afb8040$var$_isEmbeddedBrowserExtension() {
    var _extensionObject_runtime;
    if (typeof (0, $437be5401ebe48b5$export$56d8a8a25bd48b81).window === "undefined") return false;
    const _window = (0, $437be5401ebe48b5$export$56d8a8a25bd48b81);
    if (_window.nw) return false;
    const extensionObject = _window["chrome"] || _window["browser"];
    if (!(extensionObject === null || extensionObject === void 0 ? void 0 : (_extensionObject_runtime = extensionObject.runtime) === null || _extensionObject_runtime === void 0 ? void 0 : _extensionObject_runtime.id)) return false;
    const href = (0, $b353b064a96cf357$exports.getLocationHref)();
    const isDedicatedExtensionPage = (0, $437be5401ebe48b5$export$56d8a8a25bd48b81) === (0, $437be5401ebe48b5$export$56d8a8a25bd48b81).top && /^(?:chrome-extension|moz-extension|ms-browser-extension|safari-web-extension):\/\//.test(href);
    return !isDedicatedExtensionPage;
}


function $ab62593fb3228f58$export$5783b2920b1d62b9(_options) {
    return [
        // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line typescript/no-deprecated
        (0, $b353b064a96cf357$exports.inboundFiltersIntegration)(),
        (0, $b353b064a96cf357$exports.functionToStringIntegration)(),
        (0, $b353b064a96cf357$exports.conversationIdIntegration)(),
        (0, $e83828a914926395$export$59bfe9f1c76150e)(),
        (0, $6345fc92bb1e1d94$export$c079d904b326663a)(),
        (0, $008435ba3a09b2ce$export$66acc70e8cf2b71a)(),
        (0, $e21518743e269de2$export$ebabb00eb7f3a395)(),
        (0, $b353b064a96cf357$exports.dedupeIntegration)(),
        (0, $ae48a345b36d4dea$export$1378794447170364)(),
        (0, $b24879b1551d47c8$export$ec5976aacdc85985)(),
        (0, $243e9b09baa28783$export$1baa7880e357371c)()
    ];
}
function $ab62593fb3228f58$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $fec3fc268afb8040$export$dc236a86065879fc)();
    let defaultIntegrations = options.defaultIntegrations == null ? $ab62593fb3228f58$export$5783b2920b1d62b9() : options.defaultIntegrations;
    const clientOptions = (0, $2qxEV._)((0, $9tqwB._)({}, options), {
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $b353b064a96cf357$exports.stackParserFromStackParserOptions)(options.stackParser || (0, $5169eff32bb2cc1c$export$2b2b997d81bf3907)),
        integrations: (0, $b353b064a96cf357$exports.getIntegrationsToSetup)({
            integrations: options.integrations,
            defaultIntegrations: defaultIntegrations
        }),
        transport: options.transport || (0, $141b8c0af9761dc1$export$b2311068c46d7cc8)
    });
    (0, $b353b064a96cf357$exports.setNormalizeStringifier)((0, $7297cbf2d0486041$export$4c88c355e6072df5));
    return (0, $b353b064a96cf357$exports.initAndBind)((0, $31a3c3a87f4e980b$export$1df9218a526d318d), clientOptions);
}
function $ab62593fb3228f58$export$a3f323d81eede727() {}
function $ab62593fb3228f58$export$4e4d8b287d028b6b(callback) {
    callback();
}




var $7fPBF = parcelRequire("7fPBF");

function $e722c9a0757fd395$export$bc2894c7158efbac(wat) {
    return (0, $85e272e760900bb9$export$53b83ca8eaab0383)(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}


function $df844ac72233cdc3$export$2cd8252107eb640b(options) {
    const opts = (0, $9tqwB._)({}, options);
    (0, $b353b064a96cf357$exports.applySdkMetadata)(opts, "react");
    (0, $b353b064a96cf357$exports.setContext)("react", {
        version: $7fPBF.version
    });
    const client = (0, $ab62593fb3228f58$export$2cd8252107eb640b)(opts);
    (0, $b353b064a96cf357$exports.setNormalizeStringifier)($df844ac72233cdc3$var$normalizeStringifyValue);
    return client;
}
function $df844ac72233cdc3$var$normalizeStringifyValue(value) {
    if ((0, $e722c9a0757fd395$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
    return (0, $7297cbf2d0486041$export$4c88c355e6072df5)(value);
}





parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $7fPBF = parcelRequire("7fPBF");

var $84b1ef3254a60e5e$var$buttonGroupStyles = (0, $3ebaaabf76fb5db5$export$dbf350e5966cf602)({
    display: 'inline-flex',
    gap: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> *': {
        flex: '1 0 auto'
    }
});
function $84b1ef3254a60e5e$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, testId = _ref.testId, label = _ref.label, titleId = _ref.titleId;
    return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)("div", {
        css: $84b1ef3254a60e5e$var$buttonGroupStyles,
        "data-testid": testId,
        role: "group",
        "aria-label": label,
        "aria-labelledby": titleId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.toArray(children), function(child, idx) {
        if (!child) return null;
        return (0, $3ebaaabf76fb5db5$export$c8a8987d4410bf2d)((0, $7fPBF.Fragment), {
            key: idx
        }, child);
    }));
}



/* box.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $emuQy = parcelRequire("emuQy");

var $7fPBF = parcelRequire("7fPBF");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $9fd322d8762e074f$var$ATOMIC_GROUP_LENGTH = 5;
function $9fd322d8762e074f$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $9fd322d8762e074f$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $7fPBF = parcelRequire("7fPBF");
var $6424294a5ce7a4c7$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $7fPBF.createContext)('elevation.surface');
var $6424294a5ce7a4c7$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $7fPBF.useContext)($6424294a5ce7a4c7$export$1ca2a26fecb070ae);
};
$6424294a5ce7a4c7$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


var $d89fd2308dabe801$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $d89fd2308dabe801$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $d89fd2308dabe801$var$baseStyles = null;
var $d89fd2308dabe801$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhkby5v",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $d89fd2308dabe801$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $d89fd2308dabe801$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $d89fd2308dabe801$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $d89fd2308dabe801$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $d89fd2308dabe801$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $d89fd2308dabe801$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $d89fd2308dabe801$var$Box = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $d89fd2308dabe801$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(htmlAttributes, $d89fd2308dabe801$var$_excluded2);
    var node = /*#__PURE__*/ $7fPBF.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({
        style: style,
        ref: ref,
        className: (0, $9fd322d8762e074f$export$2e2bcd8739ae039)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $d89fd2308dabe801$var$backgroundColorMap[backgroundColor],
            backgroundColor && $d89fd2308dabe801$var$isSurfaceToken(backgroundColor) && $d89fd2308dabe801$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $d89fd2308dabe801$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $d89fd2308dabe801$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $d89fd2308dabe801$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $d89fd2308dabe801$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $7fPBF.createElement((0, $6424294a5ce7a4c7$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $d89fd2308dabe801$export$2e2bcd8739ae039 = $d89fd2308dabe801$var$Box;
function $d89fd2308dabe801$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $d89fd2308dabe801$var$setSurfaceTokenMap;
}

/* text.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");
var $5f872c67e71f8803$var$HasTextAncestorContext = /*#__PURE__*/ (0, $7fPBF.createContext)(false);
var $5f872c67e71f8803$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $7fPBF.useContext)($5f872c67e71f8803$var$HasTextAncestorContext);
};
var $5f872c67e71f8803$export$ae933c6cbe5643ad = $5f872c67e71f8803$var$HasTextAncestorContext.Provider;



var $c5c9cd1c8226b7c0$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $c5c9cd1c8226b7c0$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $6424294a5ce7a4c7$export$1aeb4f6b93c4540d)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($c5c9cd1c8226b7c0$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $c5c9cd1c8226b7c0$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
var $c5c9cd1c8226b7c0$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $c5c9cd1c8226b7c0$var$fontSizeMap = {
    medium: "_11c8fhey",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
var $c5c9cd1c8226b7c0$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $c5c9cd1c8226b7c0$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
var $c5c9cd1c8226b7c0$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $c5c9cd1c8226b7c0$var$Text = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)($c5c9cd1c8226b7c0$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $5f872c67e71f8803$export$9322276ec105d055)();
    var color = $c5c9cd1c8226b7c0$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $7fPBF.createElement(Component, {
        id: id,
        className: (0, $9fd322d8762e074f$export$2e2bcd8739ae039)([
            $c5c9cd1c8226b7c0$var$styles.root,
            size && $c5c9cd1c8226b7c0$var$fontSizeMap[size],
            color && $c5c9cd1c8226b7c0$var$textColorMap[color],
            maxLines && $c5c9cd1c8226b7c0$var$styles.truncation,
            maxLines === 1 && $c5c9cd1c8226b7c0$var$styles.breakAll,
            align && $c5c9cd1c8226b7c0$var$styles["textAlign.".concat(align)],
            weight && $c5c9cd1c8226b7c0$var$fontWeightMap[weight],
            Component === 'em' && $c5c9cd1c8226b7c0$var$styles['as.em'],
            Component === 'strong' && $c5c9cd1c8226b7c0$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $7fPBF.createElement((0, $5f872c67e71f8803$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var $c5c9cd1c8226b7c0$export$2e2bcd8739ae039 = $c5c9cd1c8226b7c0$var$Text;



/* actions-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $a058909fb1289e14$var$actionsStyles = null;
/**
 * __Actions container__
 *
 * A container for actions: primary action, secondary action, and tertiary action.
 *
 * @internal
 */ var $a058909fb1289e14$var$ActionsContainer = function ActionsContainer(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        className: (0, $9fd322d8762e074f$export$2e2bcd8739ae039)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _6rthu2gc _bozg1jfw"
        ])
    }, children);
};
var $a058909fb1289e14$export$2e2bcd8739ae039 = $a058909fb1289e14$var$ActionsContainer;


/* container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $b1141898838d800e$var$containerStyles = null;
/* Use max-width so the component can shrink on smaller viewports. */ var $b1141898838d800e$var$wideContainerStyles = null;
var $b1141898838d800e$var$narrowContainerStyles = null;
/**
 * __Container__
 *
 * Upper level container for Empty State.
 *
 * @internal
 */ var $b1141898838d800e$var$Container = function Container(_ref) {
    var children = _ref.children, width = _ref.width, testId = _ref.testId;
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        "data-testid": testId,
        className: (0, $9fd322d8762e074f$export$2e2bcd8739ae039)([
            "_6rthoahv _1pfhoahv _12l21wug _ahbq1wug _y3gn1h6o",
            width === 'narrow' ? "_p12fko4j" : "_p12f1pl1"
        ])
    }, children);
};
var $b1141898838d800e$export$2e2bcd8739ae039 = $b1141898838d800e$var$Container;


/* image.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $21f7ae35321213df$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}


function $efa4825531c33c20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $efa4825531c33c20$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $efa4825531c33c20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $efa4825531c33c20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $efa4825531c33c20$var$CSS_VAR_MAX_WIDTH = '--max-width';
var $efa4825531c33c20$var$CSS_VAR_MAX_HEIGHT = '--max-height';
var $efa4825531c33c20$var$imageStyles = null;
/**
 * __Image__
 *
 * Image in Empty State.
 *
 * @internal
 */ var $efa4825531c33c20$var$Image = function Image(_ref) {
    var maxHeight = _ref.maxHeight, maxWidth = _ref.maxWidth, _ref$height = _ref.height, height = _ref$height === void 0 ? 'auto' : _ref$height, _ref$width = _ref.width, width = _ref$width === void 0 ? 'auto' : _ref$width, src = _ref.src;
    return /*#__PURE__*/ $7fPBF.createElement("img", {
        width: width,
        height: height,
        alt: "",
        role: "presentation",
        src: src,
        className: (0, $9fd322d8762e074f$export$2e2bcd8739ae039)([
            "_1e0c1ule _p12f163m _c71l649k _6rth1ejb _1pfhidpf _12l21wug _ahbq1wug"
        ]),
        style: $efa4825531c33c20$var$_objectSpread($efa4825531c33c20$var$_objectSpread({}, (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, $efa4825531c33c20$var$CSS_VAR_MAX_WIDTH, "".concat(maxWidth, "px")), $efa4825531c33c20$var$CSS_VAR_MAX_HEIGHT, "".concat(maxHeight, "px"))), {}, {
            "--_11x3y0": (0, $21f7ae35321213df$export$2e2bcd8739ae039)("var(".concat($efa4825531c33c20$var$CSS_VAR_MAX_WIDTH, ")")),
            "--_zsxb2b": (0, $21f7ae35321213df$export$2e2bcd8739ae039)("var(".concat($efa4825531c33c20$var$CSS_VAR_MAX_HEIGHT, ")"))
        })
    });
};
var $efa4825531c33c20$export$2e2bcd8739ae039 = $efa4825531c33c20$var$Image;


/* spinner-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7fPBF = parcelRequire("7fPBF");

var $a4729c54663a3829$var$spinnerContainerStyles = null;
/**
 * __Spinner container__
 *
 * A spinner container for loading state of Empty State.
 *
 * @internal
 */ var $a4729c54663a3829$var$SpinnerContainer = function SpinnerContainer(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        className: (0, $9fd322d8762e074f$export$2e2bcd8739ae039)([
            "_1bsb1ejb _ahbqpxbi"
        ])
    }, children);
};
var $a4729c54663a3829$export$2e2bcd8739ae039 = $a4729c54663a3829$var$SpinnerContainer;


/**
 * __Empty state__
 *
 * A component used for presenting various empty states.
 * e.g. (no items, empty search, broken link, welcome screen etc.)
 *
 * @example
 * ```tsx
 * import EmptyState from '@atlaskit/empty-state';
 *
 * // An example of a 404 state
 * export default () => {
 *  <EmptyState
 *   header="Page not found"
 *   imageUrl="https://cdn.io/images/404"
 *   description="Looks like you've stumbled off track. Sorry about that! This page either doesn't exist or has been removed."
 *   primaryAction={<Button appearance="primary">Home Page</Button>}
 *   secondaryAction={<Button>Report a problem</Button>}
 *  />;
 * };
 * ```
 */ var $6f1c722987558d89$var$EmptyState = function EmptyState(_ref) {
    var buttonGroupLabel = _ref.buttonGroupLabel, description = _ref.description, header = _ref.header, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 4 : _ref$headingLevel, _ref$headingSize = _ref.headingSize, headingSize = _ref$headingSize === void 0 ? 'medium' : _ref$headingSize, imageHeight = _ref.imageHeight, imageUrl = _ref.imageUrl, imageWidth = _ref.imageWidth, isLoading = _ref.isLoading, _ref$maxImageHeight = _ref.maxImageHeight, maxImageHeight = _ref$maxImageHeight === void 0 ? 160 : _ref$maxImageHeight, _ref$maxImageWidth = _ref.maxImageWidth, maxImageWidth = _ref$maxImageWidth === void 0 ? 160 : _ref$maxImageWidth, primaryAction = _ref.primaryAction, renderImage = _ref.renderImage, secondaryAction = _ref.secondaryAction, width = _ref.width, tertiaryAction = _ref.tertiaryAction, testId = _ref.testId;
    var actionsContainer = primaryAction || secondaryAction || isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a058909fb1289e14$export$2e2bcd8739ae039), null, primaryAction && secondaryAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $84b1ef3254a60e5e$export$2e2bcd8739ae039), {
        label: buttonGroupLabel || 'Button group',
        testId: testId && "".concat(testId, "-button-group")
    }, secondaryAction, primaryAction) : primaryAction || secondaryAction, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a4729c54663a3829$export$2e2bcd8739ae039), null, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $aacfdd39b28e059d$export$2e2bcd8739ae039), {
        testId: "empty-state-spinner"
    }))) : null;
    var tag = "h".concat(headingLevel > 0 && headingLevel < 7 ? headingLevel : headingLevel > 6 ? 6 : 4);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $b1141898838d800e$export$2e2bcd8739ae039), {
        testId: testId,
        width: width || 'wide'
    }, imageUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $efa4825531c33c20$export$2e2bcd8739ae039), {
        src: imageUrl,
        maxWidth: maxImageWidth,
        maxHeight: maxImageHeight,
        width: imageWidth,
        height: imageHeight
    }) : renderImage && renderImage({
        maxImageWidth: maxImageWidth,
        maxImageHeight: maxImageHeight,
        imageWidth: imageWidth,
        imageHeight: imageHeight
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d89fd2308dabe801$export$2e2bcd8739ae039), {
        paddingBlockEnd: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $ae39dbf01fef6beb$export$2e2bcd8739ae039), {
        size: headingSize,
        as: tag
    }, header)), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d89fd2308dabe801$export$2e2bcd8739ae039), {
        paddingBlockEnd: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $c5c9cd1c8226b7c0$export$2e2bcd8739ae039), {
        as: "p"
    }, description)), actionsContainer, tertiaryAction);
};
var $6f1c722987558d89$export$2e2bcd8739ae039 = $6f1c722987558d89$var$EmptyState;




function $20fa494c41263167$export$f7170715618fd2f9(props) {
    const featureFlags = (0, $d377413f5e2ec9d9$export$90335b3ff08f335)();
    if (featureFlags['pc-frontend-down-for-maintenance']) return /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $6f1c722987558d89$export$2e2bcd8739ae039), {
        renderImage: ()=>/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $139978517f0651d4$export$fe8dceec803a025), {}),
        header: "Down For Maintenance",
        description: "Preferences Center is currently down for maintenance. Please try again in a few minutes."
    });
    else return props.children;
}








var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $f8e1e42abf84d2d1$export$7981b2444296e410 = /*#__PURE__*/ (0, $7fPBF.createContext)(false);
var $f8e1e42abf84d2d1$export$26aa23367bfbab0e = function useIsInsideAppProvider() {
    return (0, $7fPBF.useContext)($f8e1e42abf84d2d1$export$7981b2444296e410);
};
var $f8e1e42abf84d2d1$export$d2def9838ca456c0 = /*#__PURE__*/ (0, $7fPBF.createContext)(false);
var $f8e1e42abf84d2d1$export$a782702263f77544 = function useIsAppProviderThemingEnabled() {
    return (0, $7fPBF.useContext)($f8e1e42abf84d2d1$export$d2def9838ca456c0);
};



var $7fPBF = parcelRequire("7fPBF");
var $a81a1e57cf0d6bff$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $7fPBF.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $a81a1e57cf0d6bff$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($a81a1e57cf0d6bff$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $a81a1e57cf0d6bff$export$2e2bcd8739ae039 = $a81a1e57cf0d6bff$var$RouterLinkProvider;


/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $1uJLd = parcelRequire("1uJLd");

var $8MJe2 = parcelRequire("8MJe2");

var $iKdEz = parcelRequire("iKdEz");


var $iQsIh = parcelRequire("iQsIh");

var $7fPBF = parcelRequire("7fPBF");


var $8MJe2 = parcelRequire("8MJe2");

var $137Lh = parcelRequire("137Lh");

var $gh26H = parcelRequire("gh26H");

var $kvmJj = parcelRequire("kvmJj");

var $bRUy3 = parcelRequire("bRUy3");

var $iKdEz = parcelRequire("iKdEz");

var $kvmJj = parcelRequire("kvmJj");
var $e33833271ba987a5$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $e33833271ba987a5$var$customThemeOptions = 'UNSAFE_themeOptions';
var $e33833271ba987a5$var$isThemeKind = function isThemeKind(themeKind) {
    return $e33833271ba987a5$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $e33833271ba987a5$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $kvmJj.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $e33833271ba987a5$var$isColorMode = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
var $e33833271ba987a5$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && $e33833271ba987a5$var$isColorMode(id)) themeObject[kind] = id;
        if ($e33833271ba987a5$var$isThemeKind(kind) && $e33833271ba987a5$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $e33833271ba987a5$var$customThemeOptions) try {
            themeObject[$e33833271ba987a5$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
var $e33833271ba987a5$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $e33833271ba987a5$var$isColorMode(id) || // custom theme state
        kind === $e33833271ba987a5$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(id) === 'object' || // other theme states
        $e33833271ba987a5$var$isThemeKind(kind) && typeof id === 'string' && $e33833271ba987a5$var$isThemeIds(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};



var $8vOqQ = parcelRequire("8vOqQ");

var $gZESL = parcelRequire("gZESL");
function $bfe2fce5dd69e020$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bfe2fce5dd69e020$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bfe2fce5dd69e020$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bfe2fce5dd69e020$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bfe2fce5dd69e020$var$defaultColorMode = 'light';
var $bfe2fce5dd69e020$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ var $bfe2fce5dd69e020$var$getThemeHtmlAttrs = function getThemeHtmlAttrs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $kvmJj.themeStateDefaults)['colorMode'] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $kvmJj.themeStateDefaults)['dark'] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $kvmJj.themeStateDefaults)['light'] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $kvmJj.themeStateDefaults)['contrastMode'] : _ref$contrastMode, _ref$motion = _ref.motion, motion = _ref$motion === void 0 ? (0, $kvmJj.themeStateDefaults)['motion']() : _ref$motion, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $kvmJj.themeStateDefaults)['shape']() : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $kvmJj.themeStateDefaults)['spacing'] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $kvmJj.themeStateDefaults)['typography'] : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $kvmJj.themeStateDefaults)['UNSAFE_themeOptions'] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $e33833271ba987a5$export$62c37ab81302621a)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))((0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, (0, $gh26H.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $gh26H.COLOR_MODE_ATTRIBUTE), colorMode === 'auto' ? $bfe2fce5dd69e020$var$defaultColorMode : colorMode);
    if ((0, $137Lh.fg)('platform_increased-contrast-themes')) result = $bfe2fce5dd69e020$var$_objectSpread($bfe2fce5dd69e020$var$_objectSpread({}, result), {}, (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, (0, $gh26H.CONTRAST_MODE_ATTRIBUTE), contrastMode === 'auto' ? $bfe2fce5dd69e020$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $8vOqQ.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $gZESL.hash)(optionString);
        result[0, $gh26H.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $bfe2fce5dd69e020$export$2e2bcd8739ae039 = $bfe2fce5dd69e020$var$getThemeHtmlAttrs;


var $8MJe2 = parcelRequire("8MJe2");

var $1uJLd = parcelRequire("1uJLd");

var $iQsIh = parcelRequire("iQsIh");

var $137Lh = parcelRequire("137Lh");

var $8MJe2 = parcelRequire("8MJe2");

var $gh26H = parcelRequire("gh26H");

var $kvmJj = parcelRequire("kvmJj");

function $ade8ef1df3dc9d4e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ade8ef1df3dc9d4e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ade8ef1df3dc9d4e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ade8ef1df3dc9d4e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ade8ef1df3dc9d4e$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $kvmJj.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $ade8ef1df3dc9d4e$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $gh26H.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $gh26H.THEME_DATA_ATTRIBUTE)) || '';
    return $ade8ef1df3dc9d4e$var$_objectSpread($ade8ef1df3dc9d4e$var$_objectSpread({}, (0, $e33833271ba987a5$export$f19b488f7c0547ee)(theme)), $ade8ef1df3dc9d4e$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $ade8ef1df3dc9d4e$export$2e2bcd8739ae039 = $ade8ef1df3dc9d4e$var$getGlobalTheme;



var $kvmJj = parcelRequire("kvmJj");

var $8vOqQ = parcelRequire("8vOqQ");

var $iKdEz = parcelRequire("iKdEz");

var $137Lh = parcelRequire("137Lh");


var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $8MJe2 = parcelRequire("8MJe2");


var $gh26H = parcelRequire("gh26H");

var $1uJLd = parcelRequire("1uJLd");

var $iQsIh = parcelRequire("iQsIh");
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::a20c72d683b08b594c5be4160eec5f78>>
 * @codegenCommand yarn build tokens
 */ 









var $e01f9c74008d919a$var$themeImportsMap = {
    'light': function light() {
        return (parcelRequire("TvNHr"));
    },
    'light-future': function lightFuture() {
        return (parcelRequire("hw7El"));
    },
    'light-increased-contrast': function lightIncreasedContrast() {
        return (parcelRequire("h3yc9"));
    },
    'dark': function dark() {
        return (parcelRequire("7GhKa"));
    },
    'dark-future': function darkFuture() {
        return (parcelRequire("6CfhU"));
    },
    'dark-increased-contrast': function darkIncreasedContrast() {
        return (parcelRequire("1I0LA"));
    },
    'spacing': function spacing() {
        return (parcelRequire("9mdpk"));
    },
    'typography': function typography() {
        return (parcelRequire("j33XD"));
    },
    'shape': function shape() {
        return (parcelRequire("2kVm9"));
    },
    'motion': function motion() {
        return (parcelRequire("36Qfp"));
    }
};
var $e01f9c74008d919a$export$2e2bcd8739ae039 = $e01f9c74008d919a$var$themeImportsMap;



var $gh26H = parcelRequire("gh26H");
var $b4dee84cf83844eb$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee(themeId) {
        var themeCss, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $gh26H.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]:not([").concat((0, $gh26H.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return $b4dee84cf83844eb$export$8a48286ed7df6720(themeId);
                case 6:
                    themeCss = _context.sent;
                    style = document.createElement('style');
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $b4dee84cf83844eb$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee2(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return (0, $e01f9c74008d919a$export$2e2bcd8739ae039)[themeId]();
                case 2:
                    _yield$themeImportMap = _context2.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context2.abrupt("return", themeCss);
                case 5:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function loadThemeCss(_x2) {
        return _ref2.apply(this, arguments);
    };
}();
var $b4dee84cf83844eb$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
var $b4dee84cf83844eb$export$8662df6937d86fcb = '(prefers-contrast: more)';


var $79aa00bbe2412cc3$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $79aa00bbe2412cc3$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $gh26H.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
var $79aa00bbe2412cc3$var$darkModeMql = $79aa00bbe2412cc3$var$isMatchMediaAvailable && window.matchMedia((0, $b4dee84cf83844eb$export$bb1e815119d30f8b));
var $79aa00bbe2412cc3$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, ColorModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "unbindThemeChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$79aa00bbe2412cc3$var$darkModeMql) return 'light';
                return $79aa00bbe2412cc3$var$darkModeMql !== null && $79aa00bbe2412cc3$var$darkModeMql !== void 0 && $79aa00bbe2412cc3$var$darkModeMql.matches ? 'dark' : 'light';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($79aa00bbe2412cc3$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $a091c25729a976b1$exports.bind)($79aa00bbe2412cc3$var$darkModeMql, {
                    type: 'change',
                    listener: $79aa00bbe2412cc3$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $79aa00bbe2412cc3$var$SingletonColorModeObserver = new $79aa00bbe2412cc3$var$ColorModeObserver();
var $79aa00bbe2412cc3$export$2e2bcd8739ae039 = $79aa00bbe2412cc3$var$SingletonColorModeObserver;



var $dxrob = parcelRequire("dxrob");

var $6CtYH = parcelRequire("6CtYH");

var $8MJe2 = parcelRequire("8MJe2");


var $gh26H = parcelRequire("gh26H");

var $705b8ba4b77c73b8$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $705b8ba4b77c73b8$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $gh26H.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
var $705b8ba4b77c73b8$var$contrastModeMql = $705b8ba4b77c73b8$var$isMatchMediaAvailable && window.matchMedia((0, $b4dee84cf83844eb$export$8662df6937d86fcb));
var $705b8ba4b77c73b8$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($dxrob)))(this, ContrastModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(this, "unbindContrastChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6CtYH)))(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$705b8ba4b77c73b8$var$contrastModeMql) return 'no-preference';
                return $705b8ba4b77c73b8$var$contrastModeMql !== null && $705b8ba4b77c73b8$var$contrastModeMql !== void 0 && $705b8ba4b77c73b8$var$contrastModeMql.matches ? 'more' : 'no-preference';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($705b8ba4b77c73b8$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $a091c25729a976b1$exports.bind)($705b8ba4b77c73b8$var$contrastModeMql, {
                    type: 'change',
                    listener: $705b8ba4b77c73b8$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $705b8ba4b77c73b8$var$SingletonContrastModeObserver = new $705b8ba4b77c73b8$var$ContrastModeObserver();
var $705b8ba4b77c73b8$export$2e2bcd8739ae039 = $705b8ba4b77c73b8$var$SingletonContrastModeObserver;


function $ca768c892cdd6dd0$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $79aa00bbe2412cc3$export$2e2bcd8739ae039).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $79aa00bbe2412cc3$export$2e2bcd8739ae039).bind();
    } else (0, $79aa00bbe2412cc3$export$2e2bcd8739ae039).unbind();
    if ((0, $137Lh.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $705b8ba4b77c73b8$export$2e2bcd8739ae039).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $705b8ba4b77c73b8$export$2e2bcd8739ae039).bind();
        } else (0, $705b8ba4b77c73b8$export$2e2bcd8739ae039).unbind();
    }
    var themeAttributes = (0, $bfe2fce5dd69e020$export$2e2bcd8739ae039)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $79aa00bbe2412cc3$export$2e2bcd8739ae039).unbind();
        if ((0, $137Lh.fg)('platform_increased-contrast-themes')) (0, $705b8ba4b77c73b8$export$2e2bcd8739ae039).unbind();
    };
}



var $guYHo = parcelRequire("guYHo");

var $j9spr = parcelRequire("j9spr");

var $137Lh = parcelRequire("137Lh");

var $iKdEz = parcelRequire("iKdEz");

var $kvmJj = parcelRequire("kvmJj");
function $7bfd5b3bf91432e8$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $kvmJj.default)).find(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}


var $f57322c773e69c0b$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography, motion = themeState.motion;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $137Lh.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $7bfd5b3bf91432e8$export$2e2bcd8739ae039)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $137Lh.fg)('platform_increased-contrast-themes')) {
            var increasedContrastTheme = (0, $7bfd5b3bf91432e8$export$2e2bcd8739ae039)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(new Set(themePreferences));
};
var $f57322c773e69c0b$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(_themeState) {
    var themeOverridePreferences = [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($j9spr)))(new Set(themeOverridePreferences));
};



function $219af2cdea39e6b5$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $219af2cdea39e6b5$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $219af2cdea39e6b5$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $219af2cdea39e6b5$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $219af2cdea39e6b5$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $219af2cdea39e6b5$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $219af2cdea39e6b5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $219af2cdea39e6b5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $219af2cdea39e6b5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $219af2cdea39e6b5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $219af2cdea39e6b5$var$setGlobalTheme = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee3() {
        var nextThemeState, themeLoader, _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$motion, motion, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeState, themePreferences, loadingStrategy, loadingTasks, mode, attrOfMissingCustomStyles, themeOverridePreferences, _iterator, _step, themeId, autoUnbind, _args3 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    nextThemeState = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    _ref2 = typeof nextThemeState === 'function' ? nextThemeState($219af2cdea39e6b5$var$_objectSpread($219af2cdea39e6b5$var$_objectSpread({}, (0, $kvmJj.themeStateDefaults)), {}, {
                        typography: (0, $kvmJj.themeStateDefaults)['typography'],
                        shape: (0, $kvmJj.themeStateDefaults)['shape'](),
                        motion: (0, $kvmJj.themeStateDefaults)['motion']()
                    }, (0, $ade8ef1df3dc9d4e$export$2e2bcd8739ae039)())) : nextThemeState, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $kvmJj.themeStateDefaults)['colorMode'] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $kvmJj.themeStateDefaults)['contrastMode'] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $kvmJj.themeStateDefaults)['dark'] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $kvmJj.themeStateDefaults)['light'] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $kvmJj.themeStateDefaults)['shape']() : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $kvmJj.themeStateDefaults)['spacing'] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $kvmJj.themeStateDefaults)['typography'] : _ref2$typography, _ref2$motion = _ref2.motion, motion = _ref2$motion === void 0 ? (0, $kvmJj.themeStateDefaults)['motion']() : _ref2$motion, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $kvmJj.themeStateDefaults)['UNSAFE_themeOptions'] : _ref2$UNSAFE_themeOpt; // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $137Lh.fg)('platform_increased-contrast-themes')) {
                        if (light === 'light-increased-contrast') light = 'light';
                        if (dark === 'dark-increased-contrast') dark = 'dark';
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        motion: motion,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $f57322c773e69c0b$export$dd6aeb7c823fc03d)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $b4dee84cf83844eb$export$26cd7ae85c7144e5); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 2;
                                        return loadingStrategy(themeId);
                                    case 2:
                                        return _context.abrupt("return", _context.sent);
                                    case 3:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }()); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $8vOqQ.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $kvmJj.themeStateDefaults)['colorMode'];
                        attrOfMissingCustomStyles = (0, $guYHo.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 2;
                                        return (parcelRequire("j3q2g"));
                                    case 2:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 5:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 11;
                    return Promise.all(loadingTasks);
                case 11:
                    // Load override themes after standard themes
                    themeOverridePreferences = (0, $f57322c773e69c0b$export$5d76d7014f4a5d08)(themeState);
                    _iterator = $219af2cdea39e6b5$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 13;
                    _iterator.s();
                case 15:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 21;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 19;
                    return loadingStrategy(themeId);
                case 19:
                    _context3.next = 15;
                    break;
                case 21:
                    _context3.next = 26;
                    break;
                case 23:
                    _context3.prev = 23;
                    _context3.t0 = _context3["catch"](13);
                    _iterator.e(_context3.t0);
                case 26:
                    _context3.prev = 26;
                    _iterator.f();
                    return _context3.finish(26);
                case 29:
                    autoUnbind = (0, $ca768c892cdd6dd0$export$2e2bcd8739ae039)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 31:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                13,
                23,
                26,
                29
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();
var $219af2cdea39e6b5$export$2e2bcd8739ae039 = $219af2cdea39e6b5$var$setGlobalTheme;


var $gh26H = parcelRequire("gh26H");


var $7fPBF = parcelRequire("7fPBF");
var $1117b2915604cc65$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);
var $1117b2915604cc65$export$b06130bad0bbc70f = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);



var $7fPBF = parcelRequire("7fPBF");
var $c74b917ed7a35d45$export$332347eeb335453c = /*#__PURE__*/ (0, $7fPBF.createContext)(false);



var $7fPBF = parcelRequire("7fPBF");
var $dd4e8951291c3c20$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);
var $dd4e8951291c3c20$export$f7a97b47760e2a13 = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);



var $7fPBF = parcelRequire("7fPBF");

var $e1621cc5da2d4e95$export$7ca11437599d653d = function useIsInsideThemeProvider() {
    var _useContext;
    return (_useContext = (0, $7fPBF.useContext)((0, $c74b917ed7a35d45$export$332347eeb335453c))) !== null && _useContext !== void 0 ? _useContext : false;
};



var $1uJLd = parcelRequire("1uJLd");

var $iQsIh = parcelRequire("iQsIh");




var $gh26H = parcelRequire("gh26H");
function $4b6f2de1282afd06$export$835a0dc855d02822(themeId) {
    var doc = (0, $f30181cdac346cce$export$f65ca476c09acec0)();
    if (!doc) return false;
    return doc.head.querySelector("style[".concat((0, $gh26H.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
}


var $38a0cc7e991e8f4a$var$loadThemeCss = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(0, $4b6f2de1282afd06$export$835a0dc855d02822)(themeId)) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return (0, $e01f9c74008d919a$export$2e2bcd8739ae039)[themeId]();
                case 6:
                    _yield$themeImportMap = _context.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context.abrupt("return", themeCss);
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $38a0cc7e991e8f4a$var$mountThemeCss = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee2(css, themeId) {
        var doc, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    // SSR-safe: Only mount on client side
                    doc = (0, $f30181cdac346cce$export$f65ca476c09acec0)();
                    if (doc) {
                        _context2.next = 3;
                        break;
                    }
                    return _context2.abrupt("return");
                case 3:
                    style = doc.createElement('style');
                    style.textContent = css;
                    style.dataset.theme = themeId;
                    // Prevent duplicate mounting of themes.
                    // It's possible the theme was already being loaded elsewhere.
                    if (!(0, $4b6f2de1282afd06$export$835a0dc855d02822)(themeId)) {
                        _context2.next = 8;
                        break;
                    }
                    return _context2.abrupt("return");
                case 8:
                    doc.head.appendChild(style);
                case 9:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function mountThemeCss(_x2, _x3) {
        return _ref2.apply(this, arguments);
    };
}();
var $38a0cc7e991e8f4a$var$loadAndMountThemeCss = /*#__PURE__*/ function() {
    var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee3(themeId) {
        var themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 2;
                    return $38a0cc7e991e8f4a$var$loadThemeCss(themeId);
                case 2:
                    themeCss = _context3.sent;
                    if (themeCss) {
                        _context3.next = 5;
                        break;
                    }
                    return _context3.abrupt("return");
                case 5:
                    $38a0cc7e991e8f4a$var$mountThemeCss(themeCss, themeId);
                case 6:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function loadAndMountThemeCss(_x4) {
        return _ref3.apply(this, arguments);
    };
}();
var $38a0cc7e991e8f4a$export$7d4a7e812d176b24 = /*#__PURE__*/ function() {
    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee4(theme) {
        var themesToLoad;
        return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee4$(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    themesToLoad = Object.values(theme).filter(function(themeId) {
                        return !!themeId;
                    });
                    themesToLoad.forEach($38a0cc7e991e8f4a$var$loadAndMountThemeCss);
                case 2:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function loadAndMountThemes(_x5) {
        return _ref4.apply(this, arguments);
    };
}();


function $dc4a2023b640734e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dc4a2023b640734e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dc4a2023b640734e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dc4a2023b640734e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $dc4a2023b640734e$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    spacing: 'spacing',
    typography: 'typography'
};
var $dc4a2023b640734e$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
var $dc4a2023b640734e$var$prefersDarkModeMql = $dc4a2023b640734e$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $dc4a2023b640734e$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $dc4a2023b640734e$var$prefersDarkModeMql !== null && $dc4a2023b640734e$var$prefersDarkModeMql !== void 0 && $dc4a2023b640734e$var$prefersDarkModeMql.matches ? 'dark' : 'light';
    return colorMode;
}
var $dc4a2023b640734e$var$contentStyles = {
    body: "_1e0c1bgi"
};
/**
 * __Theme provider__
 *
 * Provides global theming configuration.
 */ function $dc4a2023b640734e$var$ThemeProvider(_ref) {
    var children = _ref.children, _ref$defaultColorMode = _ref.defaultColorMode, defaultColorMode = _ref$defaultColorMode === void 0 ? 'auto' : _ref$defaultColorMode, defaultTheme = _ref.defaultTheme;
    var _useState = (0, $7fPBF.useState)(defaultColorMode), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState, 2), chosenColorMode = _useState2[0], setChosenColorMode = _useState2[1];
    var _useState3 = (0, $7fPBF.useState)($dc4a2023b640734e$var$getReconciledColorMode(defaultColorMode)), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState3, 2), reconciledColorMode = _useState4[0], setReconciledColorMode = _useState4[1];
    var _useState5 = (0, $7fPBF.useState)(function() {
        return $dc4a2023b640734e$var$_objectSpread($dc4a2023b640734e$var$_objectSpread({}, $dc4a2023b640734e$var$defaultThemeSettings), defaultTheme);
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iKdEz)))(_useState5, 2), theme = _useState6[0], setTheme = _useState6[1];
    var setColorMode = (0, $7fPBF.useCallback)(function(colorMode) {
        setChosenColorMode(colorMode);
        setReconciledColorMode($dc4a2023b640734e$var$getReconciledColorMode(colorMode));
    }, []);
    var setPartialTheme = (0, $7fPBF.useCallback)(function(nextTheme) {
        setTheme(function(theme) {
            return $dc4a2023b640734e$var$_objectSpread($dc4a2023b640734e$var$_objectSpread({}, theme), nextTheme);
        });
    }, []);
    var lastSetGlobalThemePromiseRef = (0, $7fPBF.useRef)(null);
    var isInsideAppProvider = (0, $f8e1e42abf84d2d1$export$26aa23367bfbab0e)();
    var isAppProviderThemingEnabled = (0, $f8e1e42abf84d2d1$export$a782702263f77544)();
    var isInsideThemeProvider = (0, $e1621cc5da2d4e95$export$7ca11437599d653d)();
    /**
   * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
   *
   * This will not use sub-tree theming but instead set the global theme state using the
   * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
   * for compatibility with `@atlaskit/css-reset`.
   *
   * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
   * `html` in order to apply global theme state, which would allow a more consistent approach to
   * theme loading.
   */ var isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider && isAppProviderThemingEnabled;
    (0, $7fPBF.useEffect)(function() {
        if (isRootThemeProvider) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ var cleanupLastFnCall = /*#__PURE__*/ function() {
                var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee() {
                    var unbindFn;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!lastSetGlobalThemePromiseRef.current) {
                                    _context.next = 6;
                                    break;
                                }
                                _context.next = 3;
                                return lastSetGlobalThemePromiseRef.current;
                            case 3:
                                unbindFn = _context.sent;
                                unbindFn();
                                lastSetGlobalThemePromiseRef.current = null;
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function cleanupLastFnCall() {
                    return _ref2.apply(this, arguments);
                };
            }();
            var safelySetGlobalTheme = /*#__PURE__*/ function() {
                var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($1uJLd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).mark(function _callee2() {
                    var promise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iQsIh))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return cleanupLastFnCall();
                            case 2:
                                promise = (0, $219af2cdea39e6b5$export$2e2bcd8739ae039)($dc4a2023b640734e$var$_objectSpread($dc4a2023b640734e$var$_objectSpread({}, theme), {}, {
                                    colorMode: reconciledColorMode
                                }));
                                lastSetGlobalThemePromiseRef.current = promise;
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                return function safelySetGlobalTheme() {
                    return _ref3.apply(this, arguments);
                };
            }();
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        } else // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, $38a0cc7e991e8f4a$export$7d4a7e812d176b24)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, $7fPBF.useEffect)(function() {
        if (!$dc4a2023b640734e$var$prefersDarkModeMql) return;
        var unbindListener = (0, $a091c25729a976b1$exports.bind)($dc4a2023b640734e$var$prefersDarkModeMql, {
            type: 'change',
            listener: function listener(event) {
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    var attrs = $dc4a2023b640734e$var$_objectSpread($dc4a2023b640734e$var$_objectSpread({}, (0, $bfe2fce5dd69e020$export$2e2bcd8739ae039)($dc4a2023b640734e$var$_objectSpread($dc4a2023b640734e$var$_objectSpread({}, theme), {}, {
        colorMode: reconciledColorMode
    }))), {}, (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))({}, (0, $gh26H.SUBTREE_THEME_ATTRIBUTE), true));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $c74b917ed7a35d45$export$332347eeb335453c).Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1117b2915604cc65$export$49ddd74a6729fdb0).Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1117b2915604cc65$export$b06130bad0bbc70f).Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $dd4e8951291c3c20$export$2c657da244d00bd6).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $dd4e8951291c3c20$export$f7a97b47760e2a13).Provider, {
        value: setPartialTheme
    }, !isRootThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($91b5651481cc9d5c$exports)))({}, attrs, {
        className: (0, $bfde69414e76f2a7$export$2e2bcd8739ae039)([
            $dc4a2023b640734e$var$contentStyles.body
        ])
    }), children) : children)))));
}
var $dc4a2023b640734e$export$2e2bcd8739ae039 = $dc4a2023b640734e$var$ThemeProvider;


/**
 * __App provider__
 *
 * An app provider provides app level configuration such as global theming.
 *
 * Place it at the root of your application.
 */ function $f107ccf41cbc2985$var$AppProvider(_ref) {
    var children = _ref.children, _ref$defaultColorMode = _ref.defaultColorMode, defaultColorMode = _ref$defaultColorMode === void 0 ? 'light' : _ref$defaultColorMode, defaultTheme = _ref.defaultTheme, routerLinkComponent = _ref.routerLinkComponent, UNSAFE_isThemingDisabled = _ref.UNSAFE_isThemingDisabled;
    var isInsideAppProvider = (0, $f8e1e42abf84d2d1$export$26aa23367bfbab0e)();
    if (isInsideAppProvider) throw new Error('App provider should not be nested within another app provider.');
    var routerLinkProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a81a1e57cf0d6bff$export$2e2bcd8739ae039), {
        routerLinkComponent: routerLinkComponent
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $f8e1e42abf84d2d1$export$7981b2444296e410).Provider, {
        value: true
    }, UNSAFE_isThemingDisabled ? routerLinkProvider : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $f8e1e42abf84d2d1$export$d2def9838ca456c0).Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $dc4a2023b640734e$export$2e2bcd8739ae039), {
        defaultColorMode: defaultColorMode,
        defaultTheme: defaultTheme
    }, routerLinkProvider)));
}
var $f107ccf41cbc2985$export$2e2bcd8739ae039 = $f107ccf41cbc2985$var$AppProvider;


const $d7ff3ee147cb4273$var$BASE_URL = '/main';
const $d7ff3ee147cb4273$var$environment = (0, $35a545355f14a0c7$export$6bc7b24d4e862158)().name;
const $d7ff3ee147cb4273$var$release = "";
window.loadAnalyticsWrapper = (0, $275512fd46801a1e$export$d22535dc59b4c5d0);
const $d7ff3ee147cb4273$var$container = document.getElementById('com-atlassian-preferences-center');
const $d7ff3ee147cb4273$var$root = (0, $f11ec298ebcca059$export$882461b6382ed46c)($d7ff3ee147cb4273$var$container);
$d7ff3ee147cb4273$var$root.render(/*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $f107ccf41cbc2985$export$2e2bcd8739ae039), {
    defaultColorMode: 'light',
    children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $d377413f5e2ec9d9$export$ec0c43a58fca1a2), {
        children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $f30b917334351296$export$2881499e37b75b9a), {
            store: (0, $b91bb6c1ec048c06$export$2e2bcd8739ae039),
            children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $a0cf24fd73ae067c$export$9ba4e89fdfa1fc54), {
                basename: $d7ff3ee147cb4273$var$BASE_URL,
                children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $20fa494c41263167$export$f7170715618fd2f9), {
                    children: /*#__PURE__*/ (0, $c69938f751e7a026$export$34b9dba7ce09269b)((0, $6c559b868a542118$export$2e2bcd8739ae039), {})
                })
            })
        })
    })
}));
// Redirect to "/main" if navigating to "/"
if ($d7ff3ee147cb4273$var$BASE_URL !== '/' && window.location.pathname === '/') window.location.replace($d7ff3ee147cb4273$var$BASE_URL);
if ($d7ff3ee147cb4273$var$environment !== $c1e4a1336f2cb96e$export$2670cb7d5d4f7184) $df844ac72233cdc3$export$2cd8252107eb640b({
    dsn: 'https://76f2b7bbaa484ed582798df767d23325@o55978.ingest.sentry.io/4504554119102464',
    integrations: [
        $c773bc56c44c435b$export$b4109253475213e9()
    ],
    tracesSampleRate: 1.0,
    environment: $d7ff3ee147cb4273$var$environment,
    release: $d7ff3ee147cb4273$var$release,
    ignoreErrors: [
        'Non-Error exception captured',
        'Non-Error promise rejection captured',
        'Network request failed',
        'NetworkError'
    ]
});


//# sourceMappingURL=react.f80de46c.js.map
